(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.privmx = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
var asn1 = exports;

asn1.bignum = require('bn.js');

asn1.define = require('./asn1/api').define;
asn1.base = require('./asn1/base');
asn1.constants = require('./asn1/constants');
asn1.decoders = require('./asn1/decoders');
asn1.encoders = require('./asn1/encoders');

},{"./asn1/api":2,"./asn1/base":4,"./asn1/constants":8,"./asn1/decoders":10,"./asn1/encoders":13,"bn.js":25}],2:[function(require,module,exports){
var asn1 = require('../asn1');
var inherits = require('inherits');

var api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
};

Entity.prototype._createNamed = function createNamed(base) {
  var named;
  try {
    named = require('vm').runInThisContext(
      '(function ' + this.name + '(entity) {\n' +
      '  this._initNamed(entity);\n' +
      '})'
    );
  } catch (e) {
    named = function (entity) {
      this._initNamed(entity);
    };
  }
  inherits(named, base);
  named.prototype._initNamed = function initnamed(entity) {
    base.call(this, entity);
  };

  return new named(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};

},{"../asn1":1,"inherits":100,"vm":632}],3:[function(require,module,exports){
var inherits = require('inherits');
var Reporter = require('../base').Reporter;
var Buffer = require('buffer').Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  var res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
}

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  var res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
}

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
}

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!(item instanceof EncoderBuffer))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = new Buffer(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};

},{"../base":4,"buffer":498,"inherits":100}],4:[function(require,module,exports){
var base = exports;

base.Reporter = require('./reporter').Reporter;
base.DecoderBuffer = require('./buffer').DecoderBuffer;
base.EncoderBuffer = require('./buffer').EncoderBuffer;
base.Node = require('./node');

},{"./buffer":3,"./node":5,"./reporter":6}],5:[function(require,module,exports){
var Reporter = require('../base').Reporter;
var EncoderBuffer = require('../base').EncoderBuffer;
var DecoderBuffer = require('../base').DecoderBuffer;
var assert = require('minimalistic-assert');

// Supported tags
var tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
var methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
var overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent) {
  var state = {};
  this._baseState = state;

  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

var stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  var state = this._baseState;
  var cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  var res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  var state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      var clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  var state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  var state = this._baseState;

  // Filter children and args
  var children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      var res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        var value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    var state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  var state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  var state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  var state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  var state = this._baseState;
  var args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  var state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  var state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  var state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  var result = state['default'];
  var present = true;

  var prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    var tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      var save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  var prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      var explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    var start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      if (state.any)
        var save = input.save();
      var body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any)
      result = result;
    else if (state.choice === null)
      result = this._decodeGeneric(state.tag, input, options);
    else
      result = this._decodeChoice(input, options);

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      var data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
          ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  var state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
        ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  var state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  var state = this._baseState;
  var result = null;
  var match = false;

  Object.keys(state.choice).some(function(key) {
    var save = input.save();
    var node = state.choice[key];
    try {
      var value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  var state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  var result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  var result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default']
    else
      return;
  }

  // Encode children first
  var content = null;
  var primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      var prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      var res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      var child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        var state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  var result;
  if (!state.any && state.choice === null) {
    var tag = state.implicit !== null ? state.implicit : state.tag;
    var cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  var state = this._baseState;

  var node = state.choice[data.type];
  if (!node) {
    assert(
        false,
        data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  var state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

},{"../base":4,"minimalistic-assert":105}],6:[function(require,module,exports){
var inherits = require('inherits');

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  var state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  var state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  var state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  var state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  var state = this._reporterState;

  var prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  var state = this._reporterState;

  var now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  var err;
  var state = this._reporterState;

  var inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  var state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
};
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};

},{"inherits":100}],7:[function(require,module,exports){
var constants = require('../constants');

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = constants._reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = constants._reverse(exports.tag);

},{"../constants":8}],8:[function(require,module,exports){
var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = require('./der');

},{"./der":7}],9:[function(require,module,exports){
var inherits = require('inherits');

var asn1 = require('../../asn1');
var base = asn1.base;
var bignum = asn1.bignum;

// Import DER constants
var der = asn1.constants.der;

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!(data instanceof base.DecoderBuffer))
    data = new base.DecoderBuffer(data, options);

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  var state = buffer.save();
  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  var decodedTag = derDecodeTag(buffer,
                                'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  var len = derDecodeLen(buffer,
                         decodedTag.primitive,
                         'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  var state = buffer.save();
  var res = this._skipUntilEnd(
      buffer,
      'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  while (true) {
    var tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    var len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    var res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len)
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
                                                    options) {
  var result = [];
  while (!buffer.isEmpty()) {
    var possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    var res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    var unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    var raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    var str = '';
    for (var i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    var numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    var printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  var result;
  var identifiers = [];
  var ident = 0;
  while (!buffer.isEmpty()) {
    var subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  var first = (identifiers[0] / 40) | 0;
  var second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    var tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  var str = buffer.raw().toString();
  if (tag === 'gentime') {
    var year = str.slice(0, 4) | 0;
    var mon = str.slice(4, 6) | 0;
    var day = str.slice(6, 8) | 0;
    var hour = str.slice(8, 10) | 0;
    var min = str.slice(10, 12) | 0;
    var sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    var year = str.slice(0, 2) | 0;
    var mon = str.slice(2, 4) | 0;
    var day = str.slice(4, 6) | 0;
    var hour = str.slice(6, 8) | 0;
    var min = str.slice(8, 10) | 0;
    var sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull(buffer) {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  var res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  var raw = buffer.raw();
  var res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  var tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  var cls = der.tagClass[tag >> 6];
  var primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    var oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  var tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  var len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  var num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (var i = 0; i < num; i++) {
    len <<= 8;
    var j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}

},{"../../asn1":1,"inherits":100}],10:[function(require,module,exports){
var decoders = exports;

decoders.der = require('./der');
decoders.pem = require('./pem');

},{"./der":9,"./pem":11}],11:[function(require,module,exports){
var inherits = require('inherits');
var Buffer = require('buffer').Buffer;

var DERDecoder = require('./der');

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  var lines = data.toString().split(/[\r\n]+/g);

  var label = options.label.toUpperCase();

  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
  var start = -1;
  var end = -1;
  for (var i = 0; i < lines.length; i++) {
    var match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  var base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9\+\/=]+/gi, '');

  var input = new Buffer(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};

},{"./der":9,"buffer":498,"inherits":100}],12:[function(require,module,exports){
var inherits = require('inherits');
var Buffer = require('buffer').Buffer;

var asn1 = require('../../asn1');
var base = asn1.base;

// Import DER constants
var der = asn1.constants.der;

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
                                                              primitive,
                                                              cls,
                                                              content) {
  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    var header = new Buffer(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  var lenOctets = 1;
  for (var i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  var header = new Buffer(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    var buf = new Buffer(str.length * 2);
    for (var i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s\.]+/g);
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  var size = 0;
  for (var i = 0; i < id.length; i++) {
    var ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  var objid = new Buffer(size);
  var offset = objid.length - 1;
  for (var i = id.length - 1; i >= 0; i--) {
    var ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  var str;
  var date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    var numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = new Buffer(numArray);
  }

  if (Buffer.isBuffer(num)) {
    var size = num.length;
    if (num.length === 0)
      size++;

    var out = new Buffer(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  var size = 1;
  for (var i = num; i >= 0x100; i >>= 8)
    size++;

  var out = new Array(size);
  for (var i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(new Buffer(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  var state = this._baseState;
  var i;
  if (state['default'] === null)
    return false;

  var data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  var res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}

},{"../../asn1":1,"buffer":498,"inherits":100}],13:[function(require,module,exports){
var encoders = exports;

encoders.der = require('./der');
encoders.pem = require('./pem');

},{"./der":12,"./pem":14}],14:[function(require,module,exports){
var inherits = require('inherits');

var DEREncoder = require('./der');

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  var buf = DEREncoder.prototype.encode.call(this, data);

  var p = buf.toString('base64');
  var out = [ '-----BEGIN ' + options.label + '-----' ];
  for (var i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};

},{"./der":12,"inherits":100}],15:[function(require,module,exports){
// base-x encoding
// Forked from https://github.com/cryptocoinjs/bs58
// Originally written by Mike Hearn for BitcoinJ
// Copyright (c) 2011 Google Inc
// Ported to JavaScript by Stefan Thomas
// Merged Buffer refactorings from base58-native by Stephen Pair
// Copyright (c) 2013 BitPay Inc

module.exports = function base (ALPHABET) {
  var ALPHABET_MAP = {}
  var BASE = ALPHABET.length
  var LEADER = ALPHABET.charAt(0)

  // pre-compute lookup table
  for (var i = 0; i < ALPHABET.length; i++) {
    ALPHABET_MAP[ALPHABET.charAt(i)] = i
  }

  function encode (source) {
    if (source.length === 0) return ''

    var digits = [0]
    for (var i = 0; i < source.length; ++i) {
      for (var j = 0, carry = source[i]; j < digits.length; ++j) {
        carry += digits[j] << 8
        digits[j] = carry % BASE
        carry = (carry / BASE) | 0
      }

      while (carry > 0) {
        digits.push(carry % BASE)
        carry = (carry / BASE) | 0
      }
    }

    var string = ''

    // deal with leading zeros
    for (var k = 0; source[k] === 0 && k < source.length - 1; ++k) string += ALPHABET[0]
    // convert digits to a string
    for (var q = digits.length - 1; q >= 0; --q) string += ALPHABET[digits[q]]

    return string
  }

  function decodeUnsafe (string) {
    if (string.length === 0) return []

    var bytes = [0]
    for (var i = 0; i < string.length; i++) {
      var value = ALPHABET_MAP[string[i]]
      if (value === undefined) return

      for (var j = 0, carry = value; j < bytes.length; ++j) {
        carry += bytes[j] * BASE
        bytes[j] = carry & 0xff
        carry >>= 8
      }

      while (carry > 0) {
        bytes.push(carry & 0xff)
        carry >>= 8
      }
    }

    // deal with leading zeros
    for (var k = 0; string[k] === LEADER && k < string.length - 1; ++k) {
      bytes.push(0)
    }

    return bytes.reverse()
  }

  function decode (string) {
    var array = decodeUnsafe(string)
    if (array) return array

    throw new Error('Non-base' + BASE + ' character')
  }

  return {
    encode: encode,
    decodeUnsafe: decodeUnsafe,
    decode: decode
  }
}

},{}],16:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer
var createHash = require('create-hash')
var _pbkdf2 = require('pbkdf2')
var pbkdf2 = _pbkdf2.pbkdf2Sync
var pbkdf2Async = _pbkdf2.pbkdf2
var randomBytes = require('randombytes')

// use unorm until String.prototype.normalize gets better browser support
var unorm = require('unorm')

var CHINESE_SIMPLIFIED_WORDLIST = require('./wordlists/chinese_simplified.json')
var CHINESE_TRADITIONAL_WORDLIST = require('./wordlists/chinese_traditional.json')
var ENGLISH_WORDLIST = require('./wordlists/english.json')
var FRENCH_WORDLIST = require('./wordlists/french.json')
var ITALIAN_WORDLIST = require('./wordlists/italian.json')
var JAPANESE_WORDLIST = require('./wordlists/japanese.json')
var KOREAN_WORDLIST = require('./wordlists/korean.json')
var SPANISH_WORDLIST = require('./wordlists/spanish.json')
var DEFAULT_WORDLIST = ENGLISH_WORDLIST

var INVALID_MNEMONIC = 'Invalid mnemonic'
var INVALID_ENTROPY = 'Invalid entropy'
var INVALID_CHECKSUM = 'Invalid mnemonic checksum'

function lpad (str, padString, length) {
  while (str.length < length) str = padString + str
  return str
}

function binaryToByte (bin) {
  return parseInt(bin, 2)
}

function bytesToBinary (bytes) {
  return bytes.map(function (x) {
    return lpad(x.toString(2), '0', 8)
  }).join('')
}

function deriveChecksumBits (entropyBuffer) {
  var ENT = entropyBuffer.length * 8
  var CS = ENT / 32
  var hash = createHash('sha256').update(entropyBuffer).digest()

  return bytesToBinary([].slice.call(hash)).slice(0, CS)
}

function salt (password) {
  return 'mnemonic' + (password || '')
}

function mnemonicToSeed (mnemonic, password) {
  var mnemonicBuffer = Buffer.from(unorm.nfkd(mnemonic), 'utf8')
  var saltBuffer = Buffer.from(salt(unorm.nfkd(password)), 'utf8')

  return pbkdf2(mnemonicBuffer, saltBuffer, 2048, 64, 'sha512')
}

function mnemonicToSeedHex (mnemonic, password) {
  return mnemonicToSeed(mnemonic, password).toString('hex')
}

function mnemonicToSeedAsync (mnemonic, password) {
  return new Promise(function (resolve, reject) {
    try {
      var mnemonicBuffer = Buffer.from(unorm.nfkd(mnemonic), 'utf8')
      var saltBuffer = Buffer.from(salt(unorm.nfkd(password)), 'utf8')
    } catch (error) {
      return reject(error)
    }

    pbkdf2Async(mnemonicBuffer, saltBuffer, 2048, 64, 'sha512', function (err, data) {
      if (err) return reject(err)
      else return resolve(data)
    })
  })
}

function mnemonicToSeedHexAsync (mnemonic, password) {
  return mnemonicToSeedAsync(mnemonic, password)
    .then(function (buf) { return buf.toString('hex') })
}

function mnemonicToEntropy (mnemonic, wordlist) {
  wordlist = wordlist || DEFAULT_WORDLIST

  var words = unorm.nfkd(mnemonic).split(' ')
  if (words.length % 3 !== 0) throw new Error(INVALID_MNEMONIC)

  // convert word indices to 11 bit binary strings
  var bits = words.map(function (word) {
    var index = wordlist.indexOf(word)
    if (index === -1) throw new Error(INVALID_MNEMONIC)

    return lpad(index.toString(2), '0', 11)
  }).join('')

  // split the binary string into ENT/CS
  var dividerIndex = Math.floor(bits.length / 33) * 32
  var entropyBits = bits.slice(0, dividerIndex)
  var checksumBits = bits.slice(dividerIndex)

  // calculate the checksum and compare
  var entropyBytes = entropyBits.match(/(.{1,8})/g).map(binaryToByte)
  if (entropyBytes.length < 16) throw new Error(INVALID_ENTROPY)
  if (entropyBytes.length > 32) throw new Error(INVALID_ENTROPY)
  if (entropyBytes.length % 4 !== 0) throw new Error(INVALID_ENTROPY)

  var entropy = Buffer.from(entropyBytes)
  var newChecksum = deriveChecksumBits(entropy)
  if (newChecksum !== checksumBits) throw new Error(INVALID_CHECKSUM)

  return entropy.toString('hex')
}

function entropyToMnemonic (entropy, wordlist) {
  if (!Buffer.isBuffer(entropy)) entropy = Buffer.from(entropy, 'hex')
  wordlist = wordlist || DEFAULT_WORDLIST

  // 128 <= ENT <= 256
  if (entropy.length < 16) throw new TypeError(INVALID_ENTROPY)
  if (entropy.length > 32) throw new TypeError(INVALID_ENTROPY)
  if (entropy.length % 4 !== 0) throw new TypeError(INVALID_ENTROPY)

  var entropyBits = bytesToBinary([].slice.call(entropy))
  var checksumBits = deriveChecksumBits(entropy)

  var bits = entropyBits + checksumBits
  var chunks = bits.match(/(.{1,11})/g)
  var words = chunks.map(function (binary) {
    var index = binaryToByte(binary)
    return wordlist[index]
  })

  return wordlist === JAPANESE_WORDLIST ? words.join('\u3000') : words.join(' ')
}

function generateMnemonic (strength, rng, wordlist) {
  strength = strength || 128
  if (strength % 32 !== 0) throw new TypeError(INVALID_ENTROPY)
  rng = rng || randomBytes

  return entropyToMnemonic(rng(strength / 8), wordlist)
}

function validateMnemonic (mnemonic, wordlist) {
  try {
    mnemonicToEntropy(mnemonic, wordlist)
  } catch (e) {
    return false
  }

  return true
}

module.exports = {
  mnemonicToSeed: mnemonicToSeed,
  mnemonicToSeedAsync: mnemonicToSeedAsync,
  mnemonicToSeedHex: mnemonicToSeedHex,
  mnemonicToSeedHexAsync: mnemonicToSeedHexAsync,
  mnemonicToEntropy: mnemonicToEntropy,
  entropyToMnemonic: entropyToMnemonic,
  generateMnemonic: generateMnemonic,
  validateMnemonic: validateMnemonic,
  wordlists: {
    EN: ENGLISH_WORDLIST,
    JA: JAPANESE_WORDLIST,

    chinese_simplified: CHINESE_SIMPLIFIED_WORDLIST,
    chinese_traditional: CHINESE_TRADITIONAL_WORDLIST,
    english: ENGLISH_WORDLIST,
    french: FRENCH_WORDLIST,
    italian: ITALIAN_WORDLIST,
    japanese: JAPANESE_WORDLIST,
    korean: KOREAN_WORDLIST,
    spanish: SPANISH_WORDLIST
  }
}

},{"./wordlists/chinese_simplified.json":17,"./wordlists/chinese_traditional.json":18,"./wordlists/english.json":19,"./wordlists/french.json":20,"./wordlists/italian.json":21,"./wordlists/japanese.json":22,"./wordlists/korean.json":23,"./wordlists/spanish.json":24,"create-hash":50,"pbkdf2":126,"randombytes":377,"safe-buffer":379,"unorm":427}],17:[function(require,module,exports){
module.exports=[
  "的",
  "一",
  "是",
  "在",
  "不",
  "了",
  "有",
  "和",
  "人",
  "这",
  "中",
  "大",
  "为",
  "上",
  "个",
  "国",
  "我",
  "以",
  "要",
  "他",
  "时",
  "来",
  "用",
  "们",
  "生",
  "到",
  "作",
  "地",
  "于",
  "出",
  "就",
  "分",
  "对",
  "成",
  "会",
  "可",
  "主",
  "发",
  "年",
  "动",
  "同",
  "工",
  "也",
  "能",
  "下",
  "过",
  "子",
  "说",
  "产",
  "种",
  "面",
  "而",
  "方",
  "后",
  "多",
  "定",
  "行",
  "学",
  "法",
  "所",
  "民",
  "得",
  "经",
  "十",
  "三",
  "之",
  "进",
  "着",
  "等",
  "部",
  "度",
  "家",
  "电",
  "力",
  "里",
  "如",
  "水",
  "化",
  "高",
  "自",
  "二",
  "理",
  "起",
  "小",
  "物",
  "现",
  "实",
  "加",
  "量",
  "都",
  "两",
  "体",
  "制",
  "机",
  "当",
  "使",
  "点",
  "从",
  "业",
  "本",
  "去",
  "把",
  "性",
  "好",
  "应",
  "开",
  "它",
  "合",
  "还",
  "因",
  "由",
  "其",
  "些",
  "然",
  "前",
  "外",
  "天",
  "政",
  "四",
  "日",
  "那",
  "社",
  "义",
  "事",
  "平",
  "形",
  "相",
  "全",
  "表",
  "间",
  "样",
  "与",
  "关",
  "各",
  "重",
  "新",
  "线",
  "内",
  "数",
  "正",
  "心",
  "反",
  "你",
  "明",
  "看",
  "原",
  "又",
  "么",
  "利",
  "比",
  "或",
  "但",
  "质",
  "气",
  "第",
  "向",
  "道",
  "命",
  "此",
  "变",
  "条",
  "只",
  "没",
  "结",
  "解",
  "问",
  "意",
  "建",
  "月",
  "公",
  "无",
  "系",
  "军",
  "很",
  "情",
  "者",
  "最",
  "立",
  "代",
  "想",
  "已",
  "通",
  "并",
  "提",
  "直",
  "题",
  "党",
  "程",
  "展",
  "五",
  "果",
  "料",
  "象",
  "员",
  "革",
  "位",
  "入",
  "常",
  "文",
  "总",
  "次",
  "品",
  "式",
  "活",
  "设",
  "及",
  "管",
  "特",
  "件",
  "长",
  "求",
  "老",
  "头",
  "基",
  "资",
  "边",
  "流",
  "路",
  "级",
  "少",
  "图",
  "山",
  "统",
  "接",
  "知",
  "较",
  "将",
  "组",
  "见",
  "计",
  "别",
  "她",
  "手",
  "角",
  "期",
  "根",
  "论",
  "运",
  "农",
  "指",
  "几",
  "九",
  "区",
  "强",
  "放",
  "决",
  "西",
  "被",
  "干",
  "做",
  "必",
  "战",
  "先",
  "回",
  "则",
  "任",
  "取",
  "据",
  "处",
  "队",
  "南",
  "给",
  "色",
  "光",
  "门",
  "即",
  "保",
  "治",
  "北",
  "造",
  "百",
  "规",
  "热",
  "领",
  "七",
  "海",
  "口",
  "东",
  "导",
  "器",
  "压",
  "志",
  "世",
  "金",
  "增",
  "争",
  "济",
  "阶",
  "油",
  "思",
  "术",
  "极",
  "交",
  "受",
  "联",
  "什",
  "认",
  "六",
  "共",
  "权",
  "收",
  "证",
  "改",
  "清",
  "美",
  "再",
  "采",
  "转",
  "更",
  "单",
  "风",
  "切",
  "打",
  "白",
  "教",
  "速",
  "花",
  "带",
  "安",
  "场",
  "身",
  "车",
  "例",
  "真",
  "务",
  "具",
  "万",
  "每",
  "目",
  "至",
  "达",
  "走",
  "积",
  "示",
  "议",
  "声",
  "报",
  "斗",
  "完",
  "类",
  "八",
  "离",
  "华",
  "名",
  "确",
  "才",
  "科",
  "张",
  "信",
  "马",
  "节",
  "话",
  "米",
  "整",
  "空",
  "元",
  "况",
  "今",
  "集",
  "温",
  "传",
  "土",
  "许",
  "步",
  "群",
  "广",
  "石",
  "记",
  "需",
  "段",
  "研",
  "界",
  "拉",
  "林",
  "律",
  "叫",
  "且",
  "究",
  "观",
  "越",
  "织",
  "装",
  "影",
  "算",
  "低",
  "持",
  "音",
  "众",
  "书",
  "布",
  "复",
  "容",
  "儿",
  "须",
  "际",
  "商",
  "非",
  "验",
  "连",
  "断",
  "深",
  "难",
  "近",
  "矿",
  "千",
  "周",
  "委",
  "素",
  "技",
  "备",
  "半",
  "办",
  "青",
  "省",
  "列",
  "习",
  "响",
  "约",
  "支",
  "般",
  "史",
  "感",
  "劳",
  "便",
  "团",
  "往",
  "酸",
  "历",
  "市",
  "克",
  "何",
  "除",
  "消",
  "构",
  "府",
  "称",
  "太",
  "准",
  "精",
  "值",
  "号",
  "率",
  "族",
  "维",
  "划",
  "选",
  "标",
  "写",
  "存",
  "候",
  "毛",
  "亲",
  "快",
  "效",
  "斯",
  "院",
  "查",
  "江",
  "型",
  "眼",
  "王",
  "按",
  "格",
  "养",
  "易",
  "置",
  "派",
  "层",
  "片",
  "始",
  "却",
  "专",
  "状",
  "育",
  "厂",
  "京",
  "识",
  "适",
  "属",
  "圆",
  "包",
  "火",
  "住",
  "调",
  "满",
  "县",
  "局",
  "照",
  "参",
  "红",
  "细",
  "引",
  "听",
  "该",
  "铁",
  "价",
  "严",
  "首",
  "底",
  "液",
  "官",
  "德",
  "随",
  "病",
  "苏",
  "失",
  "尔",
  "死",
  "讲",
  "配",
  "女",
  "黄",
  "推",
  "显",
  "谈",
  "罪",
  "神",
  "艺",
  "呢",
  "席",
  "含",
  "企",
  "望",
  "密",
  "批",
  "营",
  "项",
  "防",
  "举",
  "球",
  "英",
  "氧",
  "势",
  "告",
  "李",
  "台",
  "落",
  "木",
  "帮",
  "轮",
  "破",
  "亚",
  "师",
  "围",
  "注",
  "远",
  "字",
  "材",
  "排",
  "供",
  "河",
  "态",
  "封",
  "另",
  "施",
  "减",
  "树",
  "溶",
  "怎",
  "止",
  "案",
  "言",
  "士",
  "均",
  "武",
  "固",
  "叶",
  "鱼",
  "波",
  "视",
  "仅",
  "费",
  "紧",
  "爱",
  "左",
  "章",
  "早",
  "朝",
  "害",
  "续",
  "轻",
  "服",
  "试",
  "食",
  "充",
  "兵",
  "源",
  "判",
  "护",
  "司",
  "足",
  "某",
  "练",
  "差",
  "致",
  "板",
  "田",
  "降",
  "黑",
  "犯",
  "负",
  "击",
  "范",
  "继",
  "兴",
  "似",
  "余",
  "坚",
  "曲",
  "输",
  "修",
  "故",
  "城",
  "夫",
  "够",
  "送",
  "笔",
  "船",
  "占",
  "右",
  "财",
  "吃",
  "富",
  "春",
  "职",
  "觉",
  "汉",
  "画",
  "功",
  "巴",
  "跟",
  "虽",
  "杂",
  "飞",
  "检",
  "吸",
  "助",
  "升",
  "阳",
  "互",
  "初",
  "创",
  "抗",
  "考",
  "投",
  "坏",
  "策",
  "古",
  "径",
  "换",
  "未",
  "跑",
  "留",
  "钢",
  "曾",
  "端",
  "责",
  "站",
  "简",
  "述",
  "钱",
  "副",
  "尽",
  "帝",
  "射",
  "草",
  "冲",
  "承",
  "独",
  "令",
  "限",
  "阿",
  "宣",
  "环",
  "双",
  "请",
  "超",
  "微",
  "让",
  "控",
  "州",
  "良",
  "轴",
  "找",
  "否",
  "纪",
  "益",
  "依",
  "优",
  "顶",
  "础",
  "载",
  "倒",
  "房",
  "突",
  "坐",
  "粉",
  "敌",
  "略",
  "客",
  "袁",
  "冷",
  "胜",
  "绝",
  "析",
  "块",
  "剂",
  "测",
  "丝",
  "协",
  "诉",
  "念",
  "陈",
  "仍",
  "罗",
  "盐",
  "友",
  "洋",
  "错",
  "苦",
  "夜",
  "刑",
  "移",
  "频",
  "逐",
  "靠",
  "混",
  "母",
  "短",
  "皮",
  "终",
  "聚",
  "汽",
  "村",
  "云",
  "哪",
  "既",
  "距",
  "卫",
  "停",
  "烈",
  "央",
  "察",
  "烧",
  "迅",
  "境",
  "若",
  "印",
  "洲",
  "刻",
  "括",
  "激",
  "孔",
  "搞",
  "甚",
  "室",
  "待",
  "核",
  "校",
  "散",
  "侵",
  "吧",
  "甲",
  "游",
  "久",
  "菜",
  "味",
  "旧",
  "模",
  "湖",
  "货",
  "损",
  "预",
  "阻",
  "毫",
  "普",
  "稳",
  "乙",
  "妈",
  "植",
  "息",
  "扩",
  "银",
  "语",
  "挥",
  "酒",
  "守",
  "拿",
  "序",
  "纸",
  "医",
  "缺",
  "雨",
  "吗",
  "针",
  "刘",
  "啊",
  "急",
  "唱",
  "误",
  "训",
  "愿",
  "审",
  "附",
  "获",
  "茶",
  "鲜",
  "粮",
  "斤",
  "孩",
  "脱",
  "硫",
  "肥",
  "善",
  "龙",
  "演",
  "父",
  "渐",
  "血",
  "欢",
  "械",
  "掌",
  "歌",
  "沙",
  "刚",
  "攻",
  "谓",
  "盾",
  "讨",
  "晚",
  "粒",
  "乱",
  "燃",
  "矛",
  "乎",
  "杀",
  "药",
  "宁",
  "鲁",
  "贵",
  "钟",
  "煤",
  "读",
  "班",
  "伯",
  "香",
  "介",
  "迫",
  "句",
  "丰",
  "培",
  "握",
  "兰",
  "担",
  "弦",
  "蛋",
  "沉",
  "假",
  "穿",
  "执",
  "答",
  "乐",
  "谁",
  "顺",
  "烟",
  "缩",
  "征",
  "脸",
  "喜",
  "松",
  "脚",
  "困",
  "异",
  "免",
  "背",
  "星",
  "福",
  "买",
  "染",
  "井",
  "概",
  "慢",
  "怕",
  "磁",
  "倍",
  "祖",
  "皇",
  "促",
  "静",
  "补",
  "评",
  "翻",
  "肉",
  "践",
  "尼",
  "衣",
  "宽",
  "扬",
  "棉",
  "希",
  "伤",
  "操",
  "垂",
  "秋",
  "宜",
  "氢",
  "套",
  "督",
  "振",
  "架",
  "亮",
  "末",
  "宪",
  "庆",
  "编",
  "牛",
  "触",
  "映",
  "雷",
  "销",
  "诗",
  "座",
  "居",
  "抓",
  "裂",
  "胞",
  "呼",
  "娘",
  "景",
  "威",
  "绿",
  "晶",
  "厚",
  "盟",
  "衡",
  "鸡",
  "孙",
  "延",
  "危",
  "胶",
  "屋",
  "乡",
  "临",
  "陆",
  "顾",
  "掉",
  "呀",
  "灯",
  "岁",
  "措",
  "束",
  "耐",
  "剧",
  "玉",
  "赵",
  "跳",
  "哥",
  "季",
  "课",
  "凯",
  "胡",
  "额",
  "款",
  "绍",
  "卷",
  "齐",
  "伟",
  "蒸",
  "殖",
  "永",
  "宗",
  "苗",
  "川",
  "炉",
  "岩",
  "弱",
  "零",
  "杨",
  "奏",
  "沿",
  "露",
  "杆",
  "探",
  "滑",
  "镇",
  "饭",
  "浓",
  "航",
  "怀",
  "赶",
  "库",
  "夺",
  "伊",
  "灵",
  "税",
  "途",
  "灭",
  "赛",
  "归",
  "召",
  "鼓",
  "播",
  "盘",
  "裁",
  "险",
  "康",
  "唯",
  "录",
  "菌",
  "纯",
  "借",
  "糖",
  "盖",
  "横",
  "符",
  "私",
  "努",
  "堂",
  "域",
  "枪",
  "润",
  "幅",
  "哈",
  "竟",
  "熟",
  "虫",
  "泽",
  "脑",
  "壤",
  "碳",
  "欧",
  "遍",
  "侧",
  "寨",
  "敢",
  "彻",
  "虑",
  "斜",
  "薄",
  "庭",
  "纳",
  "弹",
  "饲",
  "伸",
  "折",
  "麦",
  "湿",
  "暗",
  "荷",
  "瓦",
  "塞",
  "床",
  "筑",
  "恶",
  "户",
  "访",
  "塔",
  "奇",
  "透",
  "梁",
  "刀",
  "旋",
  "迹",
  "卡",
  "氯",
  "遇",
  "份",
  "毒",
  "泥",
  "退",
  "洗",
  "摆",
  "灰",
  "彩",
  "卖",
  "耗",
  "夏",
  "择",
  "忙",
  "铜",
  "献",
  "硬",
  "予",
  "繁",
  "圈",
  "雪",
  "函",
  "亦",
  "抽",
  "篇",
  "阵",
  "阴",
  "丁",
  "尺",
  "追",
  "堆",
  "雄",
  "迎",
  "泛",
  "爸",
  "楼",
  "避",
  "谋",
  "吨",
  "野",
  "猪",
  "旗",
  "累",
  "偏",
  "典",
  "馆",
  "索",
  "秦",
  "脂",
  "潮",
  "爷",
  "豆",
  "忽",
  "托",
  "惊",
  "塑",
  "遗",
  "愈",
  "朱",
  "替",
  "纤",
  "粗",
  "倾",
  "尚",
  "痛",
  "楚",
  "谢",
  "奋",
  "购",
  "磨",
  "君",
  "池",
  "旁",
  "碎",
  "骨",
  "监",
  "捕",
  "弟",
  "暴",
  "割",
  "贯",
  "殊",
  "释",
  "词",
  "亡",
  "壁",
  "顿",
  "宝",
  "午",
  "尘",
  "闻",
  "揭",
  "炮",
  "残",
  "冬",
  "桥",
  "妇",
  "警",
  "综",
  "招",
  "吴",
  "付",
  "浮",
  "遭",
  "徐",
  "您",
  "摇",
  "谷",
  "赞",
  "箱",
  "隔",
  "订",
  "男",
  "吹",
  "园",
  "纷",
  "唐",
  "败",
  "宋",
  "玻",
  "巨",
  "耕",
  "坦",
  "荣",
  "闭",
  "湾",
  "键",
  "凡",
  "驻",
  "锅",
  "救",
  "恩",
  "剥",
  "凝",
  "碱",
  "齿",
  "截",
  "炼",
  "麻",
  "纺",
  "禁",
  "废",
  "盛",
  "版",
  "缓",
  "净",
  "睛",
  "昌",
  "婚",
  "涉",
  "筒",
  "嘴",
  "插",
  "岸",
  "朗",
  "庄",
  "街",
  "藏",
  "姑",
  "贸",
  "腐",
  "奴",
  "啦",
  "惯",
  "乘",
  "伙",
  "恢",
  "匀",
  "纱",
  "扎",
  "辩",
  "耳",
  "彪",
  "臣",
  "亿",
  "璃",
  "抵",
  "脉",
  "秀",
  "萨",
  "俄",
  "网",
  "舞",
  "店",
  "喷",
  "纵",
  "寸",
  "汗",
  "挂",
  "洪",
  "贺",
  "闪",
  "柬",
  "爆",
  "烯",
  "津",
  "稻",
  "墙",
  "软",
  "勇",
  "像",
  "滚",
  "厘",
  "蒙",
  "芳",
  "肯",
  "坡",
  "柱",
  "荡",
  "腿",
  "仪",
  "旅",
  "尾",
  "轧",
  "冰",
  "贡",
  "登",
  "黎",
  "削",
  "钻",
  "勒",
  "逃",
  "障",
  "氨",
  "郭",
  "峰",
  "币",
  "港",
  "伏",
  "轨",
  "亩",
  "毕",
  "擦",
  "莫",
  "刺",
  "浪",
  "秘",
  "援",
  "株",
  "健",
  "售",
  "股",
  "岛",
  "甘",
  "泡",
  "睡",
  "童",
  "铸",
  "汤",
  "阀",
  "休",
  "汇",
  "舍",
  "牧",
  "绕",
  "炸",
  "哲",
  "磷",
  "绩",
  "朋",
  "淡",
  "尖",
  "启",
  "陷",
  "柴",
  "呈",
  "徒",
  "颜",
  "泪",
  "稍",
  "忘",
  "泵",
  "蓝",
  "拖",
  "洞",
  "授",
  "镜",
  "辛",
  "壮",
  "锋",
  "贫",
  "虚",
  "弯",
  "摩",
  "泰",
  "幼",
  "廷",
  "尊",
  "窗",
  "纲",
  "弄",
  "隶",
  "疑",
  "氏",
  "宫",
  "姐",
  "震",
  "瑞",
  "怪",
  "尤",
  "琴",
  "循",
  "描",
  "膜",
  "违",
  "夹",
  "腰",
  "缘",
  "珠",
  "穷",
  "森",
  "枝",
  "竹",
  "沟",
  "催",
  "绳",
  "忆",
  "邦",
  "剩",
  "幸",
  "浆",
  "栏",
  "拥",
  "牙",
  "贮",
  "礼",
  "滤",
  "钠",
  "纹",
  "罢",
  "拍",
  "咱",
  "喊",
  "袖",
  "埃",
  "勤",
  "罚",
  "焦",
  "潜",
  "伍",
  "墨",
  "欲",
  "缝",
  "姓",
  "刊",
  "饱",
  "仿",
  "奖",
  "铝",
  "鬼",
  "丽",
  "跨",
  "默",
  "挖",
  "链",
  "扫",
  "喝",
  "袋",
  "炭",
  "污",
  "幕",
  "诸",
  "弧",
  "励",
  "梅",
  "奶",
  "洁",
  "灾",
  "舟",
  "鉴",
  "苯",
  "讼",
  "抱",
  "毁",
  "懂",
  "寒",
  "智",
  "埔",
  "寄",
  "届",
  "跃",
  "渡",
  "挑",
  "丹",
  "艰",
  "贝",
  "碰",
  "拔",
  "爹",
  "戴",
  "码",
  "梦",
  "芽",
  "熔",
  "赤",
  "渔",
  "哭",
  "敬",
  "颗",
  "奔",
  "铅",
  "仲",
  "虎",
  "稀",
  "妹",
  "乏",
  "珍",
  "申",
  "桌",
  "遵",
  "允",
  "隆",
  "螺",
  "仓",
  "魏",
  "锐",
  "晓",
  "氮",
  "兼",
  "隐",
  "碍",
  "赫",
  "拨",
  "忠",
  "肃",
  "缸",
  "牵",
  "抢",
  "博",
  "巧",
  "壳",
  "兄",
  "杜",
  "讯",
  "诚",
  "碧",
  "祥",
  "柯",
  "页",
  "巡",
  "矩",
  "悲",
  "灌",
  "龄",
  "伦",
  "票",
  "寻",
  "桂",
  "铺",
  "圣",
  "恐",
  "恰",
  "郑",
  "趣",
  "抬",
  "荒",
  "腾",
  "贴",
  "柔",
  "滴",
  "猛",
  "阔",
  "辆",
  "妻",
  "填",
  "撤",
  "储",
  "签",
  "闹",
  "扰",
  "紫",
  "砂",
  "递",
  "戏",
  "吊",
  "陶",
  "伐",
  "喂",
  "疗",
  "瓶",
  "婆",
  "抚",
  "臂",
  "摸",
  "忍",
  "虾",
  "蜡",
  "邻",
  "胸",
  "巩",
  "挤",
  "偶",
  "弃",
  "槽",
  "劲",
  "乳",
  "邓",
  "吉",
  "仁",
  "烂",
  "砖",
  "租",
  "乌",
  "舰",
  "伴",
  "瓜",
  "浅",
  "丙",
  "暂",
  "燥",
  "橡",
  "柳",
  "迷",
  "暖",
  "牌",
  "秧",
  "胆",
  "详",
  "簧",
  "踏",
  "瓷",
  "谱",
  "呆",
  "宾",
  "糊",
  "洛",
  "辉",
  "愤",
  "竞",
  "隙",
  "怒",
  "粘",
  "乃",
  "绪",
  "肩",
  "籍",
  "敏",
  "涂",
  "熙",
  "皆",
  "侦",
  "悬",
  "掘",
  "享",
  "纠",
  "醒",
  "狂",
  "锁",
  "淀",
  "恨",
  "牲",
  "霸",
  "爬",
  "赏",
  "逆",
  "玩",
  "陵",
  "祝",
  "秒",
  "浙",
  "貌",
  "役",
  "彼",
  "悉",
  "鸭",
  "趋",
  "凤",
  "晨",
  "畜",
  "辈",
  "秩",
  "卵",
  "署",
  "梯",
  "炎",
  "滩",
  "棋",
  "驱",
  "筛",
  "峡",
  "冒",
  "啥",
  "寿",
  "译",
  "浸",
  "泉",
  "帽",
  "迟",
  "硅",
  "疆",
  "贷",
  "漏",
  "稿",
  "冠",
  "嫩",
  "胁",
  "芯",
  "牢",
  "叛",
  "蚀",
  "奥",
  "鸣",
  "岭",
  "羊",
  "凭",
  "串",
  "塘",
  "绘",
  "酵",
  "融",
  "盆",
  "锡",
  "庙",
  "筹",
  "冻",
  "辅",
  "摄",
  "袭",
  "筋",
  "拒",
  "僚",
  "旱",
  "钾",
  "鸟",
  "漆",
  "沈",
  "眉",
  "疏",
  "添",
  "棒",
  "穗",
  "硝",
  "韩",
  "逼",
  "扭",
  "侨",
  "凉",
  "挺",
  "碗",
  "栽",
  "炒",
  "杯",
  "患",
  "馏",
  "劝",
  "豪",
  "辽",
  "勃",
  "鸿",
  "旦",
  "吏",
  "拜",
  "狗",
  "埋",
  "辊",
  "掩",
  "饮",
  "搬",
  "骂",
  "辞",
  "勾",
  "扣",
  "估",
  "蒋",
  "绒",
  "雾",
  "丈",
  "朵",
  "姆",
  "拟",
  "宇",
  "辑",
  "陕",
  "雕",
  "偿",
  "蓄",
  "崇",
  "剪",
  "倡",
  "厅",
  "咬",
  "驶",
  "薯",
  "刷",
  "斥",
  "番",
  "赋",
  "奉",
  "佛",
  "浇",
  "漫",
  "曼",
  "扇",
  "钙",
  "桃",
  "扶",
  "仔",
  "返",
  "俗",
  "亏",
  "腔",
  "鞋",
  "棱",
  "覆",
  "框",
  "悄",
  "叔",
  "撞",
  "骗",
  "勘",
  "旺",
  "沸",
  "孤",
  "吐",
  "孟",
  "渠",
  "屈",
  "疾",
  "妙",
  "惜",
  "仰",
  "狠",
  "胀",
  "谐",
  "抛",
  "霉",
  "桑",
  "岗",
  "嘛",
  "衰",
  "盗",
  "渗",
  "脏",
  "赖",
  "涌",
  "甜",
  "曹",
  "阅",
  "肌",
  "哩",
  "厉",
  "烃",
  "纬",
  "毅",
  "昨",
  "伪",
  "症",
  "煮",
  "叹",
  "钉",
  "搭",
  "茎",
  "笼",
  "酷",
  "偷",
  "弓",
  "锥",
  "恒",
  "杰",
  "坑",
  "鼻",
  "翼",
  "纶",
  "叙",
  "狱",
  "逮",
  "罐",
  "络",
  "棚",
  "抑",
  "膨",
  "蔬",
  "寺",
  "骤",
  "穆",
  "冶",
  "枯",
  "册",
  "尸",
  "凸",
  "绅",
  "坯",
  "牺",
  "焰",
  "轰",
  "欣",
  "晋",
  "瘦",
  "御",
  "锭",
  "锦",
  "丧",
  "旬",
  "锻",
  "垄",
  "搜",
  "扑",
  "邀",
  "亭",
  "酯",
  "迈",
  "舒",
  "脆",
  "酶",
  "闲",
  "忧",
  "酚",
  "顽",
  "羽",
  "涨",
  "卸",
  "仗",
  "陪",
  "辟",
  "惩",
  "杭",
  "姚",
  "肚",
  "捉",
  "飘",
  "漂",
  "昆",
  "欺",
  "吾",
  "郎",
  "烷",
  "汁",
  "呵",
  "饰",
  "萧",
  "雅",
  "邮",
  "迁",
  "燕",
  "撒",
  "姻",
  "赴",
  "宴",
  "烦",
  "债",
  "帐",
  "斑",
  "铃",
  "旨",
  "醇",
  "董",
  "饼",
  "雏",
  "姿",
  "拌",
  "傅",
  "腹",
  "妥",
  "揉",
  "贤",
  "拆",
  "歪",
  "葡",
  "胺",
  "丢",
  "浩",
  "徽",
  "昂",
  "垫",
  "挡",
  "览",
  "贪",
  "慰",
  "缴",
  "汪",
  "慌",
  "冯",
  "诺",
  "姜",
  "谊",
  "凶",
  "劣",
  "诬",
  "耀",
  "昏",
  "躺",
  "盈",
  "骑",
  "乔",
  "溪",
  "丛",
  "卢",
  "抹",
  "闷",
  "咨",
  "刮",
  "驾",
  "缆",
  "悟",
  "摘",
  "铒",
  "掷",
  "颇",
  "幻",
  "柄",
  "惠",
  "惨",
  "佳",
  "仇",
  "腊",
  "窝",
  "涤",
  "剑",
  "瞧",
  "堡",
  "泼",
  "葱",
  "罩",
  "霍",
  "捞",
  "胎",
  "苍",
  "滨",
  "俩",
  "捅",
  "湘",
  "砍",
  "霞",
  "邵",
  "萄",
  "疯",
  "淮",
  "遂",
  "熊",
  "粪",
  "烘",
  "宿",
  "档",
  "戈",
  "驳",
  "嫂",
  "裕",
  "徙",
  "箭",
  "捐",
  "肠",
  "撑",
  "晒",
  "辨",
  "殿",
  "莲",
  "摊",
  "搅",
  "酱",
  "屏",
  "疫",
  "哀",
  "蔡",
  "堵",
  "沫",
  "皱",
  "畅",
  "叠",
  "阁",
  "莱",
  "敲",
  "辖",
  "钩",
  "痕",
  "坝",
  "巷",
  "饿",
  "祸",
  "丘",
  "玄",
  "溜",
  "曰",
  "逻",
  "彭",
  "尝",
  "卿",
  "妨",
  "艇",
  "吞",
  "韦",
  "怨",
  "矮",
  "歇"
]

},{}],18:[function(require,module,exports){
module.exports=[
  "的",
  "一",
  "是",
  "在",
  "不",
  "了",
  "有",
  "和",
  "人",
  "這",
  "中",
  "大",
  "為",
  "上",
  "個",
  "國",
  "我",
  "以",
  "要",
  "他",
  "時",
  "來",
  "用",
  "們",
  "生",
  "到",
  "作",
  "地",
  "於",
  "出",
  "就",
  "分",
  "對",
  "成",
  "會",
  "可",
  "主",
  "發",
  "年",
  "動",
  "同",
  "工",
  "也",
  "能",
  "下",
  "過",
  "子",
  "說",
  "產",
  "種",
  "面",
  "而",
  "方",
  "後",
  "多",
  "定",
  "行",
  "學",
  "法",
  "所",
  "民",
  "得",
  "經",
  "十",
  "三",
  "之",
  "進",
  "著",
  "等",
  "部",
  "度",
  "家",
  "電",
  "力",
  "裡",
  "如",
  "水",
  "化",
  "高",
  "自",
  "二",
  "理",
  "起",
  "小",
  "物",
  "現",
  "實",
  "加",
  "量",
  "都",
  "兩",
  "體",
  "制",
  "機",
  "當",
  "使",
  "點",
  "從",
  "業",
  "本",
  "去",
  "把",
  "性",
  "好",
  "應",
  "開",
  "它",
  "合",
  "還",
  "因",
  "由",
  "其",
  "些",
  "然",
  "前",
  "外",
  "天",
  "政",
  "四",
  "日",
  "那",
  "社",
  "義",
  "事",
  "平",
  "形",
  "相",
  "全",
  "表",
  "間",
  "樣",
  "與",
  "關",
  "各",
  "重",
  "新",
  "線",
  "內",
  "數",
  "正",
  "心",
  "反",
  "你",
  "明",
  "看",
  "原",
  "又",
  "麼",
  "利",
  "比",
  "或",
  "但",
  "質",
  "氣",
  "第",
  "向",
  "道",
  "命",
  "此",
  "變",
  "條",
  "只",
  "沒",
  "結",
  "解",
  "問",
  "意",
  "建",
  "月",
  "公",
  "無",
  "系",
  "軍",
  "很",
  "情",
  "者",
  "最",
  "立",
  "代",
  "想",
  "已",
  "通",
  "並",
  "提",
  "直",
  "題",
  "黨",
  "程",
  "展",
  "五",
  "果",
  "料",
  "象",
  "員",
  "革",
  "位",
  "入",
  "常",
  "文",
  "總",
  "次",
  "品",
  "式",
  "活",
  "設",
  "及",
  "管",
  "特",
  "件",
  "長",
  "求",
  "老",
  "頭",
  "基",
  "資",
  "邊",
  "流",
  "路",
  "級",
  "少",
  "圖",
  "山",
  "統",
  "接",
  "知",
  "較",
  "將",
  "組",
  "見",
  "計",
  "別",
  "她",
  "手",
  "角",
  "期",
  "根",
  "論",
  "運",
  "農",
  "指",
  "幾",
  "九",
  "區",
  "強",
  "放",
  "決",
  "西",
  "被",
  "幹",
  "做",
  "必",
  "戰",
  "先",
  "回",
  "則",
  "任",
  "取",
  "據",
  "處",
  "隊",
  "南",
  "給",
  "色",
  "光",
  "門",
  "即",
  "保",
  "治",
  "北",
  "造",
  "百",
  "規",
  "熱",
  "領",
  "七",
  "海",
  "口",
  "東",
  "導",
  "器",
  "壓",
  "志",
  "世",
  "金",
  "增",
  "爭",
  "濟",
  "階",
  "油",
  "思",
  "術",
  "極",
  "交",
  "受",
  "聯",
  "什",
  "認",
  "六",
  "共",
  "權",
  "收",
  "證",
  "改",
  "清",
  "美",
  "再",
  "採",
  "轉",
  "更",
  "單",
  "風",
  "切",
  "打",
  "白",
  "教",
  "速",
  "花",
  "帶",
  "安",
  "場",
  "身",
  "車",
  "例",
  "真",
  "務",
  "具",
  "萬",
  "每",
  "目",
  "至",
  "達",
  "走",
  "積",
  "示",
  "議",
  "聲",
  "報",
  "鬥",
  "完",
  "類",
  "八",
  "離",
  "華",
  "名",
  "確",
  "才",
  "科",
  "張",
  "信",
  "馬",
  "節",
  "話",
  "米",
  "整",
  "空",
  "元",
  "況",
  "今",
  "集",
  "溫",
  "傳",
  "土",
  "許",
  "步",
  "群",
  "廣",
  "石",
  "記",
  "需",
  "段",
  "研",
  "界",
  "拉",
  "林",
  "律",
  "叫",
  "且",
  "究",
  "觀",
  "越",
  "織",
  "裝",
  "影",
  "算",
  "低",
  "持",
  "音",
  "眾",
  "書",
  "布",
  "复",
  "容",
  "兒",
  "須",
  "際",
  "商",
  "非",
  "驗",
  "連",
  "斷",
  "深",
  "難",
  "近",
  "礦",
  "千",
  "週",
  "委",
  "素",
  "技",
  "備",
  "半",
  "辦",
  "青",
  "省",
  "列",
  "習",
  "響",
  "約",
  "支",
  "般",
  "史",
  "感",
  "勞",
  "便",
  "團",
  "往",
  "酸",
  "歷",
  "市",
  "克",
  "何",
  "除",
  "消",
  "構",
  "府",
  "稱",
  "太",
  "準",
  "精",
  "值",
  "號",
  "率",
  "族",
  "維",
  "劃",
  "選",
  "標",
  "寫",
  "存",
  "候",
  "毛",
  "親",
  "快",
  "效",
  "斯",
  "院",
  "查",
  "江",
  "型",
  "眼",
  "王",
  "按",
  "格",
  "養",
  "易",
  "置",
  "派",
  "層",
  "片",
  "始",
  "卻",
  "專",
  "狀",
  "育",
  "廠",
  "京",
  "識",
  "適",
  "屬",
  "圓",
  "包",
  "火",
  "住",
  "調",
  "滿",
  "縣",
  "局",
  "照",
  "參",
  "紅",
  "細",
  "引",
  "聽",
  "該",
  "鐵",
  "價",
  "嚴",
  "首",
  "底",
  "液",
  "官",
  "德",
  "隨",
  "病",
  "蘇",
  "失",
  "爾",
  "死",
  "講",
  "配",
  "女",
  "黃",
  "推",
  "顯",
  "談",
  "罪",
  "神",
  "藝",
  "呢",
  "席",
  "含",
  "企",
  "望",
  "密",
  "批",
  "營",
  "項",
  "防",
  "舉",
  "球",
  "英",
  "氧",
  "勢",
  "告",
  "李",
  "台",
  "落",
  "木",
  "幫",
  "輪",
  "破",
  "亞",
  "師",
  "圍",
  "注",
  "遠",
  "字",
  "材",
  "排",
  "供",
  "河",
  "態",
  "封",
  "另",
  "施",
  "減",
  "樹",
  "溶",
  "怎",
  "止",
  "案",
  "言",
  "士",
  "均",
  "武",
  "固",
  "葉",
  "魚",
  "波",
  "視",
  "僅",
  "費",
  "緊",
  "愛",
  "左",
  "章",
  "早",
  "朝",
  "害",
  "續",
  "輕",
  "服",
  "試",
  "食",
  "充",
  "兵",
  "源",
  "判",
  "護",
  "司",
  "足",
  "某",
  "練",
  "差",
  "致",
  "板",
  "田",
  "降",
  "黑",
  "犯",
  "負",
  "擊",
  "范",
  "繼",
  "興",
  "似",
  "餘",
  "堅",
  "曲",
  "輸",
  "修",
  "故",
  "城",
  "夫",
  "夠",
  "送",
  "筆",
  "船",
  "佔",
  "右",
  "財",
  "吃",
  "富",
  "春",
  "職",
  "覺",
  "漢",
  "畫",
  "功",
  "巴",
  "跟",
  "雖",
  "雜",
  "飛",
  "檢",
  "吸",
  "助",
  "昇",
  "陽",
  "互",
  "初",
  "創",
  "抗",
  "考",
  "投",
  "壞",
  "策",
  "古",
  "徑",
  "換",
  "未",
  "跑",
  "留",
  "鋼",
  "曾",
  "端",
  "責",
  "站",
  "簡",
  "述",
  "錢",
  "副",
  "盡",
  "帝",
  "射",
  "草",
  "衝",
  "承",
  "獨",
  "令",
  "限",
  "阿",
  "宣",
  "環",
  "雙",
  "請",
  "超",
  "微",
  "讓",
  "控",
  "州",
  "良",
  "軸",
  "找",
  "否",
  "紀",
  "益",
  "依",
  "優",
  "頂",
  "礎",
  "載",
  "倒",
  "房",
  "突",
  "坐",
  "粉",
  "敵",
  "略",
  "客",
  "袁",
  "冷",
  "勝",
  "絕",
  "析",
  "塊",
  "劑",
  "測",
  "絲",
  "協",
  "訴",
  "念",
  "陳",
  "仍",
  "羅",
  "鹽",
  "友",
  "洋",
  "錯",
  "苦",
  "夜",
  "刑",
  "移",
  "頻",
  "逐",
  "靠",
  "混",
  "母",
  "短",
  "皮",
  "終",
  "聚",
  "汽",
  "村",
  "雲",
  "哪",
  "既",
  "距",
  "衛",
  "停",
  "烈",
  "央",
  "察",
  "燒",
  "迅",
  "境",
  "若",
  "印",
  "洲",
  "刻",
  "括",
  "激",
  "孔",
  "搞",
  "甚",
  "室",
  "待",
  "核",
  "校",
  "散",
  "侵",
  "吧",
  "甲",
  "遊",
  "久",
  "菜",
  "味",
  "舊",
  "模",
  "湖",
  "貨",
  "損",
  "預",
  "阻",
  "毫",
  "普",
  "穩",
  "乙",
  "媽",
  "植",
  "息",
  "擴",
  "銀",
  "語",
  "揮",
  "酒",
  "守",
  "拿",
  "序",
  "紙",
  "醫",
  "缺",
  "雨",
  "嗎",
  "針",
  "劉",
  "啊",
  "急",
  "唱",
  "誤",
  "訓",
  "願",
  "審",
  "附",
  "獲",
  "茶",
  "鮮",
  "糧",
  "斤",
  "孩",
  "脫",
  "硫",
  "肥",
  "善",
  "龍",
  "演",
  "父",
  "漸",
  "血",
  "歡",
  "械",
  "掌",
  "歌",
  "沙",
  "剛",
  "攻",
  "謂",
  "盾",
  "討",
  "晚",
  "粒",
  "亂",
  "燃",
  "矛",
  "乎",
  "殺",
  "藥",
  "寧",
  "魯",
  "貴",
  "鐘",
  "煤",
  "讀",
  "班",
  "伯",
  "香",
  "介",
  "迫",
  "句",
  "豐",
  "培",
  "握",
  "蘭",
  "擔",
  "弦",
  "蛋",
  "沉",
  "假",
  "穿",
  "執",
  "答",
  "樂",
  "誰",
  "順",
  "煙",
  "縮",
  "徵",
  "臉",
  "喜",
  "松",
  "腳",
  "困",
  "異",
  "免",
  "背",
  "星",
  "福",
  "買",
  "染",
  "井",
  "概",
  "慢",
  "怕",
  "磁",
  "倍",
  "祖",
  "皇",
  "促",
  "靜",
  "補",
  "評",
  "翻",
  "肉",
  "踐",
  "尼",
  "衣",
  "寬",
  "揚",
  "棉",
  "希",
  "傷",
  "操",
  "垂",
  "秋",
  "宜",
  "氫",
  "套",
  "督",
  "振",
  "架",
  "亮",
  "末",
  "憲",
  "慶",
  "編",
  "牛",
  "觸",
  "映",
  "雷",
  "銷",
  "詩",
  "座",
  "居",
  "抓",
  "裂",
  "胞",
  "呼",
  "娘",
  "景",
  "威",
  "綠",
  "晶",
  "厚",
  "盟",
  "衡",
  "雞",
  "孫",
  "延",
  "危",
  "膠",
  "屋",
  "鄉",
  "臨",
  "陸",
  "顧",
  "掉",
  "呀",
  "燈",
  "歲",
  "措",
  "束",
  "耐",
  "劇",
  "玉",
  "趙",
  "跳",
  "哥",
  "季",
  "課",
  "凱",
  "胡",
  "額",
  "款",
  "紹",
  "卷",
  "齊",
  "偉",
  "蒸",
  "殖",
  "永",
  "宗",
  "苗",
  "川",
  "爐",
  "岩",
  "弱",
  "零",
  "楊",
  "奏",
  "沿",
  "露",
  "桿",
  "探",
  "滑",
  "鎮",
  "飯",
  "濃",
  "航",
  "懷",
  "趕",
  "庫",
  "奪",
  "伊",
  "靈",
  "稅",
  "途",
  "滅",
  "賽",
  "歸",
  "召",
  "鼓",
  "播",
  "盤",
  "裁",
  "險",
  "康",
  "唯",
  "錄",
  "菌",
  "純",
  "借",
  "糖",
  "蓋",
  "橫",
  "符",
  "私",
  "努",
  "堂",
  "域",
  "槍",
  "潤",
  "幅",
  "哈",
  "竟",
  "熟",
  "蟲",
  "澤",
  "腦",
  "壤",
  "碳",
  "歐",
  "遍",
  "側",
  "寨",
  "敢",
  "徹",
  "慮",
  "斜",
  "薄",
  "庭",
  "納",
  "彈",
  "飼",
  "伸",
  "折",
  "麥",
  "濕",
  "暗",
  "荷",
  "瓦",
  "塞",
  "床",
  "築",
  "惡",
  "戶",
  "訪",
  "塔",
  "奇",
  "透",
  "梁",
  "刀",
  "旋",
  "跡",
  "卡",
  "氯",
  "遇",
  "份",
  "毒",
  "泥",
  "退",
  "洗",
  "擺",
  "灰",
  "彩",
  "賣",
  "耗",
  "夏",
  "擇",
  "忙",
  "銅",
  "獻",
  "硬",
  "予",
  "繁",
  "圈",
  "雪",
  "函",
  "亦",
  "抽",
  "篇",
  "陣",
  "陰",
  "丁",
  "尺",
  "追",
  "堆",
  "雄",
  "迎",
  "泛",
  "爸",
  "樓",
  "避",
  "謀",
  "噸",
  "野",
  "豬",
  "旗",
  "累",
  "偏",
  "典",
  "館",
  "索",
  "秦",
  "脂",
  "潮",
  "爺",
  "豆",
  "忽",
  "托",
  "驚",
  "塑",
  "遺",
  "愈",
  "朱",
  "替",
  "纖",
  "粗",
  "傾",
  "尚",
  "痛",
  "楚",
  "謝",
  "奮",
  "購",
  "磨",
  "君",
  "池",
  "旁",
  "碎",
  "骨",
  "監",
  "捕",
  "弟",
  "暴",
  "割",
  "貫",
  "殊",
  "釋",
  "詞",
  "亡",
  "壁",
  "頓",
  "寶",
  "午",
  "塵",
  "聞",
  "揭",
  "炮",
  "殘",
  "冬",
  "橋",
  "婦",
  "警",
  "綜",
  "招",
  "吳",
  "付",
  "浮",
  "遭",
  "徐",
  "您",
  "搖",
  "谷",
  "贊",
  "箱",
  "隔",
  "訂",
  "男",
  "吹",
  "園",
  "紛",
  "唐",
  "敗",
  "宋",
  "玻",
  "巨",
  "耕",
  "坦",
  "榮",
  "閉",
  "灣",
  "鍵",
  "凡",
  "駐",
  "鍋",
  "救",
  "恩",
  "剝",
  "凝",
  "鹼",
  "齒",
  "截",
  "煉",
  "麻",
  "紡",
  "禁",
  "廢",
  "盛",
  "版",
  "緩",
  "淨",
  "睛",
  "昌",
  "婚",
  "涉",
  "筒",
  "嘴",
  "插",
  "岸",
  "朗",
  "莊",
  "街",
  "藏",
  "姑",
  "貿",
  "腐",
  "奴",
  "啦",
  "慣",
  "乘",
  "夥",
  "恢",
  "勻",
  "紗",
  "扎",
  "辯",
  "耳",
  "彪",
  "臣",
  "億",
  "璃",
  "抵",
  "脈",
  "秀",
  "薩",
  "俄",
  "網",
  "舞",
  "店",
  "噴",
  "縱",
  "寸",
  "汗",
  "掛",
  "洪",
  "賀",
  "閃",
  "柬",
  "爆",
  "烯",
  "津",
  "稻",
  "牆",
  "軟",
  "勇",
  "像",
  "滾",
  "厘",
  "蒙",
  "芳",
  "肯",
  "坡",
  "柱",
  "盪",
  "腿",
  "儀",
  "旅",
  "尾",
  "軋",
  "冰",
  "貢",
  "登",
  "黎",
  "削",
  "鑽",
  "勒",
  "逃",
  "障",
  "氨",
  "郭",
  "峰",
  "幣",
  "港",
  "伏",
  "軌",
  "畝",
  "畢",
  "擦",
  "莫",
  "刺",
  "浪",
  "秘",
  "援",
  "株",
  "健",
  "售",
  "股",
  "島",
  "甘",
  "泡",
  "睡",
  "童",
  "鑄",
  "湯",
  "閥",
  "休",
  "匯",
  "舍",
  "牧",
  "繞",
  "炸",
  "哲",
  "磷",
  "績",
  "朋",
  "淡",
  "尖",
  "啟",
  "陷",
  "柴",
  "呈",
  "徒",
  "顏",
  "淚",
  "稍",
  "忘",
  "泵",
  "藍",
  "拖",
  "洞",
  "授",
  "鏡",
  "辛",
  "壯",
  "鋒",
  "貧",
  "虛",
  "彎",
  "摩",
  "泰",
  "幼",
  "廷",
  "尊",
  "窗",
  "綱",
  "弄",
  "隸",
  "疑",
  "氏",
  "宮",
  "姐",
  "震",
  "瑞",
  "怪",
  "尤",
  "琴",
  "循",
  "描",
  "膜",
  "違",
  "夾",
  "腰",
  "緣",
  "珠",
  "窮",
  "森",
  "枝",
  "竹",
  "溝",
  "催",
  "繩",
  "憶",
  "邦",
  "剩",
  "幸",
  "漿",
  "欄",
  "擁",
  "牙",
  "貯",
  "禮",
  "濾",
  "鈉",
  "紋",
  "罷",
  "拍",
  "咱",
  "喊",
  "袖",
  "埃",
  "勤",
  "罰",
  "焦",
  "潛",
  "伍",
  "墨",
  "欲",
  "縫",
  "姓",
  "刊",
  "飽",
  "仿",
  "獎",
  "鋁",
  "鬼",
  "麗",
  "跨",
  "默",
  "挖",
  "鏈",
  "掃",
  "喝",
  "袋",
  "炭",
  "污",
  "幕",
  "諸",
  "弧",
  "勵",
  "梅",
  "奶",
  "潔",
  "災",
  "舟",
  "鑑",
  "苯",
  "訟",
  "抱",
  "毀",
  "懂",
  "寒",
  "智",
  "埔",
  "寄",
  "屆",
  "躍",
  "渡",
  "挑",
  "丹",
  "艱",
  "貝",
  "碰",
  "拔",
  "爹",
  "戴",
  "碼",
  "夢",
  "芽",
  "熔",
  "赤",
  "漁",
  "哭",
  "敬",
  "顆",
  "奔",
  "鉛",
  "仲",
  "虎",
  "稀",
  "妹",
  "乏",
  "珍",
  "申",
  "桌",
  "遵",
  "允",
  "隆",
  "螺",
  "倉",
  "魏",
  "銳",
  "曉",
  "氮",
  "兼",
  "隱",
  "礙",
  "赫",
  "撥",
  "忠",
  "肅",
  "缸",
  "牽",
  "搶",
  "博",
  "巧",
  "殼",
  "兄",
  "杜",
  "訊",
  "誠",
  "碧",
  "祥",
  "柯",
  "頁",
  "巡",
  "矩",
  "悲",
  "灌",
  "齡",
  "倫",
  "票",
  "尋",
  "桂",
  "鋪",
  "聖",
  "恐",
  "恰",
  "鄭",
  "趣",
  "抬",
  "荒",
  "騰",
  "貼",
  "柔",
  "滴",
  "猛",
  "闊",
  "輛",
  "妻",
  "填",
  "撤",
  "儲",
  "簽",
  "鬧",
  "擾",
  "紫",
  "砂",
  "遞",
  "戲",
  "吊",
  "陶",
  "伐",
  "餵",
  "療",
  "瓶",
  "婆",
  "撫",
  "臂",
  "摸",
  "忍",
  "蝦",
  "蠟",
  "鄰",
  "胸",
  "鞏",
  "擠",
  "偶",
  "棄",
  "槽",
  "勁",
  "乳",
  "鄧",
  "吉",
  "仁",
  "爛",
  "磚",
  "租",
  "烏",
  "艦",
  "伴",
  "瓜",
  "淺",
  "丙",
  "暫",
  "燥",
  "橡",
  "柳",
  "迷",
  "暖",
  "牌",
  "秧",
  "膽",
  "詳",
  "簧",
  "踏",
  "瓷",
  "譜",
  "呆",
  "賓",
  "糊",
  "洛",
  "輝",
  "憤",
  "競",
  "隙",
  "怒",
  "粘",
  "乃",
  "緒",
  "肩",
  "籍",
  "敏",
  "塗",
  "熙",
  "皆",
  "偵",
  "懸",
  "掘",
  "享",
  "糾",
  "醒",
  "狂",
  "鎖",
  "淀",
  "恨",
  "牲",
  "霸",
  "爬",
  "賞",
  "逆",
  "玩",
  "陵",
  "祝",
  "秒",
  "浙",
  "貌",
  "役",
  "彼",
  "悉",
  "鴨",
  "趨",
  "鳳",
  "晨",
  "畜",
  "輩",
  "秩",
  "卵",
  "署",
  "梯",
  "炎",
  "灘",
  "棋",
  "驅",
  "篩",
  "峽",
  "冒",
  "啥",
  "壽",
  "譯",
  "浸",
  "泉",
  "帽",
  "遲",
  "矽",
  "疆",
  "貸",
  "漏",
  "稿",
  "冠",
  "嫩",
  "脅",
  "芯",
  "牢",
  "叛",
  "蝕",
  "奧",
  "鳴",
  "嶺",
  "羊",
  "憑",
  "串",
  "塘",
  "繪",
  "酵",
  "融",
  "盆",
  "錫",
  "廟",
  "籌",
  "凍",
  "輔",
  "攝",
  "襲",
  "筋",
  "拒",
  "僚",
  "旱",
  "鉀",
  "鳥",
  "漆",
  "沈",
  "眉",
  "疏",
  "添",
  "棒",
  "穗",
  "硝",
  "韓",
  "逼",
  "扭",
  "僑",
  "涼",
  "挺",
  "碗",
  "栽",
  "炒",
  "杯",
  "患",
  "餾",
  "勸",
  "豪",
  "遼",
  "勃",
  "鴻",
  "旦",
  "吏",
  "拜",
  "狗",
  "埋",
  "輥",
  "掩",
  "飲",
  "搬",
  "罵",
  "辭",
  "勾",
  "扣",
  "估",
  "蔣",
  "絨",
  "霧",
  "丈",
  "朵",
  "姆",
  "擬",
  "宇",
  "輯",
  "陝",
  "雕",
  "償",
  "蓄",
  "崇",
  "剪",
  "倡",
  "廳",
  "咬",
  "駛",
  "薯",
  "刷",
  "斥",
  "番",
  "賦",
  "奉",
  "佛",
  "澆",
  "漫",
  "曼",
  "扇",
  "鈣",
  "桃",
  "扶",
  "仔",
  "返",
  "俗",
  "虧",
  "腔",
  "鞋",
  "棱",
  "覆",
  "框",
  "悄",
  "叔",
  "撞",
  "騙",
  "勘",
  "旺",
  "沸",
  "孤",
  "吐",
  "孟",
  "渠",
  "屈",
  "疾",
  "妙",
  "惜",
  "仰",
  "狠",
  "脹",
  "諧",
  "拋",
  "黴",
  "桑",
  "崗",
  "嘛",
  "衰",
  "盜",
  "滲",
  "臟",
  "賴",
  "湧",
  "甜",
  "曹",
  "閱",
  "肌",
  "哩",
  "厲",
  "烴",
  "緯",
  "毅",
  "昨",
  "偽",
  "症",
  "煮",
  "嘆",
  "釘",
  "搭",
  "莖",
  "籠",
  "酷",
  "偷",
  "弓",
  "錐",
  "恆",
  "傑",
  "坑",
  "鼻",
  "翼",
  "綸",
  "敘",
  "獄",
  "逮",
  "罐",
  "絡",
  "棚",
  "抑",
  "膨",
  "蔬",
  "寺",
  "驟",
  "穆",
  "冶",
  "枯",
  "冊",
  "屍",
  "凸",
  "紳",
  "坯",
  "犧",
  "焰",
  "轟",
  "欣",
  "晉",
  "瘦",
  "禦",
  "錠",
  "錦",
  "喪",
  "旬",
  "鍛",
  "壟",
  "搜",
  "撲",
  "邀",
  "亭",
  "酯",
  "邁",
  "舒",
  "脆",
  "酶",
  "閒",
  "憂",
  "酚",
  "頑",
  "羽",
  "漲",
  "卸",
  "仗",
  "陪",
  "闢",
  "懲",
  "杭",
  "姚",
  "肚",
  "捉",
  "飄",
  "漂",
  "昆",
  "欺",
  "吾",
  "郎",
  "烷",
  "汁",
  "呵",
  "飾",
  "蕭",
  "雅",
  "郵",
  "遷",
  "燕",
  "撒",
  "姻",
  "赴",
  "宴",
  "煩",
  "債",
  "帳",
  "斑",
  "鈴",
  "旨",
  "醇",
  "董",
  "餅",
  "雛",
  "姿",
  "拌",
  "傅",
  "腹",
  "妥",
  "揉",
  "賢",
  "拆",
  "歪",
  "葡",
  "胺",
  "丟",
  "浩",
  "徽",
  "昂",
  "墊",
  "擋",
  "覽",
  "貪",
  "慰",
  "繳",
  "汪",
  "慌",
  "馮",
  "諾",
  "姜",
  "誼",
  "兇",
  "劣",
  "誣",
  "耀",
  "昏",
  "躺",
  "盈",
  "騎",
  "喬",
  "溪",
  "叢",
  "盧",
  "抹",
  "悶",
  "諮",
  "刮",
  "駕",
  "纜",
  "悟",
  "摘",
  "鉺",
  "擲",
  "頗",
  "幻",
  "柄",
  "惠",
  "慘",
  "佳",
  "仇",
  "臘",
  "窩",
  "滌",
  "劍",
  "瞧",
  "堡",
  "潑",
  "蔥",
  "罩",
  "霍",
  "撈",
  "胎",
  "蒼",
  "濱",
  "倆",
  "捅",
  "湘",
  "砍",
  "霞",
  "邵",
  "萄",
  "瘋",
  "淮",
  "遂",
  "熊",
  "糞",
  "烘",
  "宿",
  "檔",
  "戈",
  "駁",
  "嫂",
  "裕",
  "徙",
  "箭",
  "捐",
  "腸",
  "撐",
  "曬",
  "辨",
  "殿",
  "蓮",
  "攤",
  "攪",
  "醬",
  "屏",
  "疫",
  "哀",
  "蔡",
  "堵",
  "沫",
  "皺",
  "暢",
  "疊",
  "閣",
  "萊",
  "敲",
  "轄",
  "鉤",
  "痕",
  "壩",
  "巷",
  "餓",
  "禍",
  "丘",
  "玄",
  "溜",
  "曰",
  "邏",
  "彭",
  "嘗",
  "卿",
  "妨",
  "艇",
  "吞",
  "韋",
  "怨",
  "矮",
  "歇"
]

},{}],19:[function(require,module,exports){
module.exports=[
  "abandon",
  "ability",
  "able",
  "about",
  "above",
  "absent",
  "absorb",
  "abstract",
  "absurd",
  "abuse",
  "access",
  "accident",
  "account",
  "accuse",
  "achieve",
  "acid",
  "acoustic",
  "acquire",
  "across",
  "act",
  "action",
  "actor",
  "actress",
  "actual",
  "adapt",
  "add",
  "addict",
  "address",
  "adjust",
  "admit",
  "adult",
  "advance",
  "advice",
  "aerobic",
  "affair",
  "afford",
  "afraid",
  "again",
  "age",
  "agent",
  "agree",
  "ahead",
  "aim",
  "air",
  "airport",
  "aisle",
  "alarm",
  "album",
  "alcohol",
  "alert",
  "alien",
  "all",
  "alley",
  "allow",
  "almost",
  "alone",
  "alpha",
  "already",
  "also",
  "alter",
  "always",
  "amateur",
  "amazing",
  "among",
  "amount",
  "amused",
  "analyst",
  "anchor",
  "ancient",
  "anger",
  "angle",
  "angry",
  "animal",
  "ankle",
  "announce",
  "annual",
  "another",
  "answer",
  "antenna",
  "antique",
  "anxiety",
  "any",
  "apart",
  "apology",
  "appear",
  "apple",
  "approve",
  "april",
  "arch",
  "arctic",
  "area",
  "arena",
  "argue",
  "arm",
  "armed",
  "armor",
  "army",
  "around",
  "arrange",
  "arrest",
  "arrive",
  "arrow",
  "art",
  "artefact",
  "artist",
  "artwork",
  "ask",
  "aspect",
  "assault",
  "asset",
  "assist",
  "assume",
  "asthma",
  "athlete",
  "atom",
  "attack",
  "attend",
  "attitude",
  "attract",
  "auction",
  "audit",
  "august",
  "aunt",
  "author",
  "auto",
  "autumn",
  "average",
  "avocado",
  "avoid",
  "awake",
  "aware",
  "away",
  "awesome",
  "awful",
  "awkward",
  "axis",
  "baby",
  "bachelor",
  "bacon",
  "badge",
  "bag",
  "balance",
  "balcony",
  "ball",
  "bamboo",
  "banana",
  "banner",
  "bar",
  "barely",
  "bargain",
  "barrel",
  "base",
  "basic",
  "basket",
  "battle",
  "beach",
  "bean",
  "beauty",
  "because",
  "become",
  "beef",
  "before",
  "begin",
  "behave",
  "behind",
  "believe",
  "below",
  "belt",
  "bench",
  "benefit",
  "best",
  "betray",
  "better",
  "between",
  "beyond",
  "bicycle",
  "bid",
  "bike",
  "bind",
  "biology",
  "bird",
  "birth",
  "bitter",
  "black",
  "blade",
  "blame",
  "blanket",
  "blast",
  "bleak",
  "bless",
  "blind",
  "blood",
  "blossom",
  "blouse",
  "blue",
  "blur",
  "blush",
  "board",
  "boat",
  "body",
  "boil",
  "bomb",
  "bone",
  "bonus",
  "book",
  "boost",
  "border",
  "boring",
  "borrow",
  "boss",
  "bottom",
  "bounce",
  "box",
  "boy",
  "bracket",
  "brain",
  "brand",
  "brass",
  "brave",
  "bread",
  "breeze",
  "brick",
  "bridge",
  "brief",
  "bright",
  "bring",
  "brisk",
  "broccoli",
  "broken",
  "bronze",
  "broom",
  "brother",
  "brown",
  "brush",
  "bubble",
  "buddy",
  "budget",
  "buffalo",
  "build",
  "bulb",
  "bulk",
  "bullet",
  "bundle",
  "bunker",
  "burden",
  "burger",
  "burst",
  "bus",
  "business",
  "busy",
  "butter",
  "buyer",
  "buzz",
  "cabbage",
  "cabin",
  "cable",
  "cactus",
  "cage",
  "cake",
  "call",
  "calm",
  "camera",
  "camp",
  "can",
  "canal",
  "cancel",
  "candy",
  "cannon",
  "canoe",
  "canvas",
  "canyon",
  "capable",
  "capital",
  "captain",
  "car",
  "carbon",
  "card",
  "cargo",
  "carpet",
  "carry",
  "cart",
  "case",
  "cash",
  "casino",
  "castle",
  "casual",
  "cat",
  "catalog",
  "catch",
  "category",
  "cattle",
  "caught",
  "cause",
  "caution",
  "cave",
  "ceiling",
  "celery",
  "cement",
  "census",
  "century",
  "cereal",
  "certain",
  "chair",
  "chalk",
  "champion",
  "change",
  "chaos",
  "chapter",
  "charge",
  "chase",
  "chat",
  "cheap",
  "check",
  "cheese",
  "chef",
  "cherry",
  "chest",
  "chicken",
  "chief",
  "child",
  "chimney",
  "choice",
  "choose",
  "chronic",
  "chuckle",
  "chunk",
  "churn",
  "cigar",
  "cinnamon",
  "circle",
  "citizen",
  "city",
  "civil",
  "claim",
  "clap",
  "clarify",
  "claw",
  "clay",
  "clean",
  "clerk",
  "clever",
  "click",
  "client",
  "cliff",
  "climb",
  "clinic",
  "clip",
  "clock",
  "clog",
  "close",
  "cloth",
  "cloud",
  "clown",
  "club",
  "clump",
  "cluster",
  "clutch",
  "coach",
  "coast",
  "coconut",
  "code",
  "coffee",
  "coil",
  "coin",
  "collect",
  "color",
  "column",
  "combine",
  "come",
  "comfort",
  "comic",
  "common",
  "company",
  "concert",
  "conduct",
  "confirm",
  "congress",
  "connect",
  "consider",
  "control",
  "convince",
  "cook",
  "cool",
  "copper",
  "copy",
  "coral",
  "core",
  "corn",
  "correct",
  "cost",
  "cotton",
  "couch",
  "country",
  "couple",
  "course",
  "cousin",
  "cover",
  "coyote",
  "crack",
  "cradle",
  "craft",
  "cram",
  "crane",
  "crash",
  "crater",
  "crawl",
  "crazy",
  "cream",
  "credit",
  "creek",
  "crew",
  "cricket",
  "crime",
  "crisp",
  "critic",
  "crop",
  "cross",
  "crouch",
  "crowd",
  "crucial",
  "cruel",
  "cruise",
  "crumble",
  "crunch",
  "crush",
  "cry",
  "crystal",
  "cube",
  "culture",
  "cup",
  "cupboard",
  "curious",
  "current",
  "curtain",
  "curve",
  "cushion",
  "custom",
  "cute",
  "cycle",
  "dad",
  "damage",
  "damp",
  "dance",
  "danger",
  "daring",
  "dash",
  "daughter",
  "dawn",
  "day",
  "deal",
  "debate",
  "debris",
  "decade",
  "december",
  "decide",
  "decline",
  "decorate",
  "decrease",
  "deer",
  "defense",
  "define",
  "defy",
  "degree",
  "delay",
  "deliver",
  "demand",
  "demise",
  "denial",
  "dentist",
  "deny",
  "depart",
  "depend",
  "deposit",
  "depth",
  "deputy",
  "derive",
  "describe",
  "desert",
  "design",
  "desk",
  "despair",
  "destroy",
  "detail",
  "detect",
  "develop",
  "device",
  "devote",
  "diagram",
  "dial",
  "diamond",
  "diary",
  "dice",
  "diesel",
  "diet",
  "differ",
  "digital",
  "dignity",
  "dilemma",
  "dinner",
  "dinosaur",
  "direct",
  "dirt",
  "disagree",
  "discover",
  "disease",
  "dish",
  "dismiss",
  "disorder",
  "display",
  "distance",
  "divert",
  "divide",
  "divorce",
  "dizzy",
  "doctor",
  "document",
  "dog",
  "doll",
  "dolphin",
  "domain",
  "donate",
  "donkey",
  "donor",
  "door",
  "dose",
  "double",
  "dove",
  "draft",
  "dragon",
  "drama",
  "drastic",
  "draw",
  "dream",
  "dress",
  "drift",
  "drill",
  "drink",
  "drip",
  "drive",
  "drop",
  "drum",
  "dry",
  "duck",
  "dumb",
  "dune",
  "during",
  "dust",
  "dutch",
  "duty",
  "dwarf",
  "dynamic",
  "eager",
  "eagle",
  "early",
  "earn",
  "earth",
  "easily",
  "east",
  "easy",
  "echo",
  "ecology",
  "economy",
  "edge",
  "edit",
  "educate",
  "effort",
  "egg",
  "eight",
  "either",
  "elbow",
  "elder",
  "electric",
  "elegant",
  "element",
  "elephant",
  "elevator",
  "elite",
  "else",
  "embark",
  "embody",
  "embrace",
  "emerge",
  "emotion",
  "employ",
  "empower",
  "empty",
  "enable",
  "enact",
  "end",
  "endless",
  "endorse",
  "enemy",
  "energy",
  "enforce",
  "engage",
  "engine",
  "enhance",
  "enjoy",
  "enlist",
  "enough",
  "enrich",
  "enroll",
  "ensure",
  "enter",
  "entire",
  "entry",
  "envelope",
  "episode",
  "equal",
  "equip",
  "era",
  "erase",
  "erode",
  "erosion",
  "error",
  "erupt",
  "escape",
  "essay",
  "essence",
  "estate",
  "eternal",
  "ethics",
  "evidence",
  "evil",
  "evoke",
  "evolve",
  "exact",
  "example",
  "excess",
  "exchange",
  "excite",
  "exclude",
  "excuse",
  "execute",
  "exercise",
  "exhaust",
  "exhibit",
  "exile",
  "exist",
  "exit",
  "exotic",
  "expand",
  "expect",
  "expire",
  "explain",
  "expose",
  "express",
  "extend",
  "extra",
  "eye",
  "eyebrow",
  "fabric",
  "face",
  "faculty",
  "fade",
  "faint",
  "faith",
  "fall",
  "false",
  "fame",
  "family",
  "famous",
  "fan",
  "fancy",
  "fantasy",
  "farm",
  "fashion",
  "fat",
  "fatal",
  "father",
  "fatigue",
  "fault",
  "favorite",
  "feature",
  "february",
  "federal",
  "fee",
  "feed",
  "feel",
  "female",
  "fence",
  "festival",
  "fetch",
  "fever",
  "few",
  "fiber",
  "fiction",
  "field",
  "figure",
  "file",
  "film",
  "filter",
  "final",
  "find",
  "fine",
  "finger",
  "finish",
  "fire",
  "firm",
  "first",
  "fiscal",
  "fish",
  "fit",
  "fitness",
  "fix",
  "flag",
  "flame",
  "flash",
  "flat",
  "flavor",
  "flee",
  "flight",
  "flip",
  "float",
  "flock",
  "floor",
  "flower",
  "fluid",
  "flush",
  "fly",
  "foam",
  "focus",
  "fog",
  "foil",
  "fold",
  "follow",
  "food",
  "foot",
  "force",
  "forest",
  "forget",
  "fork",
  "fortune",
  "forum",
  "forward",
  "fossil",
  "foster",
  "found",
  "fox",
  "fragile",
  "frame",
  "frequent",
  "fresh",
  "friend",
  "fringe",
  "frog",
  "front",
  "frost",
  "frown",
  "frozen",
  "fruit",
  "fuel",
  "fun",
  "funny",
  "furnace",
  "fury",
  "future",
  "gadget",
  "gain",
  "galaxy",
  "gallery",
  "game",
  "gap",
  "garage",
  "garbage",
  "garden",
  "garlic",
  "garment",
  "gas",
  "gasp",
  "gate",
  "gather",
  "gauge",
  "gaze",
  "general",
  "genius",
  "genre",
  "gentle",
  "genuine",
  "gesture",
  "ghost",
  "giant",
  "gift",
  "giggle",
  "ginger",
  "giraffe",
  "girl",
  "give",
  "glad",
  "glance",
  "glare",
  "glass",
  "glide",
  "glimpse",
  "globe",
  "gloom",
  "glory",
  "glove",
  "glow",
  "glue",
  "goat",
  "goddess",
  "gold",
  "good",
  "goose",
  "gorilla",
  "gospel",
  "gossip",
  "govern",
  "gown",
  "grab",
  "grace",
  "grain",
  "grant",
  "grape",
  "grass",
  "gravity",
  "great",
  "green",
  "grid",
  "grief",
  "grit",
  "grocery",
  "group",
  "grow",
  "grunt",
  "guard",
  "guess",
  "guide",
  "guilt",
  "guitar",
  "gun",
  "gym",
  "habit",
  "hair",
  "half",
  "hammer",
  "hamster",
  "hand",
  "happy",
  "harbor",
  "hard",
  "harsh",
  "harvest",
  "hat",
  "have",
  "hawk",
  "hazard",
  "head",
  "health",
  "heart",
  "heavy",
  "hedgehog",
  "height",
  "hello",
  "helmet",
  "help",
  "hen",
  "hero",
  "hidden",
  "high",
  "hill",
  "hint",
  "hip",
  "hire",
  "history",
  "hobby",
  "hockey",
  "hold",
  "hole",
  "holiday",
  "hollow",
  "home",
  "honey",
  "hood",
  "hope",
  "horn",
  "horror",
  "horse",
  "hospital",
  "host",
  "hotel",
  "hour",
  "hover",
  "hub",
  "huge",
  "human",
  "humble",
  "humor",
  "hundred",
  "hungry",
  "hunt",
  "hurdle",
  "hurry",
  "hurt",
  "husband",
  "hybrid",
  "ice",
  "icon",
  "idea",
  "identify",
  "idle",
  "ignore",
  "ill",
  "illegal",
  "illness",
  "image",
  "imitate",
  "immense",
  "immune",
  "impact",
  "impose",
  "improve",
  "impulse",
  "inch",
  "include",
  "income",
  "increase",
  "index",
  "indicate",
  "indoor",
  "industry",
  "infant",
  "inflict",
  "inform",
  "inhale",
  "inherit",
  "initial",
  "inject",
  "injury",
  "inmate",
  "inner",
  "innocent",
  "input",
  "inquiry",
  "insane",
  "insect",
  "inside",
  "inspire",
  "install",
  "intact",
  "interest",
  "into",
  "invest",
  "invite",
  "involve",
  "iron",
  "island",
  "isolate",
  "issue",
  "item",
  "ivory",
  "jacket",
  "jaguar",
  "jar",
  "jazz",
  "jealous",
  "jeans",
  "jelly",
  "jewel",
  "job",
  "join",
  "joke",
  "journey",
  "joy",
  "judge",
  "juice",
  "jump",
  "jungle",
  "junior",
  "junk",
  "just",
  "kangaroo",
  "keen",
  "keep",
  "ketchup",
  "key",
  "kick",
  "kid",
  "kidney",
  "kind",
  "kingdom",
  "kiss",
  "kit",
  "kitchen",
  "kite",
  "kitten",
  "kiwi",
  "knee",
  "knife",
  "knock",
  "know",
  "lab",
  "label",
  "labor",
  "ladder",
  "lady",
  "lake",
  "lamp",
  "language",
  "laptop",
  "large",
  "later",
  "latin",
  "laugh",
  "laundry",
  "lava",
  "law",
  "lawn",
  "lawsuit",
  "layer",
  "lazy",
  "leader",
  "leaf",
  "learn",
  "leave",
  "lecture",
  "left",
  "leg",
  "legal",
  "legend",
  "leisure",
  "lemon",
  "lend",
  "length",
  "lens",
  "leopard",
  "lesson",
  "letter",
  "level",
  "liar",
  "liberty",
  "library",
  "license",
  "life",
  "lift",
  "light",
  "like",
  "limb",
  "limit",
  "link",
  "lion",
  "liquid",
  "list",
  "little",
  "live",
  "lizard",
  "load",
  "loan",
  "lobster",
  "local",
  "lock",
  "logic",
  "lonely",
  "long",
  "loop",
  "lottery",
  "loud",
  "lounge",
  "love",
  "loyal",
  "lucky",
  "luggage",
  "lumber",
  "lunar",
  "lunch",
  "luxury",
  "lyrics",
  "machine",
  "mad",
  "magic",
  "magnet",
  "maid",
  "mail",
  "main",
  "major",
  "make",
  "mammal",
  "man",
  "manage",
  "mandate",
  "mango",
  "mansion",
  "manual",
  "maple",
  "marble",
  "march",
  "margin",
  "marine",
  "market",
  "marriage",
  "mask",
  "mass",
  "master",
  "match",
  "material",
  "math",
  "matrix",
  "matter",
  "maximum",
  "maze",
  "meadow",
  "mean",
  "measure",
  "meat",
  "mechanic",
  "medal",
  "media",
  "melody",
  "melt",
  "member",
  "memory",
  "mention",
  "menu",
  "mercy",
  "merge",
  "merit",
  "merry",
  "mesh",
  "message",
  "metal",
  "method",
  "middle",
  "midnight",
  "milk",
  "million",
  "mimic",
  "mind",
  "minimum",
  "minor",
  "minute",
  "miracle",
  "mirror",
  "misery",
  "miss",
  "mistake",
  "mix",
  "mixed",
  "mixture",
  "mobile",
  "model",
  "modify",
  "mom",
  "moment",
  "monitor",
  "monkey",
  "monster",
  "month",
  "moon",
  "moral",
  "more",
  "morning",
  "mosquito",
  "mother",
  "motion",
  "motor",
  "mountain",
  "mouse",
  "move",
  "movie",
  "much",
  "muffin",
  "mule",
  "multiply",
  "muscle",
  "museum",
  "mushroom",
  "music",
  "must",
  "mutual",
  "myself",
  "mystery",
  "myth",
  "naive",
  "name",
  "napkin",
  "narrow",
  "nasty",
  "nation",
  "nature",
  "near",
  "neck",
  "need",
  "negative",
  "neglect",
  "neither",
  "nephew",
  "nerve",
  "nest",
  "net",
  "network",
  "neutral",
  "never",
  "news",
  "next",
  "nice",
  "night",
  "noble",
  "noise",
  "nominee",
  "noodle",
  "normal",
  "north",
  "nose",
  "notable",
  "note",
  "nothing",
  "notice",
  "novel",
  "now",
  "nuclear",
  "number",
  "nurse",
  "nut",
  "oak",
  "obey",
  "object",
  "oblige",
  "obscure",
  "observe",
  "obtain",
  "obvious",
  "occur",
  "ocean",
  "october",
  "odor",
  "off",
  "offer",
  "office",
  "often",
  "oil",
  "okay",
  "old",
  "olive",
  "olympic",
  "omit",
  "once",
  "one",
  "onion",
  "online",
  "only",
  "open",
  "opera",
  "opinion",
  "oppose",
  "option",
  "orange",
  "orbit",
  "orchard",
  "order",
  "ordinary",
  "organ",
  "orient",
  "original",
  "orphan",
  "ostrich",
  "other",
  "outdoor",
  "outer",
  "output",
  "outside",
  "oval",
  "oven",
  "over",
  "own",
  "owner",
  "oxygen",
  "oyster",
  "ozone",
  "pact",
  "paddle",
  "page",
  "pair",
  "palace",
  "palm",
  "panda",
  "panel",
  "panic",
  "panther",
  "paper",
  "parade",
  "parent",
  "park",
  "parrot",
  "party",
  "pass",
  "patch",
  "path",
  "patient",
  "patrol",
  "pattern",
  "pause",
  "pave",
  "payment",
  "peace",
  "peanut",
  "pear",
  "peasant",
  "pelican",
  "pen",
  "penalty",
  "pencil",
  "people",
  "pepper",
  "perfect",
  "permit",
  "person",
  "pet",
  "phone",
  "photo",
  "phrase",
  "physical",
  "piano",
  "picnic",
  "picture",
  "piece",
  "pig",
  "pigeon",
  "pill",
  "pilot",
  "pink",
  "pioneer",
  "pipe",
  "pistol",
  "pitch",
  "pizza",
  "place",
  "planet",
  "plastic",
  "plate",
  "play",
  "please",
  "pledge",
  "pluck",
  "plug",
  "plunge",
  "poem",
  "poet",
  "point",
  "polar",
  "pole",
  "police",
  "pond",
  "pony",
  "pool",
  "popular",
  "portion",
  "position",
  "possible",
  "post",
  "potato",
  "pottery",
  "poverty",
  "powder",
  "power",
  "practice",
  "praise",
  "predict",
  "prefer",
  "prepare",
  "present",
  "pretty",
  "prevent",
  "price",
  "pride",
  "primary",
  "print",
  "priority",
  "prison",
  "private",
  "prize",
  "problem",
  "process",
  "produce",
  "profit",
  "program",
  "project",
  "promote",
  "proof",
  "property",
  "prosper",
  "protect",
  "proud",
  "provide",
  "public",
  "pudding",
  "pull",
  "pulp",
  "pulse",
  "pumpkin",
  "punch",
  "pupil",
  "puppy",
  "purchase",
  "purity",
  "purpose",
  "purse",
  "push",
  "put",
  "puzzle",
  "pyramid",
  "quality",
  "quantum",
  "quarter",
  "question",
  "quick",
  "quit",
  "quiz",
  "quote",
  "rabbit",
  "raccoon",
  "race",
  "rack",
  "radar",
  "radio",
  "rail",
  "rain",
  "raise",
  "rally",
  "ramp",
  "ranch",
  "random",
  "range",
  "rapid",
  "rare",
  "rate",
  "rather",
  "raven",
  "raw",
  "razor",
  "ready",
  "real",
  "reason",
  "rebel",
  "rebuild",
  "recall",
  "receive",
  "recipe",
  "record",
  "recycle",
  "reduce",
  "reflect",
  "reform",
  "refuse",
  "region",
  "regret",
  "regular",
  "reject",
  "relax",
  "release",
  "relief",
  "rely",
  "remain",
  "remember",
  "remind",
  "remove",
  "render",
  "renew",
  "rent",
  "reopen",
  "repair",
  "repeat",
  "replace",
  "report",
  "require",
  "rescue",
  "resemble",
  "resist",
  "resource",
  "response",
  "result",
  "retire",
  "retreat",
  "return",
  "reunion",
  "reveal",
  "review",
  "reward",
  "rhythm",
  "rib",
  "ribbon",
  "rice",
  "rich",
  "ride",
  "ridge",
  "rifle",
  "right",
  "rigid",
  "ring",
  "riot",
  "ripple",
  "risk",
  "ritual",
  "rival",
  "river",
  "road",
  "roast",
  "robot",
  "robust",
  "rocket",
  "romance",
  "roof",
  "rookie",
  "room",
  "rose",
  "rotate",
  "rough",
  "round",
  "route",
  "royal",
  "rubber",
  "rude",
  "rug",
  "rule",
  "run",
  "runway",
  "rural",
  "sad",
  "saddle",
  "sadness",
  "safe",
  "sail",
  "salad",
  "salmon",
  "salon",
  "salt",
  "salute",
  "same",
  "sample",
  "sand",
  "satisfy",
  "satoshi",
  "sauce",
  "sausage",
  "save",
  "say",
  "scale",
  "scan",
  "scare",
  "scatter",
  "scene",
  "scheme",
  "school",
  "science",
  "scissors",
  "scorpion",
  "scout",
  "scrap",
  "screen",
  "script",
  "scrub",
  "sea",
  "search",
  "season",
  "seat",
  "second",
  "secret",
  "section",
  "security",
  "seed",
  "seek",
  "segment",
  "select",
  "sell",
  "seminar",
  "senior",
  "sense",
  "sentence",
  "series",
  "service",
  "session",
  "settle",
  "setup",
  "seven",
  "shadow",
  "shaft",
  "shallow",
  "share",
  "shed",
  "shell",
  "sheriff",
  "shield",
  "shift",
  "shine",
  "ship",
  "shiver",
  "shock",
  "shoe",
  "shoot",
  "shop",
  "short",
  "shoulder",
  "shove",
  "shrimp",
  "shrug",
  "shuffle",
  "shy",
  "sibling",
  "sick",
  "side",
  "siege",
  "sight",
  "sign",
  "silent",
  "silk",
  "silly",
  "silver",
  "similar",
  "simple",
  "since",
  "sing",
  "siren",
  "sister",
  "situate",
  "six",
  "size",
  "skate",
  "sketch",
  "ski",
  "skill",
  "skin",
  "skirt",
  "skull",
  "slab",
  "slam",
  "sleep",
  "slender",
  "slice",
  "slide",
  "slight",
  "slim",
  "slogan",
  "slot",
  "slow",
  "slush",
  "small",
  "smart",
  "smile",
  "smoke",
  "smooth",
  "snack",
  "snake",
  "snap",
  "sniff",
  "snow",
  "soap",
  "soccer",
  "social",
  "sock",
  "soda",
  "soft",
  "solar",
  "soldier",
  "solid",
  "solution",
  "solve",
  "someone",
  "song",
  "soon",
  "sorry",
  "sort",
  "soul",
  "sound",
  "soup",
  "source",
  "south",
  "space",
  "spare",
  "spatial",
  "spawn",
  "speak",
  "special",
  "speed",
  "spell",
  "spend",
  "sphere",
  "spice",
  "spider",
  "spike",
  "spin",
  "spirit",
  "split",
  "spoil",
  "sponsor",
  "spoon",
  "sport",
  "spot",
  "spray",
  "spread",
  "spring",
  "spy",
  "square",
  "squeeze",
  "squirrel",
  "stable",
  "stadium",
  "staff",
  "stage",
  "stairs",
  "stamp",
  "stand",
  "start",
  "state",
  "stay",
  "steak",
  "steel",
  "stem",
  "step",
  "stereo",
  "stick",
  "still",
  "sting",
  "stock",
  "stomach",
  "stone",
  "stool",
  "story",
  "stove",
  "strategy",
  "street",
  "strike",
  "strong",
  "struggle",
  "student",
  "stuff",
  "stumble",
  "style",
  "subject",
  "submit",
  "subway",
  "success",
  "such",
  "sudden",
  "suffer",
  "sugar",
  "suggest",
  "suit",
  "summer",
  "sun",
  "sunny",
  "sunset",
  "super",
  "supply",
  "supreme",
  "sure",
  "surface",
  "surge",
  "surprise",
  "surround",
  "survey",
  "suspect",
  "sustain",
  "swallow",
  "swamp",
  "swap",
  "swarm",
  "swear",
  "sweet",
  "swift",
  "swim",
  "swing",
  "switch",
  "sword",
  "symbol",
  "symptom",
  "syrup",
  "system",
  "table",
  "tackle",
  "tag",
  "tail",
  "talent",
  "talk",
  "tank",
  "tape",
  "target",
  "task",
  "taste",
  "tattoo",
  "taxi",
  "teach",
  "team",
  "tell",
  "ten",
  "tenant",
  "tennis",
  "tent",
  "term",
  "test",
  "text",
  "thank",
  "that",
  "theme",
  "then",
  "theory",
  "there",
  "they",
  "thing",
  "this",
  "thought",
  "three",
  "thrive",
  "throw",
  "thumb",
  "thunder",
  "ticket",
  "tide",
  "tiger",
  "tilt",
  "timber",
  "time",
  "tiny",
  "tip",
  "tired",
  "tissue",
  "title",
  "toast",
  "tobacco",
  "today",
  "toddler",
  "toe",
  "together",
  "toilet",
  "token",
  "tomato",
  "tomorrow",
  "tone",
  "tongue",
  "tonight",
  "tool",
  "tooth",
  "top",
  "topic",
  "topple",
  "torch",
  "tornado",
  "tortoise",
  "toss",
  "total",
  "tourist",
  "toward",
  "tower",
  "town",
  "toy",
  "track",
  "trade",
  "traffic",
  "tragic",
  "train",
  "transfer",
  "trap",
  "trash",
  "travel",
  "tray",
  "treat",
  "tree",
  "trend",
  "trial",
  "tribe",
  "trick",
  "trigger",
  "trim",
  "trip",
  "trophy",
  "trouble",
  "truck",
  "true",
  "truly",
  "trumpet",
  "trust",
  "truth",
  "try",
  "tube",
  "tuition",
  "tumble",
  "tuna",
  "tunnel",
  "turkey",
  "turn",
  "turtle",
  "twelve",
  "twenty",
  "twice",
  "twin",
  "twist",
  "two",
  "type",
  "typical",
  "ugly",
  "umbrella",
  "unable",
  "unaware",
  "uncle",
  "uncover",
  "under",
  "undo",
  "unfair",
  "unfold",
  "unhappy",
  "uniform",
  "unique",
  "unit",
  "universe",
  "unknown",
  "unlock",
  "until",
  "unusual",
  "unveil",
  "update",
  "upgrade",
  "uphold",
  "upon",
  "upper",
  "upset",
  "urban",
  "urge",
  "usage",
  "use",
  "used",
  "useful",
  "useless",
  "usual",
  "utility",
  "vacant",
  "vacuum",
  "vague",
  "valid",
  "valley",
  "valve",
  "van",
  "vanish",
  "vapor",
  "various",
  "vast",
  "vault",
  "vehicle",
  "velvet",
  "vendor",
  "venture",
  "venue",
  "verb",
  "verify",
  "version",
  "very",
  "vessel",
  "veteran",
  "viable",
  "vibrant",
  "vicious",
  "victory",
  "video",
  "view",
  "village",
  "vintage",
  "violin",
  "virtual",
  "virus",
  "visa",
  "visit",
  "visual",
  "vital",
  "vivid",
  "vocal",
  "voice",
  "void",
  "volcano",
  "volume",
  "vote",
  "voyage",
  "wage",
  "wagon",
  "wait",
  "walk",
  "wall",
  "walnut",
  "want",
  "warfare",
  "warm",
  "warrior",
  "wash",
  "wasp",
  "waste",
  "water",
  "wave",
  "way",
  "wealth",
  "weapon",
  "wear",
  "weasel",
  "weather",
  "web",
  "wedding",
  "weekend",
  "weird",
  "welcome",
  "west",
  "wet",
  "whale",
  "what",
  "wheat",
  "wheel",
  "when",
  "where",
  "whip",
  "whisper",
  "wide",
  "width",
  "wife",
  "wild",
  "will",
  "win",
  "window",
  "wine",
  "wing",
  "wink",
  "winner",
  "winter",
  "wire",
  "wisdom",
  "wise",
  "wish",
  "witness",
  "wolf",
  "woman",
  "wonder",
  "wood",
  "wool",
  "word",
  "work",
  "world",
  "worry",
  "worth",
  "wrap",
  "wreck",
  "wrestle",
  "wrist",
  "write",
  "wrong",
  "yard",
  "year",
  "yellow",
  "you",
  "young",
  "youth",
  "zebra",
  "zero",
  "zone",
  "zoo"
]

},{}],20:[function(require,module,exports){
module.exports=[
  "abaisser",
  "abandon",
  "abdiquer",
  "abeille",
  "abolir",
  "aborder",
  "aboutir",
  "aboyer",
  "abrasif",
  "abreuver",
  "abriter",
  "abroger",
  "abrupt",
  "absence",
  "absolu",
  "absurde",
  "abusif",
  "abyssal",
  "académie",
  "acajou",
  "acarien",
  "accabler",
  "accepter",
  "acclamer",
  "accolade",
  "accroche",
  "accuser",
  "acerbe",
  "achat",
  "acheter",
  "aciduler",
  "acier",
  "acompte",
  "acquérir",
  "acronyme",
  "acteur",
  "actif",
  "actuel",
  "adepte",
  "adéquat",
  "adhésif",
  "adjectif",
  "adjuger",
  "admettre",
  "admirer",
  "adopter",
  "adorer",
  "adoucir",
  "adresse",
  "adroit",
  "adulte",
  "adverbe",
  "aérer",
  "aéronef",
  "affaire",
  "affecter",
  "affiche",
  "affreux",
  "affubler",
  "agacer",
  "agencer",
  "agile",
  "agiter",
  "agrafer",
  "agréable",
  "agrume",
  "aider",
  "aiguille",
  "ailier",
  "aimable",
  "aisance",
  "ajouter",
  "ajuster",
  "alarmer",
  "alchimie",
  "alerte",
  "algèbre",
  "algue",
  "aliéner",
  "aliment",
  "alléger",
  "alliage",
  "allouer",
  "allumer",
  "alourdir",
  "alpaga",
  "altesse",
  "alvéole",
  "amateur",
  "ambigu",
  "ambre",
  "aménager",
  "amertume",
  "amidon",
  "amiral",
  "amorcer",
  "amour",
  "amovible",
  "amphibie",
  "ampleur",
  "amusant",
  "analyse",
  "anaphore",
  "anarchie",
  "anatomie",
  "ancien",
  "anéantir",
  "angle",
  "angoisse",
  "anguleux",
  "animal",
  "annexer",
  "annonce",
  "annuel",
  "anodin",
  "anomalie",
  "anonyme",
  "anormal",
  "antenne",
  "antidote",
  "anxieux",
  "apaiser",
  "apéritif",
  "aplanir",
  "apologie",
  "appareil",
  "appeler",
  "apporter",
  "appuyer",
  "aquarium",
  "aqueduc",
  "arbitre",
  "arbuste",
  "ardeur",
  "ardoise",
  "argent",
  "arlequin",
  "armature",
  "armement",
  "armoire",
  "armure",
  "arpenter",
  "arracher",
  "arriver",
  "arroser",
  "arsenic",
  "artériel",
  "article",
  "aspect",
  "asphalte",
  "aspirer",
  "assaut",
  "asservir",
  "assiette",
  "associer",
  "assurer",
  "asticot",
  "astre",
  "astuce",
  "atelier",
  "atome",
  "atrium",
  "atroce",
  "attaque",
  "attentif",
  "attirer",
  "attraper",
  "aubaine",
  "auberge",
  "audace",
  "audible",
  "augurer",
  "aurore",
  "automne",
  "autruche",
  "avaler",
  "avancer",
  "avarice",
  "avenir",
  "averse",
  "aveugle",
  "aviateur",
  "avide",
  "avion",
  "aviser",
  "avoine",
  "avouer",
  "avril",
  "axial",
  "axiome",
  "badge",
  "bafouer",
  "bagage",
  "baguette",
  "baignade",
  "balancer",
  "balcon",
  "baleine",
  "balisage",
  "bambin",
  "bancaire",
  "bandage",
  "banlieue",
  "bannière",
  "banquier",
  "barbier",
  "baril",
  "baron",
  "barque",
  "barrage",
  "bassin",
  "bastion",
  "bataille",
  "bateau",
  "batterie",
  "baudrier",
  "bavarder",
  "belette",
  "bélier",
  "belote",
  "bénéfice",
  "berceau",
  "berger",
  "berline",
  "bermuda",
  "besace",
  "besogne",
  "bétail",
  "beurre",
  "biberon",
  "bicycle",
  "bidule",
  "bijou",
  "bilan",
  "bilingue",
  "billard",
  "binaire",
  "biologie",
  "biopsie",
  "biotype",
  "biscuit",
  "bison",
  "bistouri",
  "bitume",
  "bizarre",
  "blafard",
  "blague",
  "blanchir",
  "blessant",
  "blinder",
  "blond",
  "bloquer",
  "blouson",
  "bobard",
  "bobine",
  "boire",
  "boiser",
  "bolide",
  "bonbon",
  "bondir",
  "bonheur",
  "bonifier",
  "bonus",
  "bordure",
  "borne",
  "botte",
  "boucle",
  "boueux",
  "bougie",
  "boulon",
  "bouquin",
  "bourse",
  "boussole",
  "boutique",
  "boxeur",
  "branche",
  "brasier",
  "brave",
  "brebis",
  "brèche",
  "breuvage",
  "bricoler",
  "brigade",
  "brillant",
  "brioche",
  "brique",
  "brochure",
  "broder",
  "bronzer",
  "brousse",
  "broyeur",
  "brume",
  "brusque",
  "brutal",
  "bruyant",
  "buffle",
  "buisson",
  "bulletin",
  "bureau",
  "burin",
  "bustier",
  "butiner",
  "butoir",
  "buvable",
  "buvette",
  "cabanon",
  "cabine",
  "cachette",
  "cadeau",
  "cadre",
  "caféine",
  "caillou",
  "caisson",
  "calculer",
  "calepin",
  "calibre",
  "calmer",
  "calomnie",
  "calvaire",
  "camarade",
  "caméra",
  "camion",
  "campagne",
  "canal",
  "caneton",
  "canon",
  "cantine",
  "canular",
  "capable",
  "caporal",
  "caprice",
  "capsule",
  "capter",
  "capuche",
  "carabine",
  "carbone",
  "caresser",
  "caribou",
  "carnage",
  "carotte",
  "carreau",
  "carton",
  "cascade",
  "casier",
  "casque",
  "cassure",
  "causer",
  "caution",
  "cavalier",
  "caverne",
  "caviar",
  "cédille",
  "ceinture",
  "céleste",
  "cellule",
  "cendrier",
  "censurer",
  "central",
  "cercle",
  "cérébral",
  "cerise",
  "cerner",
  "cerveau",
  "cesser",
  "chagrin",
  "chaise",
  "chaleur",
  "chambre",
  "chance",
  "chapitre",
  "charbon",
  "chasseur",
  "chaton",
  "chausson",
  "chavirer",
  "chemise",
  "chenille",
  "chéquier",
  "chercher",
  "cheval",
  "chien",
  "chiffre",
  "chignon",
  "chimère",
  "chiot",
  "chlorure",
  "chocolat",
  "choisir",
  "chose",
  "chouette",
  "chrome",
  "chute",
  "cigare",
  "cigogne",
  "cimenter",
  "cinéma",
  "cintrer",
  "circuler",
  "cirer",
  "cirque",
  "citerne",
  "citoyen",
  "citron",
  "civil",
  "clairon",
  "clameur",
  "claquer",
  "classe",
  "clavier",
  "client",
  "cligner",
  "climat",
  "clivage",
  "cloche",
  "clonage",
  "cloporte",
  "cobalt",
  "cobra",
  "cocasse",
  "cocotier",
  "coder",
  "codifier",
  "coffre",
  "cogner",
  "cohésion",
  "coiffer",
  "coincer",
  "colère",
  "colibri",
  "colline",
  "colmater",
  "colonel",
  "combat",
  "comédie",
  "commande",
  "compact",
  "concert",
  "conduire",
  "confier",
  "congeler",
  "connoter",
  "consonne",
  "contact",
  "convexe",
  "copain",
  "copie",
  "corail",
  "corbeau",
  "cordage",
  "corniche",
  "corpus",
  "correct",
  "cortège",
  "cosmique",
  "costume",
  "coton",
  "coude",
  "coupure",
  "courage",
  "couteau",
  "couvrir",
  "coyote",
  "crabe",
  "crainte",
  "cravate",
  "crayon",
  "créature",
  "créditer",
  "crémeux",
  "creuser",
  "crevette",
  "cribler",
  "crier",
  "cristal",
  "critère",
  "croire",
  "croquer",
  "crotale",
  "crucial",
  "cruel",
  "crypter",
  "cubique",
  "cueillir",
  "cuillère",
  "cuisine",
  "cuivre",
  "culminer",
  "cultiver",
  "cumuler",
  "cupide",
  "curatif",
  "curseur",
  "cyanure",
  "cycle",
  "cylindre",
  "cynique",
  "daigner",
  "damier",
  "danger",
  "danseur",
  "dauphin",
  "débattre",
  "débiter",
  "déborder",
  "débrider",
  "débutant",
  "décaler",
  "décembre",
  "déchirer",
  "décider",
  "déclarer",
  "décorer",
  "décrire",
  "décupler",
  "dédale",
  "déductif",
  "déesse",
  "défensif",
  "défiler",
  "défrayer",
  "dégager",
  "dégivrer",
  "déglutir",
  "dégrafer",
  "déjeuner",
  "délice",
  "déloger",
  "demander",
  "demeurer",
  "démolir",
  "dénicher",
  "dénouer",
  "dentelle",
  "dénuder",
  "départ",
  "dépenser",
  "déphaser",
  "déplacer",
  "déposer",
  "déranger",
  "dérober",
  "désastre",
  "descente",
  "désert",
  "désigner",
  "désobéir",
  "dessiner",
  "destrier",
  "détacher",
  "détester",
  "détourer",
  "détresse",
  "devancer",
  "devenir",
  "deviner",
  "devoir",
  "diable",
  "dialogue",
  "diamant",
  "dicter",
  "différer",
  "digérer",
  "digital",
  "digne",
  "diluer",
  "dimanche",
  "diminuer",
  "dioxyde",
  "directif",
  "diriger",
  "discuter",
  "disposer",
  "dissiper",
  "distance",
  "divertir",
  "diviser",
  "docile",
  "docteur",
  "dogme",
  "doigt",
  "domaine",
  "domicile",
  "dompter",
  "donateur",
  "donjon",
  "donner",
  "dopamine",
  "dortoir",
  "dorure",
  "dosage",
  "doseur",
  "dossier",
  "dotation",
  "douanier",
  "double",
  "douceur",
  "douter",
  "doyen",
  "dragon",
  "draper",
  "dresser",
  "dribbler",
  "droiture",
  "duperie",
  "duplexe",
  "durable",
  "durcir",
  "dynastie",
  "éblouir",
  "écarter",
  "écharpe",
  "échelle",
  "éclairer",
  "éclipse",
  "éclore",
  "écluse",
  "école",
  "économie",
  "écorce",
  "écouter",
  "écraser",
  "écrémer",
  "écrivain",
  "écrou",
  "écume",
  "écureuil",
  "édifier",
  "éduquer",
  "effacer",
  "effectif",
  "effigie",
  "effort",
  "effrayer",
  "effusion",
  "égaliser",
  "égarer",
  "éjecter",
  "élaborer",
  "élargir",
  "électron",
  "élégant",
  "éléphant",
  "élève",
  "éligible",
  "élitisme",
  "éloge",
  "élucider",
  "éluder",
  "emballer",
  "embellir",
  "embryon",
  "émeraude",
  "émission",
  "emmener",
  "émotion",
  "émouvoir",
  "empereur",
  "employer",
  "emporter",
  "emprise",
  "émulsion",
  "encadrer",
  "enchère",
  "enclave",
  "encoche",
  "endiguer",
  "endosser",
  "endroit",
  "enduire",
  "énergie",
  "enfance",
  "enfermer",
  "enfouir",
  "engager",
  "engin",
  "englober",
  "énigme",
  "enjamber",
  "enjeu",
  "enlever",
  "ennemi",
  "ennuyeux",
  "enrichir",
  "enrobage",
  "enseigne",
  "entasser",
  "entendre",
  "entier",
  "entourer",
  "entraver",
  "énumérer",
  "envahir",
  "enviable",
  "envoyer",
  "enzyme",
  "éolien",
  "épaissir",
  "épargne",
  "épatant",
  "épaule",
  "épicerie",
  "épidémie",
  "épier",
  "épilogue",
  "épine",
  "épisode",
  "épitaphe",
  "époque",
  "épreuve",
  "éprouver",
  "épuisant",
  "équerre",
  "équipe",
  "ériger",
  "érosion",
  "erreur",
  "éruption",
  "escalier",
  "espadon",
  "espèce",
  "espiègle",
  "espoir",
  "esprit",
  "esquiver",
  "essayer",
  "essence",
  "essieu",
  "essorer",
  "estime",
  "estomac",
  "estrade",
  "étagère",
  "étaler",
  "étanche",
  "étatique",
  "éteindre",
  "étendoir",
  "éternel",
  "éthanol",
  "éthique",
  "ethnie",
  "étirer",
  "étoffer",
  "étoile",
  "étonnant",
  "étourdir",
  "étrange",
  "étroit",
  "étude",
  "euphorie",
  "évaluer",
  "évasion",
  "éventail",
  "évidence",
  "éviter",
  "évolutif",
  "évoquer",
  "exact",
  "exagérer",
  "exaucer",
  "exceller",
  "excitant",
  "exclusif",
  "excuse",
  "exécuter",
  "exemple",
  "exercer",
  "exhaler",
  "exhorter",
  "exigence",
  "exiler",
  "exister",
  "exotique",
  "expédier",
  "explorer",
  "exposer",
  "exprimer",
  "exquis",
  "extensif",
  "extraire",
  "exulter",
  "fable",
  "fabuleux",
  "facette",
  "facile",
  "facture",
  "faiblir",
  "falaise",
  "fameux",
  "famille",
  "farceur",
  "farfelu",
  "farine",
  "farouche",
  "fasciner",
  "fatal",
  "fatigue",
  "faucon",
  "fautif",
  "faveur",
  "favori",
  "fébrile",
  "féconder",
  "fédérer",
  "félin",
  "femme",
  "fémur",
  "fendoir",
  "féodal",
  "fermer",
  "féroce",
  "ferveur",
  "festival",
  "feuille",
  "feutre",
  "février",
  "fiasco",
  "ficeler",
  "fictif",
  "fidèle",
  "figure",
  "filature",
  "filetage",
  "filière",
  "filleul",
  "filmer",
  "filou",
  "filtrer",
  "financer",
  "finir",
  "fiole",
  "firme",
  "fissure",
  "fixer",
  "flairer",
  "flamme",
  "flasque",
  "flatteur",
  "fléau",
  "flèche",
  "fleur",
  "flexion",
  "flocon",
  "flore",
  "fluctuer",
  "fluide",
  "fluvial",
  "folie",
  "fonderie",
  "fongible",
  "fontaine",
  "forcer",
  "forgeron",
  "formuler",
  "fortune",
  "fossile",
  "foudre",
  "fougère",
  "fouiller",
  "foulure",
  "fourmi",
  "fragile",
  "fraise",
  "franchir",
  "frapper",
  "frayeur",
  "frégate",
  "freiner",
  "frelon",
  "frémir",
  "frénésie",
  "frère",
  "friable",
  "friction",
  "frisson",
  "frivole",
  "froid",
  "fromage",
  "frontal",
  "frotter",
  "fruit",
  "fugitif",
  "fuite",
  "fureur",
  "furieux",
  "furtif",
  "fusion",
  "futur",
  "gagner",
  "galaxie",
  "galerie",
  "gambader",
  "garantir",
  "gardien",
  "garnir",
  "garrigue",
  "gazelle",
  "gazon",
  "géant",
  "gélatine",
  "gélule",
  "gendarme",
  "général",
  "génie",
  "genou",
  "gentil",
  "géologie",
  "géomètre",
  "géranium",
  "germe",
  "gestuel",
  "geyser",
  "gibier",
  "gicler",
  "girafe",
  "givre",
  "glace",
  "glaive",
  "glisser",
  "globe",
  "gloire",
  "glorieux",
  "golfeur",
  "gomme",
  "gonfler",
  "gorge",
  "gorille",
  "goudron",
  "gouffre",
  "goulot",
  "goupille",
  "gourmand",
  "goutte",
  "graduel",
  "graffiti",
  "graine",
  "grand",
  "grappin",
  "gratuit",
  "gravir",
  "grenat",
  "griffure",
  "griller",
  "grimper",
  "grogner",
  "gronder",
  "grotte",
  "groupe",
  "gruger",
  "grutier",
  "gruyère",
  "guépard",
  "guerrier",
  "guide",
  "guimauve",
  "guitare",
  "gustatif",
  "gymnaste",
  "gyrostat",
  "habitude",
  "hachoir",
  "halte",
  "hameau",
  "hangar",
  "hanneton",
  "haricot",
  "harmonie",
  "harpon",
  "hasard",
  "hélium",
  "hématome",
  "herbe",
  "hérisson",
  "hermine",
  "héron",
  "hésiter",
  "heureux",
  "hiberner",
  "hibou",
  "hilarant",
  "histoire",
  "hiver",
  "homard",
  "hommage",
  "homogène",
  "honneur",
  "honorer",
  "honteux",
  "horde",
  "horizon",
  "horloge",
  "hormone",
  "horrible",
  "houleux",
  "housse",
  "hublot",
  "huileux",
  "humain",
  "humble",
  "humide",
  "humour",
  "hurler",
  "hydromel",
  "hygiène",
  "hymne",
  "hypnose",
  "idylle",
  "ignorer",
  "iguane",
  "illicite",
  "illusion",
  "image",
  "imbiber",
  "imiter",
  "immense",
  "immobile",
  "immuable",
  "impact",
  "impérial",
  "implorer",
  "imposer",
  "imprimer",
  "imputer",
  "incarner",
  "incendie",
  "incident",
  "incliner",
  "incolore",
  "indexer",
  "indice",
  "inductif",
  "inédit",
  "ineptie",
  "inexact",
  "infini",
  "infliger",
  "informer",
  "infusion",
  "ingérer",
  "inhaler",
  "inhiber",
  "injecter",
  "injure",
  "innocent",
  "inoculer",
  "inonder",
  "inscrire",
  "insecte",
  "insigne",
  "insolite",
  "inspirer",
  "instinct",
  "insulter",
  "intact",
  "intense",
  "intime",
  "intrigue",
  "intuitif",
  "inutile",
  "invasion",
  "inventer",
  "inviter",
  "invoquer",
  "ironique",
  "irradier",
  "irréel",
  "irriter",
  "isoler",
  "ivoire",
  "ivresse",
  "jaguar",
  "jaillir",
  "jambe",
  "janvier",
  "jardin",
  "jauger",
  "jaune",
  "javelot",
  "jetable",
  "jeton",
  "jeudi",
  "jeunesse",
  "joindre",
  "joncher",
  "jongler",
  "joueur",
  "jouissif",
  "journal",
  "jovial",
  "joyau",
  "joyeux",
  "jubiler",
  "jugement",
  "junior",
  "jupon",
  "juriste",
  "justice",
  "juteux",
  "juvénile",
  "kayak",
  "kimono",
  "kiosque",
  "label",
  "labial",
  "labourer",
  "lacérer",
  "lactose",
  "lagune",
  "laine",
  "laisser",
  "laitier",
  "lambeau",
  "lamelle",
  "lampe",
  "lanceur",
  "langage",
  "lanterne",
  "lapin",
  "largeur",
  "larme",
  "laurier",
  "lavabo",
  "lavoir",
  "lecture",
  "légal",
  "léger",
  "légume",
  "lessive",
  "lettre",
  "levier",
  "lexique",
  "lézard",
  "liasse",
  "libérer",
  "libre",
  "licence",
  "licorne",
  "liège",
  "lièvre",
  "ligature",
  "ligoter",
  "ligue",
  "limer",
  "limite",
  "limonade",
  "limpide",
  "linéaire",
  "lingot",
  "lionceau",
  "liquide",
  "lisière",
  "lister",
  "lithium",
  "litige",
  "littoral",
  "livreur",
  "logique",
  "lointain",
  "loisir",
  "lombric",
  "loterie",
  "louer",
  "lourd",
  "loutre",
  "louve",
  "loyal",
  "lubie",
  "lucide",
  "lucratif",
  "lueur",
  "lugubre",
  "luisant",
  "lumière",
  "lunaire",
  "lundi",
  "luron",
  "lutter",
  "luxueux",
  "machine",
  "magasin",
  "magenta",
  "magique",
  "maigre",
  "maillon",
  "maintien",
  "mairie",
  "maison",
  "majorer",
  "malaxer",
  "maléfice",
  "malheur",
  "malice",
  "mallette",
  "mammouth",
  "mandater",
  "maniable",
  "manquant",
  "manteau",
  "manuel",
  "marathon",
  "marbre",
  "marchand",
  "mardi",
  "maritime",
  "marqueur",
  "marron",
  "marteler",
  "mascotte",
  "massif",
  "matériel",
  "matière",
  "matraque",
  "maudire",
  "maussade",
  "mauve",
  "maximal",
  "méchant",
  "méconnu",
  "médaille",
  "médecin",
  "méditer",
  "méduse",
  "meilleur",
  "mélange",
  "mélodie",
  "membre",
  "mémoire",
  "menacer",
  "mener",
  "menhir",
  "mensonge",
  "mentor",
  "mercredi",
  "mérite",
  "merle",
  "messager",
  "mesure",
  "métal",
  "météore",
  "méthode",
  "métier",
  "meuble",
  "miauler",
  "microbe",
  "miette",
  "mignon",
  "migrer",
  "milieu",
  "million",
  "mimique",
  "mince",
  "minéral",
  "minimal",
  "minorer",
  "minute",
  "miracle",
  "miroiter",
  "missile",
  "mixte",
  "mobile",
  "moderne",
  "moelleux",
  "mondial",
  "moniteur",
  "monnaie",
  "monotone",
  "monstre",
  "montagne",
  "monument",
  "moqueur",
  "morceau",
  "morsure",
  "mortier",
  "moteur",
  "motif",
  "mouche",
  "moufle",
  "moulin",
  "mousson",
  "mouton",
  "mouvant",
  "multiple",
  "munition",
  "muraille",
  "murène",
  "murmure",
  "muscle",
  "muséum",
  "musicien",
  "mutation",
  "muter",
  "mutuel",
  "myriade",
  "myrtille",
  "mystère",
  "mythique",
  "nageur",
  "nappe",
  "narquois",
  "narrer",
  "natation",
  "nation",
  "nature",
  "naufrage",
  "nautique",
  "navire",
  "nébuleux",
  "nectar",
  "néfaste",
  "négation",
  "négliger",
  "négocier",
  "neige",
  "nerveux",
  "nettoyer",
  "neurone",
  "neutron",
  "neveu",
  "niche",
  "nickel",
  "nitrate",
  "niveau",
  "noble",
  "nocif",
  "nocturne",
  "noirceur",
  "noisette",
  "nomade",
  "nombreux",
  "nommer",
  "normatif",
  "notable",
  "notifier",
  "notoire",
  "nourrir",
  "nouveau",
  "novateur",
  "novembre",
  "novice",
  "nuage",
  "nuancer",
  "nuire",
  "nuisible",
  "numéro",
  "nuptial",
  "nuque",
  "nutritif",
  "obéir",
  "objectif",
  "obliger",
  "obscur",
  "observer",
  "obstacle",
  "obtenir",
  "obturer",
  "occasion",
  "occuper",
  "océan",
  "octobre",
  "octroyer",
  "octupler",
  "oculaire",
  "odeur",
  "odorant",
  "offenser",
  "officier",
  "offrir",
  "ogive",
  "oiseau",
  "oisillon",
  "olfactif",
  "olivier",
  "ombrage",
  "omettre",
  "onctueux",
  "onduler",
  "onéreux",
  "onirique",
  "opale",
  "opaque",
  "opérer",
  "opinion",
  "opportun",
  "opprimer",
  "opter",
  "optique",
  "orageux",
  "orange",
  "orbite",
  "ordonner",
  "oreille",
  "organe",
  "orgueil",
  "orifice",
  "ornement",
  "orque",
  "ortie",
  "osciller",
  "osmose",
  "ossature",
  "otarie",
  "ouragan",
  "ourson",
  "outil",
  "outrager",
  "ouvrage",
  "ovation",
  "oxyde",
  "oxygène",
  "ozone",
  "paisible",
  "palace",
  "palmarès",
  "palourde",
  "palper",
  "panache",
  "panda",
  "pangolin",
  "paniquer",
  "panneau",
  "panorama",
  "pantalon",
  "papaye",
  "papier",
  "papoter",
  "papyrus",
  "paradoxe",
  "parcelle",
  "paresse",
  "parfumer",
  "parler",
  "parole",
  "parrain",
  "parsemer",
  "partager",
  "parure",
  "parvenir",
  "passion",
  "pastèque",
  "paternel",
  "patience",
  "patron",
  "pavillon",
  "pavoiser",
  "payer",
  "paysage",
  "peigne",
  "peintre",
  "pelage",
  "pélican",
  "pelle",
  "pelouse",
  "peluche",
  "pendule",
  "pénétrer",
  "pénible",
  "pensif",
  "pénurie",
  "pépite",
  "péplum",
  "perdrix",
  "perforer",
  "période",
  "permuter",
  "perplexe",
  "persil",
  "perte",
  "peser",
  "pétale",
  "petit",
  "pétrir",
  "peuple",
  "pharaon",
  "phobie",
  "phoque",
  "photon",
  "phrase",
  "physique",
  "piano",
  "pictural",
  "pièce",
  "pierre",
  "pieuvre",
  "pilote",
  "pinceau",
  "pipette",
  "piquer",
  "pirogue",
  "piscine",
  "piston",
  "pivoter",
  "pixel",
  "pizza",
  "placard",
  "plafond",
  "plaisir",
  "planer",
  "plaque",
  "plastron",
  "plateau",
  "pleurer",
  "plexus",
  "pliage",
  "plomb",
  "plonger",
  "pluie",
  "plumage",
  "pochette",
  "poésie",
  "poète",
  "pointe",
  "poirier",
  "poisson",
  "poivre",
  "polaire",
  "policier",
  "pollen",
  "polygone",
  "pommade",
  "pompier",
  "ponctuel",
  "pondérer",
  "poney",
  "portique",
  "position",
  "posséder",
  "posture",
  "potager",
  "poteau",
  "potion",
  "pouce",
  "poulain",
  "poumon",
  "pourpre",
  "poussin",
  "pouvoir",
  "prairie",
  "pratique",
  "précieux",
  "prédire",
  "préfixe",
  "prélude",
  "prénom",
  "présence",
  "prétexte",
  "prévoir",
  "primitif",
  "prince",
  "prison",
  "priver",
  "problème",
  "procéder",
  "prodige",
  "profond",
  "progrès",
  "proie",
  "projeter",
  "prologue",
  "promener",
  "propre",
  "prospère",
  "protéger",
  "prouesse",
  "proverbe",
  "prudence",
  "pruneau",
  "psychose",
  "public",
  "puceron",
  "puiser",
  "pulpe",
  "pulsar",
  "punaise",
  "punitif",
  "pupitre",
  "purifier",
  "puzzle",
  "pyramide",
  "quasar",
  "querelle",
  "question",
  "quiétude",
  "quitter",
  "quotient",
  "racine",
  "raconter",
  "radieux",
  "ragondin",
  "raideur",
  "raisin",
  "ralentir",
  "rallonge",
  "ramasser",
  "rapide",
  "rasage",
  "ratisser",
  "ravager",
  "ravin",
  "rayonner",
  "réactif",
  "réagir",
  "réaliser",
  "réanimer",
  "recevoir",
  "réciter",
  "réclamer",
  "récolter",
  "recruter",
  "reculer",
  "recycler",
  "rédiger",
  "redouter",
  "refaire",
  "réflexe",
  "réformer",
  "refrain",
  "refuge",
  "régalien",
  "région",
  "réglage",
  "régulier",
  "réitérer",
  "rejeter",
  "rejouer",
  "relatif",
  "relever",
  "relief",
  "remarque",
  "remède",
  "remise",
  "remonter",
  "remplir",
  "remuer",
  "renard",
  "renfort",
  "renifler",
  "renoncer",
  "rentrer",
  "renvoi",
  "replier",
  "reporter",
  "reprise",
  "reptile",
  "requin",
  "réserve",
  "résineux",
  "résoudre",
  "respect",
  "rester",
  "résultat",
  "rétablir",
  "retenir",
  "réticule",
  "retomber",
  "retracer",
  "réunion",
  "réussir",
  "revanche",
  "revivre",
  "révolte",
  "révulsif",
  "richesse",
  "rideau",
  "rieur",
  "rigide",
  "rigoler",
  "rincer",
  "riposter",
  "risible",
  "risque",
  "rituel",
  "rival",
  "rivière",
  "rocheux",
  "romance",
  "rompre",
  "ronce",
  "rondin",
  "roseau",
  "rosier",
  "rotatif",
  "rotor",
  "rotule",
  "rouge",
  "rouille",
  "rouleau",
  "routine",
  "royaume",
  "ruban",
  "rubis",
  "ruche",
  "ruelle",
  "rugueux",
  "ruiner",
  "ruisseau",
  "ruser",
  "rustique",
  "rythme",
  "sabler",
  "saboter",
  "sabre",
  "sacoche",
  "safari",
  "sagesse",
  "saisir",
  "salade",
  "salive",
  "salon",
  "saluer",
  "samedi",
  "sanction",
  "sanglier",
  "sarcasme",
  "sardine",
  "saturer",
  "saugrenu",
  "saumon",
  "sauter",
  "sauvage",
  "savant",
  "savonner",
  "scalpel",
  "scandale",
  "scélérat",
  "scénario",
  "sceptre",
  "schéma",
  "science",
  "scinder",
  "score",
  "scrutin",
  "sculpter",
  "séance",
  "sécable",
  "sécher",
  "secouer",
  "sécréter",
  "sédatif",
  "séduire",
  "seigneur",
  "séjour",
  "sélectif",
  "semaine",
  "sembler",
  "semence",
  "séminal",
  "sénateur",
  "sensible",
  "sentence",
  "séparer",
  "séquence",
  "serein",
  "sergent",
  "sérieux",
  "serrure",
  "sérum",
  "service",
  "sésame",
  "sévir",
  "sevrage",
  "sextuple",
  "sidéral",
  "siècle",
  "siéger",
  "siffler",
  "sigle",
  "signal",
  "silence",
  "silicium",
  "simple",
  "sincère",
  "sinistre",
  "siphon",
  "sirop",
  "sismique",
  "situer",
  "skier",
  "social",
  "socle",
  "sodium",
  "soigneux",
  "soldat",
  "soleil",
  "solitude",
  "soluble",
  "sombre",
  "sommeil",
  "somnoler",
  "sonde",
  "songeur",
  "sonnette",
  "sonore",
  "sorcier",
  "sortir",
  "sosie",
  "sottise",
  "soucieux",
  "soudure",
  "souffle",
  "soulever",
  "soupape",
  "source",
  "soutirer",
  "souvenir",
  "spacieux",
  "spatial",
  "spécial",
  "sphère",
  "spiral",
  "stable",
  "station",
  "sternum",
  "stimulus",
  "stipuler",
  "strict",
  "studieux",
  "stupeur",
  "styliste",
  "sublime",
  "substrat",
  "subtil",
  "subvenir",
  "succès",
  "sucre",
  "suffixe",
  "suggérer",
  "suiveur",
  "sulfate",
  "superbe",
  "supplier",
  "surface",
  "suricate",
  "surmener",
  "surprise",
  "sursaut",
  "survie",
  "suspect",
  "syllabe",
  "symbole",
  "symétrie",
  "synapse",
  "syntaxe",
  "système",
  "tabac",
  "tablier",
  "tactile",
  "tailler",
  "talent",
  "talisman",
  "talonner",
  "tambour",
  "tamiser",
  "tangible",
  "tapis",
  "taquiner",
  "tarder",
  "tarif",
  "tartine",
  "tasse",
  "tatami",
  "tatouage",
  "taupe",
  "taureau",
  "taxer",
  "témoin",
  "temporel",
  "tenaille",
  "tendre",
  "teneur",
  "tenir",
  "tension",
  "terminer",
  "terne",
  "terrible",
  "tétine",
  "texte",
  "thème",
  "théorie",
  "thérapie",
  "thorax",
  "tibia",
  "tiède",
  "timide",
  "tirelire",
  "tiroir",
  "tissu",
  "titane",
  "titre",
  "tituber",
  "toboggan",
  "tolérant",
  "tomate",
  "tonique",
  "tonneau",
  "toponyme",
  "torche",
  "tordre",
  "tornade",
  "torpille",
  "torrent",
  "torse",
  "tortue",
  "totem",
  "toucher",
  "tournage",
  "tousser",
  "toxine",
  "traction",
  "trafic",
  "tragique",
  "trahir",
  "train",
  "trancher",
  "travail",
  "trèfle",
  "tremper",
  "trésor",
  "treuil",
  "triage",
  "tribunal",
  "tricoter",
  "trilogie",
  "triomphe",
  "tripler",
  "triturer",
  "trivial",
  "trombone",
  "tronc",
  "tropical",
  "troupeau",
  "tuile",
  "tulipe",
  "tumulte",
  "tunnel",
  "turbine",
  "tuteur",
  "tutoyer",
  "tuyau",
  "tympan",
  "typhon",
  "typique",
  "tyran",
  "ubuesque",
  "ultime",
  "ultrason",
  "unanime",
  "unifier",
  "union",
  "unique",
  "unitaire",
  "univers",
  "uranium",
  "urbain",
  "urticant",
  "usage",
  "usine",
  "usuel",
  "usure",
  "utile",
  "utopie",
  "vacarme",
  "vaccin",
  "vagabond",
  "vague",
  "vaillant",
  "vaincre",
  "vaisseau",
  "valable",
  "valise",
  "vallon",
  "valve",
  "vampire",
  "vanille",
  "vapeur",
  "varier",
  "vaseux",
  "vassal",
  "vaste",
  "vecteur",
  "vedette",
  "végétal",
  "véhicule",
  "veinard",
  "véloce",
  "vendredi",
  "vénérer",
  "venger",
  "venimeux",
  "ventouse",
  "verdure",
  "vérin",
  "vernir",
  "verrou",
  "verser",
  "vertu",
  "veston",
  "vétéran",
  "vétuste",
  "vexant",
  "vexer",
  "viaduc",
  "viande",
  "victoire",
  "vidange",
  "vidéo",
  "vignette",
  "vigueur",
  "vilain",
  "village",
  "vinaigre",
  "violon",
  "vipère",
  "virement",
  "virtuose",
  "virus",
  "visage",
  "viseur",
  "vision",
  "visqueux",
  "visuel",
  "vital",
  "vitesse",
  "viticole",
  "vitrine",
  "vivace",
  "vivipare",
  "vocation",
  "voguer",
  "voile",
  "voisin",
  "voiture",
  "volaille",
  "volcan",
  "voltiger",
  "volume",
  "vorace",
  "vortex",
  "voter",
  "vouloir",
  "voyage",
  "voyelle",
  "wagon",
  "xénon",
  "yacht",
  "zèbre",
  "zénith",
  "zeste",
  "zoologie"
]

},{}],21:[function(require,module,exports){
module.exports=[
  "abaco",
  "abbaglio",
  "abbinato",
  "abete",
  "abisso",
  "abolire",
  "abrasivo",
  "abrogato",
  "accadere",
  "accenno",
  "accusato",
  "acetone",
  "achille",
  "acido",
  "acqua",
  "acre",
  "acrilico",
  "acrobata",
  "acuto",
  "adagio",
  "addebito",
  "addome",
  "adeguato",
  "aderire",
  "adipe",
  "adottare",
  "adulare",
  "affabile",
  "affetto",
  "affisso",
  "affranto",
  "aforisma",
  "afoso",
  "africano",
  "agave",
  "agente",
  "agevole",
  "aggancio",
  "agire",
  "agitare",
  "agonismo",
  "agricolo",
  "agrumeto",
  "aguzzo",
  "alabarda",
  "alato",
  "albatro",
  "alberato",
  "albo",
  "albume",
  "alce",
  "alcolico",
  "alettone",
  "alfa",
  "algebra",
  "aliante",
  "alibi",
  "alimento",
  "allagato",
  "allegro",
  "allievo",
  "allodola",
  "allusivo",
  "almeno",
  "alogeno",
  "alpaca",
  "alpestre",
  "altalena",
  "alterno",
  "alticcio",
  "altrove",
  "alunno",
  "alveolo",
  "alzare",
  "amalgama",
  "amanita",
  "amarena",
  "ambito",
  "ambrato",
  "ameba",
  "america",
  "ametista",
  "amico",
  "ammasso",
  "ammenda",
  "ammirare",
  "ammonito",
  "amore",
  "ampio",
  "ampliare",
  "amuleto",
  "anacardo",
  "anagrafe",
  "analista",
  "anarchia",
  "anatra",
  "anca",
  "ancella",
  "ancora",
  "andare",
  "andrea",
  "anello",
  "angelo",
  "angolare",
  "angusto",
  "anima",
  "annegare",
  "annidato",
  "anno",
  "annuncio",
  "anonimo",
  "anticipo",
  "anzi",
  "apatico",
  "apertura",
  "apode",
  "apparire",
  "appetito",
  "appoggio",
  "approdo",
  "appunto",
  "aprile",
  "arabica",
  "arachide",
  "aragosta",
  "araldica",
  "arancio",
  "aratura",
  "arazzo",
  "arbitro",
  "archivio",
  "ardito",
  "arenile",
  "argento",
  "argine",
  "arguto",
  "aria",
  "armonia",
  "arnese",
  "arredato",
  "arringa",
  "arrosto",
  "arsenico",
  "arso",
  "artefice",
  "arzillo",
  "asciutto",
  "ascolto",
  "asepsi",
  "asettico",
  "asfalto",
  "asino",
  "asola",
  "aspirato",
  "aspro",
  "assaggio",
  "asse",
  "assoluto",
  "assurdo",
  "asta",
  "astenuto",
  "astice",
  "astratto",
  "atavico",
  "ateismo",
  "atomico",
  "atono",
  "attesa",
  "attivare",
  "attorno",
  "attrito",
  "attuale",
  "ausilio",
  "austria",
  "autista",
  "autonomo",
  "autunno",
  "avanzato",
  "avere",
  "avvenire",
  "avviso",
  "avvolgere",
  "azione",
  "azoto",
  "azzimo",
  "azzurro",
  "babele",
  "baccano",
  "bacino",
  "baco",
  "badessa",
  "badilata",
  "bagnato",
  "baita",
  "balcone",
  "baldo",
  "balena",
  "ballata",
  "balzano",
  "bambino",
  "bandire",
  "baraonda",
  "barbaro",
  "barca",
  "baritono",
  "barlume",
  "barocco",
  "basilico",
  "basso",
  "batosta",
  "battuto",
  "baule",
  "bava",
  "bavosa",
  "becco",
  "beffa",
  "belgio",
  "belva",
  "benda",
  "benevole",
  "benigno",
  "benzina",
  "bere",
  "berlina",
  "beta",
  "bibita",
  "bici",
  "bidone",
  "bifido",
  "biga",
  "bilancia",
  "bimbo",
  "binocolo",
  "biologo",
  "bipede",
  "bipolare",
  "birbante",
  "birra",
  "biscotto",
  "bisesto",
  "bisnonno",
  "bisonte",
  "bisturi",
  "bizzarro",
  "blando",
  "blatta",
  "bollito",
  "bonifico",
  "bordo",
  "bosco",
  "botanico",
  "bottino",
  "bozzolo",
  "braccio",
  "bradipo",
  "brama",
  "branca",
  "bravura",
  "bretella",
  "brevetto",
  "brezza",
  "briglia",
  "brillante",
  "brindare",
  "broccolo",
  "brodo",
  "bronzina",
  "brullo",
  "bruno",
  "bubbone",
  "buca",
  "budino",
  "buffone",
  "buio",
  "bulbo",
  "buono",
  "burlone",
  "burrasca",
  "bussola",
  "busta",
  "cadetto",
  "caduco",
  "calamaro",
  "calcolo",
  "calesse",
  "calibro",
  "calmo",
  "caloria",
  "cambusa",
  "camerata",
  "camicia",
  "cammino",
  "camola",
  "campale",
  "canapa",
  "candela",
  "cane",
  "canino",
  "canotto",
  "cantina",
  "capace",
  "capello",
  "capitolo",
  "capogiro",
  "cappero",
  "capra",
  "capsula",
  "carapace",
  "carcassa",
  "cardo",
  "carisma",
  "carovana",
  "carretto",
  "cartolina",
  "casaccio",
  "cascata",
  "caserma",
  "caso",
  "cassone",
  "castello",
  "casuale",
  "catasta",
  "catena",
  "catrame",
  "cauto",
  "cavillo",
  "cedibile",
  "cedrata",
  "cefalo",
  "celebre",
  "cellulare",
  "cena",
  "cenone",
  "centesimo",
  "ceramica",
  "cercare",
  "certo",
  "cerume",
  "cervello",
  "cesoia",
  "cespo",
  "ceto",
  "chela",
  "chiaro",
  "chicca",
  "chiedere",
  "chimera",
  "china",
  "chirurgo",
  "chitarra",
  "ciao",
  "ciclismo",
  "cifrare",
  "cigno",
  "cilindro",
  "ciottolo",
  "circa",
  "cirrosi",
  "citrico",
  "cittadino",
  "ciuffo",
  "civetta",
  "civile",
  "classico",
  "clinica",
  "cloro",
  "cocco",
  "codardo",
  "codice",
  "coerente",
  "cognome",
  "collare",
  "colmato",
  "colore",
  "colposo",
  "coltivato",
  "colza",
  "coma",
  "cometa",
  "commando",
  "comodo",
  "computer",
  "comune",
  "conciso",
  "condurre",
  "conferma",
  "congelare",
  "coniuge",
  "connesso",
  "conoscere",
  "consumo",
  "continuo",
  "convegno",
  "coperto",
  "copione",
  "coppia",
  "copricapo",
  "corazza",
  "cordata",
  "coricato",
  "cornice",
  "corolla",
  "corpo",
  "corredo",
  "corsia",
  "cortese",
  "cosmico",
  "costante",
  "cottura",
  "covato",
  "cratere",
  "cravatta",
  "creato",
  "credere",
  "cremoso",
  "crescita",
  "creta",
  "criceto",
  "crinale",
  "crisi",
  "critico",
  "croce",
  "cronaca",
  "crostata",
  "cruciale",
  "crusca",
  "cucire",
  "cuculo",
  "cugino",
  "cullato",
  "cupola",
  "curatore",
  "cursore",
  "curvo",
  "cuscino",
  "custode",
  "dado",
  "daino",
  "dalmata",
  "damerino",
  "daniela",
  "dannoso",
  "danzare",
  "datato",
  "davanti",
  "davvero",
  "debutto",
  "decennio",
  "deciso",
  "declino",
  "decollo",
  "decreto",
  "dedicato",
  "definito",
  "deforme",
  "degno",
  "delegare",
  "delfino",
  "delirio",
  "delta",
  "demenza",
  "denotato",
  "dentro",
  "deposito",
  "derapata",
  "derivare",
  "deroga",
  "descritto",
  "deserto",
  "desiderio",
  "desumere",
  "detersivo",
  "devoto",
  "diametro",
  "dicembre",
  "diedro",
  "difeso",
  "diffuso",
  "digerire",
  "digitale",
  "diluvio",
  "dinamico",
  "dinnanzi",
  "dipinto",
  "diploma",
  "dipolo",
  "diradare",
  "dire",
  "dirotto",
  "dirupo",
  "disagio",
  "discreto",
  "disfare",
  "disgelo",
  "disposto",
  "distanza",
  "disumano",
  "dito",
  "divano",
  "divelto",
  "dividere",
  "divorato",
  "doblone",
  "docente",
  "doganale",
  "dogma",
  "dolce",
  "domato",
  "domenica",
  "dominare",
  "dondolo",
  "dono",
  "dormire",
  "dote",
  "dottore",
  "dovuto",
  "dozzina",
  "drago",
  "druido",
  "dubbio",
  "dubitare",
  "ducale",
  "duna",
  "duomo",
  "duplice",
  "duraturo",
  "ebano",
  "eccesso",
  "ecco",
  "eclissi",
  "economia",
  "edera",
  "edicola",
  "edile",
  "editoria",
  "educare",
  "egemonia",
  "egli",
  "egoismo",
  "egregio",
  "elaborato",
  "elargire",
  "elegante",
  "elencato",
  "eletto",
  "elevare",
  "elfico",
  "elica",
  "elmo",
  "elsa",
  "eluso",
  "emanato",
  "emblema",
  "emesso",
  "emiro",
  "emotivo",
  "emozione",
  "empirico",
  "emulo",
  "endemico",
  "enduro",
  "energia",
  "enfasi",
  "enoteca",
  "entrare",
  "enzima",
  "epatite",
  "epilogo",
  "episodio",
  "epocale",
  "eppure",
  "equatore",
  "erario",
  "erba",
  "erboso",
  "erede",
  "eremita",
  "erigere",
  "ermetico",
  "eroe",
  "erosivo",
  "errante",
  "esagono",
  "esame",
  "esanime",
  "esaudire",
  "esca",
  "esempio",
  "esercito",
  "esibito",
  "esigente",
  "esistere",
  "esito",
  "esofago",
  "esortato",
  "esoso",
  "espanso",
  "espresso",
  "essenza",
  "esso",
  "esteso",
  "estimare",
  "estonia",
  "estroso",
  "esultare",
  "etilico",
  "etnico",
  "etrusco",
  "etto",
  "euclideo",
  "europa",
  "evaso",
  "evidenza",
  "evitato",
  "evoluto",
  "evviva",
  "fabbrica",
  "faccenda",
  "fachiro",
  "falco",
  "famiglia",
  "fanale",
  "fanfara",
  "fango",
  "fantasma",
  "fare",
  "farfalla",
  "farinoso",
  "farmaco",
  "fascia",
  "fastoso",
  "fasullo",
  "faticare",
  "fato",
  "favoloso",
  "febbre",
  "fecola",
  "fede",
  "fegato",
  "felpa",
  "feltro",
  "femmina",
  "fendere",
  "fenomeno",
  "fermento",
  "ferro",
  "fertile",
  "fessura",
  "festivo",
  "fetta",
  "feudo",
  "fiaba",
  "fiducia",
  "fifa",
  "figurato",
  "filo",
  "finanza",
  "finestra",
  "finire",
  "fiore",
  "fiscale",
  "fisico",
  "fiume",
  "flacone",
  "flamenco",
  "flebo",
  "flemma",
  "florido",
  "fluente",
  "fluoro",
  "fobico",
  "focaccia",
  "focoso",
  "foderato",
  "foglio",
  "folata",
  "folclore",
  "folgore",
  "fondente",
  "fonetico",
  "fonia",
  "fontana",
  "forbito",
  "forchetta",
  "foresta",
  "formica",
  "fornaio",
  "foro",
  "fortezza",
  "forzare",
  "fosfato",
  "fosso",
  "fracasso",
  "frana",
  "frassino",
  "fratello",
  "freccetta",
  "frenata",
  "fresco",
  "frigo",
  "frollino",
  "fronde",
  "frugale",
  "frutta",
  "fucilata",
  "fucsia",
  "fuggente",
  "fulmine",
  "fulvo",
  "fumante",
  "fumetto",
  "fumoso",
  "fune",
  "funzione",
  "fuoco",
  "furbo",
  "furgone",
  "furore",
  "fuso",
  "futile",
  "gabbiano",
  "gaffe",
  "galateo",
  "gallina",
  "galoppo",
  "gambero",
  "gamma",
  "garanzia",
  "garbo",
  "garofano",
  "garzone",
  "gasdotto",
  "gasolio",
  "gastrico",
  "gatto",
  "gaudio",
  "gazebo",
  "gazzella",
  "geco",
  "gelatina",
  "gelso",
  "gemello",
  "gemmato",
  "gene",
  "genitore",
  "gennaio",
  "genotipo",
  "gergo",
  "ghepardo",
  "ghiaccio",
  "ghisa",
  "giallo",
  "gilda",
  "ginepro",
  "giocare",
  "gioiello",
  "giorno",
  "giove",
  "girato",
  "girone",
  "gittata",
  "giudizio",
  "giurato",
  "giusto",
  "globulo",
  "glutine",
  "gnomo",
  "gobba",
  "golf",
  "gomito",
  "gommone",
  "gonfio",
  "gonna",
  "governo",
  "gracile",
  "grado",
  "grafico",
  "grammo",
  "grande",
  "grattare",
  "gravoso",
  "grazia",
  "greca",
  "gregge",
  "grifone",
  "grigio",
  "grinza",
  "grotta",
  "gruppo",
  "guadagno",
  "guaio",
  "guanto",
  "guardare",
  "gufo",
  "guidare",
  "ibernato",
  "icona",
  "identico",
  "idillio",
  "idolo",
  "idra",
  "idrico",
  "idrogeno",
  "igiene",
  "ignaro",
  "ignorato",
  "ilare",
  "illeso",
  "illogico",
  "illudere",
  "imballo",
  "imbevuto",
  "imbocco",
  "imbuto",
  "immane",
  "immerso",
  "immolato",
  "impacco",
  "impeto",
  "impiego",
  "importo",
  "impronta",
  "inalare",
  "inarcare",
  "inattivo",
  "incanto",
  "incendio",
  "inchino",
  "incisivo",
  "incluso",
  "incontro",
  "incrocio",
  "incubo",
  "indagine",
  "india",
  "indole",
  "inedito",
  "infatti",
  "infilare",
  "inflitto",
  "ingaggio",
  "ingegno",
  "inglese",
  "ingordo",
  "ingrosso",
  "innesco",
  "inodore",
  "inoltrare",
  "inondato",
  "insano",
  "insetto",
  "insieme",
  "insonnia",
  "insulina",
  "intasato",
  "intero",
  "intonaco",
  "intuito",
  "inumidire",
  "invalido",
  "invece",
  "invito",
  "iperbole",
  "ipnotico",
  "ipotesi",
  "ippica",
  "iride",
  "irlanda",
  "ironico",
  "irrigato",
  "irrorare",
  "isolato",
  "isotopo",
  "isterico",
  "istituto",
  "istrice",
  "italia",
  "iterare",
  "labbro",
  "labirinto",
  "lacca",
  "lacerato",
  "lacrima",
  "lacuna",
  "laddove",
  "lago",
  "lampo",
  "lancetta",
  "lanterna",
  "lardoso",
  "larga",
  "laringe",
  "lastra",
  "latenza",
  "latino",
  "lattuga",
  "lavagna",
  "lavoro",
  "legale",
  "leggero",
  "lembo",
  "lentezza",
  "lenza",
  "leone",
  "lepre",
  "lesivo",
  "lessato",
  "lesto",
  "letterale",
  "leva",
  "levigato",
  "libero",
  "lido",
  "lievito",
  "lilla",
  "limatura",
  "limitare",
  "limpido",
  "lineare",
  "lingua",
  "liquido",
  "lira",
  "lirica",
  "lisca",
  "lite",
  "litigio",
  "livrea",
  "locanda",
  "lode",
  "logica",
  "lombare",
  "londra",
  "longevo",
  "loquace",
  "lorenzo",
  "loto",
  "lotteria",
  "luce",
  "lucidato",
  "lumaca",
  "luminoso",
  "lungo",
  "lupo",
  "luppolo",
  "lusinga",
  "lusso",
  "lutto",
  "macabro",
  "macchina",
  "macero",
  "macinato",
  "madama",
  "magico",
  "maglia",
  "magnete",
  "magro",
  "maiolica",
  "malafede",
  "malgrado",
  "malinteso",
  "malsano",
  "malto",
  "malumore",
  "mana",
  "mancia",
  "mandorla",
  "mangiare",
  "manifesto",
  "mannaro",
  "manovra",
  "mansarda",
  "mantide",
  "manubrio",
  "mappa",
  "maratona",
  "marcire",
  "maretta",
  "marmo",
  "marsupio",
  "maschera",
  "massaia",
  "mastino",
  "materasso",
  "matricola",
  "mattone",
  "maturo",
  "mazurca",
  "meandro",
  "meccanico",
  "mecenate",
  "medesimo",
  "meditare",
  "mega",
  "melassa",
  "melis",
  "melodia",
  "meninge",
  "meno",
  "mensola",
  "mercurio",
  "merenda",
  "merlo",
  "meschino",
  "mese",
  "messere",
  "mestolo",
  "metallo",
  "metodo",
  "mettere",
  "miagolare",
  "mica",
  "micelio",
  "michele",
  "microbo",
  "midollo",
  "miele",
  "migliore",
  "milano",
  "milite",
  "mimosa",
  "minerale",
  "mini",
  "minore",
  "mirino",
  "mirtillo",
  "miscela",
  "missiva",
  "misto",
  "misurare",
  "mitezza",
  "mitigare",
  "mitra",
  "mittente",
  "mnemonico",
  "modello",
  "modifica",
  "modulo",
  "mogano",
  "mogio",
  "mole",
  "molosso",
  "monastero",
  "monco",
  "mondina",
  "monetario",
  "monile",
  "monotono",
  "monsone",
  "montato",
  "monviso",
  "mora",
  "mordere",
  "morsicato",
  "mostro",
  "motivato",
  "motosega",
  "motto",
  "movenza",
  "movimento",
  "mozzo",
  "mucca",
  "mucosa",
  "muffa",
  "mughetto",
  "mugnaio",
  "mulatto",
  "mulinello",
  "multiplo",
  "mummia",
  "munto",
  "muovere",
  "murale",
  "musa",
  "muscolo",
  "musica",
  "mutevole",
  "muto",
  "nababbo",
  "nafta",
  "nanometro",
  "narciso",
  "narice",
  "narrato",
  "nascere",
  "nastrare",
  "naturale",
  "nautica",
  "naviglio",
  "nebulosa",
  "necrosi",
  "negativo",
  "negozio",
  "nemmeno",
  "neofita",
  "neretto",
  "nervo",
  "nessuno",
  "nettuno",
  "neutrale",
  "neve",
  "nevrotico",
  "nicchia",
  "ninfa",
  "nitido",
  "nobile",
  "nocivo",
  "nodo",
  "nome",
  "nomina",
  "nordico",
  "normale",
  "norvegese",
  "nostrano",
  "notare",
  "notizia",
  "notturno",
  "novella",
  "nucleo",
  "nulla",
  "numero",
  "nuovo",
  "nutrire",
  "nuvola",
  "nuziale",
  "oasi",
  "obbedire",
  "obbligo",
  "obelisco",
  "oblio",
  "obolo",
  "obsoleto",
  "occasione",
  "occhio",
  "occidente",
  "occorrere",
  "occultare",
  "ocra",
  "oculato",
  "odierno",
  "odorare",
  "offerta",
  "offrire",
  "offuscato",
  "oggetto",
  "oggi",
  "ognuno",
  "olandese",
  "olfatto",
  "oliato",
  "oliva",
  "ologramma",
  "oltre",
  "omaggio",
  "ombelico",
  "ombra",
  "omega",
  "omissione",
  "ondoso",
  "onere",
  "onice",
  "onnivoro",
  "onorevole",
  "onta",
  "operato",
  "opinione",
  "opposto",
  "oracolo",
  "orafo",
  "ordine",
  "orecchino",
  "orefice",
  "orfano",
  "organico",
  "origine",
  "orizzonte",
  "orma",
  "ormeggio",
  "ornativo",
  "orologio",
  "orrendo",
  "orribile",
  "ortensia",
  "ortica",
  "orzata",
  "orzo",
  "osare",
  "oscurare",
  "osmosi",
  "ospedale",
  "ospite",
  "ossa",
  "ossidare",
  "ostacolo",
  "oste",
  "otite",
  "otre",
  "ottagono",
  "ottimo",
  "ottobre",
  "ovale",
  "ovest",
  "ovino",
  "oviparo",
  "ovocito",
  "ovunque",
  "ovviare",
  "ozio",
  "pacchetto",
  "pace",
  "pacifico",
  "padella",
  "padrone",
  "paese",
  "paga",
  "pagina",
  "palazzina",
  "palesare",
  "pallido",
  "palo",
  "palude",
  "pandoro",
  "pannello",
  "paolo",
  "paonazzo",
  "paprica",
  "parabola",
  "parcella",
  "parere",
  "pargolo",
  "pari",
  "parlato",
  "parola",
  "partire",
  "parvenza",
  "parziale",
  "passivo",
  "pasticca",
  "patacca",
  "patologia",
  "pattume",
  "pavone",
  "peccato",
  "pedalare",
  "pedonale",
  "peggio",
  "peloso",
  "penare",
  "pendice",
  "penisola",
  "pennuto",
  "penombra",
  "pensare",
  "pentola",
  "pepe",
  "pepita",
  "perbene",
  "percorso",
  "perdonato",
  "perforare",
  "pergamena",
  "periodo",
  "permesso",
  "perno",
  "perplesso",
  "persuaso",
  "pertugio",
  "pervaso",
  "pesatore",
  "pesista",
  "peso",
  "pestifero",
  "petalo",
  "pettine",
  "petulante",
  "pezzo",
  "piacere",
  "pianta",
  "piattino",
  "piccino",
  "picozza",
  "piega",
  "pietra",
  "piffero",
  "pigiama",
  "pigolio",
  "pigro",
  "pila",
  "pilifero",
  "pillola",
  "pilota",
  "pimpante",
  "pineta",
  "pinna",
  "pinolo",
  "pioggia",
  "piombo",
  "piramide",
  "piretico",
  "pirite",
  "pirolisi",
  "pitone",
  "pizzico",
  "placebo",
  "planare",
  "plasma",
  "platano",
  "plenario",
  "pochezza",
  "poderoso",
  "podismo",
  "poesia",
  "poggiare",
  "polenta",
  "poligono",
  "pollice",
  "polmonite",
  "polpetta",
  "polso",
  "poltrona",
  "polvere",
  "pomice",
  "pomodoro",
  "ponte",
  "popoloso",
  "porfido",
  "poroso",
  "porpora",
  "porre",
  "portata",
  "posa",
  "positivo",
  "possesso",
  "postulato",
  "potassio",
  "potere",
  "pranzo",
  "prassi",
  "pratica",
  "precluso",
  "predica",
  "prefisso",
  "pregiato",
  "prelievo",
  "premere",
  "prenotare",
  "preparato",
  "presenza",
  "pretesto",
  "prevalso",
  "prima",
  "principe",
  "privato",
  "problema",
  "procura",
  "produrre",
  "profumo",
  "progetto",
  "prolunga",
  "promessa",
  "pronome",
  "proposta",
  "proroga",
  "proteso",
  "prova",
  "prudente",
  "prugna",
  "prurito",
  "psiche",
  "pubblico",
  "pudica",
  "pugilato",
  "pugno",
  "pulce",
  "pulito",
  "pulsante",
  "puntare",
  "pupazzo",
  "pupilla",
  "puro",
  "quadro",
  "qualcosa",
  "quasi",
  "querela",
  "quota",
  "raccolto",
  "raddoppio",
  "radicale",
  "radunato",
  "raffica",
  "ragazzo",
  "ragione",
  "ragno",
  "ramarro",
  "ramingo",
  "ramo",
  "randagio",
  "rantolare",
  "rapato",
  "rapina",
  "rappreso",
  "rasatura",
  "raschiato",
  "rasente",
  "rassegna",
  "rastrello",
  "rata",
  "ravveduto",
  "reale",
  "recepire",
  "recinto",
  "recluta",
  "recondito",
  "recupero",
  "reddito",
  "redimere",
  "regalato",
  "registro",
  "regola",
  "regresso",
  "relazione",
  "remare",
  "remoto",
  "renna",
  "replica",
  "reprimere",
  "reputare",
  "resa",
  "residente",
  "responso",
  "restauro",
  "rete",
  "retina",
  "retorica",
  "rettifica",
  "revocato",
  "riassunto",
  "ribadire",
  "ribelle",
  "ribrezzo",
  "ricarica",
  "ricco",
  "ricevere",
  "riciclato",
  "ricordo",
  "ricreduto",
  "ridicolo",
  "ridurre",
  "rifasare",
  "riflesso",
  "riforma",
  "rifugio",
  "rigare",
  "rigettato",
  "righello",
  "rilassato",
  "rilevato",
  "rimanere",
  "rimbalzo",
  "rimedio",
  "rimorchio",
  "rinascita",
  "rincaro",
  "rinforzo",
  "rinnovo",
  "rinomato",
  "rinsavito",
  "rintocco",
  "rinuncia",
  "rinvenire",
  "riparato",
  "ripetuto",
  "ripieno",
  "riportare",
  "ripresa",
  "ripulire",
  "risata",
  "rischio",
  "riserva",
  "risibile",
  "riso",
  "rispetto",
  "ristoro",
  "risultato",
  "risvolto",
  "ritardo",
  "ritegno",
  "ritmico",
  "ritrovo",
  "riunione",
  "riva",
  "riverso",
  "rivincita",
  "rivolto",
  "rizoma",
  "roba",
  "robotico",
  "robusto",
  "roccia",
  "roco",
  "rodaggio",
  "rodere",
  "roditore",
  "rogito",
  "rollio",
  "romantico",
  "rompere",
  "ronzio",
  "rosolare",
  "rospo",
  "rotante",
  "rotondo",
  "rotula",
  "rovescio",
  "rubizzo",
  "rubrica",
  "ruga",
  "rullino",
  "rumine",
  "rumoroso",
  "ruolo",
  "rupe",
  "russare",
  "rustico",
  "sabato",
  "sabbiare",
  "sabotato",
  "sagoma",
  "salasso",
  "saldatura",
  "salgemma",
  "salivare",
  "salmone",
  "salone",
  "saltare",
  "saluto",
  "salvo",
  "sapere",
  "sapido",
  "saporito",
  "saraceno",
  "sarcasmo",
  "sarto",
  "sassoso",
  "satellite",
  "satira",
  "satollo",
  "saturno",
  "savana",
  "savio",
  "saziato",
  "sbadiglio",
  "sbalzo",
  "sbancato",
  "sbarra",
  "sbattere",
  "sbavare",
  "sbendare",
  "sbirciare",
  "sbloccato",
  "sbocciato",
  "sbrinare",
  "sbruffone",
  "sbuffare",
  "scabroso",
  "scadenza",
  "scala",
  "scambiare",
  "scandalo",
  "scapola",
  "scarso",
  "scatenare",
  "scavato",
  "scelto",
  "scenico",
  "scettro",
  "scheda",
  "schiena",
  "sciarpa",
  "scienza",
  "scindere",
  "scippo",
  "sciroppo",
  "scivolo",
  "sclerare",
  "scodella",
  "scolpito",
  "scomparto",
  "sconforto",
  "scoprire",
  "scorta",
  "scossone",
  "scozzese",
  "scriba",
  "scrollare",
  "scrutinio",
  "scuderia",
  "scultore",
  "scuola",
  "scuro",
  "scusare",
  "sdebitare",
  "sdoganare",
  "seccatura",
  "secondo",
  "sedano",
  "seggiola",
  "segnalato",
  "segregato",
  "seguito",
  "selciato",
  "selettivo",
  "sella",
  "selvaggio",
  "semaforo",
  "sembrare",
  "seme",
  "seminato",
  "sempre",
  "senso",
  "sentire",
  "sepolto",
  "sequenza",
  "serata",
  "serbato",
  "sereno",
  "serio",
  "serpente",
  "serraglio",
  "servire",
  "sestina",
  "setola",
  "settimana",
  "sfacelo",
  "sfaldare",
  "sfamato",
  "sfarzoso",
  "sfaticato",
  "sfera",
  "sfida",
  "sfilato",
  "sfinge",
  "sfocato",
  "sfoderare",
  "sfogo",
  "sfoltire",
  "sforzato",
  "sfratto",
  "sfruttato",
  "sfuggito",
  "sfumare",
  "sfuso",
  "sgabello",
  "sgarbato",
  "sgonfiare",
  "sgorbio",
  "sgrassato",
  "sguardo",
  "sibilo",
  "siccome",
  "sierra",
  "sigla",
  "signore",
  "silenzio",
  "sillaba",
  "simbolo",
  "simpatico",
  "simulato",
  "sinfonia",
  "singolo",
  "sinistro",
  "sino",
  "sintesi",
  "sinusoide",
  "sipario",
  "sisma",
  "sistole",
  "situato",
  "slitta",
  "slogatura",
  "sloveno",
  "smarrito",
  "smemorato",
  "smentito",
  "smeraldo",
  "smilzo",
  "smontare",
  "smottato",
  "smussato",
  "snellire",
  "snervato",
  "snodo",
  "sobbalzo",
  "sobrio",
  "soccorso",
  "sociale",
  "sodale",
  "soffitto",
  "sogno",
  "soldato",
  "solenne",
  "solido",
  "sollazzo",
  "solo",
  "solubile",
  "solvente",
  "somatico",
  "somma",
  "sonda",
  "sonetto",
  "sonnifero",
  "sopire",
  "soppeso",
  "sopra",
  "sorgere",
  "sorpasso",
  "sorriso",
  "sorso",
  "sorteggio",
  "sorvolato",
  "sospiro",
  "sosta",
  "sottile",
  "spada",
  "spalla",
  "spargere",
  "spatola",
  "spavento",
  "spazzola",
  "specie",
  "spedire",
  "spegnere",
  "spelatura",
  "speranza",
  "spessore",
  "spettrale",
  "spezzato",
  "spia",
  "spigoloso",
  "spillato",
  "spinoso",
  "spirale",
  "splendido",
  "sportivo",
  "sposo",
  "spranga",
  "sprecare",
  "spronato",
  "spruzzo",
  "spuntino",
  "squillo",
  "sradicare",
  "srotolato",
  "stabile",
  "stacco",
  "staffa",
  "stagnare",
  "stampato",
  "stantio",
  "starnuto",
  "stasera",
  "statuto",
  "stelo",
  "steppa",
  "sterzo",
  "stiletto",
  "stima",
  "stirpe",
  "stivale",
  "stizzoso",
  "stonato",
  "storico",
  "strappo",
  "stregato",
  "stridulo",
  "strozzare",
  "strutto",
  "stuccare",
  "stufo",
  "stupendo",
  "subentro",
  "succoso",
  "sudore",
  "suggerito",
  "sugo",
  "sultano",
  "suonare",
  "superbo",
  "supporto",
  "surgelato",
  "surrogato",
  "sussurro",
  "sutura",
  "svagare",
  "svedese",
  "sveglio",
  "svelare",
  "svenuto",
  "svezia",
  "sviluppo",
  "svista",
  "svizzera",
  "svolta",
  "svuotare",
  "tabacco",
  "tabulato",
  "tacciare",
  "taciturno",
  "tale",
  "talismano",
  "tampone",
  "tannino",
  "tara",
  "tardivo",
  "targato",
  "tariffa",
  "tarpare",
  "tartaruga",
  "tasto",
  "tattico",
  "taverna",
  "tavolata",
  "tazza",
  "teca",
  "tecnico",
  "telefono",
  "temerario",
  "tempo",
  "temuto",
  "tendone",
  "tenero",
  "tensione",
  "tentacolo",
  "teorema",
  "terme",
  "terrazzo",
  "terzetto",
  "tesi",
  "tesserato",
  "testato",
  "tetro",
  "tettoia",
  "tifare",
  "tigella",
  "timbro",
  "tinto",
  "tipico",
  "tipografo",
  "tiraggio",
  "tiro",
  "titanio",
  "titolo",
  "titubante",
  "tizio",
  "tizzone",
  "toccare",
  "tollerare",
  "tolto",
  "tombola",
  "tomo",
  "tonfo",
  "tonsilla",
  "topazio",
  "topologia",
  "toppa",
  "torba",
  "tornare",
  "torrone",
  "tortora",
  "toscano",
  "tossire",
  "tostatura",
  "totano",
  "trabocco",
  "trachea",
  "trafila",
  "tragedia",
  "tralcio",
  "tramonto",
  "transito",
  "trapano",
  "trarre",
  "trasloco",
  "trattato",
  "trave",
  "treccia",
  "tremolio",
  "trespolo",
  "tributo",
  "tricheco",
  "trifoglio",
  "trillo",
  "trincea",
  "trio",
  "tristezza",
  "triturato",
  "trivella",
  "tromba",
  "trono",
  "troppo",
  "trottola",
  "trovare",
  "truccato",
  "tubatura",
  "tuffato",
  "tulipano",
  "tumulto",
  "tunisia",
  "turbare",
  "turchino",
  "tuta",
  "tutela",
  "ubicato",
  "uccello",
  "uccisore",
  "udire",
  "uditivo",
  "uffa",
  "ufficio",
  "uguale",
  "ulisse",
  "ultimato",
  "umano",
  "umile",
  "umorismo",
  "uncinetto",
  "ungere",
  "ungherese",
  "unicorno",
  "unificato",
  "unisono",
  "unitario",
  "unte",
  "uovo",
  "upupa",
  "uragano",
  "urgenza",
  "urlo",
  "usanza",
  "usato",
  "uscito",
  "usignolo",
  "usuraio",
  "utensile",
  "utilizzo",
  "utopia",
  "vacante",
  "vaccinato",
  "vagabondo",
  "vagliato",
  "valanga",
  "valgo",
  "valico",
  "valletta",
  "valoroso",
  "valutare",
  "valvola",
  "vampata",
  "vangare",
  "vanitoso",
  "vano",
  "vantaggio",
  "vanvera",
  "vapore",
  "varano",
  "varcato",
  "variante",
  "vasca",
  "vedetta",
  "vedova",
  "veduto",
  "vegetale",
  "veicolo",
  "velcro",
  "velina",
  "velluto",
  "veloce",
  "venato",
  "vendemmia",
  "vento",
  "verace",
  "verbale",
  "vergogna",
  "verifica",
  "vero",
  "verruca",
  "verticale",
  "vescica",
  "vessillo",
  "vestale",
  "veterano",
  "vetrina",
  "vetusto",
  "viandante",
  "vibrante",
  "vicenda",
  "vichingo",
  "vicinanza",
  "vidimare",
  "vigilia",
  "vigneto",
  "vigore",
  "vile",
  "villano",
  "vimini",
  "vincitore",
  "viola",
  "vipera",
  "virgola",
  "virologo",
  "virulento",
  "viscoso",
  "visione",
  "vispo",
  "vissuto",
  "visura",
  "vita",
  "vitello",
  "vittima",
  "vivanda",
  "vivido",
  "viziare",
  "voce",
  "voga",
  "volatile",
  "volere",
  "volpe",
  "voragine",
  "vulcano",
  "zampogna",
  "zanna",
  "zappato",
  "zattera",
  "zavorra",
  "zefiro",
  "zelante",
  "zelo",
  "zenzero",
  "zerbino",
  "zibetto",
  "zinco",
  "zircone",
  "zitto",
  "zolla",
  "zotico",
  "zucchero",
  "zufolo",
  "zulu",
  "zuppa"
]

},{}],22:[function(require,module,exports){
module.exports=[
  "あいこくしん",
  "あいさつ",
  "あいだ",
  "あおぞら",
  "あかちゃん",
  "あきる",
  "あけがた",
  "あける",
  "あこがれる",
  "あさい",
  "あさひ",
  "あしあと",
  "あじわう",
  "あずかる",
  "あずき",
  "あそぶ",
  "あたえる",
  "あたためる",
  "あたりまえ",
  "あたる",
  "あつい",
  "あつかう",
  "あっしゅく",
  "あつまり",
  "あつめる",
  "あてな",
  "あてはまる",
  "あひる",
  "あぶら",
  "あぶる",
  "あふれる",
  "あまい",
  "あまど",
  "あまやかす",
  "あまり",
  "あみもの",
  "あめりか",
  "あやまる",
  "あゆむ",
  "あらいぐま",
  "あらし",
  "あらすじ",
  "あらためる",
  "あらゆる",
  "あらわす",
  "ありがとう",
  "あわせる",
  "あわてる",
  "あんい",
  "あんがい",
  "あんこ",
  "あんぜん",
  "あんてい",
  "あんない",
  "あんまり",
  "いいだす",
  "いおん",
  "いがい",
  "いがく",
  "いきおい",
  "いきなり",
  "いきもの",
  "いきる",
  "いくじ",
  "いくぶん",
  "いけばな",
  "いけん",
  "いこう",
  "いこく",
  "いこつ",
  "いさましい",
  "いさん",
  "いしき",
  "いじゅう",
  "いじょう",
  "いじわる",
  "いずみ",
  "いずれ",
  "いせい",
  "いせえび",
  "いせかい",
  "いせき",
  "いぜん",
  "いそうろう",
  "いそがしい",
  "いだい",
  "いだく",
  "いたずら",
  "いたみ",
  "いたりあ",
  "いちおう",
  "いちじ",
  "いちど",
  "いちば",
  "いちぶ",
  "いちりゅう",
  "いつか",
  "いっしゅん",
  "いっせい",
  "いっそう",
  "いったん",
  "いっち",
  "いってい",
  "いっぽう",
  "いてざ",
  "いてん",
  "いどう",
  "いとこ",
  "いない",
  "いなか",
  "いねむり",
  "いのち",
  "いのる",
  "いはつ",
  "いばる",
  "いはん",
  "いびき",
  "いひん",
  "いふく",
  "いへん",
  "いほう",
  "いみん",
  "いもうと",
  "いもたれ",
  "いもり",
  "いやがる",
  "いやす",
  "いよかん",
  "いよく",
  "いらい",
  "いらすと",
  "いりぐち",
  "いりょう",
  "いれい",
  "いれもの",
  "いれる",
  "いろえんぴつ",
  "いわい",
  "いわう",
  "いわかん",
  "いわば",
  "いわゆる",
  "いんげんまめ",
  "いんさつ",
  "いんしょう",
  "いんよう",
  "うえき",
  "うえる",
  "うおざ",
  "うがい",
  "うかぶ",
  "うかべる",
  "うきわ",
  "うくらいな",
  "うくれれ",
  "うけたまわる",
  "うけつけ",
  "うけとる",
  "うけもつ",
  "うける",
  "うごかす",
  "うごく",
  "うこん",
  "うさぎ",
  "うしなう",
  "うしろがみ",
  "うすい",
  "うすぎ",
  "うすぐらい",
  "うすめる",
  "うせつ",
  "うちあわせ",
  "うちがわ",
  "うちき",
  "うちゅう",
  "うっかり",
  "うつくしい",
  "うったえる",
  "うつる",
  "うどん",
  "うなぎ",
  "うなじ",
  "うなずく",
  "うなる",
  "うねる",
  "うのう",
  "うぶげ",
  "うぶごえ",
  "うまれる",
  "うめる",
  "うもう",
  "うやまう",
  "うよく",
  "うらがえす",
  "うらぐち",
  "うらない",
  "うりあげ",
  "うりきれ",
  "うるさい",
  "うれしい",
  "うれゆき",
  "うれる",
  "うろこ",
  "うわき",
  "うわさ",
  "うんこう",
  "うんちん",
  "うんてん",
  "うんどう",
  "えいえん",
  "えいが",
  "えいきょう",
  "えいご",
  "えいせい",
  "えいぶん",
  "えいよう",
  "えいわ",
  "えおり",
  "えがお",
  "えがく",
  "えきたい",
  "えくせる",
  "えしゃく",
  "えすて",
  "えつらん",
  "えのぐ",
  "えほうまき",
  "えほん",
  "えまき",
  "えもじ",
  "えもの",
  "えらい",
  "えらぶ",
  "えりあ",
  "えんえん",
  "えんかい",
  "えんぎ",
  "えんげき",
  "えんしゅう",
  "えんぜつ",
  "えんそく",
  "えんちょう",
  "えんとつ",
  "おいかける",
  "おいこす",
  "おいしい",
  "おいつく",
  "おうえん",
  "おうさま",
  "おうじ",
  "おうせつ",
  "おうたい",
  "おうふく",
  "おうべい",
  "おうよう",
  "おえる",
  "おおい",
  "おおう",
  "おおどおり",
  "おおや",
  "おおよそ",
  "おかえり",
  "おかず",
  "おがむ",
  "おかわり",
  "おぎなう",
  "おきる",
  "おくさま",
  "おくじょう",
  "おくりがな",
  "おくる",
  "おくれる",
  "おこす",
  "おこなう",
  "おこる",
  "おさえる",
  "おさない",
  "おさめる",
  "おしいれ",
  "おしえる",
  "おじぎ",
  "おじさん",
  "おしゃれ",
  "おそらく",
  "おそわる",
  "おたがい",
  "おたく",
  "おだやか",
  "おちつく",
  "おっと",
  "おつり",
  "おでかけ",
  "おとしもの",
  "おとなしい",
  "おどり",
  "おどろかす",
  "おばさん",
  "おまいり",
  "おめでとう",
  "おもいで",
  "おもう",
  "おもたい",
  "おもちゃ",
  "おやつ",
  "おやゆび",
  "およぼす",
  "おらんだ",
  "おろす",
  "おんがく",
  "おんけい",
  "おんしゃ",
  "おんせん",
  "おんだん",
  "おんちゅう",
  "おんどけい",
  "かあつ",
  "かいが",
  "がいき",
  "がいけん",
  "がいこう",
  "かいさつ",
  "かいしゃ",
  "かいすいよく",
  "かいぜん",
  "かいぞうど",
  "かいつう",
  "かいてん",
  "かいとう",
  "かいふく",
  "がいへき",
  "かいほう",
  "かいよう",
  "がいらい",
  "かいわ",
  "かえる",
  "かおり",
  "かかえる",
  "かがく",
  "かがし",
  "かがみ",
  "かくご",
  "かくとく",
  "かざる",
  "がぞう",
  "かたい",
  "かたち",
  "がちょう",
  "がっきゅう",
  "がっこう",
  "がっさん",
  "がっしょう",
  "かなざわし",
  "かのう",
  "がはく",
  "かぶか",
  "かほう",
  "かほご",
  "かまう",
  "かまぼこ",
  "かめれおん",
  "かゆい",
  "かようび",
  "からい",
  "かるい",
  "かろう",
  "かわく",
  "かわら",
  "がんか",
  "かんけい",
  "かんこう",
  "かんしゃ",
  "かんそう",
  "かんたん",
  "かんち",
  "がんばる",
  "きあい",
  "きあつ",
  "きいろ",
  "ぎいん",
  "きうい",
  "きうん",
  "きえる",
  "きおう",
  "きおく",
  "きおち",
  "きおん",
  "きかい",
  "きかく",
  "きかんしゃ",
  "ききて",
  "きくばり",
  "きくらげ",
  "きけんせい",
  "きこう",
  "きこえる",
  "きこく",
  "きさい",
  "きさく",
  "きさま",
  "きさらぎ",
  "ぎじかがく",
  "ぎしき",
  "ぎじたいけん",
  "ぎじにってい",
  "ぎじゅつしゃ",
  "きすう",
  "きせい",
  "きせき",
  "きせつ",
  "きそう",
  "きぞく",
  "きぞん",
  "きたえる",
  "きちょう",
  "きつえん",
  "ぎっちり",
  "きつつき",
  "きつね",
  "きてい",
  "きどう",
  "きどく",
  "きない",
  "きなが",
  "きなこ",
  "きぬごし",
  "きねん",
  "きのう",
  "きのした",
  "きはく",
  "きびしい",
  "きひん",
  "きふく",
  "きぶん",
  "きぼう",
  "きほん",
  "きまる",
  "きみつ",
  "きむずかしい",
  "きめる",
  "きもだめし",
  "きもち",
  "きもの",
  "きゃく",
  "きやく",
  "ぎゅうにく",
  "きよう",
  "きょうりゅう",
  "きらい",
  "きらく",
  "きりん",
  "きれい",
  "きれつ",
  "きろく",
  "ぎろん",
  "きわめる",
  "ぎんいろ",
  "きんかくじ",
  "きんじょ",
  "きんようび",
  "ぐあい",
  "くいず",
  "くうかん",
  "くうき",
  "くうぐん",
  "くうこう",
  "ぐうせい",
  "くうそう",
  "ぐうたら",
  "くうふく",
  "くうぼ",
  "くかん",
  "くきょう",
  "くげん",
  "ぐこう",
  "くさい",
  "くさき",
  "くさばな",
  "くさる",
  "くしゃみ",
  "くしょう",
  "くすのき",
  "くすりゆび",
  "くせげ",
  "くせん",
  "ぐたいてき",
  "くださる",
  "くたびれる",
  "くちこみ",
  "くちさき",
  "くつした",
  "ぐっすり",
  "くつろぐ",
  "くとうてん",
  "くどく",
  "くなん",
  "くねくね",
  "くのう",
  "くふう",
  "くみあわせ",
  "くみたてる",
  "くめる",
  "くやくしょ",
  "くらす",
  "くらべる",
  "くるま",
  "くれる",
  "くろう",
  "くわしい",
  "ぐんかん",
  "ぐんしょく",
  "ぐんたい",
  "ぐんて",
  "けあな",
  "けいかく",
  "けいけん",
  "けいこ",
  "けいさつ",
  "げいじゅつ",
  "けいたい",
  "げいのうじん",
  "けいれき",
  "けいろ",
  "けおとす",
  "けおりもの",
  "げきか",
  "げきげん",
  "げきだん",
  "げきちん",
  "げきとつ",
  "げきは",
  "げきやく",
  "げこう",
  "げこくじょう",
  "げざい",
  "けさき",
  "げざん",
  "けしき",
  "けしごむ",
  "けしょう",
  "げすと",
  "けたば",
  "けちゃっぷ",
  "けちらす",
  "けつあつ",
  "けつい",
  "けつえき",
  "けっこん",
  "けつじょ",
  "けっせき",
  "けってい",
  "けつまつ",
  "げつようび",
  "げつれい",
  "けつろん",
  "げどく",
  "けとばす",
  "けとる",
  "けなげ",
  "けなす",
  "けなみ",
  "けぬき",
  "げねつ",
  "けねん",
  "けはい",
  "げひん",
  "けぶかい",
  "げぼく",
  "けまり",
  "けみかる",
  "けむし",
  "けむり",
  "けもの",
  "けらい",
  "けろけろ",
  "けわしい",
  "けんい",
  "けんえつ",
  "けんお",
  "けんか",
  "げんき",
  "けんげん",
  "けんこう",
  "けんさく",
  "けんしゅう",
  "けんすう",
  "げんそう",
  "けんちく",
  "けんてい",
  "けんとう",
  "けんない",
  "けんにん",
  "げんぶつ",
  "けんま",
  "けんみん",
  "けんめい",
  "けんらん",
  "けんり",
  "こあくま",
  "こいぬ",
  "こいびと",
  "ごうい",
  "こうえん",
  "こうおん",
  "こうかん",
  "ごうきゅう",
  "ごうけい",
  "こうこう",
  "こうさい",
  "こうじ",
  "こうすい",
  "ごうせい",
  "こうそく",
  "こうたい",
  "こうちゃ",
  "こうつう",
  "こうてい",
  "こうどう",
  "こうない",
  "こうはい",
  "ごうほう",
  "ごうまん",
  "こうもく",
  "こうりつ",
  "こえる",
  "こおり",
  "ごかい",
  "ごがつ",
  "ごかん",
  "こくご",
  "こくさい",
  "こくとう",
  "こくない",
  "こくはく",
  "こぐま",
  "こけい",
  "こける",
  "ここのか",
  "こころ",
  "こさめ",
  "こしつ",
  "こすう",
  "こせい",
  "こせき",
  "こぜん",
  "こそだて",
  "こたい",
  "こたえる",
  "こたつ",
  "こちょう",
  "こっか",
  "こつこつ",
  "こつばん",
  "こつぶ",
  "こてい",
  "こてん",
  "ことがら",
  "ことし",
  "ことば",
  "ことり",
  "こなごな",
  "こねこね",
  "このまま",
  "このみ",
  "このよ",
  "ごはん",
  "こひつじ",
  "こふう",
  "こふん",
  "こぼれる",
  "ごまあぶら",
  "こまかい",
  "ごますり",
  "こまつな",
  "こまる",
  "こむぎこ",
  "こもじ",
  "こもち",
  "こもの",
  "こもん",
  "こやく",
  "こやま",
  "こゆう",
  "こゆび",
  "こよい",
  "こよう",
  "こりる",
  "これくしょん",
  "ころっけ",
  "こわもて",
  "こわれる",
  "こんいん",
  "こんかい",
  "こんき",
  "こんしゅう",
  "こんすい",
  "こんだて",
  "こんとん",
  "こんなん",
  "こんびに",
  "こんぽん",
  "こんまけ",
  "こんや",
  "こんれい",
  "こんわく",
  "ざいえき",
  "さいかい",
  "さいきん",
  "ざいげん",
  "ざいこ",
  "さいしょ",
  "さいせい",
  "ざいたく",
  "ざいちゅう",
  "さいてき",
  "ざいりょう",
  "さうな",
  "さかいし",
  "さがす",
  "さかな",
  "さかみち",
  "さがる",
  "さぎょう",
  "さくし",
  "さくひん",
  "さくら",
  "さこく",
  "さこつ",
  "さずかる",
  "ざせき",
  "さたん",
  "さつえい",
  "ざつおん",
  "ざっか",
  "ざつがく",
  "さっきょく",
  "ざっし",
  "さつじん",
  "ざっそう",
  "さつたば",
  "さつまいも",
  "さてい",
  "さといも",
  "さとう",
  "さとおや",
  "さとし",
  "さとる",
  "さのう",
  "さばく",
  "さびしい",
  "さべつ",
  "さほう",
  "さほど",
  "さます",
  "さみしい",
  "さみだれ",
  "さむけ",
  "さめる",
  "さやえんどう",
  "さゆう",
  "さよう",
  "さよく",
  "さらだ",
  "ざるそば",
  "さわやか",
  "さわる",
  "さんいん",
  "さんか",
  "さんきゃく",
  "さんこう",
  "さんさい",
  "ざんしょ",
  "さんすう",
  "さんせい",
  "さんそ",
  "さんち",
  "さんま",
  "さんみ",
  "さんらん",
  "しあい",
  "しあげ",
  "しあさって",
  "しあわせ",
  "しいく",
  "しいん",
  "しうち",
  "しえい",
  "しおけ",
  "しかい",
  "しかく",
  "じかん",
  "しごと",
  "しすう",
  "じだい",
  "したうけ",
  "したぎ",
  "したて",
  "したみ",
  "しちょう",
  "しちりん",
  "しっかり",
  "しつじ",
  "しつもん",
  "してい",
  "してき",
  "してつ",
  "じてん",
  "じどう",
  "しなぎれ",
  "しなもの",
  "しなん",
  "しねま",
  "しねん",
  "しのぐ",
  "しのぶ",
  "しはい",
  "しばかり",
  "しはつ",
  "しはらい",
  "しはん",
  "しひょう",
  "しふく",
  "じぶん",
  "しへい",
  "しほう",
  "しほん",
  "しまう",
  "しまる",
  "しみん",
  "しむける",
  "じむしょ",
  "しめい",
  "しめる",
  "しもん",
  "しゃいん",
  "しゃうん",
  "しゃおん",
  "じゃがいも",
  "しやくしょ",
  "しゃくほう",
  "しゃけん",
  "しゃこ",
  "しゃざい",
  "しゃしん",
  "しゃせん",
  "しゃそう",
  "しゃたい",
  "しゃちょう",
  "しゃっきん",
  "じゃま",
  "しゃりん",
  "しゃれい",
  "じゆう",
  "じゅうしょ",
  "しゅくはく",
  "じゅしん",
  "しゅっせき",
  "しゅみ",
  "しゅらば",
  "じゅんばん",
  "しょうかい",
  "しょくたく",
  "しょっけん",
  "しょどう",
  "しょもつ",
  "しらせる",
  "しらべる",
  "しんか",
  "しんこう",
  "じんじゃ",
  "しんせいじ",
  "しんちく",
  "しんりん",
  "すあげ",
  "すあし",
  "すあな",
  "ずあん",
  "すいえい",
  "すいか",
  "すいとう",
  "ずいぶん",
  "すいようび",
  "すうがく",
  "すうじつ",
  "すうせん",
  "すおどり",
  "すきま",
  "すくう",
  "すくない",
  "すける",
  "すごい",
  "すこし",
  "ずさん",
  "すずしい",
  "すすむ",
  "すすめる",
  "すっかり",
  "ずっしり",
  "ずっと",
  "すてき",
  "すてる",
  "すねる",
  "すのこ",
  "すはだ",
  "すばらしい",
  "ずひょう",
  "ずぶぬれ",
  "すぶり",
  "すふれ",
  "すべて",
  "すべる",
  "ずほう",
  "すぼん",
  "すまい",
  "すめし",
  "すもう",
  "すやき",
  "すらすら",
  "するめ",
  "すれちがう",
  "すろっと",
  "すわる",
  "すんぜん",
  "すんぽう",
  "せあぶら",
  "せいかつ",
  "せいげん",
  "せいじ",
  "せいよう",
  "せおう",
  "せかいかん",
  "せきにん",
  "せきむ",
  "せきゆ",
  "せきらんうん",
  "せけん",
  "せこう",
  "せすじ",
  "せたい",
  "せたけ",
  "せっかく",
  "せっきゃく",
  "ぜっく",
  "せっけん",
  "せっこつ",
  "せっさたくま",
  "せつぞく",
  "せつだん",
  "せつでん",
  "せっぱん",
  "せつび",
  "せつぶん",
  "せつめい",
  "せつりつ",
  "せなか",
  "せのび",
  "せはば",
  "せびろ",
  "せぼね",
  "せまい",
  "せまる",
  "せめる",
  "せもたれ",
  "せりふ",
  "ぜんあく",
  "せんい",
  "せんえい",
  "せんか",
  "せんきょ",
  "せんく",
  "せんげん",
  "ぜんご",
  "せんさい",
  "せんしゅ",
  "せんすい",
  "せんせい",
  "せんぞ",
  "せんたく",
  "せんちょう",
  "せんてい",
  "せんとう",
  "せんぬき",
  "せんねん",
  "せんぱい",
  "ぜんぶ",
  "ぜんぽう",
  "せんむ",
  "せんめんじょ",
  "せんもん",
  "せんやく",
  "せんゆう",
  "せんよう",
  "ぜんら",
  "ぜんりゃく",
  "せんれい",
  "せんろ",
  "そあく",
  "そいとげる",
  "そいね",
  "そうがんきょう",
  "そうき",
  "そうご",
  "そうしん",
  "そうだん",
  "そうなん",
  "そうび",
  "そうめん",
  "そうり",
  "そえもの",
  "そえん",
  "そがい",
  "そげき",
  "そこう",
  "そこそこ",
  "そざい",
  "そしな",
  "そせい",
  "そせん",
  "そそぐ",
  "そだてる",
  "そつう",
  "そつえん",
  "そっかん",
  "そつぎょう",
  "そっけつ",
  "そっこう",
  "そっせん",
  "そっと",
  "そとがわ",
  "そとづら",
  "そなえる",
  "そなた",
  "そふぼ",
  "そぼく",
  "そぼろ",
  "そまつ",
  "そまる",
  "そむく",
  "そむりえ",
  "そめる",
  "そもそも",
  "そよかぜ",
  "そらまめ",
  "そろう",
  "そんかい",
  "そんけい",
  "そんざい",
  "そんしつ",
  "そんぞく",
  "そんちょう",
  "ぞんび",
  "ぞんぶん",
  "そんみん",
  "たあい",
  "たいいん",
  "たいうん",
  "たいえき",
  "たいおう",
  "だいがく",
  "たいき",
  "たいぐう",
  "たいけん",
  "たいこ",
  "たいざい",
  "だいじょうぶ",
  "だいすき",
  "たいせつ",
  "たいそう",
  "だいたい",
  "たいちょう",
  "たいてい",
  "だいどころ",
  "たいない",
  "たいねつ",
  "たいのう",
  "たいはん",
  "だいひょう",
  "たいふう",
  "たいへん",
  "たいほ",
  "たいまつばな",
  "たいみんぐ",
  "たいむ",
  "たいめん",
  "たいやき",
  "たいよう",
  "たいら",
  "たいりょく",
  "たいる",
  "たいわん",
  "たうえ",
  "たえる",
  "たおす",
  "たおる",
  "たおれる",
  "たかい",
  "たかね",
  "たきび",
  "たくさん",
  "たこく",
  "たこやき",
  "たさい",
  "たしざん",
  "だじゃれ",
  "たすける",
  "たずさわる",
  "たそがれ",
  "たたかう",
  "たたく",
  "ただしい",
  "たたみ",
  "たちばな",
  "だっかい",
  "だっきゃく",
  "だっこ",
  "だっしゅつ",
  "だったい",
  "たてる",
  "たとえる",
  "たなばた",
  "たにん",
  "たぬき",
  "たのしみ",
  "たはつ",
  "たぶん",
  "たべる",
  "たぼう",
  "たまご",
  "たまる",
  "だむる",
  "ためいき",
  "ためす",
  "ためる",
  "たもつ",
  "たやすい",
  "たよる",
  "たらす",
  "たりきほんがん",
  "たりょう",
  "たりる",
  "たると",
  "たれる",
  "たれんと",
  "たろっと",
  "たわむれる",
  "だんあつ",
  "たんい",
  "たんおん",
  "たんか",
  "たんき",
  "たんけん",
  "たんご",
  "たんさん",
  "たんじょうび",
  "だんせい",
  "たんそく",
  "たんたい",
  "だんち",
  "たんてい",
  "たんとう",
  "だんな",
  "たんにん",
  "だんねつ",
  "たんのう",
  "たんぴん",
  "だんぼう",
  "たんまつ",
  "たんめい",
  "だんれつ",
  "だんろ",
  "だんわ",
  "ちあい",
  "ちあん",
  "ちいき",
  "ちいさい",
  "ちえん",
  "ちかい",
  "ちから",
  "ちきゅう",
  "ちきん",
  "ちけいず",
  "ちけん",
  "ちこく",
  "ちさい",
  "ちしき",
  "ちしりょう",
  "ちせい",
  "ちそう",
  "ちたい",
  "ちたん",
  "ちちおや",
  "ちつじょ",
  "ちてき",
  "ちてん",
  "ちぬき",
  "ちぬり",
  "ちのう",
  "ちひょう",
  "ちへいせん",
  "ちほう",
  "ちまた",
  "ちみつ",
  "ちみどろ",
  "ちめいど",
  "ちゃんこなべ",
  "ちゅうい",
  "ちゆりょく",
  "ちょうし",
  "ちょさくけん",
  "ちらし",
  "ちらみ",
  "ちりがみ",
  "ちりょう",
  "ちるど",
  "ちわわ",
  "ちんたい",
  "ちんもく",
  "ついか",
  "ついたち",
  "つうか",
  "つうじょう",
  "つうはん",
  "つうわ",
  "つかう",
  "つかれる",
  "つくね",
  "つくる",
  "つけね",
  "つける",
  "つごう",
  "つたえる",
  "つづく",
  "つつじ",
  "つつむ",
  "つとめる",
  "つながる",
  "つなみ",
  "つねづね",
  "つのる",
  "つぶす",
  "つまらない",
  "つまる",
  "つみき",
  "つめたい",
  "つもり",
  "つもる",
  "つよい",
  "つるぼ",
  "つるみく",
  "つわもの",
  "つわり",
  "てあし",
  "てあて",
  "てあみ",
  "ていおん",
  "ていか",
  "ていき",
  "ていけい",
  "ていこく",
  "ていさつ",
  "ていし",
  "ていせい",
  "ていたい",
  "ていど",
  "ていねい",
  "ていひょう",
  "ていへん",
  "ていぼう",
  "てうち",
  "ておくれ",
  "てきとう",
  "てくび",
  "でこぼこ",
  "てさぎょう",
  "てさげ",
  "てすり",
  "てそう",
  "てちがい",
  "てちょう",
  "てつがく",
  "てつづき",
  "でっぱ",
  "てつぼう",
  "てつや",
  "でぬかえ",
  "てぬき",
  "てぬぐい",
  "てのひら",
  "てはい",
  "てぶくろ",
  "てふだ",
  "てほどき",
  "てほん",
  "てまえ",
  "てまきずし",
  "てみじか",
  "てみやげ",
  "てらす",
  "てれび",
  "てわけ",
  "てわたし",
  "でんあつ",
  "てんいん",
  "てんかい",
  "てんき",
  "てんぐ",
  "てんけん",
  "てんごく",
  "てんさい",
  "てんし",
  "てんすう",
  "でんち",
  "てんてき",
  "てんとう",
  "てんない",
  "てんぷら",
  "てんぼうだい",
  "てんめつ",
  "てんらんかい",
  "でんりょく",
  "でんわ",
  "どあい",
  "といれ",
  "どうかん",
  "とうきゅう",
  "どうぐ",
  "とうし",
  "とうむぎ",
  "とおい",
  "とおか",
  "とおく",
  "とおす",
  "とおる",
  "とかい",
  "とかす",
  "ときおり",
  "ときどき",
  "とくい",
  "とくしゅう",
  "とくてん",
  "とくに",
  "とくべつ",
  "とけい",
  "とける",
  "とこや",
  "とさか",
  "としょかん",
  "とそう",
  "とたん",
  "とちゅう",
  "とっきゅう",
  "とっくん",
  "とつぜん",
  "とつにゅう",
  "とどける",
  "ととのえる",
  "とない",
  "となえる",
  "となり",
  "とのさま",
  "とばす",
  "どぶがわ",
  "とほう",
  "とまる",
  "とめる",
  "ともだち",
  "ともる",
  "どようび",
  "とらえる",
  "とんかつ",
  "どんぶり",
  "ないかく",
  "ないこう",
  "ないしょ",
  "ないす",
  "ないせん",
  "ないそう",
  "なおす",
  "ながい",
  "なくす",
  "なげる",
  "なこうど",
  "なさけ",
  "なたでここ",
  "なっとう",
  "なつやすみ",
  "ななおし",
  "なにごと",
  "なにもの",
  "なにわ",
  "なのか",
  "なふだ",
  "なまいき",
  "なまえ",
  "なまみ",
  "なみだ",
  "なめらか",
  "なめる",
  "なやむ",
  "ならう",
  "ならび",
  "ならぶ",
  "なれる",
  "なわとび",
  "なわばり",
  "にあう",
  "にいがた",
  "にうけ",
  "におい",
  "にかい",
  "にがて",
  "にきび",
  "にくしみ",
  "にくまん",
  "にげる",
  "にさんかたんそ",
  "にしき",
  "にせもの",
  "にちじょう",
  "にちようび",
  "にっか",
  "にっき",
  "にっけい",
  "にっこう",
  "にっさん",
  "にっしょく",
  "にっすう",
  "にっせき",
  "にってい",
  "になう",
  "にほん",
  "にまめ",
  "にもつ",
  "にやり",
  "にゅういん",
  "にりんしゃ",
  "にわとり",
  "にんい",
  "にんか",
  "にんき",
  "にんげん",
  "にんしき",
  "にんずう",
  "にんそう",
  "にんたい",
  "にんち",
  "にんてい",
  "にんにく",
  "にんぷ",
  "にんまり",
  "にんむ",
  "にんめい",
  "にんよう",
  "ぬいくぎ",
  "ぬかす",
  "ぬぐいとる",
  "ぬぐう",
  "ぬくもり",
  "ぬすむ",
  "ぬまえび",
  "ぬめり",
  "ぬらす",
  "ぬんちゃく",
  "ねあげ",
  "ねいき",
  "ねいる",
  "ねいろ",
  "ねぐせ",
  "ねくたい",
  "ねくら",
  "ねこぜ",
  "ねこむ",
  "ねさげ",
  "ねすごす",
  "ねそべる",
  "ねだん",
  "ねつい",
  "ねっしん",
  "ねつぞう",
  "ねったいぎょ",
  "ねぶそく",
  "ねふだ",
  "ねぼう",
  "ねほりはほり",
  "ねまき",
  "ねまわし",
  "ねみみ",
  "ねむい",
  "ねむたい",
  "ねもと",
  "ねらう",
  "ねわざ",
  "ねんいり",
  "ねんおし",
  "ねんかん",
  "ねんきん",
  "ねんぐ",
  "ねんざ",
  "ねんし",
  "ねんちゃく",
  "ねんど",
  "ねんぴ",
  "ねんぶつ",
  "ねんまつ",
  "ねんりょう",
  "ねんれい",
  "のいず",
  "のおづま",
  "のがす",
  "のきなみ",
  "のこぎり",
  "のこす",
  "のこる",
  "のせる",
  "のぞく",
  "のぞむ",
  "のたまう",
  "のちほど",
  "のっく",
  "のばす",
  "のはら",
  "のべる",
  "のぼる",
  "のみもの",
  "のやま",
  "のらいぬ",
  "のらねこ",
  "のりもの",
  "のりゆき",
  "のれん",
  "のんき",
  "ばあい",
  "はあく",
  "ばあさん",
  "ばいか",
  "ばいく",
  "はいけん",
  "はいご",
  "はいしん",
  "はいすい",
  "はいせん",
  "はいそう",
  "はいち",
  "ばいばい",
  "はいれつ",
  "はえる",
  "はおる",
  "はかい",
  "ばかり",
  "はかる",
  "はくしゅ",
  "はけん",
  "はこぶ",
  "はさみ",
  "はさん",
  "はしご",
  "ばしょ",
  "はしる",
  "はせる",
  "ぱそこん",
  "はそん",
  "はたん",
  "はちみつ",
  "はつおん",
  "はっかく",
  "はづき",
  "はっきり",
  "はっくつ",
  "はっけん",
  "はっこう",
  "はっさん",
  "はっしん",
  "はったつ",
  "はっちゅう",
  "はってん",
  "はっぴょう",
  "はっぽう",
  "はなす",
  "はなび",
  "はにかむ",
  "はぶらし",
  "はみがき",
  "はむかう",
  "はめつ",
  "はやい",
  "はやし",
  "はらう",
  "はろうぃん",
  "はわい",
  "はんい",
  "はんえい",
  "はんおん",
  "はんかく",
  "はんきょう",
  "ばんぐみ",
  "はんこ",
  "はんしゃ",
  "はんすう",
  "はんだん",
  "ぱんち",
  "ぱんつ",
  "はんてい",
  "はんとし",
  "はんのう",
  "はんぱ",
  "はんぶん",
  "はんぺん",
  "はんぼうき",
  "はんめい",
  "はんらん",
  "はんろん",
  "ひいき",
  "ひうん",
  "ひえる",
  "ひかく",
  "ひかり",
  "ひかる",
  "ひかん",
  "ひくい",
  "ひけつ",
  "ひこうき",
  "ひこく",
  "ひさい",
  "ひさしぶり",
  "ひさん",
  "びじゅつかん",
  "ひしょ",
  "ひそか",
  "ひそむ",
  "ひたむき",
  "ひだり",
  "ひたる",
  "ひつぎ",
  "ひっこし",
  "ひっし",
  "ひつじゅひん",
  "ひっす",
  "ひつぜん",
  "ぴったり",
  "ぴっちり",
  "ひつよう",
  "ひてい",
  "ひとごみ",
  "ひなまつり",
  "ひなん",
  "ひねる",
  "ひはん",
  "ひびく",
  "ひひょう",
  "ひほう",
  "ひまわり",
  "ひまん",
  "ひみつ",
  "ひめい",
  "ひめじし",
  "ひやけ",
  "ひやす",
  "ひよう",
  "びょうき",
  "ひらがな",
  "ひらく",
  "ひりつ",
  "ひりょう",
  "ひるま",
  "ひるやすみ",
  "ひれい",
  "ひろい",
  "ひろう",
  "ひろき",
  "ひろゆき",
  "ひんかく",
  "ひんけつ",
  "ひんこん",
  "ひんしゅ",
  "ひんそう",
  "ぴんち",
  "ひんぱん",
  "びんぼう",
  "ふあん",
  "ふいうち",
  "ふうけい",
  "ふうせん",
  "ぷうたろう",
  "ふうとう",
  "ふうふ",
  "ふえる",
  "ふおん",
  "ふかい",
  "ふきん",
  "ふくざつ",
  "ふくぶくろ",
  "ふこう",
  "ふさい",
  "ふしぎ",
  "ふじみ",
  "ふすま",
  "ふせい",
  "ふせぐ",
  "ふそく",
  "ぶたにく",
  "ふたん",
  "ふちょう",
  "ふつう",
  "ふつか",
  "ふっかつ",
  "ふっき",
  "ふっこく",
  "ぶどう",
  "ふとる",
  "ふとん",
  "ふのう",
  "ふはい",
  "ふひょう",
  "ふへん",
  "ふまん",
  "ふみん",
  "ふめつ",
  "ふめん",
  "ふよう",
  "ふりこ",
  "ふりる",
  "ふるい",
  "ふんいき",
  "ぶんがく",
  "ぶんぐ",
  "ふんしつ",
  "ぶんせき",
  "ふんそう",
  "ぶんぽう",
  "へいあん",
  "へいおん",
  "へいがい",
  "へいき",
  "へいげん",
  "へいこう",
  "へいさ",
  "へいしゃ",
  "へいせつ",
  "へいそ",
  "へいたく",
  "へいてん",
  "へいねつ",
  "へいわ",
  "へきが",
  "へこむ",
  "べにいろ",
  "べにしょうが",
  "へらす",
  "へんかん",
  "べんきょう",
  "べんごし",
  "へんさい",
  "へんたい",
  "べんり",
  "ほあん",
  "ほいく",
  "ぼうぎょ",
  "ほうこく",
  "ほうそう",
  "ほうほう",
  "ほうもん",
  "ほうりつ",
  "ほえる",
  "ほおん",
  "ほかん",
  "ほきょう",
  "ぼきん",
  "ほくろ",
  "ほけつ",
  "ほけん",
  "ほこう",
  "ほこる",
  "ほしい",
  "ほしつ",
  "ほしゅ",
  "ほしょう",
  "ほせい",
  "ほそい",
  "ほそく",
  "ほたて",
  "ほたる",
  "ぽちぶくろ",
  "ほっきょく",
  "ほっさ",
  "ほったん",
  "ほとんど",
  "ほめる",
  "ほんい",
  "ほんき",
  "ほんけ",
  "ほんしつ",
  "ほんやく",
  "まいにち",
  "まかい",
  "まかせる",
  "まがる",
  "まける",
  "まこと",
  "まさつ",
  "まじめ",
  "ますく",
  "まぜる",
  "まつり",
  "まとめ",
  "まなぶ",
  "まぬけ",
  "まねく",
  "まほう",
  "まもる",
  "まゆげ",
  "まよう",
  "まろやか",
  "まわす",
  "まわり",
  "まわる",
  "まんが",
  "まんきつ",
  "まんぞく",
  "まんなか",
  "みいら",
  "みうち",
  "みえる",
  "みがく",
  "みかた",
  "みかん",
  "みけん",
  "みこん",
  "みじかい",
  "みすい",
  "みすえる",
  "みせる",
  "みっか",
  "みつかる",
  "みつける",
  "みてい",
  "みとめる",
  "みなと",
  "みなみかさい",
  "みねらる",
  "みのう",
  "みのがす",
  "みほん",
  "みもと",
  "みやげ",
  "みらい",
  "みりょく",
  "みわく",
  "みんか",
  "みんぞく",
  "むいか",
  "むえき",
  "むえん",
  "むかい",
  "むかう",
  "むかえ",
  "むかし",
  "むぎちゃ",
  "むける",
  "むげん",
  "むさぼる",
  "むしあつい",
  "むしば",
  "むじゅん",
  "むしろ",
  "むすう",
  "むすこ",
  "むすぶ",
  "むすめ",
  "むせる",
  "むせん",
  "むちゅう",
  "むなしい",
  "むのう",
  "むやみ",
  "むよう",
  "むらさき",
  "むりょう",
  "むろん",
  "めいあん",
  "めいうん",
  "めいえん",
  "めいかく",
  "めいきょく",
  "めいさい",
  "めいし",
  "めいそう",
  "めいぶつ",
  "めいれい",
  "めいわく",
  "めぐまれる",
  "めざす",
  "めした",
  "めずらしい",
  "めだつ",
  "めまい",
  "めやす",
  "めんきょ",
  "めんせき",
  "めんどう",
  "もうしあげる",
  "もうどうけん",
  "もえる",
  "もくし",
  "もくてき",
  "もくようび",
  "もちろん",
  "もどる",
  "もらう",
  "もんく",
  "もんだい",
  "やおや",
  "やける",
  "やさい",
  "やさしい",
  "やすい",
  "やすたろう",
  "やすみ",
  "やせる",
  "やそう",
  "やたい",
  "やちん",
  "やっと",
  "やっぱり",
  "やぶる",
  "やめる",
  "ややこしい",
  "やよい",
  "やわらかい",
  "ゆうき",
  "ゆうびんきょく",
  "ゆうべ",
  "ゆうめい",
  "ゆけつ",
  "ゆしゅつ",
  "ゆせん",
  "ゆそう",
  "ゆたか",
  "ゆちゃく",
  "ゆでる",
  "ゆにゅう",
  "ゆびわ",
  "ゆらい",
  "ゆれる",
  "ようい",
  "ようか",
  "ようきゅう",
  "ようじ",
  "ようす",
  "ようちえん",
  "よかぜ",
  "よかん",
  "よきん",
  "よくせい",
  "よくぼう",
  "よけい",
  "よごれる",
  "よさん",
  "よしゅう",
  "よそう",
  "よそく",
  "よっか",
  "よてい",
  "よどがわく",
  "よねつ",
  "よやく",
  "よゆう",
  "よろこぶ",
  "よろしい",
  "らいう",
  "らくがき",
  "らくご",
  "らくさつ",
  "らくだ",
  "らしんばん",
  "らせん",
  "らぞく",
  "らたい",
  "らっか",
  "られつ",
  "りえき",
  "りかい",
  "りきさく",
  "りきせつ",
  "りくぐん",
  "りくつ",
  "りけん",
  "りこう",
  "りせい",
  "りそう",
  "りそく",
  "りてん",
  "りねん",
  "りゆう",
  "りゅうがく",
  "りよう",
  "りょうり",
  "りょかん",
  "りょくちゃ",
  "りょこう",
  "りりく",
  "りれき",
  "りろん",
  "りんご",
  "るいけい",
  "るいさい",
  "るいじ",
  "るいせき",
  "るすばん",
  "るりがわら",
  "れいかん",
  "れいぎ",
  "れいせい",
  "れいぞうこ",
  "れいとう",
  "れいぼう",
  "れきし",
  "れきだい",
  "れんあい",
  "れんけい",
  "れんこん",
  "れんさい",
  "れんしゅう",
  "れんぞく",
  "れんらく",
  "ろうか",
  "ろうご",
  "ろうじん",
  "ろうそく",
  "ろくが",
  "ろこつ",
  "ろじうら",
  "ろしゅつ",
  "ろせん",
  "ろてん",
  "ろめん",
  "ろれつ",
  "ろんぎ",
  "ろんぱ",
  "ろんぶん",
  "ろんり",
  "わかす",
  "わかめ",
  "わかやま",
  "わかれる",
  "わしつ",
  "わじまし",
  "わすれもの",
  "わらう",
  "われる"
]

},{}],23:[function(require,module,exports){
module.exports=[
  "가격",
  "가끔",
  "가난",
  "가능",
  "가득",
  "가르침",
  "가뭄",
  "가방",
  "가상",
  "가슴",
  "가운데",
  "가을",
  "가이드",
  "가입",
  "가장",
  "가정",
  "가족",
  "가죽",
  "각오",
  "각자",
  "간격",
  "간부",
  "간섭",
  "간장",
  "간접",
  "간판",
  "갈등",
  "갈비",
  "갈색",
  "갈증",
  "감각",
  "감기",
  "감소",
  "감수성",
  "감자",
  "감정",
  "갑자기",
  "강남",
  "강당",
  "강도",
  "강력히",
  "강변",
  "강북",
  "강사",
  "강수량",
  "강아지",
  "강원도",
  "강의",
  "강제",
  "강조",
  "같이",
  "개구리",
  "개나리",
  "개방",
  "개별",
  "개선",
  "개성",
  "개인",
  "객관적",
  "거실",
  "거액",
  "거울",
  "거짓",
  "거품",
  "걱정",
  "건강",
  "건물",
  "건설",
  "건조",
  "건축",
  "걸음",
  "검사",
  "검토",
  "게시판",
  "게임",
  "겨울",
  "견해",
  "결과",
  "결국",
  "결론",
  "결석",
  "결승",
  "결심",
  "결정",
  "결혼",
  "경계",
  "경고",
  "경기",
  "경력",
  "경복궁",
  "경비",
  "경상도",
  "경영",
  "경우",
  "경쟁",
  "경제",
  "경주",
  "경찰",
  "경치",
  "경향",
  "경험",
  "계곡",
  "계단",
  "계란",
  "계산",
  "계속",
  "계약",
  "계절",
  "계층",
  "계획",
  "고객",
  "고구려",
  "고궁",
  "고급",
  "고등학생",
  "고무신",
  "고민",
  "고양이",
  "고장",
  "고전",
  "고집",
  "고춧가루",
  "고통",
  "고향",
  "곡식",
  "골목",
  "골짜기",
  "골프",
  "공간",
  "공개",
  "공격",
  "공군",
  "공급",
  "공기",
  "공동",
  "공무원",
  "공부",
  "공사",
  "공식",
  "공업",
  "공연",
  "공원",
  "공장",
  "공짜",
  "공책",
  "공통",
  "공포",
  "공항",
  "공휴일",
  "과목",
  "과일",
  "과장",
  "과정",
  "과학",
  "관객",
  "관계",
  "관광",
  "관념",
  "관람",
  "관련",
  "관리",
  "관습",
  "관심",
  "관점",
  "관찰",
  "광경",
  "광고",
  "광장",
  "광주",
  "괴로움",
  "굉장히",
  "교과서",
  "교문",
  "교복",
  "교실",
  "교양",
  "교육",
  "교장",
  "교직",
  "교통",
  "교환",
  "교훈",
  "구경",
  "구름",
  "구멍",
  "구별",
  "구분",
  "구석",
  "구성",
  "구속",
  "구역",
  "구입",
  "구청",
  "구체적",
  "국가",
  "국기",
  "국내",
  "국립",
  "국물",
  "국민",
  "국수",
  "국어",
  "국왕",
  "국적",
  "국제",
  "국회",
  "군대",
  "군사",
  "군인",
  "궁극적",
  "권리",
  "권위",
  "권투",
  "귀국",
  "귀신",
  "규정",
  "규칙",
  "균형",
  "그날",
  "그냥",
  "그늘",
  "그러나",
  "그룹",
  "그릇",
  "그림",
  "그제서야",
  "그토록",
  "극복",
  "극히",
  "근거",
  "근교",
  "근래",
  "근로",
  "근무",
  "근본",
  "근원",
  "근육",
  "근처",
  "글씨",
  "글자",
  "금강산",
  "금고",
  "금년",
  "금메달",
  "금액",
  "금연",
  "금요일",
  "금지",
  "긍정적",
  "기간",
  "기관",
  "기념",
  "기능",
  "기독교",
  "기둥",
  "기록",
  "기름",
  "기법",
  "기본",
  "기분",
  "기쁨",
  "기숙사",
  "기술",
  "기억",
  "기업",
  "기온",
  "기운",
  "기원",
  "기적",
  "기준",
  "기침",
  "기혼",
  "기획",
  "긴급",
  "긴장",
  "길이",
  "김밥",
  "김치",
  "김포공항",
  "깍두기",
  "깜빡",
  "깨달음",
  "깨소금",
  "껍질",
  "꼭대기",
  "꽃잎",
  "나들이",
  "나란히",
  "나머지",
  "나물",
  "나침반",
  "나흘",
  "낙엽",
  "난방",
  "날개",
  "날씨",
  "날짜",
  "남녀",
  "남대문",
  "남매",
  "남산",
  "남자",
  "남편",
  "남학생",
  "낭비",
  "낱말",
  "내년",
  "내용",
  "내일",
  "냄비",
  "냄새",
  "냇물",
  "냉동",
  "냉면",
  "냉방",
  "냉장고",
  "넥타이",
  "넷째",
  "노동",
  "노란색",
  "노력",
  "노인",
  "녹음",
  "녹차",
  "녹화",
  "논리",
  "논문",
  "논쟁",
  "놀이",
  "농구",
  "농담",
  "농민",
  "농부",
  "농업",
  "농장",
  "농촌",
  "높이",
  "눈동자",
  "눈물",
  "눈썹",
  "뉴욕",
  "느낌",
  "늑대",
  "능동적",
  "능력",
  "다방",
  "다양성",
  "다음",
  "다이어트",
  "다행",
  "단계",
  "단골",
  "단독",
  "단맛",
  "단순",
  "단어",
  "단위",
  "단점",
  "단체",
  "단추",
  "단편",
  "단풍",
  "달걀",
  "달러",
  "달력",
  "달리",
  "닭고기",
  "담당",
  "담배",
  "담요",
  "담임",
  "답변",
  "답장",
  "당근",
  "당분간",
  "당연히",
  "당장",
  "대규모",
  "대낮",
  "대단히",
  "대답",
  "대도시",
  "대략",
  "대량",
  "대륙",
  "대문",
  "대부분",
  "대신",
  "대응",
  "대장",
  "대전",
  "대접",
  "대중",
  "대책",
  "대출",
  "대충",
  "대통령",
  "대학",
  "대한민국",
  "대합실",
  "대형",
  "덩어리",
  "데이트",
  "도대체",
  "도덕",
  "도둑",
  "도망",
  "도서관",
  "도심",
  "도움",
  "도입",
  "도자기",
  "도저히",
  "도전",
  "도중",
  "도착",
  "독감",
  "독립",
  "독서",
  "독일",
  "독창적",
  "동화책",
  "뒷모습",
  "뒷산",
  "딸아이",
  "마누라",
  "마늘",
  "마당",
  "마라톤",
  "마련",
  "마무리",
  "마사지",
  "마약",
  "마요네즈",
  "마을",
  "마음",
  "마이크",
  "마중",
  "마지막",
  "마찬가지",
  "마찰",
  "마흔",
  "막걸리",
  "막내",
  "막상",
  "만남",
  "만두",
  "만세",
  "만약",
  "만일",
  "만점",
  "만족",
  "만화",
  "많이",
  "말기",
  "말씀",
  "말투",
  "맘대로",
  "망원경",
  "매년",
  "매달",
  "매력",
  "매번",
  "매스컴",
  "매일",
  "매장",
  "맥주",
  "먹이",
  "먼저",
  "먼지",
  "멀리",
  "메일",
  "며느리",
  "며칠",
  "면담",
  "멸치",
  "명단",
  "명령",
  "명예",
  "명의",
  "명절",
  "명칭",
  "명함",
  "모금",
  "모니터",
  "모델",
  "모든",
  "모범",
  "모습",
  "모양",
  "모임",
  "모조리",
  "모집",
  "모퉁이",
  "목걸이",
  "목록",
  "목사",
  "목소리",
  "목숨",
  "목적",
  "목표",
  "몰래",
  "몸매",
  "몸무게",
  "몸살",
  "몸속",
  "몸짓",
  "몸통",
  "몹시",
  "무관심",
  "무궁화",
  "무더위",
  "무덤",
  "무릎",
  "무슨",
  "무엇",
  "무역",
  "무용",
  "무조건",
  "무지개",
  "무척",
  "문구",
  "문득",
  "문법",
  "문서",
  "문제",
  "문학",
  "문화",
  "물가",
  "물건",
  "물결",
  "물고기",
  "물론",
  "물리학",
  "물음",
  "물질",
  "물체",
  "미국",
  "미디어",
  "미사일",
  "미술",
  "미역",
  "미용실",
  "미움",
  "미인",
  "미팅",
  "미혼",
  "민간",
  "민족",
  "민주",
  "믿음",
  "밀가루",
  "밀리미터",
  "밑바닥",
  "바가지",
  "바구니",
  "바나나",
  "바늘",
  "바닥",
  "바닷가",
  "바람",
  "바이러스",
  "바탕",
  "박물관",
  "박사",
  "박수",
  "반대",
  "반드시",
  "반말",
  "반발",
  "반성",
  "반응",
  "반장",
  "반죽",
  "반지",
  "반찬",
  "받침",
  "발가락",
  "발걸음",
  "발견",
  "발달",
  "발레",
  "발목",
  "발바닥",
  "발생",
  "발음",
  "발자국",
  "발전",
  "발톱",
  "발표",
  "밤하늘",
  "밥그릇",
  "밥맛",
  "밥상",
  "밥솥",
  "방금",
  "방면",
  "방문",
  "방바닥",
  "방법",
  "방송",
  "방식",
  "방안",
  "방울",
  "방지",
  "방학",
  "방해",
  "방향",
  "배경",
  "배꼽",
  "배달",
  "배드민턴",
  "백두산",
  "백색",
  "백성",
  "백인",
  "백제",
  "백화점",
  "버릇",
  "버섯",
  "버튼",
  "번개",
  "번역",
  "번지",
  "번호",
  "벌금",
  "벌레",
  "벌써",
  "범위",
  "범인",
  "범죄",
  "법률",
  "법원",
  "법적",
  "법칙",
  "베이징",
  "벨트",
  "변경",
  "변동",
  "변명",
  "변신",
  "변호사",
  "변화",
  "별도",
  "별명",
  "별일",
  "병실",
  "병아리",
  "병원",
  "보관",
  "보너스",
  "보라색",
  "보람",
  "보름",
  "보상",
  "보안",
  "보자기",
  "보장",
  "보전",
  "보존",
  "보통",
  "보편적",
  "보험",
  "복도",
  "복사",
  "복숭아",
  "복습",
  "볶음",
  "본격적",
  "본래",
  "본부",
  "본사",
  "본성",
  "본인",
  "본질",
  "볼펜",
  "봉사",
  "봉지",
  "봉투",
  "부근",
  "부끄러움",
  "부담",
  "부동산",
  "부문",
  "부분",
  "부산",
  "부상",
  "부엌",
  "부인",
  "부작용",
  "부장",
  "부정",
  "부족",
  "부지런히",
  "부친",
  "부탁",
  "부품",
  "부회장",
  "북부",
  "북한",
  "분노",
  "분량",
  "분리",
  "분명",
  "분석",
  "분야",
  "분위기",
  "분필",
  "분홍색",
  "불고기",
  "불과",
  "불교",
  "불꽃",
  "불만",
  "불법",
  "불빛",
  "불안",
  "불이익",
  "불행",
  "브랜드",
  "비극",
  "비난",
  "비닐",
  "비둘기",
  "비디오",
  "비로소",
  "비만",
  "비명",
  "비밀",
  "비바람",
  "비빔밥",
  "비상",
  "비용",
  "비율",
  "비중",
  "비타민",
  "비판",
  "빌딩",
  "빗물",
  "빗방울",
  "빗줄기",
  "빛깔",
  "빨간색",
  "빨래",
  "빨리",
  "사건",
  "사계절",
  "사나이",
  "사냥",
  "사람",
  "사랑",
  "사립",
  "사모님",
  "사물",
  "사방",
  "사상",
  "사생활",
  "사설",
  "사슴",
  "사실",
  "사업",
  "사용",
  "사월",
  "사장",
  "사전",
  "사진",
  "사촌",
  "사춘기",
  "사탕",
  "사투리",
  "사흘",
  "산길",
  "산부인과",
  "산업",
  "산책",
  "살림",
  "살인",
  "살짝",
  "삼계탕",
  "삼국",
  "삼십",
  "삼월",
  "삼촌",
  "상관",
  "상금",
  "상대",
  "상류",
  "상반기",
  "상상",
  "상식",
  "상업",
  "상인",
  "상자",
  "상점",
  "상처",
  "상추",
  "상태",
  "상표",
  "상품",
  "상황",
  "새벽",
  "색깔",
  "색연필",
  "생각",
  "생명",
  "생물",
  "생방송",
  "생산",
  "생선",
  "생신",
  "생일",
  "생활",
  "서랍",
  "서른",
  "서명",
  "서민",
  "서비스",
  "서양",
  "서울",
  "서적",
  "서점",
  "서쪽",
  "서클",
  "석사",
  "석유",
  "선거",
  "선물",
  "선배",
  "선생",
  "선수",
  "선원",
  "선장",
  "선전",
  "선택",
  "선풍기",
  "설거지",
  "설날",
  "설렁탕",
  "설명",
  "설문",
  "설사",
  "설악산",
  "설치",
  "설탕",
  "섭씨",
  "성공",
  "성당",
  "성명",
  "성별",
  "성인",
  "성장",
  "성적",
  "성질",
  "성함",
  "세금",
  "세미나",
  "세상",
  "세월",
  "세종대왕",
  "세탁",
  "센터",
  "센티미터",
  "셋째",
  "소규모",
  "소극적",
  "소금",
  "소나기",
  "소년",
  "소득",
  "소망",
  "소문",
  "소설",
  "소속",
  "소아과",
  "소용",
  "소원",
  "소음",
  "소중히",
  "소지품",
  "소질",
  "소풍",
  "소형",
  "속담",
  "속도",
  "속옷",
  "손가락",
  "손길",
  "손녀",
  "손님",
  "손등",
  "손목",
  "손뼉",
  "손실",
  "손질",
  "손톱",
  "손해",
  "솔직히",
  "솜씨",
  "송아지",
  "송이",
  "송편",
  "쇠고기",
  "쇼핑",
  "수건",
  "수년",
  "수단",
  "수돗물",
  "수동적",
  "수면",
  "수명",
  "수박",
  "수상",
  "수석",
  "수술",
  "수시로",
  "수업",
  "수염",
  "수영",
  "수입",
  "수준",
  "수집",
  "수출",
  "수컷",
  "수필",
  "수학",
  "수험생",
  "수화기",
  "숙녀",
  "숙소",
  "숙제",
  "순간",
  "순서",
  "순수",
  "순식간",
  "순위",
  "숟가락",
  "술병",
  "술집",
  "숫자",
  "스님",
  "스물",
  "스스로",
  "스승",
  "스웨터",
  "스위치",
  "스케이트",
  "스튜디오",
  "스트레스",
  "스포츠",
  "슬쩍",
  "슬픔",
  "습관",
  "습기",
  "승객",
  "승리",
  "승부",
  "승용차",
  "승진",
  "시각",
  "시간",
  "시골",
  "시금치",
  "시나리오",
  "시댁",
  "시리즈",
  "시멘트",
  "시민",
  "시부모",
  "시선",
  "시설",
  "시스템",
  "시아버지",
  "시어머니",
  "시월",
  "시인",
  "시일",
  "시작",
  "시장",
  "시절",
  "시점",
  "시중",
  "시즌",
  "시집",
  "시청",
  "시합",
  "시험",
  "식구",
  "식기",
  "식당",
  "식량",
  "식료품",
  "식물",
  "식빵",
  "식사",
  "식생활",
  "식초",
  "식탁",
  "식품",
  "신고",
  "신규",
  "신념",
  "신문",
  "신발",
  "신비",
  "신사",
  "신세",
  "신용",
  "신제품",
  "신청",
  "신체",
  "신화",
  "실감",
  "실내",
  "실력",
  "실례",
  "실망",
  "실수",
  "실습",
  "실시",
  "실장",
  "실정",
  "실질적",
  "실천",
  "실체",
  "실컷",
  "실태",
  "실패",
  "실험",
  "실현",
  "심리",
  "심부름",
  "심사",
  "심장",
  "심정",
  "심판",
  "쌍둥이",
  "씨름",
  "씨앗",
  "아가씨",
  "아나운서",
  "아드님",
  "아들",
  "아쉬움",
  "아스팔트",
  "아시아",
  "아울러",
  "아저씨",
  "아줌마",
  "아직",
  "아침",
  "아파트",
  "아프리카",
  "아픔",
  "아홉",
  "아흔",
  "악기",
  "악몽",
  "악수",
  "안개",
  "안경",
  "안과",
  "안내",
  "안녕",
  "안동",
  "안방",
  "안부",
  "안주",
  "알루미늄",
  "알코올",
  "암시",
  "암컷",
  "압력",
  "앞날",
  "앞문",
  "애인",
  "애정",
  "액수",
  "앨범",
  "야간",
  "야단",
  "야옹",
  "약간",
  "약국",
  "약속",
  "약수",
  "약점",
  "약품",
  "약혼녀",
  "양념",
  "양력",
  "양말",
  "양배추",
  "양주",
  "양파",
  "어둠",
  "어려움",
  "어른",
  "어젯밤",
  "어쨌든",
  "어쩌다가",
  "어쩐지",
  "언니",
  "언덕",
  "언론",
  "언어",
  "얼굴",
  "얼른",
  "얼음",
  "얼핏",
  "엄마",
  "업무",
  "업종",
  "업체",
  "엉덩이",
  "엉망",
  "엉터리",
  "엊그제",
  "에너지",
  "에어컨",
  "엔진",
  "여건",
  "여고생",
  "여관",
  "여군",
  "여권",
  "여대생",
  "여덟",
  "여동생",
  "여든",
  "여론",
  "여름",
  "여섯",
  "여성",
  "여왕",
  "여인",
  "여전히",
  "여직원",
  "여학생",
  "여행",
  "역사",
  "역시",
  "역할",
  "연결",
  "연구",
  "연극",
  "연기",
  "연락",
  "연설",
  "연세",
  "연속",
  "연습",
  "연애",
  "연예인",
  "연인",
  "연장",
  "연주",
  "연출",
  "연필",
  "연합",
  "연휴",
  "열기",
  "열매",
  "열쇠",
  "열심히",
  "열정",
  "열차",
  "열흘",
  "염려",
  "엽서",
  "영국",
  "영남",
  "영상",
  "영양",
  "영역",
  "영웅",
  "영원히",
  "영하",
  "영향",
  "영혼",
  "영화",
  "옆구리",
  "옆방",
  "옆집",
  "예감",
  "예금",
  "예방",
  "예산",
  "예상",
  "예선",
  "예술",
  "예습",
  "예식장",
  "예약",
  "예전",
  "예절",
  "예정",
  "예컨대",
  "옛날",
  "오늘",
  "오락",
  "오랫동안",
  "오렌지",
  "오로지",
  "오른발",
  "오븐",
  "오십",
  "오염",
  "오월",
  "오전",
  "오직",
  "오징어",
  "오페라",
  "오피스텔",
  "오히려",
  "옥상",
  "옥수수",
  "온갖",
  "온라인",
  "온몸",
  "온종일",
  "온통",
  "올가을",
  "올림픽",
  "올해",
  "옷차림",
  "와이셔츠",
  "와인",
  "완성",
  "완전",
  "왕비",
  "왕자",
  "왜냐하면",
  "왠지",
  "외갓집",
  "외국",
  "외로움",
  "외삼촌",
  "외출",
  "외침",
  "외할머니",
  "왼발",
  "왼손",
  "왼쪽",
  "요금",
  "요일",
  "요즘",
  "요청",
  "용기",
  "용서",
  "용어",
  "우산",
  "우선",
  "우승",
  "우연히",
  "우정",
  "우체국",
  "우편",
  "운동",
  "운명",
  "운반",
  "운전",
  "운행",
  "울산",
  "울음",
  "움직임",
  "웃어른",
  "웃음",
  "워낙",
  "원고",
  "원래",
  "원서",
  "원숭이",
  "원인",
  "원장",
  "원피스",
  "월급",
  "월드컵",
  "월세",
  "월요일",
  "웨이터",
  "위반",
  "위법",
  "위성",
  "위원",
  "위험",
  "위협",
  "윗사람",
  "유난히",
  "유럽",
  "유명",
  "유물",
  "유산",
  "유적",
  "유치원",
  "유학",
  "유행",
  "유형",
  "육군",
  "육상",
  "육십",
  "육체",
  "은행",
  "음력",
  "음료",
  "음반",
  "음성",
  "음식",
  "음악",
  "음주",
  "의견",
  "의논",
  "의문",
  "의복",
  "의식",
  "의심",
  "의외로",
  "의욕",
  "의원",
  "의학",
  "이것",
  "이곳",
  "이념",
  "이놈",
  "이달",
  "이대로",
  "이동",
  "이렇게",
  "이력서",
  "이론적",
  "이름",
  "이민",
  "이발소",
  "이별",
  "이불",
  "이빨",
  "이상",
  "이성",
  "이슬",
  "이야기",
  "이용",
  "이웃",
  "이월",
  "이윽고",
  "이익",
  "이전",
  "이중",
  "이튿날",
  "이틀",
  "이혼",
  "인간",
  "인격",
  "인공",
  "인구",
  "인근",
  "인기",
  "인도",
  "인류",
  "인물",
  "인생",
  "인쇄",
  "인연",
  "인원",
  "인재",
  "인종",
  "인천",
  "인체",
  "인터넷",
  "인하",
  "인형",
  "일곱",
  "일기",
  "일단",
  "일대",
  "일등",
  "일반",
  "일본",
  "일부",
  "일상",
  "일생",
  "일손",
  "일요일",
  "일월",
  "일정",
  "일종",
  "일주일",
  "일찍",
  "일체",
  "일치",
  "일행",
  "일회용",
  "임금",
  "임무",
  "입대",
  "입력",
  "입맛",
  "입사",
  "입술",
  "입시",
  "입원",
  "입장",
  "입학",
  "자가용",
  "자격",
  "자극",
  "자동",
  "자랑",
  "자부심",
  "자식",
  "자신",
  "자연",
  "자원",
  "자율",
  "자전거",
  "자정",
  "자존심",
  "자판",
  "작가",
  "작년",
  "작성",
  "작업",
  "작용",
  "작은딸",
  "작품",
  "잔디",
  "잔뜩",
  "잔치",
  "잘못",
  "잠깐",
  "잠수함",
  "잠시",
  "잠옷",
  "잠자리",
  "잡지",
  "장관",
  "장군",
  "장기간",
  "장래",
  "장례",
  "장르",
  "장마",
  "장면",
  "장모",
  "장미",
  "장비",
  "장사",
  "장소",
  "장식",
  "장애인",
  "장인",
  "장점",
  "장차",
  "장학금",
  "재능",
  "재빨리",
  "재산",
  "재생",
  "재작년",
  "재정",
  "재채기",
  "재판",
  "재학",
  "재활용",
  "저것",
  "저고리",
  "저곳",
  "저녁",
  "저런",
  "저렇게",
  "저번",
  "저울",
  "저절로",
  "저축",
  "적극",
  "적당히",
  "적성",
  "적용",
  "적응",
  "전개",
  "전공",
  "전기",
  "전달",
  "전라도",
  "전망",
  "전문",
  "전반",
  "전부",
  "전세",
  "전시",
  "전용",
  "전자",
  "전쟁",
  "전주",
  "전철",
  "전체",
  "전통",
  "전혀",
  "전후",
  "절대",
  "절망",
  "절반",
  "절약",
  "절차",
  "점검",
  "점수",
  "점심",
  "점원",
  "점점",
  "점차",
  "접근",
  "접시",
  "접촉",
  "젓가락",
  "정거장",
  "정도",
  "정류장",
  "정리",
  "정말",
  "정면",
  "정문",
  "정반대",
  "정보",
  "정부",
  "정비",
  "정상",
  "정성",
  "정오",
  "정원",
  "정장",
  "정지",
  "정치",
  "정확히",
  "제공",
  "제과점",
  "제대로",
  "제목",
  "제발",
  "제법",
  "제삿날",
  "제안",
  "제일",
  "제작",
  "제주도",
  "제출",
  "제품",
  "제한",
  "조각",
  "조건",
  "조금",
  "조깅",
  "조명",
  "조미료",
  "조상",
  "조선",
  "조용히",
  "조절",
  "조정",
  "조직",
  "존댓말",
  "존재",
  "졸업",
  "졸음",
  "종교",
  "종로",
  "종류",
  "종소리",
  "종업원",
  "종종",
  "종합",
  "좌석",
  "죄인",
  "주관적",
  "주름",
  "주말",
  "주머니",
  "주먹",
  "주문",
  "주민",
  "주방",
  "주변",
  "주식",
  "주인",
  "주일",
  "주장",
  "주전자",
  "주택",
  "준비",
  "줄거리",
  "줄기",
  "줄무늬",
  "중간",
  "중계방송",
  "중국",
  "중년",
  "중단",
  "중독",
  "중반",
  "중부",
  "중세",
  "중소기업",
  "중순",
  "중앙",
  "중요",
  "중학교",
  "즉석",
  "즉시",
  "즐거움",
  "증가",
  "증거",
  "증권",
  "증상",
  "증세",
  "지각",
  "지갑",
  "지경",
  "지극히",
  "지금",
  "지급",
  "지능",
  "지름길",
  "지리산",
  "지방",
  "지붕",
  "지식",
  "지역",
  "지우개",
  "지원",
  "지적",
  "지점",
  "지진",
  "지출",
  "직선",
  "직업",
  "직원",
  "직장",
  "진급",
  "진동",
  "진로",
  "진료",
  "진리",
  "진짜",
  "진찰",
  "진출",
  "진통",
  "진행",
  "질문",
  "질병",
  "질서",
  "짐작",
  "집단",
  "집안",
  "집중",
  "짜증",
  "찌꺼기",
  "차남",
  "차라리",
  "차량",
  "차림",
  "차별",
  "차선",
  "차츰",
  "착각",
  "찬물",
  "찬성",
  "참가",
  "참기름",
  "참새",
  "참석",
  "참여",
  "참외",
  "참조",
  "찻잔",
  "창가",
  "창고",
  "창구",
  "창문",
  "창밖",
  "창작",
  "창조",
  "채널",
  "채점",
  "책가방",
  "책방",
  "책상",
  "책임",
  "챔피언",
  "처벌",
  "처음",
  "천국",
  "천둥",
  "천장",
  "천재",
  "천천히",
  "철도",
  "철저히",
  "철학",
  "첫날",
  "첫째",
  "청년",
  "청바지",
  "청소",
  "청춘",
  "체계",
  "체력",
  "체온",
  "체육",
  "체중",
  "체험",
  "초등학생",
  "초반",
  "초밥",
  "초상화",
  "초순",
  "초여름",
  "초원",
  "초저녁",
  "초점",
  "초청",
  "초콜릿",
  "촛불",
  "총각",
  "총리",
  "총장",
  "촬영",
  "최근",
  "최상",
  "최선",
  "최신",
  "최악",
  "최종",
  "추석",
  "추억",
  "추진",
  "추천",
  "추측",
  "축구",
  "축소",
  "축제",
  "축하",
  "출근",
  "출발",
  "출산",
  "출신",
  "출연",
  "출입",
  "출장",
  "출판",
  "충격",
  "충고",
  "충돌",
  "충분히",
  "충청도",
  "취업",
  "취직",
  "취향",
  "치약",
  "친구",
  "친척",
  "칠십",
  "칠월",
  "칠판",
  "침대",
  "침묵",
  "침실",
  "칫솔",
  "칭찬",
  "카메라",
  "카운터",
  "칼국수",
  "캐릭터",
  "캠퍼스",
  "캠페인",
  "커튼",
  "컨디션",
  "컬러",
  "컴퓨터",
  "코끼리",
  "코미디",
  "콘서트",
  "콜라",
  "콤플렉스",
  "콩나물",
  "쾌감",
  "쿠데타",
  "크림",
  "큰길",
  "큰딸",
  "큰소리",
  "큰아들",
  "큰어머니",
  "큰일",
  "큰절",
  "클래식",
  "클럽",
  "킬로",
  "타입",
  "타자기",
  "탁구",
  "탁자",
  "탄생",
  "태권도",
  "태양",
  "태풍",
  "택시",
  "탤런트",
  "터널",
  "터미널",
  "테니스",
  "테스트",
  "테이블",
  "텔레비전",
  "토론",
  "토마토",
  "토요일",
  "통계",
  "통과",
  "통로",
  "통신",
  "통역",
  "통일",
  "통장",
  "통제",
  "통증",
  "통합",
  "통화",
  "퇴근",
  "퇴원",
  "퇴직금",
  "튀김",
  "트럭",
  "특급",
  "특별",
  "특성",
  "특수",
  "특징",
  "특히",
  "튼튼히",
  "티셔츠",
  "파란색",
  "파일",
  "파출소",
  "판결",
  "판단",
  "판매",
  "판사",
  "팔십",
  "팔월",
  "팝송",
  "패션",
  "팩스",
  "팩시밀리",
  "팬티",
  "퍼센트",
  "페인트",
  "편견",
  "편의",
  "편지",
  "편히",
  "평가",
  "평균",
  "평생",
  "평소",
  "평양",
  "평일",
  "평화",
  "포스터",
  "포인트",
  "포장",
  "포함",
  "표면",
  "표정",
  "표준",
  "표현",
  "품목",
  "품질",
  "풍경",
  "풍속",
  "풍습",
  "프랑스",
  "프린터",
  "플라스틱",
  "피곤",
  "피망",
  "피아노",
  "필름",
  "필수",
  "필요",
  "필자",
  "필통",
  "핑계",
  "하느님",
  "하늘",
  "하드웨어",
  "하룻밤",
  "하반기",
  "하숙집",
  "하순",
  "하여튼",
  "하지만",
  "하천",
  "하품",
  "하필",
  "학과",
  "학교",
  "학급",
  "학기",
  "학년",
  "학력",
  "학번",
  "학부모",
  "학비",
  "학생",
  "학술",
  "학습",
  "학용품",
  "학원",
  "학위",
  "학자",
  "학점",
  "한계",
  "한글",
  "한꺼번에",
  "한낮",
  "한눈",
  "한동안",
  "한때",
  "한라산",
  "한마디",
  "한문",
  "한번",
  "한복",
  "한식",
  "한여름",
  "한쪽",
  "할머니",
  "할아버지",
  "할인",
  "함께",
  "함부로",
  "합격",
  "합리적",
  "항공",
  "항구",
  "항상",
  "항의",
  "해결",
  "해군",
  "해답",
  "해당",
  "해물",
  "해석",
  "해설",
  "해수욕장",
  "해안",
  "핵심",
  "핸드백",
  "햄버거",
  "햇볕",
  "햇살",
  "행동",
  "행복",
  "행사",
  "행운",
  "행위",
  "향기",
  "향상",
  "향수",
  "허락",
  "허용",
  "헬기",
  "현관",
  "현금",
  "현대",
  "현상",
  "현실",
  "현장",
  "현재",
  "현지",
  "혈액",
  "협력",
  "형부",
  "형사",
  "형수",
  "형식",
  "형제",
  "형태",
  "형편",
  "혜택",
  "호기심",
  "호남",
  "호랑이",
  "호박",
  "호텔",
  "호흡",
  "혹시",
  "홀로",
  "홈페이지",
  "홍보",
  "홍수",
  "홍차",
  "화면",
  "화분",
  "화살",
  "화요일",
  "화장",
  "화학",
  "확보",
  "확인",
  "확장",
  "확정",
  "환갑",
  "환경",
  "환영",
  "환율",
  "환자",
  "활기",
  "활동",
  "활발히",
  "활용",
  "활짝",
  "회견",
  "회관",
  "회복",
  "회색",
  "회원",
  "회장",
  "회전",
  "횟수",
  "횡단보도",
  "효율적",
  "후반",
  "후춧가루",
  "훈련",
  "훨씬",
  "휴식",
  "휴일",
  "흉내",
  "흐름",
  "흑백",
  "흑인",
  "흔적",
  "흔히",
  "흥미",
  "흥분",
  "희곡",
  "희망",
  "희생",
  "흰색",
  "힘껏"
]

},{}],24:[function(require,module,exports){
module.exports=[
  "ábaco",
  "abdomen",
  "abeja",
  "abierto",
  "abogado",
  "abono",
  "aborto",
  "abrazo",
  "abrir",
  "abuelo",
  "abuso",
  "acabar",
  "academia",
  "acceso",
  "acción",
  "aceite",
  "acelga",
  "acento",
  "aceptar",
  "ácido",
  "aclarar",
  "acné",
  "acoger",
  "acoso",
  "activo",
  "acto",
  "actriz",
  "actuar",
  "acudir",
  "acuerdo",
  "acusar",
  "adicto",
  "admitir",
  "adoptar",
  "adorno",
  "aduana",
  "adulto",
  "aéreo",
  "afectar",
  "afición",
  "afinar",
  "afirmar",
  "ágil",
  "agitar",
  "agonía",
  "agosto",
  "agotar",
  "agregar",
  "agrio",
  "agua",
  "agudo",
  "águila",
  "aguja",
  "ahogo",
  "ahorro",
  "aire",
  "aislar",
  "ajedrez",
  "ajeno",
  "ajuste",
  "alacrán",
  "alambre",
  "alarma",
  "alba",
  "álbum",
  "alcalde",
  "aldea",
  "alegre",
  "alejar",
  "alerta",
  "aleta",
  "alfiler",
  "alga",
  "algodón",
  "aliado",
  "aliento",
  "alivio",
  "alma",
  "almeja",
  "almíbar",
  "altar",
  "alteza",
  "altivo",
  "alto",
  "altura",
  "alumno",
  "alzar",
  "amable",
  "amante",
  "amapola",
  "amargo",
  "amasar",
  "ámbar",
  "ámbito",
  "ameno",
  "amigo",
  "amistad",
  "amor",
  "amparo",
  "amplio",
  "ancho",
  "anciano",
  "ancla",
  "andar",
  "andén",
  "anemia",
  "ángulo",
  "anillo",
  "ánimo",
  "anís",
  "anotar",
  "antena",
  "antiguo",
  "antojo",
  "anual",
  "anular",
  "anuncio",
  "añadir",
  "añejo",
  "año",
  "apagar",
  "aparato",
  "apetito",
  "apio",
  "aplicar",
  "apodo",
  "aporte",
  "apoyo",
  "aprender",
  "aprobar",
  "apuesta",
  "apuro",
  "arado",
  "araña",
  "arar",
  "árbitro",
  "árbol",
  "arbusto",
  "archivo",
  "arco",
  "arder",
  "ardilla",
  "arduo",
  "área",
  "árido",
  "aries",
  "armonía",
  "arnés",
  "aroma",
  "arpa",
  "arpón",
  "arreglo",
  "arroz",
  "arruga",
  "arte",
  "artista",
  "asa",
  "asado",
  "asalto",
  "ascenso",
  "asegurar",
  "aseo",
  "asesor",
  "asiento",
  "asilo",
  "asistir",
  "asno",
  "asombro",
  "áspero",
  "astilla",
  "astro",
  "astuto",
  "asumir",
  "asunto",
  "atajo",
  "ataque",
  "atar",
  "atento",
  "ateo",
  "ático",
  "atleta",
  "átomo",
  "atraer",
  "atroz",
  "atún",
  "audaz",
  "audio",
  "auge",
  "aula",
  "aumento",
  "ausente",
  "autor",
  "aval",
  "avance",
  "avaro",
  "ave",
  "avellana",
  "avena",
  "avestruz",
  "avión",
  "aviso",
  "ayer",
  "ayuda",
  "ayuno",
  "azafrán",
  "azar",
  "azote",
  "azúcar",
  "azufre",
  "azul",
  "baba",
  "babor",
  "bache",
  "bahía",
  "baile",
  "bajar",
  "balanza",
  "balcón",
  "balde",
  "bambú",
  "banco",
  "banda",
  "baño",
  "barba",
  "barco",
  "barniz",
  "barro",
  "báscula",
  "bastón",
  "basura",
  "batalla",
  "batería",
  "batir",
  "batuta",
  "baúl",
  "bazar",
  "bebé",
  "bebida",
  "bello",
  "besar",
  "beso",
  "bestia",
  "bicho",
  "bien",
  "bingo",
  "blanco",
  "bloque",
  "blusa",
  "boa",
  "bobina",
  "bobo",
  "boca",
  "bocina",
  "boda",
  "bodega",
  "boina",
  "bola",
  "bolero",
  "bolsa",
  "bomba",
  "bondad",
  "bonito",
  "bono",
  "bonsái",
  "borde",
  "borrar",
  "bosque",
  "bote",
  "botín",
  "bóveda",
  "bozal",
  "bravo",
  "brazo",
  "brecha",
  "breve",
  "brillo",
  "brinco",
  "brisa",
  "broca",
  "broma",
  "bronce",
  "brote",
  "bruja",
  "brusco",
  "bruto",
  "buceo",
  "bucle",
  "bueno",
  "buey",
  "bufanda",
  "bufón",
  "búho",
  "buitre",
  "bulto",
  "burbuja",
  "burla",
  "burro",
  "buscar",
  "butaca",
  "buzón",
  "caballo",
  "cabeza",
  "cabina",
  "cabra",
  "cacao",
  "cadáver",
  "cadena",
  "caer",
  "café",
  "caída",
  "caimán",
  "caja",
  "cajón",
  "cal",
  "calamar",
  "calcio",
  "caldo",
  "calidad",
  "calle",
  "calma",
  "calor",
  "calvo",
  "cama",
  "cambio",
  "camello",
  "camino",
  "campo",
  "cáncer",
  "candil",
  "canela",
  "canguro",
  "canica",
  "canto",
  "caña",
  "cañón",
  "caoba",
  "caos",
  "capaz",
  "capitán",
  "capote",
  "captar",
  "capucha",
  "cara",
  "carbón",
  "cárcel",
  "careta",
  "carga",
  "cariño",
  "carne",
  "carpeta",
  "carro",
  "carta",
  "casa",
  "casco",
  "casero",
  "caspa",
  "castor",
  "catorce",
  "catre",
  "caudal",
  "causa",
  "cazo",
  "cebolla",
  "ceder",
  "cedro",
  "celda",
  "célebre",
  "celoso",
  "célula",
  "cemento",
  "ceniza",
  "centro",
  "cerca",
  "cerdo",
  "cereza",
  "cero",
  "cerrar",
  "certeza",
  "césped",
  "cetro",
  "chacal",
  "chaleco",
  "champú",
  "chancla",
  "chapa",
  "charla",
  "chico",
  "chiste",
  "chivo",
  "choque",
  "choza",
  "chuleta",
  "chupar",
  "ciclón",
  "ciego",
  "cielo",
  "cien",
  "cierto",
  "cifra",
  "cigarro",
  "cima",
  "cinco",
  "cine",
  "cinta",
  "ciprés",
  "circo",
  "ciruela",
  "cisne",
  "cita",
  "ciudad",
  "clamor",
  "clan",
  "claro",
  "clase",
  "clave",
  "cliente",
  "clima",
  "clínica",
  "cobre",
  "cocción",
  "cochino",
  "cocina",
  "coco",
  "código",
  "codo",
  "cofre",
  "coger",
  "cohete",
  "cojín",
  "cojo",
  "cola",
  "colcha",
  "colegio",
  "colgar",
  "colina",
  "collar",
  "colmo",
  "columna",
  "combate",
  "comer",
  "comida",
  "cómodo",
  "compra",
  "conde",
  "conejo",
  "conga",
  "conocer",
  "consejo",
  "contar",
  "copa",
  "copia",
  "corazón",
  "corbata",
  "corcho",
  "cordón",
  "corona",
  "correr",
  "coser",
  "cosmos",
  "costa",
  "cráneo",
  "cráter",
  "crear",
  "crecer",
  "creído",
  "crema",
  "cría",
  "crimen",
  "cripta",
  "crisis",
  "cromo",
  "crónica",
  "croqueta",
  "crudo",
  "cruz",
  "cuadro",
  "cuarto",
  "cuatro",
  "cubo",
  "cubrir",
  "cuchara",
  "cuello",
  "cuento",
  "cuerda",
  "cuesta",
  "cueva",
  "cuidar",
  "culebra",
  "culpa",
  "culto",
  "cumbre",
  "cumplir",
  "cuna",
  "cuneta",
  "cuota",
  "cupón",
  "cúpula",
  "curar",
  "curioso",
  "curso",
  "curva",
  "cutis",
  "dama",
  "danza",
  "dar",
  "dardo",
  "dátil",
  "deber",
  "débil",
  "década",
  "decir",
  "dedo",
  "defensa",
  "definir",
  "dejar",
  "delfín",
  "delgado",
  "delito",
  "demora",
  "denso",
  "dental",
  "deporte",
  "derecho",
  "derrota",
  "desayuno",
  "deseo",
  "desfile",
  "desnudo",
  "destino",
  "desvío",
  "detalle",
  "detener",
  "deuda",
  "día",
  "diablo",
  "diadema",
  "diamante",
  "diana",
  "diario",
  "dibujo",
  "dictar",
  "diente",
  "dieta",
  "diez",
  "difícil",
  "digno",
  "dilema",
  "diluir",
  "dinero",
  "directo",
  "dirigir",
  "disco",
  "diseño",
  "disfraz",
  "diva",
  "divino",
  "doble",
  "doce",
  "dolor",
  "domingo",
  "don",
  "donar",
  "dorado",
  "dormir",
  "dorso",
  "dos",
  "dosis",
  "dragón",
  "droga",
  "ducha",
  "duda",
  "duelo",
  "dueño",
  "dulce",
  "dúo",
  "duque",
  "durar",
  "dureza",
  "duro",
  "ébano",
  "ebrio",
  "echar",
  "eco",
  "ecuador",
  "edad",
  "edición",
  "edificio",
  "editor",
  "educar",
  "efecto",
  "eficaz",
  "eje",
  "ejemplo",
  "elefante",
  "elegir",
  "elemento",
  "elevar",
  "elipse",
  "élite",
  "elixir",
  "elogio",
  "eludir",
  "embudo",
  "emitir",
  "emoción",
  "empate",
  "empeño",
  "empleo",
  "empresa",
  "enano",
  "encargo",
  "enchufe",
  "encía",
  "enemigo",
  "enero",
  "enfado",
  "enfermo",
  "engaño",
  "enigma",
  "enlace",
  "enorme",
  "enredo",
  "ensayo",
  "enseñar",
  "entero",
  "entrar",
  "envase",
  "envío",
  "época",
  "equipo",
  "erizo",
  "escala",
  "escena",
  "escolar",
  "escribir",
  "escudo",
  "esencia",
  "esfera",
  "esfuerzo",
  "espada",
  "espejo",
  "espía",
  "esposa",
  "espuma",
  "esquí",
  "estar",
  "este",
  "estilo",
  "estufa",
  "etapa",
  "eterno",
  "ética",
  "etnia",
  "evadir",
  "evaluar",
  "evento",
  "evitar",
  "exacto",
  "examen",
  "exceso",
  "excusa",
  "exento",
  "exigir",
  "exilio",
  "existir",
  "éxito",
  "experto",
  "explicar",
  "exponer",
  "extremo",
  "fábrica",
  "fábula",
  "fachada",
  "fácil",
  "factor",
  "faena",
  "faja",
  "falda",
  "fallo",
  "falso",
  "faltar",
  "fama",
  "familia",
  "famoso",
  "faraón",
  "farmacia",
  "farol",
  "farsa",
  "fase",
  "fatiga",
  "fauna",
  "favor",
  "fax",
  "febrero",
  "fecha",
  "feliz",
  "feo",
  "feria",
  "feroz",
  "fértil",
  "fervor",
  "festín",
  "fiable",
  "fianza",
  "fiar",
  "fibra",
  "ficción",
  "ficha",
  "fideo",
  "fiebre",
  "fiel",
  "fiera",
  "fiesta",
  "figura",
  "fijar",
  "fijo",
  "fila",
  "filete",
  "filial",
  "filtro",
  "fin",
  "finca",
  "fingir",
  "finito",
  "firma",
  "flaco",
  "flauta",
  "flecha",
  "flor",
  "flota",
  "fluir",
  "flujo",
  "flúor",
  "fobia",
  "foca",
  "fogata",
  "fogón",
  "folio",
  "folleto",
  "fondo",
  "forma",
  "forro",
  "fortuna",
  "forzar",
  "fosa",
  "foto",
  "fracaso",
  "frágil",
  "franja",
  "frase",
  "fraude",
  "freír",
  "freno",
  "fresa",
  "frío",
  "frito",
  "fruta",
  "fuego",
  "fuente",
  "fuerza",
  "fuga",
  "fumar",
  "función",
  "funda",
  "furgón",
  "furia",
  "fusil",
  "fútbol",
  "futuro",
  "gacela",
  "gafas",
  "gaita",
  "gajo",
  "gala",
  "galería",
  "gallo",
  "gamba",
  "ganar",
  "gancho",
  "ganga",
  "ganso",
  "garaje",
  "garza",
  "gasolina",
  "gastar",
  "gato",
  "gavilán",
  "gemelo",
  "gemir",
  "gen",
  "género",
  "genio",
  "gente",
  "geranio",
  "gerente",
  "germen",
  "gesto",
  "gigante",
  "gimnasio",
  "girar",
  "giro",
  "glaciar",
  "globo",
  "gloria",
  "gol",
  "golfo",
  "goloso",
  "golpe",
  "goma",
  "gordo",
  "gorila",
  "gorra",
  "gota",
  "goteo",
  "gozar",
  "grada",
  "gráfico",
  "grano",
  "grasa",
  "gratis",
  "grave",
  "grieta",
  "grillo",
  "gripe",
  "gris",
  "grito",
  "grosor",
  "grúa",
  "grueso",
  "grumo",
  "grupo",
  "guante",
  "guapo",
  "guardia",
  "guerra",
  "guía",
  "guiño",
  "guion",
  "guiso",
  "guitarra",
  "gusano",
  "gustar",
  "haber",
  "hábil",
  "hablar",
  "hacer",
  "hacha",
  "hada",
  "hallar",
  "hamaca",
  "harina",
  "haz",
  "hazaña",
  "hebilla",
  "hebra",
  "hecho",
  "helado",
  "helio",
  "hembra",
  "herir",
  "hermano",
  "héroe",
  "hervir",
  "hielo",
  "hierro",
  "hígado",
  "higiene",
  "hijo",
  "himno",
  "historia",
  "hocico",
  "hogar",
  "hoguera",
  "hoja",
  "hombre",
  "hongo",
  "honor",
  "honra",
  "hora",
  "hormiga",
  "horno",
  "hostil",
  "hoyo",
  "hueco",
  "huelga",
  "huerta",
  "hueso",
  "huevo",
  "huida",
  "huir",
  "humano",
  "húmedo",
  "humilde",
  "humo",
  "hundir",
  "huracán",
  "hurto",
  "icono",
  "ideal",
  "idioma",
  "ídolo",
  "iglesia",
  "iglú",
  "igual",
  "ilegal",
  "ilusión",
  "imagen",
  "imán",
  "imitar",
  "impar",
  "imperio",
  "imponer",
  "impulso",
  "incapaz",
  "índice",
  "inerte",
  "infiel",
  "informe",
  "ingenio",
  "inicio",
  "inmenso",
  "inmune",
  "innato",
  "insecto",
  "instante",
  "interés",
  "íntimo",
  "intuir",
  "inútil",
  "invierno",
  "ira",
  "iris",
  "ironía",
  "isla",
  "islote",
  "jabalí",
  "jabón",
  "jamón",
  "jarabe",
  "jardín",
  "jarra",
  "jaula",
  "jazmín",
  "jefe",
  "jeringa",
  "jinete",
  "jornada",
  "joroba",
  "joven",
  "joya",
  "juerga",
  "jueves",
  "juez",
  "jugador",
  "jugo",
  "juguete",
  "juicio",
  "junco",
  "jungla",
  "junio",
  "juntar",
  "júpiter",
  "jurar",
  "justo",
  "juvenil",
  "juzgar",
  "kilo",
  "koala",
  "labio",
  "lacio",
  "lacra",
  "lado",
  "ladrón",
  "lagarto",
  "lágrima",
  "laguna",
  "laico",
  "lamer",
  "lámina",
  "lámpara",
  "lana",
  "lancha",
  "langosta",
  "lanza",
  "lápiz",
  "largo",
  "larva",
  "lástima",
  "lata",
  "látex",
  "latir",
  "laurel",
  "lavar",
  "lazo",
  "leal",
  "lección",
  "leche",
  "lector",
  "leer",
  "legión",
  "legumbre",
  "lejano",
  "lengua",
  "lento",
  "leña",
  "león",
  "leopardo",
  "lesión",
  "letal",
  "letra",
  "leve",
  "leyenda",
  "libertad",
  "libro",
  "licor",
  "líder",
  "lidiar",
  "lienzo",
  "liga",
  "ligero",
  "lima",
  "límite",
  "limón",
  "limpio",
  "lince",
  "lindo",
  "línea",
  "lingote",
  "lino",
  "linterna",
  "líquido",
  "liso",
  "lista",
  "litera",
  "litio",
  "litro",
  "llaga",
  "llama",
  "llanto",
  "llave",
  "llegar",
  "llenar",
  "llevar",
  "llorar",
  "llover",
  "lluvia",
  "lobo",
  "loción",
  "loco",
  "locura",
  "lógica",
  "logro",
  "lombriz",
  "lomo",
  "lonja",
  "lote",
  "lucha",
  "lucir",
  "lugar",
  "lujo",
  "luna",
  "lunes",
  "lupa",
  "lustro",
  "luto",
  "luz",
  "maceta",
  "macho",
  "madera",
  "madre",
  "maduro",
  "maestro",
  "mafia",
  "magia",
  "mago",
  "maíz",
  "maldad",
  "maleta",
  "malla",
  "malo",
  "mamá",
  "mambo",
  "mamut",
  "manco",
  "mando",
  "manejar",
  "manga",
  "maniquí",
  "manjar",
  "mano",
  "manso",
  "manta",
  "mañana",
  "mapa",
  "máquina",
  "mar",
  "marco",
  "marea",
  "marfil",
  "margen",
  "marido",
  "mármol",
  "marrón",
  "martes",
  "marzo",
  "masa",
  "máscara",
  "masivo",
  "matar",
  "materia",
  "matiz",
  "matriz",
  "máximo",
  "mayor",
  "mazorca",
  "mecha",
  "medalla",
  "medio",
  "médula",
  "mejilla",
  "mejor",
  "melena",
  "melón",
  "memoria",
  "menor",
  "mensaje",
  "mente",
  "menú",
  "mercado",
  "merengue",
  "mérito",
  "mes",
  "mesón",
  "meta",
  "meter",
  "método",
  "metro",
  "mezcla",
  "miedo",
  "miel",
  "miembro",
  "miga",
  "mil",
  "milagro",
  "militar",
  "millón",
  "mimo",
  "mina",
  "minero",
  "mínimo",
  "minuto",
  "miope",
  "mirar",
  "misa",
  "miseria",
  "misil",
  "mismo",
  "mitad",
  "mito",
  "mochila",
  "moción",
  "moda",
  "modelo",
  "moho",
  "mojar",
  "molde",
  "moler",
  "molino",
  "momento",
  "momia",
  "monarca",
  "moneda",
  "monja",
  "monto",
  "moño",
  "morada",
  "morder",
  "moreno",
  "morir",
  "morro",
  "morsa",
  "mortal",
  "mosca",
  "mostrar",
  "motivo",
  "mover",
  "móvil",
  "mozo",
  "mucho",
  "mudar",
  "mueble",
  "muela",
  "muerte",
  "muestra",
  "mugre",
  "mujer",
  "mula",
  "muleta",
  "multa",
  "mundo",
  "muñeca",
  "mural",
  "muro",
  "músculo",
  "museo",
  "musgo",
  "música",
  "muslo",
  "nácar",
  "nación",
  "nadar",
  "naipe",
  "naranja",
  "nariz",
  "narrar",
  "nasal",
  "natal",
  "nativo",
  "natural",
  "náusea",
  "naval",
  "nave",
  "navidad",
  "necio",
  "néctar",
  "negar",
  "negocio",
  "negro",
  "neón",
  "nervio",
  "neto",
  "neutro",
  "nevar",
  "nevera",
  "nicho",
  "nido",
  "niebla",
  "nieto",
  "niñez",
  "niño",
  "nítido",
  "nivel",
  "nobleza",
  "noche",
  "nómina",
  "noria",
  "norma",
  "norte",
  "nota",
  "noticia",
  "novato",
  "novela",
  "novio",
  "nube",
  "nuca",
  "núcleo",
  "nudillo",
  "nudo",
  "nuera",
  "nueve",
  "nuez",
  "nulo",
  "número",
  "nutria",
  "oasis",
  "obeso",
  "obispo",
  "objeto",
  "obra",
  "obrero",
  "observar",
  "obtener",
  "obvio",
  "oca",
  "ocaso",
  "océano",
  "ochenta",
  "ocho",
  "ocio",
  "ocre",
  "octavo",
  "octubre",
  "oculto",
  "ocupar",
  "ocurrir",
  "odiar",
  "odio",
  "odisea",
  "oeste",
  "ofensa",
  "oferta",
  "oficio",
  "ofrecer",
  "ogro",
  "oído",
  "oír",
  "ojo",
  "ola",
  "oleada",
  "olfato",
  "olivo",
  "olla",
  "olmo",
  "olor",
  "olvido",
  "ombligo",
  "onda",
  "onza",
  "opaco",
  "opción",
  "ópera",
  "opinar",
  "oponer",
  "optar",
  "óptica",
  "opuesto",
  "oración",
  "orador",
  "oral",
  "órbita",
  "orca",
  "orden",
  "oreja",
  "órgano",
  "orgía",
  "orgullo",
  "oriente",
  "origen",
  "orilla",
  "oro",
  "orquesta",
  "oruga",
  "osadía",
  "oscuro",
  "osezno",
  "oso",
  "ostra",
  "otoño",
  "otro",
  "oveja",
  "óvulo",
  "óxido",
  "oxígeno",
  "oyente",
  "ozono",
  "pacto",
  "padre",
  "paella",
  "página",
  "pago",
  "país",
  "pájaro",
  "palabra",
  "palco",
  "paleta",
  "pálido",
  "palma",
  "paloma",
  "palpar",
  "pan",
  "panal",
  "pánico",
  "pantera",
  "pañuelo",
  "papá",
  "papel",
  "papilla",
  "paquete",
  "parar",
  "parcela",
  "pared",
  "parir",
  "paro",
  "párpado",
  "parque",
  "párrafo",
  "parte",
  "pasar",
  "paseo",
  "pasión",
  "paso",
  "pasta",
  "pata",
  "patio",
  "patria",
  "pausa",
  "pauta",
  "pavo",
  "payaso",
  "peatón",
  "pecado",
  "pecera",
  "pecho",
  "pedal",
  "pedir",
  "pegar",
  "peine",
  "pelar",
  "peldaño",
  "pelea",
  "peligro",
  "pellejo",
  "pelo",
  "peluca",
  "pena",
  "pensar",
  "peñón",
  "peón",
  "peor",
  "pepino",
  "pequeño",
  "pera",
  "percha",
  "perder",
  "pereza",
  "perfil",
  "perico",
  "perla",
  "permiso",
  "perro",
  "persona",
  "pesa",
  "pesca",
  "pésimo",
  "pestaña",
  "pétalo",
  "petróleo",
  "pez",
  "pezuña",
  "picar",
  "pichón",
  "pie",
  "piedra",
  "pierna",
  "pieza",
  "pijama",
  "pilar",
  "piloto",
  "pimienta",
  "pino",
  "pintor",
  "pinza",
  "piña",
  "piojo",
  "pipa",
  "pirata",
  "pisar",
  "piscina",
  "piso",
  "pista",
  "pitón",
  "pizca",
  "placa",
  "plan",
  "plata",
  "playa",
  "plaza",
  "pleito",
  "pleno",
  "plomo",
  "pluma",
  "plural",
  "pobre",
  "poco",
  "poder",
  "podio",
  "poema",
  "poesía",
  "poeta",
  "polen",
  "policía",
  "pollo",
  "polvo",
  "pomada",
  "pomelo",
  "pomo",
  "pompa",
  "poner",
  "porción",
  "portal",
  "posada",
  "poseer",
  "posible",
  "poste",
  "potencia",
  "potro",
  "pozo",
  "prado",
  "precoz",
  "pregunta",
  "premio",
  "prensa",
  "preso",
  "previo",
  "primo",
  "príncipe",
  "prisión",
  "privar",
  "proa",
  "probar",
  "proceso",
  "producto",
  "proeza",
  "profesor",
  "programa",
  "prole",
  "promesa",
  "pronto",
  "propio",
  "próximo",
  "prueba",
  "público",
  "puchero",
  "pudor",
  "pueblo",
  "puerta",
  "puesto",
  "pulga",
  "pulir",
  "pulmón",
  "pulpo",
  "pulso",
  "puma",
  "punto",
  "puñal",
  "puño",
  "pupa",
  "pupila",
  "puré",
  "quedar",
  "queja",
  "quemar",
  "querer",
  "queso",
  "quieto",
  "química",
  "quince",
  "quitar",
  "rábano",
  "rabia",
  "rabo",
  "ración",
  "radical",
  "raíz",
  "rama",
  "rampa",
  "rancho",
  "rango",
  "rapaz",
  "rápido",
  "rapto",
  "rasgo",
  "raspa",
  "rato",
  "rayo",
  "raza",
  "razón",
  "reacción",
  "realidad",
  "rebaño",
  "rebote",
  "recaer",
  "receta",
  "rechazo",
  "recoger",
  "recreo",
  "recto",
  "recurso",
  "red",
  "redondo",
  "reducir",
  "reflejo",
  "reforma",
  "refrán",
  "refugio",
  "regalo",
  "regir",
  "regla",
  "regreso",
  "rehén",
  "reino",
  "reír",
  "reja",
  "relato",
  "relevo",
  "relieve",
  "relleno",
  "reloj",
  "remar",
  "remedio",
  "remo",
  "rencor",
  "rendir",
  "renta",
  "reparto",
  "repetir",
  "reposo",
  "reptil",
  "res",
  "rescate",
  "resina",
  "respeto",
  "resto",
  "resumen",
  "retiro",
  "retorno",
  "retrato",
  "reunir",
  "revés",
  "revista",
  "rey",
  "rezar",
  "rico",
  "riego",
  "rienda",
  "riesgo",
  "rifa",
  "rígido",
  "rigor",
  "rincón",
  "riñón",
  "río",
  "riqueza",
  "risa",
  "ritmo",
  "rito",
  "rizo",
  "roble",
  "roce",
  "rociar",
  "rodar",
  "rodeo",
  "rodilla",
  "roer",
  "rojizo",
  "rojo",
  "romero",
  "romper",
  "ron",
  "ronco",
  "ronda",
  "ropa",
  "ropero",
  "rosa",
  "rosca",
  "rostro",
  "rotar",
  "rubí",
  "rubor",
  "rudo",
  "rueda",
  "rugir",
  "ruido",
  "ruina",
  "ruleta",
  "rulo",
  "rumbo",
  "rumor",
  "ruptura",
  "ruta",
  "rutina",
  "sábado",
  "saber",
  "sabio",
  "sable",
  "sacar",
  "sagaz",
  "sagrado",
  "sala",
  "saldo",
  "salero",
  "salir",
  "salmón",
  "salón",
  "salsa",
  "salto",
  "salud",
  "salvar",
  "samba",
  "sanción",
  "sandía",
  "sanear",
  "sangre",
  "sanidad",
  "sano",
  "santo",
  "sapo",
  "saque",
  "sardina",
  "sartén",
  "sastre",
  "satán",
  "sauna",
  "saxofón",
  "sección",
  "seco",
  "secreto",
  "secta",
  "sed",
  "seguir",
  "seis",
  "sello",
  "selva",
  "semana",
  "semilla",
  "senda",
  "sensor",
  "señal",
  "señor",
  "separar",
  "sepia",
  "sequía",
  "ser",
  "serie",
  "sermón",
  "servir",
  "sesenta",
  "sesión",
  "seta",
  "setenta",
  "severo",
  "sexo",
  "sexto",
  "sidra",
  "siesta",
  "siete",
  "siglo",
  "signo",
  "sílaba",
  "silbar",
  "silencio",
  "silla",
  "símbolo",
  "simio",
  "sirena",
  "sistema",
  "sitio",
  "situar",
  "sobre",
  "socio",
  "sodio",
  "sol",
  "solapa",
  "soldado",
  "soledad",
  "sólido",
  "soltar",
  "solución",
  "sombra",
  "sondeo",
  "sonido",
  "sonoro",
  "sonrisa",
  "sopa",
  "soplar",
  "soporte",
  "sordo",
  "sorpresa",
  "sorteo",
  "sostén",
  "sótano",
  "suave",
  "subir",
  "suceso",
  "sudor",
  "suegra",
  "suelo",
  "sueño",
  "suerte",
  "sufrir",
  "sujeto",
  "sultán",
  "sumar",
  "superar",
  "suplir",
  "suponer",
  "supremo",
  "sur",
  "surco",
  "sureño",
  "surgir",
  "susto",
  "sutil",
  "tabaco",
  "tabique",
  "tabla",
  "tabú",
  "taco",
  "tacto",
  "tajo",
  "talar",
  "talco",
  "talento",
  "talla",
  "talón",
  "tamaño",
  "tambor",
  "tango",
  "tanque",
  "tapa",
  "tapete",
  "tapia",
  "tapón",
  "taquilla",
  "tarde",
  "tarea",
  "tarifa",
  "tarjeta",
  "tarot",
  "tarro",
  "tarta",
  "tatuaje",
  "tauro",
  "taza",
  "tazón",
  "teatro",
  "techo",
  "tecla",
  "técnica",
  "tejado",
  "tejer",
  "tejido",
  "tela",
  "teléfono",
  "tema",
  "temor",
  "templo",
  "tenaz",
  "tender",
  "tener",
  "tenis",
  "tenso",
  "teoría",
  "terapia",
  "terco",
  "término",
  "ternura",
  "terror",
  "tesis",
  "tesoro",
  "testigo",
  "tetera",
  "texto",
  "tez",
  "tibio",
  "tiburón",
  "tiempo",
  "tienda",
  "tierra",
  "tieso",
  "tigre",
  "tijera",
  "tilde",
  "timbre",
  "tímido",
  "timo",
  "tinta",
  "tío",
  "típico",
  "tipo",
  "tira",
  "tirón",
  "titán",
  "títere",
  "título",
  "tiza",
  "toalla",
  "tobillo",
  "tocar",
  "tocino",
  "todo",
  "toga",
  "toldo",
  "tomar",
  "tono",
  "tonto",
  "topar",
  "tope",
  "toque",
  "tórax",
  "torero",
  "tormenta",
  "torneo",
  "toro",
  "torpedo",
  "torre",
  "torso",
  "tortuga",
  "tos",
  "tosco",
  "toser",
  "tóxico",
  "trabajo",
  "tractor",
  "traer",
  "tráfico",
  "trago",
  "traje",
  "tramo",
  "trance",
  "trato",
  "trauma",
  "trazar",
  "trébol",
  "tregua",
  "treinta",
  "tren",
  "trepar",
  "tres",
  "tribu",
  "trigo",
  "tripa",
  "triste",
  "triunfo",
  "trofeo",
  "trompa",
  "tronco",
  "tropa",
  "trote",
  "trozo",
  "truco",
  "trueno",
  "trufa",
  "tubería",
  "tubo",
  "tuerto",
  "tumba",
  "tumor",
  "túnel",
  "túnica",
  "turbina",
  "turismo",
  "turno",
  "tutor",
  "ubicar",
  "úlcera",
  "umbral",
  "unidad",
  "unir",
  "universo",
  "uno",
  "untar",
  "uña",
  "urbano",
  "urbe",
  "urgente",
  "urna",
  "usar",
  "usuario",
  "útil",
  "utopía",
  "uva",
  "vaca",
  "vacío",
  "vacuna",
  "vagar",
  "vago",
  "vaina",
  "vajilla",
  "vale",
  "válido",
  "valle",
  "valor",
  "válvula",
  "vampiro",
  "vara",
  "variar",
  "varón",
  "vaso",
  "vecino",
  "vector",
  "vehículo",
  "veinte",
  "vejez",
  "vela",
  "velero",
  "veloz",
  "vena",
  "vencer",
  "venda",
  "veneno",
  "vengar",
  "venir",
  "venta",
  "venus",
  "ver",
  "verano",
  "verbo",
  "verde",
  "vereda",
  "verja",
  "verso",
  "verter",
  "vía",
  "viaje",
  "vibrar",
  "vicio",
  "víctima",
  "vida",
  "vídeo",
  "vidrio",
  "viejo",
  "viernes",
  "vigor",
  "vil",
  "villa",
  "vinagre",
  "vino",
  "viñedo",
  "violín",
  "viral",
  "virgo",
  "virtud",
  "visor",
  "víspera",
  "vista",
  "vitamina",
  "viudo",
  "vivaz",
  "vivero",
  "vivir",
  "vivo",
  "volcán",
  "volumen",
  "volver",
  "voraz",
  "votar",
  "voto",
  "voz",
  "vuelo",
  "vulgar",
  "yacer",
  "yate",
  "yegua",
  "yema",
  "yerno",
  "yeso",
  "yodo",
  "yoga",
  "yogur",
  "zafiro",
  "zanja",
  "zapato",
  "zarza",
  "zona",
  "zorro",
  "zumo",
  "zurdo"
]

},{}],25:[function(require,module,exports){
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = require('buffer').Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

},{"buffer":452}],26:[function(require,module,exports){
var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = require('crypto');
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}

},{"crypto":452}],27:[function(require,module,exports){
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = require('safe-buffer').Buffer

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES

},{"safe-buffer":379}],28:[function(require,module,exports){
var aes = require('./aes')
var Buffer = require('safe-buffer').Buffer
var Transform = require('cipher-base')
var inherits = require('inherits')
var GHASH = require('./ghash')
var xor = require('buffer-xor')
var incr32 = require('./incr32')

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher

},{"./aes":27,"./ghash":32,"./incr32":33,"buffer-xor":47,"cipher-base":49,"inherits":100,"safe-buffer":379}],29:[function(require,module,exports){
var ciphers = require('./encrypter')
var deciphers = require('./decrypter')
var modes = require('./modes/list.json')

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers

},{"./decrypter":30,"./encrypter":31,"./modes/list.json":41}],30:[function(require,module,exports){
var AuthCipher = require('./authCipher')
var Buffer = require('safe-buffer').Buffer
var MODES = require('./modes')
var StreamCipher = require('./streamCipher')
var Transform = require('cipher-base')
var aes = require('./aes')
var ebtk = require('evp_bytestokey')
var inherits = require('inherits')

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv

},{"./aes":27,"./authCipher":28,"./modes":40,"./streamCipher":43,"cipher-base":49,"evp_bytestokey":68,"inherits":100,"safe-buffer":379}],31:[function(require,module,exports){
var MODES = require('./modes')
var AuthCipher = require('./authCipher')
var Buffer = require('safe-buffer').Buffer
var StreamCipher = require('./streamCipher')
var Transform = require('cipher-base')
var aes = require('./aes')
var ebtk = require('evp_bytestokey')
var inherits = require('inherits')

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher

},{"./aes":27,"./authCipher":28,"./modes":40,"./streamCipher":43,"cipher-base":49,"evp_bytestokey":68,"inherits":100,"safe-buffer":379}],32:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH

},{"safe-buffer":379}],33:[function(require,module,exports){
function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32

},{}],34:[function(require,module,exports){
var xor = require('buffer-xor')

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}

},{"buffer-xor":47}],35:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer
var xor = require('buffer-xor')

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}

},{"buffer-xor":47,"safe-buffer":379}],36:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}

},{"safe-buffer":379}],37:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}

},{"safe-buffer":379}],38:[function(require,module,exports){
var xor = require('buffer-xor')
var Buffer = require('safe-buffer').Buffer
var incr32 = require('../incr32')

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

},{"../incr32":33,"buffer-xor":47,"safe-buffer":379}],39:[function(require,module,exports){
exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}

},{}],40:[function(require,module,exports){
var modeModules = {
  ECB: require('./ecb'),
  CBC: require('./cbc'),
  CFB: require('./cfb'),
  CFB8: require('./cfb8'),
  CFB1: require('./cfb1'),
  OFB: require('./ofb'),
  CTR: require('./ctr'),
  GCM: require('./ctr')
}

var modes = require('./list.json')

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes

},{"./cbc":34,"./cfb":35,"./cfb1":36,"./cfb8":37,"./ctr":38,"./ecb":39,"./list.json":41,"./ofb":42}],41:[function(require,module,exports){
module.exports={
  "aes-128-ecb": {
    "cipher": "AES",
    "key": 128,
    "iv": 0,
    "mode": "ECB",
    "type": "block"
  },
  "aes-192-ecb": {
    "cipher": "AES",
    "key": 192,
    "iv": 0,
    "mode": "ECB",
    "type": "block"
  },
  "aes-256-ecb": {
    "cipher": "AES",
    "key": 256,
    "iv": 0,
    "mode": "ECB",
    "type": "block"
  },
  "aes-128-cbc": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes-192-cbc": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes-256-cbc": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes128": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes192": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes256": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CBC",
    "type": "block"
  },
  "aes-128-cfb": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CFB",
    "type": "stream"
  },
  "aes-192-cfb": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CFB",
    "type": "stream"
  },
  "aes-256-cfb": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CFB",
    "type": "stream"
  },
  "aes-128-cfb8": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CFB8",
    "type": "stream"
  },
  "aes-192-cfb8": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CFB8",
    "type": "stream"
  },
  "aes-256-cfb8": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CFB8",
    "type": "stream"
  },
  "aes-128-cfb1": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CFB1",
    "type": "stream"
  },
  "aes-192-cfb1": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CFB1",
    "type": "stream"
  },
  "aes-256-cfb1": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CFB1",
    "type": "stream"
  },
  "aes-128-ofb": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "OFB",
    "type": "stream"
  },
  "aes-192-ofb": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "OFB",
    "type": "stream"
  },
  "aes-256-ofb": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "OFB",
    "type": "stream"
  },
  "aes-128-ctr": {
    "cipher": "AES",
    "key": 128,
    "iv": 16,
    "mode": "CTR",
    "type": "stream"
  },
  "aes-192-ctr": {
    "cipher": "AES",
    "key": 192,
    "iv": 16,
    "mode": "CTR",
    "type": "stream"
  },
  "aes-256-ctr": {
    "cipher": "AES",
    "key": 256,
    "iv": 16,
    "mode": "CTR",
    "type": "stream"
  },
  "aes-128-gcm": {
    "cipher": "AES",
    "key": 128,
    "iv": 12,
    "mode": "GCM",
    "type": "auth"
  },
  "aes-192-gcm": {
    "cipher": "AES",
    "key": 192,
    "iv": 12,
    "mode": "GCM",
    "type": "auth"
  },
  "aes-256-gcm": {
    "cipher": "AES",
    "key": 256,
    "iv": 12,
    "mode": "GCM",
    "type": "auth"
  }
}

},{}],42:[function(require,module,exports){
(function (Buffer){(function (){
var xor = require('buffer-xor')

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":498,"buffer-xor":47}],43:[function(require,module,exports){
var aes = require('./aes')
var Buffer = require('safe-buffer').Buffer
var Transform = require('cipher-base')
var inherits = require('inherits')

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher

},{"./aes":27,"cipher-base":49,"inherits":100,"safe-buffer":379}],44:[function(require,module,exports){
var basex = require('base-x')
var ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'

module.exports = basex(ALPHABET)

},{"base-x":15}],45:[function(require,module,exports){
(function (Buffer){(function (){
'use strict'

var base58 = require('bs58')
var createHash = require('create-hash')

// SHA256(SHA256(buffer))
function sha256x2 (buffer) {
  var tmp = createHash('sha256').update(buffer).digest()
  return createHash('sha256').update(tmp).digest()
}

// Encode a buffer as a base58-check encoded string
function encode (payload) {
  var checksum = sha256x2(payload)

  return base58.encode(Buffer.concat([
    payload,
    checksum
  ], payload.length + 4))
}

// Decode a base58-check encoded string to a buffer
function decode (string) {
  var buffer = new Buffer(base58.decode(string))

  var payload = buffer.slice(0, -4)
  var checksum = buffer.slice(-4)
  var newChecksum = sha256x2(payload)

  if (checksum[0] ^ newChecksum[0] |
      checksum[1] ^ newChecksum[1] |
      checksum[2] ^ newChecksum[2] |
      checksum[3] ^ newChecksum[3]) throw new Error('Invalid checksum')

  return payload
}

module.exports = {
  encode: encode,
  decode: decode
}

}).call(this)}).call(this,require("buffer").Buffer)
},{"bs58":46,"buffer":498,"create-hash":50}],46:[function(require,module,exports){
// Base58 encoding/decoding
// Originally written by Mike Hearn for BitcoinJ
// Copyright (c) 2011 Google Inc
// Ported to JavaScript by Stefan Thomas
// Merged Buffer refactorings from base58-native by Stephen Pair
// Copyright (c) 2013 BitPay Inc

var ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'
var ALPHABET_MAP = {}
for(var i = 0; i < ALPHABET.length; i++) {
  ALPHABET_MAP[ALPHABET.charAt(i)] = i
}
var BASE = 58

function encode(buffer) {
  if (buffer.length === 0) return ''

  var i, j, digits = [0]
  for (i = 0; i < buffer.length; i++) {
    for (j = 0; j < digits.length; j++) digits[j] <<= 8

    digits[0] += buffer[i]

    var carry = 0
    for (j = 0; j < digits.length; ++j) {
      digits[j] += carry

      carry = (digits[j] / BASE) | 0
      digits[j] %= BASE
    }

    while (carry) {
      digits.push(carry % BASE)

      carry = (carry / BASE) | 0
    }
  }

  // deal with leading zeros
  for (i = 0; buffer[i] === 0 && i < buffer.length - 1; i++) digits.push(0)

  // convert digits to a string
  var stringOutput = ""
  for (var i = digits.length - 1; i >= 0; i--) {
    stringOutput = stringOutput + ALPHABET[digits[i]]
  }
  return stringOutput
}

function decode(string) {
  if (string.length === 0) return []

  var i, j, bytes = [0]
  for (i = 0; i < string.length; i++) {
    var c = string[i]
    if (!(c in ALPHABET_MAP)) throw new Error('Non-base58 character')

    for (j = 0; j < bytes.length; j++) bytes[j] *= BASE
    bytes[0] += ALPHABET_MAP[c]

    var carry = 0
    for (j = 0; j < bytes.length; ++j) {
      bytes[j] += carry

      carry = bytes[j] >> 8
      bytes[j] &= 0xff
    }

    while (carry) {
      bytes.push(carry & 0xff)

      carry >>= 8
    }
  }

  // deal with leading zeros
  for (i = 0; string[i] === '1' && i < string.length - 1; i++) bytes.push(0)

  return bytes.reverse()
}

module.exports = {
  encode: encode,
  decode: decode
}

},{}],47:[function(require,module,exports){
(function (Buffer){(function (){
module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":498}],48:[function(require,module,exports){
/*
 Copyright 2013-2014 Daniel Wirtz <dcode@dcode.io>

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */

/**
 * @license ByteBuffer.js (c) 2013-2014 Daniel Wirtz <dcode@dcode.io>
 * This version of ByteBuffer.js uses an ArrayBuffer as its backing buffer which is accessed through a DataView and is
 * compatible with modern browsers.
 * Released under the Apache License, Version 2.0
 * see: https://github.com/dcodeIO/ByteBuffer.js for details
 */ //
(function(global) {
    "use strict";

    /**
     * @param {function(new: Long, number, number, boolean=)=} Long
     * @returns {function(new: ByteBuffer, number=, boolean=, boolean=)}}
     * @inner
     */
    function loadByteBuffer(Long) {

        /**
         * Constructs a new ByteBuffer.
         * @class The swiss army knife for binary data in JavaScript.
         * @exports ByteBuffer
         * @constructor
         * @param {number=} capacity Initial capacity. Defaults to {@link ByteBuffer.DEFAULT_CAPACITY}.
         * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
         *  {@link ByteBuffer.DEFAULT_ENDIAN}.
         * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
         *  {@link ByteBuffer.DEFAULT_NOASSERT}.
         * @expose
         */
        var ByteBuffer = function(capacity, littleEndian, noAssert) {
            if (typeof capacity     === 'undefined') capacity     = ByteBuffer.DEFAULT_CAPACITY;
            if (typeof littleEndian === 'undefined') littleEndian = ByteBuffer.DEFAULT_ENDIAN;
            if (typeof noAssert     === 'undefined') noAssert     = ByteBuffer.DEFAULT_NOASSERT;
            if (!noAssert) {
                capacity = capacity | 0;
                if (capacity < 0)
                    throw RangeError("Illegal capacity");
                littleEndian = !!littleEndian;
                noAssert = !!noAssert;
            }

            /**
             * Backing buffer.
             * @type {!ArrayBuffer}
             * @expose
             */
            this.buffer = capacity === 0 ? EMPTY_BUFFER : new ArrayBuffer(capacity);

            /**
             * Data view to manipulate the backing buffer. Becomes `null` if the backing buffer has a capacity of `0`.
             * @type {?DataView}
             * @expose
             */
            this.view = capacity === 0 ? null : new DataView(this.buffer);

            /**
             * Absolute read/write offset.
             * @type {number}
             * @expose
             * @see ByteBuffer#flip
             * @see ByteBuffer#clear
             */
            this.offset = 0;

            /**
             * Marked offset.
             * @type {number}
             * @expose
             * @see ByteBuffer#mark
             * @see ByteBuffer#reset
             */
            this.markedOffset = -1;

            /**
             * Absolute limit of the contained data. Set to the backing buffer's capacity upon allocation.
             * @type {number}
             * @expose
             * @see ByteBuffer#flip
             * @see ByteBuffer#clear
             */
            this.limit = capacity;

            /**
             * Whether to use little endian byte order, defaults to `false` for big endian.
             * @type {boolean}
             * @expose
             */
            this.littleEndian = typeof littleEndian !== 'undefined' ? !!littleEndian : false;

            /**
             * Whether to skip assertions of offsets and values, defaults to `false`.
             * @type {boolean}
             * @expose
             */
            this.noAssert = !!noAssert;
        };

        /**
         * ByteBuffer version.
         * @type {string}
         * @const
         * @expose
         */
        ByteBuffer.VERSION = "3.5.5";

        /**
         * Little endian constant that can be used instead of its boolean value. Evaluates to `true`.
         * @type {boolean}
         * @const
         * @expose
         */
        ByteBuffer.LITTLE_ENDIAN = true;

        /**
         * Big endian constant that can be used instead of its boolean value. Evaluates to `false`.
         * @type {boolean}
         * @const
         * @expose
         */
        ByteBuffer.BIG_ENDIAN = false;

        /**
         * Default initial capacity of `16`.
         * @type {number}
         * @expose
         */
        ByteBuffer.DEFAULT_CAPACITY = 16;

        /**
         * Default endianess of `false` for big endian.
         * @type {boolean}
         * @expose
         */
        ByteBuffer.DEFAULT_ENDIAN = ByteBuffer.BIG_ENDIAN;

        /**
         * Default no assertions flag of `false`.
         * @type {boolean}
         * @expose
         */
        ByteBuffer.DEFAULT_NOASSERT = false;

        /**
         * A `Long` class for representing a 64-bit two's-complement integer value. May be `null` if Long.js has not been loaded
         *  and int64 support is not available.
         * @type {?Long}
         * @const
         * @see https://github.com/dcodeIO/Long.js
         * @expose
         */
        ByteBuffer.Long = Long || null;

        /**
         * @alias ByteBuffer.prototype
         * @inner
         */
        var ByteBufferPrototype = ByteBuffer.prototype;

        // helpers

        /**
         * @type {!ArrayBuffer}
         * @inner
         */
        var EMPTY_BUFFER = new ArrayBuffer(0);

        /**
         * String.fromCharCode reference for compile-time renaming.
         * @type {function(...number):string}
         * @inner
         */
        var stringFromCharCode = String.fromCharCode;

        /**
         * Creates a source function for a string.
         * @param {string} s String to read from
         * @returns {function():number|null} Source function returning the next char code respectively `null` if there are
         *  no more characters left.
         * @throws {TypeError} If the argument is invalid
         * @inner
         */
        function stringSource(s) {
            var i=0; return function() {
                return i < s.length ? s.charCodeAt(i++) : null;
            };
        }

        /**
         * Creates a destination function for a string.
         * @returns {function(number=):undefined|string} Destination function successively called with the next char code.
         *  Returns the final string when called without arguments.
         * @inner
         */
        function stringDestination() {
            var cs = [], ps = []; return function() {
                if (arguments.length === 0)
                    return ps.join('')+stringFromCharCode.apply(String, cs);
                if (cs.length + arguments.length > 1024)
                    ps.push(stringFromCharCode.apply(String, cs)),
                        cs.length = 0;
                Array.prototype.push.apply(cs, arguments);
            };
        }

        /**
         * Allocates a new ByteBuffer backed by a buffer of the specified capacity.
         * @param {number=} capacity Initial capacity. Defaults to {@link ByteBuffer.DEFAULT_CAPACITY}.
         * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
         *  {@link ByteBuffer.DEFAULT_ENDIAN}.
         * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
         *  {@link ByteBuffer.DEFAULT_NOASSERT}.
         * @returns {!ByteBuffer}
         * @expose
         */
        ByteBuffer.allocate = function(capacity, littleEndian, noAssert) {
            return new ByteBuffer(capacity, littleEndian, noAssert);
        };

        /**
         * Concatenates multiple ByteBuffers into one.
         * @param {!Array.<!ByteBuffer|!ArrayBuffer|!Uint8Array|string>} buffers Buffers to concatenate
         * @param {(string|boolean)=} encoding String encoding if `buffers` contains a string ("base64", "hex", "binary",
         *  defaults to "utf8")
         * @param {boolean=} littleEndian Whether to use little or big endian byte order for the resulting ByteBuffer. Defaults
         *  to {@link ByteBuffer.DEFAULT_ENDIAN}.
         * @param {boolean=} noAssert Whether to skip assertions of offsets and values for the resulting ByteBuffer. Defaults to
         *  {@link ByteBuffer.DEFAULT_NOASSERT}.
         * @returns {!ByteBuffer} Concatenated ByteBuffer
         * @expose
         */
        ByteBuffer.concat = function(buffers, encoding, littleEndian, noAssert) {
            if (typeof encoding === 'boolean' || typeof encoding !== 'string') {
                noAssert = littleEndian;
                littleEndian = encoding;
                encoding = undefined;
            }
            var capacity = 0;
            for (var i=0, k=buffers.length, length; i<k; ++i) {
                if (!ByteBuffer.isByteBuffer(buffers[i]))
                    buffers[i] = ByteBuffer.wrap(buffers[i], encoding);
                length = buffers[i].limit - buffers[i].offset;
                if (length > 0) capacity += length;
            }
            if (capacity === 0)
                return new ByteBuffer(0, littleEndian, noAssert);
            var bb = new ByteBuffer(capacity, littleEndian, noAssert),
                bi;
            var view = new Uint8Array(bb.buffer);
            i=0; while (i<k) {
                bi = buffers[i++];
                length = bi.limit - bi.offset;
                if (length <= 0) continue;
                view.set(new Uint8Array(bi.buffer).subarray(bi.offset, bi.limit), bb.offset);
                bb.offset += length;
            }
            bb.limit = bb.offset;
            bb.offset = 0;
            return bb;
        };

        /**
         * Tests if the specified type is a ByteBuffer.
         * @param {*} bb ByteBuffer to test
         * @returns {boolean} `true` if it is a ByteBuffer, otherwise `false`
         * @expose
         */
        ByteBuffer.isByteBuffer = function(bb) {
            return (bb && bb instanceof ByteBuffer) === true;
        };
        /**
         * Gets the backing buffer type.
         * @returns {Function} `Buffer` for NB builds, `ArrayBuffer` for AB builds (classes)
         * @expose
         */
        ByteBuffer.type = function() {
            return ArrayBuffer;
        };

        /**
         * Wraps a buffer or a string. Sets the allocated ByteBuffer's {@link ByteBuffer#offset} to `0` and its
         *  {@link ByteBuffer#limit} to the length of the wrapped data.
         * @param {!ByteBuffer|!ArrayBuffer|!Uint8Array|string|!Array.<number>} buffer Anything that can be wrapped
         * @param {(string|boolean)=} encoding String encoding if `buffer` is a string ("base64", "hex", "binary", defaults to
         *  "utf8")
         * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
         *  {@link ByteBuffer.DEFAULT_ENDIAN}.
         * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
         *  {@link ByteBuffer.DEFAULT_NOASSERT}.
         * @returns {!ByteBuffer} A ByteBuffer wrapping `buffer`
         * @expose
         */
        ByteBuffer.wrap = function(buffer, encoding, littleEndian, noAssert) {
            if (typeof encoding !== 'string') {
                noAssert = littleEndian;
                littleEndian = encoding;
                encoding = undefined;
            }
            if (typeof buffer === 'string') {
                if (typeof encoding === 'undefined')
                    encoding = "utf8";
                switch (encoding) {
                    case "base64":
                        return ByteBuffer.fromBase64(buffer, littleEndian);
                    case "hex":
                        return ByteBuffer.fromHex(buffer, littleEndian);
                    case "binary":
                        return ByteBuffer.fromBinary(buffer, littleEndian);
                    case "utf8":
                        return ByteBuffer.fromUTF8(buffer, littleEndian);
                    case "debug":
                        return ByteBuffer.fromDebug(buffer, littleEndian);
                    default:
                        throw Error("Unsupported encoding: "+encoding);
                }
            }
            if (buffer === null || typeof buffer !== 'object')
                throw TypeError("Illegal buffer");
            var bb;
            if (ByteBuffer.isByteBuffer(buffer)) {
                bb = ByteBufferPrototype.clone.call(buffer);
                bb.markedOffset = -1;
                return bb;
            }
            if (buffer instanceof Uint8Array) { // Extract ArrayBuffer from Uint8Array
                bb = new ByteBuffer(0, littleEndian, noAssert);
                if (buffer.length > 0) { // Avoid references to more than one EMPTY_BUFFER
                    bb.buffer = buffer.buffer;
                    bb.offset = buffer.byteOffset;
                    bb.limit = buffer.byteOffset + buffer.length;
                    bb.view = buffer.length > 0 ? new DataView(buffer.buffer) : null;
                }
            } else if (buffer instanceof ArrayBuffer) { // Reuse ArrayBuffer
                bb = new ByteBuffer(0, littleEndian, noAssert);
                if (buffer.byteLength > 0) {
                    bb.buffer = buffer;
                    bb.offset = 0;
                    bb.limit = buffer.byteLength;
                    bb.view = buffer.byteLength > 0 ? new DataView(buffer) : null;
                }
            } else if (Object.prototype.toString.call(buffer) === "[object Array]") { // Create from octets
                bb = new ByteBuffer(buffer.length, littleEndian, noAssert);
                bb.limit = buffer.length;
                for (i=0; i<buffer.length; ++i)
                    bb.view.setUint8(i, buffer[i]);
            } else
                throw TypeError("Illegal buffer"); // Otherwise fail
            return bb;
        };

        // types/ints/int8

        /**
         * Writes an 8bit signed integer.
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.writeInt8 = function(value, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof value !== 'number' || value % 1 !== 0)
                    throw TypeError("Illegal value: "+value+" (not an integer)");
                value |= 0;
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            offset += 1;
            var capacity0 = this.buffer.byteLength;
            if (offset > capacity0)
                this.resize((capacity0 *= 2) > offset ? capacity0 : offset);
            offset -= 1;
            this.view.setInt8(offset, value);
            if (relative) this.offset += 1;
            return this;
        };

        /**
         * Writes an 8bit signed integer. This is an alias of {@link ByteBuffer#writeInt8}.
         * @function
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.writeByte = ByteBufferPrototype.writeInt8;

        /**
         * Reads an 8bit signed integer.
         * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
         * @returns {number} Value read
         * @expose
         */
        ByteBufferPrototype.readInt8 = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 1 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+1+") <= "+this.buffer.byteLength);
            }
            var value = this.view.getInt8(offset);
            if (relative) this.offset += 1;
            return value;
        };

        /**
         * Reads an 8bit signed integer. This is an alias of {@link ByteBuffer#readInt8}.
         * @function
         * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
         * @returns {number} Value read
         * @expose
         */
        ByteBufferPrototype.readByte = ByteBufferPrototype.readInt8;

        /**
         * Writes an 8bit unsigned integer.
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.writeUint8 = function(value, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof value !== 'number' || value % 1 !== 0)
                    throw TypeError("Illegal value: "+value+" (not an integer)");
                value >>>= 0;
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            offset += 1;
            var capacity1 = this.buffer.byteLength;
            if (offset > capacity1)
                this.resize((capacity1 *= 2) > offset ? capacity1 : offset);
            offset -= 1;
            this.view.setUint8(offset, value);
            if (relative) this.offset += 1;
            return this;
        };

        /**
         * Reads an 8bit unsigned integer.
         * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
         * @returns {number} Value read
         * @expose
         */
        ByteBufferPrototype.readUint8 = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 1 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+1+") <= "+this.buffer.byteLength);
            }
            var value = this.view.getUint8(offset);
            if (relative) this.offset += 1;
            return value;
        };

        // types/ints/int16

        /**
         * Writes a 16bit signed integer.
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
         * @throws {TypeError} If `offset` or `value` is not a valid number
         * @throws {RangeError} If `offset` is out of bounds
         * @expose
         */
        ByteBufferPrototype.writeInt16 = function(value, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof value !== 'number' || value % 1 !== 0)
                    throw TypeError("Illegal value: "+value+" (not an integer)");
                value |= 0;
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            offset += 2;
            var capacity2 = this.buffer.byteLength;
            if (offset > capacity2)
                this.resize((capacity2 *= 2) > offset ? capacity2 : offset);
            offset -= 2;
            this.view.setInt16(offset, value, this.littleEndian);
            if (relative) this.offset += 2;
            return this;
        };

        /**
         * Writes a 16bit signed integer. This is an alias of {@link ByteBuffer#writeInt16}.
         * @function
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
         * @throws {TypeError} If `offset` or `value` is not a valid number
         * @throws {RangeError} If `offset` is out of bounds
         * @expose
         */
        ByteBufferPrototype.writeShort = ByteBufferPrototype.writeInt16;

        /**
         * Reads a 16bit signed integer.
         * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
         * @returns {number} Value read
         * @throws {TypeError} If `offset` is not a valid number
         * @throws {RangeError} If `offset` is out of bounds
         * @expose
         */
        ByteBufferPrototype.readInt16 = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 2 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+2+") <= "+this.buffer.byteLength);
            }
            var value = this.view.getInt16(offset, this.littleEndian);
            if (relative) this.offset += 2;
            return value;
        };

        /**
         * Reads a 16bit signed integer. This is an alias of {@link ByteBuffer#readInt16}.
         * @function
         * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
         * @returns {number} Value read
         * @throws {TypeError} If `offset` is not a valid number
         * @throws {RangeError} If `offset` is out of bounds
         * @expose
         */
        ByteBufferPrototype.readShort = ByteBufferPrototype.readInt16;

        /**
         * Writes a 16bit unsigned integer.
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
         * @throws {TypeError} If `offset` or `value` is not a valid number
         * @throws {RangeError} If `offset` is out of bounds
         * @expose
         */
        ByteBufferPrototype.writeUint16 = function(value, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof value !== 'number' || value % 1 !== 0)
                    throw TypeError("Illegal value: "+value+" (not an integer)");
                value >>>= 0;
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            offset += 2;
            var capacity3 = this.buffer.byteLength;
            if (offset > capacity3)
                this.resize((capacity3 *= 2) > offset ? capacity3 : offset);
            offset -= 2;
            this.view.setUint16(offset, value, this.littleEndian);
            if (relative) this.offset += 2;
            return this;
        };

        /**
         * Reads a 16bit unsigned integer.
         * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
         * @returns {number} Value read
         * @throws {TypeError} If `offset` is not a valid number
         * @throws {RangeError} If `offset` is out of bounds
         * @expose
         */
        ByteBufferPrototype.readUint16 = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 2 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+2+") <= "+this.buffer.byteLength);
            }
            var value = this.view.getUint16(offset, this.littleEndian);
            if (relative) this.offset += 2;
            return value;
        };

        // types/ints/int32

        /**
         * Writes a 32bit signed integer.
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
         * @expose
         */
        ByteBufferPrototype.writeInt32 = function(value, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof value !== 'number' || value % 1 !== 0)
                    throw TypeError("Illegal value: "+value+" (not an integer)");
                value |= 0;
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            offset += 4;
            var capacity4 = this.buffer.byteLength;
            if (offset > capacity4)
                this.resize((capacity4 *= 2) > offset ? capacity4 : offset);
            offset -= 4;
            this.view.setInt32(offset, value, this.littleEndian);
            if (relative) this.offset += 4;
            return this;
        };

        /**
         * Writes a 32bit signed integer. This is an alias of {@link ByteBuffer#writeInt32}.
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
         * @expose
         */
        ByteBufferPrototype.writeInt = ByteBufferPrototype.writeInt32;

        /**
         * Reads a 32bit signed integer.
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
         * @returns {number} Value read
         * @expose
         */
        ByteBufferPrototype.readInt32 = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 4 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+4+") <= "+this.buffer.byteLength);
            }
            var value = this.view.getInt32(offset, this.littleEndian);
            if (relative) this.offset += 4;
            return value;
        };

        /**
         * Reads a 32bit signed integer. This is an alias of {@link ByteBuffer#readInt32}.
         * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `4` if omitted.
         * @returns {number} Value read
         * @expose
         */
        ByteBufferPrototype.readInt = ByteBufferPrototype.readInt32;

        /**
         * Writes a 32bit unsigned integer.
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
         * @expose
         */
        ByteBufferPrototype.writeUint32 = function(value, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof value !== 'number' || value % 1 !== 0)
                    throw TypeError("Illegal value: "+value+" (not an integer)");
                value >>>= 0;
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            offset += 4;
            var capacity5 = this.buffer.byteLength;
            if (offset > capacity5)
                this.resize((capacity5 *= 2) > offset ? capacity5 : offset);
            offset -= 4;
            this.view.setUint32(offset, value, this.littleEndian);
            if (relative) this.offset += 4;
            return this;
        };

        /**
         * Reads a 32bit unsigned integer.
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
         * @returns {number} Value read
         * @expose
         */
        ByteBufferPrototype.readUint32 = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 4 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+4+") <= "+this.buffer.byteLength);
            }
            var value = this.view.getUint32(offset, this.littleEndian);
            if (relative) this.offset += 4;
            return value;
        };

        // types/ints/int64

        if (Long) {

            /**
             * Writes a 64bit signed integer.
             * @param {number|!Long} value Value to write
             * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
             * @returns {!ByteBuffer} this
             * @expose
             */
            ByteBufferPrototype.writeInt64 = function(value, offset) {
                var relative = typeof offset === 'undefined';
                if (relative) offset = this.offset;
                if (!this.noAssert) {
                    if (typeof value === 'number')
                        value = Long.fromNumber(value);
                    else if (typeof value === 'string')
                        value = Long.fromString(value);
                    else if (!(value && value instanceof Long))
                        throw TypeError("Illegal value: "+value+" (not an integer or Long)");
                    if (typeof offset !== 'number' || offset % 1 !== 0)
                        throw TypeError("Illegal offset: "+offset+" (not an integer)");
                    offset >>>= 0;
                    if (offset < 0 || offset + 0 > this.buffer.byteLength)
                        throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
                }
                if (typeof value === 'number')
                    value = Long.fromNumber(value);
                else if (typeof value === 'string')
                    value = Long.fromString(value);
                offset += 8;
                var capacity6 = this.buffer.byteLength;
                if (offset > capacity6)
                    this.resize((capacity6 *= 2) > offset ? capacity6 : offset);
                offset -= 8;
                if (this.littleEndian) {
                    this.view.setInt32(offset  , value.low , true);
                    this.view.setInt32(offset+4, value.high, true);
                } else {
                    this.view.setInt32(offset  , value.high, false);
                    this.view.setInt32(offset+4, value.low , false);
                }
                if (relative) this.offset += 8;
                return this;
            };

            /**
             * Writes a 64bit signed integer. This is an alias of {@link ByteBuffer#writeInt64}.
             * @param {number|!Long} value Value to write
             * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
             * @returns {!ByteBuffer} this
             * @expose
             */
            ByteBufferPrototype.writeLong = ByteBufferPrototype.writeInt64;

            /**
             * Reads a 64bit signed integer.
             * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
             * @returns {!Long}
             * @expose
             */
            ByteBufferPrototype.readInt64 = function(offset) {
                var relative = typeof offset === 'undefined';
                if (relative) offset = this.offset;
                if (!this.noAssert) {
                    if (typeof offset !== 'number' || offset % 1 !== 0)
                        throw TypeError("Illegal offset: "+offset+" (not an integer)");
                    offset >>>= 0;
                    if (offset < 0 || offset + 8 > this.buffer.byteLength)
                        throw RangeError("Illegal offset: 0 <= "+offset+" (+"+8+") <= "+this.buffer.byteLength);
                }
                var value = this.littleEndian
                    ? new Long(this.view.getInt32(offset  , true ), this.view.getInt32(offset+4, true ), false)
                    : new Long(this.view.getInt32(offset+4, false), this.view.getInt32(offset  , false), false);
                if (relative) this.offset += 8;
                return value;
            };

            /**
             * Reads a 64bit signed integer. This is an alias of {@link ByteBuffer#readInt64}.
             * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
             * @returns {!Long}
             * @expose
             */
            ByteBufferPrototype.readLong = ByteBufferPrototype.readInt64;

            /**
             * Writes a 64bit unsigned integer.
             * @param {number|!Long} value Value to write
             * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
             * @returns {!ByteBuffer} this
             * @expose
             */
            ByteBufferPrototype.writeUint64 = function(value, offset) {
                var relative = typeof offset === 'undefined';
                if (relative) offset = this.offset;
                if (!this.noAssert) {
                    if (typeof value === 'number')
                        value = Long.fromNumber(value);
                    else if (typeof value === 'string')
                        value = Long.fromString(value);
                    else if (!(value && value instanceof Long))
                        throw TypeError("Illegal value: "+value+" (not an integer or Long)");
                    if (typeof offset !== 'number' || offset % 1 !== 0)
                        throw TypeError("Illegal offset: "+offset+" (not an integer)");
                    offset >>>= 0;
                    if (offset < 0 || offset + 0 > this.buffer.byteLength)
                        throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
                }
                if (typeof value === 'number')
                    value = Long.fromNumber(value);
                else if (typeof value === 'string')
                    value = Long.fromString(value);
                offset += 8;
                var capacity7 = this.buffer.byteLength;
                if (offset > capacity7)
                    this.resize((capacity7 *= 2) > offset ? capacity7 : offset);
                offset -= 8;
                if (this.littleEndian) {
                    this.view.setInt32(offset  , value.low , true);
                    this.view.setInt32(offset+4, value.high, true);
                } else {
                    this.view.setInt32(offset  , value.high, false);
                    this.view.setInt32(offset+4, value.low , false);
                }
                if (relative) this.offset += 8;
                return this;
            };

            /**
             * Reads a 64bit unsigned integer.
             * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
             * @returns {!Long}
             * @expose
             */
            ByteBufferPrototype.readUint64 = function(offset) {
                var relative = typeof offset === 'undefined';
                if (relative) offset = this.offset;
                if (!this.noAssert) {
                    if (typeof offset !== 'number' || offset % 1 !== 0)
                        throw TypeError("Illegal offset: "+offset+" (not an integer)");
                    offset >>>= 0;
                    if (offset < 0 || offset + 8 > this.buffer.byteLength)
                        throw RangeError("Illegal offset: 0 <= "+offset+" (+"+8+") <= "+this.buffer.byteLength);
                }
                var value = this.littleEndian
                    ? new Long(this.view.getInt32(offset  , true ), this.view.getInt32(offset+4, true ), true)
                    : new Long(this.view.getInt32(offset+4, false), this.view.getInt32(offset  , false), true);
                if (relative) this.offset += 8;
                return value;
            };

        } // Long


        // types/floats/float32

        /**
         * Writes a 32bit float.
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.writeFloat32 = function(value, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof value !== 'number')
                    throw TypeError("Illegal value: "+value+" (not a number)");
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            offset += 4;
            var capacity8 = this.buffer.byteLength;
            if (offset > capacity8)
                this.resize((capacity8 *= 2) > offset ? capacity8 : offset);
            offset -= 4;
            this.view.setFloat32(offset, value, this.littleEndian);
            if (relative) this.offset += 4;
            return this;
        };

        /**
         * Writes a 32bit float. This is an alias of {@link ByteBuffer#writeFloat32}.
         * @function
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.writeFloat = ByteBufferPrototype.writeFloat32;

        /**
         * Reads a 32bit float.
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
         * @returns {number}
         * @expose
         */
        ByteBufferPrototype.readFloat32 = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 4 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+4+") <= "+this.buffer.byteLength);
            }
            var value = this.view.getFloat32(offset, this.littleEndian);
            if (relative) this.offset += 4;
            return value;
        };

        /**
         * Reads a 32bit float. This is an alias of {@link ByteBuffer#readFloat32}.
         * @function
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
         * @returns {number}
         * @expose
         */
        ByteBufferPrototype.readFloat = ByteBufferPrototype.readFloat32;

        // types/floats/float64

        /**
         * Writes a 64bit float.
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.writeFloat64 = function(value, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof value !== 'number')
                    throw TypeError("Illegal value: "+value+" (not a number)");
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            offset += 8;
            var capacity9 = this.buffer.byteLength;
            if (offset > capacity9)
                this.resize((capacity9 *= 2) > offset ? capacity9 : offset);
            offset -= 8;
            this.view.setFloat64(offset, value, this.littleEndian);
            if (relative) this.offset += 8;
            return this;
        };

        /**
         * Writes a 64bit float. This is an alias of {@link ByteBuffer#writeFloat64}.
         * @function
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.writeDouble = ByteBufferPrototype.writeFloat64;

        /**
         * Reads a 64bit float.
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
         * @returns {number}
         * @expose
         */
        ByteBufferPrototype.readFloat64 = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 8 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+8+") <= "+this.buffer.byteLength);
            }
            var value = this.view.getFloat64(offset, this.littleEndian);
            if (relative) this.offset += 8;
            return value;
        };

        /**
         * Reads a 64bit float. This is an alias of {@link ByteBuffer#readFloat64}.
         * @function
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
         * @returns {number}
         * @expose
         */
        ByteBufferPrototype.readDouble = ByteBufferPrototype.readFloat64;


        // types/varints/varint32

        /**
         * Maximum number of bytes required to store a 32bit base 128 variable-length integer.
         * @type {number}
         * @const
         * @expose
         */
        ByteBuffer.MAX_VARINT32_BYTES = 5;

        /**
         * Calculates the actual number of bytes required to store a 32bit base 128 variable-length integer.
         * @param {number} value Value to encode
         * @returns {number} Number of bytes required. Capped to {@link ByteBuffer.MAX_VARINT32_BYTES}
         * @expose
         */
        ByteBuffer.calculateVarint32 = function(value) {
            // ref: src/google/protobuf/io/coded_stream.cc
            value = value >>> 0;
                 if (value < 1 << 7 ) return 1;
            else if (value < 1 << 14) return 2;
            else if (value < 1 << 21) return 3;
            else if (value < 1 << 28) return 4;
            else                      return 5;
        };

        /**
         * Zigzag encodes a signed 32bit integer so that it can be effectively used with varint encoding.
         * @param {number} n Signed 32bit integer
         * @returns {number} Unsigned zigzag encoded 32bit integer
         * @expose
         */
        ByteBuffer.zigZagEncode32 = function(n) {
            return (((n |= 0) << 1) ^ (n >> 31)) >>> 0; // ref: src/google/protobuf/wire_format_lite.h
        };

        /**
         * Decodes a zigzag encoded signed 32bit integer.
         * @param {number} n Unsigned zigzag encoded 32bit integer
         * @returns {number} Signed 32bit integer
         * @expose
         */
        ByteBuffer.zigZagDecode32 = function(n) {
            return ((n >>> 1) ^ -(n & 1)) | 0; // // ref: src/google/protobuf/wire_format_lite.h
        };

        /**
         * Writes a 32bit base 128 variable-length integer.
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  written if omitted.
         * @returns {!ByteBuffer|number} this if `offset` is omitted, else the actual number of bytes written
         * @expose
         */
        ByteBufferPrototype.writeVarint32 = function(value, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof value !== 'number' || value % 1 !== 0)
                    throw TypeError("Illegal value: "+value+" (not an integer)");
                value |= 0;
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            var size = ByteBuffer.calculateVarint32(value),
                b;
            offset += size;
            var capacity10 = this.buffer.byteLength;
            if (offset > capacity10)
                this.resize((capacity10 *= 2) > offset ? capacity10 : offset);
            offset -= size;
            // ref: http://code.google.com/searchframe#WTeibokF6gE/trunk/src/google/protobuf/io/coded_stream.cc
            this.view.setUint8(offset, b = value | 0x80);
            value >>>= 0;
            if (value >= 1 << 7) {
                b = (value >> 7) | 0x80;
                this.view.setUint8(offset+1, b);
                if (value >= 1 << 14) {
                    b = (value >> 14) | 0x80;
                    this.view.setUint8(offset+2, b);
                    if (value >= 1 << 21) {
                        b = (value >> 21) | 0x80;
                        this.view.setUint8(offset+3, b);
                        if (value >= 1 << 28) {
                            this.view.setUint8(offset+4, (value >> 28) & 0x0F);
                            size = 5;
                        } else {
                            this.view.setUint8(offset+3, b & 0x7F);
                            size = 4;
                        }
                    } else {
                        this.view.setUint8(offset+2, b & 0x7F);
                        size = 3;
                    }
                } else {
                    this.view.setUint8(offset+1, b & 0x7F);
                    size = 2;
                }
            } else {
                this.view.setUint8(offset, b & 0x7F);
                size = 1;
            }
            if (relative) {
                this.offset += size;
                return this;
            }
            return size;
        };

        /**
         * Writes a zig-zag encoded 32bit base 128 variable-length integer.
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  written if omitted.
         * @returns {!ByteBuffer|number} this if `offset` is omitted, else the actual number of bytes written
         * @expose
         */
        ByteBufferPrototype.writeVarint32ZigZag = function(value, offset) {
            return this.writeVarint32(ByteBuffer.zigZagEncode32(value), offset);
        };

        /**
         * Reads a 32bit base 128 variable-length integer.
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  written if omitted.
         * @returns {number|!{value: number, length: number}} The value read if offset is omitted, else the value read
         *  and the actual number of bytes read.
         * @throws {Error} If it's not a valid varint. Has a property `truncated = true` if there is not enough data available
         *  to fully decode the varint.
         * @expose
         */
        ByteBufferPrototype.readVarint32 = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 1 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+1+") <= "+this.buffer.byteLength);
            }
            // ref: src/google/protobuf/io/coded_stream.cc
            var size = 0,
                value = 0 >>> 0,
                temp,
                ioffset;
            do {
                ioffset = offset+size;
                if (!this.noAssert && ioffset > this.limit) {
                    var err = Error("Truncated");
                    err['truncated'] = true;
                    throw err;
                }
                temp = this.view.getUint8(ioffset);
                if (size < 5)
                    value |= ((temp&0x7F)<<(7*size)) >>> 0;
                ++size;
            } while ((temp & 0x80) === 0x80);
            value = value | 0; // Make sure to discard the higher order bits
            if (relative) {
                this.offset += size;
                return value;
            }
            return {
                "value": value,
                "length": size
            };
        };

        /**
         * Reads a zig-zag encoded 32bit base 128 variable-length integer.
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  written if omitted.
         * @returns {number|!{value: number, length: number}} The value read if offset is omitted, else the value read
         *  and the actual number of bytes read.
         * @throws {Error} If it's not a valid varint
         * @expose
         */
        ByteBufferPrototype.readVarint32ZigZag = function(offset) {
            var val = this.readVarint32(offset);
            if (typeof val === 'object')
                val["value"] = ByteBuffer.zigZagDecode32(val["value"]);
            else
                val = ByteBuffer.zigZagDecode32(val);
            return val;
        };

        // types/varints/varint64

        if (Long) {

            /**
             * Maximum number of bytes required to store a 64bit base 128 variable-length integer.
             * @type {number}
             * @const
             * @expose
             */
            ByteBuffer.MAX_VARINT64_BYTES = 10;

            /**
             * Calculates the actual number of bytes required to store a 64bit base 128 variable-length integer.
             * @param {number|!Long} value Value to encode
             * @returns {number} Number of bytes required. Capped to {@link ByteBuffer.MAX_VARINT64_BYTES}
             * @expose
             */
            ByteBuffer.calculateVarint64 = function(value) {
                if (typeof value === 'number')
                    value = Long.fromNumber(value);
                else if (typeof value === 'string')
                    value = Long.fromString(value);
                // ref: src/google/protobuf/io/coded_stream.cc
                var part0 = value.toInt() >>> 0,
                    part1 = value.shiftRightUnsigned(28).toInt() >>> 0,
                    part2 = value.shiftRightUnsigned(56).toInt() >>> 0;
                if (part2 == 0) {
                    if (part1 == 0) {
                        if (part0 < 1 << 14)
                            return part0 < 1 << 7 ? 1 : 2;
                        else
                            return part0 < 1 << 21 ? 3 : 4;
                    } else {
                        if (part1 < 1 << 14)
                            return part1 < 1 << 7 ? 5 : 6;
                        else
                            return part1 < 1 << 21 ? 7 : 8;
                    }
                } else
                    return part2 < 1 << 7 ? 9 : 10;
            };

            /**
             * Zigzag encodes a signed 64bit integer so that it can be effectively used with varint encoding.
             * @param {number|!Long} value Signed long
             * @returns {!Long} Unsigned zigzag encoded long
             * @expose
             */
            ByteBuffer.zigZagEncode64 = function(value) {
                if (typeof value === 'number')
                    value = Long.fromNumber(value, false);
                else if (typeof value === 'string')
                    value = Long.fromString(value, false);
                else if (value.unsigned !== false) value = value.toSigned();
                // ref: src/google/protobuf/wire_format_lite.h
                return value.shiftLeft(1).xor(value.shiftRight(63)).toUnsigned();
            };

            /**
             * Decodes a zigzag encoded signed 64bit integer.
             * @param {!Long|number} value Unsigned zigzag encoded long or JavaScript number
             * @returns {!Long} Signed long
             * @expose
             */
            ByteBuffer.zigZagDecode64 = function(value) {
                if (typeof value === 'number')
                    value = Long.fromNumber(value, false);
                else if (typeof value === 'string')
                    value = Long.fromString(value, false);
                else if (value.unsigned !== false) value = value.toSigned();
                // ref: src/google/protobuf/wire_format_lite.h
                return value.shiftRightUnsigned(1).xor(value.and(Long.ONE).toSigned().negate()).toSigned();
            };

            /**
             * Writes a 64bit base 128 variable-length integer.
             * @param {number|Long} value Value to write
             * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
             *  written if omitted.
             * @returns {!ByteBuffer|number} `this` if offset is omitted, else the actual number of bytes written.
             * @expose
             */
            ByteBufferPrototype.writeVarint64 = function(value, offset) {
                var relative = typeof offset === 'undefined';
                if (relative) offset = this.offset;
                if (!this.noAssert) {
                    if (typeof value === 'number')
                        value = Long.fromNumber(value);
                    else if (typeof value === 'string')
                        value = Long.fromString(value);
                    else if (!(value && value instanceof Long))
                        throw TypeError("Illegal value: "+value+" (not an integer or Long)");
                    if (typeof offset !== 'number' || offset % 1 !== 0)
                        throw TypeError("Illegal offset: "+offset+" (not an integer)");
                    offset >>>= 0;
                    if (offset < 0 || offset + 0 > this.buffer.byteLength)
                        throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
                }
                if (typeof value === 'number')
                    value = Long.fromNumber(value, false);
                else if (typeof value === 'string')
                    value = Long.fromString(value, false);
                else if (value.unsigned !== false) value = value.toSigned();
                var size = ByteBuffer.calculateVarint64(value),
                    part0 = value.toInt() >>> 0,
                    part1 = value.shiftRightUnsigned(28).toInt() >>> 0,
                    part2 = value.shiftRightUnsigned(56).toInt() >>> 0;
                offset += size;
                var capacity11 = this.buffer.byteLength;
                if (offset > capacity11)
                    this.resize((capacity11 *= 2) > offset ? capacity11 : offset);
                offset -= size;
                switch (size) {
                    case 10: this.view.setUint8(offset+9, (part2 >>>  7) & 0x01);
                    case 9 : this.view.setUint8(offset+8, size !== 9 ? (part2       ) | 0x80 : (part2       ) & 0x7F);
                    case 8 : this.view.setUint8(offset+7, size !== 8 ? (part1 >>> 21) | 0x80 : (part1 >>> 21) & 0x7F);
                    case 7 : this.view.setUint8(offset+6, size !== 7 ? (part1 >>> 14) | 0x80 : (part1 >>> 14) & 0x7F);
                    case 6 : this.view.setUint8(offset+5, size !== 6 ? (part1 >>>  7) | 0x80 : (part1 >>>  7) & 0x7F);
                    case 5 : this.view.setUint8(offset+4, size !== 5 ? (part1       ) | 0x80 : (part1       ) & 0x7F);
                    case 4 : this.view.setUint8(offset+3, size !== 4 ? (part0 >>> 21) | 0x80 : (part0 >>> 21) & 0x7F);
                    case 3 : this.view.setUint8(offset+2, size !== 3 ? (part0 >>> 14) | 0x80 : (part0 >>> 14) & 0x7F);
                    case 2 : this.view.setUint8(offset+1, size !== 2 ? (part0 >>>  7) | 0x80 : (part0 >>>  7) & 0x7F);
                    case 1 : this.view.setUint8(offset  , size !== 1 ? (part0       ) | 0x80 : (part0       ) & 0x7F);
                }
                if (relative) {
                    this.offset += size;
                    return this;
                } else {
                    return size;
                }
            };

            /**
             * Writes a zig-zag encoded 64bit base 128 variable-length integer.
             * @param {number|Long} value Value to write
             * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
             *  written if omitted.
             * @returns {!ByteBuffer|number} `this` if offset is omitted, else the actual number of bytes written.
             * @expose
             */
            ByteBufferPrototype.writeVarint64ZigZag = function(value, offset) {
                return this.writeVarint64(ByteBuffer.zigZagEncode64(value), offset);
            };

            /**
             * Reads a 64bit base 128 variable-length integer. Requires Long.js.
             * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
             *  read if omitted.
             * @returns {!Long|!{value: Long, length: number}} The value read if offset is omitted, else the value read and
             *  the actual number of bytes read.
             * @throws {Error} If it's not a valid varint
             * @expose
             */
            ByteBufferPrototype.readVarint64 = function(offset) {
                var relative = typeof offset === 'undefined';
                if (relative) offset = this.offset;
                if (!this.noAssert) {
                    if (typeof offset !== 'number' || offset % 1 !== 0)
                        throw TypeError("Illegal offset: "+offset+" (not an integer)");
                    offset >>>= 0;
                    if (offset < 0 || offset + 1 > this.buffer.byteLength)
                        throw RangeError("Illegal offset: 0 <= "+offset+" (+"+1+") <= "+this.buffer.byteLength);
                }
                // ref: src/google/protobuf/io/coded_stream.cc
                var start = offset,
                    part0 = 0,
                    part1 = 0,
                    part2 = 0,
                    b  = 0;
                b = this.view.getUint8(offset++); part0  = (b & 0x7F)      ; if (b & 0x80) {
                b = this.view.getUint8(offset++); part0 |= (b & 0x7F) <<  7; if (b & 0x80) {
                b = this.view.getUint8(offset++); part0 |= (b & 0x7F) << 14; if (b & 0x80) {
                b = this.view.getUint8(offset++); part0 |= (b & 0x7F) << 21; if (b & 0x80) {
                b = this.view.getUint8(offset++); part1  = (b & 0x7F)      ; if (b & 0x80) {
                b = this.view.getUint8(offset++); part1 |= (b & 0x7F) <<  7; if (b & 0x80) {
                b = this.view.getUint8(offset++); part1 |= (b & 0x7F) << 14; if (b & 0x80) {
                b = this.view.getUint8(offset++); part1 |= (b & 0x7F) << 21; if (b & 0x80) {
                b = this.view.getUint8(offset++); part2  = (b & 0x7F)      ; if (b & 0x80) {
                b = this.view.getUint8(offset++); part2 |= (b & 0x7F) <<  7; if (b & 0x80) {
                throw Error("Buffer overrun"); }}}}}}}}}}
                var value = Long.fromBits(part0 | (part1 << 28), (part1 >>> 4) | (part2) << 24, false);
                if (relative) {
                    this.offset = offset;
                    return value;
                } else {
                    return {
                        'value': value,
                        'length': offset-start
                    };
                }
            };

            /**
             * Reads a zig-zag encoded 64bit base 128 variable-length integer. Requires Long.js.
             * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
             *  read if omitted.
             * @returns {!Long|!{value: Long, length: number}} The value read if offset is omitted, else the value read and
             *  the actual number of bytes read.
             * @throws {Error} If it's not a valid varint
             * @expose
             */
            ByteBufferPrototype.readVarint64ZigZag = function(offset) {
                var val = this.readVarint64(offset);
                if (val && val['value'] instanceof Long)
                    val["value"] = ByteBuffer.zigZagDecode64(val["value"]);
                else
                    val = ByteBuffer.zigZagDecode64(val);
                return val;
            };

        } // Long


        // types/strings/cstring

        /**
         * Writes a NULL-terminated UTF8 encoded string. For this to work the specified string must not contain any NULL
         *  characters itself.
         * @param {string} str String to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  contained in `str` + 1 if omitted.
         * @returns {!ByteBuffer|number} this if offset is omitted, else the actual number of bytes written
         * @expose
         */
        ByteBufferPrototype.writeCString = function(str, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            var i,
                k = str.length;
            if (!this.noAssert) {
                if (typeof str !== 'string')
                    throw TypeError("Illegal str: Not a string");
                for (i=0; i<k; ++i) {
                    if (str.charCodeAt(i) === 0)
                        throw RangeError("Illegal str: Contains NULL-characters");
                }
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            // UTF8 strings do not contain zero bytes in between except for the zero character, so:
            k = utfx.calculateUTF16asUTF8(stringSource(str))[1];
            offset += k+1;
            var capacity12 = this.buffer.byteLength;
            if (offset > capacity12)
                this.resize((capacity12 *= 2) > offset ? capacity12 : offset);
            offset -= k+1;
            utfx.encodeUTF16toUTF8(stringSource(str), function(b) {
                this.view.setUint8(offset++, b);
            }.bind(this));
            this.view.setUint8(offset++, 0);
            if (relative) {
                this.offset = offset;
                return this;
            }
            return k;
        };

        /**
         * Reads a NULL-terminated UTF8 encoded string. For this to work the string read must not contain any NULL characters
         *  itself.
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  read if omitted.
         * @returns {string|!{string: string, length: number}} The string read if offset is omitted, else the string
         *  read and the actual number of bytes read.
         * @expose
         */
        ByteBufferPrototype.readCString = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 1 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+1+") <= "+this.buffer.byteLength);
            }
            var start = offset,
                temp;
            // UTF8 strings do not contain zero bytes in between except for the zero character itself, so:
            var sd, b = -1;
            utfx.decodeUTF8toUTF16(function() {
                if (b === 0) return null;
                if (offset >= this.limit)
                    throw RangeError("Illegal range: Truncated data, "+offset+" < "+this.limit);
                return (b = this.view.getUint8(offset++)) === 0 ? null : b;
            }.bind(this), sd = stringDestination(), true);
            if (relative) {
                this.offset = offset;
                return sd();
            } else {
                return {
                    "string": sd(),
                    "length": offset - start
                };
            }
        };

        // types/strings/istring

        /**
         * Writes a length as uint32 prefixed UTF8 encoded string.
         * @param {string} str String to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  written if omitted.
         * @returns {!ByteBuffer|number} `this` if `offset` is omitted, else the actual number of bytes written
         * @expose
         * @see ByteBuffer#writeVarint32
         */
        ByteBufferPrototype.writeIString = function(str, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof str !== 'string')
                    throw TypeError("Illegal str: Not a string");
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            var start = offset,
                k;
            k = utfx.calculateUTF16asUTF8(stringSource(str), this.noAssert)[1];
            offset += 4+k;
            var capacity13 = this.buffer.byteLength;
            if (offset > capacity13)
                this.resize((capacity13 *= 2) > offset ? capacity13 : offset);
            offset -= 4+k;
            this.view.setUint32(offset, k, this.littleEndian);
            offset += 4;
            utfx.encodeUTF16toUTF8(stringSource(str), function(b) {
                this.view.setUint8(offset++, b);
            }.bind(this));
            if (offset !== start + 4 + k)
                throw RangeError("Illegal range: Truncated data, "+offset+" == "+(offset+4+k));
            if (relative) {
                this.offset = offset;
                return this;
            }
            return offset - start;
        };

        /**
         * Reads a length as uint32 prefixed UTF8 encoded string.
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  read if omitted.
         * @returns {string|!{string: string, length: number}} The string read if offset is omitted, else the string
         *  read and the actual number of bytes read.
         * @expose
         * @see ByteBuffer#readVarint32
         */
        ByteBufferPrototype.readIString = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 4 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+4+") <= "+this.buffer.byteLength);
            }
            var temp = 0,
                start = offset,
                str;
            temp = this.view.getUint32(offset, this.littleEndian);
            offset += 4;
            var k = offset + temp,
                sd;
            utfx.decodeUTF8toUTF16(function() {
                return offset < k ? this.view.getUint8(offset++) : null;
            }.bind(this), sd = stringDestination(), this.noAssert);
            str = sd();
            if (relative) {
                this.offset = offset;
                return str;
            } else {
                return {
                    'string': str,
                    'length': offset - start
                };
            }
        };

        // types/strings/utf8string

        /**
         * Metrics representing number of UTF8 characters. Evaluates to `c`.
         * @type {string}
         * @const
         * @expose
         */
        ByteBuffer.METRICS_CHARS = 'c';

        /**
         * Metrics representing number of bytes. Evaluates to `b`.
         * @type {string}
         * @const
         * @expose
         */
        ByteBuffer.METRICS_BYTES = 'b';

        /**
         * Writes an UTF8 encoded string.
         * @param {string} str String to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} if omitted.
         * @returns {!ByteBuffer|number} this if offset is omitted, else the actual number of bytes written.
         * @expose
         */
        ByteBufferPrototype.writeUTF8String = function(str, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            var k;
            var start = offset;
            k = utfx.calculateUTF16asUTF8(stringSource(str))[1];
            offset += k;
            var capacity14 = this.buffer.byteLength;
            if (offset > capacity14)
                this.resize((capacity14 *= 2) > offset ? capacity14 : offset);
            offset -= k;
            utfx.encodeUTF16toUTF8(stringSource(str), function(b) {
                this.view.setUint8(offset++, b);
            }.bind(this));
            if (relative) {
                this.offset = offset;
                return this;
            }
            return offset - start;
        };

        /**
         * Writes an UTF8 encoded string. This is an alias of {@link ByteBuffer#writeUTF8String}.
         * @function
         * @param {string} str String to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} if omitted.
         * @returns {!ByteBuffer|number} this if offset is omitted, else the actual number of bytes written.
         * @expose
         */
        ByteBufferPrototype.writeString = ByteBufferPrototype.writeUTF8String;

        /**
         * Calculates the number of UTF8 characters of a string. JavaScript itself uses UTF-16, so that a string's
         *  `length` property does not reflect its actual UTF8 size if it contains code points larger than 0xFFFF.
         * @function
         * @param {string} str String to calculate
         * @returns {number} Number of UTF8 characters
         * @expose
         */
        ByteBuffer.calculateUTF8Chars = function(str) {
            return utfx.calculateUTF16asUTF8(stringSource(str))[0];
        };

        /**
         * Calculates the number of UTF8 bytes of a string.
         * @function
         * @param {string} str String to calculate
         * @returns {number} Number of UTF8 bytes
         * @expose
         */
        ByteBuffer.calculateUTF8Bytes = function(str) {
            return utfx.calculateUTF16asUTF8(stringSource(str))[1];
        };

        /**
         * Reads an UTF8 encoded string.
         * @param {number} length Number of characters or bytes to read.
         * @param {string=} metrics Metrics specifying what `length` is meant to count. Defaults to
         *  {@link ByteBuffer.METRICS_CHARS}.
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  read if omitted.
         * @returns {string|!{string: string, length: number}} The string read if offset is omitted, else the string
         *  read and the actual number of bytes read.
         * @expose
         */
        ByteBufferPrototype.readUTF8String = function(length, metrics, offset) {
            if (typeof metrics === 'number') {
                offset = metrics;
                metrics = undefined;
            }
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (typeof metrics === 'undefined') metrics = ByteBuffer.METRICS_CHARS;
            if (!this.noAssert) {
                if (typeof length !== 'number' || length % 1 !== 0)
                    throw TypeError("Illegal length: "+length+" (not an integer)");
                length |= 0;
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            var i = 0,
                start = offset,
                sd;
            if (metrics === ByteBuffer.METRICS_CHARS) { // The same for node and the browser
                sd = stringDestination();
                utfx.decodeUTF8(function() {
                    return i < length && offset < this.limit ? this.view.getUint8(offset++) : null;
                }.bind(this), function(cp) {
                    ++i; utfx.UTF8toUTF16(cp, sd);
                }.bind(this));
                if (i !== length)
                    throw RangeError("Illegal range: Truncated data, "+i+" == "+length);
                if (relative) {
                    this.offset = offset;
                    return sd();
                } else {
                    return {
                        "string": sd(),
                        "length": offset - start
                    };
                }
            } else if (metrics === ByteBuffer.METRICS_BYTES) {
                if (!this.noAssert) {
                    if (typeof offset !== 'number' || offset % 1 !== 0)
                        throw TypeError("Illegal offset: "+offset+" (not an integer)");
                    offset >>>= 0;
                    if (offset < 0 || offset + length > this.buffer.byteLength)
                        throw RangeError("Illegal offset: 0 <= "+offset+" (+"+length+") <= "+this.buffer.byteLength);
                }
                var k = offset + length;
                utfx.decodeUTF8toUTF16(function() {
                    return offset < k ? this.view.getUint8(offset++) : null;
                }.bind(this), sd = stringDestination(), this.noAssert);
                if (offset !== k)
                    throw RangeError("Illegal range: Truncated data, "+offset+" == "+k);
                if (relative) {
                    this.offset = offset;
                    return sd();
                } else {
                    return {
                        'string': sd(),
                        'length': offset - start
                    };
                }
            } else
                throw TypeError("Unsupported metrics: "+metrics);
        };

        /**
         * Reads an UTF8 encoded string. This is an alias of {@link ByteBuffer#readUTF8String}.
         * @function
         * @param {number} length Number of characters or bytes to read
         * @param {number=} metrics Metrics specifying what `n` is meant to count. Defaults to
         *  {@link ByteBuffer.METRICS_CHARS}.
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  read if omitted.
         * @returns {string|!{string: string, length: number}} The string read if offset is omitted, else the string
         *  read and the actual number of bytes read.
         * @expose
         */
        ByteBufferPrototype.readString = ByteBufferPrototype.readUTF8String;

        // types/strings/vstring

        /**
         * Writes a length as varint32 prefixed UTF8 encoded string.
         * @param {string} str String to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  written if omitted.
         * @returns {!ByteBuffer|number} `this` if `offset` is omitted, else the actual number of bytes written
         * @expose
         * @see ByteBuffer#writeVarint32
         */
        ByteBufferPrototype.writeVString = function(str, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof str !== 'string')
                    throw TypeError("Illegal str: Not a string");
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            var start = offset,
                k, l;
            k = utfx.calculateUTF16asUTF8(stringSource(str), this.noAssert)[1];
            l = ByteBuffer.calculateVarint32(k);
            offset += l+k;
            var capacity15 = this.buffer.byteLength;
            if (offset > capacity15)
                this.resize((capacity15 *= 2) > offset ? capacity15 : offset);
            offset -= l+k;
            offset += this.writeVarint32(k, offset);
            utfx.encodeUTF16toUTF8(stringSource(str), function(b) {
                this.view.setUint8(offset++, b);
            }.bind(this));
            if (offset !== start+k+l)
                throw RangeError("Illegal range: Truncated data, "+offset+" == "+(offset+k+l));
            if (relative) {
                this.offset = offset;
                return this;
            }
            return offset - start;
        };

        /**
         * Reads a length as varint32 prefixed UTF8 encoded string.
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  read if omitted.
         * @returns {string|!{string: string, length: number}} The string read if offset is omitted, else the string
         *  read and the actual number of bytes read.
         * @expose
         * @see ByteBuffer#readVarint32
         */
        ByteBufferPrototype.readVString = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 1 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+1+") <= "+this.buffer.byteLength);
            }
            var temp = this.readVarint32(offset),
                start = offset,
                str;
            offset += temp['length'];
            temp = temp['value'];
            var k = offset + temp,
                sd = stringDestination();
            utfx.decodeUTF8toUTF16(function() {
                return offset < k ? this.view.getUint8(offset++) : null;
            }.bind(this), sd, this.noAssert);
            str = sd();
            if (relative) {
                this.offset = offset;
                return str;
            } else {
                return {
                    'string': str,
                    'length': offset - start
                };
            }
        };


        /**
         * Appends some data to this ByteBuffer. This will overwrite any contents behind the specified offset up to the appended
         *  data's length.
         * @param {!ByteBuffer|!ArrayBuffer|!Uint8Array|string} source Data to append. If `source` is a ByteBuffer, its offsets
         *  will be modified according to the performed read operation.
         * @param {(string|number)=} encoding Encoding if `data` is a string ("base64", "hex", "binary", defaults to "utf8")
         * @param {number=} offset Offset to append at. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  read if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         * @example A relative `<01 02>03.append(<04 05>)` will result in `<01 02 04 05>, 04 05|`
         * @example An absolute `<01 02>03.append(04 05>, 1)` will result in `<01 04>05, 04 05|`
         */
        ByteBufferPrototype.append = function(source, encoding, offset) {
            if (typeof encoding === 'number' || typeof encoding !== 'string') {
                offset = encoding;
                encoding = undefined;
            }
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            if (!(source instanceof ByteBuffer))
                source = ByteBuffer.wrap(source, encoding);
            var length = source.limit - source.offset;
            if (length <= 0) return this; // Nothing to append
            offset += length;
            var capacity16 = this.buffer.byteLength;
            if (offset > capacity16)
                this.resize((capacity16 *= 2) > offset ? capacity16 : offset);
            offset -= length;
            new Uint8Array(this.buffer, offset).set(new Uint8Array(source.buffer).subarray(source.offset, source.limit));
            source.offset += length;
            if (relative) this.offset += length;
            return this;
        };

        /**
         * Appends this ByteBuffer's contents to another ByteBuffer. This will overwrite any contents at and after the
            specified offset up to the length of this ByteBuffer's data.
         * @param {!ByteBuffer} target Target ByteBuffer
         * @param {number=} offset Offset to append to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  read if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         * @see ByteBuffer#append
         */
        ByteBufferPrototype.appendTo = function(target, offset) {
            target.append(this, offset);
            return this;
        };

        /**
         * Enables or disables assertions of argument types and offsets. Assertions are enabled by default but you can opt to
         *  disable them if your code already makes sure that everything is valid.
         * @param {boolean} assert `true` to enable assertions, otherwise `false`
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.assert = function(assert) {
            this.noAssert = !assert;
            return this;
        };

        /**
         * Gets the capacity of this ByteBuffer's backing buffer.
         * @returns {number} Capacity of the backing buffer
         * @expose
         */
        ByteBufferPrototype.capacity = function() {
            return this.buffer.byteLength;
        };

        /**
         * Clears this ByteBuffer's offsets by setting {@link ByteBuffer#offset} to `0` and {@link ByteBuffer#limit} to the
         *  backing buffer's capacity. Discards {@link ByteBuffer#markedOffset}.
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.clear = function() {
            this.offset = 0;
            this.limit = this.buffer.byteLength;
            this.markedOffset = -1;
            return this;
        };

        /**
         * Creates a cloned instance of this ByteBuffer, preset with this ByteBuffer's values for {@link ByteBuffer#offset},
         *  {@link ByteBuffer#markedOffset} and {@link ByteBuffer#limit}.
         * @param {boolean=} copy Whether to copy the backing buffer or to return another view on the same, defaults to `false`
         * @returns {!ByteBuffer} Cloned instance
         * @expose
         */
        ByteBufferPrototype.clone = function(copy) {
            var bb = new ByteBuffer(0, this.littleEndian, this.noAssert);
            if (copy) {
                var buffer = new ArrayBuffer(this.buffer.byteLength);
                new Uint8Array(buffer).set(this.buffer);
                bb.buffer = buffer;
                bb.view = new DataView(buffer);
            } else {
                bb.buffer = this.buffer;
                bb.view = this.view;
            }
            bb.offset = this.offset;
            bb.markedOffset = this.markedOffset;
            bb.limit = this.limit;
            return bb;
        };

        /**
         * Compacts this ByteBuffer to be backed by a {@link ByteBuffer#buffer} of its contents' length. Contents are the bytes
         *  between {@link ByteBuffer#offset} and {@link ByteBuffer#limit}. Will set `offset = 0` and `limit = capacity` and
         *  adapt {@link ByteBuffer#markedOffset} to the same relative position if set.
         * @param {number=} begin Offset to start at, defaults to {@link ByteBuffer#offset}
         * @param {number=} end Offset to end at, defaults to {@link ByteBuffer#limit}
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.compact = function(begin, end) {
            if (typeof begin === 'undefined') begin = this.offset;
            if (typeof end === 'undefined') end = this.limit;
            if (!this.noAssert) {
                if (typeof begin !== 'number' || begin % 1 !== 0)
                    throw TypeError("Illegal begin: Not an integer");
                begin >>>= 0;
                if (typeof end !== 'number' || end % 1 !== 0)
                    throw TypeError("Illegal end: Not an integer");
                end >>>= 0;
                if (begin < 0 || begin > end || end > this.buffer.byteLength)
                    throw RangeError("Illegal range: 0 <= "+begin+" <= "+end+" <= "+this.buffer.byteLength);
            }
            if (begin === 0 && end === this.buffer.byteLength)
                return this; // Already compacted
            var len = end - begin;
            if (len === 0) {
                this.buffer = EMPTY_BUFFER;
                this.view = null;
                if (this.markedOffset >= 0) this.markedOffset -= begin;
                this.offset = 0;
                this.limit = 0;
                return this;
            }
            var buffer = new ArrayBuffer(len);
            new Uint8Array(buffer).set(new Uint8Array(this.buffer).subarray(begin, end));
            this.buffer = buffer;
            this.view = new DataView(buffer);
            if (this.markedOffset >= 0) this.markedOffset -= begin;
            this.offset = 0;
            this.limit = len;
            return this;
        };

        /**
         * Creates a copy of this ByteBuffer's contents. Contents are the bytes between {@link ByteBuffer#offset} and
         *  {@link ByteBuffer#limit}.
         * @param {number=} begin Begin offset, defaults to {@link ByteBuffer#offset}.
         * @param {number=} end End offset, defaults to {@link ByteBuffer#limit}.
         * @returns {!ByteBuffer} Copy
         * @expose
         */
        ByteBufferPrototype.copy = function(begin, end) {
            if (typeof begin === 'undefined') begin = this.offset;
            if (typeof end === 'undefined') end = this.limit;
            if (!this.noAssert) {
                if (typeof begin !== 'number' || begin % 1 !== 0)
                    throw TypeError("Illegal begin: Not an integer");
                begin >>>= 0;
                if (typeof end !== 'number' || end % 1 !== 0)
                    throw TypeError("Illegal end: Not an integer");
                end >>>= 0;
                if (begin < 0 || begin > end || end > this.buffer.byteLength)
                    throw RangeError("Illegal range: 0 <= "+begin+" <= "+end+" <= "+this.buffer.byteLength);
            }
            if (begin === end)
                return new ByteBuffer(0, this.littleEndian, this.noAssert);
            var capacity = end - begin,
                bb = new ByteBuffer(capacity, this.littleEndian, this.noAssert);
            bb.offset = 0;
            bb.limit = capacity;
            if (bb.markedOffset >= 0) bb.markedOffset -= begin;
            this.copyTo(bb, 0, begin, end);
            return bb;
        };

        /**
         * Copies this ByteBuffer's contents to another ByteBuffer. Contents are the bytes between {@link ByteBuffer#offset} and
         *  {@link ByteBuffer#limit}.
         * @param {!ByteBuffer} target Target ByteBuffer
         * @param {number=} targetOffset Offset to copy to. Will use and increase the target's {@link ByteBuffer#offset}
         *  by the number of bytes copied if omitted.
         * @param {number=} sourceOffset Offset to start copying from. Will use and increase {@link ByteBuffer#offset} by the
         *  number of bytes copied if omitted.
         * @param {number=} sourceLimit Offset to end copying from, defaults to {@link ByteBuffer#limit}
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.copyTo = function(target, targetOffset, sourceOffset, sourceLimit) {
            var relative,
                targetRelative;
            if (!this.noAssert) {
                if (!ByteBuffer.isByteBuffer(target))
                    throw TypeError("Illegal target: Not a ByteBuffer");
            }
            targetOffset = (targetRelative = typeof targetOffset === 'undefined') ? target.offset : targetOffset | 0;
            sourceOffset = (relative = typeof sourceOffset === 'undefined') ? this.offset : sourceOffset | 0;
            sourceLimit = typeof sourceLimit === 'undefined' ? this.limit : sourceLimit | 0;

            if (targetOffset < 0 || targetOffset > target.buffer.byteLength)
                throw RangeError("Illegal target range: 0 <= "+targetOffset+" <= "+target.buffer.byteLength);
            if (sourceOffset < 0 || sourceLimit > this.buffer.byteLength)
                throw RangeError("Illegal source range: 0 <= "+sourceOffset+" <= "+this.buffer.byteLength);

            var len = sourceLimit - sourceOffset;
            if (len === 0)
                return target; // Nothing to copy

            target.ensureCapacity(targetOffset + len);

            new Uint8Array(target.buffer).set(new Uint8Array(this.buffer).subarray(sourceOffset, sourceLimit), targetOffset);

            if (relative) this.offset += len;
            if (targetRelative) target.offset += len;

            return this;
        };

        /**
         * Makes sure that this ByteBuffer is backed by a {@link ByteBuffer#buffer} of at least the specified capacity. If the
         *  current capacity is exceeded, it will be doubled. If double the current capacity is less than the required capacity,
         *  the required capacity will be used instead.
         * @param {number} capacity Required capacity
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.ensureCapacity = function(capacity) {
            var current = this.buffer.byteLength;
            if (current < capacity)
                return this.resize((current *= 2) > capacity ? current : capacity);
            return this;
        };

        /**
         * Overwrites this ByteBuffer's contents with the specified value. Contents are the bytes between
         *  {@link ByteBuffer#offset} and {@link ByteBuffer#limit}.
         * @param {number|string} value Byte value to fill with. If given as a string, the first character is used.
         * @param {number=} begin Begin offset. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  written if omitted. defaults to {@link ByteBuffer#offset}.
         * @param {number=} end End offset, defaults to {@link ByteBuffer#limit}.
         * @returns {!ByteBuffer} this
         * @expose
         * @example `someByteBuffer.clear().fill(0)` fills the entire backing buffer with zeroes
         */
        ByteBufferPrototype.fill = function(value, begin, end) {
            var relative = typeof begin === 'undefined';
            if (relative) begin = this.offset;
            if (typeof value === 'string' && value.length > 0)
                value = value.charCodeAt(0);
            if (typeof begin === 'undefined') begin = this.offset;
            if (typeof end === 'undefined') end = this.limit;
            if (!this.noAssert) {
                if (typeof value !== 'number' || value % 1 !== 0)
                    throw TypeError("Illegal value: "+value+" (not an integer)");
                value |= 0;
                if (typeof begin !== 'number' || begin % 1 !== 0)
                    throw TypeError("Illegal begin: Not an integer");
                begin >>>= 0;
                if (typeof end !== 'number' || end % 1 !== 0)
                    throw TypeError("Illegal end: Not an integer");
                end >>>= 0;
                if (begin < 0 || begin > end || end > this.buffer.byteLength)
                    throw RangeError("Illegal range: 0 <= "+begin+" <= "+end+" <= "+this.buffer.byteLength);
            }
            if (begin >= end)
                return this; // Nothing to fill
            while (begin < end) this.view.setUint8(begin++, value);
            if (relative) this.offset = begin;
            return this;
        };

        /**
         * Makes this ByteBuffer ready for a new sequence of write or relative read operations. Sets `limit = offset` and
         *  `offset = 0`. Make sure always to flip a ByteBuffer when all relative read or write operations are complete.
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.flip = function() {
            this.limit = this.offset;
            this.offset = 0;
            return this;
        };
        /**
         * Marks an offset on this ByteBuffer to be used later.
         * @param {number=} offset Offset to mark. Defaults to {@link ByteBuffer#offset}.
         * @returns {!ByteBuffer} this
         * @throws {TypeError} If `offset` is not a valid number
         * @throws {RangeError} If `offset` is out of bounds
         * @see ByteBuffer#reset
         * @expose
         */
        ByteBufferPrototype.mark = function(offset) {
            offset = typeof offset === 'undefined' ? this.offset : offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            this.markedOffset = offset;
            return this;
        };
        /**
         * Sets the byte order.
         * @param {boolean} littleEndian `true` for little endian byte order, `false` for big endian
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.order = function(littleEndian) {
            if (!this.noAssert) {
                if (typeof littleEndian !== 'boolean')
                    throw TypeError("Illegal littleEndian: Not a boolean");
            }
            this.littleEndian = !!littleEndian;
            return this;
        };

        /**
         * Switches (to) little endian byte order.
         * @param {boolean=} littleEndian Defaults to `true`, otherwise uses big endian
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.LE = function(littleEndian) {
            this.littleEndian = typeof littleEndian !== 'undefined' ? !!littleEndian : true;
            return this;
        };

        /**
         * Switches (to) big endian byte order.
         * @param {boolean=} bigEndian Defaults to `true`, otherwise uses little endian
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.BE = function(bigEndian) {
            this.littleEndian = typeof bigEndian !== 'undefined' ? !bigEndian : false;
            return this;
        };
        /**
         * Prepends some data to this ByteBuffer. This will overwrite any contents before the specified offset up to the
         *  prepended data's length. If there is not enough space available before the specified `offset`, the backing buffer
         *  will be resized and its contents moved accordingly.
         * @param {!ByteBuffer|string|!ArrayBuffer} source Data to prepend. If `source` is a ByteBuffer, its offset will be
         *  modified according to the performed read operation.
         * @param {(string|number)=} encoding Encoding if `data` is a string ("base64", "hex", "binary", defaults to "utf8")
         * @param {number=} offset Offset to prepend at. Will use and decrease {@link ByteBuffer#offset} by the number of bytes
         *  prepended if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         * @example A relative `00<01 02 03>.prepend(<04 05>)` results in `<04 05 01 02 03>, 04 05|`
         * @example An absolute `00<01 02 03>.prepend(<04 05>, 2)` results in `04<05 02 03>, 04 05|`
         */
        ByteBufferPrototype.prepend = function(source, encoding, offset) {
            if (typeof encoding === 'number' || typeof encoding !== 'string') {
                offset = encoding;
                encoding = undefined;
            }
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            if (!(source instanceof ByteBuffer))
                source = ByteBuffer.wrap(source, encoding);
            var len = source.limit - source.offset;
            if (len <= 0) return this; // Nothing to prepend
            var diff = len - offset;
            var arrayView;
            if (diff > 0) { // Not enough space before offset, so resize + move
                var buffer = new ArrayBuffer(this.buffer.byteLength + diff);
                arrayView = new Uint8Array(buffer);
                arrayView.set(new Uint8Array(this.buffer).subarray(offset, this.buffer.byteLength), len);
                this.buffer = buffer;
                this.view = new DataView(buffer);
                this.offset += diff;
                if (this.markedOffset >= 0) this.markedOffset += diff;
                this.limit += diff;
                offset += diff;
            } else {
                arrayView = new Uint8Array(this.buffer);
            }
            arrayView.set(new Uint8Array(source.buffer).subarray(source.offset, source.limit), offset - len);
            source.offset = source.limit;
            if (relative)
                this.offset -= len;
            return this;
        };

        /**
         * Prepends this ByteBuffer to another ByteBuffer. This will overwrite any contents before the specified offset up to the
         *  prepended data's length. If there is not enough space available before the specified `offset`, the backing buffer
         *  will be resized and its contents moved accordingly.
         * @param {!ByteBuffer} target Target ByteBuffer
         * @param {number=} offset Offset to prepend at. Will use and decrease {@link ByteBuffer#offset} by the number of bytes
         *  prepended if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         * @see ByteBuffer#prepend
         */
        ByteBufferPrototype.prependTo = function(target, offset) {
            target.prepend(this, offset);
            return this;
        };
        /**
         * Prints debug information about this ByteBuffer's contents.
         * @param {function(string)=} out Output function to call, defaults to console.log
         * @expose
         */
        ByteBufferPrototype.printDebug = function(out) {
            if (typeof out !== 'function') out = console.log.bind(console);
            out(
                this.toString()+"\n"+
                "-------------------------------------------------------------------\n"+
                this.toDebug(/* columns */ true)
            );
        };

        /**
         * Gets the number of remaining readable bytes. Contents are the bytes between {@link ByteBuffer#offset} and
         *  {@link ByteBuffer#limit}, so this returns `limit - offset`.
         * @returns {number} Remaining readable bytes. May be negative if `offset > limit`.
         * @expose
         */
        ByteBufferPrototype.remaining = function() {
            return this.limit - this.offset;
        };
        /**
         * Resets this ByteBuffer's {@link ByteBuffer#offset}. If an offset has been marked through {@link ByteBuffer#mark}
         *  before, `offset` will be set to {@link ByteBuffer#markedOffset}, which will then be discarded. If no offset has been
         *  marked, sets `offset = 0`.
         * @returns {!ByteBuffer} this
         * @see ByteBuffer#mark
         * @expose
         */
        ByteBufferPrototype.reset = function() {
            if (this.markedOffset >= 0) {
                this.offset = this.markedOffset;
                this.markedOffset = -1;
            } else {
                this.offset = 0;
            }
            return this;
        };
        /**
         * Resizes this ByteBuffer to be backed by a buffer of at least the given capacity. Will do nothing if already that
         *  large or larger.
         * @param {number} capacity Capacity required
         * @returns {!ByteBuffer} this
         * @throws {TypeError} If `capacity` is not a number
         * @throws {RangeError} If `capacity < 0`
         * @expose
         */
        ByteBufferPrototype.resize = function(capacity) {
            if (!this.noAssert) {
                if (typeof capacity !== 'number' || capacity % 1 !== 0)
                    throw TypeError("Illegal capacity: "+capacity+" (not an integer)");
                capacity |= 0;
                if (capacity < 0)
                    throw RangeError("Illegal capacity: 0 <= "+capacity);
            }
            if (this.buffer.byteLength < capacity) {
                var buffer = new ArrayBuffer(capacity);
                new Uint8Array(buffer).set(new Uint8Array(this.buffer));
                this.buffer = buffer;
                this.view = new DataView(buffer);
            }
            return this;
        };
        /**
         * Reverses this ByteBuffer's contents.
         * @param {number=} begin Offset to start at, defaults to {@link ByteBuffer#offset}
         * @param {number=} end Offset to end at, defaults to {@link ByteBuffer#limit}
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.reverse = function(begin, end) {
            if (typeof begin === 'undefined') begin = this.offset;
            if (typeof end === 'undefined') end = this.limit;
            if (!this.noAssert) {
                if (typeof begin !== 'number' || begin % 1 !== 0)
                    throw TypeError("Illegal begin: Not an integer");
                begin >>>= 0;
                if (typeof end !== 'number' || end % 1 !== 0)
                    throw TypeError("Illegal end: Not an integer");
                end >>>= 0;
                if (begin < 0 || begin > end || end > this.buffer.byteLength)
                    throw RangeError("Illegal range: 0 <= "+begin+" <= "+end+" <= "+this.buffer.byteLength);
            }
            if (begin === end)
                return this; // Nothing to reverse
            Array.prototype.reverse.call(new Uint8Array(this.buffer).subarray(begin, end));
            this.view = new DataView(this.buffer); // FIXME: Why exactly is this necessary?
            return this;
        };
        /**
         * Skips the next `length` bytes. This will just advance
         * @param {number} length Number of bytes to skip. May also be negative to move the offset back.
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.skip = function(length) {
            if (!this.noAssert) {
                if (typeof length !== 'number' || length % 1 !== 0)
                    throw TypeError("Illegal length: "+length+" (not an integer)");
                length |= 0;
            }
            var offset = this.offset + length;
            if (!this.noAssert) {
                if (offset < 0 || offset > this.buffer.byteLength)
                    throw RangeError("Illegal length: 0 <= "+this.offset+" + "+length+" <= "+this.buffer.byteLength);
            }
            this.offset = offset;
            return this;
        };

        /**
         * Slices this ByteBuffer by creating a cloned instance with `offset = begin` and `limit = end`.
         * @param {number=} begin Begin offset, defaults to {@link ByteBuffer#offset}.
         * @param {number=} end End offset, defaults to {@link ByteBuffer#limit}.
         * @returns {!ByteBuffer} Clone of this ByteBuffer with slicing applied, backed by the same {@link ByteBuffer#buffer}
         * @expose
         */
        ByteBufferPrototype.slice = function(begin, end) {
            if (typeof begin === 'undefined') begin = this.offset;
            if (typeof end === 'undefined') end = this.limit;
            if (!this.noAssert) {
                if (typeof begin !== 'number' || begin % 1 !== 0)
                    throw TypeError("Illegal begin: Not an integer");
                begin >>>= 0;
                if (typeof end !== 'number' || end % 1 !== 0)
                    throw TypeError("Illegal end: Not an integer");
                end >>>= 0;
                if (begin < 0 || begin > end || end > this.buffer.byteLength)
                    throw RangeError("Illegal range: 0 <= "+begin+" <= "+end+" <= "+this.buffer.byteLength);
            }
            var bb = this.clone();
            bb.offset = begin;
            bb.limit = end;
            return bb;
        };
        /**
         * Returns a copy of the backing buffer that contains this ByteBuffer's contents. Contents are the bytes between
         *  {@link ByteBuffer#offset} and {@link ByteBuffer#limit}. Will transparently {@link ByteBuffer#flip} this
         *  ByteBuffer if `offset > limit` but the actual offsets remain untouched.
         * @param {boolean=} forceCopy If `true` returns a copy, otherwise returns a view referencing the same memory if
         *  possible. Defaults to `false`
         * @returns {!ArrayBuffer} Contents as an ArrayBuffer
         * @expose
         */
        ByteBufferPrototype.toBuffer = function(forceCopy) {
            var offset = this.offset,
                limit = this.limit;
            if (offset > limit) {
                var t = offset;
                offset = limit;
                limit = t;
            }
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: Not an integer");
                offset >>>= 0;
                if (typeof limit !== 'number' || limit % 1 !== 0)
                    throw TypeError("Illegal limit: Not an integer");
                limit >>>= 0;
                if (offset < 0 || offset > limit || limit > this.buffer.byteLength)
                    throw RangeError("Illegal range: 0 <= "+offset+" <= "+limit+" <= "+this.buffer.byteLength);
            }
            // NOTE: It's not possible to have another ArrayBuffer reference the same memory as the backing buffer. This is
            // possible with Uint8Array#subarray only, but we have to return an ArrayBuffer by contract. So:
            if (!forceCopy && offset === 0 && limit === this.buffer.byteLength) {
                return this.buffer;
            }
            if (offset === limit) {
                return EMPTY_BUFFER;
            }
            var buffer = new ArrayBuffer(limit - offset);
            new Uint8Array(buffer).set(new Uint8Array(this.buffer).subarray(offset, limit), 0);
            return buffer;
        };

        /**
         * Returns a raw buffer compacted to contain this ByteBuffer's contents. Contents are the bytes between
         *  {@link ByteBuffer#offset} and {@link ByteBuffer#limit}. Will transparently {@link ByteBuffer#flip} this
         *  ByteBuffer if `offset > limit` but the actual offsets remain untouched. This is an alias of
         *  {@link ByteBuffer#toBuffer}.
         * @function
         * @param {boolean=} forceCopy If `true` returns a copy, otherwise returns a view referencing the same memory.
         *  Defaults to `false`
         * @returns {!ArrayBuffer} Contents as an ArrayBuffer
         * @expose
         */
        ByteBufferPrototype.toArrayBuffer = ByteBufferPrototype.toBuffer;


        /**
         * Converts the ByteBuffer's contents to a string.
         * @param {string=} encoding Output encoding. Returns an informative string representation if omitted but also allows
         *  direct conversion to "utf8", "hex", "base64" and "binary" encoding. "debug" returns a hex representation with
         *  highlighted offsets.
         * @param {number=} begin Offset to begin at, defaults to {@link ByteBuffer#offset}
         * @param {number=} end Offset to end at, defaults to {@link ByteBuffer#limit}
         * @returns {string} String representation
         * @throws {Error} If `encoding` is invalid
         * @expose
         */
        ByteBufferPrototype.toString = function(encoding, begin, end) {
            if (typeof encoding === 'undefined')
                return "ByteBufferAB(offset="+this.offset+",markedOffset="+this.markedOffset+",limit="+this.limit+",capacity="+this.capacity()+")";
            if (typeof encoding === 'number')
                encoding = "utf8",
                begin = encoding,
                end = begin;
            switch (encoding) {
                case "utf8":
                    return this.toUTF8(begin, end);
                case "base64":
                    return this.toBase64(begin, end);
                case "hex":
                    return this.toHex(begin, end);
                case "binary":
                    return this.toBinary(begin, end);
                case "debug":
                    return this.toDebug();
                case "columns":
                    return this.toColumns();
                default:
                    throw Error("Unsupported encoding: "+encoding);
            }
        };

        // lxiv-embeddable

        /**
         * lxiv-embeddable (c) 2014 Daniel Wirtz <dcode@dcode.io>
         * Released under the Apache License, Version 2.0
         * see: https://github.com/dcodeIO/lxiv for details
         */
        var lxiv = function() {
            "use strict";

            /**
             * lxiv namespace.
             * @type {!Object.<string,*>}
             * @exports lxiv
             */
            var lxiv = {};

            /**
             * Character codes for output.
             * @type {!Array.<number>}
             * @inner
             */
            var aout = [
                65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80,
                81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102,
                103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118,
                119, 120, 121, 122, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 43, 47
            ];

            /**
             * Character codes for input.
             * @type {!Array.<number>}
             * @inner
             */
            var ain = [];
            for (var i=0, k=aout.length; i<k; ++i)
                ain[aout[i]] = i;

            /**
             * Encodes bytes to base64 char codes.
             * @param {!function():number|null} src Bytes source as a function returning the next byte respectively `null` if
             *  there are no more bytes left.
             * @param {!function(number)} dst Characters destination as a function successively called with each encoded char
             *  code.
             */
            lxiv.encode = function(src, dst) {
                var b, t;
                while ((b = src()) !== null) {
                    dst(aout[(b>>2)&0x3f]);
                    t = (b&0x3)<<4;
                    if ((b = src()) !== null) {
                        t |= (b>>4)&0xf;
                        dst(aout[(t|((b>>4)&0xf))&0x3f]);
                        t = (b&0xf)<<2;
                        if ((b = src()) !== null)
                            dst(aout[(t|((b>>6)&0x3))&0x3f]),
                            dst(aout[b&0x3f]);
                        else
                            dst(aout[t&0x3f]),
                            dst(61);
                    } else
                        dst(aout[t&0x3f]),
                        dst(61),
                        dst(61);
                }
            };

            /**
             * Decodes base64 char codes to bytes.
             * @param {!function():number|null} src Characters source as a function returning the next char code respectively
             *  `null` if there are no more characters left.
             * @param {!function(number)} dst Bytes destination as a function successively called with the next byte.
             * @throws {Error} If a character code is invalid
             */
            lxiv.decode = function(src, dst) {
                var c, t1, t2;
                function fail(c) {
                    throw Error("Illegal character code: "+c);
                }
                while ((c = src()) !== null) {
                    t1 = ain[c];
                    if (typeof t1 === 'undefined') fail(c);
                    if ((c = src()) !== null) {
                        t2 = ain[c];
                        if (typeof t2 === 'undefined') fail(c);
                        dst((t1<<2)>>>0|(t2&0x30)>>4);
                        if ((c = src()) !== null) {
                            t1 = ain[c];
                            if (typeof t1 === 'undefined')
                                if (c === 61) break; else fail(c);
                            dst(((t2&0xf)<<4)>>>0|(t1&0x3c)>>2);
                            if ((c = src()) !== null) {
                                t2 = ain[c];
                                if (typeof t2 === 'undefined')
                                    if (c === 61) break; else fail(c);
                                dst(((t1&0x3)<<6)>>>0|t2);
                            }
                        }
                    }
                }
            };

            /**
             * Tests if a string is valid base64.
             * @param {string} str String to test
             * @returns {boolean} `true` if valid, otherwise `false`
             */
            lxiv.test = function(str) {
                return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(str);
            };

            return lxiv;
        }();

        // encodings/base64

        /**
         * Encodes this ByteBuffer's contents to a base64 encoded string.
         * @param {number=} begin Offset to begin at, defaults to {@link ByteBuffer#offset}.
         * @param {number=} end Offset to end at, defaults to {@link ByteBuffer#limit}.
         * @returns {string} Base64 encoded string
         * @expose
         */
        ByteBufferPrototype.toBase64 = function(begin, end) {
            if (typeof begin === 'undefined')
                begin = this.offset;
            if (typeof end === 'undefined')
                end = this.limit;
            if (!this.noAssert) {
                if (typeof begin !== 'number' || begin % 1 !== 0)
                    throw TypeError("Illegal begin: Not an integer");
                begin >>>= 0;
                if (typeof end !== 'number' || end % 1 !== 0)
                    throw TypeError("Illegal end: Not an integer");
                end >>>= 0;
                if (begin < 0 || begin > end || end > this.buffer.byteLength)
                    throw RangeError("Illegal range: 0 <= "+begin+" <= "+end+" <= "+this.buffer.byteLength);
            }
            var sd; lxiv.encode(function() {
                return begin < end ? this.view.getUint8(begin++) : null;
            }.bind(this), sd = stringDestination());
            return sd();
        };

        /**
         * Decodes a base64 encoded string to a ByteBuffer.
         * @param {string} str String to decode
         * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
         *  {@link ByteBuffer.DEFAULT_ENDIAN}.
         * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
         *  {@link ByteBuffer.DEFAULT_NOASSERT}.
         * @returns {!ByteBuffer} ByteBuffer
         * @expose
         */
        ByteBuffer.fromBase64 = function(str, littleEndian, noAssert) {
            if (!noAssert) {
                if (typeof str !== 'string')
                    throw TypeError("Illegal str: Not a string");
                if (str.length % 4 !== 0)
                    throw TypeError("Illegal str: Length not a multiple of 4");
            }
            var bb = new ByteBuffer(str.length/4*3, littleEndian, noAssert),
                i = 0;
            lxiv.decode(stringSource(str), function(b) {
                bb.view.setUint8(i++, b);
            });
            bb.limit = i;
            return bb;
        };

        /**
         * Encodes a binary string to base64 like `window.btoa` does.
         * @param {string} str Binary string
         * @returns {string} Base64 encoded string
         * @see https://developer.mozilla.org/en-US/docs/Web/API/Window.btoa
         * @expose
         */
        ByteBuffer.btoa = function(str) {
            return ByteBuffer.fromBinary(str).toBase64();
        };

        /**
         * Decodes a base64 encoded string to binary like `window.atob` does.
         * @param {string} b64 Base64 encoded string
         * @returns {string} Binary string
         * @see https://developer.mozilla.org/en-US/docs/Web/API/Window.atob
         * @expose
         */
        ByteBuffer.atob = function(b64) {
            return ByteBuffer.fromBase64(b64).toBinary();
        };

        // encodings/binary

        /**
         * Encodes this ByteBuffer to a binary encoded string, that is using only characters 0x00-0xFF as bytes.
         * @param {number=} begin Offset to begin at. Defaults to {@link ByteBuffer#offset}.
         * @param {number=} end Offset to end at. Defaults to {@link ByteBuffer#limit}.
         * @returns {string} Binary encoded string
         * @throws {RangeError} If `offset > limit`
         * @expose
         */
        ByteBufferPrototype.toBinary = function(begin, end) {
            begin = typeof begin === 'undefined' ? this.offset : begin;
            end = typeof end === 'undefined' ? this.limit : end;
            if (!this.noAssert) {
                if (typeof begin !== 'number' || begin % 1 !== 0)
                    throw TypeError("Illegal begin: Not an integer");
                begin >>>= 0;
                if (typeof end !== 'number' || end % 1 !== 0)
                    throw TypeError("Illegal end: Not an integer");
                end >>>= 0;
                if (begin < 0 || begin > end || end > this.buffer.byteLength)
                    throw RangeError("Illegal range: 0 <= "+begin+" <= "+end+" <= "+this.buffer.byteLength);
            }
            if (begin === end)
                return "";
            var cc = [], pt = [];
            while (begin < end) {
                cc.push(this.view.getUint8(begin++));
                if (cc.length >= 1024)
                    pt.push(String.fromCharCode.apply(String, cc)),
                    cc = [];
            }
            return pt.join('') + String.fromCharCode.apply(String, cc);
        };

        /**
         * Decodes a binary encoded string, that is using only characters 0x00-0xFF as bytes, to a ByteBuffer.
         * @param {string} str String to decode
         * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
         *  {@link ByteBuffer.DEFAULT_ENDIAN}.
         * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
         *  {@link ByteBuffer.DEFAULT_NOASSERT}.
         * @returns {!ByteBuffer} ByteBuffer
         * @expose
         */
        ByteBuffer.fromBinary = function(str, littleEndian, noAssert) {
            if (!noAssert) {
                if (typeof str !== 'string')
                    throw TypeError("Illegal str: Not a string");
            }
            var i = 0, k = str.length, charCode,
                bb = new ByteBuffer(k, littleEndian, noAssert);
            while (i<k) {
                charCode = str.charCodeAt(i);
                if (!noAssert && charCode > 255)
                    throw RangeError("Illegal charCode at "+i+": 0 <= "+charCode+" <= 255");
                bb.view.setUint8(i++, charCode);
            }
            bb.limit = k;
            return bb;
        };

        // encodings/debug

        /**
         * Encodes this ByteBuffer to a hex encoded string with marked offsets. Offset symbols are:
         * * `<` : offset,
         * * `'` : markedOffset,
         * * `>` : limit,
         * * `|` : offset and limit,
         * * `[` : offset and markedOffset,
         * * `]` : markedOffset and limit,
         * * `!` : offset, markedOffset and limit
         * @param {boolean=} columns If `true` returns two columns hex + ascii, defaults to `false`
         * @returns {string|!Array.<string>} Debug string or array of lines if `asArray = true`
         * @expose
         * @example `>00'01 02<03` contains four bytes with `limit=0, markedOffset=1, offset=3`
         * @example `00[01 02 03>` contains four bytes with `offset=markedOffset=1, limit=4`
         * @example `00|01 02 03` contains four bytes with `offset=limit=1, markedOffset=-1`
         * @example `|` contains zero bytes with `offset=limit=0, markedOffset=-1`
         */
        ByteBufferPrototype.toDebug = function(columns) {
            var i = -1,
                k = this.buffer.byteLength,
                b,
                hex = "",
                asc = "",
                out = "";
            while (i<k) {
                if (i !== -1) {
                    b = this.view.getUint8(i);
                    if (b < 0x10) hex += "0"+b.toString(16).toUpperCase();
                    else hex += b.toString(16).toUpperCase();
                    if (columns) {
                        asc += b > 32 && b < 127 ? String.fromCharCode(b) : '.';
                    }
                }
                ++i;
                if (columns) {
                    if (i > 0 && i % 16 === 0 && i !== k) {
                        while (hex.length < 3*16+3) hex += " ";
                        out += hex+asc+"\n";
                        hex = asc = "";
                    }
                }
                if (i === this.offset && i === this.limit)
                    hex += i === this.markedOffset ? "!" : "|";
                else if (i === this.offset)
                    hex += i === this.markedOffset ? "[" : "<";
                else if (i === this.limit)
                    hex += i === this.markedOffset ? "]" : ">";
                else
                    hex += i === this.markedOffset ? "'" : (columns || (i !== 0 && i !== k) ? " " : "");
            }
            if (columns && hex !== " ") {
                while (hex.length < 3*16+3) hex += " ";
                out += hex+asc+"\n";
            }
            return columns ? out : hex;
        };

        /**
         * Decodes a hex encoded string with marked offsets to a ByteBuffer.
         * @param {string} str Debug string to decode (not be generated with `columns = true`)
         * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
         *  {@link ByteBuffer.DEFAULT_ENDIAN}.
         * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
         *  {@link ByteBuffer.DEFAULT_NOASSERT}.
         * @returns {!ByteBuffer} ByteBuffer
         * @expose
         * @see ByteBuffer#toDebug
         */
        ByteBuffer.fromDebug = function(str, littleEndian, noAssert) {
            var k = str.length,
                bb = new ByteBuffer(((k+1)/3)|0, littleEndian, noAssert);
            var i = 0, j = 0, ch, b,
                rs = false, // Require symbol next
                ho = false, hm = false, hl = false, // Already has offset, markedOffset, limit?
                fail = false;
            while (i<k) {
                switch (ch = str.charAt(i++)) {
                    case '!':
                        if (!noAssert) {
                            if (ho || hm || hl) {
                                fail = true; break;
                            }
                            ho = hm = hl = true;
                        }
                        bb.offset = bb.markedOffset = bb.limit = j;
                        rs = false;
                        break;
                    case '|':
                        if (!noAssert) {
                            if (ho || hl) {
                                fail = true; break;
                            }
                            ho = hl = true;
                        }
                        bb.offset = bb.limit = j;
                        rs = false;
                        break;
                    case '[':
                        if (!noAssert) {
                            if (ho || hm) {
                                fail = true; break;
                            }
                            ho = hm = true;
                        }
                        bb.offset = bb.markedOffset = j;
                        rs = false;
                        break;
                    case '<':
                        if (!noAssert) {
                            if (ho) {
                                fail = true; break;
                            }
                            ho = true;
                        }
                        bb.offset = j;
                        rs = false;
                        break;
                    case ']':
                        if (!noAssert) {
                            if (hl || hm) {
                                fail = true; break;
                            }
                            hl = hm = true;
                        }
                        bb.limit = bb.markedOffset = j;
                        rs = false;
                        break;
                    case '>':
                        if (!noAssert) {
                            if (hl) {
                                fail = true; break;
                            }
                            hl = true;
                        }
                        bb.limit = j;
                        rs = false;
                        break;
                    case "'":
                        if (!noAssert) {
                            if (hm) {
                                fail = true; break;
                            }
                            hm = true;
                        }
                        bb.markedOffset = j;
                        rs = false;
                        break;
                    case ' ':
                        rs = false;
                        break;
                    default:
                        if (!noAssert) {
                            if (rs) {
                                fail = true; break;
                            }
                        }
                        b = parseInt(ch+str.charAt(i++), 16);
                        if (!noAssert) {
                            if (isNaN(b) || b < 0 || b > 255)
                                throw TypeError("Illegal str: Not a debug encoded string");
                        }
                        bb.view.setUint8(j++, b);
                        rs = true;
                }
                if (fail)
                    throw TypeError("Illegal str: Invalid symbol at "+i);
            }
            if (!noAssert) {
                if (!ho || !hl)
                    throw TypeError("Illegal str: Missing offset or limit");
                if (j<bb.buffer.byteLength)
                    throw TypeError("Illegal str: Not a debug encoded string (is it hex?) "+j+" < "+k);
            }
            return bb;
        };

        // encodings/hex

        /**
         * Encodes this ByteBuffer's contents to a hex encoded string.
         * @param {number=} begin Offset to begin at. Defaults to {@link ByteBuffer#offset}.
         * @param {number=} end Offset to end at. Defaults to {@link ByteBuffer#limit}.
         * @returns {string} Hex encoded string
         * @expose
         */
        ByteBufferPrototype.toHex = function(begin, end) {
            begin = typeof begin === 'undefined' ? this.offset : begin;
            end = typeof end === 'undefined' ? this.limit : end;
            if (!this.noAssert) {
                if (typeof begin !== 'number' || begin % 1 !== 0)
                    throw TypeError("Illegal begin: Not an integer");
                begin >>>= 0;
                if (typeof end !== 'number' || end % 1 !== 0)
                    throw TypeError("Illegal end: Not an integer");
                end >>>= 0;
                if (begin < 0 || begin > end || end > this.buffer.byteLength)
                    throw RangeError("Illegal range: 0 <= "+begin+" <= "+end+" <= "+this.buffer.byteLength);
            }
            var out = new Array(end - begin),
                b;
            while (begin < end) {
                b = this.view.getUint8(begin++);
                if (b < 0x10)
                    out.push("0", b.toString(16));
                else out.push(b.toString(16));
            }
            return out.join('');
        };

        /**
         * Decodes a hex encoded string to a ByteBuffer.
         * @param {string} str String to decode
         * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
         *  {@link ByteBuffer.DEFAULT_ENDIAN}.
         * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
         *  {@link ByteBuffer.DEFAULT_NOASSERT}.
         * @returns {!ByteBuffer} ByteBuffer
         * @expose
         */
        ByteBuffer.fromHex = function(str, littleEndian, noAssert) {
            if (!noAssert) {
                if (typeof str !== 'string')
                    throw TypeError("Illegal str: Not a string");
                if (str.length % 2 !== 0)
                    throw TypeError("Illegal str: Length not a multiple of 2");
            }
            var k = str.length,
                bb = new ByteBuffer((k / 2) | 0, littleEndian),
                b;
            for (var i=0, j=0; i<k; i+=2) {
                b = parseInt(str.substring(i, i+2), 16);
                if (!noAssert)
                    if (!isFinite(b) || b < 0 || b > 255)
                        throw TypeError("Illegal str: Contains non-hex characters");
                bb.view.setUint8(j++, b);
            }
            bb.limit = j;
            return bb;
        };

        // utfx-embeddable

        /**
         * utfx-embeddable (c) 2014 Daniel Wirtz <dcode@dcode.io>
         * Released under the Apache License, Version 2.0
         * see: https://github.com/dcodeIO/utfx for details
         */
        var utfx = function() {
            "use strict";

            /**
             * utfx namespace.
             * @inner
             * @type {!Object.<string,*>}
             */
            var utfx = {};

            /**
             * Maximum valid code point.
             * @type {number}
             * @const
             */
            utfx.MAX_CODEPOINT = 0x10FFFF;

            /**
             * Encodes UTF8 code points to UTF8 bytes.
             * @param {(!function():number|null) | number} src Code points source, either as a function returning the next code point
             *  respectively `null` if there are no more code points left or a single numeric code point.
             * @param {!function(number)} dst Bytes destination as a function successively called with the next byte
             */
            utfx.encodeUTF8 = function(src, dst) {
                var cp = null;
                if (typeof src === 'number')
                    cp = src,
                    src = function() { return null; };
                while (cp !== null || (cp = src()) !== null) {
                    if (cp < 0x80)
                        dst(cp&0x7F);
                    else if (cp < 0x800)
                        dst(((cp>>6)&0x1F)|0xC0),
                        dst((cp&0x3F)|0x80);
                    else if (cp < 0x10000)
                        dst(((cp>>12)&0x0F)|0xE0),
                        dst(((cp>>6)&0x3F)|0x80),
                        dst((cp&0x3F)|0x80);
                    else
                        dst(((cp>>18)&0x07)|0xF0),
                        dst(((cp>>12)&0x3F)|0x80),
                        dst(((cp>>6)&0x3F)|0x80),
                        dst((cp&0x3F)|0x80);
                    cp = null;
                }
            };

            /**
             * Decodes UTF8 bytes to UTF8 code points.
             * @param {!function():number|null} src Bytes source as a function returning the next byte respectively `null` if there
             *  are no more bytes left.
             * @param {!function(number)} dst Code points destination as a function successively called with each decoded code point.
             * @throws {RangeError} If a starting byte is invalid in UTF8
             * @throws {Error} If the last sequence is truncated. Has an array property `bytes` holding the
             *  remaining bytes.
             */
            utfx.decodeUTF8 = function(src, dst) {
                var a, b, c, d, fail = function(b) {
                    b = b.slice(0, b.indexOf(null));
                    var err = Error(b.toString());
                    err.name = "TruncatedError";
                    err['bytes'] = b;
                    throw err;
                };
                while ((a = src()) !== null) {
                    if ((a&0x80) === 0)
                        dst(a);
                    else if ((a&0xE0) === 0xC0)
                        ((b = src()) === null) && fail([a, b]),
                        dst(((a&0x1F)<<6) | (b&0x3F));
                    else if ((a&0xF0) === 0xE0)
                        ((b=src()) === null || (c=src()) === null) && fail([a, b, c]),
                        dst(((a&0x0F)<<12) | ((b&0x3F)<<6) | (c&0x3F));
                    else if ((a&0xF8) === 0xF0)
                        ((b=src()) === null || (c=src()) === null || (d=src()) === null) && fail([a, b, c ,d]),
                        dst(((a&0x07)<<18) | ((b&0x3F)<<12) | ((c&0x3F)<<6) | (d&0x3F));
                    else throw RangeError("Illegal starting byte: "+a);
                }
            };

            /**
             * Converts UTF16 characters to UTF8 code points.
             * @param {!function():number|null} src Characters source as a function returning the next char code respectively
             *  `null` if there are no more characters left.
             * @param {!function(number)} dst Code points destination as a function successively called with each converted code
             *  point.
             */
            utfx.UTF16toUTF8 = function(src, dst) {
                var c1, c2 = null;
                while (true) {
                    if ((c1 = c2 !== null ? c2 : src()) === null)
                        break;
                    if (c1 >= 0xD800 && c1 <= 0xDFFF) {
                        if ((c2 = src()) !== null) {
                            if (c2 >= 0xDC00 && c2 <= 0xDFFF) {
                                dst((c1-0xD800)*0x400+c2-0xDC00+0x10000);
                                c2 = null; continue;
                            }
                        }
                    }
                    dst(c1);
                }
                if (c2 !== null) dst(c2);
            };

            /**
             * Converts UTF8 code points to UTF16 characters.
             * @param {(!function():number|null) | number} src Code points source, either as a function returning the next code point
             *  respectively `null` if there are no more code points left or a single numeric code point.
             * @param {!function(number)} dst Characters destination as a function successively called with each converted char code.
             * @throws {RangeError} If a code point is out of range
             */
            utfx.UTF8toUTF16 = function(src, dst) {
                var cp = null;
                if (typeof src === 'number')
                    cp = src, src = function() { return null; };
                while (cp !== null || (cp = src()) !== null) {
                    if (cp <= 0xFFFF)
                        dst(cp);
                    else
                        cp -= 0x10000,
                        dst((cp>>10)+0xD800),
                        dst((cp%0x400)+0xDC00);
                    cp = null;
                }
            };

            /**
             * Converts and encodes UTF16 characters to UTF8 bytes.
             * @param {!function():number|null} src Characters source as a function returning the next char code respectively `null`
             *  if there are no more characters left.
             * @param {!function(number)} dst Bytes destination as a function successively called with the next byte.
             */
            utfx.encodeUTF16toUTF8 = function(src, dst) {
                utfx.UTF16toUTF8(src, function(cp) {
                    utfx.encodeUTF8(cp, dst);
                });
            };

            /**
             * Decodes and converts UTF8 bytes to UTF16 characters.
             * @param {!function():number|null} src Bytes source as a function returning the next byte respectively `null` if there
             *  are no more bytes left.
             * @param {!function(number)} dst Characters destination as a function successively called with each converted char code.
             * @throws {RangeError} If a starting byte is invalid in UTF8
             * @throws {Error} If the last sequence is truncated. Has an array property `bytes` holding the remaining bytes.
             */
            utfx.decodeUTF8toUTF16 = function(src, dst) {
                utfx.decodeUTF8(src, function(cp) {
                    utfx.UTF8toUTF16(cp, dst);
                });
            };

            /**
             * Calculates the byte length of an UTF8 code point.
             * @param {number} cp UTF8 code point
             * @returns {number} Byte length
             */
            utfx.calculateCodePoint = function(cp) {
                return (cp < 0x80) ? 1 : (cp < 0x800) ? 2 : (cp < 0x10000) ? 3 : 4;
            };

            /**
             * Calculates the number of UTF8 bytes required to store UTF8 code points.
             * @param {(!function():number|null)} src Code points source as a function returning the next code point respectively
             *  `null` if there are no more code points left.
             * @returns {number} The number of UTF8 bytes required
             */
            utfx.calculateUTF8 = function(src) {
                var cp, l=0;
                while ((cp = src()) !== null)
                    l += utfx.calculateCodePoint(cp);
                return l;
            };

            /**
             * Calculates the number of UTF8 code points respectively UTF8 bytes required to store UTF16 char codes.
             * @param {(!function():number|null)} src Characters source as a function returning the next char code respectively
             *  `null` if there are no more characters left.
             * @returns {!Array.<number>} The number of UTF8 code points at index 0 and the number of UTF8 bytes required at index 1.
             */
            utfx.calculateUTF16asUTF8 = function(src) {
                var n=0, l=0;
                utfx.UTF16toUTF8(src, function(cp) {
                    ++n; l += utfx.calculateCodePoint(cp);
                });
                return [n,l];
            };

            return utfx;
        }();

        // encodings/utf8

        /**
         * Encodes this ByteBuffer's contents between {@link ByteBuffer#offset} and {@link ByteBuffer#limit} to an UTF8 encoded
         *  string.
         * @returns {string} Hex encoded string
         * @throws {RangeError} If `offset > limit`
         * @expose
         */
        ByteBufferPrototype.toUTF8 = function(begin, end) {
            if (typeof begin === 'undefined') begin = this.offset;
            if (typeof end === 'undefined') end = this.limit;
            if (!this.noAssert) {
                if (typeof begin !== 'number' || begin % 1 !== 0)
                    throw TypeError("Illegal begin: Not an integer");
                begin >>>= 0;
                if (typeof end !== 'number' || end % 1 !== 0)
                    throw TypeError("Illegal end: Not an integer");
                end >>>= 0;
                if (begin < 0 || begin > end || end > this.buffer.byteLength)
                    throw RangeError("Illegal range: 0 <= "+begin+" <= "+end+" <= "+this.buffer.byteLength);
            }
            var sd; try {
                utfx.decodeUTF8toUTF16(function() {
                    return begin < end ? this.view.getUint8(begin++) : null;
                }.bind(this), sd = stringDestination());
            } catch (e) {
                if (begin !== end)
                    throw RangeError("Illegal range: Truncated data, "+begin+" != "+end);
            }
            return sd();
        };

        /**
         * Decodes an UTF8 encoded string to a ByteBuffer.
         * @param {string} str String to decode
         * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
         *  {@link ByteBuffer.DEFAULT_ENDIAN}.
         * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
         *  {@link ByteBuffer.DEFAULT_NOASSERT}.
         * @returns {!ByteBuffer} ByteBuffer
         * @expose
         */
        ByteBuffer.fromUTF8 = function(str, littleEndian, noAssert) {
            if (!noAssert)
                if (typeof str !== 'string')
                    throw TypeError("Illegal str: Not a string");
            var bb = new ByteBuffer(utfx.calculateUTF16asUTF8(stringSource(str), true)[1], littleEndian, noAssert),
                i = 0;
            utfx.encodeUTF16toUTF8(stringSource(str), function(b) {
                bb.view.setUint8(i++, b);
            });
            bb.limit = i;
            return bb;
        };


        return ByteBuffer;
    }

    /* CommonJS */ if (typeof require === 'function' && typeof module === 'object' && module && typeof exports === 'object' && exports)
        module['exports'] = (function() {
            var Long; try { Long = require("long"); } catch (e) {}
            return loadByteBuffer(Long);
        })();
    /* AMD */ else if (typeof define === 'function' && define["amd"])
        define("ByteBuffer", ["Long"], function(Long) { return loadByteBuffer(Long); });
    /* Global */ else
        (global["dcodeIO"] = global["dcodeIO"] || {})["ByteBuffer"] = loadByteBuffer(global["dcodeIO"]["Long"]);

})(this);

},{"long":102}],49:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer
var Transform = require('stream').Transform
var StringDecoder = require('string_decoder').StringDecoder
var inherits = require('inherits')

function CipherBase (hashMode) {
  Transform.call(this)
  this.hashMode = typeof hashMode === 'string'
  if (this.hashMode) {
    this[hashMode] = this._finalOrDigest
  } else {
    this.final = this._finalOrDigest
  }
  if (this._final) {
    this.__final = this._final
    this._final = null
  }
  this._decoder = null
  this._encoding = null
}
inherits(CipherBase, Transform)

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
  if (typeof data === 'string') {
    data = Buffer.from(data, inputEnc)
  }

  var outData = this._update(data)
  if (this.hashMode) return this

  if (outputEnc) {
    outData = this._toString(outData, outputEnc)
  }

  return outData
}

CipherBase.prototype.setAutoPadding = function () {}
CipherBase.prototype.getAuthTag = function () {
  throw new Error('trying to get auth tag in unsupported state')
}

CipherBase.prototype.setAuthTag = function () {
  throw new Error('trying to set auth tag in unsupported state')
}

CipherBase.prototype.setAAD = function () {
  throw new Error('trying to set aad in unsupported state')
}

CipherBase.prototype._transform = function (data, _, next) {
  var err
  try {
    if (this.hashMode) {
      this._update(data)
    } else {
      this.push(this._update(data))
    }
  } catch (e) {
    err = e
  } finally {
    next(err)
  }
}
CipherBase.prototype._flush = function (done) {
  var err
  try {
    this.push(this.__final())
  } catch (e) {
    err = e
  }

  done(err)
}
CipherBase.prototype._finalOrDigest = function (outputEnc) {
  var outData = this.__final() || Buffer.alloc(0)
  if (outputEnc) {
    outData = this._toString(outData, outputEnc, true)
  }
  return outData
}

CipherBase.prototype._toString = function (value, enc, fin) {
  if (!this._decoder) {
    this._decoder = new StringDecoder(enc)
    this._encoding = enc
  }

  if (this._encoding !== enc) throw new Error('can\'t switch encodings')

  var out = this._decoder.write(value)
  if (fin) {
    out += this._decoder.end()
  }

  return out
}

module.exports = CipherBase

},{"inherits":100,"safe-buffer":379,"stream":627,"string_decoder":628}],50:[function(require,module,exports){
'use strict'
var inherits = require('inherits')
var MD5 = require('md5.js')
var RIPEMD160 = require('ripemd160')
var sha = require('sha.js')
var Base = require('cipher-base')

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}

},{"cipher-base":49,"inherits":100,"md5.js":103,"ripemd160":378,"sha.js":390}],51:[function(require,module,exports){
var MD5 = require('md5.js')

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}

},{"md5.js":103}],52:[function(require,module,exports){
'use strict';

var elliptic = exports;

elliptic.version = require('../package.json').version;
elliptic.utils = require('./elliptic/utils');
elliptic.rand = require('brorand');
elliptic.curve = require('./elliptic/curve');
elliptic.curves = require('./elliptic/curves');

// Protocols
elliptic.ec = require('./elliptic/ec');
elliptic.eddsa = require('./elliptic/eddsa');

},{"../package.json":67,"./elliptic/curve":55,"./elliptic/curves":58,"./elliptic/ec":59,"./elliptic/eddsa":62,"./elliptic/utils":66,"brorand":26}],53:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var utils = require('../utils');
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  this._bitLength = this.n ? this.n.bitLength() : 0;

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1, this._bitLength);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  var j;
  var nafW;
  for (j = 0; j < naf.length; j += doubles.step) {
    nafW = 0;
    for (var l = j + doubles.step - 1; l >= j; l--)
      nafW = (nafW << 1) + naf[l];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (j = 0; j < repr.length; j++) {
      nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w, this._bitLength);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var l = 0; i >= 0 && naf[i] === 0; i--)
      l++;
    if (i >= 0)
      l++;
    acc = acc.dblp(l);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
  points,
  coeffs,
  len,
  jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  var i;
  var j;
  var p;
  for (i = 0; i < len; i++) {
    p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
      naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b], /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3,  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (j = 0; j < len; j++) {
      var z = tmp[j];
      p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
      bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len));
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null,
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles,
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res,
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};

},{"../utils":66,"bn.js":25}],54:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var BN = require('bn.js');
var inherits = require('inherits');
var Base = require('./base');

var assert = utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.c2);
  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.fromRed().isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
    (this.y.cmp(this.z) === 0 ||
    (this.zOne && this.y.cmp(this.curve.c) === 0));
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  var e;
  var h;
  var j;
  if (this.curve.twisted) {
    // E = a * C
    e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      h = this.z.redSqr();
      // J = F - 2 * H
      j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    e = c.redAdd(d);
    // H = (c * Z1)^2
    h = this.curve._mulC(this.z).redSqr();
    // J = E - 2 * H
    j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
    this.y,
    this.z,
    this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;

},{"../utils":66,"./base":53,"bn.js":25,"inherits":100}],55:[function(require,module,exports){
'use strict';

var curve = exports;

curve.base = require('./base');
curve.short = require('./short');
curve.mont = require('./mont');
curve.edwards = require('./edwards');

},{"./base":53,"./edwards":54,"./mont":56,"./short":57}],56:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var inherits = require('inherits');
var Base = require('./base');

var utils = require('../utils');

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};

},{"../utils":66,"./base":53,"bn.js":25,"inherits":100}],57:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var BN = require('bn.js');
var inherits = require('inherits');
var Base = require('./base');

var assert = utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16),
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis,
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 },
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
      var npoints = this._endoWnafT1;
      var ncoeffs = this._endoWnafT2;
      for (var i = 0; i < points.length; i++) {
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();

        if (split.k1.negative) {
          split.k1.ineg();
          p = p.neg(true);
        }
        if (split.k2.negative) {
          split.k2.ineg();
          beta = beta.neg(true);
        }

        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
      }
      var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

      // Clean-up references to points and coefficients
      for (var j = 0; j < i * 2; j++) {
        npoints[j] = null;
        ncoeffs[j] = null;
      }
      return res;
    };

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul),
      },
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1),
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1),
    },
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point)),
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point)),
    },
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);
  if (this.isInfinity())
    return this;
  else if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate),
      },
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  var i;
  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

},{"../utils":66,"./base":53,"bn.js":25,"inherits":100}],58:[function(require,module,exports){
'use strict';

var curves = exports;

var hash = require('hash.js');
var curve = require('./curve');
var utils = require('./utils');

var assert = utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new curve.edwards(options);
  else
    this.curve = new curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve,
      });
      return curve;
    },
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811',
  ],
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34',
  ],
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5',
  ],
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f',
  ],
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650',
  ],
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9',
  ],
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658',
  ],
});

var pre;
try {
  pre = require('./precomputed/secp256k1');
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3',
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15',
    },
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre,
  ],
});

},{"./curve":55,"./precomputed/secp256k1":65,"./utils":66,"hash.js":87}],59:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var HmacDRBG = require('hmac-drbg');
var utils = require('../utils');
var curves = require('../curves');
var rand = require('brorand');
var assert = utils.assert;

var KeyPair = require('./key');
var Signature = require('./signature');

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(Object.prototype.hasOwnProperty.call(curves, options),
      'Unknown curve ' + options);

    options = curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray(),
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  for (;;) {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  }
};

EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new BN(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; ; iter++) {
    var k = options.k ?
      options.k(iter) :
      new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc) {
  msg = this._truncateToN(new BN(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);
  var p;

  if (!this.curve._maxwellTrick) {
    p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};

},{"../curves":58,"../utils":66,"./key":60,"./signature":61,"bn.js":25,"brorand":26,"hmac-drbg":99}],60:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var utils = require('../utils');
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc,
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc,
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  if(!pub.validate()) {
    assert(pub.validate(), 'public point not validated');
  }
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

},{"../utils":66,"bn.js":25}],61:[function(require,module,exports){
'use strict';

var BN = require('bn.js');

var utils = require('../utils');
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;

  // Indefinite length or overflow
  if (octetLen === 0 || octetLen > 4) {
    return false;
  }

  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
    val >>>= 0;
  }

  // Leading zeroes
  if (val <= 0x7f) {
    return false;
  }

  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if (len === false) {
    return false;
  }
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  if (rlen === false) {
    return false;
  }
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (slen === false) {
    return false;
  }
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0) {
    if (r[1] & 0x80) {
      r = r.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }
  if (s[0] === 0) {
    if (s[1] & 0x80) {
      s = s.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};

},{"../utils":66,"bn.js":25}],62:[function(require,module,exports){
'use strict';

var hash = require('hash.js');
var curves = require('../curves');
var utils = require('../utils');
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = require('./key');
var Signature = require('./signature');

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  curve = curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
    .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};

},{"../curves":58,"../utils":66,"./key":63,"./signature":64,"hash.js":87}],63:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;

},{"../utils":66}],64:[function(require,module,exports){
'use strict';

var BN = require('bn.js');
var utils = require('../utils');
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength),
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;

},{"../utils":66,"bn.js":25}],65:[function(require,module,exports){
module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821',
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf',
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695',
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9',
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36',
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f',
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999',
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09',
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d',
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088',
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d',
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8',
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a',
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453',
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160',
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0',
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6',
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589',
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17',
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda',
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd',
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2',
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6',
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f',
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01',
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3',
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f',
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7',
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78',
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1',
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150',
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82',
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc',
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b',
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51',
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45',
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120',
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84',
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d',
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d',
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8',
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8',
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac',
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f',
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962',
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907',
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec',
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d',
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414',
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd',
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0',
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811',
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1',
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c',
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73',
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd',
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405',
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589',
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e',
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27',
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1',
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482',
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945',
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573',
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82',
      ],
    ],
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672',
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6',
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da',
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37',
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b',
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81',
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58',
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77',
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a',
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c',
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67',
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402',
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55',
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482',
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82',
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396',
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49',
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf',
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a',
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7',
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933',
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a',
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6',
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37',
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e',
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6',
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476',
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40',
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61',
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683',
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5',
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b',
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417',
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868',
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a',
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6',
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996',
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e',
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d',
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2',
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e',
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437',
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311',
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4',
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575',
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d',
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d',
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629',
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06',
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374',
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee',
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1',
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b',
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661',
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6',
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e',
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d',
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc',
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4',
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c',
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b',
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913',
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154',
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865',
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc',
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224',
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e',
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6',
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511',
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b',
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2',
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c',
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3',
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d',
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700',
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4',
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196',
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4',
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257',
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13',
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096',
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38',
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f',
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448',
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a',
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4',
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437',
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7',
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d',
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a',
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54',
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77',
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517',
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10',
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125',
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e',
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1',
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2',
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423',
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8',
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758',
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375',
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d',
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec',
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0',
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c',
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4',
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f',
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649',
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826',
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5',
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87',
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b',
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc',
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c',
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f',
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a',
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46',
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f',
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03',
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08',
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8',
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373',
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3',
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8',
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1',
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9',
      ],
    ],
  },
};

},{}],66:[function(require,module,exports){
'use strict';

var utils = exports;
var BN = require('bn.js');
var minAssert = require('minimalistic-assert');
var minUtils = require('minimalistic-crypto-utils');

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w, bits) {
  var naf = new Array(Math.max(num.bitLength(), bits) + 1);
  naf.fill(0);

  var ws = 1 << (w + 1);
  var k = num.clone();

  for (var i = 0; i < naf.length; i++) {
    var z;
    var mod = k.andln(ws - 1);
    if (k.isOdd()) {
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }

    naf[i] = z;
    k.iushrn(1);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    [],
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  var m8;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {
    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
      this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
    bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;


},{"bn.js":25,"minimalistic-assert":105,"minimalistic-crypto-utils":106}],67:[function(require,module,exports){
module.exports={
  "name": "elliptic",
  "version": "6.5.4",
  "description": "EC cryptography",
  "main": "lib/elliptic.js",
  "files": [
    "lib"
  ],
  "scripts": {
    "lint": "eslint lib test",
    "lint:fix": "npm run lint -- --fix",
    "unit": "istanbul test _mocha --reporter=spec test/index.js",
    "test": "npm run lint && npm run unit",
    "version": "grunt dist && git add dist/"
  },
  "repository": {
    "type": "git",
    "url": "git@github.com:indutny/elliptic"
  },
  "keywords": [
    "EC",
    "Elliptic",
    "curve",
    "Cryptography"
  ],
  "author": "Fedor Indutny <fedor@indutny.com>",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/indutny/elliptic/issues"
  },
  "homepage": "https://github.com/indutny/elliptic",
  "devDependencies": {
    "brfs": "^2.0.2",
    "coveralls": "^3.1.0",
    "eslint": "^7.6.0",
    "grunt": "^1.2.1",
    "grunt-browserify": "^5.3.0",
    "grunt-cli": "^1.3.2",
    "grunt-contrib-connect": "^3.0.0",
    "grunt-contrib-copy": "^1.0.0",
    "grunt-contrib-uglify": "^5.0.0",
    "grunt-mocha-istanbul": "^5.0.2",
    "grunt-saucelabs": "^9.0.1",
    "istanbul": "^0.4.5",
    "mocha": "^8.0.1"
  },
  "dependencies": {
    "bn.js": "^4.11.9",
    "brorand": "^1.1.0",
    "hash.js": "^1.0.0",
    "hmac-drbg": "^1.0.1",
    "inherits": "^2.0.4",
    "minimalistic-assert": "^1.0.1",
    "minimalistic-crypto-utils": "^1.0.1"
  }

,"_resolved": "https://npmregistry.privmx.com/elliptic/-/elliptic-6.5.4.tgz"
,"_integrity": "sha512-iLhC6ULemrljPZb+QutR5TQGB+pdW6KGD5RSegS+8sorOZT+rdQFbsQFJgvN3eRqNALqJer4oQ16YvJHlU8hzQ=="
,"_from": "elliptic@6.5.4"
}
},{}],68:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer
var MD5 = require('md5.js')

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey

},{"md5.js":103,"safe-buffer":379}],69:[function(require,module,exports){
'use strict'
var Buffer = require('safe-buffer').Buffer
var Transform = require('readable-stream').Transform
var inherits = require('inherits')

function throwIfNotStringOrBuffer (val, prefix) {
  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
    throw new TypeError(prefix + ' must be a string or a buffer')
  }
}

function HashBase (blockSize) {
  Transform.call(this)

  this._block = Buffer.allocUnsafe(blockSize)
  this._blockSize = blockSize
  this._blockOffset = 0
  this._length = [0, 0, 0, 0]

  this._finalized = false
}

inherits(HashBase, Transform)

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null
  try {
    this.update(chunk, encoding)
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype._flush = function (callback) {
  var error = null
  try {
    this.push(this.digest())
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype.update = function (data, encoding) {
  throwIfNotStringOrBuffer(data, 'Data')
  if (this._finalized) throw new Error('Digest already called')
  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding)

  // consume data
  var block = this._block
  var offset = 0
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
    this._update()
    this._blockOffset = 0
  }
  while (offset < data.length) block[this._blockOffset++] = data[offset++]

  // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry
    carry = (this._length[j] / 0x0100000000) | 0
    if (carry > 0) this._length[j] -= 0x0100000000 * carry
  }

  return this
}

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented')
}

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called')
  this._finalized = true

  var digest = this._digest()
  if (encoding !== undefined) digest = digest.toString(encoding)

  // reset state
  this._block.fill(0)
  this._blockOffset = 0
  for (var i = 0; i < 4; ++i) this._length[i] = 0

  return digest
}

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented')
}

module.exports = HashBase

},{"inherits":100,"readable-stream":84,"safe-buffer":85}],70:[function(require,module,exports){
'use strict';

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var codes = {};

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base);

  NodeError.prototype.name = Base.name;
  NodeError.prototype.code = code;
  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
  return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  // determiner: 'must be' or 'must not be'
  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  msg += ". Received type ".concat(typeof actual);
  return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
  return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function (name) {
  return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
  return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.codes = codes;

},{}],71:[function(require,module,exports){
(function (process){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';
/*<replacement>*/

var objectKeys = Object.keys || function (obj) {
  var keys = [];

  for (var key in obj) {
    keys.push(key);
  }

  return keys;
};
/*</replacement>*/


module.exports = Duplex;

var Readable = require('./_stream_readable');

var Writable = require('./_stream_writable');

require('inherits')(Duplex, Readable);

{
  // Allow the keys array to be GC'ed.
  var keys = objectKeys(Writable.prototype);

  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  this.allowHalfOpen = true;

  if (options) {
    if (options.readable === false) this.readable = false;
    if (options.writable === false) this.writable = false;

    if (options.allowHalfOpen === false) {
      this.allowHalfOpen = false;
      this.once('end', onend);
    }
  }
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
}); // the no-half-open enforcer

function onend() {
  // If the writable side ended, then we're ok.
  if (this._writableState.ended) return; // no more data can be written.
  // But allow more writes to happen in this tick.

  process.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }

    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    } // backward compatibility, the user is explicitly
    // managing destroyed


    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});
}).call(this)}).call(this,require('_process'))
},{"./_stream_readable":73,"./_stream_writable":75,"_process":592,"inherits":100}],72:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

module.exports = PassThrough;

var Transform = require('./_stream_transform');

require('inherits')(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};
},{"./_stream_transform":74,"inherits":100}],73:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

module.exports = Readable;
/*<replacement>*/

var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;
/*<replacement>*/

var EE = require('events').EventEmitter;

var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/


var Stream = require('./internal/streams/stream');
/*</replacement>*/


var Buffer = require('buffer').Buffer;

var OurUint8Array = global.Uint8Array || function () {};

function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}

function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*<replacement>*/


var debugUtil = require('util');

var debug;

if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/


var BufferList = require('./internal/streams/buffer_list');

var destroyImpl = require('./internal/streams/destroy');

var _require = require('./internal/streams/state'),
    getHighWaterMark = _require.getHighWaterMark;

var _require$codes = require('../errors').codes,
    ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
    ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
    ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
    ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.


var StringDecoder;
var createReadableStreamAsyncIterator;
var from;

require('inherits')(Readable, Stream);

var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.

  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream, isDuplex) {
  Duplex = Duplex || require('./_stream_duplex');
  options = options || {}; // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.

  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex; // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away

  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"

  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex); // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()

  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.

  this.sync = true; // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.

  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;
  this.paused = true; // Should close be emitted on destroy. Defaults to true.

  this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')

  this.autoDestroy = !!options.autoDestroy; // has it been destroyed

  this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.

  this.defaultEncoding = options.defaultEncoding || 'utf8'; // the number of writers that are awaiting a drain event in .pipe()s

  this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled

  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;

  if (options.encoding) {
    if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || require('./_stream_duplex');
  if (!(this instanceof Readable)) return new Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5

  var isDuplex = this instanceof Duplex;
  this._readableState = new ReadableState(options, this, isDuplex); // legacy

  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }

    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    } // backward compatibility, the user is explicitly
    // managing destroyed


    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;

Readable.prototype._destroy = function (err, cb) {
  cb(err);
}; // Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.


Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;

      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }

      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
}; // Unshift should *always* be something directly out of read()


Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  debug('readableAddChunk', chunk);
  var state = stream._readableState;

  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);

    if (er) {
      errorOrDestroy(stream, er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
      } else if (state.destroyed) {
        return false;
      } else {
        state.reading = false;

        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
      maybeReadMore(stream, state);
    }
  } // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.


  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    state.awaitDrain = 0;
    stream.emit('data', chunk);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }

  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;

  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
  }

  return er;
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
}; // backwards compatibility.


Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
  var decoder = new StringDecoder(enc);
  this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8

  this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:

  var p = this._readableState.buffer.head;
  var content = '';

  while (p !== null) {
    content += decoder.write(p.data);
    p = p.next;
  }

  this._readableState.buffer.clear();

  if (content !== '') this._readableState.buffer.push(content);
  this._readableState.length = content.length;
  return this;
}; // Don't raise the hwm > 1GB


var MAX_HWM = 0x40000000;

function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }

  return n;
} // This function is designed to be inlinable, so please take care when making
// changes to the function body.


function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;

  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  } // If we're asking for more than the current hwm, then raise the hwm.


  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n; // Don't have enough

  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }

  return state.length;
} // you can override either this method, or the async _read(n) below.


Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.

  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.

  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  } // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.
  // if we need a readable event, then we need to do some reading.


  var doRead = state.needReadable;
  debug('need readable', doRead); // if we currently have less than the highWaterMark, then also read some

  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  } // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.


  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true; // if the length is currently zero, then we *need* a readable event.

    if (state.length === 0) state.needReadable = true; // call internal read method

    this._read(state.highWaterMark);

    state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.

    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark;
    n = 0;
  } else {
    state.length -= n;
    state.awaitDrain = 0;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.

    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);
  return ret;
};

function onEofChunk(stream, state) {
  debug('onEofChunk');
  if (state.ended) return;

  if (state.decoder) {
    var chunk = state.decoder.end();

    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }

  state.ended = true;

  if (state.sync) {
    // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
  } else {
    // emit 'readable' now to make sure it gets picked up.
    state.needReadable = false;

    if (!state.emittedReadable) {
      state.emittedReadable = true;
      emitReadable_(stream);
    }
  }
} // Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.


function emitReadable(stream) {
  var state = stream._readableState;
  debug('emitReadable', state.needReadable, state.emittedReadable);
  state.needReadable = false;

  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    process.nextTick(emitReadable_, stream);
  }
}

function emitReadable_(stream) {
  var state = stream._readableState;
  debug('emitReadable_', state.destroyed, state.length, state.ended);

  if (!state.destroyed && (state.length || state.ended)) {
    stream.emit('readable');
    state.emittedReadable = false;
  } // The stream needs another readable event if
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.


  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
  flow(stream);
} // at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.


function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    var len = state.length;
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length) // didn't get any data, stop spinning.
      break;
  }

  state.readingMore = false;
} // abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.


Readable.prototype._read = function (n) {
  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;

    case 1:
      state.pipes = [state.pipes, dest];
      break;

    default:
      state.pipes.push(dest);
      break;
  }

  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);

  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');

    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  } // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.


  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;

  function cleanup() {
    debug('cleanup'); // cleanup event handlers once the pipe is broken

    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true; // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.

    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  src.on('data', ondata);

  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    debug('dest.write', ret);

    if (ret === false) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
      }

      src.pause();
    }
  } // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.


  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
  } // Make sure our error handler is attached before userland ones.


  prependListener(dest, 'error', onerror); // Both close and finish should trigger unpipe, but only once.

  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }

  dest.once('close', onclose);

  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }

  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  } // tell the dest that it's being piped to


  dest.emit('pipe', src); // start the flow if it hasn't been started already.

  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function pipeOnDrainFunctionResult() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;

    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  }; // if we're not piping anywhere, then do nothing.

  if (state.pipesCount === 0) return this; // just one destination.  most common case.

  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes; // got a match.

    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  } // slow case. multiple pipe destinations.


  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, {
        hasUnpiped: false
      });
    }

    return this;
  } // try to find the right one.


  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
}; // set up data events if they are asked for
// Ensure readable listeners eventually get something


Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  var state = this._readableState;

  if (ev === 'data') {
    // update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0; // Try start flowing on next tick if stream isn't explicitly paused

    if (state.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.flowing = false;
      state.emittedReadable = false;
      debug('on readable', state.length, state.reading);

      if (state.length) {
        emitReadable(this);
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this);
      }
    }
  }

  return res;
};

Readable.prototype.addListener = Readable.prototype.on;

Readable.prototype.removeListener = function (ev, fn) {
  var res = Stream.prototype.removeListener.call(this, ev, fn);

  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }

  return res;
};

Readable.prototype.removeAllListeners = function (ev) {
  var res = Stream.prototype.removeAllListeners.apply(this, arguments);

  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }

  return res;
};

function updateReadableListening(self) {
  var state = self._readableState;
  state.readableListening = self.listenerCount('readable') > 0;

  if (state.resumeScheduled && !state.paused) {
    // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true; // crude way to check if we should resume
  } else if (self.listenerCount('data') > 0) {
    self.resume();
  }
}

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
} // pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.


Readable.prototype.resume = function () {
  var state = this._readableState;

  if (!state.flowing) {
    debug('resume'); // we flow only if there is no one listening
    // for readable, but we still have to call
    // resume()

    state.flowing = !state.readableListening;
    resume(this, state);
  }

  state.paused = false;
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  debug('resume', state.reading);

  if (!state.reading) {
    stream.read(0);
  }

  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);

  if (this._readableState.flowing !== false) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }

  this._readableState.paused = true;
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);

  while (state.flowing && stream.read() !== null) {
    ;
  }
} // wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.


Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');

    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode

    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);

    if (!ret) {
      paused = true;
      stream.pause();
    }
  }); // proxy all the other methods.
  // important when wrapping filters and duplexes.

  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  } // proxy certain important events.


  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  } // when we try to consume some more bytes, simply unpause the
  // underlying stream.


  this._read = function (n) {
    debug('wrapped _read', n);

    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

if (typeof Symbol === 'function') {
  Readable.prototype[Symbol.asyncIterator] = function () {
    if (createReadableStreamAsyncIterator === undefined) {
      createReadableStreamAsyncIterator = require('./internal/streams/async_iterator');
    }

    return createReadableStreamAsyncIterator(this);
  };
}

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.flowing;
  },
  set: function set(state) {
    if (this._readableState) {
      this._readableState.flowing = state;
    }
  }
}); // exposed for testing purposes only.

Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.length;
  }
}); // Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.

function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = state.buffer.consume(n, state.decoder);
  }
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;
  debug('endReadable', state.endEmitted);

  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length); // Check that we didn't get one last unshift.

  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');

    if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well
      var wState = stream._writableState;

      if (!wState || wState.autoDestroy && wState.finished) {
        stream.destroy();
      }
    }
  }
}

if (typeof Symbol === 'function') {
  Readable.from = function (iterable, opts) {
    if (from === undefined) {
      from = require('./internal/streams/from');
    }

    return from(Readable, iterable, opts);
  };
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }

  return -1;
}
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../errors":70,"./_stream_duplex":71,"./internal/streams/async_iterator":76,"./internal/streams/buffer_list":77,"./internal/streams/destroy":78,"./internal/streams/from":80,"./internal/streams/state":82,"./internal/streams/stream":83,"_process":592,"buffer":498,"events":537,"inherits":100,"string_decoder/":86,"util":452}],74:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';

module.exports = Transform;

var _require$codes = require('../errors').codes,
    ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
    ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
    ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
    ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var Duplex = require('./_stream_duplex');

require('inherits')(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;

  if (cb === null) {
    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
  }

  ts.writechunk = null;
  ts.writecb = null;
  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;

  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }; // start out asking for a readable event once data is transformed.

  this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.

  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  } // When the writable side finishes, then flush out anything remaining.


  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
}; // This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.


Transform.prototype._transform = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;

  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
}; // Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.


Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && !ts.transforming) {
    ts.transforming = true;

    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided

  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return stream.push(null);
}
},{"../errors":70,"./_stream_duplex":71,"inherits":100}],75:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

module.exports = Writable;
/* <replacement> */

function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
} // It seems a linked list but it is not
// there will be only 2 of these for each stream


function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;

  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/


var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;
/*<replacement>*/

var internalUtil = {
  deprecate: require('util-deprecate')
};
/*</replacement>*/

/*<replacement>*/

var Stream = require('./internal/streams/stream');
/*</replacement>*/


var Buffer = require('buffer').Buffer;

var OurUint8Array = global.Uint8Array || function () {};

function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}

function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

var destroyImpl = require('./internal/streams/destroy');

var _require = require('./internal/streams/state'),
    getHighWaterMark = _require.getHighWaterMark;

var _require$codes = require('../errors').codes,
    ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
    ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
    ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
    ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
    ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
    ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
    ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
    ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;

var errorOrDestroy = destroyImpl.errorOrDestroy;

require('inherits')(Writable, Stream);

function nop() {}

function WritableState(options, stream, isDuplex) {
  Duplex = Duplex || require('./_stream_duplex');
  options = options || {}; // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.

  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex; // object stream flag to indicate whether or not this stream
  // contains buffers or objects.

  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()

  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex); // if _final has been called

  this.finalCalled = false; // drain event flag.

  this.needDrain = false; // at the start of calling end()

  this.ending = false; // when end() has been called, and returned

  this.ended = false; // when 'finish' is emitted

  this.finished = false; // has it been destroyed

  this.destroyed = false; // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.

  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.

  this.defaultEncoding = options.defaultEncoding || 'utf8'; // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.

  this.length = 0; // a flag to see when we're in the middle of a write.

  this.writing = false; // when true all writes will be buffered until .uncork() call

  this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.

  this.sync = true; // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.

  this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)

  this.onwrite = function (er) {
    onwrite(stream, er);
  }; // the callback that the user supplies to write(chunk,encoding,cb)


  this.writecb = null; // the amount that is being written when _write is called.

  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted

  this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams

  this.prefinished = false; // True if the error was already emitted and should not be thrown again

  this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.

  this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')

  this.autoDestroy = !!options.autoDestroy; // count buffered requests

  this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two

  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];

  while (current) {
    out.push(current);
    current = current.next;
  }

  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function writableStateBufferGetter() {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})(); // Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.


var realHasInstance;

if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || require('./_stream_duplex'); // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.
  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5

  var isDuplex = this instanceof Duplex;
  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
  this._writableState = new WritableState(options, this, isDuplex); // legacy.

  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
} // Otherwise people can pipe Writable streams, which is just wrong.


Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};

function writeAfterEnd(stream, cb) {
  var er = new ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb

  errorOrDestroy(stream, er);
  process.nextTick(cb, er);
} // Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.


function validChunk(stream, state, chunk, cb) {
  var er;

  if (chunk === null) {
    er = new ERR_STREAM_NULL_VALUES();
  } else if (typeof chunk !== 'string' && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
  }

  if (er) {
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
    return false;
  }

  return true;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;

  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};

Writable.prototype.cork = function () {
  this._writableState.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

Object.defineProperty(Writable.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }

  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
}); // if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.

function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);

    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }

  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.

  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };

    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }

    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    process.nextTick(cb, er); // this can emit finish, and it will always happen
    // after error

    process.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er); // this can emit finish, but finish must
    // always follow error

    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state) || stream.destroyed;

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      process.nextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
} // Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.


function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
} // if there's something in the buffer waiting, then process it


function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;

    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }

    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish); // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite

    state.pendingcb++;
    state.lastBufferedRequest = null;

    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }

    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.

      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks

  if (state.corked) {
    state.corked = 1;
    this.uncork();
  } // ignore unnecessary end() calls.


  if (!state.ending) endWritable(this, state, cb);
  return this;
};

Object.defineProperty(Writable.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}

function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;

    if (err) {
      errorOrDestroy(stream, err);
    }

    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}

function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.pendingcb++;
      state.finalCalled = true;
      process.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);

  if (need) {
    prefinish(stream, state);

    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');

      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well
        var rState = stream._readableState;

        if (!rState || rState.autoDestroy && rState.endEmitted) {
          stream.destroy();
        }
      }
    }
  }

  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);

  if (cb) {
    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
  }

  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;

  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  } // reuse the free corkReq.


  state.corkedRequestsFree.next = corkReq;
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }

    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    } // backward compatibility, the user is explicitly
    // managing destroyed


    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;

Writable.prototype._destroy = function (err, cb) {
  cb(err);
};
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../errors":70,"./_stream_duplex":71,"./internal/streams/destroy":78,"./internal/streams/state":82,"./internal/streams/stream":83,"_process":592,"buffer":498,"inherits":100,"util-deprecate":428}],76:[function(require,module,exports){
(function (process){(function (){
'use strict';

var _Object$setPrototypeO;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var finished = require('./end-of-stream');

var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');

function createIterResult(value, done) {
  return {
    value: value,
    done: done
  };
}

function readAndResolve(iter) {
  var resolve = iter[kLastResolve];

  if (resolve !== null) {
    var data = iter[kStream].read(); // we defer if data is null
    // we can be expecting either 'end' or
    // 'error'

    if (data !== null) {
      iter[kLastPromise] = null;
      iter[kLastResolve] = null;
      iter[kLastReject] = null;
      resolve(createIterResult(data, false));
    }
  }
}

function onReadable(iter) {
  // we wait for the next tick, because it might
  // emit an error with process.nextTick
  process.nextTick(readAndResolve, iter);
}

function wrapForNext(lastPromise, iter) {
  return function (resolve, reject) {
    lastPromise.then(function () {
      if (iter[kEnded]) {
        resolve(createIterResult(undefined, true));
        return;
      }

      iter[kHandlePromise](resolve, reject);
    }, reject);
  };
}

var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
  get stream() {
    return this[kStream];
  },

  next: function next() {
    var _this = this;

    // if we have detected an error in the meanwhile
    // reject straight away
    var error = this[kError];

    if (error !== null) {
      return Promise.reject(error);
    }

    if (this[kEnded]) {
      return Promise.resolve(createIterResult(undefined, true));
    }

    if (this[kStream].destroyed) {
      // We need to defer via nextTick because if .destroy(err) is
      // called, the error will be emitted via nextTick, and
      // we cannot guarantee that there is no error lingering around
      // waiting to be emitted.
      return new Promise(function (resolve, reject) {
        process.nextTick(function () {
          if (_this[kError]) {
            reject(_this[kError]);
          } else {
            resolve(createIterResult(undefined, true));
          }
        });
      });
    } // if we have multiple next() calls
    // we will wait for the previous Promise to finish
    // this logic is optimized to support for await loops,
    // where next() is only called once at a time


    var lastPromise = this[kLastPromise];
    var promise;

    if (lastPromise) {
      promise = new Promise(wrapForNext(lastPromise, this));
    } else {
      // fast path needed to support multiple this.push()
      // without triggering the next() queue
      var data = this[kStream].read();

      if (data !== null) {
        return Promise.resolve(createIterResult(data, false));
      }

      promise = new Promise(this[kHandlePromise]);
    }

    this[kLastPromise] = promise;
    return promise;
  }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
  return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
  var _this2 = this;

  // destroy(err, cb) is a private API
  // we can guarantee we have that here, because we control the
  // Readable class this is attached to
  return new Promise(function (resolve, reject) {
    _this2[kStream].destroy(null, function (err) {
      if (err) {
        reject(err);
        return;
      }

      resolve(createIterResult(undefined, true));
    });
  });
}), _Object$setPrototypeO), AsyncIteratorPrototype);

var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
  var _Object$create;

  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
    value: stream,
    writable: true
  }), _defineProperty(_Object$create, kLastResolve, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kLastReject, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kError, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kEnded, {
    value: stream._readableState.endEmitted,
    writable: true
  }), _defineProperty(_Object$create, kHandlePromise, {
    value: function value(resolve, reject) {
      var data = iterator[kStream].read();

      if (data) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(data, false));
      } else {
        iterator[kLastResolve] = resolve;
        iterator[kLastReject] = reject;
      }
    },
    writable: true
  }), _Object$create));
  iterator[kLastPromise] = null;
  finished(stream, function (err) {
    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
      var reject = iterator[kLastReject]; // reject if we are waiting for data in the Promise
      // returned by next() and store the error

      if (reject !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        reject(err);
      }

      iterator[kError] = err;
      return;
    }

    var resolve = iterator[kLastResolve];

    if (resolve !== null) {
      iterator[kLastPromise] = null;
      iterator[kLastResolve] = null;
      iterator[kLastReject] = null;
      resolve(createIterResult(undefined, true));
    }

    iterator[kEnded] = true;
  });
  stream.on('readable', onReadable.bind(null, iterator));
  return iterator;
};

module.exports = createReadableStreamAsyncIterator;
}).call(this)}).call(this,require('_process'))
},{"./end-of-stream":79,"_process":592}],77:[function(require,module,exports){
'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _require = require('buffer'),
    Buffer = _require.Buffer;

var _require2 = require('util'),
    inspect = _require2.inspect;

var custom = inspect && inspect.custom || 'inspect';

function copyBuffer(src, target, offset) {
  Buffer.prototype.copy.call(src, target, offset);
}

module.exports =
/*#__PURE__*/
function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  _createClass(BufferList, [{
    key: "push",
    value: function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    }
  }, {
    key: "unshift",
    value: function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = null;
      this.length = 0;
    }
  }, {
    key: "join",
    value: function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;

      while (p = p.next) {
        ret += s + p.data;
      }

      return ret;
    }
  }, {
    key: "concat",
    value: function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;

      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }

      return ret;
    } // Consumes a specified amount of bytes or characters from the buffered data.

  }, {
    key: "consume",
    value: function consume(n, hasStrings) {
      var ret;

      if (n < this.head.data.length) {
        // `slice` is the same for buffers and strings.
        ret = this.head.data.slice(0, n);
        this.head.data = this.head.data.slice(n);
      } else if (n === this.head.data.length) {
        // First chunk is a perfect match.
        ret = this.shift();
      } else {
        // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
      }

      return ret;
    }
  }, {
    key: "first",
    value: function first() {
      return this.head.data;
    } // Consumes a specified amount of characters from the buffered data.

  }, {
    key: "_getString",
    value: function _getString(n) {
      var p = this.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;

      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;

        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = str.slice(nb);
          }

          break;
        }

        ++c;
      }

      this.length -= c;
      return ret;
    } // Consumes a specified amount of bytes from the buffered data.

  }, {
    key: "_getBuffer",
    value: function _getBuffer(n) {
      var ret = Buffer.allocUnsafe(n);
      var p = this.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;

      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;

        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = buf.slice(nb);
          }

          break;
        }

        ++c;
      }

      this.length -= c;
      return ret;
    } // Make sure the linked list only shows the minimal necessary information.

  }, {
    key: custom,
    value: function value(_, options) {
      return inspect(this, _objectSpread({}, options, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: false
      }));
    }
  }]);

  return BufferList;
}();
},{"buffer":498,"util":452}],78:[function(require,module,exports){
(function (process){(function (){
'use strict'; // undocumented cb() API, needed for core, not for public API

function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        process.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        process.nextTick(emitErrorNT, this, err);
      }
    }

    return this;
  } // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks


  if (this._readableState) {
    this._readableState.destroyed = true;
  } // if this is a duplex stream mark the writable part as destroyed as well


  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else {
        process.nextTick(emitCloseNT, _this);
      }
    } else if (cb) {
      process.nextTick(emitCloseNT, _this);
      cb(err);
    } else {
      process.nextTick(emitCloseNT, _this);
    }
  });

  return this;
}

function emitErrorAndCloseNT(self, err) {
  emitErrorNT(self, err);
  emitCloseNT(self);
}

function emitCloseNT(self) {
  if (self._writableState && !self._writableState.emitClose) return;
  if (self._readableState && !self._readableState.emitClose) return;
  self.emit('close');
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

function errorOrDestroy(stream, err) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.
  var rState = stream._readableState;
  var wState = stream._writableState;
  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy,
  errorOrDestroy: errorOrDestroy
};
}).call(this)}).call(this,require('_process'))
},{"_process":592}],79:[function(require,module,exports){
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var ERR_STREAM_PREMATURE_CLOSE = require('../../../errors').codes.ERR_STREAM_PREMATURE_CLOSE;

function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    callback.apply(this, args);
  };
}

function noop() {}

function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}

function eos(stream, opts, callback) {
  if (typeof opts === 'function') return eos(stream, null, opts);
  if (!opts) opts = {};
  callback = once(callback || noop);
  var readable = opts.readable || opts.readable !== false && stream.readable;
  var writable = opts.writable || opts.writable !== false && stream.writable;

  var onlegacyfinish = function onlegacyfinish() {
    if (!stream.writable) onfinish();
  };

  var writableEnded = stream._writableState && stream._writableState.finished;

  var onfinish = function onfinish() {
    writable = false;
    writableEnded = true;
    if (!readable) callback.call(stream);
  };

  var readableEnded = stream._readableState && stream._readableState.endEmitted;

  var onend = function onend() {
    readable = false;
    readableEnded = true;
    if (!writable) callback.call(stream);
  };

  var onerror = function onerror(err) {
    callback.call(stream, err);
  };

  var onclose = function onclose() {
    var err;

    if (readable && !readableEnded) {
      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }

    if (writable && !writableEnded) {
      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
  };

  var onrequest = function onrequest() {
    stream.req.on('finish', onfinish);
  };

  if (isRequest(stream)) {
    stream.on('complete', onfinish);
    stream.on('abort', onclose);
    if (stream.req) onrequest();else stream.on('request', onrequest);
  } else if (writable && !stream._writableState) {
    // legacy streams
    stream.on('end', onlegacyfinish);
    stream.on('close', onlegacyfinish);
  }

  stream.on('end', onend);
  stream.on('finish', onfinish);
  if (opts.error !== false) stream.on('error', onerror);
  stream.on('close', onclose);
  return function () {
    stream.removeListener('complete', onfinish);
    stream.removeListener('abort', onclose);
    stream.removeListener('request', onrequest);
    if (stream.req) stream.req.removeListener('finish', onfinish);
    stream.removeListener('end', onlegacyfinish);
    stream.removeListener('close', onlegacyfinish);
    stream.removeListener('finish', onfinish);
    stream.removeListener('end', onend);
    stream.removeListener('error', onerror);
    stream.removeListener('close', onclose);
  };
}

module.exports = eos;
},{"../../../errors":70}],80:[function(require,module,exports){
module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};

},{}],81:[function(require,module,exports){
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var eos;

function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    callback.apply(void 0, arguments);
  };
}

var _require$codes = require('../../../errors').codes,
    ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
    ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;

function noop(err) {
  // Rethrow the error if it exists to avoid swallowing it
  if (err) throw err;
}

function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}

function destroyer(stream, reading, writing, callback) {
  callback = once(callback);
  var closed = false;
  stream.on('close', function () {
    closed = true;
  });
  if (eos === undefined) eos = require('./end-of-stream');
  eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    if (err) return callback(err);
    closed = true;
    callback();
  });
  var destroyed = false;
  return function (err) {
    if (closed) return;
    if (destroyed) return;
    destroyed = true; // request.destroy just do .end - .abort is what we want

    if (isRequest(stream)) return stream.abort();
    if (typeof stream.destroy === 'function') return stream.destroy();
    callback(err || new ERR_STREAM_DESTROYED('pipe'));
  };
}

function call(fn) {
  fn();
}

function pipe(from, to) {
  return from.pipe(to);
}

function popCallback(streams) {
  if (!streams.length) return noop;
  if (typeof streams[streams.length - 1] !== 'function') return noop;
  return streams.pop();
}

function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }

  var callback = popCallback(streams);
  if (Array.isArray(streams[0])) streams = streams[0];

  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }

  var error;
  var destroys = streams.map(function (stream, i) {
    var reading = i < streams.length - 1;
    var writing = i > 0;
    return destroyer(stream, reading, writing, function (err) {
      if (!error) error = err;
      if (err) destroys.forEach(call);
      if (reading) return;
      destroys.forEach(call);
      callback(error);
    });
  });
  return streams.reduce(pipe);
}

module.exports = pipeline;
},{"../../../errors":70,"./end-of-stream":79}],82:[function(require,module,exports){
'use strict';

var ERR_INVALID_OPT_VALUE = require('../../../errors').codes.ERR_INVALID_OPT_VALUE;

function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}

function getHighWaterMark(state, options, duplexKey, isDuplex) {
  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);

  if (hwm != null) {
    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
      var name = isDuplex ? duplexKey : 'highWaterMark';
      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    }

    return Math.floor(hwm);
  } // Default value


  return state.objectMode ? 16 : 16 * 1024;
}

module.exports = {
  getHighWaterMark: getHighWaterMark
};
},{"../../../errors":70}],83:[function(require,module,exports){
module.exports = require('events').EventEmitter;

},{"events":537}],84:[function(require,module,exports){
exports = module.exports = require('./lib/_stream_readable.js');
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = require('./lib/_stream_writable.js');
exports.Duplex = require('./lib/_stream_duplex.js');
exports.Transform = require('./lib/_stream_transform.js');
exports.PassThrough = require('./lib/_stream_passthrough.js');
exports.finished = require('./lib/internal/streams/end-of-stream.js');
exports.pipeline = require('./lib/internal/streams/pipeline.js');

},{"./lib/_stream_duplex.js":71,"./lib/_stream_passthrough.js":72,"./lib/_stream_readable.js":73,"./lib/_stream_transform.js":74,"./lib/_stream_writable.js":75,"./lib/internal/streams/end-of-stream.js":79,"./lib/internal/streams/pipeline.js":81}],85:[function(require,module,exports){
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = require('buffer')
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}

},{"buffer":498}],86:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}
},{"safe-buffer":85}],87:[function(require,module,exports){
var hash = exports;

hash.utils = require('./hash/utils');
hash.common = require('./hash/common');
hash.sha = require('./hash/sha');
hash.ripemd = require('./hash/ripemd');
hash.hmac = require('./hash/hmac');

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;

},{"./hash/common":88,"./hash/hmac":89,"./hash/ripemd":90,"./hash/sha":91,"./hash/utils":98}],88:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var assert = require('minimalistic-assert');

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};

},{"./utils":98,"minimalistic-assert":105}],89:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var assert = require('minimalistic-assert');

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};

},{"./utils":98,"minimalistic-assert":105}],90:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var common = require('./common');

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];

},{"./common":88,"./utils":98}],91:[function(require,module,exports){
'use strict';

exports.sha1 = require('./sha/1');
exports.sha224 = require('./sha/224');
exports.sha256 = require('./sha/256');
exports.sha384 = require('./sha/384');
exports.sha512 = require('./sha/512');

},{"./sha/1":92,"./sha/224":93,"./sha/256":94,"./sha/384":95,"./sha/512":96}],92:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var common = require('../common');
var shaCommon = require('./common');

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

},{"../common":88,"../utils":98,"./common":97}],93:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var SHA256 = require('./256');

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};


},{"../utils":98,"./256":94}],94:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var common = require('../common');
var shaCommon = require('./common');
var assert = require('minimalistic-assert');

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

},{"../common":88,"../utils":98,"./common":97,"minimalistic-assert":105}],95:[function(require,module,exports){
'use strict';

var utils = require('../utils');

var SHA512 = require('./512');

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};

},{"../utils":98,"./512":96}],96:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var common = require('../common');
var assert = require('minimalistic-assert');

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

},{"../common":88,"../utils":98,"minimalistic-assert":105}],97:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;

},{"../utils":98}],98:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');
var inherits = require('inherits');

exports.inherits = inherits;

function isSurrogatePair(msg, i) {
  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
    return false;
  }
  if (i < 0 || i + 1 >= msg.length) {
    return false;
  }
  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      // Inspired by stringToUtf8ByteArray() in closure-library by Google
      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
      // Apache License 2.0
      // https://github.com/google/closure-library/blob/master/LICENSE
      var p = 0;
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        if (c < 128) {
          res[p++] = c;
        } else if (c < 2048) {
          res[p++] = (c >> 6) | 192;
          res[p++] = (c & 63) | 128;
        } else if (isSurrogatePair(msg, i)) {
          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
          res[p++] = (c >> 18) | 240;
          res[p++] = ((c >> 12) & 63) | 128;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        } else {
          res[p++] = (c >> 12) | 224;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        }
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;

},{"inherits":100,"minimalistic-assert":105}],99:[function(require,module,exports){
'use strict';

var hash = require('hash.js');
var utils = require('minimalistic-crypto-utils');
var assert = require('minimalistic-assert');

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};

},{"hash.js":87,"minimalistic-assert":105,"minimalistic-crypto-utils":106}],100:[function(require,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}

},{}],101:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class StringStream {
    constructor(str, pos) {
        this.str = str;
        this.pos = pos;
    }
    char() {
        return this.str[this.pos];
    }
    isDigit() {
        if (this.pos >= this.str.length) {
            return false;
        }
        let code = this.str.charCodeAt(this.pos);
        return code >= 48 && code <= 57;
    }
    isHexDigit() {
        if (this.pos >= this.str.length) {
            return false;
        }
        let code = this.str.charCodeAt(this.pos);
        return (code >= 48 && code <= 57) || (code >= 65 && code <= 70) || (code >= 97 && code <= 102);
    }
    moveUntilSth() {
        while (this.pos < this.str.length) {
            let c = this.str.charCodeAt(this.pos);
            if (c == 9 || c == 10 || c == 13 || c == 32) {
                this.pos++;
            }
            else {
                return;
            }
        }
    }
    move(pos) {
        this.pos += pos;
    }
    eq(c) {
        return this.str[this.pos] == c;
    }
    eqs(s) {
        if (s.charCodeAt(0) != this.str.charCodeAt(this.pos) || this.pos + s.length > this.str.length) {
            return false;
        }
        for (let i = 0; i < s.length; i++) {
            if (s.charCodeAt(i) != this.str.charCodeAt(this.pos + i)) {
                return false;
            }
        }
        return true;
    }
    end() {
        return this.pos >= this.str.length;
    }
}
exports.StringStream = StringStream;
class JsonParser {
    static getPropertyString(json, property) {
        let info = this.parseJson(json);
        if (info.type != "object") {
            throw new Error("Given json is not an object");
        }
        if (info.props[property] == null || info.props[property].value == null) {
            throw new Error("Given property does not exist");
        }
        let prop = info.props[property].value;
        return { json: info, prop: prop, propertyString: JsonParser.getStringFromInfo(json, prop) };
    }
    static getStringFromInfo(json, info) {
        return json.substring(info.startPos, info.endPos);
    }
    static parseJson(str) {
        return this.readJson(new StringStream(str, 0));
    }
    static readJson(ss) {
        let element = JsonParser.readElement(ss);
        if (element == null) {
            throw new Error("Expected element at pos " + ss.pos);
        }
        if (!ss.end()) {
            throw new Error("Unexpected data at " + ss.pos);
        }
        return element;
    }
    static readValue(ss) {
        let res = this.readObject(ss) || this.readArray(ss) || this.readString(ss) || this.readNumber(ss);
        if (res) {
            return res;
        }
        if (ss.eqs("true")) {
            let startPos = ss.pos;
            ss.pos += 4;
            return { type: "bool", value: true, startPos: startPos, endPos: ss.pos };
        }
        if (ss.eqs("false")) {
            let startPos = ss.pos;
            ss.pos += 5;
            return { type: "bool", value: false, startPos: startPos, endPos: ss.pos };
        }
        if (ss.eqs("null")) {
            let startPos = ss.pos;
            ss.pos += 4;
            return { type: "null", value: null, startPos: startPos, endPos: ss.pos };
        }
        return null;
    }
    static readObject(ss) {
        if (!ss.eq("{")) {
            return null;
        }
        let startPos = ss.pos;
        ss.pos++;
        let value = {};
        let props = {};
        ss.moveUntilSth();
        if (!ss.eq("}")) {
            while (true) {
                let member = this.readMember(ss);
                value[member.key.value] = member.value.value;
                props[member.key.value] = member;
                if (ss.end() || !ss.eq(",")) {
                    break;
                }
                ss.pos++;
            }
            if (!ss.eq("}")) {
                throw new Error("Expected '}' character at " + ss.pos);
            }
        }
        ss.pos++;
        return { type: "object", value: value, props: props, startPos: startPos, endPos: ss.pos };
    }
    static readMember(ss) {
        ss.moveUntilSth();
        let key = this.readString(ss);
        if (!key) {
            throw new Error("Expected member key at " + ss.pos);
        }
        ss.moveUntilSth();
        if (!ss.eq(":")) {
            throw new Error("Expected ':' character key at " + ss.pos);
        }
        ss.pos++;
        let value = this.readElement(ss);
        if (!value) {
            throw new Error("Expected memeber value at " + ss.pos);
        }
        return { key: key, value: value };
    }
    static readArray(ss) {
        if (!ss.eq("[")) {
            return null;
        }
        let startPos = ss.pos;
        ss.pos++;
        let value = [];
        let elements = [];
        ss.moveUntilSth();
        if (!ss.eq("]")) {
            while (true) {
                let element = this.readElement(ss);
                value.push(element.value);
                elements.push(element);
                if (ss.end() || !ss.eq(",")) {
                    break;
                }
                ss.pos++;
            }
            if (!ss.eq("]")) {
                throw new Error("Expected ']' character at " + ss.pos);
            }
        }
        ss.pos++;
        return { type: "array", value: value, elements: elements, startPos: startPos, endPos: ss.pos };
    }
    static readElement(ss) {
        ss.moveUntilSth();
        let element = this.readValue(ss);
        if (!element) {
            throw new Error("Expected value at " + ss.pos);
        }
        ss.moveUntilSth();
        return element;
    }
    static isEscaped(s, pos) {
        let count = 1;
        while (pos >= 0 && s[pos] == "\\") {
            count++;
            pos--;
        }
        return count % 2 == 0;
    }
    static readString(ss) {
        if (!ss.eq("\"")) {
            return null;
        }
        let startPos = ss.pos;
        ss.pos++;
        let value = "";
        if (!ss.eq("\"")) {
            while (true) {
                let index = ss.str.indexOf('"', ss.pos);
                if (index == -1) {
                    throw new Error("Unterminated string at " + ss.pos);
                }
                if (ss.str[index - 1] == "\\" && !JsonParser.isEscaped(ss.str, index - 2)) {
                    ss.pos = index + 1;
                }
                else {
                    ss.pos = index;
                    break;
                }
            }
            if (!ss.eq("\"")) {
                throw new Error("Expected '\"' character at " + ss.pos);
            }
            let s = ss.str.substring(startPos + 1, ss.pos);
            value = s.indexOf("\\") == -1 ? s : JSON.parse('"' + s + '"');
        }
        ss.pos++;
        return { type: "string", value: value, startPos: startPos, endPos: ss.pos };
    }
    static readNumber(ss) {
        if (!ss.eq("-") && !ss.isDigit()) {
            return null;
        }
        let startPos = ss.pos;
        if (ss.eq("-")) {
            ss.pos++;
            if (!ss.isDigit()) {
                throw new Error("Expected digit at " + ss.pos);
            }
        }
        let c = ss.char();
        ss.pos++;
        if (c == "0" && ss.isDigit()) {
            throw new Error("Unexpected digit after 0 character at " + ss.pos);
        }
        while (ss.isDigit()) {
            ss.pos++;
        }
        if (ss.eq(".")) {
            ss.pos++;
            if (!ss.isDigit()) {
                throw new Error("Expected digit after '.' character at " + ss.pos);
            }
            do {
                ss.pos++;
            } while (ss.isDigit());
            if (ss.eq("e") || ss.eq("E")) {
                ss.pos++;
                if (ss.eq("+") || ss.eq("-")) {
                    ss.pos++;
                }
                if (!ss.isDigit()) {
                    throw new Error("Expected digit in exponental at " + ss.pos);
                }
                do {
                    ss.pos++;
                } while (ss.isDigit());
            }
        }
        return { type: "number", value: parseFloat(ss.str.substring(startPos, ss.pos)), startPos: startPos, endPos: ss.pos };
    }
}
exports.JsonParser = JsonParser;

},{}],102:[function(require,module,exports){
/*
 Copyright 2013 Daniel Wirtz <dcode@dcode.io>
 Copyright 2009 The Closure Library Authors. All Rights Reserved.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS-IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */

/**
 * @license Long.js (c) 2013 Daniel Wirtz <dcode@dcode.io>
 * Released under the Apache License, Version 2.0
 * see: https://github.com/dcodeIO/Long.js for details
 */
(function(global, factory) {

    /* AMD */ if (typeof define === 'function' && define["amd"])
        define([], factory);
    /* CommonJS */ else if (typeof require === 'function' && typeof module === "object" && module && module["exports"])
        module["exports"] = factory();
    /* Global */ else
        (global["dcodeIO"] = global["dcodeIO"] || {})["Long"] = factory();

})(this, function() {
    "use strict";

    /**
     * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
     *  See the from* functions below for more convenient ways of constructing Longs.
     * @exports Long
     * @class A Long class for representing a 64 bit two's-complement integer value.
     * @param {number} low The low (signed) 32 bits of the long
     * @param {number} high The high (signed) 32 bits of the long
     * @param {boolean=} unsigned Whether unsigned or not, defaults to `false` for signed
     * @constructor
     */
    function Long(low, high, unsigned) {

        /**
         * The low 32 bits as a signed value.
         * @type {number}
         * @expose
         */
        this.low = low|0;

        /**
         * The high 32 bits as a signed value.
         * @type {number}
         * @expose
         */
        this.high = high|0;

        /**
         * Whether unsigned or not.
         * @type {boolean}
         * @expose
         */
        this.unsigned = !!unsigned;
    }

    // The internal representation of a long is the two given signed, 32-bit values.
    // We use 32-bit pieces because these are the size of integers on which
    // Javascript performs bit-operations.  For operations like addition and
    // multiplication, we split each number into 16 bit pieces, which can easily be
    // multiplied within Javascript's floating-point representation without overflow
    // or change in sign.
    //
    // In the algorithms below, we frequently reduce the negative case to the
    // positive case by negating the input(s) and then post-processing the result.
    // Note that we must ALWAYS check specially whether those values are MIN_VALUE
    // (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
    // a positive number, it overflows back into a negative).  Not handling this
    // case would often result in infinite recursion.
    //
    // Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
    // methods on which they depend.

    /**
     * An indicator used to reliably determine if an object is a Long or not.
     * @type {boolean}
     * @const
     * @expose
     * @private
     */
    Long.__isLong__;

    Object.defineProperty(Long.prototype, "__isLong__", {
        value: true,
        enumerable: false,
        configurable: false
    });

    /**
     * Tests if the specified object is a Long.
     * @param {*} obj Object
     * @returns {boolean}
     * @expose
     */
    Long.isLong = function isLong(obj) {
        return (obj && obj["__isLong__"]) === true;
    };

    /**
     * A cache of the Long representations of small integer values.
     * @type {!Object}
     * @inner
     */
    var INT_CACHE = {};

    /**
     * A cache of the Long representations of small unsigned integer values.
     * @type {!Object}
     * @inner
     */
    var UINT_CACHE = {};

    /**
     * Returns a Long representing the given 32 bit integer value.
     * @param {number} value The 32 bit integer in question
     * @param {boolean=} unsigned Whether unsigned or not, defaults to `false` for signed
     * @returns {!Long} The corresponding Long value
     * @expose
     */
    Long.fromInt = function fromInt(value, unsigned) {
        var obj, cachedObj;
        if (!unsigned) {
            value = value | 0;
            if (-128 <= value && value < 128) {
                cachedObj = INT_CACHE[value];
                if (cachedObj)
                    return cachedObj;
            }
            obj = new Long(value, value < 0 ? -1 : 0, false);
            if (-128 <= value && value < 128)
                INT_CACHE[value] = obj;
            return obj;
        } else {
            value = value >>> 0;
            if (0 <= value && value < 256) {
                cachedObj = UINT_CACHE[value];
                if (cachedObj)
                    return cachedObj;
            }
            obj = new Long(value, (value | 0) < 0 ? -1 : 0, true);
            if (0 <= value && value < 256)
                UINT_CACHE[value] = obj;
            return obj;
        }
    };

    /**
     * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
     * @param {number} value The number in question
     * @param {boolean=} unsigned Whether unsigned or not, defaults to `false` for signed
     * @returns {!Long} The corresponding Long value
     * @expose
     */
    Long.fromNumber = function fromNumber(value, unsigned) {
        unsigned = !!unsigned;
        if (isNaN(value) || !isFinite(value))
            return Long.ZERO;
        if (!unsigned && value <= -TWO_PWR_63_DBL)
            return Long.MIN_VALUE;
        if (!unsigned && value + 1 >= TWO_PWR_63_DBL)
            return Long.MAX_VALUE;
        if (unsigned && value >= TWO_PWR_64_DBL)
            return Long.MAX_UNSIGNED_VALUE;
        if (value < 0)
            return Long.fromNumber(-value, unsigned).negate();
        return new Long((value % TWO_PWR_32_DBL) | 0, (value / TWO_PWR_32_DBL) | 0, unsigned);
    };

    /**
     * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
     *  assumed to use 32 bits.
     * @param {number} lowBits The low 32 bits
     * @param {number} highBits The high 32 bits
     * @param {boolean=} unsigned Whether unsigned or not, defaults to `false` for signed
     * @returns {!Long} The corresponding Long value
     * @expose
     */
    Long.fromBits = function fromBits(lowBits, highBits, unsigned) {
        return new Long(lowBits, highBits, unsigned);
    };

    /**
     * Returns a Long representation of the given string, written using the specified radix.
     * @param {string} str The textual representation of the Long
     * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to `false` for signed
     * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
     * @returns {!Long} The corresponding Long value
     * @expose
     */
    Long.fromString = function fromString(str, unsigned, radix) {
        if (str.length === 0)
            throw Error('number format error: empty string');
        if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity")
            return Long.ZERO;
        if (typeof unsigned === 'number') // For goog.math.long compatibility
            radix = unsigned,
            unsigned = false;
        radix = radix || 10;
        if (radix < 2 || 36 < radix)
            throw Error('radix out of range: ' + radix);

        var p;
        if ((p = str.indexOf('-')) > 0)
            throw Error('number format error: interior "-" character: ' + str);
        else if (p === 0)
            return Long.fromString(str.substring(1), unsigned, radix).negate();

        // Do several (8) digits each time through the loop, so as to
        // minimize the calls to the very expensive emulated div.
        var radixToPower = Long.fromNumber(Math.pow(radix, 8));

        var result = Long.ZERO;
        for (var i = 0; i < str.length; i += 8) {
            var size = Math.min(8, str.length - i);
            var value = parseInt(str.substring(i, i + size), radix);
            if (size < 8) {
                var power = Long.fromNumber(Math.pow(radix, size));
                result = result.multiply(power).add(Long.fromNumber(value));
            } else {
                result = result.multiply(radixToPower);
                result = result.add(Long.fromNumber(value));
            }
        }
        result.unsigned = unsigned;
        return result;
    };

    /**
     * Converts the specified value to a Long.
     * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
     * @returns {!Long}
     * @expose
     */
    Long.fromValue = function fromValue(val) {
        if (val /* is compatible */ instanceof Long)
            return val;
        if (typeof val === 'number')
            return Long.fromNumber(val);
        if (typeof val === 'string')
            return Long.fromString(val);
        // Throws for non-objects, converts non-instanceof Long:
        return new Long(val.low, val.high, val.unsigned);
    };

    // NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
    // no runtime penalty for these.

    /**
     * @type {number}
     * @const
     * @inner
     */
    var TWO_PWR_16_DBL = 1 << 16;

    /**
     * @type {number}
     * @const
     * @inner
     */
    var TWO_PWR_24_DBL = 1 << 24;

    /**
     * @type {number}
     * @const
     * @inner
     */
    var TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL;

    /**
     * @type {number}
     * @const
     * @inner
     */
    var TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL;

    /**
     * @type {number}
     * @const
     * @inner
     */
    var TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2;

    /**
     * @type {!Long}
     * @const
     * @inner
     */
    var TWO_PWR_24 = Long.fromInt(TWO_PWR_24_DBL);

    /**
     * Signed zero.
     * @type {!Long}
     * @expose
     */
    Long.ZERO = Long.fromInt(0);

    /**
     * Unsigned zero.
     * @type {!Long}
     * @expose
     */
    Long.UZERO = Long.fromInt(0, true);

    /**
     * Signed one.
     * @type {!Long}
     * @expose
     */
    Long.ONE = Long.fromInt(1);

    /**
     * Unsigned one.
     * @type {!Long}
     * @expose
     */
    Long.UONE = Long.fromInt(1, true);

    /**
     * Signed negative one.
     * @type {!Long}
     * @expose
     */
    Long.NEG_ONE = Long.fromInt(-1);

    /**
     * Maximum signed value.
     * @type {!Long}
     * @expose
     */
    Long.MAX_VALUE = Long.fromBits(0xFFFFFFFF|0, 0x7FFFFFFF|0, false);

    /**
     * Maximum unsigned value.
     * @type {!Long}
     * @expose
     */
    Long.MAX_UNSIGNED_VALUE = Long.fromBits(0xFFFFFFFF|0, 0xFFFFFFFF|0, true);

    /**
     * Minimum signed value.
     * @type {!Long}
     * @expose
     */
    Long.MIN_VALUE = Long.fromBits(0, 0x80000000|0, false);

    /**
     * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
     * @returns {number}
     * @expose
     */
    Long.prototype.toInt = function toInt() {
        return this.unsigned ? this.low >>> 0 : this.low;
    };

    /**
     * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
     * @returns {number}
     * @expose
     */
    Long.prototype.toNumber = function toNumber() {
        if (this.unsigned) {
            return ((this.high >>> 0) * TWO_PWR_32_DBL) + (this.low >>> 0);
        }
        return this.high * TWO_PWR_32_DBL + (this.low >>> 0);
    };

    /**
     * Converts the Long to a string written in the specified radix.
     * @param {number=} radix Radix (2-36), defaults to 10
     * @returns {string}
     * @override
     * @throws {RangeError} If `radix` is out of range
     * @expose
     */
    Long.prototype.toString = function toString(radix) {
        radix = radix || 10;
        if (radix < 2 || 36 < radix)
            throw RangeError('radix out of range: ' + radix);
        if (this.isZero())
            return '0';
        var rem;
        if (this.isNegative()) { // Unsigned Longs are never negative
            if (this.equals(Long.MIN_VALUE)) {
                // We need to change the Long value before it can be negated, so we remove
                // the bottom-most digit in this base and then recurse to do the rest.
                var radixLong = Long.fromNumber(radix);
                var div = this.divide(radixLong);
                rem = div.multiply(radixLong).subtract(this);
                return div.toString(radix) + rem.toInt().toString(radix);
            } else
                return '-' + this.negate().toString(radix);
        }

        // Do several (6) digits each time through the loop, so as to
        // minimize the calls to the very expensive emulated div.
        var radixToPower = Long.fromNumber(Math.pow(radix, 6), this.unsigned);
        rem = this;
        var result = '';
        while (true) {
            var remDiv = rem.divide(radixToPower),
                intval = rem.subtract(remDiv.multiply(radixToPower)).toInt() >>> 0,
                digits = intval.toString(radix);
            rem = remDiv;
            if (rem.isZero())
                return digits + result;
            else {
                while (digits.length < 6)
                    digits = '0' + digits;
                result = '' + digits + result;
            }
        }
    };

    /**
     * Gets the high 32 bits as a signed integer.
     * @returns {number} Signed high bits
     * @expose
     */
    Long.prototype.getHighBits = function getHighBits() {
        return this.high;
    };

    /**
     * Gets the high 32 bits as an unsigned integer.
     * @returns {number} Unsigned high bits
     * @expose
     */
    Long.prototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
        return this.high >>> 0;
    };

    /**
     * Gets the low 32 bits as a signed integer.
     * @returns {number} Signed low bits
     * @expose
     */
    Long.prototype.getLowBits = function getLowBits() {
        return this.low;
    };

    /**
     * Gets the low 32 bits as an unsigned integer.
     * @returns {number} Unsigned low bits
     * @expose
     */
    Long.prototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
        return this.low >>> 0;
    };

    /**
     * Gets the number of bits needed to represent the absolute value of this Long.
     * @returns {number}
     * @expose
     */
    Long.prototype.getNumBitsAbs = function getNumBitsAbs() {
        if (this.isNegative()) // Unsigned Longs are never negative
            return this.equals(Long.MIN_VALUE) ? 64 : this.negate().getNumBitsAbs();
        var val = this.high != 0 ? this.high : this.low;
        for (var bit = 31; bit > 0; bit--)
            if ((val & (1 << bit)) != 0)
                break;
        return this.high != 0 ? bit + 33 : bit + 1;
    };

    /**
     * Tests if this Long's value equals zero.
     * @returns {boolean}
     * @expose
     */
    Long.prototype.isZero = function isZero() {
        return this.high === 0 && this.low === 0;
    };

    /**
     * Tests if this Long's value is negative.
     * @returns {boolean}
     * @expose
     */
    Long.prototype.isNegative = function isNegative() {
        return !this.unsigned && this.high < 0;
    };

    /**
     * Tests if this Long's value is positive.
     * @returns {boolean}
     * @expose
     */
    Long.prototype.isPositive = function isPositive() {
        return this.unsigned || this.high >= 0;
    };

    /**
     * Tests if this Long's value is odd.
     * @returns {boolean}
     * @expose
     */
    Long.prototype.isOdd = function isOdd() {
        return (this.low & 1) === 1;
    };

    /**
     * Tests if this Long's value is even.
     * @returns {boolean}
     * @expose
     */
    Long.prototype.isEven = function isEven() {
        return (this.low & 1) === 0;
    };

    /**
     * Tests if this Long's value equals the specified's.
     * @param {!Long|number|string} other Other value
     * @returns {boolean}
     * @expose
     */
    Long.prototype.equals = function equals(other) {
        if (!Long.isLong(other))
            other = Long.fromValue(other);
        if (this.unsigned !== other.unsigned && (this.high >>> 31) === 1 && (other.high >>> 31) === 1)
            return false;
        return this.high === other.high && this.low === other.low;
    };

    /**
     * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
     * @function
     * @param {!Long|number|string} other Other value
     * @returns {boolean}
     * @expose
     */
    Long.eq = Long.prototype.equals;

    /**
     * Tests if this Long's value differs from the specified's.
     * @param {!Long|number|string} other Other value
     * @returns {boolean}
     * @expose
     */
    Long.prototype.notEquals = function notEquals(other) {
        return !this.equals(/* validates */ other);
    };

    /**
     * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
     * @function
     * @param {!Long|number|string} other Other value
     * @returns {boolean}
     * @expose
     */
    Long.neq = Long.prototype.notEquals;

    /**
     * Tests if this Long's value is less than the specified's.
     * @param {!Long|number|string} other Other value
     * @returns {boolean}
     * @expose
     */
    Long.prototype.lessThan = function lessThan(other) {
        return this.compare(/* validates */ other) < 0;
    };

    /**
     * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
     * @function
     * @param {!Long|number|string} other Other value
     * @returns {boolean}
     * @expose
     */
    Long.prototype.lt = Long.prototype.lessThan;

    /**
     * Tests if this Long's value is less than or equal the specified's.
     * @param {!Long|number|string} other Other value
     * @returns {boolean}
     * @expose
     */
    Long.prototype.lessThanOrEqual = function lessThanOrEqual(other) {
        return this.compare(/* validates */ other) <= 0;
    };

    /**
     * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
     * @function
     * @param {!Long|number|string} other Other value
     * @returns {boolean}
     * @expose
     */
    Long.prototype.lte = Long.prototype.lessThanOrEqual;

    /**
     * Tests if this Long's value is greater than the specified's.
     * @param {!Long|number|string} other Other value
     * @returns {boolean}
     * @expose
     */
    Long.prototype.greaterThan = function greaterThan(other) {
        return this.compare(/* validates */ other) > 0;
    };

    /**
     * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
     * @function
     * @param {!Long|number|string} other Other value
     * @returns {boolean}
     * @expose
     */
    Long.prototype.gt = Long.prototype.greaterThan;

    /**
     * Tests if this Long's value is greater than or equal the specified's.
     * @param {!Long|number|string} other Other value
     * @returns {boolean}
     * @expose
     */
    Long.prototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
        return this.compare(/* validates */ other) >= 0;
    };

    /**
     * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
     * @function
     * @param {!Long|number|string} other Other value
     * @returns {boolean}
     * @expose
     */
    Long.prototype.gte = Long.prototype.greaterThanOrEqual;

    /**
     * Compares this Long's value with the specified's.
     * @param {!Long|number|string} other Other value
     * @returns {number} 0 if they are the same, 1 if the this is greater and -1
     *  if the given one is greater
     * @expose
     */
    Long.prototype.compare = function compare(other) {
        if (!Long.isLong(other))
            other = Long.fromValue(other);
        if (this.equals(other))
            return 0;
        var thisNeg = this.isNegative(),
            otherNeg = other.isNegative();
        if (thisNeg && !otherNeg)
            return -1;
        if (!thisNeg && otherNeg)
            return 1;
        // At this point the sign bits are the same
        if (!this.unsigned)
            return this.subtract(other).isNegative() ? -1 : 1;
        // Both are positive if at least one is unsigned
        return (other.high >>> 0) > (this.high >>> 0) || (other.high === this.high && (other.low >>> 0) > (this.low >>> 0)) ? -1 : 1;
    };

    /**
     * Negates this Long's value.
     * @returns {!Long} Negated Long
     * @expose
     */
    Long.prototype.negate = function negate() {
        if (!this.unsigned && this.equals(Long.MIN_VALUE))
            return Long.MIN_VALUE;
        return this.not().add(Long.ONE);
    };

    /**
     * Negates this Long's value. This is an alias of {@link Long#negate}.
     * @function
     * @returns {!Long} Negated Long
     * @expose
     */
    Long.prototype.neg = Long.prototype.negate;

    /**
     * Returns the sum of this and the specified Long.
     * @param {!Long|number|string} addend Addend
     * @returns {!Long} Sum
     * @expose
     */
    Long.prototype.add = function add(addend) {
        if (!Long.isLong(addend))
            addend = Long.fromValue(addend);

        // Divide each number into 4 chunks of 16 bits, and then sum the chunks.

        var a48 = this.high >>> 16;
        var a32 = this.high & 0xFFFF;
        var a16 = this.low >>> 16;
        var a00 = this.low & 0xFFFF;

        var b48 = addend.high >>> 16;
        var b32 = addend.high & 0xFFFF;
        var b16 = addend.low >>> 16;
        var b00 = addend.low & 0xFFFF;

        var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
        c00 += a00 + b00;
        c16 += c00 >>> 16;
        c00 &= 0xFFFF;
        c16 += a16 + b16;
        c32 += c16 >>> 16;
        c16 &= 0xFFFF;
        c32 += a32 + b32;
        c48 += c32 >>> 16;
        c32 &= 0xFFFF;
        c48 += a48 + b48;
        c48 &= 0xFFFF;
        return Long.fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
    };

    /**
     * Returns the difference of this and the specified Long.
     * @param {!Long|number|string} subtrahend Subtrahend
     * @returns {!Long} Difference
     * @expose
     */
    Long.prototype.subtract = function subtract(subtrahend) {
        if (!Long.isLong(subtrahend))
            subtrahend = Long.fromValue(subtrahend);
        return this.add(subtrahend.negate());
    };

    /**
     * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
     * @function
     * @param {!Long|number|string} subtrahend Subtrahend
     * @returns {!Long} Difference
     * @expose
     */
    Long.prototype.sub = Long.prototype.subtract;

    /**
     * Returns the product of this and the specified Long.
     * @param {!Long|number|string} multiplier Multiplier
     * @returns {!Long} Product
     * @expose
     */
    Long.prototype.multiply = function multiply(multiplier) {
        if (this.isZero())
            return Long.ZERO;
        if (!Long.isLong(multiplier))
            multiplier = Long.fromValue(multiplier);
        if (multiplier.isZero())
            return Long.ZERO;
        if (this.equals(Long.MIN_VALUE))
            return multiplier.isOdd() ? Long.MIN_VALUE : Long.ZERO;
        if (multiplier.equals(Long.MIN_VALUE))
            return this.isOdd() ? Long.MIN_VALUE : Long.ZERO;

        if (this.isNegative()) {
            if (multiplier.isNegative())
                return this.negate().multiply(multiplier.negate());
            else
                return this.negate().multiply(multiplier).negate();
        } else if (multiplier.isNegative())
            return this.multiply(multiplier.negate()).negate();

        // If both longs are small, use float multiplication
        if (this.lessThan(TWO_PWR_24) && multiplier.lessThan(TWO_PWR_24))
            return Long.fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);

        // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
        // We can skip products that would overflow.

        var a48 = this.high >>> 16;
        var a32 = this.high & 0xFFFF;
        var a16 = this.low >>> 16;
        var a00 = this.low & 0xFFFF;

        var b48 = multiplier.high >>> 16;
        var b32 = multiplier.high & 0xFFFF;
        var b16 = multiplier.low >>> 16;
        var b00 = multiplier.low & 0xFFFF;

        var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
        c00 += a00 * b00;
        c16 += c00 >>> 16;
        c00 &= 0xFFFF;
        c16 += a16 * b00;
        c32 += c16 >>> 16;
        c16 &= 0xFFFF;
        c16 += a00 * b16;
        c32 += c16 >>> 16;
        c16 &= 0xFFFF;
        c32 += a32 * b00;
        c48 += c32 >>> 16;
        c32 &= 0xFFFF;
        c32 += a16 * b16;
        c48 += c32 >>> 16;
        c32 &= 0xFFFF;
        c32 += a00 * b32;
        c48 += c32 >>> 16;
        c32 &= 0xFFFF;
        c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
        c48 &= 0xFFFF;
        return Long.fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
    };

    /**
     * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
     * @function
     * @param {!Long|number|string} multiplier Multiplier
     * @returns {!Long} Product
     * @expose
     */
    Long.prototype.mul = Long.prototype.multiply;

    /**
     * Returns this Long divided by the specified.
     * @param {!Long|number|string} divisor Divisor
     * @returns {!Long} Quotient
     * @expose
     */
    Long.prototype.divide = function divide(divisor) {
        if (!Long.isLong(divisor))
            divisor = Long.fromValue(divisor);
        if (divisor.isZero())
            throw(new Error('division by zero'));
        if (this.isZero())
            return this.unsigned ? Long.UZERO : Long.ZERO;
        var approx, rem, res;
        if (this.equals(Long.MIN_VALUE)) {
            if (divisor.equals(Long.ONE) || divisor.equals(Long.NEG_ONE))
                return Long.MIN_VALUE;  // recall that -MIN_VALUE == MIN_VALUE
            else if (divisor.equals(Long.MIN_VALUE))
                return Long.ONE;
            else {
                // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                var halfThis = this.shiftRight(1);
                approx = halfThis.divide(divisor).shiftLeft(1);
                if (approx.equals(Long.ZERO)) {
                    return divisor.isNegative() ? Long.ONE : Long.NEG_ONE;
                } else {
                    rem = this.subtract(divisor.multiply(approx));
                    res = approx.add(rem.divide(divisor));
                    return res;
                }
            }
        } else if (divisor.equals(Long.MIN_VALUE))
            return this.unsigned ? Long.UZERO : Long.ZERO;
        if (this.isNegative()) {
            if (divisor.isNegative())
                return this.negate().divide(divisor.negate());
            return this.negate().divide(divisor).negate();
        } else if (divisor.isNegative())
            return this.divide(divisor.negate()).negate();

        // Repeat the following until the remainder is less than other:  find a
        // floating-point that approximates remainder / other *from below*, add this
        // into the result, and subtract it from the remainder.  It is critical that
        // the approximate value is less than or equal to the real value so that the
        // remainder never becomes negative.
        res = Long.ZERO;
        rem = this;
        while (rem.greaterThanOrEqual(divisor)) {
            // Approximate the result of division. This may be a little greater or
            // smaller than the actual value.
            approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));

            // We will tweak the approximate result by changing it in the 48-th digit or
            // the smallest non-fractional digit, whichever is larger.
            var log2 = Math.ceil(Math.log(approx) / Math.LN2),
                delta = (log2 <= 48) ? 1 : Math.pow(2, log2 - 48),

            // Decrease the approximation until it is smaller than the remainder.  Note
            // that if it is too large, the product overflows and is negative.
                approxRes = Long.fromNumber(approx),
                approxRem = approxRes.multiply(divisor);
            while (approxRem.isNegative() || approxRem.greaterThan(rem)) {
                approx -= delta;
                approxRes = Long.fromNumber(approx, this.unsigned);
                approxRem = approxRes.multiply(divisor);
            }

            // We know the answer can't be zero... and actually, zero would cause
            // infinite recursion since we would make no progress.
            if (approxRes.isZero())
                approxRes = Long.ONE;

            res = res.add(approxRes);
            rem = rem.subtract(approxRem);
        }
        return res;
    };

    /**
     * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
     * @function
     * @param {!Long|number|string} divisor Divisor
     * @returns {!Long} Quotient
     * @expose
     */
    Long.prototype.div = Long.prototype.divide;

    /**
     * Returns this Long modulo the specified.
     * @param {!Long|number|string} divisor Divisor
     * @returns {!Long} Remainder
     * @expose
     */
    Long.prototype.modulo = function modulo(divisor) {
        if (!Long.isLong(divisor))
            divisor = Long.fromValue(divisor);
        return this.subtract(this.divide(divisor).multiply(divisor));
    };

    /**
     * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
     * @function
     * @param {!Long|number|string} divisor Divisor
     * @returns {!Long} Remainder
     * @expose
     */
    Long.prototype.mod = Long.prototype.modulo;

    /**
     * Returns the bitwise NOT of this Long.
     * @returns {!Long}
     * @expose
     */
    Long.prototype.not = function not() {
        return Long.fromBits(~this.low, ~this.high, this.unsigned);
    };

    /**
     * Returns the bitwise AND of this Long and the specified.
     * @param {!Long|number|string} other Other Long
     * @returns {!Long}
     * @expose
     */
    Long.prototype.and = function and(other) {
        if (!Long.isLong(other))
            other = Long.fromValue(other);
        return Long.fromBits(this.low & other.low, this.high & other.high, this.unsigned);
    };

    /**
     * Returns the bitwise OR of this Long and the specified.
     * @param {!Long|number|string} other Other Long
     * @returns {!Long}
     * @expose
     */
    Long.prototype.or = function or(other) {
        if (!Long.isLong(other))
            other = Long.fromValue(other);
        return Long.fromBits(this.low | other.low, this.high | other.high, this.unsigned);
    };

    /**
     * Returns the bitwise XOR of this Long and the given one.
     * @param {!Long|number|string} other Other Long
     * @returns {!Long}
     * @expose
     */
    Long.prototype.xor = function xor(other) {
        if (!Long.isLong(other))
            other = Long.fromValue(other);
        return Long.fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
    };

    /**
     * Returns this Long with bits shifted to the left by the given amount.
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     * @expose
     */
    Long.prototype.shiftLeft = function shiftLeft(numBits) {
        if (Long.isLong(numBits))
            numBits = numBits.toInt();
        if ((numBits &= 63) === 0)
            return this;
        else if (numBits < 32)
            return Long.fromBits(this.low << numBits, (this.high << numBits) | (this.low >>> (32 - numBits)), this.unsigned);
        else
            return Long.fromBits(0, this.low << (numBits - 32), this.unsigned);
    };

    /**
     * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
     * @function
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     * @expose
     */
    Long.prototype.shl = Long.prototype.shiftLeft;

    /**
     * Returns this Long with bits arithmetically shifted to the right by the given amount.
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     * @expose
     */
    Long.prototype.shiftRight = function shiftRight(numBits) {
        if (Long.isLong(numBits))
            numBits = numBits.toInt();
        if ((numBits &= 63) === 0)
            return this;
        else if (numBits < 32)
            return Long.fromBits((this.low >>> numBits) | (this.high << (32 - numBits)), this.high >> numBits, this.unsigned);
        else
            return Long.fromBits(this.high >> (numBits - 32), this.high >= 0 ? 0 : -1, this.unsigned);
    };

    /**
     * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
     * @function
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     * @expose
     */
    Long.prototype.shr = Long.prototype.shiftRight;

    /**
     * Returns this Long with bits logically shifted to the right by the given amount.
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     * @expose
     */
    Long.prototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
        if (Long.isLong(numBits))
            numBits = numBits.toInt();
        numBits &= 63;
        if (numBits === 0)
            return this;
        else {
            var high = this.high;
            if (numBits < 32) {
                var low = this.low;
                return Long.fromBits((low >>> numBits) | (high << (32 - numBits)), high >>> numBits, this.unsigned);
            } else if (numBits === 32)
                return Long.fromBits(high, 0, this.unsigned);
            else
                return Long.fromBits(high >>> (numBits - 32), 0, this.unsigned);
        }
    };

    /**
     * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
     * @function
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     * @expose
     */
    Long.prototype.shru = Long.prototype.shiftRightUnsigned;

    /**
     * Converts this Long to signed.
     * @returns {!Long} Signed long
     * @expose
     */
    Long.prototype.toSigned = function toSigned() {
        if (!this.unsigned)
            return this;
        return new Long(this.low, this.high, false);
    };

    /**
     * Converts this Long to unsigned.
     * @returns {!Long} Unsigned long
     * @expose
     */
    Long.prototype.toUnsigned = function toUnsigned() {
        if (this.unsigned)
            return this;
        return new Long(this.low, this.high, true);
    };

    return Long;
});

},{}],103:[function(require,module,exports){
'use strict'
var inherits = require('inherits')
var HashBase = require('hash-base')
var Buffer = require('safe-buffer').Buffer

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.allocUnsafe(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5

},{"hash-base":69,"inherits":100,"safe-buffer":104}],104:[function(require,module,exports){
arguments[4][85][0].apply(exports,arguments)
},{"buffer":498,"dup":85}],105:[function(require,module,exports){
module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};

},{}],106:[function(require,module,exports){
'use strict';

var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};

},{}],107:[function(require,module,exports){
module.exports={"2.16.840.1.101.3.4.1.1": "aes-128-ecb",
"2.16.840.1.101.3.4.1.2": "aes-128-cbc",
"2.16.840.1.101.3.4.1.3": "aes-128-ofb",
"2.16.840.1.101.3.4.1.4": "aes-128-cfb",
"2.16.840.1.101.3.4.1.21": "aes-192-ecb",
"2.16.840.1.101.3.4.1.22": "aes-192-cbc",
"2.16.840.1.101.3.4.1.23": "aes-192-ofb",
"2.16.840.1.101.3.4.1.24": "aes-192-cfb",
"2.16.840.1.101.3.4.1.41": "aes-256-ecb",
"2.16.840.1.101.3.4.1.42": "aes-256-cbc",
"2.16.840.1.101.3.4.1.43": "aes-256-ofb",
"2.16.840.1.101.3.4.1.44": "aes-256-cfb"
}
},{}],108:[function(require,module,exports){
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
'use strict'

var asn1 = require('asn1.js')

exports.certificate = require('./certificate')

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('modulus').int(),
    this.key('publicExponent').int(),
    this.key('privateExponent').int(),
    this.key('prime1').int(),
    this.key('prime2').int(),
    this.key('exponent1').int(),
    this.key('exponent2').int(),
    this.key('coefficient').int()
  )
})
exports.RSAPrivateKey = RSAPrivateKey

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
  this.seq().obj(
    this.key('modulus').int(),
    this.key('publicExponent').int()
  )
})
exports.RSAPublicKey = RSAPublicKey

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})
exports.PublicKey = PublicKey

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('none').null_().optional(),
    this.key('curve').objid().optional(),
    this.key('params').seq().obj(
      this.key('p').int(),
      this.key('q').int(),
      this.key('g').int()
    ).optional()
  )
})

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPrivateKey').octstr()
  )
})
exports.PrivateKey = PrivateKeyInfo
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').seq().obj(
      this.key('id').objid(),
      this.key('decrypt').seq().obj(
        this.key('kde').seq().obj(
          this.key('id').objid(),
          this.key('kdeparams').seq().obj(
            this.key('salt').octstr(),
            this.key('iters').int()
          )
        ),
        this.key('cipher').seq().obj(
          this.key('algo').objid(),
          this.key('iv').octstr()
        )
      )
    ),
    this.key('subjectPrivateKey').octstr()
  )
})

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('p').int(),
    this.key('q').int(),
    this.key('g').int(),
    this.key('pub_key').int(),
    this.key('priv_key').int()
  )
})
exports.DSAPrivateKey = DSAPrivateKey

exports.DSAparam = asn1.define('DSAparam', function () {
  this.int()
})

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('privateKey').octstr(),
    this.key('parameters').optional().explicit(0).use(ECParameters),
    this.key('publicKey').optional().explicit(1).bitstr()
  )
})
exports.ECPrivateKey = ECPrivateKey

var ECParameters = asn1.define('ECParameters', function () {
  this.choice({
    namedCurve: this.objid()
  })
})

exports.signature = asn1.define('signature', function () {
  this.seq().obj(
    this.key('r').int(),
    this.key('s').int()
  )
})

},{"./certificate":109,"asn1.js":112}],109:[function(require,module,exports){
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen

'use strict'

var asn = require('asn1.js')

var Time = asn.define('Time', function () {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  })
})

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
  this.seq().obj(
    this.key('type').objid(),
    this.key('value').any()
  )
})

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('parameters').optional(),
    this.key('curve').objid().optional()
  )
})

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
  this.setof(AttributeTypeValue)
})

var RDNSequence = asn.define('RDNSequence', function () {
  this.seqof(RelativeDistinguishedName)
})

var Name = asn.define('Name', function () {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  })
})

var Validity = asn.define('Validity', function () {
  this.seq().obj(
    this.key('notBefore').use(Time),
    this.key('notAfter').use(Time)
  )
})

var Extension = asn.define('Extension', function () {
  this.seq().obj(
    this.key('extnID').objid(),
    this.key('critical').bool().def(false),
    this.key('extnValue').octstr()
  )
})

var TBSCertificate = asn.define('TBSCertificate', function () {
  this.seq().obj(
    this.key('version').explicit(0).int().optional(),
    this.key('serialNumber').int(),
    this.key('signature').use(AlgorithmIdentifier),
    this.key('issuer').use(Name),
    this.key('validity').use(Validity),
    this.key('subject').use(Name),
    this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
    this.key('issuerUniqueID').implicit(1).bitstr().optional(),
    this.key('subjectUniqueID').implicit(2).bitstr().optional(),
    this.key('extensions').explicit(3).seqof(Extension).optional()
  )
})

var X509Certificate = asn.define('X509Certificate', function () {
  this.seq().obj(
    this.key('tbsCertificate').use(TBSCertificate),
    this.key('signatureAlgorithm').use(AlgorithmIdentifier),
    this.key('signatureValue').bitstr()
  )
})

module.exports = X509Certificate

},{"asn1.js":112}],110:[function(require,module,exports){
// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m
var startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m
var fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m
var evp = require('evp_bytestokey')
var ciphers = require('browserify-aes')
var Buffer = require('safe-buffer').Buffer
module.exports = function (okey, password) {
  var key = okey.toString()
  var match = key.match(findProc)
  var decrypted
  if (!match) {
    var match2 = key.match(fullRegex)
    decrypted = Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64')
  } else {
    var suite = 'aes' + match[1]
    var iv = Buffer.from(match[2], 'hex')
    var cipherText = Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64')
    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
    var out = []
    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
    out.push(cipher.update(cipherText))
    out.push(cipher.final())
    decrypted = Buffer.concat(out)
  }
  var tag = key.match(startRegex)[1]
  return {
    tag: tag,
    data: decrypted
  }
}

},{"browserify-aes":29,"evp_bytestokey":68,"safe-buffer":379}],111:[function(require,module,exports){
var asn1 = require('./asn1')
var aesid = require('./aesid.json')
var fixProc = require('./fixProc')
var ciphers = require('browserify-aes')
var compat = require('pbkdf2')
var Buffer = require('safe-buffer').Buffer
module.exports = parseKeys

function parseKeys (buffer) {
  var password
  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
    password = buffer.passphrase
    buffer = buffer.key
  }
  if (typeof buffer === 'string') {
    buffer = Buffer.from(buffer)
  }

  var stripped = fixProc(buffer, password)

  var type = stripped.tag
  var data = stripped.data
  var subtype, ndata
  switch (type) {
    case 'CERTIFICATE':
      ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo
      // falls through
    case 'PUBLIC KEY':
      if (!ndata) {
        ndata = asn1.PublicKey.decode(data, 'der')
      }
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
        case '1.2.840.10045.2.1':
          ndata.subjectPrivateKey = ndata.subjectPublicKey
          return {
            type: 'ec',
            data: ndata
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
          return {
            type: 'dsa',
            data: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      // throw new Error('unknown key type ' + type)
    case 'ENCRYPTED PRIVATE KEY':
      data = asn1.EncryptedPrivateKey.decode(data, 'der')
      data = decrypt(data, password)
      // falls through
    case 'PRIVATE KEY':
      ndata = asn1.PrivateKey.decode(data, 'der')
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
        case '1.2.840.10045.2.1':
          return {
            curve: ndata.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
          return {
            type: 'dsa',
            params: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      // throw new Error('unknown key type ' + type)
    case 'RSA PUBLIC KEY':
      return asn1.RSAPublicKey.decode(data, 'der')
    case 'RSA PRIVATE KEY':
      return asn1.RSAPrivateKey.decode(data, 'der')
    case 'DSA PRIVATE KEY':
      return {
        type: 'dsa',
        params: asn1.DSAPrivateKey.decode(data, 'der')
      }
    case 'EC PRIVATE KEY':
      data = asn1.ECPrivateKey.decode(data, 'der')
      return {
        curve: data.parameters.value,
        privateKey: data.privateKey
      }
    default: throw new Error('unknown key type ' + type)
  }
}
parseKeys.signature = asn1.signature
function decrypt (data, password) {
  var salt = data.algorithm.decrypt.kde.kdeparams.salt
  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
  var iv = data.algorithm.decrypt.cipher.iv
  var cipherText = data.subjectPrivateKey
  var keylen = parseInt(algo.split('-')[1], 10) / 8
  var key = compat.pbkdf2Sync(password, salt, iters, keylen, 'sha1')
  var cipher = ciphers.createDecipheriv(algo, key, iv)
  var out = []
  out.push(cipher.update(cipherText))
  out.push(cipher.final())
  return Buffer.concat(out)
}

},{"./aesid.json":107,"./asn1":108,"./fixProc":110,"browserify-aes":29,"pbkdf2":126,"safe-buffer":379}],112:[function(require,module,exports){
'use strict';

const asn1 = exports;

asn1.bignum = require('bn.js');

asn1.define = require('./asn1/api').define;
asn1.base = require('./asn1/base');
asn1.constants = require('./asn1/constants');
asn1.decoders = require('./asn1/decoders');
asn1.encoders = require('./asn1/encoders');

},{"./asn1/api":113,"./asn1/base":115,"./asn1/constants":119,"./asn1/decoders":121,"./asn1/encoders":124,"bn.js":25}],113:[function(require,module,exports){
'use strict';

const encoders = require('./encoders');
const decoders = require('./decoders');
const inherits = require('inherits');

const api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
}

Entity.prototype._createNamed = function createNamed(Base) {
  const name = this.name;

  function Generated(entity) {
    this._initNamed(entity, name);
  }
  inherits(Generated, Base);
  Generated.prototype._initNamed = function _initNamed(entity, name) {
    Base.call(this, entity, name);
  };

  return new Generated(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};

},{"./decoders":121,"./encoders":124,"inherits":100}],114:[function(require,module,exports){
'use strict';

const inherits = require('inherits');
const Reporter = require('../base/reporter').Reporter;
const Buffer = require('safer-buffer').Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
  if (data instanceof DecoderBuffer) {
    return true;
  }

  // Or accept compatible API
  const isCompatible = typeof data === 'object' &&
    Buffer.isBuffer(data.base) &&
    data.constructor.name === 'DecoderBuffer' &&
    typeof data.offset === 'number' &&
    typeof data.length === 'number' &&
    typeof data.save === 'function' &&
    typeof data.restore === 'function' &&
    typeof data.isEmpty === 'function' &&
    typeof data.readUInt8 === 'function' &&
    typeof data.skip === 'function' &&
    typeof data.raw === 'function';

  return isCompatible;
};

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  const res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
};

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  const res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
};

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
};

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!EncoderBuffer.isEncoderBuffer(item))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
  if (data instanceof EncoderBuffer) {
    return true;
  }

  // Or accept compatible API
  const isCompatible = typeof data === 'object' &&
    data.constructor.name === 'EncoderBuffer' &&
    typeof data.length === 'number' &&
    typeof data.join === 'function';

  return isCompatible;
};

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = Buffer.alloc(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};

},{"../base/reporter":117,"inherits":100,"safer-buffer":380}],115:[function(require,module,exports){
'use strict';

const base = exports;

base.Reporter = require('./reporter').Reporter;
base.DecoderBuffer = require('./buffer').DecoderBuffer;
base.EncoderBuffer = require('./buffer').EncoderBuffer;
base.Node = require('./node');

},{"./buffer":114,"./node":116,"./reporter":117}],116:[function(require,module,exports){
'use strict';

const Reporter = require('../base/reporter').Reporter;
const EncoderBuffer = require('../base/buffer').EncoderBuffer;
const DecoderBuffer = require('../base/buffer').DecoderBuffer;
const assert = require('minimalistic-assert');

// Supported tags
const tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
const methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
const overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent, name) {
  const state = {};
  this._baseState = state;

  state.name = name;
  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

const stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  const state = this._baseState;
  const cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  const res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  const state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      const clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  const state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  const state = this._baseState;

  // Filter children and args
  const children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      const res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        const value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    const state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    const state = this._baseState;
    const args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  const state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  const state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  const state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  const state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  const state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  const state = this._baseState;
  const args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  const state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  const state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  const state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  const state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  const state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  let result = state['default'];
  let present = true;

  let prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    let tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      const save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  let prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      const explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    const start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      let save;
      if (state.any)
        save = input.save();
      const body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any) {
      // no-op
    } else if (state.choice === null) {
      result = this._decodeGeneric(state.tag, input, options);
    } else {
      result = this._decodeChoice(input, options);
    }

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      const data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
        ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  const state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
      ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  const state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  const state = this._baseState;
  let result = null;
  let match = false;

  Object.keys(state.choice).some(function(key) {
    const save = input.save();
    const node = state.choice[key];
    try {
      const value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  const state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  const result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  const state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  let result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default'];
    else
      return;
  }

  // Encode children first
  let content = null;
  let primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      const prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      const res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      const child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        const state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  if (!state.any && state.choice === null) {
    const tag = state.implicit !== null ? state.implicit : state.tag;
    const cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  const state = this._baseState;

  const node = state.choice[data.type];
  if (!node) {
    assert(
      false,
      data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  const state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str);
};

},{"../base/buffer":114,"../base/reporter":117,"minimalistic-assert":105}],117:[function(require,module,exports){
'use strict';

const inherits = require('inherits');

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  const state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  const state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  const state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  const state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  const state = this._reporterState;

  const prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  const state = this._reporterState;

  const now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  let err;
  const state = this._reporterState;

  const inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  const state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
}
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};

},{"inherits":100}],118:[function(require,module,exports){
'use strict';

// Helper
function reverse(map) {
  const res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    const value = map[key];
    res[value] = key;
  });

  return res;
}

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = reverse(exports.tag);

},{}],119:[function(require,module,exports){
'use strict';

const constants = exports;

// Helper
constants._reverse = function reverse(map) {
  const res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    const value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = require('./der');

},{"./der":118}],120:[function(require,module,exports){
'use strict';

const inherits = require('inherits');

const bignum = require('bn.js');
const DecoderBuffer = require('../base/buffer').DecoderBuffer;
const Node = require('../base/node');

// Import DER constants
const der = require('../constants/der');

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
}
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!DecoderBuffer.isDecoderBuffer(data)) {
    data = new DecoderBuffer(data, options);
  }

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  Node.call(this, 'der', parent);
}
inherits(DERNode, Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  const state = buffer.save();
  const decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  const decodedTag = derDecodeTag(buffer,
    'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  let len = derDecodeLen(buffer,
    decodedTag.primitive,
    'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  const state = buffer.save();
  const res = this._skipUntilEnd(
    buffer,
    'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  for (;;) {
    const tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    const len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    let res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len);
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
  options) {
  const result = [];
  while (!buffer.isEmpty()) {
    const possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    const res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    const unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    const raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    let str = '';
    for (let i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    const numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    const printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  let result;
  const identifiers = [];
  let ident = 0;
  let subident = 0;
  while (!buffer.isEmpty()) {
    subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  const first = (identifiers[0] / 40) | 0;
  const second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    let tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  const str = buffer.raw().toString();

  let year;
  let mon;
  let day;
  let hour;
  let min;
  let sec;
  if (tag === 'gentime') {
    year = str.slice(0, 4) | 0;
    mon = str.slice(4, 6) | 0;
    day = str.slice(6, 8) | 0;
    hour = str.slice(8, 10) | 0;
    min = str.slice(10, 12) | 0;
    sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    year = str.slice(0, 2) | 0;
    mon = str.slice(2, 4) | 0;
    day = str.slice(4, 6) | 0;
    hour = str.slice(6, 8) | 0;
    min = str.slice(8, 10) | 0;
    sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull() {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  const res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  const raw = buffer.raw();
  let res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  let tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  const cls = der.tagClass[tag >> 6];
  const primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    let oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  const tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  let len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  const num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (let i = 0; i < num; i++) {
    len <<= 8;
    const j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}

},{"../base/buffer":114,"../base/node":116,"../constants/der":118,"bn.js":25,"inherits":100}],121:[function(require,module,exports){
'use strict';

const decoders = exports;

decoders.der = require('./der');
decoders.pem = require('./pem');

},{"./der":120,"./pem":122}],122:[function(require,module,exports){
'use strict';

const inherits = require('inherits');
const Buffer = require('safer-buffer').Buffer;

const DERDecoder = require('./der');

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
}
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  const lines = data.toString().split(/[\r\n]+/g);

  const label = options.label.toUpperCase();

  const re = /^-----(BEGIN|END) ([^-]+)-----$/;
  let start = -1;
  let end = -1;
  for (let i = 0; i < lines.length; i++) {
    const match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  const base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9+/=]+/gi, '');

  const input = Buffer.from(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};

},{"./der":120,"inherits":100,"safer-buffer":380}],123:[function(require,module,exports){
'use strict';

const inherits = require('inherits');
const Buffer = require('safer-buffer').Buffer;
const Node = require('../base/node');

// Import DER constants
const der = require('../constants/der');

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
}
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  Node.call(this, 'der', parent);
}
inherits(DERNode, Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
  primitive,
  cls,
  content) {
  const encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    const header = Buffer.alloc(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  let lenOctets = 1;
  for (let i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  const header = Buffer.alloc(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (let i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    const buf = Buffer.alloc(str.length * 2);
    for (let i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s.]+/g);
    for (let i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (let i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  let size = 0;
  for (let i = 0; i < id.length; i++) {
    let ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  const objid = Buffer.alloc(size);
  let offset = objid.length - 1;
  for (let i = id.length - 1; i >= 0; i--) {
    let ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  let str;
  const date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getUTCFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getUTCFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    const numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = Buffer.from(numArray);
  }

  if (Buffer.isBuffer(num)) {
    let size = num.length;
    if (num.length === 0)
      size++;

    const out = Buffer.alloc(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0;
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  let size = 1;
  for (let i = num; i >= 0x100; i >>= 8)
    size++;

  const out = new Array(size);
  for (let i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(Buffer.from(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  const state = this._baseState;
  let i;
  if (state['default'] === null)
    return false;

  const data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  let res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}

},{"../base/node":116,"../constants/der":118,"inherits":100,"safer-buffer":380}],124:[function(require,module,exports){
'use strict';

const encoders = exports;

encoders.der = require('./der');
encoders.pem = require('./pem');

},{"./der":123,"./pem":125}],125:[function(require,module,exports){
'use strict';

const inherits = require('inherits');

const DEREncoder = require('./der');

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
}
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  const buf = DEREncoder.prototype.encode.call(this, data);

  const p = buf.toString('base64');
  const out = [ '-----BEGIN ' + options.label + '-----' ];
  for (let i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};

},{"./der":123,"inherits":100}],126:[function(require,module,exports){
exports.pbkdf2 = require('./lib/async')
exports.pbkdf2Sync = require('./lib/sync')

},{"./lib/async":127,"./lib/sync":130}],127:[function(require,module,exports){
(function (global){(function (){
var Buffer = require('safe-buffer').Buffer

var checkParameters = require('./precondition')
var defaultEncoding = require('./default-encoding')
var sync = require('./sync')
var toBuffer = require('./to-buffer')

var ZERO_BUF
var subtle = global.crypto && global.crypto.subtle
var toBrowser = {
  sha: 'SHA-1',
  'sha-1': 'SHA-1',
  sha1: 'SHA-1',
  sha256: 'SHA-256',
  'sha-256': 'SHA-256',
  sha384: 'SHA-384',
  'sha-384': 'SHA-384',
  'sha-512': 'SHA-512',
  sha512: 'SHA-512'
}
var checks = []
function checkNative (algo) {
  if (global.process && !global.process.browser) {
    return Promise.resolve(false)
  }
  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
    return Promise.resolve(false)
  }
  if (checks[algo] !== undefined) {
    return checks[algo]
  }
  ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
    .then(function () {
      return true
    }).catch(function () {
      return false
    })
  checks[algo] = prom
  return prom
}
var nextTick
function getNextTick () {
  if (nextTick) {
    return nextTick
  }
  if (global.process && global.process.nextTick) {
    nextTick = global.process.nextTick
  } else if (global.queueMicrotask) {
    nextTick = global.queueMicrotask
  } else if (global.setImmediate) {
    nextTick = global.setImmediate
  } else {
    nextTick = global.setTimeout
  }
  return nextTick
}
function browserPbkdf2 (password, salt, iterations, length, algo) {
  return subtle.importKey(
    'raw', password, { name: 'PBKDF2' }, false, ['deriveBits']
  ).then(function (key) {
    return subtle.deriveBits({
      name: 'PBKDF2',
      salt: salt,
      iterations: iterations,
      hash: {
        name: algo
      }
    }, key, length << 3)
  }).then(function (res) {
    return Buffer.from(res)
  })
}

function resolvePromise (promise, callback) {
  promise.then(function (out) {
    getNextTick()(function () {
      callback(null, out)
    })
  }, function (e) {
    getNextTick()(function () {
      callback(e)
    })
  })
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  digest = digest || 'sha1'
  var algo = toBrowser[digest.toLowerCase()]

  if (!algo || typeof global.Promise !== 'function') {
    getNextTick()(function () {
      var out
      try {
        out = sync(password, salt, iterations, keylen, digest)
      } catch (e) {
        return callback(e)
      }
      callback(null, out)
    })
    return
  }

  checkParameters(iterations, keylen)
  password = toBuffer(password, defaultEncoding, 'Password')
  salt = toBuffer(salt, defaultEncoding, 'Salt')
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')

  resolvePromise(checkNative(algo).then(function (resp) {
    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

    return sync(password, salt, iterations, keylen, digest)
  }), callback)
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./default-encoding":128,"./precondition":129,"./sync":130,"./to-buffer":131,"safe-buffer":379}],128:[function(require,module,exports){
(function (process,global){(function (){
var defaultEncoding
/* istanbul ignore next */
if (global.process && global.process.browser) {
  defaultEncoding = 'utf-8'
} else if (global.process && global.process.version) {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
} else {
  defaultEncoding = 'utf-8'
}
module.exports = defaultEncoding

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"_process":592}],129:[function(require,module,exports){
var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

module.exports = function (iterations, keylen) {
  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length')
  }
}

},{}],130:[function(require,module,exports){
var md5 = require('create-hash/md5')
var RIPEMD160 = require('ripemd160')
var sha = require('sha.js')
var Buffer = require('safe-buffer').Buffer

var checkParameters = require('./precondition')
var defaultEncoding = require('./default-encoding')
var toBuffer = require('./to-buffer')

var ZEROS = Buffer.alloc(128)
var sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
}

function Hmac (alg, key, saltLen) {
  var hash = getDigest(alg)
  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  if (key.length > blocksize) {
    key = hash(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
  var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
  ipad.copy(ipad1, 0, 0, blocksize)
  this.ipad1 = ipad1
  this.ipad2 = ipad
  this.opad = opad
  this.alg = alg
  this.blocksize = blocksize
  this.hash = hash
  this.size = sizes[alg]
}

Hmac.prototype.run = function (data, ipad) {
  data.copy(ipad, this.blocksize)
  var h = this.hash(ipad)
  h.copy(this.opad, this.blocksize)
  return this.hash(this.opad)
}

function getDigest (alg) {
  function shaFunc (data) {
    return sha(alg).update(data).digest()
  }
  function rmd160Func (data) {
    return new RIPEMD160().update(data).digest()
  }

  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
  if (alg === 'md5') return md5
  return shaFunc
}

function pbkdf2 (password, salt, iterations, keylen, digest) {
  checkParameters(iterations, keylen)
  password = toBuffer(password, defaultEncoding, 'Password')
  salt = toBuffer(salt, defaultEncoding, 'Salt')

  digest = digest || 'sha1'

  var hmac = new Hmac(digest, password, salt.length)

  var DK = Buffer.allocUnsafe(keylen)
  var block1 = Buffer.allocUnsafe(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var destPos = 0
  var hLen = sizes[digest]
  var l = Math.ceil(keylen / hLen)

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)

    var T = hmac.run(block1, hmac.ipad1)
    var U = T

    for (var j = 1; j < iterations; j++) {
      U = hmac.run(U, hmac.ipad2)
      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
    }

    T.copy(DK, destPos)
    destPos += hLen
  }

  return DK
}

module.exports = pbkdf2

},{"./default-encoding":128,"./precondition":129,"./to-buffer":131,"create-hash/md5":51,"ripemd160":378,"safe-buffer":379,"sha.js":390}],131:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer

module.exports = function (thing, encoding, name) {
  if (Buffer.isBuffer(thing)) {
    return thing
  } else if (typeof thing === 'string') {
    return Buffer.from(thing, encoding)
  } else if (ArrayBuffer.isView(thing)) {
    return Buffer.from(thing.buffer)
  } else {
    throw new TypeError(name + ' must be a string, a Buffer, a typed array or a DataView')
  }
}

},{"safe-buffer":379}],132:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockDownloader = void 0;
const privmx_crypto_1 = require("privmx-crypto");
const Utils = require("simplito-utils");
const privmx_exception_1 = require("privmx-exception");
const PrivFsException_1 = require("../exception/PrivFsException");
const StorageProviderInterface_1 = require("../core/StorageProviderInterface");
const base58 = require("bs58");
const simplito_promise_1 = require("simplito-promise");
class BlockDownloader {
    static download(storage, source, blocks, aesKey, options) {
        if (!(storage instanceof StorageProviderInterface_1.StorageProviderInterface)) {
            throw new privmx_exception_1.IllegalArgumentException("storage", storage);
        }
        if (!Utils.isBuffer(aesKey)) {
            throw new privmx_exception_1.IllegalArgumentException("aesKey", aesKey);
        }
        const deferred = simplito_promise_1.PromiseUtils.defer();
        const outBlocks = [];
        const promises = [];
        let done = 0;
        const eventData = storage.startEvent("block-download", { storage: storage, source: source, blocks: blocks });
        blocks.forEach((block, i) => {
            let cipher;
            if (options && options.cancel) {
                throw new Error("Operation was interrupted by user");
            }
            const promise = Promise.resolve().then(() => {
                return storage.blockGet(block, source, true);
            })
                .catch(e => {
                return Promise.reject(new PrivFsException_1.PrivFsException("CANNOT_READ_BLOCK", {
                    index: i,
                    length: blocks.length,
                    bid: block
                }, null, e));
            })
                .then((c) => {
                if (options && options.cancel) {
                    throw new Error("Operation was interrupted by user");
                }
                cipher = c;
                return privmx_crypto_1.service.sha256(cipher);
            })
                .then(hash => {
                if (!hash.equals(Buffer.from(base58.decode(block)))) {
                    throw new PrivFsException_1.PrivFsException("CORRUPTED_BLOCK", {
                        index: i,
                        length: blocks.length,
                        bid: block,
                        hash: hash
                    });
                }
                return privmx_crypto_1.service.generateIv(aesKey, i);
            })
                .then(iv => {
                return privmx_crypto_1.service.privmxDecrypt(cipher, aesKey, iv);
            })
                .then(data => {
                done += 1;
                outBlocks[i] = data;
                const progress = {
                    count: done,
                    total: blocks.length,
                    percent: Math.min(100, Math.floor(done * 100 / blocks.length))
                };
                if (options && options.notify) {
                    options.notify(progress);
                }
            });
            promises.push(promise);
        });
        Promise.all(promises)
            .then(() => {
            return Buffer.concat(outBlocks);
        })
            .then(deferred.resolve)
            .catch(deferred.reject)
            .finally(() => {
            storage.stopEvent(eventData);
        });
        return deferred.promise;
    }
}
exports.BlockDownloader = BlockDownloader;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../core/StorageProviderInterface":160,"../exception/PrivFsException":172,"bs58":44,"buffer":498,"privmx-crypto":265,"privmx-exception":286,"simplito-promise":421,"simplito-utils":422}],133:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockStreamer = void 0;
const privmx_crypto_1 = require("privmx-crypto");
const simplito_promise_1 = require("simplito-promise");
const simplito_lazybuffer_1 = require("simplito-lazybuffer");
const Utils = require("simplito-utils");
const privmx_exception_1 = require("privmx-exception");
const PrivFsException_1 = require("../exception/PrivFsException");
const StorageProviderInterface_1 = require("../core/StorageProviderInterface");
const base58 = require("bs58");
const BlockDownloader_1 = require("./BlockDownloader");
class BlockStreamer {
    constructor() {
    }
    static stream(storage, transferIds, content, aesKey, options) {
        if (!(storage instanceof StorageProviderInterface_1.StorageProviderInterface)) {
            throw new privmx_exception_1.IllegalArgumentException("storage", storage);
        }
        const deferred = simplito_promise_1.PromiseUtils.defer();
        const blocks = [];
        const eventData = storage.startEvent("block-stream", { storage: storage, transferIds: transferIds, content: content });
        BlockStreamer.withBlocks(storage.config, content, aesKey, (bid, cipher, i, parts) => {
            if (options && options.cancel) {
                throw new Error("Operation was interrupted by user");
            }
            return Promise.resolve().then(() => {
                return storage.blockCreate(transferIds, bid, cipher);
            })
                .catch(e => {
                return Promise.reject(new PrivFsException_1.PrivFsException("CANNOT_SEND_BLOCK", {
                    index: i,
                    length: parts,
                    bid: bid
                }, null, e));
            })
                .then(() => {
                blocks.push(bid);
                const count = (typeof (i) == "number" ? i : parseInt(i)) + 1;
                const progress = {
                    count: count,
                    total: parts,
                    percent: Math.min(100, Math.floor(count * 100 / parts))
                };
                if (options && options.notify) {
                    options.notify(progress);
                }
            });
        }).then(() => blocks)
            .then(deferred.resolve)
            .catch(deferred.reject)
            .finally(() => {
            storage.stopEvent(eventData);
        });
        return deferred.promise;
    }
    static prepareBlocks(config, content, aesKey) {
        const blocks = [];
        return BlockStreamer.withBlocks(config, content, aesKey, (bid, cipher) => {
            blocks.push({ bid: bid, data: cipher });
        })
            .then(() => blocks);
    }
    static getBlockEncryptOptions() {
        return privmx_crypto_1.service.privmxOptAesWithDetachedIv();
    }
    static getMaxInlineDataSize(config) {
        if (!config.maxInlineBlocksCount) {
            return 0;
        }
        const encryptOptions = BlockStreamer.getBlockEncryptOptions();
        const blockSize = privmx_crypto_1.service.privmxGetBlockSize(encryptOptions, config.maxBlockLength);
        return config.maxInlineBlocksCount * blockSize;
    }
    static getBlocksCount(config, bufferSize) {
        const encryptOptions = BlockStreamer.getBlockEncryptOptions();
        const blockSize = privmx_crypto_1.service.privmxGetBlockSize(encryptOptions, config.maxBlockLength);
        return BlockStreamer.getBlocksCount2(bufferSize, blockSize);
    }
    static getBlocksCount2(bufferSize, blockSize) {
        return bufferSize == 0 ? 0 : Math.floor(bufferSize / blockSize) + 1;
    }
    static withBlocks(config, content, aesKey, func) {
        if (!Utils.isBuffer(aesKey)) {
            throw new privmx_exception_1.IllegalArgumentException("aesKey", aesKey);
        }
        const encryptOptions = BlockStreamer.getBlockEncryptOptions();
        const blockSize = privmx_crypto_1.service.privmxGetBlockSize(encryptOptions, config.maxBlockLength);
        if (blockSize < 0) {
            throw new Error("Server max block length is too small for chosen algorithm");
        }
        const bufferSize = content.getSize();
        const parts = BlockStreamer.getBlocksCount2(bufferSize, blockSize);
        return simplito_promise_1.PromiseUtils.nTimes(parts, i => {
            let sliced, cipher;
            const start = i * blockSize;
            const end = start + blockSize > bufferSize ? bufferSize : start + blockSize;
            return Promise.resolve().then(() => {
                return content.slice(start, end);
            })
                .then(s => {
                sliced = s;
                return privmx_crypto_1.service.generateIv(aesKey, i);
            })
                .then(iv => {
                return privmx_crypto_1.service.privmxEncrypt(encryptOptions, sliced, aesKey, iv);
            })
                .then(c => {
                cipher = c;
                return privmx_crypto_1.service.sha256(cipher);
            })
                .then(hash => {
                const bid = base58.encode(hash);
                return func(bid, cipher, i, parts);
            });
        });
    }
    static addBlocksToSessionByInfo(storage, transferIds, blocksInfo) {
        return BlockStreamer.addBlocksToSession(storage, transferIds, blocksInfo.storage, blocksInfo.source, blocksInfo.data.blocks, blocksInfo.data.key);
    }
    static addBlocksToSession(storage, transferIds, sourceStorage, source, blocks, key) {
        const eventData = storage.startEvent("block-stream", { storage: storage, transferIds: transferIds, sourceStorage: sourceStorage, source: source, blocks: blocks });
        return Promise.resolve().then(() => {
            if (storage.getDestination() == sourceStorage.getDestination()) {
                return storage.blockAddToSession(transferIds, source, blocks).then(() => blocks);
            }
            return simplito_promise_1.PromiseUtils.oneByOne(blocks, (i, block) => {
                let cipher;
                return Promise.resolve().then(() => {
                    return sourceStorage.blockGet(block, source, true);
                })
                    .catch(e => {
                    return Promise.reject(new PrivFsException_1.PrivFsException("CANNOT_READ_BLOCK", {
                        index: i,
                        length: blocks.length,
                        bid: block
                    }, null, e));
                })
                    .then((c) => {
                    cipher = c;
                    if (cipher.length > storage.config.maxBlockLength) {
                        throw {
                            msg: "invalid-block-length",
                            index: parseInt(i)
                        };
                    }
                    return privmx_crypto_1.service.sha256(cipher);
                })
                    .then(hash => {
                    if (!hash.equals(Buffer.from(base58.decode(block)))) {
                        throw new PrivFsException_1.PrivFsException("CORRUPTED_BLOCK", {
                            index: i,
                            length: blocks.length,
                            bid: block,
                            hash: hash
                        });
                    }
                    return Promise.resolve().then(() => {
                        return storage.blockCreate(transferIds, block, cipher);
                    })
                        .catch(e => {
                        return Promise.reject(new PrivFsException_1.PrivFsException("CANNOT_SEND_BLOCK", {
                            index: i,
                            length: blocks.length,
                            bid: block
                        }, null, e));
                    });
                });
            })
                .then(() => {
                return blocks;
            })
                .catch(e => {
                if (typeof (e) != "object" || e == null || e.msg != "invalid-block-length" || e.index == null) {
                    return Promise.reject(e);
                }
                return Promise.resolve().then(() => {
                    return BlockDownloader_1.BlockDownloader.download(sourceStorage, source, blocks.slice(e.index), key, {});
                })
                    .then(buffer => {
                    return BlockStreamer.stream(storage, transferIds, simplito_lazybuffer_1.Content.createFromBuffer(buffer, "", ""), key, {});
                })
                    .then(newBlocks => {
                    return blocks.slice(0, e.index).concat(newBlocks);
                });
            });
        })
            .finally(() => {
            storage.stopEvent(eventData);
        });
    }
}
exports.BlockStreamer = BlockStreamer;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../core/StorageProviderInterface":160,"../exception/PrivFsException":172,"./BlockDownloader":132,"bs58":44,"buffer":498,"privmx-crypto":265,"privmx-exception":286,"simplito-lazybuffer":398,"simplito-promise":421,"simplito-utils":422}],134:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlocksInfo = void 0;
const simplito_lazybuffer_1 = require("simplito-lazybuffer");
const BlockDownloader_1 = require("./BlockDownloader");
const RootLogger = require("simplito-logger");
const Logger = RootLogger.get("privfs-client.block.BlocksInfo");
class BlocksInfo extends simplito_lazybuffer_1.LazyContent {
    storage;
    source;
    data;
    cachedBuffer;
    constructor(storage, source, data, cachedBuffer) {
        super(data.mimeType, data.name, data.size);
        this.storage = storage;
        this.source = source;
        this.data = data;
        this.cachedBuffer = cachedBuffer;
        this.cachedBuffer = cachedBuffer || {
            cacheEnabled: false
        };
    }
    async slice(start, end, options) {
        Logger.warn("You should never use slice at BlocksInfo");
        const content = await this.getContent(options);
        return content.slice(start, end);
    }
    create(mimeType, name) {
        return new BlocksInfo(this.storage, this.source, {
            blocks: this.data.blocks,
            mimeType: mimeType || this.data.mimeType,
            size: this.data.size,
            key: this.data.key,
            name: name || this.data.name
        }, this.cachedBuffer);
    }
    async getBuffer(options) {
        if (this.cachedBuffer.bufferPromise) {
            return this.cachedBuffer.bufferPromise;
        }
        return this.cachedBuffer.bufferPromise = (async () => {
            try {
                const buffer = await BlockDownloader_1.BlockDownloader.download(this.storage, this.source, this.data.blocks, this.data.key, options);
                if (!this.cachedBuffer.cacheEnabled) {
                    this.cachedBuffer.bufferPromise = null;
                }
                return buffer;
            }
            catch (e) {
                this.cachedBuffer.bufferPromise = null;
                throw e;
            }
        })();
    }
    clearCache(cacheEnabled) {
        this.cachedBuffer.bufferPromise = null;
        this.cachedBuffer.cacheEnabled = cacheEnabled;
    }
    static getBlocksData(content, key, blocks) {
        return {
            name: content.getName(),
            mimeType: content.getMimeType(),
            size: content.getSize(),
            key: key,
            blocks: blocks
        };
    }
}
exports.BlocksInfo = BlocksInfo;

},{"./BlockDownloader":132,"simplito-lazybuffer":398,"simplito-logger":407}],135:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockStreamer = exports.BlocksInfo = exports.BlockDownloader = void 0;
const BlockDownloader_1 = require("./BlockDownloader");
Object.defineProperty(exports, "BlockDownloader", { enumerable: true, get: function () { return BlockDownloader_1.BlockDownloader; } });
const BlocksInfo_1 = require("./BlocksInfo");
Object.defineProperty(exports, "BlocksInfo", { enumerable: true, get: function () { return BlocksInfo_1.BlocksInfo; } });
const BlockStreamer_1 = require("./BlockStreamer");
Object.defineProperty(exports, "BlockStreamer", { enumerable: true, get: function () { return BlockStreamer_1.BlockStreamer; } });

},{"./BlockDownloader":132,"./BlockStreamer":133,"./BlocksInfo":134}],136:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Acl = void 0;
class Acl {
    static getOrCreate(list) {
        return list == null ? { list: [] } : list;
    }
    static getValue(entry) {
        const obj = entry;
        return obj.value != null && obj.acls != null ? obj.value : entry;
    }
    static indexOf(entry, list) {
        for (let i = 0; i < list.list.length; i++) {
            const x = Acl.getValue(list.list[i]);
            if (x == entry) {
                return i;
            }
        }
        return -1;
    }
    static addToList(entry, list) {
        const index = Acl.indexOf(Acl.getValue(entry), list);
        if (index == -1) {
            list.list.push(entry);
        }
        else {
            list.list[index] = entry;
        }
    }
}
exports.Acl = Acl;

},{}],137:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnonymousPrivmxClient = void 0;
const RpcGateway_1 = require("../gateway/RpcGateway");
const privmx_crypto_1 = require("privmx-crypto");
const Identity_1 = require("../identity/Identity");
const Message_1 = require("../message/Message");
const MessageSink_1 = require("../message/MessageSink");
const MessageManager_1 = require("../message/MessageManager");
const MessageReceiver_1 = require("../message/MessageReceiver");
const PrivFsRpcManager_1 = require("./PrivFsRpcManager");
const StorageProviderManager_1 = require("./StorageProviderManager");
class AnonymousPrivmxClient {
    gateway;
    storageProviderManager;
    constructor(gateway) {
        if (!(gateway instanceof RpcGateway_1.RpcGateway)) {
            throw new Error("Invalid gateway");
        }
        this.gateway = gateway;
        this.storageProviderManager = new StorageProviderManager_1.StorageProviderManager(gateway, false);
    }
    withIdentity() {
        return privmx_crypto_1.service.eccGenerateKey("raw")
            .then(priv => {
            return new Identity_1.Identity("anonymous#" + this.gateway.getHost(), priv);
        });
    }
    postMessage(sid, title, content, attachments, extra, tags) {
        return this.withIdentity()
            .then(identity => {
            const sink = MessageSink_1.MessageSink.fromSerialized(sid);
            const receiver = new MessageReceiver_1.MessageReceiver(sink, identity);
            const manager = new MessageManager_1.MessageManager(this.storageProviderManager, identity);
            const message = new Message_1.Message();
            message.setSender(identity);
            message.title = title;
            message.text = content;
            message.addReceiver(receiver);
            if (Array.isArray(attachments) && attachments.length > 0) {
                attachments.forEach(a => {
                    message.addAttachment(a);
                });
            }
            return manager.messagePost(message, tags || [manager.tagService.getPlainTag("type:form")], extra ? { extra: extra } : null);
        })
            .then(r => {
            const results = r;
            if (results[0].success) {
                return results[0];
            }
            throw results[0];
        });
    }
    static async create(host) {
        const gateway = await PrivFsRpcManager_1.PrivFsRpcManager.getEcdheGateway({ host: host });
        return new AnonymousPrivmxClient(gateway);
    }
}
exports.AnonymousPrivmxClient = AnonymousPrivmxClient;

},{"../gateway/RpcGateway":208,"../identity/Identity":211,"../message/Message":215,"../message/MessageManager":217,"../message/MessageReceiver":218,"../message/MessageSink":219,"./PrivFsRpcManager":151,"./StorageProviderManager":161,"privmx-crypto":265}],138:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiErrorCodes = void 0;
const PrivmxRpc = require("privmx-rpc");
class ApiErrorCodes {
    static codes = {
        PARSE_ERROR: { code: -32700, message: "Parse error" },
        INVALID_REQUEST: { code: -32600, message: "Invalid Request" },
        METHOD_NOT_FOUND: { code: -32601, message: "Method not found" },
        INVALID_PARAMS: { code: -32602, message: "Invalid params" },
        INTERNAL_ERROR: { code: -32603, message: "Internal error" },
        NOT_YET_INSTALLED: { code: -32604, message: "Not yet installed" },
        ONLY_POST_METHOD_ALLOWED: { code: -32605, message: "Only post method allowed" },
        UNKNOWN_ERROR: { code: 0x0001, message: "Unknown error" },
        INVALID_USERNAME: { code: 0x0002, message: "Invalid username" },
        INVALID_SALT: { code: 0x0003, message: "Invalid salt" },
        INVALID_VERIFIER: { code: 0x0004, message: "Invalid verifier" },
        INVALID_MASTER_SEED: { code: 0x0005, message: "Invalid master seed" },
        INVALID_IDENTITY_KEY: { code: 0x0006, message: "Invalid identity key" },
        USER_ALREADY_EXISTS: { code: 0x0007, message: "User already exists" },
        INVALID_SIGNATURE: { code: 0x0008, message: "Invalid signature" },
        USER_DOESNT_EXIST: { code: 0x0009, message: "User doesn't exist" },
        INVALID_USER_ENTRY: { code: 0x000B, message: "Invalid user entry" },
        UNKNOWN_SESSION: { code: 0x000C, message: "Unknown session" },
        INVALID_SESSION_STATE: { code: 0x000D, message: "Invalid session state" },
        INVALID_A: { code: 0x000E, message: "Invalid A" },
        DIFFERENT_M1: { code: 0x000F, message: "Different M1" },
        INVALID_PIN: { code: 0x0010, message: "Invalid PIN" },
        OPEN_REGISTRATION_DISABLED: { code: 0x0011, message: "Open registration disabled" },
        MAX_PIN_ATTEMPTS_EXCEEDED: { code: 0x0012, message: "Max PIN attempts exceeded" },
        USER_ALREADY_ACTIVATED: { code: 0x0013, message: "User already activated" },
        INVITATION_DISABLED: { code: 0x0014, message: "Invitation disabled" },
        INVALID_TOKEN: { code: 0x0015, message: "Invalid token" },
        MAX_SIZE_OF_BLOCK_BULK_EXCEEDED: { code: 0x0016, message: "Max size of block bulk exceeded" },
        INVALID_BID: { code: 0x0017, message: "Invalid bid" },
        INVALID_DATA: { code: 0x0018, message: "Invalid data" },
        BLOCK_DOESNT_EXIST: { code: 0x0019, message: "Block doesn't exist" },
        MAX_SIZE_OF_DESCRIPTOR_BULK_EXCEEDED: { code: 0x001A, message: "Max size of descriptor bulk exceeded" },
        INVALID_DESCRIPTOR_SIGNATURE_PAIR: { code: 0x001B, message: "Invalid pair descriptor:signature" },
        INVALID_DID: { code: 0x001C, message: "Invalid did" },
        DESCRIPTOR_DOESNT_EXIST: { code: 0x001D, message: "Descriptor doesn't exist" },
        INVALID_DPUB58: { code: 0x001E, message: "Invalid dpub58" },
        INVALID_JSON_PARAMETERS: { code: 0x001F, message: "Invalid json parameters" },
        DPUB58_DOESNT_MATCH_TO_DID: { code: 0x0020, message: "Dpub58 doesn't match to did" },
        PUBLIC_KEY_CANNOT_BE_CHANGED: { code: 0x0021, message: "Public key cannot be changed" },
        OLD_SIGNATURE_DOESNT_MATCH: { code: 0x0022, message: "Old signature doesn't match" },
        INVALID_OWNER: { code: 0x0023, message: "Invalid owner" },
        INVALID_OWNER_SIGNATURE: { code: 0x0024, message: "Invalid owner signature" },
        INVALID_SID: { code: 0x0025, message: "Invalid sid" },
        INVALID_CREATE_SIGNATURE: { code: 0x0026, message: "Invalid create signature" },
        SINK_DOESNT_EXISTS: { code: 0x0027, message: "Sink doesn't exist" },
        INVALID_TIMESTAMP: { code: 0x0028, message: "Invalid timestamp" },
        INVALID_NONCE: { code: 0x0029, message: "Invalid nonce" },
        INVALID_MID: { code: 0x002A, message: "Invalid mid" },
        MESSAGE_DOESNT_EXISTS: { code: 0x002B, message: "Message doesn't exists" },
        MAX_SIZE_OF_MESSAGE_BULK_EXCEEDED: { code: 0x002C, message: "Max size of message bulk exceeded" },
        INVALID_HASHMAIL: { code: 0x002D, message: "Invalid hashmail" },
        INVALID_USER_PRESENCE: { code: 0x002E, message: "Invalid user presence" },
        INVALID_SINK_ACL: { code: 0x002F, message: "Invalid sink acl" },
        ACCESS_DENIED: { code: 0x0030, message: "Access denied" },
        INVALID_STATE: { code: 0x0031, message: "Invalid state" },
        SINK_ALREADY_EXISTS: { code: 0x0032, message: "Sink already exists" },
        INVALID_MOD_SEQ: { code: 0x0033, message: "Invalid mod seq" },
        DESCRIPTOR_ALREADY_EXISTS: { code: 0x0034, message: "Descriptor already exists" },
        INVALID_LOGIN_DATA: { code: 0x0035, message: "Invalid login data" },
        INVALID_HOST: { code: 0x0036, message: "Invalid host" },
        INVALID_DESCRIPTOR_LOCK: { code: 0x0037, message: "Invalid descriptor lock" },
        DESCRIPTOR_LOCKED: { code: 0x0038, message: "Descriptor locked" },
        INVALID_EMAIL: { code: 0x0039, message: "Invalid email" },
        INVALID_LANGUAGE: { code: 0x003A, message: "Invalid language" },
        INVALID_DESCRIPTION: { code: 0x003B, message: "Invalid description" },
        MAX_USERS_COUNT_EXCEEDED: { code: 0x003C, message: "Max users count exceeded" },
        LOGIN_BLOCKED: { code: 0x003D, message: "Login blocked" },
        INVALID_SMTP_CONFIG: { code: 0x003E, message: "Invalid SMTP config" },
        CANNOT_SAVE_CONFIG: { code: 0x003F, message: "Cannot save config" },
        LOGIN_REJECTED: { code: 0x0040, message: "Login rejected" },
        HOST_BLACKLISTED: { code: 0x0041, message: "Host blacklisted" },
        INVALID_BLOCK_SOURCE: { code: 0x0042, message: "Invalid block source" },
        INVALID_TRANSFER_SESSION: { code: 0x0043, message: "Invalid transfer session" },
        MAX_COUNT_OF_BLOCKS_EXCEEDED: { code: 0x0044, message: "Max count of blocks exceeded" },
        SECURE_FORM_VALIDATION_FAILED: { code: 0x0045, message: "Secure form validation callback returned false" },
        FORBIDDEN_USERNAME: { code: 0x0046, message: "Forbidden username" },
        INVALID_DOCUMENT_ID: { code: 0x0047, message: "Invalid document id" },
        DOCUMENT_DOESNT_EXISTS: { code: 0x0048, message: "Document doesn't exists" },
        INVALID_PKI_DOCUMENT: { code: 0x0049, message: "Invalid pki document" },
        KVDB_DOESNT_EXIST: { code: 0x0050, message: "KVDB doesn't exist" },
        KVDB_ALREADY_EXISTS: { code: 0x0051, message: "KVDB already exists" },
        KVDB_ENTRY_DOESNT_EXIST: { code: 0x0052, message: "KVDB entry doesn't exist" },
        KVDB_ENTRY_LOCKED: { code: 0x0053, message: "KVDB entry locked" },
        EVENT_LOG_DOESNT_EXIST: { code: 0x0054, message: "EventLog doesn't exist" },
        EVENT_LOG_ALREADY_EXISTS: { code: 0x0055, message: "EventLog already exists" },
        FORM_DOESNT_EXIST: { code: 0x0056, message: "Form doesn't exist" },
        FORM_ALREADY_EXISTS: { code: 0x0057, message: "Form already exists" },
        FORM_NAME_ALREADY_IN_USE: { code: 0x0058, message: "Form name already in use" },
        USER_GROUP_DOESNT_EXIST: { code: 0x0059, message: "User group doesn't exist" },
        USER_GROUP_ALREADY_EXISTS: { code: 0x0060, message: "User group already exists" },
        SECTION_DOESNT_EXIST: { code: 0x0061, message: "Section doesn't exist" },
        SECTION_ALREADY_EXISTS: { code: 0x0062, message: "Section already exists" },
        INVALID_VERSION: { code: 0x0063, message: "Invalid version" },
        INVALID_DEVICE_ID: { code: 0x0064, message: "Invalid device id" },
        PUB_KEY_ALREADY_IN_USE: { code: 0x0065, message: "Pub key already in use" },
        INVALID_LOGIN: { code: 0x0066, message: "Invalid login" },
        NO_ADMIN_FOR_EXTERNAL_USER: { code: 0x0067, message: "External user cannot be admin" },
        MAINTENANCE_MODE: { code: 0x0068, message: "Maintenance mode" },
        INVALID_PROXY_SESSION: { code: 0x0069, message: "Invalid proxy session" },
        SERVER_PROXY_ALREADY_EXISTS: { code: 0x006A, message: "Server proxy already exists" },
        SERVER_PROXY_DOES_NOT_EXIST: { code: 0x006B, message: "Server proxy does not exist" },
        DATA_CENTER_DISABLED: { code: 0x0069, message: "Data center disabled" },
        SECTIONS_LIMIT_EXCEEDED: { code: 0x006A, message: "Sections limit exceeded" },
        USER_BLOCKED: { code: 0x006B, message: "User blocked" },
        DEVICE_DOES_NOT_EXIST: { code: 0x006C, message: "Device does not exist" },
        DEVICE_BLOCKED: { code: 0x006D, message: "Device blocked" },
        IP_DOES_NOT_EXIST: { code: 0x006E, message: "IP does not exist" },
        LOGIN_LOG_DOES_NOT_EXIST: { code: 0x006F, message: "Login log does not exist" },
        INVALID_KEY: { code: 0x0070, message: "Invalid key" },
        PRIVMX_STREAM_DISABLED: { code: 0x0071, message: "PrivMX Stream disabled" },
        WEBSOCKET_REQUIRED: { code: 0x0072, message: "Websocket required" },
        WEBSOCKET_ALREADY_AUTHORIZED: { code: 0x0073, message: "Websocket already authorized" },
        INVALID_DESCRIPTOR_ACL: { code: 0x0074, message: "Invalid descriptor acl" },
        DESCRIPTOR_GROUP_DOES_NOT_EXIST: { code: 0x0075, message: "Descriptor group does not exist" },
        VIDEO_DISABLED: { code: 0x0076, message: "Video disabled" },
        VIDEO_ROOM_DOES_NOT_EXIST: { code: 0x0077, message: "Video room does not exist" },
        VIDEO_ROOM_ALREADY_CREATED: { code: 0x0078, message: "Video room already created" },
        VIDEO_ROOM_NOT_READY_YET: { code: 0x0079, message: "Video room not ready yet" },
        CANNOT_JOIN_TO_VIDEO_ROOM: { code: 0x0080, message: "Cannot join to video room" },
        NEED_2FA_AUTHENTICATION: { code: 0x0081, message: "Need 2FA authentication" },
        TOKEN_ALREADY_USED: { code: 0x0082, message: "Token already used" },
        PUSH_NOTIFICATION_ALREADY_EXIST: { code: 0x0083, message: "Push notification already exists" },
        PUSH_NOTIFICATION_ENDPOINT_MISMATCH: { code: 0x0084, message: "Push notification endpoint type mismatch" },
        EXCEEDED_LIMIT_OF_WEBSOCKET_CHANNELS: { code: 0x0085, message: "Exceeded limit of websocket channels" },
        ADD_WS_CHANNEL_ID_REQUIRED_ON_MULTI_CHANNEL_WEBSOCKET: { code: 0x0086, message: "AddWsChannelId required on multi channel websocket" },
        CANNOT_ADD_CHANNEL_TO_SINGLE_CHANNEL_WEBSOCKET: { code: 0x0087, message: "Cannot add channel to single channel websocket" },
        INVALID_CALENDAR_DATA: { code: 0x0088, message: "Invalid calendar data" },
        CALENDAR_ENTRY_DOES_NOT_EXIST: { code: 0x0089, message: "Calendar entry does not exist" },
        PAST_CALENDAR_IS_NOT_AVAILABLE: { code: 0x008A, message: "Past calendar is not available" },
        DATE_OUT_OF_RANGE: { code: 0x008B, message: "Date out of range" },
        SECTION_KEY_ENCRYPTOR_MISMATCH: { code: 0x008C, message: "Section key encryptor mismatch" },
        SECTION_KEYS_VERSION_MISMATCH: { code: 0x008D, message: "Section keys version mismatch" },
        CALENDAR_ALREADY_ACTIVATED: { code: 0x008E, message: "Calendar already activated" },
        INVALID_CALENDAR_PUBLIC_VIEW_VERSION: { code: 0x008F, message: "Invalid calendar public view version" },
        ACCESS_TO_SECTION_DENIED_FOR_SUBIDENTITY: { code: 0x0090, message: "Access to section denied for subidentity" },
        SUBIDENTITY_DOES_NOT_EXISTS: { code: 0x0091, message: "Subidentity does not exists" },
        DESCRIPTOR_VERSION_DOESNT_EXIST: { code: 0x0092, message: "Descriptor version doesn't exist" },
        TWOFA_NOT_ENABLED: { code: 0x7001, message: "2FA not enabled for user" },
        TWOFA_INVALID_TYPE: { code: 0x7002, message: "Invalid 2FA type" },
        TWOFA_CODE_ALREADY_RESEND: { code: 0x7003, message: "Code already resend" },
        TWOFA_INVALID_GOOGLE_AUTHENTICATOR_SECRET: { code: 0x7004, message: "Invalid Google Authenticator secret" },
        TWOFA_EMAIL_REQUIRED: { code: 0x7005, message: "Field email is required" },
        TWOFA_MOBILE_REQUIRED: { code: 0x7006, message: "Field mobile is required" },
        TWOFA_INVALID_CODE: { code: 0x7007, message: "Invalid code" },
        TWOFA_VERIFICATION_FAILED: { code: 0x7008, message: "Verification failed" },
        TWOFA_INVALID_SESSION: { code: 0x7009, message: "Invalid 2FA session" },
        TWOFA_CANNOT_SEND_CODE: { code: 0x7010, message: "Cannot send code" }
    };
    static is(e, name) {
        const apiError = ApiErrorCodes.codes[name];
        return e != null && e.data != null && e.data.error != null && apiError != null && apiError.code == e.data.error.code;
    }
    static isError(e) {
        return e != null && e.data != null && e.data.error != null && e.data.error.code != null;
    }
    static isConnectionError(e) {
        return e && typeof (e.message) == "string" && (e.message.startsWith("[ConnectionError]") || e.message.startsWith("[SessionLostError]") || e.message.startsWith("[AlertError]"));
    }
    static isAlertErrorWithMessage(e, message) {
        return e instanceof PrivmxRpc.AlertError && e.isError(message);
    }
    static isAssertError(e, assertName) {
        return ApiErrorCodes.isAlertErrorWithMessage(e, "Failed assert " + assertName);
    }
    static isOrCause(e, name) {
        return e != null && (ApiErrorCodes.is(e, name) || ApiErrorCodes.isOrCause(e.cause, name) || ApiErrorCodes.isOrCause(e.couse, name));
    }
    static isEx(e, name) {
        const apiError = ApiErrorCodes.codes[name];
        return ApiErrorCodes.is(e, name) || (apiError && ApiErrorCodes.isAlertErrorWithMessage(e, apiError.message));
    }
}
exports.ApiErrorCodes = ApiErrorCodes;

},{"privmx-rpc":366}],139:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bip39LoginService = void 0;
const LoginUtils_1 = require("./LoginUtils");
const PrivFsSrpSecure_1 = require("./PrivFsSrpSecure");
const Bip39Authorizer_1 = require("./login/Bip39Authorizer");
class Bip39LoginService {
    initParameters;
    identityIndex;
    constructor(initParameters, identityIndex) {
        this.initParameters = initParameters;
        this.identityIndex = identityIndex;
    }
    async login(recovery, defaultPKI) {
        const info = await this.loginWithoutProcessingMasterRecord(recovery, defaultPKI);
        return LoginUtils_1.LoginUtils.loginLastStep(info.srpSecure, info.decryptedMasterRecord.masterRecord, this.identityIndex);
    }
    async loginWithoutProcessingMasterRecord(recovery, defaultPKI) {
        const bip39Authorizer = new Bip39Authorizer_1.Bip39Authorizer(this.initParameters);
        const { gateway, decryptedMasterRecord } = await bip39Authorizer.loginByRecovery(recovery);
        return {
            srpSecure: PrivFsSrpSecure_1.PrivFsSrpSecure.create(gateway, defaultPKI),
            decryptedMasterRecord: decryptedMasterRecord
        };
    }
}
exports.Bip39LoginService = Bip39LoginService;

},{"./LoginUtils":147,"./PrivFsSrpSecure":153,"./login/Bip39Authorizer":166}],140:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockCache = void 0;
class BlockCache {
    maxSize;
    cache;
    info;
    size;
    constructor() {
        this.maxSize = 10485760;
        this.cache = {};
        this.info = [];
        this.size = 0;
    }
    set(bid, data) {
        if (this.get(bid)) {
            return;
        }
        this.cache[bid] = data;
        this.info.push({
            create: new Date().getTime(),
            access: new Date().getTime(),
            bid: bid
        });
        this.size += data.length;
        this.clear();
    }
    get(bid) {
        if (this.cache[bid]) {
            for (let i = 0; i < this.info.length; i++) {
                if (this.info[i].bid == bid) {
                    this.info[i].access = new Date().getTime();
                    break;
                }
            }
            return this.cache[bid];
        }
        return null;
    }
    clear() {
        if (this.size > this.maxSize) {
            this.removeOldest();
            this.clear();
        }
    }
    removeOldest() {
        if (this.info.length == 0) {
            return;
        }
        this.info.sort((a, b) => {
            return a.access - b.access;
        });
        const oldestBid = this.info[0].bid;
        this.info.splice(0, 1);
        this.size -= this.cache[oldestBid].length;
        delete this.cache[oldestBid];
    }
}
exports.BlockCache = BlockCache;

},{}],141:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = void 0;
const DescriptorRefWrite_1 = require("../fs/descriptor/ref/DescriptorRefWrite");
const FileSystem_1 = require("../fs/file/FileSystem");
const Manager_1 = require("../fs/descriptor/Manager");
const MessageManager_1 = require("../message/MessageManager");
const StorageProviderManager_1 = require("./StorageProviderManager");
const CryptoUtils_1 = require("./CryptoUtils");
class Client {
    gateway;
    identity;
    rootExtKey;
    storageProviderManager;
    descriptorManager;
    messageManager;
    constructor(gateway, identity, rootExtKey, withCache) {
        this.gateway = gateway;
        this.identity = identity;
        this.rootExtKey = rootExtKey;
        this.storageProviderManager = new StorageProviderManager_1.StorageProviderManager(this.gateway, withCache);
        this.descriptorManager = new Manager_1.Manager(this.storageProviderManager, this.identity);
        this.messageManager = new MessageManager_1.MessageManager(this.storageProviderManager, this.identity);
    }
    getConfig() {
        return Promise.resolve().then(() => {
            return this.storageProviderManager.getProvider(this.identity.host);
        })
            .then(provider => {
            return provider.config;
        });
    }
    init() {
        return Promise.resolve().then(() => {
            return this.messageManager.init();
        });
    }
    getFileSystem(rootRef) {
        return new FileSystem_1.FileSystem(this.descriptorManager, rootRef);
    }
    getFileSystemByIndex(index) {
        return Promise.resolve().then(() => {
            return this.deriveRootRef(index);
        })
            .then(rootRef => {
            return this.getFileSystem(rootRef);
        });
    }
    getFileSystemByIndexAndInit(index) {
        let fileSystem;
        return Promise.resolve().then(() => {
            return this.getFileSystemByIndex(index);
        })
            .then(fs => {
            fileSystem = fs;
            return fileSystem.init();
        })
            .then(() => {
            return fileSystem;
        });
    }
    getMessageManager() {
        return this.messageManager;
    }
    deriveRootRef(index) {
        return Promise.resolve().then(() => {
            return this.deriveKey(index);
        })
            .then(key => {
            return new DescriptorRefWrite_1.DescriptorRefWrite(key, this.identity.host);
        });
    }
    deriveKey(index) {
        return CryptoUtils_1.CryptoUtils.deriveHardened(this.rootExtKey, index);
    }
}
exports.Client = Client;

},{"../fs/descriptor/Manager":181,"../fs/descriptor/ref/DescriptorRefWrite":189,"../fs/file/FileSystem":191,"../message/MessageManager":217,"./CryptoUtils":142,"./StorageProviderManager":161}],142:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoUtils = void 0;
const privmx_crypto_1 = require("privmx-crypto");
class CryptoUtils {
    static async encryptWithSignature(data, key, iv) {
        return await privmx_crypto_1.service.privmxEncrypt(privmx_crypto_1.service.privmxOptAesWithSignature(), data, key, iv);
    }
    static async decryptObjectFromBase64(base64EncodedCipher, key) {
        return privmx_crypto_1.service.getObjectEncryptor(key).decrypt(Buffer.from(base64EncodedCipher, "base64"));
    }
    static async decryptBase64(base64EncodedCipher, key) {
        return privmx_crypto_1.service.privmxDecrypt(Buffer.from(base64EncodedCipher, "base64"), key);
    }
    static async deriveHardened(extKey, index) {
        return privmx_crypto_1.service.eccExtDerive(extKey, { index: index, hardened: true, serializePrivWithoutLeadingZeroes: true });
    }
}
exports.CryptoUtils = CryptoUtils;

}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":498,"privmx-crypto":265}],143:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyLoginService = void 0;
const RpcGateway_1 = require("../gateway/RpcGateway");
class KeyLoginService {
    initParameters;
    constructor(initParameters) {
        this.initParameters = initParameters;
    }
    async login(priv) {
        return RpcGateway_1.RpcGateway.createGatewayFromKeyConnection(priv, this.initParameters);
    }
}
exports.KeyLoginService = KeyLoginService;

},{"../gateway/RpcGateway":208}],144:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeystoreUtils = void 0;
const pki = require("privmx-pki");
const Utils_1 = require("./Utils");
class KeystoreUtils {
    static createKeystore(identity) {
        return pki.KeyStore.KeyStore.createFromKeyPair(identity.username, identity.keyPair);
    }
    static createKeystoreWithProfile(identity, profile) {
        const keystore = KeystoreUtils.createKeystore(identity);
        keystore.addAttachment("info", KeystoreUtils.createInfoAttachment(profile));
        if (profile.image) {
            keystore.addAttachment("image", profile.image);
        }
        return keystore;
    }
    static createInfoAttachment(profile) {
        return Utils_1.Utils.createBufferFromObject(KeystoreUtils.createInfoAttachmentData(profile));
    }
    static createInfoAttachmentData(profile) {
        return {
            name: profile.name,
            description: profile.description,
            sinks: (profile.sinks || []).map(x => x.serialize())
        };
    }
    static async createKeystoreInsertionSignature(privmxPKI, keystore) {
        const params = await KeystoreUtils.createKeystoreInsertionSignatureData(privmxPKI, keystore);
        return params.kis;
    }
    static async createKeystoreInsertionSignatureData(privmxPKI, keystore) {
        return await privmxPKI.unpackParams({ prefix: "user:", data: keystore });
    }
    static async createKeystoreFromProfileWithInsertionSignatureData(privmxPKI, identity, profile) {
        const keystore = KeystoreUtils.createKeystoreWithProfile(identity, profile);
        const params = await KeystoreUtils.createKeystoreInsertionSignatureData(privmxPKI, keystore);
        return {
            keystore: keystore,
            params: params
        };
    }
}
exports.KeystoreUtils = KeystoreUtils;

},{"./Utils":163,"privmx-pki":326}],145:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkSentStatus = void 0;
var LinkSentStatus;
(function (LinkSentStatus) {
    LinkSentStatus[LinkSentStatus["SENT"] = 0] = "SENT";
    LinkSentStatus[LinkSentStatus["NOT_WANTED"] = 1] = "NOT_WANTED";
    LinkSentStatus[LinkSentStatus["INVALID_CONFIG"] = 2] = "INVALID_CONFIG";
    LinkSentStatus[LinkSentStatus["ERROR"] = 3] = "ERROR";
})(LinkSentStatus = exports.LinkSentStatus || (exports.LinkSentStatus = {}));

},{}],146:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginByKeyUtils = void 0;
const privmx_crypto_1 = require("privmx-crypto");
const CryptoUtils_1 = require("./CryptoUtils");
class LoginByKeyUtils {
    static async encryptL1KeyWithBip39(bip39, masterRecordL1Key) {
        const masterRecordKey = LoginByKeyUtils.getMasterRecordKeyFromBip39(bip39);
        return {
            publicKey: bip39.extKey.getPublicKey(),
            encryptedL1: await CryptoUtils_1.CryptoUtils.encryptWithSignature(masterRecordL1Key, masterRecordKey)
        };
    }
    static getMasterRecordKeyFromBip39(bip39) {
        return bip39.extKey.getChainCode();
    }
    static async getBip39(recovery) {
        return typeof (recovery) == "string" ? await privmx_crypto_1.service.bip39FromMnemonic(recovery) : await privmx_crypto_1.service.bip39FromEntropy(recovery);
    }
}
exports.LoginByKeyUtils = LoginByKeyUtils;

},{"./CryptoUtils":142,"privmx-crypto":265}],147:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginUtils = void 0;
const Identity_1 = require("../identity/Identity");
const MasterRecordUtils_1 = require("./MasterRecordUtils");
class LoginUtils {
    static async loginLastStep(srpSecure, masterRecord, identityIndex) {
        const decodedMasterRecord = await MasterRecordUtils_1.MasterRecordUtils.decodeMasterRecord(masterRecord, identityIndex);
        const myData = await srpSecure.getMyData();
        if (myData.keystore == null) {
            throw new Error("Unsupported empty keystore");
        }
        const pubKeyPair = myData.keystore.getPrimaryKey().keyPair;
        const privKeyPair = pubKeyPair.createPrivateVersion(decodedMasterRecord.identityKey.key);
        return {
            myData: myData,
            srpSecure: srpSecure,
            identity: Identity_1.Identity.fromUser(myData.userInfo.user, decodedMasterRecord.identityKey),
            identityKeypair: { username: myData.userInfo.user.user, keyPair: privKeyPair },
            masterExtKey: decodedMasterRecord.masterExtKey,
            dataVersion: decodedMasterRecord.dataVersion,
            masterRecordLevel2: decodedMasterRecord.masterRecordLevel2
        };
    }
}
exports.LoginUtils = LoginUtils;

},{"../identity/Identity":211,"./MasterRecordUtils":148}],148:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MasterRecordUtils = void 0;
const PrivmxCrypto = require("privmx-crypto");
const types_1 = require("../types");
const CryptoUtils_1 = require("./CryptoUtils");
class MasterRecordUtils {
    static async getMasterExtKey(masterSeed) {
        return await PrivmxCrypto.service.eccExtFromSeed(masterSeed);
    }
    static async getIdentityKeyFromMasterExtKey(masterExtKey, identityIndex) {
        const identityExt = await CryptoUtils_1.CryptoUtils.deriveHardened(masterExtKey, identityIndex);
        return identityExt.getPrivateKey();
    }
    static getMasterSeedFromMasterRecord(masterRecord) {
        return Buffer.from(masterRecord.l1.masterSeed, "base64");
    }
    static getMasterRecordLevel2(masterRecord) {
        return {
            key: masterRecord.l1.l2Key ? Buffer.from(masterRecord.l1.l2Key, "base64") : null,
            data: masterRecord.l2
        };
    }
    static async decodeMasterRecord(masterRecord, identityIndex) {
        const masterSeed = MasterRecordUtils.getMasterSeedFromMasterRecord(masterRecord);
        const masterExtKey = await MasterRecordUtils.getMasterExtKey(masterSeed);
        const identityKey = await MasterRecordUtils.getIdentityKeyFromMasterExtKey(masterExtKey, identityIndex);
        return {
            dataVersion: masterRecord.l1.dataVersion,
            masterExtKey: masterExtKey,
            identityKey: identityKey,
            masterRecordLevel2: MasterRecordUtils.getMasterRecordLevel2(masterRecord)
        };
    }
    static async encrypt(masterRecord, l1Key) {
        const l2Key = Buffer.from(masterRecord.l1.l2Key, "base64");
        return {
            l1: await PrivmxCrypto.service.getObjectEncryptor(l1Key).encrypt(masterRecord.l1),
            l2: await PrivmxCrypto.service.getObjectEncryptor(l2Key).encrypt(masterRecord.l2)
        };
    }
    static async decrypt(model, masterRecordKey, loginMode) {
        if (model.version != "2.0") {
            throw new Error("Unsupported masterRecord.version");
        }
        const keyCipher = loginMode == types_1.core.LoginMode.SRP ? model.srpData : model.lbkData;
        const masterRecordL1Key = await CryptoUtils_1.CryptoUtils.decryptBase64(keyCipher, masterRecordKey);
        const masterRecordL1 = await CryptoUtils_1.CryptoUtils.decryptObjectFromBase64(model.privData, masterRecordL1Key);
        if (!model.privDataL2 || !masterRecordL1.l2Key) {
            throw new Error("Cannot decrypt level 2 of master record");
        }
        const masterRecordL2Key = Buffer.from(masterRecordL1.l2Key, "base64");
        const masterRecordL2 = await CryptoUtils_1.CryptoUtils.decryptObjectFromBase64(model.privDataL2, masterRecordL2Key);
        return {
            version: model.version,
            masterRecord: {
                l1: masterRecordL1,
                l2: masterRecordL2
            },
            baseKey: masterRecordKey,
            l1Key: masterRecordL1Key,
            loginMode: loginMode
        };
    }
}
exports.MasterRecordUtils = MasterRecordUtils;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../types":227,"./CryptoUtils":142,"buffer":498,"privmx-crypto":265}],149:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyDataDecoder = void 0;
const privmx_crypto_1 = require("privmx-crypto");
const pki = require("privmx-pki");
const User_1 = require("../identity/User");
const MessageSink_1 = require("../message/MessageSink");
class MyDataDecoder {
    static decodeMyData(raw, host) {
        const keystore = raw.keystore ? pki.Helper.decodeKeystore(raw.keystore) : null;
        const keystoreMsg = raw.keystoreMsg ? pki.messages.KeyStoreMessage.decode(raw.keystoreMsg) : null;
        let presence;
        if (raw.presence != null) {
            presence = {
                presence: raw.presence.presence,
                acl: {
                    type: raw.presence.acl.type
                }
            };
            if (raw.presence.acl.pubs != null) {
                presence.acl.pubs = pki.Enumerable.$A(raw.presence.acl.pubs).map(x => privmx_crypto_1.ecc.PublicKey.fromBase58DER(x)).toArray();
            }
        }
        return {
            raw: raw,
            presence: presence,
            keystore: keystore,
            userInfo: keystore ? MyDataDecoder.parseUserInfo(raw.username, host, keystore, keystoreMsg, null) : null,
        };
    }
    static parseUserInfo(username, host, keystore, keystoreMsg, treeMsg) {
        const result = {
            keystore: keystore,
            keystoreMsg: keystoreMsg,
            treeMsg: treeMsg,
            user: User_1.User.fromKeyStore({ user: username, host: host }, keystore),
            profile: {
                name: null,
                description: null,
                image: keystore.getAttachment("image"),
                sinks: []
            }
        };
        const infoBuf = keystore.getAttachment("info");
        if (infoBuf) {
            const raw = JSON.parse(infoBuf.toString("utf8"));
            result.profile.name = raw.name;
            result.user.name = raw.name;
            result.profile.description = raw.description;
            if (raw.sinks) {
                result.profile.sinks = raw.sinks.map(x => MessageSink_1.MessageSink.deserialize(x));
            }
        }
        return result;
    }
}
exports.MyDataDecoder = MyDataDecoder;

},{"../identity/User":212,"../message/MessageSink":219,"privmx-crypto":265,"privmx-pki":326}],150:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordMixer = void 0;
const privmx_crypto_1 = require("privmx-crypto");
class PasswordMixer {
    static serializeData(data) {
        return JSON.stringify({
            algorithm: data.algorithm,
            hash: data.hash,
            length: data.length,
            rounds: data.rounds,
            salt: data.salt.toString("base64"),
            version: data.version
        });
    }
    static deserializeData(raw) {
        const data = JSON.parse(raw);
        data.salt = Buffer.from(data.salt, "base64");
        return data;
    }
    static generatePbkdf2(password) {
        const data = {
            algorithm: "PBKDF2",
            hash: "SHA512",
            length: 16,
            rounds: 4000 + Math.floor(Math.random() * 1000),
            salt: privmx_crypto_1.service.randomBytes(16),
            version: 1
        };
        return PasswordMixer.perform(password, data)
            .then(mixed => {
            return {
                mixed: mixed,
                data: data
            };
        });
    }
    static mix(password, data) {
        return PasswordMixer.perform(password, data)
            .then(mixed => {
            return mixed;
        });
    }
    static perform(password, data) {
        return Promise.resolve().then(() => {
            if (data.algorithm == "PBKDF2") {
                if (data.hash != "SHA512") {
                    throw new Error("Not supported hash algorithm '" + data.hash + "'");
                }
                if (data.version != 1) {
                    throw new Error("Not supported version '" + data.version + "'");
                }
                if (data.salt.length != 16 || data.length != 16) {
                    throw new Error("Invalid parameters");
                }
                return privmx_crypto_1.service.pbkdf2(Buffer.from(password, "utf8"), data.salt, data.rounds, data.length, data.hash.toLowerCase());
            }
            throw new Error("Not supported algorithm '" + data.algorithm + "'");
        });
    }
}
exports.PasswordMixer = PasswordMixer;

}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":498,"privmx-crypto":265}],151:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivFsRpcManager = void 0;
const PrivFsRpcManagerClass_1 = require("./PrivFsRpcManagerClass");
exports.PrivFsRpcManager = new PrivFsRpcManagerClass_1.PrivFsRpcManagerClass();

},{"./PrivFsRpcManagerClass":152}],152:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivFsRpcManagerClass = void 0;
const RootLogger = require("simplito-logger");
const simplito_net_1 = require("simplito-net");
const privmx_service_discovery_1 = require("privmx-service-discovery");
const PrivmxRpc = require("privmx-rpc");
const RpcGateway_1 = require("../gateway/RpcGateway");
const PrivFsException_1 = require("../exception/PrivFsException");
const Bip39LoginService_1 = require("./Bip39LoginService");
const SrpLoginService_1 = require("./SrpLoginService");
const SrpRegisterService_1 = require("./SrpRegisterService");
const KeyLoginService_1 = require("./KeyLoginService");
const Logger = RootLogger.get("privfs-client.core.PrivFsRpcManager");
class PrivFsRpcManagerClass {
    defaultVersion = "v2.0";
    serviceDiscoveryCfg = {
        jsonMode: privmx_service_discovery_1.JsonMode.HTTP_AND_HTTPS,
        discoveryOnly: privmx_service_discovery_1.DiscoveryMode.JSON_ONLY
    };
    gatewayProperties = {};
    agent = null;
    webSocket = null;
    maxMessagesNumber = null;
    maxMessagesSize = null;
    rpcConfigEnhancer = null;
    serviceDiscovery;
    urlMap;
    constructor() {
        this.serviceDiscovery = new privmx_service_discovery_1.PrivMXServiceDiscovery();
        this.urlMap = {};
    }
    setDefaultVersion(defaultVersion) {
        this.defaultVersion = defaultVersion;
    }
    setServiceDiscoveryJsonMode(jsonMode) {
        this.serviceDiscoveryCfg.jsonMode = jsonMode;
    }
    setServiceDiscoveryDiscoveryMode(discoveryOnly) {
        this.serviceDiscoveryCfg.discoveryOnly = discoveryOnly;
    }
    setGatewayProperties(properties) {
        this.gatewayProperties = properties;
    }
    setGatewayProperty(propertyName, propertyValue) {
        this.gatewayProperties[propertyName] = propertyValue;
    }
    setAgent(agent) {
        this.agent = agent;
    }
    setWebSocket(webSocket) {
        this.webSocket = webSocket;
    }
    setMaxMessagesNumber(maxMessagesNumber) {
        this.maxMessagesNumber = maxMessagesNumber;
    }
    setMaxMessagesSize(maxMessagesSize) {
        this.maxMessagesSize = maxMessagesSize;
    }
    setRpcConfigEnhancer(rpcConfigEnhancer) {
        this.rpcConfigEnhancer = rpcConfigEnhancer;
    }
    async getSrpLoginService(params) {
        const initParams = await this.resolveInitParameters(params);
        return new SrpLoginService_1.SrpLoginService(initParams, params.identityIndex);
    }
    async getBip39LoginService(params) {
        const initParams = await this.resolveInitParameters(params);
        return new Bip39LoginService_1.Bip39LoginService(initParams, params.identityIndex);
    }
    async getEcdheGateway(params) {
        const options = await this.resolveOptions(params);
        return RpcGateway_1.RpcGateway.createGatewayFromEcdheConnection(params.key, options);
    }
    async getKeyLoginService(params) {
        const initParameters = await this.resolveInitParameters(params);
        return new KeyLoginService_1.KeyLoginService(initParameters);
    }
    async getSrpRegisterService(params) {
        const gateway = await this.getEcdheGateway(params);
        return new SrpRegisterService_1.SrpRegisterService(gateway, params.identityIndex);
    }
    async discoverHostConfiguration(host) {
        return await this.serviceDiscovery.discover(host, this.serviceDiscoveryCfg.jsonMode, this.serviceDiscoveryCfg.discoveryOnly);
    }
    getVersion(version) {
        return typeof (version) == "undefined" ? this.defaultVersion : version;
    }
    async resolveApiEndpoint(host, version) {
        const mapKey = host + ":" + version;
        if (mapKey in this.urlMap) {
            return this.urlMap[mapKey];
        }
        const apiEndpoint = await this.resolveApiEndpointWithoutCache(host, version);
        this.urlMap[mapKey] = apiEndpoint;
        return apiEndpoint;
    }
    async resolveApiEndpointWithoutCache(host, version) {
        const config = await this.discoverHostConfiguration(host);
        const apiBaseEndpoint = this.getApiBaseEndpoint(config);
        if (!apiBaseEndpoint) {
            throw new Error("Invalid config for host " + host);
        }
        const urls = this.getPotentialUrls(apiBaseEndpoint);
        const cfg = await this.tryUrls(urls);
        if (cfg.versions.indexOf(version) == -1) {
            throw new Error("Unsupported API versions");
        }
        return cfg.apiBaseEndpoint + version + "/";
    }
    getApiBaseEndpoint(config) {
        if (config.apiBaseEndpoint) {
            return this.sanitizeUrl(config.apiBaseEndpoint);
        }
        if (config.defaultEndpoint) {
            return this.sanitizeUrl(config.defaultEndpoint) + "api/";
        }
        return null;
    }
    sanitizeUrl(url) {
        const u = url.trim();
        return /\/$/.test(u) ? u : u + "/";
    }
    getPotentialUrls(apiBaseEndpoint) {
        if (apiBaseEndpoint.startsWith("//")) {
            return this.serviceDiscovery.resolveSchemeless(this.serviceDiscoveryCfg.jsonMode, apiBaseEndpoint);
        }
        return [apiBaseEndpoint];
    }
    async tryUrls(urls) {
        for (const url of urls) {
            try {
                const versions = await simplito_net_1.JsonRpcRequest.promise({
                    url: url + "?_=" + new Date().getTime(),
                    method: "versions",
                    params: {},
                    withCredentials: true
                });
                return {
                    apiBaseEndpoint: url,
                    versions: versions
                };
            }
            catch (e) {
                Logger.debug("Cannot fetch versions from '" + url + "', trying next one...", e);
            }
        }
        throw new Error("Cannot connect to endpoint");
    }
    async resolveOptions(params) {
        if (!PrivmxRpc.RpcUtils.isValidHostname(params.host)) {
            throw new Error("Invalid host");
        }
        const version = this.getVersion(params.version);
        const apiEndpoint = await this.resolveApiEndpoint(params.host, version);
        let options = {
            url: apiEndpoint,
            host: params.host,
            tickets: {},
            appHandler: {}
        };
        if (this.agent != null) {
            options.agent = this.agent;
        }
        if (this.webSocket != null) {
            options.websocket = this.webSocket;
        }
        if (this.maxMessagesNumber != null) {
            options.appHandler.maxMessagesCount = this.maxMessagesNumber;
        }
        if (this.maxMessagesSize != null) {
            options.appHandler.maxMessagesSize = this.maxMessagesSize;
        }
        if (typeof (this.rpcConfigEnhancer) == "function") {
            options = this.rpcConfigEnhancer(options);
        }
        if (typeof (params.rpcConfigEnhancer) == "function") {
            options = params.rpcConfigEnhancer(options);
        }
        if (!PrivmxRpc.RpcUtils.isValidHostname(options.host)) {
            throw new Error("Invalid host");
        }
        return options;
    }
    async resolveInitParameters(params) {
        const options = await this.resolveOptions(params);
        const result = {
            options: options,
            gatewayProperties: this.createGatewayProperties(params.extraGatewayProperties),
            additionalLoginStepCallback: async (data, service) => {
                if (typeof (params.additionalLoginStepCallback) != "function") {
                    throw new PrivFsException_1.PrivFsException("NO_CALLBACK_FOR_ADDITIONAL_LOGIN_STEP", data);
                }
                await params.additionalLoginStepCallback({ service: service }, data);
            }
        };
        return result;
    }
    createGatewayProperties(extraGatewayProperties) {
        return {
            ...this.gatewayProperties,
            ...(extraGatewayProperties || {})
        };
    }
}
exports.PrivFsRpcManagerClass = PrivFsRpcManagerClass;

},{"../exception/PrivFsException":172,"../gateway/RpcGateway":208,"./Bip39LoginService":139,"./KeyLoginService":143,"./SrpLoginService":157,"./SrpRegisterService":158,"privmx-rpc":366,"privmx-service-discovery":375,"simplito-logger":407,"simplito-net":408}],153:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivFsSrpSecure = void 0;
const privmx_crypto_1 = require("privmx-crypto");
const pki = require("privmx-pki");
const types_1 = require("../types");
const KeystoreUtils_1 = require("./KeystoreUtils");
const LoginByKeyUtils_1 = require("./LoginByKeyUtils");
const MasterRecordUtils_1 = require("./MasterRecordUtils");
const SrpAuthorizer_1 = require("./login/SrpAuthorizer");
const SrpUtils_1 = require("./SrpUtils");
const MyDataDecoder_1 = require("./MyDataDecoder");
const UserBaseApi_1 = require("./UserBaseApi");
class PrivFsSrpSecure {
    gateway;
    privmxPKI;
    static PKI_COSIGNERS_ENTRY_NAME = "cosigners";
    userApi;
    constructor(gateway, privmxPKI) {
        this.gateway = gateway;
        this.privmxPKI = privmxPKI;
        this.userApi = new UserBaseApi_1.UserBaseApi(this.gateway);
    }
    static create(gateway, defaultPKI) {
        const privmxPKI = defaultPKI === false ? null : PrivFsSrpSecure.createDefaultPki(gateway);
        return new PrivFsSrpSecure(gateway, privmxPKI);
    }
    static createDefaultPki(gateway) {
        return new pki.PrivmxPKI(gateway, gateway.getHost());
    }
    request(method, params, settings) {
        if (settings === void (0)) {
            settings = {};
        }
        return this.gateway.request(method, params, settings);
    }
    getUserConfig() {
        return this.request("getUserConfig", {});
    }
    getUserKeystoreName(username, host) {
        if (host) { }
        return "user:" + username;
    }
    getUserInfo(username, host, includeAttachments, cache) {
        const useCache = cache === true;
        return Promise.resolve().then(() => {
            return this.privmxPKI.getKeyStore(this.getUserKeystoreName(username, host), {
                pkiOptions: {
                    domain: host,
                    noCache: !useCache
                },
                includeAttachments: includeAttachments,
                cacheLoad: useCache,
                cacheSave: useCache,
                fetchSave: useCache
            });
        })
            .then(res => {
            if (res.keystore == null) {
                throw new Error("user-does-not-exists");
            }
            return MyDataDecoder_1.MyDataDecoder.parseUserInfo(username, host, res.keystore, res.keyStoreMsg, res.treeMsg);
        });
    }
    setUserInfo(identity, profile) {
        return Promise.resolve().then(() => {
            return KeystoreUtils_1.KeystoreUtils.createKeystoreFromProfileWithInsertionSignatureData(this.privmxPKI, identity, profile);
        })
            .then(res => {
            return this.privmxPKI.callMethodByPkiCore("setUserInfo", res.params, params => {
                return {
                    data: params.keystore,
                    kis: params.kis
                };
            });
        });
    }
    getKeyStoreFetch(fetchId) {
        return this.privmxPKI.getFetchExById(fetchId);
    }
    getPrimaryKeyFromKeystoreAtTime(keystore, time) {
        if (time) { }
        return new privmx_crypto_1.ecc.PublicKey(keystore.getPrimaryKey().keyPair.keyPair);
    }
    async getMyData() {
        const raw = await this.request("getMyData", {});
        return MyDataDecoder_1.MyDataDecoder.decodeMyData(raw, this.gateway.getHost());
    }
    setContactFormEnabled(enabled) {
        return this.request("setContactFormEnabled", {
            enabled: enabled
        });
    }
    async getDecryptedMasterRecord(masterRecordKey, loginMode) {
        const model = await this.userApi.getMasterRecord();
        return MasterRecordUtils_1.MasterRecordUtils.decrypt(model, masterRecordKey, loginMode);
    }
    setMasterRecordLevel2(masterRecordLevel2Key, masterRecordLevel2) {
        return Promise.resolve().then(() => {
            return privmx_crypto_1.service.getObjectEncryptor(masterRecordLevel2Key).encrypt(masterRecordLevel2);
        })
            .then(cipher => {
            return this.request("setPrivDataL2", {
                privDataL2: cipher.toString("base64")
            });
        });
    }
    async loginToNewGateway(username, password) {
        const authorizer = new SrpAuthorizer_1.SrpAuthorizer(this.gateway.getInitParameters());
        return authorizer.login(username, password);
    }
    async getRecoveryInfo(username, password) {
        const { decryptedMasterRecord } = await this.loginToNewGateway(username, password);
        const recovery = decryptedMasterRecord.masterRecord.l1.recovery;
        if (!recovery) {
            throw new Error("Mnemonic is not generated yet");
        }
        return privmx_crypto_1.service.bip39FromEntropy(Buffer.from(recovery, "base64"));
    }
    async changePasswordByOldPassword(login, oldPassword, newPassword, weakPassword) {
        const { decryptedMasterRecord } = await this.loginToNewGateway(login, oldPassword);
        return this.changePasswordByDecryptedMasterRecord(decryptedMasterRecord, login, newPassword, weakPassword);
    }
    async changePasswordByRecovery(recovery, login, newPassword, weakPassword) {
        const bip39 = await LoginByKeyUtils_1.LoginByKeyUtils.getBip39(recovery);
        const masterRecordKey = LoginByKeyUtils_1.LoginByKeyUtils.getMasterRecordKeyFromBip39(bip39);
        const decryptedMasterRecord = await this.getDecryptedMasterRecord(masterRecordKey, types_1.core.LoginMode.LBK);
        return this.changePasswordByDecryptedMasterRecord(decryptedMasterRecord, login, newPassword, weakPassword);
    }
    async changePasswordByDecryptedMasterRecord(decryptedMasterRecord, login, newPassword, weakPassword) {
        if (decryptedMasterRecord.version == "2.0") {
            return this.changePassword(decryptedMasterRecord.l1Key, login, newPassword, weakPassword);
        }
        throw new Error("Unsupported privDataInfo version");
    }
    async changePassword(l1Key, login, newPassword, weakPassword) {
        const info = await this.userApi.info();
        const srpResult = await SrpUtils_1.SrpUtils.generateSrpParamsAndEncryptL1Key(info, login, newPassword, l1Key);
        return await this.request("setSrp", {
            login: login,
            salt: srpResult.salt.toString("hex"),
            verifier: srpResult.verifier.toString("hex"),
            params: srpResult.params,
            data: srpResult.encryptedL1.toString("base64"),
            weakPassword: weakPassword !== false
        });
    }
    setUserPreferences(language, notificationsEntry, contactFormSid) {
        const params = {
            language: language,
            notificationsEntry: notificationsEntry,
        };
        if (contactFormSid != null) {
            params.contactFormSid = contactFormSid;
        }
        return this.request("setUserPreferences", params);
    }
    invite(privacyLevel) {
        return this.request("invite", { privacyLevel });
    }
    getInitData() {
        return this.request("getInitData", {});
    }
    getUser(username) {
        return this.request("getUser", { username: username });
    }
    getUsers() {
        return this.request("getUsers", {});
    }
    modifyUser(username, properties) {
        return this.request("modifyUser", { username: username, properties: properties });
    }
    getConfigEx() {
        return this.request("getConfigEx", {});
    }
    removeUser(username) {
        return this.request("removeUser", { username: username });
    }
    addUser(username, pin, privacyLevel) {
        return this.request("addUser", {
            username: username,
            pin: pin,
            privacyLevel: privacyLevel
        });
    }
    addUserWithToken(creator, username, email, description, sendActivationLink, notificationEnabled, language, linkPattern, privacyLevel) {
        return this.request("addUserWithToken", {
            creator: creator,
            username: username,
            email: email,
            description: description,
            sendActivationLink: sendActivationLink,
            notificationEnabled: notificationEnabled,
            language: language,
            linkPattern: linkPattern,
            privacyLevel: privacyLevel
        });
    }
    addExternalUser(creator, username, email, description, notificationsEnabled, language, privateSectionAllowed) {
        return this.request("addExternalUser", {
            creator: creator,
            username: username,
            email: email,
            description: description,
            language: language,
            privateSectionAllowed: privateSectionAllowed,
            notificationsEnabled: notificationsEnabled
        });
    }
    addExternalPrivmxUser(creator, username, displayName, email, description, notificationsEnabled, language, privateSectionAllowed) {
        return this.request("addExternalPrivmxUser", {
            creator: creator,
            username: username,
            displayName: displayName,
            email: email,
            description: description,
            language: language,
            privateSectionAllowed: privateSectionAllowed,
            notificationsEnabled: notificationsEnabled
        });
    }
    changePin(username, pin) {
        return this.request("changePin", {
            username: username,
            pin: pin
        });
    }
    changeEmail(username, email) {
        return this.request("changeEmail", {
            username: username,
            email: email
        });
    }
    changeDescription(username, description) {
        return this.request("changeDescription", {
            username: username,
            description: description
        });
    }
    changeUserData(username, data) {
        return this.request("changeUserData", {
            username: username,
            data: data
        });
    }
    generateInvitations(username, count, description, linkPattern, privacyLevel) {
        return this.request("generateInvitations", {
            username: username,
            count: count,
            description: description,
            linkPattern: linkPattern,
            privacyLevel: privacyLevel
        });
    }
    getFullInitData() {
        return this.request("getFullInitData", {});
    }
    setInitData(initData) {
        return this.request("setInitData", { data: initData });
    }
    getNotifierConfig() {
        return this.request("getNotifierConfig", {});
    }
    setNotifierConfig(config) {
        return this.request("setNotifierConfig", { config: config });
    }
    getInvitationMailConfig() {
        return this.request("getInvitationMailConfig", {});
    }
    setInvitationMailConfig(config) {
        return this.request("setInvitationMailConfig", { config: config });
    }
    static parseLogins(logins) {
        logins.entries.forEach(entry => {
            entry.date = new Date(parseInt(entry.timestamp));
            delete entry.timestamp;
        });
        return logins;
    }
    getLoginsPage(beg, end) {
        return this.request("getLoginsPage", {
            beg: beg,
            end: end
        })
            .then(PrivFsSrpSecure.parseLogins);
    }
    getLastLogins(count) {
        return this.request("getLastLogins", { count: count })
            .then(PrivFsSrpSecure.parseLogins);
    }
    parseCosigners(data) {
        if (Array.isArray(data) && data.length === 0) {
            return {};
        }
        const result = {};
        for (const domain in data) {
            result[domain] = {
                hashmail: data[domain].hashmail,
                uuid: data[domain].uuid,
                state: data[domain].state,
                keystore: pki.Helper.decodeKeystore(data[domain].keystore),
                ip: data[domain].ip,
                modification_timestamp: data[domain].modification_timestamp,
                response_count: data[domain].response_count,
                requests_count: data[domain].requests_count
            };
        }
        return result;
    }
    setCosigner(domain, data) {
        return Promise.resolve().then(() => {
            if (!data.state || !data.keystore || !data.uuid) {
                throw new Error("Cosigner 'keystore', 'state' and 'uuid' are required");
            }
            return this.request("setCosigner", {
                domain: domain,
                data: {
                    hashmail: data.hashmail,
                    state: data.state,
                    uuid: data.uuid,
                    keystore: data.keystore instanceof pki.KeyStore.KeyStore ? data.keystore.serialize().toString("base64") : data.keystore
                }
            })
                .then(result => {
                return this.parseCosigners(result);
            });
        });
    }
    removeCosigner(domain, uuid) {
        return Promise.resolve().then(() => {
            return this.request("removeCosigner", {
                domain: domain,
                uuid: uuid
            })
                .then(result => {
                return this.parseCosigners(result);
            });
        });
    }
    getCosigners() {
        return this.request("getCosigners", {})
            .then(result => {
            return this.parseCosigners(result);
        });
    }
    getBlacklist() {
        return this.request("getBlacklist", {});
    }
    setBlacklistEntry(domain, mode) {
        return this.request("setBlacklistEntry", {
            domain: domain,
            mode: mode
        });
    }
    suggestBlacklistEntry(domain) {
        return this.request("suggestBlacklistEntry", { domain: domain });
    }
    deleteBlacklistEntry(domain) {
        return this.request("deleteBlacklistEntry", { domain: domain });
    }
    getPkiAdminEntryName() {
        return "admin:";
    }
    getPkiDocument(name, includeAttachments) {
        return this.privmxPKI.getKeyStore(name, {
            pkiOptions: {
                noCache: true
            },
            includeAttachments: includeAttachments,
            cacheLoad: false,
            cacheSave: false,
            fetchSave: false
        })
            .then(entry => {
            if (!(entry.keystore instanceof pki.KeyStore.DocumentsPacket)) {
                throw new Error("Expected DocumentsPacket export class ");
            }
            return entry.keystore;
        });
    }
    getPublishedCosigners() {
        return Promise.resolve().then(() => {
            return this.getPkiDocument(this.getPkiAdminEntryName(), [PrivFsSrpSecure.PKI_COSIGNERS_ENTRY_NAME]);
        })
            .then(document => {
            const doc = document.getAttachment(PrivFsSrpSecure.PKI_COSIGNERS_ENTRY_NAME);
            if (doc == null) {
                return {};
            }
            const rawCosigners = JSON.parse(doc.toString("utf8"));
            const result = {};
            for (const domain in rawCosigners) {
                result[domain] = pki.Helper.decodeKeystore(rawCosigners[domain]);
            }
            return result;
        });
    }
    getAdminKeys() {
        return Promise.resolve().then(() => {
            return this.getPkiDocument(this.getPkiAdminEntryName(), [PrivFsSrpSecure.PKI_COSIGNERS_ENTRY_NAME]);
        })
            .then(document => {
            return document.keys.map(x => {
                const key = x.keyPair;
                return new privmx_crypto_1.ecc.PublicKey(key);
            });
        });
    }
    isAdminKey(key) {
        return Promise.resolve().then(() => {
            return this.getAdminKeys();
        })
            .then(keys => {
            const hexDer = key.toHexDER();
            const hexKeys = keys.map(x => x.toHexDER());
            return hexKeys.indexOf(hexDer) != -1;
        });
    }
    async getKeyPairsForAdmins() {
        const users = await this.getUsers();
        const admins = users.filter(x => x.isAdmin).map(x => x.username);
        return this.getKeyPairsForUsers(admins);
    }
    getKeyPairsForUsers(usernames) {
        return Promise.all(usernames.map(async (username) => ({ username, keyPair: await this.getKeyPairsForUser(username) })));
    }
    async getKeyPairsForUser(username) {
        const info = await this.getUserInfo(username, this.gateway.getHost(), false);
        return info.keystore.getPrimaryKey().keyPair;
    }
    async publishCosigners(identity, cosigners) {
        const admins = await this.getKeyPairsForAdmins();
        const keyPairs = admins.map(x => x.keyPair);
        const primaryKeyPair = identity.keyPair;
        const document = new pki.KeyStore.DocumentsPacket(primaryKeyPair, keyPairs);
        const rawCosigners = {};
        for (const domain in cosigners) {
            rawCosigners[domain] = cosigners[domain].serialize().toString("base64");
        }
        document.addAttachment(PrivFsSrpSecure.PKI_COSIGNERS_ENTRY_NAME, Buffer.from(JSON.stringify(rawCosigners), "utf8"));
        return this.privmxPKI.callMethodByPki("setPkiDocument", {
            name: this.getPkiAdminEntryName(),
            data: document
        }, params => {
            return {
                name: params.name,
                data: params.keystore,
                kis: params.kis
            };
        });
    }
    async changeIsAdmin(identity, username, isAdmin) {
        const document = await this.getPkiDocument(this.getPkiAdminEntryName(), true);
        const admins = await this.getKeyPairsForAdmins();
        const newAdmins = await (async () => {
            if (isAdmin) {
                if (admins.some(x => x.username === username)) {
                    return admins;
                }
                return [...admins, { username, keyPair: await this.getKeyPairsForUser(username) }];
            }
            else {
                return admins.filter(x => x.username !== username);
            }
        })();
        document.primaryKey = identity.keyPair;
        document.keys = newAdmins.map(x => x.keyPair);
        return this.privmxPKI.callMethodByPki("changeIsAdmin", {
            name: this.getPkiAdminEntryName(),
            data: document
        }, params => {
            return {
                username: username,
                isAdmin: isAdmin,
                data: params.keystore,
                kis: params.kis
            };
        });
    }
    sinkGetAllByUser(username) {
        return this.request("sinkGetAllByUser", { username: username });
    }
    async srpRelogin(username, password) {
        await this.gateway.srpRelogin(username, password);
    }
    async keyRelogin(recovery) {
        await this.gateway.keyRelogin(recovery);
    }
}
exports.PrivFsSrpSecure = PrivFsSrpSecure;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../types":227,"./KeystoreUtils":144,"./LoginByKeyUtils":146,"./MasterRecordUtils":148,"./MyDataDecoder":149,"./SrpUtils":159,"./UserBaseApi":162,"./login/SrpAuthorizer":167,"buffer":498,"privmx-crypto":265,"privmx-pki":326}],154:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Registration = void 0;
const privmx_crypto_1 = require("privmx-crypto");
const SrpUtils_1 = require("./SrpUtils");
const LoginByKeyUtils_1 = require("./LoginByKeyUtils");
const MasterRecordUtils_1 = require("./MasterRecordUtils");
const pki = require("privmx-pki");
class Registration {
    static DATA_VERSION = "2.0";
    static async generateIdentity(identityIndex) {
        const masterSeed = privmx_crypto_1.service.randomBytes(64);
        const masterExtKey = await MasterRecordUtils_1.MasterRecordUtils.getMasterExtKey(masterSeed);
        const bip39 = await privmx_crypto_1.service.bip39Generate(256);
        const masterRecordLevel1Key = await privmx_crypto_1.service.randomBytes(32);
        const masterRecordLevel2Key = await privmx_crypto_1.service.randomBytes(32);
        const identityKey = await MasterRecordUtils_1.MasterRecordUtils.getIdentityKeyFromMasterExtKey(masterExtKey, identityIndex);
        const masterRecord = {
            l1: {
                dataVersion: Registration.DATA_VERSION,
                masterSeed: masterSeed.toString("base64"),
                recovery: bip39.entropy.toString("base64"),
                l2Key: masterRecordLevel2Key.toString("base64")
            },
            l2: {}
        };
        return {
            masterSeed: masterSeed,
            masterExtKey: masterExtKey,
            identityKey: identityKey,
            masterRecord: masterRecord,
            bip39: bip39,
            masterRecordLevel1Key: masterRecordLevel1Key,
            masterRecordLevel2Key: masterRecordLevel2Key
        };
    }
    static createRegisterParams(info, identity, params) {
        return {
            username: params.username,
            host: params.host,
            pin: params.pin || "",
            token: params.token || "",
            identityKey: identity.identityKey,
            srp: {
                info: info,
                login: params.login || params.username,
                password: params.password
            },
            lbk: {
                bip39: identity.bip39
            },
            masterRecord: identity.masterRecord,
            masterRecordL1Key: identity.masterRecordLevel1Key
        };
    }
    static async registerCoreEx(info, identityIndex, params) {
        const identity = await Registration.generateIdentity(identityIndex);
        const result = await Registration.registerCore(Registration.createRegisterParams(info, identity, params));
        return {
            ...result,
            identity: identity
        };
    }
    static async registerCore(params) {
        const authParams = await Registration.generateAuthorizationParams({
            masterRecord: params.masterRecord,
            masterRecordL1Key: params.masterRecordL1Key,
            srp: params.srp,
            bip39: params.lbk.bip39
        });
        const signature = await Registration.signUserCreation({
            username: params.username,
            pin: params.pin,
            token: params.token,
            srpSalt: authParams.srp.salt,
            srpVerifier: authParams.srp.verifier,
            identityKey: params.identityKey
        });
        return {
            keystore: pki.KeyStore.KeyStore.createFromKeyPair(params.username, pki.KeyStore.EccKeyPair.generateFromKey(params.identityKey.key)),
            signature: signature,
            authParams: authParams
        };
    }
    static async signUserCreation(data) {
        const signatureData = "createUser" + data.username + data.pin + data.token + data.srpSalt.toString("hex") +
            data.srpVerifier.toString("hex") + data.identityKey.getPublicKey().toBase58DER();
        return await privmx_crypto_1.service.signToCompactSignatureWithHash(data.identityKey, Buffer.from(signatureData, "utf8"));
    }
    static async generateAuthorizationParams(params) {
        return {
            version: Registration.DATA_VERSION,
            masterRecord: await MasterRecordUtils_1.MasterRecordUtils.encrypt(params.masterRecord, params.masterRecordL1Key),
            srp: await SrpUtils_1.SrpUtils.generateSrpParamsAndEncryptL1Key(params.srp.info, params.srp.login, params.srp.password, params.masterRecordL1Key),
            lbk: await LoginByKeyUtils_1.LoginByKeyUtils.encryptL1KeyWithBip39(params.bip39, params.masterRecordL1Key)
        };
    }
}
exports.Registration = Registration;

}).call(this)}).call(this,require("buffer").Buffer)
},{"./LoginByKeyUtils":146,"./MasterRecordUtils":148,"./SrpUtils":159,"buffer":498,"privmx-crypto":265,"privmx-pki":326}],155:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteStorageProvider = void 0;
const StorageProviderInterface_1 = require("./StorageProviderInterface");
class RemoteStorageProvider extends StorageProviderInterface_1.StorageProviderInterface {
    gateway;
    constructor(manager, gateway, destination, config) {
        super(manager);
        this.gateway = gateway;
        this.destination = destination;
        this.config = config;
    }
    getDestination() {
        return this.destination;
    }
    request(method, params) {
        return this.gateway.proxyRequest(this.destination, method, params);
    }
    blockAddToSession(transferIds, source, blocks) {
        return this.gateway.proxyRequest(this.destination, "blockAddToSession", {
            transferIds: transferIds,
            source: source,
            blocks: blocks
        });
    }
    blockCreate(transferIds, bid, content) {
        return this.gateway.proxyRequest(this.destination, "blockCreate", {
            transferIds: transferIds,
            bid: bid,
            data: content
        });
    }
    blockGet(bid, source, sendAlone) {
        return this.gateway.proxyRequest(this.destination, "blockGet", {
            bid: bid,
            source: source
        }, { sendAlone: sendAlone });
    }
    multiMap(list, maxSize, func) {
        const promises = [];
        let position = 0;
        while (position < list.length) {
            const lim = position + maxSize;
            const part = [];
            for (; position < lim && position < list.length; position++) {
                part.push(list[position]);
            }
            promises.push(func(part));
        }
        return Promise.all(promises)
            .then(mapList => {
            if (mapList.length == 1) {
                return mapList[0];
            }
            const result = {};
            for (let i = 0; i < mapList.length; i++) {
                const map = mapList[i];
                for (const key in map) {
                    result[key] = map[key];
                }
            }
            return result;
        });
    }
    blockCheck(bids) {
        return this.multiMap(bids, this.config.maxBlockBulkSize, (bids) => this.blockCheckSingle(bids));
    }
    blockCheckSingle(bids) {
        return this.gateway.proxyRequest(this.destination, "blockCheck", { bids: bids });
    }
    descriptorMulti(mode, ops) {
        return this.gateway.proxyRequest(this.destination, "descriptorMulti", {
            mode: mode,
            ops: ops
        });
    }
    descriptorCheck(dids, includeBlocks) {
        return this.multiMap(dids, this.config.maxDescriptorBulkSize, dids => {
            const params = {
                dids: dids,
                failOnError: false
            };
            if (typeof (includeBlocks) == "number") {
                params.includeBlocks = includeBlocks;
            }
            return this.gateway.proxyRequest(this.destination, "descriptorCheck", params);
        });
    }
    descriptorDelete(did, signature, descriptorSignature, lockId) {
        const params = {
            did: did,
            signature: signature,
            lockId: lockId
        };
        if (descriptorSignature != null) {
            params.descriptorSignature = descriptorSignature;
        }
        return this.gateway.proxyRequest(this.destination, "descriptorDelete", params);
    }
    descriptorGet(dids, includeBlocks) {
        return this.multiMap(dids, this.config.maxDescriptorBulkSize, dids => {
            const params = {
                dids: dids,
                failOnError: false
            };
            if (typeof (includeBlocks) == "number") {
                params.includeBlocks = includeBlocks;
            }
            return this.gateway.proxyRequest(this.destination, "descriptorGet", params);
        });
    }
    descriptorGetVersions(did) {
        return this.gateway.proxyRequest(this.destination, "descriptorGetVersions", { did: did });
    }
    descriptorGetLockHistory(did) {
        return this.gateway.proxyRequest(this.destination, "descriptorGetLockHistory", { did: did });
    }
    descriptorUpdateInit(did, signature) {
        return this.gateway.proxyRequest(this.destination, "descriptorUpdateInit", {
            did: did,
            signature: signature
        });
    }
    descriptorUpdate(did, data, transfer, signature, lockId, releaseLock) {
        return this.gateway.proxyRequest(this.destination, "descriptorUpdate", this.prepareTransferParam({
            did: did,
            data: data,
            signature: signature,
            lockId: lockId,
            releaseLock: releaseLock
        }, transfer));
    }
    descriptorCopy(did, dpub58, orgDid, versions, acl, versioning) {
        const params = {
            did: did,
            dpub58: dpub58,
            orgDid: orgDid,
            versions: versions
        };
        if (acl != null) {
            params.acl = acl;
        }
        if (versioning != null) {
            params.versioning = versioning;
        }
        return this.gateway.request("descriptorCopy", params);
    }
    descriptorCreateInit() {
        return this.gateway.request("descriptorCreateInit", {});
    }
    descriptorCreate(did, data, transfer, acl, versioning, lock) {
        let params = {
            did: did,
            data: data
        };
        if (acl != null) {
            params.acl = acl;
        }
        if (versioning != null) {
            params.versioning = versioning;
        }
        if (lock != null) {
            params.lock = lock;
        }
        params = this.prepareTransferParam(params, transfer);
        return this.gateway.request("descriptorCreate", params);
    }
    descriptorLock(did, lockId, signature, lockerPub58, lockerSignature, force) {
        return this.gateway.proxyRequest(this.destination, "descriptorLock", {
            did: did,
            lockId: lockId,
            signature: signature,
            lockerPub58: lockerPub58,
            lockerSignature: lockerSignature,
            force: force
        });
    }
    descriptorLockAndGet(did, lockId, signature, lockerPub58, lockerSignature, force) {
        return this.gateway.proxyRequest(this.destination, "descriptorLockAndGet", {
            did: did,
            lockId: lockId,
            signature: signature,
            lockerPub58: lockerPub58,
            lockerSignature: lockerSignature,
            force: force
        });
    }
    descriptorRelease(did, lockId, signature) {
        return this.gateway.proxyRequest(this.destination, "descriptorRelease", {
            did: did,
            lockId: lockId,
            signature: signature
        });
    }
    descriptorRelease2(did) {
        return this.gateway.proxyRequest(this.destination, "descriptorRelease2", {
            did: did
        });
    }
    descriptorModifyAcl(did, acl) {
        return this.gateway.proxyRequest(this.destination, "descriptorModifyAcl", {
            did: did,
            acl: acl
        });
    }
    descriptorModifyVersioning(did, versioning) {
        return this.gateway.proxyRequest(this.destination, "descriptorModifyVersioning", {
            did: did,
            versioning: versioning
        });
    }
    descriptorSetStickers(did, stickers, replace) {
        return this.gateway.proxyRequest(this.destination, "descriptorSetStickers", {
            did: did,
            stickers: stickers,
            replace: replace
        });
    }
    descriptorGetLocked() {
        return this.gateway.proxyRequest(this.destination, "descriptorGetLocked", {});
    }
    descriptorMarkAsUpdated(did) {
        return this.gateway.proxyRequest(this.destination, "descriptorMarkAsUpdated", {
            did: did
        });
    }
    messageDelete(sid, mids, expectedModSeq) {
        return this.gateway.request("messageDelete", {
            sid: sid,
            mids: mids,
            expectedModSeq: expectedModSeq
        });
    }
    messageModify(sid, mid, flags, tags, expectedModSeq) {
        return this.gateway.request("messageModify", {
            sid: sid,
            mid: mid,
            flags: flags,
            tags: tags,
            expectedModSeq: expectedModSeq
        });
    }
    messageModifyTags(sid, mids, toAdd, toRemove, expectedModSeq) {
        return this.gateway.request("messageModifyTags", {
            sid: sid,
            mids: mids,
            toAdd: toAdd,
            toRemove: toRemove,
            expectedModSeq: expectedModSeq
        });
    }
    messageGet(sid, mids, mode) {
        return this.multiMap(mids, this.config.maxMessageBulkSize, mids => {
            return this.messageGetSingle(sid, mids, mode);
        });
    }
    messageGetSingle(sid, mids, mode) {
        return this.gateway.request("messageGet", {
            sid: sid,
            mids: mids,
            mode: mode
        });
    }
    messagePostInit(sid, signature, extra) {
        const params = {
            sid: sid,
            signature: signature
        };
        if (typeof (extra) === "string") {
            params.extra = extra;
        }
        return this.gateway.proxyRequest(this.destination, "messagePostInit", params);
    }
    messagePost(data, tags, transfer, extra) {
        let params = {
            data: data,
            tags: tags
        };
        if (typeof (extra) === "string") {
            params.extra = extra;
        }
        params = this.prepareTransferParam(params, transfer);
        return this.gateway.proxyRequest(this.destination, "messagePost", params);
    }
    messageCreateAndDeleteInit(dSid, dMid, cSid) {
        return this.gateway.request("messageCreateAndDeleteInit", {
            dSid: dSid,
            dMid: dMid,
            cSid: cSid
        });
    }
    messageCreateAndDelete(data, flags, tags, transfer, sid, mid, expectedModSeq) {
        return this.gateway.request("messageCreateAndDelete", this.prepareTransferParam({
            data: data,
            flags: flags,
            tags: tags,
            sid: sid,
            mid: mid,
            expectedModSeq: expectedModSeq
        }, transfer));
    }
    messageUpdateInit(sid, mid, senderPub58) {
        return this.gateway.request("messageUpdateInit", {
            sid: sid,
            mid: mid,
            senderPub58: senderPub58
        });
    }
    messageUpdate(data, mid, tags, transfer) {
        return this.gateway.request("messageUpdate", this.prepareTransferParam({
            data: data,
            mid: mid,
            tags: tags
        }, transfer));
    }
    messageCreateInit(sid) {
        return this.gateway.request("messageCreateInit", { sid: sid });
    }
    messageCreate(data, flags, tags, transfer) {
        return this.gateway.request("messageCreate", this.prepareTransferParam({
            data: data,
            flags: flags,
            tags: tags
        }, transfer));
    }
    messageSetStickers(sid, mid, stickers, replace) {
        return this.gateway.request("messageSetStickers", {
            sid: sid,
            mid: mid,
            stickers: stickers,
            replace: replace
        });
    }
    sinkGetAllMy() {
        return this.gateway.request("sinkGetAllMy", {});
    }
    sinkCreate(sid, acl, data, options) {
        return this.gateway.request("sinkCreate", {
            sid: sid,
            acl: acl,
            data: data,
            options: options
        });
    }
    sinkSave(sid, acl, data, options) {
        return this.gateway.request("sinkSave", {
            sid: sid,
            acl: acl,
            data: data,
            options: options
        });
    }
    sinkUpdateOptions(sid, options) {
        return this.gateway.request("sinkUpdateOptions", {
            sid: sid,
            options: options
        });
    }
    sinkDelete(sid) {
        return this.gateway.request("sinkDelete", { sid: sid });
    }
    sinkSetLastSeenSeq(sid, lastSeenSeq) {
        return this.gateway.request("sinkSetLastSeenSeq", {
            sid: sid,
            lastSeenSeq: lastSeenSeq
        });
    }
    sinkPoll(sinks, updateLastSeen) {
        return this.gateway.request("sinkPoll", {
            sinks: sinks,
            updateLastSeen: updateLastSeen
        });
    }
    sinkWait(sinks, updateLastSeen) {
        return this.gateway.request("sinkWait", {
            sinks: sinks,
            updateLastSeen: updateLastSeen
        }, { sendAlone: true });
    }
    sinkClear(sid, currentModSeq) {
        return this.gateway.request("sinkClear", {
            sid: sid,
            currentModSeq: currentModSeq
        });
    }
    sinkInfo(sid, addMidList) {
        return this.gateway.request("sinkInfo", {
            sid: sid,
            addMidList: addMidList
        });
    }
    sinkQuery(sid, query, limit, order) {
        return this.gateway.request("sinkQuery", {
            sid: sid,
            query: query,
            limit: limit,
            order: order
        });
    }
}
exports.RemoteStorageProvider = RemoteStorageProvider;

},{"./StorageProviderInterface":160}],156:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteStorageProviderWithCache = void 0;
const RemoteStorageProvider_1 = require("./RemoteStorageProvider");
const BlockCache_1 = require("./BlockCache");
class RemoteStorageProviderWithCache extends RemoteStorageProvider_1.RemoteStorageProvider {
    cache;
    constructor(manager, gateway, destination, config, blockCache) {
        super(manager, gateway, destination, config);
        this.cache = blockCache || new BlockCache_1.BlockCache();
    }
    blockGet(bid, source, sendAlone) {
        const data = this.cache.get(bid);
        if (data != null) {
            return Promise.resolve(data);
        }
        return this.gateway.proxyRequest(this.destination, "blockGet", {
            bid: bid,
            source: source
        }, { sendAlone: sendAlone })
            .then(res => {
            this.cache.set(bid, res);
            return res;
        });
    }
    descriptorGet(dids, includeBlocks) {
        return this.multiMap(dids, this.config.maxDescriptorBulkSize, dids => {
            return this.gateway.proxyRequest(this.destination, "descriptorGet", {
                dids: dids,
                includeBlocks: typeof (includeBlocks) == "number" ? includeBlocks : 1,
                failOnError: false
            })
                .then((res) => {
                Object.keys(res).forEach(key => {
                    const obj = res[key];
                    if (obj.blocksData) {
                        Object.keys(obj.blocksData).forEach(k => {
                            const buffer = Buffer.from(obj.blocksData[k].toArrayBuffer());
                            this.cache.set(k, buffer);
                        });
                    }
                });
                return res;
            });
        });
    }
    descriptorCheck(dids, includeBlocks) {
        return this.multiMap(dids, this.config.maxDescriptorBulkSize, dids => {
            return this.gateway.proxyRequest(this.destination, "descriptorCheck", {
                dids: dids,
                includeBlocks: typeof (includeBlocks) == "number" ? includeBlocks : 1,
                failOnError: false
            })
                .then((res) => {
                Object.keys(res).forEach(key => {
                    const obj = res[key];
                    if (obj.blocksData) {
                        Object.keys(obj.blocksData).forEach(k => {
                            const buffer = Buffer.from(obj.blocksData[k].toArrayBuffer());
                            this.cache.set(k, buffer);
                        });
                    }
                });
                return res;
            });
        });
    }
}
exports.RemoteStorageProviderWithCache = RemoteStorageProviderWithCache;

}).call(this)}).call(this,require("buffer").Buffer)
},{"./BlockCache":140,"./RemoteStorageProvider":155,"buffer":498}],157:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SrpLoginService = void 0;
const LoginUtils_1 = require("./LoginUtils");
const PrivFsSrpSecure_1 = require("./PrivFsSrpSecure");
const SrpAuthorizer_1 = require("./login/SrpAuthorizer");
class SrpLoginService {
    initParameters;
    identityIndex;
    constructor(initParameters, identityIndex) {
        this.initParameters = initParameters;
        this.identityIndex = identityIndex;
    }
    async login(username, password, defaultPKI) {
        const info = await this.loginWithoutProcessingMasterRecord(username, password, defaultPKI);
        return LoginUtils_1.LoginUtils.loginLastStep(info.srpSecure, info.decryptedMasterRecord.masterRecord, this.identityIndex);
    }
    async loginWithoutProcessingMasterRecord(username, password, defaultPKI) {
        const authorizer = new SrpAuthorizer_1.SrpAuthorizer(this.initParameters);
        const { gateway, decryptedMasterRecord } = await authorizer.login(username, password);
        return {
            srpSecure: PrivFsSrpSecure_1.PrivFsSrpSecure.create(gateway, defaultPKI),
            decryptedMasterRecord: decryptedMasterRecord
        };
    }
}
exports.SrpLoginService = SrpLoginService;

},{"./LoginUtils":147,"./PrivFsSrpSecure":153,"./login/SrpAuthorizer":167}],158:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SrpRegisterService = void 0;
const pki = require("privmx-pki");
const Registration_1 = require("./Registration");
const KeystoreUtils_1 = require("./KeystoreUtils");
const SrpUtils_1 = require("./SrpUtils");
const UserBaseApi_1 = require("./UserBaseApi");
class SrpRegisterService {
    rpcGateway;
    identityIndex;
    userApi;
    constructor(rpcGateway, identityIndex) {
        this.rpcGateway = rpcGateway;
        this.identityIndex = identityIndex;
        this.userApi = new UserBaseApi_1.UserBaseApi(this.rpcGateway);
    }
    async registerEx(params) {
        const identity = await Registration_1.Registration.generateIdentity(this.identityIndex);
        const srpInfo = await this.getSrpInfo();
        const regParams = {
            ...await Registration_1.Registration.createRegisterParams(srpInfo, identity, params),
            email: params.email,
            language: params.language,
            weakPassword: params.weakPassword
        };
        const registerResult = await this.register(regParams);
        return {
            registerResult: registerResult,
            masterSeed: identity.masterSeed,
            masterExtKey: identity.masterExtKey,
            identityKey: identity.identityKey,
            masterRecord: identity.masterRecord
        };
    }
    async register(params) {
        const result = await Registration_1.Registration.registerCore(params);
        const kis = await this.getKeystoreInsertionSignature(result.keystore);
        await this.userApi.registerUser({
            username: params.username,
            host: params.host,
            email: params.email,
            pin: params.pin,
            token: params.token,
            language: params.language,
            signature: result.signature,
            masterRecordL1: result.authParams.masterRecord.l1,
            masterRecordL2: result.authParams.masterRecord.l2,
            dataVersion: result.authParams.version,
            srp: {
                login: result.authParams.srp.login,
                salt: result.authParams.srp.salt,
                verifier: result.authParams.srp.verifier,
                params: result.authParams.srp.params,
                data: result.authParams.srp.encryptedL1,
                weakPassword: params.weakPassword
            },
            lbk: {
                pub: result.authParams.lbk.publicKey,
                data: result.authParams.lbk.encryptedL1
            },
            keystore: {
                pub: result.keystore.getPublicView(),
                kis: kis
            }
        });
        return result;
    }
    async generateAuthorizationParams(login, password, l1Key, masterRecord, bip39) {
        const info = await this.getSrpInfo();
        return Registration_1.Registration.generateAuthorizationParams({
            masterRecord: masterRecord,
            masterRecordL1Key: l1Key,
            srp: {
                info: info,
                login: login,
                password: password
            },
            bip39
        });
    }
    async generateSrpParamsAndEncryptL1Key(login, password, l1Key) {
        const info = await this.getSrpInfo();
        return SrpUtils_1.SrpUtils.generateSrpParamsAndEncryptL1Key(info, login, password, l1Key);
    }
    async getSrpInfo() {
        return await this.userApi.info();
    }
    async getServerKeystoreWithoutCosigners() {
        const privmxPKI = this.createDefaultPki();
        const keystoreEntry = await privmxPKI.getServerKeyStore();
        return keystoreEntry.keystore;
    }
    createDefaultPki(gateway) {
        gateway = gateway || this.rpcGateway;
        return new pki.PrivmxPKI(gateway, gateway.getHost());
    }
    getKeystoreInsertionSignature(keystore) {
        return KeystoreUtils_1.KeystoreUtils.createKeystoreInsertionSignature(this.createDefaultPki(), keystore);
    }
}
exports.SrpRegisterService = SrpRegisterService;

},{"./KeystoreUtils":144,"./Registration":154,"./SrpUtils":159,"./UserBaseApi":162,"privmx-pki":326}],159:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SrpUtils = void 0;
const privmx_crypto_1 = require("privmx-crypto");
const PasswordMixer_1 = require("../core/PasswordMixer");
const CryptoUtils_1 = require("./CryptoUtils");
class SrpUtils {
    static async generateSrpParamsAndEncryptL1Key(info, login, password, masterRecordL1Key) {
        const params = await SrpUtils.generateSrpParams(info, login, password);
        const masterRecordKey = await SrpUtils.createMasterRecordKeyFromMixed(params.mixed);
        return {
            login: params.login,
            salt: params.salt,
            verifier: params.verifier,
            params: params.mixerParams,
            encryptedL1: await CryptoUtils_1.CryptoUtils.encryptWithSignature(masterRecordL1Key, masterRecordKey)
        };
    }
    static async generateSrpParams(info, login, password) {
        const loginData = await PasswordMixer_1.PasswordMixer.generatePbkdf2(password);
        const register = await privmx_crypto_1.service.srpRegister(info.N, info.g, login, loginData.mixed.toString("base64"));
        return {
            login: login,
            salt: register.s,
            verifier: register.v,
            mixed: loginData.mixed,
            mixerParams: PasswordMixer_1.PasswordMixer.serializeData(loginData.data)
        };
    }
    static async createMasterRecordKeyFromMixed(generator) {
        return await privmx_crypto_1.service.sha256(generator);
    }
}
exports.SrpUtils = SrpUtils;

},{"../core/PasswordMixer":150,"./CryptoUtils":142,"privmx-crypto":265}],160:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageProviderInterface = void 0;
class StorageProviderInterface {
    manager;
    config;
    destination;
    constructor(manager) {
        this.manager = manager;
    }
    dispatchEvent(event) {
        return this.manager.dispatchEvent(event);
    }
    startEvent(type, data) {
        return this.manager.startEvent(type, data);
    }
    stopEvent(startEvent) {
        return this.manager.stopEvent(startEvent);
    }
    getDestination() {
        return this.destination;
    }
    prepareTransferParam(params, transfer) {
        if (this.config.inlineTransferSupported) {
            params.transfer = transfer;
        }
        else {
            if (transfer.type != "transfer") {
                throw new Error("Cannot send inline transfer data to not supported server " + transfer.type);
            }
            params.transferId = transfer.transferId;
        }
        return params;
    }
    performDeferredAction(promise) {
        return promise.then(z => z.run(this));
    }
}
exports.StorageProviderInterface = StorageProviderInterface;

},{}],161:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageProviderManager = void 0;
const RpcGateway_1 = require("../gateway/RpcGateway");
const RemoteStorageProvider_1 = require("./RemoteStorageProvider");
const RemoteStorageProviderWithCache_1 = require("./RemoteStorageProviderWithCache");
const privmx_exception_1 = require("privmx-exception");
const privmx_crypto_1 = require("privmx-crypto");
const BlockCache_1 = require("./BlockCache");
class StorageProviderManager {
    gateway;
    map;
    withCache;
    event;
    eventId;
    blockCache;
    constructor(gateway, withCache) {
        if (!(gateway instanceof RpcGateway_1.RpcGateway)) {
            throw new privmx_exception_1.IllegalArgumentException("gateway", gateway);
        }
        Object.defineProperty(this, "gateway", {
            value: gateway,
            enumerable: true
        });
        Object.defineProperty(this, "map", {
            value: {},
            enumerable: true
        });
        Object.defineProperty(this, "event", {
            value: new privmx_crypto_1.utils.Event(),
            enumerable: true
        });
        this.withCache = withCache !== false;
        this.eventId = 0;
        this.blockCache = new BlockCache_1.BlockCache();
    }
    getProvider(destination) {
        return Promise.resolve().then(() => {
            if (destination in this.map) {
                return this.map[destination];
            }
            return Promise.resolve().then(() => {
                return this.gateway.proxyRequest(destination, "getConfig", {});
            })
                .then(config => {
                let provider;
                if (this.withCache) {
                    provider = new RemoteStorageProviderWithCache_1.RemoteStorageProviderWithCache(this, this.gateway, destination, config, this.blockCache);
                }
                else {
                    provider = new RemoteStorageProvider_1.RemoteStorageProvider(this, this.gateway, destination, config);
                }
                this.map[destination] = provider;
                return provider;
            });
        });
    }
    startEvent(type, data) {
        const id = this.eventId++;
        const startEvent = {
            type: type,
            action: "start",
            id: id,
            data: data
        };
        this.dispatchEvent(startEvent);
        return startEvent;
    }
    stopEvent(startEvent) {
        const stopEvent = {
            type: startEvent.type,
            action: "stop",
            id: startEvent.id,
            data: startEvent.data
        };
        this.dispatchEvent(stopEvent);
    }
    dispatchEvent(event) {
        this.event.trigger(event);
    }
}
exports.StorageProviderManager = StorageProviderManager;

},{"../gateway/RpcGateway":208,"./BlockCache":140,"./RemoteStorageProvider":155,"./RemoteStorageProviderWithCache":156,"privmx-crypto":265,"privmx-exception":286}],162:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserBaseApi = void 0;
const PrivFsException_1 = require("../exception/PrivFsException");
const Utils = require("simplito-utils");
class UserBaseApi {
    gateway;
    constructor(gateway) {
        this.gateway = gateway;
    }
    async request(method, params) {
        return this.gateway.request(method, params);
    }
    async registerUser(params) {
        if (params.keystore.pub.hasAnyPrivate()) {
            throw new Error("Cannot send a keystore which contains a private key");
        }
        return this.request("register", {
            username: params.username,
            host: params.host,
            email: params.email,
            pin: params.pin,
            token: params.token,
            language: params.language,
            signature: params.signature.toString("base64"),
            privDataL1: params.masterRecordL1.toString("base64"),
            privDataL2: params.masterRecordL2.toString("base64"),
            dataVersion: params.dataVersion,
            srp: {
                login: params.srp.login,
                salt: params.srp.salt.toString("hex"),
                verifier: params.srp.verifier.toString("hex"),
                params: params.srp.params,
                data: params.srp.data.toString("base64"),
                weakPassword: params.srp.weakPassword !== false
            },
            lbk: {
                pub: params.lbk.pub.toBase58DER(),
                data: params.lbk.data.toString("base64")
            },
            keystore: {
                pub: params.keystore.pub.serialize().toString("base64"),
                kis: params.keystore.kis.serialize().toString("base64")
            }
        });
    }
    async info() {
        const data = await this.request("srpInfo", {});
        if (data == null || data.N == null || data.g == null) {
            throw new PrivFsException_1.PrivFsException("INVALID_RESPONSE", data);
        }
        return {
            N: Buffer.from(Utils.padHex(data.N), "hex"),
            g: Buffer.from(Utils.padHex(data.g), "hex")
        };
    }
    async getMasterRecord() {
        return await this.request("getPrivDataEx", {});
    }
}
exports.UserBaseApi = UserBaseApi;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../exception/PrivFsException":172,"buffer":498,"simplito-utils":422}],163:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utils = void 0;
class Utils {
    static createBufferFromObject(obj) {
        return Buffer.from(JSON.stringify(obj), "utf8");
    }
}
exports.Utils = Utils;

}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":498}],164:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZPromiseExecutor = exports.ZPromise = void 0;
const simplito_promise_1 = require("simplito-promise");
class ZPromise {
    func;
    constructor(func) {
        this.func = func;
    }
    static create(func) {
        const deferred = simplito_promise_1.PromiseUtils.defer();
        return new ZPromise(t => {
            const res = func(t);
            Promise.resolve().then(() => res).then(u => deferred.resolve(u)).catch(e => deferred.reject(e));
            return deferred.promise;
        });
    }
    run(t) {
        return this.func(t);
    }
    next(func, onReject) {
        return new ZPromise(t => this.func(t).then(func, onReject));
    }
    fail(func) {
        return new ZPromise(t => this.func(t).catch(func));
    }
}
exports.ZPromise = ZPromise;
class ZPromiseExecutor {
    ops;
    constructor() {
        this.ops = [];
    }
    performC(promises) {
        return Promise.all(promises).then(zPromises => {
            const service = this.getService();
            const promises = zPromises.filter(x => x).map(x => x.run(service));
            this.flush();
            return promises;
        });
    }
    performS(promises) {
        return this.performC(promises).then(x => Promise.allSettled(x));
    }
    perform(promises) {
        return this.performC(promises).then(x => Promise.all(x));
    }
    addOp(data) {
        const deferred = simplito_promise_1.PromiseUtils.defer();
        this.ops.push({
            data: data,
            deferred: deferred
        });
        return deferred.promise;
    }
    clearOps() {
        this.ops = [];
    }
}
exports.ZPromiseExecutor = ZPromiseExecutor;

},{"simplito-promise":421}],165:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZPromiseExecutor = exports.ZPromise = exports.Utils = exports.UserBaseApi = exports.AnonymousPrivmxClient = exports.StorageProviderInterface = exports.SrpUtils = exports.SrpRegisterService = exports.SrpLoginService = exports.RemoteStorageProvider = exports.Registration = exports.PrivFsRpcManagerClass = exports.PrivFsRpcManager = exports.PrivFsSrpSecure = exports.PasswordMixer = exports.MyDataDecoder = exports.MasterRecordUtils = exports.LoginUtils = exports.LoginByKeyUtils = exports.LinkSentStatus = exports.KeystoreUtils = exports.KeyLoginService = exports.CryptoUtils = exports.Client = exports.Bip39LoginService = exports.ApiErrorCodes = exports.Acl = exports.login = void 0;
const login = require("./login");
exports.login = login;
const Acl_1 = require("./Acl");
Object.defineProperty(exports, "Acl", { enumerable: true, get: function () { return Acl_1.Acl; } });
const ApiErrorCodes_1 = require("./ApiErrorCodes");
Object.defineProperty(exports, "ApiErrorCodes", { enumerable: true, get: function () { return ApiErrorCodes_1.ApiErrorCodes; } });
const Client_1 = require("./Client");
Object.defineProperty(exports, "Client", { enumerable: true, get: function () { return Client_1.Client; } });
const LinkSentStatus_1 = require("./LinkSentStatus");
Object.defineProperty(exports, "LinkSentStatus", { enumerable: true, get: function () { return LinkSentStatus_1.LinkSentStatus; } });
const LoginUtils_1 = require("./LoginUtils");
Object.defineProperty(exports, "LoginUtils", { enumerable: true, get: function () { return LoginUtils_1.LoginUtils; } });
const PasswordMixer_1 = require("./PasswordMixer");
Object.defineProperty(exports, "PasswordMixer", { enumerable: true, get: function () { return PasswordMixer_1.PasswordMixer; } });
const PrivFsSrpSecure_1 = require("./PrivFsSrpSecure");
Object.defineProperty(exports, "PrivFsSrpSecure", { enumerable: true, get: function () { return PrivFsSrpSecure_1.PrivFsSrpSecure; } });
const PrivFsRpcManager_1 = require("./PrivFsRpcManager");
Object.defineProperty(exports, "PrivFsRpcManager", { enumerable: true, get: function () { return PrivFsRpcManager_1.PrivFsRpcManager; } });
const PrivFsRpcManagerClass_1 = require("./PrivFsRpcManagerClass");
Object.defineProperty(exports, "PrivFsRpcManagerClass", { enumerable: true, get: function () { return PrivFsRpcManagerClass_1.PrivFsRpcManagerClass; } });
const RemoteStorageProvider_1 = require("./RemoteStorageProvider");
Object.defineProperty(exports, "RemoteStorageProvider", { enumerable: true, get: function () { return RemoteStorageProvider_1.RemoteStorageProvider; } });
const Registration_1 = require("./Registration");
Object.defineProperty(exports, "Registration", { enumerable: true, get: function () { return Registration_1.Registration; } });
const StorageProviderInterface_1 = require("./StorageProviderInterface");
Object.defineProperty(exports, "StorageProviderInterface", { enumerable: true, get: function () { return StorageProviderInterface_1.StorageProviderInterface; } });
const AnonymousPrivmxClient_1 = require("./AnonymousPrivmxClient");
Object.defineProperty(exports, "AnonymousPrivmxClient", { enumerable: true, get: function () { return AnonymousPrivmxClient_1.AnonymousPrivmxClient; } });
const ZPromise_1 = require("./ZPromise");
Object.defineProperty(exports, "ZPromise", { enumerable: true, get: function () { return ZPromise_1.ZPromise; } });
Object.defineProperty(exports, "ZPromiseExecutor", { enumerable: true, get: function () { return ZPromise_1.ZPromiseExecutor; } });
const CryptoUtils_1 = require("./CryptoUtils");
Object.defineProperty(exports, "CryptoUtils", { enumerable: true, get: function () { return CryptoUtils_1.CryptoUtils; } });
const KeystoreUtils_1 = require("./KeystoreUtils");
Object.defineProperty(exports, "KeystoreUtils", { enumerable: true, get: function () { return KeystoreUtils_1.KeystoreUtils; } });
const LoginByKeyUtils_1 = require("./LoginByKeyUtils");
Object.defineProperty(exports, "LoginByKeyUtils", { enumerable: true, get: function () { return LoginByKeyUtils_1.LoginByKeyUtils; } });
const MasterRecordUtils_1 = require("./MasterRecordUtils");
Object.defineProperty(exports, "MasterRecordUtils", { enumerable: true, get: function () { return MasterRecordUtils_1.MasterRecordUtils; } });
const SrpUtils_1 = require("./SrpUtils");
Object.defineProperty(exports, "SrpUtils", { enumerable: true, get: function () { return SrpUtils_1.SrpUtils; } });
const Utils_1 = require("./Utils");
Object.defineProperty(exports, "Utils", { enumerable: true, get: function () { return Utils_1.Utils; } });
const MyDataDecoder_1 = require("./MyDataDecoder");
Object.defineProperty(exports, "MyDataDecoder", { enumerable: true, get: function () { return MyDataDecoder_1.MyDataDecoder; } });
const Bip39LoginService_1 = require("./Bip39LoginService");
Object.defineProperty(exports, "Bip39LoginService", { enumerable: true, get: function () { return Bip39LoginService_1.Bip39LoginService; } });
const SrpLoginService_1 = require("./SrpLoginService");
Object.defineProperty(exports, "SrpLoginService", { enumerable: true, get: function () { return SrpLoginService_1.SrpLoginService; } });
const SrpRegisterService_1 = require("./SrpRegisterService");
Object.defineProperty(exports, "SrpRegisterService", { enumerable: true, get: function () { return SrpRegisterService_1.SrpRegisterService; } });
const KeyLoginService_1 = require("./KeyLoginService");
Object.defineProperty(exports, "KeyLoginService", { enumerable: true, get: function () { return KeyLoginService_1.KeyLoginService; } });
const UserBaseApi_1 = require("./UserBaseApi");
Object.defineProperty(exports, "UserBaseApi", { enumerable: true, get: function () { return UserBaseApi_1.UserBaseApi; } });

},{"./Acl":136,"./AnonymousPrivmxClient":137,"./ApiErrorCodes":138,"./Bip39LoginService":139,"./Client":141,"./CryptoUtils":142,"./KeyLoginService":143,"./KeystoreUtils":144,"./LinkSentStatus":145,"./LoginByKeyUtils":146,"./LoginUtils":147,"./MasterRecordUtils":148,"./MyDataDecoder":149,"./PasswordMixer":150,"./PrivFsRpcManager":151,"./PrivFsRpcManagerClass":152,"./PrivFsSrpSecure":153,"./Registration":154,"./RemoteStorageProvider":155,"./SrpLoginService":157,"./SrpRegisterService":158,"./SrpUtils":159,"./StorageProviderInterface":160,"./UserBaseApi":162,"./Utils":163,"./ZPromise":164,"./login":168}],166:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bip39Authorizer = void 0;
const types_1 = require("../../types");
const LoginByKeyUtils_1 = require("../LoginByKeyUtils");
const MasterRecordUtils_1 = require("../MasterRecordUtils");
const RpcGateway_1 = require("../../gateway/RpcGateway");
const UserBaseApi_1 = require("../UserBaseApi");
class Bip39Authorizer {
    initParameters;
    constructor(initParameters) {
        this.initParameters = initParameters;
    }
    async loginByRecovery(recovery) {
        const bip39 = await LoginByKeyUtils_1.LoginByKeyUtils.getBip39(recovery);
        return this.loginByBip39(bip39);
    }
    async loginByBip39(bip39) {
        const gateway = await RpcGateway_1.RpcGateway.createGatewayFromKeyConnection(bip39.extKey.getPrivateKey(), this.initParameters);
        return this.decryptMasterRecord(gateway, bip39);
    }
    async decryptMasterRecord(gateway, bip39) {
        const dataKey = LoginByKeyUtils_1.LoginByKeyUtils.getMasterRecordKeyFromBip39(bip39);
        const userApi = new UserBaseApi_1.UserBaseApi(gateway);
        const model = await userApi.getMasterRecord();
        const decryptedMasterRecord = await MasterRecordUtils_1.MasterRecordUtils.decrypt(model, dataKey, types_1.core.LoginMode.LBK);
        return { gateway, decryptedMasterRecord };
    }
}
exports.Bip39Authorizer = Bip39Authorizer;

},{"../../gateway/RpcGateway":208,"../../types":227,"../LoginByKeyUtils":146,"../MasterRecordUtils":148,"../UserBaseApi":162}],167:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SrpAuthorizer = void 0;
const RpcGateway_1 = require("../../gateway/RpcGateway");
const types_1 = require("../../types");
const SrpUtils_1 = require("../SrpUtils");
const MasterRecordUtils_1 = require("../MasterRecordUtils");
const UserBaseApi_1 = require("../UserBaseApi");
class SrpAuthorizer {
    initParameters;
    constructor(initParameters) {
        this.initParameters = initParameters;
    }
    async login(username, password) {
        const gateway = await RpcGateway_1.RpcGateway.createGatewayFromSrpConnection(username, password, this.initParameters);
        return this.decryptMasterRecord(gateway);
    }
    async decryptMasterRecord(gateway) {
        const info = gateway.getInfo();
        const masterRecordKey = await SrpUtils_1.SrpUtils.createMasterRecordKeyFromMixed(info.mixed);
        const userApi = new UserBaseApi_1.UserBaseApi(gateway);
        const model = await userApi.getMasterRecord();
        const decryptedMasterRecord = await MasterRecordUtils_1.MasterRecordUtils.decrypt(model, masterRecordKey, types_1.core.LoginMode.SRP);
        return { gateway, decryptedMasterRecord };
    }
}
exports.SrpAuthorizer = SrpAuthorizer;

},{"../../gateway/RpcGateway":208,"../../types":227,"../MasterRecordUtils":148,"../SrpUtils":159,"../UserBaseApi":162}],168:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SrpAuthorizer = exports.Bip39Authorizer = void 0;
const Bip39Authorizer_1 = require("./Bip39Authorizer");
Object.defineProperty(exports, "Bip39Authorizer", { enumerable: true, get: function () { return Bip39Authorizer_1.Bip39Authorizer; } });
const SrpAuthorizer_1 = require("./SrpAuthorizer");
Object.defineProperty(exports, "SrpAuthorizer", { enumerable: true, get: function () { return SrpAuthorizer_1.SrpAuthorizer; } });

},{"./Bip39Authorizer":166,"./SrpAuthorizer":167}],169:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyValueDb = void 0;
const privmx_crypto_1 = require("privmx-crypto");
const ApiErrorCodes_1 = require("../core/ApiErrorCodes");
class KeyValueDb {
    gateway;
    extKey;
    options;
    newlyCreated;
    dbId;
    encKey;
    keyEncKeyPromise;
    constructor(gateway, extKey, options, newlyCreated) {
        this.gateway = gateway;
        this.extKey = extKey;
        this.options = options;
        this.newlyCreated = newlyCreated;
        this.dbId = KeyValueDb.getDbId(this.extKey);
        this.encKey = KeyValueDb.getEncKey(this.extKey);
    }
    static getDbId(extKey) {
        return extKey.getPublicKey().toBase58DER();
    }
    static getEncKey(extKey) {
        return extKey.getPrivateKey().getPrivateEncKey();
    }
    async getHashedEncKeyFor(key) {
        const entryKey = await this.getEntryKey(key);
        return this.getHashedEncKeyForBufferKey(entryKey);
    }
    getHashedEncKeyForBufferKey(entryKey) {
        return privmx_crypto_1.service.sha256(Buffer.concat([entryKey, this.encKey]));
    }
    encryptValue(value, bufferKey) {
        return Promise.resolve().then(() => {
            if (!value) {
                throw new Error("Value cannot be empty");
            }
            if (!value.secured) {
                return Buffer.from(JSON.stringify(value));
            }
            return Promise.resolve().then(() => {
                return value.hashed ? this.getHashedEncKeyForBufferKey(bufferKey) : this.encKey;
            })
                .then(encKey => {
                const secured = Buffer.from(JSON.stringify(value.secured), "utf8");
                return this.encryptBuffer(secured, encKey);
            })
                .then(cipher => {
                const copy = JSON.parse(JSON.stringify(value));
                copy.secured = cipher.toString("base64");
                return Buffer.from(JSON.stringify(copy), "utf8");
            });
        });
    }
    decryptValue(value, bufferKey) {
        return Promise.resolve().then(() => {
            const v = JSON.parse(value.toString("utf8"));
            if (!v.secured) {
                return v;
            }
            return Promise.resolve().then(() => {
                return v.hashed ? this.getHashedEncKeyForBufferKey(bufferKey) : this.encKey;
            })
                .then(encKey => {
                const cipher = Buffer.from(v.secured, "base64");
                return this.decryptBuffer(cipher, encKey);
            })
                .then(raw => {
                const secured = JSON.parse(raw.toString("utf8"));
                v.secured = secured;
                return v;
            });
        });
    }
    getKeyEncKey() {
        if (this.keyEncKeyPromise == null) {
            this.keyEncKeyPromise = privmx_crypto_1.service.sha256(Buffer.concat([
                this.encKey,
                Buffer.from("KeyValueDbKeyEncryptorSalt", "utf8")
            ]));
        }
        return this.keyEncKeyPromise;
    }
    async getEntryKey(key) {
        const keyEncKey = await this.getKeyEncKey();
        return privmx_crypto_1.service.hmacSha256(keyEncKey, Buffer.from(key, "utf8"));
    }
    encryptBuffer(buffer, encKey) {
        return privmx_crypto_1.service.aes256CbcHmac256Encrypt(buffer, encKey);
    }
    decryptBuffer(cipher, encKey) {
        return privmx_crypto_1.service.aes256CbcHmac256Decrypt(cipher, encKey);
    }
    async getAll(seq) {
        const result = await this.gwKvdbEntryGetAll(this.dbId, seq);
        return this.processFetchResult(result);
    }
    async processFetchResult(result) {
        const decrypted = { seq: result.seq, map: {} };
        for (const key in result.map) {
            const value = result.map[key];
            const entryKey = Buffer.from(key, "hex");
            const buf = await this.decryptValue(Buffer.from(value.toArrayBuffer()), entryKey);
            decrypted.map[key] = buf;
        }
        return decrypted;
    }
    get(key) {
        let entryKey;
        return Promise.resolve().then(() => {
            return this.getEntryKey(key);
        })
            .then(ek => {
            entryKey = ek;
            return this.gwKvdbEntryGet(this.dbId, entryKey);
        })
            .then(cipher => {
            return this.decryptValue(cipher, entryKey);
        });
    }
    opt(key, defaultData) {
        return Promise.resolve().then(() => {
            return this.get(key);
        })
            .catch(e => {
            if (!ApiErrorCodes_1.ApiErrorCodes.is(e, "KVDB_ENTRY_DOESNT_EXIST")) {
                return Promise.reject(e);
            }
            return defaultData;
        });
    }
    setBufferCore(entryKey, key, value, lock, useVersion) {
        return Promise.resolve().then(() => {
            if (!value.secured) {
                value.secured = {};
            }
            value.secured.key = key;
            return this.encryptValue(value, entryKey);
        })
            .then(entryValue => {
            return this.gwKvdbEntrySet(this.dbId, entryKey, entryValue, lock, useVersion ? value.version : null);
        })
            .then(res => {
            value.version = res.version;
            value.createDate = res.createDate;
            value.modifyDate = res.modifyDate;
        });
    }
    set(key, value, useVersion) {
        return Promise.resolve().then(() => {
            return this.getEntryKey(key);
        })
            .then(entryKey => {
            return this.setBufferCore(entryKey, key, value, null, useVersion);
        });
    }
    createSetData(key, value) {
        return Promise.resolve().then(() => {
            return this.getEntryKey(key);
        })
            .then(entryKey => {
            if (!value.secured) {
                value.secured = {};
            }
            value.secured.key = key;
            return this.encryptValue(value, entryKey).then(entryValue => {
                return {
                    dbId: this.dbId,
                    key: entryKey,
                    value: entryValue
                };
            });
        });
    }
    async withLock(key, func) {
        let lockId, locked = false, entryKey;
        try {
            entryKey = await this.getEntryKey(key);
            lockId = privmx_crypto_1.service.randomBytes(16).toString("hex");
            const content = await this.gwKvdbEntryLock(this.dbId, entryKey, lockId);
            locked = true;
            const newContent = content === false ? false : await this.decryptValue(content, entryKey);
            const res = await func(newContent, lockId, entryKey);
            if (res == null) {
                return;
            }
            await this.setBufferCore(entryKey, key, res, { id: lockId, release: true });
            locked = false;
        }
        finally {
            if (!locked) {
                return;
            }
            await this.gwKvdbEntryRelease(this.dbId, entryKey, lockId);
        }
        ;
    }
    gwKvdbEntryGetAll(dbId, seq) {
        return this.gateway.request("kvdbEntryGetAll", {
            dbId: dbId,
            seq: seq
        });
    }
    gwKvdbEntryGet(dbId, entryKey) {
        return this.gateway.request("kvdbEntryGet", {
            dbId: dbId,
            key: entryKey
        });
    }
    gwKvdbEntrySet(dbId, entryKey, entryValue, lock, version) {
        const params = {
            dbId: dbId,
            key: entryKey,
            value: entryValue
        };
        if (lock != null) {
            params.lock = lock;
        }
        if (version != null) {
            params.version = version;
        }
        return this.gateway.request("kvdbEntrySet", params);
    }
    gwKvdbEntryLock(dbId, entryKey, lockId) {
        return this.gateway.request("kvdbEntryLock", {
            dbId: dbId,
            key: entryKey,
            lockId: lockId
        });
    }
    gwKvdbEntryRelease(dbId, entryKey, lockId) {
        return this.gateway.request("kvdbEntryRelease", {
            dbId: dbId,
            key: entryKey,
            lockId: lockId
        });
    }
}
exports.KeyValueDb = KeyValueDb;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../core/ApiErrorCodes":138,"buffer":498,"privmx-crypto":265}],170:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyValueDbManager = void 0;
const KeyValueDb_1 = require("../db/KeyValueDb");
const privmx_crypto_1 = require("privmx-crypto");
const types_1 = require("../types");
const simplito_promise_1 = require("simplito-promise");
class KeyValueDbManager {
    client;
    constructor(client) {
        this.client = client;
    }
    getByExtKey(extKey) {
        return this.createByExtKeyWithMode(extKey, {}, types_1.db.OpenMode.FAIL_ON_NON_EXISTS);
    }
    createByExtKey(extKey, options) {
        return this.createByExtKeyWithMode(extKey, options, types_1.db.OpenMode.FAIL_ON_EXISTS);
    }
    getOrCreateByExtKey(extKey, options) {
        return this.createByExtKeyWithMode(extKey, options, types_1.db.OpenMode.CREATE_ON_NOT_EXISTS);
    }
    createByExtKeyWithMode(extKey, options, mode) {
        return Promise.resolve().then(() => {
            const dbId = KeyValueDb_1.KeyValueDb.getDbId(extKey);
            return this.gtwGetOrCreateKeyValueDb(dbId, options, mode).then(result => {
                return new KeyValueDb_1.KeyValueDb(this.client.gateway, extKey, result.options, result.created);
            });
        });
    }
    getByIndex(index) {
        return this.createByIndexWithMode(index, {}, types_1.db.OpenMode.FAIL_ON_NON_EXISTS);
    }
    createByIndex(index, options) {
        return this.createByIndexWithMode(index, options, types_1.db.OpenMode.FAIL_ON_EXISTS);
    }
    getOrCreateByIndex(index, options) {
        return this.createByIndexWithMode(index, options, types_1.db.OpenMode.CREATE_ON_NOT_EXISTS);
    }
    createByIndexWithMode(index, options, mode) {
        return Promise.resolve().then(() => {
            return this.client.deriveKey(index);
        })
            .then(extKey => {
            return this.createByExtKeyWithMode(extKey, options, mode);
        });
    }
    createRandom(options) {
        return this.createByExtKey(privmx_crypto_1.serviceSync.eccExtRandom(), options);
    }
    updateOptions(db, options) {
        return Promise.resolve().then(() => {
            return this.gtwModifyKeyValueDb(db.dbId, options);
        })
            .then(() => {
            db.options = options;
        });
    }
    pollCursors(cursors) {
        return this.pollCursorsCore(cursors, map => this.gtwPollKvdb(map));
    }
    waitCursors(cursors) {
        return this.pollCursorsCore(cursors, map => this.gtwWaitKvdb(map));
    }
    pollCursorsCore(cursors, func) {
        const cursorsMap = {};
        return Promise.resolve().then(() => {
            const map = {};
            cursors.forEach(x => {
                map[x.kvdb.dbId] = x.seq;
                cursorsMap[x.kvdb.dbId] = x;
            });
            return func(map);
        })
            .then(res => {
            const result = {};
            return simplito_promise_1.PromiseUtils.oneByOne(res, (dbId, x) => {
                const cursor = cursorsMap[dbId];
                if (!cursor) {
                    return null;
                }
                return cursor.kvdb.processFetchResult(x).then(y => {
                    result[dbId] = y;
                });
            }).then(() => result);
        });
    }
    gtwGetOrCreateKeyValueDb(id, options, mode) {
        return this.client.gateway.request("kvdbGetOrCreate", {
            id: id,
            mode: mode,
            options: options
        });
    }
    gtwModifyKeyValueDb(id, options) {
        return this.client.gateway.request("kvdbModify", {
            id: id,
            options: options
        });
    }
    gtwPollKvdb(cursors) {
        return this.client.gateway.request("kvdbPoll", {
            cursors: cursors
        });
    }
    gtwWaitKvdb(cursors) {
        return this.client.gateway.request("kvdbWait", {
            cursors: cursors
        }, { sendAlone: true });
    }
}
exports.KeyValueDbManager = KeyValueDbManager;

},{"../db/KeyValueDb":169,"../types":227,"privmx-crypto":265,"simplito-promise":421}],171:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyValueDbManager = exports.KeyValueDb = void 0;
const KeyValueDb_1 = require("./KeyValueDb");
Object.defineProperty(exports, "KeyValueDb", { enumerable: true, get: function () { return KeyValueDb_1.KeyValueDb; } });
const KeyValueDbManager_1 = require("./KeyValueDbManager");
Object.defineProperty(exports, "KeyValueDbManager", { enumerable: true, get: function () { return KeyValueDbManager_1.KeyValueDbManager; } });

},{"./KeyValueDb":169,"./KeyValueDbManager":170}],172:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivFsException = void 0;
const privmx_exception_1 = require("privmx-exception");
class PrivFsException extends privmx_exception_1.Exception {
    static codes = {
        INVALID_VERIFIER: { code: 0x1001, message: "Invalid verifier" },
        DIFFERENT_IDENTITY: { code: 0x1002, message: "Different identity" },
        INVALID_RESPONSE: { code: 0x1003, message: "Invalid response" },
        INVALID_USER_ENTRY_SIGNATURE: { code: 0x1004, message: "Invalid user entry signature" },
        NO_CALLBACK_FOR_ADDITIONAL_LOGIN_STEP: { code: 0x1005, message: "No callback for additional login step" },
        CANNOT_READ_BLOCK: { code: 0x2001, message: "Cannot read block" },
        CORRUPTED_BLOCK: { code: 0x2002, message: "Corrupted block, hash is invalid" },
        CANNOT_SEND_BLOCK: { code: 0x2003, message: "Cannot send block" },
        FILE_DOES_NOT_EXIST: { code: 0x3001, message: "File does not exists" },
        FILE_ALREADY_EXISTS: { code: 0x3002, message: "File already exists" },
        ELEMENT_IS_NOT_FILE: { code: 0x3003, message: "Element is not file" },
        DIRECTORY_DOES_NOT_EXIST: { code: 0x3004, message: "Directory does not exist" },
        DIRECTORY_ALREADY_EXISTS: { code: 0x3005, message: "Directory already exists" },
        ELEMENT_IS_NOT_DIRECTORY: { code: 0x3006, message: "Element is not directory" },
        DIRECTORY_IS_NOT_EMPTY: { code: 0x3007, message: "Directory is not empty" },
        CANNOT_OPEN_DIRECTORY: { code: 0x3008, message: "Cannot open directory" },
        ACCESS_DENIED_TO_FILE: { code: 0x3009, message: "Access denied to file" },
        NO_WRITE_RIGHTS: { code: 0x300A, message: "No write rights" },
        NO_READ_RIGHTS: { code: 0x300B, message: "No read rights" },
        INVALID_DESCRIPTOR_SIGNATURE: { code: 0x300C, message: "Invalid descriptor signature" },
        CANNOT_ASSIGN_RESULT_TO_PATH_PART: { code: 0x300D, message: "Cannot assign result to path part" },
        NAME_IN_USE: { code: 0x300E, message: "Name in use" }
    };
    errorName;
    errorObject;
    constructor(errorName, data, message, cause) {
        super(message || (errorName in PrivFsException.codes ? PrivFsException.codes[errorName].message : null), data, cause);
        this.errorName = errorName;
        this.errorObject = PrivFsException.codes[errorName];
    }
    static is(e, name) {
        return e instanceof PrivFsException && e.errorName == name;
    }
}
exports.PrivFsException = PrivFsException;

},{"privmx-exception":286}],173:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivFsException = void 0;
const PrivFsException_1 = require("./PrivFsException");
Object.defineProperty(exports, "PrivFsException", { enumerable: true, get: function () { return PrivFsException_1.PrivFsException; } });

},{"./PrivFsException":172}],174:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cache = exports.CachedDescriptor = exports.CacheRefreshMode = exports.SubResultMode = void 0;
const StorageProviderInterface_1 = require("../../core/StorageProviderInterface");
const privmx_exception_1 = require("privmx-exception");
const Descriptor_1 = require("./Descriptor");
const Result_1 = require("./Result");
const RootLogger = require("simplito-logger");
const simplito_promise_1 = require("simplito-promise");
const Logger = RootLogger.get("privfs-client.fs.descriptor.Cache");
var SubResultMode;
(function (SubResultMode) {
    SubResultMode[SubResultMode["NEW"] = 0] = "NEW";
    SubResultMode[SubResultMode["MODIFIED"] = 1] = "MODIFIED";
    SubResultMode[SubResultMode["NOT_MODIFIED"] = 2] = "NOT_MODIFIED";
})(SubResultMode = exports.SubResultMode || (exports.SubResultMode = {}));
var CacheRefreshMode;
(function (CacheRefreshMode) {
    CacheRefreshMode[CacheRefreshMode["NO_NEED"] = 0] = "NO_NEED";
    CacheRefreshMode[CacheRefreshMode["CHECK"] = 1] = "CHECK";
    CacheRefreshMode[CacheRefreshMode["GET"] = 2] = "GET";
})(CacheRefreshMode = exports.CacheRefreshMode || (exports.CacheRefreshMode = {}));
class CachedDescriptor {
    cache;
    descriptor;
    expires;
    defer;
    isNew;
    constructor(cache, descriptor, expires, defer, isNew) {
        this.cache = cache;
        this.descriptor = descriptor;
        this.expires = expires;
        this.defer = defer;
        this.isNew = isNew;
    }
    static createNew(cache, ref) {
        return new CachedDescriptor(cache, new Descriptor_1.Descriptor(ref, cache.storage, cache.manager), null, simplito_promise_1.PromiseUtils.defer(), true);
    }
    static createResolved(cache, createResult) {
        const descriptor = Descriptor_1.Descriptor.create(createResult, cache.storage, cache.manager);
        return new CachedDescriptor(cache, descriptor, new Date().getTime() + cache.expirationTime, null, false);
    }
    static createResolved2(cache, ref, data) {
        const descriptor = new Descriptor_1.Descriptor(ref, cache.storage, cache.manager);
        descriptor.enrichData(data);
        return new CachedDescriptor(cache, descriptor, new Date().getTime() + cache.expirationTime, null, false);
    }
    isResolving() {
        return this.defer != null;
    }
    isExpired() {
        return this.expires < new Date().getTime();
    }
    switchToResolving() {
        this.expires = null;
        this.defer = simplito_promise_1.PromiseUtils.defer();
    }
    attach(ref) {
        return this.defer.promise.then(x => {
            if (x.mode == SubResultMode.NEW) {
                return Result_1.Result.createNew(ref, x.descriptor);
            }
            if (x.mode == SubResultMode.MODIFIED) {
                return Result_1.Result.createModified(ref, x.descriptor);
            }
            if (x.mode == SubResultMode.NOT_MODIFIED) {
                return Result_1.Result.createNotModified(ref, x.descriptor);
            }
            throw new Error("Unknown descriptor mode " + x.mode);
        });
    }
    resolveByDataEx(data) {
        if (data == "NotModified") {
            this.resolve(SubResultMode.NOT_MODIFIED);
        }
        else {
            this.resolveByData(data);
        }
    }
    resolveByData(data) {
        this.descriptor.processServerData(data).then(() => {
            this.resolve(this.isNew ? SubResultMode.NEW : SubResultMode.MODIFIED);
        })
            .catch(e => {
            this.reject(e);
        });
    }
    resolve(mode) {
        if (!this.isResolving()) {
            return;
        }
        this.expires = new Date().getTime() + this.cache.expirationTime;
        this.defer.resolve({ mode: mode, descriptor: this.descriptor });
        this.finishResolve();
    }
    reject(e) {
        if (!this.isResolving()) {
            return;
        }
        this.defer.reject(e);
        this.finishResolve();
    }
    finishResolve() {
        this.defer = null;
        this.isNew = false;
    }
}
exports.CachedDescriptor = CachedDescriptor;
class Cache {
    storage;
    manager;
    expirationTime;
    cache;
    url;
    constructor(storage, manager, expirationTime, url) {
        if (!(storage instanceof StorageProviderInterface_1.StorageProviderInterface)) {
            throw new privmx_exception_1.IllegalArgumentException("storage", storage);
        }
        Object.defineProperty(this, "storage", {
            value: storage,
            enumerable: true
        });
        Object.defineProperty(this, "manager", {
            value: manager,
            enumerable: true
        });
        this.expirationTime = expirationTime;
        this.cache = {};
        this.url = url;
    }
    getEntries(refs) {
        const result = { mode: CacheRefreshMode.NO_NEED, dids: [], promises: [], map: {} };
        refs.forEach(ref => {
            let entry = this.cache[ref.did];
            if (entry) {
                if (entry.isResolving()) {
                    result.promises.push(entry.attach(ref));
                }
                else if (entry.isExpired()) {
                    entry.switchToResolving();
                    if (entry.descriptor.lastVersion) {
                        result.mode = CacheRefreshMode.CHECK;
                        result.dids.push({ did: ref.did, signature: entry.descriptor.lastVersion.raw.signature });
                    }
                    else {
                        result.mode = result.mode == CacheRefreshMode.NO_NEED ? CacheRefreshMode.GET : result.mode;
                        result.dids.push({ did: ref.did, signature: "" });
                    }
                    result.promises.push(entry.attach(ref));
                    result.map[ref.did] = entry;
                }
                else {
                    result.promises.push(Promise.resolve(Result_1.Result.createNotModified(ref, entry.descriptor)));
                }
            }
            else {
                this.cache[ref.did] = entry = CachedDescriptor.createNew(this, ref);
                result.mode = result.mode == CacheRefreshMode.NO_NEED ? CacheRefreshMode.GET : result.mode;
                result.promises.push(entry.attach(ref));
                result.dids.push({ did: ref.did, signature: "" });
                result.map[ref.did] = entry;
            }
        });
        return result;
    }
    createResolved(createResult) {
        if (this.cache[createResult.ref.did]) {
            Logger.warn("Descriptor already in cache " + createResult.ref.did);
            this.cache[createResult.ref.did].descriptor.enrichData2(createResult);
        }
        else {
            this.cache[createResult.ref.did] = CachedDescriptor.createResolved(this, createResult);
        }
        return this.cache[createResult.ref.did].descriptor;
    }
    createResolved2(ref, data) {
        if (!this.cache[ref.did]) {
            this.cache[ref.did] = CachedDescriptor.createResolved2(this, ref, data);
        }
        return this.cache[ref.did].descriptor.processServerData(data).then(() => {
            return this.cache[ref.did].descriptor;
        });
    }
    createResolved2WCS(ref, data, expired) {
        if (!this.cache[ref.did]) {
            this.cache[ref.did] = CachedDescriptor.createResolved2(this, ref, data);
        }
        this.cache[ref.did].descriptor.processServerDataWithoutCheckingSignature(data);
        if (expired) {
            this.cache[ref.did].expires = 0;
        }
        return this.cache[ref.did].descriptor;
    }
    createOrUpdateResolved(ref, data) {
        if (this.cache[ref.did]) {
            this.cache[ref.did].descriptor.enrichData(data);
        }
        else {
            this.cache[ref.did] = CachedDescriptor.createResolved2(this, ref, data);
        }
        return this.cache[ref.did].descriptor;
    }
    getDescriptor(did) {
        const entry = this.cache[did];
        return entry ? entry.descriptor : null;
    }
    has(did) {
        return did in this.cache;
    }
    remove(did) {
        delete this.cache[did];
    }
    clear() {
        this.cache = {};
    }
}
exports.Cache = Cache;

},{"../../core/StorageProviderInterface":160,"./Descriptor":175,"./Result":183,"privmx-exception":286,"simplito-logger":407,"simplito-promise":421}],175:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Descriptor = void 0;
const privmx_exception_1 = require("privmx-exception");
const privmx_crypto_1 = require("privmx-crypto");
const StorageProviderInterface_1 = require("../../core/StorageProviderInterface");
const Version_1 = require("./Version");
const Raw_1 = require("./Raw");
const ZPromise_1 = require("../../core/ZPromise");
const DescriptorRef_1 = require("./ref/DescriptorRef");
const Utils = require("simplito-utils");
class Descriptor {
    ref;
    storage;
    manager;
    event;
    lastVersion;
    isRich;
    pubKey;
    dpub58;
    creationDate;
    owner;
    acl;
    stickers;
    versioning;
    lastModDate;
    lastModifier;
    constructor(ref, storage, manager) {
        if (!(ref instanceof DescriptorRef_1.DescriptorRef)) {
            throw new privmx_exception_1.IllegalArgumentException("ref", ref);
        }
        if (!(storage instanceof StorageProviderInterface_1.StorageProviderInterface)) {
            throw new privmx_exception_1.IllegalArgumentException("storage", storage);
        }
        Object.defineProperty(this, "ref", {
            value: ref.asDescriptorRef(),
            enumerable: true
        });
        Object.defineProperty(this, "storage", {
            value: storage,
            enumerable: true
        });
        Object.defineProperty(this, "manager", {
            value: manager,
            enumerable: true
        });
        Object.defineProperty(this, "event", {
            value: new privmx_crypto_1.utils.Event(),
            enumerable: true
        });
    }
    setPubKey(pubKey) {
        if (!pubKey) {
            throw new Error("Invalid pubKey");
        }
        if (typeof (this.dpub58) != "undefined") {
            if (this.dpub58 != pubKey.toBase58DER()) {
                throw new Error("Given public key doesn't match");
            }
        }
        else {
            Object.defineProperty(this, "pubKey", {
                value: pubKey,
                enumerable: true
            });
            Utils.defineLazyReadOnlyProperty(this, "dpub58", () => {
                return this.pubKey.toBase58DER();
            });
        }
    }
    setDpub58(dpub58) {
        if (!dpub58) {
            throw new Error("Invalid dpub58");
        }
        if (typeof (this.dpub58) != "undefined") {
            if (this.dpub58 != dpub58) {
                throw new Error("Given public key doesn't match");
            }
        }
        else {
            Object.defineProperty(this, "dpub58", {
                value: dpub58,
                enumerable: true
            });
            Utils.defineLazyReadOnlyProperty(this, "pubKey", () => {
                return privmx_crypto_1.ecc.PublicKey.fromBase58DER(this.dpub58);
            });
        }
    }
    static create(createResult, storage, manager) {
        const result = new Descriptor(createResult.ref, storage, manager);
        result.enrichData2(createResult);
        return result;
    }
    enrichData(data) {
        this.setDpub58(data.dpub58);
        this.isRich = true;
        this.creationDate = data.creationDate ? new Date(parseInt(data.creationDate)) : null;
        this.owner = data.owner;
        this.acl = data.acl;
        this.stickers = data.stickers;
        this.versioning = data.versioning !== false;
        this.lastModDate = data.lastModDate;
        this.lastModifier = data.lastModifier;
    }
    enrichData2(createResult) {
        this.setPubKey(createResult.ref.pub);
        this.isRich = true;
        this.creationDate = createResult.creationDate;
        this.owner = createResult.owner;
        this.acl = createResult.acl;
        this.stickers = [];
        this.versioning = createResult.versioning !== false;
        this.lastModDate = createResult.lastModDate;
        this.lastModifier = createResult.lastModifier;
        this.createVersionAndSetAsLast(createResult.raw, createResult.extra);
    }
    processServerData(data) {
        return Promise.resolve().then(() => {
            this.enrichData(data);
            return this.deserializeVersionAndSetAsLast(data);
        });
    }
    processServerDataWithoutCheckingSignature(data) {
        this.enrichData(data);
        return this.deserializeVersionAndSetAsLastWithoutCheckingSignature(data);
    }
    createVersion(raw, extra) {
        return new Version_1.Version(this, raw, extra);
    }
    deserializeVersion(data) {
        return Promise.resolve().then(() => {
            if (!this.isRich) {
                throw new Error("Cannot deserialize version using not enriched descriptor");
            }
            return Raw_1.Raw.deserialize(this.pubKey, data);
        })
            .then(raw => {
            return this.createVersion(raw);
        });
    }
    deserializeVersionWithoutCheckingSignature(data) {
        if (!this.isRich) {
            throw new Error("Cannot deserialize version using not enriched descriptor");
        }
        const raw = Raw_1.Raw.deserializeWithoutCheckingSignature(data);
        return this.createVersion(raw);
    }
    setLast(version) {
        if (!this.isRich) {
            throw new Error("Cannot assign version to not enriched descriptor");
        }
        if (version.descriptor != this) {
            throw new privmx_exception_1.IllegalArgumentException("Given version doesn't match to this descriptor", version);
        }
        if (this.lastVersion && this.lastVersion.raw.signature == version.raw.signature) {
            return this.lastVersion;
        }
        this.lastVersion = version;
        setTimeout(() => {
            this.event.trigger("new-version", this, version);
            const event = { type: "descriptor-new-version", descriptor: this, version: version };
            this.storage.dispatchEvent(event);
        }, 1);
        return this.lastVersion;
    }
    createVersionAndSetAsLastAndAssignLastMod(lastModDate, lastModifier, raw, extra) {
        this.lastModDate = lastModDate;
        this.lastModifier = lastModifier;
        return this.createVersionAndSetAsLast(raw, extra);
    }
    createVersionAndSetAsLast(raw, extra) {
        return this.setLast(this.createVersion(raw, extra));
    }
    deserializeVersionAndSetAsLast(data) {
        return Promise.resolve().then(() => {
            if (this.lastVersion && this.lastVersion.raw.signature == data.signature) {
                return this.lastVersion;
            }
            return Promise.resolve().then(() => {
                return this.deserializeVersion(data);
            })
                .then(version => {
                return this.setLast(version);
            });
        });
    }
    deserializeVersionAndSetAsLastWithoutCheckingSignature(data) {
        const version = this.deserializeVersionWithoutCheckingSignature(data);
        return this.setLast(version);
    }
    assignNewLastModDate(lastModDate, lastModifier) {
        const changed = this.lastModDate != lastModDate;
        this.lastModDate = lastModDate;
        this.lastModifier = lastModifier;
        if (!changed || !this.lastVersion) {
            return;
        }
        setTimeout(() => {
            const event = { type: "descriptor-new-version", descriptor: this, version: this.lastVersion };
            this.storage.dispatchEvent(event);
        }, 1);
    }
    refresh() {
        return Promise.resolve().then(() => {
            return this.storage.descriptorCheck([{
                    did: this.ref.did,
                    signature: this.lastVersion.raw.signature
                }]);
        })
            .then(descriptorData => {
            const data = descriptorData[this.ref.did];
            if (data == "NotModified") {
                return false;
            }
            return this.processServerData(data).then(() => true);
        });
    }
    setVersioning(versioning) {
        return Promise.resolve().then(() => {
            return this.storage.descriptorModifyVersioning(this.ref.did, versioning);
        })
            .then(() => {
            this.versioning = versioning;
        });
    }
    setAclZ(acl) {
        return Promise.resolve().then(() => {
            return ZPromise_1.ZPromise.create(storage => {
                return storage.descriptorModifyAcl(this.ref.did, acl);
            })
                .next(() => {
                this.acl = acl;
            });
        });
    }
    setAcl(acl) {
        return this.storage.performDeferredAction(this.setAclZ(acl));
    }
    setStickersZ(stickers, replace) {
        return Promise.resolve().then(() => {
            return ZPromise_1.ZPromise.create(storage => {
                return storage.descriptorSetStickers(this.ref.did, stickers, replace);
            })
                .next(newStickers => {
                this.stickers = newStickers;
            });
        });
    }
    setStickers(stickers, replace) {
        return this.storage.performDeferredAction(this.setStickersZ(stickers, replace));
    }
    getLastVersionCachedMeta() {
        return this.lastVersion && this.lastVersion.extra ? this.lastVersion.extra.meta : null;
    }
}
exports.Descriptor = Descriptor;

},{"../../core/StorageProviderInterface":160,"../../core/ZPromise":164,"./Raw":182,"./Version":185,"./ref/DescriptorRef":187,"privmx-crypto":265,"privmx-exception":286,"simplito-utils":422}],176:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DescriptorMultiGet = void 0;
const ZPromise_1 = require("../../core/ZPromise");
class DescriptorMultiGet extends ZPromise_1.ZPromiseExecutor {
    manager;
    constructor(manager) {
        super();
        this.manager = manager;
    }
    getService() {
        return this;
    }
    flush() {
        const ops = this.ops;
        this.ops = [];
        if (ops.length == 0) {
            return Promise.resolve();
        }
        return this.manager.getDescriptorsCore(ops.map(x => x.data)).then(result => {
            ops.forEach((o, i) => {
                if (result[i] == null) {
                    o.deferred.reject("OPERATION_NOT_PERFORMED");
                }
                result[i].then(o.deferred.resolve).catch(o.deferred.reject);
            });
        })
            .catch(e => {
            ops.forEach(o => {
                o.deferred.reject(e);
            });
        });
    }
    getDescriptor(ref) {
        return this.addOp(ref);
    }
    getHandle(ref) {
        return this.addOp(ref).then((result) => result.createHandle());
    }
}
exports.DescriptorMultiGet = DescriptorMultiGet;

},{"../../core/ZPromise":164}],177:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DescriptorMultiStorageProvider = void 0;
const ZPromise_1 = require("../../core/ZPromise");
class DescriptorMultiStorageProvider extends ZPromise_1.ZPromiseExecutor {
    storageProvider;
    mode;
    constructor(storageProvider, mode) {
        super();
        this.storageProvider = storageProvider;
        this.mode = mode;
    }
    getService() {
        return this;
    }
    flush() {
        const ops = this.ops;
        this.ops = [];
        if (ops.length == 0) {
            return Promise.resolve();
        }
        if (ops.length == 1) {
            return this.storageProvider.request(ops[0].data.method, ops[0].data.params).then(result => {
                ops[0].deferred.resolve(result);
            })
                .catch(e => {
                ops[0].deferred.reject(e);
            });
        }
        return this.storageProvider.descriptorMulti(this.mode, ops.map(x => {
            return {
                method: x.data.method,
                params: x.data.params
            };
        }))
            .then(result => {
            ops.forEach((o, i) => {
                if (result[i] == null) {
                    o.deferred.reject("OPERATION_NOT_PERFORMED");
                }
                else if (result[i].success) {
                    o.deferred.resolve(result[i].data);
                }
                else {
                    o.deferred.reject(result[i].error);
                }
            });
        })
            .catch(e => {
            ops.forEach(o => {
                o.deferred.reject(e);
            });
        });
    }
    descriptorDelete(did, signature, descriptorSignature, lockId) {
        const params = {
            did: did,
            signature: signature,
            lockId: lockId
        };
        if (descriptorSignature != null) {
            params.descriptorSignature = descriptorSignature;
        }
        return this.addOp({ method: "descriptorDelete", params: params });
    }
    descriptorUpdate(did, data, transfer, signature, lockId, releaseLock) {
        return this.addOp({ method: "descriptorUpdate", params: this.storageProvider.prepareTransferParam({
                did: did,
                data: data,
                signature: signature,
                lockId: lockId,
                releaseLock: releaseLock
            }, transfer) });
    }
    descriptorCreate(did, data, transfer, acl, versioning, lock) {
        let params = {
            did: did,
            data: data
        };
        if (acl != null) {
            params.acl = acl;
        }
        if (versioning != null) {
            params.versioning = versioning;
        }
        if (lock != null) {
            params.lock = lock;
        }
        params = this.storageProvider.prepareTransferParam(params, transfer);
        return this.addOp({ method: "descriptorCreate", params: params });
    }
    descriptorModifyAcl(did, acl) {
        return this.addOp({ method: "descriptorModifyAcl", params: {
                did: did,
                acl: acl
            } });
    }
    descriptorModifyVersioning(did, versioning) {
        return this.addOp({ method: "descriptorModifyVersioning", params: {
                did: did,
                versioning: versioning
            } });
    }
    descriptorSetStickers(did, stickers, replace) {
        return this.addOp({ method: "descriptorSetStickers", params: {
                did: did,
                stickers: stickers,
                replace: replace
            } });
    }
    descriptorMarkAsUpdated(did) {
        return this.addOp({ method: "descriptorMarkAsUpdated", params: {
                did: did
            } });
    }
}
exports.DescriptorMultiStorageProvider = DescriptorMultiStorageProvider;

},{"../../core/ZPromise":164}],178:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Extra = void 0;
const privmx_crypto_1 = require("privmx-crypto");
class Extra {
    key;
    writeKey;
    meta;
    decryptedWriteKey;
    constructor(key, writeKey, meta) {
        this.key = key;
        this.writeKey = writeKey;
        this.meta = meta;
    }
    getDecryptedWriteKey(key) {
        return Promise.resolve().then(() => {
            if (!this.writeKey) {
                return null;
            }
            if (this.decryptedWriteKey) {
                return this.decryptedWriteKey;
            }
            return Promise.resolve().then(() => {
                return Extra.decryptWriteKey(this.writeKey, key);
            })
                .then(decryptedWriteKey => {
                return this.decryptedWriteKey = decryptedWriteKey;
            });
        });
    }
    getDecryptedWriteKeyOrDefault(key, defaultKey) {
        return Promise.resolve().then(() => {
            return this.getDecryptedWriteKey(key);
        })
            .then(decryptedWriteKey => {
            return decryptedWriteKey || defaultKey;
        });
    }
    getDecryptedWriteKeyOrGivenOne(key) {
        return this.getDecryptedWriteKeyOrDefault(key, key);
    }
    serialize() {
        return {
            meta: this.meta,
            key: this.key.toString("base64"),
            writeKey: this.writeKey ? this.writeKey.toString("base64") : null
        };
    }
    static deserialize(extra) {
        return new Extra(Buffer.from(extra.key, "base64"), extra.writeKey ? Buffer.from(extra.writeKey, "base64") : null, extra.meta);
    }
    static encode(encKey, extra) {
        return privmx_crypto_1.service.generateIv(encKey, 0)
            .then(iv => {
            const buffer = Buffer.from(JSON.stringify(extra), "utf8");
            return privmx_crypto_1.service.privmxEncrypt(privmx_crypto_1.service.privmxOptAesWithDetachedIv(), buffer, encKey, iv);
        });
    }
    static decode(encKey, extra) {
        return privmx_crypto_1.service.generateIv(encKey, 0)
            .then(iv => {
            return privmx_crypto_1.service.privmxDecrypt(extra, encKey, iv)
                .then(buffer => {
                return JSON.parse(buffer.toString("utf8"));
            });
        });
    }
    serializeAndEncode(encKey) {
        return Extra.encode(encKey, this.serialize());
    }
    static decodeAndDeserialize(encKey, extra) {
        return Extra.decode(encKey, extra).then(Extra.deserialize);
    }
    static encryptWriteKey(writeKey, key) {
        return Promise.resolve().then(() => {
            return privmx_crypto_1.service.generateIv(key, 0);
        })
            .then(iv => {
            return privmx_crypto_1.service.privmxEncrypt(privmx_crypto_1.service.privmxOptAesWithDetachedIv(), writeKey, key, iv);
        });
    }
    static decryptWriteKey(writeKey, key) {
        return Promise.resolve().then(() => {
            return privmx_crypto_1.service.generateIv(key, 0);
        })
            .then(iv => {
            return privmx_crypto_1.service.privmxDecrypt(writeKey, key, iv);
        });
    }
}
exports.Extra = Extra;

}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":498,"privmx-crypto":265}],179:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Handle = void 0;
const privmx_exception_1 = require("privmx-exception");
const Descriptor_1 = require("./Descriptor");
const DescriptorRef_1 = require("./ref/DescriptorRef");
const Streamer_1 = require("./Streamer");
const PrivFsException_1 = require("../../exception/PrivFsException");
class Handle {
    ref;
    descriptor;
    canRead;
    canWrite;
    currentVersion;
    lockObj;
    created;
    constructor(ref, descriptor, version, canRead, canWrite) {
        if (!(ref instanceof DescriptorRef_1.DescriptorRef)) {
            throw new privmx_exception_1.IllegalArgumentException("ref", ref);
        }
        if (!(descriptor instanceof Descriptor_1.Descriptor)) {
            throw new privmx_exception_1.IllegalArgumentException("descriptor", descriptor);
        }
        if (ref.id != descriptor.ref.id) {
            throw new privmx_exception_1.IllegalArgumentException("Given ref doesn't match to descriptor", {
                ref: ref,
                descriptor: descriptor
            });
        }
        if (typeof (canRead) != "undefined") {
            if (typeof (canRead) != "boolean" || (canRead && !ref.hasReadRights())) {
                throw new privmx_exception_1.IllegalArgumentException("canRead", canRead);
            }
            Object.defineProperty(this, "canRead", {
                value: canRead,
                enumerable: true
            });
        }
        else {
            Object.defineProperty(this, "canRead", {
                value: ref.hasReadRights(),
                enumerable: true
            });
        }
        if (typeof (canWrite) != "undefined") {
            if (typeof (canWrite) != "boolean" || (canWrite && !ref.hasWriteRights())) {
                throw new privmx_exception_1.IllegalArgumentException("canWrite", canWrite);
            }
            Object.defineProperty(this, "canWrite", {
                value: canWrite,
                enumerable: true
            });
        }
        else {
            Object.defineProperty(this, "canWrite", {
                value: ref.hasWriteRights(),
                enumerable: true
            });
        }
        Object.defineProperty(this, "ref", {
            value: ref,
            enumerable: true
        });
        Object.defineProperty(this, "descriptor", {
            value: descriptor,
            enumerable: true
        });
        if (version && version.descriptor != descriptor) {
            throw new Error("Given version doesn't match to given descriptor");
        }
        this.currentVersion = version || this.descriptor.lastVersion;
    }
    creatCopyWithLastVersion() {
        const handle = new Handle(this.ref, this.descriptor, this.descriptor.lastVersion, this.canRead, this.canWrite);
        handle.created = this.created;
        return handle;
    }
    creatHandleCopy() {
        const handle = new Handle(this.ref, this.descriptor, this.currentVersion, this.canRead, this.canWrite);
        handle.created = this.created;
        return handle;
    }
    createWithRights(canRead, canWrite) {
        const handle = new Handle(this.ref, this.descriptor, this.currentVersion, canRead, canWrite);
        handle.created = this.created;
        handle.lockObj = this.lockObj;
        return handle;
    }
    checkReadRight() {
        return Promise.resolve().then(() => {
            if (!this.canRead) {
                throw new PrivFsException_1.PrivFsException("NO_READ_RIGHTS");
            }
        });
    }
    checkWriteRight() {
        return Promise.resolve().then(() => {
            if (!this.canWrite) {
                throw new PrivFsException_1.PrivFsException("NO_WRITE_RIGHTS");
            }
        });
    }
    getMeta() {
        return Promise.resolve().then(() => {
            return this.checkReadRight();
        })
            .then(() => {
            return this.currentVersion.getExtra(this.ref.readKey);
        })
            .then(extra => {
            return extra.meta;
        });
    }
    read(options) {
        return Promise.resolve().then(() => {
            return this.checkReadRight();
        })
            .then(() => {
            return this.currentVersion.getContent(this.ref.readKey, options);
        });
    }
    writeZ(data, options) {
        return Promise.resolve().then(() => {
            return this.checkWriteRight();
        })
            .then(() => {
            if (this.lockObj) {
                options = options || {};
                options.lockId = this.lockObj.id;
            }
            return Streamer_1.Streamer.update(this, data, options);
        })
            .then(z => {
            return z.next(result => {
                if (options != null && options.releaseLock) {
                    this.lockObj = null;
                }
                if (options == null || options.updateCurrentVersion !== false) {
                    this.currentVersion = result.version;
                }
                return result;
            });
        });
    }
    write(data, options) {
        return this.descriptor.storage.performDeferredAction(this.writeZ(data, options));
    }
    updateMetaZ(options) {
        return Promise.resolve().then(() => {
            return this.checkWriteRight();
        })
            .then(() => {
            if (this.lockObj) {
                options = options || {};
                options.lockId = this.lockObj.id;
            }
            return Streamer_1.Streamer.updateMeta(this, options);
        })
            .then(zPromise => {
            return zPromise.next(result => {
                if (result == null) {
                    return null;
                }
                if (options != null && options.releaseLock) {
                    this.lockObj = null;
                }
                if (options == null || options.updateCurrentVersion !== false) {
                    this.currentVersion = result.version;
                }
                return result;
            });
        });
    }
    updateMeta(options) {
        return this.descriptor.storage.performDeferredAction(this.updateMetaZ(options));
    }
    lock(force, updateCurrentVersion) {
        return Promise.resolve().then(() => {
            return this.checkWriteRight();
        })
            .then(() => {
            return Promise.resolve().then(() => {
                return this.descriptor.manager.lock(this.ref, this.lockObj, force);
            })
                .then(res => {
                this.lockObj = res.lock;
                if (updateCurrentVersion !== false) {
                    this.currentVersion = res.version;
                }
            });
        });
    }
    release() {
        return Promise.resolve().then(() => {
            if (this.lockObj == null) {
                return null;
            }
            return Promise.resolve().then(() => {
                return this.descriptor.manager.releaseLock(this.ref, this.lockObj);
            })
                .then(() => {
                delete this.lockObj;
            });
        });
    }
    addOnChangeCallback(callback) {
        this.descriptor.event.add(callback);
    }
    removeOnChangeCallback(callback) {
        this.descriptor.event.remove(callback);
    }
    isModified() {
        return this.currentVersion != this.descriptor.lastVersion;
    }
    isModifiedRemote() {
        return Promise.resolve().then(() => {
            return this.refresh();
        })
            .then(() => {
            return this.isModified();
        });
    }
    updateToLastVersion() {
        const oldVersion = this.currentVersion;
        this.currentVersion = this.descriptor.lastVersion;
        return oldVersion;
    }
    refresh() {
        return this.descriptor.refresh();
    }
    refreshAndUpdateToLastVersion() {
        return Promise.resolve().then(() => {
            return this.refresh();
        })
            .then(res => {
            this.updateToLastVersion();
            return res;
        });
    }
    getBlocksInfo(cache) {
        return this.currentVersion.getBlocksInfo(this.ref.readKey, cache);
    }
    setVersioning(versioning) {
        return Promise.resolve().then(() => {
            return this.descriptor.setVersioning(versioning);
        });
    }
    setAcl(acl) {
        return Promise.resolve().then(() => {
            return this.descriptor.setAcl(acl);
        });
    }
    createCopyWithVersions(manager, url, options) {
        return Promise.resolve().then(() => {
            return this.checkReadRight();
        })
            .then(() => {
            return manager.getDescriptorVersions(this.ref);
        })
            .then(result => {
            return manager.createFromCopy(url, result, this.ref.readKey, this.ref.writeKey, options);
        });
    }
    getVersionsHistory() {
        return Promise.resolve().then(() => {
            return this.checkReadRight();
        })
            .then(() => {
            return this.descriptor.manager.getDescriptorVersions(this.ref);
        });
    }
    getLockHistory() {
        return Promise.resolve().then(() => {
            return this.checkReadRight();
        })
            .then(() => {
            return this.descriptor.manager.getDescriptorLockHistory(this.ref);
        });
    }
    isLocked() {
        return Promise.resolve().then(() => {
            return this.getLockedInfo();
        })
            .then(info => {
            return info != null;
        });
    }
    getLockedInfo() {
        return this.descriptor.manager.getLockedInfo(this.ref);
    }
    forcedLockRelease() {
        return Promise.resolve().then(() => {
            return this.descriptor.manager.forcedLockRelease(this.ref);
        })
            .then(() => {
            delete this.lockObj;
        });
    }
    getWriteKeyEx() {
        if (!this.canWrite) {
            return null;
        }
        return Promise.resolve().then(() => {
            return this.currentVersion.getExtra(this.ref.readKey);
        })
            .then(extra => {
            return extra.getDecryptedWriteKeyOrGivenOne(this.ref.writeKey);
        });
    }
    getCurrentVersionSnapshot() {
        const version = this.currentVersion;
        return Promise.resolve().then(() => {
            return this.checkWriteRight();
        })
            .then(() => {
            return version.getExtra(this.ref.readKey);
        })
            .then(extra => {
            const result = {
                ref: this.ref,
                handle: this,
                version: version,
                blocksInfo: version.getBlocksInfoFromExtra(extra),
                extra: extra,
                meta: extra.meta
            };
            return result;
        });
    }
}
exports.Handle = Handle;

},{"../../exception/PrivFsException":172,"./Descriptor":175,"./Streamer":184,"./ref/DescriptorRef":187,"privmx-exception":286}],180:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lock = void 0;
const privmx_exception_1 = require("privmx-exception");
const Identity_1 = require("../../identity/Identity");
const privmx_crypto_1 = require("privmx-crypto");
class Lock {
    id;
    did;
    identity;
    lockData;
    releaseData;
    serverDate;
    lockSignature;
    lockerSignature;
    releaseSignature;
    constructor() {
    }
    isActive() {
        return this.serverDate != null;
    }
    static create(did, priv, identity) {
        const lock = new Lock();
        return Promise.resolve().then(() => {
            if (typeof (did) != "string") {
                throw new privmx_exception_1.IllegalArgumentException("did", did);
            }
            if (!(priv instanceof privmx_crypto_1.ecc.PrivateKey)) {
                throw new privmx_exception_1.IllegalArgumentException("priv", priv);
            }
            if (!(identity instanceof Identity_1.Identity)) {
                throw new privmx_exception_1.IllegalArgumentException("identity", identity);
            }
            lock.id = privmx_crypto_1.service.randomBytes(16).toString("hex");
            lock.did = did;
            lock.identity = identity;
            lock.lockData = Buffer.from("lock" + lock.did + lock.id + lock.identity.pub58, "utf8");
            lock.releaseData = Buffer.from("release" + lock.did + lock.id, "utf8");
        })
            .then(() => {
            return privmx_crypto_1.service.signToCompactSignatureWithHash(priv, lock.lockData);
        })
            .then(signature => {
            lock.lockSignature = signature.toString("base64");
        })
            .then(() => {
            return privmx_crypto_1.service.signToCompactSignatureWithHash(identity.priv, lock.lockData);
        })
            .then(signature => {
            lock.lockerSignature = signature.toString("base64");
        })
            .then(() => {
            return privmx_crypto_1.service.signToCompactSignatureWithHash(priv, lock.releaseData);
        })
            .then(signature => {
            lock.releaseSignature = signature.toString("base64");
        })
            .then(() => lock);
    }
}
exports.Lock = Lock;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../../identity/Identity":211,"buffer":498,"privmx-crypto":265,"privmx-exception":286}],181:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Manager = void 0;
const privmx_exception_1 = require("privmx-exception");
const privmx_crypto_1 = require("privmx-crypto");
const Cache_1 = require("./Cache");
const DescriptorRef_1 = require("./ref/DescriptorRef");
const DescriptorRefWrite_1 = require("./ref/DescriptorRefWrite");
const Streamer_1 = require("./Streamer");
const Handle_1 = require("./Handle");
const StorageProviderManager_1 = require("../../core/StorageProviderManager");
const Identity_1 = require("../../identity/Identity");
const ZPromise_1 = require("../../core/ZPromise");
const Lock_1 = require("./Lock");
const simplito_net_1 = require("simplito-net");
const RootLogger = require("simplito-logger");
const Entries_1 = require("../file/entry/Entries");
const Logger = RootLogger.get("privfs-client.fs.descriptor.Manager");
class Manager {
    storageProviderManager;
    identity;
    caches;
    cacheExpirationTime;
    descriptorStorage;
    blocksStorage;
    constructor(storageProviderManager, identity) {
        if (!(storageProviderManager instanceof StorageProviderManager_1.StorageProviderManager)) {
            throw new privmx_exception_1.IllegalArgumentException("storageProviderManager", storageProviderManager);
        }
        if (!(identity instanceof Identity_1.Identity)) {
            throw new privmx_exception_1.IllegalArgumentException("identity", identity);
        }
        Object.defineProperty(this, "storageProviderManager", {
            value: storageProviderManager,
            enumerable: true
        });
        Object.defineProperty(this, "identity", {
            value: identity,
            enumerable: true
        });
        Object.defineProperty(this, "caches", {
            value: {},
            enumerable: true
        });
        this.cacheExpirationTime = 100;
    }
    performDeferredAction(promise) {
        return promise.then(z => z.run(this));
    }
    getDescriptorFromCache(ref) {
        const cache = this.getCreateCache(ref.url);
        return cache ? cache.getDescriptor(ref.did) : null;
    }
    getMetaFromCache(ref) {
        const descriptor = this.getDescriptorFromCache(ref);
        return descriptor ? descriptor.getLastVersionCachedMeta() : null;
    }
    getHandleFromCache(ref) {
        return Promise.resolve().then(() => {
            return this.getCache(ref.url);
        })
            .then(cache => {
            const descriptor = cache.getDescriptor(ref.did);
            return descriptor ? new Handle_1.Handle(ref, descriptor) : this.getHandle(ref);
        });
    }
    getHandle(ref, includeBlocks) {
        return this.getDescriptor(ref, includeBlocks)
            .then(result => {
            return result.createHandle();
        });
    }
    getDescriptor(ref, includeBlocks) {
        return this.getDescriptors([ref], includeBlocks)
            .then(results => {
            return results[0];
        });
    }
    getDescriptors(refs, includeBlocks) {
        return this.getDescriptorsCore(refs, includeBlocks).then(results => Promise.all(results));
    }
    getDescriptorsFulfilled(refs, includeBlocks) {
        return Promise.resolve().then(() => {
            return this.getDescriptorsCore(refs, includeBlocks);
        })
            .then(results => {
            return Promise.allSettled(results);
        })
            .then(results => {
            return results.filter(x => x.status == "fulfilled").map(x => x.value);
        });
    }
    getDescriptorsCore(refs, includeBlocks) {
        if (refs.length == 0) {
            return Promise.resolve([]);
        }
        let url;
        return Promise.resolve().then(() => {
            if (!Array.isArray(refs) || refs.length == 0 || !(refs[0] instanceof DescriptorRef_1.DescriptorRef)) {
                throw new privmx_exception_1.IllegalArgumentException("refs", refs);
            }
            url = this.resolveUrl(refs[0].url);
            refs.forEach((ref, i) => {
                if (!(ref instanceof DescriptorRef_1.DescriptorRef)) {
                    throw new privmx_exception_1.IllegalArgumentException("Invalid ref at index " + i, refs);
                }
                if (this.resolveUrl(ref.url) != url) {
                    throw new privmx_exception_1.IllegalArgumentException("Cannot make bulk request with refs which have different urls", refs);
                }
            });
            return this.getCache(url);
        })
            .then(cache => {
            return this.loadCached(refs, cache);
        })
            .then(cache => {
            const summary = cache.getEntries(refs);
            if (summary.mode == Cache_1.CacheRefreshMode.GET) {
                cache.storage.descriptorGet(summary.dids.map(x => x.did), includeBlocks).then(descriptorData => {
                    for (const did in descriptorData) {
                        const data = descriptorData[did];
                        if (data.error) {
                            summary.map[did].reject(new simplito_net_1.JsonRpcException(data.error, null));
                        }
                        else {
                            this.saveCached(DescriptorRef_1.DescriptorRef.getId(url, did), data);
                            summary.map[did].resolveByData(data);
                        }
                    }
                })
                    .catch(e => {
                    summary.dids.forEach(x => {
                        summary.map[x.did].reject(e);
                    });
                });
            }
            else if (summary.mode == Cache_1.CacheRefreshMode.CHECK) {
                cache.storage.descriptorCheck(summary.dids, includeBlocks).then(descriptorData => {
                    for (const did in descriptorData) {
                        const data = descriptorData[did];
                        if (data.error) {
                            summary.map[did].reject(new simplito_net_1.JsonRpcException(data.error, null));
                        }
                        else {
                            if (data != "NotModified") {
                                this.saveCached(DescriptorRef_1.DescriptorRef.getId(url, did), data);
                            }
                            summary.map[did].resolveByDataEx(data);
                        }
                    }
                })
                    .catch(e => {
                    summary.dids.forEach(x => {
                        summary.map[x.did].reject(e);
                    });
                });
            }
            return summary.promises;
        });
    }
    getLockedInfo(ref) {
        return Promise.resolve().then(() => {
            return this.getDescriptorCore(ref);
        })
            .then(descriptor => {
            return descriptor.lock;
        });
    }
    getDescriptorCore(ref) {
        let cache;
        return Promise.resolve().then(() => {
            return this.getCache(ref.url);
        })
            .then(c => {
            cache = c;
            return cache.storage.descriptorGet([ref.did]);
        })
            .then(res => {
            const raw = res[ref.did];
            return cache.createResolved2(ref, raw).then(() => raw);
        });
    }
    getDescriptorVersions(ref) {
        let cache;
        let result;
        return Promise.resolve().then(() => {
            return this.getCache(ref.url);
        })
            .then(c => {
            cache = c;
            return cache.storage.descriptorGetVersions(ref.did);
        })
            .then(raw => {
            const descriptor = cache.createOrUpdateResolved(ref, raw);
            result = {
                raw: raw,
                descriptor: descriptor,
                versions: []
            };
            return Promise.all(raw.versions.map(version => {
                return descriptor.deserializeVersion(version);
            }));
        })
            .then(versions => {
            result.versions = versions;
            return result;
        });
    }
    getDescriptorLockHistory(ref) {
        return Promise.resolve().then(() => {
            return this.getCache(ref.url);
        })
            .then(cache => {
            return cache.storage.descriptorGetLockHistory(ref.did);
        });
    }
    getLockedDescriptor(url) {
        return Promise.resolve().then(() => {
            return this.getCache(url);
        })
            .then(cache => {
            return cache.storage.descriptorGetLocked();
        });
    }
    forcedLockRelease(ref) {
        return Promise.resolve().then(() => {
            return this.getCache(ref.url);
        })
            .then(cache => {
            return cache.storage.descriptorRelease2(ref.did);
        });
    }
    generateRef(url) {
        return Promise.resolve().then(() => {
            return DescriptorRefWrite_1.DescriptorRefWrite.generate(this.resolveUrl(url));
        });
    }
    createFromDescriptorWithVersions(ref, url, options) {
        return Promise.resolve().then(() => {
            return this.getDescriptorVersions(ref);
        })
            .then(result => {
            return this.createFromCopy(url, result, ref.readKey, ref.writeKey, options);
        });
    }
    createFromCopy(url, org, orgEncKey, orgWriteKey, options) {
        return Promise.resolve().then(() => {
            return this.generateRef(url);
        })
            .then(ref => {
            return this.createFromCopyUnderRef(ref, org, orgEncKey, orgWriteKey, options);
        });
    }
    createFromCopyUnderRef(ref, org, orgEncKey, orgWriteKey, options) {
        let cache;
        return Promise.resolve().then(() => {
            return this.getCache(ref.url);
        })
            .then(c => {
            cache = c;
            return Streamer_1.Streamer.copy(ref, cache.storage, org, orgEncKey, orgWriteKey, options);
        })
            .then(result => {
            return this.getVersionSnapshot(cache, result, true);
        });
    }
    performWithCache(url, promise) {
        return Promise.resolve().then(() => {
            return this.getCache(url);
        })
            .then(cache => {
            return cache.storage.performDeferredAction(promise);
        });
    }
    create(url, content, type, lock, options) {
        return this.performWithCache(url, this.createZ(url, content, type, lock, options));
    }
    createUnderRef(ref, content, type, lock, options) {
        return this.performWithCache(ref.url, this.createUnderRefZ(ref, content, type, lock, options));
    }
    createZ(url, content, type, lock, options) {
        return Promise.resolve().then(() => {
            return this.generateRef(url);
        })
            .then(ref => {
            return this.createUnderRefZ(ref, content, type, lock, options);
        });
    }
    createUnderRefZ(ref, content, type, lock, options) {
        let cache;
        return Promise.resolve().then(() => {
            return this.getCache(ref.url);
        })
            .then(c => {
            cache = c;
            return Streamer_1.Streamer.create(ref, cache.storage, content, type, lock ? this.identity : null, options);
        })
            .then(z => {
            return z.next(result => {
                return this.getVersionSnapshot(cache, result, true);
            });
        });
    }
    getVersionSnapshot(cache, result, created) {
        const handle = new Handle_1.Handle(result.ref, cache.createResolved(result));
        handle.created = created;
        handle.lockObj = result.lock;
        return {
            ref: result.ref,
            handle: handle,
            version: handle.currentVersion,
            blocksInfo: handle.currentVersion.getBlocksInfoFromExtra(result.extra),
            extra: result.extra,
            meta: result.extra.meta
        };
    }
    removeByRef(ref, oldSignature, lockId) {
        return this.performWithCache(ref.url, this.removeByRefZ(ref, oldSignature, lockId));
    }
    removeByRefZ(ref, oldSignature, lockId) {
        let cache;
        return Promise.resolve().then(() => {
            return this.getCache(ref.url);
        })
            .then(c => {
            cache = c;
            const version = Buffer.from("delete" + ref.did, "utf8");
            return privmx_crypto_1.service.signToCompactSignatureWithHash(ref.priv, version);
        })
            .then(signature => {
            return ZPromise_1.ZPromise.create(storage => {
                return storage.descriptorDelete(ref.did, signature.toString("base64"), oldSignature, lockId || "");
            })
                .next(() => {
                cache.remove(ref.did);
            });
        });
    }
    resolveUrl(url) {
        return url || this.identity.host;
    }
    getProvider(url) {
        return this.storageProviderManager.getProvider(this.resolveUrl(url));
    }
    getCreateCache(url) {
        return this.caches[this.resolveUrl(url)];
    }
    getCache(url) {
        return Promise.resolve().then(() => {
            url = this.resolveUrl(url);
            if (url in this.caches) {
                return this.caches[url];
            }
            return Promise.resolve().then(() => {
                return this.getProvider(url);
            })
                .then(storage => {
                return this.caches[url] = new Cache_1.Cache(storage, this, this.cacheExpirationTime, url);
            });
        });
    }
    setCacheExpirationTime(cacheExpirationTime) {
        this.cacheExpirationTime = cacheExpirationTime;
        for (const url in this.caches) {
            this.caches[url].expirationTime = cacheExpirationTime;
        }
    }
    setAclZ(ref, acl) {
        return Promise.resolve().then(() => {
            return this.getCache(ref.url);
        })
            .then(cache => {
            const descriptor = cache.getDescriptor(ref.did);
            return descriptor ? descriptor.setAclZ(acl) : ZPromise_1.ZPromise.create(storage => storage.descriptorModifyAcl(ref.did, acl));
        });
    }
    setAcl(ref, acl) {
        return Promise.resolve().then(() => {
            return this.getCache(ref.url);
        })
            .then(cache => {
            return cache.storage.performDeferredAction(this.setAclZ(ref, acl));
        });
    }
    lock(ref, lock, force) {
        return Promise.resolve().then(() => {
            return this.getCache(ref.url);
        })
            .then(cache => {
            return Promise.resolve().then(() => {
                return lock ? lock : Lock_1.Lock.create(ref.did, ref.priv, this.identity);
            })
                .then(l => {
                lock = l;
                return cache.storage.descriptorLockAndGet(ref.did, lock.id, lock.lockSignature, lock.identity.pub58, lock.lockerSignature, !!force);
            })
                .then(res => {
                lock.serverDate = new Date(parseInt(res.expiry));
                return cache.createResolved2(ref, res.descriptor);
            })
                .then(descriptor => {
                return {
                    version: descriptor.lastVersion,
                    lock: lock
                };
            });
        });
    }
    releaseLock(ref, lockObj) {
        return Promise.resolve().then(() => {
            return this.getCache(ref.url);
        })
            .then(cache => {
            return cache.storage.descriptorRelease(ref.did, lockObj.id, lockObj.releaseSignature);
        });
    }
    saveCached(refId, entry) {
        return Promise.resolve().then(() => {
            if (this.descriptorStorage == null || entry == null || entry.error) {
                return null;
            }
            const cachedEntry = {
                dpub58: entry.dpub58,
                creationDate: entry.creationDate,
                owner: entry.owner,
                acl: entry.acl,
                stickers: entry.stickers,
                versioning: entry.versioning,
                extra: entry.extra,
                signature: entry.signature,
                blocks: entry.blocks,
                modifier: entry.modifier,
                serverDate: entry.serverDate,
                lastModDate: entry.lastModDate,
                lastModifier: entry.lastModifier,
                lock: entry.lock
            };
            if (this.blocksStorage != null) {
                const serializedBlocks = Manager.serializeBlocks(entry.blocksData);
                if (serializedBlocks.length > 0) {
                    this.blocksStorage.set("descriptor:blocks:" + refId, serializedBlocks).catch(e => {
                        Logger.error("Error during saving cached descriptor blocks " + refId, e);
                    });
                }
            }
            return this.descriptorStorage.set("descriptor:" + refId, cachedEntry);
        })
            .catch(e => {
            Logger.error("Error during saving cached descriptor " + refId, e);
        });
    }
    loadCached(refs, cache) {
        return Promise.resolve().then(() => {
            if (this.descriptorStorage == null) {
                return null;
            }
            const filtered = refs.filter(ref => !cache.has(ref.did));
            return Promise.all(filtered.map(ref => {
                const refId = DescriptorRef_1.DescriptorRef.getId(cache.url, ref.did);
                return this.descriptorStorage.get("descriptor:" + refId).then(entry => {
                    if (entry == null) {
                        return;
                    }
                    if (this.blocksStorage != null) {
                        this.blocksStorage.get("descriptor:blocks:" + refId).then(data => {
                            if (data != null) {
                                const blocks = Manager.deserializeBlocks(data);
                                for (const bid in blocks) {
                                    this.storageProviderManager.blockCache.set(bid, blocks[bid]);
                                }
                            }
                        })
                            .catch(e => {
                            Logger.error("Error during reading cached descriptor blocks " + refId, e);
                        });
                    }
                    if (!cache.has(ref.did)) {
                        cache.createResolved2WCS(ref, entry, true);
                    }
                });
            }));
        })
            .then(() => cache);
    }
    static serializeBlocks(blocksData) {
        const blocksBuffers = [];
        for (const bid in blocksData) {
            const bidBuffer = Buffer.from(bid, "utf8");
            const bidLengthBuffer = Buffer.alloc(1);
            bidLengthBuffer.writeUInt8(bidBuffer.length, 0);
            const dataBuffer = Buffer.from(blocksData[bid].toArrayBuffer());
            const dataLengthBuffer = Buffer.alloc(4);
            dataLengthBuffer.writeUInt32LE(dataBuffer.length, 0);
            blocksBuffers.push(bidLengthBuffer);
            blocksBuffers.push(bidBuffer);
            blocksBuffers.push(dataLengthBuffer);
            blocksBuffers.push(dataBuffer);
        }
        return Buffer.concat(blocksBuffers);
    }
    static deserializeBlocks(buffer) {
        const res = {};
        let pos = 0;
        while (pos < buffer.length) {
            const bidLength = buffer.readUInt8(pos);
            pos += 1;
            const bid = buffer.slice(pos, pos + bidLength).toString("utf8");
            pos += bidLength;
            const dataLength = buffer.readUInt32LE(pos);
            pos += 4;
            const data = buffer.slice(pos, pos + dataLength);
            pos += dataLength;
            res[bid] = data;
        }
        return res;
    }
    getDirectoryEntries(newHandle) {
        return Promise.all([
            newHandle.read({ cache: false }),
            newHandle.getWriteKeyEx()
        ])
            .then(res => {
            const [obj, writeKey] = res;
            return Entries_1.Entries.deserialize(this, writeKey, obj.getJson());
        });
    }
}
exports.Manager = Manager;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../../core/StorageProviderManager":161,"../../core/ZPromise":164,"../../identity/Identity":211,"../file/entry/Entries":198,"./Cache":174,"./Handle":179,"./Lock":180,"./Streamer":184,"./ref/DescriptorRef":187,"./ref/DescriptorRefWrite":189,"buffer":498,"privmx-crypto":265,"privmx-exception":286,"simplito-logger":407,"simplito-net":408}],182:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Raw = void 0;
const PrivFsException_1 = require("../../exception/PrivFsException");
const privmx_crypto_1 = require("privmx-crypto");
class Raw {
    blocks;
    extra;
    signature;
    serverDate;
    modifier;
    constructor(blocks, extra, signature, serverDate, modifier) {
        Object.defineProperty(this, "blocks", {
            value: blocks,
            enumerable: true
        });
        Object.defineProperty(this, "extra", {
            value: extra,
            enumerable: true
        });
        Object.defineProperty(this, "signature", {
            value: signature,
            enumerable: true
        });
        Object.defineProperty(this, "serverDate", {
            value: serverDate,
            enumerable: true
        });
        Object.defineProperty(this, "modifier", {
            value: modifier,
            enumerable: true
        });
    }
    static verifySignature(pubKey, extraEnc, blocks, signature) {
        return privmx_crypto_1.service.sha256(extraEnc)
            .then(hash => {
            const version = Buffer.from(blocks.join("") + hash.toString("base64"), "utf8");
            return privmx_crypto_1.service.verifyCompactSignatureWithHash(pubKey, version, signature)
                .then(validSignature => {
                if (!validSignature) {
                    throw new PrivFsException_1.PrivFsException("INVALID_DESCRIPTOR_SIGNATURE");
                }
            });
        });
    }
    static createSignature(privKey, extraEnc, blocks) {
        return privmx_crypto_1.service.sha256(extraEnc)
            .then(hash => {
            const version = Buffer.from(blocks.join("") + hash.toString("base64"), "utf8");
            return privmx_crypto_1.service.signToCompactSignatureWithHash(privKey, version);
        });
    }
    static deserializeWithoutCheckingSignature(data, extraEnc) {
        return new Raw(data.blocks, extraEnc || Buffer.from(data.extra, "base64"), data.signature, new Date(parseInt(data.serverDate)), data.modifier);
    }
    static deserialize(pubKey, data) {
        return Promise.resolve().then(() => {
            const extraEnc = Buffer.from(data.extra, "base64");
            const signature = Buffer.from(data.signature, "base64");
            return Raw.verifySignature(pubKey, extraEnc, data.blocks, signature).then(() => {
                return Raw.deserializeWithoutCheckingSignature(data, extraEnc);
            });
        });
    }
    static serialize(privKey, extraEnc, blocks) {
        return Raw.createSignature(privKey, extraEnc, blocks)
            .then(signature => {
            return {
                blocks: blocks,
                dpub58: privKey.getPublicKey().toBase58DER(),
                extra: extraEnc.toString("base64"),
                signature: signature.toString("base64")
            };
        });
    }
}
exports.Raw = Raw;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../../exception/PrivFsException":172,"buffer":498,"privmx-crypto":265}],183:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Result = void 0;
const Handle_1 = require("./Handle");
class Result {
    static NEW = "new";
    static MODIFIED = "modified";
    static NOT_MODIFIED = "not-modified";
    ref;
    descriptor;
    mode;
    constructor(ref, descriptor, mode) {
        this.ref = ref;
        this.descriptor = descriptor;
        this.mode = mode;
    }
    static createNew(ref, descriptor) {
        return new Result(ref, descriptor, Result.NEW);
    }
    static createModified(ref, descriptor) {
        return new Result(ref, descriptor, Result.MODIFIED);
    }
    static createNotModified(ref, descriptor) {
        return new Result(ref, descriptor, Result.NOT_MODIFIED);
    }
    isNew() {
        return this.mode == Result.NEW;
    }
    isModified() {
        return this.mode == Result.MODIFIED;
    }
    isNotModified() {
        return this.mode == Result.NOT_MODIFIED;
    }
    createHandle() {
        return this.createHandleWithRef(this.ref);
    }
    createHandleWithRef(ref) {
        return new Handle_1.Handle(ref, this.descriptor);
    }
}
exports.Result = Result;

},{"./Handle":179}],184:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Streamer = void 0;
const Extra_1 = require("./Extra");
const BlockStreamer_1 = require("../../block/BlockStreamer");
const Raw_1 = require("./Raw");
const ZPromise_1 = require("../../core/ZPromise");
const Utils = require("simplito-utils");
const privmx_crypto_1 = require("privmx-crypto");
const BlocksInfo_1 = require("../../block/BlocksInfo");
const Lock_1 = require("./Lock");
class Streamer {
    constructor() {
    }
    static copy(ref, storage, org, orgEncKey, orgWriteKey, options) {
        const acl = options ? options.acl : null;
        const versioning = options ? options.versioning : null;
        let versions;
        const eventData = storage.startEvent("descriptor-create", { ref: ref, storage: storage, org: org, options: options });
        return Promise.resolve().then(() => {
            return Promise.all(org.versions.map(version => {
                let extraEnc, raw, extra, oldExtra;
                return Promise.resolve().then(() => {
                    return version.getExtra(orgEncKey);
                })
                    .then(oe => {
                    oldExtra = oe;
                    if (orgWriteKey == null || (oldExtra.writeKey == null && oldExtra.meta.type != "directory")) {
                        return null;
                    }
                    return Promise.resolve().then(() => {
                        return oldExtra.getDecryptedWriteKeyOrGivenOne(orgWriteKey);
                    })
                        .then(writeKey => {
                        return Extra_1.Extra.encryptWriteKey(writeKey, ref.writeKey);
                    });
                })
                    .then(writeKey => {
                    extra = new Extra_1.Extra(oldExtra.key, writeKey, Utils.simpleDeepClone(oldExtra.meta));
                    if (options && options.metaUpdater) {
                        options.metaUpdater(extra.meta);
                    }
                    return extra.serializeAndEncode(ref.readKey);
                })
                    .then(ee => {
                    extraEnc = ee;
                    return Raw_1.Raw.createSignature(ref.priv, extraEnc, version.raw.blocks);
                })
                    .then(signature => {
                    const rawVersion = {
                        extra: extraEnc.toString("base64"),
                        signature: signature.toString("base64")
                    };
                    raw = new Raw_1.Raw(version.raw.blocks, extraEnc, rawVersion.signature, version.raw.serverDate, version.raw.modifier);
                    return {
                        rawVersion: rawVersion,
                        raw: raw,
                        extra: extra
                    };
                });
            }));
        })
            .then(v => {
            versions = v;
            return storage.descriptorCopy(ref.did, ref.pub58, org.descriptor.ref.did, versions.map(x => x.rawVersion), acl, versioning);
        })
            .then(data => {
            const lastVersion = versions[versions.length - 1];
            const res = {
                ref: ref,
                creationDate: org.descriptor.creationDate,
                owner: data.owner,
                acl: acl,
                versioning: versioning,
                raw: lastVersion.raw,
                extra: lastVersion.extra,
                lastModDate: data.serverDate,
                lastModifier: data.modifier,
                lock: null
            };
            return res;
        })
            .finally(() => {
            storage.stopEvent(eventData);
        });
    }
    static create(ref, storage, content, type, lockIdentity, options) {
        if (content instanceof BlocksInfo_1.BlocksInfo) {
            return Streamer.createFromBlocks(ref, storage, content, type, lockIdentity, options);
        }
        return Streamer.createFromBuffer(ref, storage, content, type, lockIdentity, options);
    }
    static createFromBuffer(ref, storage, content, type, lockIdentity, options) {
        if (storage.config.inlineTransferSupported && content.getSize() < BlockStreamer_1.BlockStreamer.getMaxInlineDataSize(storage.config)) {
            return Streamer.createFromContentWithoutTransfer(ref, storage, content, type, lockIdentity, options);
        }
        return Streamer.createFromContentWithTransfer(ref, storage, content, type, lockIdentity, options);
    }
    static createFromContentWithTransfer(ref, storage, content, type, lockIdentity, options) {
        let extra, transferId;
        const eventData = storage.startEvent("descriptor-create", { ref: ref, storage: storage, content: content, type: type, options: options });
        return Promise.resolve().then(() => {
            return storage.descriptorCreateInit();
        })
            .then(id => {
            transferId = id;
            extra = new Extra_1.Extra(options && options.blocksEncKey ? options.blocksEncKey : privmx_crypto_1.service.randomBytes(32), null, {
                size: content.getSize(),
                createDate: new Date().getTime(),
                modifiedDate: new Date().getTime(),
                mimeType: content.getMimeType() || "",
                originalName: content.getName() || "",
                type: type
            });
            if (options && options.metaUpdater) {
                options.metaUpdater(extra.meta);
            }
            return BlockStreamer_1.BlockStreamer.stream(storage, [transferId], content, extra.key, options ? options.streamOptions : null);
        })
            .then(blocks => {
            const transfer = {
                type: "transfer",
                transferId: transferId
            };
            return Streamer.createCore(ref, extra, transfer, blocks, lockIdentity, options ? options.acl : null, options ? options.versioning : null);
        })
            .finally(() => {
            storage.stopEvent(eventData);
        });
    }
    static createFromContentWithoutTransfer(ref, storage, content, type, lockIdentity, options) {
        let extra;
        const eventData = storage.startEvent("descriptor-create", { ref: ref, storage: storage, content: content, type: type, options: options });
        return Promise.resolve().then(() => {
            extra = new Extra_1.Extra(options && options.blocksEncKey ? options.blocksEncKey : privmx_crypto_1.service.randomBytes(32), null, {
                size: content.getSize(),
                createDate: new Date().getTime(),
                modifiedDate: new Date().getTime(),
                mimeType: content.getMimeType() || "",
                originalName: content.getName() || "",
                type: type
            });
            if (options && options.metaUpdater) {
                options.metaUpdater(extra.meta);
            }
            return BlockStreamer_1.BlockStreamer.prepareBlocks(storage.config, content, extra.key);
        })
            .then(blocksData => {
            const transfer = {
                type: "blocks",
                blocks: blocksData
            };
            return Streamer.createCore(ref, extra, transfer, blocksData.map(x => x.bid), lockIdentity, options ? options.acl : null, options ? options.versioning : null);
        })
            .finally(() => {
            storage.stopEvent(eventData);
        });
    }
    static createFromBlocks(ref, storage, blocksInfo, type, lockIdentity, options) {
        if (storage.config.inlineTransferSupported && storage.getDestination() == blocksInfo.storage.getDestination()) {
            return Streamer.createFromBlocksWithoutTransfer(ref, storage, blocksInfo, type, lockIdentity, options);
        }
        return Streamer.createFromBlocksWithTransfer(ref, storage, blocksInfo, type, lockIdentity, options);
    }
    static createFromBlocksWithTransfer(ref, storage, blocksInfo, type, lockIdentity, options) {
        let extra, transferId;
        const eventData = storage.startEvent("descriptor-create", { ref: ref, storage: storage, blocksInfo: blocksInfo, type: type, options: options });
        return Promise.resolve().then(() => {
            return storage.descriptorCreateInit();
        })
            .then(id => {
            transferId = id;
            extra = new Extra_1.Extra(blocksInfo.data.key, null, {
                size: blocksInfo.data.size,
                createDate: new Date().getTime(),
                modifiedDate: new Date().getTime(),
                mimeType: blocksInfo.data.mimeType,
                originalName: blocksInfo.data.name || "",
                type: type
            });
            if (options && options.metaUpdater) {
                options.metaUpdater(extra.meta);
            }
            return BlockStreamer_1.BlockStreamer.addBlocksToSessionByInfo(storage, [transferId], blocksInfo);
        })
            .then(blocks => {
            const transfer = {
                type: "transfer",
                transferId: transferId
            };
            return Streamer.createCore(ref, extra, transfer, blocks, lockIdentity, options ? options.acl : null, options ? options.versioning : null);
        })
            .finally(() => {
            storage.stopEvent(eventData);
        });
    }
    static createFromBlocksWithoutTransfer(ref, storage, blocksInfo, type, lockIdentity, options) {
        let extra;
        const eventData = storage.startEvent("descriptor-create", { ref: ref, storage: storage, blocksInfo: blocksInfo, type: type, options: options });
        return Promise.resolve().then(() => {
            extra = new Extra_1.Extra(blocksInfo.data.key, null, {
                size: blocksInfo.data.size,
                createDate: new Date().getTime(),
                modifiedDate: new Date().getTime(),
                mimeType: blocksInfo.data.mimeType,
                originalName: blocksInfo.data.name || "",
                type: type
            });
            if (options && options.metaUpdater) {
                options.metaUpdater(extra.meta);
            }
            const transfer = {
                type: "blocksInfo",
                blocksInfo: [{
                        source: blocksInfo.source,
                        blocks: blocksInfo.data.blocks
                    }]
            };
            return Streamer.createCore(ref, extra, transfer, blocksInfo.data.blocks, lockIdentity, options ? options.acl : null, options ? options.versioning : null);
        })
            .finally(() => {
            storage.stopEvent(eventData);
        });
    }
    static createCore(ref, extra, transfer, blocks, lockIdentity, acl, versioning) {
        let extraEnc, rawObj;
        return Promise.resolve().then(() => {
            return extra.serializeAndEncode(ref.readKey);
        })
            .then(ee => {
            extraEnc = ee;
            return Raw_1.Raw.serialize(ref.priv, extraEnc, blocks);
        })
            .then(ro => {
            rawObj = ro;
            return lockIdentity ? Lock_1.Lock.create(ref.did, ref.priv, lockIdentity) : null;
        })
            .then(lock => {
            const lockData = lock ? {
                lockId: lock.id,
                signature: lock.lockSignature,
                lockerPub58: lock.identity.pub58,
                lockerSignature: lock.lockerSignature
            } : null;
            return ZPromise_1.ZPromise.create(storage => {
                return storage.descriptorCreate(ref.did, rawObj, transfer, acl, versioning, lockData);
            })
                .next(data => {
                const timestamp = parseInt(data.serverDate);
                const date = new Date(timestamp);
                const raw = new Raw_1.Raw(rawObj.blocks, extraEnc, rawObj.signature, date, data.modifier);
                const res = {
                    ref: ref,
                    creationDate: date,
                    lastModDate: timestamp,
                    lastModifier: data.modifier,
                    owner: data.owner,
                    acl: acl,
                    versioning: versioning,
                    raw: raw,
                    extra: extra,
                    lock: lock
                };
                return res;
            });
        });
    }
    static initUpdate(handle) {
        let nonce, timestamp;
        return Promise.resolve().then(() => {
            nonce = privmx_crypto_1.service.randomBytes(32).toString("base64");
            timestamp = new Date().getTime().toString();
            const data = Buffer.from("descriptorUpdate" + handle.ref.did + handle.descriptor.manager.identity.hashmail + " " + nonce + " " + timestamp, "utf8");
            return privmx_crypto_1.service.signToCompactSignatureWithHash(handle.descriptor.manager.identity.priv, data);
        })
            .then(signature => {
            return handle.descriptor.storage.descriptorUpdateInit(handle.ref.did, {
                hashmail: handle.descriptor.manager.identity.hashmail,
                pub: handle.descriptor.manager.identity.pub58,
                nonce: nonce,
                timestamp: timestamp,
                signature: signature.toString("base64")
            });
        });
    }
    static update(handle, content, options) {
        if (content instanceof BlocksInfo_1.BlocksInfo) {
            return Streamer.updateBlocks(handle, content, options);
        }
        return Streamer.updateFromContent(handle, content, options);
    }
    static updateFromContent(handle, content, options) {
        if (handle.descriptor.storage.config.inlineTransferSupported && content.getSize() < BlockStreamer_1.BlockStreamer.getMaxInlineDataSize(handle.descriptor.storage.config)) {
            return Streamer.updateFromContentWithoutTransfer(handle, content, options);
        }
        return Streamer.updateFromContentWithTransfer(handle, content, options);
    }
    static updateFromContentWithTransfer(handle, content, options) {
        let extra, version, transferId;
        const lockId = options ? options.lockId : "";
        const releaseLock = !!(options && options.releaseLock);
        const eventData = handle.descriptor.storage.startEvent("descriptor-update", { handle: handle, content: content, options: options });
        return Promise.resolve().then(() => {
            version = handle.currentVersion;
            return Streamer.initUpdate(handle);
        })
            .then(id => {
            transferId = id;
            return version.getExtra(handle.ref.readKey);
        })
            .then(oldExtra => {
            extra = new Extra_1.Extra(options && options.blocksEncKey ? options.blocksEncKey : privmx_crypto_1.service.randomBytes(32), oldExtra.writeKey, Utils.clone(oldExtra.meta));
            extra.meta.size = content.getSize();
            extra.meta.modifiedDate = new Date().getTime();
            extra.meta.mimeType = content.getMimeType() || extra.meta.mimeType;
            if (options && options.metaUpdater) {
                options.metaUpdater(extra.meta);
            }
            return BlockStreamer_1.BlockStreamer.stream(handle.descriptor.storage, [transferId], content, extra.key, options ? options.streamOptions : null);
        })
            .then(blocks => {
            const transfer = {
                type: "transfer",
                transferId: transferId
            };
            return Streamer.updateCore(handle, version, extra, transfer, blocks, lockId, releaseLock);
        })
            .finally(() => {
            handle.descriptor.storage.stopEvent(eventData);
        });
    }
    static updateFromContentWithoutTransfer(handle, content, options) {
        let extra, version;
        const lockId = options ? options.lockId : "";
        const releaseLock = !!(options && options.releaseLock);
        const eventData = handle.descriptor.storage.startEvent("descriptor-update", { handle: handle, content: content, options: options });
        return Promise.resolve().then(() => {
            version = handle.currentVersion;
            return version.getExtra(handle.ref.readKey);
        })
            .then(oldExtra => {
            extra = new Extra_1.Extra(options && options.blocksEncKey ? options.blocksEncKey : privmx_crypto_1.service.randomBytes(32), oldExtra.writeKey, Utils.clone(oldExtra.meta));
            extra.meta.size = content.getSize();
            extra.meta.modifiedDate = new Date().getTime();
            extra.meta.mimeType = content.getMimeType() || extra.meta.mimeType;
            if (options && options.metaUpdater) {
                options.metaUpdater(extra.meta);
            }
            return BlockStreamer_1.BlockStreamer.prepareBlocks(handle.descriptor.storage.config, content, extra.key);
        })
            .then(blocksData => {
            const transfer = {
                type: "blocks",
                blocks: blocksData
            };
            return Streamer.updateCore(handle, version, extra, transfer, blocksData.map(x => x.bid), lockId, releaseLock);
        })
            .finally(() => {
            handle.descriptor.storage.stopEvent(eventData);
        });
    }
    static updateBlocks(handle, blocksInfo, options) {
        if (handle.descriptor.storage.config.inlineTransferSupported && handle.descriptor.storage.getDestination() == blocksInfo.storage.getDestination()) {
            return Streamer.updateBlocksWithoutTransfer(handle, blocksInfo, options);
        }
        return Streamer.updateBlocksWithTransfer(handle, blocksInfo, options);
    }
    static updateBlocksWithTransfer(handle, blocksInfo, options) {
        let extra, version, transferId;
        const lockId = options ? options.lockId : "";
        const releaseLock = !!(options && options.releaseLock);
        const eventData = handle.descriptor.storage.startEvent("descriptor-update", { handle: handle, blocksInfo: blocksInfo, options: options });
        return Promise.resolve().then(() => {
            version = handle.currentVersion;
            return Streamer.initUpdate(handle);
        })
            .then(id => {
            transferId = id;
            return version.getExtra(handle.ref.readKey);
        })
            .then(oldExtra => {
            extra = new Extra_1.Extra(blocksInfo.data.key, oldExtra.writeKey, Utils.clone(oldExtra.meta));
            extra.meta.size = blocksInfo.data.size;
            extra.meta.modifiedDate = new Date().getTime();
            extra.meta.mimeType = blocksInfo.data.mimeType || extra.meta.mimeType;
            if (options && options.metaUpdater) {
                options.metaUpdater(extra.meta);
            }
            return BlockStreamer_1.BlockStreamer.addBlocksToSessionByInfo(handle.descriptor.storage, [transferId], blocksInfo);
        })
            .then(blocks => {
            const transfer = {
                type: "transfer",
                transferId: transferId
            };
            return Streamer.updateCore(handle, version, extra, transfer, blocks, lockId, releaseLock);
        })
            .finally(() => {
            handle.descriptor.storage.stopEvent(eventData);
        });
    }
    static updateBlocksWithoutTransfer(handle, blocksInfo, options) {
        let extra, version;
        const lockId = options ? options.lockId : "";
        const releaseLock = !!(options && options.releaseLock);
        const eventData = handle.descriptor.storage.startEvent("descriptor-update", { handle: handle, blocksInfo: blocksInfo, options: options });
        return Promise.resolve().then(() => {
            version = handle.currentVersion;
            return version.getExtra(handle.ref.readKey);
        })
            .then(oldExtra => {
            extra = new Extra_1.Extra(blocksInfo.data.key, oldExtra.writeKey, Utils.clone(oldExtra.meta));
            extra.meta.size = blocksInfo.data.size;
            extra.meta.modifiedDate = new Date().getTime();
            extra.meta.mimeType = blocksInfo.data.mimeType || extra.meta.mimeType;
            if (options && options.metaUpdater) {
                options.metaUpdater(extra.meta);
            }
            const transfer = {
                type: "blocksInfo",
                blocksInfo: [{
                        source: blocksInfo.source,
                        blocks: blocksInfo.data.blocks
                    }]
            };
            return Streamer.updateCore(handle, version, extra, transfer, blocksInfo.data.blocks, lockId, releaseLock);
        })
            .finally(() => {
            handle.descriptor.storage.stopEvent(eventData);
        });
    }
    static updateMeta(handle, options) {
        let extra, version;
        const lockId = options ? options.lockId : "";
        const releaseLock = !!(options && options.releaseLock);
        const eventData = handle.descriptor.storage.startEvent("descriptor-update", { handle: handle, options: options });
        return Promise.resolve().then(() => {
            version = handle.currentVersion;
            return version.getExtra(handle.ref.readKey);
        })
            .then(oldExtra => {
            const blocksInfo = version.getBlocksInfoFromExtra(oldExtra, false);
            extra = new Extra_1.Extra(oldExtra.key, oldExtra.writeKey, Utils.clone(oldExtra.meta));
            if (options && options.metaUpdater) {
                const updaterResult = options.metaUpdater(extra.meta);
                if (updaterResult === false) {
                    return ZPromise_1.ZPromise.create(() => null);
                }
            }
            if (handle.descriptor.storage.config.inlineTransferSupported) {
                const transfer = {
                    type: "blocksInfo",
                    blocksInfo: [{
                            source: blocksInfo.source,
                            blocks: blocksInfo.data.blocks
                        }]
                };
                return Streamer.updateCore(handle, version, extra, transfer, blocksInfo.data.blocks, lockId, releaseLock);
            }
            let transferId;
            return Promise.resolve().then(() => {
                return Streamer.initUpdate(handle);
            })
                .then(id => {
                transferId = id;
                return BlockStreamer_1.BlockStreamer.addBlocksToSessionByInfo(handle.descriptor.storage, [transferId], blocksInfo);
            })
                .then(blocks => {
                const transfer = {
                    type: "transfer",
                    transferId: transferId
                };
                return Streamer.updateCore(handle, version, extra, transfer, blocks, lockId, releaseLock);
            });
        })
            .finally(() => {
            handle.descriptor.storage.stopEvent(eventData);
        });
    }
    static updateCore(handle, version, extra, transfer, blocks, lockId, releaseLock) {
        let extraEnc, rawObj;
        const ref = handle.ref;
        return Promise.resolve().then(() => {
            return extra.serializeAndEncode(ref.readKey);
        })
            .then(ee => {
            extraEnc = ee;
            return Raw_1.Raw.serialize(ref.priv, extraEnc, blocks);
        })
            .then(ro => {
            rawObj = ro;
            return ZPromise_1.ZPromise.create(storage => {
                return storage.descriptorUpdate(handle.ref.did, rawObj, transfer, version.raw.signature, lockId || "", releaseLock);
            })
                .next(data => {
                const timestamp = parseInt(data.serverDate);
                const raw = new Raw_1.Raw(rawObj.blocks, extraEnc, rawObj.signature, new Date(timestamp), data.modifier);
                const newVersion = handle.descriptor.createVersionAndSetAsLastAndAssignLastMod(timestamp, data.modifier, raw, extra);
                return {
                    ref: ref,
                    handle: handle,
                    version: newVersion,
                    blocksInfo: newVersion.getBlocksInfoFromExtra(extra),
                    extra: extra,
                    meta: extra.meta
                };
            });
        });
    }
    static isSimpleTransferableContent(storage, content) {
        if (content instanceof BlocksInfo_1.BlocksInfo) {
            return content.storage.getDestination() == storage.getDestination();
        }
        return storage.config.inlineTransferSupported && content.getSize() < BlockStreamer_1.BlockStreamer.getMaxInlineDataSize(storage.config) && content.getSize() < 10000;
    }
    static async createSimpleTransferableContent(storage, content, streamOptions) {
        if (Streamer.isSimpleTransferableContent(storage, content)) {
            return content;
        }
        if (content instanceof BlocksInfo_1.BlocksInfo) {
            const transferId = await storage.descriptorCreateInit();
            const blocks = await BlockStreamer_1.BlockStreamer.addBlocksToSessionByInfo(storage, [transferId], content);
            return new BlocksInfo_1.BlocksInfo(storage, { type: "transfer", transferId }, BlocksInfo_1.BlocksInfo.getBlocksData(content, content.data.key, blocks), null);
        }
        const transferId = await storage.descriptorCreateInit();
        const aesKey = privmx_crypto_1.service.randomBytes(32);
        const blocks = await BlockStreamer_1.BlockStreamer.stream(storage, [transferId], content, aesKey, streamOptions);
        return new BlocksInfo_1.BlocksInfo(storage, { type: "transfer", transferId }, BlocksInfo_1.BlocksInfo.getBlocksData(content, aesKey, blocks), null);
    }
}
exports.Streamer = Streamer;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../../block/BlockStreamer":133,"../../block/BlocksInfo":134,"../../core/ZPromise":164,"./Extra":178,"./Lock":180,"./Raw":182,"buffer":498,"privmx-crypto":265,"simplito-utils":422}],185:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Version = void 0;
const privmx_exception_1 = require("privmx-exception");
const BlocksInfo_1 = require("../../block/BlocksInfo");
const Raw_1 = require("./Raw");
const Extra_1 = require("./Extra");
class Version {
    descriptor;
    raw;
    extra;
    extraPromise;
    blocksInfo;
    constructor(descriptor, raw, extra) {
        if (!(raw instanceof Raw_1.Raw)) {
            throw new privmx_exception_1.IllegalArgumentException("raw", raw);
        }
        Object.defineProperty(this, "descriptor", {
            value: descriptor,
            enumerable: true
        });
        Object.defineProperty(this, "raw", {
            value: raw,
            enumerable: true
        });
        if (extra != null) {
            if (!(extra instanceof Extra_1.Extra)) {
                throw new privmx_exception_1.IllegalArgumentException("extra", extra);
            }
            Object.defineProperty(this, "extra", {
                value: extra,
                enumerable: true
            });
        }
    }
    isValidDid(did) {
        return did == this.descriptor.ref.did;
    }
    getExtra(encKey) {
        return Promise.resolve().then(() => {
            if (this.extra != null) {
                return this.extra;
            }
            if (this.extraPromise != null) {
                return this.extraPromise;
            }
            return this.extraPromise = Promise.resolve().then(() => {
                return Extra_1.Extra.decodeAndDeserialize(encKey, this.raw.extra);
            })
                .then(extra => {
                Object.defineProperty(this, "extra", {
                    value: extra,
                    enumerable: true
                });
                return extra;
            })
                .finally(() => {
                delete this.extraPromise;
            });
        });
    }
    getContent(encKey, options) {
        return Promise.resolve().then(() => {
            return this.getBlocksInfo(encKey, options ? options.cache : null);
        })
            .then(data => {
            return data.getContent(options);
        });
    }
    getBlocksInfo(encKey, cache) {
        return Promise.resolve().then(() => {
            return this.getExtra(encKey);
        })
            .then(extra => {
            return this.getBlocksInfoFromExtra(extra, cache);
        });
    }
    getBlocksInfoFromExtra(extra, cache) {
        if (this.blocksInfo == null) {
            this.blocksInfo = new BlocksInfo_1.BlocksInfo(this.descriptor.storage, {
                type: "descriptor",
                did: this.descriptor.ref.did,
                signature: this.raw.signature
            }, {
                blocks: this.raw.blocks,
                mimeType: extra.meta.mimeType,
                size: extra.meta.size,
                key: extra.key,
                name: extra.meta.originalName
            }, {
                cacheEnabled: !!cache
            });
        }
        if (cache) {
            this.blocksInfo.cachedBuffer.cacheEnabled = cache;
        }
        return this.blocksInfo;
    }
    clearCache(cacheEnabled) {
        if (this.blocksInfo) {
            this.blocksInfo.clearCache(cacheEnabled);
        }
    }
}
exports.Version = Version;

},{"../../block/BlocksInfo":134,"./Extra":178,"./Raw":182,"privmx-exception":286}],186:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Version = exports.Streamer = exports.Result = exports.Raw = exports.Manager = exports.Lock = exports.Handle = exports.Extra = exports.DescriptorMultiStorageProvider = exports.DescriptorMultiGet = exports.Descriptor = exports.Cache = exports.ref = void 0;
const ref = require("./ref");
exports.ref = ref;
const Cache_1 = require("./Cache");
Object.defineProperty(exports, "Cache", { enumerable: true, get: function () { return Cache_1.Cache; } });
const Descriptor_1 = require("./Descriptor");
Object.defineProperty(exports, "Descriptor", { enumerable: true, get: function () { return Descriptor_1.Descriptor; } });
const DescriptorMultiGet_1 = require("./DescriptorMultiGet");
Object.defineProperty(exports, "DescriptorMultiGet", { enumerable: true, get: function () { return DescriptorMultiGet_1.DescriptorMultiGet; } });
const DescriptorMultiStorageProvider_1 = require("./DescriptorMultiStorageProvider");
Object.defineProperty(exports, "DescriptorMultiStorageProvider", { enumerable: true, get: function () { return DescriptorMultiStorageProvider_1.DescriptorMultiStorageProvider; } });
const Extra_1 = require("./Extra");
Object.defineProperty(exports, "Extra", { enumerable: true, get: function () { return Extra_1.Extra; } });
const Handle_1 = require("./Handle");
Object.defineProperty(exports, "Handle", { enumerable: true, get: function () { return Handle_1.Handle; } });
const Lock_1 = require("./Lock");
Object.defineProperty(exports, "Lock", { enumerable: true, get: function () { return Lock_1.Lock; } });
const Manager_1 = require("./Manager");
Object.defineProperty(exports, "Manager", { enumerable: true, get: function () { return Manager_1.Manager; } });
const Raw_1 = require("./Raw");
Object.defineProperty(exports, "Raw", { enumerable: true, get: function () { return Raw_1.Raw; } });
const Result_1 = require("./Result");
Object.defineProperty(exports, "Result", { enumerable: true, get: function () { return Result_1.Result; } });
const Streamer_1 = require("./Streamer");
Object.defineProperty(exports, "Streamer", { enumerable: true, get: function () { return Streamer_1.Streamer; } });
const Version_1 = require("./Version");
Object.defineProperty(exports, "Version", { enumerable: true, get: function () { return Version_1.Version; } });

},{"./Cache":174,"./Descriptor":175,"./DescriptorMultiGet":176,"./DescriptorMultiStorageProvider":177,"./Extra":178,"./Handle":179,"./Lock":180,"./Manager":181,"./Raw":182,"./Result":183,"./Streamer":184,"./Version":185,"./ref":190}],187:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DescriptorRef = void 0;
const privmx_exception_1 = require("privmx-exception");
const Utils = require("simplito-utils");
class DescriptorRef {
    id;
    did;
    url;
    constructor(did, url) {
        if (typeof (did) != "string") {
            throw new privmx_exception_1.IllegalArgumentException("did", did);
        }
        if (typeof (url) != "string") {
            throw new privmx_exception_1.IllegalArgumentException("url", url);
        }
        Object.defineProperty(this, "did", {
            value: did,
            enumerable: true
        });
        Object.defineProperty(this, "url", {
            value: url,
            enumerable: true
        });
        Utils.defineLazyReadOnlyProperty(this, "id", () => {
            return DescriptorRef.getId(this.url, this.did);
        });
    }
    hasReadRights() {
        return false;
    }
    hasWriteRights() {
        return false;
    }
    hasNoRights() {
        return !this.hasReadRights() && !this.hasWriteRights();
    }
    isReadOnly() {
        return this.hasReadRights() && !this.hasWriteRights();
    }
    equals(other) {
        if (other instanceof DescriptorRef) {
            return this.id == other.id;
        }
        return false;
    }
    asDescriptorRef() {
        return new DescriptorRef(this.did, this.url);
    }
    static getId(url, did) {
        return url + did;
    }
}
exports.DescriptorRef = DescriptorRef;

},{"privmx-exception":286,"simplito-utils":422}],188:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DescriptorRefRead = void 0;
const privmx_exception_1 = require("privmx-exception");
const Utils = require("simplito-utils");
const DescriptorRef_1 = require("./DescriptorRef");
const privmx_crypto_1 = require("privmx-crypto");
class DescriptorRefRead extends DescriptorRef_1.DescriptorRef {
    ext;
    extPub58;
    pub;
    pub58;
    readKey;
    constructor(eccExtKey, url) {
        super(DescriptorRefRead.getDidFromPub(eccExtKey.getPublicKey()), url);
        if (!(eccExtKey instanceof privmx_crypto_1.ecc.ExtKey)) {
            throw new privmx_exception_1.IllegalArgumentException("eccExtKey", eccExtKey);
        }
        Object.defineProperty(this, "ext", {
            value: eccExtKey,
            enumerable: true
        });
        Utils.defineLazyReadOnlyProperty(this, "extPub58", () => {
            return this.ext.getPublicPartAsBase58();
        });
        Utils.defineLazyReadOnlyProperty(this, "pub", () => {
            return this.ext.getPublicKey();
        });
        Utils.defineLazyReadOnlyProperty(this, "pub58", () => {
            return this.pub.toBase58DER();
        });
        Utils.defineLazyReadOnlyProperty(this, "readKey", () => {
            return this.ext.getChainCode();
        });
    }
    static getDidFromPub(pubKey) {
        return privmx_crypto_1.serviceSync.eccPubToBase58Address(pubKey);
    }
    static fromExtKey(eccExtKey58, url) {
        return new DescriptorRefRead(privmx_crypto_1.ecc.ExtKey.fromBase58(eccExtKey58), url);
    }
    hasReadRights() {
        return true;
    }
}
exports.DescriptorRefRead = DescriptorRefRead;

},{"./DescriptorRef":187,"privmx-crypto":265,"privmx-exception":286,"simplito-utils":422}],189:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DescriptorRefWrite = void 0;
const privmx_exception_1 = require("privmx-exception");
const Utils = require("simplito-utils");
const DescriptorRefRead_1 = require("./DescriptorRefRead");
const privmx_crypto_1 = require("privmx-crypto");
class DescriptorRefWrite extends DescriptorRefRead_1.DescriptorRefRead {
    extPriv58;
    priv;
    privWif;
    writeKey;
    constructor(eccExtKey, url) {
        super(eccExtKey, url);
        if (!(eccExtKey instanceof privmx_crypto_1.ecc.ExtKey) || !eccExtKey.isPrivate()) {
            throw new privmx_exception_1.IllegalArgumentException("eccExtKey", eccExtKey);
        }
        Utils.defineLazyReadOnlyProperty(this, "extPriv58", () => {
            return this.ext.getPrivatePartAsBase58();
        });
        Utils.defineLazyReadOnlyProperty(this, "priv", () => {
            return this.ext.getPrivateKey();
        });
        Utils.defineLazyReadOnlyProperty(this, "privWif", () => {
            return this.priv.toWIF();
        });
        Utils.defineLazyReadOnlyProperty(this, "writeKey", () => {
            return this.priv.getPrivateEncKey();
        });
    }
    createReadOnly() {
        return new DescriptorRefRead_1.DescriptorRefRead(this.ext, this.url);
    }
    static fromExtKey(eccExtKey58, url) {
        return new DescriptorRefWrite(privmx_crypto_1.ecc.ExtKey.fromBase58(eccExtKey58), url);
    }
    static generate(url) {
        return new DescriptorRefWrite(privmx_crypto_1.serviceSync.eccExtRandom(), url);
    }
    hasWriteRights() {
        return true;
    }
}
exports.DescriptorRefWrite = DescriptorRefWrite;

},{"./DescriptorRefRead":188,"privmx-crypto":265,"privmx-exception":286,"simplito-utils":422}],190:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DescriptorRefWrite = exports.DescriptorRefRead = exports.DescriptorRef = void 0;
const DescriptorRef_1 = require("./DescriptorRef");
Object.defineProperty(exports, "DescriptorRef", { enumerable: true, get: function () { return DescriptorRef_1.DescriptorRef; } });
const DescriptorRefRead_1 = require("./DescriptorRefRead");
Object.defineProperty(exports, "DescriptorRefRead", { enumerable: true, get: function () { return DescriptorRefRead_1.DescriptorRefRead; } });
const DescriptorRefWrite_1 = require("./DescriptorRefWrite");
Object.defineProperty(exports, "DescriptorRefWrite", { enumerable: true, get: function () { return DescriptorRefWrite_1.DescriptorRefWrite; } });

},{"./DescriptorRef":187,"./DescriptorRefRead":188,"./DescriptorRefWrite":189}],191:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileSystem = void 0;
const Mode_1 = require("./Mode");
const Directory_1 = require("./entry/Directory");
const PathWalker_1 = require("./path/PathWalker");
const simplito_lazybuffer_1 = require("simplito-lazybuffer");
const FileSystemCore_1 = require("./FileSystemCore");
const ShellFileSystem_1 = require("./ShellFileSystem");
const PrivFsException_1 = require("../../exception/PrivFsException");
const ApiErrorCodes_1 = require("../../core/ApiErrorCodes");
const PathPart_1 = require("./path/PathPart");
const privmx_exception_1 = require("privmx-exception");
const KeyValueFile_1 = require("./KeyValueFile");
const Path_1 = require("./path/Path");
const ZPromise_1 = require("../../core/ZPromise");
class FileSystem {
    rootRef;
    root;
    cache_file_refs_enabled;
    fsd;
    shell;
    constructor(manager, rootRef) {
        this.fsd = new FileSystemCore_1.FileSystemCore(manager);
        this.shell = new ShellFileSystem_1.ShellFileSystem(this);
        this.cache_file_refs_enabled = true;
        this.rootRef = rootRef;
    }
    openFile(path, mode, lock, options) {
        return this.openFileWithOnCreateContent(path, simplito_lazybuffer_1.Content.createEmpty(), mode, lock, options);
    }
    async openFileWithOnCreateContent(path, content, mode, lock, options) {
        if (this.cache_file_refs_enabled && mode && mode.isReadOnly()) {
            const entry = this.root.findRef(Path_1.Path.parse(path));
            if (entry != null && entry.isFile()) {
                const handle = await this.fsd.manager.getHandle(entry.ref);
                return this.fsd.checkVersioning(handle.createWithRights(true, false), options);
            }
        }
        const resolvedPath = await this.resolvePath(path);
        return this.fsd.openFileWithOnCreateContentD(resolvedPath, content, mode, lock, options);
    }
    async removeFile(path, signature, lockId) {
        const resolvedPath = await this.resolvePath(path);
        return this.fsd.removeFileD(resolvedPath, signature, lockId);
    }
    async removeMulti(dirPath, entries, options) {
        const resolvedDir = await this.resolvePathAsDirectory(dirPath);
        return this.fsd.removeMultiD(resolvedDir, entries, options);
    }
    async mkdir(path, options) {
        const resolvedPath = await this.resolvePath(path);
        return this.fsd.mkdirD(resolvedPath, options);
    }
    async list(path) {
        const resolvedPath = await this.resolvePath2(path);
        return this.fsd.listD(resolvedPath.getLast().entry, path);
    }
    async removeEmptyDir(path) {
        const resolvedPath = await this.resolvePath(path);
        return this.fsd.removeEmptyDirD(resolvedPath);
    }
    async move(sourcePath, destinationPath, options) {
        const [src, dst] = await Promise.all([
            this.resolvePath(sourcePath),
            this.resolvePath(destinationPath)
        ]);
        return this.fsd.moveD(src, dst, options);
    }
    async moveMulti(sourceDirPath, destinationDirPath, entries, options) {
        const [src, dst] = await Promise.all([
            this.resolvePathAsDirectory(sourceDirPath),
            this.resolvePathAsDirectory(destinationDirPath)
        ]);
        return this.fsd.moveMultiD(src, dst, entries, options);
    }
    async mkdirs(path) {
        const pathObj = await PathWalker_1.PathWalker.go(this.root, path, this.cache_file_refs_enabled);
        let curDir = this.root;
        let curDirPath = "/";
        for (const part of pathObj.parts.slice(1)) {
            const resolvedPath = this.fsd.createNextResolvedPath(curDir, curDirPath, part.name);
            const mkdirResult = await this.fsd.mkdir2D(resolvedPath);
            curDir = mkdirResult.directory;
            curDirPath = resolvedPath.path;
        }
    }
    async read(path, options) {
        const resolvedPath = await this.resolvePath(path);
        return this.fsd.readD(resolvedPath, options);
    }
    async readLazy(path, cache) {
        const resolvedPath = await this.resolvePath(path);
        return this.fsd.readLazyD(resolvedPath, cache);
    }
    async optRead(path, options) {
        const resolvedPath = await this.resolvePath(path);
        return this.fsd.optReadD(resolvedPath, options);
    }
    async optReadLazy(path, cache) {
        const resolvedPath = await this.resolvePath(path);
        return this.fsd.optReadLazyD(resolvedPath, cache);
    }
    async create(path, content, options) {
        const resolvedPath = await this.resolvePath(path);
        return this.fsd.createD(resolvedPath, content, options);
    }
    async openOrCreate(path, content, options) {
        const resolvedPath = await this.resolvePath(path);
        return this.fsd.openOrCreateD(resolvedPath, content, options);
    }
    async createEx(path, content, nameResolver, options) {
        const resolvedPath = await this.resolvePath(path);
        return this.fsd.createExD(resolvedPath, content, nameResolver, options);
    }
    async createEx2(path, content, nameResolver, options) {
        const resolvedPath = await this.resolvePath(path);
        return this.fsd.createEx2D(resolvedPath, content, nameResolver, options);
    }
    async save(path, content, options) {
        const resolvedPath = await this.resolvePath(path);
        return this.fsd.saveD(resolvedPath, content, options);
    }
    async saveAtExisting(path, content, options) {
        const resolvedPath = await this.resolvePath(path);
        return this.fsd.saveAtExistingD(resolvedPath, content, options);
    }
    async write(path, mode, content, options) {
        const resolvedPath = await this.resolvePath(path);
        return this.fsd.writeD(resolvedPath, mode, content, options);
    }
    async rename(path, name, options) {
        const resolvedPath = await this.resolvePath(path);
        return this.fsd.renameD(resolvedPath, name, options);
    }
    async stat(path, addMeta) {
        const pathObj = await PathWalker_1.PathWalker.go(this.root, path, this.cache_file_refs_enabled);
        if (!pathObj.isFullyResolved()) {
            throw new PrivFsException_1.PrivFsException("FILE_DOES_NOT_EXIST", path);
        }
        const last = pathObj.getLast();
        const res = {
            meta: null,
            entry: last.entry.toInfo(),
            version: null
        };
        if (addMeta === false) {
            return res;
        }
        const handle = await this.resolvePathPartToHandle(last);
        res.version = handle.currentVersion;
        const meta = await handle.getMeta();
        res.meta = meta;
        return res;
    }
    async refresh(path) {
        const pathObj = await PathWalker_1.PathWalker.go(this.root, path);
        if (!pathObj.isFullyResolved()) {
            throw new PrivFsException_1.PrivFsException("FILE_DOES_NOT_EXIST", path);
        }
    }
    async setVersioning(path, versioning) {
        const handle = await this.openFile(path, Mode_1.Mode.READ_ONLY);
        return handle.setVersioning(versioning);
    }
    async setAcl(path, acl) {
        const handle = await this.openFile(path, Mode_1.Mode.READ_ONLY);
        return handle.setAcl(acl);
    }
    async addDirectoryOnChangeCallback(path, callback) {
        const pathObj = await PathWalker_1.PathWalker.go(this.root, path, this.cache_file_refs_enabled);
        if (!pathObj.isFullyResolved()) {
            throw new PrivFsException_1.PrivFsException("DIRECTORY_DOES_NOT_EXIST", path);
        }
        const theLast = pathObj.getLast().entry;
        if (!theLast.isDirectory()) {
            throw new PrivFsException_1.PrivFsException("ELEMENT_IS_NOT_DIRECTORY", path);
        }
        return theLast.addOnChangeCallback(callback);
    }
    async removeDirectoryOnChangeCallback(path, callback) {
        const pathObj = await PathWalker_1.PathWalker.go(this.root, path, this.cache_file_refs_enabled);
        if (!pathObj.isFullyResolved()) {
            throw new PrivFsException_1.PrivFsException("DIRECTORY_DOES_NOT_EXIST", path);
        }
        const theLast = pathObj.getLast().entry;
        if (!theLast.isDirectory()) {
            throw new PrivFsException_1.PrivFsException("ELEMENT_IS_NOT_DIRECTORY", path);
        }
        return theLast.removeOnChangeCallback(callback);
    }
    async updateMeta(path, metaUpdater) {
        const pathObj = await PathWalker_1.PathWalker.go(this.root, path, this.cache_file_refs_enabled);
        if (!pathObj.isFullyResolved()) {
            throw new PrivFsException_1.PrivFsException("FILE_DOES_NOT_EXIST", path);
        }
        const handle = await this.resolvePathPartToHandle(pathObj.getLast());
        return handle.updateMeta({ metaUpdater: metaUpdater });
    }
    async getKeyValueFile(path, initialData, initialOptions) {
        const init = typeof (initialData) == "object" && initialData != null ? initialData : {};
        const mimeType = initialOptions && initialOptions.mimeType ? initialOptions.mimeType : "application/json";
        const version = await this.openOrCreate(path, simplito_lazybuffer_1.Content.createFromJson(init, mimeType), initialOptions);
        return KeyValueFile_1.KeyValueFile.create(version.handle);
    }
    async getVersionsHistory(path) {
        const handle = await this.resolvePathStringToHandle(path);
        return handle.getVersionsHistory();
    }
    async getLockHistory(path) {
        const handle = await this.resolvePathStringToHandle(path);
        return handle.getLockHistory();
    }
    async isLocked(path) {
        const handle = await this.resolvePathStringToHandle(path);
        return handle.isLocked();
    }
    async getLockedInfo(path) {
        const handle = await this.resolvePathStringToHandle(path);
        return handle.getLockedInfo();
    }
    async forcedLockRelease(path) {
        const handle = await this.resolvePathStringToHandle(path);
        return handle.forcedLockRelease();
    }
    async exists(path) {
        const pathObj = await PathWalker_1.PathWalker.go(this.root, path, this.cache_file_refs_enabled);
        return pathObj.isFullyResolved();
    }
    init(loadRoot) {
        return this.fsd.manager.performDeferredAction(this.initZ(loadRoot));
    }
    initZ(loadRoot) {
        return this.ensureRootZ(loadRoot);
    }
    ensureRoot(loadRoot) {
        return this.fsd.manager.performDeferredAction(this.ensureRootZ(loadRoot));
    }
    async ensureRootZ(loadRoot) {
        return ZPromise_1.ZPromise.create(async (manager) => {
            try {
                return await manager.getHandle(this.rootRef);
            }
            catch (e) {
                if (ApiErrorCodes_1.ApiErrorCodes.is(e, "DESCRIPTOR_DOESNT_EXIST")) {
                    const created = await this.fsd.manager.createUnderRef(this.rootRef, simplito_lazybuffer_1.Content.createFromJson([]), "directory", false, this.fsd.getDNVOptions(null));
                    return created.handle;
                }
                throw e;
            }
        })
            .next(handle => {
            this.root = Directory_1.Directory.fromHandle("", handle, null);
            return loadRoot !== false ? this.root.getEntries().then(() => null) : null;
        });
    }
    async resolvePathStringToHandle(path) {
        const pathObj = await PathWalker_1.PathWalker.go(this.root, path, this.cache_file_refs_enabled);
        if (!pathObj.isFullyResolved()) {
            throw new PrivFsException_1.PrivFsException("FILE_DOES_NOT_EXIST", path);
        }
        return this.resolvePathPartToHandle(pathObj.getLast());
    }
    async resolvePathPartToHandle(pathPart) {
        if (!(pathPart instanceof PathPart_1.PathPart) || !pathPart.isResolved()) {
            throw new privmx_exception_1.IllegalArgumentException("pathPart", pathPart);
        }
        if (pathPart.result != null) {
            return pathPart.result.createHandle();
        }
        return this.fsd.manager.getHandle(pathPart.entry.ref);
    }
    async resolvePath(path) {
        if (path == "/") {
            throw new privmx_exception_1.IllegalArgumentException("path", path);
        }
        const pathObj = await PathWalker_1.PathWalker.go(this.root, path, this.cache_file_refs_enabled);
        return pathObj.getResolvedPath();
    }
    async resolvePathAsDirectory(path) {
        if (path == "/") {
            return { directory: this.root, path: "/" };
        }
        const pathObj = await PathWalker_1.PathWalker.go(this.root, path, this.cache_file_refs_enabled);
        const dir = pathObj.getLastAsResolvedDirectory();
        if (dir == null) {
            throw new PrivFsException_1.PrivFsException("DIRECTORY_DOES_NOT_EXIST", path);
        }
        return { directory: dir, path: path };
    }
    resolvePath2(path) {
        return PathWalker_1.PathWalker.go(this.root, path, this.cache_file_refs_enabled);
    }
    isSimpleTransferableContent(content) {
        return this.fsd.isSimpleTransferableContent(this.root, content);
    }
    createSimpleTransferableContent(content, streamOptions) {
        return this.fsd.createSimpleTransferableContent(this.root, content, streamOptions);
    }
}
exports.FileSystem = FileSystem;

},{"../../core/ApiErrorCodes":138,"../../core/ZPromise":164,"../../exception/PrivFsException":172,"./FileSystemCore":192,"./KeyValueFile":193,"./Mode":194,"./ShellFileSystem":196,"./entry/Directory":197,"./path/Path":203,"./path/PathPart":204,"./path/PathWalker":205,"privmx-exception":286,"simplito-lazybuffer":398}],192:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileSystemCore = void 0;
const Mode_1 = require("./Mode");
const Handle_1 = require("../descriptor/Handle");
const Directory_1 = require("./entry/Directory");
const PrivFsException_1 = require("../../exception/PrivFsException");
const Streamer_1 = require("../descriptor/Streamer");
const simplito_lazybuffer_1 = require("simplito-lazybuffer");
const DescriptorMultiStorageProvider_1 = require("../descriptor/DescriptorMultiStorageProvider");
const ApiErrorCodes_1 = require("../../core/ApiErrorCodes");
const Entry_1 = require("./entry/Entry");
const Path_1 = require("./path/Path");
const SimpleNameResolver_1 = require("./entry/SimpleNameResolver");
const RootLogger = require("simplito-logger");
const ZPromise_1 = require("../../core/ZPromise");
const Logger = RootLogger.get("privfs-client.fs.file.FileSystem");
class FileSystemCore {
    manager;
    defaultOptions;
    constructor(manager) {
        this.manager = manager;
    }
    openFileD(path, mode, lock, options) {
        return this.openFileWithOnCreateContentD(path, simplito_lazybuffer_1.Content.createEmpty(), mode, lock, options);
    }
    openFileWithOnCreateContentD(path, onCreateContent, mode, lock, options) {
        mode = mode || Mode_1.Mode.READ_WRITE_CREATE;
        return Promise.resolve().then(() => {
            const tryPerform = () => {
                return Promise.resolve().then(() => {
                    return path.directory.getEntryByName(path.name);
                })
                    .then(entry => {
                    if (entry) {
                        if (!entry.isFile()) {
                            throw new PrivFsException_1.PrivFsException("ELEMENT_IS_NOT_FILE", path.path);
                        }
                        if (mode.shouldFailWhenExist()) {
                            throw new PrivFsException_1.PrivFsException("FILE_ALREADY_EXISTS", path.path);
                        }
                        if (mode.isWrite() && lock) {
                            return this.manager.lock(entry.ref).then(res => {
                                const handle = new Handle_1.Handle(entry.ref, res.version.descriptor, res.version);
                                handle.lockObj = res.lock;
                                return handle;
                            });
                        }
                        return this.manager.getHandleFromCache(entry.ref);
                    }
                    else {
                        if (!mode.shouldCreateWhenNotExist() || !mode.isWrite()) {
                            throw new PrivFsException_1.PrivFsException("FILE_DOES_NOT_EXIST", path.path);
                        }
                        return Promise.resolve().then(() => {
                            return this.manager.generateRef(null);
                        })
                            .then(ref => {
                            const newEntry = new Entry_1.Entry(path.name, "file", ref);
                            return new DescriptorMultiStorageProvider_1.DescriptorMultiStorageProvider(path.directory.getStorage(), "transaction").performS([
                                this.manager.createUnderRefZ(ref, onCreateContent, "file", lock, this.getDNVOptions(options)),
                                path.directory.addEntryZ(newEntry)
                            ])
                                .then(res => {
                                if (res[1].status == "rejected") {
                                    return path.directory.onError(res[1].reason, tryPerform);
                                }
                                return res[0].value.handle;
                            });
                        });
                    }
                });
            };
            return tryPerform();
        })
            .then(handle => {
            return this.checkVersioning(handle.createWithRights(mode.isRead(), mode.isWrite()), options);
        });
    }
    async removeMultiD(source, entries, options) {
        const maxOperationsInTransation = source.directory.descriptor.storage.config.maxDescriptorMultiBulkSize || 10;
        const maxFilesRemovedInTransaction = maxOperationsInTransation - 1;
        let list = entries;
        const result = [];
        while (list.length > 0) {
            const current = list.slice(0, maxFilesRemovedInTransaction);
            list = list.slice(maxFilesRemovedInTransaction);
            const chunk = await this.removeMultiDCore(source, current, options);
            result.push(chunk);
        }
        return result.flat();
    }
    async removeMultiDCore(directory, entries, options) {
        const opts = options || {};
        if (entries.length == 0) {
            return [];
        }
        const tryRemove = async () => {
            const dirEntries = await directory.directory.getEntriesObject();
            const toProceed = entries.map(entryName => {
                const entryPath = Path_1.Path.join(directory.path, entryName);
                const entry = dirEntries.getByName(entryName);
                if (entry != null) {
                    if (!entry.isFile()) {
                        throw new PrivFsException_1.PrivFsException("ELEMENT_IS_NOT_FILE", entryPath);
                    }
                    if (!entry.ref.hasWriteRights()) {
                        throw new PrivFsException_1.PrivFsException("NO_WRITE_RIGHTS", entryPath);
                    }
                }
                return { entry, entryName, entryPath };
            });
            const promises = [
                directory.directory.removeEntriesZ(toProceed.map(x => x.entryName))
            ];
            const doNothing = toProceed.filter(x => x.entry == null);
            const toRemove = toProceed.filter(x => x.entry != null);
            toRemove.forEach(x => promises.push(this.manager.removeByRefZ(x.entry.ref, null, null)));
            const res = await new DescriptorMultiStorageProvider_1.DescriptorMultiStorageProvider(directory.directory.getStorage(), "transaction").performS(promises);
            if (res[0].status == "rejected") {
                if (opts.retryAtFail && res[0].reason == "OPERATION_NOT_PERFORMED") {
                    const newEntries = [];
                    const preResult = doNothing.map(x => ({
                        removed: false,
                        srcFileName: x.entryName,
                        srcFilePath: x.entryPath
                    }));
                    for (let i = 1; i < res.length; i++) {
                        const result = res[i];
                        const entry = toRemove[i - 1];
                        if (result.status !== "rejected") {
                            throw res[0].reason;
                        }
                        if (result.reason == "OPERATION_NOT_PERFORMED") {
                            newEntries.push(entry.entryName);
                        }
                        else {
                            preResult.push({
                                removed: false,
                                srcFileName: entry.entryName,
                                srcFilePath: entry.entryPath,
                                error: result.reason
                            });
                        }
                    }
                    const newResult = await this.removeMultiDCore(directory, newEntries);
                    return preResult.concat(newResult);
                }
                return directory.directory.onError(res[0].reason, tryRemove);
            }
            return toProceed.map(x => {
                const res = {
                    removed: x.entry != null,
                    srcFileName: x.entryName,
                    srcFilePath: x.entryPath
                };
                return res;
            });
        };
        return tryRemove();
    }
    removeFileD(path, signature, lockId) {
        return Promise.resolve().then(() => {
            const tryRemove = () => {
                return Promise.resolve().then(() => {
                    return path.directory.getEntryByName(path.name);
                })
                    .then(entry => {
                    if (entry == null) {
                        return false;
                    }
                    if (!entry.isFile()) {
                        throw new PrivFsException_1.PrivFsException("ELEMENT_IS_NOT_FILE", path.path);
                    }
                    if (!entry.ref.hasWriteRights()) {
                        throw new PrivFsException_1.PrivFsException("NO_WRITE_RIGHTS", path.path);
                    }
                    return new DescriptorMultiStorageProvider_1.DescriptorMultiStorageProvider(path.directory.getStorage(), "transaction").performS([
                        path.directory.removeEntryZ(entry.name),
                        this.manager.removeByRefZ(entry.ref, signature, lockId)
                    ])
                        .then(res => {
                        if (res[0].status == "rejected" && res[1].status == "rejected") {
                            if (res[0].reason == "OPERATION_NOT_PERFORMED") {
                                return Promise.reject(res[1].reason);
                            }
                            return path.directory.onError(res[0].reason, tryRemove);
                        }
                        return true;
                    });
                });
            };
            return tryRemove();
        });
    }
    mkdirD(path, options) {
        return this.mkdir2D(path, options).then(res => res.created);
    }
    mkdir2D(path, options) {
        return Promise.resolve().then(() => {
            const url = null;
            const tryCreate = () => {
                return Promise.resolve().then(() => {
                    return path.directory.getEntryByName(path.name);
                })
                    .then(entry => {
                    if (entry != null) {
                        if (!entry.isDirectory()) {
                            throw new PrivFsException_1.PrivFsException("ELEMENT_IS_NOT_DIRECTORY", path.path);
                        }
                        return { directory: entry, created: false };
                    }
                    return Promise.resolve().then(() => {
                        return this.manager.generateRef(url);
                    })
                        .then(ref => {
                        const { directory: newEntry, updater } = Directory_1.Directory.createWithHandleUpdater(path.name, ref, this.manager);
                        return new DescriptorMultiStorageProvider_1.DescriptorMultiStorageProvider(path.directory.getStorage(), "transaction").performS([
                            this.manager.createUnderRefZ(ref, simplito_lazybuffer_1.Content.createFromJson([]), "directory", false, this.getDNVOptions(options)).then(x => x.next(res => {
                                updater(res.handle, []);
                            })),
                            path.directory.addEntryZ(newEntry)
                        ])
                            .then(res => {
                            if (res[1].status == "rejected") {
                                return path.directory.onError(res[1].reason, tryCreate);
                            }
                            return { directory: newEntry, created: true };
                        });
                    });
                });
            };
            return tryCreate();
        });
    }
    listD(entry, directoryPath) {
        return Promise.resolve().then(() => {
            if (entry == null) {
                throw new PrivFsException_1.PrivFsException("DIRECTORY_DOES_NOT_EXIST", directoryPath);
            }
            if (!entry.isDirectory()) {
                throw new PrivFsException_1.PrivFsException("ELEMENT_IS_NOT_DIRECTORY", directoryPath);
            }
            return entry.getEntries();
        })
            .then(dEntries => {
            return dEntries.list;
        });
    }
    removeEmptyDirD(path) {
        return Promise.resolve().then(() => {
            const tryRemove = () => {
                return Promise.resolve().then(() => {
                    return path.directory.getEntryByName(path.name);
                })
                    .then(entry => {
                    if (entry == null) {
                        return false;
                    }
                    if (!entry.isDirectory()) {
                        throw new PrivFsException_1.PrivFsException("ELEMENT_IS_NOT_DIRECTORY", path.path);
                    }
                    if (!entry.ref.hasWriteRights()) {
                        throw new PrivFsException_1.PrivFsException("NO_WRITE_RIGHTS", path.path);
                    }
                    return Promise.resolve().then(() => {
                        return entry.getEntries();
                    })
                        .then(dEntries => {
                        if (dEntries.list.length > 0) {
                            throw new PrivFsException_1.PrivFsException("DIRECTORY_IS_NOT_EMPTY", path.path);
                        }
                        return new DescriptorMultiStorageProvider_1.DescriptorMultiStorageProvider(path.directory.getStorage(), "transaction").performS([
                            path.directory.removeEntryZ(entry.name),
                            this.manager.removeByRefZ(entry.ref, entry.getCurrentVersion(), null)
                        ])
                            .then(res => {
                            if ((res[0].status == "rejected" && ApiErrorCodes_1.ApiErrorCodes.is(res[0].reason, "OLD_SIGNATURE_DOESNT_MATCH")) ||
                                (res[1].status == "rejected" && ApiErrorCodes_1.ApiErrorCodes.is(res[1].reason, "OLD_SIGNATURE_DOESNT_MATCH"))) {
                                return Promise.all([
                                    path.directory.refresh(),
                                    entry.refresh()
                                ])
                                    .then(() => {
                                    return tryRemove();
                                });
                            }
                            return true;
                        });
                    });
                });
            };
            return tryRemove();
        });
    }
    async moveMultiD(source, destination, entries, options) {
        if (options && !options.metaUpdater && options.markAsUpdated === false) {
            return this.moveMultiDCore(source, destination, entries, options);
        }
        const maxOperationsInTransation = source.directory.descriptor.storage.config.maxDescriptorMultiBulkSize || 10;
        const maxFilesMovedInTransaction = maxOperationsInTransation - 2;
        let list = entries;
        const result = [];
        while (list.length > 0) {
            const current = list.slice(0, maxFilesMovedInTransaction);
            list = list.slice(maxFilesMovedInTransaction);
            const chunk = await this.moveMultiDCore(source, destination, current, options);
            result.push(chunk);
        }
        return result.flat();
    }
    async moveMultiDCore(source, destination, entries, options) {
        const opts = options || {};
        const tryModify = async () => {
            const [sourceEntries, destEntries] = await Promise.all([
                source.directory.getEntriesObject(),
                destination.directory.getEntriesObject()
            ]);
            const usedNames = new Set();
            const toProceedAll = entries.map(mve => {
                const mvEntry = typeof (mve) == "string" ? { src: mve, dst: mve } : mve;
                const sourceName = mvEntry.src;
                const sourcePath = Path_1.Path.join(source.path, sourceName);
                const sourceEntry = sourceEntries.getByName(sourceName);
                if (sourceEntry == null) {
                    throw new PrivFsException_1.PrivFsException("FILE_DOES_NOT_EXIST", sourcePath);
                }
                let destinationName = mvEntry.dst;
                let destinationPath = Path_1.Path.join(destination.path, destinationName);
                if (sourcePath != destinationPath) {
                    const oldDestinationEntry = destEntries.getByName(destinationName);
                    if (oldDestinationEntry != null || usedNames.has(destinationName)) {
                        const nResolver = SimpleNameResolver_1.SimpleNameResolver.getNameResolver(opts.nameResolver, sourceEntry.isFile(), destinationName);
                        if (nResolver == null) {
                            throw new PrivFsException_1.PrivFsException("FILE_ALREADY_EXISTS", destinationPath);
                        }
                        while (destEntries.hasName(destinationName) || usedNames.has(destinationName)) {
                            destinationName = nResolver.getNextName();
                            if (destinationName == null) {
                                throw new PrivFsException_1.PrivFsException("FILE_ALREADY_EXISTS", destinationPath);
                            }
                        }
                        destinationPath = Path_1.Path.join(destination.path, destinationName);
                    }
                    usedNames.add(destinationName);
                }
                const destinationEntry = sourceEntry.getCopyWithName(destinationName);
                return { sourceName, sourcePath, sourceEntry, destinationName, destinationPath, destinationEntry, mve };
            });
            const theSame = toProceedAll.filter(x => x.sourcePath == x.destinationPath);
            const toProceed = toProceedAll.filter(x => x.sourcePath != x.destinationPath);
            const promises = source.path == destination.path ? [
                destination.directory.renameEntriesZ(toProceed.map(x => ({ oldName: x.sourceName, newName: x.destinationName }))),
            ] : [
                destination.directory.addEntriesZ(toProceed.map(x => x.destinationEntry)),
                source.directory.removeEntriesZ(toProceed.map(x => x.sourceName))
            ];
            const basePromisesCount = promises.length;
            if (opts.metaUpdater) {
                toProceedAll.forEach(x => promises.push(this.manager.getHandleFromCache(x.sourceEntry.ref).then(handle => handle.updateMetaZ({
                    metaUpdater: meta => opts.metaUpdater(x.sourceName, x.sourcePath, x.destinationName, x.destinationPath, meta)
                }))));
            }
            else if (opts.markAsUpdated !== false) {
                toProceedAll.forEach(x => promises.push(Promise.resolve(ZPromise_1.ZPromise.create(gateway => gateway.descriptorMarkAsUpdated(x.sourceEntry.ref.did)))));
            }
            const res = await new DescriptorMultiStorageProvider_1.DescriptorMultiStorageProvider(source.directory.getStorage(), "transaction").performS(promises);
            if (res.some(x => x.status == "rejected" && ApiErrorCodes_1.ApiErrorCodes.is(x.reason, "OLD_SIGNATURE_DOESNT_MATCH"))) {
                return Promise.all([
                    source.directory.refresh(),
                    destination.directory.refresh(),
                    opts.metaUpdater || opts.markAsUpdated !== false ? Promise.all(toProceedAll.map(x => this.manager.getDescriptor(x.sourceEntry.ref))) : null
                ])
                    .then(() => {
                    return tryModify();
                });
            }
            if (res.some(x => x.status == "rejected")) {
                if (opts.retryAtFail && res[0].status == "rejected" && res[0].reason == "OPERATION_NOT_PERFORMED") {
                    const newEntries = theSame.map(x => x.mve);
                    const preResult = [];
                    for (let i = basePromisesCount; i < res.length; i++) {
                        const result = res[i];
                        const entry = toProceed[i - basePromisesCount];
                        if (result.status !== "rejected") {
                            return Promise.reject({ msg: "errors during move transaction", res });
                        }
                        if (result.reason == "OPERATION_NOT_PERFORMED") {
                            newEntries.push(entry.mve);
                        }
                        else {
                            preResult.push({
                                srcFileName: entry.sourceName,
                                srcFilePath: entry.sourcePath,
                                dstFileName: entry.destinationName,
                                dstFilePath: entry.destinationPath,
                                error: result.reason
                            });
                        }
                    }
                    const newResult = await this.moveMultiDCore(source, destination, newEntries, options);
                    return preResult.concat(newResult);
                }
                return Promise.reject({ msg: "errors during move transaction", res });
            }
            return toProceedAll.map(x => {
                const res = {
                    srcFileName: x.sourceName,
                    srcFilePath: x.sourcePath,
                    dstFileName: x.destinationName,
                    dstFilePath: x.destinationPath
                };
                return res;
            });
        };
        return tryModify();
    }
    moveD(source, destination, options) {
        const opts = options || {};
        return Promise.resolve().then(() => {
            if (source.directory.ref.id == destination.directory.ref.id) {
                const tryModify = () => {
                    return Promise.resolve().then(() => {
                        return source.directory.getEntriesObject();
                    })
                        .then(sourceEntries => {
                        const entry = sourceEntries.getByName(source.name);
                        if (entry == null) {
                            throw new PrivFsException_1.PrivFsException("FILE_DOES_NOT_EXIST", source.path);
                        }
                        let destinationName = destination.name;
                        const destinationEntry = sourceEntries.getByName(destinationName);
                        if (destinationEntry != null) {
                            const nResolver = SimpleNameResolver_1.SimpleNameResolver.getNameResolver(opts.nameResolver, destinationEntry.isFile(), destinationName);
                            if (nResolver == null) {
                                throw new PrivFsException_1.PrivFsException("FILE_ALREADY_EXISTS", destination.path);
                            }
                            while (sourceEntries.hasName(destinationName)) {
                                destinationName = nResolver.getNextName();
                                if (destinationName == null) {
                                    throw new PrivFsException_1.PrivFsException("FILE_ALREADY_EXISTS", destination.path);
                                }
                            }
                        }
                        const newEntryPath = (new Path_1.Path(destination.path)).getPathStringWithoutLastAnd(destinationName);
                        return Promise.resolve().then(() => {
                            if (opts.metaUpdater) {
                                return new DescriptorMultiStorageProvider_1.DescriptorMultiStorageProvider(source.directory.getStorage(), "transaction").performS([
                                    source.directory.renameEntryZ(source.name, destinationName),
                                    this.manager.getHandleFromCache(entry.ref).then(handle => handle.updateMetaZ({ metaUpdater: opts.metaUpdater }))
                                ]);
                            }
                            if (opts.markAsUpdated === false) {
                                return new DescriptorMultiStorageProvider_1.DescriptorMultiStorageProvider(source.directory.getStorage(), "transaction").performS([
                                    source.directory.renameEntryZ(source.name, destinationName)
                                ]);
                            }
                            return new DescriptorMultiStorageProvider_1.DescriptorMultiStorageProvider(source.directory.getStorage(), "transaction").performS([
                                source.directory.renameEntryZ(source.name, destinationName),
                                Promise.resolve(ZPromise_1.ZPromise.create(gateway => gateway.descriptorMarkAsUpdated(entry.ref.did)))
                            ]);
                        })
                            .then(res => {
                            if (res.some(x => x.status == "rejected" && ApiErrorCodes_1.ApiErrorCodes.is(x.reason, "OLD_SIGNATURE_DOESNT_MATCH"))) {
                                return Promise.all([
                                    source.directory.refresh(),
                                    opts.metaUpdater || opts.markAsUpdated !== false ? this.manager.getDescriptor(entry.ref) : null
                                ])
                                    .then(() => {
                                    return tryModify();
                                });
                            }
                            if (res.some(x => x.status == "rejected")) {
                                return Promise.reject({ msg: "errors during rename transaction", res });
                            }
                            return { fileName: destinationName, filePath: newEntryPath };
                        });
                    });
                };
                return tryModify();
            }
            const tryModify = () => {
                return Promise.all([
                    source.directory.getEntriesObject(),
                    destination.directory.getEntriesObject()
                ])
                    .then(res => {
                    const [sourceEntries, destEntries] = res;
                    const entry = sourceEntries.getByName(source.name);
                    if (entry == null) {
                        throw new PrivFsException_1.PrivFsException("FILE_DOES_NOT_EXIST", source.path);
                    }
                    let destinationName = destination.name;
                    const destinationEntry = destEntries.getByName(destinationName);
                    if (destinationEntry != null) {
                        const nResolver = SimpleNameResolver_1.SimpleNameResolver.getNameResolver(opts.nameResolver, destinationEntry.isFile(), destinationName);
                        if (nResolver == null) {
                            throw new PrivFsException_1.PrivFsException("FILE_ALREADY_EXISTS", destination.path);
                        }
                        while (destEntries.hasName(destinationName)) {
                            destinationName = nResolver.getNextName();
                            if (destinationName == null) {
                                throw new PrivFsException_1.PrivFsException("FILE_ALREADY_EXISTS", destination.path);
                            }
                        }
                    }
                    const newEntry = entry.getCopyWithName(destinationName);
                    const newEntryPath = (new Path_1.Path(destination.path)).getPathStringWithoutLastAnd(destinationName);
                    return Promise.resolve().then(() => {
                        if (opts.metaUpdater) {
                            return new DescriptorMultiStorageProvider_1.DescriptorMultiStorageProvider(source.directory.getStorage(), "transaction").performS([
                                destination.directory.addEntryZ(newEntry),
                                source.directory.removeEntryZ(source.name),
                                this.manager.getHandleFromCache(entry.ref).then(handle => handle.updateMetaZ({ metaUpdater: opts.metaUpdater }))
                            ]);
                        }
                        if (opts.markAsUpdated === false) {
                            return new DescriptorMultiStorageProvider_1.DescriptorMultiStorageProvider(source.directory.getStorage(), "transaction").performS([
                                destination.directory.addEntryZ(newEntry),
                                source.directory.removeEntryZ(source.name)
                            ]);
                        }
                        return new DescriptorMultiStorageProvider_1.DescriptorMultiStorageProvider(source.directory.getStorage(), "transaction").performS([
                            destination.directory.addEntryZ(newEntry),
                            source.directory.removeEntryZ(source.name),
                            Promise.resolve(ZPromise_1.ZPromise.create(gateway => gateway.descriptorMarkAsUpdated(entry.ref.did)))
                        ]);
                    })
                        .then(res => {
                        if (res.some(x => x.status == "rejected" && ApiErrorCodes_1.ApiErrorCodes.is(x.reason, "OLD_SIGNATURE_DOESNT_MATCH"))) {
                            return Promise.all([
                                source.directory.refresh(),
                                destination.directory.refresh(),
                                opts.metaUpdater || opts.markAsUpdated !== false ? this.manager.getDescriptor(entry.ref) : null
                            ])
                                .then(() => {
                                return tryModify();
                            });
                        }
                        if (res.some(x => x.status == "rejected")) {
                            return Promise.reject({ msg: "errors during move transaction", res });
                        }
                        return { fileName: destinationName, filePath: newEntryPath };
                    });
                });
            };
            return tryModify();
        });
    }
    readD(path, options) {
        return Promise.resolve().then(() => {
            return this.openFileD(path, Mode_1.Mode.READ_ONLY);
        })
            .then(handle => {
            return handle.read(options);
        });
    }
    readLazyD(path, cache) {
        return Promise.resolve().then(() => {
            return this.openFileD(path, Mode_1.Mode.READ_ONLY);
        })
            .then(handle => {
            return handle.getBlocksInfo(cache);
        });
    }
    optReadD(path, options) {
        return Promise.resolve().then(() => {
            return this.readD(path, options);
        })
            .catch(e => {
            if (!PrivFsException_1.PrivFsException.is(e, "FILE_DOES_NOT_EXIST")) {
                return Promise.reject(e);
            }
            return null;
        });
    }
    optReadLazyD(path, cache) {
        return Promise.resolve().then(() => {
            return this.readLazyD(path, cache);
        })
            .catch(e => {
            if (!PrivFsException_1.PrivFsException.is(e, "FILE_DOES_NOT_EXIST")) {
                return Promise.reject(e);
            }
            return null;
        });
    }
    isSimpleTransferableContent(directory, content) {
        return Streamer_1.Streamer.isSimpleTransferableContent(directory.descriptor.storage, content);
    }
    createSimpleTransferableContent(directory, content, streamOptions) {
        return Streamer_1.Streamer.createSimpleTransferableContent(directory.descriptor.storage, content, streamOptions);
    }
    writeD(path, mode, content, options) {
        if (mode.createWhenNotExist && this.isSimpleTransferableContent(path.directory, content)) {
            return Promise.resolve().then(() => {
                return this.openFileWithOnCreateContentD(path, content, mode, false, options);
            })
                .then(handle => {
                if (handle.created) {
                    return handle.getCurrentVersionSnapshot();
                }
                let opt = this.getDNVOptions(options) || {};
                opt.releaseLock = true;
                return handle.write(content, opt);
            });
        }
        return Promise.resolve().then(() => {
            return this.openFileD(path, mode, false, options);
        })
            .then(handle => {
            const opt = this.getDNVOptions(options) || {};
            opt.releaseLock = true;
            return handle.write(content, opt);
        });
    }
    saveD(path, content, options) {
        return this.writeD(path, Mode_1.Mode.READ_WRITE_CREATE, content, options);
    }
    saveAtExistingD(path, content, options) {
        return this.writeD(path, Mode_1.Mode.READ_WRITE, content, options);
    }
    createD(path, content, options) {
        return this.writeD(path, Mode_1.Mode.READ_WRITE_EXCL, content, options);
    }
    openOrCreateD(path, content, options) {
        if (this.isSimpleTransferableContent(path.directory, content)) {
            return Promise.resolve().then(() => {
                return this.openFileWithOnCreateContentD(path, content, Mode_1.Mode.READ_WRITE_CREATE, false, options);
            })
                .then(handle => {
                return handle.getCurrentVersionSnapshot();
            });
        }
        return Promise.resolve().then(() => {
            return this.openFileD(path, Mode_1.Mode.READ_WRITE_CREATE, false, options);
        })
            .then(handle => {
            if (handle.created) {
                return handle.write(content, this.getDNVOptions(options));
            }
            return handle.getCurrentVersionSnapshot();
        });
    }
    createExD(path, content, nameResolver, options) {
        const simpleTransferableContent = this.isSimpleTransferableContent(path.directory, content);
        let usedPath = path;
        return Promise.resolve().then(() => {
            const tryOpen = () => {
                return Promise.resolve().then(() => {
                    return path.directory.getEntriesObject();
                })
                    .then(entries => {
                    usedPath = path;
                    if (entries.hasName(usedPath.name)) {
                        const nResolver = SimpleNameResolver_1.SimpleNameResolver.getNameResolver(nameResolver, true, usedPath.name);
                        if (nResolver == null) {
                            throw new PrivFsException_1.PrivFsException("FILE_ALREADY_EXISTS", usedPath.path);
                        }
                        while (entries.hasName(usedPath.name)) {
                            const entryName = nResolver.getNextName();
                            if (entryName == null) {
                                throw new PrivFsException_1.PrivFsException("FILE_ALREADY_EXISTS", path.path);
                            }
                            usedPath = this.createResolvedPath(path, entryName);
                        }
                    }
                    const promise = simpleTransferableContent ?
                        this.openFileWithOnCreateContentD(usedPath, content, Mode_1.Mode.READ_WRITE_EXCL, false, options) :
                        this.openFileD(usedPath, Mode_1.Mode.READ_WRITE_EXCL, false, options);
                    return promise.catch(e => {
                        if (PrivFsException_1.PrivFsException.is(e, "FILE_ALREADY_EXISTS")) {
                            return tryOpen();
                        }
                        return Promise.reject(e);
                    });
                });
            };
            return tryOpen();
        })
            .then(handle => {
            if (simpleTransferableContent) {
                return handle.getCurrentVersionSnapshot();
            }
            const opt = this.getDNVOptions(options) || {};
            opt.releaseLock = true;
            return handle.write(content, opt);
        })
            .then(version => {
            return {
                path: usedPath.path,
                version: version
            };
        });
    }
    createEx2D(path, content, nameResolver, options) {
        return Promise.resolve().then(() => {
            return this.createSimpleTransferableContent(path.directory, content, options ? options.streamOptions : null);
        })
            .then(newContent => {
            return this.createExD(path, newContent, nameResolver, options);
        });
    }
    renameD(path, newName, options) {
        return this.moveD(path, this.createResolvedPath(path, newName), options);
    }
    createResolvedPath(path, newName) {
        return {
            directory: path.directory,
            name: newName,
            path: (new Path_1.Path(path.path)).getPathStringWithoutLastAnd(newName)
        };
    }
    createNextResolvedPath(directory, dirPath, entryName) {
        return {
            directory: directory,
            name: entryName,
            path: (new Path_1.Path(dirPath)).getPathStringWith(entryName)
        };
    }
    getDNVOptions(options) {
        if (!this.defaultOptions) {
            return options;
        }
        const result = {};
        for (const key in options) {
            result[key] = options[key];
        }
        for (const key in this.defaultOptions) {
            if (!(key in result)) {
                result[key] = this.defaultOptions[key];
            }
        }
        return result;
    }
    checkVersioning(handle, options) {
        return Promise.resolve().then(() => {
            options = this.getDNVOptions(options);
            const versioning = !options || options.versioning !== false;
            if (options && options.checkVersioning && handle.descriptor.versioning != versioning) {
                return handle.setVersioning(versioning).catch(e => {
                    Logger.error("Error during setting versioning", e);
                })
                    .then(() => handle);
            }
            return handle;
        });
    }
}
exports.FileSystemCore = FileSystemCore;

},{"../../core/ApiErrorCodes":138,"../../core/ZPromise":164,"../../exception/PrivFsException":172,"../descriptor/DescriptorMultiStorageProvider":177,"../descriptor/Handle":179,"../descriptor/Streamer":184,"./Mode":194,"./entry/Directory":197,"./entry/Entry":199,"./entry/SimpleNameResolver":200,"./path/Path":203,"simplito-lazybuffer":398,"simplito-logger":407}],193:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyValueFile = void 0;
const Utils = require("simplito-utils");
const simplito_promise_1 = require("simplito-promise");
const simplito_lazybuffer_1 = require("simplito-lazybuffer");
class KeyValueFile {
    map;
    handle;
    saveQueue;
    constructor(handle) {
        this.handle = handle;
        this.saveQueue = new simplito_promise_1.PromiseQueue();
    }
    static create(handle) {
        return new KeyValueFile(handle).init();
    }
    init() {
        return Promise.resolve().then(() => {
            return this.handle.read({ cache: false });
        })
            .then(map => {
            this.map = map.isEmpty() ? {} : map.getJson();
            return this;
        });
    }
    async save(data) {
        await this.handle.refreshAndUpdateToLastVersion();
        await this.handle.write(simplito_lazybuffer_1.Content.createFromJson(data));
    }
    hasKey(key) {
        return key in this.map;
    }
    hasValue(value) {
        for (const key in this.map) {
            if (this.map[key] == value) {
                return true;
            }
        }
        return false;
    }
    getValueByKey(key) {
        return key in this.map ? this.map[key] : null;
    }
    getKeyByValue(value) {
        for (const key in this.map) {
            if (this.map[key] == value) {
                return key;
            }
        }
        return null;
    }
    set(key, value) {
        let copy;
        return this.saveQueue.add(() => {
            return Promise.resolve().then(() => {
                copy = this.setAtCopy(key, value);
                return this.save(copy);
            })
                .then(() => {
                this.map = copy;
            });
        });
    }
    setAtCopy(key, value) {
        const copy = Utils.simpleDeepClone(this.map);
        copy[key] = value;
        return copy;
    }
    remove(key) {
        let copy;
        return this.saveQueue.add(() => {
            return Promise.resolve().then(() => {
                copy = this.removeAtCopy(key);
                return this.save(copy);
            })
                .then(() => {
                this.map = copy;
            });
        });
    }
    removeAtCopy(key) {
        const copy = Utils.simpleDeepClone(this.map);
        delete copy[key];
        return copy;
    }
    isEmpty() {
        return Object.keys(this.map).length === 0;
    }
    getAll() {
        return Utils.simpleDeepClone(this.map);
    }
    replaceData(data, dontSave) {
        if (dontSave) {
            this.map = data;
            return Promise.resolve();
        }
        const file = this;
        return this.saveQueue.add(() => {
            return Promise.resolve().then(() => {
                return file.save(data);
            })
                .then(() => {
                file.map = data;
            });
        });
    }
}
exports.KeyValueFile = KeyValueFile;

},{"simplito-lazybuffer":398,"simplito-promise":421,"simplito-utils":422}],194:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mode = void 0;
const privmx_exception_1 = require("privmx-exception");
class Mode {
    static READ_ONLY = new Mode(true, false, false, false);
    static WRITE_ONLY = new Mode(false, true, false, false);
    static READ_WRITE = new Mode(true, true, false, false);
    static WRITE_CREATE = new Mode(false, true, true, false);
    static READ_WRITE_CREATE = new Mode(true, true, true, false);
    static WRITE_EXCL = new Mode(false, true, true, true);
    static READ_WRITE_EXCL = new Mode(true, true, true, true);
    read;
    write;
    createWhenNotExist;
    failWhenExist;
    constructor(read, write, createWhenNotExist, failWhenExist) {
        if (typeof (read) != "boolean") {
            throw new privmx_exception_1.IllegalArgumentException("read", read);
        }
        if (typeof (write) != "boolean") {
            throw new privmx_exception_1.IllegalArgumentException("write", write);
        }
        if (typeof (createWhenNotExist) != "boolean" || (createWhenNotExist == true && write == false)) {
            throw new privmx_exception_1.IllegalArgumentException("createWhenNotExist", createWhenNotExist);
        }
        if (typeof (failWhenExist) != "boolean" || (createWhenNotExist == false && failWhenExist == true)) {
            throw new privmx_exception_1.IllegalArgumentException("failWhenExist", failWhenExist);
        }
        Object.defineProperty(this, "read", {
            value: read,
            enumerable: true
        });
        Object.defineProperty(this, "write", {
            value: write,
            enumerable: true
        });
        Object.defineProperty(this, "createWhenNotExist", {
            value: createWhenNotExist,
            enumerable: true
        });
        Object.defineProperty(this, "failWhenExist", {
            value: failWhenExist,
            enumerable: true
        });
    }
    isRead() {
        return this.read;
    }
    isWrite() {
        return this.write;
    }
    isReadOnly() {
        return this.read && !this.write;
    }
    isWriteOnly() {
        return !this.read && this.write;
    }
    isReadWrite() {
        return this.read && this.write;
    }
    shouldCreateWhenNotExist() {
        return this.createWhenNotExist;
    }
    shouldFailWhenExist() {
        return this.failWhenExist;
    }
}
exports.Mode = Mode;

},{"privmx-exception":286}],195:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiOperation = exports.OperationStatus = exports.OperationType = void 0;
const PathWalker_1 = require("./path/PathWalker");
const PrivFsException_1 = require("../../exception/PrivFsException");
const simplito_promise_1 = require("simplito-promise");
const RootLogger = require("simplito-logger");
const Logger = RootLogger.get("privfs-client.fs.file.MultiOperation");
var OperationType;
(function (OperationType) {
    OperationType[OperationType["COPY"] = 0] = "COPY";
    OperationType[OperationType["MOVE"] = 1] = "MOVE";
    OperationType[OperationType["REMOVE"] = 2] = "REMOVE";
    OperationType[OperationType["REMOVE_EMPTY_DIR"] = 3] = "REMOVE_EMPTY_DIR";
})(OperationType = exports.OperationType || (exports.OperationType = {}));
var OperationStatus;
(function (OperationStatus) {
    OperationStatus[OperationStatus["INVALID_SOURCE_PATH"] = 0] = "INVALID_SOURCE_PATH";
    OperationStatus[OperationStatus["INVALID_DESTINATION_PATH"] = 1] = "INVALID_DESTINATION_PATH";
    OperationStatus[OperationStatus["SOURCE_DOES_NOT_EXIST"] = 2] = "SOURCE_DOES_NOT_EXIST";
    OperationStatus[OperationStatus["DESTINATION_DIR_DOES_NOT_EXIST"] = 3] = "DESTINATION_DIR_DOES_NOT_EXIST";
    OperationStatus[OperationStatus["INVALID_OPERATION_TYPE"] = 4] = "INVALID_OPERATION_TYPE";
    OperationStatus[OperationStatus["START"] = 5] = "START";
    OperationStatus[OperationStatus["FILE_CREATE_SUCCESS"] = 6] = "FILE_CREATE_SUCCESS";
    OperationStatus[OperationStatus["DIRECTORY_CREATE_SUCCESS"] = 7] = "DIRECTORY_CREATE_SUCCESS";
    OperationStatus[OperationStatus["FILE_MOVE_SUCCESS"] = 8] = "FILE_MOVE_SUCCESS";
    OperationStatus[OperationStatus["DIRECTORY_MOVE_SUCCESS"] = 9] = "DIRECTORY_MOVE_SUCCESS";
    OperationStatus[OperationStatus["FILE_REMOVE_SUCCESS"] = 10] = "FILE_REMOVE_SUCCESS";
    OperationStatus[OperationStatus["DIRECTORY_REMOVE_SUCCESS"] = 11] = "DIRECTORY_REMOVE_SUCCESS";
    OperationStatus[OperationStatus["FILE_OMITTED"] = 12] = "FILE_OMITTED";
    OperationStatus[OperationStatus["DIRECTORY_OMITTED"] = 13] = "DIRECTORY_OMITTED";
    OperationStatus[OperationStatus["CONFLICT_FILE_OVERWRITE"] = 14] = "CONFLICT_FILE_OVERWRITE";
    OperationStatus[OperationStatus["CONFLICT_DIRECTORIES_MERGE"] = 15] = "CONFLICT_DIRECTORIES_MERGE";
    OperationStatus[OperationStatus["CONFLICT_DIRECTORY_OVERWRITE_BY_FILE"] = 16] = "CONFLICT_DIRECTORY_OVERWRITE_BY_FILE";
    OperationStatus[OperationStatus["CONFLICT_FILE_OVERWRITE_BY_DIRECTORY"] = 17] = "CONFLICT_FILE_OVERWRITE_BY_DIRECTORY";
    OperationStatus[OperationStatus["FILE_LOCKED"] = 18] = "FILE_LOCKED";
    OperationStatus[OperationStatus["UNEXPECTED_ERROR"] = 19] = "UNEXPECTED_ERROR";
    OperationStatus[OperationStatus["UNSUPPORTED_SOURCE_ELEMENT"] = 20] = "UNSUPPORTED_SOURCE_ELEMENT";
    OperationStatus[OperationStatus["UNSUPPORTED_DESTINATION_ELEMENT"] = 21] = "UNSUPPORTED_DESTINATION_ELEMENT";
    OperationStatus[OperationStatus["DIRECTORY_NOT_EMPTY"] = 22] = "DIRECTORY_NOT_EMPTY";
    OperationStatus[OperationStatus["CANNOT_READ_SOURCE"] = 23] = "CANNOT_READ_SOURCE";
    OperationStatus[OperationStatus["CANNOT_WRITE_DESTINATION"] = 24] = "CANNOT_WRITE_DESTINATION";
    OperationStatus[OperationStatus["CANNOT_DELETE_FILE"] = 25] = "CANNOT_DELETE_FILE";
    OperationStatus[OperationStatus["CANNOT_DELETE_DIRECTORY"] = 26] = "CANNOT_DELETE_DIRECTORY";
    OperationStatus[OperationStatus["CANNOT_MOVE"] = 27] = "CANNOT_MOVE";
    OperationStatus[OperationStatus["CANNOT_CREATE_DIRECTORY"] = 28] = "CANNOT_CREATE_DIRECTORY";
    OperationStatus[OperationStatus["SOURCE_EQUALS_DESTINATION"] = 29] = "SOURCE_EQUALS_DESTINATION";
    OperationStatus[OperationStatus["DESTINATION_CANNOT_BE_CHILD_OF_SOURCE"] = 30] = "DESTINATION_CANNOT_BE_CHILD_OF_SOURCE";
})(OperationStatus = exports.OperationStatus || (exports.OperationStatus = {}));
;
class MultiOperation {
    list;
    conflictBehavior;
    statusCallback;
    finished;
    deferred;
    goPromise;
    constructor(list, conflictBehavior, statusCallback) {
        this.list = list;
        this.conflictBehavior = conflictBehavior;
        this.statusCallback = statusCallback;
        this.list = this.list || [];
        this.conflictBehavior = this.conflictBehavior || {};
        this.deferred = simplito_promise_1.PromiseUtils.defer();
    }
    getConflictBehavior(cnfBhv, func) {
        if (cnfBhv != null) {
            const value = func(cnfBhv);
            if (value != null) {
                return value;
            }
        }
        if (this.conflictBehavior != null) {
            const value = func(this.conflictBehavior);
            if (value != null) {
                return value;
            }
        }
        return null;
    }
    setConflictBehaviour(container, func) {
        if (container.conflictBehavior == null) {
            container.conflictBehavior = {};
        }
        func(container.conflictBehavior);
    }
    addOperation(operation) {
        this.list.push(operation);
    }
    start() {
        this.go();
        return this.deferred.promise;
    }
    go() {
        if (this.finished) {
            return;
        }
        if (this.list.length == 0) {
            this.finish();
            return;
        }
        const current = this.list.pop();
        return Promise.resolve().then(() => {
            return this.onOperationStatus({ status: OperationStatus.START, operation: current });
        })
            .then(() => {
            if (current.type == OperationType.REMOVE || current.type == OperationType.REMOVE_EMPTY_DIR) {
                return Promise.resolve().then(() => {
                    return PathWalker_1.PathWalker.go(current.source.fileSystem.root, current.source.path, current.source.fileSystem.cache_file_refs_enabled).then(x => x, e => {
                        return this.rejectOperationStatus({ status: OperationStatus.INVALID_SOURCE_PATH, operation: current, error: e });
                    });
                })
                    .then(pathObj => {
                    if (!pathObj.isFullyResolved()) {
                        return this.onOperationStatus({ status: OperationStatus.SOURCE_DOES_NOT_EXIST, operation: current });
                    }
                    const srcPath = pathObj.getResolvedPath();
                    if (pathObj.getLast().entry.isFile() && current.type == OperationType.REMOVE) {
                        return Promise.resolve().then(() => {
                            return current.source.fileSystem.fsd.removeFileD(srcPath).then(x => x, e => {
                                if (PrivFsException_1.PrivFsException.is(e, "ELEMENT_IS_NOT_FILE")) {
                                    this.addOperation(current);
                                    return Promise.reject(null);
                                }
                                return this.rejectOperationStatus({ status: OperationStatus.CANNOT_DELETE_FILE, operation: current, error: e });
                            });
                        })
                            .then(removed => {
                            return this.onOperationStatus({ status: OperationStatus.FILE_REMOVE_SUCCESS, operation: current, removed: removed });
                        });
                    }
                    const theLast = pathObj.getLast().entry;
                    if (theLast.isDirectory()) {
                        return Promise.resolve().then(() => {
                            return theLast.getEntries();
                        })
                            .then((entries) => {
                            if (entries.list.length == 0) {
                                return Promise.resolve().then(() => {
                                    return current.source.fileSystem.fsd.removeEmptyDirD(srcPath).then(x => x, e => {
                                        if (PrivFsException_1.PrivFsException.is(e, "ELEMENT_IS_NOT_DIRECTORY")) {
                                            this.addOperation(current);
                                            return Promise.reject(null);
                                        }
                                        if (PrivFsException_1.PrivFsException.is(e, "DIRECTORY_IS_NOT_EMPTY")) {
                                            if (current.type == OperationType.REMOVE_EMPTY_DIR) {
                                                return this.rejectOperationStatus({ status: OperationStatus.DIRECTORY_NOT_EMPTY, operation: current });
                                            }
                                            this.addOperation(current);
                                            return Promise.reject(null);
                                        }
                                        return this.rejectOperationStatus({ status: OperationStatus.CANNOT_DELETE_DIRECTORY, operation: current, error: e });
                                    });
                                })
                                    .then(removed => {
                                    return this.onOperationStatus({ status: OperationStatus.DIRECTORY_REMOVE_SUCCESS, operation: current, removed: removed });
                                });
                            }
                            if (current.type == OperationType.REMOVE_EMPTY_DIR) {
                                return this.onOperationStatus({ status: OperationStatus.DIRECTORY_NOT_EMPTY, operation: current });
                            }
                            this.addOperation({
                                type: OperationType.REMOVE_EMPTY_DIR,
                                source: {
                                    fileSystem: current.source.fileSystem,
                                    path: current.source.path
                                },
                                destination: null
                            });
                            entries.list.forEach(x => {
                                this.addOperation({
                                    type: OperationType.REMOVE,
                                    source: {
                                        fileSystem: current.source.fileSystem,
                                        path: pathObj.getPathStringWith(x.name)
                                    },
                                    destination: null
                                });
                            });
                        });
                    }
                    return this.onOperationStatus({ status: OperationStatus.UNSUPPORTED_SOURCE_ELEMENT, operation: current });
                });
            }
            if (current.type == OperationType.COPY || current.type == OperationType.MOVE) {
                const theSameFileSystem = current.source.fileSystem.root.ref.id == current.destination.fileSystem.root.ref.id;
                return Promise.all([
                    PathWalker_1.PathWalker.go(current.source.fileSystem.root, current.source.path, current.source.fileSystem.cache_file_refs_enabled).then(x => x, e => {
                        return this.rejectOperationStatus({ status: OperationStatus.INVALID_SOURCE_PATH, operation: current, error: e });
                    }),
                    PathWalker_1.PathWalker.go(current.destination.fileSystem.root, current.destination.path, current.destination.fileSystem.cache_file_refs_enabled).then(x => x, e => {
                        return this.rejectOperationStatus({ status: OperationStatus.INVALID_DESTINATION_PATH, operation: current, error: e });
                    })
                ])
                    .then((pathObjs) => {
                    const [srcPathObj, dstPathObj] = pathObjs;
                    if (!srcPathObj.isFullyResolved()) {
                        return this.onOperationStatus({ status: OperationStatus.SOURCE_DOES_NOT_EXIST, operation: current });
                    }
                    if (!dstPathObj.oneBeforeEndIsResolvedDirectory()) {
                        return this.onOperationStatus({ status: OperationStatus.DESTINATION_DIR_DOES_NOT_EXIST, operation: current });
                    }
                    const srcPath = srcPathObj.getResolvedPath();
                    const dstPath = dstPathObj.getResolvedPath();
                    const srcLast = srcPathObj.getLast();
                    const dstLast = dstPathObj.getLast();
                    if (theSameFileSystem && dstPathObj.isChildOrEqualTo(srcPathObj)) {
                        if (dstPathObj.parts.length == srcPathObj.parts.length) {
                            const sourceDir = srcPathObj.getOneBeforeEndAsResolvedDirectory();
                            const source = {
                                name: srcLast.name,
                                type: srcLast.entry.type,
                                dirPath: srcPathObj.getPathStringWithoutLast(),
                                elementsInDir: sourceDir.hasLoadedEntries() ? sourceDir.getEntriesSync().list.map(x => x.name) : null
                            };
                            return this.onOperationStatus({ status: OperationStatus.SOURCE_EQUALS_DESTINATION, operation: current, source: source });
                        }
                        return this.onOperationStatus({ status: OperationStatus.DESTINATION_CANNOT_BE_CHILD_OF_SOURCE, operation: current });
                    }
                    if (srcLast.entry.isFile()) {
                        if (dstLast.isResolved()) {
                            if (dstLast.entry.isFile()) {
                                const cnfBhv = this.getConflictBehavior(current.conflictBehavior, x => x.overwriteFile);
                                if (cnfBhv === true) {
                                    return Promise.resolve().then(() => {
                                        return current.source.fileSystem.fsd.readLazyD(srcPath).then(x => x, e => {
                                            if (PrivFsException_1.PrivFsException.is(e, "ELEMENT_IS_NOT_FILE")) {
                                                this.addOperation(current);
                                                return Promise.reject(null);
                                            }
                                            return this.rejectOperationStatus({ status: OperationStatus.CANNOT_READ_SOURCE, operation: current, error: e });
                                        });
                                    })
                                        .then(content => {
                                        return current.destination.fileSystem.fsd.saveD(dstPath, content, current.destination.createdFilesOptions).then(x => x, e => {
                                            if (PrivFsException_1.PrivFsException.is(e, "ELEMENT_IS_NOT_FILE")) {
                                                this.addOperation(current);
                                                return Promise.reject(null);
                                            }
                                            return this.rejectOperationStatus({ status: OperationStatus.CANNOT_WRITE_DESTINATION, operation: current, error: e });
                                        });
                                    })
                                        .then(() => {
                                        if (current.type == OperationType.MOVE) {
                                            this.addOperation({
                                                type: OperationType.REMOVE,
                                                source: {
                                                    fileSystem: current.source.fileSystem,
                                                    path: current.source.path
                                                },
                                                destination: null
                                            });
                                            current.type = OperationType.COPY;
                                        }
                                        return this.onOperationStatus({ status: OperationStatus.FILE_CREATE_SUCCESS, operation: current });
                                    });
                                }
                                if (cnfBhv === false) {
                                    return this.onOperationStatus({ status: OperationStatus.FILE_OMITTED, operation: current });
                                }
                                return this.onOperationStatus({ status: OperationStatus.CONFLICT_FILE_OVERWRITE, operation: current });
                            }
                            if (dstLast.entry.isDirectory()) {
                                const cnfBhv = this.getConflictBehavior(current.conflictBehavior, x => x.overwriteDirectoryByFile);
                                if (cnfBhv === true) {
                                    this.addOperation(current);
                                    this.addOperation({
                                        type: OperationType.REMOVE,
                                        source: {
                                            fileSystem: current.destination.fileSystem,
                                            path: current.destination.path
                                        },
                                        destination: null
                                    });
                                    return;
                                }
                                if (cnfBhv === false) {
                                    return this.onOperationStatus({ status: OperationStatus.FILE_OMITTED, operation: current });
                                }
                                return this.onOperationStatus({ status: OperationStatus.CONFLICT_DIRECTORY_OVERWRITE_BY_FILE, operation: current });
                            }
                            return this.onOperationStatus({ status: OperationStatus.UNSUPPORTED_DESTINATION_ELEMENT, operation: current });
                        }
                        else {
                            if (theSameFileSystem && current.type == OperationType.MOVE) {
                                return Promise.resolve().then(() => {
                                    return current.source.fileSystem.fsd.moveD(srcPath, dstPath).then(x => x, e => {
                                        if (PrivFsException_1.PrivFsException.is(e, "FILE_DOES_NOT_EXIST")) {
                                            return this.rejectOperationStatus({ status: OperationStatus.CANNOT_READ_SOURCE, operation: current, error: e });
                                        }
                                        if (PrivFsException_1.PrivFsException.is(e, "FILE_ALREADY_EXISTS")) {
                                            this.addOperation(current);
                                            return Promise.reject(null);
                                        }
                                        return this.rejectOperationStatus({ status: OperationStatus.CANNOT_MOVE, operation: current, error: e });
                                    });
                                })
                                    .then(() => {
                                    return this.onOperationStatus({ status: OperationStatus.FILE_MOVE_SUCCESS, operation: current });
                                });
                            }
                            const cnfBhv = this.getConflictBehavior(current.conflictBehavior, x => x.overwriteFile);
                            return Promise.resolve().then(() => {
                                return current.source.fileSystem.fsd.readLazyD(srcPath).then(x => x, e => {
                                    if (PrivFsException_1.PrivFsException.is(e, "ELEMENT_IS_NOT_FILE")) {
                                        this.addOperation(current);
                                        return Promise.reject(null);
                                    }
                                    return this.rejectOperationStatus({ status: OperationStatus.CANNOT_READ_SOURCE, operation: current, error: e });
                                });
                            })
                                .then(content => {
                                if (cnfBhv) {
                                    return current.destination.fileSystem.fsd.saveD(dstPath, content, current.destination.createdFilesOptions).then(x => x, e => {
                                        if (PrivFsException_1.PrivFsException.is(e, "ELEMENT_IS_NOT_FILE")) {
                                            this.addOperation(current);
                                            return Promise.reject(null);
                                        }
                                        return this.rejectOperationStatus({ status: OperationStatus.CANNOT_WRITE_DESTINATION, operation: current, error: e });
                                    });
                                }
                                return current.destination.fileSystem.fsd.createD(dstPath, content, current.destination.createdFilesOptions).then(x => x, e => {
                                    if (PrivFsException_1.PrivFsException.is(e, "ELEMENT_IS_NOT_FILE")) {
                                        this.addOperation(current);
                                        return Promise.reject(null);
                                    }
                                    if (PrivFsException_1.PrivFsException.is(e, "FILE_ALREADY_EXISTS")) {
                                        this.addOperation(current);
                                        return Promise.reject(null);
                                    }
                                    return this.rejectOperationStatus({ status: OperationStatus.CANNOT_WRITE_DESTINATION, operation: current, error: e });
                                });
                            })
                                .then(() => {
                                if (current.type == OperationType.MOVE) {
                                    this.addOperation({
                                        type: OperationType.REMOVE,
                                        source: {
                                            fileSystem: current.source.fileSystem,
                                            path: current.source.path
                                        },
                                        destination: null
                                    });
                                    current.type = OperationType.COPY;
                                }
                                return this.onOperationStatus({ status: OperationStatus.FILE_CREATE_SUCCESS, operation: current });
                            });
                        }
                    }
                    const srcLastEntry = srcLast.entry;
                    if (srcLastEntry.isDirectory()) {
                        if (dstLast.isResolved()) {
                            if (dstLast.entry.isFile()) {
                                const cnfBhv = this.getConflictBehavior(current.conflictBehavior, x => x.overwriteFileByDirectory);
                                if (cnfBhv === true) {
                                    this.addOperation(current);
                                    this.addOperation({
                                        type: OperationType.REMOVE,
                                        source: {
                                            fileSystem: current.destination.fileSystem,
                                            path: current.destination.path
                                        },
                                        destination: null
                                    });
                                    return;
                                }
                                if (cnfBhv === false) {
                                    return this.onOperationStatus({ status: OperationStatus.DIRECTORY_OMITTED, operation: current });
                                }
                                return this.onOperationStatus({ status: OperationStatus.CONFLICT_DIRECTORIES_MERGE, operation: current });
                            }
                            if (dstLast.entry.isDirectory()) {
                                const cnfBhv = this.getConflictBehavior(current.conflictBehavior, x => x.mergeDirectories);
                                if (cnfBhv === true) {
                                    return Promise.resolve().then(() => {
                                        return srcLastEntry.getEntries();
                                    })
                                        .then(entries => {
                                        if (current.type == OperationType.MOVE) {
                                            this.addOperation({
                                                type: OperationType.REMOVE_EMPTY_DIR,
                                                source: {
                                                    fileSystem: current.source.fileSystem,
                                                    path: current.source.path
                                                },
                                                destination: null
                                            });
                                        }
                                        entries.list.forEach(x => {
                                            this.addOperation({
                                                type: current.type,
                                                source: {
                                                    fileSystem: current.source.fileSystem,
                                                    path: srcPathObj.getPathStringWith(x.name)
                                                },
                                                destination: {
                                                    fileSystem: current.destination.fileSystem,
                                                    path: dstPathObj.getPathStringWith(x.name),
                                                    createdFilesOptions: current.destination.createdFilesOptions
                                                }
                                            });
                                        });
                                    });
                                }
                                if (cnfBhv === false) {
                                    return this.onOperationStatus({ status: OperationStatus.DIRECTORY_OMITTED, operation: current });
                                }
                                return this.onOperationStatus({ status: OperationStatus.CONFLICT_DIRECTORIES_MERGE, operation: current });
                            }
                            return this.onOperationStatus({ status: OperationStatus.UNSUPPORTED_DESTINATION_ELEMENT, operation: current });
                        }
                        else {
                            if (theSameFileSystem && current.type == OperationType.MOVE) {
                                return Promise.resolve().then(() => {
                                    return current.source.fileSystem.fsd.moveD(srcPath, dstPath).then(x => x, e => {
                                        if (PrivFsException_1.PrivFsException.is(e, "FILE_DOES_NOT_EXIST")) {
                                            return this.rejectOperationStatus({ status: OperationStatus.CANNOT_READ_SOURCE, operation: current, error: e });
                                        }
                                        if (PrivFsException_1.PrivFsException.is(e, "FILE_ALREADY_EXISTS")) {
                                            this.addOperation(current);
                                            return Promise.reject(null);
                                        }
                                        return this.rejectOperationStatus({ status: OperationStatus.CANNOT_MOVE, operation: current, error: e });
                                    });
                                })
                                    .then(() => {
                                    return this.onOperationStatus({ status: OperationStatus.DIRECTORY_MOVE_SUCCESS, operation: current });
                                });
                            }
                            const cnfBhv = this.getConflictBehavior(current.conflictBehavior, x => x.mergeDirectories);
                            return Promise.resolve().then(() => {
                                return current.destination.fileSystem.fsd.mkdirD(dstPath).then(x => x, e => {
                                    if (PrivFsException_1.PrivFsException.is(e, "ELEMENT_IS_NOT_DIRECTORY")) {
                                        this.addOperation(current);
                                        return Promise.reject(null);
                                    }
                                    return this.rejectOperationStatus({ status: OperationStatus.CANNOT_CREATE_DIRECTORY, operation: current, error: e });
                                });
                            })
                                .then(dirCreated => {
                                if (!dirCreated && cnfBhv !== true) {
                                    return this.onOperationStatus({ status: OperationStatus.CONFLICT_DIRECTORIES_MERGE, operation: current });
                                }
                                return Promise.resolve().then(() => {
                                    return this.onOperationStatus({ status: OperationStatus.DIRECTORY_CREATE_SUCCESS, operation: current });
                                })
                                    .then(() => {
                                    this.setConflictBehaviour(current, cnfBhv => cnfBhv.mergeDirectories = true);
                                    this.addOperation(current);
                                });
                            });
                        }
                    }
                    return this.onOperationStatus({ status: OperationStatus.UNSUPPORTED_SOURCE_ELEMENT, operation: current });
                });
            }
            return this.onOperationStatus({ status: OperationStatus.INVALID_OPERATION_TYPE, operation: current });
        })
            .catch((e) => {
            if (e != null) {
                return this.onOperationStatus({ status: OperationStatus.UNEXPECTED_ERROR, operation: current, error: e });
            }
        })
            .finally(() => {
            this.go();
        });
    }
    async onOperationStatus(result) {
        try {
            return this.statusCallback ? await this.statusCallback(result, this) : null;
        }
        catch (e) {
            Logger.error("Error during status callback", e);
        }
    }
    async rejectOperationStatus(result) {
        await this.onOperationStatus(result);
        throw null;
    }
    finish() {
        this.finished = true;
        this.deferred.resolve();
    }
}
exports.MultiOperation = MultiOperation;

},{"../../exception/PrivFsException":172,"./path/PathWalker":205,"simplito-logger":407,"simplito-promise":421}],196:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShellFileSystem = void 0;
const MultiOperation_1 = require("./MultiOperation");
class ShellFileSystem {
    fs;
    constructor(fs) {
        this.fs = fs;
    }
    copy(sourcePath, destinationPath, options, conflictBehavior, statusCallback, destinationFileSystem) {
        return new MultiOperation_1.MultiOperation([{
                type: MultiOperation_1.OperationType.COPY,
                source: {
                    fileSystem: this.fs,
                    path: sourcePath
                },
                destination: {
                    fileSystem: (destinationFileSystem || this).fs,
                    path: destinationPath,
                    createdFilesOptions: options
                }
            }], conflictBehavior, statusCallback).start();
    }
    move(sourcePath, destinationPath, options, conflictBehavior, statusCallback, destinationFileSystem) {
        return new MultiOperation_1.MultiOperation([{
                type: MultiOperation_1.OperationType.MOVE,
                source: {
                    fileSystem: this.fs,
                    path: sourcePath
                },
                destination: {
                    fileSystem: (destinationFileSystem || this).fs,
                    path: destinationPath,
                    createdFilesOptions: options
                }
            }], conflictBehavior, statusCallback).start();
    }
    remove(sourcePath, statusCallback) {
        return new MultiOperation_1.MultiOperation([{
                type: MultiOperation_1.OperationType.REMOVE,
                source: {
                    fileSystem: this.fs,
                    path: sourcePath
                },
                destination: null
            }], null, statusCallback).start();
    }
}
exports.ShellFileSystem = ShellFileSystem;

},{"./MultiOperation":195}],197:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecialDirectory = exports.Directory = void 0;
const Entry_1 = require("./Entry");
const Manager_1 = require("../../descriptor/Manager");
const privmx_exception_1 = require("privmx-exception");
const ApiErrorCodes_1 = require("../../../core/ApiErrorCodes");
const simplito_lazybuffer_1 = require("simplito-lazybuffer");
const Path_1 = require("../path/Path");
const simplito_promise_1 = require("simplito-promise");
class Directory extends Entry_1.Entry {
    manager;
    handle;
    currentLoadedEntries;
    handlePromise;
    entriesPromise;
    constructor(name, ref, manager) {
        super(name, "directory", ref);
        if (!(manager instanceof Manager_1.Manager)) {
            throw new privmx_exception_1.IllegalArgumentException("manager", manager);
        }
        Object.defineProperty(this, "manager", {
            value: manager,
            enumerable: true
        });
    }
    static fromHandle(name, handle, entries) {
        const directory = new Directory(name, handle.ref, handle.descriptor.manager);
        directory.setHandle(handle);
        if (entries) {
            directory.currentLoadedEntries = { list: [...entries], version: handle.currentVersion.raw.signature };
        }
        return directory;
    }
    static createWithHandleUpdater(name, ref, manager) {
        const directory = new Directory(name, ref, manager);
        return {
            directory: directory,
            updater: (handle, entries) => {
                if (directory.handle) {
                    return;
                }
                directory.setHandle(handle);
                if (entries) {
                    directory.currentLoadedEntries = { list: entries, version: handle.currentVersion.raw.signature };
                }
            }
        };
    }
    getCopyWithName(name) {
        const copy = new Directory(name, this.ref, this.manager);
        copy._descriptor = this.descriptor;
        copy.handle = this.handle ? this.handle.creatHandleCopy() : null;
        copy.currentLoadedEntries = this.hasLoadedEntries() ? this.getEntriesSync() : null;
        return copy;
    }
    setHandle(handle) {
        if (this.handle || this.ref.id != handle.ref.id) {
            throw new Error("Invalid handle");
        }
        Object.defineProperty(this, "handle", {
            value: handle,
            enumerable: true
        });
        this._descriptor = this.handle.descriptor;
    }
    addEntryF(entry) {
        if (entry.isDirectory() && !(entry instanceof Directory)) {
            entry = new Directory(entry.name, entry.ref, this.manager);
        }
        return entries => {
            entries.add(entry);
        };
    }
    addEntriesF(entryList) {
        const newEntryList = entryList.map(entry => entry.isDirectory() && !(entry instanceof Directory) ? new Directory(entry.name, entry.ref, this.manager) : entry);
        return entries => {
            for (const entry of newEntryList) {
                entries.add(entry);
            }
        };
    }
    removeEntryF(name) {
        return entries => {
            entries.remove(name);
        };
    }
    removeEntriesF(entryNames) {
        return entries => {
            for (const entryName of entryNames) {
                entries.remove(entryName);
            }
        };
    }
    renameEntryF(oldName, newName) {
        return entries => {
            entries.rename(oldName, newName);
        };
    }
    renameEntriesF(list) {
        return entries => {
            for (const ele of list) {
                entries.rename(ele.oldName, ele.newName);
            }
        };
    }
    addEntryZ(entry) {
        return this.tryModifyZ(this.addEntryF(entry));
    }
    addEntriesZ(entries) {
        return this.tryModifyZ(this.addEntriesF(entries));
    }
    removeEntryZ(name) {
        return this.tryModifyZ(this.removeEntryF(name));
    }
    removeEntriesZ(entryNames) {
        return this.tryModifyZ(this.removeEntriesF(entryNames));
    }
    renameEntryZ(oldName, newName) {
        return this.tryModifyZ(this.renameEntryF(oldName, newName));
    }
    renameEntriesZ(list) {
        return this.tryModifyZ(this.renameEntriesF(list));
    }
    addEntry(entry, retryOnOldSignature) {
        return this.tryModify(this.addEntryF(entry), retryOnOldSignature);
    }
    addEntries(entries, retryOnOldSignature) {
        return this.tryModify(this.addEntriesF(entries), retryOnOldSignature);
    }
    removeEntry(name, retryOnOldSignature) {
        return this.tryModify(this.removeEntryF(name), retryOnOldSignature);
    }
    removeEntries(entryNames, retryOnOldSignature) {
        return this.tryModify(this.removeEntriesF(entryNames), retryOnOldSignature);
    }
    renameEntry(oldName, newName, retryOnOldSignature) {
        return this.tryModify(this.renameEntryF(oldName, newName), retryOnOldSignature);
    }
    hasLoadedHandle() {
        return this.handle != null;
    }
    async retrieveHandle() {
        if (this.handle != null) {
            return this.handle;
        }
        if (this.handlePromise != null) {
            return this.handlePromise;
        }
        return this.handlePromise = Promise.resolve().then(async () => {
            const handle = await this.manager.getHandle(this.ref);
            if (this.handle == null) {
                this.setHandle(handle);
            }
            else {
                if (this.handle.descriptor != handle.descriptor) {
                    throw new Error("Descriptors do not match");
                }
            }
            return this.handle;
        })
            .finally(() => {
            delete this.handlePromise;
        });
    }
    hasLoadedEntries() {
        return this.currentLoadedEntries != null;
    }
    getEntriesSync() {
        if (!this.hasLoadedEntries()) {
            throw new Error("Entries not loaded");
        }
        return { version: this.currentLoadedEntries.version, list: [...this.currentLoadedEntries.list] };
    }
    getEntries(forceHandleLoad) {
        if (this.entriesPromise) {
            return this.entriesPromise;
        }
        return this.entriesPromise = Promise.resolve().then(async () => {
            if (forceHandleLoad !== true && this.handle != null && !this.handle.isModified() && this.hasLoadedEntries() && this.handle.currentVersion.raw.signature == this.currentLoadedEntries.version) {
                return this.getEntriesSync();
            }
            const newHandle = (await this.retrieveHandle()).creatCopyWithLastVersion();
            const entries = await this.manager.getDirectoryEntries(newHandle);
            if (this.hasLoadedEntries()) {
                entries.upgrade(new Entries_1.Entries(this.currentLoadedEntries.list));
            }
            this.handle.currentVersion = newHandle.currentVersion;
            this.currentLoadedEntries = { list: entries.list, version: this.handle.currentVersion.raw.signature };
            return this.getEntriesSync();
        })
            .finally(() => {
            delete this.entriesPromise;
        });
    }
    async getEntryByName(name) {
        const entries = await this.getEntries();
        return entries.list.find(x => x.name == name);
    }
    getEntryByNameSync(name) {
        if (!this.hasLoadedEntries()) {
            throw new Error("Entries not loaded");
        }
        return this.currentLoadedEntries.list.find(x => x.name == name);
    }
    async getEntriesObject() {
        const entries = await this.getEntries();
        return new Entries_1.Entries(entries.list.slice());
    }
    getEntriesObjectSync() {
        return new Entries_1.Entries(this.getEntriesSync().list);
    }
    getManager() {
        return this.manager;
    }
    getStorage() {
        if (this.handle == null) {
            throw new Error("Cannot get storage from not loaded directory");
        }
        return this.handle.descriptor.storage;
    }
    getCurrentVersion() {
        if (this.handle == null) {
            throw new Error("Cannot get current version from not loaded directory");
        }
        return this.handle.currentVersion.raw.signature;
    }
    async tryModifyZ(func) {
        this.handle.checkWriteRight();
        const newEntries = new Entries_1.Entries((await this.getEntries()).list.slice());
        const res = await Promise.all([
            func(newEntries),
            this.handle.getWriteKeyEx()
        ]);
        const obj = await newEntries.serialize(res[1]);
        return this.handle.writeZ(simplito_lazybuffer_1.Content.createFromJson(obj)).then(z => {
            return z.next(version => {
                this.currentLoadedEntries = { list: newEntries.list, version: version.version.raw.signature };
                return version;
            });
        });
    }
    tryModify(func, retryOnOldSignature) {
        return Promise.resolve().then(() => {
            return this.handle.descriptor.storage.performDeferredAction(this.tryModifyZ(func));
        })
            .catch(e => {
            return retryOnOldSignature ? this.onError(e, () => this.tryModify(func, retryOnOldSignature)) : Promise.reject(e);
        });
    }
    refresh() {
        return Promise.resolve().then(() => {
            return this.retrieveHandle();
        })
            .then(handle => {
            return handle.refresh();
        });
    }
    addOnChangeCallback(callback) {
        return Promise.resolve().then(() => {
            return this.retrieveHandle();
        })
            .then(handle => {
            handle.addOnChangeCallback(callback);
        });
    }
    removeOnChangeCallback(callback) {
        return Promise.resolve().then(() => {
            return this.retrieveHandle();
        })
            .then(handle => {
            handle.removeOnChangeCallback(callback);
        });
    }
    toInfo() {
        return new Entry_1.Entry(this.name, this.type, this.ref);
    }
    onError(e, func) {
        if (ApiErrorCodes_1.ApiErrorCodes.is(e, "OLD_SIGNATURE_DOESNT_MATCH")) {
            return Promise.resolve().then(() => {
                return this.refresh();
            })
                .then(() => {
                return func();
            });
        }
        return Promise.reject(e);
    }
    findRef(parts) {
        if (parts.length == 0) {
            return this;
        }
        if (!this.hasLoadedEntries()) {
            return null;
        }
        const entry = this.currentLoadedEntries.list.find(x => x.name == parts[0]);
        if (entry == null) {
            return null;
        }
        if (parts.length == 1) {
            return entry;
        }
        return entry instanceof Directory ? entry.findRef(parts.slice(1)) : null;
    }
    getDirectoriesRefs(refs) {
        refs = refs || [];
        refs.push(this.ref);
        if (this.hasLoadedEntries()) {
            this.currentLoadedEntries.list.forEach(x => {
                if (x.isDirectory()) {
                    x.getDirectoriesRefs(refs);
                }
            });
        }
        return refs;
    }
    getEntriesRefs(refs) {
        refs = refs || [];
        refs.push(this.ref);
        if (this.hasLoadedEntries()) {
            this.currentLoadedEntries.list.forEach(x => {
                if (x.isDirectory()) {
                    x.getEntriesRefs(refs);
                }
                else {
                    refs.push(x.ref);
                }
            });
        }
        return refs;
    }
    getEntriesExtraPromise(promises) {
        promises = promises || [];
        if (this.descriptor && this.descriptor.lastVersion && !this.descriptor.lastVersion.extra) {
            promises.push(this.descriptor.lastVersion.getExtra(this.ref.readKey));
        }
        if (this.hasLoadedEntries()) {
            this.currentLoadedEntries.list.forEach(x => {
                if (x.isDirectory()) {
                    x.getEntriesExtraPromise(promises);
                }
                else {
                    const d = x.getCachedDescriptor(this.manager);
                    if (d && d.lastVersion && !d.lastVersion.extra) {
                        promises.push(d.lastVersion.getExtra(x.ref.readKey));
                    }
                }
            });
        }
        return promises;
    }
    decryptMetaInEntries() {
        return Promise.all(this.getEntriesExtraPromise());
    }
    getNotLoadedRefs(refs) {
        refs = refs || [];
        if (this.descriptor == null || this.descriptor.lastVersion == null) {
            refs.push(this.ref);
        }
        if (this.descriptor && this.descriptor.lastVersion && !this.descriptor.lastVersion.extra) {
            this.descriptor.lastVersion.getExtra(this.ref.readKey);
        }
        if (this.hasLoadedEntries()) {
            this.currentLoadedEntries.list.forEach(x => {
                if (x.isDirectory()) {
                    x.getNotLoadedRefs(refs);
                }
                else {
                    const d = x.getCachedDescriptor(this.manager);
                    if (d == null || d.lastVersion == null) {
                        refs.push(x.ref);
                    }
                    if (d && d.lastVersion && !d.lastVersion.extra) {
                        d.lastVersion.getExtra(x.ref.readKey);
                    }
                }
            });
        }
        return refs;
    }
    loadNotLoadedMeta() {
        return Directory.refreshEntriesMeta(this.manager, this.getNotLoadedRefs());
    }
    refreshDeep(withFilesMeta) {
        return Directory.refreshDeep(this.manager, [this], withFilesMeta ? this.getEntriesRefs.bind(this) : this.getDirectoriesRefs.bind(this));
    }
    static refreshDeep(manager, dirsToCheck, getRefs) {
        const g = { value: true };
        const alreadyChecked = {};
        dirsToCheck = dirsToCheck.slice(0);
        return simplito_promise_1.PromiseUtils.infinity(g, () => {
            const toCheck = getRefs().filter(x => !alreadyChecked[x.id]);
            return Promise.resolve().then(() => {
                return toCheck.length == 0 ? [] : manager.getDescriptorsFulfilled(toCheck);
            })
                .then(results => {
                results.forEach(x => {
                    alreadyChecked[x.ref.id] = x;
                });
                return Promise.all(results.map(x => x.descriptor.lastVersion.getExtra(x.ref.readKey)));
            })
                .then(() => {
                dirsToCheck.forEach(dir => {
                    if (dir.handle == null) {
                        const result = alreadyChecked[dir.ref.id];
                        if (result) {
                            dir.setHandle(result.createHandle());
                        }
                    }
                });
                return Promise.all(dirsToCheck.map(x => x.getEntries()));
            })
                .then(entriesList => {
                dirsToCheck = [];
                entriesList.forEach(entries => {
                    entries.list.forEach(x => {
                        if (x.isDirectory()) {
                            dirsToCheck.push(x);
                        }
                    });
                });
                if (dirsToCheck.length == 0) {
                    g.value = false;
                }
            });
        });
    }
    getEntriesMeta(startPath, deep, includeThis, map) {
        map = map || {};
        if (includeThis) {
            map[startPath] = this.getPathMapEntry(this.manager);
        }
        if (this.hasLoadedEntries()) {
            this.currentLoadedEntries.list.forEach(x => {
                const xPath = Path_1.Path.join(startPath, x.name);
                map[xPath] = x.getPathMapEntry(this.manager);
                if (deep && x.isDirectory()) {
                    x.getEntriesMeta(xPath, deep, false, map);
                }
            });
        }
        return map;
    }
    refreshEntriesMeta() {
        return Directory.refreshEntriesMeta(this.manager, this.getEntriesRefs());
    }
    static async refreshEntriesMeta(manager, refs) {
        const results = await manager.getDescriptorsFulfilled(refs);
        await Promise.all(results.map(x => x.descriptor.lastVersion.getExtra(x.ref.readKey)));
    }
    hasRef(ref) {
        return this.getRefPath("/", ref) != null;
    }
    getRefPath(startPath, ref) {
        if (!this.hasLoadedEntries()) {
            return null;
        }
        for (let i = 0; i < this.currentLoadedEntries.list.length; i++) {
            const entry = this.currentLoadedEntries.list[i];
            if (entry.ref.id == ref.id) {
                return Path_1.Path.join(startPath, entry.name);
            }
            if (entry.isDirectory()) {
                const path = entry.getRefPath(Path_1.Path.join(startPath, entry.name), ref);
                if (path != null) {
                    return path;
                }
            }
        }
        return null;
    }
}
exports.Directory = Directory;
class SpecialDirectory {
    manager;
    directories;
    constructor(manager) {
        this.manager = manager;
        this.directories = [];
    }
    getDirectoriesRefs() {
        const refs = [];
        this.directories.forEach(x => {
            x.getDirectoriesRefs(refs);
        });
        return refs;
    }
    getEntriesRefs() {
        const refs = [];
        this.directories.forEach(x => {
            x.getEntriesRefs(refs);
        });
        return refs;
    }
    refreshDeep(withFilesMeta) {
        return Directory.refreshDeep(this.manager, this.directories, withFilesMeta ? this.getEntriesRefs.bind(this) : this.getDirectoriesRefs.bind(this));
    }
    refreshEntriesMeta() {
        return Directory.refreshEntriesMeta(this.manager, this.getEntriesRefs());
    }
    initRoots() {
    }
}
exports.SpecialDirectory = SpecialDirectory;
const Entries_1 = require("./Entries");

},{"../../../core/ApiErrorCodes":138,"../../descriptor/Manager":181,"../path/Path":203,"./Entries":198,"./Entry":199,"privmx-exception":286,"simplito-lazybuffer":398,"simplito-promise":421}],198:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Entries = void 0;
const Entry_1 = require("./Entry");
const simplito_promise_1 = require("simplito-promise");
const PrivFsException_1 = require("../../../exception/PrivFsException");
class Entries {
    list;
    constructor(list) {
        this.list = list;
    }
    serialize(encKey) {
        return simplito_promise_1.PromiseUtils.collect(this.list, (_, entry) => {
            return entry.serialize(encKey);
        });
    }
    static deserialize(manager, encKey, obj) {
        return simplito_promise_1.PromiseUtils.collect(obj, (_, raw) => {
            return Promise.resolve().then(() => {
                return Entry_1.Entry.deserialize(raw, encKey);
            })
                .then(entry => {
                return entry.isDirectory() ? new Directory_1.Directory(entry.name, entry.ref, manager) : entry;
            });
        })
            .then(list => {
            return new Entries(list);
        });
    }
    getByRef(ref) {
        for (let i = 0; i < this.list.length; i++) {
            const entry = this.list[i];
            if (entry.ref.equals(ref) && entry.ref.constructor == ref.constructor) {
                return entry;
            }
        }
        return null;
    }
    getByName(name) {
        for (let i = 0; i < this.list.length; i++) {
            const entry = this.list[i];
            if (entry.name == name) {
                return entry;
            }
        }
        return null;
    }
    getByNameWithException(name) {
        const entry = this.getByName(name);
        if (entry == null) {
            throw new PrivFsException_1.PrivFsException("FILE_DOES_NOT_EXIST", name);
        }
        return entry;
    }
    hasName(name) {
        return this.getByName(name) != null;
    }
    add(entry) {
        if (typeof (entry.name) != "string" || entry.name.indexOf("/") != -1) {
            throw new Error("Invalid entry name");
        }
        if (this.hasName(entry.name)) {
            throw new PrivFsException_1.PrivFsException("FILE_ALREADY_EXISTS", entry.name);
        }
        this.list.push(entry);
    }
    remove(name) {
        for (let i = 0; i < this.list.length; i++) {
            const entry = this.list[i];
            if (entry.name == name) {
                this.list.splice(i, 1);
                return;
            }
        }
        throw new PrivFsException_1.PrivFsException("FILE_DOES_NOT_EXIST", name);
    }
    rename(oldName, newName) {
        if (typeof (newName) != "string" || newName.indexOf("/") != -1) {
            throw new Error("Invalid entry name");
        }
        if (this.hasName(newName)) {
            throw new PrivFsException_1.PrivFsException("NAME_IN_USE", newName);
        }
        for (let i = 0; i < this.list.length; i++) {
            const entry = this.list[i];
            if (entry.name == oldName) {
                this.list[i] = entry.getCopyWithName(newName);
                return;
            }
        }
        throw new PrivFsException_1.PrivFsException("FILE_DOES_NOT_EXIST", oldName);
    }
    copy() {
        return new Entries([...this.list]);
    }
    toInfo() {
        const result = [];
        for (let i = 0; i < this.list.length; i++) {
            result.push(this.list[i].toInfo());
        }
        return result;
    }
    upgrade(old) {
        const newList = [];
        for (let i = 0; i < this.list.length; i++) {
            const newEntry = this.list[i];
            const oldEntry = old.getByRef(newEntry.ref);
            if (oldEntry) {
                newList.push(oldEntry.name === newEntry.name ? oldEntry : oldEntry.getCopyWithName(newEntry.name));
            }
            else {
                newList.push(newEntry);
            }
        }
        this.list = newList;
    }
}
exports.Entries = Entries;
const Directory_1 = require("./Directory");

},{"../../../exception/PrivFsException":172,"./Directory":197,"./Entry":199,"simplito-promise":421}],199:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Entry = void 0;
const privmx_exception_1 = require("privmx-exception");
const privmx_crypto_1 = require("privmx-crypto");
const DescriptorRefRead_1 = require("../../descriptor/ref/DescriptorRefRead");
const DescriptorRefWrite_1 = require("../../descriptor/ref/DescriptorRefWrite");
class Entry {
    name;
    type;
    ref;
    _descriptor;
    get descriptor() {
        return this._descriptor;
    }
    constructor(name, type, ref) {
        if (typeof (name) != "string" || name.indexOf("/") != -1) {
            throw new privmx_exception_1.IllegalArgumentException("name", name);
        }
        if (type != "file" && type != "directory") {
            throw new privmx_exception_1.IllegalArgumentException("type", type);
        }
        if (!(ref instanceof DescriptorRefRead_1.DescriptorRefRead)) {
            throw new privmx_exception_1.IllegalArgumentException("ref", ref);
        }
        Object.defineProperty(this, "name", {
            value: name,
            enumerable: true,
            writable: true
        });
        Object.defineProperty(this, "type", {
            value: type,
            enumerable: true
        });
        Object.defineProperty(this, "ref", {
            value: ref,
            enumerable: true
        });
    }
    getPathMapEntry(manager) {
        return {
            name: this.name,
            type: this.type,
            meta: this.getCachedMeta(manager)
        };
    }
    getCachedDescriptor(manager) {
        if (this.descriptor == null) {
            this._descriptor = manager.getDescriptorFromCache(this.ref);
        }
        return this.descriptor;
    }
    getCachedMeta(manager) {
        const descriptor = this.getCachedDescriptor(manager);
        return descriptor ? descriptor.getLastVersionCachedMeta() : null;
    }
    isFile() {
        return this.type == "file";
    }
    isDirectory() {
        return this.type == "directory";
    }
    async serialize(encKey) {
        const raw = {
            name: this.name,
            type: this.type,
            url: this.ref.url,
            xpub: this.ref.extPub58
        };
        if (this.ref.isReadOnly() || encKey == null) {
            return raw;
        }
        const iv = await privmx_crypto_1.service.generateIv(encKey, 0);
        const xpriv = Buffer.from(this.ref.extPriv58, "utf8");
        const enc = await privmx_crypto_1.service.privmxEncrypt(privmx_crypto_1.service.privmxOptAesWithDetachedIv(), xpriv, encKey, iv);
        raw.xpriv = enc.toString("base64");
        return raw;
    }
    static async deserialize(raw, decKey) {
        const ref = await Entry.deserializeToRef(raw, decKey);
        return new Entry(raw.name, raw.type, ref);
    }
    static async deserializeToRef(raw, decKey) {
        if (decKey == null || raw.xpriv == null) {
            return DescriptorRefRead_1.DescriptorRefRead.fromExtKey(raw.xpub, raw.url);
        }
        const iv = await privmx_crypto_1.service.generateIv(decKey, 0);
        const dec = await privmx_crypto_1.service.privmxDecrypt(Buffer.from(raw.xpriv, "base64"), decKey, iv);
        return DescriptorRefWrite_1.DescriptorRefWrite.fromExtKey(dec.toString("utf8"), raw.url);
    }
    toInfo() {
        return this;
    }
    getCopyWithName(name) {
        const copy = new Entry(name, this.type, this.ref);
        copy._descriptor = this.descriptor;
        return copy;
    }
}
exports.Entry = Entry;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../../descriptor/ref/DescriptorRefRead":188,"../../descriptor/ref/DescriptorRefWrite":189,"buffer":498,"privmx-crypto":265,"privmx-exception":286}],200:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleNameResolver = void 0;
class SimpleNameResolver {
    isFile;
    originalName;
    baseName;
    ext;
    i;
    currentName;
    constructor(isFile, originalName) {
        this.isFile = isFile;
        this.originalName = originalName;
        this.baseName = this.originalName;
        this.ext = "";
        this.i = 0;
        if (isFile) {
            const index = this.originalName.lastIndexOf(".");
            this.baseName = index == -1 ? this.originalName : this.originalName.substring(0, index);
            this.ext = index == -1 ? "" : this.originalName.substring(index);
        }
        this.currentName = this.originalName;
    }
    static create(isFile, originalName) {
        return new SimpleNameResolver(isFile, originalName);
    }
    getCurrentName() {
        return this.currentName;
    }
    formatName() {
        return this.isFile ? this.baseName + "(" + this.i + ")" + this.ext : this.originalName + "(" + this.i + ")";
    }
    getNextName() {
        this.i++;
        this.currentName = this.formatName();
        return this.currentName;
    }
    static getNameResolver(nameResolver, isFile, name) {
        if (typeof (nameResolver) == "boolean") {
            return nameResolver ? SimpleNameResolver.create(isFile, name) : null;
        }
        return nameResolver ? nameResolver(isFile, name) : null;
    }
}
exports.SimpleNameResolver = SimpleNameResolver;

},{}],201:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleNameResolver = exports.Entry = exports.Entries = exports.SpecialDirectory = exports.Directory = void 0;
const Directory_1 = require("./Directory");
Object.defineProperty(exports, "Directory", { enumerable: true, get: function () { return Directory_1.Directory; } });
Object.defineProperty(exports, "SpecialDirectory", { enumerable: true, get: function () { return Directory_1.SpecialDirectory; } });
const Entries_1 = require("./Entries");
Object.defineProperty(exports, "Entries", { enumerable: true, get: function () { return Entries_1.Entries; } });
const Entry_1 = require("./Entry");
Object.defineProperty(exports, "Entry", { enumerable: true, get: function () { return Entry_1.Entry; } });
const SimpleNameResolver_1 = require("./SimpleNameResolver");
Object.defineProperty(exports, "SimpleNameResolver", { enumerable: true, get: function () { return SimpleNameResolver_1.SimpleNameResolver; } });

},{"./Directory":197,"./Entries":198,"./Entry":199,"./SimpleNameResolver":200}],202:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.multi = exports.Mode = exports.ShellFileSystem = exports.KeyValueFile = exports.FileSystemCore = exports.FileSystem = exports.path = exports.entry = void 0;
const entry = require("./entry");
exports.entry = entry;
const path = require("./path");
exports.path = path;
const FileSystem_1 = require("./FileSystem");
Object.defineProperty(exports, "FileSystem", { enumerable: true, get: function () { return FileSystem_1.FileSystem; } });
const FileSystemCore_1 = require("./FileSystemCore");
Object.defineProperty(exports, "FileSystemCore", { enumerable: true, get: function () { return FileSystemCore_1.FileSystemCore; } });
const multi = require("./MultiOperation");
exports.multi = multi;
const KeyValueFile_1 = require("./KeyValueFile");
Object.defineProperty(exports, "KeyValueFile", { enumerable: true, get: function () { return KeyValueFile_1.KeyValueFile; } });
const Mode_1 = require("./Mode");
Object.defineProperty(exports, "Mode", { enumerable: true, get: function () { return Mode_1.Mode; } });
const ShellFileSystem_1 = require("./ShellFileSystem");
Object.defineProperty(exports, "ShellFileSystem", { enumerable: true, get: function () { return ShellFileSystem_1.ShellFileSystem; } });

},{"./FileSystem":191,"./FileSystemCore":192,"./KeyValueFile":193,"./Mode":194,"./MultiOperation":195,"./ShellFileSystem":196,"./entry":201,"./path":206}],203:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Path = void 0;
const privmx_exception_1 = require("privmx-exception");
const Utils = require("simplito-utils");
const PathPart_1 = require("./PathPart");
const PrivFsException_1 = require("../../../exception/PrivFsException");
class Path {
    path;
    parts;
    constructor(path) {
        const parts = Path.parse(path);
        Object.defineProperty(this, "path", {
            value: path,
            enumerable: true
        });
        const pathParts = [];
        for (let i = 0; i < parts.length; i++) {
            pathParts.push(new PathPart_1.PathPart(this, i, parts[i]));
        }
        Object.defineProperty(this, "parts", {
            value: pathParts,
            enumerable: true
        });
    }
    static parse(path) {
        if (typeof (path) != "string" || !Utils.startsWith(path, "/")) {
            throw new privmx_exception_1.IllegalArgumentException("path", path);
        }
        let p = path;
        if (Utils.endsWith(p, "/")) {
            p = p.substring(0, p.length - 1);
        }
        const parts = p.split("/");
        for (let i = 0; i < parts.length; i++) {
            if (i > 0 && parts[i].length == 0) {
                throw new privmx_exception_1.IllegalArgumentException("path", path);
            }
        }
        return parts;
    }
    getFirst() {
        return this.parts[0];
    }
    getLast() {
        return this.parts[this.parts.length - 1];
    }
    getOneBeforeEnd() {
        return this.parts[this.parts.length - 2];
    }
    assignResults(results) {
        mainLoop: for (let i = 0; i < results.length; i++) {
            const result = results[i];
            for (let j = 0; j < this.parts.length; j++) {
                const part = this.parts[j];
                if (part.did == result.ref.did) {
                    part.assignResult(result);
                    continue mainLoop;
                }
            }
            throw new PrivFsException_1.PrivFsException("CANNOT_ASSIGN_RESULT_TO_PATH_PART");
        }
    }
    isFullyResolved() {
        for (let i = 0; i < this.parts.length; i++) {
            if (!this.parts[i].isResolved()) {
                return false;
            }
        }
        return true;
    }
    isResolvedExceptLastElement() {
        for (let i = 0; i < this.parts.length - 1; i++) {
            if (!this.parts[i].isResolved()) {
                return false;
            }
        }
        return !this.getLast().isResolved();
    }
    oneBeforeEndIsResolvedDirectory() {
        const oneBeforeEnd = this.getOneBeforeEnd();
        return oneBeforeEnd && oneBeforeEnd.isResolved() && oneBeforeEnd.entry.isDirectory();
    }
    getLastAsResolvedDirectory() {
        return this.getLast().asResolvedDirectory();
    }
    getOneBeforeEndAsResolvedDirectory() {
        const oneBeforeEnd = this.getOneBeforeEnd();
        return oneBeforeEnd ? oneBeforeEnd.asResolvedDirectory() : null;
    }
    getPathString() {
        return this.path;
    }
    getPathStringWithoutLast() {
        return Path.getPathString(this.parts.map(x => x.name).slice(0, -1));
    }
    getPathStringWithoutLastAnd(name) {
        return Path.getPathString(this.parts.map(x => x.name).slice(0, -1).concat([name]));
    }
    getPathStringWith(name) {
        return Path.getPathString(this.parts.map(x => x.name).concat([name]));
    }
    static getPathString(parts) {
        if (parts.length == 0) {
            throw new Error("Invalid parts length");
        }
        if (parts[0] != "") {
            throw new Error("First element have to be empty");
        }
        if (parts.length == 1) {
            return "/";
        }
        let res = "";
        for (let i = 1; i < parts.length; i++) {
            res += "/" + parts[i];
        }
        return res;
    }
    getResolvedPath() {
        const directory = this.getOneBeforeEndAsResolvedDirectory();
        if (directory == null) {
            throw new PrivFsException_1.PrivFsException("DIRECTORY_DOES_NOT_EXIST", this.getPathStringWithoutLast());
        }
        return {
            directory: directory,
            name: this.getLast().name,
            path: this.path
        };
    }
    static join(basePath, name) {
        return basePath + (Utils.endsWith(basePath, "/") ? "" : "/") + name;
    }
    isChildOrEqualTo(other) {
        if (other.parts.length > this.parts.length) {
            return false;
        }
        for (let i = 0; i < other.parts.length; i++) {
            if (other.parts[i].name != this.parts[i].name) {
                return false;
            }
        }
        return true;
    }
}
exports.Path = Path;

},{"../../../exception/PrivFsException":172,"./PathPart":204,"privmx-exception":286,"simplito-utils":422}],204:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PathPart = void 0;
const Directory_1 = require("../entry/Directory");
class PathPart {
    path;
    index;
    name;
    did;
    result;
    entry;
    constructor(path, index, name) {
        Object.defineProperty(this, "path", {
            value: path,
            enumerable: true
        });
        Object.defineProperty(this, "index", {
            value: index,
            enumerable: true
        });
        Object.defineProperty(this, "name", {
            value: name,
            enumerable: true
        });
    }
    isLast() {
        return this.index == this.path.parts.length - 1;
    }
    next() {
        return this.path.parts[this.index + 1];
    }
    assignResult(result) {
        this.result = result;
    }
    isResultAssigned(did) {
        return this.result != null && this.result.ref.did == did;
    }
    assignDid(did) {
        this.result = null;
        this.did = did;
    }
    resolve(entry) {
        this.entry = entry;
    }
    isResolved() {
        return this.entry != null;
    }
    asResolvedDirectory() {
        return this.isResolved() && this.entry instanceof Directory_1.Directory ? this.entry : null;
    }
}
exports.PathPart = PathPart;

},{"../entry/Directory":197}],205:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PathWalker = void 0;
const Path_1 = require("./Path");
const PrivFsException_1 = require("../../../exception/PrivFsException");
class PathWalker {
    root;
    path;
    currentPart;
    currentEntry;
    quick_path;
    constructor(root, path) {
        this.root = root;
        this.path = path;
        this.currentPart = this.path.getFirst();
        this.currentEntry = root;
    }
    static go(root, path, quick_path) {
        const walker = new PathWalker(root, new Path_1.Path(path));
        walker.quick_path = quick_path || false;
        return walker.step();
    }
    async refresh(directory, pathPart) {
        let toRefresh = [];
        let cEntry = directory;
        let cPath = pathPart;
        while (cEntry != null && cPath != null) {
            if (cEntry.ref.url != directory.ref.url || (cEntry.isDirectory() && !cEntry.hasLoadedHandle())) {
                break;
            }
            if (!cPath.isResultAssigned(cEntry.ref.did)) {
                toRefresh.push(cEntry.ref);
                cPath.assignDid(cEntry.ref.did);
            }
            if (!cEntry.isDirectory() || !cEntry.hasLoadedEntries()) {
                break;
            }
            cPath = cPath.next();
            cEntry = cPath == null ? null : cEntry.getEntryByNameSync(cPath.name);
        }
        if (toRefresh.length == 0) {
            return;
        }
        if (this.quick_path) {
            toRefresh = toRefresh.slice(-1);
        }
        const results = await directory.getManager().getDescriptors(toRefresh);
        pathPart.path.assignResults(results);
    }
    step() {
        return Promise.resolve().then(() => {
            return this.refresh(this.currentEntry, this.currentPart);
        })
            .then(() => {
            this.currentPart.resolve(this.currentEntry);
            if (this.currentPart.isLast()) {
                return null;
            }
            this.currentPart = this.currentPart.next();
            return this.currentEntry.getEntryByName(this.currentPart.name);
        })
            .then(entry => {
            if (entry == null) {
                return this.path;
            }
            if (this.currentPart.isLast()) {
                this.currentPart.resolve(entry);
                return this.path;
            }
            if (entry.isDirectory()) {
                this.currentEntry = entry;
                return this.step();
            }
            throw new PrivFsException_1.PrivFsException("ELEMENT_IS_NOT_DIRECTORY", entry.name);
        });
    }
}
exports.PathWalker = PathWalker;

},{"../../../exception/PrivFsException":172,"./Path":203}],206:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PathWalker = exports.PathPart = exports.Path = void 0;
const Path_1 = require("./Path");
Object.defineProperty(exports, "Path", { enumerable: true, get: function () { return Path_1.Path; } });
const PathPart_1 = require("./PathPart");
Object.defineProperty(exports, "PathPart", { enumerable: true, get: function () { return PathPart_1.PathPart; } });
const PathWalker_1 = require("./PathWalker");
Object.defineProperty(exports, "PathWalker", { enumerable: true, get: function () { return PathWalker_1.PathWalker; } });

},{"./Path":203,"./PathPart":204,"./PathWalker":205}],207:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.file = exports.descriptor = void 0;
const descriptor = require("./descriptor");
exports.descriptor = descriptor;
const file = require("./file");
exports.file = file;

},{"./descriptor":186,"./file":202}],208:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RpcGateway = exports.Proxy = void 0;
const RootLogger = require("simplito-logger");
const PrivmxRpc = require("privmx-rpc");
const LoginByKeyUtils_1 = require("../core/LoginByKeyUtils");
const Logger = RootLogger.get("privfs-client.gateway.RpcGateway");
class Proxy {
    gateway;
    destination;
    constructor(gateway, destination) {
        this.gateway = gateway;
        this.destination = destination;
    }
    call(method, params) {
        if (this.destination) {
            return this.gateway.proxyRequest(this.destination, method, params);
        }
        return this.gateway.request(method, params);
    }
}
exports.Proxy = Proxy;
class RpcGateway {
    rpc;
    additionalLoginStepOnReloginCallback;
    eventDispatcher;
    constructor(rpc, additionalLoginStepOnReloginCallback) {
        this.rpc = rpc;
        this.additionalLoginStepOnReloginCallback = additionalLoginStepOnReloginCallback;
        this.eventDispatcher = new PrivmxRpc.EventDispatcher();
        this.bindEventsFromRpc();
    }
    request(method, params, settings) {
        return Promise.resolve().then(() => {
            if (settings === void (0)) {
                settings = {};
            }
            Logger.debug("request", method, params, settings);
            return this.rpc.call(method, params, settings);
        });
    }
    proxyRequest(destination, method, params, settings) {
        return Promise.resolve().then(() => {
            if (settings === void (0)) {
                settings = {};
            }
            Logger.debug("proxyRequest", destination, method, params, settings);
            return this.rpc.proxy(destination, method, params, settings);
        });
    }
    async probe() {
        const options = this.getOptions();
        return PrivmxRpc.rpc.probe(options.url, options.appCredentials);
    }
    async verifyConnection() {
        return this.rpc.verifyConnection();
    }
    destroy() {
        return this.rpc.destroy();
    }
    isConnected() {
        return this.rpc.isConnected();
    }
    isSessionEstablished() {
        return this.rpc.isSessionEstablished();
    }
    isRestorableBySession() {
        const info = this.getInfo();
        return info.type != "ecdhe" && !!info.sessionKey;
    }
    getInfo() {
        return this.rpc.getInfo();
    }
    getHost() {
        return this.rpc.getHost();
    }
    getOptions() {
        return this.rpc.getOptions();
    }
    getType() {
        return this.rpc.getInfo().type;
    }
    getProperties() {
        const info = this.rpc.getInfo();
        if (info.type != "srp" && info.type != "key" && info.type != "session") {
            throw new Error("Cannot get properties from non srp/key/session connection");
        }
        return info.properties;
    }
    getUsername() {
        const info = this.rpc.getInfo();
        if (info.type != "srp" && info.type != "key" && info.type != "session") {
            throw new Error("Cannot get username from non srp/key/session connection");
        }
        return info.username;
    }
    getClient(host) {
        return Promise.resolve(new Proxy(this, this.getHost() === host ? null : host));
    }
    getInitParameters() {
        return {
            options: this.getOptions(),
            gatewayProperties: this.getProperties(),
            additionalLoginStepCallback: this.additionalLoginStepOnReloginCallback
        };
    }
    async srpRelogin(username, password) {
        const newRpc = await PrivmxRpc.rpc.createSrpConnection({
            username,
            password,
            properties: this.getProperties(),
            onAdditionalLoginStep: this.additionalLoginStepOnReloginCallback
        }, this.rpc.getOptions());
        if (newRpc.getInfo().username != this.getUsername()) {
            newRpc.destroy();
            throw new Error("Cannot relogin - user mismatch");
        }
        this.switchRpc(newRpc);
    }
    async keyRelogin(recovery) {
        const bip39 = await LoginByKeyUtils_1.LoginByKeyUtils.getBip39(recovery);
        const newRpc = await PrivmxRpc.rpc.createKeyConnection({
            key: bip39.extKey.getPrivateKey(),
            properties: this.getProperties(),
            onAdditionalLoginStep: this.additionalLoginStepOnReloginCallback
        }, this.rpc.getOptions());
        if (newRpc.getInfo().username != this.getUsername()) {
            newRpc.destroy();
            throw new Error("Cannot relogin - user mismatch");
        }
        this.switchRpc(newRpc);
    }
    async tryRestoreBySession() {
        const info = this.getInfo();
        if (info.type == "ecdhe" || !info.sessionKey) {
            throw new Error("Connection cannot be restored by session");
        }
        try {
            const newRpc = await PrivmxRpc.rpc.createSessionConnection({
                sessionId: info.sessionId,
                sessionKey: info.sessionKey,
                username: info.username,
                properties: info.properties
            }, this.rpc.getOptions());
            this.switchRpc(newRpc);
        }
        catch (e) {
            if (e instanceof PrivmxRpc.AlertError) {
                info.sessionKey = null;
            }
            throw e;
        }
    }
    switchRpc(newRpc) {
        this.rpc.destroy();
        this.rpc = newRpc;
        this.bindEventsFromRpc();
        this.eventDispatcher.dispatchEvent({ type: "connected" });
    }
    addEventListener(type, eventListener) {
        this.eventDispatcher.addEventListener(type, eventListener);
    }
    removeEventListener(type, eventListener) {
        this.eventDispatcher.removeEventListener(type, eventListener);
    }
    bindEventsFromRpc() {
        this.rpc.addEventListener("notification", x => this.eventDispatcher.dispatchEvent(x));
        this.rpc.addEventListener("sessionLost", x => this.eventDispatcher.dispatchEvent(x));
        this.rpc.addEventListener("connected", x => this.eventDispatcher.dispatchEvent(x));
        this.rpc.addEventListener("disconnected", x => this.eventDispatcher.dispatchEvent(x));
    }
    async createEcdheProxyConnection(auth, options) {
        return PrivmxRpc.proxy.createEcdheConnection(this.rpc, auth, options);
    }
    async createSrpProxyConnection(auth, options) {
        return PrivmxRpc.proxy.createSrpConnection(this.rpc, auth, options);
    }
    async createKeyProxyConnection(auth, options) {
        return PrivmxRpc.proxy.createKeyConnection(this.rpc, auth, options);
    }
    static async createGatewayFromEcdheConnection(key, options) {
        const connection = await PrivmxRpc.rpc.createEcdheConnection({ key: key }, options);
        return new RpcGateway(connection, null);
    }
    static async createGatewayFromKeyConnection(key, initParameters) {
        const connection = await PrivmxRpc.rpc.createKeyConnection({
            key: key,
            onAdditionalLoginStep: initParameters.additionalLoginStepCallback,
            properties: initParameters.gatewayProperties
        }, initParameters.options);
        return new RpcGateway(connection, initParameters.additionalLoginStepCallback);
    }
    static async createGatewayFromSrpConnection(username, password, initParameters) {
        const connection = await PrivmxRpc.rpc.createSrpConnection({
            username: username,
            password: password,
            onAdditionalLoginStep: initParameters.additionalLoginStepCallback,
            properties: initParameters.gatewayProperties
        }, initParameters.options);
        return new RpcGateway(connection, initParameters.additionalLoginStepCallback);
    }
}
exports.RpcGateway = RpcGateway;

},{"../core/LoginByKeyUtils":146,"privmx-rpc":366,"simplito-logger":407}],209:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RpcGateway = void 0;
const RpcGateway_1 = require("./RpcGateway");
Object.defineProperty(exports, "RpcGateway", { enumerable: true, get: function () { return RpcGateway_1.RpcGateway; } });

},{"./RpcGateway":208}],210:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hashmail = void 0;
class Hashmail {
    hashmail;
    user;
    host;
    constructor(hashmail) {
        if (typeof (hashmail) == "string") {
            const splitted = hashmail.split("#");
            if (splitted.length != 2 || splitted[0].length == 0 || splitted[0].length == 0) {
                throw new Error("Invalid parameter");
            }
            Object.defineProperty(this, "hashmail", {
                value: hashmail,
                enumerable: true
            });
            Object.defineProperty(this, "user", {
                value: splitted[0],
                enumerable: true
            });
            Object.defineProperty(this, "host", {
                value: splitted[1],
                enumerable: true
            });
        }
        else if (typeof (hashmail) == "object") {
            const hObj = hashmail;
            if (typeof (hObj.user) != "string" || typeof (hObj.host) != "string" || hObj.user.length == 0 || hObj.host.length == 0 || hObj.user.indexOf("#") != -1 || hObj.host.indexOf("#") != -1) {
                throw new Error("Invalid parameter");
            }
            Object.defineProperty(this, "hashmail", {
                value: hObj.user + "#" + hObj.host,
                enumerable: true
            });
            Object.defineProperty(this, "user", {
                value: hObj.user,
                enumerable: true
            });
            Object.defineProperty(this, "host", {
                value: hObj.host,
                enumerable: true
            });
        }
        else {
            throw new Error("Invalid parameter type");
        }
    }
    toString() {
        return this.hashmail;
    }
}
exports.Hashmail = Hashmail;

},{}],211:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Identity = void 0;
const User_1 = require("./User");
const privmx_crypto_1 = require("privmx-crypto");
const PrivFsException_1 = require("../exception/PrivFsException");
class Identity extends User_1.User {
    priv;
    privWif;
    constructor(hashmail, priv, name, keystore) {
        super(hashmail, priv.getPublicKey(), name, keystore);
        if (!(priv instanceof privmx_crypto_1.ecc.PrivateKey)) {
            throw new Error("Invalid parameter");
        }
        Object.defineProperty(this, "priv", {
            value: priv,
            enumerable: true
        });
        Object.defineProperty(this, "privWif", {
            value: priv.toWIF(),
            enumerable: true
        });
    }
    static fromSerialized(hashmail, privWif, name) {
        return new Identity(hashmail, privmx_crypto_1.ecc.PrivateKey.fromWIF(privWif), name);
    }
    static fromUser(user, priv) {
        const identityKeyPub = priv.getPublicKey().toBase58DER();
        if (identityKeyPub != user.pub58) {
            throw new PrivFsException_1.PrivFsException("DIFFERENT_IDENTITY", {
                my: identityKeyPub,
                server: user.pub58
            });
        }
        return new Identity(user.hashmail, priv, user.name, user.keystore);
    }
}
exports.Identity = Identity;

},{"../exception/PrivFsException":172,"./User":212,"privmx-crypto":265}],212:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
const Hashmail_1 = require("./Hashmail");
const privmx_crypto_1 = require("privmx-crypto");
class User extends Hashmail_1.Hashmail {
    pub;
    pub58;
    name;
    keystore;
    constructor(hashmail, pub, name, keystore) {
        super(hashmail);
        if (!(pub instanceof privmx_crypto_1.ecc.PublicKey)) {
            throw new Error("Invalid parameter");
        }
        Object.defineProperty(this, "pub", {
            value: pub,
            enumerable: true
        });
        Object.defineProperty(this, "pub58", {
            value: pub.toBase58DER(),
            enumerable: true
        });
        Object.defineProperty(this, "name", {
            value: name,
            enumerable: true,
            writable: true
        });
        Object.defineProperty(this, "keystore", {
            value: keystore,
            enumerable: true,
            writable: true
        });
    }
    static fromSerialized(hashmail, pub58, name) {
        return new User(hashmail, privmx_crypto_1.ecc.PublicKey.fromBase58DER(pub58), name);
    }
    static fromKeyStore(hashmail, keystore, name) {
        const key = keystore.getPrimaryKey().keyPair.keyPair;
        return new User(hashmail, new privmx_crypto_1.ecc.PublicKey(key), name, keystore);
    }
    serialize() {
        return {
            hashmail: this.hashmail,
            pub58: this.pub58,
            name: this.name
        };
    }
    getDisplayName(displayName) {
        return displayName || this.name || this.hashmail;
    }
    toString() {
        return this.name == null ? this.hashmail : this.name + "<" + this.hashmail + ">";
    }
    getNameWithHashmail() {
        return this.name == null ? this.hashmail : this.name + " (" + this.hashmail + ")";
    }
}
exports.User = User;

},{"./Hashmail":210,"privmx-crypto":265}],213:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = exports.Identity = exports.Hashmail = void 0;
const Hashmail_1 = require("./Hashmail");
Object.defineProperty(exports, "Hashmail", { enumerable: true, get: function () { return Hashmail_1.Hashmail; } });
const Identity_1 = require("./Identity");
Object.defineProperty(exports, "Identity", { enumerable: true, get: function () { return Identity_1.Identity; } });
const User_1 = require("./User");
Object.defineProperty(exports, "User", { enumerable: true, get: function () { return User_1.User; } });

},{"./Hashmail":210,"./Identity":211,"./User":212}],"/home/lukas/Work/Projects/privfs/privmx/privmx-desktop-client/main/app/node_modules/privfs-client/out/index-browser-ext.js":[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.privmx = exports.collectFormData = exports.send = void 0;
const privmx = require("./index");
exports.privmx = privmx;
function send(options) {
    options = options || {};
    if (options.form) {
        const formData = collectFormData(options.form);
        options.data = formData.fields;
        options.files = formData.files;
    }
    if (options.protocol == "https") {
        privmx.core.PrivFsRpcManager.setServiceDiscoveryJsonMode(privmx.serviceDiscovery.JsonMode.HTTPS_ONLY);
    }
    else if (options.protocol == "http") {
        privmx.core.PrivFsRpcManager.setServiceDiscoveryJsonMode(privmx.serviceDiscovery.JsonMode.HTTP_ONLY);
    }
    else {
        privmx.core.PrivFsRpcManager.setServiceDiscoveryJsonMode(window.location.protocol === "https:" ?
            privmx.serviceDiscovery.JsonMode.HTTPS_ONLY : privmx.serviceDiscovery.JsonMode.HTTP_ONLY);
    }
    const promise = privmx.core.AnonymousPrivmxClient.create(options.host).then(client => {
        const attachments = [];
        if (options.files) {
            options.files.forEach(file => {
                attachments.push(new privmx.lazyBuffer.BrowserLazyContent(file));
            });
        }
        return client.postMessage(options.sid, options.subject, JSON.stringify(options.data), attachments, options.extra, options.tags);
    });
    if (typeof options.onSuccess == "function") {
        promise.then(options.onSuccess);
    }
    if (typeof options.onError == "function") {
        promise.catch(options.onError);
    }
    return promise;
}
exports.send = send;
function collectFormData(form) {
    const result = {
        fields: {},
        files: []
    };
    function addFieldValue(name, value) {
        if (!result.fields[name]) {
            result.fields[name] = [];
        }
        result.fields[name].push(value);
    }
    for (let i = 0; i < form.elements.length; i++) {
        const elem = form.elements[i];
        if (!elem.name) {
            continue;
        }
        switch (elem.type) {
            case "file":
                const fileElem = elem;
                for (let j = 0; j < fileElem.files.length; j++) {
                    result.files.push(fileElem.files[j]);
                }
                break;
            case "select-multiple":
            case "select-one":
                const selectElem = elem;
                for (let j = 0; j < selectElem.options.length; j++) {
                    if (selectElem.options[j].selected) {
                        addFieldValue(elem.name, selectElem.options[j].value);
                    }
                }
                break;
            case "checkbox":
            case "radio":
                const inputElem = elem;
                if (inputElem.checked) {
                    addFieldValue(elem.name, elem.value);
                }
                break;
            default:
                addFieldValue(elem.name, elem.value);
                break;
        }
    }
    Object.keys(result.fields).forEach(function (key) {
        if (result.fields[key].length == 1) {
            result.fields[key] = result.fields[key][0];
        }
    });
    return result;
}
exports.collectFormData = collectFormData;
if (typeof (window) == "undefined") {
    require("privmx-crypto/out/src/crypto/webworker/Listener");
}

},{"./index":214,"privmx-crypto/out/src/crypto/webworker/Listener":252}],214:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.utils = exports.serviceDiscovery = exports.rpc = exports.pki = exports.bs58 = exports.Buffer = exports.lazyBuffer = exports.crypto = exports.types = exports.message = exports.identity = exports.gateway = exports.fs = exports.exception = exports.db = exports.core = exports.block = void 0;
const block = require("./block");
exports.block = block;
const core = require("./core");
exports.core = core;
const db = require("./db");
exports.db = db;
const exception = require("./exception");
exports.exception = exception;
const fs = require("./fs");
exports.fs = fs;
const gateway = require("./gateway");
exports.gateway = gateway;
const identity = require("./identity");
exports.identity = identity;
const message = require("./message");
exports.message = message;
const types = require("./types");
exports.types = types;
const crypto = require("privmx-crypto");
exports.crypto = crypto;
const serviceDiscovery = require("privmx-service-discovery");
exports.serviceDiscovery = serviceDiscovery;
const rpc = require("privmx-rpc");
exports.rpc = rpc;
const utils = require("simplito-utils");
exports.utils = utils;
const lazyBuffer = require("simplito-lazybuffer");
exports.lazyBuffer = lazyBuffer;
const bs58 = require("bs58");
exports.bs58 = bs58;
const pki = require("privmx-pki");
exports.pki = pki;
const Buffer = require("buffer");
exports.Buffer = Buffer;

},{"./block":135,"./core":165,"./db":171,"./exception":173,"./fs":207,"./gateway":209,"./identity":213,"./message":226,"./types":227,"bs58":44,"buffer":498,"privmx-crypto":265,"privmx-pki":326,"privmx-rpc":366,"privmx-service-discovery":375,"simplito-lazybuffer":398,"simplito-utils":422}],215:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
const MessageAttachment_1 = require("./MessageAttachment");
const Identity_1 = require("../identity/Identity");
const User_1 = require("../identity/User");
const MessageReceiver_1 = require("./MessageReceiver");
const privmx_crypto_1 = require("privmx-crypto");
class Message {
    msgId;
    receivers;
    createDate;
    attachments;
    sender;
    title;
    text;
    type;
    inReplyTo;
    forwarded;
    contentType;
    serverDate;
    deleted;
    constructor() {
        this.msgId = privmx_crypto_1.service.randomBytes(16).toString("hex");
        this.receivers = [];
        this.createDate = new Date();
        this.attachments = [];
    }
    setSender(sender) {
        if (!(sender instanceof Identity_1.Identity)) {
            throw new Error("Invalid parameter");
        }
        this.sender = sender;
    }
    addReceiver(receiver) {
        if (!(receiver instanceof MessageReceiver_1.MessageReceiver)) {
            throw new Error("Invalid parameter");
        }
        this.receivers.push(receiver);
    }
    setTitle(title) {
        this.title = title;
    }
    setText(text) {
        this.text = text;
    }
    setType(type) {
        this.type = type;
    }
    addAttachment(data) {
        this.attachments.push(data);
    }
    checkReadyToSent() {
        if (this.sender == null) {
            throw new Error("Sender cannot be empty");
        }
        if (!(this.sender instanceof Identity_1.Identity)) {
            throw new Error("Sender must be instance of Identity");
        }
        if (this.receivers.length == 0) {
            throw new Error("Message must contains at least one receiver");
        }
        for (let i = 0; i < this.receivers.length; i++) {
            if (!(this.receivers[i] instanceof MessageReceiver_1.MessageReceiver)) {
                throw new Error("Receiver must be instance of MessageReceiver");
            }
        }
    }
    checkReadyToCreate() {
        if (this.sender == null) {
            throw new Error("Sender cannot be empty");
        }
        if (!(this.sender instanceof User_1.User)) {
            throw new Error("Sender must be instance of User");
        }
        if (this.receivers.length == 0) {
            throw new Error("Message must contains at least one receiver");
        }
        for (let i = 0; i < this.receivers.length; i++) {
            if (!(this.receivers[i] instanceof MessageReceiver_1.MessageReceiver)) {
                throw new Error("Receiver must be instance of MessageReceiver");
            }
        }
    }
    serialize(mainReceiver, attachments, outerSignatory) {
        let data;
        return Promise.resolve().then(() => {
            const createMessageMode = mainReceiver == null;
            if (!createMessageMode && this.receivers.indexOf(mainReceiver) == -1) {
                throw new Error("Main receiver not at receiver list");
            }
            const serializedAttachments = [];
            attachments.forEach(attachment => {
                serializedAttachments.push(MessageAttachment_1.MessageAttachment.serialize(attachment));
            });
            const receivers = [];
            this.receivers.forEach(receiver => {
                receivers.push({
                    name: receiver.user.name,
                    hashmail: receiver.user.hashmail,
                    pub58: receiver.user.pub58,
                    sinkPub58: receiver.sink.pub58,
                    sent: createMessageMode && receiver.sent === false ? false : undefined
                });
            });
            data = {
                msgId: this.msgId,
                createDate: this.createDate.getTime(),
                text: this.text,
                title: this.title,
                inReplyTo: this.inReplyTo,
                forwarded: this.forwarded,
                attachments: serializedAttachments,
                sender: {
                    name: this.sender.name,
                    hashmail: this.sender.hashmail,
                    pub58: this.sender.pub58
                },
                sid: createMessageMode ? undefined : mainReceiver.sink.id,
                outerSignatory: outerSignatory,
                receivers: receivers,
                type: this.type,
                contentType: this.contentType,
                deleted: this.deleted
            };
            const sigData = Buffer.from(JSON.stringify(data), "utf8");
            return privmx_crypto_1.service.signToCompactSignatureWithHash(this.sender.priv, sigData)
                .then(signature => {
                return {
                    data: data,
                    signature: signature.toString("base64")
                };
            });
        });
    }
    static deserializeWithoutCheckingSignature;
    static deserializeFromSourceWithoutCheckingSignature;
}
exports.Message = Message;
const SentMessage_1 = require("./SentMessage");
Message.deserializeWithoutCheckingSignature = SentMessage_1.SentMessage.deserializeWithoutCheckingSignature;
Message.deserializeFromSourceWithoutCheckingSignature = SentMessage_1.SentMessage.deserializeFromSourceWithoutCheckingSignature;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../identity/Identity":211,"../identity/User":212,"./MessageAttachment":216,"./MessageReceiver":218,"./SentMessage":222,"buffer":498,"privmx-crypto":265}],216:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageAttachment = void 0;
const BlocksInfo_1 = require("../block/BlocksInfo");
class MessageAttachment {
    message;
    info;
    blocksInfo;
    constructor(message, info) {
        this.message = message;
        this.info = info;
    }
    getName() {
        return this.info.name;
    }
    getMimeType() {
        return this.info.mimeType;
    }
    getSize() {
        return this.info.size;
    }
    getAttachmentIndex() {
        return this.message.attachments.indexOf(this);
    }
    serialize() {
        return MessageAttachment.serialize(this.info);
    }
    static serialize(info) {
        return {
            name: info.name,
            mimeType: info.mimeType,
            blocks: info.blocks,
            size: info.size,
            key: info.key.toString("base64")
        };
    }
    static deserializeBlocksInfoData(attachment) {
        return {
            name: attachment.name,
            mimeType: attachment.mimeType,
            blocks: attachment.blocks,
            size: attachment.size,
            key: Buffer.from(attachment.key, "base64")
        };
    }
    static deserialize(message, attachment) {
        return new MessageAttachment(message, MessageAttachment.deserializeBlocksInfoData(attachment));
    }
    getBids() {
        let bids = "";
        this.info.blocks.forEach(bid => {
            bids += (bids == "" ? "" : ",") + bid;
        });
        return bids;
    }
    checkBlocks(blockMap) {
        for (let i = 0; i < this.info.blocks.length; i++) {
            if (!(this.info.blocks[i] in blockMap)) {
                return false;
            }
        }
        return true;
    }
    getBlocksInfo(cache) {
        if (this.blocksInfo == null) {
            const source = {
                type: "message",
                sid: this.message.sink.id,
                mid: this.message.id
            };
            this.blocksInfo = new BlocksInfo_1.BlocksInfo(this.message.storage, source, {
                blocks: this.info.blocks,
                mimeType: this.info.mimeType,
                size: this.info.size,
                key: this.info.key,
                name: this.info.name
            }, {
                cacheEnabled: !!cache
            });
        }
        if (cache) {
            this.blocksInfo.cachedBuffer.cacheEnabled = cache;
        }
        return this.blocksInfo;
    }
    getContent(options) {
        return this.getBlocksInfo(options ? options.cache : null).getContent(options);
    }
    clearCache(cacheEnabled) {
        if (this.blocksInfo) {
            this.blocksInfo.clearCache(cacheEnabled);
        }
    }
    static getAllBlocks(attachments) {
        const result = [];
        attachments.forEach(a => {
            a.blocks.forEach(b => {
                result.push(b);
            });
        });
        return result;
    }
}
exports.MessageAttachment = MessageAttachment;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../block/BlocksInfo":134,"buffer":498}],217:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageManager = void 0;
const privmx_crypto_1 = require("privmx-crypto");
const BlockStreamer_1 = require("../block/BlockStreamer");
const MessageSinkCursor_1 = require("./MessageSinkCursor");
const MessageSinkPriv_1 = require("./MessageSinkPriv");
const Message_1 = require("./Message");
const SentMessage_1 = require("./SentMessage");
const MessageAttachment_1 = require("./MessageAttachment");
const TagService_1 = require("./TagService");
const RootLogger = require("simplito-logger");
const simplito_promise_1 = require("simplito-promise");
const BlocksInfo_1 = require("../block/BlocksInfo");
const Logger = RootLogger.get("privfs-client.message.MessageManager");
class MessageManager {
    storageProviderManager;
    storage;
    identity;
    tagService;
    constructor(storageProviderManager, identity) {
        this.storageProviderManager = storageProviderManager;
        this.identity = identity;
        this.tagService = new TagService_1.TagService();
    }
    async init() {
        const storage = await this.storageProviderManager.getProvider(this.identity.host);
        this.storage = storage;
    }
    async sinkGetAllMy(encryptor) {
        const sinks = await this.storage.sinkGetAllMy();
        const result = [];
        for (const sink of sinks) {
            if (!sink.data) {
                continue;
            }
            const data = await encryptor.decrypt(Buffer.from(sink.data, "base64"));
            const sinkPriv = MessageSinkPriv_1.MessageSinkPriv.fromSerialized(data.wif, data.name, data.description, sink.acl, data.extra, sink.options);
            if (sinkPriv.id != sink.id) {
                throw new Error("Invalid sink private key");
            }
            result.push(sinkPriv);
        }
        return result;
    }
    static async prepareSinkCreateRequest(name, description, acl, extra, encryptor, options) {
        const sink = new MessageSinkPriv_1.MessageSinkPriv(privmx_crypto_1.serviceSync.eccPrivRandom(), name, description, acl, extra, options);
        const data = {
            extra: sink.extra,
            name: sink.name,
            description: sink.description,
            wif: sink.privWif
        };
        const enc = await encryptor.encrypt(data);
        return {
            sink: sink,
            data: {
                id: sink.id,
                acl: sink.acl,
                data: enc.toString("base64"),
                options: sink.options
            }
        };
    }
    async sinkCreate(name, description, acl, extra, encryptor, options) {
        const res = await MessageManager.prepareSinkCreateRequest(name, description, acl, extra, encryptor, options);
        await this.storage.sinkCreate(res.data.id, res.data.acl, res.data.data, res.data.options);
        return res.sink;
    }
    sinkSave(sink, encryptor) {
        const data = {
            extra: sink.extra,
            name: sink.name,
            description: sink.description,
            wif: sink.privWif
        };
        return encryptor.encrypt(data)
            .then(enc => {
            return this.storage.sinkSave(sink.id, sink.acl, enc.toString("base64"), sink.options);
        });
    }
    sinkUpdateOptions(sink) {
        return this.storage.sinkUpdateOptions(sink.id, sink.options);
    }
    sinkDelete(sink) {
        return this.storage.sinkDelete(sink.id);
    }
    sinkSetLastSeenSeq(sid, lastSeenSeq) {
        return this.storage.sinkSetLastSeenSeq(sid, lastSeenSeq);
    }
    sinkPoll(cursors, updateCursors, updateLastSeen) {
        return this.sinkPollCore(cursors, updateCursors, updateLastSeen, (request, updateLastSeen) => this.storage.sinkPoll(request, updateLastSeen));
    }
    sinkWait(cursors, updateCursors, updateLastSeen) {
        return this.sinkPollCore(cursors, updateCursors, updateLastSeen, (request, updateLastSeen) => this.storage.sinkWait(request, updateLastSeen));
    }
    async sinkPollCore(cursors, updateCursors, updateLastSeen, func) {
        const request = [];
        for (const cursor of cursors) {
            request.push({
                sid: cursor.sink.id,
                seq: cursor.seq,
                modSeq: cursor.modSeq
            });
        }
        const mods = await func(request, updateLastSeen);
        for (const sid in mods.sinks) {
            const mod = mods.sinks[sid];
            let cursor = null;
            for (let i = 0; i < cursors.length; i++) {
                if (cursors[i].sink.id == sid) {
                    cursor = cursors[i];
                    break;
                }
            }
            if (cursor == null) {
                throw new Error("Cannot find cursor");
            }
            if (updateCursors) {
                cursor.seq = mod.seq;
                cursor.modSeq = mod.modSeq;
            }
            const encKey = cursor.sink.priv.getPrivateEncKey();
            for (const meta of mod.meta) {
                if (meta.data == "") {
                    meta.data = null;
                }
                else {
                    try {
                        const data = await privmx_crypto_1.service.privmxDecrypt(privmx_crypto_1.service.privmxOptSignedCipher(), Buffer.from(meta.data, "base64"), encKey);
                        meta.data = JSON.parse(data.toString("utf8"));
                    }
                    catch (e) {
                        meta.error = e;
                    }
                }
            }
            for (const [i, msg] of mod.msg.entries()) {
                try {
                    const message = await this.decodeMessageAsync(cursor.sink, msg);
                    mod.msg[i] = message;
                }
                catch (e) {
                    mod.msg[i] = {
                        data: msg,
                        error: e
                    };
                }
            }
        }
        return mods;
    }
    sinkClear(cursor, updateCursor) {
        return this.storage.sinkClear(cursor.sink.id, cursor.modSeq)
            .then(result => {
            if (updateCursor) {
                cursor.seq = result.seq;
                cursor.modSeq = result.modSeq;
            }
            return result;
        });
    }
    sinkInfo(sid, addMidList) {
        return this.storage.sinkInfo(sid, !!addMidList);
    }
    encodeSinkQuery(query) {
        return Promise.resolve().then(() => {
            if (typeof (query) == "string") {
                return this.tagService.createTag(this.identity.pub, query);
            }
            else if (query.operand == "OR" || query.operand == "AND") {
                let left;
                return Promise.resolve().then(() => {
                    return this.encodeSinkQuery(query.left);
                })
                    .then(l => {
                    left = l;
                    return this.encodeSinkQuery(query.right);
                })
                    .then(right => {
                    return {
                        operand: query.operand,
                        right: right,
                        left: left
                    };
                });
            }
            else if (query.operand == "NOT") {
                return Promise.resolve().then(() => {
                    return this.encodeSinkQuery(query.value);
                })
                    .then(encoded => {
                    return {
                        operand: query.operand,
                        value: encoded
                    };
                });
            }
            return query;
        });
    }
    sinkQuery(sid, query, limit, order) {
        return Promise.resolve().then(() => {
            return this.encodeSinkQuery(query);
        })
            .then(encodedQuery => {
            return this.storage.sinkQuery(sid, encodedQuery, limit, order);
        });
    }
    messageSetStickers(sid, mid, stickers, replace) {
        return this.storage.messageSetStickers(sid, mid, stickers, replace);
    }
    sendAttachment(transferIds, attachment) {
        let key;
        return Promise.resolve().then(() => {
            if (attachment instanceof BlocksInfo_1.BlocksInfo) {
                key = attachment.data.key;
                return BlockStreamer_1.BlockStreamer.addBlocksToSessionByInfo(this.storage, transferIds, attachment);
            }
            key = privmx_crypto_1.service.randomBytes(32);
            return BlockStreamer_1.BlockStreamer.stream(this.storage, transferIds, attachment, key, null);
        })
            .then(blocks => {
            return BlocksInfo_1.BlocksInfo.getBlocksData(attachment, key, blocks);
        });
    }
    sendAttachments(transferIds, attachments) {
        const aPromises = [];
        attachments.forEach(attachment => {
            aPromises.push(this.sendAttachment(transferIds, attachment));
        });
        return Promise.all(aPromises);
    }
    static allPass(list, func) {
        for (let i = 0; i < list.length; i++) {
            if (!func(list[i])) {
                return false;
            }
        }
        return true;
    }
    getTransferForAttachments(storage, attachments, singleReceiver) {
        if (attachments.length == 0) {
            const transfer = {
                type: "transfer",
                transferId: ""
            };
            return Promise.resolve({
                attachments: [],
                transfer: transfer
            });
        }
        if (!storage.config.inlineTransferSupported) {
            return Promise.resolve(null);
        }
        if (MessageManager.allPass(attachments, x => x instanceof BlocksInfo_1.BlocksInfo && x.storage.getDestination() == storage.getDestination())) {
            const transfer = {
                type: "blocksInfo",
                blocksInfo: attachments.map(x => {
                    const info = x;
                    return {
                        blocks: info.data.blocks,
                        source: info.source
                    };
                })
            };
            const newAttachments = attachments.map(x => {
                const info = x;
                return BlocksInfo_1.BlocksInfo.getBlocksData(x, info.data.key, info.data.blocks);
            });
            return Promise.resolve({
                attachments: newAttachments,
                transfer: transfer
            });
        }
        if (singleReceiver && MessageManager.allPass(attachments, x => !(x instanceof BlocksInfo_1.BlocksInfo))) {
            let blocksCount = 0;
            attachments.forEach(x => {
                blocksCount += BlockStreamer_1.BlockStreamer.getBlocksCount(storage.config, x.getSize());
            });
            if (blocksCount > storage.config.maxInlineBlocksCount) {
                return Promise.resolve(null);
            }
            return simplito_promise_1.PromiseUtils.collect(attachments, (_, attachment) => {
                const key = privmx_crypto_1.service.randomBytes(32);
                return BlockStreamer_1.BlockStreamer.prepareBlocks(storage.config, attachment, key).then(data => {
                    return { data: data, key: key, attachment: attachment };
                });
            })
                .then(data => {
                const blocks = [];
                data.forEach(x => {
                    x.data.forEach(y => {
                        blocks.push(y);
                    });
                });
                const transfer = {
                    type: "blocks",
                    blocks: blocks
                };
                const newAttachments = data.map(x => {
                    return BlocksInfo_1.BlocksInfo.getBlocksData(x.attachment, x.key, x.data.map(y => y.bid));
                });
                return { attachments: newAttachments, transfer: transfer };
            });
        }
        return Promise.resolve(null);
    }
    getSingleTransferForAttachments(storage, attachments, transferGetter) {
        return Promise.resolve().then(() => {
            return this.getTransferForAttachments(storage, attachments, true);
        })
            .then(transferData => {
            if (transferData) {
                return transferData;
            }
            let transfer;
            return Promise.resolve().then(() => {
                return transferGetter();
            })
                .then(transferId => {
                transfer = {
                    type: "transfer",
                    transferId: transferId
                };
                return this.sendAttachments([transferId], attachments);
            })
                .then(attachments => {
                return {
                    transfer: transfer,
                    attachments: attachments
                };
            });
        });
    }
    prepareMessageDataToSend(message, attachments, receiver) {
        let senderPriv, senderPub58, senderHashmail, extra, extraEnc, blocks;
        return Promise.resolve().then(() => {
            senderPriv = message.sender.priv;
            senderPub58 = message.sender.pub58;
            senderHashmail = message.sender.hashmail;
            return message.serialize(receiver, attachments, senderPub58);
        })
            .then(serializedMsg => {
            extra = {
                data: serializedMsg.data,
                signature: serializedMsg.signature
            };
            const extraBuffer = Buffer.from(JSON.stringify(extra), "utf8");
            return privmx_crypto_1.service.eciesEncrypt(senderPriv, receiver.sink.pub, extraBuffer);
        })
            .then(enc => {
            extraEnc = enc;
            return privmx_crypto_1.service.sha256(extraEnc);
        })
            .then(hash => {
            blocks = MessageAttachment_1.MessageAttachment.getAllBlocks(attachments);
            const versionData = blocks.join("") + hash.toString("base64") + receiver.sink.id + senderPub58;
            return privmx_crypto_1.service.signToCompactSignatureWithHash(senderPriv, Buffer.from(versionData, "utf8"));
        })
            .then(signature => {
            const data = {
                sid: receiver.sink.id,
                senderPub58: senderPub58,
                senderHashmail: senderHashmail,
                blocks: blocks,
                extra: extraEnc.toString("base64"),
                signature: signature.toString("base64")
            };
            const source = {
                data: extra.data,
                signature: extra.signature
            };
            return {
                data: data,
                source: source
            };
        });
    }
    prepareMessageDataToCreate(message, sink, attachments) {
        let outerPub58, receiver;
        return Promise.resolve().then(() => {
            const many = message.receivers.length > 1;
            outerPub58 = message.sender.pub58;
            receiver = many ? null : message.receivers[0];
            return message.serialize(receiver, attachments, outerPub58);
        })
            .then(serializedMsg => {
            const extra = {
                data: serializedMsg.data,
                signature: serializedMsg.signature,
                pub: outerPub58,
                serverDate: message.serverDate ? message.serverDate.getTime() : null,
                sink: receiver == null ? null : receiver.sink.id
            };
            return this.prepareMessageData(extra, sink, attachments);
        });
    }
    prepareMessageDataToCopy(message, sink, attachments) {
        return Promise.resolve().then(() => {
            const extra = {
                data: message.source.data,
                signature: message.source.signature,
                pub: message.outerSignatory,
                serverDate: message.serverDate.getTime(),
                sink: message.mainReceiver == null ? null : message.mainReceiver.sink.id
            };
            return this.prepareMessageData(extra, sink, attachments);
        });
    }
    prepareMessageData(extra, sink, attachments) {
        let blocks, extraEnc;
        return Promise.resolve().then(() => {
            const extraBuffer = Buffer.from(JSON.stringify(extra), "utf8");
            return privmx_crypto_1.service.privmxEncrypt(privmx_crypto_1.service.privmxOptAesWithAttachedIv(), extraBuffer, sink.priv.getPrivateEncKey());
        })
            .then(enc => {
            extraEnc = enc;
            return privmx_crypto_1.service.sha256(extraEnc);
        })
            .then(hash => {
            blocks = MessageAttachment_1.MessageAttachment.getAllBlocks(attachments);
            const versionData = blocks.join("") + hash.toString("base64") + sink.id + sink.id;
            return privmx_crypto_1.service.signToCompactSignatureWithHash(sink.priv, Buffer.from(versionData, "utf8"));
        })
            .then(signature => {
            const data = {
                sid: sink.id,
                senderPub58: sink.id,
                blocks: blocks,
                extra: extraEnc.toString("base64"),
                signature: signature.toString("base64")
            };
            const source = {
                data: extra.data,
                signature: extra.signature,
                serverDate: extra.serverDate
            };
            return {
                data: data,
                source: source
            };
        });
    }
    messagePostSingle(message, tags, attachments, receiver, extra) {
        let msgData, mTags;
        return Promise.resolve().then(() => {
            return this.tagService.createTags(receiver.receiver.user.pub, tags);
        })
            .then(t => {
            mTags = t;
            return this.prepareMessageDataToSend(message, attachments, receiver.receiver);
        })
            .then(d => {
            msgData = d;
            return this.storage.messagePost(msgData.data, mTags, receiver.transfer, extra);
        })
            .then(data => {
            const serverDate = new Date(parseInt(data.serverDate));
            msgData.source.serverId = data.serverId;
            msgData.source.serverDate = serverDate.getTime();
            receiver.success = true;
            receiver.source = msgData.source;
            receiver.message = Message_1.Message.deserializeFromSourceWithoutCheckingSignature(this.storage, msgData.source);
        })
            .catch(e => {
            receiver.success = false;
            receiver.cause = e;
        });
    }
    messagePostInit(message, receiver, extra) {
        let nonce, timestamp;
        return Promise.resolve().then(() => {
            nonce = privmx_crypto_1.service.randomBytes(32).toString("base64");
            timestamp = new Date().getTime().toString();
            const data = Buffer.from("messagePost" + receiver.sink.id + message.sender.hashmail + " " + nonce + " " + timestamp, "utf8");
            return privmx_crypto_1.service.signToCompactSignatureWithHash(message.sender.priv, data);
        })
            .then(signature => {
            return this.storage.messagePostInit(receiver.sink.id, {
                hashmail: message.sender.hashmail,
                pub: message.sender.pub58,
                nonce: nonce,
                timestamp: timestamp,
                signature: signature.toString("base64")
            }, extra);
        });
    }
    messagePostToReceivers(message, tags, receivers, options, additionalTransfers) {
        return Promise.resolve().then(() => {
            if (!(message instanceof Message_1.Message)) {
                throw new Error("Invalid message");
            }
            message.checkReadyToSent();
            const hostMap = {};
            receivers.forEach(receiver => {
                const host = receiver.user.host;
                if (!(host in hostMap)) {
                    hostMap[host] = {
                        host: host,
                        transfers: [],
                        transferIds: [],
                        messageManager: null
                    };
                }
                const hostEntry = hostMap[host];
                const receiverData = {
                    host: host,
                    receiver: receiver,
                    transferIdGetter: () => hostEntry.messageManager.messagePostInit(message, receiver, options ? options.extra : null)
                };
                hostEntry.transfers.push(receiverData);
            });
            if (additionalTransfers != null) {
                additionalTransfers.forEach(transfer => {
                    const host = transfer.host;
                    if (!(host in hostMap)) {
                        hostMap[host] = {
                            host: host,
                            transfers: [],
                            transferIds: [],
                            messageManager: null
                        };
                    }
                    const hostEntry = hostMap[host];
                    hostEntry.transfers.push(transfer);
                });
            }
            return simplito_promise_1.PromiseUtils.settle(hostMap, (_, hostEntry) => {
                let extraSent = false;
                return Promise.resolve().then(() => {
                    return this.storageProviderManager.getProvider(hostEntry.host);
                })
                    .then(receiverStorage => {
                    hostEntry.messageManager = new MessageManager(this.storageProviderManager, this.identity);
                    hostEntry.messageManager.storage = receiverStorage;
                    return this.getTransferForAttachments(receiverStorage, message.attachments, hostEntry.transfers.length == 1);
                })
                    .then(transferData => {
                    if (transferData) {
                        hostEntry.transfers.forEach(x => {
                            x.transfer = transferData.transfer;
                        });
                        return transferData.attachments;
                    }
                    return simplito_promise_1.PromiseUtils.settle(hostEntry.transfers, (_, transferEntry) => {
                        return Promise.resolve().then(() => {
                            return transferEntry.transferIdGetter();
                        })
                            .then(transferId => {
                            extraSent = true;
                            const transfer = {
                                type: "transfer",
                                transferId: transferId
                            };
                            transferEntry.transfer = transfer;
                            hostEntry.transferIds.push(transferId);
                        })
                            .catch(e => {
                            transferEntry.success = false;
                            transferEntry.cause = e;
                        });
                    })
                        .then(() => {
                        if (hostEntry.transferIds.length == 0) {
                            return [];
                        }
                        return hostEntry.messageManager.sendAttachments(hostEntry.transferIds, message.attachments);
                    });
                })
                    .then(attachments => {
                    hostEntry.transfers.forEach(transferEntry => {
                        if (transferEntry.receiver == null) {
                            transferEntry.success = true;
                        }
                        transferEntry.attachments = attachments;
                    });
                    return simplito_promise_1.PromiseUtils.settle(hostEntry.transfers, (_, transferEntry) => {
                        if (transferEntry.success === false || transferEntry.receiver == null) {
                            return;
                        }
                        return hostEntry.messageManager.messagePostSingle(message, tags, attachments, transferEntry, !extraSent && options ? options.extra : null);
                    });
                })
                    .catch(e => {
                    hostEntry.transfers.forEach(transfer => {
                        if (transfer.success == null) {
                            transfer.success = false;
                            transfer.cause = e;
                        }
                    });
                });
            })
                .then(() => {
                const result = [];
                for (const host in hostMap) {
                    hostMap[host].transfers.forEach(transferEntry => {
                        if (transferEntry.receiver != null) {
                            result.push(transferEntry);
                        }
                    });
                }
                return result;
            });
        });
    }
    messagePostToReceiversAndSaveInOutbox(message, tags, receivers, options) {
        if (options == null || options.outbox == null) {
            return this.messagePostToReceivers(message, tags, receivers, options);
        }
        let messageManager = this, transfer, res;
        return Promise.resolve().then(() => {
            transfer = {
                host: messageManager.storage.getDestination(),
                transferIdGetter: () => messageManager.messageCreateInit(options.outbox.sink)
            };
            return messageManager.messagePostToReceivers(message, tags, receivers, options, [transfer]);
        })
            .then(results => {
            res = {
                results: results,
                errors: 0
            };
            let first;
            results.forEach(result => {
                res.errors += result.success ? 0 : 1;
                first = first == null && result.success ? result : first;
            });
            res.nooneGetMsg = res.errors == results.length;
            if (res.nooneGetMsg) {
                return res;
            }
            if (!transfer.success) {
                res.outboxError = transfer.cause;
                return res;
            }
            return Promise.resolve().then(() => {
                message.serverDate = new Date(first.source.serverDate);
                messageManager.updateReceiversSentStatus(message, res.results);
                return messageManager.messageCreateCore(message, options.outbox.flags, options.outbox.tags, options.outbox.sink, transfer.attachments, transfer.transfer);
            })
                .then(outboxMessage => {
                res.outboxMessage = outboxMessage;
                return res;
            })
                .catch(e => {
                res.outboxError = e;
                return res;
            });
        });
    }
    messagePost(message, tags, options) {
        return this.messagePostToReceiversAndSaveInOutbox(message, tags, message.receivers, options);
    }
    messageResend(message, tags, receivers, options) {
        return this.messagePostToReceiversAndSaveInOutbox(message, tags, receivers, options);
    }
    updateReceiversSentStatus(message, results) {
        for (let i = 0; i < results.length; i++) {
            const r = results[i];
            for (let j = 0; j < message.receivers.length; j++) {
                const mr = message.receivers[j];
                if (r.receiver == mr) {
                    mr.sent = r.success;
                }
            }
        }
    }
    convertMessageToRaw(message, cacheAttachments) {
        return message.createMessage(cacheAttachments);
    }
    messageUpdate(message, mid, tags) {
        let transfer, receiver, msgData;
        return Promise.resolve().then(() => {
            if (!(message instanceof Message_1.Message) || message.receivers.length != 1) {
                throw new Error("Invalid parameter");
            }
            message.checkReadyToSent();
            receiver = message.receivers[0];
            return this.getSingleTransferForAttachments(this.storage, message.attachments, () => this.storage.messageUpdateInit(receiver.sink.id, mid, message.sender.pub58));
        })
            .then(transferData => {
            transfer = transferData.transfer;
            return Promise.all([
                this.tagService.createTags(receiver.user.pub, tags),
                this.prepareMessageDataToSend(message, transferData.attachments, receiver)
            ]);
        })
            .then(result => {
            const [mTags, md] = result;
            msgData = md;
            return this.storage.messageUpdate(msgData.data, mid, mTags, transfer);
        })
            .then(data => {
            const lastEdit = new Date(parseInt(data.lastEdit));
            const serverDate = new Date(parseInt(data.serverDate));
            msgData.source.serverId = data.serverId;
            msgData.source.serverDate = serverDate.getTime();
            msgData.source.editCount = data.editCount;
            msgData.source.lastEdit = lastEdit.getTime();
            return Message_1.Message.deserializeFromSourceWithoutCheckingSignature(this.storage, msgData.source);
        });
    }
    messageUpdateInit(sinkId, mid, senderPub58) {
        return Promise.resolve().then(() => {
            return this.storage.messageUpdateInit(sinkId, mid, senderPub58);
        });
    }
    messageCreate(message, flags, tags, sink) {
        return Promise.resolve().then(() => {
            if (!(message instanceof Message_1.Message) || !(sink instanceof MessageSinkPriv_1.MessageSinkPriv)) {
                throw new Error("Invalid parameter");
            }
            message.checkReadyToCreate();
            return this.getSingleTransferForAttachments(this.storage, message.attachments, () => this.storage.messageCreateInit(sink.id));
        })
            .then(transferData => {
            return this.messageCreateCore(message, flags, tags, sink, transferData.attachments, transferData.transfer);
        });
    }
    messageCreateInit(sink) {
        return Promise.resolve().then(() => {
            if (!(sink instanceof MessageSinkPriv_1.MessageSinkPriv)) {
                throw new Error("Invalid parameter");
            }
            return this.storage.messageCreateInit(sink.id);
        });
    }
    messageCreateCore(message, flags, tags, sink, attachments, transfer) {
        let msgData;
        return Promise.resolve().then(() => {
            if (!(message instanceof Message_1.Message) || !(sink instanceof MessageSinkPriv_1.MessageSinkPriv)) {
                throw new Error("Invalid parameter");
            }
            message.checkReadyToCreate();
            return Promise.all([
                this.tagService.createTags(this.identity.pub, tags),
                this.encryptFlags(flags, sink),
                this.prepareMessageDataToCreate(message, sink, attachments)
            ]);
        })
            .then(result => {
            const [mTags, flagsEnc, md] = result;
            msgData = md;
            return this.storage.messageCreate(msgData.data, flagsEnc, mTags, transfer);
        })
            .then(data => {
            const serverDate = new Date(parseInt(data.serverDate));
            msgData.source.serverId = data.serverId;
            msgData.source.serverDate = serverDate.getTime();
            return Message_1.Message.deserializeFromSourceWithoutCheckingSignature(this.storage, msgData.source);
        });
    }
    messageMove(message, flags, tags, src, dest, updateCursor) {
        let msgData, expectedModSeq = src.modSeq + 1;
        return Promise.resolve().then(() => {
            if (!(message instanceof SentMessage_1.SentMessage) || !(src instanceof MessageSinkCursor_1.MessageSinkCursor) || !(dest instanceof MessageSinkPriv_1.MessageSinkPriv)) {
                throw new Error("Invalid parameter");
            }
            return this.getSingleTransferForAttachments(this.storage, message.getAttachmentSources(false), () => this.storage.messageCreateAndDeleteInit(src.sink.id, message.id, dest.id));
        })
            .then(transferData => {
            return Promise.all([
                this.tagService.createTags(this.identity.pub, tags),
                this.encryptFlags(flags, dest),
                this.prepareMessageDataToCopy(message, dest, transferData.attachments)
            ])
                .then(result => {
                const [mTags, flagsEnc, md] = result;
                msgData = md;
                return this.storage.messageCreateAndDelete(msgData.data, flagsEnc, mTags, transferData.transfer, src.sink.id, message.serverId, expectedModSeq);
            })
                .then(data => {
                if (updateCursor) {
                    src.modSeq = expectedModSeq;
                }
                const serverDate = new Date(parseInt(data.serverDate));
                msgData.source.serverId = data.serverId;
                msgData.source.serverDate = serverDate.getTime();
                return {
                    message: message,
                    source: msgData.source
                };
            });
        });
    }
    messageDelete(cursor, midsP, updateCursor) {
        const mids = Array.isArray(midsP) ? midsP : [midsP];
        const messageManager = this, expectedModSeq = cursor.modSeq + mids.length;
        return Promise.resolve().then(() => {
            return messageManager.storage.messageDelete(cursor.sink.id, mids, expectedModSeq);
        })
            .then(() => {
            if (updateCursor) {
                cursor.modSeq = expectedModSeq;
            }
        });
    }
    messageModify(cursor, mid, flags, tags, updateCursor, rawTags) {
        let mTags, expectedModSeq = cursor.modSeq + 1;
        return Promise.resolve().then(() => {
            return rawTags ? tags : this.tagService.createTags(this.identity.pub, tags);
        })
            .then(t => {
            mTags = t;
            return this.encryptFlags(flags, cursor.sink);
        })
            .then(flagsEnc => {
            return this.storage.messageModify(cursor.sink.id, mid, flagsEnc, mTags, expectedModSeq);
        })
            .then(() => {
            if (updateCursor) {
                cursor.modSeq = expectedModSeq;
            }
        });
    }
    messageModifyTags(cursor, mids, toAdd, toRemove, updateCursor) {
        let mToAdd, expectedModSeq = cursor.modSeq + mids.length;
        return Promise.resolve().then(() => {
            return this.tagService.createTags(this.identity.pub, toAdd);
        })
            .then(t => {
            mToAdd = t;
            return this.tagService.createTags(this.identity.pub, toRemove);
        })
            .then(mToRemove => {
            return this.storage.messageModifyTags(cursor.sink.id, mids, mToAdd, mToRemove, expectedModSeq);
        })
            .then(() => {
            if (updateCursor) {
                cursor.modSeq = expectedModSeq;
            }
        });
    }
    encryptFlags(data, sink) {
        return Promise.resolve().then(() => {
            if (data == null) {
                return "";
            }
            const buf = Buffer.from(JSON.stringify(data), "utf8");
            return privmx_crypto_1.service.privmxEncrypt(privmx_crypto_1.service.privmxOptAesWithSignature(), buf, sink.priv.getPrivateEncKey())
                .then(enc => {
                return enc.toString("base64");
            });
        });
    }
    messageGet(sink, midsParam, mode, asMap) {
        if (!(sink instanceof MessageSinkPriv_1.MessageSinkPriv)) {
            throw new Error("Invalid parameter");
        }
        const isArray = Array.isArray(midsParam);
        const mids = isArray ? midsParam : [midsParam];
        if (mids.length == 0) {
            throw new Error("Empty mids list");
        }
        const encKey = sink.priv.getPrivateEncKey();
        return this.storage.messageGet(sink.id, mids, mode || "DATA_AND_META")
            .then(msgMap => {
            return Promise.resolve().then(() => {
                return simplito_promise_1.PromiseUtils.oneByOne(msgMap, (_, entry) => {
                    if (entry.meta == null) {
                        return;
                    }
                    if (entry.meta.data == "") {
                        entry.meta.data = null;
                    }
                    else {
                        return privmx_crypto_1.service.privmxDecrypt(privmx_crypto_1.service.privmxOptSignedCipher(), Buffer.from(entry.meta.data, "base64"), encKey)
                            .then(data => {
                            entry.meta.data = JSON.parse(data.toString("utf8"));
                        })
                            .catch(e => {
                            entry.metaError = e;
                        });
                    }
                });
            })
                .then(() => {
                return simplito_promise_1.PromiseUtils.oneByOne(msgMap, (_, entry) => {
                    if (entry.data == null) {
                        return;
                    }
                    return this.decodeMessageAsync(sink, entry.data)
                        .then(message => {
                        entry.data = message;
                    })
                        .catch(e => {
                        entry.dataError = e;
                    });
                });
            })
                .then(() => {
                if (!isArray) {
                    return msgMap[mids[0]];
                }
                if (asMap) {
                    return msgMap;
                }
                const result = [];
                for (const i in mids) {
                    result.push(msgMap[mids[i]]);
                }
                return result;
            });
        });
    }
    decodeMessageAsync(sink, data) {
        let senderPub, my = false, extraEnc, sid;
        return Promise.resolve().then(() => {
            sid = data.originalSid ? data.originalSid : sink.id;
            senderPub = privmx_crypto_1.ecc.PublicKey.fromBase58DER(data.senderPub58);
            extraEnc = Buffer.from(data.extra, "base64");
            return privmx_crypto_1.service.sha256(extraEnc);
        })
            .then(hash => {
            const versionData = data.blocks.join("") + hash.toString("base64") + sid + data.senderPub58;
            return privmx_crypto_1.service.verifyCompactSignatureWithHash(senderPub, Buffer.from(versionData, "utf8"), Buffer.from(data.signature, "base64"));
        })
            .then(validSignature => {
            if (!validSignature) {
                throw new Error("Invalid sink entry signature");
            }
            if (sink.id != sid) {
                const entry = sink.registry ? sink.registry.map[sid] : null;
                if (entry == null) {
                    throw new Error("Cannot decrypt proxied message - no key");
                }
                if (entry.type == "ecies") {
                    return privmx_crypto_1.service.eciesDecrypt(entry.priv, senderPub, extraEnc);
                }
                if (entry.type == "aesKey") {
                    return privmx_crypto_1.service.privmxDecrypt(extraEnc, entry.key);
                }
                throw new Error("Unsupported sink register entry type " + entry.type);
            }
            my = data.senderPub58 == sink.id;
            return my ? privmx_crypto_1.service.privmxDecrypt(extraEnc, sink.priv.getPrivateEncKey()) : privmx_crypto_1.service.eciesDecrypt(sink.priv, senderPub, extraEnc);
        })
            .then(extraBuffer => {
            const extraString = extraBuffer.toString("utf8");
            const lastEdit = data.lastEdit ? parseInt(data.lastEdit) : null;
            return SentMessage_1.SentMessage.deserialize2({
                storage: this.storage,
                my: my,
                data: extraString,
                sid: sid,
                senderPub58: data.senderPub58,
                serverId: data.serverId,
                serverDate: data.serverDate,
                lastEdit: lastEdit,
                editCount: data.editCount
            });
        })
            .catch(e => {
            if (e === "Error: Invalid checksum") {
                Logger.error("Message decode error", e, sink, data);
                return null;
            }
            return Promise.reject(e);
        });
    }
}
exports.MessageManager = MessageManager;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../block/BlockStreamer":133,"../block/BlocksInfo":134,"./Message":215,"./MessageAttachment":216,"./MessageSinkCursor":220,"./MessageSinkPriv":221,"./SentMessage":222,"./TagService":223,"buffer":498,"privmx-crypto":265,"simplito-logger":407,"simplito-promise":421}],218:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageReceiver = void 0;
const User_1 = require("../identity/User");
const MessageSink_1 = require("./MessageSink");
const privmx_exception_1 = require("privmx-exception");
class MessageReceiver {
    sink;
    user;
    sent;
    constructor(sink, user) {
        if (!(sink instanceof MessageSink_1.MessageSink)) {
            throw new privmx_exception_1.IllegalArgumentException("sink", sink);
        }
        if (!(user instanceof User_1.User)) {
            throw new privmx_exception_1.IllegalArgumentException("user", user);
        }
        Object.defineProperty(this, "sink", {
            value: sink,
            enumerable: true
        });
        Object.defineProperty(this, "user", {
            value: user,
            enumerable: true
        });
    }
    static fromSerialized(sinkPub58, hashmail, pub58, name) {
        return new MessageReceiver(MessageSink_1.MessageSink.fromSerialized(sinkPub58), User_1.User.fromSerialized(hashmail, pub58, name));
    }
    toString() {
        const hashmailWithSink = this.user.hashmail + ":" + this.sink.id;
        return this.user.name == null ? hashmailWithSink : this.user.name + "<" + hashmailWithSink + ">";
    }
}
exports.MessageReceiver = MessageReceiver;

},{"../identity/User":212,"./MessageSink":219,"privmx-exception":286}],219:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageSink = void 0;
const privmx_crypto_1 = require("privmx-crypto");
const Utils = require("simplito-utils");
class MessageSink {
    id;
    pub;
    pub58;
    name;
    description;
    constructor(pub, name, description) {
        if (!(pub instanceof privmx_crypto_1.ecc.PublicKey)) {
            throw new Error("Invalid parameter");
        }
        Object.defineProperty(this, "pub", {
            value: pub,
            enumerable: true
        });
        Utils.defineLazyReadOnlyProperty(this, "pub58", () => {
            return this.pub.toBase58DER();
        });
        Utils.defineLazyReadOnlyProperty(this, "id", () => {
            return this.pub58;
        });
        Object.defineProperty(this, "name", {
            value: name,
            enumerable: true,
            writable: true
        });
        Object.defineProperty(this, "description", {
            value: description,
            enumerable: true,
            writable: true
        });
    }
    static fromSerialized(pub58, name, description) {
        return new MessageSink(privmx_crypto_1.ecc.PublicKey.fromBase58DER(pub58), name, description);
    }
    static deserialize(serialized) {
        return MessageSink.fromSerialized(serialized.id, serialized.name, serialized.description);
    }
    serialize() {
        return {
            id: this.id,
            name: this.name,
            description: this.description
        };
    }
    toString() {
        return this.id;
    }
    equals(other) {
        if (other instanceof MessageSink) {
            return this.id === other.id;
        }
        return false;
    }
}
exports.MessageSink = MessageSink;

},{"privmx-crypto":265,"simplito-utils":422}],220:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageSinkCursor = void 0;
const MessageSinkPriv_1 = require("./MessageSinkPriv");
class MessageSinkCursor {
    sink;
    seq;
    modSeq;
    constructor(sink, seq, modSeq) {
        if (!(sink instanceof MessageSinkPriv_1.MessageSinkPriv)) {
            throw new Error("Invalid parameter");
        }
        Object.defineProperty(this, "sink", {
            value: sink,
            enumerable: true
        });
        Object.defineProperty(this, "seq", {
            value: seq,
            enumerable: true,
            writable: true
        });
        Object.defineProperty(this, "modSeq", {
            value: modSeq,
            enumerable: true,
            writable: true
        });
    }
}
exports.MessageSinkCursor = MessageSinkCursor;

},{"./MessageSinkPriv":221}],221:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageSinkPriv = void 0;
const privmx_crypto_1 = require("privmx-crypto");
const MessageSink_1 = require("./MessageSink");
const Acl_1 = require("../core/Acl");
const Utils = require("simplito-utils");
class MessageSinkPriv extends MessageSink_1.MessageSink {
    priv;
    privWif;
    acl;
    extra;
    options;
    registry;
    constructor(priv, name, description, acl, extra, options) {
        super(priv.getPublicKey(), name, description);
        if (!(priv instanceof privmx_crypto_1.ecc.PrivateKey) || (acl != "public" && acl != "private" && acl != "shared" && acl != "anonymous")) {
            throw new Error("Invalid parameter");
        }
        Object.defineProperty(this, "priv", {
            value: priv,
            enumerable: true
        });
        Utils.defineLazyReadOnlyProperty(this, "privWif", () => {
            return this.priv.toWIF();
        });
        Object.defineProperty(this, "acl", {
            value: acl,
            enumerable: true,
            writable: true
        });
        Object.defineProperty(this, "extra", {
            value: extra || {},
            enumerable: true,
            writable: true
        });
        this.options = {};
        if (options != null) {
            for (const key in options) {
                this.options[key] = options[key];
            }
        }
        if (options == null || options.removable == null) {
            this.options.removable = true;
        }
        if (options == null || options.verify == null) {
            this.options.verify = null;
        }
    }
    static fromSerialized(privWif, name, description, acl, extra, options) {
        return new MessageSinkPriv(privmx_crypto_1.ecc.PrivateKey.fromWIF(privWif), name, description, acl, extra, options);
    }
    equals(other) {
        if (other instanceof MessageSinkPriv) {
            return this.id === other.id;
        }
        return false;
    }
    hasInProxyTo(entry) {
        return this.options.proxyTo != null && Acl_1.Acl.indexOf(Acl_1.Acl.getValue(entry), this.options.proxyTo) != -1;
    }
    hasInProxyFrom(entry) {
        return this.options.proxyFrom == "all" ? true : this.options.proxyFrom != null && Acl_1.Acl.indexOf(Acl_1.Acl.getValue(entry), this.options.proxyFrom) != -1;
    }
    addToProxyTo(entry) {
        this.options.proxyTo = Acl_1.Acl.getOrCreate(this.options.proxyTo);
        Acl_1.Acl.addToList(entry, this.options.proxyTo);
    }
    addToProxyFrom(entry) {
        if (this.options.proxyFrom == "all") {
            return;
        }
        this.options.proxyFrom = Acl_1.Acl.getOrCreate(this.options.proxyFrom);
        Acl_1.Acl.addToList(entry, this.options.proxyFrom);
    }
}
exports.MessageSinkPriv = MessageSinkPriv;

},{"../core/Acl":136,"./MessageSink":219,"privmx-crypto":265,"simplito-utils":422}],222:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentMessage = void 0;
const MessageAttachment_1 = require("./MessageAttachment");
const User_1 = require("../identity/User");
const MessageReceiver_1 = require("./MessageReceiver");
const privmx_crypto_1 = require("privmx-crypto");
const json_parser_js_1 = require("json-parser-js");
class SentMessage {
    storage;
    id;
    msgId;
    receivers;
    createDate;
    attachments;
    title;
    text;
    type;
    inReplyTo;
    forwarded;
    contentType;
    serverId;
    serverDate;
    sender;
    mainReceiver;
    outerSignatory;
    source;
    sink;
    deleted;
    constructor(storage) {
        this.storage = storage;
    }
    hasNotSent() {
        for (let i = 0; i < this.receivers.length; i++) {
            if (this.receivers[i].sent === false) {
                return true;
            }
        }
        return false;
    }
    createMessage(cacheAttachments) {
        const msg = new Message_1.Message();
        msg.msgId = this.msgId;
        msg.createDate = this.createDate;
        msg.text = this.text;
        msg.title = this.title;
        msg.inReplyTo = this.inReplyTo;
        msg.forwarded = this.forwarded;
        msg.sender = this.sender;
        msg.receivers = this.receivers.concat([]);
        for (let i = 0; i < this.attachments.length; i++) {
            msg.addAttachment(this.attachments[i].getBlocksInfo(cacheAttachments));
        }
        msg.type = this.type;
        msg.contentType = this.contentType;
        return msg;
    }
    getAttachmentSources(cache) {
        return this.attachments.map(attachment => attachment.getBlocksInfo(cache));
    }
    static deserializeWithoutCheckingSignature(storage, data, signature, serverId, serverDate, lastEdit, editCount) {
        return SentMessage.deserializeFromSourceWithoutCheckingSignature(storage, {
            data: data,
            signature: signature,
            serverId: serverId,
            serverDate: serverDate.getTime(),
            lastEdit: lastEdit,
            editCount: editCount
        });
    }
    static deserializeFromSourceWithoutCheckingSignature(storage, source) {
        const message = new SentMessage(storage);
        message.msgId = source.data.msgId;
        if (source.data.createDate) {
            message.createDate = new Date(source.data.createDate);
        }
        message.text = source.data.text;
        message.title = source.data.title;
        message.inReplyTo = source.data.inReplyTo;
        message.forwarded = source.data.forwarded;
        message.sender = User_1.User.fromSerialized(source.data.sender.hashmail, source.data.sender.pub58, source.data.sender.name);
        message.receivers = [];
        source.data.receivers.forEach(receiver => {
            const r = MessageReceiver_1.MessageReceiver.fromSerialized(receiver.sinkPub58, receiver.hashmail, receiver.pub58, receiver.name);
            r.sent = receiver.sent;
            if (receiver.sinkPub58 == source.data.sid) {
                message.mainReceiver = r;
            }
            message.receivers.push(r);
        });
        message.attachments = [];
        if (source.data.attachments) {
            source.data.attachments.forEach(a => {
                message.attachments.push(MessageAttachment_1.MessageAttachment.deserialize(message, a));
            });
        }
        message.outerSignatory = source.data.outerSignatory;
        message.serverId = source.serverId;
        message.serverDate = new Date(source.serverDate);
        message.source = source;
        message.type = source.data.type;
        message.contentType = source.data.contentType;
        message.deleted = source.data.deleted;
        return message;
    }
    static deserialize2(options) {
        let message;
        return Promise.resolve().then(() => {
            const info = json_parser_js_1.JsonParser.getPropertyString(options.data, "data");
            const extra = info.json.value;
            if (extra.data.sid != (options.my ? extra.sink : options.sid)) {
                throw new Error("Sink id differ from id in message");
            }
            if (extra.data.outerSignatory != (options.my ? extra.pub : options.senderPub58)) {
                throw new Error("Sink entry signatory differ from signatory in message");
            }
            const serverDate = options.my ? new Date(extra.serverDate) : new Date(parseInt(options.serverDate));
            message = SentMessage.deserializeFromSourceWithoutCheckingSignature(options.storage, {
                data: extra.data,
                signature: extra.signature,
                serverId: options.serverId,
                serverDate: serverDate.getTime(),
                lastEdit: options.lastEdit,
                editCount: options.editCount
            });
            const sigData = Buffer.from(info.propertyString, "utf8");
            return privmx_crypto_1.service.verifyCompactSignatureWithHash(message.sender.pub, sigData, Buffer.from(extra.signature, "base64"));
        })
            .then(validSignature => {
            if (!validSignature) {
                throw new Error("Invalid signature");
            }
            return message;
        });
    }
}
exports.SentMessage = SentMessage;
Object.defineProperty(SentMessage.prototype, "id", { enumerable: true, get: function () { return this.serverId; } });
const Message_1 = require("./Message");

}).call(this)}).call(this,require("buffer").Buffer)
},{"../identity/User":212,"./Message":215,"./MessageAttachment":216,"./MessageReceiver":218,"buffer":498,"json-parser-js":101,"privmx-crypto":265}],223:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagService = void 0;
const privmx_crypto_1 = require("privmx-crypto");
const simplito_promise_1 = require("simplito-promise");
class TagService {
    static PLAIN_PREFIX = "__$$";
    constructor() {
    }
    getPlainTag(tag) {
        return TagService.PLAIN_PREFIX + tag;
    }
    createTag(pub, tag) {
        return Promise.resolve().then(() => {
            return this.getKeyFromPub(pub);
        })
            .then(key => {
            return this.createTagByKey(key, tag);
        });
    }
    getKeyFromPub(pub) {
        return privmx_crypto_1.service.sha256(pub.toDER());
    }
    createTagByKey(key, tag) {
        return Promise.resolve().then(() => {
            return tag.indexOf(TagService.PLAIN_PREFIX) == 0 ?
                privmx_crypto_1.service.sha1(Buffer.from(tag, "utf8")) :
                privmx_crypto_1.service.hmacSha1(key, Buffer.from(tag, "utf8"));
        })
            .then(hash => {
            return hash.toString("base64");
        });
    }
    createTags(pub, tags) {
        return Promise.resolve().then(() => {
            return this.getKeyFromPub(pub);
        })
            .then(key => {
            return simplito_promise_1.PromiseUtils.collect(tags, (_, tag) => {
                return this.createTagByKey(key, tag);
            });
        });
    }
}
exports.TagService = TagService;

}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":498,"privmx-crypto":265,"simplito-promise":421}],224:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagStorage = void 0;
const privmx_crypto_1 = require("privmx-crypto");
class TagStorage {
    storage;
    constructor(storage) {
        this.storage = storage;
    }
    static async create(fileSystem, path, initialOptions) {
        const storage = await fileSystem.getKeyValueFile(path, null, initialOptions);
        return new TagStorage(storage);
    }
    async getTag(name) {
        if (this.storage.hasKey(name)) {
            return this.storage.getValueByKey(name);
        }
        const value = privmx_crypto_1.service.randomBytes(32).toString("hex");
        await this.storage.set(name, value);
        return value;
    }
}
exports.TagStorage = TagStorage;

},{"privmx-crypto":265}],225:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrustedServers = void 0;
const pki = require("privmx-pki");
var CosignersProvider = pki.CosignersProvider.CosignersProvider;
class TrustedServers extends CosignersProvider {
    storage;
    constructor(storage, cosigners, defaultSelectCount) {
        super(cosigners, defaultSelectCount);
        this.storage = storage;
    }
    static create(fileSystem, path, defaultSelectCount) {
        return Promise.resolve().then(() => {
            return fileSystem.getKeyValueFile(path);
        })
            .then(storage => {
            const data = storage.getAll();
            let serialized = data;
            if (data && "cosigners" in data) {
                serialized = data["cosigners"];
            }
            const cosigners = {};
            for (const domain in (serialized || {})) {
                cosigners[domain] = pki.Helper.decodeKeystore(serialized[domain]);
            }
            return new TrustedServers(storage, cosigners, defaultSelectCount);
        });
    }
    setData(cosigners) {
        const serializedCosigners = {};
        for (const domain in cosigners) {
            serializedCosigners[domain] = cosigners[domain].serialize().toString("base64");
        }
        return this.storage.replaceData(serializedCosigners)
            .then(() => {
            this.cosigners = cosigners;
        });
    }
}
exports.TrustedServers = TrustedServers;

},{"privmx-pki":326}],226:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrustedServers = exports.TagStorage = exports.TagService = exports.SentMessage = exports.MessageSinkPriv = exports.MessageSinkCursor = exports.MessageSink = exports.MessageReceiver = exports.MessageManager = exports.MessageAttachment = exports.Message = void 0;
const Message_1 = require("./Message");
Object.defineProperty(exports, "Message", { enumerable: true, get: function () { return Message_1.Message; } });
const MessageAttachment_1 = require("./MessageAttachment");
Object.defineProperty(exports, "MessageAttachment", { enumerable: true, get: function () { return MessageAttachment_1.MessageAttachment; } });
const MessageManager_1 = require("./MessageManager");
Object.defineProperty(exports, "MessageManager", { enumerable: true, get: function () { return MessageManager_1.MessageManager; } });
const MessageReceiver_1 = require("./MessageReceiver");
Object.defineProperty(exports, "MessageReceiver", { enumerable: true, get: function () { return MessageReceiver_1.MessageReceiver; } });
const MessageSink_1 = require("./MessageSink");
Object.defineProperty(exports, "MessageSink", { enumerable: true, get: function () { return MessageSink_1.MessageSink; } });
const MessageSinkCursor_1 = require("./MessageSinkCursor");
Object.defineProperty(exports, "MessageSinkCursor", { enumerable: true, get: function () { return MessageSinkCursor_1.MessageSinkCursor; } });
const MessageSinkPriv_1 = require("./MessageSinkPriv");
Object.defineProperty(exports, "MessageSinkPriv", { enumerable: true, get: function () { return MessageSinkPriv_1.MessageSinkPriv; } });
const SentMessage_1 = require("./SentMessage");
Object.defineProperty(exports, "SentMessage", { enumerable: true, get: function () { return SentMessage_1.SentMessage; } });
const TagService_1 = require("./TagService");
Object.defineProperty(exports, "TagService", { enumerable: true, get: function () { return TagService_1.TagService; } });
const TagStorage_1 = require("./TagStorage");
Object.defineProperty(exports, "TagStorage", { enumerable: true, get: function () { return TagStorage_1.TagStorage; } });
const TrustedServers_1 = require("./TrustedServers");
Object.defineProperty(exports, "TrustedServers", { enumerable: true, get: function () { return TrustedServers_1.TrustedServers; } });

},{"./Message":215,"./MessageAttachment":216,"./MessageManager":217,"./MessageReceiver":218,"./MessageSink":219,"./MessageSinkCursor":220,"./MessageSinkPriv":221,"./SentMessage":222,"./TagService":223,"./TagStorage":224,"./TrustedServers":225}],227:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.descriptor = exports.message = exports.db = exports.core = void 0;
var core;
(function (core) {
    let LoginMode;
    (function (LoginMode) {
        LoginMode[LoginMode["SRP"] = 0] = "SRP";
        LoginMode[LoginMode["LBK"] = 1] = "LBK";
    })(LoginMode = core.LoginMode || (core.LoginMode = {}));
    let AclType;
    (function (AclType) {
        AclType[AclType["ALLOW_ALL"] = 0] = "ALLOW_ALL";
        AclType[AclType["DENY_ALL"] = 1] = "DENY_ALL";
        AclType[AclType["WHITE_LIST"] = 2] = "WHITE_LIST";
        AclType[AclType["BLACK_LIST"] = 3] = "BLACK_LIST";
    })(AclType = core.AclType || (core.AclType = {}));
})(core = exports.core || (exports.core = {}));
var db;
(function (db) {
    let OpenMode;
    (function (OpenMode) {
        OpenMode[OpenMode["CREATE_ON_NOT_EXISTS"] = 0] = "CREATE_ON_NOT_EXISTS";
        OpenMode[OpenMode["FAIL_ON_EXISTS"] = 1] = "FAIL_ON_EXISTS";
        OpenMode[OpenMode["FAIL_ON_NON_EXISTS"] = 2] = "FAIL_ON_NON_EXISTS";
    })(OpenMode = db.OpenMode || (db.OpenMode = {}));
})(db = exports.db || (exports.db = {}));
var message;
(function (message) {
    ;
})(message = exports.message || (exports.message = {}));
var descriptor;
(function (descriptor_1) {
    ;
})(descriptor = exports.descriptor || (exports.descriptor = {}));

},{}],228:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserBuffer = void 0;
class BrowserBuffer {
    static bufferToArray(buffer) {
        if (typeof (buffer.toArrayBuffer) == "function") {
            return buffer.toArrayBuffer();
        }
        const buf = buffer;
        const ab = new ArrayBuffer(buf.length);
        const view = new Uint8Array(ab);
        for (let i = 0; i < buf.length; ++i) {
            view[i] = buf[i];
        }
        return ab;
    }
    static arrayToBuffer(ab) {
        return Buffer.from(ab).slice(0);
    }
    static isBuffer(arg) {
        return Buffer.isBuffer(arg) || arg instanceof Uint8Array;
    }
    static createBlob(buffer, mimetype) {
        return new Blob([BrowserBuffer.bufferToArray(buffer)], { type: mimetype });
    }
}
exports.BrowserBuffer = BrowserBuffer;

}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":498}],229:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CipherType = void 0;
var CipherType;
(function (CipherType) {
    CipherType[CipherType["AES_256_CBC_PKCS7_NO_IV"] = 1] = "AES_256_CBC_PKCS7_NO_IV";
    CipherType[CipherType["AES_256_CBC_PKCS7_WITH_IV"] = 2] = "AES_256_CBC_PKCS7_WITH_IV";
    CipherType[CipherType["XTEA_ECB_PKCS7"] = 3] = "XTEA_ECB_PKCS7";
    CipherType[CipherType["AES_256_CBC_PKCS7_WITH_IV_AND_HMAC_SHA256"] = 4] = "AES_256_CBC_PKCS7_WITH_IV_AND_HMAC_SHA256";
})(CipherType = exports.CipherType || (exports.CipherType = {}));

},{}],230:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoBase = void 0;
const R_1 = require("../crypto/R");
const bip39 = require("bip39");
const Ecc = require("../ecc");
const CipherType_1 = require("./CipherType");
const srp_1 = require("../srp");
const BN = require("bn.js");
class CryptoBase {
    static hmacSha1(crypto, key, data) {
        return (0, R_1.R)(() => {
            return crypto.hmac("sha1", key, data);
        });
    }
    static hmacSha256(crypto, key, data) {
        return (0, R_1.R)(() => {
            return crypto.hmac("sha256", key, data);
        });
    }
    static hmacSha512(crypto, key, data) {
        return (0, R_1.R)(() => {
            return crypto.hmac("sha512", key, data);
        });
    }
    static sha1(crypto, data) {
        return (0, R_1.R)(() => {
            return crypto.hash("sha1", data);
        });
    }
    static sha256(crypto, data) {
        return (0, R_1.R)(() => {
            return crypto.hash("sha256", data);
        });
    }
    static sha512(crypto, data) {
        return (0, R_1.R)(() => {
            return crypto.hash("sha512", data);
        });
    }
    static ripemd160(crypto, data) {
        return (0, R_1.R)(() => {
            return crypto.hash("ripemd160", data);
        });
    }
    static hash160(crypto, data) {
        return (0, R_1.R)(() => {
            return crypto.sha256(data);
        })
            .then(x => {
            return crypto.ripemd160(x);
        });
    }
    static kdf(crypto, algo, length, key, options) {
        let result;
        return (0, R_1.R)(() => {
            if (!options) {
                options = {};
            }
            if (typeof (options) === "string") {
                options = { label: options };
            }
            const counters = options.counters === false ? false : true;
            const feedback = options.feedback === false ? false : true;
            let seed = Buffer.alloc(0);
            const opt2buffer = (opt) => {
                if (typeof (opt) === "string") {
                    return Buffer.from(opt);
                }
                if (opt instanceof Buffer) {
                    return opt;
                }
                return Buffer.alloc(0);
            };
            if (options.seed instanceof Buffer) {
                seed = options.seed;
            }
            else {
                const label = opt2buffer(options.label);
                const context = opt2buffer(options.context);
                seed = Buffer.alloc(label.length + context.length + 5);
                label.copy(seed);
                seed.writeUInt8(0, label.length);
                context.copy(seed, label.length + 1);
                seed.writeUInt32BE(length, label.length + context.length + 1);
            }
            let k = opt2buffer(options.iv);
            result = Buffer.alloc(0);
            let i = 1;
            const next = () => {
                if (result.length >= length) {
                    return;
                }
                let input = Buffer.alloc(0);
                if (feedback) {
                    input = k;
                }
                if (counters) {
                    const count = Buffer.alloc(4);
                    count.writeUInt32BE(i++, 0);
                    input = Buffer.concat([input, count]);
                }
                input = Buffer.concat([input, seed]);
                return (0, R_1.R)(() => {
                    return crypto.hmac(algo, key, input);
                })
                    .then(hmac => {
                    k = hmac;
                    result = Buffer.concat([result, k]);
                    return next();
                });
            };
            return next();
        })
            .then(() => {
            return result.slice(0, length);
        });
    }
    static getKEM(crypto, algo, key, keLen, kmLen) {
        return (0, R_1.R)(() => {
            if (!keLen && keLen !== 0) {
                keLen = 32;
            }
            if (!kmLen && kmLen !== 0) {
                kmLen = 32;
            }
            return crypto.kdf(algo, keLen + kmLen, key, "key expansion");
        })
            .then(kEM => {
            return {
                kE: kEM.slice(0, keLen),
                kM: kEM.slice(keLen)
            };
        });
    }
    static aes256CbcHmac256Encrypt(crypto, data, key32, iv, tagLen) {
        let kem, cipher;
        return (0, R_1.R)(() => {
            if (!tagLen && tagLen !== 0) {
                tagLen = 16;
            }
            return crypto.getKEM("sha256", key32);
        })
            .then(k => {
            kem = k;
            return iv == null ? crypto.hmacSha256(key32, data) : iv;
        })
            .then(iv => {
            iv = iv.slice(0, 16);
            const prefix = Buffer.alloc(16);
            prefix.fill(0);
            data = Buffer.concat([prefix, data]);
            return crypto.aes256CbcPkcs7Encrypt(data, kem.kE, iv);
        })
            .then(c => {
            cipher = c;
            return crypto.hmacSha256(kem.kM, cipher);
        })
            .then(tag => {
            tag = tag.slice(0, tagLen);
            return Buffer.concat([cipher, tag]);
        });
    }
    static aes256CbcHmac256Decrypt(crypto, data, key32, tagLen) {
        let kem, tag;
        return (0, R_1.R)(() => {
            if (!tagLen && tagLen !== 0) {
                tagLen = 16;
            }
            return crypto.getKEM("sha256", key32);
        })
            .then(k => {
            kem = k;
            tag = data.slice(data.length - tagLen);
            data = data.slice(0, data.length - tagLen);
            return crypto.hmacSha256(kem.kM, data);
        })
            .then(rTag => {
            rTag = rTag.slice(0, tagLen);
            if (!tag.equals(rTag)) {
                throw new Error("Wrong message security tag");
            }
            const iv = data.slice(0, 16);
            data = data.slice(16);
            return crypto.aes256CbcPkcs7Decrypt(data, kem.kE, iv);
        });
    }
    static prf_tls12(crypto, key, seed, length) {
        let result;
        return (0, R_1.R)(() => {
            let a = seed;
            result = Buffer.alloc(0);
            const next = () => {
                if (result.length >= length) {
                    return;
                }
                return (0, R_1.R)(() => {
                    return crypto.hmacSha256(key, a);
                })
                    .then(newA => {
                    a = newA;
                    return crypto.hmacSha256(key, Buffer.concat([a, seed]));
                })
                    .then(d => {
                    result = Buffer.concat([result, d]);
                    return next();
                });
            };
            return next();
        })
            .then(() => {
            return result.slice(0, length);
        });
    }
    static hkdfSha256(crypto, key, salt, info, len) {
        let output;
        return (0, R_1.R)(() => {
            info = info || Buffer.alloc(0);
            if (!Buffer.isBuffer(key)) {
                key = Buffer.from(key);
            }
            if (!Buffer.isBuffer(salt)) {
                salt = Buffer.from(salt);
            }
            if (!Buffer.isBuffer(info)) {
                info = Buffer.from(info);
            }
            output = Buffer.alloc(len);
            return crypto.hmacSha256(key, salt);
        })
            .then(prk => {
            let offset = 0;
            const t = Buffer.alloc(0);
            let i = 1;
            const next = () => {
                if (offset >= len) {
                    return;
                }
                return (0, R_1.R)(() => {
                    return crypto.hmacSha256(prk, Buffer.concat([t, info, Buffer.from([i++])]));
                })
                    .then(t => {
                    offset += t.copy(output, offset, 0, Math.min(t.length, len - offset));
                    return next();
                });
            };
            return next();
        })
            .then(() => {
            return output;
        });
    }
    static generateIv(crypto, key, idx) {
        return (0, R_1.R)(() => {
            return crypto.hmacSha256(key, Buffer.from("iv" + idx, "utf8"));
        })
            .then(x => {
            return x.slice(0, 16);
        });
    }
    static reductKey(crypto, key) {
        return (0, R_1.R)(() => {
            return crypto.sha256(key);
        })
            .then(x => {
            return x.slice(0, 16);
        });
    }
    static xteaEcbPkcs7Key32Encrypt(crypto, data, key32) {
        return (0, R_1.R)(() => {
            return crypto.reductKey(key32);
        })
            .then(key => {
            return crypto.xteaEcbPkcs7Encrypt(data, key);
        });
    }
    static xteaEcbPkcs7Key32Decrypt(crypto, data, key32) {
        return (0, R_1.R)(() => {
            return crypto.reductKey(key32);
        })
            .then(key => {
            return crypto.xteaEcbPkcs7Decrypt(data, key);
        });
    }
    static ctAes256CbcPkcs7NoIv(crypto, data, key, iv) {
        return (0, R_1.R)(() => {
            return crypto.aes256CbcPkcs7Encrypt(data, key, iv);
        })
            .then(cipher => {
            return Buffer.concat([Buffer.from([CipherType_1.CipherType.AES_256_CBC_PKCS7_NO_IV]), cipher]);
        });
    }
    static ctAes256CbcPkcs7WithIv(crypto, data, key, iv) {
        return (0, R_1.R)(() => {
            return crypto.aes256CbcPkcs7Encrypt(data, key, iv);
        })
            .then(cipher => {
            return Buffer.concat([Buffer.from([CipherType_1.CipherType.AES_256_CBC_PKCS7_WITH_IV]), iv, cipher]);
        });
    }
    static ctAes256CbcPkcs7WithRandomIv(crypto, data, key) {
        return (0, R_1.R)(() => {
            return crypto.ctAes256CbcPkcs7WithIv(data, key, crypto.randomBytes(16));
        });
    }
    static ctXteaEcbPkcs7(crypto, data, key) {
        return (0, R_1.R)(() => {
            return crypto.xteaEcbPkcs7Encrypt(data, key);
        })
            .then(cipher => {
            return Buffer.concat([Buffer.from([CipherType_1.CipherType.XTEA_ECB_PKCS7]), cipher]);
        });
    }
    static ctXteaEcbPkcs7Key32(crypto, data, key32) {
        return (0, R_1.R)(() => {
            return crypto.xteaEcbPkcs7Key32Encrypt(data, key32);
        })
            .then(cipher => {
            return Buffer.concat([Buffer.from([CipherType_1.CipherType.XTEA_ECB_PKCS7]), cipher]);
        });
    }
    static ctAes256CbcPkcs7WithIvAndHmacSha256(crypto, data, key, iv, tagLen) {
        return (0, R_1.R)(() => {
            return crypto.aes256CbcHmac256Encrypt(data, key, iv, tagLen);
        })
            .then(cipher => {
            return Buffer.concat([Buffer.from([CipherType_1.CipherType.AES_256_CBC_PKCS7_WITH_IV_AND_HMAC_SHA256]), cipher]);
        });
    }
    static ctDecrypt(crypto, data, key32, iv16, tagLen, key16) {
        return (0, R_1.R)(() => {
            if (key32.length !== 32) {
                throw new Error("Decrypt invalid key length, required: 32, have: " + key32.length + " " + key32.toString("hex"));
            }
            const type = data.readUInt8(0);
            if (type == CipherType_1.CipherType.AES_256_CBC_PKCS7_NO_IV) {
                if (iv16 == null) {
                    throw new Error("Missing IV");
                }
                return crypto.aes256CbcPkcs7Decrypt(data.slice(1), key32, iv16);
            }
            if (type == CipherType_1.CipherType.AES_256_CBC_PKCS7_WITH_IV) {
                return crypto.aes256CbcPkcs7Decrypt(data.slice(17), key32, data.slice(1, 17));
            }
            if (type == CipherType_1.CipherType.XTEA_ECB_PKCS7) {
                return key16 ? crypto.xteaEcbPkcs7Decrypt(data.slice(1), key16) : crypto.xteaEcbPkcs7Key32Decrypt(data.slice(1), key32);
            }
            if (type == CipherType_1.CipherType.AES_256_CBC_PKCS7_WITH_IV_AND_HMAC_SHA256) {
                return crypto.aes256CbcHmac256Decrypt(data.slice(1), key32, tagLen);
            }
            throw new Error("Unknown decryption type " + type);
        });
    }
    static eccExtFromSeed(crypto, seed) {
        return (0, R_1.R)(() => Ecc.ExtKey.fromSeed(crypto, seed));
    }
    static eccExtRandom(crypto) {
        return (0, R_1.R)(() => Ecc.ExtKey.generateRandom(crypto));
    }
    static eccPrivRandom(crypto) {
        return (0, R_1.R)(() => Ecc.PrivateKey.generateRandom(crypto));
    }
    static eccPubToBase58Address(crypto, pub, network) {
        return (0, R_1.R)(() => pub.toBase58Address(crypto, network));
    }
    static signToCompactSignature(priv, hash) {
        return (0, R_1.R)(() => priv.signToCompactSignature(hash));
    }
    static signToCompactSignatureWithHash(crypto, priv, message) {
        return (0, R_1.R)(() => {
            return crypto.sha256(message);
        })
            .then(x => {
            return crypto.signToCompactSignature(priv, x);
        });
    }
    static eccDerive(priv, pub) {
        return (0, R_1.R)(() => priv.derive(pub));
    }
    static verifyCompactSignature(pub, hash, signature) {
        return (0, R_1.R)(() => pub.verifyCompactSignature(hash, signature));
    }
    static verifyCompactSignatureWithHash(crypto, pub, message, signature) {
        return (0, R_1.R)(() => {
            return crypto.sha256(message);
        })
            .then(x => {
            return crypto.verifyCompactSignature(pub, x, signature);
        });
    }
    static eciesEncrypt(crypto, priv, pub, data) {
        return (0, R_1.R)(() => priv.eciesEncrypt(crypto, pub, data));
    }
    static eciesDecrypt(crypto, priv, pub, data) {
        return (0, R_1.R)(() => priv.eciesDecrypt(crypto, pub, data));
    }
    static eccExtDerive(crypto, ext, options) {
        return (0, R_1.R)(() => ext.derive(crypto, options));
    }
    static eccExtDeriveWithPath(crypto, ext, options) {
        return (0, R_1.R)(() => ext.deriveWithPath(crypto, options));
    }
    static bip39FromEntropy(crypto, entropy, password) {
        let mnemonic;
        return (0, R_1.R)(() => {
            mnemonic = bip39.entropyToMnemonic(entropy.toString("hex"));
            return crypto.bip39GetExtKey(mnemonic, password);
        })
            .then(extKey => {
            return {
                entropy: entropy,
                mnemonic: mnemonic,
                extKey: extKey
            };
        });
    }
    static bip39FromMnemonic(crypto, mnemonic, password) {
        let entropy;
        return (0, R_1.R)(() => {
            entropy = Buffer.from(bip39.mnemonicToEntropy(mnemonic), "hex");
            return crypto.bip39GetExtKey(mnemonic, password);
        })
            .then(extKey => {
            return {
                entropy: entropy,
                mnemonic: mnemonic,
                extKey: extKey
            };
        });
    }
    static bip39GetExtKey(crypto, mnemonic, password) {
        return (0, R_1.R)(() => {
            const seed = bip39.mnemonicToSeed(mnemonic, password);
            return Ecc.ExtKey.fromSeed(crypto, seed);
        });
    }
    static bip39Generate(crypto, strength, password) {
        return (0, R_1.R)(() => crypto.bip39FromEntropy(crypto.randomBytes(strength / 8), password));
    }
    static srpRegister(crypto, N, g, I, P) {
        return (0, R_1.R)(() => crypto.srpRegisterS(N, g, I, P, crypto.randomBytes(16)));
    }
    static srpRegisterS(crypto, N, g, I, P, s) {
        return (0, R_1.R)(() => {
            const srp = new srp_1.SrpLogic(crypto, "sha256");
            return srp.register(new BN(N), new BN(g), I, P, s);
        })
            .then(result => {
            return {
                s: result.s,
                v: result.v.toArrayLike(Buffer)
            };
        });
    }
    static srpLoginStep1(crypto, N, g, s, B, I, P) {
        return (0, R_1.R)(() => crypto.srpLoginStep1A(N, g, s, B, I, P, crypto.randomBytes(64)));
    }
    static srpLoginStep1A(crypto, N, g, s, B, I, P, a) {
        return (0, R_1.R)(() => {
            const srp = new srp_1.SrpLogic(crypto, "sha256");
            return srp.login_step1(new BN(N), new BN(g), s, new BN(B), I, P, new BN(a));
        })
            .then(result => {
            return {
                A: result.A.toArrayLike(Buffer),
                K: result.K.toArrayLike(Buffer, "be", 32),
                M1: result.M1.toArrayLike(Buffer),
                M2: result.M2.toArrayLike(Buffer)
            };
        });
    }
    static srpLoginStep2(clientM2, serverM2) {
        return (0, R_1.R)(() => srp_1.SrpLogicBase.login_step2(new BN(clientM2), new BN(serverM2)));
    }
}
exports.CryptoBase = CryptoBase;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../crypto/R":235,"../ecc":262,"../srp":278,"./CipherType":229,"bip39":16,"bn.js":25,"buffer":498}],231:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoPrivmx = exports.CryptoPrivmxBase = void 0;
const R_1 = require("../crypto/R");
const BrowserBuffer_1 = require("../browserbuffer/BrowserBuffer");
const CipherType_1 = require("./CipherType");
class CryptoPrivmxBase {
    static privmxOptAesWithDetachedIv() {
        return {
            algorithm: "AES-256-CBC"
        };
    }
    static privmxOptAesWithAttachedIv() {
        return {
            algorithm: "AES-256-CBC",
            attachIv: true
        };
    }
    static privmxOptAesWithSignature() {
        return {
            algorithm: "AES-256-CBC",
            attachIv: true,
            hmac: "SHA-256"
        };
    }
    static privmxOptXtea() {
        return {
            algorithm: "XTEA-ECB"
        };
    }
    static privmxOptSignedCipher() {
        return {
            signed: true
        };
    }
    static privmxGetBlockSize(options, blockSize) {
        let size = blockSize - 1;
        if (options.attachIv) {
            size -= 16;
        }
        if (options.hmac) {
            size -= typeof (options.tagLen) == "undefined" ? 16 : options.tagLen;
        }
        return size - (size % 16) - 1;
    }
    static privmxHasSignature(data) {
        const nr = BrowserBuffer_1.BrowserBuffer.isBuffer(data) ? data.readUInt8(0) : data;
        return nr == CipherType_1.CipherType.AES_256_CBC_PKCS7_WITH_IV_AND_HMAC_SHA256;
    }
    static privmxEncrypt(crypto, options, data, key, iv) {
        return (0, R_1.R)(() => {
            if (key.length !== 32) {
                throw new Error("Encrypt invalid key length, required: 32, have: " + key.length + " " + key.toString("hex"));
            }
            const hmac = options.hmac || false;
            const withIV = options.attachIv === true;
            switch (options.algorithm) {
                case "AES-256-CBC":
                    if (hmac) {
                        if (hmac !== "SHA-256" || !withIV) {
                            throw new Error("Only hmac SHA-256 with iv is supported for AES-256-CBC");
                        }
                        if (options.deterministic) {
                            if (iv) {
                                throw new Error("Cannot pass IV to deterministic AES-256-CBC hmac SHA-256");
                            }
                        }
                        else {
                            iv = iv || crypto.randomBytes(16);
                        }
                        return crypto.ctAes256CbcPkcs7WithIvAndHmacSha256(data, key, options.deterministic ? null : iv, options.tagLen);
                    }
                    iv = iv || crypto.randomBytes(16);
                    if (withIV) {
                        return crypto.ctAes256CbcPkcs7WithIv(data, key, iv);
                    }
                    return crypto.ctAes256CbcPkcs7NoIv(data, key, iv);
                case "XTEA-ECB":
                    if (hmac || iv || withIV) {
                        throw new Error("XTEA-ECB encryption doesn't support hmac and iv");
                    }
                    return crypto.ctXteaEcbPkcs7Key32(data, key);
                default:
                    throw new Error("Unsupported encryption algorithm " + options.algorithm);
            }
        });
    }
    static privmxDecrypt(crypto, helper, options, data, key32, iv16) {
        return (0, R_1.R)(() => {
            if (options != null && options.signed && !helper.privmxHasSignature(data) && helper.errorOnMissingSignature) {
                throw new Error("Missing required signature");
            }
            return crypto.ctDecrypt(data, key32, iv16, options == null ? null : options.tagLen);
        });
    }
}
exports.CryptoPrivmxBase = CryptoPrivmxBase;
class CryptoPrivmx {
    crypto;
    errorOnMissingSignature = true;
    constructor(crypto) {
        this.crypto = crypto;
    }
    privmxSetErrorOnMissingSignature(value) {
        this.errorOnMissingSignature = !!value;
    }
    privmxOptAesWithDetachedIv() {
        return CryptoPrivmxBase.privmxOptAesWithDetachedIv();
    }
    privmxOptAesWithAttachedIv() {
        return CryptoPrivmxBase.privmxOptAesWithAttachedIv();
    }
    privmxOptAesWithSignature() {
        return CryptoPrivmxBase.privmxOptAesWithSignature();
    }
    privmxOptXtea() {
        return CryptoPrivmxBase.privmxOptXtea();
    }
    privmxOptSignedCipher() {
        return CryptoPrivmxBase.privmxOptSignedCipher();
    }
    privmxGetBlockSize(options, blockSize) {
        return CryptoPrivmxBase.privmxGetBlockSize(options, blockSize);
    }
    privmxHasSignature(data) {
        return CryptoPrivmxBase.privmxHasSignature(data);
    }
    privmxEncrypt(options, data, key, iv) {
        return CryptoPrivmxBase.privmxEncrypt(this.crypto, options, data, key, iv).async();
    }
    privmxDecrypt(optionsOrData, dataOrKey32, key32OrIv16, iv16) {
        if (BrowserBuffer_1.BrowserBuffer.isBuffer(optionsOrData)) {
            return CryptoPrivmxBase.privmxDecrypt(this.crypto, this, null, optionsOrData, dataOrKey32, key32OrIv16).async();
        }
        return CryptoPrivmxBase.privmxDecrypt(this.crypto, this, optionsOrData, dataOrKey32, key32OrIv16, iv16).async();
    }
}
exports.CryptoPrivmx = CryptoPrivmx;

},{"../browserbuffer/BrowserBuffer":228,"../crypto/R":235,"./CipherType":229}],232:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoSubtle = void 0;
const BrowserBuffer_1 = require("../browserbuffer/BrowserBuffer");
const CryptoBase_1 = require("./CryptoBase");
const privmxException = require("privmx-exception");
var IllegalArgumentException = privmxException.IllegalArgumentException;
function P(p) {
    return p;
}
class CryptoSubtle {
    static HASH_ALGORITHM_MAP = {
        sha1: "SHA-1",
        sha256: "SHA-256",
        sha512: "SHA-512"
    };
    check(func) {
        return Promise.resolve().then(func).then(() => true).catch(() => false);
    }
    isSupported() {
        return Promise.resolve().then(() => {
            const hasSupp = typeof (window) != "undefined" &&
                typeof (window.crypto) != "undefined" &&
                typeof (window.crypto.subtle) != "undefined" &&
                typeof (window.crypto.subtle.encrypt) != "undefined" &&
                typeof (window.crypto.subtle.decrypt) != "undefined" &&
                typeof (window.crypto.subtle.digest) != "undefined" &&
                typeof (window.crypto.subtle.importKey) != "undefined";
            if (hasSupp) {
                return this.sha1_check();
            }
            return false;
        });
    }
    hmac(digest, key, data) {
        return Promise.resolve().then(() => {
            const algorithm = {
                name: "HMAC",
                hash: { name: CryptoSubtle.HASH_ALGORITHM_MAP[digest] }
            };
            return P(window.crypto.subtle.importKey("raw", BrowserBuffer_1.BrowserBuffer.bufferToArray(key), algorithm, false, ["sign"])
                .then(symmetric => {
                return window.crypto.subtle.sign(algorithm, symmetric, BrowserBuffer_1.BrowserBuffer.bufferToArray(data));
            })
                .then(BrowserBuffer_1.BrowserBuffer.arrayToBuffer));
        });
    }
    hmac_vary(digest, _key, _data) {
        return digest;
    }
    hmac_check(digest) {
        return this.check(() => this.hmac(digest, Buffer.alloc(32), Buffer.alloc(1024)));
    }
    hmacSha1(key, data) {
        return CryptoBase_1.CryptoBase.hmacSha1(this, key, data).async();
    }
    hmacSha1_check() {
        return this.check(() => this.hmacSha1(Buffer.alloc(32), Buffer.alloc(1024)));
    }
    hmacSha256(key, data) {
        return CryptoBase_1.CryptoBase.hmacSha256(this, key, data).async();
    }
    hmacSha256_check() {
        return this.check(() => this.hmacSha256(Buffer.alloc(32), Buffer.alloc(1024)));
    }
    hmacSha512(key, data) {
        return CryptoBase_1.CryptoBase.hmacSha512(this, key, data).async();
    }
    hmacSha512_check() {
        return this.check(() => this.hmacSha512(Buffer.alloc(32), Buffer.alloc(1024)));
    }
    hash(algorithm, data) {
        return Promise.resolve().then(() => {
            algorithm = CryptoSubtle.HASH_ALGORITHM_MAP[algorithm];
            if (!BrowserBuffer_1.BrowserBuffer.isBuffer(data)) {
                throw new IllegalArgumentException("data", data);
            }
            return P(window.crypto.subtle.digest({ name: algorithm }, BrowserBuffer_1.BrowserBuffer.bufferToArray(data))
                .then(BrowserBuffer_1.BrowserBuffer.arrayToBuffer));
        });
    }
    hash_vary(algorithm, _data) {
        return algorithm;
    }
    hash_check(algorithm) {
        return this.check(() => this.hash(algorithm, Buffer.alloc(1024)));
    }
    sha1(data) {
        return CryptoBase_1.CryptoBase.sha1(this, data).async();
    }
    sha1_check() {
        return this.check(() => this.sha1(Buffer.alloc(1024)));
    }
    sha256(data) {
        return CryptoBase_1.CryptoBase.sha256(this, data).async();
    }
    sha256_check() {
        return this.check(() => this.sha256(Buffer.alloc(1024)));
    }
    sha512(data) {
        return CryptoBase_1.CryptoBase.sha512(this, data).async();
    }
    sha512_check() {
        return this.check(() => this.sha512(Buffer.alloc(1024)));
    }
    aes256CbcPkcs7Encrypt(data, key, iv) {
        return Promise.resolve().then(() => {
            if (!BrowserBuffer_1.BrowserBuffer.isBuffer(data) || data.length == 0) {
                throw new IllegalArgumentException("data", data);
            }
            if (!BrowserBuffer_1.BrowserBuffer.isBuffer(key) || key.length != 32) {
                throw new IllegalArgumentException("key", key);
            }
            if (!BrowserBuffer_1.BrowserBuffer.isBuffer(iv) || iv.length != 16) {
                throw new IllegalArgumentException("iv", iv);
            }
            return P(window.crypto.subtle.importKey("raw", BrowserBuffer_1.BrowserBuffer.bufferToArray(key), "AES-CBC", true, ["encrypt"])
                .then(key => {
                return window.crypto.subtle.encrypt({
                    name: "AES-CBC",
                    iv: BrowserBuffer_1.BrowserBuffer.bufferToArray(iv)
                }, key, BrowserBuffer_1.BrowserBuffer.bufferToArray(data));
            })
                .then(BrowserBuffer_1.BrowserBuffer.arrayToBuffer));
        });
    }
    aes256CbcPkcs7Encrypt_check() {
        return this.check(() => this.aes256CbcPkcs7Encrypt(Buffer.alloc(1024), Buffer.alloc(32), Buffer.alloc(16)));
    }
    aes256CbcPkcs7Decrypt(data, key, iv) {
        return Promise.resolve().then(() => {
            if (!BrowserBuffer_1.BrowserBuffer.isBuffer(data) || data.length == 0) {
                throw new IllegalArgumentException("data", data);
            }
            if (!BrowserBuffer_1.BrowserBuffer.isBuffer(key) || key.length != 32) {
                throw new IllegalArgumentException("key", key);
            }
            if (!BrowserBuffer_1.BrowserBuffer.isBuffer(iv) || iv.length != 16) {
                throw new IllegalArgumentException("iv", iv);
            }
            return P(window.crypto.subtle.importKey("raw", BrowserBuffer_1.BrowserBuffer.bufferToArray(key), "AES-CBC", true, ["decrypt"])
                .then(key => {
                return window.crypto.subtle.decrypt({
                    name: "AES-CBC",
                    iv: BrowserBuffer_1.BrowserBuffer.bufferToArray(iv)
                }, key, BrowserBuffer_1.BrowserBuffer.bufferToArray(data));
            })
                .then(BrowserBuffer_1.BrowserBuffer.arrayToBuffer));
        });
    }
    aes256CbcPkcs7Decrypt_check() {
        return this.aes256CbcPkcs7Encrypt_check();
    }
    pbkdf2(password, salt, rounds, length, algorithm) {
        return Promise.resolve().then(() => {
            return P(window.crypto.subtle.importKey("raw", BrowserBuffer_1.BrowserBuffer.bufferToArray(password), "PBKDF2", false, ["deriveBits"])
                .then(key => {
                return window.crypto.subtle.deriveBits({
                    name: "PBKDF2",
                    salt: BrowserBuffer_1.BrowserBuffer.bufferToArray(salt),
                    iterations: rounds,
                    hash: { name: CryptoSubtle.HASH_ALGORITHM_MAP[algorithm] }
                }, key, length * 8);
            })
                .then(BrowserBuffer_1.BrowserBuffer.arrayToBuffer));
        });
    }
    pbkdf2_vary(_password, _salt, _rounds, _length, algorithm) {
        return algorithm;
    }
    pbkdf2_check(algorithm) {
        return this.check(() => this.pbkdf2(Buffer.alloc(32), Buffer.alloc(16), 1, 1, algorithm));
    }
    kdf(algo, length, key, options) {
        return CryptoBase_1.CryptoBase.kdf(this, algo, length, key, options).async();
    }
    kdf_vary(algo, _length, _key, _options) {
        return algo;
    }
    kdf_check(algo) {
        return this.check(() => this.kdf(algo, 32, Buffer.alloc(32), "a"));
    }
    getKEM(algo, key, keLen, kmLen) {
        return CryptoBase_1.CryptoBase.getKEM(this, algo, key, keLen, kmLen).async();
    }
    getKEM_vary(algo, _key, _keLen, _kmLen) {
        return algo;
    }
    getKEM_check(algo) {
        return this.check(() => this.getKEM(algo, Buffer.alloc(32)));
    }
    aes256CbcHmac256Encrypt(data, key32, iv, tagLen) {
        return CryptoBase_1.CryptoBase.aes256CbcHmac256Encrypt(this, data, key32, iv, tagLen).async();
    }
    aes256CbcHmac256Encrypt_check() {
        return this.check(() => this.aes256CbcHmac256Encrypt(Buffer.alloc(1024), Buffer.alloc(32), Buffer.alloc(16)));
    }
    aes256CbcHmac256Decrypt(data, key, tagLen) {
        return CryptoBase_1.CryptoBase.aes256CbcHmac256Decrypt(this, data, key, tagLen).async();
    }
    aes256CbcHmac256Decrypt_check() {
        return this.aes256CbcHmac256Encrypt_check();
    }
    prf_tls12(key, seed, length) {
        return CryptoBase_1.CryptoBase.prf_tls12(this, key, seed, length).async();
    }
    prf_tls12_check() {
        return this.check(() => this.prf_tls12(Buffer.alloc(32), Buffer.alloc(32), 32));
    }
    hkdfSha256(key, salt, info, len) {
        info = info || Buffer.alloc(0);
        return Promise.resolve().then(() => {
            return P(window.crypto.subtle.importKey("raw", BrowserBuffer_1.BrowserBuffer.bufferToArray(key), "HKDF", false, ["deriveBits"])
                .then(key => {
                return window.crypto.subtle.deriveBits({
                    name: "HKDF",
                    hash: { name: "SHA-256" },
                    salt: BrowserBuffer_1.BrowserBuffer.bufferToArray(salt),
                    info: BrowserBuffer_1.BrowserBuffer.bufferToArray(info)
                }, key, 8 * len);
            })
                .then(ab => {
                return Buffer.from(ab);
            }));
        });
    }
    hkdfSha256_check() {
        return this.check(() => this.hkdfSha256(Buffer.alloc(32), Buffer.alloc(16), Buffer.alloc(16), 32));
    }
    generateIv(key, idx) {
        return CryptoBase_1.CryptoBase.generateIv(this, key, idx).async();
    }
    generateIv_check() {
        return this.check(() => this.generateIv(Buffer.alloc(32), 0));
    }
    reductKey(key) {
        return CryptoBase_1.CryptoBase.reductKey(this, key).async();
    }
    reductKey_check() {
        return this.check(() => this.reductKey(Buffer.alloc(32)));
    }
    ctAes256CbcPkcs7NoIv(data, key, iv) {
        return CryptoBase_1.CryptoBase.ctAes256CbcPkcs7NoIv(this, data, key, iv).async();
    }
    ctAes256CbcPkcs7NoIv_check() {
        return this.check(() => this.ctAes256CbcPkcs7NoIv(Buffer.alloc(1024), Buffer.alloc(32), Buffer.alloc(16)));
    }
    ctAes256CbcPkcs7WithIv(data, key, iv) {
        return CryptoBase_1.CryptoBase.ctAes256CbcPkcs7WithIv(this, data, key, iv).async();
    }
    ctAes256CbcPkcs7WithIv_check() {
        return this.check(() => this.ctAes256CbcPkcs7WithIv(Buffer.alloc(1024), Buffer.alloc(32), Buffer.alloc(16)));
    }
    ctAes256CbcPkcs7WithIvAndHmacSha256(data, key, iv, tagLen) {
        return CryptoBase_1.CryptoBase.ctAes256CbcPkcs7WithIvAndHmacSha256(this, data, key, iv, tagLen).async();
    }
    ctAes256CbcPkcs7WithIvAndHmacSha256_check() {
        return this.check(() => this.ctAes256CbcPkcs7WithIvAndHmacSha256(Buffer.alloc(1024), Buffer.alloc(32), Buffer.alloc(16)));
    }
}
exports.CryptoSubtle = CryptoSubtle;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../browserbuffer/BrowserBuffer":228,"./CryptoBase":230,"buffer":498,"privmx-exception":286}],233:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;

},{}],234:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordMixer = exports.PasswordMixerBase = void 0;
const R_1 = require("../crypto/R");
class PasswordMixerBase {
    static serializeData(data) {
        return JSON.stringify({
            algorithm: data.algorithm,
            hash: data.hash,
            length: data.length,
            rounds: data.rounds,
            salt: data.salt.toString("base64"),
            version: data.version
        });
    }
    static deserializeData(raw) {
        const data = JSON.parse(raw);
        data.salt = Buffer.from(data.salt, "base64");
        return data;
    }
    static generatePbkdf2(crypto, password) {
        let data;
        return (0, R_1.R)(() => {
            data = {
                algorithm: "PBKDF2",
                hash: "SHA512",
                length: 16,
                rounds: 4000 + Math.floor(Math.random() * 1000),
                salt: crypto.randomBytes(16),
                version: 1
            };
            return PasswordMixerBase.perform(crypto, password, data);
        })
            .then(mixed => {
            return {
                mixed: mixed,
                data: data
            };
        });
    }
    static perform(crypto, password, data) {
        return (0, R_1.R)(() => {
            if (data.algorithm == "PBKDF2") {
                if (data.hash != "SHA512") {
                    throw new Error("Not supported hash algorithm '" + data.hash + "'");
                }
                if (data.version != 1) {
                    throw new Error("Not supported version '" + data.version + "'");
                }
                if (data.salt.length != 16 || data.length != 16) {
                    throw new Error("Invalid parameters");
                }
                return crypto.pbkdf2(password, data.salt, data.rounds, data.length, data.hash.toLowerCase());
            }
            throw new Error("Not supported algorithm '" + data.algorithm + "'");
        });
    }
}
exports.PasswordMixerBase = PasswordMixerBase;
class PasswordMixer {
    crypto;
    constructor(crypto) {
        this.crypto = crypto;
    }
    serializeData(data) {
        return PasswordMixerBase.serializeData(data);
    }
    deserializeData(raw) {
        return PasswordMixerBase.deserializeData(raw);
    }
    generatePbkdf2(password) {
        return PasswordMixerBase.generatePbkdf2(this.crypto, password).async();
    }
    perform(password, data) {
        return PasswordMixerBase.perform(this.crypto, password, data).async();
    }
}
exports.PasswordMixer = PasswordMixer;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../crypto/R":235,"buffer":498}],235:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RE = exports.RV = exports.R = exports.ValueResult = void 0;
const PromiseUtils_1 = require("../utils/PromiseUtils");
class ValueResult {
    promiseMode;
    success;
    value;
    error;
    promise;
    toResolve;
    resolved;
    constructor() {
    }
    static createPromise(promise) {
        const result = new ValueResult();
        result.promiseMode = true;
        result.promise = promise;
        result.toResolve = [];
        result.promise.then(x => {
            return result.resolve(x);
        }, e => {
            result.reject(e);
            return ValueResult.createError(e);
        });
        return result;
    }
    static createResult(value) {
        const res = new ValueResult();
        res.success = true;
        res.value = value;
        return res;
    }
    static createError(error) {
        const result = new ValueResult();
        result.success = false;
        result.error = error;
        return result;
    }
    sync() {
        if (this.promiseMode) {
            throw new Error("Not supported sync mode");
        }
        if (this.success) {
            return this.value;
        }
        throw this.error;
    }
    async() {
        if (this.promiseMode && !this.resolved) {
            const defer = PromiseUtils_1.PromiseUtils.defer();
            this.toResolve.push(defer);
            return defer.promise;
        }
        return this.success ? Promise.resolve(this.value) : Promise.reject(this.error);
    }
    resolve(value) {
        if (this.resolved) {
            return;
        }
        this.success = true;
        this.value = value;
        this.resolved = true;
        this.toResolve.forEach(x => {
            x.resolve(this.value);
        });
        delete this.promise;
        delete this.toResolve;
    }
    reject(error) {
        if (this.resolved) {
            return;
        }
        this.success = false;
        this.error = error;
        this.resolved = true;
        this.toResolve.forEach(x => {
            x.reject(this.error);
        });
        delete this.promise;
        delete this.toResolve;
    }
    then(onfulfilled, onrejected) {
        if (this.promiseMode && !this.resolved) {
            const defer = PromiseUtils_1.PromiseUtils.defer();
            this.toResolve.push(defer);
            return ValueResult.createPromise(defer.promise.then(onfulfilled, onrejected));
        }
        try {
            let u;
            if (this.success) {
                u = onfulfilled(this.value);
            }
            else {
                if (onrejected) {
                    u = onrejected(this.error);
                }
                return ValueResult.createError(this.error);
            }
            if (u instanceof ValueResult && !u.promiseMode) {
                if (u.success) {
                    return ValueResult.createResult(u.value);
                }
                else {
                    return ValueResult.createError(u.error);
                }
            }
            else if (u != null && typeof (u.then) == "function") {
                return ValueResult.createPromise(u);
            }
            return ValueResult.createResult(u);
        }
        catch (e) {
            return ValueResult.createError(e);
        }
    }
    catch(onrejected) {
        return this.then(x => x, onrejected);
    }
}
exports.ValueResult = ValueResult;
function R(func) {
    return ValueResult.createResult(null).then(func);
}
exports.R = R;
function RV(value) {
    return ValueResult.createResult(value);
}
exports.RV = RV;
function RE(error) {
    return ValueResult.createError(error);
}
exports.RE = RE;

},{"../utils/PromiseUtils":283}],236:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Service = exports.CryptoSyncAsPromiseExecute = exports.Binder = void 0;
const Requester_1 = require("./webworker/Requester");
const CryptoSubtle_1 = require("./CryptoSubtle");
const sync_1 = require("./sync");
const CryptoPrivmx_1 = require("./CryptoPrivmx");
const ServiceHelper_1 = require("./ServiceHelper");
const openssl_handler_1 = require("../openssl/openssl-handler");
const ecc_crypto_1 = require("../ecc/ecc-crypto");
const rsa_subtle_1 = require("../rsa/rsa-subtle");
const rsa_crypto_1 = require("../rsa/rsa-crypto");
const rsa_browser_1 = require("../rsa/rsa-browser");
const ObjectEncryptor_1 = require("../utils/ObjectEncryptor");
const PasswordMixer_1 = require("./PasswordMixer");
const EntropyManager_1 = require("./random/EntropyManager");
const RandomService_1 = require("./random/RandomService");
const BytesGenerator_1 = require("./random/BytesGenerator");
const isNode = new Function("try {return this===global;}catch(e){ return false;}");
class Binder {
    hmac(algorithm, key, data) {
        return this.execute("hmac", [algorithm, key, data]);
    }
    hmacSha1(key, data) {
        return this.execute("hmacSha1", [key, data]);
    }
    hmacSha256(key, data) {
        return this.execute("hmacSha256", [key, data]);
    }
    hmacSha512(key, data) {
        return this.execute("hmacSha512", [key, data]);
    }
    hash(algorithm, data) {
        return this.execute("hash", [algorithm, data]);
    }
    sha1(data) {
        return this.execute("sha1", [data]);
    }
    sha256(data) {
        return this.execute("sha256", [data]);
    }
    sha512(data) {
        return this.execute("sha512", [data]);
    }
    ripemd160(data) {
        return this.execute("ripemd160", [data]);
    }
    hash160(data) {
        return this.execute("hash160", [data]);
    }
    kdf(algo, length, key, options) {
        return this.execute("kdf", [algo, length, key, options]);
    }
    getKEM(algo, key, keLen, kmLen) {
        return this.execute("getKEM", [algo, key, keLen, kmLen]);
    }
    aes256CbcPkcs7Encrypt(data, key, iv) {
        return this.execute("aes256CbcPkcs7Encrypt", [data, key, iv]);
    }
    aes256CbcPkcs7Decrypt(data, key, iv) {
        return this.execute("aes256CbcPkcs7Decrypt", [data, key, iv]);
    }
    aes256CbcNoPadEncrypt(data, key, iv) {
        return this.execute("aes256CbcNoPadEncrypt", [data, key, iv]);
    }
    aes256CbcNoPadDecrypt(data, key, iv) {
        return this.execute("aes256CbcNoPadDecrypt", [data, key, iv]);
    }
    aes256EcbEncrypt(data, key) {
        return this.execute("aes256EcbEncrypt", [data, key]);
    }
    aes256EcbDecrypt(data, key) {
        return this.execute("aes256EcbDecrypt", [data, key]);
    }
    xteaEcbPkcs7Encrypt(data, key) {
        return this.execute("xteaEcbPkcs7Encrypt", [data, key]);
    }
    xteaEcbPkcs7Decrypt(data, key) {
        return this.execute("xteaEcbPkcs7Decrypt", [data, key]);
    }
    aes256CbcHmac256Encrypt(data, key32, iv, tagLen) {
        return this.execute("aes256CbcHmac256Encrypt", [data, key32, iv, tagLen]);
    }
    aes256CbcHmac256Decrypt(data, key32, tagLen) {
        return this.execute("aes256CbcHmac256Decrypt", [data, key32, tagLen]);
    }
    prf_tls12(key, seed, length) {
        return this.execute("prf_tls12", [key, seed, length]);
    }
    hkdfSha256(key, salt, length) {
        return this.execute("hkdfSha256", [key, salt, length]);
    }
    generateIv(key, idx) {
        return this.execute("generateIv", [key, idx]);
    }
    reductKey(key) {
        return this.execute("reductKey", [key]);
    }
    xteaEcbPkcs7Key32Encrypt(data, key) {
        return this.execute("xteaEcbPkcs7Key32Encrypt", [data, key]);
    }
    xteaEcbPkcs7Key32Decrypt(data, key) {
        return this.execute("xteaEcbPkcs7Key32Decrypt", [data, key]);
    }
    ctAes256CbcPkcs7NoIv(data, key, iv) {
        return this.execute("ctAes256CbcPkcs7NoIv", [data, key, iv]);
    }
    ctAes256CbcPkcs7WithIv(data, key, iv) {
        return this.execute("ctAes256CbcPkcs7WithIv", [data, key, iv]);
    }
    ctAes256CbcPkcs7WithRandomIv(data, key) {
        return this.execute("ctAes256CbcPkcs7WithRandomIv", [data, key]);
    }
    ctXteaEcbPkcs7(data, key) {
        return this.execute("ctXteaEcbPkcs7", [data, key]);
    }
    ctXteaEcbPkcs7Key32(data, key32) {
        return this.execute("ctXteaEcbPkcs7Key32", [data, key32]);
    }
    ctAes256CbcPkcs7WithIvAndHmacSha256(data, key, iv, tagLen) {
        return this.execute("ctAes256CbcPkcs7WithIvAndHmacSha256", [data, key, iv, tagLen]);
    }
    ctDecrypt(data, key32, iv16, tagLen, key16) {
        return this.execute("ctDecrypt", [data, key32, iv16, tagLen, key16]);
    }
    pbkdf2(password, salt, rounds, length, algorithm) {
        return this.execute("pbkdf2", [password, salt, rounds, length, algorithm]);
    }
    eccExtFromSeed(seed) {
        return this.execute("eccExtFromSeed", [seed]);
    }
    eccExtRandom() {
        return this.execute("eccExtRandom", []);
    }
    eccPrivRandom() {
        return this.execute("eccPrivRandom", []);
    }
    eccPubToBase58Address(pub, network) {
        return this.execute("eccPubToBase58Address", [pub, network]);
    }
    signToCompactSignature(priv, hash) {
        return this.execute("signToCompactSignature", [priv, hash]);
    }
    signToCompactSignatureWithHash(priv, message) {
        return this.execute("signToCompactSignatureWithHash", [priv, message]);
    }
    eccDerive(priv, pub) {
        return this.execute("eccDerive", [priv, pub]);
    }
    eciesEncrypt(priv, pub, data) {
        return this.execute("eciesEncrypt", [priv, pub, data]);
    }
    eciesDecrypt(priv, pub, data) {
        return this.execute("eciesDecrypt", [priv, pub, data]);
    }
    eccEciesEncrypt(priv, pub, data) {
        return this.execute("eccEciesEncrypt", [priv, pub, data]);
    }
    eccEciesDecrypt(priv, pub, data) {
        return this.execute("eccEciesDecrypt", [priv, pub, data]);
    }
    verifyCompactSignature(pub, hash, signature) {
        return this.execute("verifyCompactSignature", [pub, hash, signature]);
    }
    verifyCompactSignatureWithHash(pub, message, signature) {
        return this.execute("verifyCompactSignatureWithHash", [pub, message, signature]);
    }
    eccExtDerive(ext, options) {
        return this.execute("eccExtDerive", [ext, options]);
    }
    eccExtDeriveWithPath(ext, options) {
        return this.execute("eccExtDeriveWithPath", [ext, options]);
    }
    eccGenerateKey(type) {
        return this.execute("eccGenerateKey", [type]);
    }
    ecdsaSign(priv, data) {
        return this.execute("ecdsaSign", [priv, data]);
    }
    ecdsaVerify(pub, signature, data) {
        return this.execute("ecdsaVerify", [pub, signature, data]);
    }
    bip39Generate(strength, password) {
        return this.execute("bip39Generate", [strength, password]);
    }
    bip39FromEntropy(entropy, password) {
        return this.execute("bip39FromEntropy", [entropy, password]);
    }
    bip39FromMnemonic(mnemonic, password) {
        return this.execute("bip39FromMnemonic", [mnemonic, password]);
    }
    bip39GetExtKey(mnemonic, password) {
        return this.execute("bip39GetExtKey", [mnemonic, password]);
    }
    srpRegister(N, g, I, P) {
        return this.execute("srpRegister", [N, g, I, P]);
    }
    srpRegisterS(N, g, I, P, s) {
        return this.execute("srpRegisterS", [N, g, I, P, s]);
    }
    srpLoginStep1(N, g, s, B, I, P) {
        return this.execute("srpLoginStep1", [N, g, s, B, I, P]);
    }
    srpLoginStep1A(N, g, s, B, I, P, a) {
        return this.execute("srpLoginStep1A", [N, g, s, B, I, P, a]);
    }
    srpLoginStep2(clientM2, serverM2) {
        return this.execute("srpLoginStep2", [clientM2, serverM2]);
    }
    rsaGenerateKey(bits) {
        return this.execute("rsaGenerateKey", [bits]);
    }
    rsaOaepEncrypt(key, data) {
        return this.execute("rsaOaepEncrypt", [key, data]);
    }
    rsaOaepDecrypt(key, data) {
        return this.execute("rsaOaepDecrypt", [key, data]);
    }
    rsaSign(key, data) {
        return this.execute("rsaSign", [key, data]);
    }
    rsaVerify(key, signature, data) {
        return this.execute("rsaVerify", [key, signature, data]);
    }
    encryptPrivateKey(key, passphrase) {
        return this.execute("encryptPrivateKey", [key, passphrase]);
    }
    decryptPrivateKey(encKey, passphrase) {
        return this.execute("decryptPrivateKey", [encKey, passphrase]);
    }
    extractPublicKey(priv) {
        return this.execute("extractPublicKey", [priv]);
    }
    privmxEncrypt(options, data, key, iv) {
        return this.execute("privmxEncrypt", [options, data, key, iv]);
    }
    privmxDecrypt(optionsOrData, dataOrKey32, key32OrIv16, iv16) {
        return this.execute("privmxDecrypt", [optionsOrData, dataOrKey32, key32OrIv16, iv16]);
    }
    privmxGetBlockSize(options, blockSize) {
        return this.executeSync("privmxGetBlockSize", [options, blockSize]);
    }
    privmxHasSignature(data) {
        return this.executeSync("privmxHasSignature", [data]);
    }
    privmxSetErrorOnMissingSignature(value) {
        return this.executeSync("privmxSetErrorOnMissingSignature", [value]);
    }
    privmxOptAesWithDetachedIv() {
        return this.executeSync("privmxOptAesWithDetachedIv", []);
    }
    privmxOptAesWithAttachedIv() {
        return this.executeSync("privmxOptAesWithAttachedIv", []);
    }
    privmxOptAesWithSignature() {
        return this.executeSync("privmxOptAesWithSignature", []);
    }
    privmxOptXtea() {
        return this.executeSync("privmxOptXtea", []);
    }
    privmxOptSignedCipher() {
        return this.executeSync("privmxOptSignedCipher", []);
    }
    randomInt32() {
        return this.executeSync("randomInt32", []);
    }
    randomDouble() {
        return this.executeSync("randomDouble", []);
    }
    randomBytes(num) {
        return this.executeSync("randomBytes", [num]);
    }
    randomBits(num) {
        return this.executeSync("randomBits", [num]);
    }
    randomBN(max) {
        return this.executeSync("randomBN", [max]);
    }
}
exports.Binder = Binder;
class CryptoSyncAsPromiseExecute {
    cryptoSync;
    constructor() {
        this.cryptoSync = new sync_1.CryptoSyncRandom();
    }
    execute(method, params) {
        if (!(method in this.cryptoSync)) {
            return false;
        }
        return Promise.resolve().then(() => {
            return this.cryptoSync[method].apply(this.cryptoSync, params);
        });
    }
}
exports.CryptoSyncAsPromiseExecute = CryptoSyncAsPromiseExecute;
class Service extends Binder {
    useEntropy;
    handlers;
    initialized;
    entropyManager;
    constructor() {
        super();
        this.handlers = [];
        this.initialized = false;
    }
    init(path) {
        if (this.initialized) {
            return;
        }
        this.handlers.push(new RandomService_1.RandomService(this.getRandomProvider()));
        this.handlers.push(new ServiceHelper_1.ServiceHelper(this));
        this.handlers.push(new openssl_handler_1.OpenSSLHandler(this));
        this.handlers.push(new CryptoPrivmx_1.CryptoPrivmx(this));
        this.handlers.push(new CryptoSubtle_1.CryptoSubtle());
        this.handlers.push(new rsa_subtle_1.RsaSubtle(this));
        if (path) {
            this.handlers.push(new Requester_1.Requester(path));
        }
        this.handlers.push(new ServiceHelper_1.ServiceHelper2(this));
        this.handlers.push(new CryptoSyncAsPromiseExecute());
        this.handlers.push(new ecc_crypto_1.EccCrypto(this));
        if (isNode()) {
            this.handlers.push(new rsa_crypto_1.RsaCrypto(this));
        }
        else {
            this.handlers.push(new rsa_browser_1.RsaBrowser(this));
        }
        this.handlers.forEach(handler => {
            if (typeof (handler["init"]) == "function") {
                handler.init(this);
            }
        });
        this.initialized = true;
    }
    getRandomProvider() {
        if (this.useEntropy) {
            this.entropyManager = new EntropyManager_1.EntropyManager();
            return this.entropyManager.bytesGenerator;
        }
        if (typeof (window) != "undefined" && typeof (window.crypto) != "undefined" && typeof (window.crypto.getRandomValues) != "undefined") {
            return new BytesGenerator_1.BrowserCryptoRandomBytesGenerator();
        }
        return new BytesGenerator_1.NodeCryptoRandomBytesGenerator();
    }
    executeSync(method, params) {
        this.init();
        if (this.entropyManager) {
            this.entropyManager.increaseCounter();
        }
        for (const handler of this.handlers) {
            if (handler[method]) {
                return handler[method].apply(handler, params);
            }
        }
        throw new Error("Unhandled method " + method);
    }
    execute(method, params) {
        this.init();
        if (this.entropyManager) {
            this.entropyManager.increaseCounter();
        }
        if (!Array.isArray(params)) {
            params = Array.prototype.slice.call(params);
        }
        for (const handler of this.handlers) {
            handler._state = handler._state || {};
            if (handler["isSupported"]) {
                let state = handler._state["isSupported"];
                if (state === undefined) {
                    state = handler["isSupported"].apply(handler);
                    handler._state["isSupported"] = state;
                }
                if (state === false) {
                    continue;
                }
                if (state !== true) {
                    return state
                        .then((result) => {
                        handler._state["isSupported"] = result;
                        return this.execute(method, params);
                    });
                }
            }
            if (!handler[method]) {
                if (!handler["execute"]) {
                    continue;
                }
                const result = handler.execute(method, params);
                if (result === false) {
                    continue;
                }
                return Promise.resolve().then(() => result);
            }
            if (!handler[method + "_check"]) {
                return handler[method].apply(handler, params);
            }
            let checkMethod = handler[method + "_check"];
            if (typeof (checkMethod) !== "string") {
                checkMethod = method;
            }
            let algo = checkMethod;
            let vary = "";
            if (handler[checkMethod + "_vary"]) {
                vary = handler[checkMethod + "_vary"].apply(handler, params);
                algo = algo + vary;
            }
            let state = handler._state[algo];
            if (state === false) {
                continue;
            }
            if (state === true) {
                return handler[method].apply(handler, params);
            }
            if (state === undefined) {
                state = handler[checkMethod + "_check"].apply(handler, [vary])
                    .then((result) => {
                    handler._state[algo] = result;
                });
                handler._state[algo] = state;
            }
            return state
                .then(() => {
                return this.execute(method, params);
            });
        }
        return Promise.resolve().then(() => {
            throw new Error("unhandled method " + method);
        });
    }
    getObjectEncryptor(key, encryptOptions, decryptOptions) {
        return new ObjectEncryptor_1.ObjectEncryptor(this, key, encryptOptions, decryptOptions);
    }
    getPasswordMixer() {
        return new PasswordMixer_1.PasswordMixer(this);
    }
}
exports.Service = Service;

},{"../ecc/ecc-crypto":261,"../openssl/openssl-handler":269,"../rsa/rsa-browser":274,"../rsa/rsa-crypto":275,"../rsa/rsa-subtle":276,"../utils/ObjectEncryptor":282,"./CryptoPrivmx":231,"./CryptoSubtle":232,"./PasswordMixer":234,"./ServiceHelper":237,"./random/BytesGenerator":241,"./random/EntropyManager":243,"./random/RandomService":246,"./sync":250,"./webworker/Requester":253}],237:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceHelper2 = exports.ServiceHelper = void 0;
const CryptoBase_1 = require("./CryptoBase");
class ServiceHelper {
    service;
    constructor(service) {
        this.service = service;
    }
    eccExtRandom() {
        return CryptoBase_1.CryptoBase.eccExtRandom(this.service).async();
    }
    eccPrivRandom() {
        return CryptoBase_1.CryptoBase.eccPrivRandom(this.service).async();
    }
    ctAes256CbcPkcs7WithRandomIv(data, key) {
        return CryptoBase_1.CryptoBase.ctAes256CbcPkcs7WithRandomIv(this.service, data, key).async();
    }
    bip39Generate(strength, password) {
        return CryptoBase_1.CryptoBase.bip39Generate(this.service, strength, password).async();
    }
    srpRegister(N, g, I, P) {
        return CryptoBase_1.CryptoBase.srpRegister(this.service, N, g, I, P).async();
    }
    srpLoginStep1(N, g, s, B, I, P) {
        return CryptoBase_1.CryptoBase.srpLoginStep1(this.service, N, g, s, B, I, P).async();
    }
    ctDecrypt(data, key32, iv16, tagLen, key16) {
        return CryptoBase_1.CryptoBase.ctDecrypt(this.service, data, key32, iv16, tagLen, key16).async();
    }
}
exports.ServiceHelper = ServiceHelper;
class ServiceHelper2 {
    service;
    constructor(service) {
        this.service = service;
    }
    hash160(data) {
        return CryptoBase_1.CryptoBase.hash160(this.service, data).async();
    }
    eccExtFromSeed(seed) {
        return CryptoBase_1.CryptoBase.eccExtFromSeed(this.service, seed).async();
    }
    eccPubToBase58Address(pub, network) {
        return CryptoBase_1.CryptoBase.eccPubToBase58Address(this.service, pub, network).async();
    }
    signToCompactSignatureWithHash(priv, message) {
        return CryptoBase_1.CryptoBase.signToCompactSignatureWithHash(this.service, priv, message).async();
    }
    eccDerive(priv, pub) {
        return CryptoBase_1.CryptoBase.eccDerive(priv, pub).async();
    }
    verifyCompactSignatureWithHash(pub, message, signature) {
        return CryptoBase_1.CryptoBase.verifyCompactSignatureWithHash(this.service, pub, message, signature).async();
    }
    eciesEncrypt(priv, pub, data) {
        return CryptoBase_1.CryptoBase.eciesEncrypt(this.service, priv, pub, data).async();
    }
    eciesDecrypt(priv, pub, data) {
        return CryptoBase_1.CryptoBase.eciesDecrypt(this.service, priv, pub, data).async();
    }
    eccExtDerive(ext, options) {
        return CryptoBase_1.CryptoBase.eccExtDerive(this.service, ext, options).async();
    }
    eccExtDeriveWithPath(ext, options) {
        return CryptoBase_1.CryptoBase.eccExtDeriveWithPath(this.service, ext, options).async();
    }
    bip39FromEntropy(entropy, password) {
        return CryptoBase_1.CryptoBase.bip39FromEntropy(this.service, entropy, password).async();
    }
    bip39FromMnemonic(mnemonic, password) {
        return CryptoBase_1.CryptoBase.bip39FromMnemonic(this.service, mnemonic, password).async();
    }
    bip39GetExtKey(mnemonic, password) {
        return CryptoBase_1.CryptoBase.bip39GetExtKey(this.service, mnemonic, password).async();
    }
    srpRegisterS(N, g, I, P, s) {
        return CryptoBase_1.CryptoBase.srpRegisterS(this.service, N, g, I, P, s).async();
    }
    srpLoginStep1A(N, g, s, B, I, P, a) {
        return CryptoBase_1.CryptoBase.srpLoginStep1A(this.service, N, g, s, B, I, P, a).async();
    }
}
exports.ServiceHelper2 = ServiceHelper2;

},{"./CryptoBase":230}],238:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoAsyncAbstract = void 0;
const CryptoBase_1 = require("../CryptoBase");
class CryptoAsyncAbstract {
    hmacSha1(key, data) {
        return CryptoBase_1.CryptoBase.hmacSha1(this, key, data).async();
    }
    hmacSha256(key, data) {
        return CryptoBase_1.CryptoBase.hmacSha256(this, key, data).async();
    }
    hmacSha512(key, data) {
        return CryptoBase_1.CryptoBase.hmacSha512(this, key, data).async();
    }
    sha1(data) {
        return CryptoBase_1.CryptoBase.sha1(this, data).async();
    }
    sha256(data) {
        return CryptoBase_1.CryptoBase.sha256(this, data).async();
    }
    sha512(data) {
        return CryptoBase_1.CryptoBase.sha512(this, data).async();
    }
    ripemd160(data) {
        return CryptoBase_1.CryptoBase.ripemd160(this, data).async();
    }
    hash160(data) {
        return CryptoBase_1.CryptoBase.hash160(this, data).async();
    }
    kdf(algo, length, key, options) {
        return CryptoBase_1.CryptoBase.kdf(this, algo, length, key, options).async();
    }
    getKEM(algo, key, keLen, kmLen) {
        return CryptoBase_1.CryptoBase.getKEM(this, algo, key, keLen, kmLen).async();
    }
    aes256CbcHmac256Encrypt(data, key32, iv, tagLen) {
        return CryptoBase_1.CryptoBase.aes256CbcHmac256Encrypt(this, data, key32, iv, tagLen).async();
    }
    aes256CbcHmac256Decrypt(data, key32, tagLen) {
        return CryptoBase_1.CryptoBase.aes256CbcHmac256Decrypt(this, data, key32, tagLen).async();
    }
    prf_tls12(key, seed, length) {
        return CryptoBase_1.CryptoBase.prf_tls12(this, key, seed, length).async();
    }
    hkdfSha256(key, salt, info, len) {
        return CryptoBase_1.CryptoBase.hkdfSha256(this, key, salt, info, len).async();
    }
    generateIv(key, idx) {
        return CryptoBase_1.CryptoBase.generateIv(this, key, idx).async();
    }
    reductKey(key) {
        return CryptoBase_1.CryptoBase.reductKey(this, key).async();
    }
    xteaEcbPkcs7Key32Encrypt(data, key32) {
        return CryptoBase_1.CryptoBase.xteaEcbPkcs7Key32Encrypt(this, data, key32).async();
    }
    xteaEcbPkcs7Key32Decrypt(data, key32) {
        return CryptoBase_1.CryptoBase.xteaEcbPkcs7Key32Decrypt(this, data, key32).async();
    }
    ctAes256CbcPkcs7NoIv(data, key, iv) {
        return CryptoBase_1.CryptoBase.ctAes256CbcPkcs7NoIv(this, data, key, iv).async();
    }
    ctAes256CbcPkcs7WithIv(data, key, iv) {
        return CryptoBase_1.CryptoBase.ctAes256CbcPkcs7WithIv(this, data, key, iv).async();
    }
    ctXteaEcbPkcs7(data, key) {
        return CryptoBase_1.CryptoBase.ctXteaEcbPkcs7(this, data, key).async();
    }
    ctXteaEcbPkcs7Key32(data, key32) {
        return CryptoBase_1.CryptoBase.ctXteaEcbPkcs7Key32(this, data, key32).async();
    }
    ctAes256CbcPkcs7WithIvAndHmacSha256(data, key, iv, tagLen) {
        return CryptoBase_1.CryptoBase.ctAes256CbcPkcs7WithIvAndHmacSha256(this, data, key, iv, tagLen).async();
    }
    ctDecrypt(data, key32, iv16, tagLen, key16) {
        return CryptoBase_1.CryptoBase.ctDecrypt(this, data, key32, iv16, tagLen, key16).async();
    }
    eccExtFromSeed(seed) {
        return CryptoBase_1.CryptoBase.eccExtFromSeed(this, seed).async();
    }
    eccPubToBase58Address(pub, network) {
        return CryptoBase_1.CryptoBase.eccPubToBase58Address(this, pub, network).async();
    }
    signToCompactSignature(priv, hash) {
        return CryptoBase_1.CryptoBase.signToCompactSignature(priv, hash).async();
    }
    signToCompactSignatureWithHash(priv, message) {
        return CryptoBase_1.CryptoBase.signToCompactSignatureWithHash(this, priv, message).async();
    }
    eccDerive(priv, pub) {
        return CryptoBase_1.CryptoBase.eccDerive(priv, pub).async();
    }
    verifyCompactSignature(pub, hash, signature) {
        return CryptoBase_1.CryptoBase.verifyCompactSignature(pub, hash, signature).async();
    }
    verifyCompactSignatureWithHash(pub, message, signature) {
        return CryptoBase_1.CryptoBase.verifyCompactSignatureWithHash(this, pub, message, signature).async();
    }
    eciesEncrypt(priv, pub, data) {
        return CryptoBase_1.CryptoBase.eciesEncrypt(this, priv, pub, data).async();
    }
    eciesDecrypt(priv, pub, data) {
        return CryptoBase_1.CryptoBase.eciesDecrypt(this, priv, pub, data).async();
    }
    eccExtDerive(ext, options) {
        return CryptoBase_1.CryptoBase.eccExtDerive(this, ext, options).async();
    }
    eccExtDeriveWithPath(ext, options) {
        return CryptoBase_1.CryptoBase.eccExtDeriveWithPath(this, ext, options).async();
    }
    bip39FromEntropy(entropy, password) {
        return CryptoBase_1.CryptoBase.bip39FromEntropy(this, entropy, password).async();
    }
    bip39FromMnemonic(mnemonic, password) {
        return CryptoBase_1.CryptoBase.bip39FromMnemonic(this, mnemonic, password).async();
    }
    bip39GetExtKey(mnemonic, password) {
        return CryptoBase_1.CryptoBase.bip39GetExtKey(this, mnemonic, password).async();
    }
    srpRegisterS(N, g, I, P, s) {
        return CryptoBase_1.CryptoBase.srpRegisterS(this, N, g, I, P, s).async();
    }
    srpLoginStep1A(N, g, s, B, I, P, a) {
        return CryptoBase_1.CryptoBase.srpLoginStep1A(this, N, g, s, B, I, P, a).async();
    }
    srpLoginStep2(clientM2, serverM2) {
        return CryptoBase_1.CryptoBase.srpLoginStep2(clientM2, serverM2).async();
    }
    eccExtRandom() {
        return CryptoBase_1.CryptoBase.eccExtRandom(this).async();
    }
    eccPrivRandom() {
        return CryptoBase_1.CryptoBase.eccPrivRandom(this).async();
    }
    ctAes256CbcPkcs7WithRandomIv(data, key) {
        return CryptoBase_1.CryptoBase.ctAes256CbcPkcs7WithRandomIv(this, data, key).async();
    }
    bip39Generate(strength, password) {
        return CryptoBase_1.CryptoBase.bip39Generate(this, strength, password).async();
    }
    srpRegister(N, g, I, P) {
        return CryptoBase_1.CryptoBase.srpRegister(this, N, g, I, P).async();
    }
    srpLoginStep1(N, g, s, B, I, P) {
        return CryptoBase_1.CryptoBase.srpLoginStep1(this, N, g, s, B, I, P).async();
    }
}
exports.CryptoAsyncAbstract = CryptoAsyncAbstract;

},{"../CryptoBase":230}],239:[function(require,module,exports){
"use strict";
const CryptoAsync = require("./CryptoAsync");
module.exports = CryptoAsync;

},{"./CryptoAsync":238}],240:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceHelper2 = exports.ServiceHelper = exports.Service = exports.R = exports.PasswordMixer = exports.Interfaces = exports.CryptoSubtle = exports.CryptoPrivmx = exports.CryptoPrivmxBase = exports.CryptoBase = exports.CipherType = exports.sync = exports.random = exports.async = exports.webworker = void 0;
const webworker = require("./webworker");
exports.webworker = webworker;
const async = require("./async");
exports.async = async;
const random = require("./random");
exports.random = random;
const sync = require("./sync");
exports.sync = sync;
const CipherType_1 = require("./CipherType");
Object.defineProperty(exports, "CipherType", { enumerable: true, get: function () { return CipherType_1.CipherType; } });
const CryptoBase_1 = require("./CryptoBase");
Object.defineProperty(exports, "CryptoBase", { enumerable: true, get: function () { return CryptoBase_1.CryptoBase; } });
const CryptoPrivmx_1 = require("./CryptoPrivmx");
Object.defineProperty(exports, "CryptoPrivmxBase", { enumerable: true, get: function () { return CryptoPrivmx_1.CryptoPrivmxBase; } });
Object.defineProperty(exports, "CryptoPrivmx", { enumerable: true, get: function () { return CryptoPrivmx_1.CryptoPrivmx; } });
const CryptoSubtle_1 = require("./CryptoSubtle");
Object.defineProperty(exports, "CryptoSubtle", { enumerable: true, get: function () { return CryptoSubtle_1.CryptoSubtle; } });
const Interfaces = require("./Interfaces");
exports.Interfaces = Interfaces;
const PasswordMixer_1 = require("./PasswordMixer");
Object.defineProperty(exports, "PasswordMixer", { enumerable: true, get: function () { return PasswordMixer_1.PasswordMixer; } });
const R = require("./R");
exports.R = R;
const Service_1 = require("./Service");
Object.defineProperty(exports, "Service", { enumerable: true, get: function () { return Service_1.Service; } });
const ServiceHelper_1 = require("./ServiceHelper");
Object.defineProperty(exports, "ServiceHelper", { enumerable: true, get: function () { return ServiceHelper_1.ServiceHelper; } });
Object.defineProperty(exports, "ServiceHelper2", { enumerable: true, get: function () { return ServiceHelper_1.ServiceHelper2; } });

},{"./CipherType":229,"./CryptoBase":230,"./CryptoPrivmx":231,"./CryptoSubtle":232,"./Interfaces":233,"./PasswordMixer":234,"./R":235,"./Service":236,"./ServiceHelper":237,"./async":239,"./random":248,"./sync":250,"./webworker":255}],241:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeedRandomBytesGenerator = exports.MathRandomBytesGenerator = exports.NodeCryptoRandomBytesGenerator = exports.BrowserCryptoRandomBytesGenerator = void 0;
const _crypto = require("crypto");
const seedrandom = require("seedrandom");
class BrowserCryptoRandomBytesGenerator {
    generate(length) {
        const result = Buffer.alloc(length);
        crypto.getRandomValues(result);
        return result;
    }
}
exports.BrowserCryptoRandomBytesGenerator = BrowserCryptoRandomBytesGenerator;
class NodeCryptoRandomBytesGenerator {
    generate(length) {
        return _crypto.randomBytes(length);
    }
}
exports.NodeCryptoRandomBytesGenerator = NodeCryptoRandomBytesGenerator;
class MathRandomBytesGenerator {
    generate(length) {
        const result = Buffer.alloc(length);
        for (let i = 0; i < length; i++) {
            result[i] = Math.floor(Math.random() * 256);
        }
        return result;
    }
}
exports.MathRandomBytesGenerator = MathRandomBytesGenerator;
class SeedRandomBytesGenerator {
    rng;
    constructor() {
        this.rng = new seedrandom();
    }
    generate(num) {
        const buffer = Buffer.alloc(num);
        let offset = 0;
        while (num >= 4) {
            buffer.writeInt32LE(this.rng.int32(), offset);
            offset += 4;
            num -= 4;
        }
        while (num > 0) {
            buffer.writeUInt8(this.rng.int32() & 0xff, offset);
            offset += 1;
            num -= 1;
        }
        return buffer;
    }
    feed(value) {
        this.rng = new seedrandom(value, { entropy: true });
    }
}
exports.SeedRandomBytesGenerator = SeedRandomBytesGenerator;

}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":498,"crypto":507,"seedrandom":381}],242:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntropyGatherer = void 0;
class EntropyGatherer {
    callback;
    maxEntropy;
    entropy;
    constructor(callback, maxEntropy = 64 * 1024) {
        this.callback = callback;
        this.maxEntropy = maxEntropy;
        this.initEntropy();
    }
    initEntropy() {
        this.entropy = Buffer.alloc(0);
    }
    writeEntropy(data) {
        this.addEntropy(data);
        if (this.isFull()) {
            this.flushEntropy();
        }
    }
    addEntropy(data) {
        this.entropy = Buffer.concat([this.entropy, data]);
    }
    isFull() {
        return this.entropy.length >= this.maxEntropy;
    }
    flushEntropy() {
        this.emitEntropy();
        this.clearEntropy();
    }
    emitEntropy() {
        this.callback(this.entropy);
    }
    clearEntropy() {
        this.initEntropy();
    }
}
exports.EntropyGatherer = EntropyGatherer;

}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":498}],243:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntropyManager = void 0;
const EventsAndIntervalEntropyGenerator_1 = require("./EventsAndIntervalEntropyGenerator");
const BytesGenerator_1 = require("./BytesGenerator");
class EntropyManager {
    bytesGenerator;
    entropyGenerator;
    constructor() {
        this.bytesGenerator = new BytesGenerator_1.SeedRandomBytesGenerator();
        this.entropyGenerator = EventsAndIntervalEntropyGenerator_1.EventsAndIntervalEntropyGenerator.create(entropy => {
            this.bytesGenerator.feed(entropy);
        });
    }
    increaseCounter() {
        this.entropyGenerator.increaseCounter();
    }
}
exports.EntropyManager = EntropyManager;

},{"./BytesGenerator":241,"./EventsAndIntervalEntropyGenerator":244}],244:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsAndIntervalEntropyGenerator = void 0;
const Interval_1 = require("../../utils/Interval");
const UIEventsListener_1 = require("./UIEventsListener");
const EntropyGatherer_1 = require("./EntropyGatherer");
const Utils_1 = require("../../utils/Utils");
class EventsAndIntervalEntropyGenerator {
    entropyGatherer;
    interval;
    uiEventsListener;
    counter;
    constructor(intervalGenerator, entropyGatherer) {
        this.entropyGatherer = entropyGatherer;
        this.counter = 0;
        this.uiEventsListener = new UIEventsListener_1.UIEventsListener(data => {
            this.counter++;
            this.entropyGatherer.writeEntropy(data);
        });
        this.interval = new Interval_1.Interval(() => {
            const buffer = this.generateEntropy();
            this.entropyGatherer.writeEntropy(buffer);
        }, intervalGenerator);
    }
    static create(callback) {
        return new EventsAndIntervalEntropyGenerator(() => (0, Utils_1.randomIntInRange)(1000, 2000), new EntropyGatherer_1.EntropyGatherer(callback));
    }
    increaseCounter() {
        this.counter++;
    }
    destroy() {
        this.uiEventsListener.destroy();
        this.interval.stop();
    }
    generateEntropy() {
        const buffer = Buffer.alloc(8);
        const date = new Date().getTime();
        buffer.writeInt32LE(this.counter & 0xFFFFFFFF, 0);
        buffer.writeInt32BE(date & 0xFFFFFFFF, 4);
        return buffer;
    }
}
exports.EventsAndIntervalEntropyGenerator = EventsAndIntervalEntropyGenerator;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../../utils/Interval":280,"../../utils/Utils":284,"./EntropyGatherer":242,"./UIEventsListener":247,"buffer":498}],245:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntervalEntropyGenerator = void 0;
const Interval_1 = require("../../utils/Interval");
const Utils_1 = require("../../utils/Utils");
class IntervalEntropyGenerator {
    entropyGenerator;
    intervalGenerator;
    callback;
    interval;
    constructor(entropyGenerator, intervalGenerator, callback) {
        this.entropyGenerator = entropyGenerator;
        this.intervalGenerator = intervalGenerator;
        this.callback = callback;
        this.interval = new Interval_1.Interval(() => {
            const data = this.entropyGenerator();
            this.callback(data);
        }, this.intervalGenerator);
    }
    destroy() {
        this.interval.stop();
    }
    static create(entropyGenerator, callback) {
        return new IntervalEntropyGenerator(() => entropyGenerator(256), () => (0, Utils_1.randomIntInRange)(1000, 2000), callback);
    }
}
exports.IntervalEntropyGenerator = IntervalEntropyGenerator;

},{"../../utils/Interval":280,"../../utils/Utils":284}],246:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RandomService = void 0;
const BN = require("bn.js");
class RandomService {
    randomBytesGenerator;
    constructor(randomBytesGenerator) {
        this.randomBytesGenerator = randomBytesGenerator;
    }
    randomBytes(length) {
        return this.randomBytesGenerator.generate(length);
    }
    randomInt32() {
        const buffer = this.randomBytes(4);
        return buffer.readInt32BE(0);
    }
    randomDouble() {
        const buffer = this.randomBytes(4);
        const value = buffer.readUInt32BE(0);
        return value / 0xFFFFFFFF;
    }
    randomBits(num) {
        const bytes = ((num + 7) / 8) | 0;
        const r = this.randomBytes(bytes);
        if (num & 7) {
            r[0] >>= 8 - (num & 7);
        }
        return r;
    }
    randomBN(maxArg) {
        const max = BN.isBN(maxArg) ? maxArg : new BN(maxArg);
        const bl = max.byteLength();
        const r = this.randomBytes(bl);
        const bn = new BN(r);
        bn.words[bn.length - 1] %= max.words[max.length - 1];
        return bn;
    }
}
exports.RandomService = RandomService;

},{"bn.js":25}],247:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UIEventsListener = void 0;
class UIEventsListener {
    callback;
    eventCallback;
    eventTypes = ["click", "dblclick", "mousemove", "keyup", "keydown", "keypress", "touchmove", "touchstart", "touchend"];
    constructor(callback) {
        this.callback = callback;
        this.eventCallback = (event) => {
            this.callback(this.serializeEvent(event));
        };
        this.bindEvents();
    }
    destroy() {
        this.unbindEvents();
    }
    isSupported() {
        return typeof (document) !== "undefined";
    }
    bindEvents() {
        if (!this.isSupported()) {
            return;
        }
        for (const type of this.eventTypes) {
            document.addEventListener(type, this.eventCallback);
        }
    }
    unbindEvents() {
        if (!this.isSupported()) {
            return;
        }
        for (const type of this.eventTypes) {
            document.removeEventListener(type, this.eventCallback);
        }
    }
    serializeEvent(event) {
        const allowedEventKeys = ["altKey", "ctrlKey", "shiftKey", "metaKey", "button", "buttons", "clientX", "clientY", "code"];
        let data = "";
        for (const key in event) {
            const value = event[key];
            const type = typeof (value);
            if (type === "function" || type === "object" || allowedEventKeys.indexOf(key) == -1) {
                continue;
            }
            try {
                data += key + value;
            }
            catch (e) {
            }
        }
        return Buffer.from(data);
    }
}
exports.UIEventsListener = UIEventsListener;

}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":498}],248:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UIEventsListener = exports.RandomService = exports.IntervalEntropyGenerator = exports.EntropyManager = exports.EntropyGatherer = exports.SeedRandomBytesGenerator = exports.MathRandomBytesGenerator = exports.NodeCryptoRandomBytesGenerator = exports.BrowserCryptoRandomBytesGenerator = void 0;
const BytesGenerator_1 = require("./BytesGenerator");
Object.defineProperty(exports, "BrowserCryptoRandomBytesGenerator", { enumerable: true, get: function () { return BytesGenerator_1.BrowserCryptoRandomBytesGenerator; } });
Object.defineProperty(exports, "NodeCryptoRandomBytesGenerator", { enumerable: true, get: function () { return BytesGenerator_1.NodeCryptoRandomBytesGenerator; } });
Object.defineProperty(exports, "MathRandomBytesGenerator", { enumerable: true, get: function () { return BytesGenerator_1.MathRandomBytesGenerator; } });
Object.defineProperty(exports, "SeedRandomBytesGenerator", { enumerable: true, get: function () { return BytesGenerator_1.SeedRandomBytesGenerator; } });
const EntropyGatherer_1 = require("./EntropyGatherer");
Object.defineProperty(exports, "EntropyGatherer", { enumerable: true, get: function () { return EntropyGatherer_1.EntropyGatherer; } });
const EntropyManager_1 = require("./EntropyManager");
Object.defineProperty(exports, "EntropyManager", { enumerable: true, get: function () { return EntropyManager_1.EntropyManager; } });
const IntervalEntropyGenerator_1 = require("./IntervalEntropyGenerator");
Object.defineProperty(exports, "IntervalEntropyGenerator", { enumerable: true, get: function () { return IntervalEntropyGenerator_1.IntervalEntropyGenerator; } });
const RandomService_1 = require("./RandomService");
Object.defineProperty(exports, "RandomService", { enumerable: true, get: function () { return RandomService_1.RandomService; } });
const UIEventsListener_1 = require("./UIEventsListener");
Object.defineProperty(exports, "UIEventsListener", { enumerable: true, get: function () { return UIEventsListener_1.UIEventsListener; } });

},{"./BytesGenerator":241,"./EntropyGatherer":242,"./EntropyManager":243,"./IntervalEntropyGenerator":245,"./RandomService":246,"./UIEventsListener":247}],249:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoSyncRandom = exports.CryptoSync = exports.CryptoSyncRandomAbstract = exports.CryptoSyncAbstract = exports.CryptoSyncBase = void 0;
const _crypto = require("crypto");
const XTEA = require("xtea");
const BrowserBuffer_1 = require("../../browserbuffer/BrowserBuffer");
const privmxException = require("privmx-exception");
var IllegalArgumentException = privmxException.IllegalArgumentException;
const randomBytes = require("randombytes");
const CryptoBase_1 = require("../CryptoBase");
class CryptoSyncBase {
    static hmac(algorithm, key, data) {
        return _crypto.createHmac(algorithm, key).update(data).digest();
    }
    static hash(algorithm, data) {
        return _crypto.createHash(algorithm).update(data).digest();
    }
    static aes256CbcPkcs7Encrypt(data, key, iv) {
        if (!BrowserBuffer_1.BrowserBuffer.isBuffer(data) || data.length == 0) {
            throw new IllegalArgumentException("data", data);
        }
        if (!BrowserBuffer_1.BrowserBuffer.isBuffer(key) || key.length != 32) {
            throw new IllegalArgumentException("key", key);
        }
        if (!BrowserBuffer_1.BrowserBuffer.isBuffer(iv) || iv.length != 16) {
            throw new IllegalArgumentException("iv", iv);
        }
        const cipher = _crypto.createCipheriv("aes-256-cbc", key, iv);
        return Buffer.concat([cipher.update(data), cipher.final()]);
    }
    static aes256CbcNoPadEncrypt(data, key, iv) {
        if (!BrowserBuffer_1.BrowserBuffer.isBuffer(data) || data.length == 0 || data.length % 16 != 0) {
            throw new IllegalArgumentException("data", data);
        }
        if (!BrowserBuffer_1.BrowserBuffer.isBuffer(key) || key.length != 32) {
            throw new IllegalArgumentException("key", key);
        }
        if (!BrowserBuffer_1.BrowserBuffer.isBuffer(iv) || iv.length != 16) {
            throw new IllegalArgumentException("iv", iv);
        }
        const cipher = _crypto.createCipheriv("aes-256-cbc", key, iv);
        cipher.setAutoPadding(false);
        return Buffer.concat([cipher.update(data), cipher.final()]);
    }
    static aes256CbcPkcs7Decrypt(data, key, iv) {
        if (!BrowserBuffer_1.BrowserBuffer.isBuffer(data) || data.length == 0) {
            throw new IllegalArgumentException("data", data);
        }
        if (!BrowserBuffer_1.BrowserBuffer.isBuffer(key) || key.length != 32) {
            throw new IllegalArgumentException("key", key);
        }
        if (!BrowserBuffer_1.BrowserBuffer.isBuffer(iv) || iv.length != 16) {
            throw new IllegalArgumentException("iv", iv);
        }
        const cipher = _crypto.createDecipheriv("aes-256-cbc", key, iv);
        return Buffer.concat([cipher.update(data), cipher.final()]);
    }
    static aes256CbcNoPadDecrypt(data, key, iv) {
        if (!BrowserBuffer_1.BrowserBuffer.isBuffer(data) || data.length == 0 || data.length % 16 != 0) {
            throw new IllegalArgumentException("data", data);
        }
        if (!BrowserBuffer_1.BrowserBuffer.isBuffer(key) || key.length != 32) {
            throw new IllegalArgumentException("key", key);
        }
        if (!BrowserBuffer_1.BrowserBuffer.isBuffer(iv) || iv.length != 16) {
            throw new IllegalArgumentException("iv", iv);
        }
        const cipher = _crypto.createDecipheriv("aes-256-cbc", key, iv);
        cipher.setAutoPadding(false);
        return Buffer.concat([cipher.update(data), cipher.final()]);
    }
    static xteaEcbPkcs7Encrypt(data, key) {
        if (!BrowserBuffer_1.BrowserBuffer.isBuffer(data) || data.length == 0) {
            throw new IllegalArgumentException("data", data);
        }
        if (!BrowserBuffer_1.BrowserBuffer.isBuffer(key) || key.length != 16) {
            throw new IllegalArgumentException("key", key);
        }
        return XTEA.encrypt(data, key, "ecb");
    }
    static xteaEcbPkcs7Decrypt(data, key) {
        if (!BrowserBuffer_1.BrowserBuffer.isBuffer(data) || data.length == 0) {
            throw new IllegalArgumentException("data", data);
        }
        if (!BrowserBuffer_1.BrowserBuffer.isBuffer(key) || key.length != 16) {
            throw new IllegalArgumentException("key", key);
        }
        return XTEA.decrypt(data, key, "ecb");
    }
    static aes256EcbEncrypt(data, key) {
        if (!BrowserBuffer_1.BrowserBuffer.isBuffer(data) || data.length == 0 || data.length % 16 != 0) {
            throw new IllegalArgumentException("data", data);
        }
        if (!BrowserBuffer_1.BrowserBuffer.isBuffer(key) || (key.length != 32 && key.length != 16)) {
            throw new IllegalArgumentException("key", key);
        }
        const cipher = _crypto.createCipheriv("aes-256-ecb", key, '');
        cipher.setAutoPadding(false);
        return Buffer.concat([cipher.update(data), cipher.final()]);
    }
    static aes256EcbDecrypt(data, key) {
        if (!BrowserBuffer_1.BrowserBuffer.isBuffer(data) || data.length == 0 || data.length % 16 != 0) {
            throw new IllegalArgumentException("data", data);
        }
        if (!BrowserBuffer_1.BrowserBuffer.isBuffer(key) || key.length != 32) {
            throw new IllegalArgumentException("key", key);
        }
        const cipher = _crypto.createDecipheriv("aes-256-ecb", key, '');
        cipher.setAutoPadding(false);
        return Buffer.concat([cipher.update(data), cipher.final()]);
    }
    static pbkdf2(password, salt, rounds, length, algorithm) {
        return _crypto.pbkdf2Sync(password, salt, rounds, length, algorithm);
    }
}
exports.CryptoSyncBase = CryptoSyncBase;
class CryptoSyncAbstract {
    hmacSha1(key, data) {
        return CryptoBase_1.CryptoBase.hmacSha1(this, key, data).sync();
    }
    hmacSha256(key, data) {
        return CryptoBase_1.CryptoBase.hmacSha256(this, key, data).sync();
    }
    hmacSha512(key, data) {
        return CryptoBase_1.CryptoBase.hmacSha512(this, key, data).sync();
    }
    sha1(data) {
        return CryptoBase_1.CryptoBase.sha1(this, data).sync();
    }
    sha256(data) {
        return CryptoBase_1.CryptoBase.sha256(this, data).sync();
    }
    sha512(data) {
        return CryptoBase_1.CryptoBase.sha512(this, data).sync();
    }
    ripemd160(data) {
        return CryptoBase_1.CryptoBase.ripemd160(this, data).sync();
    }
    hash160(data) {
        return CryptoBase_1.CryptoBase.hash160(this, data).sync();
    }
    kdf(algo, length, key, options) {
        return CryptoBase_1.CryptoBase.kdf(this, algo, length, key, options).sync();
    }
    getKEM(algo, key, keLen, kmLen) {
        return CryptoBase_1.CryptoBase.getKEM(this, algo, key, keLen, kmLen).sync();
    }
    aes256CbcHmac256Encrypt(data, key32, iv, tagLen) {
        return CryptoBase_1.CryptoBase.aes256CbcHmac256Encrypt(this, data, key32, iv, tagLen).sync();
    }
    aes256CbcHmac256Decrypt(data, key32, tagLen) {
        return CryptoBase_1.CryptoBase.aes256CbcHmac256Decrypt(this, data, key32, tagLen).sync();
    }
    prf_tls12(key, seed, length) {
        return CryptoBase_1.CryptoBase.prf_tls12(this, key, seed, length).sync();
    }
    hkdfSha256(key, salt, info, len) {
        return CryptoBase_1.CryptoBase.hkdfSha256(this, key, salt, info, len).sync();
    }
    generateIv(key, idx) {
        return CryptoBase_1.CryptoBase.generateIv(this, key, idx).sync();
    }
    reductKey(key) {
        return CryptoBase_1.CryptoBase.reductKey(this, key).sync();
    }
    xteaEcbPkcs7Key32Encrypt(data, key32) {
        return CryptoBase_1.CryptoBase.xteaEcbPkcs7Key32Encrypt(this, data, key32).sync();
    }
    xteaEcbPkcs7Key32Decrypt(data, key32) {
        return CryptoBase_1.CryptoBase.xteaEcbPkcs7Key32Decrypt(this, data, key32).sync();
    }
    ctAes256CbcPkcs7NoIv(data, key, iv) {
        return CryptoBase_1.CryptoBase.ctAes256CbcPkcs7NoIv(this, data, key, iv).sync();
    }
    ctAes256CbcPkcs7WithIv(data, key, iv) {
        return CryptoBase_1.CryptoBase.ctAes256CbcPkcs7WithIv(this, data, key, iv).sync();
    }
    ctXteaEcbPkcs7(data, key) {
        return CryptoBase_1.CryptoBase.ctXteaEcbPkcs7(this, data, key).sync();
    }
    ctXteaEcbPkcs7Key32(data, key32) {
        return CryptoBase_1.CryptoBase.ctXteaEcbPkcs7Key32(this, data, key32).sync();
    }
    ctAes256CbcPkcs7WithIvAndHmacSha256(data, key, iv, tagLen) {
        return CryptoBase_1.CryptoBase.ctAes256CbcPkcs7WithIvAndHmacSha256(this, data, key, iv, tagLen).sync();
    }
    ctDecrypt(data, key32, iv16, tagLen, key16) {
        return CryptoBase_1.CryptoBase.ctDecrypt(this, data, key32, iv16, tagLen, key16).sync();
    }
    eccExtFromSeed(seed) {
        return CryptoBase_1.CryptoBase.eccExtFromSeed(this, seed).sync();
    }
    eccPubToBase58Address(pub, network) {
        return CryptoBase_1.CryptoBase.eccPubToBase58Address(this, pub, network).sync();
    }
    signToCompactSignature(priv, hash) {
        return CryptoBase_1.CryptoBase.signToCompactSignature(priv, hash).sync();
    }
    signToCompactSignatureWithHash(priv, message) {
        return CryptoBase_1.CryptoBase.signToCompactSignatureWithHash(this, priv, message).sync();
    }
    eccDerive(priv, pub) {
        return CryptoBase_1.CryptoBase.eccDerive(priv, pub).sync();
    }
    verifyCompactSignature(pub, hash, signature) {
        return CryptoBase_1.CryptoBase.verifyCompactSignature(pub, hash, signature).sync();
    }
    verifyCompactSignatureWithHash(pub, message, signature) {
        return CryptoBase_1.CryptoBase.verifyCompactSignatureWithHash(this, pub, message, signature).sync();
    }
    eciesEncrypt(priv, pub, data) {
        return CryptoBase_1.CryptoBase.eciesEncrypt(this, priv, pub, data).sync();
    }
    eciesDecrypt(priv, pub, data) {
        return CryptoBase_1.CryptoBase.eciesDecrypt(this, priv, pub, data).sync();
    }
    eccExtDerive(ext, options) {
        return CryptoBase_1.CryptoBase.eccExtDerive(this, ext, options).sync();
    }
    eccExtDeriveWithPath(ext, options) {
        return CryptoBase_1.CryptoBase.eccExtDeriveWithPath(this, ext, options).sync();
    }
    bip39FromEntropy(entropy, password) {
        return CryptoBase_1.CryptoBase.bip39FromEntropy(this, entropy, password).sync();
    }
    bip39FromMnemonic(mnemonic, password) {
        return CryptoBase_1.CryptoBase.bip39FromMnemonic(this, mnemonic, password).sync();
    }
    bip39GetExtKey(mnemonic, password) {
        return CryptoBase_1.CryptoBase.bip39GetExtKey(this, mnemonic, password).sync();
    }
    srpRegisterS(N, g, I, P, s) {
        return CryptoBase_1.CryptoBase.srpRegisterS(this, N, g, I, P, s).sync();
    }
    srpLoginStep1A(N, g, s, B, I, P, a) {
        return CryptoBase_1.CryptoBase.srpLoginStep1A(this, N, g, s, B, I, P, a).sync();
    }
    srpLoginStep2(clientM2, serverM2) {
        return CryptoBase_1.CryptoBase.srpLoginStep2(clientM2, serverM2).sync();
    }
}
exports.CryptoSyncAbstract = CryptoSyncAbstract;
class CryptoSyncRandomAbstract extends CryptoSyncAbstract {
    eccExtRandom() {
        return CryptoBase_1.CryptoBase.eccExtRandom(this).sync();
    }
    eccPrivRandom() {
        return CryptoBase_1.CryptoBase.eccPrivRandom(this).sync();
    }
    ctAes256CbcPkcs7WithRandomIv(data, key) {
        return CryptoBase_1.CryptoBase.ctAes256CbcPkcs7WithRandomIv(this, data, key).sync();
    }
    bip39Generate(strength, password) {
        return CryptoBase_1.CryptoBase.bip39Generate(this, strength, password).sync();
    }
    srpRegister(N, g, I, P) {
        return CryptoBase_1.CryptoBase.srpRegister(this, N, g, I, P).sync();
    }
    srpLoginStep1(N, g, s, B, I, P) {
        return CryptoBase_1.CryptoBase.srpLoginStep1(this, N, g, s, B, I, P).sync();
    }
}
exports.CryptoSyncRandomAbstract = CryptoSyncRandomAbstract;
class CryptoSync extends CryptoSyncAbstract {
    hmac(algorithm, key, data) {
        return CryptoSyncBase.hmac(algorithm, key, data);
    }
    hash(algorithm, data) {
        return CryptoSyncBase.hash(algorithm, data);
    }
    aes256CbcPkcs7Encrypt(data, key, iv) {
        return CryptoSyncBase.aes256CbcPkcs7Encrypt(data, key, iv);
    }
    aes256CbcNoPadEncrypt(data, key, iv) {
        return CryptoSyncBase.aes256CbcNoPadEncrypt(data, key, iv);
    }
    aes256CbcPkcs7Decrypt(data, key, iv) {
        return CryptoSyncBase.aes256CbcPkcs7Decrypt(data, key, iv);
    }
    aes256CbcNoPadDecrypt(data, key, iv) {
        return CryptoSyncBase.aes256CbcNoPadDecrypt(data, key, iv);
    }
    xteaEcbPkcs7Encrypt(data, key) {
        return CryptoSyncBase.xteaEcbPkcs7Encrypt(data, key);
    }
    xteaEcbPkcs7Decrypt(data, key) {
        return CryptoSyncBase.xteaEcbPkcs7Decrypt(data, key);
    }
    aes256EcbEncrypt(data, key) {
        return CryptoSyncBase.aes256EcbEncrypt(data, key);
    }
    aes256EcbDecrypt(data, key) {
        return CryptoSyncBase.aes256EcbDecrypt(data, key);
    }
    pbkdf2(password, salt, rounds, length, algorithm) {
        return CryptoSyncBase.pbkdf2(password, salt, rounds, length, algorithm);
    }
}
exports.CryptoSync = CryptoSync;
class CryptoSyncRandom extends CryptoSyncRandomAbstract {
    randomBytes(length) {
        return randomBytes(length);
    }
    hmac(algorithm, key, data) {
        return CryptoSyncBase.hmac(algorithm, key, data);
    }
    hash(algorithm, data) {
        return CryptoSyncBase.hash(algorithm, data);
    }
    aes256CbcPkcs7Encrypt(data, key, iv) {
        return CryptoSyncBase.aes256CbcPkcs7Encrypt(data, key, iv);
    }
    aes256CbcNoPadEncrypt(data, key, iv) {
        return CryptoSyncBase.aes256CbcNoPadEncrypt(data, key, iv);
    }
    aes256CbcPkcs7Decrypt(data, key, iv) {
        return CryptoSyncBase.aes256CbcPkcs7Decrypt(data, key, iv);
    }
    aes256CbcNoPadDecrypt(data, key, iv) {
        return CryptoSyncBase.aes256CbcNoPadDecrypt(data, key, iv);
    }
    xteaEcbPkcs7Encrypt(data, key) {
        return CryptoSyncBase.xteaEcbPkcs7Encrypt(data, key);
    }
    xteaEcbPkcs7Decrypt(data, key) {
        return CryptoSyncBase.xteaEcbPkcs7Decrypt(data, key);
    }
    aes256EcbEncrypt(data, key) {
        return CryptoSyncBase.aes256EcbEncrypt(data, key);
    }
    aes256EcbDecrypt(data, key) {
        return CryptoSyncBase.aes256EcbDecrypt(data, key);
    }
    pbkdf2(password, salt, rounds, length, algorithm) {
        return CryptoSyncBase.pbkdf2(password, salt, rounds, length, algorithm);
    }
}
exports.CryptoSyncRandom = CryptoSyncRandom;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../../browserbuffer/BrowserBuffer":228,"../CryptoBase":230,"buffer":498,"crypto":507,"privmx-exception":286,"randombytes":377,"xtea":429}],250:[function(require,module,exports){
"use strict";
const CryptoSync = require("./CryptoSync");
module.exports = CryptoSync;

},{"./CryptoSync":249}],251:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Helper = void 0;
class Helper {
    static getTransferable(obj) {
        if (obj instanceof ArrayBuffer) {
            return [obj];
        }
        const result = [];
        if (Array.isArray(obj)) {
            for (const entry of obj) {
                if (entry instanceof ArrayBuffer) {
                    result.push(entry);
                }
            }
        }
        else if (typeof (obj) == "object") {
            for (const name in obj) {
                if (obj[name] instanceof ArrayBuffer) {
                    result.push(obj[name]);
                }
            }
        }
        return result;
    }
}
exports.Helper = Helper;

},{}],252:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Listener = exports.ListenerClass = void 0;
const CryptoSync_1 = require("../sync/CryptoSync");
const Serializer_1 = require("./Serializer");
const Helper_1 = require("./Helper");
class ListenerClass {
    cryptoSync;
    constructor() {
        this.cryptoSync = new CryptoSync_1.CryptoSync();
        onmessage = this.onMessage.bind(this);
    }
    onMessage(event) {
        const method = event.data.method;
        Promise.resolve().then(() => {
            if (method == "setEntropy") {
                return;
            }
            const params = Serializer_1.Serializer.decode(event.data.params);
            const service = this.cryptoSync;
            return service[method].apply(service, params);
        })
            .then(result => {
            result = Serializer_1.Serializer.encode(result);
            const response = {
                id: event.data.id,
                result: result
            };
            postMessage(response, Helper_1.Helper.getTransferable(result));
        })
            .catch(e => {
            const response = {
                id: event.data.id,
                error: e.toString()
            };
            postMessage(response);
        });
    }
}
exports.ListenerClass = ListenerClass;
exports.Listener = new ListenerClass();

},{"../sync/CryptoSync":249,"./Helper":251,"./Serializer":254}],253:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Requester = void 0;
const Serializer_1 = require("./Serializer");
const Helper_1 = require("./Helper");
const CryptoSync_1 = require("../sync/CryptoSync");
const PromiseUtils_1 = require("../../utils/PromiseUtils");
class Requester {
    tasks;
    taskId;
    worker;
    isSupported;
    constructor(path) {
        this.tasks = {};
        this.taskId = 0;
        try {
            this.worker = new Worker(path);
            this.worker.onmessage = this.onMessage.bind(this);
            this.worker.onerror = () => {
                return this.isSupported = () => {
                    return false;
                };
            };
        }
        catch (error) {
            console.log("Requester error", error);
            this.isSupported = () => {
                return false;
            };
        }
    }
    onMessage(event) {
        const task = this.tasks[event.data.id];
        if (task == null) {
            throw new Error("Invalid task id");
        }
        delete this.tasks[event.data.id];
        if ("result" in event.data) {
            task.resolve(event.data.result);
        }
        else {
            task.reject(event.data.error);
        }
    }
    execute(method, params) {
        if (!(method in CryptoSync_1.CryptoSync.prototype)) {
            return false;
        }
        return Promise.resolve().then(() => {
            const deferred = PromiseUtils_1.PromiseUtils.defer();
            this.taskId++;
            this.tasks[this.taskId] = deferred;
            params = Serializer_1.Serializer.encode(params);
            const request = {
                id: this.taskId,
                method: method,
                params: params
            };
            this.worker.postMessage(request, Helper_1.Helper.getTransferable(params));
            return deferred.promise;
        })
            .then(result => {
            return Serializer_1.Serializer.decode(result);
        });
    }
}
exports.Requester = Requester;

},{"../../utils/PromiseUtils":283,"../sync/CryptoSync":249,"./Helper":251,"./Serializer":254}],254:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Serializer = void 0;
const BrowserBuffer_1 = require("../../browserbuffer/BrowserBuffer");
const Ecc = require("../../ecc");
class Serializer {
    static encode(value) {
        if (typeof (value) !== "object" || value == null) {
            return value;
        }
        if (Array.isArray(value)) {
            return value.map(v => {
                return this.encode(v);
            });
        }
        if (value instanceof Buffer || value instanceof ArrayBuffer || value instanceof Uint8Array) {
            return {
                _type: "buffer",
                _value: value instanceof ArrayBuffer ? value : BrowserBuffer_1.BrowserBuffer.bufferToArray(value)
            };
        }
        const type = Serializer.getType(value);
        if (type !== "") {
            return {
                _type: type,
                _value: BrowserBuffer_1.BrowserBuffer.bufferToArray(value.serialize())
            };
        }
        const res = {};
        for (const key in value) {
            res[key] = this.encode(value[key]);
        }
        return res;
    }
    static getType(value) {
        if (value instanceof Ecc.PublicKey) {
            return "eccPub";
        }
        else if (value instanceof Ecc.PrivateKey) {
            return "eccPriv";
        }
        else if (value instanceof Ecc.ExtKey) {
            return "eccExt";
        }
        return "";
    }
    static decode(value) {
        if (typeof (value) !== "object" || value == null) {
            return value;
        }
        if (Array.isArray(value)) {
            return value.map(v => {
                return this.decode(v);
            });
        }
        if (value._type && value._value && Object.keys(value).length === 2) {
            switch (value._type) {
                case "buffer":
                    return BrowserBuffer_1.BrowserBuffer.arrayToBuffer(value._value);
                case "eccPub":
                    return Ecc.PublicKey.deserialize(BrowserBuffer_1.BrowserBuffer.arrayToBuffer(value._value));
                case "eccPriv":
                    return Ecc.PrivateKey.deserialize(BrowserBuffer_1.BrowserBuffer.arrayToBuffer(value._value));
                case "eccExt":
                    return Ecc.ExtKey.deserialize(BrowserBuffer_1.BrowserBuffer.arrayToBuffer(value._value));
            }
            throw new Error("Invalid type " + value._type);
        }
        const res = {};
        for (const key in value) {
            res[key] = this.decode(value[key]);
        }
        return res;
    }
}
exports.Serializer = Serializer;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../../browserbuffer/BrowserBuffer":228,"../../ecc":262,"buffer":498}],255:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Requester = exports.Helper = exports.Serializer = void 0;
const Serializer_1 = require("./Serializer");
Object.defineProperty(exports, "Serializer", { enumerable: true, get: function () { return Serializer_1.Serializer; } });
const Helper_1 = require("./Helper");
Object.defineProperty(exports, "Helper", { enumerable: true, get: function () { return Helper_1.Helper; } });
const Requester_1 = require("./Requester");
Object.defineProperty(exports, "Requester", { enumerable: true, get: function () { return Requester_1.Requester; } });

},{"./Helper":251,"./Requester":253,"./Serializer":254}],256:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECIES = void 0;
const PublicKey_1 = require("./PublicKey");
const R_1 = require("../crypto/R");
class ECIES {
    privateKey;
    publicKey;
    opts;
    pubKeyBuf;
    sharedSecret;
    encryptionKey;
    signatureKey;
    constructor(privateKey, publicKey, opts) {
        this.privateKey = privateKey;
        this.publicKey = publicKey;
        this.opts = opts || {};
    }
    getPubKeyBuf() {
        if (this.pubKeyBuf == null) {
            this.pubKeyBuf = this.privateKey.getPublicKey().toDER();
        }
        return this.pubKeyBuf;
    }
    getSharedSecret(crypto) {
        if (this.sharedSecret == null) {
            this.sharedSecret = (0, R_1.R)(() => {
                const derived = this.privateKey.derive(this.publicKey);
                return crypto.sha512(derived.serialize());
            });
        }
        return this.sharedSecret;
    }
    getEncryptionKey(crypto) {
        if (this.encryptionKey == null) {
            this.encryptionKey = this.getSharedSecret(crypto).then(x => x.slice(0, 32));
        }
        return this.encryptionKey;
    }
    getSignatureKey(crypto) {
        if (this.signatureKey == null) {
            this.signatureKey = this.getSharedSecret(crypto).then(x => x.slice(32, 64));
        }
        return this.signatureKey;
    }
    encrypt(crypto, message, iv) {
        let ivBuf, c;
        return (0, R_1.R)(() => {
            if (iv === undefined) {
                return (0, R_1.R)(() => {
                    return crypto.hmacSha256(this.privateKey.getPrivateEncKey(), message);
                }).then(x => x.slice(0, 16));
            }
            return iv;
        })
            .then(iv => {
            ivBuf = iv;
            return this.getEncryptionKey(crypto);
        })
            .then(ke => {
            return crypto.aes256CbcPkcs7Encrypt(message, ke, ivBuf);
        })
            .then(enc => {
            c = Buffer.concat([ivBuf, enc]);
            return this.getSignatureKey(crypto);
        })
            .then(km => {
            return crypto.hmacSha256(km, c);
        })
            .then(d => {
            if (this.opts.shortTag) {
                d = d.slice(0, 4);
            }
            return this.opts.noKey ? Buffer.concat([c, d]) : Buffer.concat([this.getPubKeyBuf(), c, d]);
        });
    }
    decrypt(crypto, cipher) {
        let c, d;
        return (0, R_1.R)(() => {
            let offset = 0;
            let tagLength = 32;
            if (this.opts.shortTag) {
                tagLength = 4;
            }
            if (!this.opts.noKey) {
                offset = 33;
                this.publicKey = PublicKey_1.PublicKey.fromDER(cipher.slice(0, 33));
            }
            c = cipher.slice(offset, cipher.length - tagLength);
            d = cipher.slice(cipher.length - tagLength, cipher.length);
            return this.getSignatureKey(crypto);
        })
            .then(km => {
            return crypto.hmacSha256(km, c);
        })
            .then(d2 => {
            if (this.opts.shortTag) {
                d2 = d2.slice(0, 4);
            }
            let equal = true;
            for (let i = 0; i < d.length; i++) {
                equal = equal && (d[i] === d2[i]);
            }
            if (!equal) {
                throw new Error("Invalid checksum");
            }
            return this.getEncryptionKey(crypto);
        })
            .then(ke => {
            return crypto.aes256CbcPkcs7Decrypt(c.slice(16), ke, c.slice(0, 16));
        });
    }
}
exports.ECIES = ECIES;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../crypto/R":235,"./PublicKey":260,"buffer":498}],257:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtKey = void 0;
const HDNode_1 = require("./HDNode");
const BN = require("bn.js");
const PublicKey_1 = require("./PublicKey");
const PrivateKey_1 = require("./PrivateKey");
const R_1 = require("../crypto/R");
const Utils_1 = require("../utils/Utils");
class ExtKey {
    key;
    constructor(key) {
        this.key = key;
    }
    static fromBase58(base58) {
        return new ExtKey(HDNode_1.HDNode.fromBase58(base58));
    }
    static fromSeed(crypto, seed) {
        return (0, R_1.R)(() => {
            return HDNode_1.HDNode.fromSeedBuffer(crypto, seed);
        })
            .then(key => {
            return new ExtKey(key);
        });
    }
    static generateRandom(random) {
        return ExtKey.generateFromBuffer(random.randomBytes(64));
    }
    static generateFromBuffer(buffer) {
        return new ExtKey(HDNode_1.HDNode.fromRawBuffer(buffer));
    }
    isPrivate() {
        return !!this.key.privKey;
    }
    getPrivatePartAsBase58() {
        return this.key.toBase58();
    }
    getPublicPartAsBase58() {
        return this.key.neutered().toBase58();
    }
    getPublicKey() {
        return new PublicKey_1.PublicKey(this.key.key);
    }
    getPrivateKey() {
        return new PrivateKey_1.PrivateKey(this.key.key);
    }
    getChainCode() {
        return this.key.chainCode;
    }
    derive(crypto, options) {
        return (0, R_1.R)(() => {
            return this.key.derive(crypto, options);
        })
            .then(key => {
            return new ExtKey(key);
        });
    }
    deriveWithPath(crypto, options) {
        return (0, R_1.R)(() => {
            return this.key.deriveWithPath(crypto, options);
        })
            .then(key => {
            return new ExtKey(key);
        });
    }
    static deserialize(buf) {
        return new ExtKey(new HDNode_1.HDNode(new BN(buf.slice(0, 32).toString("hex"), 16), buf.slice(32)));
    }
    serialize() {
        const r = (0, Utils_1.fillWithZeroesTo32)(Buffer.from(this.key.key.getPrivate("hex"), "hex"));
        return Buffer.concat([r, Buffer.from(this.key.chainCode.toString("hex"), "hex")]);
    }
}
exports.ExtKey = ExtKey;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../crypto/R":235,"../utils/Utils":284,"./HDNode":258,"./PrivateKey":259,"./PublicKey":260,"bn.js":25,"buffer":498}],258:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HDNode = void 0;
const networks_1 = require("./networks");
const typeForce = require("typeforce");
const assert = require("assert");
const BN = require("bn.js");
const base58check = require("bs58check");
const secp256k1_1 = require("./secp256k1");
const PublicKey_1 = require("./PublicKey");
const PrivateKey_1 = require("./PrivateKey");
const R_1 = require("../crypto/R");
const Utils_1 = require("../utils/Utils");
class HDNode {
    static MASTER_SECRET = Buffer.from("Bitcoin seed");
    static HIGHEST_BIT = 0x80000000;
    static LENGTH = 78;
    chainCode;
    depth;
    index;
    parentFingerprint;
    network;
    key;
    privKey;
    pubKey;
    constructor(K, chainCode, network) {
        network = network || networks_1.networks.bitcoin;
        typeForce("Buffer", chainCode);
        assert.strictEqual(chainCode.length, 32, "Expected chainCode length of 32, got " + chainCode.length);
        assert(network.bip32, "Unknown BIP32 constants for network");
        this.chainCode = chainCode;
        this.depth = 0;
        this.index = 0;
        this.parentFingerprint = 0x00000000;
        this.network = network;
        if (K instanceof BN) {
            this.key = secp256k1_1.secp256k1.keyFromPrivateBN(K);
            this.privKey = this.key.getPrivate();
            this.pubKey = this.key.getPublic();
        }
        else if (K instanceof PrivateKey_1.PrivateKey) {
            this.key = K.key;
            this.privKey = this.key.getPrivate();
            this.pubKey = this.key.getPublic();
        }
        else if (K instanceof PublicKey_1.PublicKey) {
            this.key = K.key;
            this.pubKey = this.key.getPublic();
        }
        else {
            throw new Error("not_implemented");
        }
    }
    static findBIP32NetworkByVersion(version) {
        for (const name in networks_1.networksMap) {
            const network = networks_1.networksMap[name];
            if (version === network.bip32.private || version === network.bip32.public) {
                return network;
            }
        }
        assert(false, "Could not find network for " + version.toString(16));
    }
    static fromSeedBuffer(crypto, seed) {
        return (0, R_1.R)(() => {
            typeForce("Buffer", seed);
            assert(seed.length >= 16, "Seed should be at least 128 bits");
            assert(seed.length <= 64, "Seed should be at most 512 bits");
            return crypto.hmacSha512(HDNode.MASTER_SECRET, seed);
        })
            .then(I => {
            return HDNode.fromRawBuffer(I);
        });
    }
    static fromRawBuffer(buffer, network) {
        typeForce("Buffer", buffer);
        assert(buffer.length == 64, "Buffer has to be 512 bits");
        const key = buffer.slice(0, 32);
        const chainCode = buffer.slice(32);
        const bn = PrivateKey_1.PrivateKey.getSafeBn(key);
        return new HDNode(bn, chainCode, network);
    }
    static fromBase58(string, network) {
        return HDNode.fromBuffer(base58check.decode(string), network);
    }
    static fromBuffer(buffer, network) {
        assert.strictEqual(buffer.length, HDNode.LENGTH, "Invalid buffer length");
        const version = buffer.readUInt32BE(0);
        if (network) {
            assert(version === network.bip32.private || version === network.bip32.public, "Network doesn't match");
        }
        else {
            network = HDNode.findBIP32NetworkByVersion(version);
        }
        const depth = buffer.readUInt8(4);
        const parentFingerprint = buffer.readUInt32BE(5);
        if (depth === 0) {
            assert.strictEqual(parentFingerprint, 0x00000000, "Invalid parent fingerprint");
        }
        const index = buffer.readUInt32BE(9);
        assert(depth > 0 || index === 0, "Invalid index");
        const chainCode = buffer.slice(13, 45);
        let hd;
        if (version === network.bip32.private) {
            assert.strictEqual(buffer.readUInt8(45), 0x00, "Invalid private key");
            const data = buffer.slice(46, 78);
            const d = new BN(data.toString("hex"), 16);
            if (d.isZero() || d.eq(secp256k1_1.secp256k1.ec.curve.n)) {
                throw new Error("Invalid private key");
            }
            hd = new HDNode(d, chainCode, network);
        }
        else {
            const data = buffer.slice(45, 78);
            const key = secp256k1_1.secp256k1.keyFromPoint(data);
            const pk = new PublicKey_1.PublicKey(key);
            hd = new HDNode(pk, chainCode, network);
        }
        hd.depth = depth;
        hd.index = index;
        hd.parentFingerprint = parentFingerprint;
        return hd;
    }
    neutered() {
        const neutered = new HDNode(new PublicKey_1.PublicKey(this.key), this.chainCode, this.network);
        neutered.depth = this.depth;
        neutered.index = this.index;
        neutered.parentFingerprint = this.parentFingerprint;
        return neutered;
    }
    toBase58(isPrivate) {
        return base58check.encode(this.toBuffer(isPrivate));
    }
    toBuffer(isPrivate) {
        if (isPrivate === undefined) {
            isPrivate = !!this.privKey;
        }
        else {
            console.warn("isPrivate flag is deprecated, please use the .neutered() method instead");
        }
        const version = isPrivate ? this.network.bip32.private : this.network.bip32.public;
        const buffer = Buffer.alloc(HDNode.LENGTH);
        buffer.writeUInt32BE(version, 0);
        buffer.writeUInt8(this.depth, 4);
        buffer.writeUInt32BE(this.parentFingerprint, 5);
        buffer.writeUInt32BE(this.index, 9);
        this.chainCode.copy(buffer, 13);
        if (isPrivate) {
            assert(this.privKey, "Missing private key");
            buffer.writeUInt8(0, 45);
            const r = (0, Utils_1.fillWithZeroesTo32)(Buffer.from(this.key.getPrivate("hex"), "hex"));
            r.copy(buffer, 46);
        }
        else {
            Buffer.from(this.key.getPublic().encodeCompressed()).copy(buffer, 45);
        }
        return buffer;
    }
    getIdentifier(crypto) {
        return (0, R_1.R)(() => crypto.hash160(Buffer.from(this.key.getPublic().encodeCompressed())));
    }
    getFingerprint(crypto) {
        return this.getIdentifier(crypto).then(x => x.slice(0, 4));
    }
    derive(crypto, options) {
        const index = options.hardened ? options.index + HDNode.HIGHEST_BIT : options.index;
        const serializePrivWithoutLeadingZeroes = !!options.serializePrivWithoutLeadingZeroes;
        let hd;
        return (0, R_1.R)(() => {
            const isHardened = index >= HDNode.HIGHEST_BIT;
            const indexBuffer = Buffer.alloc(4);
            indexBuffer.writeUInt32BE(index, 0);
            let data;
            if (isHardened) {
                assert(this.privKey, "Could not derive hardened child key");
                const privBuf = Buffer.from(this.key.getPrivate("hex"), "hex");
                const serializedPriv = serializePrivWithoutLeadingZeroes ? privBuf : (0, Utils_1.fillWithZeroesTo32)(privBuf);
                data = Buffer.concat([Buffer.from([0x00]), serializedPriv, indexBuffer]);
            }
            else {
                data = Buffer.concat([Buffer.from(this.key.getPublic().encodeCompressed()), indexBuffer]);
            }
            return crypto.hmacSha512(this.chainCode, data);
        })
            .then(I => {
            const IL = I.slice(0, 32);
            const IR = I.slice(32);
            const pIL = new BN(IL.toString("hex"), 16);
            if (pIL.cmp(secp256k1_1.secp256k1.ec.curve.n) >= 0) {
                return this.derive(crypto, { index: index + 1, serializePrivWithoutLeadingZeroes });
            }
            if (this.privKey) {
                const ki = pIL.add(this.privKey).mod(secp256k1_1.secp256k1.ec.curve.n);
                if (ki.isZero()) {
                    return this.derive(crypto, { index: index + 1, serializePrivWithoutLeadingZeroes });
                }
                hd = new HDNode(ki, IR, this.network);
            }
            else {
                throw new Error("derive from public key not implemented");
            }
            hd.depth = this.depth + 1;
            hd.index = index;
            return this.getFingerprint(crypto).then(fingerprint => {
                hd.parentFingerprint = fingerprint.readUInt32BE(0);
                return hd;
            });
        });
    }
    deriveWithPath(crypto, options) {
        return (0, R_1.R)(() => {
            const parts = typeof (options.path) == "string" ? HDNode.parsePath(options.path) : options.path;
            let i = 0;
            const loopStep = (current) => {
                if (i >= parts.length) {
                    return (0, R_1.RV)(current);
                }
                const part = parts[i++];
                return current.derive(crypto, {
                    index: part.index,
                    hardened: part.hardened,
                    serializePrivWithoutLeadingZeroes: options.serializePrivWithoutLeadingZeroes
                }).then(key => {
                    return loopStep(key);
                });
            };
            return loopStep(this);
        });
    }
    toString(priv) {
        return this.toBase58(priv);
    }
    static parsePath(path) {
        const parts = path.split("/");
        if (parts[0] != "m") {
            throw new Error("Invalid path " + path);
        }
        return parts.slice(1).map(x => {
            const hardened = x.endsWith("H");
            return { hardened, index: parseInt(hardened ? x.slice(0, -1) : x, 10) };
        });
    }
}
exports.HDNode = HDNode;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../crypto/R":235,"../utils/Utils":284,"./PrivateKey":259,"./PublicKey":260,"./networks":263,"./secp256k1":264,"assert":445,"bn.js":25,"bs58check":45,"buffer":498,"typeforce":425}],259:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateKey = void 0;
const secp256k1_1 = require("./secp256k1");
const PublicKey_1 = require("./PublicKey");
const networks_1 = require("./networks");
const base58check = require("bs58check");
const assert = require("assert");
const BN = require("bn.js");
const ECIES_1 = require("./ECIES");
const Utils_1 = require("../utils/Utils");
class PrivateKey {
    key;
    constructor(key) {
        this.key = key;
    }
    static getSafeBn(buffer) {
        if (buffer.length != 32) {
            throw new Error("Expected 32-bytes length buffer");
        }
        let d = new BN(buffer);
        d = d.mod(secp256k1_1.secp256k1.nSub(new BN(2)));
        if (d.isZero()) {
            d.iaddn(1);
        }
        return d;
    }
    static generateRandom(random) {
        return PrivateKey.generateFromBuffer(random.randomBytes(32));
    }
    static generateFromBuffer(buffer) {
        return new PrivateKey(secp256k1_1.secp256k1.keyFromPrivateBN(PrivateKey.getSafeBn(buffer)));
    }
    static fromWIF(wif) {
        let payload = base58check.decode(wif);
        payload = payload.slice(1);
        if (payload.length === 33) {
            assert.strictEqual(payload[32], 0x01, "Invalid compression flag");
            payload = payload.slice(0, -1);
        }
        assert.strictEqual(payload.length, 32, "Invalid WIF payload length");
        return new PrivateKey(secp256k1_1.secp256k1.keyFromPrivateBuffer(payload));
    }
    toWIF() {
        const network = networks_1.networks.bitcoin;
        const bufferLen = 34;
        const buffer = Buffer.alloc(bufferLen);
        buffer.writeUInt8(network.wif, 0);
        let b = Buffer.from(this.key.getPrivate("hex"), "hex");
        if (b.length < 32) {
            b = Buffer.concat([Buffer.alloc(32 - b.length).fill(0), b]);
        }
        b.copy(buffer, 1);
        buffer.writeUInt8(0x01, 33);
        return base58check.encode(buffer);
    }
    signToCompactSignature(message) {
        const s = this.key.sign(message);
        const compact = 27 + s.recoveryParam;
        const buffer = Buffer.alloc(65);
        buffer.writeUInt8(compact, 0);
        Buffer.from(s.r.toArray("be", 32)).copy(buffer, 1);
        Buffer.from(s.s.toArray("be", 32)).copy(buffer, 33);
        return buffer;
    }
    getPublicKey() {
        return new PublicKey_1.PublicKey(this.key);
    }
    getPrivateEncKey() {
        return this.serialize();
    }
    derive(publicKey) {
        const derived = this.key.derive(publicKey.key.getPublic());
        return new PrivateKey(secp256k1_1.secp256k1.keyFromPrivateBN(derived));
    }
    eciesEncrypt(crypto, publicKey, data) {
        return new ECIES_1.ECIES(this, publicKey, {
            noKey: true,
            shortTag: true
        }).encrypt(crypto, data);
    }
    eciesDecrypt(crypto, publicKey, data) {
        return new ECIES_1.ECIES(this, publicKey, {
            noKey: true,
            shortTag: true
        }).decrypt(crypto, data);
    }
    static deserialize(buf) {
        return new PrivateKey(secp256k1_1.secp256k1.keyFromPrivateBuffer(buf));
    }
    serialize() {
        return (0, Utils_1.fillWithZeroesTo32)(Buffer.from(this.key.getPrivate("hex"), "hex"));
    }
}
exports.PrivateKey = PrivateKey;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../utils/Utils":284,"./ECIES":256,"./PublicKey":260,"./networks":263,"./secp256k1":264,"assert":445,"bn.js":25,"bs58check":45,"buffer":498}],260:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicKey = void 0;
const secp256k1_1 = require("./secp256k1");
const base58check = require("bs58check");
const assert = require("assert");
const networks_1 = require("./networks");
const BN = require("bn.js");
const Signature = require("elliptic/lib/elliptic/ec/signature");
const R_1 = require("../crypto/R");
class PublicKey {
    key;
    constructor(key) {
        this.key = key;
    }
    static fromDER(der) {
        return PublicKey.deserialize(der);
    }
    toDER() {
        return Buffer.from(this.key.getPublic().encodeCompressed());
    }
    static fromBase58DER(base58) {
        return new PublicKey(secp256k1_1.secp256k1.keyFromPublicBuffer(base58check.decode(base58)));
    }
    toBase58DER() {
        return base58check.encode(this.toDER());
    }
    static fromHexDER(hexDer) {
        return new PublicKey(secp256k1_1.secp256k1.keyFromPublicBuffer(Buffer.from(hexDer, "hex")));
    }
    toHexDER() {
        return this.key.getPublic().encodeCompressed("hex");
    }
    toBase58Address(crypto, network) {
        network = network || networks_1.networks.bitcoin;
        if (network == networks_1.networks.bitcoin && this.key.bitcoinAddress) {
            return (0, R_1.RV)(this.key.bitcoinAddress);
        }
        return (0, R_1.R)(() => {
            return crypto.hash160(Buffer.from(this.key.getPublic().encodeCompressed()));
        })
            .then(hash => {
            const version = network.pubKeyHash;
            const payload = Buffer.alloc(21);
            payload.writeUInt8(version, 0);
            hash.copy(payload, 1);
            const address = base58check.encode(payload);
            if (network == networks_1.networks.bitcoin) {
                this.key.bitcoinAddress = address;
            }
            return address;
        });
    }
    verifyCompactSignature(message, signature) {
        assert.equal(signature.length, 65, "Invalid signature length");
        const recoveryParam = secp256k1_1.secp256k1.getRecoveryParam(signature.readUInt8(0));
        const r = new BN(signature.slice(1, 33).toString("hex"), 16);
        const s = new BN(signature.slice(33).toString("hex"), 16);
        const sig = new Signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
        return this.key.verify(message, sig);
    }
    equals(other) {
        return this.toDER().equals(other.toDER());
    }
    static deserialize(buf) {
        return new PublicKey(secp256k1_1.secp256k1.keyFromPublicBuffer(buf));
    }
    serialize() {
        return Buffer.from(this.key.getPublic().encode());
    }
    static recoverPubKey(message, signature) {
        return new PublicKey(secp256k1_1.secp256k1.recoverPubKey(message, signature));
    }
}
exports.PublicKey = PublicKey;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../crypto/R":235,"./networks":263,"./secp256k1":264,"assert":445,"bn.js":25,"bs58check":45,"buffer":498,"elliptic/lib/elliptic/ec/signature":61}],261:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EccCrypto = exports.EccCryptoBase = exports.EccCryptoNode = void 0;
const crypto = require("crypto");
const PrivateKey_1 = require("./PrivateKey");
const PublicKey_1 = require("./PublicKey");
const secp256k1_1 = require("./secp256k1");
const BN = require("bn.js");
const oid_1 = require("../openssl/oid");
const utils = require("../openssl/openssl-utils");
const openssl_handler_1 = require("../openssl/openssl-handler");
const R_1 = require("../crypto/R");
const parameters = utils.asn.ECParameters.encode({
    type: "namedCurve",
    value: oid_1.oid.idSecp256k1.split(".")
}, "der");
class EccCryptoNode {
    static ecdsaSign(priv, data) {
        if (priv instanceof PrivateKey_1.PrivateKey) {
            priv = EccCryptoBase.encodePrivate(priv, "pem");
        }
        else if (priv instanceof Buffer) {
            priv = EccCryptoBase.encodePrivate(EccCryptoBase.decodePrivate(priv), "pem");
        }
        const ctx = crypto.createSign("sha256");
        ctx.update(data);
        return ctx.sign(priv);
    }
    static ecdsaVerify(pub, signature, data) {
        if (EccCryptoBase.isCompact(signature)) {
            signature = EccCryptoBase.compact2DER(signature);
        }
        if (pub instanceof PublicKey_1.PublicKey) {
            pub = EccCryptoBase.encodePublic(pub, "pem");
        }
        const ctx = crypto.createVerify("sha256");
        ctx.update(data);
        return ctx.verify(pub, signature);
    }
}
exports.EccCryptoNode = EccCryptoNode;
class EccCryptoBase {
    static encodePrivate(priv, type) {
        const algorithm = {
            algorithm: oid_1.oid.idEcPublicKey.split("."),
            parameters: parameters
        };
        const key = utils.asn.ECPrivateKey.encode({
            version: 1,
            privateKey: priv.key.getPrivate().toArrayLike(Buffer),
            publicKey: {
                data: Buffer.from(priv.key.getPublic(false, "binary"))
            }
        }, "der");
        return utils.encodePrivateKey(algorithm, key, type);
    }
    static decodePrivate(priv) {
        const decoded = utils.decodePrivateKey(priv);
        let algorithm = "";
        if (decoded.algorithm && decoded.algorithm.algorithm) {
            algorithm = decoded.algorithm.algorithm.join(".");
        }
        if (algorithm !== oid_1.oid.idEcPublicKey) {
            throw new Error("Invalid algorithm (" + algorithm + ")");
        }
        if (!decoded.algorithm.parameters || !parameters.equals(decoded.algorithm.parameters)) {
            throw new Error("Invalid parameters");
        }
        if (!decoded.subjectPrivateKey) {
            throw new Error("Missing private key data");
        }
        const ecDecoded = utils.asn.ECPrivateKey.decode(decoded.subjectPrivateKey);
        if (!ecDecoded.privateKey || !ecDecoded.publicKey) {
            throw new Error("Incorrect private key data");
        }
        const key = secp256k1_1.secp256k1.keyFromPrivAndPublicBuffer(ecDecoded.privateKey, ecDecoded.publicKey.data);
        return new PrivateKey_1.PrivateKey(key);
    }
    static encodePublic(pub, type) {
        const algorithm = {
            algorithm: oid_1.oid.idEcPublicKey.split("."),
            parameters: parameters
        };
        const key = Buffer.from(pub.key.getPublic(false, "binary"));
        return utils.encodePublicKey(algorithm, key, type);
    }
    static decodePublic(pub) {
        const decoded = utils.decodePublicKey(pub);
        let algorithm = "";
        if (decoded.algorithm && decoded.algorithm.algorithm) {
            algorithm = decoded.algorithm.algorithm.join(".");
        }
        if (algorithm !== oid_1.oid.idEcPublicKey) {
            throw new Error("Invalid algorithm (" + algorithm + ")");
        }
        if (!decoded.algorithm.parameters || !parameters.equals(decoded.algorithm.parameters)) {
            throw new Error("Invalid parameters");
        }
        if (!decoded.subjectPublicKey || !decoded.subjectPublicKey.data) {
            throw new Error("Missing public key data");
        }
        const key = secp256k1_1.secp256k1.keyFromPublicBuffer(decoded.subjectPublicKey.data);
        return new PublicKey_1.PublicKey(key);
    }
    static eccGenerateKey(crypto, type) {
        if (typeof (type) === "undefined") {
            type = "pem";
        }
        const key = PrivateKey_1.PrivateKey.generateFromBuffer(crypto.randomBytes(32));
        if (type === "raw") {
            return key;
        }
        return EccCryptoBase.encodePrivate(key, type);
    }
    static ecdsaSign(crypto, priv, data) {
        return (0, R_1.R)(() => {
            if (!(priv instanceof PrivateKey_1.PrivateKey)) {
                priv = EccCryptoBase.decodePrivate(priv);
            }
            return crypto.signToCompactSignatureWithHash(priv, data);
        })
            .then(signature => {
            return EccCryptoBase.compact2DER(signature);
        });
    }
    static ecdsaVerify(crypto, pub, signature, data) {
        return (0, R_1.R)(() => {
            if (!(pub instanceof PublicKey_1.PublicKey)) {
                pub = EccCryptoBase.decodePublic(pub);
            }
            if (!EccCryptoBase.isCompact(signature)) {
                signature = EccCryptoBase.DER2compact(signature);
            }
            return crypto.verifyCompactSignatureWithHash(pub, data, signature);
        });
    }
    static extractPublicKey(priv) {
        return openssl_handler_1.OpenSSLHandlerBase.extractPublicKey(priv);
    }
    static eccEciesEncrypt(crypto, priv, pub, data) {
        return (0, R_1.R)(() => {
            if (!(priv instanceof PrivateKey_1.PrivateKey)) {
                priv = EccCryptoBase.decodePrivate(priv);
            }
            if (!(pub instanceof PublicKey_1.PublicKey)) {
                pub = EccCryptoBase.decodePublic(pub);
            }
            return priv.eciesEncrypt(crypto, pub, data);
        });
    }
    static eccEciesDecrypt(crypto, priv, pub, data) {
        return (0, R_1.R)(() => {
            if (!(priv instanceof PrivateKey_1.PrivateKey)) {
                priv = EccCryptoBase.decodePrivate(priv);
            }
            if (!(pub instanceof PublicKey_1.PublicKey)) {
                pub = EccCryptoBase.decodePublic(pub);
            }
            return priv.eciesDecrypt(crypto, pub, data);
        });
    }
    static isCompact(sign) {
        return sign.readUInt8(0) === 0x1B && sign.length === 65;
    }
    static compact2DER(sign) {
        if (!EccCryptoBase.isCompact(sign)) {
            throw new Error("Unknown signature format");
        }
        const data = {
            r: new BN(sign.slice(1, 33)),
            s: new BN(sign.slice(33))
        };
        return utils.asn.Signature.encode(data, "der");
    }
    static DER2compact(sign) {
        const data = utils.asn.Signature.decode(sign);
        return Buffer.concat([
            Buffer.from([0x1B]),
            Buffer.from(data.r.toArray("be", 32)),
            Buffer.from(data.s.toArray("be", 32))
        ]);
    }
}
exports.EccCryptoBase = EccCryptoBase;
class EccCrypto {
    crypto;
    isNode;
    constructor(crypto) {
        this.crypto = crypto;
        const check = new Function("try {return this===global;}catch(e){ return false;}");
        this.isNode = check();
    }
    eccEciesEncrypt(priv, pub, data) {
        return EccCryptoBase.eccEciesEncrypt(this.crypto, priv, pub, data).async();
    }
    eccEciesDecrypt(priv, pub, data) {
        return EccCryptoBase.eccEciesDecrypt(this.crypto, priv, pub, data).async();
    }
    eccGenerateKey(type) {
        return Promise.resolve(EccCryptoBase.eccGenerateKey(this.crypto, type));
    }
    ecdsaSign(priv, data) {
        if (this.isNode) {
            return Promise.resolve(EccCryptoNode.ecdsaSign(priv, data));
        }
        return EccCryptoBase.ecdsaSign(this.crypto, priv, data).async();
    }
    ecdsaVerify(pub, signature, data) {
        if (this.isNode) {
            return Promise.resolve(EccCryptoNode.ecdsaVerify(pub, signature, data));
        }
        return EccCryptoBase.ecdsaVerify(this.crypto, pub, signature, data).async();
    }
}
exports.EccCrypto = EccCrypto;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../crypto/R":235,"../openssl/oid":268,"../openssl/openssl-handler":269,"../openssl/openssl-utils":270,"./PrivateKey":259,"./PublicKey":260,"./secp256k1":264,"bn.js":25,"buffer":498,"crypto":507}],262:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.secp256k1 = exports.PrivateKey = exports.PublicKey = exports.HDNode = exports.ExtKey = exports.ECIES = exports.EccCrypto = exports.EccCryptoBase = exports.EccCryptoNode = void 0;
const ecc_crypto_1 = require("./ecc-crypto");
Object.defineProperty(exports, "EccCryptoNode", { enumerable: true, get: function () { return ecc_crypto_1.EccCryptoNode; } });
Object.defineProperty(exports, "EccCryptoBase", { enumerable: true, get: function () { return ecc_crypto_1.EccCryptoBase; } });
Object.defineProperty(exports, "EccCrypto", { enumerable: true, get: function () { return ecc_crypto_1.EccCrypto; } });
const ECIES_1 = require("./ECIES");
Object.defineProperty(exports, "ECIES", { enumerable: true, get: function () { return ECIES_1.ECIES; } });
const ExtKey_1 = require("./ExtKey");
Object.defineProperty(exports, "ExtKey", { enumerable: true, get: function () { return ExtKey_1.ExtKey; } });
const HDNode_1 = require("./HDNode");
Object.defineProperty(exports, "HDNode", { enumerable: true, get: function () { return HDNode_1.HDNode; } });
const PublicKey_1 = require("./PublicKey");
Object.defineProperty(exports, "PublicKey", { enumerable: true, get: function () { return PublicKey_1.PublicKey; } });
const PrivateKey_1 = require("./PrivateKey");
Object.defineProperty(exports, "PrivateKey", { enumerable: true, get: function () { return PrivateKey_1.PrivateKey; } });
const secp256k1_1 = require("./secp256k1");
Object.defineProperty(exports, "secp256k1", { enumerable: true, get: function () { return secp256k1_1.secp256k1; } });

},{"./ECIES":256,"./ExtKey":257,"./HDNode":258,"./PrivateKey":259,"./PublicKey":260,"./ecc-crypto":261,"./secp256k1":264}],263:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.estimateFee = exports.networksMap = exports.networks = void 0;
exports.networks = {
    bitcoin: {
        magicPrefix: '\x18Bitcoin Signed Message:\n',
        bip32: {
            public: 0x0488b21e,
            private: 0x0488ade4
        },
        pubKeyHash: 0x00,
        scriptHash: 0x05,
        wif: 0x80,
        dustThreshold: 546,
        feePerKb: 10000,
        estimateFee: estimateFee('bitcoin')
    },
    testnet: {
        magicPrefix: '\x18Bitcoin Signed Message:\n',
        bip32: {
            public: 0x043587cf,
            private: 0x04358394
        },
        pubKeyHash: 0x6f,
        scriptHash: 0xc4,
        wif: 0xef,
        dustThreshold: 546,
        feePerKb: 10000,
        estimateFee: estimateFee('testnet')
    },
    litecoin: {
        magicPrefix: '\x19Litecoin Signed Message:\n',
        bip32: {
            public: 0x019da462,
            private: 0x019d9cfe
        },
        pubKeyHash: 0x30,
        scriptHash: 0x05,
        wif: 0xb0,
        dustThreshold: 0,
        dustSoftThreshold: 100000,
        feePerKb: 100000,
        estimateFee: estimateFee('litecoin')
    },
    dogecoin: {
        magicPrefix: '\x19Dogecoin Signed Message:\n',
        bip32: {
            public: 0x02facafd,
            private: 0x02fac398
        },
        pubKeyHash: 0x1e,
        scriptHash: 0x16,
        wif: 0x9e,
        dustThreshold: 0,
        dustSoftThreshold: 100000000,
        feePerKb: 100000000,
        estimateFee: estimateFee('dogecoin')
    },
    viacoin: {
        magicPrefix: '\x18Viacoin Signed Message:\n',
        bip32: {
            public: 0x0488b21e,
            private: 0x0488ade4
        },
        pubKeyHash: 0x47,
        scriptHash: 0x21,
        wif: 0xc7,
        dustThreshold: 560,
        dustSoftThreshold: 100000,
        feePerKb: 100000,
        estimateFee: estimateFee('viacoin')
    },
    viacointestnet: {
        magicPrefix: '\x18Viacoin Signed Message:\n',
        bip32: {
            public: 0x043587cf,
            private: 0x04358394
        },
        pubKeyHash: 0x7f,
        scriptHash: 0xc4,
        wif: 0xff,
        dustThreshold: 560,
        dustSoftThreshold: 100000,
        feePerKb: 100000,
        estimateFee: estimateFee('viacointestnet')
    },
    gamerscoin: {
        magicPrefix: '\x19Gamerscoin Signed Message:\n',
        bip32: {
            public: 0x019da462,
            private: 0x019d9cfe
        },
        pubKeyHash: 0x26,
        scriptHash: 0x05,
        wif: 0xA6,
        dustThreshold: 0,
        dustSoftThreshold: 100000,
        feePerKb: 100000,
        estimateFee: estimateFee('gamerscoin')
    },
    jumbucks: {
        magicPrefix: '\x19Jumbucks Signed Message:\n',
        bip32: {
            public: 0x037a689a,
            private: 0x037a6460
        },
        pubKeyHash: 0x2b,
        scriptHash: 0x05,
        wif: 0xab,
        dustThreshold: 0,
        dustSoftThreshold: 10000,
        feePerKb: 10000,
        estimateFee: estimateFee('jumbucks')
    },
    zetacoin: {
        magicPrefix: '\x18Zetacoin Signed Message:\n',
        bip32: {
            public: 0x0488b21e,
            private: 0x0488ade4
        },
        pubKeyHash: 0x50,
        scriptHash: 0x09,
        wif: 0xe0,
        dustThreshold: 546,
        feePerKb: 10000,
        estimateFee: estimateFee('zetacoin')
    }
};
exports.networksMap = exports.networks;
function estimateFee(type) {
    return (tx) => {
        const network = exports.networks[type];
        const baseFee = network.feePerKb;
        const byteSize = tx.toBuffer().length;
        let fee = baseFee * Math.ceil(byteSize / 1000);
        if (network.dustSoftThreshold === undefined) {
            return fee;
        }
        tx.outs.forEach(e => {
            if (e.value < network.dustSoftThreshold) {
                fee += baseFee;
            }
        });
        return fee;
    };
}
exports.estimateFee = estimateFee;

},{}],264:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.secp256k1 = void 0;
const elliptic = require("elliptic");
const ec = elliptic.ec("secp256k1");
exports.secp256k1 = {
    ec: ec,
    nSub(bn) {
        return ec.curve.n.sub(bn);
    },
    keyFromPrivAndPublicBuffer(priv, pub) {
        return exports.secp256k1.enrichKey(ec.keyPair({ pub: pub, priv: priv }));
    },
    keyFromPublicBuffer(pub) {
        return exports.secp256k1.enrichKey(ec.keyFromPublic(pub));
    },
    keyFromPrivateBN(priv) {
        return exports.secp256k1.enrichKey(ec.keyFromPrivate(priv));
    },
    keyFromPrivateBuffer(priv) {
        return exports.secp256k1.enrichKey(ec.keyFromPrivate(priv));
    },
    keyFromPoint(data) {
        const point = ec.curve.decodePoint(data);
        return exports.secp256k1.keyFromPointObj(point);
    },
    keyFromPointObj(point) {
        return exports.secp256k1.enrichKey(ec.keyPair({ pub: point }));
    },
    recoverPubKey(message, signature) {
        if (signature.length != 65) {
            throw new Error("Invalid signature buffer");
        }
        const sig = {
            r: signature.slice(1, 33).toString("hex"),
            s: signature.slice(33).toString("hex")
        };
        const recoveryParam = exports.secp256k1.getRecoveryParam(signature[0]);
        const pubPoint = ec.recoverPubKey(message, sig, recoveryParam);
        return exports.secp256k1.keyFromPointObj(pubPoint);
    },
    getRecoveryParam(value) {
        if (value >= 27 && value <= 30) {
            return value - 27;
        }
        if (value >= 31 && value <= 34) {
            return value - 31;
        }
        if (value >= 35 && value <= 38) {
            return value - 35;
        }
        if (value >= 39 && value <= 42) {
            return value - 39;
        }
        throw new Error("Invalid recovery param value");
    },
    enrichKey(key) {
        return key;
    }
};

},{"elliptic":52}],265:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.utils = exports.srp = exports.rsa = exports.openssl = exports.ecc = exports.crypto = exports.BrowserBuffer = exports.serviceSync = exports.service = void 0;
const BrowserBuffer_1 = require("./browserbuffer/BrowserBuffer");
Object.defineProperty(exports, "BrowserBuffer", { enumerable: true, get: function () { return BrowserBuffer_1.BrowserBuffer; } });
const crypto = require("./crypto");
exports.crypto = crypto;
const ecc = require("./ecc");
exports.ecc = ecc;
const openssl = require("./openssl");
exports.openssl = openssl;
const rsa = require("./rsa");
exports.rsa = rsa;
const srp = require("./srp");
exports.srp = srp;
const utils = require("./utils");
exports.utils = utils;
var Service = crypto.Service;
var CryptoSyncRandom = crypto.sync.CryptoSyncRandom;
exports.service = new Service();
exports.serviceSync = new CryptoSyncRandom();

},{"./browserbuffer/BrowserBuffer":228,"./crypto":240,"./ecc":262,"./openssl":267,"./rsa":272,"./srp":278,"./utils":285}],266:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Signature = exports.ECParameters = exports.ECPrivateKey = exports.EncryptedPrivateKey = exports.PrivateKey = exports.AlgorithmIdentifier = exports.PublicKey = exports.RSAPublicKey = exports.RSAPrivateKey = void 0;
const asn1 = require("asn1.js");
exports.RSAPrivateKey = asn1.define("RSAPrivateKey", function () {
    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
});
exports.RSAPublicKey = asn1.define("RSAPublicKey", function () {
    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
});
exports.PublicKey = asn1.define("SubjectPublicKeyInfo", function () {
    this.seq().obj(this.key("algorithm").use(exports.AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
exports.AlgorithmIdentifier = asn1.define("AlgorithmIdentifier", function () {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional().any());
});
exports.PrivateKey = asn1.define("PrivateKeyInfo", function () {
    this.seq().obj(this.key("version").int(), this.key("algorithm").use(exports.AlgorithmIdentifier), this.key("subjectPrivateKey").octstr());
});
exports.EncryptedPrivateKey = asn1.define("EncryptedPrivateKeyInfo", function () {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
});
exports.ECPrivateKey = asn1.define("ECPrivateKey", function () {
    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use(exports.ECParameters), this.key("publicKey").optional().explicit(1).bitstr());
});
exports.ECParameters = asn1.define("ECParameters", function () {
    this.choice({
        namedCurve: this.objid()
    });
});
exports.Signature = asn1.define("signature", function () {
    this.seq().obj(this.key("r").int(), this.key("s").int());
});

},{"asn1.js":1}],267:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.utils = exports.OpenSSLHandler = exports.OpenSSLHandlerBase = exports.oid = exports.asn1 = void 0;
const asn1 = require("./asn1");
exports.asn1 = asn1;
const oid_1 = require("./oid");
Object.defineProperty(exports, "oid", { enumerable: true, get: function () { return oid_1.oid; } });
const openssl_handler_1 = require("./openssl-handler");
Object.defineProperty(exports, "OpenSSLHandlerBase", { enumerable: true, get: function () { return openssl_handler_1.OpenSSLHandlerBase; } });
Object.defineProperty(exports, "OpenSSLHandler", { enumerable: true, get: function () { return openssl_handler_1.OpenSSLHandler; } });
const utils = require("./openssl-utils");
exports.utils = utils;

},{"./asn1":266,"./oid":268,"./openssl-handler":269,"./openssl-utils":270}],268:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.oid = void 0;
exports.oid = {
    idPBES2: '1.2.840.113549.1.5.13',
    idPBKDF2: '1.2.840.113549.1.5.12',
    idSHA1: '1.3.14.3.2.26',
    idSHA256: '2.16.840.1.101.3.4.2.1',
    idSHA384: '2.16.840.1.101.3.4.2.2',
    idSHA512: '2.16.840.1.101.3.4.2.3',
    idAES256CBC: '2.16.840.1.101.3.4.1.42',
    idRSAEncryption: '1.2.840.113549.1.1.1',
    idEcPublicKey: '1.2.840.10045.2.1',
    idSecp256k1: '1.3.132.0.10'
};

},{}],269:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenSSLHandler = exports.OpenSSLHandlerBase = void 0;
const oid_1 = require("./oid");
const utils = require("./openssl-utils");
const R_1 = require("../crypto/R");
;
class OpenSSLHandlerBase {
    static encryptKey(crypto, key, passphrase) {
        let iv, salt, iters;
        return (0, R_1.R)(() => {
            if (!utils.isDER(key)) {
                const pem = utils.parsePem(key);
                if (!pem || pem.name !== "PRIVATE KEY") {
                    throw new Error("Invalid argument");
                }
                key = pem.data;
            }
            const rand = crypto.randomBytes(32);
            salt = rand.slice(0, 16);
            iv = rand.slice(16);
            iters = 4096;
            return crypto.pbkdf2(Buffer.from(passphrase, "utf8"), salt, iters, 32, "sha1");
        })
            .then(cek => {
            return crypto.aes256CbcPkcs7Encrypt(key, cek, iv);
        })
            .then(cipherText => {
            const epk = {
                algorithm: {
                    id: oid_1.oid.idPBES2.split("."),
                    decrypt: {
                        kde: {
                            id: oid_1.oid.idPBKDF2.split("."),
                            kdeparams: {
                                salt: salt,
                                iters: iters
                            }
                        },
                        cipher: {
                            algo: oid_1.oid.idAES256CBC.split("."),
                            iv: iv
                        }
                    }
                },
                subjectPrivateKey: cipherText
            };
            return utils.asn.EncryptedPrivateKey.encode(epk, "pem", { label: "ENCRYPTED PRIVATE KEY" });
        });
    }
    static decryptKey(crypto, key, passphrase) {
        let epk;
        return (0, R_1.R)(() => {
            if (!utils.isDER(key)) {
                const pem = utils.parsePem(key);
                if (!pem || pem.name !== "ENCRYPTED PRIVATE KEY") {
                    throw new Error("Invalid argument");
                }
                key = pem.data;
            }
            const epk = utils.asn.EncryptedPrivateKey.decode(key);
            const algo = epk.algorithm.id.join(".");
            if (algo !== oid_1.oid.idPBES2) {
                throw new Error("unsupported encrypted key algorithm " + algo);
            }
            const kde = epk.algorithm.decrypt.kde.id.join(".");
            if (kde !== oid_1.oid.idPBKDF2) {
                throw new Error("unsupported encrypted key derivation algorithm " + kde);
            }
            const cipher = epk.algorithm.decrypt.cipher.algo.join(".");
            if (cipher !== oid_1.oid.idAES256CBC) {
                throw new Error("unsupported encrypted key cipher " + cipher);
            }
            const kdeparams = epk.algorithm.decrypt.kde.kdeparams;
            const salt = kdeparams.salt;
            const iters = kdeparams.iters.toNumber();
            return crypto.pbkdf2(Buffer.from(passphrase, "utf8"), salt, iters, 32, "sha1");
        })
            .then(key => {
            const iv = epk.algorithm.decrypt.cipher.iv;
            return crypto.aes256CbcPkcs7Decrypt(epk.subjectPrivateKey, key, iv);
        })
            .then(key => {
            return "-----BEGIN PRIVATE KEY-----\n" + utils.chunk(key.toString("base64"), 64) + "-----END PRIVATE KEY-----";
        });
    }
    static extractPublicKey(priv) {
        const pk = utils.decodePrivateKey(priv);
        const algorithm = pk.algorithm.algorithm.join(".");
        let pub;
        switch (algorithm) {
            case oid_1.oid.idRSAEncryption:
                const rsa = utils.asn.RSAPrivateKey.decode(pk.subjectPrivateKey);
                pub = utils.asn.RSAPublicKey.encode(rsa);
                break;
            case oid_1.oid.idEcPublicKey:
                const ecc = utils.asn.ECPrivateKey.decode(pk.subjectPrivateKey);
                pub = ecc.publicKey.data;
                break;
            default:
                throw new Error("unsupported pki algorithm " + algorithm);
        }
        return utils.encodePublicKey(pk.algorithm, pub, "pem");
    }
}
exports.OpenSSLHandlerBase = OpenSSLHandlerBase;
class OpenSSLHandler {
    crypto;
    constructor(crypto) {
        this.crypto = crypto;
    }
    encryptKey(key, passphrase) {
        return OpenSSLHandlerBase.encryptKey(this.crypto, key, passphrase).async();
    }
    decryptKey(key, passphrase) {
        return OpenSSLHandlerBase.decryptKey(this.crypto, key, passphrase).async();
    }
    extractPublicKey(priv) {
        return Promise.resolve(OpenSSLHandlerBase.extractPublicKey(priv));
    }
}
exports.OpenSSLHandler = OpenSSLHandler;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../crypto/R":235,"./oid":268,"./openssl-utils":270,"buffer":498}],270:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodePublicKey = exports.encodePublicKey = exports.decodePrivateKey = exports.encodePrivateKey = exports.isDER = exports.parsePem = exports.chunk = exports.asn = void 0;
const asn = require("./asn1");
exports.asn = asn;
function chunk(str, len) {
    if (str.length == 0) {
        return "";
    }
    return str.slice(0, len) + "\n" + chunk(str.slice(len), len);
}
exports.chunk = chunk;
function parsePem(pem) {
    if (Buffer.isBuffer(pem)) {
        pem = pem.toString();
    }
    const m = pem.match(/\s*-----BEGIN ([^-]+)-----\s+((.|\s)*)\s+-----END (\1)-----/m);
    if (m == null) {
        return null;
    }
    return {
        name: m[1],
        data: Buffer.from(m[2], "base64")
    };
}
exports.parsePem = parsePem;
function isDER(key) {
    return Buffer.isBuffer(key) && key[0] === 0x30;
}
exports.isDER = isDER;
function encodePrivateKey(algorithm, priv, type) {
    if (typeof (type) === "undefined") {
        type = "pem";
    }
    const data = {
        version: 0,
        algorithm: algorithm,
        subjectPrivateKey: priv
    };
    if (type === "pem") {
        return asn.PrivateKey.encode(data, "pem", { label: "PRIVATE KEY" });
    }
    return asn.PrivateKey.encode(data, "der");
}
exports.encodePrivateKey = encodePrivateKey;
function decodePrivateKey(priv) {
    if (!isDER(priv)) {
        const pem = parsePem(priv);
        if (!pem || pem.name !== "PRIVATE KEY") {
            throw new Error("Invalid argument");
        }
        priv = pem.data;
    }
    return asn.PrivateKey.decode(priv);
}
exports.decodePrivateKey = decodePrivateKey;
function encodePublicKey(algorithm, pub, type) {
    if (typeof (type) === "undefined") {
        type = "pem";
    }
    const data = {
        algorithm: algorithm,
        subjectPublicKey: {
            data: pub
        }
    };
    if (type === "pem") {
        return asn.PublicKey.encode(data, "pem", { label: "PUBLIC KEY" });
    }
    return asn.PublicKey.encode(data, "der");
}
exports.encodePublicKey = encodePublicKey;
function decodePublicKey(pub) {
    if (!isDER(pub)) {
        const pem = parsePem(pub);
        if (!pem || pem.name !== "PUBLIC KEY")
            throw new Error("Invalid argument");
        pub = pem.data;
    }
    return asn.PublicKey.decode(pub);
}
exports.decodePublicKey = decodePublicKey;

}).call(this)}).call(this,require("buffer").Buffer)
},{"./asn1":266,"buffer":498}],271:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generate = exports.generateKey = void 0;
const BN = require("bn.js");
const prime = require("./prime");
const utils = require("../openssl/openssl-utils");
const oid_1 = require("../openssl/oid");
function generateKey(random, bits) {
    const key = generate(random, bits);
    const rsaPk = {
        version: 0,
        modulus: key.n,
        publicExponent: key.e,
        privateExponent: key.d,
        prime1: key.p,
        prime2: key.q,
        exponent1: key.dp,
        exponent2: key.dq,
        coefficient: key.qi
    };
    const algorithm = {
        algorithm: oid_1.oid.idRSAEncryption.split('.'),
        parameters: Buffer.from("0500", "hex")
    };
    const encKey = utils.asn.RSAPrivateKey.encode(rsaPk, 'der');
    return utils.encodePrivateKey(algorithm, encKey, "pem");
}
exports.generateKey = generateKey;
function generate(random, bits) {
    const bitSp = ((bits + 1) / 2) | 0;
    const bitSq = bits - bitSp;
    const e = new BN(65537);
    let p, pp, q, pq;
    while (true) {
        p = prime.generate(random, bitSp);
        pp = p.subn(1);
        if (pp.gcd(e).eqn(1)) {
            break;
        }
    }
    while (true) {
        q = prime.generate(random, bitSq);
        if (p.eq(q)) {
            continue;
        }
        pq = q.subn(1);
        if (pq.gcd(e).eqn(1)) {
            break;
        }
    }
    if (p.cmp(q) < 0) {
        const tmp = p;
        p = q;
        q = tmp;
        const tmp2 = pp;
        pp = pq;
        pq = tmp2;
    }
    const n = p.mul(q);
    const fi = pp.mul(pq);
    const d = e.invm(fi);
    const dp = d.mod(pp);
    const dq = d.mod(pq);
    const qi = q.invm(p);
    return {
        n: n,
        e: e,
        d: d,
        p: p,
        q: q,
        dp: dp,
        dq: dq,
        qi: qi
    };
}
exports.generate = generate;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../openssl/oid":268,"../openssl/openssl-utils":270,"./prime":273,"bn.js":25,"buffer":498}],272:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RsaSubtle = exports.RsaCrypto = exports.RsaCryptoBase = exports.RsaBrowser = exports.RsaBrowserBase = exports.prime = exports.GenRSA = void 0;
const GenRSA = require("./GenRSA");
exports.GenRSA = GenRSA;
const prime = require("./prime");
exports.prime = prime;
const rsa_browser_1 = require("./rsa-browser");
Object.defineProperty(exports, "RsaBrowserBase", { enumerable: true, get: function () { return rsa_browser_1.RsaBrowserBase; } });
Object.defineProperty(exports, "RsaBrowser", { enumerable: true, get: function () { return rsa_browser_1.RsaBrowser; } });
const rsa_crypto_1 = require("./rsa-crypto");
Object.defineProperty(exports, "RsaCryptoBase", { enumerable: true, get: function () { return rsa_crypto_1.RsaCryptoBase; } });
Object.defineProperty(exports, "RsaCrypto", { enumerable: true, get: function () { return rsa_crypto_1.RsaCrypto; } });
const rsa_subtle_1 = require("./rsa-subtle");
Object.defineProperty(exports, "RsaSubtle", { enumerable: true, get: function () { return rsa_subtle_1.RsaSubtle; } });

},{"./GenRSA":271,"./prime":273,"./rsa-browser":274,"./rsa-crypto":275,"./rsa-subtle":276}],273:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generate = exports.isPrime = exports.miller = void 0;
const BN = require("bn.js");
const ONE = new BN(1);
const TWO = new BN(2);
const smallPrimes = [
    2, 3, 5, 7, 11, 13, 17, 19,
    23, 29, 31, 37, 41, 43, 47, 53,
    59, 61, 67, 71, 73, 79, 83, 89,
    97, 101, 103, 107, 109, 113, 127, 131,
    137, 139, 149, 151, 157, 163, 167, 173,
    179, 181, 191, 193, 197, 199, 211, 223,
    227, 229, 233, 239, 241, 251, 257, 263,
    269, 271, 277, 281, 283, 293, 307, 311,
    313, 317, 331, 337, 347, 349, 353, 359,
    367, 373, 379, 383, 389, 397, 401, 409,
    419, 421, 431, 433, 439, 443, 449, 457,
    461, 463, 467, 479, 487, 491, 499, 503,
    509, 521, 523, 541, 547, 557, 563, 569,
    571, 577, 587, 593, 599, 601, 607, 613,
    617, 619, 631, 641, 643, 647, 653, 659,
    661, 673, 677, 683, 691, 701, 709, 719,
    727, 733, 739, 743, 751, 757, 761, 769,
    773, 787, 797, 809, 811, 821, 823, 827,
    829, 839, 853, 857, 859, 863, 877, 881,
    883, 887, 907, 911, 919, 929, 937, 941,
    947, 953, 967, 971, 977, 983, 991, 997,
    1009, 1013, 1019, 1021, 1031, 1033, 1039, 1049,
    1051, 1061, 1063, 1069, 1087, 1091, 1093, 1097,
    1103, 1109, 1117, 1123, 1129, 1151, 1153, 1163,
    1171, 1181, 1187, 1193, 1201, 1213, 1217, 1223,
    1229, 1231, 1237, 1249, 1259, 1277, 1279, 1283,
    1289, 1291, 1297, 1301, 1303, 1307, 1319, 1321,
    1327, 1361, 1367, 1373, 1381, 1399, 1409, 1423,
    1427, 1429, 1433, 1439, 1447, 1451, 1453, 1459,
    1471, 1481, 1483, 1487, 1489, 1493, 1499, 1511,
    1523, 1531, 1543, 1549, 1553, 1559, 1567, 1571,
    1579, 1583, 1597, 1601, 1607, 1609, 1613, 1619,
    1621, 1627, 1637, 1657, 1663, 1667, 1669, 1693,
    1697, 1699, 1709, 1721, 1723, 1733, 1741, 1747,
    1753, 1759, 1777, 1783, 1787, 1789, 1801, 1811,
    1823, 1831, 1847, 1861, 1867, 1871, 1873, 1877,
    1879, 1889, 1901, 1907, 1913, 1931, 1933, 1949,
    1951, 1973, 1979, 1987, 1993, 1997, 1999, 2003,
    2011, 2017, 2027, 2029, 2039, 2053, 2063, 2069,
    2081, 2083, 2087, 2089, 2099, 2111, 2113, 2129,
    2131, 2137, 2141, 2143, 2153, 2161, 2179, 2203,
    2207, 2213, 2221, 2237, 2239, 2243, 2251, 2267,
    2269, 2273, 2281, 2287, 2293, 2297, 2309, 2311,
    2333, 2339, 2341, 2347, 2351, 2357, 2371, 2377,
    2381, 2383, 2389, 2393, 2399, 2411, 2417, 2423,
    2437, 2441, 2447, 2459, 2467, 2473, 2477, 2503,
    2521, 2531, 2539, 2543, 2549, 2551, 2557, 2579,
    2591, 2593, 2609, 2617, 2621, 2633, 2647, 2657,
    2659, 2663, 2671, 2677, 2683, 2687, 2689, 2693,
    2699, 2707, 2711, 2713, 2719, 2729, 2731, 2741,
    2749, 2753, 2767, 2777, 2789, 2791, 2797, 2801,
    2803, 2819, 2833, 2837, 2843, 2851, 2857, 2861,
    2879, 2887, 2897, 2903, 2909, 2917, 2927, 2939,
    2953, 2957, 2963, 2969, 2971, 2999, 3001, 3011,
    3019, 3023, 3037, 3041, 3049, 3061, 3067, 3079,
    3083, 3089, 3109, 3119, 3121, 3137, 3163, 3167,
    3169, 3181, 3187, 3191, 3203, 3209, 3217, 3221,
    3229, 3251, 3253, 3257, 3259, 3271, 3299, 3301,
    3307, 3313, 3319, 3323, 3329, 3331, 3343, 3347,
    3359, 3361, 3371, 3373, 3389, 3391, 3407, 3413,
    3433, 3449, 3457, 3461, 3463, 3467, 3469, 3491,
    3499, 3511, 3517, 3527, 3529, 3533, 3539, 3541,
    3547, 3557, 3559, 3571, 3581, 3583, 3593, 3607,
    3613, 3617, 3623, 3631, 3637, 3643, 3659, 3671,
    3673, 3677, 3691, 3697, 3701, 3709, 3719, 3727,
    3733, 3739, 3761, 3767, 3769, 3779, 3793, 3797,
    3803, 3821, 3823, 3833, 3847, 3851, 3853, 3863,
    3877, 3881, 3889, 3907, 3911, 3917, 3919, 3923,
    3929, 3931, 3943, 3947, 3967, 3989, 4001, 4003,
    4007, 4013, 4019, 4021, 4027, 4049, 4051, 4057,
    4073, 4079, 4091, 4093, 4099, 4111, 4127, 4129,
    4133, 4139, 4153, 4157, 4159, 4177, 4201, 4211,
    4217, 4219, 4229, 4231, 4241, 4243, 4253, 4259,
    4261, 4271, 4273, 4283, 4289, 4297, 4327, 4337,
    4339, 4349, 4357, 4363, 4373, 4391, 4397, 4409,
    4421, 4423, 4441, 4447, 4451, 4457, 4463, 4481,
    4483, 4493, 4507, 4513, 4517, 4519, 4523, 4547,
    4549, 4561, 4567, 4583, 4591, 4597, 4603, 4621,
    4637, 4639, 4643, 4649, 4651, 4657, 4663, 4673,
    4679, 4691, 4703, 4721, 4723, 4729, 4733, 4751,
    4759, 4783, 4787, 4789, 4793, 4799, 4801, 4813,
    4817, 4831, 4861, 4871, 4877, 4889, 4903, 4909,
    4919, 4931, 4933, 4937, 4943, 4951, 4957, 4967,
    4969, 4973, 4987, 4993, 4999, 5003, 5009, 5011,
    5021, 5023, 5039, 5051, 5059, 5077, 5081, 5087,
    5099, 5101, 5107, 5113, 5119, 5147, 5153, 5167,
    5171, 5179, 5189, 5197, 5209, 5227, 5231, 5233,
    5237, 5261, 5273, 5279, 5281, 5297, 5303, 5309,
    5323, 5333, 5347, 5351, 5381, 5387, 5393, 5399,
    5407, 5413, 5417, 5419, 5431, 5437, 5441, 5443,
    5449, 5471, 5477, 5479, 5483, 5501, 5503, 5507,
    5519, 5521, 5527, 5531, 5557, 5563, 5569, 5573,
    5581, 5591, 5623, 5639, 5641, 5647, 5651, 5653,
    5657, 5659, 5669, 5683, 5689, 5693, 5701, 5711,
    5717, 5737, 5741, 5743, 5749, 5779, 5783, 5791,
    5801, 5807, 5813, 5821, 5827, 5839, 5843, 5849,
    5851, 5857, 5861, 5867, 5869, 5879, 5881, 5897,
    5903, 5923, 5927, 5939, 5953, 5981, 5987, 6007,
    6011, 6029, 6037, 6043, 6047, 6053, 6067, 6073,
    6079, 6089, 6091, 6101, 6113, 6121, 6131, 6133,
    6143, 6151, 6163, 6173, 6197, 6199, 6203, 6211,
    6217, 6221, 6229, 6247, 6257, 6263, 6269, 6271,
    6277, 6287, 6299, 6301, 6311, 6317, 6323, 6329,
    6337, 6343, 6353, 6359, 6361, 6367, 6373, 6379,
    6389, 6397, 6421, 6427, 6449, 6451, 6469, 6473,
    6481, 6491, 6521, 6529, 6547, 6551, 6553, 6563,
    6569, 6571, 6577, 6581, 6599, 6607, 6619, 6637,
    6653, 6659, 6661, 6673, 6679, 6689, 6691, 6701,
    6703, 6709, 6719, 6733, 6737, 6761, 6763, 6779,
    6781, 6791, 6793, 6803, 6823, 6827, 6829, 6833,
    6841, 6857, 6863, 6869, 6871, 6883, 6899, 6907,
    6911, 6917, 6947, 6949, 6959, 6961, 6967, 6971,
    6977, 6983, 6991, 6997, 7001, 7013, 7019, 7027,
    7039, 7043, 7057, 7069, 7079, 7103, 7109, 7121,
    7127, 7129, 7151, 7159, 7177, 7187, 7193, 7207,
    7211, 7213, 7219, 7229, 7237, 7243, 7247, 7253,
    7283, 7297, 7307, 7309, 7321, 7331, 7333, 7349,
    7351, 7369, 7393, 7411, 7417, 7433, 7451, 7457,
    7459, 7477, 7481, 7487, 7489, 7499, 7507, 7517,
    7523, 7529, 7537, 7541, 7547, 7549, 7559, 7561,
    7573, 7577, 7583, 7589, 7591, 7603, 7607, 7621,
    7639, 7643, 7649, 7669, 7673, 7681, 7687, 7691,
    7699, 7703, 7717, 7723, 7727, 7741, 7753, 7757,
    7759, 7789, 7793, 7817, 7823, 7829, 7841, 7853,
    7867, 7873, 7877, 7879, 7883, 7901, 7907, 7919,
    7927, 7933, 7937, 7949, 7951, 7963, 7993, 8009,
    8011, 8017, 8039, 8053, 8059, 8069, 8081, 8087,
    8089, 8093, 8101, 8111, 8117, 8123, 8147, 8161,
    8167, 8171, 8179, 8191, 8209, 8219, 8221, 8231,
    8233, 8237, 8243, 8263, 8269, 8273, 8287, 8291,
    8293, 8297, 8311, 8317, 8329, 8353, 8363, 8369,
    8377, 8387, 8389, 8419, 8423, 8429, 8431, 8443,
    8447, 8461, 8467, 8501, 8513, 8521, 8527, 8537,
    8539, 8543, 8563, 8573, 8581, 8597, 8599, 8609,
    8623, 8627, 8629, 8641, 8647, 8663, 8669, 8677,
    8681, 8689, 8693, 8699, 8707, 8713, 8719, 8731,
    8737, 8741, 8747, 8753, 8761, 8779, 8783, 8803,
    8807, 8819, 8821, 8831, 8837, 8839, 8849, 8861,
    8863, 8867, 8887, 8893, 8923, 8929, 8933, 8941,
    8951, 8963, 8969, 8971, 8999, 9001, 9007, 9011,
    9013, 9029, 9041, 9043, 9049, 9059, 9067, 9091,
    9103, 9109, 9127, 9133, 9137, 9151, 9157, 9161,
    9173, 9181, 9187, 9199, 9203, 9209, 9221, 9227,
    9239, 9241, 9257, 9277, 9281, 9283, 9293, 9311,
    9319, 9323, 9337, 9341, 9343, 9349, 9371, 9377,
    9391, 9397, 9403, 9413, 9419, 9421, 9431, 9433,
    9437, 9439, 9461, 9463, 9467, 9473, 9479, 9491,
    9497, 9511, 9521, 9533, 9539, 9547, 9551, 9587,
    9601, 9613, 9619, 9623, 9629, 9631, 9643, 9649,
    9661, 9677, 9679, 9689, 9697, 9719, 9721, 9733,
    9739, 9743, 9749, 9767, 9769, 9781, 9787, 9791,
    9803, 9811, 9817, 9829, 9833, 9839, 9851, 9857,
    9859, 9871, 9883, 9887, 9901, 9907, 9923, 9929,
    9931, 9941, 9949, 9967, 9973, 10007, 10009, 10037,
    10039, 10061, 10067, 10069, 10079, 10091, 10093, 10099,
    10103, 10111, 10133, 10139, 10141, 10151, 10159, 10163,
    10169, 10177, 10181, 10193, 10211, 10223, 10243, 10247,
    10253, 10259, 10267, 10271, 10273, 10289, 10301, 10303,
    10313, 10321, 10331, 10333, 10337, 10343, 10357, 10369,
    10391, 10399, 10427, 10429, 10433, 10453, 10457, 10459,
    10463, 10477, 10487, 10499, 10501, 10513, 10529, 10531,
    10559, 10567, 10589, 10597, 10601, 10607, 10613, 10627,
    10631, 10639, 10651, 10657, 10663, 10667, 10687, 10691,
    10709, 10711, 10723, 10729, 10733, 10739, 10753, 10771,
    10781, 10789, 10799, 10831, 10837, 10847, 10853, 10859,
    10861, 10867, 10883, 10889, 10891, 10903, 10909, 10937,
    10939, 10949, 10957, 10973, 10979, 10987, 10993, 11003,
    11027, 11047, 11057, 11059, 11069, 11071, 11083, 11087,
    11093, 11113, 11117, 11119, 11131, 11149, 11159, 11161,
    11171, 11173, 11177, 11197, 11213, 11239, 11243, 11251,
    11257, 11261, 11273, 11279, 11287, 11299, 11311, 11317,
    11321, 11329, 11351, 11353, 11369, 11383, 11393, 11399,
    11411, 11423, 11437, 11443, 11447, 11467, 11471, 11483,
    11489, 11491, 11497, 11503, 11519, 11527, 11549, 11551,
    11579, 11587, 11593, 11597, 11617, 11621, 11633, 11657,
    11677, 11681, 11689, 11699, 11701, 11717, 11719, 11731,
    11743, 11777, 11779, 11783, 11789, 11801, 11807, 11813,
    11821, 11827, 11831, 11833, 11839, 11863, 11867, 11887,
    11897, 11903, 11909, 11923, 11927, 11933, 11939, 11941,
    11953, 11959, 11969, 11971, 11981, 11987, 12007, 12011,
    12037, 12041, 12043, 12049, 12071, 12073, 12097, 12101,
    12107, 12109, 12113, 12119, 12143, 12149, 12157, 12161,
    12163, 12197, 12203, 12211, 12227, 12239, 12241, 12251,
    12253, 12263, 12269, 12277, 12281, 12289, 12301, 12323,
    12329, 12343, 12347, 12373, 12377, 12379, 12391, 12401,
    12409, 12413, 12421, 12433, 12437, 12451, 12457, 12473,
    12479, 12487, 12491, 12497, 12503, 12511, 12517, 12527,
    12539, 12541, 12547, 12553, 12569, 12577, 12583, 12589,
    12601, 12611, 12613, 12619, 12637, 12641, 12647, 12653,
    12659, 12671, 12689, 12697, 12703, 12713, 12721, 12739,
    12743, 12757, 12763, 12781, 12791, 12799, 12809, 12821,
    12823, 12829, 12841, 12853, 12889, 12893, 12899, 12907,
    12911, 12917, 12919, 12923, 12941, 12953, 12959, 12967,
    12973, 12979, 12983, 13001, 13003, 13007, 13009, 13033,
    13037, 13043, 13049, 13063, 13093, 13099, 13103, 13109,
    13121, 13127, 13147, 13151, 13159, 13163, 13171, 13177,
    13183, 13187, 13217, 13219, 13229, 13241, 13249, 13259,
    13267, 13291, 13297, 13309, 13313, 13327, 13331, 13337,
    13339, 13367, 13381, 13397, 13399, 13411, 13417, 13421,
    13441, 13451, 13457, 13463, 13469, 13477, 13487, 13499,
    13513, 13523, 13537, 13553, 13567, 13577, 13591, 13597,
    13613, 13619, 13627, 13633, 13649, 13669, 13679, 13681,
    13687, 13691, 13693, 13697, 13709, 13711, 13721, 13723,
    13729, 13751, 13757, 13759, 13763, 13781, 13789, 13799,
    13807, 13829, 13831, 13841, 13859, 13873, 13877, 13879,
    13883, 13901, 13903, 13907, 13913, 13921, 13931, 13933,
    13963, 13967, 13997, 13999, 14009, 14011, 14029, 14033,
    14051, 14057, 14071, 14081, 14083, 14087, 14107, 14143,
    14149, 14153, 14159, 14173, 14177, 14197, 14207, 14221,
    14243, 14249, 14251, 14281, 14293, 14303, 14321, 14323,
    14327, 14341, 14347, 14369, 14387, 14389, 14401, 14407,
    14411, 14419, 14423, 14431, 14437, 14447, 14449, 14461,
    14479, 14489, 14503, 14519, 14533, 14537, 14543, 14549,
    14551, 14557, 14561, 14563, 14591, 14593, 14621, 14627,
    14629, 14633, 14639, 14653, 14657, 14669, 14683, 14699,
    14713, 14717, 14723, 14731, 14737, 14741, 14747, 14753,
    14759, 14767, 14771, 14779, 14783, 14797, 14813, 14821,
    14827, 14831, 14843, 14851, 14867, 14869, 14879, 14887,
    14891, 14897, 14923, 14929, 14939, 14947, 14951, 14957,
    14969, 14983, 15013, 15017, 15031, 15053, 15061, 15073,
    15077, 15083, 15091, 15101, 15107, 15121, 15131, 15137,
    15139, 15149, 15161, 15173, 15187, 15193, 15199, 15217,
    15227, 15233, 15241, 15259, 15263, 15269, 15271, 15277,
    15287, 15289, 15299, 15307, 15313, 15319, 15329, 15331,
    15349, 15359, 15361, 15373, 15377, 15383, 15391, 15401,
    15413, 15427, 15439, 15443, 15451, 15461, 15467, 15473,
    15493, 15497, 15511, 15527, 15541, 15551, 15559, 15569,
    15581, 15583, 15601, 15607, 15619, 15629, 15641, 15643,
    15647, 15649, 15661, 15667, 15671, 15679, 15683, 15727,
    15731, 15733, 15737, 15739, 15749, 15761, 15767, 15773,
    15787, 15791, 15797, 15803, 15809, 15817, 15823, 15859,
    15877, 15881, 15887, 15889, 15901, 15907, 15913, 15919,
    15923, 15937, 15959, 15971, 15973, 15991, 16001, 16007,
    16033, 16057, 16061, 16063, 16067, 16069, 16073, 16087,
    16091, 16097, 16103, 16111, 16127, 16139, 16141, 16183,
    16187, 16189, 16193, 16217, 16223, 16229, 16231, 16249,
    16253, 16267, 16273, 16301, 16319, 16333, 16339, 16349,
    16361, 16363, 16369, 16381, 16411, 16417, 16421, 16427,
    16433, 16447, 16451, 16453, 16477, 16481, 16487, 16493,
    16519, 16529, 16547, 16553, 16561, 16567, 16573, 16603,
    16607, 16619, 16631, 16633, 16649, 16651, 16657, 16661,
    16673, 16691, 16693, 16699, 16703, 16729, 16741, 16747,
    16759, 16763, 16787, 16811, 16823, 16829, 16831, 16843,
    16871, 16879, 16883, 16889, 16901, 16903, 16921, 16927,
    16931, 16937, 16943, 16963, 16979, 16981, 16987, 16993,
    17011, 17021, 17027, 17029, 17033, 17041, 17047, 17053,
    17077, 17093, 17099, 17107, 17117, 17123, 17137, 17159,
    17167, 17183, 17189, 17191, 17203, 17207, 17209, 17231,
    17239, 17257, 17291, 17293, 17299, 17317, 17321, 17327,
    17333, 17341, 17351, 17359, 17377, 17383, 17387, 17389,
    17393, 17401, 17417, 17419, 17431, 17443, 17449, 17467,
    17471, 17477, 17483, 17489, 17491, 17497, 17509, 17519,
    17539, 17551, 17569, 17573, 17579, 17581, 17597, 17599,
    17609, 17623, 17627, 17657, 17659, 17669, 17681, 17683,
    17707, 17713, 17729, 17737, 17747, 17749, 17761, 17783,
    17789, 17791, 17807, 17827, 17837, 17839, 17851, 17863
];
function miller(random, n, k) {
    if (n.isEven()) {
        return false;
    }
    const red = BN.red(n);
    let pn = n.subn(1);
    const oneN = ONE.toRed(red);
    const s = pn.zeroBits();
    const d = pn.shrn(s);
    pn = pn.toRed(red);
    while (k-- > 0) {
        const a = random.randomBN(n.subn(4)).addn(2).toRed(red);
        let x = a.redPow(d);
        if (x.eq(oneN) || x.eq(pn)) {
            continue;
        }
        let i = 0;
        for (; i < s - 1; ++i) {
            x = x.redSqr();
            if (x.eq(oneN)) {
                return false;
            }
            if (x.eq(pn)) {
                break;
            }
        }
        if (i == s - 1) {
            return false;
        }
    }
    return true;
}
exports.miller = miller;
function isPrime(random, n, k) {
    if (n.isEven()) {
        return n.eqn(2);
    }
    if (n.eqn(1)) {
        return false;
    }
    for (const smallPrime of smallPrimes) {
        const mr = n.modn(smallPrime);
        const bn_mr = BN.isBN(mr) ? mr : new BN(mr);
        if (bn_mr.eqn(0)) {
            return n.eqn(smallPrime);
        }
    }
    const red = BN.red(n);
    if (!TWO.toRed(red).redPow(n.subn(1)).fromRed().eqn(1)) {
        return false;
    }
    return miller(random, n, k);
}
exports.isPrime = isPrime;
function generate(random, bits) {
    const checks = (bits >= 1300) ? 2 : ((bits >= 850) ? 3 : ((bits >= 650) ? 4 : ((bits >= 550) ? 5 : ((bits >= 450) ? 6 : ((bits >= 400) ? 7 : ((bits >= 350) ? 8 : ((bits >= 300) ? 9 : ((bits >= 250) ? 12 : ((bits >= 200) ? 15 : ((bits >= 150) ? 18 : (27)))))))))));
    while (true) {
        const p = new BN(random.randomBits(bits));
        if (p.isEven() && !p.eqn(2)) {
            p.iadd(ONE);
        }
        if (isPrime(random, p, checks)) {
            return p;
        }
    }
}
exports.generate = generate;

},{"bn.js":25}],274:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RsaBrowser = exports.RsaBrowserBase = void 0;
const BN = require("bn.js");
const parseKey = require("parse-asn1");
const GenRSA = require("./GenRSA");
const R_1 = require("../crypto/R");
const oaepEmptyLabelHash = Buffer.from("da39a3ee5e6b4b0d3255bfef95601890afd80709", "hex");
const pkcs1Prefix = Buffer.from([0, 1]);
const pkcs1Suffix = Buffer.from([0]);
const sha256Prefix = Buffer.from("3031300d060960864801650304020105000420", "hex");
class RsaBrowserBase {
    static rsaOaepEncrypt(service, key, data) {
        return (0, R_1.R)(() => {
            const pKey = parseKey(key);
            if (!Buffer.isBuffer(data)) {
                data = Buffer.from(data);
            }
            return RsaBrowserBase.oaepEncrypt(service, pKey, data);
        });
    }
    static rsaOaepDecrypt(service, key, data) {
        return (0, R_1.R)(() => {
            const pKey = parseKey(key);
            if (!Buffer.isBuffer(data)) {
                data = Buffer.from(data);
            }
            return RsaBrowserBase.oaepDecrypt(service, pKey, data);
        });
    }
    static rsaSign(service, key, data) {
        return (0, R_1.R)(() => {
            const pKey = parseKey(key);
            if (!Buffer.isBuffer(data)) {
                data = Buffer.from(data);
            }
            return RsaBrowserBase.sign(service, pKey, data);
        });
    }
    static rsaVerify(service, key, signature, data) {
        return (0, R_1.R)(() => {
            const pKey = parseKey(key);
            if (!Buffer.isBuffer(data)) {
                data = Buffer.from(data);
            }
            return RsaBrowserBase.verify(service, pKey, signature, data);
        });
    }
    static encrypt(key, data) {
        const c_size = key.modulus.byteLength();
        if (data.length > c_size) {
            throw new Error("data too long");
        }
        const m = new BN(data);
        if (m.gte(key.modulus)) {
            throw new Error("data too long");
        }
        const c = new BN(m).toRed(BN.red(key.modulus)).redPow(key.publicExponent).fromRed();
        return c.toArrayLike(Buffer, "be", c_size);
    }
    static decrypt(key, enc) {
        const c_size = key.modulus.byteLength();
        if (enc.length > c_size) {
            throw new Error("data too long");
        }
        const c = new BN(enc);
        if (c.gte(key.modulus)) {
            throw new Error("data too long");
        }
        if (!key.exponent1 || !key.exponent2 || !key.coefficient) {
            const dec = c.toRed(BN.red(key.modulus)).redPow(key.privateExponent).fromRed();
            return dec.toArrayLike(Buffer, "be", c_size);
        }
        if (!key.pred) {
            key.pred = BN.red(key.prime1);
        }
        if (!key.qred) {
            key.qred = BN.red(key.prime2);
        }
        const m_1 = c.toRed(key.pred).redPow(key.exponent1);
        const m_2 = c.toRed(key.qred).redPow(key.exponent2);
        let h = m_1.sub(m_2);
        if (h.isNeg()) {
            h = h.neg();
            h = h.mul(key.coefficient).mod(key.prime1);
            h = key.prime1.sub(h);
        }
        else {
            h = h.mul(key.coefficient).mod(key.prime1);
        }
        h = m_2.add(key.prime2.mul(h));
        return h.toArrayLike(Buffer, "be", c_size);
    }
    static mgf1(service, seed, len) {
        const mask = [];
        return (0, R_1.R)(() => {
            let outLen = 0;
            let i = 0;
            const next = () => {
                if (outLen >= len) {
                    return;
                }
                const ctr = Buffer.alloc(4);
                ctr.writeInt32BE(i, 0);
                return (0, R_1.R)(() => {
                    return service.sha1(Buffer.concat([seed, ctr]));
                })
                    .then(digest => {
                    i++;
                    mask.push(digest);
                    outLen += digest.length;
                    return next();
                });
            };
            return next();
        })
            .then(() => {
            return Buffer.concat(mask);
        });
    }
    static mgf1_xor(service, seed, data) {
        return (0, R_1.R)(() => {
            const len = data.length;
            let outLen = 0;
            let i = 0;
            const next = () => {
                if (outLen >= len) {
                    return;
                }
                const ctr = Buffer.alloc(4);
                ctr.writeInt32BE(i, 0);
                return (0, R_1.R)(() => {
                    return service.sha1(Buffer.concat([seed, ctr]));
                })
                    .then(digest => {
                    i++;
                    for (let idx = 0; idx < digest.length && outLen < len; ++idx, ++outLen) {
                        data[outLen] ^= digest[idx];
                    }
                    return next();
                });
            };
            return next();
        })
            .then(() => {
            return data;
        });
    }
    static timingSafeEqual(a, b) {
        let equal = a.length == b.length;
        const length = a.length < b.length ? a.length : b.length;
        for (let i = 0; i < length; ++i) {
            equal = equal && (a[i] == b[i]);
        }
        return equal;
    }
    static oaepEncrypt(service, key, data) {
        let seed, db;
        return (0, R_1.R)(() => {
            const c_size = key.modulus.byteLength();
            const md_size = 20;
            seed = service.randomBytes(md_size);
            db = Buffer.alloc(c_size - md_size - 1, 0);
            oaepEmptyLabelHash.copy(db, 0);
            data.copy(db, c_size - md_size - 1 - data.length);
            db[c_size - md_size - 1 - data.length - 1] = 1;
            return RsaBrowserBase.mgf1_xor(service, seed, db);
        })
            .then(() => {
            return RsaBrowserBase.mgf1_xor(service, db, seed);
        })
            .then(() => {
            const packet = Buffer.concat([Buffer.alloc(1, 0), seed, db]);
            return RsaBrowserBase.encrypt(key, packet);
        });
    }
    static oaepDecrypt(service, key, data) {
        let seed, db, md_size, good;
        return (0, R_1.R)(() => {
            const mb = RsaBrowserBase.decrypt(key, data);
            good = (mb[0] == 0);
            md_size = 20;
            seed = mb.slice(1, 1 + md_size);
            db = mb.slice(1 + md_size);
            return RsaBrowserBase.mgf1_xor(service, db, seed);
        })
            .then(() => {
            return RsaBrowserBase.mgf1_xor(service, seed, db);
        })
            .then(() => {
            const labelHash = db.slice(0, md_size);
            let onePos = -1;
            for (let idx = md_size + 1; idx < db.length; ++idx) {
                if (db[idx] == 1 && onePos < 0) {
                    onePos = idx;
                }
            }
            if (onePos < 0)
                good = false;
            const expected = oaepEmptyLabelHash;
            if (!RsaBrowserBase.timingSafeEqual(labelHash, expected)) {
                good = false;
            }
            if (!good) {
                throw new Error("Invalid cipher");
            }
            db = db.slice(onePos + 1);
            return db;
        });
    }
    static sign(service, key, data) {
        return (0, R_1.R)(() => {
            return service.sha256(data);
        })
            .then(hash => {
            const c_size = key.modulus.byteLength();
            const algInfo = sha256Prefix;
            const pkcs1Infix = Buffer.alloc(c_size - algInfo.length - hash.length - 3, 0xff);
            const packet = Buffer.concat([pkcs1Prefix, pkcs1Infix, pkcs1Suffix, algInfo, hash]);
            return RsaBrowserBase.decrypt(key, packet);
        });
    }
    static verify(service, key, signature, data) {
        return (0, R_1.R)(() => {
            return service.sha256(data);
        })
            .then(hash => {
            const c_size = key.modulus.byteLength();
            const algInfo = sha256Prefix;
            const encrypted = RsaBrowserBase.encrypt(key, signature);
            if (encrypted[0] != 0 || encrypted[1] != 1) {
                return false;
            }
            const sigPos = c_size - hash.length - algInfo.length;
            for (let i = 2; i < sigPos - 1; ++i) {
                if (encrypted[i] == 0) {
                    return false;
                }
            }
            if (encrypted[sigPos - 1] != 0) {
                return false;
            }
            if (algInfo.compare(encrypted, sigPos, sigPos + algInfo.length) != 0) {
                return false;
            }
            return hash.compare(encrypted, sigPos + algInfo.length) == 0;
        });
    }
}
exports.RsaBrowserBase = RsaBrowserBase;
class RsaBrowser {
    service;
    constructor(service) {
        this.service = service;
    }
    rsaGenerateKey(bits) {
        return Promise.resolve(GenRSA.generateKey(this.service, bits));
    }
    rsaOaepEncrypt(key, data) {
        return RsaBrowserBase.rsaOaepEncrypt(this.service, key, data).async();
    }
    rsaOaepDecrypt(key, data) {
        return RsaBrowserBase.rsaOaepDecrypt(this.service, key, data).async();
    }
    rsaSign(key, data) {
        return RsaBrowserBase.rsaSign(this.service, key, data).async();
    }
    rsaVerify(key, signature, data) {
        return RsaBrowserBase.rsaVerify(this.service, key, signature, data).async();
    }
}
exports.RsaBrowser = RsaBrowser;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../crypto/R":235,"./GenRSA":271,"bn.js":25,"buffer":498,"parse-asn1":111}],275:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RsaCrypto = exports.RsaCryptoBase = void 0;
const utils = require("../openssl/openssl-utils");
const GenRSA = require("./GenRSA");
const crypto = require("crypto");
const R_1 = require("../crypto/R");
const RSA_PKCS1_OAEP_PADDING = 4;
class RsaCryptoBase {
    static rsaOaepEncrypt(key, data) {
        if (!Buffer.isBuffer(data)) {
            data = Buffer.from(data);
        }
        return crypto.publicEncrypt({
            key: key,
            padding: RSA_PKCS1_OAEP_PADDING
        }, data);
    }
    static rsaOaepDecrypt(key, data) {
        if (!Buffer.isBuffer(data)) {
            data = Buffer.from(data);
        }
        return crypto.privateDecrypt({
            key: key,
            padding: RSA_PKCS1_OAEP_PADDING
        }, data);
    }
    static rsaSign(key, data) {
        const rsa = utils.parsePem(key);
        if (!rsa || rsa.name != "PRIVATE KEY") {
            throw new Error("Invalid 'key' argument");
        }
        const sign = crypto.createSign('RSA-SHA256');
        sign.write(data);
        return sign.sign(key);
    }
    static rsaVerify(service, key, signature, data) {
        return (0, R_1.R)(() => {
            const rsa = utils.parsePem(key);
            if (rsa && rsa.name == "PRIVATE KEY") {
                return (0, R_1.R)(() => {
                    return service.extractPublicKey(key);
                })
                    .then(key => {
                    return utils.parsePem(key);
                });
            }
            return rsa;
        })
            .then(rsa => {
            if (!rsa || rsa.name != "PUBLIC KEY") {
                throw new Error("Invalid 'key' argument");
            }
            const verify = crypto.createVerify('RSA-SHA256');
            verify.write(data);
            return verify.verify(key, signature);
        });
    }
}
exports.RsaCryptoBase = RsaCryptoBase;
class RsaCrypto {
    service;
    constructor(service) {
        this.service = service;
    }
    rsaGenerateKey(bits) {
        return Promise.resolve(GenRSA.generateKey(this.service, bits));
    }
    rsaOaepEncrypt(key, data) {
        return Promise.resolve(RsaCryptoBase.rsaOaepEncrypt(key, data));
    }
    rsaOaepDecrypt(key, data) {
        return Promise.resolve(RsaCryptoBase.rsaOaepDecrypt(key, data));
    }
    rsaSign(key, data) {
        return Promise.resolve(RsaCryptoBase.rsaSign(key, data));
    }
    rsaVerify(key, signature, data) {
        return RsaCryptoBase.rsaVerify(this.service, key, signature, data).async();
    }
}
exports.RsaCrypto = RsaCrypto;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../crypto/R":235,"../openssl/openssl-utils":270,"./GenRSA":271,"buffer":498,"crypto":507}],276:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RsaSubtle = void 0;
const utils = require("../openssl/openssl-utils");
const R_1 = require("../crypto/R");
const PromiseUtils_1 = require("../utils/PromiseUtils");
const crypto = (typeof (window) === "object") && window.crypto;
function P(p) {
    return p;
}
class RsaSubtle {
    service;
    constructor(service) {
        this.service = service;
    }
    isSupported() {
        if (!crypto || !crypto.subtle || !crypto.subtle.generateKey) {
            return false;
        }
        const key = "-----BEGIN PRIVATE KEY-----\n" +
            "MIIBVQIBADANBgkqhkiG9w0BAQEFAASCAT8wggE7AgEAAkEA0CGzPfzAL1Q+FnDZ\n" +
            "KfsHb+T81YK6oN4LPLTFelcPQFmWvzteezi8xulmN9mQ+D6MztuPZr0kUyU+5ce6\n" +
            "AdQJkQIDAQABAkBIovpDL+qCmgvxGQExPYKi8m+qtC0d52BUl2I0CB4yfnBjuljI\n" +
            "npuPBRqGDubD1M/8VGnbMxASTBOjCvg7LEhhAiEA8rbgA+tWaEEoLJP/UJ8EnImy\n" +
            "5Jw8ABb++avKYQl9yo8CIQDbhjjUZS3yO218fgzJ2qnpoZs2H1XERpRXJQ1trM15\n" +
            "3wIgDE9yNUCudUM4wmoPPQuTtEzXofi6olaIQCmSbjGJC8kCIQCDiHTcrpNNJNaB\n" +
            "VXWMLPzKBA7f6v6U0EVpwcW+BWBIuQIhANGvd79Hg0cK79nGBYLc+byidnaX1Pb6\n" +
            "EwYWFXU/a9Yt\n" +
            "-----END PRIVATE KEY-----";
        const cipher = Buffer.from("Xp5uW0NY8bvNJRXS0KSVXXZzMpqdwrWmQrx3f9SArsdBKcGguI030dB8FcIZD6OuGinfRKFDX5NsudI/wHb7xA==", "base64");
        return this.rsaOaepDecrypt(key, cipher)
            .then(() => {
            return PromiseUtils_1.PromiseUtils.delay(100);
        })
            .then(x => {
            return x.toString() == "abcd";
        })
            .catch(() => {
            return false;
        });
    }
    rsaGenerateKey(bits) {
        return Promise.resolve().then(() => {
            const algorithm = {
                name: "RSA-OAEP",
                modulusLength: bits,
                publicExponent: new Uint8Array([1, 0, 1]),
                hash: { name: "SHA-256" }
            };
            return P(crypto.subtle.generateKey(algorithm, true, ["encrypt", "decrypt"])
                .then(keys => {
                return crypto.subtle.exportKey("pkcs8", keys.privateKey);
            })
                .then(ab => {
                return "-----BEGIN PRIVATE KEY-----\n" +
                    utils.chunk(Buffer.from(ab).toString("base64"), 64) +
                    "-----END PRIVATE KEY-----";
            }));
        });
    }
    rsaOaepEncrypt(key, data) {
        const algorithm = {
            name: "RSA-OAEP",
            hash: { name: "SHA-1" }
        };
        return Promise.resolve().then(() => {
            const rsa = utils.parsePem(key);
            if (rsa && rsa.name == "PRIVATE KEY") {
                return (0, R_1.R)(() => {
                    return this.service.extractPublicKey(key);
                })
                    .then(pub => {
                    return utils.parsePem(pub);
                })
                    .async();
            }
            return rsa;
        })
            .then(rsa => {
            if (!rsa || rsa.name != "PUBLIC KEY") {
                throw new Error("Invalid 'key' argument");
            }
            return P(crypto.subtle.importKey("spki", rsa.data.buffer, algorithm, false, ["encrypt"])
                .then(key => {
                return crypto.subtle.encrypt(algorithm, key, data.buffer);
            })
                .then(ab => {
                return Buffer.from(ab);
            }));
        });
    }
    rsaOaepDecrypt(key, data) {
        const algorithm = {
            name: "RSA-OAEP",
            hash: { name: "SHA-1" }
        };
        return Promise.resolve().then(() => {
            const rsa = utils.parsePem(key);
            if (!rsa || rsa.name != "PRIVATE KEY") {
                throw new Error("Invalid 'key' argument");
            }
            return P(crypto.subtle.importKey("pkcs8", rsa.data.buffer, algorithm, false, ["decrypt"])
                .then(key => {
                return crypto.subtle.decrypt(algorithm, key, data.buffer);
            })
                .then(ab => {
                return Buffer.from(ab);
            }));
        });
    }
    rsaSign(key, data) {
        const algorithm = {
            name: "RSASSA-PKCS1-v1_5",
            hash: { name: "SHA-256" }
        };
        return Promise.resolve().then(() => {
            const rsa = utils.parsePem(key);
            if (!rsa || rsa.name != "PRIVATE KEY") {
                throw new Error("Invalid 'key' argument");
            }
            return P(crypto.subtle.importKey("pkcs8", rsa.data.buffer, algorithm, false, ["sign"])
                .then(key => {
                return crypto.subtle.sign(algorithm, key, data.buffer);
            })
                .then(ab => {
                return Buffer.from(ab);
            }));
        });
    }
    rsaVerify(key, signature, data) {
        const algorithm = {
            name: "RSASSA-PKCS1-v1_5",
            hash: { name: "SHA-256" }
        };
        return Promise.resolve().then(() => {
            const rsa = utils.parsePem(key);
            if (rsa && rsa.name == "PRIVATE KEY") {
                return (0, R_1.R)(() => {
                    return this.service.extractPublicKey(key);
                })
                    .then(pub => {
                    return utils.parsePem(pub);
                })
                    .async();
            }
            return rsa;
        })
            .then(rsa => {
            if (!rsa || rsa.name != "PUBLIC KEY") {
                throw new Error("Invalid 'key' argument");
            }
            return P(crypto.subtle.importKey("spki", rsa.data.buffer, algorithm, false, ["verify"])
                .then(key => {
                return crypto.subtle.verify(algorithm, key, signature.buffer, data.buffer);
            }));
        });
    }
}
exports.RsaSubtle = RsaSubtle;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../crypto/R":235,"../openssl/openssl-utils":270,"../utils/PromiseUtils":283,"buffer":498}],277:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SrpLogicEx = exports.SrpLogic = exports.SrpLogicBase = void 0;
const BN = require("bn.js");
const R_1 = require("../crypto/R");
class SrpLogicBase {
    static get_a(random) {
        return new BN(random.randomBytes(64));
    }
    static get_b(random) {
        return new BN(random.randomBytes(64));
    }
    static get_s(random) {
        return random.randomBytes(16);
    }
    static get_k(service, N, g) {
        return service.HBN(Buffer.concat([service.PAD(N, N), service.PAD(g, N)]));
    }
    static get_v(g, N, x) {
        const red = BN.red(N);
        return g.toRed(red).redPow(x).fromRed();
    }
    static get_x(service, s, I, P) {
        return (0, R_1.R)(() => {
            return service.H(Buffer.from(I + ":" + P, "utf8"));
        })
            .then(hash => {
            return service.HBN(Buffer.concat([s, hash]));
        });
    }
    static get_A(g, N, a) {
        const red = BN.red(N);
        g = g.toRed(red);
        return g.redPow(a).fromRed();
    }
    static get_B(g, N, k, b, v) {
        const red = BN.red(N);
        k = k.toRed(red);
        v = v.toRed(red);
        g = g.toRed(red);
        return k.redMul(v).redAdd(g.redPow(b)).fromRed();
    }
    static get_u(service, A, B, N) {
        return service.HBN(Buffer.concat([service.PAD(A, N), service.PAD(B, N)]));
    }
    static getClient_S(B, k, v, a, u, x, N) {
        const red = BN.red(N);
        B = B.toRed(red);
        k = k.toRed(red);
        v = v.toRed(red);
        return B.redSub(k.redMul(v)).redPow(a.add(u.mul(x))).fromRed();
    }
    static getServer_S(A, v, u, b, N) {
        const red = BN.red(N);
        A = A.toRed(red);
        v = v.toRed(red);
        return A.redMul(v.redPow(u)).redPow(b).fromRed();
    }
    static get_M1(service, A, B, S, N) {
        return service.HBN(Buffer.concat([service.PAD(A, N), service.PAD(B, N), service.PAD(S, N)]));
    }
    static get_M2(service, A, M1, S, N) {
        return service.HBN(Buffer.concat([service.PAD(A, N), service.PAD(M1, N), service.PAD(S, N)]));
    }
    static get_K(service, S, N) {
        return service.HBN(service.PAD(S, N));
    }
    static valid_A(A, N) {
        return A.mod(N).eqn(0) === false;
    }
    static valid_B(B, N) {
        return B.mod(N).eqn(0) === false;
    }
    static register(service, N, g, I, P, s) {
        return (0, R_1.R)(() => {
            return service.get_x(s, I, P);
        })
            .then(x => {
            const v = service.get_v(g, N, x);
            return {
                s: s,
                v: v
            };
        });
    }
    static registerEx(service, N, g, I, P) {
        return service.register(N, g, I, P, service.get_s());
    }
    static server_init(service, N, g, v, b) {
        return (0, R_1.R)(() => {
            return service.get_k(N, g);
        })
            .then(k => {
            const B = service.get_B(g, N, k, b, v);
            return {
                b: b,
                B: B
            };
        });
    }
    static server_initEx(service, N, g, v) {
        return service.server_init(N, g, v, service.get_b());
    }
    static server_exchange(service, N, A, M1, v, B, b) {
        let u, S, M2;
        return (0, R_1.R)(() => {
            return service.get_u(A, B, N);
        })
            .then(_u => {
            u = _u;
            S = service.getServer_S(A, v, u, b, N);
            return service.get_M2(A, M1, S, N);
        })
            .then(_M2 => {
            M2 = _M2;
            return service.get_K(S, N);
        })
            .then(K => {
            return {
                S: S,
                u: u,
                K: K,
                M2: M2
            };
        });
    }
    static login_step1(service, N, g, s, B, I, P, a) {
        let k, A, x, v, u, S, M1, K;
        return (0, R_1.R)(() => {
            if (!service.valid_B(B, N)) {
                throw new Error("InvalidBException");
            }
            return service.get_k(N, g);
        })
            .then(_k => {
            k = _k;
            A = service.get_A(g, N, a);
            return service.get_x(s, I, P);
        })
            .then(_x => {
            x = _x;
            v = service.get_v(g, N, x);
            return service.get_u(A, B, N);
        })
            .then(_u => {
            u = _u;
            S = service.getClient_S(B, k, v, a, u, x, N);
            return service.get_M1(A, B, S, N);
        })
            .then(_M1 => {
            M1 = _M1;
            return service.get_K(S, N);
        })
            .then(_K => {
            K = _K;
            return service.get_M2(A, M1, S, N);
        })
            .then(M2 => {
            return {
                A: A,
                u: u,
                S: S,
                K: K,
                M1: M1,
                M2: M2
            };
        });
    }
    static login_step1Ex(service, N, g, s, B, I, P) {
        return service.login_step1(N, g, s, B, I, P, service.get_a());
    }
    static login_step2(clientM2, serverM2) {
        if (!clientM2.eq(serverM2)) {
            throw new Error("DifferentM2Exception - " + clientM2 + ", " + serverM2);
        }
    }
}
exports.SrpLogicBase = SrpLogicBase;
class SrpLogic {
    service;
    hash;
    constructor(service, hash) {
        this.service = service;
        this.hash = hash;
    }
    PAD(x, N) {
        return x.toArrayLike(Buffer, "be", N.byteLength());
    }
    H(x) {
        return (0, R_1.R)(() => {
            return this.service.hash(this.hash, x);
        });
    }
    HBN(x) {
        return (0, R_1.R)(() => {
            return this.H(x);
        })
            .then(hash => {
            return new BN(hash);
        });
    }
    get_k(N, g) {
        return SrpLogicBase.get_k(this, N, g);
    }
    get_v(g, N, x) {
        return SrpLogicBase.get_v(g, N, x);
    }
    get_x(s, I, P) {
        return SrpLogicBase.get_x(this, s, I, P);
    }
    get_A(g, N, a) {
        return SrpLogicBase.get_A(g, N, a);
    }
    get_B(g, N, k, b, v) {
        return SrpLogicBase.get_B(g, N, k, b, v);
    }
    get_u(A, B, N) {
        return SrpLogicBase.get_u(this, A, B, N);
    }
    getClient_S(B, k, v, a, u, x, N) {
        return SrpLogicBase.getClient_S(B, k, v, a, u, x, N);
    }
    getServer_S(A, v, u, b, N) {
        return SrpLogicBase.getServer_S(A, v, u, b, N);
    }
    get_M1(A, B, S, N) {
        return SrpLogicBase.get_M1(this, A, B, S, N);
    }
    get_M2(A, M1, S, N) {
        return SrpLogicBase.get_M2(this, A, M1, S, N);
    }
    get_K(S, N) {
        return SrpLogicBase.get_K(this, S, N);
    }
    valid_A(A, N) {
        return SrpLogicBase.valid_A(A, N);
    }
    valid_B(B, N) {
        return SrpLogicBase.valid_B(B, N);
    }
    register(N, g, I, P, s) {
        return SrpLogicBase.register(this, N, g, I, P, s);
    }
    server_init(N, g, v, b) {
        return SrpLogicBase.server_init(this, N, g, v, b);
    }
    server_exchange(N, A, M1, v, B, b) {
        return SrpLogicBase.server_exchange(this, N, A, M1, v, B, b);
    }
    login_step1(N, g, s, B, I, P, a) {
        return SrpLogicBase.login_step1(this, N, g, s, B, I, P, a);
    }
    static login_step2(clientM2, serverM2) {
        return SrpLogicBase.login_step2(clientM2, serverM2);
    }
}
exports.SrpLogic = SrpLogic;
class SrpLogicEx extends SrpLogic {
    service;
    constructor(service, hash) {
        super(service, hash);
        this.service = service;
    }
    get_a() {
        return SrpLogicBase.get_a(this.service);
    }
    get_b() {
        return SrpLogicBase.get_b(this.service);
    }
    get_s() {
        return SrpLogicBase.get_s(this.service);
    }
    registerEx(N, g, I, P) {
        return SrpLogicBase.registerEx(this, N, g, I, P);
    }
    server_initEx(N, g, v) {
        return SrpLogicBase.server_initEx(this, N, g, v);
    }
    login_step1Ex(N, g, s, B, I, P) {
        return SrpLogicBase.login_step1Ex(this, N, g, s, B, I, P);
    }
}
exports.SrpLogicEx = SrpLogicEx;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../crypto/R":235,"bn.js":25,"buffer":498}],278:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SrpLogicEx = exports.SrpLogic = exports.SrpLogicBase = void 0;
const SrpLogic_1 = require("./SrpLogic");
Object.defineProperty(exports, "SrpLogicBase", { enumerable: true, get: function () { return SrpLogic_1.SrpLogicBase; } });
Object.defineProperty(exports, "SrpLogic", { enumerable: true, get: function () { return SrpLogic_1.SrpLogic; } });
Object.defineProperty(exports, "SrpLogicEx", { enumerable: true, get: function () { return SrpLogic_1.SrpLogicEx; } });

},{"./SrpLogic":277}],279:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Event = void 0;
class Event {
    callbacks;
    constructor() {
        this.callbacks = [];
    }
    add(callback) {
        this.callbacks.push(callback);
    }
    remove(callback) {
        for (const [i, c] of this.callbacks.entries()) {
            if (c == callback) {
                this.callbacks.splice(i, 1);
                return;
            }
        }
    }
    clear() {
        this.callbacks = [];
    }
    trigger(...args) {
        if (this.callbacks.length == 0) {
            return;
        }
        setTimeout(() => {
            this.callbacks.forEach(callback => {
                callback.apply(null, args);
            });
        }, 1);
    }
}
exports.Event = Event;

},{}],280:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Interval = void 0;
class Interval {
    intervalId;
    constructor(func, intervalGenerator) {
        const loop = () => {
            func();
            this.intervalId = setTimeout(loop, intervalGenerator());
        };
        loop();
    }
    stop() {
        clearTimeout(this.intervalId);
    }
}
exports.Interval = Interval;

},{}],281:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LazyMap = void 0;
class LazyMap {
    valueGetter;
    cache;
    constructor(valueGetter) {
        this.valueGetter = valueGetter;
        this.cache = {};
    }
    get(key) {
        if (key in this) {
            return this.cache[key];
        }
        if (this.valueGetter != null) {
            const value = this.valueGetter(this, key);
            if (typeof (value) != "undefined") {
                this.cache[key] = value;
                return this.cache[key];
            }
        }
        throw new Error("Value under key '" + key + "' cannot be resolved");
    }
}
exports.LazyMap = LazyMap;

},{}],282:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectEncryptor = exports.ObjectEncryptorBase = void 0;
const BrowserBuffer_1 = require("../browserbuffer/BrowserBuffer");
const privmxException = require("privmx-exception");
var IllegalArgumentException = privmxException.IllegalArgumentException;
const R_1 = require("../crypto/R");
class ObjectEncryptorBase {
    static encrypt(crypto, encryptOptions, object, key) {
        return (0, R_1.R)(() => {
            const buff = Buffer.from(JSON.stringify(object), "utf8");
            return crypto.privmxEncrypt(encryptOptions, buff, key);
        });
    }
    static decrypt(crypto, decryptOptions, encrypted, key) {
        return (0, R_1.R)(() => {
            return crypto.privmxDecrypt(decryptOptions, encrypted, key);
        })
            .then(buff => {
            return JSON.parse(buff.toString("utf8"));
        });
    }
}
exports.ObjectEncryptorBase = ObjectEncryptorBase;
class ObjectEncryptor {
    crypto;
    key;
    encryptOptions;
    decryptOptions;
    constructor(crypto, key, encryptOptions, decryptOptions) {
        this.crypto = crypto;
        if (!BrowserBuffer_1.BrowserBuffer.isBuffer(key) || key.length != 32) {
            throw new IllegalArgumentException("key", key);
        }
        Object.defineProperty(this, "key", {
            value: key,
            enumerable: true
        });
        this.encryptOptions = encryptOptions || crypto.privmxOptAesWithSignature();
        this.decryptOptions = decryptOptions || crypto.privmxOptSignedCipher();
    }
    encrypt(object) {
        return ObjectEncryptorBase.encrypt(this.crypto, this.encryptOptions, object, this.key).async();
    }
    decrypt(encrypted) {
        return ObjectEncryptorBase.decrypt(this.crypto, this.decryptOptions, encrypted, this.key).async();
    }
}
exports.ObjectEncryptor = ObjectEncryptor;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../browserbuffer/BrowserBuffer":228,"../crypto/R":235,"buffer":498,"privmx-exception":286}],283:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromiseUtils = void 0;
class PromiseUtils {
    static defer() {
        const defer = {
            resolve: null,
            reject: null,
            promise: null
        };
        defer.promise = new Promise((resolve, reject) => {
            defer.resolve = resolve;
            defer.reject = reject;
        });
        return defer;
    }
    static delay(milliseconds) {
        return new Promise(resolve => setTimeout(resolve, milliseconds));
    }
}
exports.PromiseUtils = PromiseUtils;

},{}],284:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fillWithZeroesTo32 = exports.randomIntInRange = exports.randomInt = void 0;
function randomInt(max) {
    return randomIntInRange(0, max);
}
exports.randomInt = randomInt;
function randomIntInRange(min, max) {
    return min + Math.floor(Math.random() * (max - min));
}
exports.randomIntInRange = randomIntInRange;
function fillWithZeroesTo32(buffer) {
    return buffer.length < 32 ? Buffer.concat([Buffer.alloc(32 - buffer.length).fill(0), buffer]) : buffer;
}
exports.fillWithZeroesTo32 = fillWithZeroesTo32;

}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":498}],285:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utils = exports.ObjectEncryptor = exports.LazyMap = exports.Event = exports.Interval = void 0;
const Event_1 = require("./Event");
Object.defineProperty(exports, "Event", { enumerable: true, get: function () { return Event_1.Event; } });
const LazyMap_1 = require("./LazyMap");
Object.defineProperty(exports, "LazyMap", { enumerable: true, get: function () { return LazyMap_1.LazyMap; } });
const ObjectEncryptor_1 = require("./ObjectEncryptor");
Object.defineProperty(exports, "ObjectEncryptor", { enumerable: true, get: function () { return ObjectEncryptor_1.ObjectEncryptor; } });
const Interval_1 = require("./Interval");
Object.defineProperty(exports, "Interval", { enumerable: true, get: function () { return Interval_1.Interval; } });
const Utils = require("./Utils");
exports.Utils = Utils;

},{"./Event":279,"./Interval":280,"./LazyMap":281,"./ObjectEncryptor":282,"./Utils":284}],286:[function(require,module,exports){
module.exports = {
    Exception: require("./src/Exception"),
    IllegalArgumentException: require("./src/IllegalArgumentException"),
    UnsupportedOperationException: require("./src/UnsupportedOperationException")
}

},{"./src/Exception":287,"./src/IllegalArgumentException":288,"./src/UnsupportedOperationException":289}],287:[function(require,module,exports){
function Exception(msg, data, couse) {
    this.init(new Error(msg), data, couse);
}

Exception.prototype.init = function(error, data, couse) {
    var func = arguments.callee.caller.toString();
    this.name = func.substring(8, func.indexOf("(")).trim();
    this.error = error;
    this.message = this.error.message;
    this.data = data;
    this.couse = couse;
    
    var stack = this.error && this.error.stack ? this.error.stack.toString().split("\n") : "";
    var newStack = [];
    var index = -1;
    for (var i = 0; i < stack.length; i++) {
        var s = stack[i];
        if (s.trim() == "") {
            continue;
        }
        if (s.indexOf("   ") != 0) {
            s = "    " + s;
        }
        if (index == -1 && s.indexOf(this.name) != -1) {
            newStack = [];
        }
        else {
            newStack.push(s);
        }
    }
    this.stack = newStack.join("\n");
}

Exception.prototype.toString = function() {
    var res = this.name + (this.data ? " (with additional data)" : "") + ": " + this.message + "\n" + this.stack;
    if (this.couse) {
        res += "\nCoused by: " + this.couse;
    }
    return res;
}

Exception.prototype.printData = function(printer) {
    if (this.data) {
        printer(this.name + " additional data", this.data);
    }
    if (this.couse && this.couse instanceof Exception) {
        this.couse.printData(printer);
    }
}

Exception.printer = console.log.bind(console);

Exception.print = function(e, printer) {
    printer = printer || Exception.printer;
    if (e instanceof Exception) {
        printer(e.toString());
        e.printData(printer);
    }
    else if (e instanceof Error) {
        if (e.stack) {
            var msg = e.toString().trim();
            var stack = e.stack.toString().split("\n");
            var newStack = [];
            for (var i = 0; i < stack.length; i++) {
                var s = stack[i];
                if (s.trim() == "" || s.trim() == msg) {
                    continue;
                }
                if (s.indexOf("   ") != 0) {
                    s = "    " + s;
                }
                newStack.push(s);
            }
            printer(msg + "\n" + newStack.join("\n"));
        }
        else {
            printer(e.toString());
        }
    }
    else {
        printer(e);
    }
}

module.exports = Exception;

},{}],288:[function(require,module,exports){
var Exception = require("./Exception");

function IllegalArgumentException(paramName, paramValue) {
    this.init(new Error(paramName), paramValue);
}

IllegalArgumentException.prototype = Object.create(Exception.prototype);
IllegalArgumentException.prototype.constructor = IllegalArgumentException;

module.exports = IllegalArgumentException;
},{"./Exception":287}],289:[function(require,module,exports){
var Exception = require("./Exception");

function UnsupportedOperationException() {
    this.init(new Error(""));
}

UnsupportedOperationException.prototype = Object.create(Exception.prototype);
UnsupportedOperationException.prototype.constructor = UnsupportedOperationException;

module.exports = UnsupportedOperationException;
},{"./Exception":287}],290:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ErrorCodes_1 = require("./ErrorCodes");
class BitString {
    value;
    _length;
    constructor(obj, len = -1) {
        if (obj instanceof BitString) {
            this.value = obj.value;
        }
        else if (obj instanceof Buffer) {
            this.value = obj;
        }
        else {
            this.value = Buffer.from(obj, "binary");
        }
        this._length = len == -1 ? 8 * this.value.length : len;
        if (this.length > (8 * this.value.length)) {
            throw {
                msg: "Incorrect length",
                value: { length: this.length, max: (8 * this.value.length) },
                code: ErrorCodes_1.ErrorCodes.INVALID_DATA
            };
        }
    }
    get length() {
        return this._length;
    }
    bytes() {
        const bytes = 1 + ((this.length - 1) >> 3);
        const result = Buffer.alloc(bytes);
        this.value.copy(result, 0, 0, bytes);
        if (this.length & 7) {
            result[bytes - 1] &= (255 ^ (255 >> (this.length & 7)));
        }
        return result;
    }
    encode() {
        const sByte = (8 - (this.length & 7)) & 7;
        return Buffer.concat([this.bytes(), Buffer.from([sByte])]);
    }
    prefix(len) {
        if (this.length == len) {
            return this;
        }
        if (this.length < len) {
            throw {
                msg: "Too short for prefix",
                value: { value: len, max: this.length },
                code: ErrorCodes_1.ErrorCodes.INVALID_DATA
            };
        }
        return new BitString(this, len);
    }
    bit(pos) {
        if (pos >= this.length) {
            throw {
                msg: "Value is too short",
                value: { position: pos, max: this.length - 1 },
                code: ErrorCodes_1.ErrorCodes.INVALID_DATA
            };
        }
        const offset = pos >> 3;
        const bitmask = 1 << (7 - (pos & 7));
        return ((this.value[offset] & bitmask) != 0);
    }
    equals(other) {
        if (this === other) {
            return true;
        }
        if (other.length != this.length) {
            return false;
        }
        for (let i = 0; i < this.length; ++i) {
            if (this.bit(i) != other.bit(i)) {
                return false;
            }
        }
        return true;
    }
    isPrefixOf(other) {
        if (this === other) {
            return true;
        }
        if (other.length < this.length) {
            return false;
        }
        for (let i = 0; i < this.length; ++i) {
            if (this.bit(i) != other.bit(i)) {
                return false;
            }
        }
        return true;
    }
    static decode(buffer) {
        const pos = buffer.length - 1;
        if (pos <= 0) {
            return new BitString("", 0);
        }
        const sByte = buffer[pos];
        const len = 8 * pos - sByte;
        return new BitString(buffer, len);
    }
}
exports.default = BitString;

}).call(this)}).call(this,require("buffer").Buffer)
},{"./ErrorCodes":294,"buffer":498}],291:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageCache = exports.MemoryCache = void 0;
const pson_1 = require("pson");
const LoggerModule = require("simplito-logger");
class MemoryCache {
    map = {};
    load(key) {
        return Promise.resolve(this.map[key]);
    }
    save(key, data) {
        this.map[key] = data;
        return Promise.resolve(true);
    }
}
exports.MemoryCache = MemoryCache;
class StorageCache {
    encoder = null;
    keyCache = {};
    keyMangler = (k) => Promise.resolve(k);
    storage = null;
    logger = LoggerModule.get("dbchain.Cache");
    constructor() {
        try {
            if (typeof (localStorage) !== "undefined") {
                this.setStorage(localStorage);
            }
        }
        catch (e) {
        }
    }
    setStorage(storage) {
        this.storage = storage;
    }
    setKeyMangler(mangler) {
        this.keyMangler = mangler;
    }
    async key(key) {
        if (this.keyCache[key]) {
            return this.keyCache[key];
        }
        const keyMangled = await this.keyMangler(key);
        if (keyMangled !== key) {
            this.keyCache[key] = keyMangled;
        }
        return keyMangled;
    }
    getEncoder() {
        if (this.encoder === null) {
            this.encoder = new pson_1.StaticPair();
        }
        return this.encoder;
    }
    async save(name, value) {
        try {
            this.logger.debug("save", name);
            const key = await this.key(name);
            const pson = this.getEncoder().encode(value);
            this.logger.debug("save encode", name, pson);
            await this.storage.setItem(key, pson.toBinary());
            return true;
        }
        catch (e) {
            return false;
        }
    }
    async load(name) {
        try {
            this.logger.debug("load", name);
            const key = await this.key(name);
            const value = await this.storage.getItem(key);
            this.logger.debug("load", name, value);
            if (value === null) {
                return null;
            }
            return this.getEncoder().decode(Buffer.from(value, "binary"));
        }
        catch (e) {
            return null;
        }
    }
    async remove(name) {
        const key = await this.key(name);
        return this.storage.removeItem(key);
    }
    async clear() {
        if (!this.storage || typeof (this.storage.clear) !== "function") {
            return;
        }
        return this.storage.clear();
    }
}
exports.StorageCache = StorageCache;

}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":498,"pson":376,"simplito-logger":407}],292:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CosignersProvider = exports.BaseCosignersProvider = void 0;
class BaseCosignersProvider {
    async selectCosigners(count) {
        const max = count == null ? this.getDefaultSelectCount() : count;
        const cosigners = await this.getAllCosigners();
        const domains = Object.keys(cosigners);
        if (max <= 0 || domains.length <= max) {
            return cosigners;
        }
        const result = {};
        for (let i = 0; i < max; ++i) {
            const index = Math.floor(Math.random() * domains.length);
            const domain = domains[index];
            result[domain] = cosigners[domain];
            domains.splice(index, 1);
        }
        return result;
    }
}
exports.BaseCosignersProvider = BaseCosignersProvider;
class CosignersProvider extends BaseCosignersProvider {
    cosigners;
    defaultSelectCount;
    constructor(cosigners, defaultSelectCount) {
        super();
        this.cosigners = cosigners;
        this.defaultSelectCount = defaultSelectCount;
    }
    getDefaultSelectCount() {
        return this.defaultSelectCount;
    }
    getAllCosigners() {
        return Promise.resolve(this.cosigners);
    }
}
exports.CosignersProvider = CosignersProvider;

},{}],293:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$A = exports.ArrayEnumerable = exports.ArrayEnumerator = exports.FindAllEnumerable = exports.FindAllEnumerator = exports.MapEnumerable = exports.MapEnumerator = exports.BaseEnumerable = void 0;
class BaseEnumerable {
    forEach(func) {
        const enumerator = this.getEnumerator();
        while (enumerator.hasNext()) {
            func(enumerator.next());
        }
    }
    indexOf(finder) {
        let i = 0;
        const enumerator = this.getEnumerator();
        while (enumerator.hasNext()) {
            const value = enumerator.next();
            if (finder(value)) {
                return i;
            }
            i++;
        }
        return -1;
    }
    find(finder) {
        const enumerator = this.getEnumerator();
        while (enumerator.hasNext()) {
            const value = enumerator.next();
            if (finder(value)) {
                return value;
            }
        }
        return undefined;
    }
    findAll(finder) {
        return new FindAllEnumerable(this, finder);
    }
    takeFirstNotNull(finder) {
        const enumerator = this.getEnumerator();
        while (enumerator.hasNext()) {
            const value = finder(enumerator.next());
            if (value != null) {
                return value;
            }
        }
        return undefined;
    }
    map(mapper) {
        return new MapEnumerable(this, mapper);
    }
    max(comparator) {
        let hasValue = false;
        let max = undefined;
        const enumerator = this.getEnumerator();
        while (enumerator.hasNext()) {
            const value = enumerator.next();
            if (!hasValue || comparator(max, value) < 0) {
                hasValue = true;
                max = value;
            }
        }
        return max;
    }
    min(comparator) {
        return this.max((a, b) => -comparator(a, b));
    }
    contains(finder) {
        const enumerator = this.getEnumerator();
        while (enumerator.hasNext()) {
            const value = enumerator.next();
            if (finder(value)) {
                return true;
            }
        }
        return false;
    }
    containsValue(value) {
        const enumerator = this.getEnumerator();
        while (enumerator.hasNext()) {
            if (enumerator.next() === value) {
                return true;
            }
        }
        return false;
    }
    allPass(tester) {
        return !this.contains(x => !tester(x));
    }
    empty() {
        const enumerator = this.getEnumerator();
        return !enumerator.hasNext();
    }
    length() {
        let result = 0;
        const enumerator = this.getEnumerator();
        while (enumerator.hasNext()) {
            enumerator.next();
            result++;
        }
        return result;
    }
    sort(comparator) {
        const array = this.toArray();
        array.sort(comparator);
        return new ArrayEnumerable(array);
    }
    toArray() {
        const result = [];
        const enumerator = this.getEnumerator();
        while (enumerator.hasNext()) {
            result.push(enumerator.next());
        }
        return result;
    }
    first() {
        const enumerator = this.getEnumerator();
        return enumerator.hasNext() ? enumerator.next() : undefined;
    }
    last() {
        let result = undefined;
        const enumerator = this.getEnumerator();
        while (enumerator.hasNext()) {
            result = enumerator.next();
        }
        return result;
    }
    nth(index) {
        if (index < 0) {
            return undefined;
        }
        let i = 0;
        const enumerator = this.getEnumerator();
        while (enumerator.hasNext()) {
            const result = enumerator.next();
            if (i == index) {
                return result;
            }
            i++;
        }
        return undefined;
    }
    firstOrDefault(def) {
        const val = this.first();
        return val == undefined ? def : val;
    }
    lastOrDefault(def) {
        const val = this.last();
        return val == undefined ? def : val;
    }
    nthOrDefault(index, def) {
        const val = this.nth(index);
        return val == undefined ? def : val;
    }
    save() {
        return new ArrayEnumerable(this.toArray());
    }
}
exports.BaseEnumerable = BaseEnumerable;
class MapEnumerator {
    enumerator;
    mapper;
    constructor(enumerator, mapper) {
        this.enumerator = enumerator;
        this.mapper = mapper;
    }
    next() {
        return this.mapper(this.enumerator.next());
    }
    hasNext() {
        return this.enumerator.hasNext();
    }
}
exports.MapEnumerator = MapEnumerator;
class MapEnumerable extends BaseEnumerable {
    enumerable;
    mapper;
    constructor(enumerable, mapper) {
        super();
        this.enumerable = enumerable;
        this.mapper = mapper;
    }
    getEnumerator() {
        return new MapEnumerator(this.enumerable.getEnumerator(), this.mapper);
    }
    empty() {
        return this.enumerable.empty();
    }
    length() {
        return this.enumerable.length();
    }
    first() {
        const val = this.enumerable.first();
        return val === undefined ? undefined : this.mapper(val);
    }
    last() {
        const val = this.enumerable.last();
        return val === undefined ? undefined : this.mapper(val);
    }
    nth(index) {
        const val = this.enumerable.nth(index);
        return val === undefined ? undefined : this.mapper(val);
    }
}
exports.MapEnumerable = MapEnumerable;
class FindAllEnumerator {
    enumerator;
    finder;
    consumed = true;
    hasNextValue;
    current;
    constructor(enumerator, finder) {
        this.enumerator = enumerator;
        this.finder = finder;
    }
    prepareNextValue() {
        if (!this.consumed) {
            return;
        }
        this.consumed = false;
        this.hasNextValue = false;
        this.current = null;
        while (this.enumerator.hasNext()) {
            const value = this.enumerator.next();
            if (this.finder(value)) {
                this.hasNextValue = true;
                this.current = value;
                return;
            }
        }
    }
    next() {
        this.prepareNextValue();
        this.consumed = true;
        return this.current;
    }
    hasNext() {
        this.prepareNextValue();
        return this.hasNextValue;
    }
}
exports.FindAllEnumerator = FindAllEnumerator;
class FindAllEnumerable extends BaseEnumerable {
    enumerable;
    finder;
    constructor(enumerable, finder) {
        super();
        this.enumerable = enumerable;
        this.finder = finder;
    }
    getEnumerator() {
        return new FindAllEnumerator(this.enumerable.getEnumerator(), this.finder);
    }
}
exports.FindAllEnumerable = FindAllEnumerable;
class ArrayEnumerator {
    array;
    index;
    constructor(array, index) {
        this.array = array;
        this.index = index;
    }
    next() {
        return this.array[this.index++];
    }
    hasNext() {
        return this.index < this.array.length;
    }
}
exports.ArrayEnumerator = ArrayEnumerator;
class ArrayEnumerable extends BaseEnumerable {
    array;
    constructor(array) {
        super();
        this.array = array;
    }
    getEnumerator() {
        return new ArrayEnumerator(this.array, 0);
    }
    containsValue(value) {
        return this.array.indexOf(value) != -1;
    }
    empty() {
        return this.array.length == 0;
    }
    length() {
        return this.array.length;
    }
    toArray() {
        return [].concat(this.array);
    }
    first() {
        return this.array[0];
    }
    last() {
        return this.array[this.array.length - 1];
    }
    nth(index) {
        return this.array[index];
    }
}
exports.ArrayEnumerable = ArrayEnumerable;
const $A = (array) => new ArrayEnumerable(array);
exports.$A = $A;

},{}],294:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCodes = void 0;
var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes[ErrorCodes["VERIFICATION_FAILURE"] = 32769] = "VERIFICATION_FAILURE";
    ErrorCodes[ErrorCodes["PARSE_FAILURE"] = 32770] = "PARSE_FAILURE";
    ErrorCodes[ErrorCodes["RPC_FAILURE"] = 32771] = "RPC_FAILURE";
    ErrorCodes[ErrorCodes["UNSUPPORTED_FEATURE"] = 32772] = "UNSUPPORTED_FEATURE";
    ErrorCodes[ErrorCodes["INVALID_DATA"] = 32773] = "INVALID_DATA";
})(ErrorCodes = exports.ErrorCodes || (exports.ErrorCodes = {}));

},{}],295:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentDataPacket = void 0;
const Packet_1 = require("./Packet");
const ErrorCodes_1 = require("../ErrorCodes");
const Utils_1 = require("../Utils");
const Types_1 = require("../Types");
class AttachmentDataPacket {
    hash;
    data;
    static create(hash, data) {
        const result = new AttachmentDataPacket();
        result.hash = hash;
        result.data = data;
        return result;
    }
    serialize() {
        const length = 1 + this.hash.length + this.data.length;
        const bos = new Utils_1.BufferOutputStream(Buffer.alloc(length), 0);
        bos.writeOneOctetLengthBuffer(this.hash);
        bos.writeBuffer(this.data);
        return Packet_1.Packet.encode(bos.buffer, Types_1.keystore.PacketTag.ATTACHMENT_DATA);
    }
    static deserialize(data) {
        return AttachmentDataPacket.deserializeFromPacket(Packet_1.Packet.decodeSinglePacket(data));
    }
    static deserializeFromPacket(packet) {
        if (packet.tag !== Types_1.keystore.PacketTag.ATTACHMENT_DATA) {
            throw {
                msg: "Incorrect tag for AttachmentDataPacket packet",
                value: packet.tag,
                code: ErrorCodes_1.ErrorCodes.PARSE_FAILURE
            };
        }
        const result = new AttachmentDataPacket();
        const bis = new Utils_1.BufferInputStream(packet.body);
        result.hash = bis.readOneOctetLengthBuffer();
        result.data = bis.readBufferUntilEnd();
        return result;
    }
    validate() {
        return true;
    }
}
exports.AttachmentDataPacket = AttachmentDataPacket;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../ErrorCodes":294,"../Types":324,"../Utils":325,"./Packet":305,"buffer":498}],296:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentPointerPacket = void 0;
const Packet_1 = require("./Packet");
const ErrorCodes_1 = require("../ErrorCodes");
const Utils_1 = require("../Utils");
const Types_1 = require("../Types");
class AttachmentPointerPacket {
    fileName;
    date;
    algorithm;
    hash;
    static create(fileName, hash, algorithm) {
        const result = new AttachmentPointerPacket();
        result.fileName = fileName;
        result.date = Math.floor(new Date().getTime() / 1000);
        result.algorithm = algorithm;
        result.hash = hash;
        return result;
    }
    serialize() {
        const fileNameEnc = Buffer.from(this.fileName, "utf8");
        const length = 1 + fileNameEnc.length + 4 + 1 + this.hash.length;
        const bos = new Utils_1.BufferOutputStream(Buffer.alloc(length), 0);
        bos.writeOneOctetLengthBuffer(fileNameEnc);
        bos.writeUInt32BE(this.date);
        bos.writeUInt8(this.algorithm);
        bos.writeBuffer(this.hash);
        return Packet_1.Packet.encode(bos.buffer, Types_1.keystore.PacketTag.ATTACHMENT_POINTER);
    }
    static deserialize(data) {
        return AttachmentPointerPacket.deserializeFromPacket(Packet_1.Packet.decodeSinglePacket(data));
    }
    static deserializeFromPacket(packet) {
        if (packet.tag !== Types_1.keystore.PacketTag.ATTACHMENT_POINTER) {
            throw {
                msg: "Incorrect tag for AttachmentPointerPacket packet",
                value: packet.tag,
                code: ErrorCodes_1.ErrorCodes.PARSE_FAILURE
            };
        }
        const result = new AttachmentPointerPacket();
        const bis = new Utils_1.BufferInputStream(packet.body);
        result.fileName = bis.readOneOctetLengthBuffer().toString("utf8");
        result.date = bis.readUInt32BE();
        result.algorithm = bis.readUInt8();
        result.hash = bis.readBufferUntilEnd();
        return result;
    }
    validate() {
        return true;
    }
}
exports.AttachmentPointerPacket = AttachmentPointerPacket;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../ErrorCodes":294,"../Types":324,"../Utils":325,"./Packet":305,"buffer":498}],297:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentsStorage = void 0;
const Types_1 = require("../Types");
const AttachmentDataPacket_1 = require("./AttachmentDataPacket");
const AttachmentPointerPacket_1 = require("./AttachmentPointerPacket");
const Utils_1 = require("../Utils");
const Enumerable_1 = require("../Enumerable");
class AttachmentsStorage {
    static addAttachment(container, fileName, data) {
        const algorithm = Types_1.keystore.HashAlgorithm.SHA256;
        const hash = Utils_1.default.hashWithAlgorithm(data, algorithm);
        const attPointer = AttachmentPointerPacket_1.AttachmentPointerPacket.create(fileName, hash, algorithm);
        const attData = AttachmentDataPacket_1.AttachmentDataPacket.create(hash, data);
        const pointerIndex = (0, Enumerable_1.$A)(container.attachmentPointerList).indexOf(x => x.fileName == fileName);
        if (pointerIndex != -1) {
            const pointer = container.attachmentPointerList[pointerIndex];
            container.attachmentPointerList.splice(pointerIndex, 1);
            const dataIndex = (0, Enumerable_1.$A)(container.attachmentDataList).indexOf(x => x.hash.equals(pointer.hash));
            if (dataIndex != -1) {
                container.attachmentDataList.splice(dataIndex, 1);
            }
        }
        container.attachmentPointerList.push(attPointer);
        container.attachmentDataList.push(attData);
    }
    static getAttachment(container, fileName) {
        const pointer = (0, Enumerable_1.$A)(container.attachmentPointerList).find(x => x.fileName == fileName);
        if (pointer == null) {
            return null;
        }
        const data = (0, Enumerable_1.$A)(container.attachmentDataList).find(x => x.hash.equals(pointer.hash));
        return data == null ? null : data.data;
    }
    static validate(container) {
        return (0, Enumerable_1.$A)(container.attachmentPointerList).allPass(x => x.validate() && x.hash.length == Utils_1.default.hashLength(x.algorithm)) && (0, Enumerable_1.$A)(container.attachmentDataList).allPass(x => {
            const pointer = (0, Enumerable_1.$A)(container.attachmentPointerList).find(y => y.hash.equals(x.hash));
            return x.validate() && pointer != null && Utils_1.default.hashWithAlgorithm(x.data, pointer.algorithm).equals(x.hash);
        });
    }
    static isValidToSave(container) {
        return AttachmentsStorage.validate(container) && (0, Enumerable_1.$A)(container.attachmentPointerList).allPass(x => {
            return (0, Enumerable_1.$A)(container.attachmentDataList).contains(y => y.hash.equals(x.hash));
        });
    }
}
exports.AttachmentsStorage = AttachmentsStorage;

},{"../Enumerable":293,"../Types":324,"../Utils":325,"./AttachmentDataPacket":295,"./AttachmentPointerPacket":296}],298:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentsPacket = void 0;
const Subpacket_1 = require("./Subpacket");
const Packet_1 = require("./Packet");
const KeyPair_1 = require("./KeyPair");
const PkiDataTypePacket_1 = require("./PkiDataTypePacket");
const Enumerable_1 = require("../Enumerable");
const ErrorCodes_1 = require("../ErrorCodes");
const Types_1 = require("../Types");
const AttachmentDataPacket_1 = require("./AttachmentDataPacket");
const AttachmentPointerPacket_1 = require("./AttachmentPointerPacket");
const AttachmentsStorage_1 = require("./AttachmentsStorage");
class DocumentsPacket {
    primaryKey;
    keys;
    attachmentPointerList;
    attachmentDataList;
    constructor(primaryKey, keys) {
        this.primaryKey = primaryKey;
        this.keys = keys;
        this.attachmentPointerList = [];
        this.attachmentDataList = [];
    }
    addAttachment(fileName, data) {
        return AttachmentsStorage_1.AttachmentsStorage.addAttachment(this, fileName, data);
    }
    getAttachment(fileName) {
        return AttachmentsStorage_1.AttachmentsStorage.getAttachment(this, fileName);
    }
    getKeyById(id) {
        return (0, Enumerable_1.$A)(this.keys).find(x => x.getKeyId().equals(id));
    }
    removePrivate() {
        (0, Enumerable_1.$A)(this.keys).forEach(x => x.removePrivate());
    }
    getPublicView() {
        const clone = DocumentsPacket.deserialize(this.serialize());
        clone.removePrivate();
        return clone;
    }
    hasAnyPrivate() {
        return (0, Enumerable_1.$A)(this.keys).contains(x => x.hasPrivate());
    }
    generateKis(hash) {
        if (this.primaryKey == null || this.getKeyById(this.primaryKey.getKeyId()) == null) {
            throw {
                msg: "Cannot use key",
                value: this.primaryKey,
                code: ErrorCodes_1.ErrorCodes.INVALID_DATA
            };
        }
        const kstore = this.getPublicView();
        const msg = kstore.serializeWithoutAttachmentsData();
        return this.primaryKey.sign({
            data: { msg: msg },
            hashed: [new Subpacket_1.default.ConiksDbIdSubpacket(hash)]
        });
    }
    verifyKis(kis) {
        const key = this.getKeyById(kis.getIssuerId());
        if (key == null) {
            return false;
        }
        const kstore = this.getPublicView();
        const msg = kstore.serializeWithoutAttachmentsData();
        return key.verify({ msg: msg }, kis);
    }
    serialize() {
        return Buffer.concat([].concat(this.serializeWithoutAttachmentsData(), (0, Enumerable_1.$A)(this.attachmentDataList).map(x => x.serialize()).toArray()));
    }
    serializeWithoutAttachmentsData() {
        return Buffer.concat([].concat(new PkiDataTypePacket_1.PkiDataTypePacket(Types_1.keystore.PkiDataType.DOCUMENT).serialize(), (0, Enumerable_1.$A)(this.keys).map(x => x.serialize()).toArray(), (0, Enumerable_1.$A)(this.attachmentPointerList).map(x => x.serialize()).toArray()));
    }
    static deserialize(data) {
        const stream = Packet_1.Packet.decode(data);
        const documentsPacket = DocumentsPacket.deserializeFromStream(stream);
        if (stream.hasCurrent()) {
            throw new Error("Unexpected packets " + stream.current.tag);
        }
        return documentsPacket;
    }
    static deserializeFromStream(stream) {
        if (!stream.hasCurrent()) {
            throw new Error("Expected pki data type packet");
        }
        const pkiDataType = PkiDataTypePacket_1.PkiDataTypePacket.deserializeFromPacket(stream.current);
        if (pkiDataType.type != Types_1.keystore.PkiDataType.DOCUMENT) {
            throw new Error("Invalid pki data type " + pkiDataType.type);
        }
        stream.next();
        const documentsPacket = new DocumentsPacket(null, []);
        while (stream.hasCurrent()) {
            if (KeyPair_1.KeyPair.isMainKeyTag(stream.current.tag)) {
                documentsPacket.keys.push(KeyPair_1.KeyPair.deserializeFromPacket(stream.current));
                stream.next();
            }
            else if (stream.current.tag == Types_1.keystore.PacketTag.ATTACHMENT_DATA) {
                documentsPacket.attachmentDataList.push(AttachmentDataPacket_1.AttachmentDataPacket.deserializeFromPacket(stream.current));
                stream.next();
            }
            else if (stream.current.tag == Types_1.keystore.PacketTag.ATTACHMENT_POINTER) {
                documentsPacket.attachmentPointerList.push(AttachmentPointerPacket_1.AttachmentPointerPacket.deserializeFromPacket(stream.current));
                stream.next();
            }
            else {
                break;
            }
        }
        return documentsPacket;
    }
    validate() {
        return this.keys.length > 0 && AttachmentsStorage_1.AttachmentsStorage.validate(this);
    }
    isValidToSave() {
        return this.keys.length > 0 && AttachmentsStorage_1.AttachmentsStorage.isValidToSave(this);
    }
}
exports.DocumentsPacket = DocumentsPacket;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../Enumerable":293,"../ErrorCodes":294,"../Types":324,"./AttachmentDataPacket":295,"./AttachmentPointerPacket":296,"./AttachmentsStorage":297,"./KeyPair":300,"./Packet":305,"./PkiDataTypePacket":307,"./Subpacket":310,"buffer":498}],299:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EccKeyPairSerializer = exports.EccKeyPair = void 0;
const Packet_1 = require("./Packet");
const Signature_1 = require("./Signature");
const ErrorCodes_1 = require("../ErrorCodes");
const Types_1 = require("../Types");
const createHash = require("create-hash");
const elliptic = require("elliptic");
class EccKeyPair {
    keyPair;
    subkey;
    timestamp;
    kdf;
    constructor(keyPair, subkey, timestamp, kdf) {
        this.keyPair = keyPair;
        this.subkey = subkey;
        this.timestamp = timestamp;
        this.kdf = kdf;
    }
    static generateFromKey(keyPair) {
        const timestamp = Math.floor((new Date().getTime() / 1000) + 0.5);
        return new EccKeyPair(keyPair, false, timestamp, null);
    }
    static generate(ecName = "secp256k1") {
        return EccKeyPair.generateFromKey(elliptic.ec(ecName).genKeyPair());
    }
    createPrivateVersion(keyPair) {
        if (keyPair.getPrivate() == null) {
            throw new Error("Given keypair has no private key");
        }
        if (!this.isGivenKeyMatch(keyPair)) {
            throw Error("Given key does not match");
        }
        return new EccKeyPair(keyPair, this.subkey, this.timestamp, this.kdf);
    }
    getKeyId() {
        const id = this.getFingerprint();
        return id.slice(id.length - 8);
    }
    getFingerprint() {
        const sha1 = createHash("sha1");
        sha1.update(this.getFingerprintUnhashed());
        return sha1.digest();
    }
    getFingerprintUnhashed() {
        const data = EccKeyPairSerializer.encodePublic(this);
        return Buffer.concat([
            Buffer.from([
                0x99,
                (data.length >> 8) & 0xFF,
                data.length & 0xFF
            ]),
            data
        ]);
    }
    getKeyAlgorithm() {
        return this.hasKdf() ? Types_1.keystore.PublicKeyAlgorithm.ECDH : Types_1.keystore.PublicKeyAlgorithm.ECDSA;
    }
    sign(options) {
        return Signature_1.Signature.create(options, this);
    }
    signRaw(msg) {
        return this.encodeEccSignature(this.signEcc(msg));
    }
    verify(data, signature) {
        return signature.verify(data, this);
    }
    verifyRaw(msg, signature) {
        return this.verifyEcc(msg, this.decodeEccSignature(signature));
    }
    hasPrivate() {
        return this.keyPair.getPrivate() != null;
    }
    removePrivate() {
        if (!this.hasPrivate()) {
            return;
        }
        const pub = this.keyPair.getPublic();
        this.keyPair = this.keyPair.ec.keyFromPublic(pub);
    }
    getPublicView() {
        const clone = KeyPair_1.KeyPair.deserialize(this.serialize());
        clone.removePrivate();
        return clone;
    }
    isSubkey() {
        return this.subkey;
    }
    setSubkey(subkey) {
        this.subkey = subkey;
    }
    serialize() {
        return EccKeyPairSerializer.encode(this);
    }
    serializeWithArmor() {
        return EccKeyPairSerializer.encodeWithArmor(this);
    }
    getPublic() {
        return this.keyPair.getPublic();
    }
    getPublicBuffer(compact) {
        return Buffer.from(this.keyPair.getPublic(!!compact, "binary"));
    }
    getPrivate() {
        return this.keyPair.getPrivate();
    }
    getPrivateBinary() {
        return Buffer.from(this.keyPair.getPrivate().toArray());
    }
    isGivenKeyMatch(key) {
        return this.keyPair.getPublic().eq(key.getPublic());
    }
    setPrivate(key) {
        key = this.keyPair.ec.keyFromPrivate(key);
        if (!this.isGivenKeyMatch(key)) {
            throw {
                msg: "Private key doesn't match public",
                value: key,
                code: ErrorCodes_1.ErrorCodes.INVALID_DATA
            };
        }
        this.keyPair = key;
    }
    hasKdf() {
        return this.kdf != null;
    }
    verifyEcc(msg, signature) {
        return this.keyPair.verify(msg, signature);
    }
    decodeEccSignature(signature) {
        let length = Math.ceil(signature.readInt16BE(0) / 8);
        const r = signature.slice(2, length + 2);
        const tmp = signature.slice(length + 2);
        length = Math.ceil(tmp.readInt16BE(0) / 8);
        const s = tmp.slice(2, length + 2);
        return { r: r, s: s };
    }
    signEcc(msg) {
        if (!this.hasPrivate()) {
            throw new Error("Cannot sign without private part");
        }
        return this.keyPair.sign(msg);
    }
    encodeEccSignature(signature) {
        let tmp = [];
        let bitLength = signature.r.bitLength();
        tmp.push((bitLength >> 8) & 0xFF);
        tmp.push(bitLength & 0xFF);
        tmp = tmp.concat(signature.r.toArray());
        bitLength = signature.s.bitLength();
        tmp.push((bitLength >> 8) & 0xFF);
        tmp.push(bitLength & 0xFF);
        tmp = tmp.concat(signature.s.toArray());
        return Buffer.from(tmp);
    }
}
exports.EccKeyPair = EccKeyPair;
class EccKeyPairSerializer {
    static getCurveName(key) {
        for (const name in elliptic.curves) {
            if (key.ec.curve == elliptic.curves[name].curve) {
                return name;
            }
        }
        throw new Error("Unknown curve");
    }
    static oids = {
        "2B8104000A": "secp256k1",
        "2B06010401DA470F01": "ed25519",
        "2A8648CE3D030107": "p256",
        "2B81040022": "p384",
        "2B81040023": "p521"
    };
    static ec2oid(ec) {
        ec = ec.toLowerCase();
        for (const oid in EccKeyPairSerializer.oids) {
            if (ec === EccKeyPairSerializer.oids[oid]) {
                return oid;
            }
        }
        throw {
            msg: "Unknown elliptic curve name",
            value: ec,
            code: ErrorCodes_1.ErrorCodes.INVALID_DATA
        };
    }
    static oid2ec(oid) {
        oid = oid.toUpperCase();
        if (!EccKeyPairSerializer.oids[oid]) {
            throw {
                msg: "Unknown oid",
                value: oid,
                code: ErrorCodes_1.ErrorCodes.INVALID_DATA
            };
        }
        return EccKeyPairSerializer.oids[oid];
    }
    static deserialize(hasPrivateKey, subkey, timestamp, ecdh, body) {
        let length = body.readUInt8(6);
        body = body.slice(7);
        const oid = body.slice(0, length).toString("hex");
        const ecName = EccKeyPairSerializer.oid2ec(oid);
        body = body.slice(length);
        length = Math.ceil(body.readUInt16BE(0) / 8);
        body = body.slice(2);
        const ec = new elliptic.ec(ecName);
        let key = ec.keyFromPublic(body.slice(0, length));
        body = body.slice(length);
        let kdf = null;
        if (ecdh) {
            if (body[0] !== 0x3 && body[1] !== 0x1) {
                throw {
                    msg: "Incorrect KDF params",
                    value: body,
                    code: ErrorCodes_1.ErrorCodes.PARSE_FAILURE
                };
            }
            kdf = {
                hashAlgorithm: body.readUInt8(2),
                symmetricAlgorithm: body.readUInt8(3)
            };
            body = body.slice(4);
        }
        if (hasPrivateKey) {
            if (body[0] !== 0) {
                throw {
                    msg: "Unsupported S2K type",
                    value: body[0],
                    code: ErrorCodes_1.ErrorCodes.UNSUPPORTED_FEATURE
                };
            }
            length = Math.ceil(body.readUInt16BE(1) / 8);
            const privkey = ec.keyFromPrivate(body.slice(3, length + 3));
            if (!privkey.getPublic().eq(key.getPublic())) {
                throw {
                    msg: "Decoded private key doesn't match public",
                    value: privkey,
                    code: ErrorCodes_1.ErrorCodes.INVALID_DATA
                };
            }
            key = privkey;
        }
        const validation = key.validate();
        if (!validation.result) {
            throw {
                msg: "Invalid public key",
                value: validation,
                code: ErrorCodes_1.ErrorCodes.INVALID_DATA
            };
        }
        return new EccKeyPair(key, subkey, timestamp, kdf);
    }
    static getPublicMpi(eccKeyPair) {
        const pub = eccKeyPair.getPublicBuffer();
        let length = pub.length * 8;
        for (let i = 7; i > 0; --i) {
            if (pub[0] & (1 << i)) {
                break;
            }
            --length;
        }
        const oid = Buffer.from(EccKeyPairSerializer.ec2oid(EccKeyPairSerializer.getCurveName(eccKeyPair.keyPair)), "hex");
        return Buffer.concat([
            Buffer.from([oid.length]),
            oid,
            Buffer.from([
                (length >> 8) & 0xFF,
                length & 0xFF
            ]),
            pub
        ]);
    }
    static encodePublic(eccKeyPair) {
        return Buffer.concat([
            KeyPair_1.KeyPair.serializeHeader(eccKeyPair.timestamp, eccKeyPair.getKeyAlgorithm()),
            EccKeyPairSerializer.getPublicMpi(eccKeyPair)
        ]);
    }
    static encodeKDF(eccKeyPair) {
        if (!eccKeyPair.hasKdf()) {
            return Buffer.alloc(0);
        }
        return Buffer.from([
            0x3, 0x1, eccKeyPair.kdf.hashAlgorithm, eccKeyPair.kdf.symmetricAlgorithm
        ]);
    }
    static encodeS2K(eccKeyPair) {
        const privkey = eccKeyPair.getPrivate();
        if (privkey === null) {
            return Buffer.alloc(0);
        }
        const length = privkey.bitLength();
        const bytes = [
            (length >> 8) & 0xFF,
            length & 0xFF
        ].concat(privkey.toArray());
        const checksum = bytes.reduce((prev, byte) => prev = (prev + byte) % 0x10000);
        bytes.push((checksum >> 8) & 0xFF);
        bytes.push(checksum & 0xFF);
        return Buffer.from([0].concat(bytes));
    }
    static getBody(eccKeyPair) {
        return Buffer.concat([
            EccKeyPairSerializer.encodePublic(eccKeyPair),
            EccKeyPairSerializer.encodeKDF(eccKeyPair),
            EccKeyPairSerializer.encodeS2K(eccKeyPair)
        ]);
    }
    static encode(eccKeyPair) {
        return Packet_1.Packet.encode(EccKeyPairSerializer.getBody(eccKeyPair), KeyPair_1.KeyPair.getTag(eccKeyPair));
    }
    static encodeWithArmor(eccKeyPair) {
        return Packet_1.Packet.enarmor(EccKeyPairSerializer.encode(eccKeyPair), KeyPair_1.KeyPair.getArmor(eccKeyPair));
    }
}
exports.EccKeyPairSerializer = EccKeyPairSerializer;
const KeyPair_1 = require("./KeyPair");

}).call(this)}).call(this,require("buffer").Buffer)
},{"../ErrorCodes":294,"../Types":324,"./KeyPair":300,"./Packet":305,"./Signature":308,"buffer":498,"create-hash":50,"elliptic":52}],300:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyPair = void 0;
const Types_1 = require("../Types");
const ErrorCodes_1 = require("../ErrorCodes");
const Packet_1 = require("./Packet");
class KeyPair {
    static VERSION = 4;
    static isValidTag(tag) {
        return tag == Types_1.keystore.PacketTag.SECRET_KEY ||
            tag === Types_1.keystore.PacketTag.SECRET_SUBKEY ||
            tag == Types_1.keystore.PacketTag.PUBLIC_KEY ||
            tag == Types_1.keystore.PacketTag.PUBLIC_SUBKEY;
    }
    static isMainKeyTag(tag) {
        return tag === Types_1.keystore.PacketTag.SECRET_KEY ||
            tag == Types_1.keystore.PacketTag.PUBLIC_KEY;
    }
    static isSubkeyTag(tag) {
        return tag === Types_1.keystore.PacketTag.SECRET_SUBKEY ||
            tag == Types_1.keystore.PacketTag.PUBLIC_SUBKEY;
    }
    static isPrivateTag(tag) {
        return tag === Types_1.keystore.PacketTag.SECRET_KEY ||
            tag == Types_1.keystore.PacketTag.SECRET_SUBKEY;
    }
    static isPublicTag(tag) {
        return tag === Types_1.keystore.PacketTag.PUBLIC_KEY ||
            tag == Types_1.keystore.PacketTag.PUBLIC_SUBKEY;
    }
    static getArmor(keyPair) {
        return keyPair.hasPrivate() ? "PRIVATE KEY BLOCK" : "PUBLIC KEY BLOCK";
    }
    static getTag(keyPair) {
        return keyPair.isSubkey() ?
            (keyPair.hasPrivate() ? Types_1.keystore.PacketTag.SECRET_SUBKEY : Types_1.keystore.PacketTag.PUBLIC_SUBKEY) :
            (keyPair.hasPrivate() ? Types_1.keystore.PacketTag.SECRET_KEY : Types_1.keystore.PacketTag.PUBLIC_KEY);
    }
    static deserialize(data) {
        return KeyPair.deserializeFromPacket(Packet_1.Packet.decodeSinglePacket(data));
    }
    static deserializeFromPacket(packet) {
        if (!KeyPair.isValidTag(packet.tag)) {
            throw {
                msg: "Incorrect tag for KeyPair packet",
                value: packet.tag,
                code: ErrorCodes_1.ErrorCodes.PARSE_FAILURE
            };
        }
        const hasPrivateKey = KeyPair.isPrivateTag(packet.tag);
        const subkey = KeyPair.isSubkeyTag(packet.tag);
        const version = packet.body.readUInt8(0);
        if (version != KeyPair.VERSION) {
            throw {
                msg: "Unsupported version",
                value: version,
                code: ErrorCodes_1.ErrorCodes.PARSE_FAILURE
            };
        }
        const timestamp = packet.body.readUInt32BE(1);
        const keyAlgorithm = packet.body.readUInt8(5);
        if (keyAlgorithm == Types_1.keystore.PublicKeyAlgorithm.ECDSA || keyAlgorithm == Types_1.keystore.PublicKeyAlgorithm.ECDH) {
            return EccKeyPair_1.EccKeyPairSerializer.deserialize(hasPrivateKey, subkey, timestamp, keyAlgorithm == Types_1.keystore.PublicKeyAlgorithm.ECDH, packet.body);
        }
        else {
            throw {
                msg: "Unimplemented key algorithm",
                value: keyAlgorithm,
                code: ErrorCodes_1.ErrorCodes.UNSUPPORTED_FEATURE
            };
        }
    }
    static serializeHeader(timestamp, keyAlgorithm) {
        const buffer = Buffer.alloc(6);
        buffer.writeUInt8(KeyPair.VERSION, 0);
        buffer.writeUInt32BE(timestamp, 1);
        buffer.writeUInt8(keyAlgorithm, 5);
        return buffer;
    }
}
exports.KeyPair = KeyPair;
const EccKeyPair_1 = require("./EccKeyPair");

}).call(this)}).call(this,require("buffer").Buffer)
},{"../ErrorCodes":294,"../Types":324,"./EccKeyPair":299,"./Packet":305,"buffer":498}],301:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyStore = void 0;
const Subpacket_1 = require("./Subpacket");
const MasterKeyPair_1 = require("./MasterKeyPair");
const Packet_1 = require("./Packet");
const KeyPair_1 = require("./KeyPair");
const PkiDataTypePacket_1 = require("./PkiDataTypePacket");
const ErrorCodes_1 = require("../ErrorCodes");
const Enumerable_1 = require("../Enumerable");
const Types_1 = require("../Types");
const AttachmentDataPacket_1 = require("./AttachmentDataPacket");
const AttachmentPointerPacket_1 = require("./AttachmentPointerPacket");
const AttachmentsStorage_1 = require("./AttachmentsStorage");
class KeyStore {
    keys;
    attachmentPointerList;
    attachmentDataList;
    constructor(keys) {
        this.keys = keys;
        this.attachmentPointerList = [];
        this.attachmentDataList = [];
    }
    static createFromKeyPair(userId, keyPair) {
        const keyStore = new KeyStore([]);
        keyStore.addKeyPair(userId, keyPair);
        return keyStore;
    }
    forEachKey(func) {
        (0, Enumerable_1.$A)(this.keys).forEach(x => x.forEachKey(func));
    }
    removePrivate() {
        (0, Enumerable_1.$A)(this.keys).forEach(x => x.removePrivate());
    }
    getPublicView() {
        const clone = KeyStore.deserialize(this.serialize());
        clone.removePrivate();
        return clone;
    }
    hasAnyPrivate() {
        return (0, Enumerable_1.$A)(this.keys).contains(x => x.hasAnyPrivate());
    }
    addKey(key) {
        this.keys.push(key);
    }
    addKeyPair(userId, keyPair) {
        const master = new MasterKeyPair_1.MasterKeyPair(keyPair, [], [], []);
        master.addUserId(userId);
        this.keys.push(master);
    }
    addAttachment(fileName, data) {
        return AttachmentsStorage_1.AttachmentsStorage.addAttachment(this, fileName, data);
    }
    getPrimaryKey() {
        return (0, Enumerable_1.$A)(this.keys).first();
    }
    getPrimaryUserId() {
        const pk = this.getPrimaryKey();
        return pk == null ? "" : pk.getPrimaryUserId();
    }
    getKeyById(id) {
        return (0, Enumerable_1.$A)(this.keys).takeFirstNotNull(x => x.getKeyById(id));
    }
    getAttachment(fileName) {
        return AttachmentsStorage_1.AttachmentsStorage.getAttachment(this, fileName);
    }
    generateKis(hash) {
        const key = this.getPrimaryKey();
        if (key == null || !key.hasFlag(Types_1.keystore.KeyFlag.SIGNING)) {
            throw {
                msg: "Cannot use key",
                value: key,
                code: ErrorCodes_1.ErrorCodes.INVALID_DATA
            };
        }
        const kstore = this.getPublicView();
        const msg = kstore.serializeWithoutAttachmentsData();
        return key.sign({
            data: { msg: msg },
            hashed: [new Subpacket_1.default.ConiksDbIdSubpacket(hash)]
        });
    }
    verifyKis(kis) {
        const key = this.getKeyById(kis.getIssuerId());
        if (key == null || !key.hasFlag(Types_1.keystore.KeyFlag.SIGNING)) {
            return false;
        }
        const kstore = this.getPublicView();
        const msg = kstore.serializeWithoutAttachmentsData();
        return key.verify({ msg: msg }, kis);
    }
    serialize() {
        return Buffer.concat([].concat(this.serializeWithoutAttachmentsData(), (0, Enumerable_1.$A)(this.attachmentDataList).map(x => x.serialize()).toArray()));
    }
    serializeWithoutAttachmentsData() {
        return Buffer.concat([].concat(new PkiDataTypePacket_1.PkiDataTypePacket(Types_1.keystore.PkiDataType.KEYSTORE).serialize(), (0, Enumerable_1.$A)(this.keys).map(x => x.serialize()).toArray(), (0, Enumerable_1.$A)(this.attachmentPointerList).map(x => x.serialize()).toArray()));
    }
    serializeWithArmor() {
        const primary = this.getPrimaryKey();
        return Packet_1.Packet.enarmor(this.serialize(), primary == null ? "MESSAGE" : KeyPair_1.KeyPair.getArmor(primary.keyPair));
    }
    static deserialize(data) {
        const stream = Packet_1.Packet.decode(data);
        const keystore = KeyStore.deserializeFromStream(stream);
        if (stream.hasCurrent()) {
            throw new Error("Unexpected packets " + stream.current.tag);
        }
        return keystore;
    }
    static deserializeFromStream(stream) {
        if (!stream.hasCurrent()) {
            throw new Error("Expected pki data type packet");
        }
        const pkiDataType = PkiDataTypePacket_1.PkiDataTypePacket.deserializeFromPacket(stream.current);
        if (pkiDataType.type != Types_1.keystore.PkiDataType.KEYSTORE) {
            throw new Error("Invalid pki data type " + pkiDataType.type);
        }
        stream.next();
        const kstore = new KeyStore([]);
        while (stream.hasCurrent()) {
            if (KeyPair_1.KeyPair.isMainKeyTag(stream.current.tag)) {
                kstore.keys.push(MasterKeyPair_1.MasterKeyPair.deserializeFromStream(stream));
            }
            else if (stream.current.tag == Types_1.keystore.PacketTag.ATTACHMENT_DATA) {
                kstore.attachmentDataList.push(AttachmentDataPacket_1.AttachmentDataPacket.deserializeFromPacket(stream.current));
                stream.next();
            }
            else if (stream.current.tag == Types_1.keystore.PacketTag.ATTACHMENT_POINTER) {
                kstore.attachmentPointerList.push(AttachmentPointerPacket_1.AttachmentPointerPacket.deserializeFromPacket(stream.current));
                stream.next();
            }
            else {
                break;
            }
        }
        return kstore;
    }
    validate() {
        return (0, Enumerable_1.$A)(this.keys).allPass(x => x.validate()) && AttachmentsStorage_1.AttachmentsStorage.validate(this);
    }
    isValidToSave() {
        return (0, Enumerable_1.$A)(this.keys).allPass(x => x.validate()) && AttachmentsStorage_1.AttachmentsStorage.isValidToSave(this);
    }
}
exports.KeyStore = KeyStore;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../Enumerable":293,"../ErrorCodes":294,"../Types":324,"./AttachmentDataPacket":295,"./AttachmentPointerPacket":296,"./AttachmentsStorage":297,"./KeyPair":300,"./MasterKeyPair":303,"./Packet":305,"./PkiDataTypePacket":307,"./Subpacket":310,"buffer":498}],302:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiteralDataPacket = void 0;
const Packet_1 = require("./Packet");
const ErrorCodes_1 = require("../ErrorCodes");
const Utils_1 = require("../Utils");
const Types_1 = require("../Types");
class LiteralDataPacket {
    format;
    fileName;
    date;
    data;
    static createBinary(fileName, data) {
        const result = new LiteralDataPacket();
        result.format = Types_1.keystore.LiteralDataType.BINARY;
        result.fileName = fileName;
        result.date = Math.floor(new Date().getTime() / 1000);
        result.data = data;
        return result;
    }
    static createUtf8(fileName, text) {
        const result = new LiteralDataPacket();
        result.format = Types_1.keystore.LiteralDataType.UTF8;
        result.fileName = fileName;
        result.date = Math.floor(new Date().getTime() / 1000);
        result.data = Buffer.from(text, "utf8");
        return result;
    }
    getText() {
        return this.data.toString("utf8");
    }
    serialize() {
        const fileNameEnc = Buffer.from(this.fileName, "utf8");
        const length = 1 + 1 + fileNameEnc.length + 4 + this.data.length;
        const bos = new Utils_1.BufferOutputStream(Buffer.alloc(length), 0);
        bos.writeUInt8(this.format);
        bos.writeOneOctetLengthBuffer(fileNameEnc);
        bos.writeUInt32BE(this.date);
        bos.writeBuffer(this.data);
        return Packet_1.Packet.encode(bos.buffer, Types_1.keystore.PacketTag.LITERAL_DATA);
    }
    static deserialize(data) {
        return LiteralDataPacket.deserializeFromPacket(Packet_1.Packet.decodeSinglePacket(data));
    }
    static deserializeFromPacket(packet) {
        if (packet.tag !== Types_1.keystore.PacketTag.LITERAL_DATA) {
            throw {
                msg: "Incorrect tag for LiteralData packet",
                value: packet.tag,
                code: ErrorCodes_1.ErrorCodes.PARSE_FAILURE
            };
        }
        const result = new LiteralDataPacket();
        const bis = new Utils_1.BufferInputStream(packet.body);
        result.format = bis.readUInt8();
        result.fileName = bis.readOneOctetLengthBuffer().toString("utf8");
        result.date = bis.readUInt32BE();
        result.data = bis.readBufferUntilEnd();
        return result;
    }
    validate() {
        return true;
    }
}
exports.LiteralDataPacket = LiteralDataPacket;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../ErrorCodes":294,"../Types":324,"../Utils":325,"./Packet":305,"buffer":498}],303:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MasterKeyPair = void 0;
const PackagedKeyPair_1 = require("./PackagedKeyPair");
const SubKeyPair_1 = require("./SubKeyPair");
const UserId_1 = require("./UserId");
const Enumerable_1 = require("../Enumerable");
const Subpacket_1 = require("./Subpacket");
const Signature_1 = require("./Signature");
const Packet_1 = require("./Packet");
const KeyPair_1 = require("./KeyPair");
const Types_1 = require("../Types");
class MasterKeyPair extends PackagedKeyPair_1.PackagedKeyPair {
    userIds;
    subkeys;
    container;
    constructor(keyPair, signatures, userIds, subkeys) {
        super(keyPair, signatures);
        this.userIds = userIds;
        this.subkeys = subkeys;
        if (keyPair.isSubkey()) {
            throw new Error("Cannot use subkey in MasterKeyPair");
        }
        this.container = this;
    }
    getRevokeSignature() {
        return (0, Enumerable_1.$A)(this.signatures).find(x => x.type === Types_1.keystore.SignatureType.KEY_REVOCATION_SIGNATURE);
    }
    getBindSignature() {
        return (0, Enumerable_1.$A)(this.userIds)
            .map(x => x.getBindSignature())
            .findAll(x => x != null)
            .max((a, b) => a.getTimestamp() - b.getTimestamp());
    }
    isValidRevokeKey(key) {
        return this.keyPair.getKeyId().equals(key.keyPair.getKeyId());
    }
    getKeyPairContainer() {
        return this.container;
    }
    getKeyById(id) {
        if (this.keyPair.getKeyId().equals(id)) {
            return this;
        }
        return (0, Enumerable_1.$A)(this.subkeys).find(x => x.keyPair.getKeyId().equals(id));
    }
    getPrimaryUserId() {
        const userId = (0, Enumerable_1.$A)(this.userIds).find(x => x.validate());
        return userId == null ? "" : userId.name;
    }
    removePrivate() {
        this.keyPair.removePrivate();
        (0, Enumerable_1.$A)(this.subkeys).forEach(x => x.keyPair.removePrivate());
    }
    forEachKey(func) {
        func(this.keyPair);
        (0, Enumerable_1.$A)(this.subkeys).forEach(x => func(x.keyPair));
    }
    hasAnyPrivate() {
        return this.keyPair.hasPrivate() || (0, Enumerable_1.$A)(this.subkeys).contains(x => x.keyPair.hasPrivate());
    }
    addSubkey(keyPair, signatures, flags = 0) {
        if (!flags) {
            flags = Types_1.keystore.KeyFlag.CERTIFICATION | Types_1.keystore.KeyFlag.SIGNING;
        }
        const subkey = new SubKeyPair_1.SubKeyPair(this, keyPair, signatures);
        const options = {
            type: Types_1.keystore.SignatureType.SUBKEY_BINDING_SIGNATURE,
            data: {
                key: this.keyPair,
                subkey: subkey.keyPair
            },
            hashed: [
                new Subpacket_1.default.RevocationKeySubpacket(subkey.keyPair.getKeyAlgorithm(), subkey.keyPair.getFingerprint()),
                new Subpacket_1.default.KeyFlagsSubpacket(flags)
            ]
        };
        if (flags & Types_1.keystore.KeyFlag.SIGNING) {
            options.hashed.push(new Subpacket_1.default.EmbededSignatureSubpacket(subkey.sign({
                type: Types_1.keystore.SignatureType.PRIMARY_KEY_BINDING_SIGNATURE,
                data: {
                    key: this.keyPair,
                    subkey: subkey.keyPair
                },
                hashed: [new Subpacket_1.default.KeyFlagsSubpacket(flags)]
            })));
        }
        subkey.addSignature(this.sign(options));
        this.subkeys.push(subkey);
        return subkey;
    }
    addUserId(name, flags = 0) {
        if (!flags) {
            flags = Types_1.keystore.KeyFlag.CERTIFICATION | Types_1.keystore.KeyFlag.SIGNING;
        }
        const userId = new UserId_1.UserId(this, name);
        userId.addSignature(this.sign({
            type: Types_1.keystore.SignatureType.POSITIVE_PK_USER_ID_CERTIFICATION,
            data: {
                key: this.keyPair,
                userId: userId.name
            },
            hashed: [new Subpacket_1.default.KeyFlagsSubpacket(flags)]
        }));
        this.userIds.push(userId);
        return userId;
    }
    serialize() {
        return Buffer.concat([].concat([this.keyPair.serialize()], (0, Enumerable_1.$A)(this.signatures).map(x => x.serialize()).toArray(), (0, Enumerable_1.$A)(this.userIds).map(x => x.serialize()).toArray(), (0, Enumerable_1.$A)(this.subkeys).map(x => x.serialize()).toArray()));
    }
    serializeWithArmor() {
        return Packet_1.Packet.enarmor(this.serialize(), KeyPair_1.KeyPair.getArmor(this.keyPair));
    }
    static deserialize(data) {
        const stream = Packet_1.Packet.decode(data);
        const masterKeyPair = MasterKeyPair.deserializeFromStream(stream);
        if (stream.hasCurrent()) {
            throw new Error("Unexpected packets " + stream.current.tag);
        }
        return masterKeyPair;
    }
    static deserializeFromStream(stream) {
        if (!stream.hasCurrent()) {
            throw new Error("Expected key packet");
        }
        const key = KeyPair_1.KeyPair.deserializeFromPacket(stream.current);
        const masterKeyPair = new MasterKeyPair(key, [], [], []);
        stream.next();
        while (stream.hasCurrent() && stream.current.tag == Types_1.keystore.PacketTag.SIGNATURE) {
            masterKeyPair.signatures.push(Signature_1.Signature.deserializeFromPacket(stream.current));
            stream.next();
        }
        while (stream.hasCurrent() && stream.current.tag == Types_1.keystore.PacketTag.USER_ID) {
            masterKeyPair.userIds.push(UserId_1.UserId.deserializeFromStream(masterKeyPair, stream));
        }
        while (stream.hasCurrent() && KeyPair_1.KeyPair.isSubkeyTag(stream.current.tag)) {
            masterKeyPair.subkeys.push(SubKeyPair_1.SubKeyPair.deserializeFromStream(masterKeyPair, stream));
        }
        return masterKeyPair;
    }
    validate() {
        if (!super.validate()) {
            return false;
        }
        if (this.userIds.length === 0) {
            return false;
        }
        if (!(0, Enumerable_1.$A)(this.userIds).allPass(x => x.validate())) {
            return false;
        }
        if (!(0, Enumerable_1.$A)(this.subkeys).allPass(x => x.validate())) {
            return false;
        }
        return true;
    }
}
exports.MasterKeyPair = MasterKeyPair;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../Enumerable":293,"../Types":324,"./KeyPair":300,"./PackagedKeyPair":304,"./Packet":305,"./Signature":308,"./SubKeyPair":309,"./Subpacket":310,"./UserId":311,"buffer":498}],304:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackagedKeyPair = void 0;
const Signature_1 = require("./Signature");
const Enumerable_1 = require("../Enumerable");
const Types_1 = require("../Types");
class PackagedKeyPair {
    keyPair;
    signatures;
    constructor(keyPair, signatures) {
        this.keyPair = keyPair;
        this.signatures = signatures;
    }
    revoke(key) {
        if (key.isRevoked()) {
            return;
        }
        const options = key.keyPair.isSubkey() ? {
            type: Types_1.keystore.SignatureType.SUBKEY_REVOCATION_SIGNATURE,
            data: {
                subkey: key.keyPair
            }
        } : {
            type: Types_1.keystore.SignatureType.KEY_REVOCATION_SIGNATURE,
            data: {
                key: key.keyPair
            }
        };
        const revoke = this.sign(options);
        key.addSignature(revoke);
    }
    addSignature(signature) {
        if (signature.type == Types_1.keystore.SignatureType.SUBKEY_REVOCATION_SIGNATURE || signature.type == Types_1.keystore.SignatureType.KEY_REVOCATION_SIGNATURE) {
            this.signatures = [signature].concat(this.signatures);
        }
        else {
            this.signatures.push(signature);
        }
    }
    revokeSelf() {
        return this.revoke(this);
    }
    isRevoked() {
        return this.getRevokeSignature() != null;
    }
    getRevokeTime() {
        const signature = this.getRevokeSignature();
        return signature == null ? -1 : signature.getTimestamp();
    }
    getFlags() {
        const signature = this.getBindSignature();
        return signature == null ? 0 : signature.getKeyFlags();
    }
    hasFlag(flag) {
        return (this.getFlags() & flag) !== 0;
    }
    sign(options) {
        if (this.isRevoked()) {
            throw new Error("Cannot use revoked key");
        }
        if (options.type == Types_1.keystore.SignatureType.KEY_REVOCATION_SIGNATURE) {
            if (!options.data || !options.data.key) {
                throw new Error("Invalid signature options");
            }
            const key = this.getKeyPairContainer().getKeyById(options.data.key.getKeyId());
            if (key == null) {
                throw new Error("Cannot find a revocating key");
            }
            if (!key.isValidRevokeKey(this)) {
                throw new Error("Key has no permission to revoke given key");
            }
        }
        else if (options.type == Types_1.keystore.SignatureType.SUBKEY_REVOCATION_SIGNATURE) {
            if (!options.data || !options.data.subkey) {
                throw new Error("Invalid signature options");
            }
            const subKey = this.getKeyPairContainer().getKeyById(options.data.subkey.getKeyId());
            if (subKey == null) {
                throw new Error("Cannot find a revocating subkey");
            }
            if (!subKey.isValidRevokeKey(this)) {
                throw new Error("Key has no permission to revoke given subkey");
            }
        }
        return Signature_1.Signature.create(options, this.keyPair);
    }
    verify(data, signature) {
        if (this.isRevoked() && this.getRevokeTime() < signature.getTimestamp()) {
            return false;
        }
        if (signature.type == Types_1.keystore.SignatureType.KEY_REVOCATION_SIGNATURE) {
            if (!data || !data.key) {
                return false;
            }
            const key = this.getKeyPairContainer().getKeyById(data.key.getKeyId());
            if (key == null || !key.isValidRevokeKey(this)) {
                return false;
            }
        }
        else if (signature.type == Types_1.keystore.SignatureType.SUBKEY_REVOCATION_SIGNATURE) {
            if (!data || !data.subkey) {
                return false;
            }
            const subKey = this.getKeyPairContainer().getKeyById(data.subkey.getKeyId());
            if (subKey == null || !subKey.isValidRevokeKey(this)) {
                return false;
            }
        }
        return signature.verify(data, this.keyPair);
    }
    validate() {
        return (0, Enumerable_1.$A)(this.signatures).allPass(x => {
            if (x.type == Types_1.keystore.SignatureType.SUBKEY_REVOCATION_SIGNATURE) {
                const key = this.getKeyPairContainer().getKeyById(x.getIssuerId());
                return this.keyPair.isSubkey() && key && key.verify({ subkey: this.keyPair }, x);
            }
            else if (x.type == Types_1.keystore.SignatureType.KEY_REVOCATION_SIGNATURE) {
                const key2 = this.getKeyPairContainer().getKeyById(x.getIssuerId());
                return !this.keyPair.isSubkey() && key2 && key2.verify({ key: this.keyPair }, x);
            }
            return true;
        });
    }
}
exports.PackagedKeyPair = PackagedKeyPair;

},{"../Enumerable":293,"../Types":324,"./Signature":308}],305:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PacketStream = exports.Packet = void 0;
const ErrorCodes_1 = require("../ErrorCodes");
const Utils_1 = require("../Utils");
const ByteBuffer = require("bytebuffer");
class Packet {
    static crc24(data) {
        let crc = 0xB704CE;
        const poly = 0x1864CFB;
        for (let i = 0; i < data.length; i++) {
            crc ^= data[i] << 16;
            for (let j = 0; j < 8; j++) {
                crc <<= 1;
                if (crc & 0x1000000) {
                    crc ^= poly;
                }
            }
        }
        return Buffer.from([
            (crc >> 16) & 0xFF,
            (crc >> 8) & 0xFF,
            crc & 0xFF,
        ]);
    }
    static enarmor(raw, marker = "MESSAGE") {
        marker = marker.toUpperCase();
        return "-----BEGIN PGP " + marker + "-----\n\n" +
            raw.toString("base64").match(/.{1,64}/g).join("\n") +
            "\n=" + Packet.crc24(raw).toString("base64") +
            "\n-----END PGP " + marker + "-----\n";
    }
    static unarmor(armored) {
        let lines = armored.split("\n");
        let pos = 0;
        for (pos = 0; pos < lines.length; pos++) {
            if (lines[pos].trim().length === 0) {
                break;
            }
        }
        lines = lines.splice(pos);
        for (pos = lines.length - 1; pos >= 0; pos--) {
            if (lines[pos].trim()[0] === "=") {
                break;
            }
        }
        const crcLine = lines[pos];
        lines = lines.splice(0, pos);
        const crc = Buffer.from(crcLine.trim().substr(1), "base64");
        const data = Buffer.from(lines.join(""), "base64");
        if (!crc.equals(Packet.crc24(data))) {
            throw {
                msg: "Incorrect CRC 24",
                value: { armored: armored, crc: crc, data: data },
                code: ErrorCodes_1.ErrorCodes.PARSE_FAILURE
            };
        }
        return data;
    }
    static encode(body, tag) {
        const header = [0xC0 | tag];
        let length = body.length;
        if (length < 192) {
            header.push(body.length);
        }
        else if (length < 8383) {
            length -= 192;
            header.push((length >> 8) + 192);
            header.push(length & 0xFF);
        }
        else {
            header.push(0xFF);
            header.push((length >> 24) & 0xFF);
            header.push((length >> 16) & 0xFF);
            header.push((length >> 8) & 0xFF);
            header.push(length & 0xFF);
        }
        return Buffer.concat([
            Buffer.from(header),
            body
        ]);
    }
    static decode(data) {
        return new PacketStream(new Utils_1.BufferInputStream(data));
    }
    static decodeSinglePacket(data) {
        const stream = new PacketStream(new Utils_1.BufferInputStream(data));
        if (!stream.hasCurrent()) {
            throw new Error("Empty buffer");
        }
        const packet = stream.current;
        stream.next();
        if (stream.hasCurrent()) {
            throw new Error("Unexpected packets " + stream.current.tag);
        }
        return packet;
    }
    static encodeToArmored(body, tag, armor) {
        return Packet.enarmor(Packet.encode(body, tag), armor);
    }
    static decodeFromArmored(armored) {
        return Packet.decode(Packet.unarmor(armored));
    }
    static isTag(tagByte, expected) {
        return Packet.decodeTag(tagByte) == expected;
    }
    static decodeTag(tagByte) {
        return (tagByte & 0x40) === 0 ? (tagByte & 0x3F) >> 2 : tagByte & 0x3F;
    }
    static oneOfTags(tagByte, expected) {
        const tag = Packet.decodeTag(tagByte);
        return expected.indexOf(tag) != -1;
    }
    static decodeString(data) {
        if (data.substr(0, 5) === "-----") {
            return Packet.unarmor(data);
        }
        if (data.replace(/[a-f]|[0-9]/gi, "").trim().length > 0) {
            return Buffer.from(data, "base64");
        }
        return Buffer.from(data, "hex");
    }
    static decodePacket(clazz, data) {
        if (data instanceof clazz) {
            return data;
        }
        if (data instanceof ByteBuffer) {
            return clazz.deserialize(Buffer.from(data.toArrayBuffer()));
        }
        if (data instanceof Buffer) {
            return clazz.deserialize(data);
        }
        if (typeof (data) == "string") {
            const buffer = Packet.decodeString(data);
            return clazz.deserialize(buffer);
        }
        return undefined;
    }
}
exports.Packet = Packet;
class PacketStream {
    bis;
    current = null;
    constructor(bis) {
        this.bis = bis;
        this.next();
    }
    hasCurrent() {
        return this.current != null;
    }
    next() {
        if (this.bis.isEnd()) {
            this.current = null;
            return;
        }
        const firstByte = this.bis.readUInt8();
        let bodyLength = 0;
        if ((firstByte & 0x40) === 0) {
            switch (firstByte & 0x3) {
                case 0:
                    bodyLength = this.bis.readUInt8();
                    break;
                case 1:
                    bodyLength = this.bis.readUInt16BE();
                    break;
                case 2:
                    bodyLength = this.bis.readUInt32BE();
                    break;
                default:
                    throw {
                        msg: "Unsupported packet length",
                        buffer: this.bis.buffer,
                        offset: this.bis.offset,
                        code: ErrorCodes_1.ErrorCodes.PARSE_FAILURE
                    };
            }
        }
        else {
            const b = this.bis.readUInt8();
            if (b == 0xFF) {
                bodyLength = this.bis.readUInt32BE();
            }
            else if ((b & 0xC0) === 0xC0) {
                bodyLength = ((b - 192) << 8) + 192 + this.bis.readUInt8();
            }
            else {
                bodyLength = b;
            }
        }
        if (!this.bis.canRead(bodyLength)) {
            throw {
                msg: "Cannot read packet body, expected " + bodyLength + " bytes at " + this.bis.offset + " but get " + (this.bis.buffer.length - this.bis.offset),
                buffer: this.bis.buffer,
                offset: this.bis.offset,
                code: ErrorCodes_1.ErrorCodes.PARSE_FAILURE
            };
        }
        this.current = {
            tag: Packet.decodeTag(firstByte),
            body: this.bis.readBuffer(bodyLength)
        };
    }
}
exports.PacketStream = PacketStream;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../ErrorCodes":294,"../Utils":325,"buffer":498,"bytebuffer":48}],306:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PkiData = void 0;
const Packet_1 = require("./Packet");
const Types_1 = require("../Types");
const PkiDataTypePacket_1 = require("./PkiDataTypePacket");
const DocumentsPacket_1 = require("./DocumentsPacket");
const KeyStore_1 = require("./KeyStore");
const ByteBuffer = require("bytebuffer");
class PkiData {
    static deserialize(data) {
        const stream = Packet_1.Packet.decode(data);
        const keystore = PkiData.deserializeFromStream(stream);
        if (stream.hasCurrent()) {
            throw new Error("Unexpected packets " + stream.current.tag);
        }
        return keystore;
    }
    static deserializeFromStream(stream) {
        if (!stream.hasCurrent()) {
            throw new Error("Expected key packet");
        }
        const pkiDataType = PkiDataTypePacket_1.PkiDataTypePacket.deserializeFromPacket(stream.current);
        if (pkiDataType.type == Types_1.keystore.PkiDataType.KEYSTORE) {
            return KeyStore_1.KeyStore.deserializeFromStream(stream);
        }
        if (pkiDataType.type == Types_1.keystore.PkiDataType.DOCUMENT) {
            return DocumentsPacket_1.DocumentsPacket.deserializeFromStream(stream);
        }
        throw new Error("Unsupported pki data type " + pkiDataType.type);
    }
    static decode(data) {
        if (data instanceof KeyStore_1.KeyStore || data instanceof DocumentsPacket_1.DocumentsPacket) {
            return data;
        }
        if (data instanceof ByteBuffer) {
            return PkiData.deserialize(Buffer.from(data.toArrayBuffer()));
        }
        if (data instanceof Buffer) {
            return PkiData.deserialize(data);
        }
        if (typeof (data) == "string") {
            const buffer = Packet_1.Packet.decodeString(data);
            return PkiData.deserialize(buffer);
        }
        return undefined;
    }
}
exports.PkiData = PkiData;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../Types":324,"./DocumentsPacket":298,"./KeyStore":301,"./Packet":305,"./PkiDataTypePacket":307,"buffer":498,"bytebuffer":48}],307:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PkiDataTypePacket = void 0;
const Packet_1 = require("./Packet");
const ErrorCodes_1 = require("../ErrorCodes");
const Types_1 = require("../Types");
class PkiDataTypePacket {
    type;
    constructor(type) {
        this.type = type;
    }
    serialize() {
        return Packet_1.Packet.encode(Buffer.from([this.type]), Types_1.keystore.PacketTag.PKI_DATA_TYPE);
    }
    static deserialize(data) {
        return PkiDataTypePacket.deserializeFromPacket(Packet_1.Packet.decodeSinglePacket(data));
    }
    static deserializeFromPacket(packet) {
        if (packet.tag !== Types_1.keystore.PacketTag.PKI_DATA_TYPE) {
            throw {
                msg: "Incorrect tag for PkiDataType packet",
                value: packet.tag,
                code: ErrorCodes_1.ErrorCodes.PARSE_FAILURE
            };
        }
        const type = packet.body.readUInt8(0);
        return new PkiDataTypePacket(type);
    }
    validate() {
        return true;
    }
}
exports.PkiDataTypePacket = PkiDataTypePacket;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../ErrorCodes":294,"../Types":324,"./Packet":305,"buffer":498}],308:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Signature = void 0;
const Packet_1 = require("./Packet");
const Subpacket_1 = require("./Subpacket");
const ErrorCodes_1 = require("../ErrorCodes");
const Types_1 = require("../Types");
const Utils_1 = require("../Utils");
class Signature {
    static VERSION = 4;
    static createSignatureHashedPart(signature) {
        const { data, length } = signature.getSubpacketData(true);
        const head = Buffer.from([
            Signature.VERSION & 0xFF,
            signature.type & 0xFF,
            signature.keyAlgorithm & 0xFF,
            signature.hashAlgorithm & 0xFF
        ]);
        return Buffer.concat([
            head, length, data
        ]);
    }
    static createSignatureTrailerPart(length) {
        return Buffer.from([
            Signature.VERSION & 0xFF,
            0xFF,
            (length >> 24) & 0xFF,
            (length >> 16) & 0xFF,
            (length >> 8) & 0xFF,
            length & 0xFF
        ]);
    }
    static createSignatureUserIdPart(userId) {
        const buffer = Buffer.from(userId);
        return Buffer.concat([
            Buffer.from([
                0xB4,
                (buffer.length >> 24) & 0xFF,
                (buffer.length >> 16) & 0xFF,
                (buffer.length >> 8) & 0xFF,
                buffer.length & 0xFF
            ]),
            buffer
        ]);
    }
    static buildHashData(signature, data) {
        const parts = [];
        switch (signature.type) {
            case Types_1.keystore.SignatureType.BINARY_DOCUMENT_SIGNATURE:
                parts.push(data.msg);
                break;
            case Types_1.keystore.SignatureType.STANDALONE_SIGNATURE:
                break;
            case Types_1.keystore.SignatureType.GENERIC_PK_USER_ID_CERTIFICATION:
            case Types_1.keystore.SignatureType.PERSONA_PK_USER_ID_CERTIFICATION:
            case Types_1.keystore.SignatureType.CASUAL_PK_USER_ID_CERTIFICATION:
            case Types_1.keystore.SignatureType.POSITIVE_PK_USER_ID_CERTIFICATION:
                if (!data.key || !data.userId) {
                    throw {
                        msg: "Signature type " + signature.type + " requires PublicKey and UserID",
                        value: { signature: signature, data: data },
                        code: ErrorCodes_1.ErrorCodes.INVALID_DATA
                    };
                }
                parts.push(data.key.getFingerprintUnhashed());
                parts.push(Signature.createSignatureUserIdPart(data.userId));
                break;
            case Types_1.keystore.SignatureType.PRIMARY_KEY_BINDING_SIGNATURE:
            case Types_1.keystore.SignatureType.SUBKEY_BINDING_SIGNATURE:
                if (!data.key || !data.subkey) {
                    throw {
                        msg: "Signature type " + signature.type + " requires PublicKey and Subkey",
                        value: { signature: signature, data: data },
                        code: ErrorCodes_1.ErrorCodes.INVALID_DATA
                    };
                }
                parts.push(data.key.getFingerprintUnhashed());
                parts.push(data.subkey.getFingerprintUnhashed());
                break;
            case Types_1.keystore.SignatureType.KEY_REVOCATION_SIGNATURE:
                if (!data.key) {
                    throw {
                        msg: "Signature type " + signature.type + " requires PublicKey",
                        value: { signature: signature, data: data },
                        code: ErrorCodes_1.ErrorCodes.INVALID_DATA
                    };
                }
                parts.push(data.key.getFingerprintUnhashed());
                break;
            case Types_1.keystore.SignatureType.SUBKEY_REVOCATION_SIGNATURE:
                if (!data.subkey) {
                    throw {
                        msg: "Signature type " + signature.type + " requires PublicSubkey",
                        value: { signature: signature, data: data },
                        code: ErrorCodes_1.ErrorCodes.INVALID_DATA
                    };
                }
                parts.push(data.subkey.getFingerprintUnhashed());
                break;
            default:
                throw {
                    msg: "Unsupported signature type " + signature.type,
                    value: { signature: signature, data: data },
                    code: ErrorCodes_1.ErrorCodes.UNSUPPORTED_FEATURE
                };
        }
        const hashedPart = Signature.createSignatureHashedPart(signature);
        parts.push(hashedPart);
        parts.push(Signature.createSignatureTrailerPart(hashedPart.length));
        return Utils_1.default.hashWithAlgorithm(Buffer.concat(parts), signature.hashAlgorithm);
    }
    static create(options, key) {
        const result = new Signature();
        result.type = options.type ? options.type : result.type;
        result.hashedPackets = options.hashed ? options.hashed : [];
        let hasSubpacket = false;
        for (const subpacket of result.hashedPackets) {
            hasSubpacket = subpacket instanceof Subpacket_1.default.SignatureCreationTimeSubpacket;
            if (hasSubpacket) {
                break;
            }
        }
        if (!hasSubpacket) {
            result.hashedPackets.push(new Subpacket_1.default.SignatureCreationTimeSubpacket());
        }
        if (result.type === Types_1.keystore.SignatureType.KEY_REVOCATION_SIGNATURE ||
            result.type === Types_1.keystore.SignatureType.SUBKEY_REVOCATION_SIGNATURE) {
            hasSubpacket = false;
            for (const subpacket of result.hashedPackets) {
                hasSubpacket = subpacket instanceof Subpacket_1.default.RevocableSubpacket;
                if (hasSubpacket) {
                    break;
                }
            }
            if (!hasSubpacket) {
                result.hashedPackets.push(new Subpacket_1.default.RevocableSubpacket(false));
            }
        }
        result.unhashedPackets = options.unhashed ? options.unhashed : [];
        hasSubpacket = false;
        for (const subpacket of result.unhashedPackets) {
            hasSubpacket = subpacket instanceof Subpacket_1.default.IssuerSubpacket;
            if (hasSubpacket) {
                break;
            }
        }
        if (!hasSubpacket) {
            result.unhashedPackets.push(new Subpacket_1.default.IssuerSubpacket(key.getKeyId()));
        }
        result.hashAlgorithm = options.hashAlgorithm ? options.hashAlgorithm : result.hashAlgorithm;
        const hash = Signature.buildHashData(result, options.data);
        result.hashPrefix = hash.slice(0, 2);
        result.signatureData = key.signRaw(hash);
        return result;
    }
    static deserialize(data) {
        return Signature.deserializeFromPacket(Packet_1.Packet.decodeSinglePacket(data));
    }
    static deserializeFromPacket(packet) {
        if (packet.tag !== Types_1.keystore.PacketTag.SIGNATURE) {
            throw {
                msg: "Incorrect tag for Signature packet",
                value: packet.tag,
                code: ErrorCodes_1.ErrorCodes.PARSE_FAILURE
            };
        }
        let body = packet.body;
        const result = new Signature();
        result.type = body[1];
        if (body[2] !== Types_1.keystore.PublicKeyAlgorithm.ECDSA) {
            throw {
                msg: "Unimplemented public key algorithm",
                value: body[2],
                code: ErrorCodes_1.ErrorCodes.UNSUPPORTED_FEATURE
            };
        }
        result.hashAlgorithm = body[3];
        const hashedLength = (body[4] << 8) + (body[5]);
        body = body.slice(6);
        const hashedData = body.slice(0, hashedLength);
        result.hashedPackets = Subpacket_1.default.deserialize(hashedData);
        body = body.slice(hashedLength);
        const unhashedLength = (body[0] << 8) + body[1];
        const unhashedData = body.slice(2, unhashedLength + 2);
        result.unhashedPackets = Subpacket_1.default.deserialize(unhashedData);
        body = body.slice(unhashedLength + 2);
        result.hashPrefix = body.slice(0, 2);
        result.signatureData = body.slice(2);
        return result;
    }
    type = Types_1.keystore.SignatureType.BINARY_DOCUMENT_SIGNATURE;
    keyAlgorithm = Types_1.keystore.PublicKeyAlgorithm.ECDSA;
    hashAlgorithm = Types_1.keystore.HashAlgorithm.SHA256;
    hashedPackets = [];
    unhashedPackets = [];
    hashPrefix = null;
    signatureData = null;
    getSubpacketData(hashed) {
        const subpackets = hashed ? this.hashedPackets : this.unhashedPackets;
        const tmp = [];
        for (const packet of subpackets) {
            tmp.push(packet.serialize());
        }
        const data = Buffer.concat(tmp);
        const length = Buffer.from([
            (data.length >> 8) & 0xFF,
            data.length & 0xFF
        ]);
        return { data: data, length: length };
    }
    getBody() {
        const { data, length } = this.getSubpacketData(false);
        return Buffer.concat([
            Signature.createSignatureHashedPart(this),
            length,
            data,
            this.hashPrefix,
            this.signatureData
        ]);
    }
    verify(data, pubkey) {
        if (!this.getIssuerId().equals(pubkey.getKeyId())) {
            return false;
        }
        const hash = Signature.buildHashData(this, data);
        if (!this.hashPrefix.equals(hash.slice(0, 2))) {
            return false;
        }
        return pubkey.verifyRaw(hash, this.signatureData);
    }
    getIssuerId() {
        for (const subpacket of this.unhashedPackets) {
            if (subpacket instanceof Subpacket_1.default.IssuerSubpacket) {
                return subpacket.keyId;
            }
        }
        throw {
            msg: "Missing Issuer Subpacket",
            value: this,
            code: ErrorCodes_1.ErrorCodes.INVALID_DATA
        };
    }
    getTimestamp() {
        for (const subpacket of this.hashedPackets) {
            if (subpacket instanceof Subpacket_1.default.SignatureCreationTimeSubpacket) {
                return subpacket.timestamp;
            }
        }
        throw {
            msg: "Missing SignatureCreationTimeSubpacket",
            value: this,
            code: ErrorCodes_1.ErrorCodes.INVALID_DATA
        };
    }
    getRevocationKeys() {
        const list = [];
        for (const subpacket of this.hashedPackets) {
            if (subpacket instanceof Subpacket_1.default.RevocationKeySubpacket) {
                list.push(subpacket.fingerprint);
            }
        }
        return list;
    }
    getKeyFlags() {
        for (const subpacket of this.hashedPackets) {
            if (subpacket instanceof Subpacket_1.default.KeyFlagsSubpacket) {
                return subpacket.flags;
            }
        }
        return 0;
    }
    getEmbeded() {
        for (const subpacket of this.hashedPackets) {
            if (subpacket instanceof Subpacket_1.default.EmbededSignatureSubpacket) {
                return subpacket.signature;
            }
        }
        return null;
    }
    serialize() {
        return Packet_1.Packet.encode(this.getBody(), Types_1.keystore.PacketTag.SIGNATURE);
    }
    serializeWithArmor() {
        return Packet_1.Packet.enarmor(this.serialize(), "SIGNATURE");
    }
}
exports.Signature = Signature;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../ErrorCodes":294,"../Types":324,"../Utils":325,"./Packet":305,"./Subpacket":310,"buffer":498}],309:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubKeyPair = void 0;
const PackagedKeyPair_1 = require("./PackagedKeyPair");
const Enumerable_1 = require("../Enumerable");
const Packet_1 = require("./Packet");
const KeyPair_1 = require("./KeyPair");
const Signature_1 = require("./Signature");
const Types_1 = require("../Types");
class SubKeyPair extends PackagedKeyPair_1.PackagedKeyPair {
    parent;
    constructor(parent, keyPair, signatures) {
        super(keyPair, signatures);
        this.parent = parent;
        if (!keyPair.isSubkey()) {
            throw new Error("Cannot use normal key in SubKeyPair");
        }
    }
    getRevokeSignature() {
        return (0, Enumerable_1.$A)(this.signatures).find(x => x.type === Types_1.keystore.SignatureType.SUBKEY_REVOCATION_SIGNATURE);
    }
    getBindSignature() {
        if (this.parent === null) {
            return null;
        }
        const parentId = this.parent.keyPair.getKeyId();
        return (0, Enumerable_1.$A)(this.signatures)
            .findAll(x => x.type === Types_1.keystore.SignatureType.SUBKEY_BINDING_SIGNATURE && x.getIssuerId().equals(parentId))
            .max((a, b) => a.getTimestamp() - b.getTimestamp());
    }
    isValidRevokeKey(key) {
        if (this.parent && this.parent.keyPair.getKeyId().equals(key.keyPair.getKeyId())) {
            return true;
        }
        const fingerprint = key.keyPair.getFingerprint();
        return (0, Enumerable_1.$A)(this.getBindSignature().getRevocationKeys()).contains(x => x.equals(fingerprint));
    }
    getKeyPairContainer() {
        return this.parent;
    }
    serialize() {
        return Buffer.concat([].concat([this.keyPair.serialize()], (0, Enumerable_1.$A)(this.signatures).map(x => x.serialize()).toArray()));
    }
    serializeWithArmor() {
        return Packet_1.Packet.enarmor(this.serialize(), KeyPair_1.KeyPair.getArmor(this.keyPair));
    }
    static deserialize(parent, data) {
        const stream = Packet_1.Packet.decode(data);
        const subKeyPair = SubKeyPair.deserializeFromStream(parent, stream);
        if (stream.hasCurrent()) {
            throw new Error("Unexpected packets " + stream.current.tag);
        }
        return subKeyPair;
    }
    static deserializeFromStream(parent, stream) {
        if (!stream.hasCurrent()) {
            throw new Error("Expected key packet");
        }
        const key = KeyPair_1.KeyPair.deserializeFromPacket(stream.current);
        const subKeyPair = new SubKeyPair(parent, key, []);
        stream.next();
        while (stream.hasCurrent() && stream.current.tag == Types_1.keystore.PacketTag.SIGNATURE) {
            subKeyPair.signatures.push(Signature_1.Signature.deserializeFromPacket(stream.current));
            stream.next();
        }
        return subKeyPair;
    }
    validate() {
        if (!super.validate() || this.parent === null) {
            return false;
        }
        const signature = this.getBindSignature();
        if (signature === null) {
            return false;
        }
        const data = {
            key: this.parent.keyPair,
            subkey: this.keyPair
        };
        if (this.hasFlag(Types_1.keystore.KeyFlag.SIGNING)) {
            const embeded = signature.getEmbeded();
            if (embeded === null || !this.verify(data, embeded) || embeded.type !== Types_1.keystore.SignatureType.PRIMARY_KEY_BINDING_SIGNATURE) {
                return false;
            }
        }
        return this.parent.verify(data, signature);
    }
}
exports.SubKeyPair = SubKeyPair;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../Enumerable":293,"../Types":324,"./KeyPair":300,"./PackagedKeyPair":304,"./Packet":305,"./Signature":308,"buffer":498}],310:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Signature_1 = require("./Signature");
const Utils_1 = require("../Utils");
const Types_1 = require("../Types");
var Subpacket;
(function (Subpacket) {
    class SubpacketBase {
        type = 0;
        serialize() {
            const body = this.getBody();
            const header = [];
            let length = body.length + 1;
            if (length < 192) {
                header.push(length);
            }
            else if (length < 8383) {
                length -= 192;
                header.push((length >> 8) + 192);
                header.push(length & 0xFF);
            }
            else {
                header.push(0xFF);
                header.push((length >> 24) & 0xFF);
                header.push((length >> 16) & 0xFF);
                header.push((length >> 8) & 0xFF);
                header.push(length & 0xFF);
            }
            header.push(this.type);
            return Buffer.concat([
                Buffer.from(header),
                body
            ]);
        }
    }
    Subpacket.SubpacketBase = SubpacketBase;
    class IssuerSubpacket extends SubpacketBase {
        keyId;
        type = Types_1.keystore.SubPacketType.ISSUER;
        constructor(keyId) {
            super();
            this.keyId = keyId;
        }
        getBody() {
            return this.keyId;
        }
    }
    Subpacket.IssuerSubpacket = IssuerSubpacket;
    class SignatureCreationTimeSubpacket extends SubpacketBase {
        timestamp;
        type = Types_1.keystore.SubPacketType.SIGNATURE_CREATION_TIME;
        constructor(timestamp = null) {
            super();
            this.timestamp = timestamp;
            if (this.timestamp === null) {
                this.timestamp = Math.floor((new Date().getTime() / 1000) + 0.5);
            }
        }
        getBody() {
            return Buffer.from([
                (this.timestamp >> 24) & 0xFF,
                (this.timestamp >> 16) & 0xFF,
                (this.timestamp >> 8) & 0xFF,
                this.timestamp & 0xFF
            ]);
        }
    }
    Subpacket.SignatureCreationTimeSubpacket = SignatureCreationTimeSubpacket;
    class KeyFlagsSubpacket extends SubpacketBase {
        type = Types_1.keystore.SubPacketType.KEY_FLAGS;
        data = null;
        get flags() {
            switch (this.data.length) {
                case 0:
                    return 0;
                case 1:
                    return this.data.readUInt8(0);
                case 2:
                    return this.data.readUInt16BE(0);
                case 3:
                    return (this.data.readUInt16BE(0) << 8) + this.data.readUInt8(2);
                default:
                    return this.data.readUInt32BE(0);
            }
        }
        constructor(flags) {
            super();
            if (!(flags instanceof Buffer)) {
                let num = flags;
                const bytes = [];
                if (num === 0) {
                    bytes.push(0);
                }
                while (num > 0) {
                    bytes.push(num & 0xFF);
                    num = num >> 8;
                }
                flags = Buffer.from(bytes.reverse());
            }
            this.data = flags;
        }
        getBody() {
            return this.data;
        }
    }
    Subpacket.KeyFlagsSubpacket = KeyFlagsSubpacket;
    class RevocationKeySubpacket extends SubpacketBase {
        algorithm;
        fingerprint;
        sensitive;
        type = Types_1.keystore.SubPacketType.REVOCATION_KEY;
        constructor(algorithm, fingerprint, sensitive = 0x40) {
            super();
            this.algorithm = algorithm;
            this.fingerprint = fingerprint;
            this.sensitive = sensitive;
        }
        getBody() {
            return Buffer.concat([
                Buffer.from([
                    this.sensitive,
                    this.algorithm
                ]),
                this.fingerprint
            ]);
        }
    }
    Subpacket.RevocationKeySubpacket = RevocationKeySubpacket;
    class EmbededSignatureSubpacket extends SubpacketBase {
        signature;
        type = Types_1.keystore.SubPacketType.EMBEDDED_SIGNATURE;
        constructor(signature) {
            super();
            this.signature = signature;
        }
        getBody() {
            return this.signature.serialize();
        }
    }
    Subpacket.EmbededSignatureSubpacket = EmbededSignatureSubpacket;
    class RevocableSubpacket extends SubpacketBase {
        revocable;
        type = Types_1.keystore.SubPacketType.REVOCABLE;
        constructor(revocable) {
            super();
            this.revocable = revocable;
        }
        getBody() {
            return Buffer.from([this.revocable]);
        }
    }
    Subpacket.RevocableSubpacket = RevocableSubpacket;
    class GenericSubpacket extends SubpacketBase {
        type;
        data;
        constructor(type, data) {
            super();
            this.type = type;
            this.data = data;
        }
        getBody() {
            return this.data;
        }
    }
    class ConiksDbIdSubpacket extends SubpacketBase {
        timestamp;
        type = Types_1.keystore.SubPacketType.CONIKS_DB_ID;
        data = null;
        constructor(id, timestamp = null) {
            super();
            this.timestamp = timestamp;
            this.data = id instanceof Buffer ? id : Buffer.from(id, "hex");
            if (this.timestamp === null) {
                this.timestamp = Math.floor((new Date().getTime() / 1000) + 0.5);
            }
        }
        getBody() {
            return Buffer.concat([
                Buffer.from([
                    (this.timestamp >> 24) & 0xFF,
                    (this.timestamp >> 16) & 0xFF,
                    (this.timestamp >> 8) & 0xFF,
                    this.timestamp & 0xFF
                ]),
                this.data
            ]);
        }
    }
    Subpacket.ConiksDbIdSubpacket = ConiksDbIdSubpacket;
    class SubpacketStream {
        bis;
        current = null;
        constructor(bis) {
            this.bis = bis;
            this.next();
        }
        hasCurrent() {
            return this.current != null;
        }
        next() {
            if (this.bis.isEnd()) {
                this.current = null;
                return;
            }
            const byte = this.bis.readUInt8();
            if (byte < 192) {
                this.current = {
                    type: this.bis.readUInt8(),
                    body: this.bis.readBuffer(byte - 1)
                };
            }
            else if (byte < 255) {
                const length = ((byte - 192) << 8) + this.bis.readUInt8() + 192;
                this.current = {
                    type: this.bis.readUInt8(),
                    body: this.bis.readBuffer(length - 1)
                };
            }
            else {
                const length = this.bis.readInt32BE();
                this.current = {
                    type: this.bis.readUInt8(),
                    body: this.bis.readBuffer(length - 1)
                };
            }
        }
    }
    Subpacket.SubpacketStream = SubpacketStream;
    function deserializeSupacket(data) {
        const type = data.type;
        const body = data.body;
        switch (type) {
            case Types_1.keystore.SubPacketType.SIGNATURE_CREATION_TIME:
                return new SignatureCreationTimeSubpacket(body.readUInt32BE(0));
            case Types_1.keystore.SubPacketType.REVOCABLE:
                return new RevocableSubpacket(body[0] === 1);
            case Types_1.keystore.SubPacketType.REVOCATION_KEY:
                return new RevocationKeySubpacket(body[1], body.slice(2), body[0]);
            case Types_1.keystore.SubPacketType.ISSUER:
                return new IssuerSubpacket(body);
            case Types_1.keystore.SubPacketType.KEY_FLAGS:
                return new KeyFlagsSubpacket(body);
            case Types_1.keystore.SubPacketType.EMBEDDED_SIGNATURE:
                return new EmbededSignatureSubpacket(Signature_1.Signature.deserialize(body));
            case Types_1.keystore.SubPacketType.CONIKS_DB_ID:
                return new ConiksDbIdSubpacket(body.slice(4), body.readUInt32BE(0));
            default:
                return new GenericSubpacket(type, body);
        }
    }
    function deserialize(data) {
        const stream = new SubpacketStream(new Utils_1.BufferInputStream(data));
        const result = [];
        while (stream.hasCurrent()) {
            result.push(deserializeSupacket(stream.current));
            stream.next();
        }
        return result;
    }
    Subpacket.deserialize = deserialize;
})(Subpacket || (Subpacket = {}));
exports.default = Subpacket;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../Types":324,"../Utils":325,"./Signature":308,"buffer":498}],311:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserId = void 0;
const Signature_1 = require("./Signature");
const Packet_1 = require("./Packet");
const Types_1 = require("../Types");
const ErrorCodes_1 = require("../ErrorCodes");
const Enumerable_1 = require("../Enumerable");
class UserId {
    parent;
    name;
    signatures = [];
    constructor(parent, name) {
        this.parent = parent;
        this.name = name;
    }
    addSignature(signature) {
        this.signatures.push(signature);
    }
    getBindSignature() {
        return (0, Enumerable_1.$A)(this.signatures)
            .findAll(x => x.type == Types_1.keystore.SignatureType.GENERIC_PK_USER_ID_CERTIFICATION ||
            x.type == Types_1.keystore.SignatureType.PERSONA_PK_USER_ID_CERTIFICATION ||
            x.type == Types_1.keystore.SignatureType.CASUAL_PK_USER_ID_CERTIFICATION ||
            x.type == Types_1.keystore.SignatureType.POSITIVE_PK_USER_ID_CERTIFICATION)
            .max((a, b) => a.getTimestamp() - b.getTimestamp());
    }
    serialize() {
        return Buffer.concat([].concat([Packet_1.Packet.encode(Buffer.from(this.name, "utf8"), Types_1.keystore.PacketTag.USER_ID)], (0, Enumerable_1.$A)(this.signatures).map(x => x.serialize()).toArray()));
    }
    static deserialize(parent, data) {
        const stream = Packet_1.Packet.decode(data);
        const userId = UserId.deserializeFromStream(parent, stream);
        if (stream.hasCurrent()) {
            throw new Error("Unexpected packets " + stream.current.tag);
        }
        return userId;
    }
    static deserializeFromStream(parent, stream) {
        if (!stream.hasCurrent()) {
            throw new Error("Expected userId packet");
        }
        const currTag = stream.current.tag;
        if (currTag !== Types_1.keystore.PacketTag.USER_ID) {
            throw {
                msg: "Incorrect tag for UserId packet",
                value: stream.current.tag,
                code: ErrorCodes_1.ErrorCodes.PARSE_FAILURE
            };
        }
        const userId = new UserId(parent, stream.current.body.toString("utf8"));
        stream.next();
        while (stream.hasCurrent() && stream.current.tag == Types_1.keystore.PacketTag.SIGNATURE) {
            userId.signatures.push(Signature_1.Signature.deserializeFromPacket(stream.current));
            stream.next();
        }
        return userId;
    }
    validate() {
        const signature = this.getBindSignature();
        if (signature == null) {
            return false;
        }
        return this.parent.verify({
            key: this.parent.keyPair,
            userId: this.name
        }, signature);
    }
}
exports.UserId = UserId;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../Enumerable":293,"../ErrorCodes":294,"../Types":324,"./Packet":305,"./Signature":308,"buffer":498}],312:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserId = exports.Subpacket = exports.SubKeyPair = exports.Signature = exports.PkiDataTypePacket = exports.PkiData = exports.PacketStream = exports.Packet = exports.PackagedKeyPair = exports.MasterKeyPair = exports.LiteralDataPacket = exports.KeyStore = exports.KeyPair = exports.EccKeyPairSerializer = exports.EccKeyPair = exports.DocumentsPacket = exports.AttachmentsStorage = exports.AttachmentPointerPacket = exports.AttachmentDataPacket = void 0;
const AttachmentDataPacket_1 = require("./AttachmentDataPacket");
Object.defineProperty(exports, "AttachmentDataPacket", { enumerable: true, get: function () { return AttachmentDataPacket_1.AttachmentDataPacket; } });
const AttachmentPointerPacket_1 = require("./AttachmentPointerPacket");
Object.defineProperty(exports, "AttachmentPointerPacket", { enumerable: true, get: function () { return AttachmentPointerPacket_1.AttachmentPointerPacket; } });
const AttachmentsStorage_1 = require("./AttachmentsStorage");
Object.defineProperty(exports, "AttachmentsStorage", { enumerable: true, get: function () { return AttachmentsStorage_1.AttachmentsStorage; } });
const DocumentsPacket_1 = require("./DocumentsPacket");
Object.defineProperty(exports, "DocumentsPacket", { enumerable: true, get: function () { return DocumentsPacket_1.DocumentsPacket; } });
const EccKeyPair_1 = require("./EccKeyPair");
Object.defineProperty(exports, "EccKeyPair", { enumerable: true, get: function () { return EccKeyPair_1.EccKeyPair; } });
Object.defineProperty(exports, "EccKeyPairSerializer", { enumerable: true, get: function () { return EccKeyPair_1.EccKeyPairSerializer; } });
const KeyPair_1 = require("./KeyPair");
Object.defineProperty(exports, "KeyPair", { enumerable: true, get: function () { return KeyPair_1.KeyPair; } });
const KeyStore_1 = require("./KeyStore");
Object.defineProperty(exports, "KeyStore", { enumerable: true, get: function () { return KeyStore_1.KeyStore; } });
const LiteralDataPacket_1 = require("./LiteralDataPacket");
Object.defineProperty(exports, "LiteralDataPacket", { enumerable: true, get: function () { return LiteralDataPacket_1.LiteralDataPacket; } });
const MasterKeyPair_1 = require("./MasterKeyPair");
Object.defineProperty(exports, "MasterKeyPair", { enumerable: true, get: function () { return MasterKeyPair_1.MasterKeyPair; } });
const PackagedKeyPair_1 = require("./PackagedKeyPair");
Object.defineProperty(exports, "PackagedKeyPair", { enumerable: true, get: function () { return PackagedKeyPair_1.PackagedKeyPair; } });
const Packet_1 = require("./Packet");
Object.defineProperty(exports, "Packet", { enumerable: true, get: function () { return Packet_1.Packet; } });
Object.defineProperty(exports, "PacketStream", { enumerable: true, get: function () { return Packet_1.PacketStream; } });
const PkiData_1 = require("./PkiData");
Object.defineProperty(exports, "PkiData", { enumerable: true, get: function () { return PkiData_1.PkiData; } });
const PkiDataTypePacket_1 = require("./PkiDataTypePacket");
Object.defineProperty(exports, "PkiDataTypePacket", { enumerable: true, get: function () { return PkiDataTypePacket_1.PkiDataTypePacket; } });
const Signature_1 = require("./Signature");
Object.defineProperty(exports, "Signature", { enumerable: true, get: function () { return Signature_1.Signature; } });
const SubKeyPair_1 = require("./SubKeyPair");
Object.defineProperty(exports, "SubKeyPair", { enumerable: true, get: function () { return SubKeyPair_1.SubKeyPair; } });
const Subpacket_1 = require("./Subpacket");
exports.Subpacket = Subpacket_1.default;
const UserId_1 = require("./UserId");
Object.defineProperty(exports, "UserId", { enumerable: true, get: function () { return UserId_1.UserId; } });

},{"./AttachmentDataPacket":295,"./AttachmentPointerPacket":296,"./AttachmentsStorage":297,"./DocumentsPacket":298,"./EccKeyPair":299,"./KeyPair":300,"./KeyStore":301,"./LiteralDataPacket":302,"./MasterKeyPair":303,"./PackagedKeyPair":304,"./Packet":305,"./PkiData":306,"./PkiDataTypePacket":307,"./Signature":308,"./SubKeyPair":309,"./Subpacket":310,"./UserId":311}],313:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BitString_1 = require("../BitString");
const Utils_1 = require("../Utils");
const MessageBase_1 = require("./MessageBase");
class AuthPathNodeMessage extends MessageBase_1.MessageBase {
    hash = null;
    auth = null;
    constructor(hash = null, auth = null) {
        super();
        if (MessageBase_1.MessageBase.isEmptyConstructor([hash, auth])) {
            return;
        }
        this.setHash(hash).setAuth(auth);
    }
    authindex(index) {
        if (this.auth instanceof BitString_1.default) {
            return this.auth;
        }
        return index.prefix(this.auth);
    }
    authhash(authindex, hash = null) {
        if (hash == null) {
            hash = this.hash;
        }
        return Utils_1.default.hash(Buffer.concat([authindex.encode(), hash]));
    }
    interhash(prev, dir) {
        const array = [this.hash, prev];
        return Utils_1.default.hash(Buffer.concat(dir ? array : array.reverse()));
    }
    setHash(hash) {
        hash = Utils_1.default.fromByteBuffer(hash);
        if (!(hash instanceof Buffer)) {
            this.incorrectFieldType("hash");
        }
        this.hash = hash;
        return this;
    }
    getHash() {
        return this.hash;
    }
    setAuth(auth) {
        auth = Utils_1.default.fromLong(auth);
        if (typeof (auth) !== "number") {
            auth = Utils_1.default.fromByteBuffer(auth);
            if (auth instanceof Buffer) {
                auth = BitString_1.default.decode(auth);
            }
            if (!(auth instanceof BitString_1.default)) {
                this.incorrectFieldType("auth");
            }
            this.auth = auth;
        }
        else {
            this.auth = auth;
        }
        return this;
    }
    getAuth() {
        return this.auth;
    }
    validate() {
        if (this.getHash() === null) {
            this.missingField("hash");
        }
        if (this.getAuth() === null) {
            this.missingField("auth");
        }
    }
    psonSerialize() {
        this.validate();
        const tmp = this.getAuth();
        return {
            "hash": this.getHash(),
            "auth": typeof (tmp) === "number" ? tmp : tmp.encode()
        };
    }
    psonDeserialize(data) {
        if (data["hash"]) {
            this.setHash(data["hash"]);
        }
        if (data["auth"]) {
            this.setAuth(data["auth"]);
        }
        this.validate();
    }
    static decode(data) {
        return MessageBase_1.MessageBase.decodeMessage(AuthPathNodeMessage, data);
    }
}
exports.default = AuthPathNodeMessage;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../BitString":290,"../Utils":325,"./MessageBase":317,"buffer":498}],314:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TreeMessage_1 = require("./TreeMessage");
const MessageBase_1 = require("./MessageBase");
const KeyStore_1 = require("../KeyStore");
class HistoryMessage extends MessageBase_1.MessageBase {
    history = null;
    serverKeystore = null;
    constructor(history = null, serverKeystore = null) {
        super();
        if (MessageBase_1.MessageBase.isEmptyConstructor([history, serverKeystore])) {
            return;
        }
        this.setHistory(history).setServerKeyStore(serverKeystore);
    }
    setHistory(history) {
        if (!Array.isArray(history)) {
            this.incorrectFieldType("history");
        }
        const tmp = [];
        for (const tree of history) {
            tmp.push(tree instanceof TreeMessage_1.default ? tree : TreeMessage_1.default.decode(tree));
        }
        this.history = tmp;
        return this;
    }
    getHistory() {
        return this.history;
    }
    setServerKeyStore(keystore) {
        this.serverKeystore = KeyStore_1.Packet.decodePacket(KeyStore_1.KeyStore, keystore);
        if (this.serverKeystore == undefined) {
            this.incorrectFieldType("serverKeystore");
        }
        return this;
    }
    getServerKeyStore() {
        return this.serverKeystore;
    }
    validate() {
        if (this.getHistory() === null) {
            this.missingField("history");
        }
        if (this.getServerKeyStore() === null) {
            this.missingField("serverKeystore");
        }
    }
    verify(keystore = null, prev = null) {
        if (keystore === null) {
            keystore = this.getServerKeyStore();
        }
        const history = this.getHistory();
        if (history.length === 0) {
            return true;
        }
        for (let i = history.length - 1; i >= 0; --i) {
            const tree = history[i];
            if (!tree.verify(keystore, i < history.length - 1) || (prev != null && !tree.getPrevTree().equals(prev.getHash()))) {
                return false;
            }
            prev = tree;
        }
        return true;
    }
    psonSerialize() {
        this.validate();
        return {
            "history": MessageBase_1.MessageBase.serializeArray(this.history),
            "serverKeystore": this.getServerKeyStore().serialize()
        };
    }
    psonDeserialize(data) {
        if (data["history"]) {
            this.setHistory(data["history"]);
        }
        if (data["serverKeystore"]) {
            this.setServerKeyStore(data["serverKeystore"]);
        }
        this.validate();
    }
    static decode(data) {
        return MessageBase_1.MessageBase.decodeMessage(HistoryMessage, data);
    }
}
exports.default = HistoryMessage;

},{"../KeyStore":312,"./MessageBase":317,"./TreeMessage":318}],315:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MessageBase_1 = require("./MessageBase");
const VRFMessage_1 = require("./VRFMessage");
const TreeMessage_1 = require("./TreeMessage");
const AuthPathNodeMessage_1 = require("./AuthPathNodeMessage");
const LeafMessage_1 = require("./LeafMessage");
const KeyStore_1 = require("../KeyStore");
class KeyStoreMessage extends MessageBase_1.MessageBase {
    vrf = null;
    tree = null;
    path = null;
    leaf = null;
    serverKeystore = null;
    constructor(vrf = null, tree = null, path = null, leaf = null, serverKeystore = null) {
        super();
        if (MessageBase_1.MessageBase.isEmptyConstructor([vrf, tree, path, leaf, serverKeystore])) {
            return;
        }
        this.setVRF(vrf).setTree(tree).setPath(path).setServerKeyStore(serverKeystore);
        if (leaf != null) {
            this.setLeaf(leaf);
        }
    }
    setVRF(vrf) {
        if (!(vrf instanceof VRFMessage_1.default)) {
            vrf = VRFMessage_1.default.decode(vrf);
        }
        this.vrf = vrf;
        return this;
    }
    getVRF() {
        return this.vrf;
    }
    setTree(tree) {
        if (!(tree instanceof TreeMessage_1.default)) {
            tree = TreeMessage_1.default.decode(tree);
        }
        this.tree = tree;
        return this;
    }
    getTree() {
        return this.tree;
    }
    setPath(path) {
        if (!Array.isArray(path)) {
            this.incorrectFieldType("path");
        }
        const tmp = [];
        for (const node of path) {
            tmp.push(node instanceof AuthPathNodeMessage_1.default ? node : AuthPathNodeMessage_1.default.decode(node));
        }
        this.path = tmp;
        return this;
    }
    getPath() {
        return this.path;
    }
    setLeaf(leaf) {
        if (!(leaf instanceof LeafMessage_1.default)) {
            leaf = LeafMessage_1.default.decode(leaf);
        }
        this.leaf = leaf;
        return this;
    }
    getLeaf() {
        return this.leaf;
    }
    setServerKeyStore(keystore) {
        this.serverKeystore = KeyStore_1.Packet.decodePacket(KeyStore_1.KeyStore, keystore);
        if (this.serverKeystore == undefined) {
            this.incorrectFieldType("serverKeystore");
        }
        return this;
    }
    getServerKeyStore() {
        return this.serverKeystore;
    }
    validate() {
        if (this.getVRF() === null) {
            this.missingField("vrf");
        }
        if (this.getTree() === null) {
            this.missingField("tree");
        }
        if (this.getPath() === null) {
            this.missingField("path");
        }
        if (this.getServerKeyStore() === null) {
            this.missingField("serverKeystore");
        }
    }
    psonSerialize() {
        this.validate();
        const result = {
            "vrf": this.getVRF().encode("array"),
            "tree": this.getTree().encode("array"),
            "path": MessageBase_1.MessageBase.serializeArray(this.getPath()),
            "serverKeystore": this.getServerKeyStore().serialize()
        };
        const tmp = this.getLeaf();
        if (tmp != null) {
            result["leaf"] = tmp.encode("array");
        }
        return result;
    }
    psonDeserialize(data) {
        if (data["vrf"]) {
            this.setVRF(data["vrf"]);
        }
        if (data["tree"]) {
            this.setTree(data["tree"]);
        }
        if (data["path"]) {
            this.setPath(data["path"]);
        }
        if (data["serverKeystore"]) {
            this.setServerKeyStore(data["serverKeystore"]);
        }
        if (data["leaf"]) {
            this.setLeaf(data["leaf"]);
        }
        this.validate();
    }
    getKeyStore() {
        const leaf = this.getLeaf();
        return leaf ? leaf.getKeyStore() : null;
    }
    verifyVRF(name, keystore) {
        if (name === null) {
            return true;
        }
        return this.getVRF().verify(name, keystore);
    }
    verifyAuthPath() {
        const index = this.getVRF().getValue();
        const leaf = this.getLeaf();
        const tree = this.getTree();
        const path = this.getPath();
        if (path.length === 0) {
            return false;
        }
        let authindex = path[0].authindex(index);
        const match = authindex.equals(index);
        if (!match && leaf != null) {
            return false;
        }
        let hash = path[0].authhash(authindex);
        if (match && !(leaf != null && leaf.getIndex().equals(index) && leaf.getHash().equals(hash))) {
            return false;
        }
        for (let i = 1; i < path.length; ++i) {
            const previndex = authindex;
            authindex = path[i].authindex(previndex);
            if (!authindex.isPrefixOf(previndex)) {
                return false;
            }
            const dir = index.bit(authindex.length);
            const interhash = path[i].interhash(hash, dir);
            hash = path[i].authhash(authindex, interhash);
        }
        return tree.getRoot().equals(hash);
    }
    verify(name = null, serverKeystore = null) {
        if (serverKeystore === null) {
            serverKeystore = this.getServerKeyStore();
        }
        const leaf = this.getLeaf();
        if (name === null && leaf != null) {
            name = leaf.getName();
        }
        return (this.verifyVRF(name, serverKeystore) &&
            this.getTree().verify(serverKeystore) &&
            (leaf != null ? leaf.verify() : true) &&
            this.verifyAuthPath());
    }
    static decode(data) {
        return MessageBase_1.MessageBase.decodeMessage(KeyStoreMessage, data);
    }
}
exports.default = KeyStoreMessage;

},{"../KeyStore":312,"./AuthPathNodeMessage":313,"./LeafMessage":316,"./MessageBase":317,"./TreeMessage":318,"./VRFMessage":320}],316:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Utils_1 = require("../Utils");
const BitString_1 = require("../BitString");
const ErrorCodes_1 = require("../ErrorCodes");
const KeyStore_1 = require("../KeyStore");
const MessageBase_1 = require("./MessageBase");
class LeafMessage extends MessageBase_1.MessageBase {
    index = null;
    hash = null;
    name = null;
    datahash = null;
    nonce = null;
    revision = null;
    keystore = null;
    kis = null;
    prevRevision = null;
    constructor(index = null, hash = null, name = null, datahash = null, revision = null, keystore = null, kis = null, nonce = null, prevRevision = null) {
        super();
        if (MessageBase_1.MessageBase.isEmptyConstructor([index, hash, name, datahash, revision, keystore, kis])) {
            return;
        }
        this.setIndex(index).setHash(hash).setName(name).setDatahash(datahash);
        this.setRevision(revision).setKeyStore(keystore).setKis(kis);
        if (nonce != null) {
            this.setNonce(nonce);
        }
        if (prevRevision != null) {
            this.setPrevRevision(prevRevision);
        }
    }
    verify() {
        if (!this.getKeyStore().verifyKis(this.getKis())) {
            return false;
        }
        return this.getKeyStore().validate();
    }
    toJSON() {
        return {
            index: this.index.encode().toString("base64"),
            name: this.name,
            hash: this.hash.toString("base64"),
            datahash: this.datahash.toString("base64"),
            nonce: this.nonce.toString("base64"),
            revision: this.revision.toString("base64"),
            key_store: this.keystore,
            kis: this.kis,
            prev_revision: this.prevRevision ? this.prevRevision.toString("base64") : null
        };
    }
    static FromJson(obj) {
        const error = (!Utils_1.default.isString(obj.index) ||
            !Utils_1.default.isString(obj.hash) ||
            !Utils_1.default.isString(obj.name) ||
            !Utils_1.default.isString(obj.datahash) ||
            !Utils_1.default.isString(obj.nonce) ||
            !Utils_1.default.isString(obj.revision) ||
            !Utils_1.default.isString(obj.key_store) ||
            !Utils_1.default.isString(obj.kis) ||
            (obj.prev_revision && !Utils_1.default.isString(obj.prev_revision)));
        if (error) {
            throw {
                msg: "Incorrect Leaf json",
                value: obj,
                code: ErrorCodes_1.ErrorCodes.PARSE_FAILURE
            };
        }
        const prevRevision = obj.prev_revision ? Utils_1.default.decodeString(obj.prev_revision) : null;
        return new LeafMessage(Utils_1.default.decodeBitString(obj.index), Utils_1.default.decodeString(obj.hash), obj.name, Utils_1.default.decodeString(obj.datahash), Utils_1.default.decodeString(obj.revision), KeyStore_1.Packet.decodePacket(KeyStore_1.KeyStore, obj.key_store), KeyStore_1.Packet.decodePacket(KeyStore_1.Signature, obj.kis), Utils_1.default.decodeString(obj.nonce), prevRevision);
    }
    setIndex(index) {
        index = Utils_1.default.fromByteBuffer(index);
        if (index instanceof Buffer) {
            index = BitString_1.default.decode(index);
        }
        if (!(index instanceof BitString_1.default)) {
            this.incorrectFieldType("index");
        }
        this.index = index;
        return this;
    }
    getIndex() {
        return this.index;
    }
    setHash(hash) {
        hash = Utils_1.default.fromByteBuffer(hash);
        if (!(hash instanceof Buffer)) {
            this.incorrectFieldType("hash");
        }
        this.hash = hash;
        return this;
    }
    getHash() {
        return this.hash;
    }
    setName(name) {
        if (typeof (name) !== "string") {
            this.incorrectFieldType("name");
        }
        this.name = name;
        return this;
    }
    getName() {
        return this.name;
    }
    setDatahash(datahash) {
        datahash = Utils_1.default.fromByteBuffer(datahash);
        if (!(datahash instanceof Buffer)) {
            this.incorrectFieldType("datahash");
        }
        this.datahash = datahash;
        return this;
    }
    getDatahash() {
        return this.datahash;
    }
    setNonce(nonce) {
        nonce = Utils_1.default.fromByteBuffer(nonce);
        if (!(nonce instanceof Buffer)) {
            this.incorrectFieldType("nonce");
        }
        this.nonce = nonce;
        return this;
    }
    getNonce() {
        return this.nonce;
    }
    setRevision(revision) {
        revision = Utils_1.default.fromByteBuffer(revision);
        if (!(revision instanceof Buffer)) {
            this.incorrectFieldType("revision");
        }
        this.revision = revision;
        return this;
    }
    getRevision() {
        return this.revision;
    }
    setKeyStore(keystore) {
        this.keystore = KeyStore_1.PkiData.decode(keystore);
        if (this.keystore == undefined) {
            this.incorrectFieldType("keystore");
        }
        return this;
    }
    getKeyStore() {
        return this.keystore;
    }
    setKis(kis) {
        this.kis = KeyStore_1.Packet.decodePacket(KeyStore_1.Signature, kis);
        if (this.kis == undefined) {
            this.incorrectFieldType("signature");
        }
        return this;
    }
    getKis() {
        return this.kis;
    }
    setPrevRevision(prevRevision) {
        prevRevision = Utils_1.default.fromByteBuffer(prevRevision);
        if (!(prevRevision instanceof Buffer)) {
            this.incorrectFieldType("prevRevision");
        }
        this.prevRevision = prevRevision;
        return this;
    }
    getPrevRevision() {
        return this.prevRevision;
    }
    validate() {
        if (this.getIndex() === null) {
            this.missingField("index");
        }
        if (this.getHash() === null) {
            this.missingField("hash");
        }
        if (this.getName() === null) {
            this.missingField("name");
        }
        if (this.getDatahash() === null) {
            this.missingField("datahash");
        }
        if (this.getRevision() === null) {
            this.missingField("revision");
        }
        if (this.getKeyStore() === null) {
            this.missingField("keystore");
        }
        if (this.getKis() === null) {
            this.missingField("kis");
        }
    }
    psonSerialize() {
        this.validate();
        const result = {
            "index": this.getIndex().encode(),
            "hash": this.getHash(),
            "name": this.getName(),
            "datahash": this.getDatahash(),
            "revision": this.getRevision(),
            "keystore": this.getKeyStore().serialize(),
            "kis": this.getKis().serialize()
        };
        const tmp = this.getNonce();
        if (tmp != null) {
            result["nonce"] = tmp;
        }
        const tmp2 = this.getPrevRevision();
        if (tmp2 != null) {
            result["prevRevision"] = tmp2;
        }
        return result;
    }
    psonDeserialize(data) {
        if (data["index"]) {
            this.setIndex(data["index"]);
        }
        if (data["hash"]) {
            this.setHash(data["hash"]);
        }
        if (data["name"] || data["name"] === "") {
            this.setName(data["name"]);
        }
        if (data["datahash"]) {
            this.setDatahash(data["datahash"]);
        }
        if (data["nonce"]) {
            this.setNonce(data["nonce"]);
        }
        if (data["revision"]) {
            this.setRevision(data["revision"]);
        }
        if (data["keystore"]) {
            this.setKeyStore(data["keystore"]);
        }
        if (data["kis"]) {
            this.setKis(data["kis"]);
        }
        if (data["prevRevision"]) {
            this.setPrevRevision(data["prevRevision"]);
        }
        this.validate();
    }
    static decode(data) {
        return MessageBase_1.MessageBase.decodeMessage(LeafMessage, data);
    }
}
exports.default = LeafMessage;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../BitString":290,"../ErrorCodes":294,"../KeyStore":312,"../Utils":325,"./MessageBase":317,"buffer":498}],317:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageBase = void 0;
const pson_1 = require("pson");
const ErrorCodes_1 = require("../ErrorCodes");
const Utils_1 = require("../Utils");
class MessageBase {
    static encoder = null;
    encode(type = "pson") {
        const data = this.psonSerialize();
        switch (type) {
            case "array":
                return data;
            default:
                const pair = MessageBase.getEncoder();
                const bbuffer = pair.encode(data);
                if (type === "buffer") {
                    return Buffer.from(bbuffer.toArrayBuffer());
                }
                return bbuffer;
        }
    }
    missingField(name) {
        throw {
            msg: "Missing required field \"" + name + "\" for class " + MessageBase.getClass(this),
            value: this,
            code: ErrorCodes_1.ErrorCodes.PARSE_FAILURE
        };
    }
    incorrectFieldType(name) {
        throw {
            msg: "Incorrect field type \"" + name + "\" for class " + MessageBase.getClass(this),
            value: this,
            code: ErrorCodes_1.ErrorCodes.PARSE_FAILURE
        };
    }
    static serializeArray(array) {
        return array.map((value) => value.psonSerialize());
    }
    static isEmptyConstructor(params) {
        for (const param of params) {
            if (param != null) {
                return false;
            }
        }
        return true;
    }
    static decodeUint64(value) {
        value = Utils_1.default.fromByteBuffer(value);
        if (!(value instanceof Buffer)) {
            return value;
        }
        let result = 0;
        for (let offset = 0; offset < value.length; ++offset) {
            result = (result * 256) + value.readUInt8(offset);
        }
        return result;
    }
    static getClass(obj) {
        const regex = /function (.{1,})\(/;
        const result = regex.exec(obj.constructor.toString());
        return result && result.length > 1 ? result[1] : "";
    }
    static getEncoder() {
        if (MessageBase.encoder === null) {
            MessageBase.encoder = new pson_1.StaticPair();
        }
        return MessageBase.encoder;
    }
    static decodeMessage(c, data) {
        const result = new c();
        data = Utils_1.default.fromByteBuffer(data);
        if (Utils_1.default.isString(data)) {
            data = Buffer.from(data);
        }
        if (data instanceof Buffer) {
            data = MessageBase.getEncoder().decode(data);
        }
        result.psonDeserialize(data);
        return result;
    }
}
exports.MessageBase = MessageBase;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../ErrorCodes":294,"../Utils":325,"buffer":498,"pson":376}],318:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Utils_1 = require("../Utils");
const KeyStore_1 = require("../KeyStore");
const MessageBase_1 = require("./MessageBase");
class TreeMessage extends MessageBase_1.MessageBase {
    version = null;
    hash = null;
    prevTree = null;
    root = null;
    timestamp = null;
    nonce = null;
    signature = null;
    seq = null;
    constructor(version = null, hash = null, prevTree = null, root = null, timestamp = null, signature = null, seq = null, nonce = null) {
        super();
        if (MessageBase_1.MessageBase.isEmptyConstructor([version, hash, prevTree, root, timestamp, signature, seq])) {
            return;
        }
        this.setVersion(version).setHash(hash).setPrevTree(prevTree).setRoot(root);
        this.setTimestamp(timestamp).setSignature(signature).setSeq(seq);
        if (nonce != null) {
            this.setNonce(nonce);
        }
    }
    verify(keystore, skipSignature = false) {
        const msg = Buffer.concat([
            Utils_1.default.buffer32b(this.getVersion()),
            this.getPrevTree(),
            this.getRoot(),
            Utils_1.default.buffer64b(this.getTimestamp()),
            this.getNonce(),
            Utils_1.default.buffer64b(this.getSeq())
        ]);
        const signature = this.getSignature();
        const pubkey = keystore.getPrimaryKey();
        if (!Utils_1.default.hash(Buffer.concat([signature.serialize(), msg])).equals(this.getHash())) {
            return false;
        }
        return skipSignature ? true : pubkey.verify({ msg: msg }, signature);
    }
    setVersion(version) {
        version = Utils_1.default.fromLong(version);
        if (typeof (version) !== "number") {
            this.incorrectFieldType("number");
        }
        this.version = version;
        return this;
    }
    getVersion() {
        return this.version;
    }
    setHash(hash) {
        hash = Utils_1.default.fromByteBuffer(hash);
        if (!(hash instanceof Buffer)) {
            this.incorrectFieldType("hash");
        }
        this.hash = hash;
        return this;
    }
    getHash() {
        return this.hash;
    }
    setPrevTree(prevTree) {
        prevTree = Utils_1.default.fromByteBuffer(prevTree);
        if (!(prevTree instanceof Buffer)) {
            this.incorrectFieldType("prevTree");
        }
        this.prevTree = prevTree;
        return this;
    }
    getPrevTree() {
        return this.prevTree;
    }
    setRoot(root) {
        root = Utils_1.default.fromByteBuffer(root);
        if (!(root instanceof Buffer)) {
            this.incorrectFieldType("root");
        }
        this.root = root;
        return this;
    }
    getRoot() {
        return this.root;
    }
    setTimestamp(timestamp) {
        timestamp = Utils_1.default.fromLong(timestamp);
        timestamp = MessageBase_1.MessageBase.decodeUint64(timestamp);
        if (typeof (timestamp) !== "number") {
            this.incorrectFieldType("timestamp");
        }
        this.timestamp = timestamp;
        return this;
    }
    getTimestamp() {
        return this.timestamp;
    }
    setNonce(nonce) {
        nonce = Utils_1.default.fromByteBuffer(nonce);
        if (!(nonce instanceof Buffer)) {
            this.incorrectFieldType("nonce");
        }
        this.nonce = nonce;
        return this;
    }
    getNonce() {
        return this.nonce;
    }
    setSignature(signature) {
        this.signature = KeyStore_1.Packet.decodePacket(KeyStore_1.Signature, signature);
        if (this.signature == undefined) {
            this.incorrectFieldType("signature");
        }
        return this;
    }
    getSignature() {
        return this.signature;
    }
    setSeq(seq) {
        seq = Utils_1.default.fromLong(seq);
        if (typeof (seq) !== "number") {
            this.incorrectFieldType("seq");
        }
        this.seq = seq;
        return this;
    }
    getSeq() {
        return this.seq;
    }
    validate() {
        if (this.getVersion() === null) {
            this.missingField("version");
        }
        if (this.getHash() === null) {
            this.missingField("hash");
        }
        if (this.getPrevTree() === null) {
            this.missingField("prevTree");
        }
        if (this.getRoot() === null) {
            this.missingField("root");
        }
        if (this.getTimestamp() === null) {
            this.missingField("timestamp");
        }
        if (this.getSignature() === null) {
            this.missingField("signature");
        }
        if (this.getSeq() === null) {
            this.missingField("seq");
        }
    }
    psonSerialize() {
        this.validate();
        const result = {
            "version": this.getVersion(),
            "hash": this.getHash(),
            "prevTree": this.getPrevTree(),
            "root": this.getRoot(),
            "timestamp": Utils_1.default.buffer64b(this.getTimestamp()),
            "signature": this.getSignature().serialize(),
            "seq": this.getSeq()
        };
        const tmp = this.getNonce();
        if (tmp === null) {
            result["nonce"] = tmp;
        }
        return result;
    }
    psonDeserialize(data) {
        if (data["version"]) {
            this.setVersion(data["version"]);
        }
        if (data["hash"]) {
            this.setHash(data["hash"]);
        }
        if (data["prevTree"]) {
            this.setPrevTree(data["prevTree"]);
        }
        if (data["root"]) {
            this.setRoot(data["root"]);
        }
        if (data["timestamp"]) {
            this.setTimestamp(data["timestamp"]);
        }
        if (data["signature"]) {
            this.setSignature(data["signature"]);
        }
        if (data["seq"] || data["seq"] === 0) {
            this.setSeq(data["seq"]);
        }
        if (data["nonce"]) {
            this.setNonce(data["nonce"]);
        }
        this.validate();
    }
    static decode(data) {
        return MessageBase_1.MessageBase.decodeMessage(TreeMessage, data);
    }
}
exports.default = TreeMessage;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../KeyStore":312,"../Utils":325,"./MessageBase":317,"buffer":498}],319:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CosignedVerifyStatus = exports.VerifyStatus = void 0;
const Utils_1 = require("../Utils");
const MessageBase_1 = require("./MessageBase");
const KeyStore_1 = require("../KeyStore");
var VerifyStatus;
(function (VerifyStatus) {
    VerifyStatus[VerifyStatus["OK"] = 0] = "OK";
    VerifyStatus[VerifyStatus["INVALID_STATE"] = 1] = "INVALID_STATE";
    VerifyStatus[VerifyStatus["HAS_INVALID"] = 2] = "HAS_INVALID";
    VerifyStatus[VerifyStatus["NO_QUORUM"] = 3] = "NO_QUORUM";
})(VerifyStatus = exports.VerifyStatus || (exports.VerifyStatus = {}));
var CosignedVerifyStatus;
(function (CosignedVerifyStatus) {
    CosignedVerifyStatus[CosignedVerifyStatus["OK"] = 0] = "OK";
    CosignedVerifyStatus[CosignedVerifyStatus["INVALID"] = 1] = "INVALID";
    CosignedVerifyStatus[CosignedVerifyStatus["MISSING"] = 2] = "MISSING";
})(CosignedVerifyStatus = exports.CosignedVerifyStatus || (exports.CosignedVerifyStatus = {}));
class TreeSignaturesMessage extends MessageBase_1.MessageBase {
    domain;
    hash;
    signatures;
    constructor(domain = null, hash = null, signatures = null) {
        super();
        if (MessageBase_1.MessageBase.isEmptyConstructor([domain, hash, signatures])) {
            return;
        }
        this.setDomain(domain).setHash(hash);
        if (signatures != null) {
            this.setSignatures(signatures);
        }
    }
    setDomain(domain) {
        if (!Utils_1.default.isString(domain)) {
            this.incorrectFieldType("domain");
        }
        this.domain = domain;
        return this;
    }
    getDomain() {
        return this.domain;
    }
    setHash(hash) {
        hash = Utils_1.default.fromByteBuffer(hash);
        if (!(hash instanceof Buffer)) {
            this.incorrectFieldType("hash");
        }
        this.hash = hash;
        return this;
    }
    getHash() {
        return this.hash;
    }
    setSignatures(signatures) {
        const tmp = {};
        for (const domain in signatures) {
            if (!Utils_1.default.isString(domain)) {
                this.incorrectFieldType("signatures (Domain)");
            }
            const sig = signatures[domain];
            let signature = KeyStore_1.Packet.decodePacket(KeyStore_1.Signature, sig);
            let info = "";
            if (signature == undefined) {
                if (typeof (sig) != "object") {
                    this.incorrectFieldType("signature");
                }
                if (typeof (sig.info) != "string") {
                    this.incorrectFieldType("signature[info]");
                }
                info = sig.info;
                if (sig.signature) {
                    if (typeof (sig.signature) != "string") {
                        this.incorrectFieldType("signature[signature type]");
                    }
                    signature = KeyStore_1.Packet.decodePacket(KeyStore_1.Signature, sig.signature);
                    if (signature == undefined) {
                        this.incorrectFieldType("signatures");
                    }
                }
            }
            tmp[domain] = {
                signature: signature,
                info: info
            };
        }
        this.signatures = tmp;
        return this;
    }
    getSignatures() {
        return this.signatures;
    }
    validate() {
        if (this.getDomain() === null) {
            this.missingField("domain");
        }
        if (this.getHash() === null) {
            this.missingField("hash");
        }
    }
    psonSerialize() {
        this.validate();
        const result = {
            "domain": this.getDomain(),
            "hash": this.getHash()
        };
        const signatures = this.getSignatures();
        if (signatures != null) {
            result["signatures"] = {};
            for (const domain in signatures) {
                const sig = signatures[domain];
                result["signatures"][domain] = {
                    signature: sig.signature ? sig.signature.serialize().toString("base64") : null,
                    info: sig.info
                };
            }
        }
        return result;
    }
    psonDeserialize(data) {
        if (data["domain"]) {
            this.setDomain(data["domain"]);
        }
        if (data["hash"]) {
            this.setHash(data["hash"]);
        }
        if (data["signatures"]) {
            this.setSignatures(data["signatures"]);
        }
        this.validate();
    }
    verify(cosigners, domain, hash) {
        const res = this.verifyFull(cosigners, domain, hash);
        return res.status === VerifyStatus.OK;
    }
    verifyFull(cosigners, domain, hash) {
        if ((domain && domain != this.getDomain()) || (hash && !hash.equals(this.getHash()))) {
            return { status: VerifyStatus.INVALID_STATE, cosigners: [] };
        }
        const count = Object.keys(cosigners).length;
        let confirmed = 0;
        if (count === 0) {
            return { status: VerifyStatus.OK, cosigners: [] };
        }
        const signatures = this.getSignatures();
        if (signatures == null) {
            return { status: VerifyStatus.INVALID_STATE, cosigners: [] };
        }
        const data = { msg: this.getHash() };
        const result = { status: VerifyStatus.OK, cosigners: [] };
        for (const domain in cosigners) {
            if (!signatures[domain]) {
                result.cosigners.push({ domain: domain, status: CosignedVerifyStatus.MISSING, info: "" });
                continue;
            }
            const sigEntry = signatures[domain];
            if (!sigEntry.signature) {
                let status = CosignedVerifyStatus.MISSING;
                if (sigEntry.info || sigEntry.info.indexOf("Incorrect tree hash") == 0 || sigEntry.info.indexOf("Missing tree for revision") == 0) {
                    status = CosignedVerifyStatus.INVALID;
                    result.status = VerifyStatus.HAS_INVALID;
                }
                result.cosigners.push({ domain: domain, status: status, info: sigEntry.info });
                continue;
            }
            const signature = sigEntry.signature;
            const key = cosigners[domain].getKeyById(signature.getIssuerId());
            if (key === null || !key.verify(data, signature)) {
                result.cosigners.push({ domain: domain, status: CosignedVerifyStatus.INVALID, info: sigEntry.info });
                result.status = VerifyStatus.HAS_INVALID;
                continue;
            }
            result.cosigners.push({ domain: domain, status: CosignedVerifyStatus.OK, info: sigEntry.info });
            confirmed += domain === this.domain ? 0.6 : 1;
        }
        if (result.status == VerifyStatus.HAS_INVALID) {
            return result;
        }
        if (confirmed * 2 <= count) {
            result.status = VerifyStatus.NO_QUORUM;
        }
        return result;
    }
    static decode(data) {
        return MessageBase_1.MessageBase.decodeMessage(TreeSignaturesMessage, data);
    }
}
exports.default = TreeSignaturesMessage;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../KeyStore":312,"../Utils":325,"./MessageBase":317,"buffer":498}],320:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BitString_1 = require("../BitString");
const ErrorCodes_1 = require("../ErrorCodes");
const Utils_1 = require("../Utils");
const MessageBase_1 = require("./MessageBase");
const KeyStore_1 = require("../KeyStore");
const BN = require("bn.js");
const elliptic = require("elliptic");
const createHash = require("create-hash");
const Types_1 = require("../Types");
const EC = elliptic.ec("secp256k1");
class VRFMessage extends MessageBase_1.MessageBase {
    value = null;
    s = null;
    t = null;
    constructor(value = null, s = null, t = null) {
        super();
        if (MessageBase_1.MessageBase.isEmptyConstructor([value, s, t])) {
            return;
        }
        this.setValue(value).setProof(s, t);
    }
    static H2(msg) {
        const sha256 = createHash("sha256");
        sha256.update(msg);
        const hash = sha256.digest();
        return new BN(hash).umod(EC.n);
    }
    static H1(msg) {
        return EC.g.mul(VRFMessage.H2(msg));
    }
    verify(msg, kstore) {
        const [s, t] = this.getProof();
        const msgBuffer = Buffer.from(msg);
        const h = VRFMessage.H1(msgBuffer);
        const v = EC.keyFromPublic(this.getValue().bytes()).getPublic();
        const keyPair = kstore.getPrimaryKey().keyPair;
        if (keyPair.getKeyAlgorithm() != Types_1.keystore.PublicKeyAlgorithm.ECDSA || !(keyPair instanceof KeyStore_1.EccKeyPair)) {
            return false;
        }
        const eccKeyPair = keyPair;
        const buffer = Buffer.concat([
            msgBuffer,
            Buffer.from(EC.g.mul(t).add(eccKeyPair.getPublic().mul(s)).encode()),
            Buffer.from(h.mul(t).add(v.mul(s)).encode())
        ]);
        return VRFMessage.H2(buffer).eq(s);
    }
    static FromJson(obj) {
        if (!obj.value || !Array.isArray(obj.proof) || (obj.proof.length != 2)) {
            throw {
                msg: "Incorrect VRF json",
                value: obj,
                code: ErrorCodes_1.ErrorCodes.PARSE_FAILURE
            };
        }
        const value = Utils_1.default.decodeBitString(obj.value);
        const s = new BN(obj.proof[0], 16);
        const t = new BN(obj.proof[1], 16);
        return new VRFMessage(value, s, t);
    }
    setValue(value) {
        value = Utils_1.default.fromByteBuffer(value);
        if (value instanceof Buffer) {
            value = BitString_1.default.decode(value);
        }
        if (!(value instanceof BitString_1.default)) {
            this.incorrectFieldType("value");
        }
        this.value = value;
        return this;
    }
    getValue() {
        return this.value;
    }
    setProof(s, t) {
        s = Utils_1.default.fromByteBuffer(s);
        if (s instanceof Buffer) {
            s = new BN(s);
        }
        if (!(s instanceof BN)) {
            this.incorrectFieldType("proof - s");
        }
        this.s = s;
        t = Utils_1.default.fromByteBuffer(t);
        if (t instanceof Buffer) {
            t = new BN(t);
        }
        if (!(t instanceof BN)) {
            this.incorrectFieldType("proof - t");
        }
        this.t = t;
        return this;
    }
    getProof() {
        if (this.s === null || this.t === null) {
            return null;
        }
        return [this.s, this.t];
    }
    validate() {
        if (this.getValue() === null) {
            this.missingField("value");
        }
        if (this.getProof() === null) {
            this.missingField("proof (s,t)");
        }
    }
    psonSerialize() {
        this.validate();
        const [s, t] = this.getProof();
        return {
            "value": this.getValue().encode(),
            "s": s.toArrayLike(Buffer),
            "t": t.toArrayLike(Buffer)
        };
    }
    psonDeserialize(data) {
        if (data["value"]) {
            this.setValue(data["value"]);
        }
        if (data["s"] && data["t"]) {
            this.setProof(data["s"], data["t"]);
        }
        this.validate();
    }
    static decode(data) {
        return MessageBase_1.MessageBase.decodeMessage(VRFMessage, data);
    }
}
exports.default = VRFMessage;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../BitString":290,"../ErrorCodes":294,"../KeyStore":312,"../Types":324,"../Utils":325,"./MessageBase":317,"bn.js":25,"buffer":498,"create-hash":50,"elliptic":52}],321:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeSignaturesMessage = exports.CosignedVerifyStatus = exports.VerifyStatus = exports.HistoryMessage = exports.KeyStoreMessage = exports.VRFMessage = exports.TreeMessage = exports.AuthPathNodeMessage = exports.LeafMessage = void 0;
const LeafMessage_1 = require("./LeafMessage");
exports.LeafMessage = LeafMessage_1.default;
const AuthPathNodeMessage_1 = require("./AuthPathNodeMessage");
exports.AuthPathNodeMessage = AuthPathNodeMessage_1.default;
const TreeMessage_1 = require("./TreeMessage");
exports.TreeMessage = TreeMessage_1.default;
const VRFMessage_1 = require("./VRFMessage");
exports.VRFMessage = VRFMessage_1.default;
const KeyStoreMessage_1 = require("./KeyStoreMessage");
exports.KeyStoreMessage = KeyStoreMessage_1.default;
const HistoryMessage_1 = require("./HistoryMessage");
exports.HistoryMessage = HistoryMessage_1.default;
const TreeSignaturesMessage_1 = require("./TreeSignaturesMessage");
exports.TreeSignaturesMessage = TreeSignaturesMessage_1.default;
const TreeSignaturesMessage_2 = require("./TreeSignaturesMessage");
Object.defineProperty(exports, "VerifyStatus", { enumerable: true, get: function () { return TreeSignaturesMessage_2.VerifyStatus; } });
Object.defineProperty(exports, "CosignedVerifyStatus", { enumerable: true, get: function () { return TreeSignaturesMessage_2.CosignedVerifyStatus; } });

},{"./AuthPathNodeMessage":313,"./HistoryMessage":314,"./KeyStoreMessage":315,"./LeafMessage":316,"./TreeMessage":318,"./TreeSignaturesMessage":319,"./VRFMessage":320}],322:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Messages_1 = require("./Messages");
const TreeSignaturesMessage_1 = require("./Messages/TreeSignaturesMessage");
const KeyStore_1 = require("./KeyStore");
const RpcClientFactory_1 = require("./RpcClientFactory");
const ErrorCodes_1 = require("./ErrorCodes");
const Cache_1 = require("./Cache");
const CosignersProvider_1 = require("./CosignersProvider");
const LoggerModule = require("simplito-logger");
class PrivmxPKI {
    clientFactory;
    static HEAD = "__HEAD";
    static SERVER_KEYSTORE = "server:";
    static CACHE_TTL = 60 * 60 * 24 * 30;
    static TREE_EXPIRATION_TIME = 65 * 60 * 1000;
    static DEFAULT_HISTORY_TIMESPAN_WHEN_HEAD_IS_NOT_AVAILABLE = 24 * 60 * 60 * 1000;
    static DEFAULT_HISTORY_COUNT_WHEN_HEAD_IS_NOT_AVAILABLE = null;
    options = null;
    logger = LoggerModule.get("dbchain.PrivmxPKI");
    cosignersProvider;
    keyStoreCache;
    fetchCache;
    historyCache;
    useDomainKeyStoreCache;
    historyTimespanWhenHeadIsNotAvailable;
    historyCountWhenHeadIsNotAvailable;
    initOptions;
    constructor(clientFactory = null, domain = null, cosignersProvider = null, keyStoreCache = null, fetchCache = null, historyCache = null) {
        this.clientFactory = clientFactory;
        if (this.clientFactory == null) {
            this.clientFactory = new RpcClientFactory_1.RpcClientFactory();
        }
        this.initOptions = domain ? this.setOptions({ domain: domain }) : Promise.resolve();
        this.cosignersProvider = cosignersProvider || new CosignersProvider_1.CosignersProvider({}, 3);
        const memoryCache = new Cache_1.MemoryCache();
        this.keyStoreCache = keyStoreCache || memoryCache;
        this.fetchCache = fetchCache || memoryCache;
        this.historyCache = historyCache || memoryCache;
        this.useDomainKeyStoreCache = false;
        this.historyTimespanWhenHeadIsNotAvailable = PrivmxPKI.DEFAULT_HISTORY_TIMESPAN_WHEN_HEAD_IS_NOT_AVAILABLE;
        this.historyCountWhenHeadIsNotAvailable = PrivmxPKI.DEFAULT_HISTORY_COUNT_WHEN_HEAD_IS_NOT_AVAILABLE;
    }
    cacheKey(prefix, suffix) {
        return prefix + "." + suffix;
    }
    async setOptions(overwrite) {
        const options = await this.overwriteOptions(overwrite);
        this.options = options;
        return true;
    }
    setClientRpcFactory(factory) {
        this.clientFactory = factory;
    }
    async getOptions() {
        await this.initOptions;
        if (this.options == null) {
            this.options = {
                domain: typeof (location) !== "undefined" ? location.host : ""
            };
        }
        return this.options;
    }
    async overwriteOptions(overwrite) {
        const options = await this.getOptions();
        if (!overwrite) {
            overwrite = {};
        }
        if (typeof (overwrite.domain) !== "string" && options.domain) {
            overwrite.domain = options.domain;
        }
        if (typeof (overwrite.noCache) !== "boolean" && options.noCache) {
            overwrite.noCache = options.noCache;
        }
        return overwrite;
    }
    async remoteCall(domain, method, params) {
        const client = await this.clientFactory.getClient(domain);
        return client.call(method, params);
    }
    async getDomainKeyStore(domain) {
        if (!this.useDomainKeyStoreCache) {
            return null;
        }
        const entry = await this.getKeyStoreFromCache(domain, PrivmxPKI.SERVER_KEYSTORE);
        if (entry == null) {
            return null;
        }
        const data = Messages_1.KeyStoreMessage.decode(entry.keyStoreRawMsg).getKeyStore();
        return data instanceof KeyStore_1.KeyStore ? data : null;
    }
    async getTreeSignatures(domain, hash, options) {
        options = options || {};
        options.failOnVerificationError = options.failOnVerificationError !== false;
        const fetchCosignersPromise = options.cosigners ? options.cosigners : this.cosignersProvider.selectCosigners();
        const [pkiOptions, cosigners] = await Promise.all([this.getOptions(), fetchCosignersPromise]);
        const params = {
            domain: domain,
            hash: hash,
            cosigners: Object.keys(cosigners)
        };
        const data = await this.remoteCall(pkiOptions.domain, "getTreeSignatures", params);
        const msg = Messages_1.TreeSignaturesMessage.decode(data);
        const verifyResult = msg.verifyFull(cosigners, domain, hash);
        const result = {
            data: data,
            msg: msg,
            result: verifyResult
        };
        if (verifyResult.status != TreeSignaturesMessage_1.VerifyStatus.OK && options.failOnVerificationError) {
            throw {
                msg: "Tree Signatures Verification failed",
                value: result,
                code2: "status-failure",
                code: ErrorCodes_1.ErrorCodes.VERIFICATION_FAILURE
            };
        }
        return result;
    }
    isValidTreeTimestamp(tree) {
        return tree.getTimestamp() + PrivmxPKI.TREE_EXPIRATION_TIME > new Date().getTime();
    }
    async getKeyStore(name, options) {
        const timestamp = Math.floor(new Date().getTime() / 1000);
        options = options || {};
        options.cacheLoad = options.cacheLoad !== false;
        options.cacheSave = options.cacheSave !== false;
        options.fetchSave = options.fetchSave !== false;
        const requestOptions = await this.overwriteOptions(options.pkiOptions);
        const cacheEntry = options.cacheLoad && options.revision == null ? await this.getKeyStoreFromCache(requestOptions.domain, name) : null;
        if (cacheEntry && cacheEntry.timestamp + PrivmxPKI.CACHE_TTL > timestamp) {
            const cacheMessage = Messages_1.KeyStoreMessage.decode(cacheEntry.keyStoreRawMsg);
            const res = {
                keyStoreRawMsg: cacheEntry.keyStoreRawMsg,
                keyStoreMsg: cacheMessage,
                keystore: cacheMessage.getKeyStore(),
                treeRawMsg: cacheEntry.treeRawMsg,
                treeMsg: Messages_1.TreeSignaturesMessage.decode(cacheEntry.treeRawMsg),
                result: cacheEntry.result,
                timestamp: cacheEntry.timestamp,
                fetchId: cacheEntry.fetchId
            };
            return res;
        }
        const params = {
            name: name,
            includeAttachments: options.includeAttachments || false,
            options: requestOptions
        };
        if (options.revision) {
            params["revision"] = options.revision;
        }
        const [messageData, serverKeystore] = await Promise.all([
            this.remoteCall(requestOptions.domain, "getKeyStore", params),
            this.getDomainKeyStore(requestOptions.domain)
        ]);
        const message = Messages_1.KeyStoreMessage.decode(messageData);
        if (!this.isValidTreeTimestamp(message.getTree())) {
            throw new Error("Tree head is too old");
        }
        if (!message.verify(params.name, serverKeystore)) {
            if (message.verify(params.name)) {
                throw {
                    msg: "Invalid Server Keystore",
                    value: message,
                    serverKeystore: serverKeystore,
                    code: ErrorCodes_1.ErrorCodes.VERIFICATION_FAILURE,
                    errorType: "invalid-server-keystore",
                    result: {
                        keyStoreRawMsg: messageData,
                        keyStoreMsg: message,
                        keystore: message.getKeyStore(),
                        timestamp: timestamp,
                        fetchId: null
                    }
                };
            }
            throw {
                msg: "Keystore Message Verification failed during get",
                value: message,
                code: ErrorCodes_1.ErrorCodes.VERIFICATION_FAILURE
            };
        }
        const treeRevision = message.getTree().getHash();
        try {
            const signatures = await this.getTreeSignatures(requestOptions.domain, treeRevision, options.treeOptions);
            const result = {
                keyStoreRawMsg: messageData,
                keyStoreMsg: message,
                keystore: message.getKeyStore(),
                treeRawMsg: signatures.data,
                treeMsg: signatures.msg,
                result: signatures.result,
                timestamp: timestamp,
                fetchId: null
            };
            if (options.fetchSave) {
                const fetchId = signatures.result.status == TreeSignaturesMessage_1.VerifyStatus.OK && options.cacheSave && options.revision == null ?
                    await this.saveNewKeyStoreFetchInCache(requestOptions.domain, name, messageData, signatures.data, signatures.result, timestamp) :
                    await this.saveKeyStoreFetchInCache(messageData, signatures.data, signatures.result, timestamp);
                result.fetchId = fetchId;
            }
            return result;
        }
        catch (_e) {
            const e = _e;
            if (e && e.code == ErrorCodes_1.ErrorCodes.VERIFICATION_FAILURE && e.code2 == "status-failure") {
                const signatures = e.value;
                const result = {
                    keyStoreRawMsg: messageData,
                    keyStoreMsg: message,
                    keystore: message.getKeyStore(),
                    treeRawMsg: signatures.data,
                    treeMsg: signatures.msg,
                    result: signatures.result,
                    timestamp: timestamp,
                    fetchId: null
                };
                e.errorType = "invalid-tree-signature";
                e.pkiResult = result;
            }
            return Promise.reject(e);
        }
    }
    async callMethodByPkiCore(method, params, paramsOverwriter) {
        const options = await this.overwriteOptions(params.options);
        const pkiParams = {
            name: params.name,
            keystore: params.data.getPublicView().serialize().toString("base64"),
            kis: params.kis.serialize().toString("base64"),
            options: options
        };
        const reqParams = paramsOverwriter ? paramsOverwriter(pkiParams) : pkiParams;
        const [value, serverKeystore] = await Promise.all([
            this.remoteCall(options.domain, method, reqParams),
            this.getDomainKeyStore(options.domain)
        ]);
        const msg = Messages_1.KeyStoreMessage.decode(value);
        if (!msg.verify(params.name, serverKeystore)) {
            throw {
                msg: "Keystore Message Verification failed after modify",
                value: msg,
                code: ErrorCodes_1.ErrorCodes.VERIFICATION_FAILURE
            };
        }
        return msg;
    }
    async unpackParams(params) {
        if (!params) {
            throw new Error("Parameters are required");
        }
        if (!params.data) {
            throw new Error("Parameter data is required");
        }
        if (!params.name) {
            if (params.data instanceof KeyStore_1.KeyStore) {
                params.name = (params.prefix || "user:") + params.data.getPrimaryUserId();
            }
            else {
                throw new Error("Parameter name is required");
            }
        }
        if (params.kis) {
            return params;
        }
        const head = await this.getHead();
        if (head == null) {
            throw {
                msg: "Cannot load head",
                value: params,
                code: ErrorCodes_1.ErrorCodes.INVALID_DATA
            };
        }
        params.kis = params.data.generateKis(head.getHash());
        return params;
    }
    async callMethodByPki(method, params, paramsOverwriter) {
        const unpackedParams = await this.unpackParams(params);
        return this.callMethodByPkiCore(method, unpackedParams, paramsOverwriter);
    }
    insertKeyStore(params) {
        return this.callMethodByPki("insertKeyStore", params);
    }
    updateKeyStore(params) {
        return this.callMethodByPki("updateKeyStore", params);
    }
    insertOrUpdateKeyStore(params) {
        return this.callMethodByPki("insertOrUpdateKeyStore", params);
    }
    async getHistory(options, revision = null, seq = 0, timestamp = 0) {
        const requestOptions = await this.overwriteOptions(options);
        this.logger.debug("getHistory requestOptions", requestOptions);
        const cacheKey = this.cacheKey(requestOptions.domain, PrivmxPKI.HEAD);
        const data = requestOptions.noCache !== true ? await this.historyCache.load(cacheKey) : null;
        const head = data ? Messages_1.TreeMessage.decode(data) : null;
        const params = {};
        if (revision !== null) {
            params.revision = revision;
        }
        if (seq > 0) {
            params.seq = seq;
        }
        else if (head) {
            params.seq = head.getSeq();
        }
        else {
            if (this.historyCountWhenHeadIsNotAvailable != null) {
                params.count = this.historyCountWhenHeadIsNotAvailable;
            }
            if (this.historyTimespanWhenHeadIsNotAvailable) {
                params.timestamp = Date.now() - this.historyTimespanWhenHeadIsNotAvailable;
            }
        }
        if (timestamp > 0) {
            params.timestamp = timestamp;
        }
        const [value, serverKeystore] = await Promise.all([
            this.remoteCall(requestOptions.domain, "getHistory", params),
            this.getDomainKeyStore(requestOptions.domain)
        ]);
        const msg = Messages_1.HistoryMessage.decode(value);
        this.logger.debug("getHistory msg", msg);
        if (!msg.verify(serverKeystore, head)) {
            throw {
                msg: "History Message Verification failed",
                value: { msg: msg, head: head },
                code: ErrorCodes_1.ErrorCodes.VERIFICATION_FAILURE
            };
        }
        if (requestOptions.noCache !== true) {
            const history = msg.getHistory();
            if (history.length > 0) {
                this.historyCache.save(cacheKey, history[0].encode("buffer"));
            }
        }
        return msg;
    }
    async getHead(options) {
        const requestOptions = await this.overwriteOptions(options);
        const msg = await this.getHistory(requestOptions);
        const history = msg.getHistory();
        this.logger.debug("getHead history", history);
        if (history && history.length > 0) {
            if (!this.isValidTreeTimestamp(history[0])) {
                throw new Error("Tree head is too old");
            }
            return history[0];
        }
        if (requestOptions.noCache === true) {
            return null;
        }
        const key = this.cacheKey(requestOptions.domain, PrivmxPKI.HEAD);
        const cached = await this.historyCache.load(key);
        this.logger.debug("getHead cached", cached);
        if (cached) {
            return Messages_1.TreeMessage.decode(cached);
        }
        return null;
    }
    getServerKeyStore(options) {
        return this.getKeyStore(PrivmxPKI.SERVER_KEYSTORE, options);
    }
    getKeyStoreCacheKey(domain, name) {
        return "keystore" + "." + "__CURRENT" + "." + domain + "." + name;
    }
    async getKeyStoreFromCache(domain, name) {
        const key = this.getKeyStoreCacheKey(domain, name);
        const fetchId = await this.keyStoreCache.load(key);
        if (fetchId == null) {
            return null;
        }
        return this.getFetchById(fetchId);
    }
    async getFetchById(fetchId) {
        const entry = await this.fetchCache.load(fetchId);
        if (entry == null) {
            return null;
        }
        const res = {
            keyStoreRawMsg: entry.keyStoreRawMsg,
            treeRawMsg: entry.treeRawMsg,
            result: entry.result,
            timestamp: entry.timestamp,
            fetchId: fetchId
        };
        return res;
    }
    async getFetchExById(fetchId) {
        const cacheEntry = await this.getFetchById(fetchId);
        if (cacheEntry == null) {
            return null;
        }
        const msg = Messages_1.KeyStoreMessage.decode(cacheEntry.keyStoreRawMsg);
        const res = {
            keyStoreRawMsg: cacheEntry.keyStoreRawMsg,
            keyStoreMsg: msg,
            keystore: msg.getKeyStore(),
            treeRawMsg: cacheEntry.treeRawMsg,
            treeMsg: Messages_1.TreeSignaturesMessage.decode(cacheEntry.treeRawMsg),
            result: cacheEntry.result,
            timestamp: cacheEntry.timestamp,
            fetchId: cacheEntry.fetchId
        };
        return res;
    }
    generateFetchId() {
        return "fetch" + "." + new Date().getTime() + "." + Math.floor(Math.random() * 1000000);
    }
    async saveKeyStoreFetchInCache(keyStore, tree, result, timestamp) {
        const fetchId = this.generateFetchId();
        const entry = {
            keyStoreRawMsg: keyStore,
            treeRawMsg: tree,
            result: result,
            timestamp: timestamp
        };
        await this.fetchCache.save(fetchId, entry);
        return fetchId;
    }
    async saveNewKeyStoreFetchInCache(domain, name, keyStore, tree, result, timestamp) {
        const fetchId = await this.saveKeyStoreFetchInCache(keyStore, tree, result, timestamp);
        const key = this.getKeyStoreCacheKey(domain, name);
        await this.keyStoreCache.save(key, fetchId);
        return fetchId;
    }
}
exports.default = PrivmxPKI;

},{"./Cache":291,"./CosignersProvider":292,"./ErrorCodes":294,"./KeyStore":312,"./Messages":321,"./Messages/TreeSignaturesMessage":319,"./RpcClientFactory":323,"simplito-logger":407}],323:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AjaxRequester = exports.RpcClientFactory = exports.RpcClient = void 0;
const pson_1 = require("pson");
const ErrorCodes_1 = require("./ErrorCodes");
class RpcClient {
    uri;
    encoder = null;
    id = 0;
    constructor(uri) {
        this.uri = uri;
        this.encoder = new pson_1.StaticPair();
    }
    handleResponse(request, data) {
        const response = this.encoder.decode(data);
        const errorData = {
            request: request,
            response: response,
            uri: this.uri
        };
        if (response.id !== request.id) {
            throw {
                msg: "Invalid rpc id",
                value: errorData,
                code: ErrorCodes_1.ErrorCodes.RPC_FAILURE
            };
        }
        if (response.error) {
            throw {
                msg: "Server returned error",
                value: errorData,
                code: ErrorCodes_1.ErrorCodes.RPC_FAILURE
            };
        }
        if (response.result === undefined) {
            throw {
                msg: "Missing result",
                value: errorData,
                code: ErrorCodes_1.ErrorCodes.RPC_FAILURE
            };
        }
        return response.result;
    }
    async call(method, params) {
        const rpc = {
            id: ++this.id,
            method: method,
            params: params
        };
        const data = Buffer.from(this.encoder.encode(rpc).toArrayBuffer());
        let response;
        try {
            response = await AjaxRequester.INSTANCE.send({
                url: this.uri,
                data: data,
                contentType: "application/octet-stream",
                method: "POST"
            });
            if (response.statusCode != 200) {
                throw new Error("Invalid status code " + response.statusCode);
            }
            return this.handleResponse(rpc, Buffer.from(response.data));
        }
        catch (error) {
            throw {
                msg: "Request error",
                value: {
                    error: error,
                    uri: this.uri,
                    request: rpc,
                    response: response
                },
                code: ErrorCodes_1.ErrorCodes.RPC_FAILURE
            };
        }
    }
}
exports.RpcClient = RpcClient;
class RpcClientFactory {
    clients = {};
    getClient(domain) {
        const uri = "https://" + domain;
        if (!this.clients[uri]) {
            this.clients[uri] = new RpcClient(uri);
        }
        return Promise.resolve(this.clients[uri]);
    }
}
exports.RpcClientFactory = RpcClientFactory;
class AjaxRequester {
    static INSTANCE = new AjaxRequester();
    send(options) {
        return new Promise((resolve, reject) => {
            const req = new XMLHttpRequest();
            req.open("POST", options.url, true);
            req.responseType = "arraybuffer";
            if (options.contentType) {
                req.setRequestHeader("Content-Type", options.contentType);
            }
            if (options.timeout) {
                req.timeout = options.timeout;
                req.ontimeout = (err) => {
                    reject(err);
                };
            }
            req.onload = (evt) => {
                const status = evt.currentTarget.status;
                resolve({
                    statusCode: status,
                    data: req.response
                });
            };
            req.onerror = (err) => {
                reject(err);
            };
            req.send(options.data);
        });
    }
}
exports.AjaxRequester = AjaxRequester;

}).call(this)}).call(this,require("buffer").Buffer)
},{"./ErrorCodes":294,"buffer":498,"pson":376}],324:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keystore = void 0;
var keystore;
(function (keystore) {
    let PacketTag;
    (function (PacketTag) {
        PacketTag[PacketTag["PUBLIC_KEY_ENCRYPTED_SESSION_KEY"] = 1] = "PUBLIC_KEY_ENCRYPTED_SESSION_KEY";
        PacketTag[PacketTag["SIGNATURE"] = 2] = "SIGNATURE";
        PacketTag[PacketTag["SYMMETRIC_KEY_ENCRYPTED_SESSION_KEY"] = 3] = "SYMMETRIC_KEY_ENCRYPTED_SESSION_KEY";
        PacketTag[PacketTag["ONE_PASS_SIGNATURE"] = 4] = "ONE_PASS_SIGNATURE";
        PacketTag[PacketTag["SECRET_KEY"] = 5] = "SECRET_KEY";
        PacketTag[PacketTag["PUBLIC_KEY"] = 6] = "PUBLIC_KEY";
        PacketTag[PacketTag["SECRET_SUBKEY"] = 7] = "SECRET_SUBKEY";
        PacketTag[PacketTag["COMPRESSED_DATA"] = 8] = "COMPRESSED_DATA";
        PacketTag[PacketTag["SYMMETRICALLY_ENCRYPTED_DATA"] = 9] = "SYMMETRICALLY_ENCRYPTED_DATA";
        PacketTag[PacketTag["MARKER_PACKET"] = 10] = "MARKER_PACKET";
        PacketTag[PacketTag["LITERAL_DATA"] = 11] = "LITERAL_DATA";
        PacketTag[PacketTag["TRUST_PACKET"] = 12] = "TRUST_PACKET";
        PacketTag[PacketTag["USER_ID"] = 13] = "USER_ID";
        PacketTag[PacketTag["PUBLIC_SUBKEY"] = 14] = "PUBLIC_SUBKEY";
        PacketTag[PacketTag["USER_ATTRIBUTE"] = 17] = "USER_ATTRIBUTE";
        PacketTag[PacketTag["SYM_ENCRYPTED_AND_INTEGRITY_PROTECTED_DATA"] = 18] = "SYM_ENCRYPTED_AND_INTEGRITY_PROTECTED_DATA";
        PacketTag[PacketTag["MODIFICATION_DETECTION_CODE"] = 19] = "MODIFICATION_DETECTION_CODE";
        PacketTag[PacketTag["PKI_DATA_TYPE"] = 60] = "PKI_DATA_TYPE";
        PacketTag[PacketTag["ATTACHMENT_POINTER"] = 61] = "ATTACHMENT_POINTER";
        PacketTag[PacketTag["ATTACHMENT_DATA"] = 62] = "ATTACHMENT_DATA";
    })(PacketTag = keystore.PacketTag || (keystore.PacketTag = {}));
    let SignatureType;
    (function (SignatureType) {
        SignatureType[SignatureType["BINARY_DOCUMENT_SIGNATURE"] = 0] = "BINARY_DOCUMENT_SIGNATURE";
        SignatureType[SignatureType["TEXT_DOCUMENT_SIGNATURE"] = 1] = "TEXT_DOCUMENT_SIGNATURE";
        SignatureType[SignatureType["STANDALONE_SIGNATURE"] = 2] = "STANDALONE_SIGNATURE";
        SignatureType[SignatureType["GENERIC_PK_USER_ID_CERTIFICATION"] = 16] = "GENERIC_PK_USER_ID_CERTIFICATION";
        SignatureType[SignatureType["PERSONA_PK_USER_ID_CERTIFICATION"] = 17] = "PERSONA_PK_USER_ID_CERTIFICATION";
        SignatureType[SignatureType["CASUAL_PK_USER_ID_CERTIFICATION"] = 18] = "CASUAL_PK_USER_ID_CERTIFICATION";
        SignatureType[SignatureType["POSITIVE_PK_USER_ID_CERTIFICATION"] = 19] = "POSITIVE_PK_USER_ID_CERTIFICATION";
        SignatureType[SignatureType["SUBKEY_BINDING_SIGNATURE"] = 24] = "SUBKEY_BINDING_SIGNATURE";
        SignatureType[SignatureType["PRIMARY_KEY_BINDING_SIGNATURE"] = 25] = "PRIMARY_KEY_BINDING_SIGNATURE";
        SignatureType[SignatureType["SIGNATURE_DIRECTLY_ON_KEY"] = 31] = "SIGNATURE_DIRECTLY_ON_KEY";
        SignatureType[SignatureType["KEY_REVOCATION_SIGNATURE"] = 32] = "KEY_REVOCATION_SIGNATURE";
        SignatureType[SignatureType["SUBKEY_REVOCATION_SIGNATURE"] = 40] = "SUBKEY_REVOCATION_SIGNATURE";
        SignatureType[SignatureType["CERTIFICATION_REVOCATION_SIGNATURE"] = 48] = "CERTIFICATION_REVOCATION_SIGNATURE";
        SignatureType[SignatureType["TIMESTAMP_SIGNATURE"] = 64] = "TIMESTAMP_SIGNATURE";
        SignatureType[SignatureType["THIRD_PARTY_CONFIRMATION_SIGNATURE"] = 80] = "THIRD_PARTY_CONFIRMATION_SIGNATURE";
    })(SignatureType = keystore.SignatureType || (keystore.SignatureType = {}));
    let PublicKeyAlgorithm;
    (function (PublicKeyAlgorithm) {
        PublicKeyAlgorithm[PublicKeyAlgorithm["RSA"] = 1] = "RSA";
        PublicKeyAlgorithm[PublicKeyAlgorithm["RSA_ENCRYPT_ONLY"] = 2] = "RSA_ENCRYPT_ONLY";
        PublicKeyAlgorithm[PublicKeyAlgorithm["RSA_SIGN_ONLY"] = 3] = "RSA_SIGN_ONLY";
        PublicKeyAlgorithm[PublicKeyAlgorithm["ELGAMAL_ENCRYPT_ONLY"] = 16] = "ELGAMAL_ENCRYPT_ONLY";
        PublicKeyAlgorithm[PublicKeyAlgorithm["DSA"] = 17] = "DSA";
        PublicKeyAlgorithm[PublicKeyAlgorithm["ECDH"] = 18] = "ECDH";
        PublicKeyAlgorithm[PublicKeyAlgorithm["ECDSA"] = 19] = "ECDSA";
        PublicKeyAlgorithm[PublicKeyAlgorithm["ELGAMAL"] = 20] = "ELGAMAL";
        PublicKeyAlgorithm[PublicKeyAlgorithm["DIFFIE_HELLMAN"] = 21] = "DIFFIE_HELLMAN";
    })(PublicKeyAlgorithm = keystore.PublicKeyAlgorithm || (keystore.PublicKeyAlgorithm = {}));
    let HashAlgorithm;
    (function (HashAlgorithm) {
        HashAlgorithm[HashAlgorithm["MD5"] = 1] = "MD5";
        HashAlgorithm[HashAlgorithm["SHA1"] = 2] = "SHA1";
        HashAlgorithm[HashAlgorithm["RIPEMD160"] = 3] = "RIPEMD160";
        HashAlgorithm[HashAlgorithm["SHA256"] = 8] = "SHA256";
        HashAlgorithm[HashAlgorithm["SHA384"] = 9] = "SHA384";
        HashAlgorithm[HashAlgorithm["SHA512"] = 10] = "SHA512";
        HashAlgorithm[HashAlgorithm["SHA224"] = 11] = "SHA224";
    })(HashAlgorithm = keystore.HashAlgorithm || (keystore.HashAlgorithm = {}));
    let SymmetricAlgorithm;
    (function (SymmetricAlgorithm) {
        SymmetricAlgorithm[SymmetricAlgorithm["PLAIN"] = 0] = "PLAIN";
        SymmetricAlgorithm[SymmetricAlgorithm["IDEA"] = 1] = "IDEA";
        SymmetricAlgorithm[SymmetricAlgorithm["TRIPLE_DES"] = 2] = "TRIPLE_DES";
        SymmetricAlgorithm[SymmetricAlgorithm["CAST5"] = 3] = "CAST5";
        SymmetricAlgorithm[SymmetricAlgorithm["BLOWFISH"] = 4] = "BLOWFISH";
        SymmetricAlgorithm[SymmetricAlgorithm["AES128"] = 7] = "AES128";
        SymmetricAlgorithm[SymmetricAlgorithm["AES192"] = 8] = "AES192";
        SymmetricAlgorithm[SymmetricAlgorithm["AES256"] = 9] = "AES256";
        SymmetricAlgorithm[SymmetricAlgorithm["TWOFISH"] = 10] = "TWOFISH";
    })(SymmetricAlgorithm = keystore.SymmetricAlgorithm || (keystore.SymmetricAlgorithm = {}));
    let SubPacketType;
    (function (SubPacketType) {
        SubPacketType[SubPacketType["SIGNATURE_CREATION_TIME"] = 2] = "SIGNATURE_CREATION_TIME";
        SubPacketType[SubPacketType["SIGNATURE_EXPIRATION_TIME"] = 3] = "SIGNATURE_EXPIRATION_TIME";
        SubPacketType[SubPacketType["EXPORTABLE_CERTIFICATION"] = 4] = "EXPORTABLE_CERTIFICATION";
        SubPacketType[SubPacketType["THRUST_SIGNATURE"] = 5] = "THRUST_SIGNATURE";
        SubPacketType[SubPacketType["REGULAR_EXPRESSION"] = 6] = "REGULAR_EXPRESSION";
        SubPacketType[SubPacketType["REVOCABLE"] = 7] = "REVOCABLE";
        SubPacketType[SubPacketType["KEY_EXPIRATION_TIME"] = 9] = "KEY_EXPIRATION_TIME";
        SubPacketType[SubPacketType["PREFERRED_SYMMETRIC_ALGORITHMS"] = 11] = "PREFERRED_SYMMETRIC_ALGORITHMS";
        SubPacketType[SubPacketType["REVOCATION_KEY"] = 12] = "REVOCATION_KEY";
        SubPacketType[SubPacketType["ISSUER"] = 16] = "ISSUER";
        SubPacketType[SubPacketType["NOTATION_DATA"] = 20] = "NOTATION_DATA";
        SubPacketType[SubPacketType["PREFERRED_HASH_ALGORITHMS"] = 21] = "PREFERRED_HASH_ALGORITHMS";
        SubPacketType[SubPacketType["PREFERRED_COMPRESSION_ALGORITHMS"] = 22] = "PREFERRED_COMPRESSION_ALGORITHMS";
        SubPacketType[SubPacketType["KEY_SERVER_PREFERENCES"] = 23] = "KEY_SERVER_PREFERENCES";
        SubPacketType[SubPacketType["PREFERRED_KEY_SERVER"] = 24] = "PREFERRED_KEY_SERVER";
        SubPacketType[SubPacketType["PRIMARY_USER_ID"] = 25] = "PRIMARY_USER_ID";
        SubPacketType[SubPacketType["POLICY_URI"] = 26] = "POLICY_URI";
        SubPacketType[SubPacketType["KEY_FLAGS"] = 27] = "KEY_FLAGS";
        SubPacketType[SubPacketType["SIGNER_USER_ID"] = 28] = "SIGNER_USER_ID";
        SubPacketType[SubPacketType["REASON_FOR_REVOCATION"] = 29] = "REASON_FOR_REVOCATION";
        SubPacketType[SubPacketType["FEATURES"] = 30] = "FEATURES";
        SubPacketType[SubPacketType["SIGNATURE_TARGET"] = 31] = "SIGNATURE_TARGET";
        SubPacketType[SubPacketType["EMBEDDED_SIGNATURE"] = 32] = "EMBEDDED_SIGNATURE";
        SubPacketType[SubPacketType["CONIKS_DB_ID"] = 110] = "CONIKS_DB_ID";
    })(SubPacketType = keystore.SubPacketType || (keystore.SubPacketType = {}));
    let KeyFlag;
    (function (KeyFlag) {
        KeyFlag[KeyFlag["CERTIFICATION"] = 1] = "CERTIFICATION";
        KeyFlag[KeyFlag["SIGNING"] = 2] = "SIGNING";
        KeyFlag[KeyFlag["ENCRYPT_COMMUNICATION"] = 4] = "ENCRYPT_COMMUNICATION";
        KeyFlag[KeyFlag["ENCRYPT_STORAGE"] = 8] = "ENCRYPT_STORAGE";
        KeyFlag[KeyFlag["SPLIT_KEY"] = 16] = "SPLIT_KEY";
        KeyFlag[KeyFlag["AUTHENTICATION"] = 32] = "AUTHENTICATION";
        KeyFlag[KeyFlag["GROUP_KEY"] = 128] = "GROUP_KEY";
    })(KeyFlag = keystore.KeyFlag || (keystore.KeyFlag = {}));
    let PkiDataType;
    (function (PkiDataType) {
        PkiDataType[PkiDataType["KEYSTORE"] = 1] = "KEYSTORE";
        PkiDataType[PkiDataType["DOCUMENT"] = 2] = "DOCUMENT";
    })(PkiDataType = keystore.PkiDataType || (keystore.PkiDataType = {}));
    let LiteralDataType;
    (function (LiteralDataType) {
        LiteralDataType[LiteralDataType["BINARY"] = 98] = "BINARY";
        LiteralDataType[LiteralDataType["TEXT"] = 116] = "TEXT";
        LiteralDataType[LiteralDataType["UTF8"] = 117] = "UTF8";
    })(LiteralDataType = keystore.LiteralDataType || (keystore.LiteralDataType = {}));
})(keystore = exports.keystore || (exports.keystore = {}));

},{}],325:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BufferOutputStream = exports.BufferInputStream = void 0;
const hash = require("create-hash");
const elliptic = require("elliptic");
const ByteBuffer = require("bytebuffer");
const Long = require("long");
const BitString_1 = require("./BitString");
const ErrorCodes_1 = require("./ErrorCodes");
const Types_1 = require("./Types");
const ec = elliptic.ec("secp256k1");
class BufferInputStream {
    buffer;
    offset;
    constructor(buffer, offset) {
        this.buffer = buffer;
        this.offset = offset;
        this.offset = offset || 0;
    }
    readInt8() {
        const value = this.buffer.readInt8(this.offset);
        this.offset++;
        return value;
    }
    readUInt8() {
        const value = this.buffer.readUInt8(this.offset);
        this.offset++;
        return value;
    }
    readInt16BE() {
        const value = this.buffer.readInt16BE(this.offset);
        this.offset += 2;
        return value;
    }
    readUInt16BE() {
        const value = this.buffer.readUInt16BE(this.offset);
        this.offset += 2;
        return value;
    }
    readInt16LE() {
        const value = this.buffer.readInt16LE(this.offset);
        this.offset += 2;
        return value;
    }
    readUInt16LE() {
        const value = this.buffer.readUInt16LE(this.offset);
        this.offset += 2;
        return value;
    }
    readInt32BE() {
        const value = this.buffer.readInt32BE(this.offset);
        this.offset += 4;
        return value;
    }
    readUInt32BE() {
        const value = this.buffer.readUInt32BE(this.offset);
        this.offset += 4;
        return value;
    }
    readInt32LE() {
        const value = this.buffer.readInt32LE(this.offset);
        this.offset += 4;
        return value;
    }
    readUInt32LE() {
        const value = this.buffer.readUInt32LE(this.offset);
        this.offset += 4;
        return value;
    }
    skip(offset) {
        this.offset += offset;
    }
    readBuffer(length) {
        const value = this.buffer.slice(this.offset, this.offset + length);
        this.offset += length;
        return value;
    }
    readOneOctetLengthBuffer() {
        const length = this.readUInt8();
        return this.readBuffer(length);
    }
    readBufferUntilEnd() {
        const value = this.buffer.slice(this.offset);
        this.offset = this.buffer.length;
        return value;
    }
    canRead(length) {
        return this.offset + length <= this.buffer.length;
    }
    isEnd() {
        return this.offset >= this.buffer.length;
    }
}
exports.BufferInputStream = BufferInputStream;
class BufferOutputStream {
    buffer;
    offset;
    constructor(buffer, offset) {
        this.buffer = buffer;
        this.offset = offset;
        this.offset = offset || 0;
    }
    writeUInt8(value) {
        this.buffer.writeUInt8(value, this.offset);
        this.offset++;
    }
    writeUInt32BE(value) {
        this.buffer.writeUInt32BE(value, this.offset);
        this.offset += 4;
    }
    skip(offset) {
        this.offset += offset;
    }
    writeBuffer(value) {
        value.copy(this.buffer, this.offset);
        this.offset += value.length;
    }
    writeOneOctetLengthBuffer(value) {
        this.writeUInt8(value.length);
        this.writeBuffer(value);
    }
}
exports.BufferOutputStream = BufferOutputStream;
class Utils {
    static hash(msg) {
        const sha256 = hash("sha256");
        sha256.update(msg);
        return sha256.digest();
    }
    static numberToBuffer(num, bytes) {
        const arr = [];
        for (let i = 0; i < bytes; ++i) {
            const byte = num & 0xff;
            arr.push(byte);
            num = (num - byte) / 256;
        }
        return Buffer.from(arr.reverse());
    }
    static buffer32b(num) {
        return this.numberToBuffer(num, 4);
    }
    static buffer64b(num) {
        return this.numberToBuffer(num, 8);
    }
    static signMessage(msg, key) {
        const signature = key.sign(this.hash(msg));
        let rhex = signature.r.toString("hex");
        let shex = signature.s.toString("hex");
        if (rhex.length % 2 == 1) {
            rhex = "0" + rhex;
        }
        if (shex.length % 2 == 1) {
            shex = "0" + shex;
        }
        return Buffer.from("1B" + rhex + shex, "hex");
    }
    static index(phrase) {
        return new BitString_1.default(this.hash(phrase));
    }
    static sign(name, value, key) {
        const msg = Buffer.concat([
            this.hash(Buffer.from(name, "ascii")),
            this.hash(Buffer.from(value, "ascii"))
        ]);
        return this.signMessage(msg, key);
    }
    static signUpdate(signature, revision, key) {
        const msg = Buffer.concat([signature, revision]);
        return this.signMessage(msg, key);
    }
    static verify(msg, signature, pubkey) {
        const key = ec.keyFromPublic(pubkey);
        let offset = 0;
        if (signature.length == 65 && signature[0] == 27) {
            offset = 1;
        }
        const sign = {
            r: signature.slice(offset, offset + 32),
            s: signature.slice(offset + 32)
        };
        return key.verify(this.hash(msg), sign);
    }
    static isString(param) {
        return ((typeof (param) == "string") || (param instanceof String));
    }
    static decodeString(param) {
        if (this.isString(param)) {
            return Buffer.from(param, "base64");
        }
        return param;
    }
    static decodeBitString(param) {
        if (this.isString(param)) {
            return BitString_1.default.decode(Buffer.from(param, "base64"));
        }
        return new BitString_1.default(param);
    }
    static fromByteBuffer(obj) {
        if (obj instanceof ByteBuffer) {
            obj = Buffer.from(obj.toArrayBuffer());
        }
        return obj;
    }
    static fromLong(obj) {
        if (obj instanceof Long) {
            obj = obj.toNumber();
        }
        return obj;
    }
    static contains(array, value) {
        return array.indexOf(value) != -1;
    }
    static containsFunc(array, func) {
        for (let i = 0; i < array.length; i++) {
            if (func(array[i], i)) {
                return true;
            }
        }
        return false;
    }
    static findAll(array, func) {
        const result = [];
        for (let i = 0; i < array.length; i++) {
            if (func(array[i], i)) {
                result.push(array[i]);
            }
        }
        return result;
    }
    static max(array, comparer) {
        let max = null;
        for (let i = 0; i < array.length; i++) {
            if (max == null || comparer(max, array[i]) < 0) {
                max = array[1];
            }
        }
        return max;
    }
    static hashAlgorithmName(hashAlgorithm) {
        switch (hashAlgorithm) {
            case Types_1.keystore.HashAlgorithm.MD5:
                return "md5";
            case Types_1.keystore.HashAlgorithm.SHA1:
                return "sha1";
            case Types_1.keystore.HashAlgorithm.RIPEMD160:
                return "ripemd160";
            case Types_1.keystore.HashAlgorithm.SHA256:
                return "sha256";
            case Types_1.keystore.HashAlgorithm.SHA384:
                return "sha384";
            case Types_1.keystore.HashAlgorithm.SHA512:
                return "sha512";
            case Types_1.keystore.HashAlgorithm.SHA224:
                return "sha224";
            default:
                throw {
                    msg: "Unknown hash algorithm",
                    value: hashAlgorithm,
                    code: ErrorCodes_1.ErrorCodes.UNSUPPORTED_FEATURE
                };
        }
    }
    static hashLength(hashAlgorithm) {
        switch (hashAlgorithm) {
            case Types_1.keystore.HashAlgorithm.MD5:
                return 16;
            case Types_1.keystore.HashAlgorithm.SHA1:
                return 20;
            case Types_1.keystore.HashAlgorithm.RIPEMD160:
                return 20;
            case Types_1.keystore.HashAlgorithm.SHA256:
                return 32;
            case Types_1.keystore.HashAlgorithm.SHA384:
                return 48;
            case Types_1.keystore.HashAlgorithm.SHA512:
                return 64;
            case Types_1.keystore.HashAlgorithm.SHA224:
                return 28;
            default:
                throw {
                    msg: "Unknown hash algorithm",
                    value: hashAlgorithm,
                    code: ErrorCodes_1.ErrorCodes.UNSUPPORTED_FEATURE
                };
        }
    }
    static hashWithAlgorithm(data, hashAlgorithm) {
        const hashed = hash(Utils.hashAlgorithmName(hashAlgorithm));
        hashed.update(data);
        return hashed.digest();
    }
}
exports.default = Utils;

}).call(this)}).call(this,require("buffer").Buffer)
},{"./BitString":290,"./ErrorCodes":294,"./Types":324,"buffer":498,"bytebuffer":48,"create-hash":50,"elliptic":52,"long":102}],326:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticPair = exports.Types = exports.rpc = exports.PrivmxPKI = exports.ErrorCodes = exports.Enumerable = exports.CosignersProvider = exports.Cache = exports.BitString = exports.messages = exports.KeyStore = exports.Helper = void 0;
const KeyStore = require("./KeyStore");
exports.KeyStore = KeyStore;
const messages = require("./Messages");
exports.messages = messages;
const BitString_1 = require("./BitString");
exports.BitString = BitString_1.default;
const Cache = require("./Cache");
exports.Cache = Cache;
const CosignersProvider = require("./CosignersProvider");
exports.CosignersProvider = CosignersProvider;
const Enumerable = require("./Enumerable");
exports.Enumerable = Enumerable;
const ErrorCodes_1 = require("./ErrorCodes");
Object.defineProperty(exports, "ErrorCodes", { enumerable: true, get: function () { return ErrorCodes_1.ErrorCodes; } });
const PrivmxPKI_1 = require("./PrivmxPKI");
exports.PrivmxPKI = PrivmxPKI_1.default;
const rpc = require("./RpcClientFactory");
exports.rpc = rpc;
const Types = require("./Types");
exports.Types = Types;
const pson_1 = require("pson");
Object.defineProperty(exports, "StaticPair", { enumerable: true, get: function () { return pson_1.StaticPair; } });
class Helper {
    static decodeKeystore(data) {
        return KeyStore.Packet.decodePacket(KeyStore.KeyStore, data);
    }
    static decodeDocuments(data) {
        return KeyStore.Packet.decodePacket(KeyStore.DocumentsPacket, data);
    }
}
exports.Helper = Helper;

},{"./BitString":290,"./Cache":291,"./CosignersProvider":292,"./Enumerable":293,"./ErrorCodes":294,"./KeyStore":312,"./Messages":321,"./PrivmxPKI":322,"./RpcClientFactory":323,"./Types":324,"pson":376}],327:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdditionalLoginStepHandler = void 0;
const RpcUtils_1 = require("./RpcUtils");
const AlertError_1 = require("./AlertError");
const SessionLostError_1 = require("./SessionLostError");
const AppHandler_1 = require("./AppHandler");
class AdditionalLoginStepHandler {
    senderFactory;
    constructor(senderFactory) {
        this.senderFactory = senderFactory;
    }
    async onAdditionalLoginStep(channel, appCredentials, host, requestTimeout, additionalLoginStep, tickets, onAdditionalLoginStep) {
        const defer = RpcUtils_1.RpcUtils.defer();
        const promiseResult = RpcUtils_1.RpcUtils.watchPromise(defer.promise);
        let requestId = 1;
        const send = async (method, params) => {
            if (promiseResult.status != "pending") {
                throw new Error("2FA already resolved");
            }
            if (tickets.length == 0) {
                defer.reject(new Error("No tickets"));
                throw new Error("No tickets");
            }
            const ticket = tickets.shift();
            const sender = this.senderFactory.createTicketSender(channel, ticket, appCredentials);
            try {
                return await AppHandler_1.AppHandler.sendApplicationFrame(sender, 2, requestTimeout, requestId++, method, params);
            }
            catch (e) {
                if (e instanceof AlertError_1.AlertError && e.isError("Invalid ticket")) {
                    defer.reject(new SessionLostError_1.SessionLostError("Invalid ticket"));
                }
                throw e;
            }
        };
        onAdditionalLoginStep(additionalLoginStep, {
            getHost: () => {
                return host;
            },
            confirm: async (model) => {
                await send("twofaChallenge", model);
                defer.resolve();
            },
            resendCode: async () => {
                await send("twofaResendCode", {});
            },
            reject: (e) => {
                defer.reject(e);
            }
        });
        return defer.promise;
    }
}
exports.AdditionalLoginStepHandler = AdditionalLoginStepHandler;

},{"./AlertError":329,"./AppHandler":330,"./RpcUtils":352,"./SessionLostError":357}],328:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AjaxChannel = void 0;
const BaseChannel_1 = require("./BaseChannel");
const AjaxRequester_1 = require("./ajax/AjaxRequester");
const RpcUtils_1 = require("./RpcUtils");
class AjaxChannel extends BaseChannel_1.BaseChannel {
    url;
    requestMap = new Set();
    constructor(url) {
        super();
        this.url = url;
    }
    async send(buffer, messagePriority, timeout) {
        const defer = RpcUtils_1.RpcUtils.executeInDefer(async () => {
            const response = await AjaxRequester_1.AjaxRequester.INSTANCE.send({
                method: "POST",
                url: this.url,
                contentType: "application/octet-stream",
                data: buffer,
                timeout: timeout,
                priority: messagePriority
            });
            if (response.statusCode != 200) {
                throw new Error("Wrong response status: " + response.statusCode);
            }
            return Buffer.from(response.data);
        });
        this.requestMap.add(defer);
        return defer.promise;
    }
    stopAll() {
        for (const request of this.requestMap) {
            request.reject({ type: "disconnected" });
        }
        this.requestMap.clear();
    }
}
exports.AjaxChannel = AjaxChannel;

}).call(this)}).call(this,require("buffer").Buffer)
},{"./BaseChannel":332,"./RpcUtils":352,"./ajax/AjaxRequester":365,"buffer":498}],329:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertError = void 0;
class AlertError extends Error {
    constructor(message) {
        super("[AlertError] " + message);
        Object.setPrototypeOf(this, AlertError.prototype);
    }
    isError(message) {
        return this.message == "[AlertError] " + message;
    }
}
exports.AlertError = AlertError;

},{}],330:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppHandler = void 0;
const RpcUtils_1 = require("./RpcUtils");
const RootLogger = require("simplito-logger");
const Scheduler_1 = require("./Scheduler");
const Logger = RootLogger.get("privmx-rpc.AppHandler");
class AppHandler {
    sender;
    idGenerator;
    options;
    timeoutChecker;
    messagesQueue;
    singleEntries;
    constructor(sender, idGenerator, options) {
        this.sender = sender;
        this.idGenerator = idGenerator;
        this.options = options;
        this.messagesQueue = new Map();
        this.singleEntries = new Map();
        this.timeoutChecker = new Scheduler_1.Scheduler(this.options.timeoutTimerValue, () => this.checkTimeouts);
    }
    call(method, params, options) {
        const priority = options.priority != null ? options.priority : this.options.defaultMessagePriority;
        const rpcEntry = this.createRpcEntry(method, params, priority, options.timeout);
        if (options.channelType == "websocket" || options.sendAlone) {
            this.singleEntries.set(rpcEntry.id, rpcEntry);
            this.sendRightNow(rpcEntry, options.channelType);
        }
        else {
            const queue = this.getOrCreateQueueByPriority(priority);
            this.addRpcEntry(rpcEntry, queue);
        }
        this.scheduleTimeoutsCheck();
        return rpcEntry.deferred.promise;
    }
    getOrCreateQueueByPriority(priority) {
        if (this.messagesQueue.has(priority)) {
            return this.messagesQueue.get(priority);
        }
        const queue = { priority: priority, scheduleId: null, entries: new Map(), entriesSize: 0 };
        this.messagesQueue.set(priority, queue);
        return queue;
    }
    createRpcEntry(method, params, priority, timeout) {
        const id = this.idGenerator.generateNewId();
        const rpcEntry = {
            id: id,
            createdAt: Date.now(),
            timeout: timeout != null ? timeout : this.options.defaultTimeout,
            method: method,
            params: params,
            serializedMessage: this.sender.serializeApplicationMessage({ id, method, params }),
            priority: priority,
            deferred: RpcUtils_1.RpcUtils.defer()
        };
        return rpcEntry;
    }
    addRpcEntry(rpcEntry, queue) {
        if (queue.entries.size >= this.options.maxMessagesCount || queue.entriesSize >= this.options.maxMessagesSize) {
            this.clearScheduleAndFlushMessagesFromQueue(queue);
        }
        queue.entries.set(rpcEntry.id, rpcEntry);
        queue.entriesSize += rpcEntry.serializedMessage.length;
        this.scheduleSend(queue);
    }
    scheduleSend(queue) {
        if (queue.scheduleId) {
            return;
        }
        queue.scheduleId = setTimeout(() => this.flushMessagesFromQueue(queue), 1);
    }
    async clearScheduleAndFlushMessagesFromQueue(queue) {
        if (queue.scheduleId) {
            clearTimeout(queue.scheduleId);
        }
        this.flushMessagesFromQueue(queue);
    }
    flushMessagesFromQueue(queue) {
        queue.scheduleId = null;
        const entries = queue.entries;
        queue.entries = new Map();
        queue.entriesSize = 0;
        this.flushMessages(entries, "ajax", queue.priority);
    }
    async flushMessages(entries, channelType, priority) {
        try {
            const values = [...entries.values()];
            const timeout = RpcUtils_1.RpcUtils.getMax(values, x => x.timeout, this.options.defaultTimeout);
            const result = await this.sendMessages(values.map(x => x.serializedMessage), channelType, priority, timeout);
            for (const res of result) {
                const entry = entries.get(res.id);
                if (!entry) {
                    Logger.warn("No matching RpcCall for", res.id);
                }
                entries.delete(res.id);
                if (res.error) {
                    entry.deferred.reject(res.error);
                }
                else {
                    entry.deferred.resolve(res.result);
                }
            }
            for (const entry of entries.values()) {
                entry.deferred.reject(new Error("No response"));
            }
        }
        catch (e) {
            for (const entry of entries.values()) {
                entry.deferred.reject(e);
            }
        }
    }
    sendRightNow(entry, channelType) {
        const map = new Map();
        map.set(entry.id, entry);
        this.flushMessages(map, channelType, entry.priority);
    }
    async sendMessages(msgs, channelType, priority, timeout) {
        return this.sender.send({
            channelType: channelType,
            messagePriority: priority,
            timeout: timeout,
            requestBuilder: async (request) => {
                for (const msg of msgs) {
                    await request.addSerializedApplicationMessage(msg);
                }
            },
            onResponse: async (reader) => {
                const result = [];
                while (reader.hasFrame()) {
                    const frame = await reader.readApplicationFrame();
                    result.push(frame.data);
                }
                return result;
            }
        });
    }
    checkTimeouts() {
        let hasMessages = false;
        for (const queue of this.messagesQueue.values()) {
            this.checkTimeoutsInMap(queue.entries);
            hasMessages = hasMessages || queue.entries.size > 0;
        }
        this.checkTimeoutsInMap(this.singleEntries);
        hasMessages = hasMessages || this.singleEntries.size > 0;
        if (hasMessages) {
            this.scheduleTimeoutsCheck();
        }
    }
    checkTimeoutsInMap(map) {
        const now = Date.now();
        const toRemove = [];
        for (const entry of map.values()) {
            if (entry.createdAt < now - entry.timeout) {
                entry.deferred.reject("timeout ( " + entry.method + ")");
                toRemove.push(entry.id);
            }
        }
        for (const id of toRemove) {
            map.delete(id);
        }
    }
    scheduleTimeoutsCheck() {
        this.timeoutChecker.schedule();
    }
    static sendApplicationFrame(sender, messagePriority, timeout, id, method, params) {
        return sender.send({
            messagePriority: messagePriority,
            timeout: timeout,
            requestBuilder: async (request) => {
                await request.addApplicationMessage({ id, method, params });
            },
            onResponse: async (reader) => {
                return reader.readAndProcessApplicationFrame();
            }
        });
    }
}
exports.AppHandler = AppHandler;

},{"./RpcUtils":352,"./Scheduler":354,"simplito-logger":407}],331:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizedConnection = void 0;
const AjaxChannel_1 = require("./AjaxChannel");
const privmx_crypto_1 = require("privmx-crypto");
const PSON = require("pson");
const WebSocketChannel_1 = require("./WebSocketChannel");
const EventDispatcher_1 = require("./EventDispatcher");
const TicketsManager_1 = require("./TicketsManager");
const AppHandler_1 = require("./AppHandler");
const IdGenerator_1 = require("./IdGenerator");
const AlertError_1 = require("./AlertError");
const ConnectionError_1 = require("./ConnectionError");
const RootLogger = require("simplito-logger");
const EventBinder_1 = require("./EventBinder");
const SessionLostError_1 = require("./SessionLostError");
const Logger = RootLogger.get("privmx-rpc.Connection");
class AuthorizedConnection {
    ajaxChannel;
    webSocketChannel;
    senderFactory;
    loginService;
    options;
    info;
    eventDispatcher;
    eventBinder;
    ticketsManager;
    idGenerator;
    sender;
    appHandler;
    ticketsCheckerId;
    destroyed;
    channelsConnected;
    sessionChecked;
    sessionEstablished;
    codec;
    executions = {};
    proxyManager;
    webSocketNotificationKeysMap = {};
    get mainChannel() {
        if (this.options.mainChannel == "ajax") {
            return this.ajaxChannel;
        }
        if (this.options.mainChannel == "websocket") {
            return this.webSocketChannel;
        }
        throw new Error("Unsupported main channel type " + this.options.mainChannel);
    }
    constructor(ajaxChannel, webSocketChannel, senderFactory, loginService, options, info, tickets) {
        this.ajaxChannel = ajaxChannel;
        this.webSocketChannel = webSocketChannel;
        this.senderFactory = senderFactory;
        this.loginService = loginService;
        this.options = options;
        this.info = info;
        this.eventBinder = new EventBinder_1.EventBinder();
        this.eventDispatcher = new EventDispatcher_1.EventDispatcher();
        this.ticketsManager = new TicketsManager_1.TicketsManager(tickets, this.options.tickets);
        this.idGenerator = new IdGenerator_1.IdGenerator();
        this.codec = new PSON.StaticPair([]);
        this.sender = {
            send: async (options) => {
                this.checkState();
                await this.checkConnectionAndSessionAndRepairIfNeeded();
                const ticket = await this.popTicket();
                const sender = this.senderFactory.createTicketSender(this.getChannelByType(options.channelType), ticket, this.options.appCredentials);
                return this.sendSafe(sender, options);
            },
            serializeApplicationMessage: msg => this.senderFactory.serializeApplicationMessage(msg)
        };
        this.proxyManager = new ProxyManager_1.ProxyManager(this.loginService, this.senderFactory, this.options, {
            create: host => {
                return {
                    send: async (buffer, priority) => {
                        return this.call("proxy", {
                            destination: host,
                            encrypt: false,
                            data: buffer
                        }, {
                            channelType: "ajax",
                            priority: priority,
                            sendAlone: true
                        });
                    }
                };
            }
        });
        this.appHandler = new AppHandler_1.AppHandler(this.sender, this.idGenerator, this.options.appHandler);
        if (this.options.tickets.checkerEnabled) {
            this.ticketsCheckerId = setInterval(async () => {
                if (!this.isConnected()) {
                    return;
                }
                if (this.needNewTickets()) {
                    try {
                        Logger.info("Fetching new tickets from interval");
                        await this.fetchNewTickets();
                    }
                    catch (e) {
                        Logger.error("Error during fetching new tickets", e);
                    }
                }
            }, this.options.tickets.checkerInterval);
        }
    }
    static async create(senderFactory, loginService, channel, webSocketChannel, options, info, tickets) {
        const ajaxChannel = channel || new AjaxChannel_1.AjaxChannel(options.url);
        if (options.websocket && webSocketChannel == null) {
            webSocketChannel = new WebSocketChannel_1.WebSocketChannel(options.url, options.websocketOptions);
            await webSocketChannel.connect();
        }
        const conn = new AuthorizedConnection(ajaxChannel, webSocketChannel, senderFactory, loginService, options, info, tickets);
        if (options.websocket) {
            conn.eventBinder.with(webSocketChannel, x => x.addEventListener("disconnected", event => conn.onConnectionLost(event.cause)));
            if (options.notifications) {
                await conn.authorizeWebSocket();
            }
        }
        conn.channelsConnected = true;
        conn.sessionChecked = true;
        conn.sessionEstablished = true;
        return conn;
    }
    async reconnectWebSocket() {
        this.clearWebSocket();
        const webSocketChannel = new WebSocketChannel_1.WebSocketChannel(this.options.url, this.options.websocketOptions);
        try {
            await webSocketChannel.connect();
        }
        catch (e) {
            throw new ConnectionError_1.ConnectionError(e);
        }
        await this.performPlainTestPing(webSocketChannel);
        if (!webSocketChannel.isConnected()) {
            throw new ConnectionError_1.ConnectionError({ type: "disconnected" });
        }
        this.webSocketChannel = webSocketChannel;
        this.eventBinder.with(webSocketChannel, x => x.addEventListener("disconnected", event => this.onConnectionLost(event.cause)));
    }
    clearWebSocket() {
        if (this.webSocketChannel) {
            this.eventBinder.clearFor(this.webSocketChannel);
            this.webSocketChannel.notifyCallback = null;
            this.webSocketChannel.disconnect();
            this.webSocketChannel = null;
            this.webSocketNotificationKeysMap = {};
        }
    }
    clearAjaxChannel() {
        if (this.ajaxChannel && this.ajaxChannel instanceof AjaxChannel_1.AjaxChannel) {
            this.ajaxChannel.stopAll();
        }
    }
    async authorizeWebSocket() {
        const key = privmx_crypto_1.service.randomBytes(32);
        const ticket = this.popFirstTicketForHandshake();
        const sender = this.senderFactory.createTicketSender(this.webSocketChannel, ticket, this.options.appCredentials);
        const res = await this.sendApplicationFrameAndFetchTicketsIfNeeded(sender, "authorizeWebSocket", { key: key.toString("base64"), addWsChannelId: true }, this.options.connectionRequestTimeout);
        this.webSocketNotificationKeysMap[res.wsChannelId] = key;
        this.webSocketChannel.notifyCallback = async (cipher) => {
            const wsChannelId = cipher.readUInt32BE(0);
            const key = this.webSocketNotificationKeysMap[wsChannelId];
            if (!key) {
                throw new Error("Unknown wsChannelId");
            }
            const msgData = cipher.slice(4);
            const data = await privmx_crypto_1.service.aes256CbcHmac256Decrypt(msgData, key);
            const notification = this.codec.decode(data);
            this.eventDispatcher.dispatchEvent({ type: "notification", notificationType: notification.type, data: notification.data });
        };
    }
    async sendApplicationFrame(sender, method, params, timeout) {
        return this.sendSafe(sender, {
            messagePriority: 2,
            timeout: timeout || this.options.appHandler.defaultTimeout,
            requestBuilder: async (request) => {
                await this.addApplicationMessageToRequest(request, method, params);
            },
            onResponse: async (reader) => {
                return reader.readAndProcessApplicationFrame();
            }
        });
    }
    async sendApplicationFrameAndFetchTicketsIfNeeded(sender, method, params, timeout) {
        if (this.needNewTickets()) {
            return this.sendSafe(sender, {
                messagePriority: 2,
                timeout: this.options.tickets.fetchTicketsTimeout,
                requestBuilder: async (request) => {
                    await request.addNewTicketsRequestMessage(this.options.tickets.ticketsCount);
                    await this.addApplicationMessageToRequest(request, method, params);
                },
                onResponse: async (reader, request) => {
                    const tickets = await reader.readTicketsResponse(request.getCipherState().masterSecret);
                    this.addTickets(tickets);
                    return reader.readAndProcessApplicationFrame();
                }
            });
        }
        return this.sendApplicationFrame(sender, method, params, timeout);
    }
    async addApplicationMessageToRequest(request, method, params) {
        return request.addApplicationMessage({
            id: this.idGenerator.generateNewId(),
            method: method,
            params: params
        });
    }
    async sendSafe(sender, options) {
        try {
            return await sender.send(options);
        }
        catch (e) {
            if (e instanceof ConnectionError_1.ConnectionError) {
                this.onConnectionLost(e.cause);
            }
            if (e instanceof AlertError_1.AlertError && e.isError("Invalid ticket")) {
                this.onSessionLost("Invalid ticket");
                throw new SessionLostError_1.SessionLostError("Invalid ticket");
            }
            throw e;
        }
    }
    async singleExecution(name, func) {
        if (this.executions[name]) {
            return this.executions[name];
        }
        return this.executions[name] = (async () => {
            try {
                await func();
            }
            finally {
                this.executions[name] = null;
            }
        })();
    }
    getChannelByType(type) {
        if (type == "ajax") {
            return this.ajaxChannel;
        }
        if (type == "websocket") {
            return this.webSocketChannel;
        }
        throw new Error("Unsupported channel type " + type);
    }
    async popTicket() {
        while (this.needNewTickets()) {
            await this.fetchNewTickets();
        }
        return this.popFirstTicketForHandshake();
    }
    async fetchNewTickets() {
        return this.singleExecution("fetchingTickets", async () => {
            const ticket = this.popFirstTicketForHandshake();
            const sender = this.senderFactory.createTicketSender(this.mainChannel, ticket, this.options.appCredentials);
            const tickets = await this.fetchNewTicketsCore(sender);
            this.addTickets(tickets);
        });
    }
    async fetchNewTicketsCore(sender) {
        return this.sendSafe(sender, {
            messagePriority: 2,
            timeout: this.options.tickets.fetchTicketsTimeout,
            requestBuilder: async (request) => {
                await request.addNewTicketsRequestMessage(this.options.tickets.ticketsCount);
            },
            onResponse: async (reader, request) => {
                return reader.readTicketsResponse(request.getCipherState().masterSecret);
            }
        });
    }
    needNewTickets() {
        return this.options.tickets.checkTickets && this.ticketsManager.needNewTickets();
    }
    checkTicketsPresent() {
        if (!this.ticketsManager.hasTickets()) {
            this.onSessionLost("No tickets");
            throw new SessionLostError_1.SessionLostError("No tickets");
        }
    }
    popFirstTicketForHandshake() {
        this.checkTicketsPresent();
        return this.ticketsManager.popFirstTicketForHandshake().ticket;
    }
    addTickets(tickets) {
        if (tickets.length > 0) {
            this.ticketsManager.addTickets(tickets);
            this.sessionEstablished = true;
        }
    }
    onSessionLost(cause) {
        if (!this.sessionEstablished) {
            return;
        }
        this.channelsConnected = false;
        this.sessionChecked = false;
        this.sessionEstablished = false;
        this.ticketsManager.clear();
        this.clearWebSocket();
        this.eventDispatcher.dispatchEvent({ type: "sessionLost", cause: cause });
    }
    async performPlainTestPing(channel) {
        return this.performTestPing(this.senderFactory.createPlainSender(channel, this.options.appCredentials), "plain");
    }
    async performTicketTest(channel) {
        const ticket = this.popFirstTicketForHandshake();
        const sender = this.senderFactory.createTicketSender(channel, ticket, this.options.appCredentials);
        if (this.needNewTickets()) {
            const tickets = await this.fetchNewTicketsCore(sender);
            this.addTickets(tickets);
        }
        else {
            await this.performTestPing(sender, "ticket");
        }
    }
    async performTestPing(sender, pingType) {
        const result = await this.sendApplicationFrame(sender, "ping", {}, this.options.connectionRequestTimeout);
        if (result != "pong") {
            throw new Error("Recovery " + pingType + " + ping failed");
        }
    }
    checkState() {
        this.checkDestroyed();
        this.checkSessionEstablished();
    }
    checkDestroyed() {
        if (this.destroyed) {
            throw new Error("Connection destroyed");
        }
    }
    checkSessionEstablished() {
        if (!this.sessionEstablished) {
            throw new SessionLostError_1.SessionLostError("Session lost");
        }
    }
    onConnectionLost(cause) {
        if (!this.channelsConnected) {
            return;
        }
        this.channelsConnected = false;
        this.sessionChecked = false;
        this.clearWebSocket();
        this.eventDispatcher.dispatchEvent({ type: "disconnected", cause: cause });
    }
    async checkConnectionAndSessionAndRepairIfNeeded() {
        await this.checkConnectionAndRepairIfNeeded();
        await this.checkSessionAndRepairIfNeeded();
    }
    async checkConnectionAndRepairIfNeeded() {
        if (this.channelsConnected) {
            return;
        }
        return this.singleExecution("repairingConnection", async () => {
            if (this.options.websocket) {
                await this.reconnectWebSocket();
            }
            else {
                await this.performPlainTestPing(this.ajaxChannel);
            }
            this.channelsConnected = true;
        });
    }
    async checkSessionAndRepairIfNeeded() {
        if (this.sessionChecked) {
            return;
        }
        return this.singleExecution("repairingSession", async () => {
            if (this.options.websocket) {
                if (this.options.notifications && this.webSocketChannel.notifyCallback == null) {
                    await this.authorizeWebSocket();
                }
                else {
                    await this.performTicketTest(this.webSocketChannel);
                }
            }
            else {
                await this.performTicketTest(this.ajaxChannel);
            }
            this.sessionChecked = true;
            this.eventDispatcher.dispatchEvent({ type: "connected" });
        });
    }
    isConnected() {
        return !this.destroyed && this.channelsConnected && this.sessionChecked && this.sessionEstablished;
    }
    isSessionEstablished() {
        return this.sessionEstablished;
    }
    getInfo() {
        return this.info;
    }
    getHost() {
        return this.options.host;
    }
    getOptions() {
        return this.options;
    }
    async call(method, params, options) {
        this.checkState();
        const opts = { channelType: this.options.mainChannel, ...(options || {}) };
        return this.appHandler.call(method, params, opts);
    }
    async proxy(host, method, params, options) {
        if (host == this.options.host) {
            return this.call(method, params, options);
        }
        this.checkState();
        const connection = await this.proxyManager.getProxyConnection(host);
        return connection.call(method, params, options);
    }
    async verifyConnection() {
        this.checkState();
        await this.checkConnectionAndSessionAndRepairIfNeeded();
    }
    destroy() {
        if (this.destroyed) {
            return;
        }
        this.destroyed = true;
        this.channelsConnected = false;
        this.sessionChecked = false;
        this.sessionEstablished = false;
        this.ticketsManager.clear();
        this.eventBinder.clear();
        this.eventDispatcher.clear();
        if (this.ticketsCheckerId) {
            clearInterval(this.ticketsCheckerId);
            this.ticketsCheckerId = null;
        }
        this.clearWebSocket();
        this.clearAjaxChannel();
        this.ajaxChannel = null;
    }
    addEventListener(type, eventListener) {
        this.eventDispatcher.addEventListener(type, eventListener);
    }
    removeEventListener(type, eventListener) {
        this.eventDispatcher.removeEventListener(type, eventListener);
    }
}
exports.AuthorizedConnection = AuthorizedConnection;
const ProxyManager_1 = require("./ProxyManager");

},{"./AjaxChannel":328,"./AlertError":329,"./AppHandler":330,"./ConnectionError":333,"./EventBinder":337,"./EventDispatcher":338,"./IdGenerator":341,"./ProxyManager":348,"./SessionLostError":357,"./TicketsManager":362,"./WebSocketChannel":364,"privmx-crypto":265,"pson":376,"simplito-logger":407}],332:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseChannel = void 0;
const EventDispatcher_1 = require("./EventDispatcher");
class BaseChannel {
    eventDispatcher;
    disconnected;
    constructor() {
        this.eventDispatcher = new EventDispatcher_1.EventDispatcher();
    }
    disconnect() {
        if (this.disconnected) {
            return;
        }
        this.disconnected = true;
        this.eventDispatcher.dispatchEvent({ type: "disconnected", cause: "Manual disconnect" });
    }
    addEventListener(type, eventListener) {
        this.eventDispatcher.addEventListener(type, eventListener);
    }
    removeEventListener(type, eventListener) {
        this.eventDispatcher.removeEventListener(type, eventListener);
    }
}
exports.BaseChannel = BaseChannel;

},{"./EventDispatcher":338}],333:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionError = void 0;
class ConnectionError extends Error {
    cause;
    constructor(cause) {
        super("[ConnectionError]" + (cause && cause.message ? " " + cause.message : (cause && cause.type ? " type=" + cause.type : "")));
        this.cause = cause;
        Object.setPrototypeOf(this, ConnectionError.prototype);
    }
}
exports.ConnectionError = ConnectionError;

},{}],334:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionManager = void 0;
const AjaxChannel_1 = require("./AjaxChannel");
const privmx_crypto_1 = require("privmx-crypto");
const WebSocketChannel_1 = require("./WebSocketChannel");
const AuthorizedConnection_1 = require("./AuthorizedConnection");
const AppHandler_1 = require("./AppHandler");
const PlainConnection_1 = require("./PlainConnection");
const RpcUtils_1 = require("./RpcUtils");
class ConnectionManager {
    loginService;
    senderFactory;
    additionalLoginStepHandler;
    constructor(loginService, senderFactory, additionalLoginStepHandler) {
        this.loginService = loginService;
        this.senderFactory = senderFactory;
        this.additionalLoginStepHandler = additionalLoginStepHandler;
    }
    async createEcdheConnection(auth, options) {
        const fullOptions = this.fillOptions(options);
        const key = auth.key || privmx_crypto_1.serviceSync.eccPrivRandom();
        const channel = await this.createChannel(fullOptions.mainChannel, fullOptions.url, fullOptions.websocketOptions);
        const result = await this.loginService.ecdheLogin(channel, key, {
            agent: fullOptions.agent,
            requestTimeout: fullOptions.connectionRequestTimeout,
            ticketsCount: fullOptions.tickets.ticketsCount,
            serverAgentValidator: fullOptions.serverAgentValidator,
            appCredentials: fullOptions.appCredentials,
        });
        return this.createAuthorizedConnection(channel, fullOptions, {
            type: "ecdhe",
            key: key.getPublicKey()
        }, result.tickets);
    }
    async createSrpConnection(auth, options) {
        const fullOptions = this.fillOptions(options);
        const channel = await this.createChannel(fullOptions.mainChannel, fullOptions.url, fullOptions.websocketOptions);
        const result = await this.loginService.srpLogin(channel, auth, {
            overEcdhe: fullOptions.overEcdhe,
            restorableSession: fullOptions.restorableSession,
            host: fullOptions.host,
            agent: fullOptions.agent,
            requestTimeout: fullOptions.connectionRequestTimeout,
            ticketsCount: fullOptions.tickets.ticketsCount,
            serverAgentValidator: fullOptions.serverAgentValidator,
            appCredentials: fullOptions.appCredentials,
        });
        if (result.additionalLoginStep) {
            await this.additionalLoginStepHandler.onAdditionalLoginStep(channel, fullOptions.appCredentials, fullOptions.host, fullOptions.connectionRequestTimeout, result.additionalLoginStep, result.tickets, auth.onAdditionalLoginStep);
        }
        return this.createAuthorizedConnection(channel, fullOptions, {
            type: "srp",
            sessionId: result.sessionId,
            sessionKey: result.sessionKey,
            username: auth.username,
            mixed: result.mixed,
            properties: auth.properties
        }, result.tickets);
    }
    async createKeyConnection(auth, options) {
        const fullOptions = this.fillOptions(options);
        const channel = await this.createChannel(fullOptions.mainChannel, fullOptions.url, fullOptions.websocketOptions);
        const result = await this.loginService.keyLogin(channel, auth, {
            overEcdhe: fullOptions.overEcdhe,
            restorableSession: fullOptions.restorableSession,
            agent: fullOptions.agent,
            requestTimeout: fullOptions.connectionRequestTimeout,
            ticketsCount: fullOptions.tickets.ticketsCount,
            serverAgentValidator: fullOptions.serverAgentValidator,
            appCredentials: fullOptions.appCredentials,
        });
        if (result.additionalLoginStep) {
            await this.additionalLoginStepHandler.onAdditionalLoginStep(channel, fullOptions.appCredentials, fullOptions.host, fullOptions.connectionRequestTimeout, result.additionalLoginStep, result.tickets, auth.onAdditionalLoginStep);
        }
        return this.createAuthorizedConnection(channel, fullOptions, {
            type: "key",
            sessionId: result.sessionId,
            sessionKey: result.sessionKey,
            key: auth.key.getPublicKey(),
            username: result.username,
            properties: auth.properties
        }, result.tickets);
    }
    async createSessionConnection(auth, options) {
        const fullOptions = this.fillOptions(options);
        const channel = await this.createChannel(fullOptions.mainChannel, fullOptions.url, fullOptions.websocketOptions);
        const result = await this.loginService.sessionRestore(channel, auth, {
            overEcdhe: fullOptions.overEcdhe,
            agent: fullOptions.agent,
            requestTimeout: fullOptions.connectionRequestTimeout,
            ticketsCount: fullOptions.tickets.ticketsCount,
            serverAgentValidator: fullOptions.serverAgentValidator,
            appCredentials: fullOptions.appCredentials,
        });
        return this.createAuthorizedConnection(channel, fullOptions, {
            type: "session",
            sessionId: auth.sessionId,
            sessionKey: auth.sessionKey,
            username: auth.username,
            properties: auth.properties
        }, result.tickets);
    }
    createPlainConnection(options) {
        const fullOptions = this.fillOptions(options);
        const channel = new AjaxChannel_1.AjaxChannel(fullOptions.url);
        const sender = this.senderFactory.createPlainSender(channel, options.appCredentials);
        const senderEx = {
            send: options => sender.send(options),
            serializeApplicationMessage: msg => this.senderFactory.serializeApplicationMessage(msg)
        };
        return new PlainConnection_1.PlainConnection(senderEx, fullOptions);
    }
    async probe(url, appCredentials, timeout) {
        const channel = new AjaxChannel_1.AjaxChannel(url);
        const sender = this.senderFactory.createPlainSender(channel, appCredentials);
        await AppHandler_1.AppHandler.sendApplicationFrame(sender, 2, timeout || 10000, 1, "ping", {});
    }
    async createChannel(channelType, url, options) {
        if (channelType == "ajax") {
            return new AjaxChannel_1.AjaxChannel(url);
        }
        else if (channelType == "websocket") {
            const channel = new WebSocketChannel_1.WebSocketChannel(url, options);
            await channel.connect();
            return channel;
        }
        throw new Error("Unsupported channel type " + channelType);
    }
    async createAuthorizedConnection(channel, options, info, tickets) {
        const ajaxChannel = channel instanceof AjaxChannel_1.AjaxChannel ? channel : null;
        const webSocketChannel = channel instanceof WebSocketChannel_1.WebSocketChannel ? channel : null;
        return AuthorizedConnection_1.AuthorizedConnection.create(this.senderFactory, this.loginService, ajaxChannel, webSocketChannel, options, info, tickets);
    }
    fillOptions(options) {
        const res = {
            agent: "privmx-rpc",
            mainChannel: "ajax",
            websocket: true,
            notifications: true,
            overEcdhe: true,
            restorableSession: true,
            serverAgentValidator: null,
            connectionRequestTimeout: 15000,
            ...options,
            tickets: {
                ticketsCount: 50,
                checkTickets: true,
                checkerEnabled: true,
                checkerInterval: 10000,
                minTicketsCount: 10,
                ttlThreshold: 60 * 1000,
                minTicketTTL: 5 * 1000,
                fetchTicketsTimeout: 10000,
                ...(options.tickets ? options.tickets : {})
            },
            appHandler: {
                timeoutTimerValue: 500,
                defaultTimeout: 40000,
                defaultMessagePriority: 2,
                maxMessagesCount: 4,
                maxMessagesSize: 1024 * 1024,
                ...(options.appHandler ? options.appHandler : {})
            },
            websocketOptions: {
                connectTimeout: 5000,
                disconnectOnHeartBeatTimeout: true,
                heartBeatTimeout: 5000,
                pingTimeout: 5000,
                onHeartBeatCallback: () => { },
                ...(options.websocketOptions ? options.websocketOptions : {})
            }
        };
        if (!RpcUtils_1.RpcUtils.isValidHostname(options.host)) {
            throw new Error("Invalid host");
        }
        if (res.mainChannel == "websocket" && !res.websocket) {
            throw new Error("Websocket cannot be main channel when it is disabled");
        }
        return res;
    }
}
exports.ConnectionManager = ConnectionManager;

},{"./AjaxChannel":328,"./AppHandler":330,"./AuthorizedConnection":331,"./PlainConnection":346,"./RpcUtils":352,"./WebSocketChannel":364,"privmx-crypto":265}],335:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECUtils = void 0;
const elliptic_1 = require("elliptic");
const RpcUtils_1 = require("./RpcUtils");
class ECUtils {
    static generateEcdheKey() {
        const ec = new elliptic_1.ec("secp256k1");
        return ec.genKeyPair();
    }
    static decodePublicKey(publicKey) {
        const ec = new elliptic_1.ec("secp256k1");
        return ec.keyFromPublic(RpcUtils_1.RpcUtils.createBufferFromBytesLike(publicKey));
    }
    static deriveKey(priv, pub) {
        const derived = priv.derive(pub.getPublic());
        return RpcUtils_1.RpcUtils.fillTo32(ECUtils.convertBnToBuffer(derived));
    }
    static convertBnToBuffer(bn) {
        return Buffer.from(bn.toString("hex", 2).trim(), "hex");
    }
}
exports.ECUtils = ECUtils;

}).call(this)}).call(this,require("buffer").Buffer)
},{"./RpcUtils":352,"buffer":498,"elliptic":52}],336:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EcdheService = void 0;
const ECUtils_1 = require("./ECUtils");
class EcdheService {
    async ecdheHandshake(sender, key, agent, requestTimeout, ticketCount, serverAgentValidator) {
        return sender.send({
            messagePriority: 2,
            timeout: requestTimeout,
            requestBuilder: async (request) => {
                await request.addEcdheHandshakeMessage(key.key, agent);
                await request.addNewTicketsRequestMessage(ticketCount);
            },
            onResponse: async (reader, request) => {
                const frame = await reader.readEcdheHandshakeFrame();
                if (serverAgentValidator) {
                    serverAgentValidator(frame.data.agent);
                }
                const derived = this.deriveKey(key.key, frame.data.key);
                const tickets = await reader.switchToPreMasterAndReadTickets(derived, request);
                const result = {
                    tickets: tickets
                };
                return result;
            }
        });
    }
    deriveKey(priv, pub) {
        return ECUtils_1.ECUtils.deriveKey(priv, ECUtils_1.ECUtils.decodePublicKey(pub));
    }
}
exports.EcdheService = EcdheService;

},{"./ECUtils":335}],337:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBinder = void 0;
class EventBinder {
    list = [];
    with(eventTarget, func) {
        func({
            addEventListener: (type, eventListener) => {
                this.list.push({ eventTarget: eventTarget, type: type, eventListener: eventListener });
                eventTarget.addEventListener(type, eventListener);
            }
        });
    }
    clearFor(eventTarget) {
        this.list.filter(entry => {
            if (entry.eventTarget == eventTarget) {
                entry.eventTarget.removeEventListener(entry.type, entry.eventListener);
                return false;
            }
            return true;
        });
    }
    clear() {
        for (const entry of this.list) {
            entry.eventTarget.removeEventListener(entry.type, entry.eventListener);
        }
        this.list = [];
    }
}
exports.EventBinder = EventBinder;

},{}],338:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventDispatcher = void 0;
const RootLogger = require("simplito-logger");
const Logger = RootLogger.get("privmx-rpc.EventDispatcher");
class EventDispatcher {
    eventListeners;
    constructor() {
        this.eventListeners = {};
    }
    addEventListener(type, eventListener) {
        if (!(type in this.eventListeners)) {
            this.eventListeners[type] = [];
        }
        this.eventListeners[type].push(eventListener);
    }
    removeEventListener(type, eventListener) {
        if (!(type in this.eventListeners)) {
            return;
        }
        let index = this.eventListeners[type].indexOf(eventListener);
        if (index != -1) {
            this.eventListeners[type].splice(index, 1);
        }
    }
    dispatchEvent(event) {
        if (event.type in this.eventListeners) {
            this.eventListeners[event.type].forEach(eventListener => {
                try {
                    eventListener(event);
                }
                catch (e) {
                    Logger.error({
                        message: "Uncaught exception during dispatching event",
                        eventListener: eventListener,
                        event: event,
                        cause: e
                    });
                }
            });
        }
    }
    clear() {
        this.eventListeners = {};
    }
}
exports.EventDispatcher = EventDispatcher;

},{"simplito-logger":407}],339:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrameSerializer = void 0;
const Types_1 = require("./Types");
const privmx_crypto_1 = require("privmx-crypto");
const RootLogger = require("simplito-logger");
const RpcUtils_1 = require("./RpcUtils");
let Logger = RootLogger.get("privmx-rpc.RpcUtils");
class FrameSerializer {
    version = 1;
    maxDataLengthForSyncHmac = 256;
    async parseHeader(input, readState) {
        const result = {
            headerLength: 0,
            macLength: 0,
            iv: null,
            frameSeed: null,
            frameLength: 0,
            frameContentType: Types_1.ContentType.ALERT,
        };
        let rawHeader;
        if (!readState.initialized) {
            result.headerLength = 8;
            rawHeader = input.slice(0, 8);
        }
        else {
            const encryptedHeader = input.slice(0, 16);
            result.macLength = 16;
            result.headerLength = 16;
            result.iv = Buffer.from(encryptedHeader);
            const decryptedHeader = await privmx_crypto_1.service.aes256EcbDecrypt(encryptedHeader, readState.key);
            if (Logger.getLevel() == Logger.DEBUG) {
                Logger.debug("parseHeader: readState.key", readState.key.toString("hex"));
                Logger.debug("parseHeader: decrypted header", decryptedHeader.toString("hex"));
            }
            rawHeader = decryptedHeader.slice(0, 8);
            const frameHeaderTag = decryptedHeader.slice(8, 16);
            const seq = Buffer.alloc(8);
            seq.writeUInt32BE(readState.sequenceNumber >> 8, 0);
            seq.writeUInt32BE(readState.sequenceNumber & 0x00ff, 4);
            result.frameSeed = RpcUtils_1.RpcUtils.concat2Buffers(seq, rawHeader);
            const hmac = await privmx_crypto_1.service.hmacSha256(readState.macKey, result.frameSeed);
            const expectedTag = hmac.slice(0, 8);
            if (!frameHeaderTag.equals(expectedTag)) {
                throw new Error("Invalid frame TAG in: " + rawHeader.toString("hex"));
            }
        }
        const frameVersion = rawHeader.readUInt8(0);
        if (frameVersion != this.version) {
            throw new Error("Unsupported version");
        }
        result.frameContentType = rawHeader.readUInt8(1);
        result.frameLength = rawHeader.readUInt32BE(2);
        if (result.frameLength == 0) {
            result.macLength = 0;
        }
        return result;
    }
    async readFrameData(headerInfo, readState, input) {
        if (headerInfo.frameLength == 0) {
            return Buffer.alloc(0);
        }
        const cipher = input.slice(headerInfo.headerLength, headerInfo.headerLength + headerInfo.frameLength);
        if (!readState.initialized) {
            return cipher;
        }
        const macData = RpcUtils_1.RpcUtils.concat3Buffers(headerInfo.frameSeed, headerInfo.iv, cipher);
        const data = await privmx_crypto_1.service.hmacSha256(readState.macKey, macData);
        const expectedMac = data.slice(0, 16);
        const frameMac = input.slice(headerInfo.headerLength + headerInfo.frameLength, headerInfo.headerLength + headerInfo.frameLength + 16);
        if (!frameMac.equals(expectedMac)) {
            throw new Error("Invalid frame MAC");
        }
        return privmx_crypto_1.service.aes256CbcPkcs7Decrypt(cipher, readState.key, headerInfo.iv);
    }
    buildHeader(contentType, frameLength) {
        const header = Buffer.alloc(8);
        header.writeUInt8(this.version, 0);
        header.writeUInt8(contentType, 1);
        header.writeUInt32BE(frameLength, 2);
        header.writeUInt8(0, 6);
        header.writeUInt8(0, 7);
        return header;
    }
    async buildFrame(packet, writeState, contentType = Types_1.ContentType.APPLICATION_DATA) {
        if (!writeState.initialized) {
            const header = this.buildHeader(contentType, packet.length);
            const result = RpcUtils_1.RpcUtils.concat2Buffers(header, packet);
            if (Logger.getLevel() == Logger.DEBUG) {
                Logger.debug("sending plain - message:", result.toString("hex"));
            }
            return result;
        }
        Logger.debug("Creating encrypted message");
        let frameLength = packet.length;
        if (frameLength > 0) {
            frameLength = ((frameLength + 16) >> 4) << 4;
        }
        const rawHeader = this.buildHeader(contentType, frameLength);
        let seq = Buffer.alloc(8);
        seq.writeUInt32BE(writeState.sequenceNumber >> 8, 0);
        seq.writeUInt32BE(writeState.sequenceNumber & 0x00ff, 4);
        const frameSeed = RpcUtils_1.RpcUtils.concat2Buffers(seq, rawHeader);
        const data = await privmx_crypto_1.service.hmacSha256(writeState.macKey, frameSeed);
        const frameHeaderTag = data.slice(0, 8);
        const headerToEncrypt = RpcUtils_1.RpcUtils.concat2Buffers(rawHeader, frameHeaderTag);
        if (Logger.getLevel() == Logger.DEBUG) {
            Logger.debug("source header:", headerToEncrypt.toString("hex"));
        }
        const encryptedHeader = await privmx_crypto_1.service.aes256EcbEncrypt(headerToEncrypt, writeState.key);
        if (Logger.getLevel() == Logger.DEBUG) {
            Logger.debug("encrypted header: ", encryptedHeader.toString("hex"));
        }
        writeState.sequenceNumber += 1;
        let result;
        if (frameLength == 0) {
            result = encryptedHeader;
        }
        else {
            const iv = Buffer.from(encryptedHeader);
            const encryptedFrameData = await privmx_crypto_1.service.aes256CbcPkcs7Encrypt(packet, writeState.key, iv);
            const allData = RpcUtils_1.RpcUtils.concat3Buffers(frameSeed, iv, encryptedFrameData);
            const res = await privmx_crypto_1.service.hmacSha256(writeState.macKey, allData);
            const frameMac = res.slice(0, 16);
            result = RpcUtils_1.RpcUtils.concat3Buffers(encryptedHeader, encryptedFrameData, frameMac);
        }
        if (Logger.getLevel() == Logger.DEBUG) {
            Logger.debug("sending encrypted - key:", writeState.key.toString("hex"));
            Logger.debug("sending encrypted - macKey:", writeState.macKey.toString("hex"));
            Logger.debug("sending encrypted - message:", result.toString("hex"));
        }
        return result;
    }
}
exports.FrameSerializer = FrameSerializer;

}).call(this)}).call(this,require("buffer").Buffer)
},{"./RpcUtils":352,"./Types":363,"buffer":498,"privmx-crypto":265,"simplito-logger":407}],340:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOC = void 0;
const PSON = require("pson");
const FrameSerializer_1 = require("./FrameSerializer");
const RpcRequestBuilder_1 = require("./RpcRequestBuilder");
const ResponseReader_1 = require("./ResponseReader");
const ConnectionManager_1 = require("./ConnectionManager");
const EcdheService_1 = require("./EcdheService");
const SrpService_1 = require("./SrpService");
const KeyService_1 = require("./KeyService");
const SenderFactory_1 = require("./SenderFactory");
const LoginService_1 = require("./LoginService");
const AdditionalLoginStepHandler_1 = require("./AdditionalLoginStepHandler");
const ProxyConnectionManager_1 = require("./ProxyConnectionManager");
const SessionRestoreService_1 = require("./SessionRestoreService");
class IOC {
    codec;
    frameSerializer;
    rpcRequestBuilder;
    responseReaderFactory;
    senderFactory;
    connectionManager;
    loginService;
    additionalLoginStepHandler;
    proxyConnectionManager;
    getCodec() {
        if (this.codec == null) {
            this.codec = new PSON.StaticPair(["type", "ticket", "tickets", "ticket_id", "ticket_request", "ticket_response", "ecdhe", "ecdh", "key", "count", "client_random"]);
        }
        return this.codec;
    }
    getFrameSerializer() {
        if (this.frameSerializer == null) {
            this.frameSerializer = new FrameSerializer_1.FrameSerializer();
        }
        return this.frameSerializer;
    }
    getRpcRequestBuilder() {
        if (this.rpcRequestBuilder == null) {
            this.rpcRequestBuilder = new RpcRequestBuilder_1.RpcRequestBuilder(this.getCodec(), this.getFrameSerializer());
        }
        return this.rpcRequestBuilder;
    }
    getResponseReaderFactory() {
        if (this.responseReaderFactory == null) {
            this.responseReaderFactory = new ResponseReader_1.ResponseReaderFactory(this.getCodec(), this.getFrameSerializer());
        }
        return this.responseReaderFactory;
    }
    getSenderFactory() {
        if (this.senderFactory == null) {
            this.senderFactory = new SenderFactory_1.SenderFactory(this.getRpcRequestBuilder(), this.getResponseReaderFactory());
        }
        return this.senderFactory;
    }
    getAdditionalLoginStepHandler() {
        if (this.additionalLoginStepHandler == null) {
            this.additionalLoginStepHandler = new AdditionalLoginStepHandler_1.AdditionalLoginStepHandler(this.getSenderFactory());
        }
        return this.additionalLoginStepHandler;
    }
    getConnectionManager() {
        if (this.connectionManager == null) {
            this.connectionManager = new ConnectionManager_1.ConnectionManager(this.getLoginService(), this.getSenderFactory(), this.getAdditionalLoginStepHandler());
        }
        return this.connectionManager;
    }
    getProxyConnectionManager() {
        if (this.proxyConnectionManager == null) {
            this.proxyConnectionManager = new ProxyConnectionManager_1.ProxyConnectionManager(this.getLoginService(), this.getSenderFactory(), this.getAdditionalLoginStepHandler());
        }
        return this.proxyConnectionManager;
    }
    getLoginService() {
        if (this.loginService == null) {
            this.loginService = new LoginService_1.LoginService(new EcdheService_1.EcdheService(), new SrpService_1.SrpService(), new KeyService_1.KeyService(), new SessionRestoreService_1.SessionRestoreService(), this.getSenderFactory());
        }
        return this.loginService;
    }
}
exports.IOC = IOC;

},{"./AdditionalLoginStepHandler":327,"./ConnectionManager":334,"./EcdheService":336,"./FrameSerializer":339,"./KeyService":342,"./LoginService":344,"./ProxyConnectionManager":347,"./ResponseReader":349,"./RpcRequestBuilder":351,"./SenderFactory":356,"./SessionRestoreService":358,"./SrpService":360,"pson":376}],341:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdGenerator = void 0;
class IdGenerator {
    id = 0;
    generateNewId() {
        return this.id++;
    }
}
exports.IdGenerator = IdGenerator;

},{}],342:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyService = void 0;
const KeyUtils_1 = require("./KeyUtils");
const privmx_crypto_1 = require("privmx-crypto");
class KeyService {
    async keyHandshake(sender, priv, properties, agent, requestTimeout, ticketCount, serverAgentValidator, restorableSession) {
        const step1 = await sender.send({
            messagePriority: 2,
            timeout: requestTimeout,
            requestBuilder: async (request) => {
                await request.addKeyInitMessage(priv.getPublicKey(), agent, properties);
            },
            onResponse: async (reader) => {
                const frame = await reader.readKeyInitFrame();
                if (serverAgentValidator) {
                    serverAgentValidator(frame.data.agent);
                }
                const K = await this.prepareBigKFromBase58Pub(priv, frame.data.pub);
                const signatureInfo = await KeyUtils_1.KeyUtils.prepareLoginSignature(priv, K.encrypted);
                return { K, ...signatureInfo, sessionId: frame.data.sessionId, username: frame.data.I };
            }
        });
        const sessionKey = restorableSession ? privmx_crypto_1.serviceSync.eccPrivRandom() : null;
        return sender.send({
            messagePriority: 2,
            timeout: requestTimeout,
            requestBuilder: async (request) => {
                const publicSessionKey = sessionKey ? sessionKey.getPublicKey() : null;
                await request.addKeyExchangeMessage(step1.sessionId, step1.nonce, step1.timestamp, step1.K.encrypted, step1.signature, 0, publicSessionKey);
                await request.addNewTicketsRequestMessage(ticketCount);
            },
            onResponse: async (reader, request) => {
                const frame = await reader.readKeyExchangeFrame();
                const tickets = await reader.switchToPreMasterAndReadTickets(step1.K.raw, request);
                const result = {
                    username: step1.username,
                    tickets: tickets,
                    sessionId: step1.sessionId,
                    sessionKey: sessionKey,
                    additionalLoginStep: frame.data.additionalLoginStep
                };
                return result;
            }
        });
    }
    async prepareBigKFromBase58Pub(priv, pub58) {
        const pub = privmx_crypto_1.ecc.PublicKey.fromBase58DER(pub58);
        return KeyUtils_1.KeyUtils.prepareBigK(priv, pub);
    }
}
exports.KeyService = KeyService;

},{"./KeyUtils":343,"privmx-crypto":265}],343:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyUtils = void 0;
const privmx_crypto_1 = require("privmx-crypto");
class KeyUtils {
    static async prepareBigK(priv, pub) {
        const K = privmx_crypto_1.service.randomBytes(32);
        const encryptedK = await privmx_crypto_1.service.eciesEncrypt(priv, pub, K);
        const encodedK = encryptedK.toString("base64");
        return { raw: K, encrypted: encodedK };
    }
    static async prepareLoginSignature(priv, encryptedK) {
        const nonce = privmx_crypto_1.service.randomBytes(32).toString("base64");
        const timestamp = Date.now().toString();
        const signatureData = "login" + encryptedK + " " + nonce + " " + timestamp;
        const signature = await privmx_crypto_1.service.signToCompactSignatureWithHash(priv, Buffer.from(signatureData, "utf8"));
        return { nonce, timestamp, signature };
    }
}
exports.KeyUtils = KeyUtils;

}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":498,"privmx-crypto":265}],344:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginService = void 0;
const privmx_crypto_1 = require("privmx-crypto");
class LoginService {
    ecdheService;
    srpService;
    keyService;
    sessionRestoreService;
    senderFactory;
    constructor(ecdheService, srpService, keyService, sessionRestoreService, senderFactory) {
        this.ecdheService = ecdheService;
        this.srpService = srpService;
        this.keyService = keyService;
        this.sessionRestoreService = sessionRestoreService;
        this.senderFactory = senderFactory;
    }
    async ecdheLogin(channel, key, options) {
        const sender = this.senderFactory.createPlainSender(channel, options.appCredentials);
        return this.ecdheService.ecdheHandshake(sender, key, options.agent, options.requestTimeout, options.ticketsCount, options.serverAgentValidator);
    }
    async srpLogin(channel, auth, options) {
        const sender = options.overEcdhe ? await this.createEcdheSender(channel, options.agent, options.requestTimeout, 2, options.serverAgentValidator, options.appCredentials) : this.senderFactory.createPlainSender(channel, options.appCredentials);
        return this.srpService.srpHandshake(sender, options.host, auth.username, auth.password, auth.properties, options.agent, options.requestTimeout, options.ticketsCount, options.serverAgentValidator, options.restorableSession);
    }
    async keyLogin(channel, auth, options) {
        const sender = options.overEcdhe ? await this.createEcdheSender(channel, options.agent, options.requestTimeout, 2, options.serverAgentValidator, options.appCredentials) : this.senderFactory.createPlainSender(channel, options.appCredentials);
        return this.keyService.keyHandshake(sender, auth.key, auth.properties, options.agent, options.requestTimeout, options.ticketsCount, options.serverAgentValidator, options.restorableSession);
    }
    async sessionRestore(channel, auth, options) {
        const sender = options.overEcdhe ? await this.createEcdheSender(channel, options.agent, options.requestTimeout, 1, options.serverAgentValidator, options.appCredentials) : this.senderFactory.createPlainSender(channel, options.appCredentials);
        return this.sessionRestoreService.sessionHandshake(sender, auth.sessionId, auth.sessionKey, options.requestTimeout, options.ticketsCount, options.serverAgentValidator);
    }
    async createEcdheSender(channel, agent, requestTimeout, ticketsCount, serverAgentValidator, appCredentials) {
        const key = privmx_crypto_1.serviceSync.eccPrivRandom();
        const sender = this.senderFactory.createPlainSender(channel, appCredentials);
        const { tickets } = await this.ecdheService.ecdheHandshake(sender, key, agent, requestTimeout, ticketsCount, serverAgentValidator);
        return this.senderFactory.createTicketsSender(channel, tickets, appCredentials);
    }
}
exports.LoginService = LoginService;

},{"privmx-crypto":265}],345:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessagesBuffer = void 0;
const RpcUtils_1 = require("./RpcUtils");
class MessagesBuffer {
    messages;
    messagesSize;
    constructor() {
        this.messages = [];
        this.messagesSize = 0;
    }
    addMessage(message) {
        this.messages.push(message);
        this.messagesSize += message.length;
    }
    getMessageSize() {
        return this.messagesSize;
    }
    getMessagesCount() {
        return this.messages.length;
    }
    getBuffer() {
        return RpcUtils_1.RpcUtils.concatBuffers(this.messages);
    }
}
exports.MessagesBuffer = MessagesBuffer;

},{"./RpcUtils":352}],346:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlainConnection = void 0;
const AppHandler_1 = require("./AppHandler");
const IdGenerator_1 = require("./IdGenerator");
class PlainConnection {
    sender;
    options;
    idGenerator;
    appHandler;
    constructor(sender, options) {
        this.sender = sender;
        this.options = options;
        this.idGenerator = new IdGenerator_1.IdGenerator();
        this.appHandler = new AppHandler_1.AppHandler(this.sender, this.idGenerator, this.options.appHandler);
    }
    async call(method, params, options) {
        const opts = { channelType: this.options.mainChannel, ...(options || {}) };
        return this.appHandler.call(method, params, opts);
    }
}
exports.PlainConnection = PlainConnection;

},{"./AppHandler":330,"./IdGenerator":341}],347:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProxyConnectionManager = void 0;
const privmx_crypto_1 = require("privmx-crypto");
const AuthorizedConnection_1 = require("./AuthorizedConnection");
const AppHandler_1 = require("./AppHandler");
const RpcUtils_1 = require("./RpcUtils");
class ProxyConnectionManager {
    loginService;
    senderFactory;
    additionalLoginStepHandler;
    constructor(loginService, senderFactory, additionalLoginStepHandler) {
        this.loginService = loginService;
        this.senderFactory = senderFactory;
        this.additionalLoginStepHandler = additionalLoginStepHandler;
    }
    async createEcdheConnection(baseConnection, auth, options) {
        const fullOptions = this.fillOptions(baseConnection.getOptions(), options);
        const key = auth.key || privmx_crypto_1.serviceSync.eccPrivRandom();
        const channel = this.createChannel(baseConnection, fullOptions.host);
        const result = await this.loginService.ecdheLogin(channel, key, {
            agent: fullOptions.agent,
            requestTimeout: fullOptions.connectionRequestTimeout,
            ticketsCount: fullOptions.tickets.ticketsCount,
            serverAgentValidator: fullOptions.serverAgentValidator,
            appCredentials: fullOptions.appCredentials,
        });
        return this.createAuthorizedConnection(channel, fullOptions, {
            type: "ecdhe",
            key: key.getPublicKey()
        }, result.tickets);
    }
    async createSrpConnection(baseConnection, auth, options) {
        const fullOptions = this.fillOptions(baseConnection.getOptions(), options);
        const channel = this.createChannel(baseConnection, fullOptions.host);
        const result = await this.loginService.srpLogin(channel, auth, {
            overEcdhe: fullOptions.overEcdhe,
            restorableSession: fullOptions.restorableSession,
            host: fullOptions.host,
            agent: fullOptions.agent,
            requestTimeout: fullOptions.connectionRequestTimeout,
            ticketsCount: fullOptions.tickets.ticketsCount,
            serverAgentValidator: fullOptions.serverAgentValidator,
            appCredentials: fullOptions.appCredentials,
        });
        if (result.additionalLoginStep) {
            await this.additionalLoginStepHandler.onAdditionalLoginStep(channel, fullOptions.appCredentials, fullOptions.host, fullOptions.connectionRequestTimeout, result.additionalLoginStep, result.tickets, auth.onAdditionalLoginStep);
        }
        return this.createAuthorizedConnection(channel, fullOptions, {
            type: "srp",
            sessionId: result.sessionId,
            sessionKey: result.sessionKey,
            username: auth.username,
            mixed: result.mixed,
            properties: auth.properties
        }, result.tickets);
    }
    async createKeyConnection(baseConnection, auth, options) {
        const fullOptions = this.fillOptions(baseConnection.getOptions(), options);
        const channel = this.createChannel(baseConnection, fullOptions.host);
        const result = await this.loginService.keyLogin(channel, auth, {
            overEcdhe: fullOptions.overEcdhe,
            restorableSession: fullOptions.restorableSession,
            agent: fullOptions.agent,
            requestTimeout: fullOptions.connectionRequestTimeout,
            ticketsCount: fullOptions.tickets.ticketsCount,
            serverAgentValidator: fullOptions.serverAgentValidator,
            appCredentials: fullOptions.appCredentials,
        });
        if (result.additionalLoginStep) {
            await this.additionalLoginStepHandler.onAdditionalLoginStep(channel, fullOptions.appCredentials, fullOptions.host, fullOptions.connectionRequestTimeout, result.additionalLoginStep, result.tickets, auth.onAdditionalLoginStep);
        }
        return this.createAuthorizedConnection(channel, fullOptions, {
            type: "key",
            sessionId: result.sessionId,
            sessionKey: result.sessionKey,
            key: auth.key.getPublicKey(),
            username: result.username,
            properties: auth.properties
        }, result.tickets);
    }
    async createSessionConnection(baseConnection, auth, options) {
        const fullOptions = this.fillOptions(baseConnection.getOptions(), options);
        const channel = this.createChannel(baseConnection, fullOptions.host);
        const result = await this.loginService.sessionRestore(channel, auth, {
            overEcdhe: fullOptions.overEcdhe,
            agent: fullOptions.agent,
            requestTimeout: fullOptions.connectionRequestTimeout,
            ticketsCount: fullOptions.tickets.ticketsCount,
            serverAgentValidator: fullOptions.serverAgentValidator,
            appCredentials: fullOptions.appCredentials,
        });
        return this.createAuthorizedConnection(channel, fullOptions, {
            type: "session",
            sessionId: auth.sessionId,
            sessionKey: auth.sessionKey,
            username: auth.username,
            properties: auth.properties
        }, result.tickets);
    }
    async probe(baseConnection, host, appCredentials, timeout) {
        const channel = this.createChannel(baseConnection, host);
        const sender = this.senderFactory.createPlainSender(channel, appCredentials);
        await AppHandler_1.AppHandler.sendApplicationFrame(sender, 2, timeout || 10000, 1, "ping", {});
    }
    createChannel(baseConnection, host) {
        return {
            send: (buffer, messagePriority) => {
                return baseConnection.call("proxy", {
                    destination: host,
                    encrypt: false,
                    data: buffer
                }, {
                    channelType: "ajax",
                    priority: messagePriority,
                    sendAlone: true
                });
            }
        };
    }
    async createAuthorizedConnection(channel, options, info, tickets) {
        return AuthorizedConnection_1.AuthorizedConnection.create(this.senderFactory, this.loginService, channel, null, options, info, tickets);
    }
    fillOptions(connectionOptions, options) {
        const res = {
            agent: "privmx-rpc",
            serverAgentValidator: null,
            ...connectionOptions,
            mainChannel: "ajax",
            websocket: false,
            notifications: false,
            overEcdhe: true,
            restorableSession: true,
            connectionRequestTimeout: 15000,
            ...options,
            tickets: {
                ticketsCount: 50,
                checkTickets: true,
                checkerEnabled: true,
                checkerInterval: 10000,
                minTicketsCount: 10,
                ttlThreshold: 60 * 1000,
                minTicketTTL: 5 * 1000,
                fetchTicketsTimeout: 10000,
                ...connectionOptions.tickets,
                ...(options.tickets ? options.tickets : {})
            },
            appHandler: {
                timeoutTimerValue: 500,
                defaultTimeout: 40000,
                defaultMessagePriority: 2,
                maxMessagesCount: 4,
                maxMessagesSize: 1024 * 1024,
                ...connectionOptions.appHandler,
                ...(options.appHandler ? options.appHandler : {})
            },
            websocketOptions: {
                connectTimeout: 5000,
                disconnectOnHeartBeatTimeout: true,
                heartBeatTimeout: 5000,
                pingTimeout: 5000,
                onHeartBeatCallback: () => { },
                ...(options.websocketOptions ? options.websocketOptions : {})
            }
        };
        if (!RpcUtils_1.RpcUtils.isValidHostname(options.host)) {
            throw new Error("Invalid host");
        }
        if (res.mainChannel != "ajax") {
            throw new Error("Unsupported mainChannel value");
        }
        if (res.websocket || res.notifications) {
            throw new Error("Websocket in proxy connection is not supported");
        }
        return res;
    }
}
exports.ProxyConnectionManager = ProxyConnectionManager;

},{"./AppHandler":330,"./AuthorizedConnection":331,"./RpcUtils":352,"privmx-crypto":265}],348:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProxyManager = void 0;
const RpcUtils_1 = require("./RpcUtils");
const privmx_crypto_1 = require("privmx-crypto");
class ProxyManager {
    loginService;
    senderFactory;
    options;
    channelFactory;
    map;
    constructor(loginService, senderFactory, options, channelFactory) {
        this.loginService = loginService;
        this.senderFactory = senderFactory;
        this.options = options;
        this.channelFactory = channelFactory;
        this.map = new Map();
    }
    async getProxyConnection(host) {
        if (this.map.has(host)) {
            return this.map.get(host).promise;
        }
        const defer = RpcUtils_1.RpcUtils.defer();
        this.map.set(host, defer);
        (async () => {
            try {
                const options = this.getOptionsForHost(host);
                const channel = this.channelFactory.create(host);
                const key = privmx_crypto_1.serviceSync.eccPrivRandom();
                const result = await this.loginService.ecdheLogin(channel, key, { agent: options.agent, requestTimeout: options.connectionRequestTimeout, ticketsCount: options.tickets.ticketsCount, serverAgentValidator: options.serverAgentValidator, appCredentials: options.appCredentials });
                const connection = await AuthorizedConnection_1.AuthorizedConnection.create(this.senderFactory, this.loginService, channel, null, options, { type: "ecdhe", key: key.getPublicKey() }, result.tickets);
                connection.addEventListener("sessionLost", () => {
                    connection.destroy();
                    this.map.delete(host);
                });
                defer.resolve(connection);
            }
            catch (e) {
                defer.reject(e);
                this.map.delete(host);
            }
        })();
        return defer.promise;
    }
    getOptionsForHost(host) {
        const opt = {
            ...this.options,
            url: "",
            host: host,
            websocket: false,
            mainChannel: "ajax",
            notifications: false
        };
        return opt;
    }
}
exports.ProxyManager = ProxyManager;
const AuthorizedConnection_1 = require("./AuthorizedConnection");

},{"./AuthorizedConnection":331,"./RpcUtils":352,"privmx-crypto":265}],349:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseReader = exports.ResponseReaderFactory = void 0;
const RwState_1 = require("./RwState");
const Types_1 = require("./Types");
const AlertError_1 = require("./AlertError");
const ByteBuffer = require("bytebuffer");
const RpcUtils_1 = require("./RpcUtils");
class ResponseReaderFactory {
    codec;
    frameSerializer;
    constructor(codec, frameSerializer) {
        this.codec = codec;
        this.frameSerializer = frameSerializer;
    }
    create(buffer) {
        return new ResponseReader(this.codec, this.frameSerializer, buffer);
    }
}
exports.ResponseReaderFactory = ResponseReaderFactory;
class ResponseReader {
    codec;
    frameSerializer;
    buffer;
    readState;
    constructor(codec, frameSerializer, buffer) {
        this.codec = codec;
        this.frameSerializer = frameSerializer;
        this.buffer = buffer;
        this.readState = new RwState_1.RwState();
    }
    async readChangeCipherSpecFrame(readState) {
        const frame = await this.readFrame();
        if (frame.type != Types_1.ContentType.CHANGE_CIPHER_SPEC) {
            throw new Error("Expected CHANGE_CIPHER_SPEC frame");
        }
        this.readState = readState;
    }
    readEcdheHandshakeFrame() {
        return this.readHandshakeFrame("ecdhe");
    }
    readSessionHandshakeFrame() {
        return this.readHandshakeFrame("session");
    }
    readSrpInitFrame() {
        return this.readHandshakeFrame("srp_init");
    }
    readSrpExchangeFrame() {
        return this.readHandshakeFrame("srp_exchange");
    }
    readKeyInitFrame() {
        return this.readHandshakeFrame("key_init");
    }
    readKeyExchangeFrame() {
        return this.readHandshakeFrame("key_exchange");
    }
    readTicketResponseFrame() {
        return this.readHandshakeFrame("ticket_response");
    }
    async readHandshakeFrame(type) {
        const frame = await this.readFrame();
        if (frame.type != Types_1.ContentType.HANDSHAKE || frame.data.type != type) {
            throw new Error("Expected " + type + " handshake frame");
        }
        return frame;
    }
    async readApplicationFrame() {
        const frame = await this.readFrame();
        if (frame.type != Types_1.ContentType.APPLICATION_DATA) {
            throw new Error("Expected application frame");
        }
        return frame;
    }
    async readAndProcessApplicationFrame() {
        const frame = await this.readApplicationFrame();
        if (frame.data.error) {
            throw frame.data.error;
        }
        return frame.data.result;
    }
    async readFrame() {
        if (!this.hasFrame()) {
            throw new Error("End of response");
        }
        const headerInfo = await this.frameSerializer.parseHeader(this.buffer, this.readState);
        const packLength = headerInfo.headerLength + headerInfo.frameLength + headerInfo.macLength;
        if (this.buffer.length < packLength) {
            throw new Error("Frame is longer than buffer");
        }
        const pack = this.slice(packLength);
        if (this.readState.initialized) {
            this.readState.sequenceNumber += 1;
        }
        const frameType = headerInfo.frameContentType;
        const frameData = await this.frameSerializer.readFrameData(headerInfo, this.readState, pack);
        return this.decodeFrameData(frameType, frameData);
    }
    decodeFrameData(frameType, frameData) {
        if (frameType == Types_1.ContentType.ALERT) {
            const alertMessage = frameData.toString();
            throw new AlertError_1.AlertError(alertMessage);
        }
        if (frameType == Types_1.ContentType.CHANGE_CIPHER_SPEC) {
            const frame = {
                type: Types_1.ContentType.CHANGE_CIPHER_SPEC
            };
            return frame;
        }
        if (frameType == Types_1.ContentType.HANDSHAKE) {
            const frame = {
                type: Types_1.ContentType.HANDSHAKE,
                data: this.codec.decode(frameData)
            };
            return frame;
        }
        if (frameType == Types_1.ContentType.APPLICATION_DATA) {
            const frame = {
                type: Types_1.ContentType.APPLICATION_DATA,
                data: frameData.length > 0 ? this.clearBuffers(this.codec.decode(frameData)) : null
            };
            return frame;
        }
        throw new Error("Unsupported frame type " + frameType);
    }
    slice(size) {
        const result = this.buffer.slice(0, size);
        this.buffer = this.buffer.slice(size, this.buffer.length);
        return result;
    }
    clearBuffers(packet) {
        for (const key in packet) {
            if (packet[key] instanceof ByteBuffer) {
                packet[key] = Buffer.from(packet[key].toArrayBuffer());
            }
        }
        return packet;
    }
    hasFrame() {
        return this.buffer.length > 0;
    }
    checkEof() {
        if (this.hasFrame()) {
            throw new Error("Response has unexpected frame");
        }
    }
    async switchToPreMasterAndReadTickets(key, request) {
        const { masterSecret, rwStates } = await request.getPreMasterCipherState(key);
        await this.readChangeCipherSpecFrame(rwStates.readState);
        return this.readTicketsResponse(masterSecret);
    }
    async readTicketsResponse(masterSecret) {
        const ticketsFrame = await this.readTicketResponseFrame();
        return this.readTicketsPacket(ticketsFrame.data, masterSecret);
    }
    readTicketsPacket(ticketsPacket, masterSecret) {
        const ttl = RpcUtils_1.RpcUtils.getTTLDate(ticketsPacket);
        const tickets = ticketsPacket.tickets.map(x => {
            const ticket = {
                id: RpcUtils_1.RpcUtils.createBufferFromBytesLike(x),
                data: {
                    masterSecret: masterSecret
                },
                ttl: ttl
            };
            return ticket;
        });
        return tickets;
    }
}
exports.ResponseReader = ResponseReader;

}).call(this)}).call(this,require("buffer").Buffer)
},{"./AlertError":329,"./RpcUtils":352,"./RwState":353,"./Types":363,"buffer":498,"bytebuffer":48}],350:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RpcRequest = void 0;
const RwState_1 = require("./RwState");
const MessagesBuffer_1 = require("./MessagesBuffer");
const Types_1 = require("./Types");
const RpcUtils_1 = require("./RpcUtils");
const privmx_crypto_1 = require("privmx-crypto");
class RpcRequest {
    priority;
    timeout;
    codec;
    frameSerializer;
    cipherState;
    messagesBuffer;
    constructor(priority, timeout, codec, frameSerializer) {
        this.priority = priority;
        this.timeout = timeout;
        this.codec = codec;
        this.frameSerializer = frameSerializer;
        this.cipherState = {
            masterSecret: null,
            clientRandom: Buffer.alloc(0),
            serverRandom: Buffer.alloc(0),
            rwStates: {
                readState: new RwState_1.RwState(),
                writeState: new RwState_1.RwState()
            }
        };
        this.messagesBuffer = new MessagesBuffer_1.MessagesBuffer();
    }
    addChangeCipherSpecMessage() {
        return this.addMessage({}, Types_1.ContentType.CHANGE_CIPHER_SPEC);
    }
    async addHelloMessage(appCredentials) {
        const msg = await this.createHelloMessage(appCredentials);
        return this.addMessage(msg, Types_1.ContentType.HELLO);
    }
    async createHelloMessage(appCredentials) {
        const salt = privmx_crypto_1.service.randomBytes(8).toString("hex");
        const base = `${appCredentials.id};${Date.now()};${salt}`;
        const toSign = `${base};${appCredentials.secret}`;
        const hash = await privmx_crypto_1.service.sha256(Buffer.from(toSign, "utf8"));
        const appAuth = `${base};${hash.toString("hex").substring(0, 32)}`;
        return appAuth;
    }
    addEcdheHandshakeMessage(key, clientAgent) {
        const msg = this.createEcdheHandshakeMessage(key, clientAgent);
        return this.addMessage(msg, Types_1.ContentType.HANDSHAKE);
    }
    createEcdheHandshakeMessage(key, clientAgent) {
        return {
            type: "ecdhe",
            agent: clientAgent,
            key: Buffer.from(key.getPublic(true, "binary"))
        };
    }
    addSessionRestoreHandshakeMessage(sessionId, sessionKey, nonce, timestamp, signature) {
        const msg = this.createSessionRestoreHandshakeMessage(sessionId, sessionKey, nonce, timestamp, signature);
        return this.addMessage(msg, Types_1.ContentType.HANDSHAKE);
    }
    createSessionRestoreHandshakeMessage(sessionId, sessionKey, nonce, timestamp, signature) {
        return {
            type: "session",
            sessionId: sessionId,
            sessionKey: sessionKey.toBase58DER(),
            nonce: nonce,
            timestamp: timestamp,
            signature: signature.toString("base64")
        };
    }
    addSrpInitMessage(username, host, clientAgent, properties) {
        const msg = this.createSrpInitMessage(username, host, clientAgent, properties);
        return this.addMessage(msg, Types_1.ContentType.HANDSHAKE);
    }
    createSrpInitMessage(username, host, clientAgent, properties) {
        return {
            type: "srp_init",
            agent: clientAgent,
            I: username,
            host: host,
            properties: properties
        };
    }
    addSrpExchangeMessage(bigA, bigM1, sessionId, ticketsCount, sessionKey) {
        const msg = this.createSrpExchangeMessage(bigA, bigM1, sessionId, ticketsCount, sessionKey);
        return this.addMessage(msg, Types_1.ContentType.HANDSHAKE);
    }
    createSrpExchangeMessage(bigA, bigM1, sessionId, ticketsCount, sessionKey) {
        return {
            type: "srp_exchange",
            A: bigA.toString("hex"),
            M1: bigM1.toString("hex"),
            sessionId: sessionId,
            sessionKey: sessionKey ? sessionKey.toBase58DER() : null,
            tickets: ticketsCount
        };
    }
    addKeyInitMessage(pubKey, clientAgent, properties) {
        const msg = this.createKeyInitMessage(pubKey, clientAgent, properties);
        return this.addMessage(msg, Types_1.ContentType.HANDSHAKE);
    }
    createKeyInitMessage(pubKey, clientAgent, properties) {
        return {
            type: "key_init",
            agent: clientAgent,
            pub: pubKey.toBase58DER(),
            properties: properties
        };
    }
    addKeyExchangeMessage(sessionId, nonce, timestamp, K, signature, ticketsCount, sessionKey) {
        const msg = this.createKeyExchangeMessage(sessionId, nonce, timestamp, K, signature, ticketsCount, sessionKey);
        return this.addMessage(msg, Types_1.ContentType.HANDSHAKE);
    }
    createKeyExchangeMessage(sessionId, nonce, timestamp, K, signature, ticketsCount, sessionKey) {
        return {
            type: "key_exchange",
            sessionId: sessionId,
            sessionKey: sessionKey ? sessionKey.toBase58DER() : null,
            nonce: nonce,
            timestamp: timestamp,
            K: K,
            signature: signature.toString("base64"),
            tickets: ticketsCount
        };
    }
    addNewTicketsRequestMessage(ticketsCount) {
        const msg = this.createNewTicketsRequestMessage(ticketsCount);
        return this.addMessage(msg, Types_1.ContentType.HANDSHAKE);
    }
    createNewTicketsRequestMessage(ticketsCount) {
        return {
            type: "ticket_request",
            count: ticketsCount
        };
    }
    addTicketHandshakeMessage(ticket, clientRandom) {
        const msg = this.createTicketHandshakeMessage(ticket, clientRandom);
        return this.addMessage(msg, Types_1.ContentType.HANDSHAKE);
    }
    createTicketHandshakeMessage(ticket, clientRandom) {
        return {
            type: "ticket",
            ticket_id: ticket.id,
            client_random: clientRandom
        };
    }
    addApplicationMessage(msg) {
        return this.addMessage(msg, Types_1.ContentType.APPLICATION_DATA);
    }
    addSerializedApplicationMessage(msg) {
        return this.addSerializedMessage(msg, Types_1.ContentType.APPLICATION_DATA);
    }
    async addMessage(message, type) {
        const serialized = this.serializeMessage(message);
        return this.addSerializedMessage(serialized, type);
    }
    async addSerializedMessage(serialized, type) {
        const encoded = await this.buildFrame(serialized, type);
        this.messagesBuffer.addMessage(encoded);
    }
    serializeMessage(message) {
        return RpcUtils_1.RpcUtils.createBufferFromBytesLike(this.codec.encode(message));
    }
    async buildFrame(data, contentType) {
        return this.frameSerializer.buildFrame(data, this.cipherState.rwStates.writeState, contentType);
    }
    getCipherState() {
        return this.cipherState;
    }
    setCipherState(rwStates) {
        this.cipherState = rwStates;
    }
    getBuffer() {
        return this.messagesBuffer.getBuffer();
    }
    getPreMasterCipherState(preMasterSecret) {
        return RwState_1.RwState.fromPreMasterSecret(preMasterSecret, this.cipherState.clientRandom, this.cipherState.serverRandom);
    }
    getPriority() {
        return this.priority;
    }
    getTimeout() {
        return this.timeout;
    }
}
exports.RpcRequest = RpcRequest;

}).call(this)}).call(this,require("buffer").Buffer)
},{"./MessagesBuffer":345,"./RpcUtils":352,"./RwState":353,"./Types":363,"buffer":498,"privmx-crypto":265}],351:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RpcRequestBuilder = void 0;
const RpcRequest_1 = require("./RpcRequest");
const RpcUtils_1 = require("./RpcUtils");
const RootLogger = require("simplito-logger");
const RwState_1 = require("./RwState");
const Logger = RootLogger.get("privmx-rpc.TicketsManager");
class RpcRequestBuilder {
    codec;
    frameSerializer;
    constructor(codec, frameSerializer) {
        this.codec = codec;
        this.frameSerializer = frameSerializer;
    }
    async createTicketHandshakeRequest(ticket, appCredentials, priority, timeout) {
        const clientRandom = RpcUtils_1.RpcUtils.generateClientRandom();
        if (Logger.getLevel() == Logger.DEBUG) {
            Logger.debug("ticketHandshake - clientRandom", clientRandom.toString("hex"));
            Logger.info("ticketHandshake with ticket: ", ticket.id.toString("hex"));
        }
        const state = await this.getCipherStateFromTicket(ticket, clientRandom);
        const request = await this.createPlainRpcRequest(appCredentials, priority, timeout);
        await request.addTicketHandshakeMessage(ticket, clientRandom);
        await request.addChangeCipherSpecMessage();
        request.setCipherState(state);
        return request;
    }
    async getCipherStateFromTicket(ticket, clientRandom) {
        const { masterSecret, serverRandom } = this.unpackTicket(ticket);
        const rwStates = await RwState_1.RwState.getRWStates(masterSecret, clientRandom, serverRandom);
        return { masterSecret, clientRandom, serverRandom, rwStates };
    }
    unpackTicket(ticket) {
        return {
            masterSecret: ticket.data.masterSecret,
            serverRandom: ticket.id
        };
    }
    async createPlainRpcRequest(appCredentials, priority, timeout) {
        const request = new RpcRequest_1.RpcRequest(priority, timeout, this.codec, this.frameSerializer);
        if (appCredentials) {
            await request.addHelloMessage(appCredentials);
        }
        return request;
    }
    serializeApplicationMessage(msg) {
        return RpcUtils_1.RpcUtils.createBufferFromBytesLike(this.codec.encode(msg));
    }
}
exports.RpcRequestBuilder = RpcRequestBuilder;

},{"./RpcRequest":350,"./RpcUtils":352,"./RwState":353,"simplito-logger":407}],352:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RpcUtils = void 0;
const privmx_crypto_1 = require("privmx-crypto");
class RpcUtils {
    static HOSTNAME_REGEX = /^(([a-zA-Z0-9_]|[a-zA-Z0-9_][a-zA-Z0-9\-_]*[a-zA-Z0-9_])\.)*([A-Za-z0-9_]|[A-Za-z0-9_][A-Za-z0-9\-_]*[A-Za-z0-9_])$/;
    static fillTo(buff, length) {
        if (buff.length < length) {
            let zeros = Buffer.alloc(length - buff.length);
            zeros.fill(0);
            return RpcUtils.concat2Buffers(zeros, buff);
        }
        if (buff.length > length) {
            return buff.slice(0, length);
        }
        return buff;
    }
    static fillTo32(buff) {
        return RpcUtils.fillTo(buff, 32);
    }
    static getTTLDate(packet) {
        let ttl = new Date();
        ttl.setSeconds(ttl.getSeconds() + packet["ttl"]);
        return ttl;
    }
    static generateId() {
        return new Date().getTime().toString() + Math.random().toString();
    }
    static generateClientRandom() {
        let b1 = Buffer.from(privmx_crypto_1.service.randomBytes(6));
        let b2 = Buffer.from(privmx_crypto_1.service.randomBytes(10));
        return RpcUtils.concat2Buffers(b1, b2);
    }
    static simpleDeepCopy(x) {
        return JSON.parse(JSON.stringify(x));
    }
    static getMsgFromError(e) {
        if (typeof (e) == "string") {
            return e;
        }
        return e && typeof (e.message) == "string" ? e.message : "" + e;
    }
    static bufferFromHex(hex) {
        return Buffer.from(RpcUtils.padHex(hex), "hex");
    }
    static padHex(hex) {
        return hex.length % 2 == 1 ? "0" + hex : hex;
    }
    static createBufferFromBytesLike(buffer) {
        if (typeof (buffer.toArrayBuffer) === "function") {
            return Buffer.from(buffer.toArrayBuffer());
        }
        return Buffer.from(buffer.toString("binary"), "binary");
    }
    static defer() {
        let defer = {
            resolve: null,
            reject: null,
            promise: null
        };
        defer.promise = new Promise((resolve, reject) => {
            defer.resolve = resolve;
            defer.reject = reject;
        });
        return defer;
    }
    static executeInDefer(func) {
        const defer = RpcUtils.defer();
        func().then(defer.resolve, defer.reject);
        return defer;
    }
    static watchPromise(promise) {
        const result = {
            promise: promise,
            status: "pending"
        };
        promise.then(v => {
            const r = result;
            r.status = "fulfilled";
            r.value = v;
        }, e => {
            const r = result;
            r.status = "rejected";
            r.reason = e;
        });
        return result;
    }
    static isValidHostname(hostname) {
        return typeof (hostname) == "string" && RpcUtils.HOSTNAME_REGEX.test(hostname);
    }
    static getMax(array, func, defaultValue) {
        let max = null;
        for (const e of array) {
            const v = func(e);
            if (max == null || v > max) {
                max = v;
            }
        }
        return max == null ? defaultValue : max;
    }
    static concat2Buffers(a, b) {
        const res = Buffer.alloc(a.length + b.length);
        res.set(a);
        res.set(b, a.length);
        return res;
    }
    static concat3Buffers(a, b, c) {
        const res = Buffer.alloc(a.length + b.length + c.length);
        res.set(a);
        res.set(b, a.length);
        res.set(c, a.length + b.length);
        return res;
    }
    static concat4Buffers(a, b, c, d) {
        const res = Buffer.alloc(a.length + b.length + c.length + d.length);
        res.set(a);
        res.set(b, a.length);
        res.set(c, a.length + b.length);
        res.set(d, a.length + b.length + c.length);
        return res;
    }
    static concatBuffers(buffers) {
        let size = 0;
        for (const buffer of buffers) {
            size += buffer.length;
        }
        const res = Buffer.alloc(size);
        let pos = 0;
        for (const buffer of buffers) {
            res.set(buffer, pos);
            pos += buffer.length;
        }
        return res;
    }
}
exports.RpcUtils = RpcUtils;

}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":498,"privmx-crypto":265}],353:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RwState = void 0;
const privmx_crypto_1 = require("privmx-crypto");
const RpcUtils_1 = require("./RpcUtils");
class RwState {
    initialized;
    sequenceNumber = 0;
    key;
    macKey;
    constructor(key, macKey) {
        if (key && macKey) {
            this.initialized = true;
            this.key = key;
            this.macKey = macKey;
        }
        else {
            this.initialized = false;
        }
    }
    static async getRWStates(masterSecret, clientRandom, serverRandom) {
        const seed = RpcUtils_1.RpcUtils.concat3Buffers(Buffer.from("key expansion"), serverRandom, clientRandom);
        const keyBlock = await privmx_crypto_1.service.prf_tls12(masterSecret, seed, 4 * 32);
        const clientMacKey = keyBlock.slice(0, 32);
        const serverMacKey = keyBlock.slice(32, 64);
        const clientKey = keyBlock.slice(64, 96);
        const serverKey = keyBlock.slice(96, 128);
        const result = {
            readState: new RwState(serverKey, serverMacKey),
            writeState: new RwState(clientKey, clientMacKey)
        };
        return result;
    }
    static async fromPreMasterSecret(preMasterSecret, clientRandom, serverRandom) {
        const masterSecret = await privmx_crypto_1.service.prf_tls12(preMasterSecret, RpcUtils_1.RpcUtils.concat3Buffers(Buffer.from("master secret"), clientRandom, serverRandom), 48);
        return { masterSecret, clientRandom, serverRandom, rwStates: await RwState.getRWStates(masterSecret, clientRandom, serverRandom) };
    }
}
exports.RwState = RwState;

}).call(this)}).call(this,require("buffer").Buffer)
},{"./RpcUtils":352,"buffer":498,"privmx-crypto":265}],354:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scheduler = void 0;
const RootLogger = require("simplito-logger");
const Logger = RootLogger.get("privmx-rpc.Scheduler");
class Scheduler {
    timeout;
    callback;
    timeoutId;
    constructor(timeout, callback) {
        this.timeout = timeout;
        this.callback = callback;
    }
    isScheduled() {
        return this.timeoutId != null;
    }
    schedule() {
        if (this.isScheduled()) {
            return;
        }
        this.timeoutId = setTimeout(() => {
            this.timeoutId = null;
            try {
                this.callback();
            }
            catch (e) {
                Logger.error("Error during running schedule callback", e);
            }
        }, this.timeout);
    }
    clear() {
        if (this.isScheduled()) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
}
exports.Scheduler = Scheduler;

},{"simplito-logger":407}],355:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketsSender = exports.TicketSender = exports.PlainSender = void 0;
const ConnectionError_1 = require("./ConnectionError");
class PlainSender {
    channel;
    appCredentials;
    rpcRequestBuilder;
    responseReaderFactory;
    constructor(channel, appCredentials, rpcRequestBuilder, responseReaderFactory) {
        this.channel = channel;
        this.appCredentials = appCredentials;
        this.rpcRequestBuilder = rpcRequestBuilder;
        this.responseReaderFactory = responseReaderFactory;
    }
    async send(options) {
        const request = await this.createRequest(options.messagePriority, options.timeout, options.requestBuilder);
        const response = await this.sendRequest(request);
        return this.readResponse(request, response, options.onResponse);
    }
    async createRequest(messagePriority, timeout, requestBuilder) {
        const request = await this.rpcRequestBuilder.createPlainRpcRequest(this.appCredentials, messagePriority, timeout);
        await requestBuilder(request);
        return request;
    }
    async sendRequest(request) {
        try {
            return await this.channel.send(request.getBuffer(), request.getPriority(), request.getTimeout());
        }
        catch (e) {
            throw new ConnectionError_1.ConnectionError(e);
        }
    }
    async readResponse(request, response, onResponse) {
        const reader = this.responseReaderFactory.create(response);
        const state = request.getCipherState();
        if (state.rwStates.readState.initialized) {
            await reader.readChangeCipherSpecFrame(state.rwStates.readState);
        }
        const result = await onResponse(reader, request);
        reader.checkEof();
        return result;
    }
}
exports.PlainSender = PlainSender;
class TicketSender extends PlainSender {
    ticket;
    constructor(channel, appCredentials, rpcRequestBuilder, responseReaderFactory, ticket) {
        super(channel, appCredentials, rpcRequestBuilder, responseReaderFactory);
        this.ticket = ticket;
    }
    async createRequest(messagePriority, timeout, requestBuilder) {
        const request = await this.rpcRequestBuilder.createTicketHandshakeRequest(this.ticket, this.appCredentials, messagePriority, timeout);
        await requestBuilder(request);
        return request;
    }
}
exports.TicketSender = TicketSender;
class TicketsSender extends PlainSender {
    tickets;
    constructor(channel, appCredentials, rpcRequestBuilder, responseReaderFactory, tickets) {
        super(channel, appCredentials, rpcRequestBuilder, responseReaderFactory);
        this.tickets = tickets;
    }
    async createRequest(messagePriority, timeout, requestBuilder) {
        if (this.tickets.length == 0) {
            throw new Error("No tickets");
        }
        const ticket = this.tickets.shift();
        const request = await this.rpcRequestBuilder.createTicketHandshakeRequest(ticket, this.appCredentials, messagePriority, timeout);
        await requestBuilder(request);
        return request;
    }
}
exports.TicketsSender = TicketsSender;

},{"./ConnectionError":333}],356:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SenderFactory = void 0;
const AjaxChannel_1 = require("./AjaxChannel");
const Sender_1 = require("./Sender");
class SenderFactory {
    rpcRequestBuilder;
    responseReaderFactory;
    constructor(rpcRequestBuilder, responseReaderFactory) {
        this.rpcRequestBuilder = rpcRequestBuilder;
        this.responseReaderFactory = responseReaderFactory;
    }
    createPlainSenderHttp(url, appCredentials) {
        return this.createPlainSender(new AjaxChannel_1.AjaxChannel(url), appCredentials);
    }
    createPlainSender(channel, appCredentials) {
        return new Sender_1.PlainSender(channel, appCredentials, this.rpcRequestBuilder, this.responseReaderFactory);
    }
    createTicketSender(channel, ticket, appCredentials) {
        return new Sender_1.TicketSender(channel, appCredentials, this.rpcRequestBuilder, this.responseReaderFactory, ticket);
    }
    createTicketsSenderHttp(url, tickets, appCredentials) {
        return this.createTicketsSender(new AjaxChannel_1.AjaxChannel(url), tickets, appCredentials);
    }
    createTicketsSender(channel, tickets, appCredentials) {
        return new Sender_1.TicketsSender(channel, appCredentials, this.rpcRequestBuilder, this.responseReaderFactory, tickets);
    }
    serializeApplicationMessage(msg) {
        return this.rpcRequestBuilder.serializeApplicationMessage(msg);
    }
}
exports.SenderFactory = SenderFactory;

},{"./AjaxChannel":328,"./Sender":355}],357:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionLostError = void 0;
class SessionLostError extends Error {
    constructor(message) {
        super("[SessionLostError] " + message);
        Object.setPrototypeOf(this, SessionLostError.prototype);
    }
}
exports.SessionLostError = SessionLostError;

},{}],358:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionRestoreService = void 0;
const ECUtils_1 = require("./ECUtils");
const SessionRestoreUtils_1 = require("./SessionRestoreUtils");
class SessionRestoreService {
    async sessionHandshake(sender, sessionId, key, requestTimeout, ticketCount, serverAgentValidator) {
        return sender.send({
            messagePriority: 2,
            timeout: requestTimeout,
            requestBuilder: async (request) => {
                const info = await SessionRestoreUtils_1.SessionRestoreUtils.prepareSignature(key, sessionId);
                await request.addSessionRestoreHandshakeMessage(sessionId, key.getPublicKey(), info.nonce, info.timestamp, info.signature);
                await request.addNewTicketsRequestMessage(ticketCount);
            },
            onResponse: async (reader, request) => {
                const frame = await reader.readSessionHandshakeFrame();
                if (serverAgentValidator) {
                    serverAgentValidator(frame.data.agent);
                }
                const derived = this.deriveKey(key.key, frame.data.key);
                const tickets = await reader.switchToPreMasterAndReadTickets(derived, request);
                const result = {
                    tickets: tickets
                };
                return result;
            }
        });
    }
    deriveKey(priv, pub) {
        return ECUtils_1.ECUtils.deriveKey(priv, ECUtils_1.ECUtils.decodePublicKey(pub));
    }
}
exports.SessionRestoreService = SessionRestoreService;

},{"./ECUtils":335,"./SessionRestoreUtils":359}],359:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionRestoreUtils = void 0;
const privmx_crypto_1 = require("privmx-crypto");
class SessionRestoreUtils {
    static async prepareSignature(priv, sessionId) {
        const nonce = privmx_crypto_1.service.randomBytes(32).toString("base64");
        const timestamp = Date.now().toString();
        const signatureData = "restore_" + sessionId + " " + nonce + " " + timestamp;
        const signature = await privmx_crypto_1.service.signToCompactSignatureWithHash(priv, Buffer.from(signatureData, "utf8"));
        return { nonce, timestamp, signature };
    }
}
exports.SessionRestoreUtils = SessionRestoreUtils;

}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":498,"privmx-crypto":265}],360:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SrpService = void 0;
const SrpUtils_1 = require("./SrpUtils");
const privmx_crypto_1 = require("privmx-crypto");
class SrpService {
    async srpHandshake(sender, host, username, password, properties, agent, requestTimeout, ticketCount, serverAgentValidator, restorableSession) {
        const step1 = await sender.send({
            messagePriority: 2,
            timeout: requestTimeout,
            requestBuilder: async (request) => {
                await request.addSrpInitMessage(username, host, agent, properties);
            },
            onResponse: async (reader) => {
                const frame = await reader.readSrpInitFrame();
                if (serverAgentValidator) {
                    serverAgentValidator(frame.data.agent);
                }
                const step1 = await SrpUtils_1.SrpUtils.prepareSrpLoginStep1(username, password, frame.data);
                return { ...step1, sessionId: frame.data.sessionId };
            }
        });
        const sessionKey = restorableSession ? privmx_crypto_1.serviceSync.eccPrivRandom() : null;
        return sender.send({
            messagePriority: 2,
            timeout: requestTimeout,
            requestBuilder: async (request) => {
                const publicSessionKey = sessionKey ? sessionKey.getPublicKey() : null;
                await request.addSrpExchangeMessage(step1.A, step1.M1, step1.sessionId, 0, publicSessionKey);
                await request.addNewTicketsRequestMessage(ticketCount);
            },
            onResponse: async (reader, request) => {
                const frame = await reader.readSrpExchangeFrame();
                SrpUtils_1.SrpUtils.verifyM2(step1.M2, frame.data.M2);
                const tickets = await reader.switchToPreMasterAndReadTickets(step1.K, request);
                const result = {
                    tickets: tickets,
                    sessionId: step1.sessionId,
                    sessionKey: sessionKey,
                    mixed: step1.mixed,
                    additionalLoginStep: frame.data.additionalLoginStep
                };
                return result;
            }
        });
    }
}
exports.SrpService = SrpService;

},{"./SrpUtils":361,"privmx-crypto":265}],361:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SrpUtils = void 0;
const RpcUtils_1 = require("./RpcUtils");
const privmx_crypto_1 = require("privmx-crypto");
class SrpUtils {
    static async prepareSrpLoginStep1(username, password, packet) {
        const mixed = await SrpUtils.mixPassword(password, packet.loginData);
        const decoded = {
            g: RpcUtils_1.RpcUtils.bufferFromHex(packet.g),
            N: RpcUtils_1.RpcUtils.bufferFromHex(packet.N),
            s: RpcUtils_1.RpcUtils.bufferFromHex(packet.s),
            B: RpcUtils_1.RpcUtils.bufferFromHex(packet.B)
        };
        const step1 = await privmx_crypto_1.service.srpLoginStep1(decoded.N, decoded.g, decoded.s, decoded.B, username, mixed.toString("base64"));
        return { ...step1, mixed, K: RpcUtils_1.RpcUtils.fillTo32(step1.K) };
    }
    static async mixPassword(password, loginData) {
        const passwordMixer = privmx_crypto_1.service.getPasswordMixer();
        const deserializedLoginData = passwordMixer.deserializeData(loginData);
        return passwordMixer.perform(Buffer.from(password, "utf8"), deserializedLoginData);
    }
    static verifyM2(myM2, serverM2) {
        const bigM2Hex = myM2.toString("hex");
        if (bigM2Hex != serverM2) {
            throw new Error(`Invalid M2 ${bigM2Hex} != ${serverM2}`);
        }
    }
}
exports.SrpUtils = SrpUtils;

}).call(this)}).call(this,require("buffer").Buffer)
},{"./RpcUtils":352,"buffer":498,"privmx-crypto":265}],362:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketsManager = void 0;
const RootLogger = require("simplito-logger");
const Logger = RootLogger.get("privmx-rpc.TicketsManager");
class TicketsManager {
    tickets;
    config;
    minTTL;
    maxTTL;
    constructor(tickets, config) {
        this.tickets = tickets;
        this.config = config;
        this.refreshTTL();
    }
    setTickets(tickets) {
        this.clear();
        this.addTickets(tickets);
    }
    addTickets(tickets) {
        this.tickets = this.tickets.concat(tickets);
        this.refreshTTL();
        Logger.info(`add ${tickets.length} new tickets, all tickets: ${this.tickets.length}`);
    }
    refreshTTL() {
        this.minTTL = null;
        this.maxTTL = null;
        for (const ticket of this.tickets) {
            const ttl = ticket.ttl.getTime();
            if (this.minTTL == null || ttl < this.minTTL) {
                this.minTTL = ttl;
            }
            if (this.maxTTL == null || ttl > this.maxTTL) {
                this.maxTTL = ttl;
            }
        }
    }
    needNewTickets() {
        this.dropExpiredTickets();
        return this.tickets.length < this.config.minTicketsCount || (this.maxTTL != null && this.maxTTL - this.config.ttlThreshold < Date.now());
    }
    popFirstTicketForHandshake() {
        Logger.info(`ticket handshake, tickets left: ${this.tickets.length}`);
        this.checkTicketsPresent();
        const ticket = this.tickets.shift();
        const ticketId = ticket.id.toString("hex");
        return { ticketId, ticket };
    }
    popAllTickets() {
        const tickets = this.tickets;
        this.tickets = [];
        this.refreshTTL();
        return tickets;
    }
    checkTicketsPresent() {
        if (!this.hasTickets()) {
            throw new Error("No tickets");
        }
    }
    hasTickets() {
        this.dropExpiredTickets();
        return this.tickets.length > 0;
    }
    clear() {
        this.tickets = [];
        this.refreshTTL();
    }
    dropExpiredTickets() {
        const ttl = Date.now() + this.config.minTicketTTL;
        if (this.minTTL != null && ttl > this.minTTL) {
            const ticketsCount = this.tickets.length;
            this.tickets = this.tickets.filter(x => x.ttl.getTime() > ttl);
            this.refreshTTL();
            const count = ticketsCount - this.tickets.length;
            Logger.debug(`Deleted ${count} expired tickets`);
        }
    }
}
exports.TicketsManager = TicketsManager;

},{"simplito-logger":407}],363:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentType = void 0;
var ContentType;
(function (ContentType) {
    ContentType[ContentType["CHANGE_CIPHER_SPEC"] = 20] = "CHANGE_CIPHER_SPEC";
    ContentType[ContentType["ALERT"] = 21] = "ALERT";
    ContentType[ContentType["HANDSHAKE"] = 22] = "HANDSHAKE";
    ContentType[ContentType["APPLICATION_DATA"] = 23] = "APPLICATION_DATA";
    ContentType[ContentType["HELLO"] = 24] = "HELLO";
})(ContentType = exports.ContentType || (exports.ContentType = {}));

},{}],364:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketChannel = void 0;
const BaseChannel_1 = require("./BaseChannel");
const RootLogger = require("simplito-logger");
const WebSocket = require("./ws/ws");
const RpcUtils_1 = require("./RpcUtils");
const Logger = RootLogger.get("privmx-rpc.WebsocketPrivmxChannel");
class WebSocketChannel extends BaseChannel_1.BaseChannel {
    options;
    notifyCallback;
    wsUrl;
    pinger;
    heartBeatChecker;
    lastHeartBeat = 0;
    webSocket;
    callbacks;
    id;
    constructor(url, options, notifyCallback) {
        super();
        this.options = options;
        this.notifyCallback = notifyCallback;
        this.wsUrl = options.url || this.getWsUrl(url);
        this.callbacks = {};
        this.id = 1;
    }
    async send(data, _messagePriority, timeout) {
        if (!this.webSocket) {
            throw { type: "disconnected" };
        }
        const defer = RpcUtils_1.RpcUtils.defer();
        const id = this.id++;
        if (Logger.getLevel() == Logger.DEBUG) {
            Logger.debug("Sending data: ", id, data.toString("hex"));
        }
        const idBuf = Buffer.alloc(4);
        idBuf.writeUInt32BE(id, 0);
        const fullData = RpcUtils_1.RpcUtils.concat2Buffers(idBuf, data);
        this.webSocket.send(fullData);
        this.callbacks[id] = {
            timeoutId: setTimeout(() => {
                defer.reject({ type: "timeout", value: timeout });
                delete this.callbacks[id];
            }, timeout),
            deferred: defer
        };
        return defer.promise;
    }
    getWsUrl(url) {
        const u = new URL(url);
        u.protocol = this.getWsProtocol(u.protocol);
        return u.href;
    }
    getWsProtocol(protocol) {
        if (protocol == "http:") {
            return "ws:";
        }
        if (protocol == "https:") {
            return "wss:";
        }
        throw new Error("Unsupported protocol " + protocol);
    }
    async connect() {
        if (this.webSocket) {
            return;
        }
        let connectDefer = RpcUtils_1.RpcUtils.defer();
        let connectionTimeoutId = setTimeout(() => {
            if (connectDefer) {
                const errorMessage = "WebsocketChannel connection timeout: " + this.options.connectTimeout;
                Logger.warn(errorMessage);
                connectDefer.reject({ message: errorMessage });
                connectDefer = null;
                this.disconnectCore(errorMessage);
            }
        }, this.options.connectTimeout);
        this.webSocket = new WebSocket(this.wsUrl);
        this.webSocket.binaryType = "arraybuffer";
        this.webSocket.addEventListener("open", _event => {
            connectDefer.resolve();
            connectDefer = null;
            clearTimeout(connectionTimeoutId);
            this.lastHeartBeat = Date.now();
            this.setupHeartBeatChecker();
            this.setupPinger();
        });
        this.webSocket.addEventListener("message", event => {
            Logger.debug("increase lastHeartBeat after " + (Date.now() - this.lastHeartBeat) + " (message)");
            this.lastHeartBeat = Date.now();
            const buf = Buffer.from(event.data);
            const id = buf.readUInt32BE(0);
            const resData = buf.slice(4);
            if (Logger.getLevel() == Logger.DEBUG) {
                Logger.debug("Received: ", id, resData.toString("hex"));
            }
            if (id in this.callbacks) {
                this.callbacks[id].deferred.resolve(resData);
                clearTimeout(this.callbacks[id].timeoutId);
                delete this.callbacks[id];
            }
            else if (id == 0) {
                if (this.notifyCallback) {
                    (async () => {
                        try {
                            await this.notifyCallback(resData);
                        }
                        catch (e) {
                            Logger.error("WebsocketChannel error during call notify callback:", e);
                        }
                    })();
                }
                else {
                    Logger.warn("There is no notify callback");
                }
            }
            else {
                Logger.warn("There is no callback with id", id);
            }
        });
        this.webSocket.addEventListener("close", event => {
            const errorMessage = "WebsocketChannel closed: " + this.formatEvent(event);
            Logger.warn(errorMessage);
            if (connectDefer) {
                connectDefer.reject({ message: errorMessage });
                connectDefer = null;
                clearTimeout(connectionTimeoutId);
            }
            this.disconnectCore("WebsocketChannel closed");
        });
        this.webSocket.addEventListener("error", event => {
            const errorMessage = "WebsocketChannel error: " + this.formatEvent(event);
            Logger.warn(errorMessage);
            if (connectDefer) {
                connectDefer.reject({ message: errorMessage });
                connectDefer = null;
                clearTimeout(connectionTimeoutId);
            }
            this.disconnectCore(errorMessage);
        });
        return connectDefer.promise;
    }
    setupHeartBeatChecker() {
        this.heartBeatChecker = setInterval(() => {
            const latency = Date.now() - this.lastHeartBeat;
            if (typeof (this.options.onHeartBeatCallback) === "function") {
                try {
                    this.options.onHeartBeatCallback({
                        type: "heartBeat",
                        latency: latency,
                        websocket: this
                    });
                }
                catch (e) {
                    Logger.error("WebsocketChannel error during call heartBeat callback:", e);
                }
            }
            if (this.options.disconnectOnHeartBeatTimeout && latency > this.options.heartBeatTimeout) {
                this.onWebsocketTimeout();
            }
        }, 1000);
    }
    setupPinger() {
        if (typeof (this.webSocket.ping) == "function") {
            this.webSocket.addEventListener("pong", () => {
                Logger.debug("increase lastHeartBeat after " + (Date.now() - this.lastHeartBeat) + " (pong)");
                this.lastHeartBeat = Date.now();
            });
            this.pinger = setInterval(() => {
                if (!this.webSocket) {
                    return;
                }
                this.webSocket.ping();
            }, 1000);
        }
        else {
            const pingPacket = Buffer.from("ping", "utf8");
            const pongPacket = Buffer.from("pong", "utf8");
            this.pinger = setInterval(async () => {
                if (!this.webSocket) {
                    return;
                }
                const start = Date.now();
                try {
                    const res = await this.send(pingPacket, 0, this.options.pingTimeout);
                    if (res.equals(pongPacket)) {
                        Logger.debug("ping-pong with latency=" + (Date.now() - start) + ")");
                    }
                }
                catch (e) {
                    Logger.warn("WebsocketChannel ping error (latency: " + (Date.now() - start) + ", heartBeat: " + (Date.now() - this.lastHeartBeat) + ")", e);
                }
            }, 1000);
        }
    }
    formatEvent(e) {
        try {
            if (!e || typeof (e) != "object") {
                return e;
            }
            const copy = { ...e };
            if (e.target instanceof WebSocket) {
                copy.target = "<WebSocket>";
            }
            if (e.error && e.message == e.error.message) {
                copy.error = "<Error>";
            }
            return e.constructor.name + " " + JSON.stringify(copy);
        }
        catch (e) {
            return "<UnserializableData>";
        }
    }
    onWebsocketTimeout() {
        Logger.debug("On websocket timeout - disconnecting...");
        this.disconnectCore("Websocket timeout");
    }
    isConnected() {
        return !this.disconnected;
    }
    disconnect() {
        this.disconnectCore("Manual disconnect");
    }
    disconnectCore(cause) {
        if (this.disconnected) {
            return;
        }
        this.disconnected = true;
        if (this.heartBeatChecker) {
            clearInterval(this.heartBeatChecker);
            this.heartBeatChecker = null;
        }
        if (this.pinger) {
            clearInterval(this.pinger);
            this.pinger = null;
        }
        if (this.webSocket) {
            this.webSocket.close();
            this.webSocket = null;
        }
        for (const requestId in this.callbacks) {
            this.callbacks[requestId].deferred.reject({ type: "disconnected" });
            clearTimeout(this.callbacks[requestId].timeoutId);
        }
        this.callbacks = {};
        this.eventDispatcher.dispatchEvent({ type: "disconnected", cause: cause });
    }
}
exports.WebSocketChannel = WebSocketChannel;

}).call(this)}).call(this,require("buffer").Buffer)
},{"./BaseChannel":332,"./RpcUtils":352,"./ws/ws":367,"buffer":498,"simplito-logger":407}],365:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AjaxRequester = void 0;
class AjaxRequester {
    static INSTANCE = new AjaxRequester();
    send(options) {
        return new Promise((resolve, reject) => {
            const req = new XMLHttpRequest();
            req.open(options.method, options.url, true);
            req.responseType = "arraybuffer";
            if (options.contentType) {
                req.setRequestHeader("Content-Type", options.contentType);
            }
            if (options.timeout) {
                req.timeout = options.timeout;
                req.ontimeout = (err) => {
                    reject(err);
                };
            }
            req.onload = (evt) => {
                const status = evt.currentTarget.status;
                resolve({
                    statusCode: status,
                    data: req.response
                });
            };
            req.onerror = (err) => {
                reject(err);
            };
            req.send(options.data);
        });
    }
}
exports.AjaxRequester = AjaxRequester;

},{}],366:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.proxy = exports.rpc = exports.ioc = exports.WebSocketChannel = exports.Types = exports.TicketsManager = exports.SrpUtils = exports.SrpService = exports.SessionLostError = exports.SenderFactory = exports.TicketsSender = exports.TicketSender = exports.PlainSender = exports.Scheduler = exports.RwState = exports.RpcUtils = exports.RpcRequestBuilder = exports.RpcRequest = exports.ResponseReader = exports.ResponseReaderFactory = exports.ProxyManager = exports.ProxyConnectionManager = exports.PlainConnection = exports.MessagesBuffer = exports.LoginService = exports.KeyUtils = exports.KeyService = exports.IOC = exports.IdGenerator = exports.FrameSerializer = exports.EventDispatcher = exports.EventBinder = exports.ECUtils = exports.ConnectionManager = exports.ConnectionError = exports.BaseChannel = exports.AuthorizedConnection = exports.AppHandler = exports.AlertError = exports.AjaxChannel = exports.AdditionalLoginStepHandler = exports.ajax = void 0;
const ajax = require("./ajax/AjaxRequester");
exports.ajax = ajax;
const AdditionalLoginStepHandler_1 = require("./AdditionalLoginStepHandler");
Object.defineProperty(exports, "AdditionalLoginStepHandler", { enumerable: true, get: function () { return AdditionalLoginStepHandler_1.AdditionalLoginStepHandler; } });
const AjaxChannel_1 = require("./AjaxChannel");
Object.defineProperty(exports, "AjaxChannel", { enumerable: true, get: function () { return AjaxChannel_1.AjaxChannel; } });
const AlertError_1 = require("./AlertError");
Object.defineProperty(exports, "AlertError", { enumerable: true, get: function () { return AlertError_1.AlertError; } });
const AppHandler_1 = require("./AppHandler");
Object.defineProperty(exports, "AppHandler", { enumerable: true, get: function () { return AppHandler_1.AppHandler; } });
const AuthorizedConnection_1 = require("./AuthorizedConnection");
Object.defineProperty(exports, "AuthorizedConnection", { enumerable: true, get: function () { return AuthorizedConnection_1.AuthorizedConnection; } });
const BaseChannel_1 = require("./BaseChannel");
Object.defineProperty(exports, "BaseChannel", { enumerable: true, get: function () { return BaseChannel_1.BaseChannel; } });
const ConnectionError_1 = require("./ConnectionError");
Object.defineProperty(exports, "ConnectionError", { enumerable: true, get: function () { return ConnectionError_1.ConnectionError; } });
const ConnectionManager_1 = require("./ConnectionManager");
Object.defineProperty(exports, "ConnectionManager", { enumerable: true, get: function () { return ConnectionManager_1.ConnectionManager; } });
const ECUtils_1 = require("./ECUtils");
Object.defineProperty(exports, "ECUtils", { enumerable: true, get: function () { return ECUtils_1.ECUtils; } });
const EventBinder_1 = require("./EventBinder");
Object.defineProperty(exports, "EventBinder", { enumerable: true, get: function () { return EventBinder_1.EventBinder; } });
const EventDispatcher_1 = require("./EventDispatcher");
Object.defineProperty(exports, "EventDispatcher", { enumerable: true, get: function () { return EventDispatcher_1.EventDispatcher; } });
const FrameSerializer_1 = require("./FrameSerializer");
Object.defineProperty(exports, "FrameSerializer", { enumerable: true, get: function () { return FrameSerializer_1.FrameSerializer; } });
const IdGenerator_1 = require("./IdGenerator");
Object.defineProperty(exports, "IdGenerator", { enumerable: true, get: function () { return IdGenerator_1.IdGenerator; } });
const IOC_1 = require("./IOC");
Object.defineProperty(exports, "IOC", { enumerable: true, get: function () { return IOC_1.IOC; } });
const KeyService_1 = require("./KeyService");
Object.defineProperty(exports, "KeyService", { enumerable: true, get: function () { return KeyService_1.KeyService; } });
const KeyUtils_1 = require("./KeyUtils");
Object.defineProperty(exports, "KeyUtils", { enumerable: true, get: function () { return KeyUtils_1.KeyUtils; } });
const LoginService_1 = require("./LoginService");
Object.defineProperty(exports, "LoginService", { enumerable: true, get: function () { return LoginService_1.LoginService; } });
const MessagesBuffer_1 = require("./MessagesBuffer");
Object.defineProperty(exports, "MessagesBuffer", { enumerable: true, get: function () { return MessagesBuffer_1.MessagesBuffer; } });
const ProxyConnectionManager_1 = require("./ProxyConnectionManager");
Object.defineProperty(exports, "ProxyConnectionManager", { enumerable: true, get: function () { return ProxyConnectionManager_1.ProxyConnectionManager; } });
const ProxyManager_1 = require("./ProxyManager");
Object.defineProperty(exports, "ProxyManager", { enumerable: true, get: function () { return ProxyManager_1.ProxyManager; } });
const ResponseReader_1 = require("./ResponseReader");
Object.defineProperty(exports, "ResponseReaderFactory", { enumerable: true, get: function () { return ResponseReader_1.ResponseReaderFactory; } });
Object.defineProperty(exports, "ResponseReader", { enumerable: true, get: function () { return ResponseReader_1.ResponseReader; } });
const RpcRequest_1 = require("./RpcRequest");
Object.defineProperty(exports, "RpcRequest", { enumerable: true, get: function () { return RpcRequest_1.RpcRequest; } });
const RpcRequestBuilder_1 = require("./RpcRequestBuilder");
Object.defineProperty(exports, "RpcRequestBuilder", { enumerable: true, get: function () { return RpcRequestBuilder_1.RpcRequestBuilder; } });
const RpcUtils_1 = require("./RpcUtils");
Object.defineProperty(exports, "RpcUtils", { enumerable: true, get: function () { return RpcUtils_1.RpcUtils; } });
const RwState_1 = require("./RwState");
Object.defineProperty(exports, "RwState", { enumerable: true, get: function () { return RwState_1.RwState; } });
const Scheduler_1 = require("./Scheduler");
Object.defineProperty(exports, "Scheduler", { enumerable: true, get: function () { return Scheduler_1.Scheduler; } });
const Sender_1 = require("./Sender");
Object.defineProperty(exports, "PlainSender", { enumerable: true, get: function () { return Sender_1.PlainSender; } });
Object.defineProperty(exports, "TicketSender", { enumerable: true, get: function () { return Sender_1.TicketSender; } });
Object.defineProperty(exports, "TicketsSender", { enumerable: true, get: function () { return Sender_1.TicketsSender; } });
const SenderFactory_1 = require("./SenderFactory");
Object.defineProperty(exports, "SenderFactory", { enumerable: true, get: function () { return SenderFactory_1.SenderFactory; } });
const SessionLostError_1 = require("./SessionLostError");
Object.defineProperty(exports, "SessionLostError", { enumerable: true, get: function () { return SessionLostError_1.SessionLostError; } });
const SrpService_1 = require("./SrpService");
Object.defineProperty(exports, "SrpService", { enumerable: true, get: function () { return SrpService_1.SrpService; } });
const SrpUtils_1 = require("./SrpUtils");
Object.defineProperty(exports, "SrpUtils", { enumerable: true, get: function () { return SrpUtils_1.SrpUtils; } });
const TicketsManager_1 = require("./TicketsManager");
Object.defineProperty(exports, "TicketsManager", { enumerable: true, get: function () { return TicketsManager_1.TicketsManager; } });
const Types = require("./Types");
exports.Types = Types;
const WebSocketChannel_1 = require("./WebSocketChannel");
Object.defineProperty(exports, "WebSocketChannel", { enumerable: true, get: function () { return WebSocketChannel_1.WebSocketChannel; } });
const PlainConnection_1 = require("./PlainConnection");
Object.defineProperty(exports, "PlainConnection", { enumerable: true, get: function () { return PlainConnection_1.PlainConnection; } });
const ioc = new IOC_1.IOC();
exports.ioc = ioc;
const rpc = ioc.getConnectionManager();
exports.rpc = rpc;
const proxy = ioc.getProxyConnectionManager();
exports.proxy = proxy;

},{"./AdditionalLoginStepHandler":327,"./AjaxChannel":328,"./AlertError":329,"./AppHandler":330,"./AuthorizedConnection":331,"./BaseChannel":332,"./ConnectionError":333,"./ConnectionManager":334,"./ECUtils":335,"./EventBinder":337,"./EventDispatcher":338,"./FrameSerializer":339,"./IOC":340,"./IdGenerator":341,"./KeyService":342,"./KeyUtils":343,"./LoginService":344,"./MessagesBuffer":345,"./PlainConnection":346,"./ProxyConnectionManager":347,"./ProxyManager":348,"./ResponseReader":349,"./RpcRequest":350,"./RpcRequestBuilder":351,"./RpcUtils":352,"./RwState":353,"./Scheduler":354,"./Sender":355,"./SenderFactory":356,"./SessionLostError":357,"./SrpService":360,"./SrpUtils":361,"./TicketsManager":362,"./Types":363,"./WebSocketChannel":364,"./ajax/AjaxRequester":365}],367:[function(require,module,exports){
"use strict";
module.exports = WebSocket;

},{}],368:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CacheEntry_1 = require("./CacheEntry");
class Cache {
    static DefaultTTL = 600;
    entries = {};
    defaultTTL;
    storage;
    constructor(defaultTTL) {
        this.defaultTTL = defaultTTL || Cache.DefaultTTL;
        this.storage = null;
    }
    save(key, value, ttl) {
        const expires = this.computeExpireDate(ttl);
        const entry = new CacheEntry_1.default(key, value, expires);
        this.entries[key] = entry;
        if (this.storage != null) {
            this.storage.setItem(key, entry.serialize());
        }
    }
    fetch(key) {
        let entry = this.entries[key];
        if (!entry && this.storage !== null) {
            const tmp = this.storage.getItem(key);
            if (tmp) {
                entry = CacheEntry_1.default.deserialize(tmp);
                this.entries[key] = entry;
            }
        }
        if (entry) {
            if (entry.expired()) {
                this.delete(key);
            }
            else {
                return entry.value;
            }
        }
    }
    delete(key) {
        delete this.entries[key];
        if (this.storage !== null) {
            this.storage.removeItem(key);
        }
    }
    computeExpireDate(ttl) {
        return new Date().getTime() + (ttl || this.defaultTTL) * 1000;
    }
    setStorage(storage) {
        this.storage = storage;
    }
}
exports.default = Cache;

},{"./CacheEntry":369}],369:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CacheEntry {
    key;
    value;
    expires;
    constructor(key, value, expires) {
        this.key = key;
        this.value = value;
        this.expires = expires;
    }
    expired() {
        return this.expires < new Date().getTime();
    }
    serialize() {
        return JSON.stringify(this);
    }
    static deserialize(serialized) {
        const d = JSON.parse(serialized);
        return new CacheEntry(d.key, d.value, d.expires);
    }
}
exports.default = CacheEntry;

},{}],370:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Config {
    ttl;
    apiBaseEndpoint;
    defaultEndpoint;
    version;
    static fromJSON(data) {
        const parsed = JSON.parse(data);
        if (!parsed) {
            throw new Error("No data");
        }
        const config = new Config();
        config.ttl = parsed.ttl || 600;
        config.apiBaseEndpoint = parsed.apiBaseEndpoint;
        config.defaultEndpoint = parsed.defaultEndpoint;
        config.version = parsed.version;
        return config;
    }
}
exports.default = Config;

},{}],371:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FetchResult {
    location;
    config;
    constructor(location, config) {
        this.location = location;
        this.config = config;
    }
}
exports.default = FetchResult;

},{}],372:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscoveryMode = exports.JsonMode = void 0;
const FetchResult_1 = require("./FetchResult");
const Config_1 = require("./Config");
const Cache_1 = require("./Cache");
const SimpleHttpClient_1 = require("./SimpleHttpClient");
var JsonMode;
(function (JsonMode) {
    JsonMode[JsonMode["HTTP_ONLY"] = 0] = "HTTP_ONLY";
    JsonMode[JsonMode["HTTPS_ONLY"] = 1] = "HTTPS_ONLY";
    JsonMode[JsonMode["HTTP_AND_HTTPS"] = 2] = "HTTP_AND_HTTPS";
})(JsonMode = exports.JsonMode || (exports.JsonMode = {}));
var DiscoveryMode;
(function (DiscoveryMode) {
    DiscoveryMode[DiscoveryMode["JSON_ONLY"] = 0] = "JSON_ONLY";
    DiscoveryMode[DiscoveryMode["DNS_ONLY"] = 1] = "DNS_ONLY";
    DiscoveryMode[DiscoveryMode["JSON_AND_DNS"] = 2] = "JSON_AND_DNS";
})(DiscoveryMode = exports.DiscoveryMode || (exports.DiscoveryMode = {}));
class PrivMXServiceDiscovery {
    static ConfigPaths = [
        "/privmx/privmx-configuration.json",
        "/.well-known/privmx-configuration.json",
        "/privmx-configuration.json"
    ];
    static DefaultRemoteResolverUrl = "https://privmx.com/resolve-config";
    cache;
    httpClient;
    remoteResolverUrl;
    constructor(options) {
        options = options || {};
        this.cache = options.cache || new Cache_1.default();
        this.httpClient = options.httpClient || new SimpleHttpClient_1.default();
        this.remoteResolverUrl = options.remoteResolverUrl || PrivMXServiceDiscovery.DefaultRemoteResolverUrl;
    }
    async discover(host, jsonMode, mode) {
        host = host.trim();
        const config = this.cache.fetch(host);
        if (config) {
            return config;
        }
        if (!mode) {
            mode = DiscoveryMode.JSON_ONLY;
        }
        const dicoveredConfig = await this.discoverCore(host, mode, jsonMode);
        this.cache.save(host, dicoveredConfig);
        return dicoveredConfig;
    }
    async discoverCore(host, mode, jsonMode) {
        if (mode === DiscoveryMode.JSON_ONLY || mode === DiscoveryMode.JSON_AND_DNS) {
            try {
                return await this.discoverJSON(host, jsonMode);
            }
            catch (error) {
                if (mode === DiscoveryMode.JSON_AND_DNS) {
                    return this.discoverDNS(host);
                }
                throw error;
            }
        }
        return this.discoverDNS(host);
    }
    isHttpSupported(jsonMode) {
        return jsonMode == JsonMode.HTTP_ONLY || jsonMode == JsonMode.HTTP_AND_HTTPS;
    }
    isHttpsSupported(jsonMode) {
        return jsonMode == JsonMode.HTTPS_ONLY || jsonMode == JsonMode.HTTP_AND_HTTPS;
    }
    resolveSchemeless(jsonMode, url, res) {
        res = res || [];
        if (this.isHttpSupported(jsonMode)) {
            res.push("http:" + url);
        }
        if (this.isHttpsSupported(jsonMode)) {
            res.push("https:" + url);
        }
        return res;
    }
    getConfigLocations(host, jsonMode) {
        const locations = [];
        jsonMode = jsonMode == null ? JsonMode.HTTP_AND_HTTPS : jsonMode;
        PrivMXServiceDiscovery.ConfigPaths.forEach((path) => {
            this.resolveSchemeless(jsonMode, "//" + host + path, locations);
        });
        return locations;
    }
    async fetchConfig(method, url, params) {
        const makeRequest = (method === "GET") ? this.httpClient.get : this.httpClient.post;
        const response = await makeRequest.call(this.httpClient, url, params);
        const config = Config_1.default.fromJSON(response);
        return new FetchResult_1.default(url, config);
    }
    async discoverJSON(host, jsonMode) {
        const locations = this.getConfigLocations(host, jsonMode);
        const params = { x: new Date().getTime() };
        for (const location of locations.slice(0, 2)) {
            try {
                const res = await this.fetchConfig("GET", location, params);
                return res.config;
            }
            catch (e) {
            }
        }
        const promises = locations.slice(2).map(url => this.fetchConfig("GET", url, params));
        const results = await Promise.allSettled(promises);
        let fulfilledHttpConfig, fulfilledHttpsConfig;
        for (const result of results) {
            if (result.status === "fulfilled") {
                const fetchResult = result.value;
                if (fetchResult.location.lastIndexOf("https://", 0) === 0) {
                    if (!fulfilledHttpsConfig) {
                        fulfilledHttpsConfig = fetchResult.config;
                    }
                }
                else {
                    if (!fulfilledHttpConfig) {
                        fulfilledHttpConfig = fetchResult.config;
                    }
                }
            }
        }
        const config = fulfilledHttpsConfig || fulfilledHttpConfig;
        if (!config) {
            throw new Error("Config not found");
        }
        return config;
    }
    async discoverDNS(host) {
        const params = {
            host: host,
            dnsOnly: 1
        };
        const fetchResult = await this.fetchConfig("POST", this.remoteResolverUrl, params);
        return fetchResult.config;
    }
    setCache(cache) {
        this.cache = cache;
    }
    setCacheStorage(storage) {
        this.cache.setStorage(storage);
    }
}
exports.default = PrivMXServiceDiscovery;

},{"./Cache":368,"./Config":370,"./FetchResult":371,"./SimpleHttpClient":374}],373:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CacheEntry_1 = require("./CacheEntry");
const Cache_1 = require("./Cache");
class SessionStorageCache extends Cache_1.default {
    save(key, value, ttl) {
        const expires = this.computeExpireDate(ttl);
        const entry = new CacheEntry_1.default(key, value, expires);
        window.sessionStorage.setItem(key, entry.serialize());
    }
    fetch(key) {
        const serializedEntry = window.sessionStorage.getItem(key);
        if (serializedEntry) {
            const entry = CacheEntry_1.default.deserialize(serializedEntry);
            if (entry) {
                if (entry.expired()) {
                    this.delete(key);
                }
                else {
                    return entry.value;
                }
            }
        }
    }
    delete(key) {
        window.sessionStorage.removeItem(key);
    }
}
exports.default = SessionStorageCache;

},{"./Cache":368,"./CacheEntry":369}],374:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const simplito_net_1 = require("simplito-net");
class SimpleHttpClient {
    get(url, params) {
        if (params) {
            url += "?" + this.serializeParams(params);
        }
        return simplito_net_1.HttpRequest.promise({
            url: url,
            method: "GET",
            responseType: "text"
        });
    }
    post(url, params) {
        return simplito_net_1.HttpRequest.promise({
            url: url,
            method: "POST",
            responseType: "text",
            data: params
        });
    }
    serializeParams(params) {
        return Object.keys(params).map((k) => {
            return [encodeURIComponent(k), encodeURIComponent(params[k])].join("=");
        }).join("&");
    }
}
exports.default = SimpleHttpClient;

},{"simplito-net":408}],375:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleHttpClient = exports.SessionStorageCache = exports.PrivMXServiceDiscovery = exports.JsonMode = exports.DiscoveryMode = exports.FetchResult = exports.Config = exports.CacheEntry = exports.Cache = void 0;
const Cache_1 = require("./Cache");
exports.Cache = Cache_1.default;
const CacheEntry_1 = require("./CacheEntry");
exports.CacheEntry = CacheEntry_1.default;
const Config_1 = require("./Config");
exports.Config = Config_1.default;
const FetchResult_1 = require("./FetchResult");
exports.FetchResult = FetchResult_1.default;
const PrivMXServiceDiscovery_1 = require("./PrivMXServiceDiscovery");
Object.defineProperty(exports, "DiscoveryMode", { enumerable: true, get: function () { return PrivMXServiceDiscovery_1.DiscoveryMode; } });
Object.defineProperty(exports, "JsonMode", { enumerable: true, get: function () { return PrivMXServiceDiscovery_1.JsonMode; } });
Object.defineProperty(exports, "PrivMXServiceDiscovery", { enumerable: true, get: function () { return PrivMXServiceDiscovery_1.default; } });
const SessionStorageCache_1 = require("./SessionStorageCache");
exports.SessionStorageCache = SessionStorageCache_1.default;
const SimpleHttpClient_1 = require("./SimpleHttpClient");
exports.SimpleHttpClient = SimpleHttpClient_1.default;

},{"./Cache":368,"./CacheEntry":369,"./Config":370,"./FetchResult":371,"./PrivMXServiceDiscovery":372,"./SessionStorageCache":373,"./SimpleHttpClient":374}],376:[function(require,module,exports){
/*
 Copyright 2013 Daniel Wirtz <dcode@dcode.io>

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */

/**
 * @license PSON (c) 2013 Daniel Wirtz <dcode@dcode.io>
 * Released under the Apache License, Version 2.0
 * see: https://github.com/dcodeIO/PSON for details
 */
(function(global) {
    "use strict";

    function loadPSON(ByteBuffer) {
        if (!ByteBuffer) {
            throw(new Error("PSON requires ByteBuffer.js: Get it at https://github.com/dcodeIO/ByteBuffer.js"));
        }

        /**
         * PSON namespace.
         * @exports PSON
         * @namespace
         */
        var PSON = {};

        /**
         * @alias PSON.T
         */
        PSON.T = (function() {

            /**
             * PSON byte types.
             * @exports PSON.T
             * @namespace
             */
            var T = {};

            T.ZERO       = 0x00; // 0
            //             0x01; // -1
            //             0x02; // 1
            //             ...   // zig-zag encoded varints
            T.MAX        = 0xEF; // -120, max. zig-zag encoded varint

            T.NULL       = 0xF0; // null
            T.TRUE       = 0xF1; // true
            T.FALSE      = 0xF2; // false
            T.EOBJECT    = 0xF3; // {}
            T.EARRAY     = 0xF4; // []
            T.ESTRING    = 0xF5; // ""
            T.OBJECT     = 0xF6; // {...}
            T.ARRAY      = 0xF7; // [...]
            T.INTEGER    = 0xF8; // number (zig-zag encoded varint32)
            T.LONG       = 0xF9; // Long   (zig-zag encoded varint64)
            T.FLOAT      = 0xFA; // number (float32)
            T.DOUBLE     = 0xFB; // number (float64)
            T.STRING     = 0xFC; // string (varint length + data)
            T.STRING_ADD = 0xFD; // string (varint length + data, add to dictionary)
            T.STRING_GET = 0xFE; // string (varint index to get from dictionary)
            T.BINARY     = 0xFF; // bytes (varint length + data)

            return T;

        })();

        /**
         * @alias PSON.Encoder
         */
        PSON.Encoder = (function(ByteBuffer, T) {

            /**
             * Float conversion test buffer.
             * @type {!ByteBuffer}
             */
            var fbuf = new ByteBuffer(4);
            fbuf.length = 4;

            /**
             * Long.js.
             * @type {?Long}
             */
            var Long = ByteBuffer.Long;

            /**
             * Constructs a new PSON Encoder.
             * @exports PSON.Encoder
             * @class A PSON Encoder.
             * @param {Array.<string>=} dict Initial dictionary
             * @param {boolean} progressive Whether this is a progressive or a static encoder
             * @param {Object.<string,*>=} options Options
             * @constructor
             */
            var Encoder = function(dict, progressive, options) {

                /**
                 * Dictionary hash.
                 * @type {Object.<string,number>}
                 */
                this.dict = {};

                /**
                 * Next dictionary index.
                 * @type {number}
                 */
                this.next = 0;
                if (dict && Array.isArray(dict)) {
                    while (this.next < dict.length) {
                        this.dict[dict[this.next]] = this.next++;
                    }
                }

                /**
                 * Whether the encoder is progressive or static.
                 * @type {boolean}
                 */
                this.progressive = !!progressive;

                /**
                 * Options.
                 * @type {Object.<string,*>}
                 */
                this.options = options || {};
            };

            /**
             * Encodes JSON to PSON.
             * @param {*} json JSON
             * @param {(!ByteBuffer)=} buf Buffer to encode to. When omitted, the resulting ByteBuffer will be flipped. When
             *  specified, it will not be flipped.
             * @returns {!ByteBuffer} PSON
             */
            Encoder.prototype.encode = function(json, buf) {
                var doFlip = false;
                if (!buf) {
                    buf = new ByteBuffer();
                    doFlip = true;
                }
                var le = buf.littleEndian;
                try {
                    this._encodeValue(json, buf.LE());
                    buf.littleEndian = le;
                    return doFlip ? buf.flip() : buf;
                } catch (e) {
                    buf.littleEndian = le;
                    throw(e);
                }
            };

            /**
             * Encodes a single JSON value to PSON.
             * @param {*} val JSON value
             * @param {!ByteBuffer} buf Target buffer
             * @param {boolean=} excluded Whether keywords are to be excluded or not
             * @private
             */
            Encoder.prototype._encodeValue = function(val, buf, excluded) {
                if (val === null) {
                    buf.writeUint8(T.NULL);
                } else {
                    switch (typeof val) {
                        case 'function':
                            val = val.toString();
                            // fall through
                        case 'string':
                            if (val.length === 0) {
                                buf.writeUint8(T.ESTRING);
                            } else {
                                if (this.dict.hasOwnProperty(val)) {
                                    buf.writeUint8(T.STRING_GET);
                                    buf.writeVarint32(this.dict[val]);
                                } else {
                                    buf.writeUint8(T.STRING);
                                    buf.writeVString(val);
                                }
                            }
                            break;
                        case 'number':
                            var intVal = parseInt(val);
                            if (val === intVal) {
                                if (val > -2147483647 && val < 2147483648) {
                                  var zzval = ByteBuffer.zigZagEncode32(val); // unsigned
                                  if (zzval <= T.MAX) {
                                      buf.writeUint8(zzval);
                                  } else {
                                      buf.writeUint8(T.INTEGER);
                                      buf.writeVarint32ZigZag(val);
                                  }
                                } else {
                                  buf.writeUint8(T.LONG);
                                  buf.writeVarint64ZigZag(Long.fromValue(val));
                                }
                            } else {
                                fbuf.writeFloat32(val, 0);
                                if (val === fbuf.readFloat32(0)) {
                                    buf.writeUint8(T.FLOAT);
                                    buf.writeFloat32(val);
                                } else {
                                    buf.writeUint8(T.DOUBLE);
                                    buf.writeFloat64(val);
                                }
                            }
                            break;
                        case 'boolean':
                            buf.writeUint8(val ? T.TRUE : T.FALSE);
                            break;
                        case 'object':
                            var i;
                            if (Array.isArray(val)) {
                                if (val.length === 0) {
                                    buf.writeUint8(T.EARRAY);
                                } else {
                                    buf.writeUint8(T.ARRAY);
                                    buf.writeVarint32(val.length);
                                    for (i=0; i<val.length; i++) {
                                        this._encodeValue(val[i], buf);
                                    }
                                }
                            } else if (Long && val instanceof Long) {
                                buf.writeUint8(T.LONG);
                                buf.writeVarint64ZigZag(val);
                            } else {
                                try {
                                    val = ByteBuffer.wrap(val);
                                    buf.writeUint8(T.BINARY);
                                    buf.writeVarint32(val.remaining());
                                    buf.append(val);
                                } catch (e) {
                                    var keys = Object.keys(val);
                                    var n = 0;
                                    for (i=0; i<keys.length; i++) {
                                        if (typeof val[keys[i]] !== 'undefined') n++;
                                    }
                                    if (n === 0) {
                                        buf.writeUint8(T.EOBJECT);
                                    } else {
                                        buf.writeUint8(T.OBJECT);
                                        buf.writeVarint32(n);
                                        if (!excluded) excluded = !!val._PSON_EXCL_;
                                        for (i=0; i<keys.length; i++) {
                                            var key = keys[i];
                                            if (typeof val[key] === 'undefined') continue;
                                            if (this.dict.hasOwnProperty(key)) {
                                                buf.writeUint8(T.STRING_GET);
                                                buf.writeVarint32(this.dict[key]);
                                            } else {
                                                if (this.progressive && !excluded) {
                                                    // Add to dictionary
                                                    this.dict[key] = this.next++;
                                                    buf.writeUint8(T.STRING_ADD);
                                                } else {
                                                    // Plain string
                                                    buf.writeUint8(T.STRING);
                                                }
                                                buf.writeVString(key);
                                            }
                                            this._encodeValue(val[key], buf);
                                        }
                                    }
                                }
                            }
                            break;
                        case 'undefined':
                            buf.writeUint8(T.NULL);
                            break;
                    }
                }
            };

            return Encoder;

        })(ByteBuffer, PSON.T);

        /**
         * @alias PSON.Decoder
         */
        PSON.Decoder = (function(ByteBuffer, T) {

            /**
             * Long.js.
             * @type {?Long}
             */
            var Long = ByteBuffer.Long;

            /**
             * Constructs a new PSON Decoder.
             * @exports PSON.Decoder
             * @class A PSON Decoder.
             * @param {Array.<string>} dict Initial dictionary values
             * @param {boolean} progressive Whether this is a progressive or a static decoder
             * @param {Object.<string,*>=} options Options
             * @constructor
             */
            var Decoder = function(dict, progressive, options) {

                /**
                 * Dictionary array.
                 * @type {Array.<string>}
                 */
                this.dict = (dict && Array.isArray(dict)) ? dict : [];

                /**
                 * Whether this is a progressive or a static decoder.
                 * @type {boolean}
                 */
                this.progressive = !!progressive;

                /**
                 * Options.
                 * @type {Object.<string,*>}
                 */
                this.options = options || {};
            };

            /**
             * Decodes PSON to JSON.
             * @param {!(ByteBuffer|ArrayBuffer|Buffer)} buf PSON
             * @returns {?} JSON
             */
            Decoder.prototype.decode = function(buf) {
                if (!(buf instanceof ByteBuffer)) {
                    buf = ByteBuffer.wrap(buf);
                }
                var le = buf.littleEndian;
                try {
                    var val = this._decodeValue(buf.LE());
                    buf.littleEndian = le;
                    return val;
                } catch (e) {
                    buf.littleEndian = le;
                    throw(e);
                }
            };

            /**
             * Decodes a single PSON value to JSON.
             * @param {!ByteBuffer} buf Buffer to decode from
             * @returns {?} JSON
             * @private
             */
            Decoder.prototype._decodeValue = function(buf) {
                var t = buf.readUint8();
                if (t <= T.MAX) {
                    return ByteBuffer.zigZagDecode32(t);
                } else {
                    switch (t) {
                        case T.NULL: return null;
                        case T.TRUE: return true;
                        case T.FALSE: return false;
                        case T.EOBJECT: return {};
                        case T.EARRAY: return [];
                        case T.ESTRING: return "";
                        case T.OBJECT:
                            t = buf.readVarint32(); // #keys
                            var obj = {};
                            while (--t>=0) {
                                obj[this._decodeValue(buf)] = this._decodeValue(buf);
                            }
                            return obj;
                        case T.ARRAY:
                            t = buf.readVarint32(); // #items
                            var arr = [];
                            while (--t>=0) {
                                arr.push(this._decodeValue(buf));
                            }
                            return arr;
                        case T.INTEGER: return buf.readVarint32ZigZag();
                        case T.LONG: // must not crash
                            if (Long) return buf.readVarint64ZigZag().toNumber();
                            return buf.readVarint32ZigZag();
                        case T.FLOAT: return buf.readFloat32();
                        case T.DOUBLE: return buf.readFloat64();
                        case T.STRING: return buf.readVString();
                        case T.STRING_ADD:
                            var str = buf.readVString();
                            this.dict.push(str);
                            return str;
                        case T.STRING_GET:
                            return this.dict[buf.readVarint32()];
                        case T.BINARY:
                            t = buf.readVarint32();
                            var ret = buf.slice(buf.offset, buf.offset+t);
                            buf.offset += t;
                            return ret;
                        default:
                            throw(new Error("Illegal type at "+buf.offset+": "+t));
                    }
                }
            };

            return Decoder;

        })(ByteBuffer, PSON.T);

        /**
         * @alias PSON.Pair
         */
        PSON.Pair = (function() {

            /**
             * Constructs a new abstract PSON encoder and decoder pair.
             * @exports PSON.Pair
             * @class An abstract PSON encoder and decoder pair.
             * @constructor
             * @abstract
             */
            var Pair = function() {

                /**
                 * Encoder.
                 * @type {!PSON.Encoder}
                 * @expose
                 */
                this.encoder;

                /**
                 * Decoder.
                 * @type {!PSON.Decoder}
                 * @expose
                 */
                this.decoder;
            };

            /**
             * Encodes JSON to PSON.
             * @param {*} json JSON
             * @returns {!ByteBuffer} PSON
             * @expose
             */
            Pair.prototype.encode = function(json) {
                return this.encoder.encode(json);
            };

            /**
             * Encodes JSON straight to an ArrayBuffer of PSON.
             * @param {*} json JSON
             * @returns {!ArrayBuffer} PSON as ArrayBuffer
             * @expose
             */
            Pair.prototype.toArrayBuffer = function(json) {
                return this.encoder.encode(json).toArrayBuffer();
            };

            /**
             * Encodes JSON straight to a node Buffer of PSON.
             * @param {*} json JSON
             * @returns {!Buffer} PSON as node Buffer
             * @expose
             */
            Pair.prototype.toBuffer = function(json) {
                return this.encoder.encode(json).toBuffer();
            };

            /**
             * Decodes PSON to JSON.
             * @param {ByteBuffer|ArrayBuffer|Buffer} pson PSON
             * @returns {*} JSON
             * @expose
             */
            Pair.prototype.decode = function(pson) {
                return this.decoder.decode(pson);
            };

            return Pair;
        })();

        /**
         * @alias PSON.StaticPair
         */
        PSON.StaticPair = (function(Pair, Encoder, Decoder) {

            /**
             * Constructs a new static PSON encoder and decoder pair.
             * @exports PSON.StaticPair
             * @class A static PSON encoder and decoder pair.
             * @param {Array.<string>=} dict Static dictionary
             * @param {Object.<string,*>=} options Options
             * @constructor
             * @extends PSON.Pair
             */
            var StaticPair = function(dict, options) {
                Pair.call(this);

                this.encoder = new Encoder(dict, false, options);
                this.decoder = new Decoder(dict, false, options);
            };

            // Extends PSON.Pair
            StaticPair.prototype = Object.create(Pair.prototype);

            return StaticPair;

        })(PSON.Pair, PSON.Encoder, PSON.Decoder);

        /**
         * @alias PSON.ProgressivePair
         */
        PSON.ProgressivePair = (function(Pair, Encoder, Decoder) {

            /**
             * Constructs a new progressive PSON encoder and decoder pair.
             * @exports PSON.ProgressivePair
             * @class A progressive PSON encoder and decoder pair.
             * @param {Array.<string>=} dict Initial dictionary
             * @param {Object.<string,*>=} options Options
             * @constructor
             * @extends PSON.Pair
             */
            var ProgressivePair = function(dict, options) {
                Pair.call(this);

                this.encoder = new Encoder(dict, true, options);
                this.decoder = new Decoder(dict, true, options);
            };

            // Extends PSON.Pair
            ProgressivePair.prototype = Object.create(Pair.prototype);

            /**
             * Alias for {@link PSON.exclude}.
             * @param {Object} obj Now excluded object
             */
            ProgressivePair.prototype.exclude = function(obj) {
                PSON.exclude(obj);
            };

            /**
             * Alias for {@link PSON.include}.
             * @param {Object} obj New included object
             */
            ProgressivePair.prototype.include = function(obj) {
                PSON.include(obj);
            };

            return ProgressivePair;

        })(PSON.Pair, PSON.Encoder, PSON.Decoder);

        /**
         * Excluces an object's and its children's keys from being added to a progressive dictionary.
         * @param {Object} obj Now excluded object
         */
        PSON.exclude = function(obj) {
            if (typeof obj === 'object') {
                Object.defineProperty(obj, "_PSON_EXCL_", {
                    value: true,
                    enumerable: false,
                    configurable: true
                });
            }
        };

        /**
         * Undoes exclusion of an object's and its children's keys from being added to a progressive dictionary.
         * @param {Object} obj Now included object
         */
        PSON.include = function(obj) {
            if (typeof obj === 'object') {
                delete obj["_PSON_EXCL_"];
            }
        };

        return PSON;
    }

    // Enable module loading if available
    if (typeof module != 'undefined' && module["exports"]) { // CommonJS
        module["exports"] = loadPSON(require("bytebuffer"));
    } else if (typeof define != 'undefined' && define["amd"]) { // AMD
        define("PSON", ["ByteBuffer"], loadPSON);
    } else {
        if (!global["dcodeIO"]) {
            global["dcodeIO"] = {};
        }
        global["dcodeIO"]["PSON"] = loadPSON(global["dcodeIO"]["ByteBuffer"]);
    }

})(this);

},{"bytebuffer":48}],377:[function(require,module,exports){
(function (process,global){(function (){
'use strict'

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = require('safe-buffer').Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > 65536) throw new Error('requested too many random bytes')
  // in case browserify  isn't using the Uint8Array version
  var rawBytes = new global.Uint8Array(size)

  // This will not work in older browsers.
  // See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
  if (size > 0) {  // getRandomValues fails on IE if size == 0
    crypto.getRandomValues(rawBytes)
  }

  // XXX: phantomjs doesn't like a buffer being passed here
  var bytes = Buffer.from(rawBytes.buffer)

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"_process":592,"safe-buffer":379}],378:[function(require,module,exports){
'use strict'
var Buffer = require('buffer').Buffer
var inherits = require('inherits')
var HashBase = require('hash-base')

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160

},{"buffer":498,"hash-base":69,"inherits":100}],379:[function(require,module,exports){
/* eslint-disable node/no-deprecated-api */
var buffer = require('buffer')
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}

},{"buffer":498}],380:[function(require,module,exports){
(function (process){(function (){
/* eslint-disable node/no-deprecated-api */

'use strict'

var buffer = require('buffer')
var Buffer = buffer.Buffer

var safer = {}

var key

for (key in buffer) {
  if (!buffer.hasOwnProperty(key)) continue
  if (key === 'SlowBuffer' || key === 'Buffer') continue
  safer[key] = buffer[key]
}

var Safer = safer.Buffer = {}
for (key in Buffer) {
  if (!Buffer.hasOwnProperty(key)) continue
  if (key === 'allocUnsafe' || key === 'allocUnsafeSlow') continue
  Safer[key] = Buffer[key]
}

safer.Buffer.prototype = Buffer.prototype

if (!Safer.from || Safer.from === Uint8Array.from) {
  Safer.from = function (value, encodingOrOffset, length) {
    if (typeof value === 'number') {
      throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value)
    }
    if (value && typeof value.length === 'undefined') {
      throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' + typeof value)
    }
    return Buffer(value, encodingOrOffset, length)
  }
}

if (!Safer.alloc) {
  Safer.alloc = function (size, fill, encoding) {
    if (typeof size !== 'number') {
      throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size)
    }
    if (size < 0 || size >= 2 * (1 << 30)) {
      throw new RangeError('The value "' + size + '" is invalid for option "size"')
    }
    var buf = Buffer(size)
    if (!fill || fill.length === 0) {
      buf.fill(0)
    } else if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
    return buf
  }
}

if (!safer.kStringMaxLength) {
  try {
    safer.kStringMaxLength = process.binding('buffer').kStringMaxLength
  } catch (e) {
    // we can't determine kStringMaxLength in environments where process.binding
    // is unsupported, so let's not set it
  }
}

if (!safer.constants) {
  safer.constants = {
    MAX_LENGTH: safer.kMaxLength
  }
  if (safer.kStringMaxLength) {
    safer.constants.MAX_STRING_LENGTH = safer.kStringMaxLength
  }
}

module.exports = safer

}).call(this)}).call(this,require('_process'))
},{"_process":592,"buffer":498}],381:[function(require,module,exports){
// A library of seedable RNGs implemented in Javascript.
//
// Usage:
//
// var seedrandom = require('seedrandom');
// var random = seedrandom(1); // or any seed.
// var x = random();       // 0 <= x < 1.  Every bit is random.
// var x = random.quick(); // 0 <= x < 1.  32 bits of randomness.

// alea, a 53-bit multiply-with-carry generator by Johannes Baagøe.
// Period: ~2^116
// Reported to pass all BigCrush tests.
var alea = require('./lib/alea');

// xor128, a pure xor-shift generator by George Marsaglia.
// Period: 2^128-1.
// Reported to fail: MatrixRank and LinearComp.
var xor128 = require('./lib/xor128');

// xorwow, George Marsaglia's 160-bit xor-shift combined plus weyl.
// Period: 2^192-2^32
// Reported to fail: CollisionOver, SimpPoker, and LinearComp.
var xorwow = require('./lib/xorwow');

// xorshift7, by François Panneton and Pierre L'ecuyer, takes
// a different approach: it adds robustness by allowing more shifts
// than Marsaglia's original three.  It is a 7-shift generator
// with 256 bits, that passes BigCrush with no systmatic failures.
// Period 2^256-1.
// No systematic BigCrush failures reported.
var xorshift7 = require('./lib/xorshift7');

// xor4096, by Richard Brent, is a 4096-bit xor-shift with a
// very long period that also adds a Weyl generator. It also passes
// BigCrush with no systematic failures.  Its long period may
// be useful if you have many generators and need to avoid
// collisions.
// Period: 2^4128-2^32.
// No systematic BigCrush failures reported.
var xor4096 = require('./lib/xor4096');

// Tyche-i, by Samuel Neves and Filipe Araujo, is a bit-shifting random
// number generator derived from ChaCha, a modern stream cipher.
// https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf
// Period: ~2^127
// No systematic BigCrush failures reported.
var tychei = require('./lib/tychei');

// The original ARC4-based prng included in this library.
// Period: ~2^1600
var sr = require('./seedrandom');

sr.alea = alea;
sr.xor128 = xor128;
sr.xorwow = xorwow;
sr.xorshift7 = xorshift7;
sr.xor4096 = xor4096;
sr.tychei = tychei;

module.exports = sr;

},{"./lib/alea":382,"./lib/tychei":383,"./lib/xor128":384,"./lib/xor4096":385,"./lib/xorshift7":386,"./lib/xorwow":387,"./seedrandom":388}],382:[function(require,module,exports){
// A port of an algorithm by Johannes Baagøe <baagoe@baagoe.com>, 2010
// http://baagoe.com/en/RandomMusings/javascript/
// https://github.com/nquinlan/better-random-numbers-for-javascript-mirror
// Original work is under MIT license -

// Copyright (C) 2010 by Johannes Baagøe <baagoe@baagoe.org>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
// 
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
// 
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.



(function(global, module, define) {

function Alea(seed) {
  var me = this, mash = Mash();

  me.next = function() {
    var t = 2091639 * me.s0 + me.c * 2.3283064365386963e-10; // 2^-32
    me.s0 = me.s1;
    me.s1 = me.s2;
    return me.s2 = t - (me.c = t | 0);
  };

  // Apply the seeding algorithm from Baagoe.
  me.c = 1;
  me.s0 = mash(' ');
  me.s1 = mash(' ');
  me.s2 = mash(' ');
  me.s0 -= mash(seed);
  if (me.s0 < 0) { me.s0 += 1; }
  me.s1 -= mash(seed);
  if (me.s1 < 0) { me.s1 += 1; }
  me.s2 -= mash(seed);
  if (me.s2 < 0) { me.s2 += 1; }
  mash = null;
}

function copy(f, t) {
  t.c = f.c;
  t.s0 = f.s0;
  t.s1 = f.s1;
  t.s2 = f.s2;
  return t;
}

function impl(seed, opts) {
  var xg = new Alea(seed),
      state = opts && opts.state,
      prng = xg.next;
  prng.int32 = function() { return (xg.next() * 0x100000000) | 0; }
  prng.double = function() {
    return prng() + (prng() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
  };
  prng.quick = prng;
  if (state) {
    if (typeof(state) == 'object') copy(state, xg);
    prng.state = function() { return copy(xg, {}); }
  }
  return prng;
}

function Mash() {
  var n = 0xefc8249d;

  var mash = function(data) {
    data = data.toString();
    for (var i = 0; i < data.length; i++) {
      n += data.charCodeAt(i);
      var h = 0.02519603282416938 * n;
      n = h >>> 0;
      h -= n;
      h *= n;
      n = h >>> 0;
      h -= n;
      n += h * 0x100000000; // 2^32
    }
    return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
  };

  return mash;
}


if (module && module.exports) {
  module.exports = impl;
} else if (define && define.amd) {
  define(function() { return impl; });
} else {
  this.alea = impl;
}

})(
  this,
  (typeof module) == 'object' && module,    // present in node.js
  (typeof define) == 'function' && define   // present with an AMD loader
);



},{}],383:[function(require,module,exports){
// A Javascript implementaion of the "Tyche-i" prng algorithm by
// Samuel Neves and Filipe Araujo.
// See https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf

(function(global, module, define) {

function XorGen(seed) {
  var me = this, strseed = '';

  // Set up generator function.
  me.next = function() {
    var b = me.b, c = me.c, d = me.d, a = me.a;
    b = (b << 25) ^ (b >>> 7) ^ c;
    c = (c - d) | 0;
    d = (d << 24) ^ (d >>> 8) ^ a;
    a = (a - b) | 0;
    me.b = b = (b << 20) ^ (b >>> 12) ^ c;
    me.c = c = (c - d) | 0;
    me.d = (d << 16) ^ (c >>> 16) ^ a;
    return me.a = (a - b) | 0;
  };

  /* The following is non-inverted tyche, which has better internal
   * bit diffusion, but which is about 25% slower than tyche-i in JS.
  me.next = function() {
    var a = me.a, b = me.b, c = me.c, d = me.d;
    a = (me.a + me.b | 0) >>> 0;
    d = me.d ^ a; d = d << 16 ^ d >>> 16;
    c = me.c + d | 0;
    b = me.b ^ c; b = b << 12 ^ d >>> 20;
    me.a = a = a + b | 0;
    d = d ^ a; me.d = d = d << 8 ^ d >>> 24;
    me.c = c = c + d | 0;
    b = b ^ c;
    return me.b = (b << 7 ^ b >>> 25);
  }
  */

  me.a = 0;
  me.b = 0;
  me.c = 2654435769 | 0;
  me.d = 1367130551;

  if (seed === Math.floor(seed)) {
    // Integer seed.
    me.a = (seed / 0x100000000) | 0;
    me.b = seed | 0;
  } else {
    // String seed.
    strseed += seed;
  }

  // Mix in string seed, then discard an initial batch of 64 values.
  for (var k = 0; k < strseed.length + 20; k++) {
    me.b ^= strseed.charCodeAt(k) | 0;
    me.next();
  }
}

function copy(f, t) {
  t.a = f.a;
  t.b = f.b;
  t.c = f.c;
  t.d = f.d;
  return t;
};

function impl(seed, opts) {
  var xg = new XorGen(seed),
      state = opts && opts.state,
      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
  prng.double = function() {
    do {
      var top = xg.next() >>> 11,
          bot = (xg.next() >>> 0) / 0x100000000,
          result = (top + bot) / (1 << 21);
    } while (result === 0);
    return result;
  };
  prng.int32 = xg.next;
  prng.quick = prng;
  if (state) {
    if (typeof(state) == 'object') copy(state, xg);
    prng.state = function() { return copy(xg, {}); }
  }
  return prng;
}

if (module && module.exports) {
  module.exports = impl;
} else if (define && define.amd) {
  define(function() { return impl; });
} else {
  this.tychei = impl;
}

})(
  this,
  (typeof module) == 'object' && module,    // present in node.js
  (typeof define) == 'function' && define   // present with an AMD loader
);



},{}],384:[function(require,module,exports){
// A Javascript implementaion of the "xor128" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper

(function(global, module, define) {

function XorGen(seed) {
  var me = this, strseed = '';

  me.x = 0;
  me.y = 0;
  me.z = 0;
  me.w = 0;

  // Set up generator function.
  me.next = function() {
    var t = me.x ^ (me.x << 11);
    me.x = me.y;
    me.y = me.z;
    me.z = me.w;
    return me.w ^= (me.w >>> 19) ^ t ^ (t >>> 8);
  };

  if (seed === (seed | 0)) {
    // Integer seed.
    me.x = seed;
  } else {
    // String seed.
    strseed += seed;
  }

  // Mix in string seed, then discard an initial batch of 64 values.
  for (var k = 0; k < strseed.length + 64; k++) {
    me.x ^= strseed.charCodeAt(k) | 0;
    me.next();
  }
}

function copy(f, t) {
  t.x = f.x;
  t.y = f.y;
  t.z = f.z;
  t.w = f.w;
  return t;
}

function impl(seed, opts) {
  var xg = new XorGen(seed),
      state = opts && opts.state,
      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
  prng.double = function() {
    do {
      var top = xg.next() >>> 11,
          bot = (xg.next() >>> 0) / 0x100000000,
          result = (top + bot) / (1 << 21);
    } while (result === 0);
    return result;
  };
  prng.int32 = xg.next;
  prng.quick = prng;
  if (state) {
    if (typeof(state) == 'object') copy(state, xg);
    prng.state = function() { return copy(xg, {}); }
  }
  return prng;
}

if (module && module.exports) {
  module.exports = impl;
} else if (define && define.amd) {
  define(function() { return impl; });
} else {
  this.xor128 = impl;
}

})(
  this,
  (typeof module) == 'object' && module,    // present in node.js
  (typeof define) == 'function' && define   // present with an AMD loader
);



},{}],385:[function(require,module,exports){
// A Javascript implementaion of Richard Brent's Xorgens xor4096 algorithm.
//
// This fast non-cryptographic random number generator is designed for
// use in Monte-Carlo algorithms. It combines a long-period xorshift
// generator with a Weyl generator, and it passes all common batteries
// of stasticial tests for randomness while consuming only a few nanoseconds
// for each prng generated.  For background on the generator, see Brent's
// paper: "Some long-period random number generators using shifts and xors."
// http://arxiv.org/pdf/1004.3115v1.pdf
//
// Usage:
//
// var xor4096 = require('xor4096');
// random = xor4096(1);                        // Seed with int32 or string.
// assert.equal(random(), 0.1520436450538547); // (0, 1) range, 53 bits.
// assert.equal(random.int32(), 1806534897);   // signed int32, 32 bits.
//
// For nonzero numeric keys, this impelementation provides a sequence
// identical to that by Brent's xorgens 3 implementaion in C.  This
// implementation also provides for initalizing the generator with
// string seeds, or for saving and restoring the state of the generator.
//
// On Chrome, this prng benchmarks about 2.1 times slower than
// Javascript's built-in Math.random().

(function(global, module, define) {

function XorGen(seed) {
  var me = this;

  // Set up generator function.
  me.next = function() {
    var w = me.w,
        X = me.X, i = me.i, t, v;
    // Update Weyl generator.
    me.w = w = (w + 0x61c88647) | 0;
    // Update xor generator.
    v = X[(i + 34) & 127];
    t = X[i = ((i + 1) & 127)];
    v ^= v << 13;
    t ^= t << 17;
    v ^= v >>> 15;
    t ^= t >>> 12;
    // Update Xor generator array state.
    v = X[i] = v ^ t;
    me.i = i;
    // Result is the combination.
    return (v + (w ^ (w >>> 16))) | 0;
  };

  function init(me, seed) {
    var t, v, i, j, w, X = [], limit = 128;
    if (seed === (seed | 0)) {
      // Numeric seeds initialize v, which is used to generates X.
      v = seed;
      seed = null;
    } else {
      // String seeds are mixed into v and X one character at a time.
      seed = seed + '\0';
      v = 0;
      limit = Math.max(limit, seed.length);
    }
    // Initialize circular array and weyl value.
    for (i = 0, j = -32; j < limit; ++j) {
      // Put the unicode characters into the array, and shuffle them.
      if (seed) v ^= seed.charCodeAt((j + 32) % seed.length);
      // After 32 shuffles, take v as the starting w value.
      if (j === 0) w = v;
      v ^= v << 10;
      v ^= v >>> 15;
      v ^= v << 4;
      v ^= v >>> 13;
      if (j >= 0) {
        w = (w + 0x61c88647) | 0;     // Weyl.
        t = (X[j & 127] ^= (v + w));  // Combine xor and weyl to init array.
        i = (0 == t) ? i + 1 : 0;     // Count zeroes.
      }
    }
    // We have detected all zeroes; make the key nonzero.
    if (i >= 128) {
      X[(seed && seed.length || 0) & 127] = -1;
    }
    // Run the generator 512 times to further mix the state before using it.
    // Factoring this as a function slows the main generator, so it is just
    // unrolled here.  The weyl generator is not advanced while warming up.
    i = 127;
    for (j = 4 * 128; j > 0; --j) {
      v = X[(i + 34) & 127];
      t = X[i = ((i + 1) & 127)];
      v ^= v << 13;
      t ^= t << 17;
      v ^= v >>> 15;
      t ^= t >>> 12;
      X[i] = v ^ t;
    }
    // Storing state as object members is faster than using closure variables.
    me.w = w;
    me.X = X;
    me.i = i;
  }

  init(me, seed);
}

function copy(f, t) {
  t.i = f.i;
  t.w = f.w;
  t.X = f.X.slice();
  return t;
};

function impl(seed, opts) {
  if (seed == null) seed = +(new Date);
  var xg = new XorGen(seed),
      state = opts && opts.state,
      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
  prng.double = function() {
    do {
      var top = xg.next() >>> 11,
          bot = (xg.next() >>> 0) / 0x100000000,
          result = (top + bot) / (1 << 21);
    } while (result === 0);
    return result;
  };
  prng.int32 = xg.next;
  prng.quick = prng;
  if (state) {
    if (state.X) copy(state, xg);
    prng.state = function() { return copy(xg, {}); }
  }
  return prng;
}

if (module && module.exports) {
  module.exports = impl;
} else if (define && define.amd) {
  define(function() { return impl; });
} else {
  this.xor4096 = impl;
}

})(
  this,                                     // window object or global
  (typeof module) == 'object' && module,    // present in node.js
  (typeof define) == 'function' && define   // present with an AMD loader
);

},{}],386:[function(require,module,exports){
// A Javascript implementaion of the "xorshift7" algorithm by
// François Panneton and Pierre L'ecuyer:
// "On the Xorgshift Random Number Generators"
// http://saluc.engr.uconn.edu/refs/crypto/rng/panneton05onthexorshift.pdf

(function(global, module, define) {

function XorGen(seed) {
  var me = this;

  // Set up generator function.
  me.next = function() {
    // Update xor generator.
    var X = me.x, i = me.i, t, v, w;
    t = X[i]; t ^= (t >>> 7); v = t ^ (t << 24);
    t = X[(i + 1) & 7]; v ^= t ^ (t >>> 10);
    t = X[(i + 3) & 7]; v ^= t ^ (t >>> 3);
    t = X[(i + 4) & 7]; v ^= t ^ (t << 7);
    t = X[(i + 7) & 7]; t = t ^ (t << 13); v ^= t ^ (t << 9);
    X[i] = v;
    me.i = (i + 1) & 7;
    return v;
  };

  function init(me, seed) {
    var j, w, X = [];

    if (seed === (seed | 0)) {
      // Seed state array using a 32-bit integer.
      w = X[0] = seed;
    } else {
      // Seed state using a string.
      seed = '' + seed;
      for (j = 0; j < seed.length; ++j) {
        X[j & 7] = (X[j & 7] << 15) ^
            (seed.charCodeAt(j) + X[(j + 1) & 7] << 13);
      }
    }
    // Enforce an array length of 8, not all zeroes.
    while (X.length < 8) X.push(0);
    for (j = 0; j < 8 && X[j] === 0; ++j);
    if (j == 8) w = X[7] = -1; else w = X[j];

    me.x = X;
    me.i = 0;

    // Discard an initial 256 values.
    for (j = 256; j > 0; --j) {
      me.next();
    }
  }

  init(me, seed);
}

function copy(f, t) {
  t.x = f.x.slice();
  t.i = f.i;
  return t;
}

function impl(seed, opts) {
  if (seed == null) seed = +(new Date);
  var xg = new XorGen(seed),
      state = opts && opts.state,
      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
  prng.double = function() {
    do {
      var top = xg.next() >>> 11,
          bot = (xg.next() >>> 0) / 0x100000000,
          result = (top + bot) / (1 << 21);
    } while (result === 0);
    return result;
  };
  prng.int32 = xg.next;
  prng.quick = prng;
  if (state) {
    if (state.x) copy(state, xg);
    prng.state = function() { return copy(xg, {}); }
  }
  return prng;
}

if (module && module.exports) {
  module.exports = impl;
} else if (define && define.amd) {
  define(function() { return impl; });
} else {
  this.xorshift7 = impl;
}

})(
  this,
  (typeof module) == 'object' && module,    // present in node.js
  (typeof define) == 'function' && define   // present with an AMD loader
);


},{}],387:[function(require,module,exports){
// A Javascript implementaion of the "xorwow" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper

(function(global, module, define) {

function XorGen(seed) {
  var me = this, strseed = '';

  // Set up generator function.
  me.next = function() {
    var t = (me.x ^ (me.x >>> 2));
    me.x = me.y; me.y = me.z; me.z = me.w; me.w = me.v;
    return (me.d = (me.d + 362437 | 0)) +
       (me.v = (me.v ^ (me.v << 4)) ^ (t ^ (t << 1))) | 0;
  };

  me.x = 0;
  me.y = 0;
  me.z = 0;
  me.w = 0;
  me.v = 0;

  if (seed === (seed | 0)) {
    // Integer seed.
    me.x = seed;
  } else {
    // String seed.
    strseed += seed;
  }

  // Mix in string seed, then discard an initial batch of 64 values.
  for (var k = 0; k < strseed.length + 64; k++) {
    me.x ^= strseed.charCodeAt(k) | 0;
    if (k == strseed.length) {
      me.d = me.x << 10 ^ me.x >>> 4;
    }
    me.next();
  }
}

function copy(f, t) {
  t.x = f.x;
  t.y = f.y;
  t.z = f.z;
  t.w = f.w;
  t.v = f.v;
  t.d = f.d;
  return t;
}

function impl(seed, opts) {
  var xg = new XorGen(seed),
      state = opts && opts.state,
      prng = function() { return (xg.next() >>> 0) / 0x100000000; };
  prng.double = function() {
    do {
      var top = xg.next() >>> 11,
          bot = (xg.next() >>> 0) / 0x100000000,
          result = (top + bot) / (1 << 21);
    } while (result === 0);
    return result;
  };
  prng.int32 = xg.next;
  prng.quick = prng;
  if (state) {
    if (typeof(state) == 'object') copy(state, xg);
    prng.state = function() { return copy(xg, {}); }
  }
  return prng;
}

if (module && module.exports) {
  module.exports = impl;
} else if (define && define.amd) {
  define(function() { return impl; });
} else {
  this.xorwow = impl;
}

})(
  this,
  (typeof module) == 'object' && module,    // present in node.js
  (typeof define) == 'function' && define   // present with an AMD loader
);



},{}],388:[function(require,module,exports){
/*
Copyright 2014 David Bau.

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

(function (pool, math) {
//
// The following constants are related to IEEE 754 limits.
//

// Detect the global object, even if operating in strict mode.
// http://stackoverflow.com/a/14387057/265298
var global = (0, eval)('this'),
    width = 256,        // each RC4 output is 0 <= x < 256
    chunks = 6,         // at least six RC4 outputs for each double
    digits = 52,        // there are 52 significant digits in a double
    rngname = 'random', // rngname: name for Math.random and Math.seedrandom
    startdenom = math.pow(width, chunks),
    significance = math.pow(2, digits),
    overflow = significance * 2,
    mask = width - 1,
    nodecrypto;         // node.js crypto module, initialized at the bottom.

//
// seedrandom()
// This is the seedrandom function described above.
//
function seedrandom(seed, options, callback) {
  var key = [];
  options = (options == true) ? { entropy: true } : (options || {});

  // Flatten the seed string or build one from local entropy if needed.
  var shortseed = mixkey(flatten(
    options.entropy ? [seed, tostring(pool)] :
    (seed == null) ? autoseed() : seed, 3), key);

  // Use the seed to initialize an ARC4 generator.
  var arc4 = new ARC4(key);

  // This function returns a random double in [0, 1) that contains
  // randomness in every bit of the mantissa of the IEEE 754 value.
  var prng = function() {
    var n = arc4.g(chunks),             // Start with a numerator n < 2 ^ 48
        d = startdenom,                 //   and denominator d = 2 ^ 48.
        x = 0;                          //   and no 'extra last byte'.
    while (n < significance) {          // Fill up all significant digits by
      n = (n + x) * width;              //   shifting numerator and
      d *= width;                       //   denominator and generating a
      x = arc4.g(1);                    //   new least-significant-byte.
    }
    while (n >= overflow) {             // To avoid rounding up, before adding
      n /= 2;                           //   last byte, shift everything
      d /= 2;                           //   right using integer math until
      x >>>= 1;                         //   we have exactly the desired bits.
    }
    return (n + x) / d;                 // Form the number within [0, 1).
  };

  prng.int32 = function() { return arc4.g(4) | 0; }
  prng.quick = function() { return arc4.g(4) / 0x100000000; }
  prng.double = prng;

  // Mix the randomness into accumulated entropy.
  mixkey(tostring(arc4.S), pool);

  // Calling convention: what to return as a function of prng, seed, is_math.
  return (options.pass || callback ||
      function(prng, seed, is_math_call, state) {
        if (state) {
          // Load the arc4 state from the given state if it has an S array.
          if (state.S) { copy(state, arc4); }
          // Only provide the .state method if requested via options.state.
          prng.state = function() { return copy(arc4, {}); }
        }

        // If called as a method of Math (Math.seedrandom()), mutate
        // Math.random because that is how seedrandom.js has worked since v1.0.
        if (is_math_call) { math[rngname] = prng; return seed; }

        // Otherwise, it is a newer calling convention, so return the
        // prng directly.
        else return prng;
      })(
  prng,
  shortseed,
  'global' in options ? options.global : (this == math),
  options.state);
}
math['seed' + rngname] = seedrandom;

//
// ARC4
//
// An ARC4 implementation.  The constructor takes a key in the form of
// an array of at most (width) integers that should be 0 <= x < (width).
//
// The g(count) method returns a pseudorandom integer that concatenates
// the next (count) outputs from ARC4.  Its return value is a number x
// that is in the range 0 <= x < (width ^ count).
//
function ARC4(key) {
  var t, keylen = key.length,
      me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];

  // The empty key [] is treated as [0].
  if (!keylen) { key = [keylen++]; }

  // Set up S using the standard key scheduling algorithm.
  while (i < width) {
    s[i] = i++;
  }
  for (i = 0; i < width; i++) {
    s[i] = s[j = mask & (j + key[i % keylen] + (t = s[i]))];
    s[j] = t;
  }

  // The "g" method returns the next (count) outputs as one number.
  (me.g = function(count) {
    // Using instance members instead of closure state nearly doubles speed.
    var t, r = 0,
        i = me.i, j = me.j, s = me.S;
    while (count--) {
      t = s[i = mask & (i + 1)];
      r = r * width + s[mask & ((s[i] = s[j = mask & (j + t)]) + (s[j] = t))];
    }
    me.i = i; me.j = j;
    return r;
    // For robust unpredictability, the function call below automatically
    // discards an initial batch of values.  This is called RC4-drop[256].
    // See http://google.com/search?q=rsa+fluhrer+response&btnI
  })(width);
}

//
// copy()
// Copies internal state of ARC4 to or from a plain object.
//
function copy(f, t) {
  t.i = f.i;
  t.j = f.j;
  t.S = f.S.slice();
  return t;
};

//
// flatten()
// Converts an object tree to nested arrays of strings.
//
function flatten(obj, depth) {
  var result = [], typ = (typeof obj), prop;
  if (depth && typ == 'object') {
    for (prop in obj) {
      try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
    }
  }
  return (result.length ? result : typ == 'string' ? obj : obj + '\0');
}

//
// mixkey()
// Mixes a string seed into a key that is an array of integers, and
// returns a shortened string seed that is equivalent to the result key.
//
function mixkey(seed, key) {
  var stringseed = seed + '', smear, j = 0;
  while (j < stringseed.length) {
    key[mask & j] =
      mask & ((smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++));
  }
  return tostring(key);
}

//
// autoseed()
// Returns an object for autoseeding, using window.crypto and Node crypto
// module if available.
//
function autoseed() {
  try {
    var out;
    if (nodecrypto && (out = nodecrypto.randomBytes)) {
      // The use of 'out' to remember randomBytes makes tight minified code.
      out = out(width);
    } else {
      out = new Uint8Array(width);
      (global.crypto || global.msCrypto).getRandomValues(out);
    }
    return tostring(out);
  } catch (e) {
    var browser = global.navigator,
        plugins = browser && browser.plugins;
    return [+new Date, global, plugins, global.screen, tostring(pool)];
  }
}

//
// tostring()
// Converts an array of charcodes to a string
//
function tostring(a) {
  return String.fromCharCode.apply(0, a);
}

//
// When seedrandom.js is loaded, we immediately mix a few bits
// from the built-in RNG into the entropy pool.  Because we do
// not want to interfere with deterministic PRNG state later,
// seedrandom will not call math.random on its own again after
// initialization.
//
mixkey(math.random(), pool);

//
// Nodejs and AMD support: export the implementation as a module using
// either convention.
//
if ((typeof module) == 'object' && module.exports) {
  module.exports = seedrandom;
  // When in node.js, try using crypto package for autoseeding.
  try {
    nodecrypto = require('crypto');
  } catch (ex) {}
} else if ((typeof define) == 'function' && define.amd) {
  define(function() { return seedrandom; });
}

// End anonymous scope, and pass initial values.
})(
  [],     // pool: entropy pool starts empty
  Math    // math: package containing random, pow, and seedrandom
);

},{"crypto":452}],389:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash

},{"safe-buffer":379}],390:[function(require,module,exports){
var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = require('./sha')
exports.sha1 = require('./sha1')
exports.sha224 = require('./sha224')
exports.sha256 = require('./sha256')
exports.sha384 = require('./sha384')
exports.sha512 = require('./sha512')

},{"./sha":391,"./sha1":392,"./sha224":393,"./sha256":394,"./sha384":395,"./sha512":396}],391:[function(require,module,exports){
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = require('inherits')
var Hash = require('./hash')
var Buffer = require('safe-buffer').Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha

},{"./hash":389,"inherits":100,"safe-buffer":379}],392:[function(require,module,exports){
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = require('inherits')
var Hash = require('./hash')
var Buffer = require('safe-buffer').Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1

},{"./hash":389,"inherits":100,"safe-buffer":379}],393:[function(require,module,exports){
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = require('inherits')
var Sha256 = require('./sha256')
var Hash = require('./hash')
var Buffer = require('safe-buffer').Buffer

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224

},{"./hash":389,"./sha256":394,"inherits":100,"safe-buffer":379}],394:[function(require,module,exports){
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = require('inherits')
var Hash = require('./hash')
var Buffer = require('safe-buffer').Buffer

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256

},{"./hash":389,"inherits":100,"safe-buffer":379}],395:[function(require,module,exports){
var inherits = require('inherits')
var SHA512 = require('./sha512')
var Hash = require('./hash')
var Buffer = require('safe-buffer').Buffer

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384

},{"./hash":389,"./sha512":396,"inherits":100,"safe-buffer":379}],396:[function(require,module,exports){
var inherits = require('inherits')
var Hash = require('./hash')
var Buffer = require('safe-buffer').Buffer

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512

},{"./hash":389,"inherits":100,"safe-buffer":379}],397:[function(require,module,exports){
(function (Buffer){(function (){

function BrowserBuffer() {
}

/**
 * Converts Buffer to ArrayBuffer
 * @param {Buffer} buffer
 * @param {boolean} copy - default: true, if true returns copy of ArrayBuffer
 * @return {ArrayBuffer}
 */
BrowserBuffer.prototype.bufferToArray = function(buffer, copy) {
    if (copy === void 0) { copy = true; }
    // if (buffer.buffer && (buffer.buffer instanceof ArrayBuffer)) {
    //     if (copy) {
    //         return buffer.buffer.slice(0);
    //     }

    //     return buffer.buffer;
    // }
    if (typeof(buffer.toArrayBuffer) == "function") {
        return buffer.toArrayBuffer();
    }
    var ab = new ArrayBuffer(buffer.length);
    var view = new Uint8Array(ab);
    for (var i = 0; i < buffer.length; ++i) {
        view[i] = buffer[i];
    }
    return ab;
}

/**
 * Converts ArrayBuffer to Buffer
 * @param {ArrayBuffer} ab
 * @return {Buffer}
 */
BrowserBuffer.prototype.arrayToBuffer = function(ab) {
    return Buffer.from(ab)
}

/**
 * Checks whether the arg is a Buffer
 * @param  {*} arg
 * @return {boolean}
 */
BrowserBuffer.prototype.isBuffer = function(arg) {
    return Buffer.isBuffer(arg) || arg instanceof Uint8Array;
}

/**
 * Create blob from buffer and mimetype
 * @param  {Buffer} buffer
 * @param  {string} mimetype
 * @return {Blob}
 */
BrowserBuffer.prototype.createBlob = function(buffer, mimetype) {
  return new Blob([this.bufferToArray(buffer)], {type: mimetype});
};

module.exports = new BrowserBuffer();

}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":498}],398:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserLazyContent = exports.Content = exports.SimpleLazyContent = exports.LazyContent = void 0;
const LazyContent_1 = require("./common/LazyContent");
Object.defineProperty(exports, "LazyContent", { enumerable: true, get: function () { return LazyContent_1.LazyContent; } });
const SimpleLazyContent_1 = require("./common/SimpleLazyContent");
Object.defineProperty(exports, "SimpleLazyContent", { enumerable: true, get: function () { return SimpleLazyContent_1.SimpleLazyContent; } });
const Content_1 = require("./common/Content");
Object.defineProperty(exports, "Content", { enumerable: true, get: function () { return Content_1.Content; } });
const BrowserLazyContent_1 = require("./browser/BrowserLazyContent");
Object.defineProperty(exports, "BrowserLazyContent", { enumerable: true, get: function () { return BrowserLazyContent_1.BrowserLazyContent; } });

},{"./browser/BrowserLazyContent":399,"./common/Content":400,"./common/LazyContent":401,"./common/SimpleLazyContent":402}],399:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserLazyContent = void 0;
const LazyContent_1 = require("../common/LazyContent");
const Utils_1 = require("../common/Utils");
class BrowserLazyContent extends LazyContent_1.LazyContent {
    blob;
    constructor(blob) {
        super(blob.type, blob.name, blob.size);
        this.blob = blob;
        this.blob = blob;
    }
    async slice(start, end, options) {
        const fr = BrowserLazyContent.createPromiseFromFileReader(options ? options.notify : null);
        fr.fileReader.readAsArrayBuffer(this.blob.slice(start, end));
        await fr.promise;
        if (options && options.notify)
            options.notify({ count: this.size, total: this.size, percent: 1 });
        return Buffer.from(fr.fileReader.result);
    }
    async getBuffer(options) {
        const fr = BrowserLazyContent.createPromiseFromFileReader(options ? options.notify : null);
        fr.fileReader.readAsArrayBuffer(this.blob);
        await fr.promise;
        if (options && options.notify)
            options.notify({ count: this.size, total: this.size, percent: 1 });
        return Buffer.from(fr.fileReader.result);
    }
    async getDataURL(options) {
        const fr = BrowserLazyContent.createPromiseFromFileReader(options ? options.notify : null);
        fr.fileReader.readAsDataURL(this.blob);
        await fr.promise;
        if (options && options.notify)
            options.notify({ count: this.size, total: this.size, percent: 1 });
        return fr.fileReader.result;
    }
    create(mimeType, name) {
        const result = new BrowserLazyContent(this.blob);
        result.mimeType = mimeType || result.mimeType;
        result.name = name || result.name;
        return result;
    }
    static createPromiseFromFileReader(onProgress) {
        const defered = Utils_1.PromiseUtils.defer();
        const fileReader = new FileReader();
        fileReader.onload = defered.resolve;
        fileReader.onerror = defered.reject;
        fileReader.onprogress = evt => {
            if (onProgress) {
                onProgress({ count: evt.loaded, total: evt.total, percent: evt.loaded / evt.total });
            }
        };
        return {
            promise: defered.promise,
            fileReader: fileReader
        };
    }
}
exports.BrowserLazyContent = BrowserLazyContent;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../common/LazyContent":401,"../common/Utils":403,"buffer":498}],400:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = void 0;
class Content {
    buffer;
    mimeType;
    name;
    size;
    constructor(buffer, mimeType, name) {
        this.buffer = buffer;
        this.mimeType = mimeType;
        this.name = name;
        this.size = buffer.length;
    }
    static createFromBuffers(buffers, mimeType, name) {
        return new Content(buffers.length == 1 ? buffers[0] : Buffer.concat(buffers), mimeType || "application/octet-stream", name);
    }
    static createFromBuffer(buffer, mimeType, name) {
        return new Content(buffer, mimeType || "application/octet-stream", name);
    }
    static createFromBase64(base64, mimeType, name) {
        return Content.createFromBuffer(Buffer.from(base64, "base64"), mimeType, name);
    }
    static createFromHex(hex, mimeType, name) {
        return Content.createFromBuffer(Buffer.from(hex, "hex"), mimeType, name);
    }
    static createEmpty(mimeType, name) {
        return Content.createFromHex("", mimeType, name);
    }
    static createFromText(text, mimeType, name) {
        return Content.createFromBuffer(Buffer.from(text, "utf8"), mimeType || "text/plain", name);
    }
    static createFromJson(object, mimeType, name) {
        return Content.createFromText(JSON.stringify(object), mimeType || "application/json", name);
    }
    static async readAndCreateFromLazyContent(lazyBuffer, options) {
        const buffer = await lazyBuffer.getBuffer(options);
        return new Content(buffer, lazyBuffer.getMimeType(), lazyBuffer.getName());
    }
    slice(start, end, options) {
        if (options && options.notify)
            options.notify({ count: end - start, total: end - start, percent: 1 });
        return this.buffer.slice(start, end);
    }
    getBuffer(options) {
        if (options && options.notify)
            options.notify({ count: this.size, total: this.size, percent: 1 });
        return this.buffer;
    }
    create(mimeType, name) {
        return new Content(this.buffer, mimeType || this.mimeType, name || this.name);
    }
    getContent(options) {
        if (options && options.notify)
            options.notify({ count: this.size, total: this.size, percent: 1 });
        return this;
    }
    getLazyContent() {
        return new SimpleLazyContent_1.SimpleLazyContent(this.buffer, this.mimeType, this.name);
    }
    getText(options) {
        if (options && options.notify)
            options.notify({ count: this.size, total: this.size, percent: 1 });
        return this.buffer.toString("utf8");
    }
    getBase64(options) {
        if (options && options.notify)
            options.notify({ count: this.size, total: this.size, percent: 1 });
        return this.buffer.toString("base64");
    }
    getHex(options) {
        if (options && options.notify)
            options.notify({ count: this.size, total: this.size, percent: 1 });
        return this.buffer.toString("hex");
    }
    getJson(options) {
        return JSON.parse(this.getText(options));
    }
    getDataUrl(options) {
        if (options && options.notify)
            options.notify({ count: this.size, total: this.size, percent: 1 });
        return Content.getDataUrl(this.buffer, this.mimeType);
    }
    getMimeType() {
        return this.mimeType;
    }
    getName() {
        return this.name;
    }
    getSize() {
        return this.size;
    }
    isEmpty() {
        return this.size == 0;
    }
    static getDataUrl(buffer, mimeType) {
        return "data:" + mimeType + ";base64," + buffer.toString("base64");
    }
}
exports.Content = Content;
const SimpleLazyContent_1 = require("./SimpleLazyContent");

}).call(this)}).call(this,require("buffer").Buffer)
},{"./SimpleLazyContent":402,"buffer":498}],401:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LazyContent = void 0;
class LazyContent {
    mimeType;
    name;
    size;
    constructor(mimeType, name, size) {
        this.mimeType = mimeType;
        this.name = name;
        this.size = size;
    }
    async getContent(options) {
        const buffer = await this.getBuffer(options);
        return new Content_1.Content(buffer, this.getMimeType(), this.getName());
    }
    getLazyContent() {
        return this;
    }
    async getText(options) {
        const content = await this.getContent(options);
        return content.getText();
    }
    async getBase64(options) {
        const content = await this.getContent(options);
        return content.getBase64();
    }
    async getHex(options) {
        const content = await this.getContent(options);
        return content.getHex();
    }
    async getJson(options) {
        const content = await this.getContent(options);
        return content.getJson();
    }
    async getDataUrl(options) {
        const content = await this.getContent(options);
        return content.getDataUrl();
    }
    getMimeType() {
        return this.mimeType;
    }
    getName() {
        return this.name;
    }
    getSize() {
        return this.size;
    }
    isEmpty() {
        return this.size == 0;
    }
}
exports.LazyContent = LazyContent;
const Content_1 = require("./Content");

},{"./Content":400}],402:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleLazyContent = void 0;
const LazyContent_1 = require("./LazyContent");
class SimpleLazyContent extends LazyContent_1.LazyContent {
    buffer;
    constructor(buffer, mimeType, name) {
        super(mimeType, name, buffer.length);
        this.buffer = buffer;
    }
    async slice(start, end, options) {
        if (options && options.notify)
            options.notify({ count: end - start, total: end - start, percent: 1 });
        return this.buffer.slice(start, end);
    }
    async getBuffer(options) {
        if (options && options.notify)
            options.notify({ count: this.size, total: this.size, percent: 1 });
        return this.buffer;
    }
    create(mimeType, name) {
        return new SimpleLazyContent(this.buffer, mimeType || this.mimeType, name || this.name);
    }
}
exports.SimpleLazyContent = SimpleLazyContent;

},{"./LazyContent":401}],403:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromiseUtils = void 0;
class PromiseUtils {
    static defer() {
        const defer = {
            resolve: null,
            reject: null,
            promise: null
        };
        defer.promise = new Promise((resolve, reject) => {
            defer.resolve = resolve;
            defer.reject = reject;
        });
        return defer;
    }
}
exports.PromiseUtils = PromiseUtils;

},{}],404:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleAppender = void 0;
class ConsoleAppender {
    append(level, loggerName, args) {
        const newArgs = ["[" + loggerName + "]"].concat(args);
        const type = level.name.toLowerCase();
        if (type in console && typeof (console[type]) == "function") {
            console[type].apply(console, newArgs);
        }
        else {
            console.log.apply(console, newArgs);
        }
    }
}
exports.ConsoleAppender = ConsoleAppender;

},{}],405:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Level = void 0;
class Level {
    constructor(value, name) {
        this.value = value;
        this.name = name;
        this.value = value;
        this.name = name;
    }
    static isValidLevel(level) {
        return level == Level.DEBUG || level == Level.INFO ||
            level == Level.WARN || level == Level.ERROR || level == Level.OFF;
    }
}
exports.Level = Level;
Level.DEBUG = new Level(1, "DEBUG");
Level.INFO = new Level(2, "INFO");
Level.WARN = new Level(4, "WARN");
Level.ERROR = new Level(5, "ERROR");
Level.OFF = new Level(6, "OFF");

},{}],406:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
const Level_1 = require("./Level");
class Logger {
    constructor(parent, name) {
        this.parent = parent;
        this.name = name;
        this.DEBUG = Level_1.Level.DEBUG;
        this.INFO = Level_1.Level.INFO;
        this.WARN = Level_1.Level.WARN;
        this.ERROR = Level_1.Level.ERROR;
        this.OFF = Level_1.Level.OFF;
        this.fullName = this.parent == null || this.parent.fullName == "" ? this.name : this.parent.fullName + "." + this.name;
        this.inheritedLevel = this.parent == null ? Level_1.Level.OFF : this.parent.getLevel();
        this.children = {};
        this.appenders = [];
        this.delegateAppendToParent = true;
    }
    getLevel() {
        return this.level ? this.level : this.inheritedLevel;
    }
    setLevel(level) {
        if (!Level_1.Level.isValidLevel(level)) {
            return;
        }
        this.level = level;
        for (const name in this.children) {
            this.children[name].setInheritedLevel(this.level);
        }
    }
    addAppender(appender) {
        this.appenders.push(appender);
    }
    setDelegateAppendToParent(delegateAppendToParent) {
        this.delegateAppendToParent = delegateAppendToParent;
    }
    setInheritedLevel(inheritedLevel) {
        this.inheritedLevel = inheritedLevel;
        if (this.level == null) {
            for (const name in this.children) {
                this.children[name].setInheritedLevel(this.inheritedLevel);
            }
        }
    }
    get(name) {
        return this.getLoggerByNames(name.split("."));
    }
    getLoggerByNames(names) {
        if (names.length == 0 || (names.length == 1 && names[0] == "")) {
            return this;
        }
        const name = names.shift();
        let child = this.children[name];
        if (child == null) {
            child = new Logger(this, name);
            this.children[name] = child;
        }
        return child.getLoggerByNames(names);
    }
    debug(...args) {
        return this.log(Level_1.Level.DEBUG, args);
    }
    info(...args) {
        return this.log(Level_1.Level.INFO, args);
    }
    warn(...args) {
        return this.log(Level_1.Level.WARN, args);
    }
    error(...args) {
        return this.log(Level_1.Level.ERROR, args);
    }
    log(level, args) {
        if (this.getLevel().value > level.value) {
            return;
        }
        this.appendFromChild(level, this.fullName, args);
    }
    appendFromChild(level, loggerName, args) {
        for (const appender of this.appenders) {
            appender.append(level, loggerName, args);
        }
        if (this.parent && this.delegateAppendToParent) {
            this.parent.appendFromChild(level, loggerName, args);
        }
    }
}
exports.Logger = Logger;

},{"./Level":405}],407:[function(require,module,exports){
"use strict";
const ConsoleAppender_1 = require("./ConsoleAppender");
const Logger_1 = require("./Logger");
const rootLogger = new Logger_1.Logger(null, "");
rootLogger.addAppender(new ConsoleAppender_1.ConsoleAppender());
module.exports = rootLogger;

},{"./ConsoleAppender":404,"./Logger":406}],408:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnknownConnectionException = exports.ServerNotRespondingException = exports.NoJsonResponseException = exports.JsonRpcException = exports.InvalidStatusCodeException = exports.InvalidJsonRpcException = exports.ConnectionException = exports.JsonRpcRequest = exports.HttpRequest = void 0;
const ConnectionException_1 = require("./common/ConnectionException");
Object.defineProperty(exports, "ConnectionException", { enumerable: true, get: function () { return ConnectionException_1.ConnectionException; } });
const InvalidJsonRpcException_1 = require("./common/InvalidJsonRpcException");
Object.defineProperty(exports, "InvalidJsonRpcException", { enumerable: true, get: function () { return InvalidJsonRpcException_1.InvalidJsonRpcException; } });
const InvalidStatusCodeException_1 = require("./common/InvalidStatusCodeException");
Object.defineProperty(exports, "InvalidStatusCodeException", { enumerable: true, get: function () { return InvalidStatusCodeException_1.InvalidStatusCodeException; } });
const JsonRpcException_1 = require("./common/JsonRpcException");
Object.defineProperty(exports, "JsonRpcException", { enumerable: true, get: function () { return JsonRpcException_1.JsonRpcException; } });
const NoJsonResponseException_1 = require("./common/NoJsonResponseException");
Object.defineProperty(exports, "NoJsonResponseException", { enumerable: true, get: function () { return NoJsonResponseException_1.NoJsonResponseException; } });
const ServerNotRespondingException_1 = require("./common/ServerNotRespondingException");
Object.defineProperty(exports, "ServerNotRespondingException", { enumerable: true, get: function () { return ServerNotRespondingException_1.ServerNotRespondingException; } });
const UnknownConnectionException_1 = require("./common/UnknownConnectionException");
Object.defineProperty(exports, "UnknownConnectionException", { enumerable: true, get: function () { return UnknownConnectionException_1.UnknownConnectionException; } });
const HttpRequest_1 = require("./browser/HttpRequest");
const JsonRpcRequest_1 = require("./browser/JsonRpcRequest");
__exportStar(require("./common/Types"), exports);
exports.HttpRequest = HttpRequest_1.HttpRequest.INSTANCE;
exports.JsonRpcRequest = JsonRpcRequest_1.JsonRpcRequest.INSTANCE;

},{"./browser/HttpRequest":409,"./browser/JsonRpcRequest":410,"./common/ConnectionException":411,"./common/InvalidJsonRpcException":412,"./common/InvalidStatusCodeException":413,"./common/JsonRpcException":414,"./common/NoJsonResponseException":415,"./common/ServerNotRespondingException":416,"./common/Types":417,"./common/UnknownConnectionException":418}],409:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpRequest = void 0;
const BrowserBuffer = require("simplito-browserbuffer");
const NoJsonResponseException_1 = require("../common/NoJsonResponseException");
const InvalidStatusCodeException_1 = require("../common/InvalidStatusCodeException");
const UnknownConnectionException_1 = require("../common/UnknownConnectionException");
const ServerNotRespondingException_1 = require("../common/ServerNotRespondingException");
class HttpRequest {
    static INSTANCE = new HttpRequest();
    basicAuth;
    setBasicAuth(username, password, byUrl) {
        this.basicAuth = {
            username: username,
            password: password,
            byUrl: byUrl
        };
    }
    isValidUrl(url) {
        return typeof (url) === "string" && /^(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/.test(url);
    }
    prepareFormData(data) {
        if (!data || data instanceof FormData) {
            return data || null;
        }
        if (typeof (data) != "object") {
            throw new Error("Invalid data. Allowed values: null, object, FormData");
        }
        const fd = new FormData();
        for (const key in data) {
            const value = data[key];
            if (BrowserBuffer.isBuffer(value)) {
                fd.append(key, new Blob([BrowserBuffer.bufferToArray(value)]));
            }
            else {
                fd.append(key, value);
            }
        }
        return fd;
    }
    promise(options) {
        return new Promise((resolve, reject) => {
            if (options == null) {
                throw new Error("Parameter options is required");
            }
            options.success = resolve;
            options.error = reject;
            try {
                this.start(options);
            }
            catch (e) {
                reject(e);
            }
        });
    }
    start(options) {
        if (options == null)
            throw new Error("Parameter options is required");
        if (typeof (options) !== "object")
            throw new Error("Parameter options is invalid");
        if (options.url == null)
            throw new Error("Parameter options.url is required");
        if (options.method == null)
            options.method = "GET";
        if (options.responseType == null)
            options.responseType = "buffer";
        if (options.withCredentials == null)
            options.withCredentials = false;
        if (options.success == null)
            options.success = () => { };
        if (options.error == null)
            options.error = () => { };
        if (!this.isValidUrl(options.url))
            throw new Error("Parameter options.url is invalid");
        if (options.method !== "GET" && options.method !== "POST")
            throw new Error("Parameter options.method is invalid");
        if (options.responseType !== "buffer" && options.responseType !== "text" && options.responseType !== "json")
            throw new Error("Parameter options.responseType is invalid");
        if (options.withCredentials !== true && options.withCredentials !== false)
            throw new Error("Parameter options.withCredentials is invalid");
        if (typeof (options.success) !== "function")
            throw new Error("Parameter options.success is invalid");
        if (typeof (options.error) !== "function")
            throw new Error("Parameter options.error is invalid");
        if (this.basicAuth && this.basicAuth.byUrl) {
            const protoIndex = options.url.indexOf("://");
            const proto = options.url.substring(0, protoIndex);
            const rest = options.url.substring(protoIndex + 3);
            options.url = proto + "://" + this.basicAuth.username + ":" + this.basicAuth.password + "@" + rest;
        }
        const formData = this.prepareFormData(options.data);
        const xhr = new XMLHttpRequest();
        xhr.withCredentials = options.withCredentials;
        xhr.onreadystatechange = () => {
            if (xhr.readyState == XMLHttpRequest.DONE) {
                if (xhr.status == 0) {
                    options.error(new ServerNotRespondingException_1.ServerNotRespondingException(options));
                    return;
                }
                let response = xhr.response;
                if (options.responseType == "buffer") {
                    if (xhr.response instanceof ArrayBuffer) {
                        response = BrowserBuffer.arrayToBuffer(xhr.response);
                    }
                    else {
                        response = null;
                    }
                }
                else if (options.responseType == "json") {
                    try {
                        response = JSON.parse(xhr.response);
                    }
                    catch (e) {
                        options.error(new NoJsonResponseException_1.NoJsonResponseException(response, xhr.status, e));
                        return;
                    }
                }
                if (xhr.status == 200) {
                    options.success(response);
                }
                else {
                    options.error(new InvalidStatusCodeException_1.InvalidStatusCodeException(response, xhr.status));
                }
            }
        };
        xhr.open(options.method, options.url, true);
        xhr.responseType = options.responseType == "buffer" ? "arraybuffer" : "text";
        if (this.basicAuth && !this.basicAuth.byUrl) {
            xhr.setRequestHeader("Authorization", "Basic " + btoa(this.basicAuth.username + ":" + this.basicAuth.password));
        }
        try {
            xhr.send(formData);
        }
        catch (e) {
            options.error(new UnknownConnectionException_1.UnknownConnectionException(e));
        }
    }
}
exports.HttpRequest = HttpRequest;

},{"../common/InvalidStatusCodeException":413,"../common/NoJsonResponseException":415,"../common/ServerNotRespondingException":416,"../common/UnknownConnectionException":418,"simplito-browserbuffer":397}],410:[function(require,module,exports){
(function (Buffer){(function (){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonRpcRequest = void 0;
const BrowserBuffer = require("simplito-browserbuffer");
const NoJsonResponseException_1 = require("../common/NoJsonResponseException");
const UnknownConnectionException_1 = require("../common/UnknownConnectionException");
const InvalidJsonRpcException_1 = require("../common/InvalidJsonRpcException");
const JsonRpcException_1 = require("../common/JsonRpcException");
const ServerNotRespondingException_1 = require("../common/ServerNotRespondingException");
class JsonRpcRequest {
    static INSTANCE = new JsonRpcRequest();
    basicAuth;
    setBasicAuth(username, password, byUrl) {
        this.basicAuth = {
            username: username,
            password: password,
            byUrl: byUrl
        };
    }
    isValidUrl(url) {
        return typeof (url) === "string" && /^(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/.test(url);
    }
    prepareRequestAsBuffer(method, params) {
        return Buffer.from(this.prepareRequestAsString(method, params), "utf8");
    }
    prepareRequestAsString(method, params) {
        return JSON.stringify(this.prepareRequestAsObject(method, params));
    }
    prepareRequestAsObject(method, params) {
        return {
            jsonrpc: "2.0",
            method: method,
            params: params,
            id: 0
        };
    }
    processBuffer(buffer, status, request) {
        return this.processText(buffer.toString("utf8"), status, request);
    }
    processText(text, status, request) {
        let object;
        try {
            object = JSON.parse(text);
        }
        catch (e) {
            throw new NoJsonResponseException_1.NoJsonResponseException(text, status, request, e);
        }
        return this.processObject(object, status, request);
    }
    processObject(object, status, request) {
        if (object.jsonrpc != "2.0" || (object.result == null && object.error == null) ||
            (object.result != null && object.error != null) ||
            (object.result != null && typeof (status) != "undefined" && status != 200) ||
            (object.error != null && (object.error.code == null || object.error.message == null))) {
            throw new InvalidJsonRpcException_1.InvalidJsonRpcException(object, status, request);
        }
        if (object.result != null && object.id == 0) {
            return object.result;
        }
        else {
            throw new JsonRpcException_1.JsonRpcException(object.error, request);
        }
    }
    promise(options) {
        return new Promise((resolve, reject) => {
            if (options == null) {
                throw new Error("Parameter options is required");
            }
            options.success = resolve;
            options.error = reject;
            try {
                this.start(options);
            }
            catch (e) {
                reject(e);
            }
        });
    }
    start(options) {
        if (options == null)
            throw new Error("Parameter options is required");
        if (typeof (options) !== "object")
            throw new Error("Parameter options is invalid");
        if (options.url == null)
            throw new Error("Parameter options.url is required");
        if (options.method == null)
            throw new Error("Parameter options.method is required");
        if (options.params == null)
            throw new Error("Parameter options.params is required");
        if (options.withCredentials == null)
            options.withCredentials = false;
        if (options.success == null)
            options.success = () => { };
        if (options.error == null)
            options.error = () => { };
        if (!this.isValidUrl(options.url))
            throw new Error("Parameter options.url is invalid");
        if (typeof (options.method) !== "string")
            throw new Error("Parameter options.method is invalid");
        if (typeof (options.params) !== "object")
            throw new Error("Parameter options.params is invalid");
        if (options.withCredentials !== true && options.withCredentials !== false)
            throw new Error("Parameter options.withCredentials is invalid");
        if (typeof (options.success) !== "function")
            throw new Error("Parameter options.success is invalid");
        if (typeof (options.error) !== "function")
            throw new Error("Parameter options.error is invalid");
        if (this.basicAuth && this.basicAuth.byUrl) {
            const protoIndex = options.url.indexOf("://");
            const proto = options.url.substring(0, protoIndex);
            const rest = options.url.substring(protoIndex + 3);
            options.url = proto + "://" + this.basicAuth.username + ":" + this.basicAuth.password + "@" + rest;
        }
        const jsonRpc = this.prepareRequestAsObject(options.method, options.params);
        const jsonRpcStr = JSON.stringify(jsonRpc);
        const xhr = new XMLHttpRequest();
        xhr.withCredentials = options.withCredentials;
        xhr.onreadystatechange = () => {
            if (xhr.readyState == XMLHttpRequest.DONE) {
                if (xhr.status == 0) {
                    options.error(new ServerNotRespondingException_1.ServerNotRespondingException(jsonRpc));
                    return;
                }
                if (options.expectedBuffer) {
                    const buffer = BrowserBuffer.arrayToBuffer(xhr.response);
                    const contentType = xhr.getResponseHeader("content-type");
                    if (xhr.status == 200 && contentType == "binary/octet-stream") {
                        options.success(buffer);
                    }
                    else {
                        let result;
                        try {
                            result = this.processText(buffer.toString("utf8"), xhr.status, jsonRpc);
                        }
                        catch (e) {
                            options.error(e);
                        }
                        options.success(result);
                    }
                }
                else {
                    let result;
                    try {
                        result = this.processText(xhr.response, xhr.status, jsonRpc);
                    }
                    catch (e) {
                        options.error(e);
                    }
                    options.success(result);
                }
            }
        };
        let sendData;
        xhr.open("POST", options.url, true);
        xhr.responseType = options.expectedBuffer ? "arraybuffer" : "text";
        if (options.data) {
            sendData = new FormData();
            sendData.append("jsonrpc", jsonRpcStr);
            if (BrowserBuffer.isBuffer(options.data)) {
                sendData.append("data", new Blob([BrowserBuffer.bufferToArray(options.data)]));
            }
            else {
                throw new Error("Parameter options.data is invalid, expected Buffer");
            }
        }
        else {
            xhr.setRequestHeader("Content-Type", "application/json");
            sendData = jsonRpcStr;
        }
        if (this.basicAuth && !this.basicAuth.byUrl) {
            xhr.setRequestHeader("Authorization", "Basic " + btoa(this.basicAuth.username + ":" + this.basicAuth.password));
        }
        try {
            xhr.send(sendData);
        }
        catch (e) {
            options.error(new UnknownConnectionException_1.UnknownConnectionException(e));
        }
    }
}
exports.JsonRpcRequest = JsonRpcRequest;

}).call(this)}).call(this,require("buffer").Buffer)
},{"../common/InvalidJsonRpcException":412,"../common/JsonRpcException":414,"../common/NoJsonResponseException":415,"../common/ServerNotRespondingException":416,"../common/UnknownConnectionException":418,"buffer":498,"simplito-browserbuffer":397}],411:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionException = void 0;
class ConnectionException extends Error {
    data;
    couse;
    constructor(msg, data, couse) {
        super(msg);
        this.data = data;
        this.couse = couse;
        Object.setPrototypeOf(this, ConnectionException.prototype);
    }
}
exports.ConnectionException = ConnectionException;

},{}],412:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidJsonRpcException = void 0;
const ConnectionException_1 = require("./ConnectionException");
class InvalidJsonRpcException extends ConnectionException_1.ConnectionException {
    constructor(response, status, request) {
        super("[InvalidJsonRpcException]", { response: response, status: status, request: request });
        Object.setPrototypeOf(this, InvalidJsonRpcException.prototype);
    }
}
exports.InvalidJsonRpcException = InvalidJsonRpcException;

},{"./ConnectionException":411}],413:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidStatusCodeException = void 0;
const ConnectionException_1 = require("./ConnectionException");
class InvalidStatusCodeException extends ConnectionException_1.ConnectionException {
    constructor(response, status) {
        super("[InvalidStatusCodeException]", { response: response, status: status });
        Object.setPrototypeOf(this, InvalidStatusCodeException.prototype);
    }
}
exports.InvalidStatusCodeException = InvalidStatusCodeException;

},{"./ConnectionException":411}],414:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonRpcException = void 0;
const ConnectionException_1 = require("./ConnectionException");
class JsonRpcException extends ConnectionException_1.ConnectionException {
    constructor(error, request) {
        super("[JsonRpcException]", { error: error, request: request });
        Object.setPrototypeOf(this, JsonRpcException.prototype);
    }
}
exports.JsonRpcException = JsonRpcException;

},{"./ConnectionException":411}],415:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoJsonResponseException = void 0;
const ConnectionException_1 = require("./ConnectionException");
class NoJsonResponseException extends ConnectionException_1.ConnectionException {
    constructor(response, status, request, couse) {
        super("[NoJsonResponseException]", { response: response, status: status, request: request }, couse);
        Object.setPrototypeOf(this, NoJsonResponseException.prototype);
    }
}
exports.NoJsonResponseException = NoJsonResponseException;

},{"./ConnectionException":411}],416:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerNotRespondingException = void 0;
const ConnectionException_1 = require("./ConnectionException");
class ServerNotRespondingException extends ConnectionException_1.ConnectionException {
    constructor(request, couse) {
        super("[ServerNotRespondingException]", { request: request }, couse);
        Object.setPrototypeOf(this, ServerNotRespondingException.prototype);
    }
}
exports.ServerNotRespondingException = ServerNotRespondingException;

},{"./ConnectionException":411}],417:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

},{}],418:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnknownConnectionException = void 0;
const ConnectionException_1 = require("./ConnectionException");
class UnknownConnectionException extends ConnectionException_1.ConnectionException {
    constructor(couse) {
        super("[UnknownConnectionException]", null, couse);
        Object.setPrototypeOf(this, UnknownConnectionException.prototype);
    }
}
exports.UnknownConnectionException = UnknownConnectionException;

},{"./ConnectionException":411}],419:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromiseQueue = void 0;
const PromiseUtils_1 = require("./PromiseUtils");
class PromiseQueue {
    queue;
    isRunning;
    constructor() {
        this.queue = [];
        this.isRunning = false;
    }
    add(func) {
        const deferred = PromiseUtils_1.PromiseUtils.defer();
        this.queue.push({
            deferred: deferred,
            func: func
        });
        this.run();
        return deferred.promise;
    }
    run() {
        if (this.isRunning) {
            return;
        }
        this.isRunning = true;
        PromiseUtils_1.PromiseUtils.queue(this.queue, task => {
            return Promise.resolve().then(task.func).then(task.deferred.resolve).catch(task.deferred.reject);
        })
            .then(() => {
            this.isRunning = false;
            if (this.queue.length > 0) {
                this.run();
            }
        });
    }
}
exports.PromiseQueue = PromiseQueue;

},{"./PromiseUtils":420}],420:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromiseUtils = void 0;
class PromiseUtils {
    static oneByOne(enumerable, func) {
        return Promise.resolve().then(() => {
            const keys = [];
            for (const key in enumerable) {
                keys.push(key);
            }
            let i = 0;
            const worker = () => {
                if (i >= keys.length) {
                    return;
                }
                const key = keys[i];
                const value = enumerable[key];
                return Promise.resolve().then(() => {
                    return func(key, value);
                })
                    .then(() => {
                    i++;
                    return worker();
                });
            };
            return worker();
        });
    }
    static collect(enumerable, func) {
        return Promise.resolve().then(() => {
            const result = [];
            const keys = [];
            for (const key in enumerable) {
                keys.push(key);
            }
            let i = 0;
            const worker = () => {
                if (i >= keys.length) {
                    return;
                }
                const key = keys[i];
                const value = enumerable[key];
                return Promise.resolve().then(() => {
                    return func(key, value);
                })
                    .then(function (r) {
                    result.push(r);
                    i++;
                    return worker();
                });
            };
            return Promise.resolve().then(worker).then(() => result);
        });
    }
    static collectMap(enumerable, func) {
        return Promise.resolve().then(() => {
            const result = {};
            const keys = [];
            for (const key in enumerable) {
                keys.push(key);
            }
            let i = 0;
            const worker = () => {
                if (i >= keys.length) {
                    return;
                }
                const key = keys[i];
                const value = enumerable[key];
                return Promise.resolve().then(() => {
                    return func(key, value);
                }).then(function (r) {
                    result[key] = r;
                    i++;
                    return worker();
                });
            };
            return Promise.resolve().then(worker).then(() => result);
        });
    }
    static settle(enumerable, func) {
        return Promise.resolve().then(function () {
            const result = Array.isArray(enumerable) ? [] : {};
            const keys = Object.keys(enumerable);
            const promises = [];
            for (const i in keys) {
                const key = keys[i];
                const value = enumerable[key];
                const p = ((k, v) => {
                    return Promise.resolve().then(function () {
                        return func(k, v);
                    });
                })(key, value);
                promises.push(p);
            }
            return Promise.allSettled(promises).then((results) => {
                let allFulfilled = true;
                for (const i in keys) {
                    const key = keys[i];
                    result[key] = results[i];
                    if (allFulfilled && results[i].status != "fulfilled") {
                        allFulfilled = false;
                    }
                }
                return {
                    allFulfilled: allFulfilled,
                    results: result
                };
            });
        });
    }
    static nTimes(n, func) {
        return Promise.resolve().then(() => {
            let i = 0;
            const worker = () => {
                if (i >= n) {
                    return Promise.resolve();
                }
                return Promise.resolve().then(() => {
                    return func(i);
                })
                    .then(() => {
                    i++;
                    return worker();
                });
            };
            return worker();
        });
    }
    static queue(queue, func) {
        return Promise.resolve().then(() => {
            const worker = () => {
                return queue.length == 0 ? Promise.resolve() : Promise.resolve(queue.shift()).then(func).then(worker);
            };
            return worker();
        });
    }
    static infinity(guardian, func) {
        return Promise.resolve().then(() => {
            const worker = () => {
                return guardian.value ? Promise.resolve().then(func).then(worker) : Promise.resolve();
            };
            return worker();
        });
    }
    static timeout(miliseconds) {
        return new Promise((resolve) => setTimeout(resolve, miliseconds));
    }
    static delay(miliseconds) {
        return PromiseUtils.timeout(miliseconds);
    }
    static defer() {
        let defer = {
            resolve: null,
            reject: null,
            promise: null
        };
        defer.promise = new Promise((resolve, reject) => {
            defer.resolve = resolve;
            defer.reject = reject;
        });
        return defer;
    }
    static watchPromise(promise) {
        const result = {
            promise: promise,
            status: "pending"
        };
        promise.then(v => {
            const r = result;
            r.status = "fulfilled";
            r.value = v;
        }, e => {
            const r = result;
            r.status = "rejected";
            r.reason = e;
        });
        return result;
    }
}
exports.PromiseUtils = PromiseUtils;

},{}],421:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./PromiseUtils"), exports);
__exportStar(require("./PromiseQueue"), exports);

},{"./PromiseQueue":419,"./PromiseUtils":420}],422:[function(require,module,exports){
(function (Buffer){(function (){
var buffer = require('buffer');

function Utils() {
}

Utils.prototype.isNumber = function(n) {
    return typeof(n) == "number" && isFinite(n) && !isNaN(n)
};

Utils.prototype.isInteger = function(n) {
    return this.isNumber(n) && Math.floor(n) == n;
};

Utils.prototype.isPositiveInteger = function(n) {
    return this.isInteger(n) && n >= 0
};

Utils.prototype.isBuffer = function(arg) {
  return buffer.Buffer.isBuffer(arg) || arg instanceof Uint8Array;
};

Utils.prototype.padHex = function(hex) {
  return hex.length % 2 == 1 ? "0" + hex : hex;
};

Utils.prototype.clone = function(object, clonedList) {
    clonedList = clonedList == null ? [] : clonedList;
    var type = typeof(object);
    if (type == "object") {
        if (object == null) {
            return object;
        }
        for (var i in clonedList) {
            if (clonedList[i].src === object) {
                return clonedList[i].clone;
            }
        }
        if (this.isBuffer(object)) {
            var clone = new Buffer(object);
            clonedList.push({src: object, clone: clone});
            return clone;
        }
        if (object instanceof Date) {
            var clone = new Date(object.getTime());
            clonedList.push({src: object, clone: clone});
            return clone;
        }
        var clone = Array.isArray(object) ? [] : {};
        clonedList.push({src: object, clone: clone});
        var propNames = Object.getOwnPropertyNames(object);
        for (var i in propNames) {
            var propName = propNames[i];
            clone[propName] = this.clone(object[propName], clonedList);
        }
        return clone;
    }
    else if (type == "string" || type == "number" || type == "boolean" || type == "undefined") {
        return object;
    }
    else {
        throw new Error("Cannot clone object of type '" + type + "'");
    }
};

Utils.prototype.startsWith = function(str, searchString, position) {
    if (typeof(str.startsWith) == "function") {
        return str.startsWith(searchString, position);
    }
    position = position || 0;
    return str.indexOf(searchString, position) === position;
};

Utils.prototype.endsWith = function(str, searchString, position) {
    if (typeof(str.endsWith) == "function") {
        return str.endsWith(searchString, position);
    }
    var subjectString = str;
    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
      position = subjectString.length;
    }
    position -= searchString.length;
    var lastIndex = subjectString.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};

Utils.prototype.simpleDeepClone = function(simpleObject) {
    return JSON.parse(JSON.stringify(simpleObject));
};

Utils.prototype.isObject = function(obj) {
    return typeof(obj) == "object" && obj != null;
}

Utils.prototype.fillByDefaults = function(obj, defaults) {
    if (typeof(obj) == "undefined") {
      return defaults;
    }
    if (this.isObject(obj) && this.isObject(defaults)) {
        for (var key in defaults) {
            if (key in obj) {
                this.fillByDefaults(obj[key], defaults[key]);
            }
            else {
                obj[key] = defaults[key];
            }
        }
    }
    return obj;
};

Utils.prototype.defineLazyReadOnlyProperty = function(obj, name, initializer) {
    Object.defineProperty(obj, name, {get: function() {
        var value = initializer.call(obj);
        Object.defineProperty(obj, name, {value: value, enumerable: true});
        return value;
    }, enumerable: true, configurable: true});
}

Utils.prototype.isInstanceOf = function(obj, arrayOfClassed) {
    for (var i = 0; i < arrayOfClassed.length; i++) {
        if (obj instanceof arrayOfClassed[i]) {
            return true;
        }
    }
    return false;
}

module.exports = new Utils();

}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":498}],423:[function(require,module,exports){
var native = require('./native')

function getTypeName (fn) {
  return fn.name || fn.toString().match(/function (.*?)\s*\(/)[1]
}

function getValueTypeName (value) {
  return native.Nil(value) ? '' : getTypeName(value.constructor)
}

function getValue (value) {
  if (native.Function(value)) return ''
  if (native.String(value)) return JSON.stringify(value)
  if (value && native.Object(value)) return ''
  return value
}

function captureStackTrace (e, t) {
  if (Error.captureStackTrace) {
    Error.captureStackTrace(e, t)
  }
}

function tfJSON (type) {
  if (native.Function(type)) return type.toJSON ? type.toJSON() : getTypeName(type)
  if (native.Array(type)) return 'Array'
  if (type && native.Object(type)) return 'Object'

  return type !== undefined ? type : ''
}

function tfErrorString (type, value, valueTypeName) {
  var valueJson = getValue(value)

  return 'Expected ' + tfJSON(type) + ', got' +
    (valueTypeName !== '' ? ' ' + valueTypeName : '') +
    (valueJson !== '' ? ' ' + valueJson : '')
}

function TfTypeError (type, value, valueTypeName) {
  valueTypeName = valueTypeName || getValueTypeName(value)
  this.message = tfErrorString(type, value, valueTypeName)

  captureStackTrace(this, TfTypeError)
  this.__type = type
  this.__value = value
  this.__valueTypeName = valueTypeName
}

TfTypeError.prototype = Object.create(Error.prototype)
TfTypeError.prototype.constructor = TfTypeError

function tfPropertyErrorString (type, label, name, value, valueTypeName) {
  var description = '" of type '
  if (label === 'key') description = '" with key type '

  return tfErrorString('property "' + tfJSON(name) + description + tfJSON(type), value, valueTypeName)
}

function TfPropertyTypeError (type, property, label, value, valueTypeName) {
  if (type) {
    valueTypeName = valueTypeName || getValueTypeName(value)
    this.message = tfPropertyErrorString(type, label, property, value, valueTypeName)
  } else {
    this.message = 'Unexpected property "' + property + '"'
  }

  captureStackTrace(this, TfTypeError)
  this.__label = label
  this.__property = property
  this.__type = type
  this.__value = value
  this.__valueTypeName = valueTypeName
}

TfPropertyTypeError.prototype = Object.create(Error.prototype)
TfPropertyTypeError.prototype.constructor = TfTypeError

function tfCustomError (expected, actual) {
  return new TfTypeError(expected, {}, actual)
}

function tfSubError (e, property, label) {
  // sub child?
  if (e instanceof TfPropertyTypeError) {
    property = property + '.' + e.__property

    e = new TfPropertyTypeError(
      e.__type, property, e.__label, e.__value, e.__valueTypeName
    )

  // child?
  } else if (e instanceof TfTypeError) {
    e = new TfPropertyTypeError(
      e.__type, property, label, e.__value, e.__valueTypeName
    )
  }

  captureStackTrace(e)
  return e
}

module.exports = {
  TfTypeError: TfTypeError,
  TfPropertyTypeError: TfPropertyTypeError,
  tfCustomError: tfCustomError,
  tfSubError: tfSubError,
  tfJSON: tfJSON,
  getValueTypeName: getValueTypeName
}

},{"./native":426}],424:[function(require,module,exports){
(function (Buffer){(function (){
var NATIVE = require('./native')
var ERRORS = require('./errors')

function _Buffer (value) {
  return Buffer.isBuffer(value)
}

function Hex (value) {
  return typeof value === 'string' && /^([0-9a-f]{2})+$/i.test(value)
}

function _LengthN (type, length) {
  var name = type.toJSON()

  function Length (value) {
    if (!type(value)) return false
    if (value.length === length) return true

    throw ERRORS.tfCustomError(name + '(Length: ' + length + ')', name + '(Length: ' + value.length + ')')
  }
  Length.toJSON = function () { return name }

  return Length
}

var _ArrayN = _LengthN.bind(null, NATIVE.Array)
var _BufferN = _LengthN.bind(null, _Buffer)
var _HexN = _LengthN.bind(null, Hex)
var _StringN = _LengthN.bind(null, NATIVE.String)

function Range (a, b, f) {
  f = f || NATIVE.Number
  function _range (value, strict) {
    return f(value, strict) && (value > a) && (value < b)
  }
  _range.toJSON = function () {
    return `${f.toJSON()} between [${a}, ${b}]`
  }
  return _range
}

var INT53_MAX = Math.pow(2, 53) - 1

function Finite (value) {
  return typeof value === 'number' && isFinite(value)
}
function Int8 (value) { return ((value << 24) >> 24) === value }
function Int16 (value) { return ((value << 16) >> 16) === value }
function Int32 (value) { return (value | 0) === value }
function Int53 (value) {
  return typeof value === 'number' &&
    value >= -INT53_MAX &&
    value <= INT53_MAX &&
    Math.floor(value) === value
}
function UInt8 (value) { return (value & 0xff) === value }
function UInt16 (value) { return (value & 0xffff) === value }
function UInt32 (value) { return (value >>> 0) === value }
function UInt53 (value) {
  return typeof value === 'number' &&
    value >= 0 &&
    value <= INT53_MAX &&
    Math.floor(value) === value
}

var types = {
  ArrayN: _ArrayN,
  Buffer: _Buffer,
  BufferN: _BufferN,
  Finite: Finite,
  Hex: Hex,
  HexN: _HexN,
  Int8: Int8,
  Int16: Int16,
  Int32: Int32,
  Int53: Int53,
  Range: Range,
  StringN: _StringN,
  UInt8: UInt8,
  UInt16: UInt16,
  UInt32: UInt32,
  UInt53: UInt53
}

for (var typeName in types) {
  types[typeName].toJSON = function (t) {
    return t
  }.bind(null, typeName)
}

module.exports = types

}).call(this)}).call(this,{"isBuffer":require("../../../node_modules/is-buffer/index.js")})
},{"../../../node_modules/is-buffer/index.js":572,"./errors":423,"./native":426}],425:[function(require,module,exports){
var ERRORS = require('./errors')
var NATIVE = require('./native')

// short-hand
var tfJSON = ERRORS.tfJSON
var TfTypeError = ERRORS.TfTypeError
var TfPropertyTypeError = ERRORS.TfPropertyTypeError
var tfSubError = ERRORS.tfSubError
var getValueTypeName = ERRORS.getValueTypeName

var TYPES = {
  arrayOf: function arrayOf (type, options) {
    type = compile(type)
    options = options || {}

    function _arrayOf (array, strict) {
      if (!NATIVE.Array(array)) return false
      if (NATIVE.Nil(array)) return false
      if (options.minLength !== undefined && array.length < options.minLength) return false
      if (options.maxLength !== undefined && array.length > options.maxLength) return false
      if (options.length !== undefined && array.length !== options.length) return false

      return array.every(function (value, i) {
        try {
          return typeforce(type, value, strict)
        } catch (e) {
          throw tfSubError(e, i)
        }
      })
    }
    _arrayOf.toJSON = function () {
      var str = '[' + tfJSON(type) + ']'
      if (options.length !== undefined) {
        str += '{' + options.length + '}'
      } else if (options.minLength !== undefined || options.maxLength !== undefined) {
        str += '{' +
          (options.minLength === undefined ? 0 : options.minLength) + ',' +
          (options.maxLength === undefined ? Infinity : options.maxLength) + '}'
      }
      return str
    }

    return _arrayOf
  },

  maybe: function maybe (type) {
    type = compile(type)

    function _maybe (value, strict) {
      return NATIVE.Nil(value) || type(value, strict, maybe)
    }
    _maybe.toJSON = function () { return '?' + tfJSON(type) }

    return _maybe
  },

  map: function map (propertyType, propertyKeyType) {
    propertyType = compile(propertyType)
    if (propertyKeyType) propertyKeyType = compile(propertyKeyType)

    function _map (value, strict) {
      if (!NATIVE.Object(value)) return false
      if (NATIVE.Nil(value)) return false

      for (var propertyName in value) {
        try {
          if (propertyKeyType) {
            typeforce(propertyKeyType, propertyName, strict)
          }
        } catch (e) {
          throw tfSubError(e, propertyName, 'key')
        }

        try {
          var propertyValue = value[propertyName]
          typeforce(propertyType, propertyValue, strict)
        } catch (e) {
          throw tfSubError(e, propertyName)
        }
      }

      return true
    }

    if (propertyKeyType) {
      _map.toJSON = function () {
        return '{' + tfJSON(propertyKeyType) + ': ' + tfJSON(propertyType) + '}'
      }
    } else {
      _map.toJSON = function () { return '{' + tfJSON(propertyType) + '}' }
    }

    return _map
  },

  object: function object (uncompiled) {
    var type = {}

    for (var typePropertyName in uncompiled) {
      type[typePropertyName] = compile(uncompiled[typePropertyName])
    }

    function _object (value, strict) {
      if (!NATIVE.Object(value)) return false
      if (NATIVE.Nil(value)) return false

      var propertyName

      try {
        for (propertyName in type) {
          var propertyType = type[propertyName]
          var propertyValue = value[propertyName]

          typeforce(propertyType, propertyValue, strict)
        }
      } catch (e) {
        throw tfSubError(e, propertyName)
      }

      if (strict) {
        for (propertyName in value) {
          if (type[propertyName]) continue

          throw new TfPropertyTypeError(undefined, propertyName)
        }
      }

      return true
    }
    _object.toJSON = function () { return tfJSON(type) }

    return _object
  },

  anyOf: function anyOf () {
    var types = [].slice.call(arguments).map(compile)

    function _anyOf (value, strict) {
      return types.some(function (type) {
        try {
          return typeforce(type, value, strict)
        } catch (e) {
          return false
        }
      })
    }
    _anyOf.toJSON = function () { return types.map(tfJSON).join('|') }

    return _anyOf
  },

  allOf: function allOf () {
    var types = [].slice.call(arguments).map(compile)

    function _allOf (value, strict) {
      return types.every(function (type) {
        try {
          return typeforce(type, value, strict)
        } catch (e) {
          return false
        }
      })
    }
    _allOf.toJSON = function () { return types.map(tfJSON).join(' & ') }

    return _allOf
  },

  quacksLike: function quacksLike (type) {
    function _quacksLike (value) {
      return type === getValueTypeName(value)
    }
    _quacksLike.toJSON = function () { return type }

    return _quacksLike
  },

  tuple: function tuple () {
    var types = [].slice.call(arguments).map(compile)

    function _tuple (values, strict) {
      if (NATIVE.Nil(values)) return false
      if (NATIVE.Nil(values.length)) return false
      if (strict && (values.length !== types.length)) return false

      return types.every(function (type, i) {
        try {
          return typeforce(type, values[i], strict)
        } catch (e) {
          throw tfSubError(e, i)
        }
      })
    }
    _tuple.toJSON = function () { return '(' + types.map(tfJSON).join(', ') + ')' }

    return _tuple
  },

  value: function value (expected) {
    function _value (actual) {
      return actual === expected
    }
    _value.toJSON = function () { return expected }

    return _value
  }
}

// TODO: deprecate
TYPES.oneOf = TYPES.anyOf

function compile (type) {
  if (NATIVE.String(type)) {
    if (type[0] === '?') return TYPES.maybe(type.slice(1))

    return NATIVE[type] || TYPES.quacksLike(type)
  } else if (type && NATIVE.Object(type)) {
    if (NATIVE.Array(type)) {
      if (type.length !== 1) throw new TypeError('Expected compile() parameter of type Array of length 1')
      return TYPES.arrayOf(type[0])
    }

    return TYPES.object(type)
  } else if (NATIVE.Function(type)) {
    return type
  }

  return TYPES.value(type)
}

function typeforce (type, value, strict, surrogate) {
  if (NATIVE.Function(type)) {
    if (type(value, strict)) return true

    throw new TfTypeError(surrogate || type, value)
  }

  // JIT
  return typeforce(compile(type), value, strict)
}

// assign types to typeforce function
for (var typeName in NATIVE) {
  typeforce[typeName] = NATIVE[typeName]
}

for (typeName in TYPES) {
  typeforce[typeName] = TYPES[typeName]
}

var EXTRA = require('./extra')
for (typeName in EXTRA) {
  typeforce[typeName] = EXTRA[typeName]
}

typeforce.compile = compile
typeforce.TfTypeError = TfTypeError
typeforce.TfPropertyTypeError = TfPropertyTypeError

module.exports = typeforce

},{"./errors":423,"./extra":424,"./native":426}],426:[function(require,module,exports){
var types = {
  Array: function (value) { return value !== null && value !== undefined && value.constructor === Array },
  Boolean: function (value) { return typeof value === 'boolean' },
  Function: function (value) { return typeof value === 'function' },
  Nil: function (value) { return value === undefined || value === null },
  Number: function (value) { return typeof value === 'number' },
  Object: function (value) { return typeof value === 'object' },
  String: function (value) { return typeof value === 'string' },
  '': function () { return true }
}

// TODO: deprecate
types.Null = types.Nil

for (var typeName in types) {
  types[typeName].toJSON = function (t) {
    return t
  }.bind(null, typeName)
}

module.exports = types

},{}],427:[function(require,module,exports){
(function (root) {
   "use strict";

/***** unorm.js *****/

/*
 * UnicodeNormalizer 1.0.0
 * Copyright (c) 2008 Matsuza
 * Dual licensed under the MIT (MIT-LICENSE.txt) and GPL (GPL-LICENSE.txt) licenses.
 * $Date: 2008-06-05 16:44:17 +0200 (Thu, 05 Jun 2008) $
 * $Rev: 13309 $
 */

   var DEFAULT_FEATURE = [null, 0, {}];
   var CACHE_THRESHOLD = 10;
   var SBase = 0xAC00, LBase = 0x1100, VBase = 0x1161, TBase = 0x11A7, LCount = 19, VCount = 21, TCount = 28;
   var NCount = VCount * TCount; // 588
   var SCount = LCount * NCount; // 11172

   var UChar = function(cp, feature){
      this.codepoint = cp;
      this.feature = feature;
   };

   // Strategies
   var cache = {};
   var cacheCounter = [];
   for (var i = 0; i <= 0xFF; ++i){
      cacheCounter[i] = 0;
   }

   function fromCache(next, cp, needFeature){
      var ret = cache[cp];
      if(!ret){
         ret = next(cp, needFeature);
         if(!!ret.feature && ++cacheCounter[(cp >> 8) & 0xFF] > CACHE_THRESHOLD){
            cache[cp] = ret;
         }
      }
      return ret;
   }

   function fromData(next, cp, needFeature){
      var hash = cp & 0xFF00;
      var dunit = UChar.udata[hash] || {};
      var f = dunit[cp];
      return f ? new UChar(cp, f) : new UChar(cp, DEFAULT_FEATURE);
   }
   function fromCpOnly(next, cp, needFeature){
      return !!needFeature ? next(cp, needFeature) : new UChar(cp, null);
   }
   function fromRuleBasedJamo(next, cp, needFeature){
      var j;
      if(cp < LBase || (LBase + LCount <= cp && cp < SBase) || (SBase + SCount < cp)){
         return next(cp, needFeature);
      }
      if(LBase <= cp && cp < LBase + LCount){
         var c = {};
         var base = (cp - LBase) * VCount;
         for (j = 0; j < VCount; ++j){
            c[VBase + j] = SBase + TCount * (j + base);
         }
         return new UChar(cp, [,,c]);
      }

      var SIndex = cp - SBase;
      var TIndex = SIndex % TCount;
      var feature = [];
      if(TIndex !== 0){
         feature[0] = [SBase + SIndex - TIndex, TBase + TIndex];
      } else {
         feature[0] = [LBase + Math.floor(SIndex / NCount), VBase + Math.floor((SIndex % NCount) / TCount)];
         feature[2] = {};
         for (j = 1; j < TCount; ++j){
            feature[2][TBase + j] = cp + j;
         }
      }
      return new UChar(cp, feature);
   }
   function fromCpFilter(next, cp, needFeature){
      return cp < 60 || 13311 < cp && cp < 42607 ? new UChar(cp, DEFAULT_FEATURE) : next(cp, needFeature);
   }

   var strategies = [fromCpFilter, fromCache, fromCpOnly, fromRuleBasedJamo, fromData];

   UChar.fromCharCode = strategies.reduceRight(function (next, strategy) {
      return function (cp, needFeature) {
         return strategy(next, cp, needFeature);
      };
   }, null);

   UChar.isHighSurrogate = function(cp){
      return cp >= 0xD800 && cp <= 0xDBFF;
   };
   UChar.isLowSurrogate = function(cp){
      return cp >= 0xDC00 && cp <= 0xDFFF;
   };

   UChar.prototype.prepFeature = function(){
      if(!this.feature){
         this.feature = UChar.fromCharCode(this.codepoint, true).feature;
      }
   };

   UChar.prototype.toString = function(){
      if(this.codepoint < 0x10000){
         return String.fromCharCode(this.codepoint);
      } else {
         var x = this.codepoint - 0x10000;
         return String.fromCharCode(Math.floor(x / 0x400) + 0xD800, x % 0x400 + 0xDC00);
      }
   };

   UChar.prototype.getDecomp = function(){
      this.prepFeature();
      return this.feature[0] || null;
   };

   UChar.prototype.isCompatibility = function(){
      this.prepFeature();
      return !!this.feature[1] && (this.feature[1] & (1 << 8));
   };
   UChar.prototype.isExclude = function(){
      this.prepFeature();
      return !!this.feature[1] && (this.feature[1] & (1 << 9));
   };
   UChar.prototype.getCanonicalClass = function(){
      this.prepFeature();
      return !!this.feature[1] ? (this.feature[1] & 0xff) : 0;
   };
   UChar.prototype.getComposite = function(following){
      this.prepFeature();
      if(!this.feature[2]){
         return null;
      }
      var cp = this.feature[2][following.codepoint];
      return cp ? UChar.fromCharCode(cp) : null;
   };

   var UCharIterator = function(str){
      this.str = str;
      this.cursor = 0;
   };
   UCharIterator.prototype.next = function(){
      if(!!this.str && this.cursor < this.str.length){
         var cp = this.str.charCodeAt(this.cursor++);
         var d;
         if(UChar.isHighSurrogate(cp) && this.cursor < this.str.length && UChar.isLowSurrogate((d = this.str.charCodeAt(this.cursor)))){
            cp = (cp - 0xD800) * 0x400 + (d -0xDC00) + 0x10000;
            ++this.cursor;
         }
         return UChar.fromCharCode(cp);
      } else {
         this.str = null;
         return null;
      }
   };

   var RecursDecompIterator = function(it, cano){
      this.it = it;
      this.canonical = cano;
      this.resBuf = [];
   };

   RecursDecompIterator.prototype.next = function(){
      function recursiveDecomp(cano, uchar){
         var decomp = uchar.getDecomp();
         if(!!decomp && !(cano && uchar.isCompatibility())){
            var ret = [];
            for(var i = 0; i < decomp.length; ++i){
               var a = recursiveDecomp(cano, UChar.fromCharCode(decomp[i]));
                ret = ret.concat(a);
            }
            return ret;
         } else {
            return [uchar];
         }
      }
      if(this.resBuf.length === 0){
         var uchar = this.it.next();
         if(!uchar){
            return null;
         }
         this.resBuf = recursiveDecomp(this.canonical, uchar);
      }
      return this.resBuf.shift();
   };

   var DecompIterator = function(it){
      this.it = it;
      this.resBuf = [];
   };

   DecompIterator.prototype.next = function(){
      var cc;
      if(this.resBuf.length === 0){
         do{
            var uchar = this.it.next();
            if(!uchar){
               break;
            }
            cc = uchar.getCanonicalClass();
            var inspt = this.resBuf.length;
            if(cc !== 0){
               for(; inspt > 0; --inspt){
                  var uchar2 = this.resBuf[inspt - 1];
                  var cc2 = uchar2.getCanonicalClass();
                  if(cc2 <= cc){
                     break;
                  }
               }
            }
            this.resBuf.splice(inspt, 0, uchar);
         } while(cc !== 0);
      }
      return this.resBuf.shift();
   };

   var CompIterator = function(it){
      this.it = it;
      this.procBuf = [];
      this.resBuf = [];
      this.lastClass = null;
   };

   CompIterator.prototype.next = function(){
      while(this.resBuf.length === 0){
         var uchar = this.it.next();
         if(!uchar){
            this.resBuf = this.procBuf;
            this.procBuf = [];
            break;
         }
         if(this.procBuf.length === 0){
            this.lastClass = uchar.getCanonicalClass();
            this.procBuf.push(uchar);
         } else {
            var starter = this.procBuf[0];
            var composite = starter.getComposite(uchar);
            var cc = uchar.getCanonicalClass();
            if(!!composite && (this.lastClass < cc || this.lastClass === 0)){
               this.procBuf[0] = composite;
            } else {
               if(cc === 0){
                  this.resBuf = this.procBuf;
                  this.procBuf = [];
               }
               this.lastClass = cc;
               this.procBuf.push(uchar);
            }
         }
      }
      return this.resBuf.shift();
   };

   var createIterator = function(mode, str){
      switch(mode){
         case "NFD":
            return new DecompIterator(new RecursDecompIterator(new UCharIterator(str), true));
         case "NFKD":
            return new DecompIterator(new RecursDecompIterator(new UCharIterator(str), false));
         case "NFC":
            return new CompIterator(new DecompIterator(new RecursDecompIterator(new UCharIterator(str), true)));
         case "NFKC":
            return new CompIterator(new DecompIterator(new RecursDecompIterator(new UCharIterator(str), false)));
      }
      throw mode + " is invalid";
   };
   var normalize = function(mode, str){
      var it = createIterator(mode, str);
      var ret = "";
      var uchar;
      while(!!(uchar = it.next())){
         ret += uchar.toString();
      }
      return ret;
   };

   /* API functions */
   function nfd(str){
      return normalize("NFD", str);
   }

   function nfkd(str){
      return normalize("NFKD", str);
   }

   function nfc(str){
      return normalize("NFC", str);
   }

   function nfkc(str){
      return normalize("NFKC", str);
   }

/* Unicode data */
UChar.udata={
0:{60:[,,{824:8814}],61:[,,{824:8800}],62:[,,{824:8815}],65:[,,{768:192,769:193,770:194,771:195,772:256,774:258,775:550,776:196,777:7842,778:197,780:461,783:512,785:514,803:7840,805:7680,808:260}],66:[,,{775:7682,803:7684,817:7686}],67:[,,{769:262,770:264,775:266,780:268,807:199}],68:[,,{775:7690,780:270,803:7692,807:7696,813:7698,817:7694}],69:[,,{768:200,769:201,770:202,771:7868,772:274,774:276,775:278,776:203,777:7866,780:282,783:516,785:518,803:7864,807:552,808:280,813:7704,816:7706}],70:[,,{775:7710}],71:[,,{769:500,770:284,772:7712,774:286,775:288,780:486,807:290}],72:[,,{770:292,775:7714,776:7718,780:542,803:7716,807:7720,814:7722}],73:[,,{768:204,769:205,770:206,771:296,772:298,774:300,775:304,776:207,777:7880,780:463,783:520,785:522,803:7882,808:302,816:7724}],74:[,,{770:308}],75:[,,{769:7728,780:488,803:7730,807:310,817:7732}],76:[,,{769:313,780:317,803:7734,807:315,813:7740,817:7738}],77:[,,{769:7742,775:7744,803:7746}],78:[,,{768:504,769:323,771:209,775:7748,780:327,803:7750,807:325,813:7754,817:7752}],79:[,,{768:210,769:211,770:212,771:213,772:332,774:334,775:558,776:214,777:7886,779:336,780:465,783:524,785:526,795:416,803:7884,808:490}],80:[,,{769:7764,775:7766}],82:[,,{769:340,775:7768,780:344,783:528,785:530,803:7770,807:342,817:7774}],83:[,,{769:346,770:348,775:7776,780:352,803:7778,806:536,807:350}],84:[,,{775:7786,780:356,803:7788,806:538,807:354,813:7792,817:7790}],85:[,,{768:217,769:218,770:219,771:360,772:362,774:364,776:220,777:7910,778:366,779:368,780:467,783:532,785:534,795:431,803:7908,804:7794,808:370,813:7798,816:7796}],86:[,,{771:7804,803:7806}],87:[,,{768:7808,769:7810,770:372,775:7814,776:7812,803:7816}],88:[,,{775:7818,776:7820}],89:[,,{768:7922,769:221,770:374,771:7928,772:562,775:7822,776:376,777:7926,803:7924}],90:[,,{769:377,770:7824,775:379,780:381,803:7826,817:7828}],97:[,,{768:224,769:225,770:226,771:227,772:257,774:259,775:551,776:228,777:7843,778:229,780:462,783:513,785:515,803:7841,805:7681,808:261}],98:[,,{775:7683,803:7685,817:7687}],99:[,,{769:263,770:265,775:267,780:269,807:231}],100:[,,{775:7691,780:271,803:7693,807:7697,813:7699,817:7695}],101:[,,{768:232,769:233,770:234,771:7869,772:275,774:277,775:279,776:235,777:7867,780:283,783:517,785:519,803:7865,807:553,808:281,813:7705,816:7707}],102:[,,{775:7711}],103:[,,{769:501,770:285,772:7713,774:287,775:289,780:487,807:291}],104:[,,{770:293,775:7715,776:7719,780:543,803:7717,807:7721,814:7723,817:7830}],105:[,,{768:236,769:237,770:238,771:297,772:299,774:301,776:239,777:7881,780:464,783:521,785:523,803:7883,808:303,816:7725}],106:[,,{770:309,780:496}],107:[,,{769:7729,780:489,803:7731,807:311,817:7733}],108:[,,{769:314,780:318,803:7735,807:316,813:7741,817:7739}],109:[,,{769:7743,775:7745,803:7747}],110:[,,{768:505,769:324,771:241,775:7749,780:328,803:7751,807:326,813:7755,817:7753}],111:[,,{768:242,769:243,770:244,771:245,772:333,774:335,775:559,776:246,777:7887,779:337,780:466,783:525,785:527,795:417,803:7885,808:491}],112:[,,{769:7765,775:7767}],114:[,,{769:341,775:7769,780:345,783:529,785:531,803:7771,807:343,817:7775}],115:[,,{769:347,770:349,775:7777,780:353,803:7779,806:537,807:351}],116:[,,{775:7787,776:7831,780:357,803:7789,806:539,807:355,813:7793,817:7791}],117:[,,{768:249,769:250,770:251,771:361,772:363,774:365,776:252,777:7911,778:367,779:369,780:468,783:533,785:535,795:432,803:7909,804:7795,808:371,813:7799,816:7797}],118:[,,{771:7805,803:7807}],119:[,,{768:7809,769:7811,770:373,775:7815,776:7813,778:7832,803:7817}],120:[,,{775:7819,776:7821}],121:[,,{768:7923,769:253,770:375,771:7929,772:563,775:7823,776:255,777:7927,778:7833,803:7925}],122:[,,{769:378,770:7825,775:380,780:382,803:7827,817:7829}],160:[[32],256],168:[[32,776],256,{768:8173,769:901,834:8129}],170:[[97],256],175:[[32,772],256],178:[[50],256],179:[[51],256],180:[[32,769],256],181:[[956],256],184:[[32,807],256],185:[[49],256],186:[[111],256],188:[[49,8260,52],256],189:[[49,8260,50],256],190:[[51,8260,52],256],192:[[65,768]],193:[[65,769]],194:[[65,770],,{768:7846,769:7844,771:7850,777:7848}],195:[[65,771]],196:[[65,776],,{772:478}],197:[[65,778],,{769:506}],198:[,,{769:508,772:482}],199:[[67,807],,{769:7688}],200:[[69,768]],201:[[69,769]],202:[[69,770],,{768:7872,769:7870,771:7876,777:7874}],203:[[69,776]],204:[[73,768]],205:[[73,769]],206:[[73,770]],207:[[73,776],,{769:7726}],209:[[78,771]],210:[[79,768]],211:[[79,769]],212:[[79,770],,{768:7890,769:7888,771:7894,777:7892}],213:[[79,771],,{769:7756,772:556,776:7758}],214:[[79,776],,{772:554}],216:[,,{769:510}],217:[[85,768]],218:[[85,769]],219:[[85,770]],220:[[85,776],,{768:475,769:471,772:469,780:473}],221:[[89,769]],224:[[97,768]],225:[[97,769]],226:[[97,770],,{768:7847,769:7845,771:7851,777:7849}],227:[[97,771]],228:[[97,776],,{772:479}],229:[[97,778],,{769:507}],230:[,,{769:509,772:483}],231:[[99,807],,{769:7689}],232:[[101,768]],233:[[101,769]],234:[[101,770],,{768:7873,769:7871,771:7877,777:7875}],235:[[101,776]],236:[[105,768]],237:[[105,769]],238:[[105,770]],239:[[105,776],,{769:7727}],241:[[110,771]],242:[[111,768]],243:[[111,769]],244:[[111,770],,{768:7891,769:7889,771:7895,777:7893}],245:[[111,771],,{769:7757,772:557,776:7759}],246:[[111,776],,{772:555}],248:[,,{769:511}],249:[[117,768]],250:[[117,769]],251:[[117,770]],252:[[117,776],,{768:476,769:472,772:470,780:474}],253:[[121,769]],255:[[121,776]]},
256:{256:[[65,772]],257:[[97,772]],258:[[65,774],,{768:7856,769:7854,771:7860,777:7858}],259:[[97,774],,{768:7857,769:7855,771:7861,777:7859}],260:[[65,808]],261:[[97,808]],262:[[67,769]],263:[[99,769]],264:[[67,770]],265:[[99,770]],266:[[67,775]],267:[[99,775]],268:[[67,780]],269:[[99,780]],270:[[68,780]],271:[[100,780]],274:[[69,772],,{768:7700,769:7702}],275:[[101,772],,{768:7701,769:7703}],276:[[69,774]],277:[[101,774]],278:[[69,775]],279:[[101,775]],280:[[69,808]],281:[[101,808]],282:[[69,780]],283:[[101,780]],284:[[71,770]],285:[[103,770]],286:[[71,774]],287:[[103,774]],288:[[71,775]],289:[[103,775]],290:[[71,807]],291:[[103,807]],292:[[72,770]],293:[[104,770]],296:[[73,771]],297:[[105,771]],298:[[73,772]],299:[[105,772]],300:[[73,774]],301:[[105,774]],302:[[73,808]],303:[[105,808]],304:[[73,775]],306:[[73,74],256],307:[[105,106],256],308:[[74,770]],309:[[106,770]],310:[[75,807]],311:[[107,807]],313:[[76,769]],314:[[108,769]],315:[[76,807]],316:[[108,807]],317:[[76,780]],318:[[108,780]],319:[[76,183],256],320:[[108,183],256],323:[[78,769]],324:[[110,769]],325:[[78,807]],326:[[110,807]],327:[[78,780]],328:[[110,780]],329:[[700,110],256],332:[[79,772],,{768:7760,769:7762}],333:[[111,772],,{768:7761,769:7763}],334:[[79,774]],335:[[111,774]],336:[[79,779]],337:[[111,779]],340:[[82,769]],341:[[114,769]],342:[[82,807]],343:[[114,807]],344:[[82,780]],345:[[114,780]],346:[[83,769],,{775:7780}],347:[[115,769],,{775:7781}],348:[[83,770]],349:[[115,770]],350:[[83,807]],351:[[115,807]],352:[[83,780],,{775:7782}],353:[[115,780],,{775:7783}],354:[[84,807]],355:[[116,807]],356:[[84,780]],357:[[116,780]],360:[[85,771],,{769:7800}],361:[[117,771],,{769:7801}],362:[[85,772],,{776:7802}],363:[[117,772],,{776:7803}],364:[[85,774]],365:[[117,774]],366:[[85,778]],367:[[117,778]],368:[[85,779]],369:[[117,779]],370:[[85,808]],371:[[117,808]],372:[[87,770]],373:[[119,770]],374:[[89,770]],375:[[121,770]],376:[[89,776]],377:[[90,769]],378:[[122,769]],379:[[90,775]],380:[[122,775]],381:[[90,780]],382:[[122,780]],383:[[115],256,{775:7835}],416:[[79,795],,{768:7900,769:7898,771:7904,777:7902,803:7906}],417:[[111,795],,{768:7901,769:7899,771:7905,777:7903,803:7907}],431:[[85,795],,{768:7914,769:7912,771:7918,777:7916,803:7920}],432:[[117,795],,{768:7915,769:7913,771:7919,777:7917,803:7921}],439:[,,{780:494}],452:[[68,381],256],453:[[68,382],256],454:[[100,382],256],455:[[76,74],256],456:[[76,106],256],457:[[108,106],256],458:[[78,74],256],459:[[78,106],256],460:[[110,106],256],461:[[65,780]],462:[[97,780]],463:[[73,780]],464:[[105,780]],465:[[79,780]],466:[[111,780]],467:[[85,780]],468:[[117,780]],469:[[220,772]],470:[[252,772]],471:[[220,769]],472:[[252,769]],473:[[220,780]],474:[[252,780]],475:[[220,768]],476:[[252,768]],478:[[196,772]],479:[[228,772]],480:[[550,772]],481:[[551,772]],482:[[198,772]],483:[[230,772]],486:[[71,780]],487:[[103,780]],488:[[75,780]],489:[[107,780]],490:[[79,808],,{772:492}],491:[[111,808],,{772:493}],492:[[490,772]],493:[[491,772]],494:[[439,780]],495:[[658,780]],496:[[106,780]],497:[[68,90],256],498:[[68,122],256],499:[[100,122],256],500:[[71,769]],501:[[103,769]],504:[[78,768]],505:[[110,768]],506:[[197,769]],507:[[229,769]],508:[[198,769]],509:[[230,769]],510:[[216,769]],511:[[248,769]],66045:[,220]},
512:{512:[[65,783]],513:[[97,783]],514:[[65,785]],515:[[97,785]],516:[[69,783]],517:[[101,783]],518:[[69,785]],519:[[101,785]],520:[[73,783]],521:[[105,783]],522:[[73,785]],523:[[105,785]],524:[[79,783]],525:[[111,783]],526:[[79,785]],527:[[111,785]],528:[[82,783]],529:[[114,783]],530:[[82,785]],531:[[114,785]],532:[[85,783]],533:[[117,783]],534:[[85,785]],535:[[117,785]],536:[[83,806]],537:[[115,806]],538:[[84,806]],539:[[116,806]],542:[[72,780]],543:[[104,780]],550:[[65,775],,{772:480}],551:[[97,775],,{772:481}],552:[[69,807],,{774:7708}],553:[[101,807],,{774:7709}],554:[[214,772]],555:[[246,772]],556:[[213,772]],557:[[245,772]],558:[[79,775],,{772:560}],559:[[111,775],,{772:561}],560:[[558,772]],561:[[559,772]],562:[[89,772]],563:[[121,772]],658:[,,{780:495}],688:[[104],256],689:[[614],256],690:[[106],256],691:[[114],256],692:[[633],256],693:[[635],256],694:[[641],256],695:[[119],256],696:[[121],256],728:[[32,774],256],729:[[32,775],256],730:[[32,778],256],731:[[32,808],256],732:[[32,771],256],733:[[32,779],256],736:[[611],256],737:[[108],256],738:[[115],256],739:[[120],256],740:[[661],256],66272:[,220]},
768:{768:[,230],769:[,230],770:[,230],771:[,230],772:[,230],773:[,230],774:[,230],775:[,230],776:[,230,{769:836}],777:[,230],778:[,230],779:[,230],780:[,230],781:[,230],782:[,230],783:[,230],784:[,230],785:[,230],786:[,230],787:[,230],788:[,230],789:[,232],790:[,220],791:[,220],792:[,220],793:[,220],794:[,232],795:[,216],796:[,220],797:[,220],798:[,220],799:[,220],800:[,220],801:[,202],802:[,202],803:[,220],804:[,220],805:[,220],806:[,220],807:[,202],808:[,202],809:[,220],810:[,220],811:[,220],812:[,220],813:[,220],814:[,220],815:[,220],816:[,220],817:[,220],818:[,220],819:[,220],820:[,1],821:[,1],822:[,1],823:[,1],824:[,1],825:[,220],826:[,220],827:[,220],828:[,220],829:[,230],830:[,230],831:[,230],832:[[768],230],833:[[769],230],834:[,230],835:[[787],230],836:[[776,769],230],837:[,240],838:[,230],839:[,220],840:[,220],841:[,220],842:[,230],843:[,230],844:[,230],845:[,220],846:[,220],848:[,230],849:[,230],850:[,230],851:[,220],852:[,220],853:[,220],854:[,220],855:[,230],856:[,232],857:[,220],858:[,220],859:[,230],860:[,233],861:[,234],862:[,234],863:[,233],864:[,234],865:[,234],866:[,233],867:[,230],868:[,230],869:[,230],870:[,230],871:[,230],872:[,230],873:[,230],874:[,230],875:[,230],876:[,230],877:[,230],878:[,230],879:[,230],884:[[697]],890:[[32,837],256],894:[[59]],900:[[32,769],256],901:[[168,769]],902:[[913,769]],903:[[183]],904:[[917,769]],905:[[919,769]],906:[[921,769]],908:[[927,769]],910:[[933,769]],911:[[937,769]],912:[[970,769]],913:[,,{768:8122,769:902,772:8121,774:8120,787:7944,788:7945,837:8124}],917:[,,{768:8136,769:904,787:7960,788:7961}],919:[,,{768:8138,769:905,787:7976,788:7977,837:8140}],921:[,,{768:8154,769:906,772:8153,774:8152,776:938,787:7992,788:7993}],927:[,,{768:8184,769:908,787:8008,788:8009}],929:[,,{788:8172}],933:[,,{768:8170,769:910,772:8169,774:8168,776:939,788:8025}],937:[,,{768:8186,769:911,787:8040,788:8041,837:8188}],938:[[921,776]],939:[[933,776]],940:[[945,769],,{837:8116}],941:[[949,769]],942:[[951,769],,{837:8132}],943:[[953,769]],944:[[971,769]],945:[,,{768:8048,769:940,772:8113,774:8112,787:7936,788:7937,834:8118,837:8115}],949:[,,{768:8050,769:941,787:7952,788:7953}],951:[,,{768:8052,769:942,787:7968,788:7969,834:8134,837:8131}],953:[,,{768:8054,769:943,772:8145,774:8144,776:970,787:7984,788:7985,834:8150}],959:[,,{768:8056,769:972,787:8000,788:8001}],961:[,,{787:8164,788:8165}],965:[,,{768:8058,769:973,772:8161,774:8160,776:971,787:8016,788:8017,834:8166}],969:[,,{768:8060,769:974,787:8032,788:8033,834:8182,837:8179}],970:[[953,776],,{768:8146,769:912,834:8151}],971:[[965,776],,{768:8162,769:944,834:8167}],972:[[959,769]],973:[[965,769]],974:[[969,769],,{837:8180}],976:[[946],256],977:[[952],256],978:[[933],256,{769:979,776:980}],979:[[978,769]],980:[[978,776]],981:[[966],256],982:[[960],256],1008:[[954],256],1009:[[961],256],1010:[[962],256],1012:[[920],256],1013:[[949],256],1017:[[931],256],66422:[,230],66423:[,230],66424:[,230],66425:[,230],66426:[,230]},
1024:{1024:[[1045,768]],1025:[[1045,776]],1027:[[1043,769]],1030:[,,{776:1031}],1031:[[1030,776]],1036:[[1050,769]],1037:[[1048,768]],1038:[[1059,774]],1040:[,,{774:1232,776:1234}],1043:[,,{769:1027}],1045:[,,{768:1024,774:1238,776:1025}],1046:[,,{774:1217,776:1244}],1047:[,,{776:1246}],1048:[,,{768:1037,772:1250,774:1049,776:1252}],1049:[[1048,774]],1050:[,,{769:1036}],1054:[,,{776:1254}],1059:[,,{772:1262,774:1038,776:1264,779:1266}],1063:[,,{776:1268}],1067:[,,{776:1272}],1069:[,,{776:1260}],1072:[,,{774:1233,776:1235}],1075:[,,{769:1107}],1077:[,,{768:1104,774:1239,776:1105}],1078:[,,{774:1218,776:1245}],1079:[,,{776:1247}],1080:[,,{768:1117,772:1251,774:1081,776:1253}],1081:[[1080,774]],1082:[,,{769:1116}],1086:[,,{776:1255}],1091:[,,{772:1263,774:1118,776:1265,779:1267}],1095:[,,{776:1269}],1099:[,,{776:1273}],1101:[,,{776:1261}],1104:[[1077,768]],1105:[[1077,776]],1107:[[1075,769]],1110:[,,{776:1111}],1111:[[1110,776]],1116:[[1082,769]],1117:[[1080,768]],1118:[[1091,774]],1140:[,,{783:1142}],1141:[,,{783:1143}],1142:[[1140,783]],1143:[[1141,783]],1155:[,230],1156:[,230],1157:[,230],1158:[,230],1159:[,230],1217:[[1046,774]],1218:[[1078,774]],1232:[[1040,774]],1233:[[1072,774]],1234:[[1040,776]],1235:[[1072,776]],1238:[[1045,774]],1239:[[1077,774]],1240:[,,{776:1242}],1241:[,,{776:1243}],1242:[[1240,776]],1243:[[1241,776]],1244:[[1046,776]],1245:[[1078,776]],1246:[[1047,776]],1247:[[1079,776]],1250:[[1048,772]],1251:[[1080,772]],1252:[[1048,776]],1253:[[1080,776]],1254:[[1054,776]],1255:[[1086,776]],1256:[,,{776:1258}],1257:[,,{776:1259}],1258:[[1256,776]],1259:[[1257,776]],1260:[[1069,776]],1261:[[1101,776]],1262:[[1059,772]],1263:[[1091,772]],1264:[[1059,776]],1265:[[1091,776]],1266:[[1059,779]],1267:[[1091,779]],1268:[[1063,776]],1269:[[1095,776]],1272:[[1067,776]],1273:[[1099,776]]},
1280:{1415:[[1381,1410],256],1425:[,220],1426:[,230],1427:[,230],1428:[,230],1429:[,230],1430:[,220],1431:[,230],1432:[,230],1433:[,230],1434:[,222],1435:[,220],1436:[,230],1437:[,230],1438:[,230],1439:[,230],1440:[,230],1441:[,230],1442:[,220],1443:[,220],1444:[,220],1445:[,220],1446:[,220],1447:[,220],1448:[,230],1449:[,230],1450:[,220],1451:[,230],1452:[,230],1453:[,222],1454:[,228],1455:[,230],1456:[,10],1457:[,11],1458:[,12],1459:[,13],1460:[,14],1461:[,15],1462:[,16],1463:[,17],1464:[,18],1465:[,19],1466:[,19],1467:[,20],1468:[,21],1469:[,22],1471:[,23],1473:[,24],1474:[,25],1476:[,230],1477:[,220],1479:[,18]},
1536:{1552:[,230],1553:[,230],1554:[,230],1555:[,230],1556:[,230],1557:[,230],1558:[,230],1559:[,230],1560:[,30],1561:[,31],1562:[,32],1570:[[1575,1619]],1571:[[1575,1620]],1572:[[1608,1620]],1573:[[1575,1621]],1574:[[1610,1620]],1575:[,,{1619:1570,1620:1571,1621:1573}],1608:[,,{1620:1572}],1610:[,,{1620:1574}],1611:[,27],1612:[,28],1613:[,29],1614:[,30],1615:[,31],1616:[,32],1617:[,33],1618:[,34],1619:[,230],1620:[,230],1621:[,220],1622:[,220],1623:[,230],1624:[,230],1625:[,230],1626:[,230],1627:[,230],1628:[,220],1629:[,230],1630:[,230],1631:[,220],1648:[,35],1653:[[1575,1652],256],1654:[[1608,1652],256],1655:[[1735,1652],256],1656:[[1610,1652],256],1728:[[1749,1620]],1729:[,,{1620:1730}],1730:[[1729,1620]],1746:[,,{1620:1747}],1747:[[1746,1620]],1749:[,,{1620:1728}],1750:[,230],1751:[,230],1752:[,230],1753:[,230],1754:[,230],1755:[,230],1756:[,230],1759:[,230],1760:[,230],1761:[,230],1762:[,230],1763:[,220],1764:[,230],1767:[,230],1768:[,230],1770:[,220],1771:[,230],1772:[,230],1773:[,220]},
1792:{1809:[,36],1840:[,230],1841:[,220],1842:[,230],1843:[,230],1844:[,220],1845:[,230],1846:[,230],1847:[,220],1848:[,220],1849:[,220],1850:[,230],1851:[,220],1852:[,220],1853:[,230],1854:[,220],1855:[,230],1856:[,230],1857:[,230],1858:[,220],1859:[,230],1860:[,220],1861:[,230],1862:[,220],1863:[,230],1864:[,220],1865:[,230],1866:[,230],2027:[,230],2028:[,230],2029:[,230],2030:[,230],2031:[,230],2032:[,230],2033:[,230],2034:[,220],2035:[,230]},
2048:{2070:[,230],2071:[,230],2072:[,230],2073:[,230],2075:[,230],2076:[,230],2077:[,230],2078:[,230],2079:[,230],2080:[,230],2081:[,230],2082:[,230],2083:[,230],2085:[,230],2086:[,230],2087:[,230],2089:[,230],2090:[,230],2091:[,230],2092:[,230],2093:[,230],2137:[,220],2138:[,220],2139:[,220],2276:[,230],2277:[,230],2278:[,220],2279:[,230],2280:[,230],2281:[,220],2282:[,230],2283:[,230],2284:[,230],2285:[,220],2286:[,220],2287:[,220],2288:[,27],2289:[,28],2290:[,29],2291:[,230],2292:[,230],2293:[,230],2294:[,220],2295:[,230],2296:[,230],2297:[,220],2298:[,220],2299:[,230],2300:[,230],2301:[,230],2302:[,230],2303:[,230]},
2304:{2344:[,,{2364:2345}],2345:[[2344,2364]],2352:[,,{2364:2353}],2353:[[2352,2364]],2355:[,,{2364:2356}],2356:[[2355,2364]],2364:[,7],2381:[,9],2385:[,230],2386:[,220],2387:[,230],2388:[,230],2392:[[2325,2364],512],2393:[[2326,2364],512],2394:[[2327,2364],512],2395:[[2332,2364],512],2396:[[2337,2364],512],2397:[[2338,2364],512],2398:[[2347,2364],512],2399:[[2351,2364],512],2492:[,7],2503:[,,{2494:2507,2519:2508}],2507:[[2503,2494]],2508:[[2503,2519]],2509:[,9],2524:[[2465,2492],512],2525:[[2466,2492],512],2527:[[2479,2492],512]},
2560:{2611:[[2610,2620],512],2614:[[2616,2620],512],2620:[,7],2637:[,9],2649:[[2582,2620],512],2650:[[2583,2620],512],2651:[[2588,2620],512],2654:[[2603,2620],512],2748:[,7],2765:[,9],68109:[,220],68111:[,230],68152:[,230],68153:[,1],68154:[,220],68159:[,9],68325:[,230],68326:[,220]},
2816:{2876:[,7],2887:[,,{2878:2891,2902:2888,2903:2892}],2888:[[2887,2902]],2891:[[2887,2878]],2892:[[2887,2903]],2893:[,9],2908:[[2849,2876],512],2909:[[2850,2876],512],2962:[,,{3031:2964}],2964:[[2962,3031]],3014:[,,{3006:3018,3031:3020}],3015:[,,{3006:3019}],3018:[[3014,3006]],3019:[[3015,3006]],3020:[[3014,3031]],3021:[,9]},
3072:{3142:[,,{3158:3144}],3144:[[3142,3158]],3149:[,9],3157:[,84],3158:[,91],3260:[,7],3263:[,,{3285:3264}],3264:[[3263,3285]],3270:[,,{3266:3274,3285:3271,3286:3272}],3271:[[3270,3285]],3272:[[3270,3286]],3274:[[3270,3266],,{3285:3275}],3275:[[3274,3285]],3277:[,9]},
3328:{3398:[,,{3390:3402,3415:3404}],3399:[,,{3390:3403}],3402:[[3398,3390]],3403:[[3399,3390]],3404:[[3398,3415]],3405:[,9],3530:[,9],3545:[,,{3530:3546,3535:3548,3551:3550}],3546:[[3545,3530]],3548:[[3545,3535],,{3530:3549}],3549:[[3548,3530]],3550:[[3545,3551]]},
3584:{3635:[[3661,3634],256],3640:[,103],3641:[,103],3642:[,9],3656:[,107],3657:[,107],3658:[,107],3659:[,107],3763:[[3789,3762],256],3768:[,118],3769:[,118],3784:[,122],3785:[,122],3786:[,122],3787:[,122],3804:[[3755,3737],256],3805:[[3755,3745],256]},
3840:{3852:[[3851],256],3864:[,220],3865:[,220],3893:[,220],3895:[,220],3897:[,216],3907:[[3906,4023],512],3917:[[3916,4023],512],3922:[[3921,4023],512],3927:[[3926,4023],512],3932:[[3931,4023],512],3945:[[3904,4021],512],3953:[,129],3954:[,130],3955:[[3953,3954],512],3956:[,132],3957:[[3953,3956],512],3958:[[4018,3968],512],3959:[[4018,3969],256],3960:[[4019,3968],512],3961:[[4019,3969],256],3962:[,130],3963:[,130],3964:[,130],3965:[,130],3968:[,130],3969:[[3953,3968],512],3970:[,230],3971:[,230],3972:[,9],3974:[,230],3975:[,230],3987:[[3986,4023],512],3997:[[3996,4023],512],4002:[[4001,4023],512],4007:[[4006,4023],512],4012:[[4011,4023],512],4025:[[3984,4021],512],4038:[,220]},
4096:{4133:[,,{4142:4134}],4134:[[4133,4142]],4151:[,7],4153:[,9],4154:[,9],4237:[,220],4348:[[4316],256],69702:[,9],69759:[,9],69785:[,,{69818:69786}],69786:[[69785,69818]],69787:[,,{69818:69788}],69788:[[69787,69818]],69797:[,,{69818:69803}],69803:[[69797,69818]],69817:[,9],69818:[,7]},
4352:{69888:[,230],69889:[,230],69890:[,230],69934:[[69937,69927]],69935:[[69938,69927]],69937:[,,{69927:69934}],69938:[,,{69927:69935}],69939:[,9],69940:[,9],70003:[,7],70080:[,9]},
4608:{70197:[,9],70198:[,7],70377:[,7],70378:[,9]},
4864:{4957:[,230],4958:[,230],4959:[,230],70460:[,7],70471:[,,{70462:70475,70487:70476}],70475:[[70471,70462]],70476:[[70471,70487]],70477:[,9],70502:[,230],70503:[,230],70504:[,230],70505:[,230],70506:[,230],70507:[,230],70508:[,230],70512:[,230],70513:[,230],70514:[,230],70515:[,230],70516:[,230]},
5120:{70841:[,,{70832:70844,70842:70843,70845:70846}],70843:[[70841,70842]],70844:[[70841,70832]],70846:[[70841,70845]],70850:[,9],70851:[,7]},
5376:{71096:[,,{71087:71098}],71097:[,,{71087:71099}],71098:[[71096,71087]],71099:[[71097,71087]],71103:[,9],71104:[,7]},
5632:{71231:[,9],71350:[,9],71351:[,7]},
5888:{5908:[,9],5940:[,9],6098:[,9],6109:[,230]},
6144:{6313:[,228]},
6400:{6457:[,222],6458:[,230],6459:[,220]},
6656:{6679:[,230],6680:[,220],6752:[,9],6773:[,230],6774:[,230],6775:[,230],6776:[,230],6777:[,230],6778:[,230],6779:[,230],6780:[,230],6783:[,220],6832:[,230],6833:[,230],6834:[,230],6835:[,230],6836:[,230],6837:[,220],6838:[,220],6839:[,220],6840:[,220],6841:[,220],6842:[,220],6843:[,230],6844:[,230],6845:[,220]},
6912:{6917:[,,{6965:6918}],6918:[[6917,6965]],6919:[,,{6965:6920}],6920:[[6919,6965]],6921:[,,{6965:6922}],6922:[[6921,6965]],6923:[,,{6965:6924}],6924:[[6923,6965]],6925:[,,{6965:6926}],6926:[[6925,6965]],6929:[,,{6965:6930}],6930:[[6929,6965]],6964:[,7],6970:[,,{6965:6971}],6971:[[6970,6965]],6972:[,,{6965:6973}],6973:[[6972,6965]],6974:[,,{6965:6976}],6975:[,,{6965:6977}],6976:[[6974,6965]],6977:[[6975,6965]],6978:[,,{6965:6979}],6979:[[6978,6965]],6980:[,9],7019:[,230],7020:[,220],7021:[,230],7022:[,230],7023:[,230],7024:[,230],7025:[,230],7026:[,230],7027:[,230],7082:[,9],7083:[,9],7142:[,7],7154:[,9],7155:[,9]},
7168:{7223:[,7],7376:[,230],7377:[,230],7378:[,230],7380:[,1],7381:[,220],7382:[,220],7383:[,220],7384:[,220],7385:[,220],7386:[,230],7387:[,230],7388:[,220],7389:[,220],7390:[,220],7391:[,220],7392:[,230],7394:[,1],7395:[,1],7396:[,1],7397:[,1],7398:[,1],7399:[,1],7400:[,1],7405:[,220],7412:[,230],7416:[,230],7417:[,230]},
7424:{7468:[[65],256],7469:[[198],256],7470:[[66],256],7472:[[68],256],7473:[[69],256],7474:[[398],256],7475:[[71],256],7476:[[72],256],7477:[[73],256],7478:[[74],256],7479:[[75],256],7480:[[76],256],7481:[[77],256],7482:[[78],256],7484:[[79],256],7485:[[546],256],7486:[[80],256],7487:[[82],256],7488:[[84],256],7489:[[85],256],7490:[[87],256],7491:[[97],256],7492:[[592],256],7493:[[593],256],7494:[[7426],256],7495:[[98],256],7496:[[100],256],7497:[[101],256],7498:[[601],256],7499:[[603],256],7500:[[604],256],7501:[[103],256],7503:[[107],256],7504:[[109],256],7505:[[331],256],7506:[[111],256],7507:[[596],256],7508:[[7446],256],7509:[[7447],256],7510:[[112],256],7511:[[116],256],7512:[[117],256],7513:[[7453],256],7514:[[623],256],7515:[[118],256],7516:[[7461],256],7517:[[946],256],7518:[[947],256],7519:[[948],256],7520:[[966],256],7521:[[967],256],7522:[[105],256],7523:[[114],256],7524:[[117],256],7525:[[118],256],7526:[[946],256],7527:[[947],256],7528:[[961],256],7529:[[966],256],7530:[[967],256],7544:[[1085],256],7579:[[594],256],7580:[[99],256],7581:[[597],256],7582:[[240],256],7583:[[604],256],7584:[[102],256],7585:[[607],256],7586:[[609],256],7587:[[613],256],7588:[[616],256],7589:[[617],256],7590:[[618],256],7591:[[7547],256],7592:[[669],256],7593:[[621],256],7594:[[7557],256],7595:[[671],256],7596:[[625],256],7597:[[624],256],7598:[[626],256],7599:[[627],256],7600:[[628],256],7601:[[629],256],7602:[[632],256],7603:[[642],256],7604:[[643],256],7605:[[427],256],7606:[[649],256],7607:[[650],256],7608:[[7452],256],7609:[[651],256],7610:[[652],256],7611:[[122],256],7612:[[656],256],7613:[[657],256],7614:[[658],256],7615:[[952],256],7616:[,230],7617:[,230],7618:[,220],7619:[,230],7620:[,230],7621:[,230],7622:[,230],7623:[,230],7624:[,230],7625:[,230],7626:[,220],7627:[,230],7628:[,230],7629:[,234],7630:[,214],7631:[,220],7632:[,202],7633:[,230],7634:[,230],7635:[,230],7636:[,230],7637:[,230],7638:[,230],7639:[,230],7640:[,230],7641:[,230],7642:[,230],7643:[,230],7644:[,230],7645:[,230],7646:[,230],7647:[,230],7648:[,230],7649:[,230],7650:[,230],7651:[,230],7652:[,230],7653:[,230],7654:[,230],7655:[,230],7656:[,230],7657:[,230],7658:[,230],7659:[,230],7660:[,230],7661:[,230],7662:[,230],7663:[,230],7664:[,230],7665:[,230],7666:[,230],7667:[,230],7668:[,230],7669:[,230],7676:[,233],7677:[,220],7678:[,230],7679:[,220]},
7680:{7680:[[65,805]],7681:[[97,805]],7682:[[66,775]],7683:[[98,775]],7684:[[66,803]],7685:[[98,803]],7686:[[66,817]],7687:[[98,817]],7688:[[199,769]],7689:[[231,769]],7690:[[68,775]],7691:[[100,775]],7692:[[68,803]],7693:[[100,803]],7694:[[68,817]],7695:[[100,817]],7696:[[68,807]],7697:[[100,807]],7698:[[68,813]],7699:[[100,813]],7700:[[274,768]],7701:[[275,768]],7702:[[274,769]],7703:[[275,769]],7704:[[69,813]],7705:[[101,813]],7706:[[69,816]],7707:[[101,816]],7708:[[552,774]],7709:[[553,774]],7710:[[70,775]],7711:[[102,775]],7712:[[71,772]],7713:[[103,772]],7714:[[72,775]],7715:[[104,775]],7716:[[72,803]],7717:[[104,803]],7718:[[72,776]],7719:[[104,776]],7720:[[72,807]],7721:[[104,807]],7722:[[72,814]],7723:[[104,814]],7724:[[73,816]],7725:[[105,816]],7726:[[207,769]],7727:[[239,769]],7728:[[75,769]],7729:[[107,769]],7730:[[75,803]],7731:[[107,803]],7732:[[75,817]],7733:[[107,817]],7734:[[76,803],,{772:7736}],7735:[[108,803],,{772:7737}],7736:[[7734,772]],7737:[[7735,772]],7738:[[76,817]],7739:[[108,817]],7740:[[76,813]],7741:[[108,813]],7742:[[77,769]],7743:[[109,769]],7744:[[77,775]],7745:[[109,775]],7746:[[77,803]],7747:[[109,803]],7748:[[78,775]],7749:[[110,775]],7750:[[78,803]],7751:[[110,803]],7752:[[78,817]],7753:[[110,817]],7754:[[78,813]],7755:[[110,813]],7756:[[213,769]],7757:[[245,769]],7758:[[213,776]],7759:[[245,776]],7760:[[332,768]],7761:[[333,768]],7762:[[332,769]],7763:[[333,769]],7764:[[80,769]],7765:[[112,769]],7766:[[80,775]],7767:[[112,775]],7768:[[82,775]],7769:[[114,775]],7770:[[82,803],,{772:7772}],7771:[[114,803],,{772:7773}],7772:[[7770,772]],7773:[[7771,772]],7774:[[82,817]],7775:[[114,817]],7776:[[83,775]],7777:[[115,775]],7778:[[83,803],,{775:7784}],7779:[[115,803],,{775:7785}],7780:[[346,775]],7781:[[347,775]],7782:[[352,775]],7783:[[353,775]],7784:[[7778,775]],7785:[[7779,775]],7786:[[84,775]],7787:[[116,775]],7788:[[84,803]],7789:[[116,803]],7790:[[84,817]],7791:[[116,817]],7792:[[84,813]],7793:[[116,813]],7794:[[85,804]],7795:[[117,804]],7796:[[85,816]],7797:[[117,816]],7798:[[85,813]],7799:[[117,813]],7800:[[360,769]],7801:[[361,769]],7802:[[362,776]],7803:[[363,776]],7804:[[86,771]],7805:[[118,771]],7806:[[86,803]],7807:[[118,803]],7808:[[87,768]],7809:[[119,768]],7810:[[87,769]],7811:[[119,769]],7812:[[87,776]],7813:[[119,776]],7814:[[87,775]],7815:[[119,775]],7816:[[87,803]],7817:[[119,803]],7818:[[88,775]],7819:[[120,775]],7820:[[88,776]],7821:[[120,776]],7822:[[89,775]],7823:[[121,775]],7824:[[90,770]],7825:[[122,770]],7826:[[90,803]],7827:[[122,803]],7828:[[90,817]],7829:[[122,817]],7830:[[104,817]],7831:[[116,776]],7832:[[119,778]],7833:[[121,778]],7834:[[97,702],256],7835:[[383,775]],7840:[[65,803],,{770:7852,774:7862}],7841:[[97,803],,{770:7853,774:7863}],7842:[[65,777]],7843:[[97,777]],7844:[[194,769]],7845:[[226,769]],7846:[[194,768]],7847:[[226,768]],7848:[[194,777]],7849:[[226,777]],7850:[[194,771]],7851:[[226,771]],7852:[[7840,770]],7853:[[7841,770]],7854:[[258,769]],7855:[[259,769]],7856:[[258,768]],7857:[[259,768]],7858:[[258,777]],7859:[[259,777]],7860:[[258,771]],7861:[[259,771]],7862:[[7840,774]],7863:[[7841,774]],7864:[[69,803],,{770:7878}],7865:[[101,803],,{770:7879}],7866:[[69,777]],7867:[[101,777]],7868:[[69,771]],7869:[[101,771]],7870:[[202,769]],7871:[[234,769]],7872:[[202,768]],7873:[[234,768]],7874:[[202,777]],7875:[[234,777]],7876:[[202,771]],7877:[[234,771]],7878:[[7864,770]],7879:[[7865,770]],7880:[[73,777]],7881:[[105,777]],7882:[[73,803]],7883:[[105,803]],7884:[[79,803],,{770:7896}],7885:[[111,803],,{770:7897}],7886:[[79,777]],7887:[[111,777]],7888:[[212,769]],7889:[[244,769]],7890:[[212,768]],7891:[[244,768]],7892:[[212,777]],7893:[[244,777]],7894:[[212,771]],7895:[[244,771]],7896:[[7884,770]],7897:[[7885,770]],7898:[[416,769]],7899:[[417,769]],7900:[[416,768]],7901:[[417,768]],7902:[[416,777]],7903:[[417,777]],7904:[[416,771]],7905:[[417,771]],7906:[[416,803]],7907:[[417,803]],7908:[[85,803]],7909:[[117,803]],7910:[[85,777]],7911:[[117,777]],7912:[[431,769]],7913:[[432,769]],7914:[[431,768]],7915:[[432,768]],7916:[[431,777]],7917:[[432,777]],7918:[[431,771]],7919:[[432,771]],7920:[[431,803]],7921:[[432,803]],7922:[[89,768]],7923:[[121,768]],7924:[[89,803]],7925:[[121,803]],7926:[[89,777]],7927:[[121,777]],7928:[[89,771]],7929:[[121,771]]},
7936:{7936:[[945,787],,{768:7938,769:7940,834:7942,837:8064}],7937:[[945,788],,{768:7939,769:7941,834:7943,837:8065}],7938:[[7936,768],,{837:8066}],7939:[[7937,768],,{837:8067}],7940:[[7936,769],,{837:8068}],7941:[[7937,769],,{837:8069}],7942:[[7936,834],,{837:8070}],7943:[[7937,834],,{837:8071}],7944:[[913,787],,{768:7946,769:7948,834:7950,837:8072}],7945:[[913,788],,{768:7947,769:7949,834:7951,837:8073}],7946:[[7944,768],,{837:8074}],7947:[[7945,768],,{837:8075}],7948:[[7944,769],,{837:8076}],7949:[[7945,769],,{837:8077}],7950:[[7944,834],,{837:8078}],7951:[[7945,834],,{837:8079}],7952:[[949,787],,{768:7954,769:7956}],7953:[[949,788],,{768:7955,769:7957}],7954:[[7952,768]],7955:[[7953,768]],7956:[[7952,769]],7957:[[7953,769]],7960:[[917,787],,{768:7962,769:7964}],7961:[[917,788],,{768:7963,769:7965}],7962:[[7960,768]],7963:[[7961,768]],7964:[[7960,769]],7965:[[7961,769]],7968:[[951,787],,{768:7970,769:7972,834:7974,837:8080}],7969:[[951,788],,{768:7971,769:7973,834:7975,837:8081}],7970:[[7968,768],,{837:8082}],7971:[[7969,768],,{837:8083}],7972:[[7968,769],,{837:8084}],7973:[[7969,769],,{837:8085}],7974:[[7968,834],,{837:8086}],7975:[[7969,834],,{837:8087}],7976:[[919,787],,{768:7978,769:7980,834:7982,837:8088}],7977:[[919,788],,{768:7979,769:7981,834:7983,837:8089}],7978:[[7976,768],,{837:8090}],7979:[[7977,768],,{837:8091}],7980:[[7976,769],,{837:8092}],7981:[[7977,769],,{837:8093}],7982:[[7976,834],,{837:8094}],7983:[[7977,834],,{837:8095}],7984:[[953,787],,{768:7986,769:7988,834:7990}],7985:[[953,788],,{768:7987,769:7989,834:7991}],7986:[[7984,768]],7987:[[7985,768]],7988:[[7984,769]],7989:[[7985,769]],7990:[[7984,834]],7991:[[7985,834]],7992:[[921,787],,{768:7994,769:7996,834:7998}],7993:[[921,788],,{768:7995,769:7997,834:7999}],7994:[[7992,768]],7995:[[7993,768]],7996:[[7992,769]],7997:[[7993,769]],7998:[[7992,834]],7999:[[7993,834]],8000:[[959,787],,{768:8002,769:8004}],8001:[[959,788],,{768:8003,769:8005}],8002:[[8000,768]],8003:[[8001,768]],8004:[[8000,769]],8005:[[8001,769]],8008:[[927,787],,{768:8010,769:8012}],8009:[[927,788],,{768:8011,769:8013}],8010:[[8008,768]],8011:[[8009,768]],8012:[[8008,769]],8013:[[8009,769]],8016:[[965,787],,{768:8018,769:8020,834:8022}],8017:[[965,788],,{768:8019,769:8021,834:8023}],8018:[[8016,768]],8019:[[8017,768]],8020:[[8016,769]],8021:[[8017,769]],8022:[[8016,834]],8023:[[8017,834]],8025:[[933,788],,{768:8027,769:8029,834:8031}],8027:[[8025,768]],8029:[[8025,769]],8031:[[8025,834]],8032:[[969,787],,{768:8034,769:8036,834:8038,837:8096}],8033:[[969,788],,{768:8035,769:8037,834:8039,837:8097}],8034:[[8032,768],,{837:8098}],8035:[[8033,768],,{837:8099}],8036:[[8032,769],,{837:8100}],8037:[[8033,769],,{837:8101}],8038:[[8032,834],,{837:8102}],8039:[[8033,834],,{837:8103}],8040:[[937,787],,{768:8042,769:8044,834:8046,837:8104}],8041:[[937,788],,{768:8043,769:8045,834:8047,837:8105}],8042:[[8040,768],,{837:8106}],8043:[[8041,768],,{837:8107}],8044:[[8040,769],,{837:8108}],8045:[[8041,769],,{837:8109}],8046:[[8040,834],,{837:8110}],8047:[[8041,834],,{837:8111}],8048:[[945,768],,{837:8114}],8049:[[940]],8050:[[949,768]],8051:[[941]],8052:[[951,768],,{837:8130}],8053:[[942]],8054:[[953,768]],8055:[[943]],8056:[[959,768]],8057:[[972]],8058:[[965,768]],8059:[[973]],8060:[[969,768],,{837:8178}],8061:[[974]],8064:[[7936,837]],8065:[[7937,837]],8066:[[7938,837]],8067:[[7939,837]],8068:[[7940,837]],8069:[[7941,837]],8070:[[7942,837]],8071:[[7943,837]],8072:[[7944,837]],8073:[[7945,837]],8074:[[7946,837]],8075:[[7947,837]],8076:[[7948,837]],8077:[[7949,837]],8078:[[7950,837]],8079:[[7951,837]],8080:[[7968,837]],8081:[[7969,837]],8082:[[7970,837]],8083:[[7971,837]],8084:[[7972,837]],8085:[[7973,837]],8086:[[7974,837]],8087:[[7975,837]],8088:[[7976,837]],8089:[[7977,837]],8090:[[7978,837]],8091:[[7979,837]],8092:[[7980,837]],8093:[[7981,837]],8094:[[7982,837]],8095:[[7983,837]],8096:[[8032,837]],8097:[[8033,837]],8098:[[8034,837]],8099:[[8035,837]],8100:[[8036,837]],8101:[[8037,837]],8102:[[8038,837]],8103:[[8039,837]],8104:[[8040,837]],8105:[[8041,837]],8106:[[8042,837]],8107:[[8043,837]],8108:[[8044,837]],8109:[[8045,837]],8110:[[8046,837]],8111:[[8047,837]],8112:[[945,774]],8113:[[945,772]],8114:[[8048,837]],8115:[[945,837]],8116:[[940,837]],8118:[[945,834],,{837:8119}],8119:[[8118,837]],8120:[[913,774]],8121:[[913,772]],8122:[[913,768]],8123:[[902]],8124:[[913,837]],8125:[[32,787],256],8126:[[953]],8127:[[32,787],256,{768:8141,769:8142,834:8143}],8128:[[32,834],256],8129:[[168,834]],8130:[[8052,837]],8131:[[951,837]],8132:[[942,837]],8134:[[951,834],,{837:8135}],8135:[[8134,837]],8136:[[917,768]],8137:[[904]],8138:[[919,768]],8139:[[905]],8140:[[919,837]],8141:[[8127,768]],8142:[[8127,769]],8143:[[8127,834]],8144:[[953,774]],8145:[[953,772]],8146:[[970,768]],8147:[[912]],8150:[[953,834]],8151:[[970,834]],8152:[[921,774]],8153:[[921,772]],8154:[[921,768]],8155:[[906]],8157:[[8190,768]],8158:[[8190,769]],8159:[[8190,834]],8160:[[965,774]],8161:[[965,772]],8162:[[971,768]],8163:[[944]],8164:[[961,787]],8165:[[961,788]],8166:[[965,834]],8167:[[971,834]],8168:[[933,774]],8169:[[933,772]],8170:[[933,768]],8171:[[910]],8172:[[929,788]],8173:[[168,768]],8174:[[901]],8175:[[96]],8178:[[8060,837]],8179:[[969,837]],8180:[[974,837]],8182:[[969,834],,{837:8183}],8183:[[8182,837]],8184:[[927,768]],8185:[[908]],8186:[[937,768]],8187:[[911]],8188:[[937,837]],8189:[[180]],8190:[[32,788],256,{768:8157,769:8158,834:8159}]},
8192:{8192:[[8194]],8193:[[8195]],8194:[[32],256],8195:[[32],256],8196:[[32],256],8197:[[32],256],8198:[[32],256],8199:[[32],256],8200:[[32],256],8201:[[32],256],8202:[[32],256],8209:[[8208],256],8215:[[32,819],256],8228:[[46],256],8229:[[46,46],256],8230:[[46,46,46],256],8239:[[32],256],8243:[[8242,8242],256],8244:[[8242,8242,8242],256],8246:[[8245,8245],256],8247:[[8245,8245,8245],256],8252:[[33,33],256],8254:[[32,773],256],8263:[[63,63],256],8264:[[63,33],256],8265:[[33,63],256],8279:[[8242,8242,8242,8242],256],8287:[[32],256],8304:[[48],256],8305:[[105],256],8308:[[52],256],8309:[[53],256],8310:[[54],256],8311:[[55],256],8312:[[56],256],8313:[[57],256],8314:[[43],256],8315:[[8722],256],8316:[[61],256],8317:[[40],256],8318:[[41],256],8319:[[110],256],8320:[[48],256],8321:[[49],256],8322:[[50],256],8323:[[51],256],8324:[[52],256],8325:[[53],256],8326:[[54],256],8327:[[55],256],8328:[[56],256],8329:[[57],256],8330:[[43],256],8331:[[8722],256],8332:[[61],256],8333:[[40],256],8334:[[41],256],8336:[[97],256],8337:[[101],256],8338:[[111],256],8339:[[120],256],8340:[[601],256],8341:[[104],256],8342:[[107],256],8343:[[108],256],8344:[[109],256],8345:[[110],256],8346:[[112],256],8347:[[115],256],8348:[[116],256],8360:[[82,115],256],8400:[,230],8401:[,230],8402:[,1],8403:[,1],8404:[,230],8405:[,230],8406:[,230],8407:[,230],8408:[,1],8409:[,1],8410:[,1],8411:[,230],8412:[,230],8417:[,230],8421:[,1],8422:[,1],8423:[,230],8424:[,220],8425:[,230],8426:[,1],8427:[,1],8428:[,220],8429:[,220],8430:[,220],8431:[,220],8432:[,230]},
8448:{8448:[[97,47,99],256],8449:[[97,47,115],256],8450:[[67],256],8451:[[176,67],256],8453:[[99,47,111],256],8454:[[99,47,117],256],8455:[[400],256],8457:[[176,70],256],8458:[[103],256],8459:[[72],256],8460:[[72],256],8461:[[72],256],8462:[[104],256],8463:[[295],256],8464:[[73],256],8465:[[73],256],8466:[[76],256],8467:[[108],256],8469:[[78],256],8470:[[78,111],256],8473:[[80],256],8474:[[81],256],8475:[[82],256],8476:[[82],256],8477:[[82],256],8480:[[83,77],256],8481:[[84,69,76],256],8482:[[84,77],256],8484:[[90],256],8486:[[937]],8488:[[90],256],8490:[[75]],8491:[[197]],8492:[[66],256],8493:[[67],256],8495:[[101],256],8496:[[69],256],8497:[[70],256],8499:[[77],256],8500:[[111],256],8501:[[1488],256],8502:[[1489],256],8503:[[1490],256],8504:[[1491],256],8505:[[105],256],8507:[[70,65,88],256],8508:[[960],256],8509:[[947],256],8510:[[915],256],8511:[[928],256],8512:[[8721],256],8517:[[68],256],8518:[[100],256],8519:[[101],256],8520:[[105],256],8521:[[106],256],8528:[[49,8260,55],256],8529:[[49,8260,57],256],8530:[[49,8260,49,48],256],8531:[[49,8260,51],256],8532:[[50,8260,51],256],8533:[[49,8260,53],256],8534:[[50,8260,53],256],8535:[[51,8260,53],256],8536:[[52,8260,53],256],8537:[[49,8260,54],256],8538:[[53,8260,54],256],8539:[[49,8260,56],256],8540:[[51,8260,56],256],8541:[[53,8260,56],256],8542:[[55,8260,56],256],8543:[[49,8260],256],8544:[[73],256],8545:[[73,73],256],8546:[[73,73,73],256],8547:[[73,86],256],8548:[[86],256],8549:[[86,73],256],8550:[[86,73,73],256],8551:[[86,73,73,73],256],8552:[[73,88],256],8553:[[88],256],8554:[[88,73],256],8555:[[88,73,73],256],8556:[[76],256],8557:[[67],256],8558:[[68],256],8559:[[77],256],8560:[[105],256],8561:[[105,105],256],8562:[[105,105,105],256],8563:[[105,118],256],8564:[[118],256],8565:[[118,105],256],8566:[[118,105,105],256],8567:[[118,105,105,105],256],8568:[[105,120],256],8569:[[120],256],8570:[[120,105],256],8571:[[120,105,105],256],8572:[[108],256],8573:[[99],256],8574:[[100],256],8575:[[109],256],8585:[[48,8260,51],256],8592:[,,{824:8602}],8594:[,,{824:8603}],8596:[,,{824:8622}],8602:[[8592,824]],8603:[[8594,824]],8622:[[8596,824]],8653:[[8656,824]],8654:[[8660,824]],8655:[[8658,824]],8656:[,,{824:8653}],8658:[,,{824:8655}],8660:[,,{824:8654}]},
8704:{8707:[,,{824:8708}],8708:[[8707,824]],8712:[,,{824:8713}],8713:[[8712,824]],8715:[,,{824:8716}],8716:[[8715,824]],8739:[,,{824:8740}],8740:[[8739,824]],8741:[,,{824:8742}],8742:[[8741,824]],8748:[[8747,8747],256],8749:[[8747,8747,8747],256],8751:[[8750,8750],256],8752:[[8750,8750,8750],256],8764:[,,{824:8769}],8769:[[8764,824]],8771:[,,{824:8772}],8772:[[8771,824]],8773:[,,{824:8775}],8775:[[8773,824]],8776:[,,{824:8777}],8777:[[8776,824]],8781:[,,{824:8813}],8800:[[61,824]],8801:[,,{824:8802}],8802:[[8801,824]],8804:[,,{824:8816}],8805:[,,{824:8817}],8813:[[8781,824]],8814:[[60,824]],8815:[[62,824]],8816:[[8804,824]],8817:[[8805,824]],8818:[,,{824:8820}],8819:[,,{824:8821}],8820:[[8818,824]],8821:[[8819,824]],8822:[,,{824:8824}],8823:[,,{824:8825}],8824:[[8822,824]],8825:[[8823,824]],8826:[,,{824:8832}],8827:[,,{824:8833}],8828:[,,{824:8928}],8829:[,,{824:8929}],8832:[[8826,824]],8833:[[8827,824]],8834:[,,{824:8836}],8835:[,,{824:8837}],8836:[[8834,824]],8837:[[8835,824]],8838:[,,{824:8840}],8839:[,,{824:8841}],8840:[[8838,824]],8841:[[8839,824]],8849:[,,{824:8930}],8850:[,,{824:8931}],8866:[,,{824:8876}],8872:[,,{824:8877}],8873:[,,{824:8878}],8875:[,,{824:8879}],8876:[[8866,824]],8877:[[8872,824]],8878:[[8873,824]],8879:[[8875,824]],8882:[,,{824:8938}],8883:[,,{824:8939}],8884:[,,{824:8940}],8885:[,,{824:8941}],8928:[[8828,824]],8929:[[8829,824]],8930:[[8849,824]],8931:[[8850,824]],8938:[[8882,824]],8939:[[8883,824]],8940:[[8884,824]],8941:[[8885,824]]},
8960:{9001:[[12296]],9002:[[12297]]},
9216:{9312:[[49],256],9313:[[50],256],9314:[[51],256],9315:[[52],256],9316:[[53],256],9317:[[54],256],9318:[[55],256],9319:[[56],256],9320:[[57],256],9321:[[49,48],256],9322:[[49,49],256],9323:[[49,50],256],9324:[[49,51],256],9325:[[49,52],256],9326:[[49,53],256],9327:[[49,54],256],9328:[[49,55],256],9329:[[49,56],256],9330:[[49,57],256],9331:[[50,48],256],9332:[[40,49,41],256],9333:[[40,50,41],256],9334:[[40,51,41],256],9335:[[40,52,41],256],9336:[[40,53,41],256],9337:[[40,54,41],256],9338:[[40,55,41],256],9339:[[40,56,41],256],9340:[[40,57,41],256],9341:[[40,49,48,41],256],9342:[[40,49,49,41],256],9343:[[40,49,50,41],256],9344:[[40,49,51,41],256],9345:[[40,49,52,41],256],9346:[[40,49,53,41],256],9347:[[40,49,54,41],256],9348:[[40,49,55,41],256],9349:[[40,49,56,41],256],9350:[[40,49,57,41],256],9351:[[40,50,48,41],256],9352:[[49,46],256],9353:[[50,46],256],9354:[[51,46],256],9355:[[52,46],256],9356:[[53,46],256],9357:[[54,46],256],9358:[[55,46],256],9359:[[56,46],256],9360:[[57,46],256],9361:[[49,48,46],256],9362:[[49,49,46],256],9363:[[49,50,46],256],9364:[[49,51,46],256],9365:[[49,52,46],256],9366:[[49,53,46],256],9367:[[49,54,46],256],9368:[[49,55,46],256],9369:[[49,56,46],256],9370:[[49,57,46],256],9371:[[50,48,46],256],9372:[[40,97,41],256],9373:[[40,98,41],256],9374:[[40,99,41],256],9375:[[40,100,41],256],9376:[[40,101,41],256],9377:[[40,102,41],256],9378:[[40,103,41],256],9379:[[40,104,41],256],9380:[[40,105,41],256],9381:[[40,106,41],256],9382:[[40,107,41],256],9383:[[40,108,41],256],9384:[[40,109,41],256],9385:[[40,110,41],256],9386:[[40,111,41],256],9387:[[40,112,41],256],9388:[[40,113,41],256],9389:[[40,114,41],256],9390:[[40,115,41],256],9391:[[40,116,41],256],9392:[[40,117,41],256],9393:[[40,118,41],256],9394:[[40,119,41],256],9395:[[40,120,41],256],9396:[[40,121,41],256],9397:[[40,122,41],256],9398:[[65],256],9399:[[66],256],9400:[[67],256],9401:[[68],256],9402:[[69],256],9403:[[70],256],9404:[[71],256],9405:[[72],256],9406:[[73],256],9407:[[74],256],9408:[[75],256],9409:[[76],256],9410:[[77],256],9411:[[78],256],9412:[[79],256],9413:[[80],256],9414:[[81],256],9415:[[82],256],9416:[[83],256],9417:[[84],256],9418:[[85],256],9419:[[86],256],9420:[[87],256],9421:[[88],256],9422:[[89],256],9423:[[90],256],9424:[[97],256],9425:[[98],256],9426:[[99],256],9427:[[100],256],9428:[[101],256],9429:[[102],256],9430:[[103],256],9431:[[104],256],9432:[[105],256],9433:[[106],256],9434:[[107],256],9435:[[108],256],9436:[[109],256],9437:[[110],256],9438:[[111],256],9439:[[112],256],9440:[[113],256],9441:[[114],256],9442:[[115],256],9443:[[116],256],9444:[[117],256],9445:[[118],256],9446:[[119],256],9447:[[120],256],9448:[[121],256],9449:[[122],256],9450:[[48],256]},
10752:{10764:[[8747,8747,8747,8747],256],10868:[[58,58,61],256],10869:[[61,61],256],10870:[[61,61,61],256],10972:[[10973,824],512]},
11264:{11388:[[106],256],11389:[[86],256],11503:[,230],11504:[,230],11505:[,230]},
11520:{11631:[[11617],256],11647:[,9],11744:[,230],11745:[,230],11746:[,230],11747:[,230],11748:[,230],11749:[,230],11750:[,230],11751:[,230],11752:[,230],11753:[,230],11754:[,230],11755:[,230],11756:[,230],11757:[,230],11758:[,230],11759:[,230],11760:[,230],11761:[,230],11762:[,230],11763:[,230],11764:[,230],11765:[,230],11766:[,230],11767:[,230],11768:[,230],11769:[,230],11770:[,230],11771:[,230],11772:[,230],11773:[,230],11774:[,230],11775:[,230]},
11776:{11935:[[27597],256],12019:[[40863],256]},
12032:{12032:[[19968],256],12033:[[20008],256],12034:[[20022],256],12035:[[20031],256],12036:[[20057],256],12037:[[20101],256],12038:[[20108],256],12039:[[20128],256],12040:[[20154],256],12041:[[20799],256],12042:[[20837],256],12043:[[20843],256],12044:[[20866],256],12045:[[20886],256],12046:[[20907],256],12047:[[20960],256],12048:[[20981],256],12049:[[20992],256],12050:[[21147],256],12051:[[21241],256],12052:[[21269],256],12053:[[21274],256],12054:[[21304],256],12055:[[21313],256],12056:[[21340],256],12057:[[21353],256],12058:[[21378],256],12059:[[21430],256],12060:[[21448],256],12061:[[21475],256],12062:[[22231],256],12063:[[22303],256],12064:[[22763],256],12065:[[22786],256],12066:[[22794],256],12067:[[22805],256],12068:[[22823],256],12069:[[22899],256],12070:[[23376],256],12071:[[23424],256],12072:[[23544],256],12073:[[23567],256],12074:[[23586],256],12075:[[23608],256],12076:[[23662],256],12077:[[23665],256],12078:[[24027],256],12079:[[24037],256],12080:[[24049],256],12081:[[24062],256],12082:[[24178],256],12083:[[24186],256],12084:[[24191],256],12085:[[24308],256],12086:[[24318],256],12087:[[24331],256],12088:[[24339],256],12089:[[24400],256],12090:[[24417],256],12091:[[24435],256],12092:[[24515],256],12093:[[25096],256],12094:[[25142],256],12095:[[25163],256],12096:[[25903],256],12097:[[25908],256],12098:[[25991],256],12099:[[26007],256],12100:[[26020],256],12101:[[26041],256],12102:[[26080],256],12103:[[26085],256],12104:[[26352],256],12105:[[26376],256],12106:[[26408],256],12107:[[27424],256],12108:[[27490],256],12109:[[27513],256],12110:[[27571],256],12111:[[27595],256],12112:[[27604],256],12113:[[27611],256],12114:[[27663],256],12115:[[27668],256],12116:[[27700],256],12117:[[28779],256],12118:[[29226],256],12119:[[29238],256],12120:[[29243],256],12121:[[29247],256],12122:[[29255],256],12123:[[29273],256],12124:[[29275],256],12125:[[29356],256],12126:[[29572],256],12127:[[29577],256],12128:[[29916],256],12129:[[29926],256],12130:[[29976],256],12131:[[29983],256],12132:[[29992],256],12133:[[30000],256],12134:[[30091],256],12135:[[30098],256],12136:[[30326],256],12137:[[30333],256],12138:[[30382],256],12139:[[30399],256],12140:[[30446],256],12141:[[30683],256],12142:[[30690],256],12143:[[30707],256],12144:[[31034],256],12145:[[31160],256],12146:[[31166],256],12147:[[31348],256],12148:[[31435],256],12149:[[31481],256],12150:[[31859],256],12151:[[31992],256],12152:[[32566],256],12153:[[32593],256],12154:[[32650],256],12155:[[32701],256],12156:[[32769],256],12157:[[32780],256],12158:[[32786],256],12159:[[32819],256],12160:[[32895],256],12161:[[32905],256],12162:[[33251],256],12163:[[33258],256],12164:[[33267],256],12165:[[33276],256],12166:[[33292],256],12167:[[33307],256],12168:[[33311],256],12169:[[33390],256],12170:[[33394],256],12171:[[33400],256],12172:[[34381],256],12173:[[34411],256],12174:[[34880],256],12175:[[34892],256],12176:[[34915],256],12177:[[35198],256],12178:[[35211],256],12179:[[35282],256],12180:[[35328],256],12181:[[35895],256],12182:[[35910],256],12183:[[35925],256],12184:[[35960],256],12185:[[35997],256],12186:[[36196],256],12187:[[36208],256],12188:[[36275],256],12189:[[36523],256],12190:[[36554],256],12191:[[36763],256],12192:[[36784],256],12193:[[36789],256],12194:[[37009],256],12195:[[37193],256],12196:[[37318],256],12197:[[37324],256],12198:[[37329],256],12199:[[38263],256],12200:[[38272],256],12201:[[38428],256],12202:[[38582],256],12203:[[38585],256],12204:[[38632],256],12205:[[38737],256],12206:[[38750],256],12207:[[38754],256],12208:[[38761],256],12209:[[38859],256],12210:[[38893],256],12211:[[38899],256],12212:[[38913],256],12213:[[39080],256],12214:[[39131],256],12215:[[39135],256],12216:[[39318],256],12217:[[39321],256],12218:[[39340],256],12219:[[39592],256],12220:[[39640],256],12221:[[39647],256],12222:[[39717],256],12223:[[39727],256],12224:[[39730],256],12225:[[39740],256],12226:[[39770],256],12227:[[40165],256],12228:[[40565],256],12229:[[40575],256],12230:[[40613],256],12231:[[40635],256],12232:[[40643],256],12233:[[40653],256],12234:[[40657],256],12235:[[40697],256],12236:[[40701],256],12237:[[40718],256],12238:[[40723],256],12239:[[40736],256],12240:[[40763],256],12241:[[40778],256],12242:[[40786],256],12243:[[40845],256],12244:[[40860],256],12245:[[40864],256]},
12288:{12288:[[32],256],12330:[,218],12331:[,228],12332:[,232],12333:[,222],12334:[,224],12335:[,224],12342:[[12306],256],12344:[[21313],256],12345:[[21316],256],12346:[[21317],256],12358:[,,{12441:12436}],12363:[,,{12441:12364}],12364:[[12363,12441]],12365:[,,{12441:12366}],12366:[[12365,12441]],12367:[,,{12441:12368}],12368:[[12367,12441]],12369:[,,{12441:12370}],12370:[[12369,12441]],12371:[,,{12441:12372}],12372:[[12371,12441]],12373:[,,{12441:12374}],12374:[[12373,12441]],12375:[,,{12441:12376}],12376:[[12375,12441]],12377:[,,{12441:12378}],12378:[[12377,12441]],12379:[,,{12441:12380}],12380:[[12379,12441]],12381:[,,{12441:12382}],12382:[[12381,12441]],12383:[,,{12441:12384}],12384:[[12383,12441]],12385:[,,{12441:12386}],12386:[[12385,12441]],12388:[,,{12441:12389}],12389:[[12388,12441]],12390:[,,{12441:12391}],12391:[[12390,12441]],12392:[,,{12441:12393}],12393:[[12392,12441]],12399:[,,{12441:12400,12442:12401}],12400:[[12399,12441]],12401:[[12399,12442]],12402:[,,{12441:12403,12442:12404}],12403:[[12402,12441]],12404:[[12402,12442]],12405:[,,{12441:12406,12442:12407}],12406:[[12405,12441]],12407:[[12405,12442]],12408:[,,{12441:12409,12442:12410}],12409:[[12408,12441]],12410:[[12408,12442]],12411:[,,{12441:12412,12442:12413}],12412:[[12411,12441]],12413:[[12411,12442]],12436:[[12358,12441]],12441:[,8],12442:[,8],12443:[[32,12441],256],12444:[[32,12442],256],12445:[,,{12441:12446}],12446:[[12445,12441]],12447:[[12424,12426],256],12454:[,,{12441:12532}],12459:[,,{12441:12460}],12460:[[12459,12441]],12461:[,,{12441:12462}],12462:[[12461,12441]],12463:[,,{12441:12464}],12464:[[12463,12441]],12465:[,,{12441:12466}],12466:[[12465,12441]],12467:[,,{12441:12468}],12468:[[12467,12441]],12469:[,,{12441:12470}],12470:[[12469,12441]],12471:[,,{12441:12472}],12472:[[12471,12441]],12473:[,,{12441:12474}],12474:[[12473,12441]],12475:[,,{12441:12476}],12476:[[12475,12441]],12477:[,,{12441:12478}],12478:[[12477,12441]],12479:[,,{12441:12480}],12480:[[12479,12441]],12481:[,,{12441:12482}],12482:[[12481,12441]],12484:[,,{12441:12485}],12485:[[12484,12441]],12486:[,,{12441:12487}],12487:[[12486,12441]],12488:[,,{12441:12489}],12489:[[12488,12441]],12495:[,,{12441:12496,12442:12497}],12496:[[12495,12441]],12497:[[12495,12442]],12498:[,,{12441:12499,12442:12500}],12499:[[12498,12441]],12500:[[12498,12442]],12501:[,,{12441:12502,12442:12503}],12502:[[12501,12441]],12503:[[12501,12442]],12504:[,,{12441:12505,12442:12506}],12505:[[12504,12441]],12506:[[12504,12442]],12507:[,,{12441:12508,12442:12509}],12508:[[12507,12441]],12509:[[12507,12442]],12527:[,,{12441:12535}],12528:[,,{12441:12536}],12529:[,,{12441:12537}],12530:[,,{12441:12538}],12532:[[12454,12441]],12535:[[12527,12441]],12536:[[12528,12441]],12537:[[12529,12441]],12538:[[12530,12441]],12541:[,,{12441:12542}],12542:[[12541,12441]],12543:[[12467,12488],256]},
12544:{12593:[[4352],256],12594:[[4353],256],12595:[[4522],256],12596:[[4354],256],12597:[[4524],256],12598:[[4525],256],12599:[[4355],256],12600:[[4356],256],12601:[[4357],256],12602:[[4528],256],12603:[[4529],256],12604:[[4530],256],12605:[[4531],256],12606:[[4532],256],12607:[[4533],256],12608:[[4378],256],12609:[[4358],256],12610:[[4359],256],12611:[[4360],256],12612:[[4385],256],12613:[[4361],256],12614:[[4362],256],12615:[[4363],256],12616:[[4364],256],12617:[[4365],256],12618:[[4366],256],12619:[[4367],256],12620:[[4368],256],12621:[[4369],256],12622:[[4370],256],12623:[[4449],256],12624:[[4450],256],12625:[[4451],256],12626:[[4452],256],12627:[[4453],256],12628:[[4454],256],12629:[[4455],256],12630:[[4456],256],12631:[[4457],256],12632:[[4458],256],12633:[[4459],256],12634:[[4460],256],12635:[[4461],256],12636:[[4462],256],12637:[[4463],256],12638:[[4464],256],12639:[[4465],256],12640:[[4466],256],12641:[[4467],256],12642:[[4468],256],12643:[[4469],256],12644:[[4448],256],12645:[[4372],256],12646:[[4373],256],12647:[[4551],256],12648:[[4552],256],12649:[[4556],256],12650:[[4558],256],12651:[[4563],256],12652:[[4567],256],12653:[[4569],256],12654:[[4380],256],12655:[[4573],256],12656:[[4575],256],12657:[[4381],256],12658:[[4382],256],12659:[[4384],256],12660:[[4386],256],12661:[[4387],256],12662:[[4391],256],12663:[[4393],256],12664:[[4395],256],12665:[[4396],256],12666:[[4397],256],12667:[[4398],256],12668:[[4399],256],12669:[[4402],256],12670:[[4406],256],12671:[[4416],256],12672:[[4423],256],12673:[[4428],256],12674:[[4593],256],12675:[[4594],256],12676:[[4439],256],12677:[[4440],256],12678:[[4441],256],12679:[[4484],256],12680:[[4485],256],12681:[[4488],256],12682:[[4497],256],12683:[[4498],256],12684:[[4500],256],12685:[[4510],256],12686:[[4513],256],12690:[[19968],256],12691:[[20108],256],12692:[[19977],256],12693:[[22235],256],12694:[[19978],256],12695:[[20013],256],12696:[[19979],256],12697:[[30002],256],12698:[[20057],256],12699:[[19993],256],12700:[[19969],256],12701:[[22825],256],12702:[[22320],256],12703:[[20154],256]},
12800:{12800:[[40,4352,41],256],12801:[[40,4354,41],256],12802:[[40,4355,41],256],12803:[[40,4357,41],256],12804:[[40,4358,41],256],12805:[[40,4359,41],256],12806:[[40,4361,41],256],12807:[[40,4363,41],256],12808:[[40,4364,41],256],12809:[[40,4366,41],256],12810:[[40,4367,41],256],12811:[[40,4368,41],256],12812:[[40,4369,41],256],12813:[[40,4370,41],256],12814:[[40,4352,4449,41],256],12815:[[40,4354,4449,41],256],12816:[[40,4355,4449,41],256],12817:[[40,4357,4449,41],256],12818:[[40,4358,4449,41],256],12819:[[40,4359,4449,41],256],12820:[[40,4361,4449,41],256],12821:[[40,4363,4449,41],256],12822:[[40,4364,4449,41],256],12823:[[40,4366,4449,41],256],12824:[[40,4367,4449,41],256],12825:[[40,4368,4449,41],256],12826:[[40,4369,4449,41],256],12827:[[40,4370,4449,41],256],12828:[[40,4364,4462,41],256],12829:[[40,4363,4457,4364,4453,4523,41],256],12830:[[40,4363,4457,4370,4462,41],256],12832:[[40,19968,41],256],12833:[[40,20108,41],256],12834:[[40,19977,41],256],12835:[[40,22235,41],256],12836:[[40,20116,41],256],12837:[[40,20845,41],256],12838:[[40,19971,41],256],12839:[[40,20843,41],256],12840:[[40,20061,41],256],12841:[[40,21313,41],256],12842:[[40,26376,41],256],12843:[[40,28779,41],256],12844:[[40,27700,41],256],12845:[[40,26408,41],256],12846:[[40,37329,41],256],12847:[[40,22303,41],256],12848:[[40,26085,41],256],12849:[[40,26666,41],256],12850:[[40,26377,41],256],12851:[[40,31038,41],256],12852:[[40,21517,41],256],12853:[[40,29305,41],256],12854:[[40,36001,41],256],12855:[[40,31069,41],256],12856:[[40,21172,41],256],12857:[[40,20195,41],256],12858:[[40,21628,41],256],12859:[[40,23398,41],256],12860:[[40,30435,41],256],12861:[[40,20225,41],256],12862:[[40,36039,41],256],12863:[[40,21332,41],256],12864:[[40,31085,41],256],12865:[[40,20241,41],256],12866:[[40,33258,41],256],12867:[[40,33267,41],256],12868:[[21839],256],12869:[[24188],256],12870:[[25991],256],12871:[[31631],256],12880:[[80,84,69],256],12881:[[50,49],256],12882:[[50,50],256],12883:[[50,51],256],12884:[[50,52],256],12885:[[50,53],256],12886:[[50,54],256],12887:[[50,55],256],12888:[[50,56],256],12889:[[50,57],256],12890:[[51,48],256],12891:[[51,49],256],12892:[[51,50],256],12893:[[51,51],256],12894:[[51,52],256],12895:[[51,53],256],12896:[[4352],256],12897:[[4354],256],12898:[[4355],256],12899:[[4357],256],12900:[[4358],256],12901:[[4359],256],12902:[[4361],256],12903:[[4363],256],12904:[[4364],256],12905:[[4366],256],12906:[[4367],256],12907:[[4368],256],12908:[[4369],256],12909:[[4370],256],12910:[[4352,4449],256],12911:[[4354,4449],256],12912:[[4355,4449],256],12913:[[4357,4449],256],12914:[[4358,4449],256],12915:[[4359,4449],256],12916:[[4361,4449],256],12917:[[4363,4449],256],12918:[[4364,4449],256],12919:[[4366,4449],256],12920:[[4367,4449],256],12921:[[4368,4449],256],12922:[[4369,4449],256],12923:[[4370,4449],256],12924:[[4366,4449,4535,4352,4457],256],12925:[[4364,4462,4363,4468],256],12926:[[4363,4462],256],12928:[[19968],256],12929:[[20108],256],12930:[[19977],256],12931:[[22235],256],12932:[[20116],256],12933:[[20845],256],12934:[[19971],256],12935:[[20843],256],12936:[[20061],256],12937:[[21313],256],12938:[[26376],256],12939:[[28779],256],12940:[[27700],256],12941:[[26408],256],12942:[[37329],256],12943:[[22303],256],12944:[[26085],256],12945:[[26666],256],12946:[[26377],256],12947:[[31038],256],12948:[[21517],256],12949:[[29305],256],12950:[[36001],256],12951:[[31069],256],12952:[[21172],256],12953:[[31192],256],12954:[[30007],256],12955:[[22899],256],12956:[[36969],256],12957:[[20778],256],12958:[[21360],256],12959:[[27880],256],12960:[[38917],256],12961:[[20241],256],12962:[[20889],256],12963:[[27491],256],12964:[[19978],256],12965:[[20013],256],12966:[[19979],256],12967:[[24038],256],12968:[[21491],256],12969:[[21307],256],12970:[[23447],256],12971:[[23398],256],12972:[[30435],256],12973:[[20225],256],12974:[[36039],256],12975:[[21332],256],12976:[[22812],256],12977:[[51,54],256],12978:[[51,55],256],12979:[[51,56],256],12980:[[51,57],256],12981:[[52,48],256],12982:[[52,49],256],12983:[[52,50],256],12984:[[52,51],256],12985:[[52,52],256],12986:[[52,53],256],12987:[[52,54],256],12988:[[52,55],256],12989:[[52,56],256],12990:[[52,57],256],12991:[[53,48],256],12992:[[49,26376],256],12993:[[50,26376],256],12994:[[51,26376],256],12995:[[52,26376],256],12996:[[53,26376],256],12997:[[54,26376],256],12998:[[55,26376],256],12999:[[56,26376],256],13000:[[57,26376],256],13001:[[49,48,26376],256],13002:[[49,49,26376],256],13003:[[49,50,26376],256],13004:[[72,103],256],13005:[[101,114,103],256],13006:[[101,86],256],13007:[[76,84,68],256],13008:[[12450],256],13009:[[12452],256],13010:[[12454],256],13011:[[12456],256],13012:[[12458],256],13013:[[12459],256],13014:[[12461],256],13015:[[12463],256],13016:[[12465],256],13017:[[12467],256],13018:[[12469],256],13019:[[12471],256],13020:[[12473],256],13021:[[12475],256],13022:[[12477],256],13023:[[12479],256],13024:[[12481],256],13025:[[12484],256],13026:[[12486],256],13027:[[12488],256],13028:[[12490],256],13029:[[12491],256],13030:[[12492],256],13031:[[12493],256],13032:[[12494],256],13033:[[12495],256],13034:[[12498],256],13035:[[12501],256],13036:[[12504],256],13037:[[12507],256],13038:[[12510],256],13039:[[12511],256],13040:[[12512],256],13041:[[12513],256],13042:[[12514],256],13043:[[12516],256],13044:[[12518],256],13045:[[12520],256],13046:[[12521],256],13047:[[12522],256],13048:[[12523],256],13049:[[12524],256],13050:[[12525],256],13051:[[12527],256],13052:[[12528],256],13053:[[12529],256],13054:[[12530],256]},
13056:{13056:[[12450,12497,12540,12488],256],13057:[[12450,12523,12501,12449],256],13058:[[12450,12531,12506,12450],256],13059:[[12450,12540,12523],256],13060:[[12452,12491,12531,12464],256],13061:[[12452,12531,12481],256],13062:[[12454,12457,12531],256],13063:[[12456,12473,12463,12540,12489],256],13064:[[12456,12540,12459,12540],256],13065:[[12458,12531,12473],256],13066:[[12458,12540,12512],256],13067:[[12459,12452,12522],256],13068:[[12459,12521,12483,12488],256],13069:[[12459,12525,12522,12540],256],13070:[[12460,12525,12531],256],13071:[[12460,12531,12510],256],13072:[[12462,12460],256],13073:[[12462,12491,12540],256],13074:[[12461,12517,12522,12540],256],13075:[[12462,12523,12480,12540],256],13076:[[12461,12525],256],13077:[[12461,12525,12464,12521,12512],256],13078:[[12461,12525,12513,12540,12488,12523],256],13079:[[12461,12525,12527,12483,12488],256],13080:[[12464,12521,12512],256],13081:[[12464,12521,12512,12488,12531],256],13082:[[12463,12523,12476,12452,12525],256],13083:[[12463,12525,12540,12493],256],13084:[[12465,12540,12473],256],13085:[[12467,12523,12490],256],13086:[[12467,12540,12509],256],13087:[[12469,12452,12463,12523],256],13088:[[12469,12531,12481,12540,12512],256],13089:[[12471,12522,12531,12464],256],13090:[[12475,12531,12481],256],13091:[[12475,12531,12488],256],13092:[[12480,12540,12473],256],13093:[[12487,12471],256],13094:[[12489,12523],256],13095:[[12488,12531],256],13096:[[12490,12494],256],13097:[[12494,12483,12488],256],13098:[[12495,12452,12484],256],13099:[[12497,12540,12475,12531,12488],256],13100:[[12497,12540,12484],256],13101:[[12496,12540,12524,12523],256],13102:[[12500,12450,12473,12488,12523],256],13103:[[12500,12463,12523],256],13104:[[12500,12467],256],13105:[[12499,12523],256],13106:[[12501,12449,12521,12483,12489],256],13107:[[12501,12451,12540,12488],256],13108:[[12502,12483,12471,12455,12523],256],13109:[[12501,12521,12531],256],13110:[[12504,12463,12479,12540,12523],256],13111:[[12506,12477],256],13112:[[12506,12491,12498],256],13113:[[12504,12523,12484],256],13114:[[12506,12531,12473],256],13115:[[12506,12540,12472],256],13116:[[12505,12540,12479],256],13117:[[12509,12452,12531,12488],256],13118:[[12508,12523,12488],256],13119:[[12507,12531],256],13120:[[12509,12531,12489],256],13121:[[12507,12540,12523],256],13122:[[12507,12540,12531],256],13123:[[12510,12452,12463,12525],256],13124:[[12510,12452,12523],256],13125:[[12510,12483,12495],256],13126:[[12510,12523,12463],256],13127:[[12510,12531,12471,12519,12531],256],13128:[[12511,12463,12525,12531],256],13129:[[12511,12522],256],13130:[[12511,12522,12496,12540,12523],256],13131:[[12513,12460],256],13132:[[12513,12460,12488,12531],256],13133:[[12513,12540,12488,12523],256],13134:[[12516,12540,12489],256],13135:[[12516,12540,12523],256],13136:[[12518,12450,12531],256],13137:[[12522,12483,12488,12523],256],13138:[[12522,12521],256],13139:[[12523,12500,12540],256],13140:[[12523,12540,12502,12523],256],13141:[[12524,12512],256],13142:[[12524,12531,12488,12466,12531],256],13143:[[12527,12483,12488],256],13144:[[48,28857],256],13145:[[49,28857],256],13146:[[50,28857],256],13147:[[51,28857],256],13148:[[52,28857],256],13149:[[53,28857],256],13150:[[54,28857],256],13151:[[55,28857],256],13152:[[56,28857],256],13153:[[57,28857],256],13154:[[49,48,28857],256],13155:[[49,49,28857],256],13156:[[49,50,28857],256],13157:[[49,51,28857],256],13158:[[49,52,28857],256],13159:[[49,53,28857],256],13160:[[49,54,28857],256],13161:[[49,55,28857],256],13162:[[49,56,28857],256],13163:[[49,57,28857],256],13164:[[50,48,28857],256],13165:[[50,49,28857],256],13166:[[50,50,28857],256],13167:[[50,51,28857],256],13168:[[50,52,28857],256],13169:[[104,80,97],256],13170:[[100,97],256],13171:[[65,85],256],13172:[[98,97,114],256],13173:[[111,86],256],13174:[[112,99],256],13175:[[100,109],256],13176:[[100,109,178],256],13177:[[100,109,179],256],13178:[[73,85],256],13179:[[24179,25104],256],13180:[[26157,21644],256],13181:[[22823,27491],256],13182:[[26126,27835],256],13183:[[26666,24335,20250,31038],256],13184:[[112,65],256],13185:[[110,65],256],13186:[[956,65],256],13187:[[109,65],256],13188:[[107,65],256],13189:[[75,66],256],13190:[[77,66],256],13191:[[71,66],256],13192:[[99,97,108],256],13193:[[107,99,97,108],256],13194:[[112,70],256],13195:[[110,70],256],13196:[[956,70],256],13197:[[956,103],256],13198:[[109,103],256],13199:[[107,103],256],13200:[[72,122],256],13201:[[107,72,122],256],13202:[[77,72,122],256],13203:[[71,72,122],256],13204:[[84,72,122],256],13205:[[956,8467],256],13206:[[109,8467],256],13207:[[100,8467],256],13208:[[107,8467],256],13209:[[102,109],256],13210:[[110,109],256],13211:[[956,109],256],13212:[[109,109],256],13213:[[99,109],256],13214:[[107,109],256],13215:[[109,109,178],256],13216:[[99,109,178],256],13217:[[109,178],256],13218:[[107,109,178],256],13219:[[109,109,179],256],13220:[[99,109,179],256],13221:[[109,179],256],13222:[[107,109,179],256],13223:[[109,8725,115],256],13224:[[109,8725,115,178],256],13225:[[80,97],256],13226:[[107,80,97],256],13227:[[77,80,97],256],13228:[[71,80,97],256],13229:[[114,97,100],256],13230:[[114,97,100,8725,115],256],13231:[[114,97,100,8725,115,178],256],13232:[[112,115],256],13233:[[110,115],256],13234:[[956,115],256],13235:[[109,115],256],13236:[[112,86],256],13237:[[110,86],256],13238:[[956,86],256],13239:[[109,86],256],13240:[[107,86],256],13241:[[77,86],256],13242:[[112,87],256],13243:[[110,87],256],13244:[[956,87],256],13245:[[109,87],256],13246:[[107,87],256],13247:[[77,87],256],13248:[[107,937],256],13249:[[77,937],256],13250:[[97,46,109,46],256],13251:[[66,113],256],13252:[[99,99],256],13253:[[99,100],256],13254:[[67,8725,107,103],256],13255:[[67,111,46],256],13256:[[100,66],256],13257:[[71,121],256],13258:[[104,97],256],13259:[[72,80],256],13260:[[105,110],256],13261:[[75,75],256],13262:[[75,77],256],13263:[[107,116],256],13264:[[108,109],256],13265:[[108,110],256],13266:[[108,111,103],256],13267:[[108,120],256],13268:[[109,98],256],13269:[[109,105,108],256],13270:[[109,111,108],256],13271:[[80,72],256],13272:[[112,46,109,46],256],13273:[[80,80,77],256],13274:[[80,82],256],13275:[[115,114],256],13276:[[83,118],256],13277:[[87,98],256],13278:[[86,8725,109],256],13279:[[65,8725,109],256],13280:[[49,26085],256],13281:[[50,26085],256],13282:[[51,26085],256],13283:[[52,26085],256],13284:[[53,26085],256],13285:[[54,26085],256],13286:[[55,26085],256],13287:[[56,26085],256],13288:[[57,26085],256],13289:[[49,48,26085],256],13290:[[49,49,26085],256],13291:[[49,50,26085],256],13292:[[49,51,26085],256],13293:[[49,52,26085],256],13294:[[49,53,26085],256],13295:[[49,54,26085],256],13296:[[49,55,26085],256],13297:[[49,56,26085],256],13298:[[49,57,26085],256],13299:[[50,48,26085],256],13300:[[50,49,26085],256],13301:[[50,50,26085],256],13302:[[50,51,26085],256],13303:[[50,52,26085],256],13304:[[50,53,26085],256],13305:[[50,54,26085],256],13306:[[50,55,26085],256],13307:[[50,56,26085],256],13308:[[50,57,26085],256],13309:[[51,48,26085],256],13310:[[51,49,26085],256],13311:[[103,97,108],256]},
27136:{92912:[,1],92913:[,1],92914:[,1],92915:[,1],92916:[,1]},
27392:{92976:[,230],92977:[,230],92978:[,230],92979:[,230],92980:[,230],92981:[,230],92982:[,230]},
42496:{42607:[,230],42612:[,230],42613:[,230],42614:[,230],42615:[,230],42616:[,230],42617:[,230],42618:[,230],42619:[,230],42620:[,230],42621:[,230],42652:[[1098],256],42653:[[1100],256],42655:[,230],42736:[,230],42737:[,230]},
42752:{42864:[[42863],256],43000:[[294],256],43001:[[339],256]},
43008:{43014:[,9],43204:[,9],43232:[,230],43233:[,230],43234:[,230],43235:[,230],43236:[,230],43237:[,230],43238:[,230],43239:[,230],43240:[,230],43241:[,230],43242:[,230],43243:[,230],43244:[,230],43245:[,230],43246:[,230],43247:[,230],43248:[,230],43249:[,230]},
43264:{43307:[,220],43308:[,220],43309:[,220],43347:[,9],43443:[,7],43456:[,9]},
43520:{43696:[,230],43698:[,230],43699:[,230],43700:[,220],43703:[,230],43704:[,230],43710:[,230],43711:[,230],43713:[,230],43766:[,9]},
43776:{43868:[[42791],256],43869:[[43831],256],43870:[[619],256],43871:[[43858],256],44013:[,9]},
48128:{113822:[,1]},
53504:{119134:[[119127,119141],512],119135:[[119128,119141],512],119136:[[119135,119150],512],119137:[[119135,119151],512],119138:[[119135,119152],512],119139:[[119135,119153],512],119140:[[119135,119154],512],119141:[,216],119142:[,216],119143:[,1],119144:[,1],119145:[,1],119149:[,226],119150:[,216],119151:[,216],119152:[,216],119153:[,216],119154:[,216],119163:[,220],119164:[,220],119165:[,220],119166:[,220],119167:[,220],119168:[,220],119169:[,220],119170:[,220],119173:[,230],119174:[,230],119175:[,230],119176:[,230],119177:[,230],119178:[,220],119179:[,220],119210:[,230],119211:[,230],119212:[,230],119213:[,230],119227:[[119225,119141],512],119228:[[119226,119141],512],119229:[[119227,119150],512],119230:[[119228,119150],512],119231:[[119227,119151],512],119232:[[119228,119151],512]},
53760:{119362:[,230],119363:[,230],119364:[,230]},
54272:{119808:[[65],256],119809:[[66],256],119810:[[67],256],119811:[[68],256],119812:[[69],256],119813:[[70],256],119814:[[71],256],119815:[[72],256],119816:[[73],256],119817:[[74],256],119818:[[75],256],119819:[[76],256],119820:[[77],256],119821:[[78],256],119822:[[79],256],119823:[[80],256],119824:[[81],256],119825:[[82],256],119826:[[83],256],119827:[[84],256],119828:[[85],256],119829:[[86],256],119830:[[87],256],119831:[[88],256],119832:[[89],256],119833:[[90],256],119834:[[97],256],119835:[[98],256],119836:[[99],256],119837:[[100],256],119838:[[101],256],119839:[[102],256],119840:[[103],256],119841:[[104],256],119842:[[105],256],119843:[[106],256],119844:[[107],256],119845:[[108],256],119846:[[109],256],119847:[[110],256],119848:[[111],256],119849:[[112],256],119850:[[113],256],119851:[[114],256],119852:[[115],256],119853:[[116],256],119854:[[117],256],119855:[[118],256],119856:[[119],256],119857:[[120],256],119858:[[121],256],119859:[[122],256],119860:[[65],256],119861:[[66],256],119862:[[67],256],119863:[[68],256],119864:[[69],256],119865:[[70],256],119866:[[71],256],119867:[[72],256],119868:[[73],256],119869:[[74],256],119870:[[75],256],119871:[[76],256],119872:[[77],256],119873:[[78],256],119874:[[79],256],119875:[[80],256],119876:[[81],256],119877:[[82],256],119878:[[83],256],119879:[[84],256],119880:[[85],256],119881:[[86],256],119882:[[87],256],119883:[[88],256],119884:[[89],256],119885:[[90],256],119886:[[97],256],119887:[[98],256],119888:[[99],256],119889:[[100],256],119890:[[101],256],119891:[[102],256],119892:[[103],256],119894:[[105],256],119895:[[106],256],119896:[[107],256],119897:[[108],256],119898:[[109],256],119899:[[110],256],119900:[[111],256],119901:[[112],256],119902:[[113],256],119903:[[114],256],119904:[[115],256],119905:[[116],256],119906:[[117],256],119907:[[118],256],119908:[[119],256],119909:[[120],256],119910:[[121],256],119911:[[122],256],119912:[[65],256],119913:[[66],256],119914:[[67],256],119915:[[68],256],119916:[[69],256],119917:[[70],256],119918:[[71],256],119919:[[72],256],119920:[[73],256],119921:[[74],256],119922:[[75],256],119923:[[76],256],119924:[[77],256],119925:[[78],256],119926:[[79],256],119927:[[80],256],119928:[[81],256],119929:[[82],256],119930:[[83],256],119931:[[84],256],119932:[[85],256],119933:[[86],256],119934:[[87],256],119935:[[88],256],119936:[[89],256],119937:[[90],256],119938:[[97],256],119939:[[98],256],119940:[[99],256],119941:[[100],256],119942:[[101],256],119943:[[102],256],119944:[[103],256],119945:[[104],256],119946:[[105],256],119947:[[106],256],119948:[[107],256],119949:[[108],256],119950:[[109],256],119951:[[110],256],119952:[[111],256],119953:[[112],256],119954:[[113],256],119955:[[114],256],119956:[[115],256],119957:[[116],256],119958:[[117],256],119959:[[118],256],119960:[[119],256],119961:[[120],256],119962:[[121],256],119963:[[122],256],119964:[[65],256],119966:[[67],256],119967:[[68],256],119970:[[71],256],119973:[[74],256],119974:[[75],256],119977:[[78],256],119978:[[79],256],119979:[[80],256],119980:[[81],256],119982:[[83],256],119983:[[84],256],119984:[[85],256],119985:[[86],256],119986:[[87],256],119987:[[88],256],119988:[[89],256],119989:[[90],256],119990:[[97],256],119991:[[98],256],119992:[[99],256],119993:[[100],256],119995:[[102],256],119997:[[104],256],119998:[[105],256],119999:[[106],256],120000:[[107],256],120001:[[108],256],120002:[[109],256],120003:[[110],256],120005:[[112],256],120006:[[113],256],120007:[[114],256],120008:[[115],256],120009:[[116],256],120010:[[117],256],120011:[[118],256],120012:[[119],256],120013:[[120],256],120014:[[121],256],120015:[[122],256],120016:[[65],256],120017:[[66],256],120018:[[67],256],120019:[[68],256],120020:[[69],256],120021:[[70],256],120022:[[71],256],120023:[[72],256],120024:[[73],256],120025:[[74],256],120026:[[75],256],120027:[[76],256],120028:[[77],256],120029:[[78],256],120030:[[79],256],120031:[[80],256],120032:[[81],256],120033:[[82],256],120034:[[83],256],120035:[[84],256],120036:[[85],256],120037:[[86],256],120038:[[87],256],120039:[[88],256],120040:[[89],256],120041:[[90],256],120042:[[97],256],120043:[[98],256],120044:[[99],256],120045:[[100],256],120046:[[101],256],120047:[[102],256],120048:[[103],256],120049:[[104],256],120050:[[105],256],120051:[[106],256],120052:[[107],256],120053:[[108],256],120054:[[109],256],120055:[[110],256],120056:[[111],256],120057:[[112],256],120058:[[113],256],120059:[[114],256],120060:[[115],256],120061:[[116],256],120062:[[117],256],120063:[[118],256]},
54528:{120064:[[119],256],120065:[[120],256],120066:[[121],256],120067:[[122],256],120068:[[65],256],120069:[[66],256],120071:[[68],256],120072:[[69],256],120073:[[70],256],120074:[[71],256],120077:[[74],256],120078:[[75],256],120079:[[76],256],120080:[[77],256],120081:[[78],256],120082:[[79],256],120083:[[80],256],120084:[[81],256],120086:[[83],256],120087:[[84],256],120088:[[85],256],120089:[[86],256],120090:[[87],256],120091:[[88],256],120092:[[89],256],120094:[[97],256],120095:[[98],256],120096:[[99],256],120097:[[100],256],120098:[[101],256],120099:[[102],256],120100:[[103],256],120101:[[104],256],120102:[[105],256],120103:[[106],256],120104:[[107],256],120105:[[108],256],120106:[[109],256],120107:[[110],256],120108:[[111],256],120109:[[112],256],120110:[[113],256],120111:[[114],256],120112:[[115],256],120113:[[116],256],120114:[[117],256],120115:[[118],256],120116:[[119],256],120117:[[120],256],120118:[[121],256],120119:[[122],256],120120:[[65],256],120121:[[66],256],120123:[[68],256],120124:[[69],256],120125:[[70],256],120126:[[71],256],120128:[[73],256],120129:[[74],256],120130:[[75],256],120131:[[76],256],120132:[[77],256],120134:[[79],256],120138:[[83],256],120139:[[84],256],120140:[[85],256],120141:[[86],256],120142:[[87],256],120143:[[88],256],120144:[[89],256],120146:[[97],256],120147:[[98],256],120148:[[99],256],120149:[[100],256],120150:[[101],256],120151:[[102],256],120152:[[103],256],120153:[[104],256],120154:[[105],256],120155:[[106],256],120156:[[107],256],120157:[[108],256],120158:[[109],256],120159:[[110],256],120160:[[111],256],120161:[[112],256],120162:[[113],256],120163:[[114],256],120164:[[115],256],120165:[[116],256],120166:[[117],256],120167:[[118],256],120168:[[119],256],120169:[[120],256],120170:[[121],256],120171:[[122],256],120172:[[65],256],120173:[[66],256],120174:[[67],256],120175:[[68],256],120176:[[69],256],120177:[[70],256],120178:[[71],256],120179:[[72],256],120180:[[73],256],120181:[[74],256],120182:[[75],256],120183:[[76],256],120184:[[77],256],120185:[[78],256],120186:[[79],256],120187:[[80],256],120188:[[81],256],120189:[[82],256],120190:[[83],256],120191:[[84],256],120192:[[85],256],120193:[[86],256],120194:[[87],256],120195:[[88],256],120196:[[89],256],120197:[[90],256],120198:[[97],256],120199:[[98],256],120200:[[99],256],120201:[[100],256],120202:[[101],256],120203:[[102],256],120204:[[103],256],120205:[[104],256],120206:[[105],256],120207:[[106],256],120208:[[107],256],120209:[[108],256],120210:[[109],256],120211:[[110],256],120212:[[111],256],120213:[[112],256],120214:[[113],256],120215:[[114],256],120216:[[115],256],120217:[[116],256],120218:[[117],256],120219:[[118],256],120220:[[119],256],120221:[[120],256],120222:[[121],256],120223:[[122],256],120224:[[65],256],120225:[[66],256],120226:[[67],256],120227:[[68],256],120228:[[69],256],120229:[[70],256],120230:[[71],256],120231:[[72],256],120232:[[73],256],120233:[[74],256],120234:[[75],256],120235:[[76],256],120236:[[77],256],120237:[[78],256],120238:[[79],256],120239:[[80],256],120240:[[81],256],120241:[[82],256],120242:[[83],256],120243:[[84],256],120244:[[85],256],120245:[[86],256],120246:[[87],256],120247:[[88],256],120248:[[89],256],120249:[[90],256],120250:[[97],256],120251:[[98],256],120252:[[99],256],120253:[[100],256],120254:[[101],256],120255:[[102],256],120256:[[103],256],120257:[[104],256],120258:[[105],256],120259:[[106],256],120260:[[107],256],120261:[[108],256],120262:[[109],256],120263:[[110],256],120264:[[111],256],120265:[[112],256],120266:[[113],256],120267:[[114],256],120268:[[115],256],120269:[[116],256],120270:[[117],256],120271:[[118],256],120272:[[119],256],120273:[[120],256],120274:[[121],256],120275:[[122],256],120276:[[65],256],120277:[[66],256],120278:[[67],256],120279:[[68],256],120280:[[69],256],120281:[[70],256],120282:[[71],256],120283:[[72],256],120284:[[73],256],120285:[[74],256],120286:[[75],256],120287:[[76],256],120288:[[77],256],120289:[[78],256],120290:[[79],256],120291:[[80],256],120292:[[81],256],120293:[[82],256],120294:[[83],256],120295:[[84],256],120296:[[85],256],120297:[[86],256],120298:[[87],256],120299:[[88],256],120300:[[89],256],120301:[[90],256],120302:[[97],256],120303:[[98],256],120304:[[99],256],120305:[[100],256],120306:[[101],256],120307:[[102],256],120308:[[103],256],120309:[[104],256],120310:[[105],256],120311:[[106],256],120312:[[107],256],120313:[[108],256],120314:[[109],256],120315:[[110],256],120316:[[111],256],120317:[[112],256],120318:[[113],256],120319:[[114],256]},
54784:{120320:[[115],256],120321:[[116],256],120322:[[117],256],120323:[[118],256],120324:[[119],256],120325:[[120],256],120326:[[121],256],120327:[[122],256],120328:[[65],256],120329:[[66],256],120330:[[67],256],120331:[[68],256],120332:[[69],256],120333:[[70],256],120334:[[71],256],120335:[[72],256],120336:[[73],256],120337:[[74],256],120338:[[75],256],120339:[[76],256],120340:[[77],256],120341:[[78],256],120342:[[79],256],120343:[[80],256],120344:[[81],256],120345:[[82],256],120346:[[83],256],120347:[[84],256],120348:[[85],256],120349:[[86],256],120350:[[87],256],120351:[[88],256],120352:[[89],256],120353:[[90],256],120354:[[97],256],120355:[[98],256],120356:[[99],256],120357:[[100],256],120358:[[101],256],120359:[[102],256],120360:[[103],256],120361:[[104],256],120362:[[105],256],120363:[[106],256],120364:[[107],256],120365:[[108],256],120366:[[109],256],120367:[[110],256],120368:[[111],256],120369:[[112],256],120370:[[113],256],120371:[[114],256],120372:[[115],256],120373:[[116],256],120374:[[117],256],120375:[[118],256],120376:[[119],256],120377:[[120],256],120378:[[121],256],120379:[[122],256],120380:[[65],256],120381:[[66],256],120382:[[67],256],120383:[[68],256],120384:[[69],256],120385:[[70],256],120386:[[71],256],120387:[[72],256],120388:[[73],256],120389:[[74],256],120390:[[75],256],120391:[[76],256],120392:[[77],256],120393:[[78],256],120394:[[79],256],120395:[[80],256],120396:[[81],256],120397:[[82],256],120398:[[83],256],120399:[[84],256],120400:[[85],256],120401:[[86],256],120402:[[87],256],120403:[[88],256],120404:[[89],256],120405:[[90],256],120406:[[97],256],120407:[[98],256],120408:[[99],256],120409:[[100],256],120410:[[101],256],120411:[[102],256],120412:[[103],256],120413:[[104],256],120414:[[105],256],120415:[[106],256],120416:[[107],256],120417:[[108],256],120418:[[109],256],120419:[[110],256],120420:[[111],256],120421:[[112],256],120422:[[113],256],120423:[[114],256],120424:[[115],256],120425:[[116],256],120426:[[117],256],120427:[[118],256],120428:[[119],256],120429:[[120],256],120430:[[121],256],120431:[[122],256],120432:[[65],256],120433:[[66],256],120434:[[67],256],120435:[[68],256],120436:[[69],256],120437:[[70],256],120438:[[71],256],120439:[[72],256],120440:[[73],256],120441:[[74],256],120442:[[75],256],120443:[[76],256],120444:[[77],256],120445:[[78],256],120446:[[79],256],120447:[[80],256],120448:[[81],256],120449:[[82],256],120450:[[83],256],120451:[[84],256],120452:[[85],256],120453:[[86],256],120454:[[87],256],120455:[[88],256],120456:[[89],256],120457:[[90],256],120458:[[97],256],120459:[[98],256],120460:[[99],256],120461:[[100],256],120462:[[101],256],120463:[[102],256],120464:[[103],256],120465:[[104],256],120466:[[105],256],120467:[[106],256],120468:[[107],256],120469:[[108],256],120470:[[109],256],120471:[[110],256],120472:[[111],256],120473:[[112],256],120474:[[113],256],120475:[[114],256],120476:[[115],256],120477:[[116],256],120478:[[117],256],120479:[[118],256],120480:[[119],256],120481:[[120],256],120482:[[121],256],120483:[[122],256],120484:[[305],256],120485:[[567],256],120488:[[913],256],120489:[[914],256],120490:[[915],256],120491:[[916],256],120492:[[917],256],120493:[[918],256],120494:[[919],256],120495:[[920],256],120496:[[921],256],120497:[[922],256],120498:[[923],256],120499:[[924],256],120500:[[925],256],120501:[[926],256],120502:[[927],256],120503:[[928],256],120504:[[929],256],120505:[[1012],256],120506:[[931],256],120507:[[932],256],120508:[[933],256],120509:[[934],256],120510:[[935],256],120511:[[936],256],120512:[[937],256],120513:[[8711],256],120514:[[945],256],120515:[[946],256],120516:[[947],256],120517:[[948],256],120518:[[949],256],120519:[[950],256],120520:[[951],256],120521:[[952],256],120522:[[953],256],120523:[[954],256],120524:[[955],256],120525:[[956],256],120526:[[957],256],120527:[[958],256],120528:[[959],256],120529:[[960],256],120530:[[961],256],120531:[[962],256],120532:[[963],256],120533:[[964],256],120534:[[965],256],120535:[[966],256],120536:[[967],256],120537:[[968],256],120538:[[969],256],120539:[[8706],256],120540:[[1013],256],120541:[[977],256],120542:[[1008],256],120543:[[981],256],120544:[[1009],256],120545:[[982],256],120546:[[913],256],120547:[[914],256],120548:[[915],256],120549:[[916],256],120550:[[917],256],120551:[[918],256],120552:[[919],256],120553:[[920],256],120554:[[921],256],120555:[[922],256],120556:[[923],256],120557:[[924],256],120558:[[925],256],120559:[[926],256],120560:[[927],256],120561:[[928],256],120562:[[929],256],120563:[[1012],256],120564:[[931],256],120565:[[932],256],120566:[[933],256],120567:[[934],256],120568:[[935],256],120569:[[936],256],120570:[[937],256],120571:[[8711],256],120572:[[945],256],120573:[[946],256],120574:[[947],256],120575:[[948],256]},
55040:{120576:[[949],256],120577:[[950],256],120578:[[951],256],120579:[[952],256],120580:[[953],256],120581:[[954],256],120582:[[955],256],120583:[[956],256],120584:[[957],256],120585:[[958],256],120586:[[959],256],120587:[[960],256],120588:[[961],256],120589:[[962],256],120590:[[963],256],120591:[[964],256],120592:[[965],256],120593:[[966],256],120594:[[967],256],120595:[[968],256],120596:[[969],256],120597:[[8706],256],120598:[[1013],256],120599:[[977],256],120600:[[1008],256],120601:[[981],256],120602:[[1009],256],120603:[[982],256],120604:[[913],256],120605:[[914],256],120606:[[915],256],120607:[[916],256],120608:[[917],256],120609:[[918],256],120610:[[919],256],120611:[[920],256],120612:[[921],256],120613:[[922],256],120614:[[923],256],120615:[[924],256],120616:[[925],256],120617:[[926],256],120618:[[927],256],120619:[[928],256],120620:[[929],256],120621:[[1012],256],120622:[[931],256],120623:[[932],256],120624:[[933],256],120625:[[934],256],120626:[[935],256],120627:[[936],256],120628:[[937],256],120629:[[8711],256],120630:[[945],256],120631:[[946],256],120632:[[947],256],120633:[[948],256],120634:[[949],256],120635:[[950],256],120636:[[951],256],120637:[[952],256],120638:[[953],256],120639:[[954],256],120640:[[955],256],120641:[[956],256],120642:[[957],256],120643:[[958],256],120644:[[959],256],120645:[[960],256],120646:[[961],256],120647:[[962],256],120648:[[963],256],120649:[[964],256],120650:[[965],256],120651:[[966],256],120652:[[967],256],120653:[[968],256],120654:[[969],256],120655:[[8706],256],120656:[[1013],256],120657:[[977],256],120658:[[1008],256],120659:[[981],256],120660:[[1009],256],120661:[[982],256],120662:[[913],256],120663:[[914],256],120664:[[915],256],120665:[[916],256],120666:[[917],256],120667:[[918],256],120668:[[919],256],120669:[[920],256],120670:[[921],256],120671:[[922],256],120672:[[923],256],120673:[[924],256],120674:[[925],256],120675:[[926],256],120676:[[927],256],120677:[[928],256],120678:[[929],256],120679:[[1012],256],120680:[[931],256],120681:[[932],256],120682:[[933],256],120683:[[934],256],120684:[[935],256],120685:[[936],256],120686:[[937],256],120687:[[8711],256],120688:[[945],256],120689:[[946],256],120690:[[947],256],120691:[[948],256],120692:[[949],256],120693:[[950],256],120694:[[951],256],120695:[[952],256],120696:[[953],256],120697:[[954],256],120698:[[955],256],120699:[[956],256],120700:[[957],256],120701:[[958],256],120702:[[959],256],120703:[[960],256],120704:[[961],256],120705:[[962],256],120706:[[963],256],120707:[[964],256],120708:[[965],256],120709:[[966],256],120710:[[967],256],120711:[[968],256],120712:[[969],256],120713:[[8706],256],120714:[[1013],256],120715:[[977],256],120716:[[1008],256],120717:[[981],256],120718:[[1009],256],120719:[[982],256],120720:[[913],256],120721:[[914],256],120722:[[915],256],120723:[[916],256],120724:[[917],256],120725:[[918],256],120726:[[919],256],120727:[[920],256],120728:[[921],256],120729:[[922],256],120730:[[923],256],120731:[[924],256],120732:[[925],256],120733:[[926],256],120734:[[927],256],120735:[[928],256],120736:[[929],256],120737:[[1012],256],120738:[[931],256],120739:[[932],256],120740:[[933],256],120741:[[934],256],120742:[[935],256],120743:[[936],256],120744:[[937],256],120745:[[8711],256],120746:[[945],256],120747:[[946],256],120748:[[947],256],120749:[[948],256],120750:[[949],256],120751:[[950],256],120752:[[951],256],120753:[[952],256],120754:[[953],256],120755:[[954],256],120756:[[955],256],120757:[[956],256],120758:[[957],256],120759:[[958],256],120760:[[959],256],120761:[[960],256],120762:[[961],256],120763:[[962],256],120764:[[963],256],120765:[[964],256],120766:[[965],256],120767:[[966],256],120768:[[967],256],120769:[[968],256],120770:[[969],256],120771:[[8706],256],120772:[[1013],256],120773:[[977],256],120774:[[1008],256],120775:[[981],256],120776:[[1009],256],120777:[[982],256],120778:[[988],256],120779:[[989],256],120782:[[48],256],120783:[[49],256],120784:[[50],256],120785:[[51],256],120786:[[52],256],120787:[[53],256],120788:[[54],256],120789:[[55],256],120790:[[56],256],120791:[[57],256],120792:[[48],256],120793:[[49],256],120794:[[50],256],120795:[[51],256],120796:[[52],256],120797:[[53],256],120798:[[54],256],120799:[[55],256],120800:[[56],256],120801:[[57],256],120802:[[48],256],120803:[[49],256],120804:[[50],256],120805:[[51],256],120806:[[52],256],120807:[[53],256],120808:[[54],256],120809:[[55],256],120810:[[56],256],120811:[[57],256],120812:[[48],256],120813:[[49],256],120814:[[50],256],120815:[[51],256],120816:[[52],256],120817:[[53],256],120818:[[54],256],120819:[[55],256],120820:[[56],256],120821:[[57],256],120822:[[48],256],120823:[[49],256],120824:[[50],256],120825:[[51],256],120826:[[52],256],120827:[[53],256],120828:[[54],256],120829:[[55],256],120830:[[56],256],120831:[[57],256]},
59392:{125136:[,220],125137:[,220],125138:[,220],125139:[,220],125140:[,220],125141:[,220],125142:[,220]},
60928:{126464:[[1575],256],126465:[[1576],256],126466:[[1580],256],126467:[[1583],256],126469:[[1608],256],126470:[[1586],256],126471:[[1581],256],126472:[[1591],256],126473:[[1610],256],126474:[[1603],256],126475:[[1604],256],126476:[[1605],256],126477:[[1606],256],126478:[[1587],256],126479:[[1593],256],126480:[[1601],256],126481:[[1589],256],126482:[[1602],256],126483:[[1585],256],126484:[[1588],256],126485:[[1578],256],126486:[[1579],256],126487:[[1582],256],126488:[[1584],256],126489:[[1590],256],126490:[[1592],256],126491:[[1594],256],126492:[[1646],256],126493:[[1722],256],126494:[[1697],256],126495:[[1647],256],126497:[[1576],256],126498:[[1580],256],126500:[[1607],256],126503:[[1581],256],126505:[[1610],256],126506:[[1603],256],126507:[[1604],256],126508:[[1605],256],126509:[[1606],256],126510:[[1587],256],126511:[[1593],256],126512:[[1601],256],126513:[[1589],256],126514:[[1602],256],126516:[[1588],256],126517:[[1578],256],126518:[[1579],256],126519:[[1582],256],126521:[[1590],256],126523:[[1594],256],126530:[[1580],256],126535:[[1581],256],126537:[[1610],256],126539:[[1604],256],126541:[[1606],256],126542:[[1587],256],126543:[[1593],256],126545:[[1589],256],126546:[[1602],256],126548:[[1588],256],126551:[[1582],256],126553:[[1590],256],126555:[[1594],256],126557:[[1722],256],126559:[[1647],256],126561:[[1576],256],126562:[[1580],256],126564:[[1607],256],126567:[[1581],256],126568:[[1591],256],126569:[[1610],256],126570:[[1603],256],126572:[[1605],256],126573:[[1606],256],126574:[[1587],256],126575:[[1593],256],126576:[[1601],256],126577:[[1589],256],126578:[[1602],256],126580:[[1588],256],126581:[[1578],256],126582:[[1579],256],126583:[[1582],256],126585:[[1590],256],126586:[[1592],256],126587:[[1594],256],126588:[[1646],256],126590:[[1697],256],126592:[[1575],256],126593:[[1576],256],126594:[[1580],256],126595:[[1583],256],126596:[[1607],256],126597:[[1608],256],126598:[[1586],256],126599:[[1581],256],126600:[[1591],256],126601:[[1610],256],126603:[[1604],256],126604:[[1605],256],126605:[[1606],256],126606:[[1587],256],126607:[[1593],256],126608:[[1601],256],126609:[[1589],256],126610:[[1602],256],126611:[[1585],256],126612:[[1588],256],126613:[[1578],256],126614:[[1579],256],126615:[[1582],256],126616:[[1584],256],126617:[[1590],256],126618:[[1592],256],126619:[[1594],256],126625:[[1576],256],126626:[[1580],256],126627:[[1583],256],126629:[[1608],256],126630:[[1586],256],126631:[[1581],256],126632:[[1591],256],126633:[[1610],256],126635:[[1604],256],126636:[[1605],256],126637:[[1606],256],126638:[[1587],256],126639:[[1593],256],126640:[[1601],256],126641:[[1589],256],126642:[[1602],256],126643:[[1585],256],126644:[[1588],256],126645:[[1578],256],126646:[[1579],256],126647:[[1582],256],126648:[[1584],256],126649:[[1590],256],126650:[[1592],256],126651:[[1594],256]},
61696:{127232:[[48,46],256],127233:[[48,44],256],127234:[[49,44],256],127235:[[50,44],256],127236:[[51,44],256],127237:[[52,44],256],127238:[[53,44],256],127239:[[54,44],256],127240:[[55,44],256],127241:[[56,44],256],127242:[[57,44],256],127248:[[40,65,41],256],127249:[[40,66,41],256],127250:[[40,67,41],256],127251:[[40,68,41],256],127252:[[40,69,41],256],127253:[[40,70,41],256],127254:[[40,71,41],256],127255:[[40,72,41],256],127256:[[40,73,41],256],127257:[[40,74,41],256],127258:[[40,75,41],256],127259:[[40,76,41],256],127260:[[40,77,41],256],127261:[[40,78,41],256],127262:[[40,79,41],256],127263:[[40,80,41],256],127264:[[40,81,41],256],127265:[[40,82,41],256],127266:[[40,83,41],256],127267:[[40,84,41],256],127268:[[40,85,41],256],127269:[[40,86,41],256],127270:[[40,87,41],256],127271:[[40,88,41],256],127272:[[40,89,41],256],127273:[[40,90,41],256],127274:[[12308,83,12309],256],127275:[[67],256],127276:[[82],256],127277:[[67,68],256],127278:[[87,90],256],127280:[[65],256],127281:[[66],256],127282:[[67],256],127283:[[68],256],127284:[[69],256],127285:[[70],256],127286:[[71],256],127287:[[72],256],127288:[[73],256],127289:[[74],256],127290:[[75],256],127291:[[76],256],127292:[[77],256],127293:[[78],256],127294:[[79],256],127295:[[80],256],127296:[[81],256],127297:[[82],256],127298:[[83],256],127299:[[84],256],127300:[[85],256],127301:[[86],256],127302:[[87],256],127303:[[88],256],127304:[[89],256],127305:[[90],256],127306:[[72,86],256],127307:[[77,86],256],127308:[[83,68],256],127309:[[83,83],256],127310:[[80,80,86],256],127311:[[87,67],256],127338:[[77,67],256],127339:[[77,68],256],127376:[[68,74],256]},
61952:{127488:[[12411,12363],256],127489:[[12467,12467],256],127490:[[12469],256],127504:[[25163],256],127505:[[23383],256],127506:[[21452],256],127507:[[12487],256],127508:[[20108],256],127509:[[22810],256],127510:[[35299],256],127511:[[22825],256],127512:[[20132],256],127513:[[26144],256],127514:[[28961],256],127515:[[26009],256],127516:[[21069],256],127517:[[24460],256],127518:[[20877],256],127519:[[26032],256],127520:[[21021],256],127521:[[32066],256],127522:[[29983],256],127523:[[36009],256],127524:[[22768],256],127525:[[21561],256],127526:[[28436],256],127527:[[25237],256],127528:[[25429],256],127529:[[19968],256],127530:[[19977],256],127531:[[36938],256],127532:[[24038],256],127533:[[20013],256],127534:[[21491],256],127535:[[25351],256],127536:[[36208],256],127537:[[25171],256],127538:[[31105],256],127539:[[31354],256],127540:[[21512],256],127541:[[28288],256],127542:[[26377],256],127543:[[26376],256],127544:[[30003],256],127545:[[21106],256],127546:[[21942],256],127552:[[12308,26412,12309],256],127553:[[12308,19977,12309],256],127554:[[12308,20108,12309],256],127555:[[12308,23433,12309],256],127556:[[12308,28857,12309],256],127557:[[12308,25171,12309],256],127558:[[12308,30423,12309],256],127559:[[12308,21213,12309],256],127560:[[12308,25943,12309],256],127568:[[24471],256],127569:[[21487],256]},
63488:{194560:[[20029]],194561:[[20024]],194562:[[20033]],194563:[[131362]],194564:[[20320]],194565:[[20398]],194566:[[20411]],194567:[[20482]],194568:[[20602]],194569:[[20633]],194570:[[20711]],194571:[[20687]],194572:[[13470]],194573:[[132666]],194574:[[20813]],194575:[[20820]],194576:[[20836]],194577:[[20855]],194578:[[132380]],194579:[[13497]],194580:[[20839]],194581:[[20877]],194582:[[132427]],194583:[[20887]],194584:[[20900]],194585:[[20172]],194586:[[20908]],194587:[[20917]],194588:[[168415]],194589:[[20981]],194590:[[20995]],194591:[[13535]],194592:[[21051]],194593:[[21062]],194594:[[21106]],194595:[[21111]],194596:[[13589]],194597:[[21191]],194598:[[21193]],194599:[[21220]],194600:[[21242]],194601:[[21253]],194602:[[21254]],194603:[[21271]],194604:[[21321]],194605:[[21329]],194606:[[21338]],194607:[[21363]],194608:[[21373]],194609:[[21375]],194610:[[21375]],194611:[[21375]],194612:[[133676]],194613:[[28784]],194614:[[21450]],194615:[[21471]],194616:[[133987]],194617:[[21483]],194618:[[21489]],194619:[[21510]],194620:[[21662]],194621:[[21560]],194622:[[21576]],194623:[[21608]],194624:[[21666]],194625:[[21750]],194626:[[21776]],194627:[[21843]],194628:[[21859]],194629:[[21892]],194630:[[21892]],194631:[[21913]],194632:[[21931]],194633:[[21939]],194634:[[21954]],194635:[[22294]],194636:[[22022]],194637:[[22295]],194638:[[22097]],194639:[[22132]],194640:[[20999]],194641:[[22766]],194642:[[22478]],194643:[[22516]],194644:[[22541]],194645:[[22411]],194646:[[22578]],194647:[[22577]],194648:[[22700]],194649:[[136420]],194650:[[22770]],194651:[[22775]],194652:[[22790]],194653:[[22810]],194654:[[22818]],194655:[[22882]],194656:[[136872]],194657:[[136938]],194658:[[23020]],194659:[[23067]],194660:[[23079]],194661:[[23000]],194662:[[23142]],194663:[[14062]],194664:[[14076]],194665:[[23304]],194666:[[23358]],194667:[[23358]],194668:[[137672]],194669:[[23491]],194670:[[23512]],194671:[[23527]],194672:[[23539]],194673:[[138008]],194674:[[23551]],194675:[[23558]],194676:[[24403]],194677:[[23586]],194678:[[14209]],194679:[[23648]],194680:[[23662]],194681:[[23744]],194682:[[23693]],194683:[[138724]],194684:[[23875]],194685:[[138726]],194686:[[23918]],194687:[[23915]],194688:[[23932]],194689:[[24033]],194690:[[24034]],194691:[[14383]],194692:[[24061]],194693:[[24104]],194694:[[24125]],194695:[[24169]],194696:[[14434]],194697:[[139651]],194698:[[14460]],194699:[[24240]],194700:[[24243]],194701:[[24246]],194702:[[24266]],194703:[[172946]],194704:[[24318]],194705:[[140081]],194706:[[140081]],194707:[[33281]],194708:[[24354]],194709:[[24354]],194710:[[14535]],194711:[[144056]],194712:[[156122]],194713:[[24418]],194714:[[24427]],194715:[[14563]],194716:[[24474]],194717:[[24525]],194718:[[24535]],194719:[[24569]],194720:[[24705]],194721:[[14650]],194722:[[14620]],194723:[[24724]],194724:[[141012]],194725:[[24775]],194726:[[24904]],194727:[[24908]],194728:[[24910]],194729:[[24908]],194730:[[24954]],194731:[[24974]],194732:[[25010]],194733:[[24996]],194734:[[25007]],194735:[[25054]],194736:[[25074]],194737:[[25078]],194738:[[25104]],194739:[[25115]],194740:[[25181]],194741:[[25265]],194742:[[25300]],194743:[[25424]],194744:[[142092]],194745:[[25405]],194746:[[25340]],194747:[[25448]],194748:[[25475]],194749:[[25572]],194750:[[142321]],194751:[[25634]],194752:[[25541]],194753:[[25513]],194754:[[14894]],194755:[[25705]],194756:[[25726]],194757:[[25757]],194758:[[25719]],194759:[[14956]],194760:[[25935]],194761:[[25964]],194762:[[143370]],194763:[[26083]],194764:[[26360]],194765:[[26185]],194766:[[15129]],194767:[[26257]],194768:[[15112]],194769:[[15076]],194770:[[20882]],194771:[[20885]],194772:[[26368]],194773:[[26268]],194774:[[32941]],194775:[[17369]],194776:[[26391]],194777:[[26395]],194778:[[26401]],194779:[[26462]],194780:[[26451]],194781:[[144323]],194782:[[15177]],194783:[[26618]],194784:[[26501]],194785:[[26706]],194786:[[26757]],194787:[[144493]],194788:[[26766]],194789:[[26655]],194790:[[26900]],194791:[[15261]],194792:[[26946]],194793:[[27043]],194794:[[27114]],194795:[[27304]],194796:[[145059]],194797:[[27355]],194798:[[15384]],194799:[[27425]],194800:[[145575]],194801:[[27476]],194802:[[15438]],194803:[[27506]],194804:[[27551]],194805:[[27578]],194806:[[27579]],194807:[[146061]],194808:[[138507]],194809:[[146170]],194810:[[27726]],194811:[[146620]],194812:[[27839]],194813:[[27853]],194814:[[27751]],194815:[[27926]]},
63744:{63744:[[35912]],63745:[[26356]],63746:[[36554]],63747:[[36040]],63748:[[28369]],63749:[[20018]],63750:[[21477]],63751:[[40860]],63752:[[40860]],63753:[[22865]],63754:[[37329]],63755:[[21895]],63756:[[22856]],63757:[[25078]],63758:[[30313]],63759:[[32645]],63760:[[34367]],63761:[[34746]],63762:[[35064]],63763:[[37007]],63764:[[27138]],63765:[[27931]],63766:[[28889]],63767:[[29662]],63768:[[33853]],63769:[[37226]],63770:[[39409]],63771:[[20098]],63772:[[21365]],63773:[[27396]],63774:[[29211]],63775:[[34349]],63776:[[40478]],63777:[[23888]],63778:[[28651]],63779:[[34253]],63780:[[35172]],63781:[[25289]],63782:[[33240]],63783:[[34847]],63784:[[24266]],63785:[[26391]],63786:[[28010]],63787:[[29436]],63788:[[37070]],63789:[[20358]],63790:[[20919]],63791:[[21214]],63792:[[25796]],63793:[[27347]],63794:[[29200]],63795:[[30439]],63796:[[32769]],63797:[[34310]],63798:[[34396]],63799:[[36335]],63800:[[38706]],63801:[[39791]],63802:[[40442]],63803:[[30860]],63804:[[31103]],63805:[[32160]],63806:[[33737]],63807:[[37636]],63808:[[40575]],63809:[[35542]],63810:[[22751]],63811:[[24324]],63812:[[31840]],63813:[[32894]],63814:[[29282]],63815:[[30922]],63816:[[36034]],63817:[[38647]],63818:[[22744]],63819:[[23650]],63820:[[27155]],63821:[[28122]],63822:[[28431]],63823:[[32047]],63824:[[32311]],63825:[[38475]],63826:[[21202]],63827:[[32907]],63828:[[20956]],63829:[[20940]],63830:[[31260]],63831:[[32190]],63832:[[33777]],63833:[[38517]],63834:[[35712]],63835:[[25295]],63836:[[27138]],63837:[[35582]],63838:[[20025]],63839:[[23527]],63840:[[24594]],63841:[[29575]],63842:[[30064]],63843:[[21271]],63844:[[30971]],63845:[[20415]],63846:[[24489]],63847:[[19981]],63848:[[27852]],63849:[[25976]],63850:[[32034]],63851:[[21443]],63852:[[22622]],63853:[[30465]],63854:[[33865]],63855:[[35498]],63856:[[27578]],63857:[[36784]],63858:[[27784]],63859:[[25342]],63860:[[33509]],63861:[[25504]],63862:[[30053]],63863:[[20142]],63864:[[20841]],63865:[[20937]],63866:[[26753]],63867:[[31975]],63868:[[33391]],63869:[[35538]],63870:[[37327]],63871:[[21237]],63872:[[21570]],63873:[[22899]],63874:[[24300]],63875:[[26053]],63876:[[28670]],63877:[[31018]],63878:[[38317]],63879:[[39530]],63880:[[40599]],63881:[[40654]],63882:[[21147]],63883:[[26310]],63884:[[27511]],63885:[[36706]],63886:[[24180]],63887:[[24976]],63888:[[25088]],63889:[[25754]],63890:[[28451]],63891:[[29001]],63892:[[29833]],63893:[[31178]],63894:[[32244]],63895:[[32879]],63896:[[36646]],63897:[[34030]],63898:[[36899]],63899:[[37706]],63900:[[21015]],63901:[[21155]],63902:[[21693]],63903:[[28872]],63904:[[35010]],63905:[[35498]],63906:[[24265]],63907:[[24565]],63908:[[25467]],63909:[[27566]],63910:[[31806]],63911:[[29557]],63912:[[20196]],63913:[[22265]],63914:[[23527]],63915:[[23994]],63916:[[24604]],63917:[[29618]],63918:[[29801]],63919:[[32666]],63920:[[32838]],63921:[[37428]],63922:[[38646]],63923:[[38728]],63924:[[38936]],63925:[[20363]],63926:[[31150]],63927:[[37300]],63928:[[38584]],63929:[[24801]],63930:[[20102]],63931:[[20698]],63932:[[23534]],63933:[[23615]],63934:[[26009]],63935:[[27138]],63936:[[29134]],63937:[[30274]],63938:[[34044]],63939:[[36988]],63940:[[40845]],63941:[[26248]],63942:[[38446]],63943:[[21129]],63944:[[26491]],63945:[[26611]],63946:[[27969]],63947:[[28316]],63948:[[29705]],63949:[[30041]],63950:[[30827]],63951:[[32016]],63952:[[39006]],63953:[[20845]],63954:[[25134]],63955:[[38520]],63956:[[20523]],63957:[[23833]],63958:[[28138]],63959:[[36650]],63960:[[24459]],63961:[[24900]],63962:[[26647]],63963:[[29575]],63964:[[38534]],63965:[[21033]],63966:[[21519]],63967:[[23653]],63968:[[26131]],63969:[[26446]],63970:[[26792]],63971:[[27877]],63972:[[29702]],63973:[[30178]],63974:[[32633]],63975:[[35023]],63976:[[35041]],63977:[[37324]],63978:[[38626]],63979:[[21311]],63980:[[28346]],63981:[[21533]],63982:[[29136]],63983:[[29848]],63984:[[34298]],63985:[[38563]],63986:[[40023]],63987:[[40607]],63988:[[26519]],63989:[[28107]],63990:[[33256]],63991:[[31435]],63992:[[31520]],63993:[[31890]],63994:[[29376]],63995:[[28825]],63996:[[35672]],63997:[[20160]],63998:[[33590]],63999:[[21050]],194816:[[27966]],194817:[[28023]],194818:[[27969]],194819:[[28009]],194820:[[28024]],194821:[[28037]],194822:[[146718]],194823:[[27956]],194824:[[28207]],194825:[[28270]],194826:[[15667]],194827:[[28363]],194828:[[28359]],194829:[[147153]],194830:[[28153]],194831:[[28526]],194832:[[147294]],194833:[[147342]],194834:[[28614]],194835:[[28729]],194836:[[28702]],194837:[[28699]],194838:[[15766]],194839:[[28746]],194840:[[28797]],194841:[[28791]],194842:[[28845]],194843:[[132389]],194844:[[28997]],194845:[[148067]],194846:[[29084]],194847:[[148395]],194848:[[29224]],194849:[[29237]],194850:[[29264]],194851:[[149000]],194852:[[29312]],194853:[[29333]],194854:[[149301]],194855:[[149524]],194856:[[29562]],194857:[[29579]],194858:[[16044]],194859:[[29605]],194860:[[16056]],194861:[[16056]],194862:[[29767]],194863:[[29788]],194864:[[29809]],194865:[[29829]],194866:[[29898]],194867:[[16155]],194868:[[29988]],194869:[[150582]],194870:[[30014]],194871:[[150674]],194872:[[30064]],194873:[[139679]],194874:[[30224]],194875:[[151457]],194876:[[151480]],194877:[[151620]],194878:[[16380]],194879:[[16392]],194880:[[30452]],194881:[[151795]],194882:[[151794]],194883:[[151833]],194884:[[151859]],194885:[[30494]],194886:[[30495]],194887:[[30495]],194888:[[30538]],194889:[[16441]],194890:[[30603]],194891:[[16454]],194892:[[16534]],194893:[[152605]],194894:[[30798]],194895:[[30860]],194896:[[30924]],194897:[[16611]],194898:[[153126]],194899:[[31062]],194900:[[153242]],194901:[[153285]],194902:[[31119]],194903:[[31211]],194904:[[16687]],194905:[[31296]],194906:[[31306]],194907:[[31311]],194908:[[153980]],194909:[[154279]],194910:[[154279]],194911:[[31470]],194912:[[16898]],194913:[[154539]],194914:[[31686]],194915:[[31689]],194916:[[16935]],194917:[[154752]],194918:[[31954]],194919:[[17056]],194920:[[31976]],194921:[[31971]],194922:[[32000]],194923:[[155526]],194924:[[32099]],194925:[[17153]],194926:[[32199]],194927:[[32258]],194928:[[32325]],194929:[[17204]],194930:[[156200]],194931:[[156231]],194932:[[17241]],194933:[[156377]],194934:[[32634]],194935:[[156478]],194936:[[32661]],194937:[[32762]],194938:[[32773]],194939:[[156890]],194940:[[156963]],194941:[[32864]],194942:[[157096]],194943:[[32880]],194944:[[144223]],194945:[[17365]],194946:[[32946]],194947:[[33027]],194948:[[17419]],194949:[[33086]],194950:[[23221]],194951:[[157607]],194952:[[157621]],194953:[[144275]],194954:[[144284]],194955:[[33281]],194956:[[33284]],194957:[[36766]],194958:[[17515]],194959:[[33425]],194960:[[33419]],194961:[[33437]],194962:[[21171]],194963:[[33457]],194964:[[33459]],194965:[[33469]],194966:[[33510]],194967:[[158524]],194968:[[33509]],194969:[[33565]],194970:[[33635]],194971:[[33709]],194972:[[33571]],194973:[[33725]],194974:[[33767]],194975:[[33879]],194976:[[33619]],194977:[[33738]],194978:[[33740]],194979:[[33756]],194980:[[158774]],194981:[[159083]],194982:[[158933]],194983:[[17707]],194984:[[34033]],194985:[[34035]],194986:[[34070]],194987:[[160714]],194988:[[34148]],194989:[[159532]],194990:[[17757]],194991:[[17761]],194992:[[159665]],194993:[[159954]],194994:[[17771]],194995:[[34384]],194996:[[34396]],194997:[[34407]],194998:[[34409]],194999:[[34473]],195000:[[34440]],195001:[[34574]],195002:[[34530]],195003:[[34681]],195004:[[34600]],195005:[[34667]],195006:[[34694]],195007:[[17879]],195008:[[34785]],195009:[[34817]],195010:[[17913]],195011:[[34912]],195012:[[34915]],195013:[[161383]],195014:[[35031]],195015:[[35038]],195016:[[17973]],195017:[[35066]],195018:[[13499]],195019:[[161966]],195020:[[162150]],195021:[[18110]],195022:[[18119]],195023:[[35488]],195024:[[35565]],195025:[[35722]],195026:[[35925]],195027:[[162984]],195028:[[36011]],195029:[[36033]],195030:[[36123]],195031:[[36215]],195032:[[163631]],195033:[[133124]],195034:[[36299]],195035:[[36284]],195036:[[36336]],195037:[[133342]],195038:[[36564]],195039:[[36664]],195040:[[165330]],195041:[[165357]],195042:[[37012]],195043:[[37105]],195044:[[37137]],195045:[[165678]],195046:[[37147]],195047:[[37432]],195048:[[37591]],195049:[[37592]],195050:[[37500]],195051:[[37881]],195052:[[37909]],195053:[[166906]],195054:[[38283]],195055:[[18837]],195056:[[38327]],195057:[[167287]],195058:[[18918]],195059:[[38595]],195060:[[23986]],195061:[[38691]],195062:[[168261]],195063:[[168474]],195064:[[19054]],195065:[[19062]],195066:[[38880]],195067:[[168970]],195068:[[19122]],195069:[[169110]],195070:[[38923]],195071:[[38923]]},
64000:{64000:[[20999]],64001:[[24230]],64002:[[25299]],64003:[[31958]],64004:[[23429]],64005:[[27934]],64006:[[26292]],64007:[[36667]],64008:[[34892]],64009:[[38477]],64010:[[35211]],64011:[[24275]],64012:[[20800]],64013:[[21952]],64016:[[22618]],64018:[[26228]],64021:[[20958]],64022:[[29482]],64023:[[30410]],64024:[[31036]],64025:[[31070]],64026:[[31077]],64027:[[31119]],64028:[[38742]],64029:[[31934]],64030:[[32701]],64032:[[34322]],64034:[[35576]],64037:[[36920]],64038:[[37117]],64042:[[39151]],64043:[[39164]],64044:[[39208]],64045:[[40372]],64046:[[37086]],64047:[[38583]],64048:[[20398]],64049:[[20711]],64050:[[20813]],64051:[[21193]],64052:[[21220]],64053:[[21329]],64054:[[21917]],64055:[[22022]],64056:[[22120]],64057:[[22592]],64058:[[22696]],64059:[[23652]],64060:[[23662]],64061:[[24724]],64062:[[24936]],64063:[[24974]],64064:[[25074]],64065:[[25935]],64066:[[26082]],64067:[[26257]],64068:[[26757]],64069:[[28023]],64070:[[28186]],64071:[[28450]],64072:[[29038]],64073:[[29227]],64074:[[29730]],64075:[[30865]],64076:[[31038]],64077:[[31049]],64078:[[31048]],64079:[[31056]],64080:[[31062]],64081:[[31069]],64082:[[31117]],64083:[[31118]],64084:[[31296]],64085:[[31361]],64086:[[31680]],64087:[[32244]],64088:[[32265]],64089:[[32321]],64090:[[32626]],64091:[[32773]],64092:[[33261]],64093:[[33401]],64094:[[33401]],64095:[[33879]],64096:[[35088]],64097:[[35222]],64098:[[35585]],64099:[[35641]],64100:[[36051]],64101:[[36104]],64102:[[36790]],64103:[[36920]],64104:[[38627]],64105:[[38911]],64106:[[38971]],64107:[[24693]],64108:[[148206]],64109:[[33304]],64112:[[20006]],64113:[[20917]],64114:[[20840]],64115:[[20352]],64116:[[20805]],64117:[[20864]],64118:[[21191]],64119:[[21242]],64120:[[21917]],64121:[[21845]],64122:[[21913]],64123:[[21986]],64124:[[22618]],64125:[[22707]],64126:[[22852]],64127:[[22868]],64128:[[23138]],64129:[[23336]],64130:[[24274]],64131:[[24281]],64132:[[24425]],64133:[[24493]],64134:[[24792]],64135:[[24910]],64136:[[24840]],64137:[[24974]],64138:[[24928]],64139:[[25074]],64140:[[25140]],64141:[[25540]],64142:[[25628]],64143:[[25682]],64144:[[25942]],64145:[[26228]],64146:[[26391]],64147:[[26395]],64148:[[26454]],64149:[[27513]],64150:[[27578]],64151:[[27969]],64152:[[28379]],64153:[[28363]],64154:[[28450]],64155:[[28702]],64156:[[29038]],64157:[[30631]],64158:[[29237]],64159:[[29359]],64160:[[29482]],64161:[[29809]],64162:[[29958]],64163:[[30011]],64164:[[30237]],64165:[[30239]],64166:[[30410]],64167:[[30427]],64168:[[30452]],64169:[[30538]],64170:[[30528]],64171:[[30924]],64172:[[31409]],64173:[[31680]],64174:[[31867]],64175:[[32091]],64176:[[32244]],64177:[[32574]],64178:[[32773]],64179:[[33618]],64180:[[33775]],64181:[[34681]],64182:[[35137]],64183:[[35206]],64184:[[35222]],64185:[[35519]],64186:[[35576]],64187:[[35531]],64188:[[35585]],64189:[[35582]],64190:[[35565]],64191:[[35641]],64192:[[35722]],64193:[[36104]],64194:[[36664]],64195:[[36978]],64196:[[37273]],64197:[[37494]],64198:[[38524]],64199:[[38627]],64200:[[38742]],64201:[[38875]],64202:[[38911]],64203:[[38923]],64204:[[38971]],64205:[[39698]],64206:[[40860]],64207:[[141386]],64208:[[141380]],64209:[[144341]],64210:[[15261]],64211:[[16408]],64212:[[16441]],64213:[[152137]],64214:[[154832]],64215:[[163539]],64216:[[40771]],64217:[[40846]],195072:[[38953]],195073:[[169398]],195074:[[39138]],195075:[[19251]],195076:[[39209]],195077:[[39335]],195078:[[39362]],195079:[[39422]],195080:[[19406]],195081:[[170800]],195082:[[39698]],195083:[[40000]],195084:[[40189]],195085:[[19662]],195086:[[19693]],195087:[[40295]],195088:[[172238]],195089:[[19704]],195090:[[172293]],195091:[[172558]],195092:[[172689]],195093:[[40635]],195094:[[19798]],195095:[[40697]],195096:[[40702]],195097:[[40709]],195098:[[40719]],195099:[[40726]],195100:[[40763]],195101:[[173568]]},
64256:{64256:[[102,102],256],64257:[[102,105],256],64258:[[102,108],256],64259:[[102,102,105],256],64260:[[102,102,108],256],64261:[[383,116],256],64262:[[115,116],256],64275:[[1396,1398],256],64276:[[1396,1381],256],64277:[[1396,1387],256],64278:[[1406,1398],256],64279:[[1396,1389],256],64285:[[1497,1460],512],64286:[,26],64287:[[1522,1463],512],64288:[[1506],256],64289:[[1488],256],64290:[[1491],256],64291:[[1492],256],64292:[[1499],256],64293:[[1500],256],64294:[[1501],256],64295:[[1512],256],64296:[[1514],256],64297:[[43],256],64298:[[1513,1473],512],64299:[[1513,1474],512],64300:[[64329,1473],512],64301:[[64329,1474],512],64302:[[1488,1463],512],64303:[[1488,1464],512],64304:[[1488,1468],512],64305:[[1489,1468],512],64306:[[1490,1468],512],64307:[[1491,1468],512],64308:[[1492,1468],512],64309:[[1493,1468],512],64310:[[1494,1468],512],64312:[[1496,1468],512],64313:[[1497,1468],512],64314:[[1498,1468],512],64315:[[1499,1468],512],64316:[[1500,1468],512],64318:[[1502,1468],512],64320:[[1504,1468],512],64321:[[1505,1468],512],64323:[[1507,1468],512],64324:[[1508,1468],512],64326:[[1510,1468],512],64327:[[1511,1468],512],64328:[[1512,1468],512],64329:[[1513,1468],512],64330:[[1514,1468],512],64331:[[1493,1465],512],64332:[[1489,1471],512],64333:[[1499,1471],512],64334:[[1508,1471],512],64335:[[1488,1500],256],64336:[[1649],256],64337:[[1649],256],64338:[[1659],256],64339:[[1659],256],64340:[[1659],256],64341:[[1659],256],64342:[[1662],256],64343:[[1662],256],64344:[[1662],256],64345:[[1662],256],64346:[[1664],256],64347:[[1664],256],64348:[[1664],256],64349:[[1664],256],64350:[[1658],256],64351:[[1658],256],64352:[[1658],256],64353:[[1658],256],64354:[[1663],256],64355:[[1663],256],64356:[[1663],256],64357:[[1663],256],64358:[[1657],256],64359:[[1657],256],64360:[[1657],256],64361:[[1657],256],64362:[[1700],256],64363:[[1700],256],64364:[[1700],256],64365:[[1700],256],64366:[[1702],256],64367:[[1702],256],64368:[[1702],256],64369:[[1702],256],64370:[[1668],256],64371:[[1668],256],64372:[[1668],256],64373:[[1668],256],64374:[[1667],256],64375:[[1667],256],64376:[[1667],256],64377:[[1667],256],64378:[[1670],256],64379:[[1670],256],64380:[[1670],256],64381:[[1670],256],64382:[[1671],256],64383:[[1671],256],64384:[[1671],256],64385:[[1671],256],64386:[[1677],256],64387:[[1677],256],64388:[[1676],256],64389:[[1676],256],64390:[[1678],256],64391:[[1678],256],64392:[[1672],256],64393:[[1672],256],64394:[[1688],256],64395:[[1688],256],64396:[[1681],256],64397:[[1681],256],64398:[[1705],256],64399:[[1705],256],64400:[[1705],256],64401:[[1705],256],64402:[[1711],256],64403:[[1711],256],64404:[[1711],256],64405:[[1711],256],64406:[[1715],256],64407:[[1715],256],64408:[[1715],256],64409:[[1715],256],64410:[[1713],256],64411:[[1713],256],64412:[[1713],256],64413:[[1713],256],64414:[[1722],256],64415:[[1722],256],64416:[[1723],256],64417:[[1723],256],64418:[[1723],256],64419:[[1723],256],64420:[[1728],256],64421:[[1728],256],64422:[[1729],256],64423:[[1729],256],64424:[[1729],256],64425:[[1729],256],64426:[[1726],256],64427:[[1726],256],64428:[[1726],256],64429:[[1726],256],64430:[[1746],256],64431:[[1746],256],64432:[[1747],256],64433:[[1747],256],64467:[[1709],256],64468:[[1709],256],64469:[[1709],256],64470:[[1709],256],64471:[[1735],256],64472:[[1735],256],64473:[[1734],256],64474:[[1734],256],64475:[[1736],256],64476:[[1736],256],64477:[[1655],256],64478:[[1739],256],64479:[[1739],256],64480:[[1733],256],64481:[[1733],256],64482:[[1737],256],64483:[[1737],256],64484:[[1744],256],64485:[[1744],256],64486:[[1744],256],64487:[[1744],256],64488:[[1609],256],64489:[[1609],256],64490:[[1574,1575],256],64491:[[1574,1575],256],64492:[[1574,1749],256],64493:[[1574,1749],256],64494:[[1574,1608],256],64495:[[1574,1608],256],64496:[[1574,1735],256],64497:[[1574,1735],256],64498:[[1574,1734],256],64499:[[1574,1734],256],64500:[[1574,1736],256],64501:[[1574,1736],256],64502:[[1574,1744],256],64503:[[1574,1744],256],64504:[[1574,1744],256],64505:[[1574,1609],256],64506:[[1574,1609],256],64507:[[1574,1609],256],64508:[[1740],256],64509:[[1740],256],64510:[[1740],256],64511:[[1740],256]},
64512:{64512:[[1574,1580],256],64513:[[1574,1581],256],64514:[[1574,1605],256],64515:[[1574,1609],256],64516:[[1574,1610],256],64517:[[1576,1580],256],64518:[[1576,1581],256],64519:[[1576,1582],256],64520:[[1576,1605],256],64521:[[1576,1609],256],64522:[[1576,1610],256],64523:[[1578,1580],256],64524:[[1578,1581],256],64525:[[1578,1582],256],64526:[[1578,1605],256],64527:[[1578,1609],256],64528:[[1578,1610],256],64529:[[1579,1580],256],64530:[[1579,1605],256],64531:[[1579,1609],256],64532:[[1579,1610],256],64533:[[1580,1581],256],64534:[[1580,1605],256],64535:[[1581,1580],256],64536:[[1581,1605],256],64537:[[1582,1580],256],64538:[[1582,1581],256],64539:[[1582,1605],256],64540:[[1587,1580],256],64541:[[1587,1581],256],64542:[[1587,1582],256],64543:[[1587,1605],256],64544:[[1589,1581],256],64545:[[1589,1605],256],64546:[[1590,1580],256],64547:[[1590,1581],256],64548:[[1590,1582],256],64549:[[1590,1605],256],64550:[[1591,1581],256],64551:[[1591,1605],256],64552:[[1592,1605],256],64553:[[1593,1580],256],64554:[[1593,1605],256],64555:[[1594,1580],256],64556:[[1594,1605],256],64557:[[1601,1580],256],64558:[[1601,1581],256],64559:[[1601,1582],256],64560:[[1601,1605],256],64561:[[1601,1609],256],64562:[[1601,1610],256],64563:[[1602,1581],256],64564:[[1602,1605],256],64565:[[1602,1609],256],64566:[[1602,1610],256],64567:[[1603,1575],256],64568:[[1603,1580],256],64569:[[1603,1581],256],64570:[[1603,1582],256],64571:[[1603,1604],256],64572:[[1603,1605],256],64573:[[1603,1609],256],64574:[[1603,1610],256],64575:[[1604,1580],256],64576:[[1604,1581],256],64577:[[1604,1582],256],64578:[[1604,1605],256],64579:[[1604,1609],256],64580:[[1604,1610],256],64581:[[1605,1580],256],64582:[[1605,1581],256],64583:[[1605,1582],256],64584:[[1605,1605],256],64585:[[1605,1609],256],64586:[[1605,1610],256],64587:[[1606,1580],256],64588:[[1606,1581],256],64589:[[1606,1582],256],64590:[[1606,1605],256],64591:[[1606,1609],256],64592:[[1606,1610],256],64593:[[1607,1580],256],64594:[[1607,1605],256],64595:[[1607,1609],256],64596:[[1607,1610],256],64597:[[1610,1580],256],64598:[[1610,1581],256],64599:[[1610,1582],256],64600:[[1610,1605],256],64601:[[1610,1609],256],64602:[[1610,1610],256],64603:[[1584,1648],256],64604:[[1585,1648],256],64605:[[1609,1648],256],64606:[[32,1612,1617],256],64607:[[32,1613,1617],256],64608:[[32,1614,1617],256],64609:[[32,1615,1617],256],64610:[[32,1616,1617],256],64611:[[32,1617,1648],256],64612:[[1574,1585],256],64613:[[1574,1586],256],64614:[[1574,1605],256],64615:[[1574,1606],256],64616:[[1574,1609],256],64617:[[1574,1610],256],64618:[[1576,1585],256],64619:[[1576,1586],256],64620:[[1576,1605],256],64621:[[1576,1606],256],64622:[[1576,1609],256],64623:[[1576,1610],256],64624:[[1578,1585],256],64625:[[1578,1586],256],64626:[[1578,1605],256],64627:[[1578,1606],256],64628:[[1578,1609],256],64629:[[1578,1610],256],64630:[[1579,1585],256],64631:[[1579,1586],256],64632:[[1579,1605],256],64633:[[1579,1606],256],64634:[[1579,1609],256],64635:[[1579,1610],256],64636:[[1601,1609],256],64637:[[1601,1610],256],64638:[[1602,1609],256],64639:[[1602,1610],256],64640:[[1603,1575],256],64641:[[1603,1604],256],64642:[[1603,1605],256],64643:[[1603,1609],256],64644:[[1603,1610],256],64645:[[1604,1605],256],64646:[[1604,1609],256],64647:[[1604,1610],256],64648:[[1605,1575],256],64649:[[1605,1605],256],64650:[[1606,1585],256],64651:[[1606,1586],256],64652:[[1606,1605],256],64653:[[1606,1606],256],64654:[[1606,1609],256],64655:[[1606,1610],256],64656:[[1609,1648],256],64657:[[1610,1585],256],64658:[[1610,1586],256],64659:[[1610,1605],256],64660:[[1610,1606],256],64661:[[1610,1609],256],64662:[[1610,1610],256],64663:[[1574,1580],256],64664:[[1574,1581],256],64665:[[1574,1582],256],64666:[[1574,1605],256],64667:[[1574,1607],256],64668:[[1576,1580],256],64669:[[1576,1581],256],64670:[[1576,1582],256],64671:[[1576,1605],256],64672:[[1576,1607],256],64673:[[1578,1580],256],64674:[[1578,1581],256],64675:[[1578,1582],256],64676:[[1578,1605],256],64677:[[1578,1607],256],64678:[[1579,1605],256],64679:[[1580,1581],256],64680:[[1580,1605],256],64681:[[1581,1580],256],64682:[[1581,1605],256],64683:[[1582,1580],256],64684:[[1582,1605],256],64685:[[1587,1580],256],64686:[[1587,1581],256],64687:[[1587,1582],256],64688:[[1587,1605],256],64689:[[1589,1581],256],64690:[[1589,1582],256],64691:[[1589,1605],256],64692:[[1590,1580],256],64693:[[1590,1581],256],64694:[[1590,1582],256],64695:[[1590,1605],256],64696:[[1591,1581],256],64697:[[1592,1605],256],64698:[[1593,1580],256],64699:[[1593,1605],256],64700:[[1594,1580],256],64701:[[1594,1605],256],64702:[[1601,1580],256],64703:[[1601,1581],256],64704:[[1601,1582],256],64705:[[1601,1605],256],64706:[[1602,1581],256],64707:[[1602,1605],256],64708:[[1603,1580],256],64709:[[1603,1581],256],64710:[[1603,1582],256],64711:[[1603,1604],256],64712:[[1603,1605],256],64713:[[1604,1580],256],64714:[[1604,1581],256],64715:[[1604,1582],256],64716:[[1604,1605],256],64717:[[1604,1607],256],64718:[[1605,1580],256],64719:[[1605,1581],256],64720:[[1605,1582],256],64721:[[1605,1605],256],64722:[[1606,1580],256],64723:[[1606,1581],256],64724:[[1606,1582],256],64725:[[1606,1605],256],64726:[[1606,1607],256],64727:[[1607,1580],256],64728:[[1607,1605],256],64729:[[1607,1648],256],64730:[[1610,1580],256],64731:[[1610,1581],256],64732:[[1610,1582],256],64733:[[1610,1605],256],64734:[[1610,1607],256],64735:[[1574,1605],256],64736:[[1574,1607],256],64737:[[1576,1605],256],64738:[[1576,1607],256],64739:[[1578,1605],256],64740:[[1578,1607],256],64741:[[1579,1605],256],64742:[[1579,1607],256],64743:[[1587,1605],256],64744:[[1587,1607],256],64745:[[1588,1605],256],64746:[[1588,1607],256],64747:[[1603,1604],256],64748:[[1603,1605],256],64749:[[1604,1605],256],64750:[[1606,1605],256],64751:[[1606,1607],256],64752:[[1610,1605],256],64753:[[1610,1607],256],64754:[[1600,1614,1617],256],64755:[[1600,1615,1617],256],64756:[[1600,1616,1617],256],64757:[[1591,1609],256],64758:[[1591,1610],256],64759:[[1593,1609],256],64760:[[1593,1610],256],64761:[[1594,1609],256],64762:[[1594,1610],256],64763:[[1587,1609],256],64764:[[1587,1610],256],64765:[[1588,1609],256],64766:[[1588,1610],256],64767:[[1581,1609],256]},
64768:{64768:[[1581,1610],256],64769:[[1580,1609],256],64770:[[1580,1610],256],64771:[[1582,1609],256],64772:[[1582,1610],256],64773:[[1589,1609],256],64774:[[1589,1610],256],64775:[[1590,1609],256],64776:[[1590,1610],256],64777:[[1588,1580],256],64778:[[1588,1581],256],64779:[[1588,1582],256],64780:[[1588,1605],256],64781:[[1588,1585],256],64782:[[1587,1585],256],64783:[[1589,1585],256],64784:[[1590,1585],256],64785:[[1591,1609],256],64786:[[1591,1610],256],64787:[[1593,1609],256],64788:[[1593,1610],256],64789:[[1594,1609],256],64790:[[1594,1610],256],64791:[[1587,1609],256],64792:[[1587,1610],256],64793:[[1588,1609],256],64794:[[1588,1610],256],64795:[[1581,1609],256],64796:[[1581,1610],256],64797:[[1580,1609],256],64798:[[1580,1610],256],64799:[[1582,1609],256],64800:[[1582,1610],256],64801:[[1589,1609],256],64802:[[1589,1610],256],64803:[[1590,1609],256],64804:[[1590,1610],256],64805:[[1588,1580],256],64806:[[1588,1581],256],64807:[[1588,1582],256],64808:[[1588,1605],256],64809:[[1588,1585],256],64810:[[1587,1585],256],64811:[[1589,1585],256],64812:[[1590,1585],256],64813:[[1588,1580],256],64814:[[1588,1581],256],64815:[[1588,1582],256],64816:[[1588,1605],256],64817:[[1587,1607],256],64818:[[1588,1607],256],64819:[[1591,1605],256],64820:[[1587,1580],256],64821:[[1587,1581],256],64822:[[1587,1582],256],64823:[[1588,1580],256],64824:[[1588,1581],256],64825:[[1588,1582],256],64826:[[1591,1605],256],64827:[[1592,1605],256],64828:[[1575,1611],256],64829:[[1575,1611],256],64848:[[1578,1580,1605],256],64849:[[1578,1581,1580],256],64850:[[1578,1581,1580],256],64851:[[1578,1581,1605],256],64852:[[1578,1582,1605],256],64853:[[1578,1605,1580],256],64854:[[1578,1605,1581],256],64855:[[1578,1605,1582],256],64856:[[1580,1605,1581],256],64857:[[1580,1605,1581],256],64858:[[1581,1605,1610],256],64859:[[1581,1605,1609],256],64860:[[1587,1581,1580],256],64861:[[1587,1580,1581],256],64862:[[1587,1580,1609],256],64863:[[1587,1605,1581],256],64864:[[1587,1605,1581],256],64865:[[1587,1605,1580],256],64866:[[1587,1605,1605],256],64867:[[1587,1605,1605],256],64868:[[1589,1581,1581],256],64869:[[1589,1581,1581],256],64870:[[1589,1605,1605],256],64871:[[1588,1581,1605],256],64872:[[1588,1581,1605],256],64873:[[1588,1580,1610],256],64874:[[1588,1605,1582],256],64875:[[1588,1605,1582],256],64876:[[1588,1605,1605],256],64877:[[1588,1605,1605],256],64878:[[1590,1581,1609],256],64879:[[1590,1582,1605],256],64880:[[1590,1582,1605],256],64881:[[1591,1605,1581],256],64882:[[1591,1605,1581],256],64883:[[1591,1605,1605],256],64884:[[1591,1605,1610],256],64885:[[1593,1580,1605],256],64886:[[1593,1605,1605],256],64887:[[1593,1605,1605],256],64888:[[1593,1605,1609],256],64889:[[1594,1605,1605],256],64890:[[1594,1605,1610],256],64891:[[1594,1605,1609],256],64892:[[1601,1582,1605],256],64893:[[1601,1582,1605],256],64894:[[1602,1605,1581],256],64895:[[1602,1605,1605],256],64896:[[1604,1581,1605],256],64897:[[1604,1581,1610],256],64898:[[1604,1581,1609],256],64899:[[1604,1580,1580],256],64900:[[1604,1580,1580],256],64901:[[1604,1582,1605],256],64902:[[1604,1582,1605],256],64903:[[1604,1605,1581],256],64904:[[1604,1605,1581],256],64905:[[1605,1581,1580],256],64906:[[1605,1581,1605],256],64907:[[1605,1581,1610],256],64908:[[1605,1580,1581],256],64909:[[1605,1580,1605],256],64910:[[1605,1582,1580],256],64911:[[1605,1582,1605],256],64914:[[1605,1580,1582],256],64915:[[1607,1605,1580],256],64916:[[1607,1605,1605],256],64917:[[1606,1581,1605],256],64918:[[1606,1581,1609],256],64919:[[1606,1580,1605],256],64920:[[1606,1580,1605],256],64921:[[1606,1580,1609],256],64922:[[1606,1605,1610],256],64923:[[1606,1605,1609],256],64924:[[1610,1605,1605],256],64925:[[1610,1605,1605],256],64926:[[1576,1582,1610],256],64927:[[1578,1580,1610],256],64928:[[1578,1580,1609],256],64929:[[1578,1582,1610],256],64930:[[1578,1582,1609],256],64931:[[1578,1605,1610],256],64932:[[1578,1605,1609],256],64933:[[1580,1605,1610],256],64934:[[1580,1581,1609],256],64935:[[1580,1605,1609],256],64936:[[1587,1582,1609],256],64937:[[1589,1581,1610],256],64938:[[1588,1581,1610],256],64939:[[1590,1581,1610],256],64940:[[1604,1580,1610],256],64941:[[1604,1605,1610],256],64942:[[1610,1581,1610],256],64943:[[1610,1580,1610],256],64944:[[1610,1605,1610],256],64945:[[1605,1605,1610],256],64946:[[1602,1605,1610],256],64947:[[1606,1581,1610],256],64948:[[1602,1605,1581],256],64949:[[1604,1581,1605],256],64950:[[1593,1605,1610],256],64951:[[1603,1605,1610],256],64952:[[1606,1580,1581],256],64953:[[1605,1582,1610],256],64954:[[1604,1580,1605],256],64955:[[1603,1605,1605],256],64956:[[1604,1580,1605],256],64957:[[1606,1580,1581],256],64958:[[1580,1581,1610],256],64959:[[1581,1580,1610],256],64960:[[1605,1580,1610],256],64961:[[1601,1605,1610],256],64962:[[1576,1581,1610],256],64963:[[1603,1605,1605],256],64964:[[1593,1580,1605],256],64965:[[1589,1605,1605],256],64966:[[1587,1582,1610],256],64967:[[1606,1580,1610],256],65008:[[1589,1604,1746],256],65009:[[1602,1604,1746],256],65010:[[1575,1604,1604,1607],256],65011:[[1575,1603,1576,1585],256],65012:[[1605,1581,1605,1583],256],65013:[[1589,1604,1593,1605],256],65014:[[1585,1587,1608,1604],256],65015:[[1593,1604,1610,1607],256],65016:[[1608,1587,1604,1605],256],65017:[[1589,1604,1609],256],65018:[[1589,1604,1609,32,1575,1604,1604,1607,32,1593,1604,1610,1607,32,1608,1587,1604,1605],256],65019:[[1580,1604,32,1580,1604,1575,1604,1607],256],65020:[[1585,1740,1575,1604],256]},
65024:{65040:[[44],256],65041:[[12289],256],65042:[[12290],256],65043:[[58],256],65044:[[59],256],65045:[[33],256],65046:[[63],256],65047:[[12310],256],65048:[[12311],256],65049:[[8230],256],65056:[,230],65057:[,230],65058:[,230],65059:[,230],65060:[,230],65061:[,230],65062:[,230],65063:[,220],65064:[,220],65065:[,220],65066:[,220],65067:[,220],65068:[,220],65069:[,220],65072:[[8229],256],65073:[[8212],256],65074:[[8211],256],65075:[[95],256],65076:[[95],256],65077:[[40],256],65078:[[41],256],65079:[[123],256],65080:[[125],256],65081:[[12308],256],65082:[[12309],256],65083:[[12304],256],65084:[[12305],256],65085:[[12298],256],65086:[[12299],256],65087:[[12296],256],65088:[[12297],256],65089:[[12300],256],65090:[[12301],256],65091:[[12302],256],65092:[[12303],256],65095:[[91],256],65096:[[93],256],65097:[[8254],256],65098:[[8254],256],65099:[[8254],256],65100:[[8254],256],65101:[[95],256],65102:[[95],256],65103:[[95],256],65104:[[44],256],65105:[[12289],256],65106:[[46],256],65108:[[59],256],65109:[[58],256],65110:[[63],256],65111:[[33],256],65112:[[8212],256],65113:[[40],256],65114:[[41],256],65115:[[123],256],65116:[[125],256],65117:[[12308],256],65118:[[12309],256],65119:[[35],256],65120:[[38],256],65121:[[42],256],65122:[[43],256],65123:[[45],256],65124:[[60],256],65125:[[62],256],65126:[[61],256],65128:[[92],256],65129:[[36],256],65130:[[37],256],65131:[[64],256],65136:[[32,1611],256],65137:[[1600,1611],256],65138:[[32,1612],256],65140:[[32,1613],256],65142:[[32,1614],256],65143:[[1600,1614],256],65144:[[32,1615],256],65145:[[1600,1615],256],65146:[[32,1616],256],65147:[[1600,1616],256],65148:[[32,1617],256],65149:[[1600,1617],256],65150:[[32,1618],256],65151:[[1600,1618],256],65152:[[1569],256],65153:[[1570],256],65154:[[1570],256],65155:[[1571],256],65156:[[1571],256],65157:[[1572],256],65158:[[1572],256],65159:[[1573],256],65160:[[1573],256],65161:[[1574],256],65162:[[1574],256],65163:[[1574],256],65164:[[1574],256],65165:[[1575],256],65166:[[1575],256],65167:[[1576],256],65168:[[1576],256],65169:[[1576],256],65170:[[1576],256],65171:[[1577],256],65172:[[1577],256],65173:[[1578],256],65174:[[1578],256],65175:[[1578],256],65176:[[1578],256],65177:[[1579],256],65178:[[1579],256],65179:[[1579],256],65180:[[1579],256],65181:[[1580],256],65182:[[1580],256],65183:[[1580],256],65184:[[1580],256],65185:[[1581],256],65186:[[1581],256],65187:[[1581],256],65188:[[1581],256],65189:[[1582],256],65190:[[1582],256],65191:[[1582],256],65192:[[1582],256],65193:[[1583],256],65194:[[1583],256],65195:[[1584],256],65196:[[1584],256],65197:[[1585],256],65198:[[1585],256],65199:[[1586],256],65200:[[1586],256],65201:[[1587],256],65202:[[1587],256],65203:[[1587],256],65204:[[1587],256],65205:[[1588],256],65206:[[1588],256],65207:[[1588],256],65208:[[1588],256],65209:[[1589],256],65210:[[1589],256],65211:[[1589],256],65212:[[1589],256],65213:[[1590],256],65214:[[1590],256],65215:[[1590],256],65216:[[1590],256],65217:[[1591],256],65218:[[1591],256],65219:[[1591],256],65220:[[1591],256],65221:[[1592],256],65222:[[1592],256],65223:[[1592],256],65224:[[1592],256],65225:[[1593],256],65226:[[1593],256],65227:[[1593],256],65228:[[1593],256],65229:[[1594],256],65230:[[1594],256],65231:[[1594],256],65232:[[1594],256],65233:[[1601],256],65234:[[1601],256],65235:[[1601],256],65236:[[1601],256],65237:[[1602],256],65238:[[1602],256],65239:[[1602],256],65240:[[1602],256],65241:[[1603],256],65242:[[1603],256],65243:[[1603],256],65244:[[1603],256],65245:[[1604],256],65246:[[1604],256],65247:[[1604],256],65248:[[1604],256],65249:[[1605],256],65250:[[1605],256],65251:[[1605],256],65252:[[1605],256],65253:[[1606],256],65254:[[1606],256],65255:[[1606],256],65256:[[1606],256],65257:[[1607],256],65258:[[1607],256],65259:[[1607],256],65260:[[1607],256],65261:[[1608],256],65262:[[1608],256],65263:[[1609],256],65264:[[1609],256],65265:[[1610],256],65266:[[1610],256],65267:[[1610],256],65268:[[1610],256],65269:[[1604,1570],256],65270:[[1604,1570],256],65271:[[1604,1571],256],65272:[[1604,1571],256],65273:[[1604,1573],256],65274:[[1604,1573],256],65275:[[1604,1575],256],65276:[[1604,1575],256]},
65280:{65281:[[33],256],65282:[[34],256],65283:[[35],256],65284:[[36],256],65285:[[37],256],65286:[[38],256],65287:[[39],256],65288:[[40],256],65289:[[41],256],65290:[[42],256],65291:[[43],256],65292:[[44],256],65293:[[45],256],65294:[[46],256],65295:[[47],256],65296:[[48],256],65297:[[49],256],65298:[[50],256],65299:[[51],256],65300:[[52],256],65301:[[53],256],65302:[[54],256],65303:[[55],256],65304:[[56],256],65305:[[57],256],65306:[[58],256],65307:[[59],256],65308:[[60],256],65309:[[61],256],65310:[[62],256],65311:[[63],256],65312:[[64],256],65313:[[65],256],65314:[[66],256],65315:[[67],256],65316:[[68],256],65317:[[69],256],65318:[[70],256],65319:[[71],256],65320:[[72],256],65321:[[73],256],65322:[[74],256],65323:[[75],256],65324:[[76],256],65325:[[77],256],65326:[[78],256],65327:[[79],256],65328:[[80],256],65329:[[81],256],65330:[[82],256],65331:[[83],256],65332:[[84],256],65333:[[85],256],65334:[[86],256],65335:[[87],256],65336:[[88],256],65337:[[89],256],65338:[[90],256],65339:[[91],256],65340:[[92],256],65341:[[93],256],65342:[[94],256],65343:[[95],256],65344:[[96],256],65345:[[97],256],65346:[[98],256],65347:[[99],256],65348:[[100],256],65349:[[101],256],65350:[[102],256],65351:[[103],256],65352:[[104],256],65353:[[105],256],65354:[[106],256],65355:[[107],256],65356:[[108],256],65357:[[109],256],65358:[[110],256],65359:[[111],256],65360:[[112],256],65361:[[113],256],65362:[[114],256],65363:[[115],256],65364:[[116],256],65365:[[117],256],65366:[[118],256],65367:[[119],256],65368:[[120],256],65369:[[121],256],65370:[[122],256],65371:[[123],256],65372:[[124],256],65373:[[125],256],65374:[[126],256],65375:[[10629],256],65376:[[10630],256],65377:[[12290],256],65378:[[12300],256],65379:[[12301],256],65380:[[12289],256],65381:[[12539],256],65382:[[12530],256],65383:[[12449],256],65384:[[12451],256],65385:[[12453],256],65386:[[12455],256],65387:[[12457],256],65388:[[12515],256],65389:[[12517],256],65390:[[12519],256],65391:[[12483],256],65392:[[12540],256],65393:[[12450],256],65394:[[12452],256],65395:[[12454],256],65396:[[12456],256],65397:[[12458],256],65398:[[12459],256],65399:[[12461],256],65400:[[12463],256],65401:[[12465],256],65402:[[12467],256],65403:[[12469],256],65404:[[12471],256],65405:[[12473],256],65406:[[12475],256],65407:[[12477],256],65408:[[12479],256],65409:[[12481],256],65410:[[12484],256],65411:[[12486],256],65412:[[12488],256],65413:[[12490],256],65414:[[12491],256],65415:[[12492],256],65416:[[12493],256],65417:[[12494],256],65418:[[12495],256],65419:[[12498],256],65420:[[12501],256],65421:[[12504],256],65422:[[12507],256],65423:[[12510],256],65424:[[12511],256],65425:[[12512],256],65426:[[12513],256],65427:[[12514],256],65428:[[12516],256],65429:[[12518],256],65430:[[12520],256],65431:[[12521],256],65432:[[12522],256],65433:[[12523],256],65434:[[12524],256],65435:[[12525],256],65436:[[12527],256],65437:[[12531],256],65438:[[12441],256],65439:[[12442],256],65440:[[12644],256],65441:[[12593],256],65442:[[12594],256],65443:[[12595],256],65444:[[12596],256],65445:[[12597],256],65446:[[12598],256],65447:[[12599],256],65448:[[12600],256],65449:[[12601],256],65450:[[12602],256],65451:[[12603],256],65452:[[12604],256],65453:[[12605],256],65454:[[12606],256],65455:[[12607],256],65456:[[12608],256],65457:[[12609],256],65458:[[12610],256],65459:[[12611],256],65460:[[12612],256],65461:[[12613],256],65462:[[12614],256],65463:[[12615],256],65464:[[12616],256],65465:[[12617],256],65466:[[12618],256],65467:[[12619],256],65468:[[12620],256],65469:[[12621],256],65470:[[12622],256],65474:[[12623],256],65475:[[12624],256],65476:[[12625],256],65477:[[12626],256],65478:[[12627],256],65479:[[12628],256],65482:[[12629],256],65483:[[12630],256],65484:[[12631],256],65485:[[12632],256],65486:[[12633],256],65487:[[12634],256],65490:[[12635],256],65491:[[12636],256],65492:[[12637],256],65493:[[12638],256],65494:[[12639],256],65495:[[12640],256],65498:[[12641],256],65499:[[12642],256],65500:[[12643],256],65504:[[162],256],65505:[[163],256],65506:[[172],256],65507:[[175],256],65508:[[166],256],65509:[[165],256],65510:[[8361],256],65512:[[9474],256],65513:[[8592],256],65514:[[8593],256],65515:[[8594],256],65516:[[8595],256],65517:[[9632],256],65518:[[9675],256]}

};

   /***** Module to export */
   var unorm = {
      nfc: nfc,
      nfd: nfd,
      nfkc: nfkc,
      nfkd: nfkd
   };

   /*globals module:true,define:true*/

   // CommonJS
   if (typeof module === "object") {
      module.exports = unorm;

   // AMD
   } else if (typeof define === "function" && define.amd) {
      define("unorm", function () {
         return unorm;
      });

   // Global
   } else {
      root.unorm = unorm;
   }

   /***** Export as shim for String::normalize method *****/
   /*
      http://wiki.ecmascript.org/doku.php?id=harmony:specification_drafts#november_8_2013_draft_rev_21

      21.1.3.12 String.prototype.normalize(form="NFC")
      When the normalize method is called with one argument form, the following steps are taken:

      1. Let O be CheckObjectCoercible(this value).
      2. Let S be ToString(O).
      3. ReturnIfAbrupt(S).
      4. If form is not provided or undefined let form be "NFC".
      5. Let f be ToString(form).
      6. ReturnIfAbrupt(f).
      7. If f is not one of "NFC", "NFD", "NFKC", or "NFKD", then throw a RangeError Exception.
      8. Let ns be the String value is the result of normalizing S into the normalization form named by f as specified in Unicode Standard Annex #15, UnicodeNormalizatoin Forms.
      9. Return ns.

      The length property of the normalize method is 0.

      *NOTE* The normalize function is intentionally generic; it does not require that its this value be a String object. Therefore it can be transferred to other kinds of objects for use as a method.
   */
    unorm.shimApplied = false;

   if (!String.prototype.normalize) {
      Object.defineProperty(String.prototype, "normalize", {
         enumerable: false,
         configurable: true,
         writable: true,
         value: function normalize (/*form*/) {
            
            var str = "" + this;
            var form = arguments[0] === undefined ? "NFC" : arguments[0];

            if (this === null || this === undefined) {
               throw new TypeError("Cannot call method on " + Object.prototype.toString.call(this));
            }

            if (form === "NFC") {
               return unorm.nfc(str);
            } else if (form === "NFD") {
               return unorm.nfd(str);
            } else if (form === "NFKC") {
               return unorm.nfkc(str);
            } else if (form === "NFKD") {
               return unorm.nfkd(str);
            } else {
               throw new RangeError("Invalid normalization form: " + form);
            }
         }
      });

      unorm.shimApplied = true;
   }
}(this));

},{}],428:[function(require,module,exports){
(function (global){(function (){

/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],429:[function(require,module,exports){
var Buffer = require('buffer').Buffer;

var ROUNDS = 32;
var DELTA = 0x9E3779B9;

/** @private */
function encipher( v, k ) {
  var y = v[0];
  var z = v[1];
  var sum = 0;
  var limit = (DELTA * ROUNDS) >>> 0;

  while ( sum !== limit ) {
    y += (((z << 4) >>> 0 ^ (z >>> 5)) + z) ^ (sum + k[sum & 3]);
    y = y >>> 0;
    sum = (sum + DELTA) >>> 0;
    z += (((y << 4) >>> 0 ^ (y >>> 5)) + y) ^ (sum + k[(sum >> 11) & 3]);
    z = z >>> 0;
  }
  v[0] = y;
  v[1] = z;
}

/** @private */
function decipher( v, k ) {
  var y = v[0];
  var z = v[1];
  var sum = (DELTA * ROUNDS) >>> 0;

  while (sum) {
    z -= (((y << 4) >>> 0 ^ (y >>> 5)) + y) ^ (sum + k[(sum >> 11) & 3]);
    z = z >>> 0;
    sum = (sum - DELTA) >>> 0;
    y -= (((z << 4) >>> 0 ^ (z >>> 5)) + z) ^ (sum + k[sum & 3]);
    y = y >>> 0;
  }
  v[0] = y;
  v[1] = z;
}

/** @private */
function encipher_cbc( v, k, iv ) {
  v[0] ^= iv[0];
  v[1] ^= iv[1];
  encipher( v, k );
  iv[0] = v[0];
  iv[1] = v[1];
}

/** @private */
function decipher_cbc( v, k, iv ) {
  var tmp = new Uint32Array(v);
  decipher( v, k );
  v[0] ^= iv[0];
  v[1] ^= iv[1];
  iv[0] = tmp[0];
  iv[1] = tmp[1];
}

/** @private */
function doBlock( method, block ,key ) {
  var k = new Uint32Array(4);
  var v = new Uint32Array(2);
  var out = new Buffer(8);

  for (var i = 0; i < 4; ++i) {
    k[i] = key.readUInt32BE(i * 4);
  }
  v[0] = block.readUInt32BE(0);
  v[1] = block.readUInt32BE(4);

  method( v, k );

  out.writeUInt32BE(v[0], 0);
  out.writeUInt32BE(v[1], 4);

  return out
}

var MODES = {
  ecb: { encrypt: encipher, decrypt: decipher },
  cbc: { encrypt: encipher_cbc, decrypt: decipher_cbc }
}

/** @private */
function doBlocks( encryption, msg, key, mode, ivbuf, skippad ) {
  mode = mode || 'ecb';
  if (!ivbuf) {
    ivbuf = new Buffer(8);
    ivbuf.fill(0);
  }

  var mode_ = MODES[ mode ];
  if (!mode_) {
    throw new Error('Unimplemented mode: ' + mode);
  }

  var method;
  if (encryption) {
    method = mode_.encrypt;
  } else {
    method = mode_.decrypt;
  }

  var length = msg.length;
  var pad = 8 - (length & 7);

  if ( skippad || ! encryption ) {
    if (pad !== 8) {
      throw new Error("Data not aligned to 8 bytes block boundary");
    }
    pad = 0;
  }

  var out = new Buffer(length + pad);
  var k = new Uint32Array(4);
  var v = new Uint32Array(2);
  var iv = new Uint32Array(2);

  iv[0] = ivbuf.readUInt32BE(0);
  iv[1] = ivbuf.readUInt32BE(4);

  for (var i = 0; i < 4; ++i) {
    k[i] = key.readUInt32BE(i * 4);
  }

  var offset = 0;
  while (offset <= length) {
    if (length - offset < 8) {
      if ( skippad || ! encryption ) {
        break;
      }

      var buf = new Buffer( pad );
      buf.fill( pad );

      buf = Buffer.concat([ msg.slice( offset ), buf ]);
      v[0] = buf.readUInt32BE( 0 );
      v[1] = buf.readUInt32BE( 4 );
    } else {
      v[0] = msg.readUInt32BE( offset );
      v[1] = msg.readUInt32BE( offset + 4 );
    }

    method( v, k, iv );

    out.writeUInt32BE( v[0], offset );
    out.writeUInt32BE( v[1], offset + 4 );
    offset += 8;
  }

  if ( skippad || encryption )
    return out;

  var pad = out[out.length - 1];
  return out.slice(0, out.length - pad);
}

/**
 * Encrypts single block of data using XTEA cipher.
 *
 * @param {Buffer} block  64-bit (8-bytes) block of data to encrypt
 * @param {Buffer} key    128-bit (16-bytes) encryption key
 * @returns {Buffer}  64-bit of encrypted block
 */
function encryptBlock( block, key ) {
  return doBlock( encipher, block, key );
}

/**
 * Decrypts single block of data using XTEA cipher.
 *
 * @param {Buffer} block  64-bit (8-bytes) block of data to encrypt
 * @param {Buffer} key    128-bit (16-bytes) encryption key
 * @returns {Buffer}  64-bit of encrypted block
 */
function decryptBlock( block, key ) {
  return doBlock( decipher, block, key );
}

/**
 * Encrypts data using XTEA cipher using specified block cipher mode of operation
 * and PKCS#7 padding.
 *
 * @param {Buffer} msg  Message to encrypt
 * @param {Buffer} key  128-bit encryption key (16 bytes)
 * @param {string} [mode=ecb]  Block cipher mode of operation (currently only 'ecb' or 'cbc')
 * @param {Buffer} [iv]  Optional IV
 * @param {bool}   [skippad]  Skip PKCS#7 padding postprocessing
 * @returns {Buffer}
 */
function encrypt( msg, key, mode, ivbuf, skippad ) {
  return doBlocks( true, msg, key, mode, ivbuf, skippad );
}

/**
 * Decrypts data using XTEA cipher using specified block cipher mode of operation
 * and PKCS#7 padding.
 *
 * @param {Buffer} msg  Ciphertext to decrypt
 * @param {Buffer} key  128-bit encryption key (16 bytes)
 * @param {string} [mode=ecb]  Block cipher mode of operation (currently only 'ecb' or 'cbc')
 * @param {Buffer} [iv]  Optional IV
 * @param {bool}   [skippad]  Skip PKCS#7 padding postprocessing
 * @returns {Buffer}
 */
function decrypt( msg, key, mode, ivbuf, skippad ) {
  return doBlocks( false, msg, key, mode, ivbuf, skippad );
}

exports.encryptBlock = encryptBlock
exports.decryptBlock = decryptBlock
exports.encrypt = encrypt
exports.decrypt = decrypt
// vim: ts=2 sts=2 sw=2 et

},{"buffer":498}],430:[function(require,module,exports){
arguments[4][112][0].apply(exports,arguments)
},{"./asn1/api":431,"./asn1/base":433,"./asn1/constants":437,"./asn1/decoders":439,"./asn1/encoders":442,"bn.js":444,"dup":112}],431:[function(require,module,exports){
arguments[4][113][0].apply(exports,arguments)
},{"./decoders":439,"./encoders":442,"dup":113,"inherits":571}],432:[function(require,module,exports){
arguments[4][114][0].apply(exports,arguments)
},{"../base/reporter":435,"dup":114,"inherits":571,"safer-buffer":618}],433:[function(require,module,exports){
arguments[4][115][0].apply(exports,arguments)
},{"./buffer":432,"./node":434,"./reporter":435,"dup":115}],434:[function(require,module,exports){
arguments[4][116][0].apply(exports,arguments)
},{"../base/buffer":432,"../base/reporter":435,"dup":116,"minimalistic-assert":577}],435:[function(require,module,exports){
arguments[4][117][0].apply(exports,arguments)
},{"dup":117,"inherits":571}],436:[function(require,module,exports){
arguments[4][118][0].apply(exports,arguments)
},{"dup":118}],437:[function(require,module,exports){
arguments[4][119][0].apply(exports,arguments)
},{"./der":436,"dup":119}],438:[function(require,module,exports){
arguments[4][120][0].apply(exports,arguments)
},{"../base/buffer":432,"../base/node":434,"../constants/der":436,"bn.js":444,"dup":120,"inherits":571}],439:[function(require,module,exports){
arguments[4][121][0].apply(exports,arguments)
},{"./der":438,"./pem":440,"dup":121}],440:[function(require,module,exports){
arguments[4][122][0].apply(exports,arguments)
},{"./der":438,"dup":122,"inherits":571,"safer-buffer":618}],441:[function(require,module,exports){
arguments[4][123][0].apply(exports,arguments)
},{"../base/node":434,"../constants/der":436,"dup":123,"inherits":571,"safer-buffer":618}],442:[function(require,module,exports){
arguments[4][124][0].apply(exports,arguments)
},{"./der":441,"./pem":443,"dup":124}],443:[function(require,module,exports){
arguments[4][125][0].apply(exports,arguments)
},{"./der":441,"dup":125,"inherits":571}],444:[function(require,module,exports){
arguments[4][25][0].apply(exports,arguments)
},{"buffer":452,"dup":25}],445:[function(require,module,exports){
(function (global){(function (){
'use strict';

var objectAssign = require('object-assign');

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:
// NB: The URL to the CommonJS spec is kept just for tradition.
//     node-assert has evolved a lot since then, both in API and behavior.

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = require('util/');
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

// Expose a strict only variant of assert
function strict(value, message) {
  if (!value) fail(value, true, message, '==', strict);
}
assert.strict = objectAssign(strict, assert, {
  equal: assert.strictEqual,
  deepEqual: assert.deepStrictEqual,
  notEqual: assert.notStrictEqual,
  notDeepEqual: assert.notDeepStrictEqual
});
assert.strict.strict = assert.strict;

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"object-assign":579,"util/":448}],446:[function(require,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}

},{}],447:[function(require,module,exports){
module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}
},{}],448:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = require('./support/isBuffer');

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = require('inherits');

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./support/isBuffer":447,"_process":592,"inherits":446}],449:[function(require,module,exports){
'use strict'

exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}

},{}],450:[function(require,module,exports){
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = require('buffer').Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [number & 0x3ffffff];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [0];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this._strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // '0' - '9'
    if (c >= 48 && c <= 57) {
      return c - 48;
    // 'A' - 'F'
    } else if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    } else {
      assert(false, 'Invalid character in ' + string);
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this._strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var b = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        b = c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        b = c - 17 + 0xa;

      // '0' - '9'
      } else {
        b = c;
      }
      assert(c >= 0 && b < mul, 'Invalid character');
      r += b;
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [0];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this._strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  function move (dest, src) {
    dest.words = src.words;
    dest.length = src.length;
    dest.negative = src.negative;
    dest.red = src.red;
  }

  BN.prototype._move = function _move (dest) {
    move(dest, this);
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype._strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  // Check Symbol.for because not everywhere where Symbol defined
  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
  if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') {
    try {
      BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
      BN.prototype.inspect = inspect;
    }
  } else {
    BN.prototype.inspect = inspect;
  }

  function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  }

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modrn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16, 2);
  };

  if (Buffer) {
    BN.prototype.toBuffer = function toBuffer (endian, length) {
      return this.toArrayLike(Buffer, endian, length);
    };
  }

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  var allocate = function allocate (ArrayType, size) {
    if (ArrayType.allocUnsafe) {
      return ArrayType.allocUnsafe(size);
    }
    return new ArrayType(size);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    this._strip();

    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    var res = allocate(ArrayType, reqLength);
    var postfix = endian === 'le' ? 'LE' : 'BE';
    this['_toArrayLike' + postfix](res, byteLength);
    return res;
  };

  BN.prototype._toArrayLikeLE = function _toArrayLikeLE (res, byteLength) {
    var position = 0;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position++] = word & 0xff;
      if (position < res.length) {
        res[position++] = (word >> 8) & 0xff;
      }
      if (position < res.length) {
        res[position++] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position < res.length) {
          res[position++] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position < res.length) {
      res[position++] = carry;

      while (position < res.length) {
        res[position++] = 0;
      }
    }
  };

  BN.prototype._toArrayLikeBE = function _toArrayLikeBE (res, byteLength) {
    var position = res.length - 1;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position--] = word & 0xff;
      if (position >= 0) {
        res[position--] = (word >> 8) & 0xff;
      }
      if (position >= 0) {
        res[position--] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position >= 0) {
          res[position--] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position >= 0) {
      res[position--] = carry;

      while (position >= 0) {
        res[position--] = 0;
      }
    }
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] >>> wbit) & 0x01;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this._strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this._strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this._strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this._strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this._strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this._strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out._strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out._strip();
  }

  function jumboMulTo (self, num, out) {
    // Temporary disable, see https://github.com/indutny/bn.js/issues/211
    // var fftm = new FFTM();
    // return fftm.mulp(self, num, out);
    return bigMulTo(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out._strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this._strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this._strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this._strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) <= num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this._strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this._strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this._strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q._strip();
    }
    a._strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modrn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modrn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || (r2 === 1 && cmp === 0)) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modrn = function modrn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return isNegNum ? -acc : acc;
  };

  // WARNING: DEPRECATED
  BN.prototype.modn = function modn (num) {
    return this.modrn(num);
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    this._strip();
    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this._strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is a BN v4 instance
        r.strip();
      } else {
        // r is a BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);

    move(a, a.umod(this.m)._forceRed(this));
    return a;
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

},{"buffer":452}],451:[function(require,module,exports){
arguments[4][26][0].apply(exports,arguments)
},{"crypto":452,"dup":26}],452:[function(require,module,exports){

},{}],453:[function(require,module,exports){
arguments[4][27][0].apply(exports,arguments)
},{"dup":27,"safe-buffer":617}],454:[function(require,module,exports){
arguments[4][28][0].apply(exports,arguments)
},{"./aes":453,"./ghash":458,"./incr32":459,"buffer-xor":497,"cipher-base":499,"dup":28,"inherits":571,"safe-buffer":617}],455:[function(require,module,exports){
arguments[4][29][0].apply(exports,arguments)
},{"./decrypter":456,"./encrypter":457,"./modes/list.json":467,"dup":29}],456:[function(require,module,exports){
arguments[4][30][0].apply(exports,arguments)
},{"./aes":453,"./authCipher":454,"./modes":466,"./streamCipher":469,"cipher-base":499,"dup":30,"evp_bytestokey":538,"inherits":571,"safe-buffer":617}],457:[function(require,module,exports){
arguments[4][31][0].apply(exports,arguments)
},{"./aes":453,"./authCipher":454,"./modes":466,"./streamCipher":469,"cipher-base":499,"dup":31,"evp_bytestokey":538,"inherits":571,"safe-buffer":617}],458:[function(require,module,exports){
arguments[4][32][0].apply(exports,arguments)
},{"dup":32,"safe-buffer":617}],459:[function(require,module,exports){
arguments[4][33][0].apply(exports,arguments)
},{"dup":33}],460:[function(require,module,exports){
arguments[4][34][0].apply(exports,arguments)
},{"buffer-xor":497,"dup":34}],461:[function(require,module,exports){
arguments[4][35][0].apply(exports,arguments)
},{"buffer-xor":497,"dup":35,"safe-buffer":617}],462:[function(require,module,exports){
arguments[4][36][0].apply(exports,arguments)
},{"dup":36,"safe-buffer":617}],463:[function(require,module,exports){
arguments[4][37][0].apply(exports,arguments)
},{"dup":37,"safe-buffer":617}],464:[function(require,module,exports){
arguments[4][38][0].apply(exports,arguments)
},{"../incr32":459,"buffer-xor":497,"dup":38,"safe-buffer":617}],465:[function(require,module,exports){
arguments[4][39][0].apply(exports,arguments)
},{"dup":39}],466:[function(require,module,exports){
arguments[4][40][0].apply(exports,arguments)
},{"./cbc":460,"./cfb":461,"./cfb1":462,"./cfb8":463,"./ctr":464,"./ecb":465,"./list.json":467,"./ofb":468,"dup":40}],467:[function(require,module,exports){
arguments[4][41][0].apply(exports,arguments)
},{"dup":41}],468:[function(require,module,exports){
arguments[4][42][0].apply(exports,arguments)
},{"buffer":498,"buffer-xor":497,"dup":42}],469:[function(require,module,exports){
arguments[4][43][0].apply(exports,arguments)
},{"./aes":453,"cipher-base":499,"dup":43,"inherits":571,"safe-buffer":617}],470:[function(require,module,exports){
var DES = require('browserify-des')
var aes = require('browserify-aes/browser')
var aesModes = require('browserify-aes/modes')
var desModes = require('browserify-des/modes')
var ebtk = require('evp_bytestokey')

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers

},{"browserify-aes/browser":455,"browserify-aes/modes":466,"browserify-des":471,"browserify-des/modes":472,"evp_bytestokey":538}],471:[function(require,module,exports){
var CipherBase = require('cipher-base')
var des = require('des.js')
var inherits = require('inherits')
var Buffer = require('safe-buffer').Buffer

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}

},{"cipher-base":499,"des.js":508,"inherits":571,"safe-buffer":617}],472:[function(require,module,exports){
exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}

},{}],473:[function(require,module,exports){
(function (Buffer){(function (){
var BN = require('bn.js')
var randomBytes = require('randombytes')

function blind (priv) {
  var r = getr(priv)
  var blinder = r.toRed(BN.mont(priv.modulus)).redPow(new BN(priv.publicExponent)).fromRed()
  return { blinder: blinder, unblinder: r.invm(priv.modulus) }
}

function getr (priv) {
  var len = priv.modulus.byteLength()
  var r
  do {
    r = new BN(randomBytes(len))
  } while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2))
  return r
}

function crt (msg, priv) {
  var blinds = blind(priv)
  var len = priv.modulus.byteLength()
  var blinded = new BN(msg).mul(blinds.blinder).umod(priv.modulus)
  var c1 = blinded.toRed(BN.mont(priv.prime1))
  var c2 = blinded.toRed(BN.mont(priv.prime2))
  var qinv = priv.coefficient
  var p = priv.prime1
  var q = priv.prime2
  var m1 = c1.redPow(priv.exponent1).fromRed()
  var m2 = c2.redPow(priv.exponent2).fromRed()
  var h = m1.isub(m2).imul(qinv).umod(p).imul(q)
  return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike(Buffer, 'be', len)
}
crt.getr = getr

module.exports = crt

}).call(this)}).call(this,require("buffer").Buffer)
},{"bn.js":450,"buffer":498,"randombytes":600}],474:[function(require,module,exports){
module.exports = require('./browser/algorithms.json')

},{"./browser/algorithms.json":475}],475:[function(require,module,exports){
module.exports={
  "sha224WithRSAEncryption": {
    "sign": "rsa",
    "hash": "sha224",
    "id": "302d300d06096086480165030402040500041c"
  },
  "RSA-SHA224": {
    "sign": "ecdsa/rsa",
    "hash": "sha224",
    "id": "302d300d06096086480165030402040500041c"
  },
  "sha256WithRSAEncryption": {
    "sign": "rsa",
    "hash": "sha256",
    "id": "3031300d060960864801650304020105000420"
  },
  "RSA-SHA256": {
    "sign": "ecdsa/rsa",
    "hash": "sha256",
    "id": "3031300d060960864801650304020105000420"
  },
  "sha384WithRSAEncryption": {
    "sign": "rsa",
    "hash": "sha384",
    "id": "3041300d060960864801650304020205000430"
  },
  "RSA-SHA384": {
    "sign": "ecdsa/rsa",
    "hash": "sha384",
    "id": "3041300d060960864801650304020205000430"
  },
  "sha512WithRSAEncryption": {
    "sign": "rsa",
    "hash": "sha512",
    "id": "3051300d060960864801650304020305000440"
  },
  "RSA-SHA512": {
    "sign": "ecdsa/rsa",
    "hash": "sha512",
    "id": "3051300d060960864801650304020305000440"
  },
  "RSA-SHA1": {
    "sign": "rsa",
    "hash": "sha1",
    "id": "3021300906052b0e03021a05000414"
  },
  "ecdsa-with-SHA1": {
    "sign": "ecdsa",
    "hash": "sha1",
    "id": ""
  },
  "sha256": {
    "sign": "ecdsa",
    "hash": "sha256",
    "id": ""
  },
  "sha224": {
    "sign": "ecdsa",
    "hash": "sha224",
    "id": ""
  },
  "sha384": {
    "sign": "ecdsa",
    "hash": "sha384",
    "id": ""
  },
  "sha512": {
    "sign": "ecdsa",
    "hash": "sha512",
    "id": ""
  },
  "DSA-SHA": {
    "sign": "dsa",
    "hash": "sha1",
    "id": ""
  },
  "DSA-SHA1": {
    "sign": "dsa",
    "hash": "sha1",
    "id": ""
  },
  "DSA": {
    "sign": "dsa",
    "hash": "sha1",
    "id": ""
  },
  "DSA-WITH-SHA224": {
    "sign": "dsa",
    "hash": "sha224",
    "id": ""
  },
  "DSA-SHA224": {
    "sign": "dsa",
    "hash": "sha224",
    "id": ""
  },
  "DSA-WITH-SHA256": {
    "sign": "dsa",
    "hash": "sha256",
    "id": ""
  },
  "DSA-SHA256": {
    "sign": "dsa",
    "hash": "sha256",
    "id": ""
  },
  "DSA-WITH-SHA384": {
    "sign": "dsa",
    "hash": "sha384",
    "id": ""
  },
  "DSA-SHA384": {
    "sign": "dsa",
    "hash": "sha384",
    "id": ""
  },
  "DSA-WITH-SHA512": {
    "sign": "dsa",
    "hash": "sha512",
    "id": ""
  },
  "DSA-SHA512": {
    "sign": "dsa",
    "hash": "sha512",
    "id": ""
  },
  "DSA-RIPEMD160": {
    "sign": "dsa",
    "hash": "rmd160",
    "id": ""
  },
  "ripemd160WithRSA": {
    "sign": "rsa",
    "hash": "rmd160",
    "id": "3021300906052b2403020105000414"
  },
  "RSA-RIPEMD160": {
    "sign": "rsa",
    "hash": "rmd160",
    "id": "3021300906052b2403020105000414"
  },
  "md5WithRSAEncryption": {
    "sign": "rsa",
    "hash": "md5",
    "id": "3020300c06082a864886f70d020505000410"
  },
  "RSA-MD5": {
    "sign": "rsa",
    "hash": "md5",
    "id": "3020300c06082a864886f70d020505000410"
  }
}

},{}],476:[function(require,module,exports){
module.exports={
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
}

},{}],477:[function(require,module,exports){
var Buffer = require('safe-buffer').Buffer
var createHash = require('create-hash')
var stream = require('readable-stream')
var inherits = require('inherits')
var sign = require('./sign')
var verify = require('./verify')

var algorithms = require('./algorithms.json')
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = Buffer.from(algorithms[key].id, 'hex')
  algorithms[key.toLowerCase()] = algorithms[key]
})

function Sign (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hashType = data.hash
  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Sign, stream.Writable)

Sign.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Sign.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = Buffer.from(data, enc)

  this._hash.update(data)
  return this
}

Sign.prototype.sign = function signMethod (key, enc) {
  this.end()
  var hash = this._hash.digest()
  var sig = sign(hash, key, this._hashType, this._signType, this._tag)

  return enc ? sig.toString(enc) : sig
}

function Verify (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Verify, stream.Writable)

Verify.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Verify.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = Buffer.from(data, enc)

  this._hash.update(data)
  return this
}

Verify.prototype.verify = function verifyMethod (key, sig, enc) {
  if (typeof sig === 'string') sig = Buffer.from(sig, enc)

  this.end()
  var hash = this._hash.digest()
  return verify(sig, hash, key, this._signType, this._tag)
}

function createSign (algorithm) {
  return new Sign(algorithm)
}

function createVerify (algorithm) {
  return new Verify(algorithm)
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
}

},{"./algorithms.json":475,"./sign":478,"./verify":479,"create-hash":503,"inherits":480,"readable-stream":495,"safe-buffer":496}],478:[function(require,module,exports){
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = require('safe-buffer').Buffer
var createHmac = require('create-hmac')
var crt = require('browserify-rsa')
var EC = require('elliptic').ec
var BN = require('bn.js')
var parseKeys = require('parse-asn1')
var curves = require('./curves.json')

function sign (hash, key, hashType, signType, tag) {
  var priv = parseKeys(key)
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
    return ecSign(hash, priv)
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong private key type')
    return dsaSign(hash, priv, hashType)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = priv.modulus.byteLength()
  var pad = [0, 1]
  while (hash.length + pad.length + 1 < len) pad.push(0xff)
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) pad.push(hash[i])

  var out = crt(pad, priv)
  return out
}

function ecSign (hash, priv) {
  var curveId = curves[priv.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))

  var curve = new EC(curveId)
  var key = curve.keyFromPrivate(priv.privateKey)
  var out = key.sign(hash)

  return Buffer.from(out.toDER())
}

function dsaSign (hash, priv, algo) {
  var x = priv.params.priv_key
  var p = priv.params.p
  var q = priv.params.q
  var g = priv.params.g
  var r = new BN(0)
  var k
  var H = bits2int(hash, q).mod(q)
  var s = false
  var kv = getKey(x, q, hash, algo)
  while (s === false) {
    k = makeKey(q, kv, algo)
    r = makeR(g, k, p, q)
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
    if (s.cmpn(0) === 0) {
      s = false
      r = new BN(0)
    }
  }
  return toDER(r, s)
}

function toDER (r, s) {
  r = r.toArray()
  s = s.toArray()

  // Pad values
  if (r[0] & 0x80) r = [0].concat(r)
  if (s[0] & 0x80) s = [0].concat(s)

  var total = r.length + s.length + 4
  var res = [0x30, total, 0x02, r.length]
  res = res.concat(r, [0x02, s.length], s)
  return Buffer.from(res)
}

function getKey (x, q, hash, algo) {
  x = Buffer.from(x.toArray())
  if (x.length < q.byteLength()) {
    var zeros = Buffer.alloc(q.byteLength() - x.length)
    x = Buffer.concat([zeros, x])
  }
  var hlen = hash.length
  var hbits = bits2octets(hash, q)
  var v = Buffer.alloc(hlen)
  v.fill(1)
  var k = Buffer.alloc(hlen)
  k = createHmac(algo, k).update(v).update(Buffer.from([0])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  k = createHmac(algo, k).update(v).update(Buffer.from([1])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  return { k: k, v: v }
}

function bits2int (obits, q) {
  var bits = new BN(obits)
  var shift = (obits.length << 3) - q.bitLength()
  if (shift > 0) bits.ishrn(shift)
  return bits
}

function bits2octets (bits, q) {
  bits = bits2int(bits, q)
  bits = bits.mod(q)
  var out = Buffer.from(bits.toArray())
  if (out.length < q.byteLength()) {
    var zeros = Buffer.alloc(q.byteLength() - out.length)
    out = Buffer.concat([zeros, out])
  }
  return out
}

function makeKey (q, kv, algo) {
  var t
  var k

  do {
    t = Buffer.alloc(0)

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest()
      t = Buffer.concat([t, kv.v])
    }

    k = bits2int(t, q)
    kv.k = createHmac(algo, kv.k).update(kv.v).update(Buffer.from([0])).digest()
    kv.v = createHmac(algo, kv.k).update(kv.v).digest()
  } while (k.cmp(q) !== -1)

  return k
}

function makeR (g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
}

module.exports = sign
module.exports.getKey = getKey
module.exports.makeKey = makeKey

},{"./curves.json":476,"bn.js":450,"browserify-rsa":473,"create-hmac":505,"elliptic":519,"parse-asn1":584,"safe-buffer":496}],479:[function(require,module,exports){
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = require('safe-buffer').Buffer
var BN = require('bn.js')
var EC = require('elliptic').ec
var parseKeys = require('parse-asn1')
var curves = require('./curves.json')

function verify (sig, hash, key, signType, tag) {
  var pub = parseKeys(key)
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
    return ecVerify(sig, hash, pub)
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong public key type')
    return dsaVerify(sig, hash, pub)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = pub.modulus.byteLength()
  var pad = [1]
  var padNum = 0
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff)
    padNum++
  }
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) {
    pad.push(hash[i])
  }
  pad = Buffer.from(pad)
  var red = BN.mont(pub.modulus)
  sig = new BN(sig).toRed(red)

  sig = sig.redPow(new BN(pub.publicExponent))
  sig = Buffer.from(sig.fromRed().toArray())
  var out = padNum < 8 ? 1 : 0
  len = Math.min(sig.length, pad.length)
  if (sig.length !== pad.length) out = 1

  i = -1
  while (++i < len) out |= sig[i] ^ pad[i]
  return out === 0
}

function ecVerify (sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))

  var curve = new EC(curveId)
  var pubkey = pub.data.subjectPrivateKey.data

  return curve.verify(hash, sig, pubkey)
}

function dsaVerify (sig, hash, pub) {
  var p = pub.data.p
  var q = pub.data.q
  var g = pub.data.g
  var y = pub.data.pub_key
  var unpacked = parseKeys.signature.decode(sig, 'der')
  var s = unpacked.s
  var r = unpacked.r
  checkValue(s, q)
  checkValue(r, q)
  var montp = BN.mont(p)
  var w = s.invm(q)
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q)
  return v.cmp(r) === 0
}

function checkValue (b, q) {
  if (b.cmpn(0) <= 0) throw new Error('invalid sig')
  if (b.cmp(q) >= q) throw new Error('invalid sig')
}

module.exports = verify

},{"./curves.json":476,"bn.js":450,"elliptic":519,"parse-asn1":584,"safe-buffer":496}],480:[function(require,module,exports){
arguments[4][100][0].apply(exports,arguments)
},{"dup":100}],481:[function(require,module,exports){
arguments[4][70][0].apply(exports,arguments)
},{"dup":70}],482:[function(require,module,exports){
arguments[4][71][0].apply(exports,arguments)
},{"./_stream_readable":484,"./_stream_writable":486,"_process":592,"dup":71,"inherits":480}],483:[function(require,module,exports){
arguments[4][72][0].apply(exports,arguments)
},{"./_stream_transform":485,"dup":72,"inherits":480}],484:[function(require,module,exports){
arguments[4][73][0].apply(exports,arguments)
},{"../errors":481,"./_stream_duplex":482,"./internal/streams/async_iterator":487,"./internal/streams/buffer_list":488,"./internal/streams/destroy":489,"./internal/streams/from":491,"./internal/streams/state":493,"./internal/streams/stream":494,"_process":592,"buffer":498,"dup":73,"events":537,"inherits":480,"string_decoder/":628,"util":452}],485:[function(require,module,exports){
arguments[4][74][0].apply(exports,arguments)
},{"../errors":481,"./_stream_duplex":482,"dup":74,"inherits":480}],486:[function(require,module,exports){
arguments[4][75][0].apply(exports,arguments)
},{"../errors":481,"./_stream_duplex":482,"./internal/streams/destroy":489,"./internal/streams/state":493,"./internal/streams/stream":494,"_process":592,"buffer":498,"dup":75,"inherits":480,"util-deprecate":631}],487:[function(require,module,exports){
arguments[4][76][0].apply(exports,arguments)
},{"./end-of-stream":490,"_process":592,"dup":76}],488:[function(require,module,exports){
arguments[4][77][0].apply(exports,arguments)
},{"buffer":498,"dup":77,"util":452}],489:[function(require,module,exports){
arguments[4][78][0].apply(exports,arguments)
},{"_process":592,"dup":78}],490:[function(require,module,exports){
arguments[4][79][0].apply(exports,arguments)
},{"../../../errors":481,"dup":79}],491:[function(require,module,exports){
arguments[4][80][0].apply(exports,arguments)
},{"dup":80}],492:[function(require,module,exports){
arguments[4][81][0].apply(exports,arguments)
},{"../../../errors":481,"./end-of-stream":490,"dup":81}],493:[function(require,module,exports){
arguments[4][82][0].apply(exports,arguments)
},{"../../../errors":481,"dup":82}],494:[function(require,module,exports){
arguments[4][83][0].apply(exports,arguments)
},{"dup":83,"events":537}],495:[function(require,module,exports){
arguments[4][84][0].apply(exports,arguments)
},{"./lib/_stream_duplex.js":482,"./lib/_stream_passthrough.js":483,"./lib/_stream_readable.js":484,"./lib/_stream_transform.js":485,"./lib/_stream_writable.js":486,"./lib/internal/streams/end-of-stream.js":490,"./lib/internal/streams/pipeline.js":492,"dup":84}],496:[function(require,module,exports){
arguments[4][85][0].apply(exports,arguments)
},{"buffer":498,"dup":85}],497:[function(require,module,exports){
arguments[4][47][0].apply(exports,arguments)
},{"buffer":498,"dup":47}],498:[function(require,module,exports){
(function (Buffer){(function (){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = require('base64-js')
var ieee754 = require('ieee754')

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function () { return 42 } }
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  buf.__proto__ = Buffer.prototype
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

// Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
if (typeof Symbol !== 'undefined' && Symbol.species != null &&
    Buffer[Symbol.species] === Buffer) {
  Object.defineProperty(Buffer, Symbol.species, {
    value: null,
    configurable: true,
    enumerable: false,
    writable: false
  })
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayLike(value)
  }

  if (value == null) {
    throw TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Buffer.prototype.__proto__ = Uint8Array.prototype
Buffer.__proto__ = Uint8Array

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  buf.__proto__ = Buffer.prototype
  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      buf = Buffer.from(buf)
    }
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
        : (firstByte > 0xBF) ? 2
          : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  newBuf.__proto__ = Buffer.prototype
  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (var i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

}).call(this)}).call(this,require("buffer").Buffer)
},{"base64-js":449,"buffer":498,"ieee754":570}],499:[function(require,module,exports){
arguments[4][49][0].apply(exports,arguments)
},{"dup":49,"inherits":571,"safe-buffer":617,"stream":627,"string_decoder":628}],500:[function(require,module,exports){
(function (Buffer){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

}).call(this)}).call(this,{"isBuffer":require("../../is-buffer/index.js")})
},{"../../is-buffer/index.js":572}],501:[function(require,module,exports){
(function (Buffer){(function (){
var elliptic = require('elliptic')
var BN = require('bn.js')

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}

}).call(this)}).call(this,require("buffer").Buffer)
},{"bn.js":502,"buffer":498,"elliptic":519}],502:[function(require,module,exports){
arguments[4][25][0].apply(exports,arguments)
},{"buffer":452,"dup":25}],503:[function(require,module,exports){
arguments[4][50][0].apply(exports,arguments)
},{"cipher-base":499,"dup":50,"inherits":571,"md5.js":574,"ripemd160":616,"sha.js":620}],504:[function(require,module,exports){
arguments[4][51][0].apply(exports,arguments)
},{"dup":51,"md5.js":574}],505:[function(require,module,exports){
'use strict'
var inherits = require('inherits')
var Legacy = require('./legacy')
var Base = require('cipher-base')
var Buffer = require('safe-buffer').Buffer
var md5 = require('create-hash/md5')
var RIPEMD160 = require('ripemd160')

var sha = require('sha.js')

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}

},{"./legacy":506,"cipher-base":499,"create-hash/md5":504,"inherits":571,"ripemd160":616,"safe-buffer":617,"sha.js":620}],506:[function(require,module,exports){
'use strict'
var inherits = require('inherits')
var Buffer = require('safe-buffer').Buffer

var Base = require('cipher-base')

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac

},{"cipher-base":499,"inherits":571,"safe-buffer":617}],507:[function(require,module,exports){
'use strict'

exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = require('randombytes')
exports.createHash = exports.Hash = require('create-hash')
exports.createHmac = exports.Hmac = require('create-hmac')

var algos = require('browserify-sign/algos')
var algoKeys = Object.keys(algos)
var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys)
exports.getHashes = function () {
  return hashes
}

var p = require('pbkdf2')
exports.pbkdf2 = p.pbkdf2
exports.pbkdf2Sync = p.pbkdf2Sync

var aes = require('browserify-cipher')

exports.Cipher = aes.Cipher
exports.createCipher = aes.createCipher
exports.Cipheriv = aes.Cipheriv
exports.createCipheriv = aes.createCipheriv
exports.Decipher = aes.Decipher
exports.createDecipher = aes.createDecipher
exports.Decipheriv = aes.Decipheriv
exports.createDecipheriv = aes.createDecipheriv
exports.getCiphers = aes.getCiphers
exports.listCiphers = aes.listCiphers

var dh = require('diffie-hellman')

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup
exports.getDiffieHellman = dh.getDiffieHellman
exports.createDiffieHellman = dh.createDiffieHellman
exports.DiffieHellman = dh.DiffieHellman

var sign = require('browserify-sign')

exports.createSign = sign.createSign
exports.Sign = sign.Sign
exports.createVerify = sign.createVerify
exports.Verify = sign.Verify

exports.createECDH = require('create-ecdh')

var publicEncrypt = require('public-encrypt')

exports.publicEncrypt = publicEncrypt.publicEncrypt
exports.privateEncrypt = publicEncrypt.privateEncrypt
exports.publicDecrypt = publicEncrypt.publicDecrypt
exports.privateDecrypt = publicEncrypt.privateDecrypt

// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })

var rf = require('randomfill')

exports.randomFill = rf.randomFill
exports.randomFillSync = rf.randomFillSync

exports.createCredentials = function () {
  throw new Error([
    'sorry, createCredentials is not implemented yet',
    'we accept pull requests',
    'https://github.com/crypto-browserify/crypto-browserify'
  ].join('\n'))
}

exports.constants = {
  'DH_CHECK_P_NOT_SAFE_PRIME': 2,
  'DH_CHECK_P_NOT_PRIME': 1,
  'DH_UNABLE_TO_CHECK_GENERATOR': 4,
  'DH_NOT_SUITABLE_GENERATOR': 8,
  'NPN_ENABLED': 1,
  'ALPN_ENABLED': 1,
  'RSA_PKCS1_PADDING': 1,
  'RSA_SSLV23_PADDING': 2,
  'RSA_NO_PADDING': 3,
  'RSA_PKCS1_OAEP_PADDING': 4,
  'RSA_X931_PADDING': 5,
  'RSA_PKCS1_PSS_PADDING': 6,
  'POINT_CONVERSION_COMPRESSED': 2,
  'POINT_CONVERSION_UNCOMPRESSED': 4,
  'POINT_CONVERSION_HYBRID': 6
}

},{"browserify-cipher":470,"browserify-sign":477,"browserify-sign/algos":474,"create-ecdh":501,"create-hash":503,"create-hmac":505,"diffie-hellman":514,"pbkdf2":585,"public-encrypt":593,"randombytes":600,"randomfill":601}],508:[function(require,module,exports){
'use strict';

exports.utils = require('./des/utils');
exports.Cipher = require('./des/cipher');
exports.DES = require('./des/des');
exports.CBC = require('./des/cbc');
exports.EDE = require('./des/ede');

},{"./des/cbc":509,"./des/cipher":510,"./des/des":511,"./des/ede":512,"./des/utils":513}],509:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');
var inherits = require('inherits');

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};

},{"inherits":571,"minimalistic-assert":577}],510:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};

},{"minimalistic-assert":577}],511:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');
var inherits = require('inherits');

var utils = require('./utils');
var Cipher = require('./cipher');

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};

},{"./cipher":510,"./utils":513,"inherits":571,"minimalistic-assert":577}],512:[function(require,module,exports){
'use strict';

var assert = require('minimalistic-assert');
var inherits = require('inherits');

var Cipher = require('./cipher');
var DES = require('./des');

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;

},{"./cipher":510,"./des":511,"inherits":571,"minimalistic-assert":577}],513:[function(require,module,exports){
'use strict';

exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};

},{}],514:[function(require,module,exports){
(function (Buffer){(function (){
var generatePrime = require('./lib/generatePrime')
var primes = require('./lib/primes.json')

var DH = require('./lib/dh')

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

}).call(this)}).call(this,require("buffer").Buffer)
},{"./lib/dh":515,"./lib/generatePrime":516,"./lib/primes.json":517,"buffer":498}],515:[function(require,module,exports){
(function (Buffer){(function (){
var BN = require('bn.js');
var MillerRabin = require('miller-rabin');
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = require('./generatePrime');
var randomBytes = require('randombytes');
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

}).call(this)}).call(this,require("buffer").Buffer)
},{"./generatePrime":516,"bn.js":518,"buffer":498,"miller-rabin":575,"randombytes":600}],516:[function(require,module,exports){
var randomBytes = require('randombytes');
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = require('bn.js');
var TWENTYFOUR = new BN(24);
var MillerRabin = require('miller-rabin');
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}

},{"bn.js":518,"miller-rabin":575,"randombytes":600}],517:[function(require,module,exports){
module.exports={
    "modp1": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
    },
    "modp2": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
    },
    "modp5": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
    },
    "modp14": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
    },
    "modp15": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
    },
    "modp16": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
    },
    "modp17": {
        "gen": "02",
        "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
    },
    "modp18": {
        "gen": "02",
        "prime": "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"
    }
}
},{}],518:[function(require,module,exports){
arguments[4][25][0].apply(exports,arguments)
},{"buffer":452,"dup":25}],519:[function(require,module,exports){
arguments[4][52][0].apply(exports,arguments)
},{"../package.json":536,"./elliptic/curve":522,"./elliptic/curves":525,"./elliptic/ec":526,"./elliptic/eddsa":529,"./elliptic/utils":533,"brorand":451,"dup":52}],520:[function(require,module,exports){
arguments[4][53][0].apply(exports,arguments)
},{"../utils":533,"bn.js":534,"dup":53}],521:[function(require,module,exports){
arguments[4][54][0].apply(exports,arguments)
},{"../utils":533,"./base":520,"bn.js":534,"dup":54,"inherits":535}],522:[function(require,module,exports){
arguments[4][55][0].apply(exports,arguments)
},{"./base":520,"./edwards":521,"./mont":523,"./short":524,"dup":55}],523:[function(require,module,exports){
arguments[4][56][0].apply(exports,arguments)
},{"../utils":533,"./base":520,"bn.js":534,"dup":56,"inherits":535}],524:[function(require,module,exports){
arguments[4][57][0].apply(exports,arguments)
},{"../utils":533,"./base":520,"bn.js":534,"dup":57,"inherits":535}],525:[function(require,module,exports){
arguments[4][58][0].apply(exports,arguments)
},{"./curve":522,"./precomputed/secp256k1":532,"./utils":533,"dup":58,"hash.js":557}],526:[function(require,module,exports){
arguments[4][59][0].apply(exports,arguments)
},{"../curves":525,"../utils":533,"./key":527,"./signature":528,"bn.js":534,"brorand":451,"dup":59,"hmac-drbg":569}],527:[function(require,module,exports){
arguments[4][60][0].apply(exports,arguments)
},{"../utils":533,"bn.js":534,"dup":60}],528:[function(require,module,exports){
arguments[4][61][0].apply(exports,arguments)
},{"../utils":533,"bn.js":534,"dup":61}],529:[function(require,module,exports){
arguments[4][62][0].apply(exports,arguments)
},{"../curves":525,"../utils":533,"./key":530,"./signature":531,"dup":62,"hash.js":557}],530:[function(require,module,exports){
arguments[4][63][0].apply(exports,arguments)
},{"../utils":533,"dup":63}],531:[function(require,module,exports){
arguments[4][64][0].apply(exports,arguments)
},{"../utils":533,"bn.js":534,"dup":64}],532:[function(require,module,exports){
arguments[4][65][0].apply(exports,arguments)
},{"dup":65}],533:[function(require,module,exports){
arguments[4][66][0].apply(exports,arguments)
},{"bn.js":534,"dup":66,"minimalistic-assert":577,"minimalistic-crypto-utils":578}],534:[function(require,module,exports){
arguments[4][25][0].apply(exports,arguments)
},{"buffer":452,"dup":25}],535:[function(require,module,exports){
arguments[4][100][0].apply(exports,arguments)
},{"dup":100}],536:[function(require,module,exports){
arguments[4][67][0].apply(exports,arguments)
},{"dup":67}],537:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var objectCreate = Object.create || objectCreatePolyfill
var objectKeys = Object.keys || objectKeysPolyfill
var bind = Function.prototype.bind || functionBindPolyfill

function EventEmitter() {
  if (!this._events || !Object.prototype.hasOwnProperty.call(this, '_events')) {
    this._events = objectCreate(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

var hasDefineProperty;
try {
  var o = {};
  if (Object.defineProperty) Object.defineProperty(o, 'x', { value: 0 });
  hasDefineProperty = o.x === 0;
} catch (err) { hasDefineProperty = false }
if (hasDefineProperty) {
  Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
      return defaultMaxListeners;
    },
    set: function(arg) {
      // check whether the input is a positive number (whose value is zero or
      // greater and not a NaN).
      if (typeof arg !== 'number' || arg < 0 || arg !== arg)
        throw new TypeError('"defaultMaxListeners" must be a positive number');
      defaultMaxListeners = arg;
    }
  });
} else {
  EventEmitter.defaultMaxListeners = defaultMaxListeners;
}

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || isNaN(n))
    throw new TypeError('"n" argument must be a positive number');
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

// These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.
function emitNone(handler, isFn, self) {
  if (isFn)
    handler.call(self);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self);
  }
}
function emitOne(handler, isFn, self, arg1) {
  if (isFn)
    handler.call(self, arg1);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1);
  }
}
function emitTwo(handler, isFn, self, arg1, arg2) {
  if (isFn)
    handler.call(self, arg1, arg2);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2);
  }
}
function emitThree(handler, isFn, self, arg1, arg2, arg3) {
  if (isFn)
    handler.call(self, arg1, arg2, arg3);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2, arg3);
  }
}

function emitMany(handler, isFn, self, args) {
  if (isFn)
    handler.apply(self, args);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].apply(self, args);
  }
}

EventEmitter.prototype.emit = function emit(type) {
  var er, handler, len, args, i, events;
  var doError = (type === 'error');

  events = this._events;
  if (events)
    doError = (doError && events.error == null);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    if (arguments.length > 1)
      er = arguments[1];
    if (er instanceof Error) {
      throw er; // Unhandled 'error' event
    } else {
      // At least give some kind of context to the user
      var err = new Error('Unhandled "error" event. (' + er + ')');
      err.context = er;
      throw err;
    }
    return false;
  }

  handler = events[type];

  if (!handler)
    return false;

  var isFn = typeof handler === 'function';
  len = arguments.length;
  switch (len) {
      // fast cases
    case 1:
      emitNone(handler, isFn, this);
      break;
    case 2:
      emitOne(handler, isFn, this, arguments[1]);
      break;
    case 3:
      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
      break;
    case 4:
      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
      break;
      // slower
    default:
      args = new Array(len - 1);
      for (i = 1; i < len; i++)
        args[i - 1] = arguments[i];
      emitMany(handler, isFn, this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');

  events = target._events;
  if (!events) {
    events = target._events = objectCreate(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener) {
      target.emit('newListener', type,
          listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (!existing) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
          prepend ? [listener, existing] : [existing, listener];
    } else {
      // If we've already got an array, just append.
      if (prepend) {
        existing.unshift(listener);
      } else {
        existing.push(listener);
      }
    }

    // Check for listener leak
    if (!existing.warned) {
      m = $getMaxListeners(target);
      if (m && m > 0 && existing.length > m) {
        existing.warned = true;
        var w = new Error('Possible EventEmitter memory leak detected. ' +
            existing.length + ' "' + String(type) + '" listeners ' +
            'added. Use emitter.setMaxListeners() to ' +
            'increase limit.');
        w.name = 'MaxListenersExceededWarning';
        w.emitter = target;
        w.type = type;
        w.count = existing.length;
        if (typeof console === 'object' && console.warn) {
          console.warn('%s: %s', w.name, w.message);
        }
      }
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    switch (arguments.length) {
      case 0:
        return this.listener.call(this.target);
      case 1:
        return this.listener.call(this.target, arguments[0]);
      case 2:
        return this.listener.call(this.target, arguments[0], arguments[1]);
      case 3:
        return this.listener.call(this.target, arguments[0], arguments[1],
            arguments[2]);
      default:
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i)
          args[i] = arguments[i];
        this.listener.apply(this.target, args);
    }
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = bind.call(onceWrapper, state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');

      events = this._events;
      if (!events)
        return this;

      list = events[type];
      if (!list)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = objectCreate(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else
          spliceOne(list, position);

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (!events)
        return this;

      // not listening for removeListener, no need to emit
      if (!events.removeListener) {
        if (arguments.length === 0) {
          this._events = objectCreate(null);
          this._eventsCount = 0;
        } else if (events[type]) {
          if (--this._eventsCount === 0)
            this._events = objectCreate(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = objectKeys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = objectCreate(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (!events)
    return [];

  var evlistener = events[type];
  if (!evlistener)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};

// About 1.5x faster than the two-arg version of Array#splice().
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
    list[i] = list[k];
  list.pop();
}

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function objectCreatePolyfill(proto) {
  var F = function() {};
  F.prototype = proto;
  return new F;
}
function objectKeysPolyfill(obj) {
  var keys = [];
  for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k)) {
    keys.push(k);
  }
  return k;
}
function functionBindPolyfill(context) {
  var fn = this;
  return function () {
    return fn.apply(context, arguments);
  };
}

},{}],538:[function(require,module,exports){
arguments[4][68][0].apply(exports,arguments)
},{"dup":68,"md5.js":574,"safe-buffer":617}],539:[function(require,module,exports){
arguments[4][69][0].apply(exports,arguments)
},{"dup":69,"inherits":540,"readable-stream":555,"safe-buffer":556}],540:[function(require,module,exports){
arguments[4][100][0].apply(exports,arguments)
},{"dup":100}],541:[function(require,module,exports){
arguments[4][70][0].apply(exports,arguments)
},{"dup":70}],542:[function(require,module,exports){
arguments[4][71][0].apply(exports,arguments)
},{"./_stream_readable":544,"./_stream_writable":546,"_process":592,"dup":71,"inherits":540}],543:[function(require,module,exports){
arguments[4][72][0].apply(exports,arguments)
},{"./_stream_transform":545,"dup":72,"inherits":540}],544:[function(require,module,exports){
arguments[4][73][0].apply(exports,arguments)
},{"../errors":541,"./_stream_duplex":542,"./internal/streams/async_iterator":547,"./internal/streams/buffer_list":548,"./internal/streams/destroy":549,"./internal/streams/from":551,"./internal/streams/state":553,"./internal/streams/stream":554,"_process":592,"buffer":498,"dup":73,"events":537,"inherits":540,"string_decoder/":628,"util":452}],545:[function(require,module,exports){
arguments[4][74][0].apply(exports,arguments)
},{"../errors":541,"./_stream_duplex":542,"dup":74,"inherits":540}],546:[function(require,module,exports){
arguments[4][75][0].apply(exports,arguments)
},{"../errors":541,"./_stream_duplex":542,"./internal/streams/destroy":549,"./internal/streams/state":553,"./internal/streams/stream":554,"_process":592,"buffer":498,"dup":75,"inherits":540,"util-deprecate":631}],547:[function(require,module,exports){
arguments[4][76][0].apply(exports,arguments)
},{"./end-of-stream":550,"_process":592,"dup":76}],548:[function(require,module,exports){
arguments[4][77][0].apply(exports,arguments)
},{"buffer":498,"dup":77,"util":452}],549:[function(require,module,exports){
arguments[4][78][0].apply(exports,arguments)
},{"_process":592,"dup":78}],550:[function(require,module,exports){
arguments[4][79][0].apply(exports,arguments)
},{"../../../errors":541,"dup":79}],551:[function(require,module,exports){
arguments[4][80][0].apply(exports,arguments)
},{"dup":80}],552:[function(require,module,exports){
arguments[4][81][0].apply(exports,arguments)
},{"../../../errors":541,"./end-of-stream":550,"dup":81}],553:[function(require,module,exports){
arguments[4][82][0].apply(exports,arguments)
},{"../../../errors":541,"dup":82}],554:[function(require,module,exports){
arguments[4][83][0].apply(exports,arguments)
},{"dup":83,"events":537}],555:[function(require,module,exports){
arguments[4][84][0].apply(exports,arguments)
},{"./lib/_stream_duplex.js":542,"./lib/_stream_passthrough.js":543,"./lib/_stream_readable.js":544,"./lib/_stream_transform.js":545,"./lib/_stream_writable.js":546,"./lib/internal/streams/end-of-stream.js":550,"./lib/internal/streams/pipeline.js":552,"dup":84}],556:[function(require,module,exports){
arguments[4][85][0].apply(exports,arguments)
},{"buffer":498,"dup":85}],557:[function(require,module,exports){
arguments[4][87][0].apply(exports,arguments)
},{"./hash/common":558,"./hash/hmac":559,"./hash/ripemd":560,"./hash/sha":561,"./hash/utils":568,"dup":87}],558:[function(require,module,exports){
arguments[4][88][0].apply(exports,arguments)
},{"./utils":568,"dup":88,"minimalistic-assert":577}],559:[function(require,module,exports){
arguments[4][89][0].apply(exports,arguments)
},{"./utils":568,"dup":89,"minimalistic-assert":577}],560:[function(require,module,exports){
arguments[4][90][0].apply(exports,arguments)
},{"./common":558,"./utils":568,"dup":90}],561:[function(require,module,exports){
arguments[4][91][0].apply(exports,arguments)
},{"./sha/1":562,"./sha/224":563,"./sha/256":564,"./sha/384":565,"./sha/512":566,"dup":91}],562:[function(require,module,exports){
arguments[4][92][0].apply(exports,arguments)
},{"../common":558,"../utils":568,"./common":567,"dup":92}],563:[function(require,module,exports){
arguments[4][93][0].apply(exports,arguments)
},{"../utils":568,"./256":564,"dup":93}],564:[function(require,module,exports){
arguments[4][94][0].apply(exports,arguments)
},{"../common":558,"../utils":568,"./common":567,"dup":94,"minimalistic-assert":577}],565:[function(require,module,exports){
arguments[4][95][0].apply(exports,arguments)
},{"../utils":568,"./512":566,"dup":95}],566:[function(require,module,exports){
arguments[4][96][0].apply(exports,arguments)
},{"../common":558,"../utils":568,"dup":96,"minimalistic-assert":577}],567:[function(require,module,exports){
arguments[4][97][0].apply(exports,arguments)
},{"../utils":568,"dup":97}],568:[function(require,module,exports){
arguments[4][98][0].apply(exports,arguments)
},{"dup":98,"inherits":571,"minimalistic-assert":577}],569:[function(require,module,exports){
arguments[4][99][0].apply(exports,arguments)
},{"dup":99,"hash.js":557,"minimalistic-assert":577,"minimalistic-crypto-utils":578}],570:[function(require,module,exports){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],571:[function(require,module,exports){
arguments[4][446][0].apply(exports,arguments)
},{"dup":446}],572:[function(require,module,exports){
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}

},{}],573:[function(require,module,exports){
var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

},{}],574:[function(require,module,exports){
arguments[4][103][0].apply(exports,arguments)
},{"dup":103,"hash-base":539,"inherits":571,"safe-buffer":617}],575:[function(require,module,exports){
var bn = require('bn.js');
var brorand = require('brorand');

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};

},{"bn.js":576,"brorand":451}],576:[function(require,module,exports){
arguments[4][25][0].apply(exports,arguments)
},{"buffer":452,"dup":25}],577:[function(require,module,exports){
arguments[4][105][0].apply(exports,arguments)
},{"dup":105}],578:[function(require,module,exports){
arguments[4][106][0].apply(exports,arguments)
},{"dup":106}],579:[function(require,module,exports){
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

'use strict';
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

},{}],580:[function(require,module,exports){
arguments[4][107][0].apply(exports,arguments)
},{"dup":107}],581:[function(require,module,exports){
arguments[4][108][0].apply(exports,arguments)
},{"./certificate":582,"asn1.js":430,"dup":108}],582:[function(require,module,exports){
arguments[4][109][0].apply(exports,arguments)
},{"asn1.js":430,"dup":109}],583:[function(require,module,exports){
arguments[4][110][0].apply(exports,arguments)
},{"browserify-aes":455,"dup":110,"evp_bytestokey":538,"safe-buffer":617}],584:[function(require,module,exports){
arguments[4][111][0].apply(exports,arguments)
},{"./aesid.json":580,"./asn1":581,"./fixProc":583,"browserify-aes":455,"dup":111,"pbkdf2":585,"safe-buffer":617}],585:[function(require,module,exports){
arguments[4][126][0].apply(exports,arguments)
},{"./lib/async":586,"./lib/sync":589,"dup":126}],586:[function(require,module,exports){
arguments[4][127][0].apply(exports,arguments)
},{"./default-encoding":587,"./precondition":588,"./sync":589,"./to-buffer":590,"dup":127,"safe-buffer":617}],587:[function(require,module,exports){
arguments[4][128][0].apply(exports,arguments)
},{"_process":592,"dup":128}],588:[function(require,module,exports){
arguments[4][129][0].apply(exports,arguments)
},{"dup":129}],589:[function(require,module,exports){
arguments[4][130][0].apply(exports,arguments)
},{"./default-encoding":587,"./precondition":588,"./to-buffer":590,"create-hash/md5":504,"dup":130,"ripemd160":616,"safe-buffer":617,"sha.js":620}],590:[function(require,module,exports){
arguments[4][131][0].apply(exports,arguments)
},{"dup":131,"safe-buffer":617}],591:[function(require,module,exports){
(function (process){(function (){
'use strict';

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


}).call(this)}).call(this,require('_process'))
},{"_process":592}],592:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],593:[function(require,module,exports){
exports.publicEncrypt = require('./publicEncrypt')
exports.privateDecrypt = require('./privateDecrypt')

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}

},{"./privateDecrypt":596,"./publicEncrypt":597}],594:[function(require,module,exports){
var createHash = require('create-hash')
var Buffer = require('safe-buffer').Buffer

module.exports = function (seed, len) {
  var t = Buffer.alloc(0)
  var i = 0
  var c
  while (t.length < len) {
    c = i2ops(i++)
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
  }
  return t.slice(0, len)
}

function i2ops (c) {
  var out = Buffer.allocUnsafe(4)
  out.writeUInt32BE(c, 0)
  return out
}

},{"create-hash":503,"safe-buffer":617}],595:[function(require,module,exports){
arguments[4][25][0].apply(exports,arguments)
},{"buffer":452,"dup":25}],596:[function(require,module,exports){
var parseKeys = require('parse-asn1')
var mgf = require('./mgf')
var xor = require('./xor')
var BN = require('bn.js')
var crt = require('browserify-rsa')
var createHash = require('create-hash')
var withPublic = require('./withPublic')
var Buffer = require('safe-buffer').Buffer

module.exports = function privateDecrypt (privateKey, enc, reverse) {
  var padding
  if (privateKey.padding) {
    padding = privateKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }

  var key = parseKeys(privateKey)
  var k = key.modulus.byteLength()
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error')
  }
  var msg
  if (reverse) {
    msg = withPublic(new BN(enc), key)
  } else {
    msg = crt(enc, key)
  }
  var zBuffer = Buffer.alloc(k - msg.length)
  msg = Buffer.concat([zBuffer, msg], k)
  if (padding === 4) {
    return oaep(key, msg)
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    return msg
  } else {
    throw new Error('unknown padding')
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  if (msg[0] !== 0) {
    throw new Error('decryption error')
  }
  var maskedSeed = msg.slice(1, hLen + 1)
  var maskedDb = msg.slice(hLen + 1)
  var seed = xor(maskedSeed, mgf(maskedDb, hLen))
  var db = xor(maskedDb, mgf(seed, k - hLen - 1))
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error')
  }
  var i = hLen
  while (db[i] === 0) {
    i++
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error')
  }
  return db.slice(i)
}

function pkcs1 (key, msg, reverse) {
  var p1 = msg.slice(0, 2)
  var i = 2
  var status = 0
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++
      break
    }
  }
  var ps = msg.slice(2, i - 1)

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
    status++
  }
  if (ps.length < 8) {
    status++
  }
  if (status) {
    throw new Error('decryption error')
  }
  return msg.slice(i)
}
function compare (a, b) {
  a = Buffer.from(a)
  b = Buffer.from(b)
  var dif = 0
  var len = a.length
  if (a.length !== b.length) {
    dif++
    len = Math.min(a.length, b.length)
  }
  var i = -1
  while (++i < len) {
    dif += (a[i] ^ b[i])
  }
  return dif
}

},{"./mgf":594,"./withPublic":598,"./xor":599,"bn.js":595,"browserify-rsa":473,"create-hash":503,"parse-asn1":584,"safe-buffer":617}],597:[function(require,module,exports){
var parseKeys = require('parse-asn1')
var randomBytes = require('randombytes')
var createHash = require('create-hash')
var mgf = require('./mgf')
var xor = require('./xor')
var BN = require('bn.js')
var withPublic = require('./withPublic')
var crt = require('browserify-rsa')
var Buffer = require('safe-buffer').Buffer

module.exports = function publicEncrypt (publicKey, msg, reverse) {
  var padding
  if (publicKey.padding) {
    padding = publicKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }
  var key = parseKeys(publicKey)
  var paddedMsg
  if (padding === 4) {
    paddedMsg = oaep(key, msg)
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    paddedMsg = new BN(msg)
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus')
    }
  } else {
    throw new Error('unknown padding')
  }
  if (reverse) {
    return crt(paddedMsg, key)
  } else {
    return withPublic(paddedMsg, key)
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var mLen = msg.length
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  var hLen2 = 2 * hLen
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long')
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2)
  var dblen = k - hLen - 1
  var seed = randomBytes(hLen)
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
  var maskedSeed = xor(seed, mgf(maskedDb, hLen))
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
}
function pkcs1 (key, msg, reverse) {
  var mLen = msg.length
  var k = key.modulus.byteLength()
  if (mLen > k - 11) {
    throw new Error('message too long')
  }
  var ps
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff)
  } else {
    ps = nonZero(k - mLen - 3)
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
}
function nonZero (len) {
  var out = Buffer.allocUnsafe(len)
  var i = 0
  var cache = randomBytes(len * 2)
  var cur = 0
  var num
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2)
      cur = 0
    }
    num = cache[cur++]
    if (num) {
      out[i++] = num
    }
  }
  return out
}

},{"./mgf":594,"./withPublic":598,"./xor":599,"bn.js":595,"browserify-rsa":473,"create-hash":503,"parse-asn1":584,"randombytes":600,"safe-buffer":617}],598:[function(require,module,exports){
var BN = require('bn.js')
var Buffer = require('safe-buffer').Buffer

function withPublic (paddedMsg, key) {
  return Buffer.from(paddedMsg
    .toRed(BN.mont(key.modulus))
    .redPow(new BN(key.publicExponent))
    .fromRed()
    .toArray())
}

module.exports = withPublic

},{"bn.js":595,"safe-buffer":617}],599:[function(require,module,exports){
module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}

},{}],600:[function(require,module,exports){
(function (process,global){(function (){
'use strict'

// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var MAX_BYTES = 65536

// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var MAX_UINT32 = 4294967295

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = require('safe-buffer').Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > MAX_UINT32) throw new RangeError('requested too many random bytes')

  var bytes = Buffer.allocUnsafe(size)

  if (size > 0) {  // getRandomValues fails on IE if size == 0
    if (size > MAX_BYTES) { // this is the max bytes crypto.getRandomValues
      // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
      for (var generated = 0; generated < size; generated += MAX_BYTES) {
        // buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES))
      }
    } else {
      crypto.getRandomValues(bytes)
    }
  }

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"_process":592,"safe-buffer":617}],601:[function(require,module,exports){
(function (process,global){(function (){
'use strict'

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = require('safe-buffer')
var randombytes = require('randombytes')
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = global.crypto || global.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !process.browser) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"_process":592,"randombytes":600,"safe-buffer":617}],602:[function(require,module,exports){
module.exports = require('./lib/_stream_duplex.js');

},{"./lib/_stream_duplex.js":603}],603:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = require('core-util-is');
util.inherits = require('inherits');
/*</replacement>*/

var Readable = require('./_stream_readable');
var Writable = require('./_stream_writable');

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};
},{"./_stream_readable":605,"./_stream_writable":607,"core-util-is":500,"inherits":571,"process-nextick-args":591}],604:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.

'use strict';

module.exports = PassThrough;

var Transform = require('./_stream_transform');

/*<replacement>*/
var util = require('core-util-is');
util.inherits = require('inherits');
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};
},{"./_stream_transform":606,"core-util-is":500,"inherits":571}],605:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = require('isarray');
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = require('events').EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = require('core-util-is');
util.inherits = require('inherits');
/*</replacement>*/

/*<replacement>*/
var debugUtil = require('util');
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = require('./internal/streams/BufferList');
var destroyImpl = require('./internal/streams/destroy');
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || require('./_stream_duplex');

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || require('./_stream_duplex');

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./_stream_duplex":603,"./internal/streams/BufferList":608,"./internal/streams/destroy":609,"./internal/streams/stream":610,"_process":592,"core-util-is":500,"events":537,"inherits":571,"isarray":573,"process-nextick-args":591,"safe-buffer":617,"string_decoder/":611,"util":452}],606:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

'use strict';

module.exports = Transform;

var Duplex = require('./_stream_duplex');

/*<replacement>*/
var util = require('core-util-is');
util.inherits = require('inherits');
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}
},{"./_stream_duplex":603,"core-util-is":500,"inherits":571}],607:[function(require,module,exports){
(function (process,global,setImmediate){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = require('core-util-is');
util.inherits = require('inherits');
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: require('util-deprecate')
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = require('./internal/streams/destroy');

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || require('./_stream_duplex');

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || require('./_stream_duplex');

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("timers").setImmediate)
},{"./_stream_duplex":603,"./internal/streams/destroy":609,"./internal/streams/stream":610,"_process":592,"core-util-is":500,"inherits":571,"process-nextick-args":591,"safe-buffer":617,"timers":630,"util-deprecate":631}],608:[function(require,module,exports){
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = require('safe-buffer').Buffer;
var util = require('util');

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}
},{"safe-buffer":617,"util":452}],609:[function(require,module,exports){
'use strict';

/*<replacement>*/

var pna = require('process-nextick-args');
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};
},{"process-nextick-args":591}],610:[function(require,module,exports){
arguments[4][83][0].apply(exports,arguments)
},{"dup":83,"events":537}],611:[function(require,module,exports){
arguments[4][86][0].apply(exports,arguments)
},{"dup":86,"safe-buffer":617}],612:[function(require,module,exports){
module.exports = require('./readable').PassThrough

},{"./readable":613}],613:[function(require,module,exports){
exports = module.exports = require('./lib/_stream_readable.js');
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = require('./lib/_stream_writable.js');
exports.Duplex = require('./lib/_stream_duplex.js');
exports.Transform = require('./lib/_stream_transform.js');
exports.PassThrough = require('./lib/_stream_passthrough.js');

},{"./lib/_stream_duplex.js":603,"./lib/_stream_passthrough.js":604,"./lib/_stream_readable.js":605,"./lib/_stream_transform.js":606,"./lib/_stream_writable.js":607}],614:[function(require,module,exports){
module.exports = require('./readable').Transform

},{"./readable":613}],615:[function(require,module,exports){
module.exports = require('./lib/_stream_writable.js');

},{"./lib/_stream_writable.js":607}],616:[function(require,module,exports){
arguments[4][378][0].apply(exports,arguments)
},{"buffer":498,"dup":378,"hash-base":539,"inherits":571}],617:[function(require,module,exports){
arguments[4][379][0].apply(exports,arguments)
},{"buffer":498,"dup":379}],618:[function(require,module,exports){
arguments[4][380][0].apply(exports,arguments)
},{"_process":592,"buffer":498,"dup":380}],619:[function(require,module,exports){
arguments[4][389][0].apply(exports,arguments)
},{"dup":389,"safe-buffer":617}],620:[function(require,module,exports){
arguments[4][390][0].apply(exports,arguments)
},{"./sha":621,"./sha1":622,"./sha224":623,"./sha256":624,"./sha384":625,"./sha512":626,"dup":390}],621:[function(require,module,exports){
arguments[4][391][0].apply(exports,arguments)
},{"./hash":619,"dup":391,"inherits":571,"safe-buffer":617}],622:[function(require,module,exports){
arguments[4][392][0].apply(exports,arguments)
},{"./hash":619,"dup":392,"inherits":571,"safe-buffer":617}],623:[function(require,module,exports){
arguments[4][393][0].apply(exports,arguments)
},{"./hash":619,"./sha256":624,"dup":393,"inherits":571,"safe-buffer":617}],624:[function(require,module,exports){
arguments[4][394][0].apply(exports,arguments)
},{"./hash":619,"dup":394,"inherits":571,"safe-buffer":617}],625:[function(require,module,exports){
arguments[4][395][0].apply(exports,arguments)
},{"./hash":619,"./sha512":626,"dup":395,"inherits":571,"safe-buffer":617}],626:[function(require,module,exports){
arguments[4][396][0].apply(exports,arguments)
},{"./hash":619,"dup":396,"inherits":571,"safe-buffer":617}],627:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = require('events').EventEmitter;
var inherits = require('inherits');

inherits(Stream, EE);
Stream.Readable = require('readable-stream/readable.js');
Stream.Writable = require('readable-stream/writable.js');
Stream.Duplex = require('readable-stream/duplex.js');
Stream.Transform = require('readable-stream/transform.js');
Stream.PassThrough = require('readable-stream/passthrough.js');

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};

},{"events":537,"inherits":571,"readable-stream/duplex.js":602,"readable-stream/passthrough.js":612,"readable-stream/readable.js":613,"readable-stream/transform.js":614,"readable-stream/writable.js":615}],628:[function(require,module,exports){
arguments[4][86][0].apply(exports,arguments)
},{"dup":86,"safe-buffer":629}],629:[function(require,module,exports){
arguments[4][85][0].apply(exports,arguments)
},{"buffer":498,"dup":85}],630:[function(require,module,exports){
(function (setImmediate,clearImmediate){(function (){
var nextTick = require('process/browser.js').nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
}).call(this)}).call(this,require("timers").setImmediate,require("timers").clearImmediate)
},{"process/browser.js":592,"timers":630}],631:[function(require,module,exports){
arguments[4][428][0].apply(exports,arguments)
},{"dup":428}],632:[function(require,module,exports){
var indexOf = function (xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for (var i = 0; i < xs.length; i++) {
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function (obj) {
    if (Object.keys) return Object.keys(obj)
    else {
        var res = [];
        for (var key in obj) res.push(key)
        return res;
    }
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

var defineProp = (function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            })
        };
    } catch(e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}());

var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript (code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};

Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }
    
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    
    document.body.appendChild(iframe);
    
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;

    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    
    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });
    
    var winKeys = Object_keys(win);

    var res = wEval.call(win, this.code);
    
    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });

    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });
    
    document.body.removeChild(iframe);
    
    return res;
};

Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);

    if (context) {
        forEach(Object_keys(ctx), function (key) {
            context[key] = ctx[key];
        });
    }

    return res;
};

forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});

exports.isContext = function (context) {
    return context instanceof Context;
};

exports.createScript = function (code) {
    return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if(typeof context === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};

},{}]},{},[])("/home/lukas/Work/Projects/privfs/privmx/privmx-desktop-client/main/app/node_modules/privfs-client/out/index-browser-ext.js")
});
